


  
  

  var faTurnUp = {
    prefix: 'fast',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      'M160 176v16l0 224v16H144 16l0 64H224l0-304V176h16 96v-9.4L192 22.6 48 166.6V176h96 16zM32 160L180.7 11.3 192 0l11.3 11.3L352 160v16 16H336 256 240v16l0 288v16H224 16 0l0-16 0-64 0-16H16 128h16V400l0-192V192H128 48 32l0-16V160z'
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fast',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm8-256h88 88c4.4 0 8 3.6 8 8s-3.6 8-8 8H264V296c0 4.4-3.6 8-8 8s-8-3.6-8-8V160H168c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fast',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm320 96h8v10.8l-1.8 2.2L144.6 368H320h8v16h-8H128h-8V373.2l1.8-2.2L303.4 144H128h-8V128h8H320z'
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fast',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      'M160 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 160 0a56 56 0 1 0 0 112zM95.9 128l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H214.1l65.6 135.9c3.1-5.4 6.5-10.6 10.2-15.6L226.3 132.5l-2.2-4.5h-5H100.9h-5zM104 248v-8H88v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H216v8V496H184V344v-8h-8H144h-8v8V496H104V248zm328-8a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L496 316.7l-5.7 5.7L416 396.7l-42.3-42.3-5.7-5.7L356.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fast',
    iconName: 'hand-holding-medical',
    icon: [
      543,
      512,
      [],
      'e05c',
      
      'M236.4 28.9h-7.5v7.5 71.5H157.3h-7.5v7.5 70.3 7.5h7.5 71.5v71.5 7.5h7.5 70.3 7.5v-7.5V193.3h71.5 7.5v-7.5V115.5v-7.5h-7.5H314.2V36.4 28.9h-7.5H236.4zm7.5 86.6V43.9h55.2v71.5V123h7.5 71.5v55.2H306.6h-7.5v7.5 71.5H243.9V185.7v-7.5h-7.5H164.8V123h71.5 7.5v-7.5zM143.1 331.3h-2.6l-2.1 1.7L65.2 391.5H8 .4v15.1H8 67.8h2.6l2.1-1.7 73.2-58.6h201V384H233.9h-7.5v7.5 37.6 7.5h7.5H374.4h2.3l1.9-1.3 109.5-75.3 25.6 37.2L368.9 496.9H8 .4V512H8 371.2h2.3l1.9-1.3 153-105.2 6.2-4.3-4.3-6.2-34.1-49.6-4.3-6.2-6.2 4.3L372.1 421.6H241.4V399.1H354.3h7.5v-7.5V338.8v-7.5h-7.5H143.1z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fast',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M320 271L130.1 204.6l192.7-72.3 7.5-2.8-5.6-15-7.5 2.8-210.7 79L16 164.6v-9.3L320 49 624 155.4v9.3L320 271zM108.3 213.9L320 288 640 176V144L320 32 0 144v32l92.1 32.2L58 247.6l-2 2.3v3 66.4L48 359c-5 25-15.1 48.6-29.7 69.4l-10.5 15-6.5 9.2 10.8 3.1 73.6 20.8L96 479.4V468.8 430.4c0-31.7-5.7-63.1-16.8-92.7L72 318.5V255.8l36.3-41.9zm50.5 54.3l-15.5-5.6L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6l-15.5 5.6L496 408.6c-.2 2.4-2 7-9.5 13.5c-7.9 6.8-20.1 13.9-36.5 20.3C417.3 455.1 371.4 464 320 464s-97.3-8.9-129.9-21.6c-16.4-6.4-28.6-13.5-36.5-20.3c-7.5-6.5-9.3-11.2-9.5-13.5l14.8-140.3zm-92.5 81C75.4 375.3 80 402.8 80 430.4v27.8L27.4 443.4l4.1-5.8c15.9-22.7 26.8-48.4 32.3-75.5l2.6-12.9z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fast',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      'M173.7 416H16 0V400 16 0H16 496h16V16 400v16H496 338.3l-71.7 83.7L256 512l-10.5-12.3L173.7 416zM256 487.4l70.1-81.8 4.8-5.6h7.4H496V16H16V400H173.7h7.4l4.8 5.6L256 487.4z'
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fast',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      'M16 80V432H368V344 168 80H16zM384 352v80 16H368 16 0V432 80 64H16 368h16V80v80 17.9V334.1 352zm32-1.9l144 72V89.9l-144 72V144L560 72l16-8V81.9 430.1 448l-16-8L416 368V350.1z'
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fast',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM144 96H128v8 56H88 72v16 32 16H88h96 16V208 176 160H184 144V104 96zm0 80h40v32H88V176h40 16zm0 80H128v8V408v8h16v-8V264v-8zM320 104V96H304v8V256H264 248v16 32 16h16 96 16V304 272 256H360 320V104zM304 272h16 40v32H264V272h40zm16 88v-8H304v8 48 8h16v-8V360z'
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fast',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      'M184 360v8h16v-8V200H360h8V184h-8H200V24 16H184v8V184H24 16v16h8H184V360zM8 464v16h8H368h8V464h-8H16 8z'
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fast',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      'M40 32H32v8V192v8 24 96h1.6C12.9 340.3 0 368.7 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-31.3-12.9-59.7-33.6-80H448h88v80 2.9l1.9 2.2 88 104 12.2-10.3L552 397.1V242.9l86.1-101.8-12.2-10.3-88 104-1.9 2.2V240v64H448V200v-8h-8H360V128v-8H344v8 64H284.7L199 36.1 196.7 32H192 40zM432 304v4.1c-18.1-12.7-40.2-20.1-64-20.1H112c-23.8 0-45.9 7.4-64 20.1V224 208H279.9h.3H344h16 72v96zM266.5 192H48V48H187.3l79.2 144zM112 304H368c53 0 96 43 96 96s-43 96-96 96H112c-53 0-96-43-96-96s43-96 96-96zM96 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm304-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fast',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      'M0 32H16V480H0V32zm256 0h16V480H256V32zm144 0V480H384V32h16zm-96 0h16V480H304V32zM64 32V480H48V32H64zm384 0h16V480H448V32zm64 0V480H496V32h16zM112 32h16V480H112V32zm88 0V480H184V32h16z'
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fast',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      'M80 496H16V16H208V168v8h8H368V304h16V160L224 0H16 0V16 496v16H16 80V496zM361.4 160H224V22.6L361.4 160zM248 376v-8l-8 0-5.6 0-4.6 0-2.3 3.9-35.6 60.5-37-60.6-2.3-3.8-4.5 0-4 0-8 0v8V504v8h16v-8V397.9l33.2 54.3 7 11.4 6.8-11.5L232 395.8V504v8h16v-8V376zm56-8h-8v8 80 48 8h16v-8V464h24c26.5 0 48-21.5 48-48s-21.5-48-48-48H304zm32 80H312V384h24c17.7 0 32 14.3 32 32s-14.3 32-32 32zm88 0h8 56v56 8h16v-8V440 376v-8H488v8 56H440V376v-8H424v8 64 8z'
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fast',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM256 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3V328v8h16v-8V255.3c22.7-3.8 40-23.6 40-47.3z'
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fast',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      'M0 248l8 0 496 0 8 0 0 16-8 0L8 264l-8 0 0-16zm244.7 83.3L256 320l11.3 11.3L416 480l0 16 0 16-16 0-288 0-16 0 0-16 0-16L244.7 331.3zM112 486.6l0 9.4 288 0 0-9.4-144-144-144 144zM256 192l-11.3-11.3L96 32l0-16L96 0l16 0L400 0l16 0 0 16 0 16L267.3 180.7 256 192zM112 16l0 9.4 144 144 144-144 0-9.4L112 16z'
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fast',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM328 192a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0 16c-19.1 0-35.9-9.5-46-24.1L173.2 238.4c1.8 5.5 2.8 11.5 2.8 17.6s-1 12.1-2.8 17.6L282 328.1c10.1-14.5 26.9-24.1 46-24.1c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-6.2 1-12.1 2.8-17.6L166 287.9c-10.1 14.5-26.9 24.1-46 24.1c-30.9 0-56-25.1-56-56s25.1-56 56-56c19.1 0 35.9 9.5 46 24.1l108.8-54.4c-1.8-5.5-2.8-11.5-2.8-17.6c0-30.9 25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56zm0 192a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM160 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fast',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M302.5 35.3l-1.8 23.1-1.3 17.5L315.9 70 492.5 7 512 0l-7 19.5L442 196.1l-5.9 16.5 17.5-1.3 23.1-1.8L496 208l-9.7 16.8L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L287.2 25.7 304 16l-1.5 19.3zM304.8 91l-23.2 8.3 1.9-24.6 2.3-29.6L109.3 147.2C51.6 180.6 16 242.3 16 309c0 103.3 83.7 187 187 187c66.7 0 128.4-35.6 161.8-93.3L466.9 226.3l-29.6 2.3-24.6 1.9 8.3-23.2L485.6 26.4 304.8 91zM208.9 206.7l30.6 61.1 68.3 9.8 20.1 2.9-14.6 14.1L264 342l11.7 67 3.4 19.8-17.8-9.3L200 387.8l-61.3 31.7-17.8 9.3 3.4-19.8L136 342 86.6 294.5 72 280.5l20.1-2.9 68.3-9.8 30.6-61.1 8.9-17.9 8.9 17.9zm28.3 77l-8.3-1.2-3.7-7.5L200 224.5 174.8 275l-3.7 7.5-8.3 1.2-56 8 40.3 38.8 6.1 5.9-1.5 8.4-9.6 55 50.5-26.1 7.4-3.8 7.4 3.8 50.5 26.1-9.6-55-1.5-8.4 6.1-5.9 40.3-38.8-56-8z'
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fast',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      'M208 16h36L368.1 184 208 184V16zM384.1 200H494.6L624 245.7v20.7L494.6 312H384.1h-.2H152h-2.9l-2.2 1.9L101.1 352H48V264H152h8V248h-8H48V160h53.1l45.8 38.1 2.2 1.9H152 383.9h.2zM32 264v96 8h8 64 2.9l2.2-1.9L154.9 328l37.1 0V496h-8v16h8l8 0 47.9 0h.2H304h8V496h-8H263.9L388 328H496h1.4l1.3-.5 136-48 5.3-1.9V272 240v-5.7l-5.3-1.9-136-48-1.3-.5H496 388L263.9 16H304h8V0h-8H248.1h-.2H200h-8-8V16h8V184l-37.1 0-45.8-38.1-2.2-1.9H104 40 32v8 96H8 0v16H8 32zm176 64l160.1 0L244 496H208V328z'
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fast',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      'M368 118.6V496H16V16H265.4L368 118.6zm16-6.6L272 0H16 0V16 496v16H16 368h16V496 112zM96 304v16h16H272h16V304 288l-84.7-84.7L192 192l-11.3 11.3L96 288v16zm16-9.4l80-80 80 80V304H112v-9.4z'
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fast',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M209.3 64H294L277.1 80h-65l-73.9 62.1c-1.4 1.2-3.3 1.9-5.1 1.9H40 32V128h8 90.2l73.9-62.1c1.4-1.2 3.3-1.9 5.1-1.9zm131.3 0h3.2 85.6 2.9l2.2 1.9L508.4 128H600h8v16h-8H505.5h-2.9l-2.2-1.9L426.4 80H346.9L194.9 224l64.7 64.7L364 184.4l5.7-5.7L380.9 190l-5.7 5.7-13.9 13.9L484.3 332.5l3.5 3.5H600h8v16h-8H480h-3.9l-59.6 59.6-5.7 5.7-5.7-5.7-26-26-56.9 56.9-5.7 5.7-5.7-5.7-43-43-37 37-5.7 5.7-5.7-5.7L191 407.7l0 0-5.7-5.7L135.2 352H48 40l0-16h8 90.5 3.3l2.3 2.3 37 37 0 0 44.1 44.1 37-37 5.7-5.7 5.7 5.7 43 43 56.9-56.9 5.7-5.7 5.7 5.7 26 26 56.5-56.5L350.1 220.9l-84.8 84.8-5.7 5.7-5.7-5.7-76.2-76.2-5.8-5.8 6-5.7L338.3 66.2l2.3-2.2z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fast',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      'M312 256c0 58.8-17.5 111.4-44.9 148.9C239.6 442.5 203 464 164 464s-75.6-21.5-103.1-59.1c-11.1-15.1-20.5-32.7-27.8-52.1C46.3 362.4 62.5 368 80 368c44.2 0 80-35.8 80-80s-35.8-80-80-80c-25.9 0-48.9 12.3-63.5 31.4c3-52.1 19.6-98.4 44.5-132.3C88.4 69.5 125 48 164 48s75.6 21.5 103.1 59.1C294.5 144.6 312 197.2 312 256zM16.8 277.8C21.7 247.3 48.1 224 80 224c35.3 0 64 28.7 64 64s-28.7 64-64 64c-25.5 0-47.5-14.9-57.8-36.5c-2.6-12.1-4.4-24.7-5.4-37.7zM320 186.7C298.6 96.9 236.9 32 164 32C73.4 32 0 132.3 0 256S73.4 480 164 480c72.9 0 134.6-64.9 156-154.7C341.4 415.1 403.1 480 476 480c90.6 0 164-100.3 164-224s-73.4-224-164-224c-72.9 0-134.6 64.9-156 154.7zm52.9 218.2c-13-17.7-23.7-38.9-31.5-62.4C356.1 358.2 376.9 368 400 368c44.2 0 80-35.8 80-80s-35.8-80-80-80c-31.7 0-59 18.4-72 45.1c.6-57.6 17.9-109.1 44.9-146C400.4 69.5 437 48 476 48s75.6 21.5 103.1 59.1C606.5 144.6 624 197.2 624 256s-17.5 111.4-44.9 148.9C551.6 442.5 515 464 476 464s-75.6-21.5-103.1-59.1zM400 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128z'
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fast',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-376v-8H320v8V296c0 39.8-32.2 72-72 72s-72-32.2-72-72V280v-8H160v8 16c0 48.6 39.4 88 88 88s88-39.4 88-88V136z'
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fast',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      'M560 16V336H16V16H560zM16 0H0V16 336v16H16 560h16V336 16 0H560 16zM80 432v64H16V432H80zM16 416H0v16 64 16H16 80 96V496 432 416H80 16zm160 16h64v64H176V432zm-16-16v16 64 16h16 64 16V496 432 416H240 176 160zm240 16v64H336V432h64zm-64-16H320v16 64 16h16 64 16V496 432 416H400 336zm160 16h64v64H496V432zm-16-16v16 64 16h16 64 16V496 432 416H560 496 480z'
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fast',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      'M0 120l0-8 8 0 248 0 0-40 0-8 8 0 96 0c83.9 0 152 68.1 152 152l0 80c0 83.9-68.1 152-152 152l-8 0-8 0-64 0-72 0-8 0 0-8 0-72-8 0-8 0 0-8 0-72-24 0-8 0 0-8 0-72L8 208l-8 0 0-8 0-80zm168 88l0 64 16 0 8 0 64 0 0-64-88 0zm104 64l0 0 64 0 0-104 0-8 16 0 0 8 0 104 0 8 0 8 0 64 0 8 0 8 0 64 8 0c75.1 0 136-60.9 136-136l0-80c0-75.1-60.9-136-136-136l-88 0 0 32 0 0 0 16 0 0 0 64 0 0 0 16 0 0 0 64zm0 16l-8 0-8 0-56 0 0 64 8 0 128 0 0-64-64 0zm-16-96l0-64L16 128l0 64 136 0 8 0 96 0zm24 240l56 0 0-64-120 0 0 64 64 0z'
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fast',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      'M460.7 124.7L449.4 136l11.3 11.3 6.8 6.8-41 16.4 12.3 12.3 41-16.4L496 160l-12.3-12.3-.4-.4L472 136l11.3-11.3 16-16L512 96l-17-5.7L482 86l10.6-53L496 16l-17 3.4L426 30l-4.3-13L416 0 403.4 12.6l-16 16L376 40 364.7 28.7l-.4-.4L352 16l-6.5 16.2-16.4 41 12.3 12.3 16.4-41 6.8 6.8L376 62.6l11.3-11.3L409 29.6l1.8 5.4 4.5 13.4 13.8-2.8 46.5-9.3-9.3 46.5-2.8 13.9 13.4 4.5 5.4 1.8-21.7 21.7zM134.6 496L16 377.4V262.6L198.6 80H313.4L432 198.6V313.4L249.4 496H134.6zM0 384L128 512H256L448 320V192L320 64H192L0 256V384zM165.7 218.3l-5.7-5.7L148.7 224l5.7 5.7 32 32 5.7 5.7 5.7-5.7 32-32 5.7-5.7L224 212.7l-5.7 5.7L192 244.7l-26.3-26.3zm-64 96L96 308.7 84.7 320l5.7 5.7 32 32 5.7 5.7 5.7-5.7 32-32 5.7-5.7L160 308.7l-5.7 5.7L128 340.7l-26.3-26.3zm128 0l-5.7-5.7L212.7 320l5.7 5.7 32 32 5.7 5.7 5.7-5.7 32-32 5.7-5.7L288 308.7l-5.7 5.7L256 340.7l-26.3-26.3zm-64 96l-5.7-5.7L148.7 416l5.7 5.7 32 32 5.7 5.7 5.7-5.7 32-32 5.7-5.7L224 404.7l-5.7 5.7L192 436.7l-26.3-26.3z'
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fast',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM232 232c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L328 326.9V352v8H312v-8V322.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H288c-22.1 0-40 17.9-40 40l0 6.5-16 0V232zm72 152h32v32H304V384z'
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fast',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM198.7 116.4c-26.8 40.2-66.8 61.4-84.1 67.2l-7.6 2.5-5.1-15.2 7.6-2.5c14.7-4.9 51.5-24.2 75.9-60.8l4.4-6.7 13.3 8.9-4.4 6.7zm19 113.4l-7.8 1.9-64 16-7.8 1.9-3.9-15.5 7.8-1.9 64-16 7.8-1.9 3.9 15.5zm188 111.8l-39.3 39.3c-12.2 12.2-28.7 19.1-46 19.1c-12.2 0-24.1-3.4-34.5-9.9l-14.2-8.9c-20.4-12.7-45.6-15-67.9-6.1c-27.9 11.2-59.6 7.9-84.6-8.8l-11.5-7.7-6.7-4.4 8.9-13.3 6.7 4.4 11.5 7.7c20.7 13.8 46.8 16.5 69.8 7.3c27.1-10.8 57.7-8.1 82.4 7.4l14.2 8.9c7.8 4.9 16.8 7.5 26 7.5c13 0 25.5-5.2 34.7-14.4l39.3-39.3 5.7-5.7L411.3 336l-5.7 5.7zM320.5 166.3c-5.1 10.3-8.5 25-8.5 41.7s3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C346.1 155.6 340.2 152 336 152s-10.1 3.6-15.5 14.3zm-14.3-7.2c6.2-12.4 16.3-23.2 29.8-23.2s23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C359.6 269.3 349.5 280 336 280s-23.6-10.7-29.8-23.2C299.8 243.9 296 226.6 296 208s3.8-35.9 10.2-48.8z'
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fast',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      'M96 32v8V238.8l234.9-197 6.1-5.1L347.3 49l-6.1 5.1L110 248H376h8v16h-8H110L341.1 457.9l6.1 5.1L337 475.3l-6.1-5.1L96 273.2V473v8H80v-8V264H8 0V248H8 80V40 32H96z'
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fast',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      'M16 496H176v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM232 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v16H296V400c0-8.8-7.2-16-16-16H264c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464h-8-8V448h8 16 8v8 24c0 17.7-14.3 32-32 32H264c-17.7 0-32-14.3-32-32V400zm144-24V504v8H360v-8V376v-8h16v8zm56-8h48 8v16h-8H440v48h40 8v16h-8H440v56 8H424v-8V440 376v-8h8z'
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fast',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      'M332.4 27.7c4.9 1.8 9.1 3.7 12.8 5.5c8.3-1 17-1.6 26.4-2C354.2 16.7 301.4-13.6 178.8 6.9C21 33.3 0 101.7 0 101.7L31.7 291.1C52.8 417.3 252.7 448.8 252.7 448.8s.7-.4 2.1-1.2c-4.9-5.6-9.8-11.4-14.5-17.6c-4.3-1-9.5-2.2-15.2-3.6c-18.5-4.8-43.2-12.4-68.5-23.7C105.1 379.5 56.6 343.2 47.5 288.4L16.6 103.8c.6-1.2 1.5-2.7 2.6-4.4c3.5-5.5 10-13.6 21.2-22.7c22.4-18.3 64.3-41.1 141.1-53.9s123.9-4.9 151 5zM166.6 293.8c-6.9 5.4-12.5 10.6-16.4 14.4c-1.9 1.9-3.4 3.5-4.5 4.6c-.5 .6-.9 1-1.2 1.3l-.3 .4-.1 .1 0 0s0 0 6.1 5.2s6.1 5.2 6.1 5.2l.1-.1 .2-.3c.2-.2 .6-.6 1-1.1c.9-1 2.2-2.4 4-4.1c3.5-3.5 8.6-8.2 15-13.1c6-4.7 12.9-9.4 20.5-13.4c.3-2.5 .7-5 1.1-7.5l1.9-11.6c-13 5.5-24.5 13-33.4 19.9zM102.3 175.2L99 182.5c-3.3 7.3-3.3 7.3-3.3 7.3l0 0 .1 0 .3 .1 1 .4c.8 .3 2 .8 3.5 1.4c2.9 1.1 7 2.6 11.8 3.9c9.3 2.6 22.1 5.2 33.7 3.2s22.9-8.5 30.8-14c4.1-2.8 7.5-5.6 9.9-7.6c1.2-1 2.2-1.8 2.8-2.4l.8-.7 .2-.2 .1-.1 0 0s0 0-5.5-5.8l-5.5-5.8 0 0-.1 .1-.6 .6c-.6 .5-1.4 1.2-2.4 2.1c-2.1 1.8-5.2 4.2-8.8 6.7c-7.4 5.2-16.3 10.1-24.3 11.4s-18-.4-26.7-2.9c-4.2-1.2-7.9-2.5-10.5-3.5c-1.3-.5-2.3-.9-3-1.2l-.8-.3-.2-.1 0 0zm285 336.6s199.9-31.4 221.1-157.7L640 164.8s-21-68.4-178.8-94.8s-199.9 31.4-199.9 31.4L229.6 290.7C208.4 417 387.3 511.8 387.3 511.8zm-111-403.1c1-.9 2.2-2 3.9-3.3c5.1-4 13.9-9.6 27.4-14.6c27.1-10 74.2-17.9 151-5s118.7 35.7 141.1 53.9c11.2 9.1 17.6 17.3 21.2 22.7c1.1 1.8 2 3.2 2.6 4.4L592.5 351.5c-9.2 54.7-57.7 91.1-109.2 114.2c-25.2 11.3-50 18.9-68.5 23.7c-9.2 2.4-16.8 4-22.1 5.1c-1 .2-1.9 .4-2.7 .5c-.7-.4-1.5-.9-2.4-1.4c-4.6-2.7-11.3-6.8-19.2-12c-15.9-10.5-36.8-25.8-57-44.7c-41.2-38.7-75.2-88.8-66.1-143.6l30.9-184.7zm62.2 124.9l.1-.1 .5-.3c.4-.3 1.1-.7 2-1.2c1.8-1 4.3-2.4 7.4-3.7c6.3-2.6 14.2-4.5 21.9-3.2s14.5 5.7 19.7 10.2c2.5 2.2 4.5 4.3 5.8 5.9c.7 .8 1.2 1.4 1.5 1.8l.3 .4 .1 .1s0 0 6.5-4.6s6.5-4.6 6.5-4.6l0 0-.1-.1-.2-.2-.2-.3-.4-.5c-.5-.6-1.1-1.4-2-2.4c-1.7-2-4.2-4.7-7.4-7.5c-6.3-5.5-15.8-12-27.6-13.9s-22.9 1-30.6 4.2c-3.9 1.6-7.2 3.3-9.4 4.7c-1.1 .7-2 1.2-2.7 1.7c-.3 .2-.6 .4-.8 .5l-.2 .2-.1 .1 0 0s0 0 4.7 6.5s4.7 6.5 4.7 6.5zM460 248.2c4.7 6.5 4.7 6.5 4.7 6.5l.1-.1 .5-.3c.4-.3 1.1-.7 2-1.2c1.8-1 4.3-2.4 7.4-3.7c6.3-2.6 14.2-4.5 21.9-3.2s14.5 5.7 19.7 10.2c2.5 2.2 4.5 4.3 5.8 5.9c.7 .8 1.2 1.4 1.5 1.8l.3 .4 .1 .1s0 0 6.5-4.6s6.5-4.6 6.5-4.6l0 0-.1-.1-.2-.2c-.1-.2-.3-.4-.6-.7c-.5-.6-1.1-1.4-2-2.4c-1.7-2-4.2-4.7-7.4-7.5c-6.3-5.5-15.8-12-27.6-13.9s-22.9 1-30.6 4.2c-3.9 1.6-7.2 3.3-9.4 4.7c-1.1 .7-2 1.2-2.7 1.7c-.3 .2-.6 .4-.8 .5l-.2 .2-.1 .1 0 0s0 0 4.7 6.5zm-42.4 82.1c-34.9-5.8-65.7-21.6-89.9-43.8c-4.6-4.2-8.9-8.7-13-13.3c-1.5 4.8-2.7 9.8-3.6 15c-.2 1.3-.4 2.6-.6 4c-7.8 59.5 32.9 115 92.6 125s116.2-29.2 128.2-88c.3-1.3 .5-2.6 .7-3.9c.9-5.1 1.4-10.3 1.5-15.3c-5.4 3.1-11 5.9-16.7 8.3c-30.2 13.2-64.4 18-99.3 12.2zM415 346.1c34 5.7 67.4 2.1 97.7-9C498 381.2 453 409.2 405.7 401.3s-80.6-49.1-80.2-95.6c25 20.3 55.4 34.6 89.4 40.3z'
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fast',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      'M448 352v64H48 32v16 32 16H48 624h16V464 432 416 336 320 256L256.6 64.3c-21.4-10.7-45-16.3-69-16.3C131.1 48 79.2 78.8 52.1 128.4L7.9 209.5 0 224l16 4 32 8V344v8h8H448zm0-16H64V240l384 96zm176 80H464V336 323.5l-12.1-3L24 213.5l42.2-77.4C90.4 91.6 137 64 187.6 64c21.5 0 42.6 5 61.8 14.6L624 265.9V320v16 80zM464 432H624v32H48V432H448h16z'
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fast',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M0 32H8 160c123.7 0 224 100.3 224 224s-100.3 224-224 224H8 0v-8V40 32zM16 48V464H160c114.9 0 208-93.1 208-208s-93.1-208-208-208H16z'
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fast',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M40 32H32v8 88 8 88H8 0v8V408v64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H496v56 8h16v-8V408 232v-8h-8H480V136v-8V40 32h-8H40zm8 112H248v80H48V144zm200-16H48V48H464v80H264h-8-8zm16 16H464v80H264V144zm0 96H464h16 16V400H16V240H32 48 248h16z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fast',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      'M0 248H8 632h8v16h-8H8 0V248z'
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fast',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      'M387.3 220.7L376 232l-11.3-11.3-73.4-73.4L280 136l11.3-11.3L404.7 11.3 416 0l11.3 11.3 73.4 73.4L512 96l-11.3 11.3L387.3 220.7zM489.4 96L416 22.6 302.6 136 376 209.4 489.4 96zm-279 194.3l112-112 11.3 11.3-112 112 87 87L320 400l-11.3 11.3L280 440 17.7 507.4 0 512l4.5-17.7L72 232l28.7-28.7L112 192l11.3 11.3 87 87zm61.4 135.3L297.4 400 112 214.6 86.4 240.2 22.2 489.8l249.5-64.2z'
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fast',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      'M296 0V8 48.1c142.8 3.7 260.8 105.4 277.9 237.8l.3 2.1 2.1 16H560.1 558h-6.5-7.2l-4.8-5.3C525 282.3 503.7 272 480 272c-44.2 0-80 35.8-80 80H384h0H368c0-44.2-35.8-80-80-80s-80 35.8-80 80H192h0H176c0-44.2-35.8-80-80-80c-23.7 0-45 10.3-59.6 26.7L31.6 304H24.4 18 15.9-.2l2.1-16 .3-2.1C19.2 153.5 137.2 51.8 280 48.1V8 0h16zM280 304.7c2.6-.4 5.3-.7 8-.7s5.4 .2 8 .7V462.2c0 27.5-22.3 49.8-49.8 49.8c-21.5 0-40.5-13.7-47.3-34.1l-6.5-19.4-2.5-7.6 15.2-5.1 2.5 7.6 6.5 19.4c4.6 13.8 17.5 23.1 32.1 23.1c18.7 0 33.8-15.2 33.8-33.8V304.7zM385.3 336c7.6-45.4 47.1-80 94.7-80c28.4 0 54 12.4 71.6 32H558C541.7 161.8 427 64 288 64S34.3 161.8 18 288h6.5C42 268.4 67.6 256 96 256c47.6 0 87.1 34.6 94.7 80H192h1.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H384h1.3z'
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fast',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      'M0 224l8-14L128 0 558 168.9l18 7.1-15.9 10.9L320 352 215 310 167.5 434.8l-2 5.2H160 16v64 8H0v-8V432 360v-8H16v8 64H154.5l45.7-119.9L15 230 0 224zM318 334L542.1 179.9 135 20 23 216 318 334zm187.3 59.8L387.7 344.3l15.7-10.8 108 45.5L555 273l-40.6-15.8 15.9-11 30.8 12L576 264l-6.1 14.8L526.1 385.2 520 400l-14.7-6.2z'
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fast',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M48 48V208H208V48H48zM32 32H48 208h16V48 208v16H208 48 32V208 48 32zM48 304V464H208V304H48zM32 288H48 208h16v16V464v16H208 48 32V464 304 288zM464 48H304V208H464V48zM304 32H464h16V48 208v16H464 304 288V208 48 32h16zm0 272V464H464V304H304zm-16-16h16H464h16v16V464v16H464 304 288V464 304 288z'
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fast',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      'M405 16l-62.9 91.2L333 120.4c4.1 2.6 8.6 5.6 13.3 8.8C406.9 170.8 512 262.9 512 416v80 16H496 16 0V496 416C0 262.9 105.1 170.8 165.7 129.2c4.7-3.3 9.2-6.2 13.3-8.8l-9.1-13.2L107 16 96 0h19.4H396.6 416L405 16zm91 400c0-156.4-115.8-246.4-171.6-282.1l-9.2-5.9H196.8l-9.2 5.9C131.8 169.6 16 259.6 16 416v80H496V416zM319.3 112l.5-.7L385.5 16H126.5l65.7 95.3 .5 .7H319.3z'
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fast',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM136 144h-8v16h8H248V392v8h16v-8V160H376h8V144h-8H256 136z'
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fast',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M16 122.5V144H224c-5-6.7-8-15-8-24c0-22.1 17.9-40 40-40s40 17.9 40 40c0 9-3 17.3-8 24H496V122.5L256 17.5 16 122.5zM256 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 16H16 0V144 112L256 0 512 112v32 16H496 256zM80 192v8V368H184V200v-8h16v8V368H312V200v-8h16v8V368H432V200v-8h16v8V376v8h-8H328 312 200 184 72 64v-8V200v-8H80zM32 432h8H472h8v16h-8H40 32V432zM0 496H8 504h8v16h-8H8 0V496z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fast',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      'M240 38.1l160-20V64H240V38.1zM400 2L224 24V64 80h16H400h16V64 16.1 0L400 2zm-2.7 238L240 418.8V304 288H224 72 48V240H72 240 397.3zM224 440.4V496v16h16H400h16V496 401.2 369.7l16 27.1 29.4 49.8 8.1 13.8 13.8-8.1 41.3-24.4 13.8-8.1-8.1-13.8L434.4 243.6 422.8 224H400 240 72 48 32v16 48 16H48 72 208h16v16V439.6c0 .2 0 .5 0 .7zm16 7.6H400v48H240V448zm160-16H249.7L414 245.3c.6-.7 1.1-1.5 1.4-2.3l5.2 8.8L516.5 414l-41.3 24.4-45.4-76.9-5.7-9.6H400v17.7V432zM241.6 96c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H382c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16H241.6z'
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fast',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      'M144 144a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM400 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM149.5 496H391.9l9.2 16H144.7 128l4.8-16L176 352H347.3l-5.9 7.4 14.9 8.6H187.9L149.5 496zM614.2 251.1l-14 8.1L580.9 208H447c-.7-5.4-1.7-10.8-3-16H592l22.2 59.1zM48 192H196c-1.3 5.2-2.4 10.6-3 16H59.1l-36 96H6L48 192zm464-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM480 256h8 48 8v8 29.6c11 4.4 20.9 10.2 30.3 17.5l25.6-14.8 6.9-4 4 6.9 24 41.6 4 6.9-6.9 4-25.6 14.8c.9 5.6 1.6 11.5 1.6 17.5s-.7 11.9-1.6 17.5l25.6 14.8 6.9 4-4 6.9-24 41.6-4 6.9-6.9-4-25.6-14.8c-9.3 7.3-19.2 13.1-30.3 17.5V504v8h-8H488h-8v-8V474.4c-11-4.4-20.9-10.2-30.3-17.5l-25.6 14.8-6.9 4-4-6.9-24-41.6-4-6.9 6.9-4 25.6-14.8c-.9-5.6-1.6-11.5-1.6-17.5s.7-11.9 1.6-17.5l-25.6-14.8-6.9-4 4-6.9 24-41.6 4-6.9 6.9 4 25.6 14.8c9.3-7.3 19.2-13.1 30.3-17.5V264v-8zm16 16v27.1 5.7l-5.3 1.9c-13.1 4.6-24.3 11.1-34.9 20.2l-4.3 3.7-4.9-2.8L423 314.1l-16 27.7 23.5 13.6 4.9 2.8-1 5.6c-1.3 7.1-2.4 13.7-2.4 20.2s1 13.1 2.4 20.2l1 5.6-4.9 2.8L407 426.1l16 27.7 23.5-13.6 4.9-2.8 4.3 3.7c10.6 9.1 21.8 15.6 35 20.2l5.3 1.9v5.7V496h32V468.9v-5.7l5.3-1.9c13.2-4.6 24.3-11.1 35-20.2l4.3-3.7 4.9 2.8L601 453.9l16-27.7-23.5-13.6-4.9-2.8 1-5.6c1.3-7.1 2.4-13.7 2.4-20.2s-1-13.1-2.4-20.2l-1-5.6 4.9-2.8L617 341.9l-16-27.7-23.5 13.6-4.9 2.8-4.3-3.7c-10.6-9.1-21.8-15.6-34.9-20.2l-5.3-1.9v-5.7V272H496zm16 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fast',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm8-304v-8H200v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V112z'
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fast',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M361.5 32H382L202.3 256 382 480H361.5L192 268.8 22.5 480H2L181.7 256 2 32H22.5L192 243.2 361.5 32z'
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fast',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      'M17.4 86.2c-.9 5.6-1.4 11.3-1.4 17V120c0 57.4 46.6 104 104 104h40V160H97c-41 0-75.4-31.1-79.5-71.9c-.1-.6-.1-1.2-.2-1.8zM97 144h63V112 96h16H464h16v16 32h63c32.8 0 60.3-24.9 63.5-57.5c.9-9-.1-18-3-26.5L592.4 26.5 606.2 19l7.5 9.3c17 21.3 26.3 47.7 26.3 75V120c0 66.3-53.7 120-120 120H480V368v16H464 414.4L376 512H264L225.6 384H176 160V368 240H120C53.7 240 0 186.3 0 120V103.3C0 76 9.3 49.6 26.3 28.3L33.8 19l13.8 7.5L36.4 59.9c-2.8 8.5-3.9 17.6-3 26.5C36.8 119.1 64.2 144 97 144zm383 80h40c57.4 0 104-46.6 104-104V103.3c0-5.7-.5-11.4-1.4-17c0 .6-.1 1.2-.2 1.8C618.3 128.9 584 160 543 160H480v64zm-16-64V144 112H176v32 16V368h49.6 11.9l3.4 11.4 35 116.6h88.2l35-116.6 3.4-11.4h11.9H464V160zM256 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm64 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fast',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      'M16 32H0V48 400v16H16 288V400H16V48H288V32H16zM80 96H64v16V336v16H80 288V336H80V112H288V96H80zm24 368H96v16h8H288V464H104zM624 48V464H336V48H624zM336 32H320V48 464v16h16H624h16V464 48 32H624 336zM480 400a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm-96-80a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fast',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      'M224 16V48c0 17.7 14.3 32 32 32s32-14.3 32-32V16H224zM208 0h16 64 16V16 42.9c19.7 4.5 38.4 11.6 55.6 21.1H368h64 16V80v32c0 10.2-3.2 19.6-8.6 27.4c12.9 20.8 22.5 43.9 27.8 68.6H496h16v16 32c0 25.8-20.4 46.9-45.9 48C462 321 455.9 337.4 448 352.6V368v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368 352h16 62.1c8.8-15.5 15.6-32.3 20-50c-17.3-5.2-30.4-19.9-33.4-38H303.3c-2.3 13.7-10.4 25.4-21.7 32.6l85.7 204.3L372 512H360 152 140l4.7-11.1 85.7-204.3C219 289.4 211 277.7 208.7 264H95.3c-3 18.1-16.2 32.7-33.4 38c4.4 17.7 11.2 34.5 20 50H144h16v16 32c0 26.5-21.5 48-48 48s-48-21.5-48-48V368 352.6C56.1 337.4 50 321 45.9 304C20.4 302.9 0 281.8 0 256V224 208H16 44.8c5.3-24.7 14.8-47.8 27.8-68.6C67.2 131.6 64 122.2 64 112V80 64H80h64 8.4c17.3-9.5 35.9-16.6 55.6-21.1V16 0zM416 248V224 208h16 18.8c-4.7-20.3-12.6-39.5-23-56.9c-7.8 5.6-17.4 8.9-27.8 8.9s-20-3.3-27.8-8.9l-77.1 77.1c4.1 5.8 7 12.5 8.2 19.8H416zM360.9 139.8c-5.6-7.8-8.9-17.4-8.9-27.8V80 78.1c-15.3-8.4-31.9-14.8-49.3-19c-4.4 18.6-19.6 33.1-38.7 36.3V208.7c7.3 1.2 14 4.1 19.8 8.2l77.1-77.1zM248 95.3c-19.1-3.2-34.3-17.7-38.7-36.3c-17.4 4.2-34 10.6-49.3 19V80v32c0 10.4-3.3 20-8.9 27.8l77.1 77.1c5.8-4.1 12.5-7 19.8-8.2V95.3zM139.8 151.1c-7.8 5.6-17.4 8.9-27.8 8.9s-20-3.3-27.8-8.9c-10.4 17.4-18.2 36.6-23 56.9H80 96v16 24H208.7c1.2-7.3 4.1-14 8.2-19.8l-77.1-77.1zM256 304c-3.8 0-7.4-.4-10.9-1.2L164 496H348l-81-193.2c-3.5 .8-7.2 1.2-10.9 1.2zM16 224v32c0 17.7 14.3 32 32 32s32-14.3 32-32V224H16zm480 0H432v32c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM80 80v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80H80zm352 0H368v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80zM80 400c0 17.7 14.3 32 32 32s32-14.3 32-32V368H80v32zm288-32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V368H368zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fast',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M168 8V0H152V8 63.5c-9.5-.2-18.9 .1-28.2 .8c-24.6 2-48.4 7.8-67.4 20.1C37.1 96.9 23 115.7 17.9 142.6c-3.8 19.8-1.7 36.6 5.3 50.8c7 14.1 18.5 25 32.3 33.7c27.1 17 65.2 26.8 101.6 36.2l0 0 .9 .2c37.5 9.7 73.2 18.9 98 34.5c12.2 7.7 21.2 16.5 26.5 27.2c5.2 10.6 7.2 23.7 3.9 40.7c-4.9 25.3-22.9 43.8-51.1 54.6c-28.4 10.9-66.4 13.9-108.8 7.9c-26.5-3.9-66.2-12.9-99.3-26.9l-7.4-3.1-6.2 14.7 7.4 3.1c34.8 14.8 75.9 24 103.3 28l0 0c9.4 1.3 18.7 2.2 27.8 2.7v1 56 8h16v-8V448v-.5c27.2 0 52.1-3.9 73-12c31.9-12.3 54.9-34.4 61.1-66.5c3.8-19.8 1.7-36.6-5.3-50.8c-7-14.1-18.5-25-32.3-33.7c-27.1-17-65.2-26.8-101.6-36.2l0 0-.9-.2c-37.5-9.7-73.2-18.9-98-34.5c-12.2-7.7-21.2-16.5-26.5-27.2c-5.2-10.6-7.2-23.7-3.9-40.7c4.3-22.5 15.7-37.6 31.5-47.7c16-10.3 36.9-15.7 60.1-17.6c46.5-3.8 99.8 6.4 135 14.8l7.8 1.9 3.7-15.6-7.8-1.9c-25.1-6-60.1-13.2-95.9-15.4V64 8z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fast',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 136V376v8H264v-8V136v-8h16v8zM152 168V344v8H136v-8V168v-8h16v8zm192 24V320v8H328v-8V192v-8h16v8zM216 208v96 8H200v-8V208v-8h16v8zm192 24v48 8H392v-8V232v-8h16v8z'
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fast',
    iconName: 'face-nose-steam',
    icon: [
      512,
      512,
      [],
      'e382',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 21.4-2.8 42.2-8.1 61.9l15.5 4.1C509 301 512 278.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 22.8 3 45 8.6 66.1l15.5-4.1C18.8 298.2 16 277.4 16 256zM256 496c-27.1 0-53.1-4.5-77.4-12.8l-5.2 15.1c25.9 8.8 53.7 13.6 82.6 13.6s56.7-4.8 82.6-13.6l-5.2-15.1C309.1 491.5 283.1 496 256 496zM386.5 143.6l7.6-2.5-5.1-15.2-7.6 2.5c-39.8 13.3-71.8 38.6-83.1 49.9l-5.7 5.7L304 195.3l5.7-5.7c10-10 39.9-33.7 76.9-46.1zM96 240v16h8H216h8V240h-8H104 96zm192 0v16h8H408h8V240h-8H296h-8zM112.4 349.3c-1.8-3.3-4.1-6.4-6.9-9.2c-15.6-15.6-40.9-15.6-56.6 0c-3.5 3.5-6.3 7.6-8.2 11.9c-12.9-2.9-27 .7-37 10.7c-15.6 15.6-15.6 40.9 0 56.6c.5 .5 1 1 1.5 1.5c-11.9 21.3-8.7 48.7 9.4 66.8s45.5 21.2 66.8 9.4c.5 .5 1 1 1.5 1.6c15.6 15.6 40.9 15.6 56.6 0c10.1-10.1 13.6-24.1 10.7-37c4.3-1.9 8.3-4.7 11.9-8.2c15.6-15.6 15.6-40.9 0-56.6c-2.8-2.8-5.9-5.1-9.2-6.9l44.2-73.7-11-11-73.7 44.2zm54.5-14l-32.6 54.4-5.6 9.4 10.7 2.5c4.2 1 8.2 3.1 11.5 6.4c9.4 9.4 9.4 24.6 0 33.9c-3.5 3.5-7.8 5.7-12.3 6.6l-10.1 2 4.5 9.3c4.3 8.9 2.7 20-4.7 27.4c-9.4 9.4-24.6 9.4-33.9 0c-1.6-1.6-2.8-3.3-3.9-5.1l-4.6-7.9-7.3 5.6c-15.7 12-38.2 10.9-52.6-3.5s-15.5-36.9-3.5-52.6l5.6-7.3-7.9-4.6c-1.8-1-3.5-2.3-5.1-3.9c-9.4-9.4-9.4-24.6 0-33.9c7.4-7.4 18.4-9 27.4-4.7l9.3 4.5 2-10.1c.9-4.5 3.1-8.8 6.6-12.3c9.4-9.4 24.6-9.4 33.9 0c3.3 3.3 5.4 7.3 6.4 11.5l2.5 10.7 9.4-5.6 54.4-32.6zM313.1 317l44.2 73.7c-3.3 1.8-6.4 4.1-9.2 6.9c-15.6 15.6-15.6 40.9 0 56.6c3.5 3.5 7.6 6.3 11.9 8.2c-2.9 12.9 .7 27 10.7 37c15.6 15.6 40.9 15.6 56.6 0c.5-.5 1-1 1.5-1.6c21.3 11.9 48.7 8.7 66.8-9.4s21.2-45.5 9.4-66.8c.5-.5 1-1 1.5-1.5c15.6-15.6 15.6-40.9 0-56.6c-10.1-10.1-24.1-13.6-37-10.7c-1.9-4.3-4.7-8.3-8.2-11.9c-15.6-15.6-41-15.6-56.6 0c-2.8 2.8-5.1 5.9-6.9 9.2L324.1 306l-11 11zm30.2 19.2l54.4 32.6 9.4 5.6 2.5-10.7c1-4.2 3.1-8.2 6.4-11.5c9.4-9.4 24.6-9.4 33.9 0c3.5 3.5 5.7 7.8 6.6 12.3l2 10.1 9.3-4.5c8.9-4.3 20-2.7 27.4 4.7c9.4 9.4 9.4 24.6 0 33.9c-1.6 1.6-3.3 2.8-5.1 3.9l-7.9 4.6 5.6 7.3c12 15.7 10.9 38.2-3.5 52.6s-36.9 15.5-52.6 3.5l-7.3-5.6-4.6 7.9c-1 1.8-2.3 3.5-3.9 5.1c-9.4 9.4-24.6 9.4-33.9 0c-7.4-7.4-9-18.4-4.7-27.4l4.5-9.3-10.1-2c-4.5-.9-8.8-3.1-12.3-6.6c-9.4-9.4-9.4-24.6 0-33.9c3.3-3.3 7.3-5.4 11.5-6.4l10.7-2.5-5.6-9.4-32.6-54.4zM117.9 141.1l7.6 2.5c37 12.3 66.9 36.1 76.9 46.1l5.7 5.7L219.3 184l-5.7-5.7c-11.3-11.3-43.3-36.7-83.1-49.9l-7.6-2.5-5.1 15.2z'
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fast',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      'M96 32v8 91.1L278.2 88.2l7.8-1.8 3.7 15.6-7.8 1.8L96 147.5v79.6l182.2-42.9 7.8-1.8 3.7 15.6-7.8 1.8L96 243.5V464H216c83.9 0 152-68.1 152-152V264v-8h16v8 48c0 92.8-75.2 168-168 168H88 80v-8V247.3L9.8 263.8 2 265.6-1.6 250l7.8-1.8L80 230.8V151.3L9.8 167.8 2 169.6-1.6 154l7.8-1.8L80 134.8V40 32H96z'
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fast',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      'M80 160H64V16 0H80 384l64 64v96H432V70.6L377.4 16H80V160zm416 48H16V400H64V336 320H80 432h16v16 64h48V208zM448 416v80 16H432 80 64V496 416H16 0V400 208 192H16 496h16v16V400v16H496 448zM80 336V496H432V336H80zm368-48H416V256h32v32z'
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fast',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM185.8 158.5l-11.3 11.3 5.7 5.7L244.7 240l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L256 251.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L267.3 240l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L256 228.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fast',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm137.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zM175.6 200c-14.6 0-30.2 8.6-41 27.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9zm119 27.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fast',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M86.6 64l-8 8 39.6 39.6 0 0 .8 .8 49 49 8-8V64H86.6zM67.3 83.3L56 72 67.3 60.7 80 48h96 16V64v96l-12.7 12.7L168 184l-11.3-11.3-38.2-38.2c-28.3 32.3-45.4 74.7-45.4 121c0 11.1 1 21.9 2.9 32.5H59.8c-1.7-10.6-2.6-21.4-2.6-32.5c0-50.7 18.9-97.1 50-132.3L67.3 83.3zM257.1 71.5c-11.3 0-22.4 1-33.1 3V58.3c10.8-1.8 21.8-2.7 33.1-2.7c51 0 97.5 19.1 132.8 50.5l38.7-38.7L440 56l11.3 11.3L464 80v96 16H448 352l-12.7-12.7L328 168l11.3-11.3 39.3-39.3c-32.4-28.5-74.9-45.8-121.5-45.8zm184 184c0-10.7-.9-21.3-2.7-31.5h16.2c1.6 10.3 2.5 20.8 2.5 31.5c0 51.6-19.5 98.6-51.6 134l39.1 39.1L456 440l-11.3 11.3L432 464H336 320V448 352l12.7-12.7L344 328l11.3 11.3 38.9 38.9c29.2-32.6 46.9-75.6 46.9-122.7zM394.3 401.1l-1.5-1.6L344 350.6l-8 8V448h89.4l8-8-39-39-.1 .1zM288 437v16.2c-10.1 1.6-20.4 2.4-30.9 2.4c-51.3 0-98.1-19.3-133.5-51.1L83.3 444.7 72 456 60.7 444.7 48 432V336 320H64h96l12.7 12.7L184 344l-11.3 11.3-37.8 37.8c32.5 28.9 75.3 46.5 122.2 46.5c10.5 0 20.8-.9 30.9-2.6zM440 78.6L350.6 168l8 8 89.4 0V86.6l-8-8zM72 433.4L161.4 344l-8-8H64l0 89.4 8 8z'
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fast',
    iconName: 'exclamation',
    icon: [
      64,
      512,
      [10069,10071,61738],
      '21',
      
      'M40 40V32H24v8V368v8H40v-8V40zm8 392H16v32H48V432z'
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fast',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      'M203.3 128.6l-10.7-11.9-5.9 5.4L120 182 120 8V0H104V8l0 174-66.6-60-5.9-5.4L20.7 128.6l5.9 5.4 80 72 5.4 4.8 5.4-4.8 80-72 5.9-5.4zM64 512H80.2 495.8 512l-2.3-16L480 288 288 160 96 288 66.3 496 64 512zm232-16V348.5L385.8 496H296zm-16 0H82.4l28.4-198.7L280 184.6V496zm16-311.4L465.2 297.3 493.6 496H404.5L296 317.8V184.6zm253.4-50.6l5.9-5.4-10.7-11.9-5.9 5.4L472 182V8 0H456V8 182l-66.6-60-5.9-5.4-10.7 11.9 5.9 5.4 80 72 5.4 4.8 5.4-4.8 80-72z'
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fast',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      'M542.7 209.7C559.8 220.2 576 236.2 576 256c0 20.2-16.2 36.3-33.3 46.7c-17.6 10.7-39.3 17.3-55.8 17.3L368 320l-1.3 0L263 507.9l-2.3 4.1H256l-88 0H157.5l2.8-10.1L210.5 320 192 320H124L78.4 380.8 76 384H72 16 5.6l2.7-10.1L39.7 256 8.3 138.1 5.6 128H16l56 0h4l2.4 3.2L124 192l68 0h18.5L160.3 10.1 157.5 0H168h88 4.7L263 4.1 366.7 192l1.3 0H486.8c16.6 0 38.3 7 55.9 17.7zM368 208l-6.1 0h-4.7l-125.7 0H221 192l-72 0h-4l-2.4-3.2L68 144l-41.6 0L55.7 253.9l.5 2.1-.5 2.1L26.4 368H68l45.6-60.8L116 304h4 72 29 10.5l125.7 0h4.7l6.1 0 118.8 0c13 0 31.9-5.6 47.5-15c16-9.7 25.6-21.6 25.6-33c0-10.9-9.6-22.8-25.7-32.7c-15.7-9.6-34.5-15.3-47.5-15.3H368zm-19.6-16L251.3 16l-72.8 0 48.6 176H348.4zM227.1 320L178.5 496l72.8 0 97.1-176H227.1z'
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fast',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm95.6 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM248 320h8c46.3 0 87.7 26 118.4 67.2l4.8 6.4-12.8 9.6-4.8-6.4C332.9 358.4 295.8 336 256 336h-8V320zm-97.1 34.5c-4 6-5.6 13.3-4.6 20.4c2.1 14.4 14.4 25.1 29 25.1h1.5c14.6 0 26.9-10.7 29-25.1c1-7.1-.6-14.4-4.6-20.4L176 316.8l-25.1 37.6zm-13.3-8.9l28.8-43.2L176 288l9.6 14.4 28.8 43.2c6.2 9.3 8.7 20.5 7.1 31.5c-3.2 22.3-22.3 38.9-44.8 38.9h-1.5c-22.5 0-41.6-16.6-44.8-38.9c-1.6-11 1-22.2 7.1-31.5z'
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fast',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      'M160 48v80h88 16 88V48H160zm-16 80V48H48v80h96zM48 144V248H248V144H48zm0 224h96V264H48V368zm0 16v80H248V384H160 144 48zm112-16H288.7c.4 5.4 1.1 10.7 2 16H264v80h60.1c4 5.6 8.3 10.9 12.9 16H48 32V464 48 32H48 464h16V48v98.6L461.4 128H464V48H368v80h70.6l-7.5 4.7c-5.1 3.2-10.7 7-16.6 11.3H264V248h54.4c-3 5.2-5.9 10.5-8.6 16H160V368zM500.7 212.8L512 224.2l11.3-11.3L544 192.2c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192l52.7 52.7zM576 422.6c0 18.2-5.8 35.1-15.7 49.2C598.7 445.9 624 402 624 352.2c0-20.2-14.9-79.7-79.2-138.1l-21.4 21.4L512 246.8l-11.3-11.3L446 180.7c-19.3 13.6-44.2 35.1-65.4 61.8C355 274.5 336 312.4 336 352.2c0 49.8 25.3 93.7 63.7 119.6c-9.9-14.1-15.7-31-15.7-49.2c0-70.4 96-134.4 96-134.4s96 64 96 134.4zm-96 73.6c45.2 0 80-34 80-73.6c0-28.5-20-58.2-43.5-82.5c-11.4-11.8-22.8-21.5-31.4-28.3c-1.8-1.5-3.5-2.8-5.1-3.9c-1.5 1.2-3.2 2.5-5.1 3.9c-8.6 6.8-20 16.5-31.4 28.3C420 364.4 400 394 400 422.6c0 39.6 34.8 73.6 80 73.6z'
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fast',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      'M336 128c0-8.2-.9-16.3-2.6-24H192 114.6c-1.7 7.7-2.6 15.8-2.6 24c0 61.9 50.1 112 112 112s112-50.1 112-112zM188.7 88L256 20.6c-10.2-3-20.9-4.6-32-4.6c-47.8 0-88.5 29.9-104.6 72h69.3zm140 0c-10.3-26.8-30.6-48.7-56.3-61l-61 61H328.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM21.7 496H80V320H75.8L21.7 496zM96 496h72 16 43.7 21.5L134.4 320H96V496zm172.3 0H336V416H216.2l52.2 80zm-62.6-96H344h8v8 88h74.3L372.2 320H153.6l52.2 80zM168 512H16.7 0l4.9-16L64 304H384l59.1 192 4.9 16H431.3 352h-8H176h-8z'
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fast',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M200 16h48V64v72H207c-3.6-13.8-16.1-24-31-24c-17.7 0-32 14.3-32 32s14.3 32 32 32c14.9 0 27.4-10.2 31-24h41V272H160h-8v8 41c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.9-10.2-27.4-24-31V288h80V444v4 48H196c-25.8 0-47.3-18.8-51.3-43.5l-1.4-8.7-8.6 2.3c-4.7 1.3-9.6 1.9-14.7 1.9c-30.9 0-56-25.1-56-56c0-5.8 .9-11.5 2.5-16.7l2.4-7.7-7.7-2.4C35 357.2 16 332.8 16 304c0-26.6 16.2-49.4 39.3-59.1l9.3-3.9-5.9-8.2C52 223.6 48 212.3 48 200c0-27.9 20.4-51 47-55.3l10.7-1.7-4.8-9.7c-3.2-6.4-5-13.6-5-21.3c0-26.5 21.5-48 48-48l.5 0 7 0 1-6.9C155.8 33.9 175.8 16 200 16zm64 136h80v41c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.9-10.2-27.4-24-31V144v-8h-8H264V64 16h48c24.2 0 44.2 17.9 47.5 41.1l1 6.9 7 0 .5 0c26.5 0 48 21.5 48 48c0 7.7-1.8 14.9-5 21.3l-4.8 9.7 10.7 1.7c26.7 4.3 47 27.4 47 55.3c0 12.3-4 23.6-10.7 32.9l-5.9 8.2 9.3 3.9c23.1 9.7 39.3 32.5 39.3 59.1c0 28.8-19 53.2-45.3 61.2l-7.7 2.4 2.4 7.7c1.7 5.3 2.5 10.9 2.5 16.7c0 30.9-25.1 56-56 56c-5.1 0-10-.7-14.7-1.9l-8.6-2.3-1.4 8.7c-4 24.7-25.5 43.5-51.3 43.5H264V448v-4V376h73c3.6 13.8 16.1 24 31 24c17.7 0 32-14.3 32-32s-14.3-32-32-32c-14.9 0-27.4 10.2-31 24H264V152zM196 512h52 8 8 52c30.9 0 57-20.6 65.2-48.8c3.5 .5 7.1 .8 10.8 .8c39.8 0 72-32.2 72-72c0-4.8-.5-9.5-1.4-14.1c29-12 49.4-40.6 49.4-73.9c0-29.9-16.4-56-40.7-69.7c5.5-10.2 8.7-21.9 8.7-34.3c0-32.4-21.4-59.8-50.9-68.9c1.9-6 2.9-12.5 2.9-19.1c0-33.3-25.4-60.7-57.9-63.7C367 20.5 341.9 0 312 0H264h-8-8H200c-29.9 0-55 20.5-62.1 48.3C105.4 51.3 80 78.7 80 112c0 6.7 1 13.1 2.9 19.1C53.4 140.2 32 167.6 32 200c0 12.4 3.1 24.1 8.7 34.3C16.4 248 0 274.1 0 304c0 33.3 20.4 61.9 49.4 73.9c-.9 4.6-1.4 9.3-1.4 14.1c0 39.8 32.2 72 72 72c3.7 0 7.2-.3 10.8-.8C139 491.4 165.1 512 196 512zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fast',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      'M385.3 0l-5.7 32H160h-6.6l-1.3 6.5-72 368L78.3 416H88 472h8v-8V288v-5.1l-4.6-2.2L361 227.4 401.6 0H385.3zM259.2 48H376.7l-20 112H296h-8v16h8 57.9l-8.6 48H280h-8v16h8 70.2L464 293.1V400H97.7L129 240h7 76.7 6.5l1.3-6.4L258.7 50.1l.4-2.1zm-16.3 0L206.2 224H136h-3.8L166.6 48h76.2zM640 424v-8H624v8 72H8 0v16H8 632h8v-8V424z'
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fast',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      'M331.8 144h-24v24h24V144zM129.4 240l17 17 17-17-17-17-17 17zM88 392H64v24H88V392zm112 8h-8v16h8H440h8V400h-8H200zm376-8H552v24h24V392zM481.4 240l17 17 17-17-17-17-17 17z'
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fast',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      'M591 108.6c.6-4.1 1-8.3 1-12.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 4.3 .3 8.5 1 12.6l1.5 9.7-8 5.8C410.4 135.7 400 154.7 400 176v64H624V176c0-21.3-10.4-40.3-26.6-51.9l-8-5.8 1.5-9.7zM384 176c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176v64 16H624 520V504v8H504v-8V256H400 384V240 176zM48 208v96H72 88 296h16 24V208H48zM72 320H48 32V304 208 192H48 336h16v16 96 16H336 312v64h24 40 8v16h-8H344V504v8H328v-8V400H304 80 56V504v8H40v-8V400H8 0V384H8 48 72V320zm16 0v64H296V320H88z'
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fast',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72-384H168h-8v16h8H306.7l-112 98-2.7 2.4V256l8 0 79.5-.4c31.1-.1 56.4 25.1 56.4 56.2c0 31-25.2 56.2-56.2 56.2H208.7c-12.1 0-23.2-6.8-28.6-17.7l-4.9-9.9-3.6-7.2-14.3 7.2 3.6 7.2 4.9 9.9c8.1 16.3 24.8 26.5 42.9 26.5h71.1c39.9 0 72.2-32.3 72.2-72.2c0-40-32.5-72.4-72.5-72.2l-58.1 .3L333.3 142l2.7-2.4V128h-8z'
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fast',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      'M443.1 359.5L216.8 490.1 21.9 152.5 248.1 21.9 443.1 359.5zM240.1 8L0 146.7 202.9 498.1l8 13.9 13.9-8L451.1 373.4l13.9-8-8-13.9L262 13.9 254 0 240.1 8zM320 496v16h16H624h16V496 80 64H624 327.9l9.2 16H624V496H336V476.7L320 486v10z'
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fast',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      'M144 192h16H416h16V176c0-35.3 28.7-64 64-64s64 28.7 64 64c0 26.2-15.8 48.8-38.4 58.7l-9.6 4.2v10.5 13.3 10.5l9.6 4.2c22.6 9.9 38.4 32.5 38.4 58.7c0 35.3-28.7 64-64 64s-64-28.7-64-64V320H416 160 144v16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.2 15.8-48.8 38.4-58.7l9.6-4.2V262.7 249.3 238.9l-9.6-4.2C31.8 224.8 16 202.2 16 176c0-35.3 28.7-64 64-64s64 28.7 64 64v16zm384 57.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80H400 176 160c0-44.2-35.8-80-80-80S0 131.8 0 176c0 32.8 19.7 61 48 73.3v13.3C19.7 275 0 303.2 0 336c0 44.2 35.8 80 80 80s80-35.8 80-80h16H400h16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V249.3z'
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fast',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm53.7 280.3l5.7-5.7L272 263.4l-5.7 5.7-101 101-47.7-47.7-5.7-5.7L100.7 328l5.7 5.7L159.7 387l5.7 5.7L171 387 277.7 280.3z'
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fast',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      'M80 16V256H272V16H80zm208 0V256H440l0-220.7-82.3 82.3-5.7 5.7L340.7 112l5.7-5.7 96-96L448 4.7l5.7 5.7 96 96 5.7 5.7L544 123.3l-5.7-5.7L456 35.3 456 256H560h16v16V415c-5.2 0-10.5-.7-16-1.9V272H288 272 80 64 16V413.1C10.5 414.3 5.2 415 0 415V272 256H16 64V16 0H80 272h16V16zM96.6 427c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 481.8 553.5 496 576 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 494.2 28.7 512 0 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9z'
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fast',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      'M16 16H368v96H16V16zM0 0V16v96 16H16 368h16V112 16 0H368 16 0zM240 160h-8v16h8 96v48H240h-8v16h8H344h4.6L496 306.3V400H16V160H0V400v16 64l32 32H96l20.7-20.7L128 480l11.3 11.3L160 512h64l20.7-20.7L256 480l11.3 11.3L288 512h64l20.7-20.7L384 480l11.3 11.3L416 512h64l32-32V416 400 296L352 224V176v-8-8h-8H240zM16 416H496v57.4L473.4 496H422.6l-27.3-27.3L384 457.4l-11.3 11.3L345.4 496H294.6l-27.3-27.3L256 457.4l-11.3 11.3L217.4 496H166.6l-27.3-27.3L128 457.4l-11.3 11.3L89.4 496H38.6L16 473.4V416z'
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fast',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      'M0 32H8 408h8v8V312v8H400v-8V48H16V312v8H0v-8V40 32zm448 96h8H560h4l2.4 3.2 72 96 1.6 2.1V232 400v8h-8H607.6c-4 40.4-38.1 72-79.6 72s-75.6-31.6-79.6-72H448v-8H304c0 44.2-35.8 80-80 80c-31.7 0-59-18.4-72-45.1C139 461.6 111.7 480 80 480c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.7 0 59 18.4 72 45.1c13-26.7 40.3-45.1 72-45.1c38.7 0 71 27.5 78.4 64H448V352 136v-8zM624 392V240H464V352c14.6-19.4 37.8-32 64-32c41.5 0 75.6 31.6 79.6 72H624zm-8-168l-60-80H464v80H616zM120 104V264v8H104v-8V104 96h16v8zm96 0V264v8H200v-8V104 96h16v8zm96 0V264v8H296v-8V104 96h16v8zM528 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fast',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      'M564.1 114.7L576 104 564.7 92.7 483.3 11.3 472 0 461.3 11.9 322.4 166.2l12.6 9.9L472.6 23.2l80.2 80.2L408 233.7l12.7 10.1L564.1 114.7zm-251.7 227l-29.2 93.5L100.4 493.8 97 490.3l73-73c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1l-73 73-3.4-3.4 58.5-182.8 78.6-24.6-15.2-12L128 280 64 480l10.3 10.3 11.3 11.3L96 512l200-64 29.9-95.6-13.4-10.6zM168 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fast',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      'M16 112H304V400H16V112zM304 416h16H560h16V400 112 96H560 320 304 16 0v16V400v16H16 304zm16-16V112H560V400H320zM80 176H240V336H80V176zM64 160v16V336v16H80 240h16V336 176 160H240 80 64z'
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fast',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      'M16 496V16H368V496H16zM0 512H16 368h16V496 16 0H368 16 0V16 496v16zM272 248H112V112H272V248zM112 264H272V400H112V264zM96 416h16H272h16V400 112 96H272 112 96v16V400v16zm96 24a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-400a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM152 352V304h80v48H152zm-16 16h16 80 16V352 304 288H232 152 136v16 48 16z'
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fast',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      'M208 0H193.1l8.3 12.4 10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C216 53.8 205.8 64 193.3 64H152c-35.3 0-64 28.7-64 64H80c-44.2 0-80 35.8-80 80v72 8H8 440h8v-8V208c0-44.2-35.8-80-80-80h-8.1c0-.9 .1-1.8 .1-2.7C360 56.1 303.9 0 234.7 0H208zm17.5 19.8L222.9 16h11.7C295 16 344 65 344 125.3c0 3.2-.3 6.2-.8 9.2l-1.7 9.4H351h17c35.3 0 64 28.7 64 64v64H16V208c0-35.3 28.7-64 64-64H96.6h9.2l-1.3-9.1c-.3-2.2-.5-4.5-.5-6.9c0-26.5 21.5-48 48-48h41.3C214.7 80 232 62.7 232 41.3c0-7.6-2.3-15.1-6.5-21.5zM96 512H352l27.4-192H363.3L338.1 496H272l14.7-176H270.6L256 495.3c0 .2 0 .4 0 .7H192c0-.2 0-.4 0-.7L177.4 320H161.3L176 496H109.9L84.7 320H68.6L96 512z'
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fast',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      'M568 296h8V280h-8H480V176v-4.7l61.7-61.7 5.7-5.7L536 92.7l-5.7 5.7L468.7 160H464 314.6l20.3 16H464V278l22.9 18H568zM328 463.8V354l-16-12.6V463.8c-75.8-4.2-136-66.9-136-143.8V296 280 234l-16-12.6V280H72 64v16h8 88v24c0 33.1 10.1 63.9 27.3 89.4l-.9 .9-80 80-5.7 5.7L112 507.3l5.7-5.7L197 422.3c27.8 33.3 68.8 55.2 115 57.5v.2h8 8v-.2c39.9-2 76-18.5 102.9-44.5l-12.7-10c-23.9 22.3-55.4 36.6-90.2 38.5zM400 128h16V112 96c0-53-43-96-96-96c-50.6 0-92 39.1-95.7 88.7L240 101.1V96c0-44.2 35.8-80 80-80s80 35.8 80 80v16H253.8l20.3 16H400zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fast',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      'M288 16C166 16 65.2 107.1 50 225l-15.9-2C50.3 97.2 157.8 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-70.4 0-134.1-28.4-180.4-74.3l11.3-11.4C162.3 469.4 222 496 288 496c132.5 0 240-107.5 240-240S420.5 16 288 16zM203.3 168l-5.7 5.7-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L203.3 168zM359.4 419.3l-5.4-5.9C341.3 399.1 319.3 384 288 384s-53.3 15.1-66.1 29.4l-5.4 5.9-11.9-10.7 5.4-5.9C225.1 386 251.1 368 288 368s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7zm18.9-245.6l-5.7-5.7L384 156.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.2-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zm5.3 98.3a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM28.1 326.5c-7.4 9.2-10.9 21-9.7 32.8c2.3 23.1 21.8 40.7 45 40.7h1.2c23.2 0 42.7-17.6 45-40.7c1.2-11.8-2.3-23.5-9.7-32.8L64 281.6 28.1 326.5zm-12.5-10l38.2-47.7L64 256l10.2 12.8 38.2 47.7c10 12.5 14.7 28.4 13.1 44.4C122.4 392.2 96 416 64.6 416H63.4C32 416 5.6 392.2 2.5 360.9C.9 344.9 5.6 329 15.6 316.5z'
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fast',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      'M512 192C512 86 426 0 320 0C266.7 0 218.5 21.7 183.8 56.7l12.6 10C228.2 35.3 271.8 16 320 16c97.2 0 176 78.8 176 176c0 23.9-10.4 54.9-27.9 89.2l12.8 10.1c18.6-36 31.1-70.8 31.1-99.3zm-383.9 4.2c4 96.5 141.3 258.7 181.2 303.8c6.8 7.7 10.7 12 10.7 12s4-4.3 10.7-12c14.6-16.5 42.1-48.6 71.5-87.4l-12.6-9.9c-19.1 25.2-37.4 47.6-51.8 64.7c-7 8.2-13 15.2-17.8 20.6c-4.8-5.4-10.8-12.4-17.8-20.6c-17.8-21-41.6-50.2-65.3-82.8c-23.7-32.6-47.2-68.4-64.7-102.6c-13.5-26.5-22.9-51-26.5-71.8l-17.6-13.9zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fast',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      'M224 464c86.5 0 160.7-52.8 192.1-128h17.2C401.1 420.2 319.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224H432c0-114.9-93.1-208-208-208S16 141.1 16 256s93.1 208 208 208zm8-336v8V296v8H216v-8V136v-8h16zM208 368V336h32v32H208zM480 480V464h8 56c44.2 0 80-35.8 80-80s-35.8-80-80-80H328h-8V288h8H544c53 0 96 43 96 96s-43 96-96 96H488h-8zm64-256H478c-.7-5.4-1.5-10.7-2.5-16H544c44.2 0 80-35.8 80-80s-35.8-80-80-80H488h-8V32h8 56c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fast',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      'M80 88c0-48.6 39.4-88 88-88s88 39.4 88 88V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V136v-8h16v8V352c0 26.5 21.5 48 48 48s48-21.5 48-48V88c0-39.8-32.2-72-72-72s-72 32.2-72 72V400c0 53 43 96 96 96s96-43 96-96V136v-8h16v8V400c0 61.9-50.1 112-112 112s-112-50.1-112-112V88z'
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fast',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      'M179.5 86c3-30.6 28.7-54 59.5-54c35.3 0 62.9 30.4 59.5 65.5L284.5 242c-3 30.6-28.7 54-59.5 54c-35.3 0-62.9-30.4-59.5-65.5L179.5 86zM239 48c-22.5 0-41.4 17.1-43.6 39.5L181.5 232c-2.5 25.7 17.7 48 43.6 48c22.5 0 41.4-17.1 43.6-39.5L282.5 96C285 70.3 264.8 48 239 48zM110.4 53L51.1 79.3l-7.4 3.3L37.5 68l7.4-3.3 72-32 11.1 8.1-32 272-.9 8-15.9-1.6 .9-8L110.4 53zM404 32c37.1 0 66.3 31.4 63.7 68.4l-8 112.3C457.3 246.1 429.5 272 396 272c-37.1 0-66.3-31.4-63.7-68.4l8-112.3C342.7 57.9 370.5 32 404 32zM356.3 92.4l-8 112.3c-2 27.7 20 51.3 47.7 51.3c25.1 0 45.9-19.4 47.7-44.4l8-112.3c2-27.7-20-51.3-47.7-51.3c-25.1 0-45.9 19.4-47.7 44.4zm149 243.4l-496 80L6.7 400.1l496-80 2.5 15.8zm-312.1 128l-2.3-15.8 272-40 2.3 15.8-272 40z'
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fast',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      'M144 272V256 48h96V256v16h16H368v9.4l-176 176L16 281.4V272H128h16zM0 288L180.7 468.7 192 480l11.3-11.3L384 288V272 256H368 272 256V240 48 32H240 144 128V48 240v16H112 16 0v16 16z'
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fast',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M16 48V464H288V336 320h16H432V48H16zM304 457.4L425.4 336H304V457.4zM288 480H16 0V464 48 32H16 432h16V48 320v16L304 480H288z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fast',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      'M0 187.4v11.7V324.6L68.6 443.4l108.5 62.7 10.3 5.9H324.6l10.3-5.9 108.5-62.7L512 324.6V199.1 187.4L443.4 68.6 434 63.2 324.6 0H187.4L78 63.2l-9.4 5.4L0 187.4zM80.1 80.6L248 133.9V251.2L129.6 314.6 16 192.8v-1.1L80.1 80.6zM264 133.9L431.9 80.6 496 191.7v1.1L382.4 314.6 264 251.2V133.9zM413.4 69.7L256 119.6 98.6 69.7 191.7 16l128.6 0 93.1 53.7zM496 216.3v104L431.7 431.7 342 483.5l49-154.7L496 216.3zm-174.5 279l-1.2 .7H191.7l-1.2-.7L137.6 328.5 256 265.1l118.4 63.4L321.5 495.3zM170 483.5L80.3 431.7 16 320.3l0-104L120.9 328.7l49 154.7z'
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fast',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      'M114.5 8.4l-8.1-2.7L104.3 14l-72 280-1.6 6.3 5.8 2.9 16 8 4.4 2.2 3.9-2.9c120.1-88.8 216.8-83.4 256.4-70.7c19.1 6.1 34.8 25.6 34.8 44.6c0 11.9-5.6 25-15 35.1c-9.4 10.1-22 16.6-35.3 16.6H160h-8v16h8H301.7c18.8 0 35.4-9.1 47.1-21.8c4.1-4.5 7.8-9.5 10.7-14.8c5.4-9.7 8.5-20.4 8.5-31.1c0-26.4-15.8-47.9-37.6-60.4C265 186.4 218.2 135.6 187.7 94C172.4 73.3 161.3 54.9 154 41.7c-3.7-6.6-6.3-11.9-8.1-15.5c-.9-1.8-1.5-3.2-2-4.1l-.5-1-.1-.2 0-.1 0 0 0 0 0 0-1.4-3.3-3.4-1.1-24-8zm60.3 95.1c26.3 35.9 64.7 78.7 116.4 114.6c-52.2-6.1-136.9 4.7-236 76.6l-5.9-2.9L117.6 26.3l12.6 4.2c.4 .8 .8 1.7 1.3 2.8c1.9 3.8 4.7 9.3 8.5 16.2c7.6 13.7 19.1 32.6 34.8 54zM336 400v48H48V400H336zM48 384H32v16 48l-16 0H0v16 32 16H16 368h16V496 464 448H368l-16 0V400 384H336 48zM16 464H368v32H16V464z'
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fast',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      'M64 16V64H256V16H64zM48 64V16 0H64 256h16V16 64h32 16V80 496v16H304 16 0V496 80 64H16 48zM272 80H256 64 48 16V192H304V80H272zM16 368H304V208H16V368zm0 16V496H304V384H16z'
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fast',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      'M0 32H8 136h8v8V256c0 44.2 35.8 80 80 80s80-35.8 80-80V40 32h8H440h8v8V256c0 123.7-100.3 224-224 224S0 379.7 0 256V40 32zM16 48v96H128V48H16zm0 208c0 114.9 93.1 208 208 208s208-93.1 208-208V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H16v96zM432 144V48H320v96H432z'
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fast',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm3-367.6l2.3 0c32.6 .5 58.8 27 58.8 59.6c0 15.8-6.3 31-17.5 42.2L178.3 370.3l-2.3 2.3V384h8H344h8V368h-8H203.3L313.9 257.5C328 243.3 336 224 336 204c0-41.3-33.2-75-74.5-75.6l-2.3 0c-18.1-.3-35.7 5.8-49.8 17.1L179 169.8l-6.2 5 10 12.5 6.2-5 30.4-24.3c11.2-9 25.2-13.8 39.6-13.6z'
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fast',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      'M117.7 32H120h8 8v8V464H248h8v16h-8H120 8 0V464H8 120V49.4L20.2 110.8 16 113.4V94.6l99.8-61.4 1.9-1.2z'
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fast',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      'M167.7 120.1L152 152l13.8 28.1L178 177l3.7-.9L169.8 152 182 127.1l1.7-3.5-.1-3.9L183.2 92l21.4-16.9 3.1-2.4 1.6-3.6L220.5 44l26.2-5.6 3.9-.8 3.1-2.6 20.6-17.4 25.8 6.5 3.9 1 3.9-1 25.8-6.5L354.3 35l3.1 2.6 3.9 .8L387.5 44l11.2 25.1 1.6 3.6 3.1 2.4L424.8 92l-.5 27.8-.1 3.9 1.7 3.5L438.2 152 426 176.9l-1.7 3.5 0 1.3 7.7 2 9.7-2.5L456 152l-15.7-31.9 .6-35.7L413.3 62.6 398.8 30.1l-34.1-7.3L337.8 0 304 8.6 270.2 0 243.3 22.8l-34.1 7.3L194.7 62.6 167.1 84.4l.6 35.7zm102.6 151l-.7-.6-15-32.5-35.2-7.3L191.7 208l-34.9 8.6L121.9 208 94.2 230.8 59 238.1 44 270.6 15.5 292.4l.6 35.7L0 360l16.2 31.9-.6 35.7L44 449.4l15 32.5 35.2 7.3L121.9 512l34.9-8.6 34.9 8.6 27.7-22.8 35.2-7.3 15-32.5 .7-.6-7.5-5.9 .1-8.6-3.1 2.3-3.1 2.4-1.7 3.6-11.6 25.2-27.3 5.7-3.9 .8-3 2.5-21.5 17.7-27.1-6.7-3.8-.9-3.8 .9-27.1 6.7-21.5-17.7-3-2.5-3.9-.8-27.3-5.7L58.5 442.7l-1.7-3.6-3.1-2.4L31.7 419.8l.5-27.6 .1-4-1.8-3.5L17.9 360l12.5-24.7 1.8-3.5-.1-4-.5-27.6 22.1-16.9 3.1-2.4 1.7-3.6 11.6-25.2 27.3-5.7 3.9-.8 3-2.5 21.5-17.7 27.1 6.7 3.8 .9 3.8-.9 27.1-6.7 21.5 17.7 3 2.5 3.9 .8 27.3 5.7 11.6 25.2 1.7 3.6 3.1 2.4 3.1 2.3-.1-8.6 7.5-5.9zm25.4 57L280 360l15.7 31.9-.6 35.7 27.6 21.8 14.6 32.5 34.1 7.3L398.2 512l33.8-8.6 33.8 8.6 26.9-22.8 34.1-7.3 14.6-32.5 27.6-21.8-.6-35.7 .4-25.2c8.5-12.5 9-29.3 4.5-45.9c-5.3-19.3-17.7-40.1-35.8-58.2s-38.9-30.5-58.2-35.8c-13.3-3.6-26.9-4-38.2 .4L398.2 208l-26.9 22.8-34.1 7.3-14.6 32.5-27.6 21.8 .6 35.7zM425.9 238c-10.9 12.7-11.9 31.1-7 49.2c5.3 19.3 17.7 40.1 35.8 58.2s38.9 30.5 58.2 35.8c13.9 3.8 28.1 4.1 39.7-1.1l-.2 11.6 0 .2 0 .2 .5 27.8-21.4 16.9-3.1 2.4-1.6 3.6L515.5 468l-26.2 5.6-3.9 .8-3.1 2.6-20.6 17.4-25.8-6.5-3.9-1-3.9 1-25.8 6.5L381.7 477l-3.1-2.6-3.9-.8L348.5 468l-11.2-25.1-1.6-3.6-3.1-2.4L311.2 420l.5-27.8 .1-3.9-1.7-3.5L297.8 360 310 335.1l1.7-3.5-.1-3.9-.5-27.8 21.4-16.9 3.1-2.4 1.6-3.6L348.5 252l26.2-5.6 3.9-.8 3.1-2.6 19.2-16.2 25 11.3zM240 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm39.2-200.8c7-7 19.3-9.4 35.8-4.9c16.2 4.4 34.6 15.2 51.1 31.7s27.3 34.9 31.7 51.1c4.5 16.5 2.1 28.8-4.9 35.8s-19.3 9.4-35.8 4.9c-16.2-4.4-34.6-15.2-51.1-31.7s-27.3-34.9-31.7-51.1c-4.5-16.5-2.1-28.8 4.9-35.8z'
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fast',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      'M442.3 143l47-47L416 22.6l-47 47L442.3 143zM352 64l5.7-5.7 47-47L416 0l11.3 11.3 73.4 73.4L512 96l-11.3 11.3-47 47L448 160l-5.7 5.7L288 320 177.6 347.6 160 352l4.4-17.6L192 224 346.3 69.7 352 64zm5.7 17L206.4 232.2 182 330l97.8-24.5L431 154.3 357.7 81zM472 256c0-22.6-3.5-44.4-9.9-64.8l8.5-8.5 4.1-4.1c8.6 24.2 13.3 50.3 13.3 77.5c0 75.1-60.9 136-136 136c-18 0-35.2-3.5-51-9.9c-4.1-1.7-6.1-6.3-4.4-10.4s6.3-6.1 10.4-4.4c13.9 5.6 29.1 8.7 45 8.7c66.3 0 120-53.7 120-120zM256 24c27.2 0 53.3 4.7 77.5 13.3l-4.1 4.1-8.5 8.5C300.4 43.5 278.6 40 256 40C136.7 40 40 136.7 40 256s96.7 216 216 216c4.4 0 8 3.6 8 8s-3.6 8-8 8C127.9 488 24 384.1 24 256S127.9 24 256 24z'
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fast',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM264 112H248v8V280v8h16v-8V120v-8zM240 352h32V320H240v32z'
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fast',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M384 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM32 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM192 336a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fast',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M496 16V496H16V16H496zM16 0H0V16 496v16H16 496h16V496 16 0H496 16z'
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fast',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      'M304 0H144V16h72V96.2C104.8 100.4 16 191.8 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-50.5-18-96.8-47.9-132.8l37.6-37.6 5.7-5.7L416 116.7l-5.7 5.7-36.9 36.9c-36.1-37.2-86-61-141.4-63.1V16h72V0zM32 304a192 192 0 1 1 384 0A192 192 0 1 1 32 304zm208-64V368c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-32c17.7 0 32 14.3 32 32V368c0 17.7-14.3 32-32 32s-32-14.3-32-32V240c0-17.7 14.3-32 32-32zM128.1 232.6c3.6-14.4 16.6-24.6 31.5-24.6c17.9 0 32.4 14.5 32.4 32.4v13c0 10-3.7 19.5-10.4 26.9L139 327.2c-17.4 19.1-27 44.1-27 70V408v8h8 80 8V400h-8H128v-2.9c0-21.9 8.2-43 22.9-59.2l42.6-46.8c9.4-10.3 14.6-23.7 14.6-37.7v-13c0-26.7-21.7-48.4-48.4-48.4c-22.2 0-41.6 15.1-47 36.7l-.3 1.4-1.9 7.8 15.5 3.9 1.9-7.8 .3-1.4z'
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fast',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM264 128H248v8V296v8h16v-8V136v-8zM240 336v32h32V336H240z'
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fast',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      'M106.6 119.8l11.3-1.9 1.9-11.3 13.2-79 65.9 46.1 9.2 6.4 9.2-6.4 65.9-46.1 13.2 79 1.9 11.3 11.3 1.9 79 13.2-42.7 61c6.8-1.2 13.8-1.9 20.9-1.9l39.3-56.1L416 121.3l-17.5-2.9L312 104 297.6 17.5 294.7 0 280.1 10.2 208 60.7 135.9 10.2 121.3 0l-2.9 17.5L104 104 17.5 118.4 0 121.3l10.2 14.5L60.7 208 10.2 280.1 0 294.7l17.5 2.9L104 312l14.4 86.5 2.9 17.5 14.5-10.2 27.5-19.3c2.1-9.1 5.2-17.7 9.1-25.9l-39.6 27.7-13.2-79-1.9-11.3-11.3-1.9-79-13.2 46.1-65.9 6.4-9.2-6.4-9.2L27.7 132.9l79-13.2zM304 208c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c3.5-1.7 7.1-3.3 10.7-4.7c1.2-6.4 2.8-12.6 4.9-18.6C235.5 284.3 222.2 288 208 288c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 4.4-.4 8.7-1 12.9c5.3-4.4 11-8.3 17-11.8l0-1.1zm64 16c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v80 16h16 80H559.9l64 0h16v-16-64c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4C425.2 238 398.2 224 368 224zM623.9 431.9v64l-64 0H288 208v-80c0-39.6 28.8-72.5 66.6-78.9l13.4-2.3-.1-13.6 0-1.3c0-44.1 35.8-79.9 80-79.9c29 0 54.5 15.5 68.5 38.7l8.8 14.6 14-9.8c10.4-7.3 23-11.5 36.6-11.5c35.3 0 64 28.6 64 64c0 4.8-.5 9.4-1.5 13.8L554.8 366l16.4 2.9c29.9 5.3 52.6 31.5 52.6 63z'
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fast',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      'M416 4.7L404.7 16l5.7 5.7L444.7 56 384 116.7 301.7 34.3 296 28.7 284.7 40l5.7 5.7 88 88 88 88 5.7 5.7L483.3 216l-5.7-5.7L395.3 128 456 67.3l34.3 34.3 5.7 5.7L507.3 96l-5.7-5.7-40-40-40-40L416 4.7zM132.7 240L66.3 306.3c-1.5 1.5-2.3 3.5-2.3 5.7V436.7L5.9 494.8 .2 500.5l11.3 11.3 5.7-5.7L75.3 448H200c2.1 0 4.2-.8 5.7-2.3L425.4 225.9l-11.3-11.3L196.7 432H80V315.3l64-64 58.3 58.3 5.7 5.7L219.3 304l-5.7-5.7L155.3 240 208 187.3l58.3 58.3 5.7 5.7L283.3 240l-5.7-5.7L219.3 176l78.1-78.1L286.1 86.6 208 164.7 196.7 176 144 228.7 132.7 240z'
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fast',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      'M72 0H64V8 160H16 0v16V496v16H16 624h16V496 176 160H624 576V8 0h-8H72zM560 160H448V136v-8h-8H392h-8v8 24H352V136v-8h-8H296h-8v8 24H256V136v-8h-8H200h-8v8 24H80V16H560V160zM72 176H200h48 48 48 48 48H568h56V496H16V176H72zm328-32h32v16H400V144zm-64 16H304V144h32v16zm-96-16v16H208V144h32zm-64 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 336a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z'
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fast',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      'M112 66.5l112-49 112 49V144H112V66.5zM96 56v88 16 0 16c0 70.7 57.3 128 128 128s128-57.3 128-128V160v0V144 56L224 0 96 56zm16 104v0H336v0 16c0 61.9-50.1 112-112 112s-112-50.1-112-112V160zM212.3 435L224 447.3 235.7 435l93.1-99h43.7l53.3 160H22.2L75.5 336h43.7l93.1 99zM384 320H321.9L235 412.3 224 424l-11-11.7L126.1 320H64L5.3 496 0 512H16.9 431.1 448l-5.3-16L384 320zM232 40H216v8V72H192h-8V88h8 24v24 8h16v-8V88h24 8V72h-8H232V48 40z'
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fast',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      'M160 0h-4.4l-2.4 3.8L115.6 64H0V80H448V64H332.4L294.8 3.8 292.4 0H288 160zM313.6 64H134.4l30-48H283.6l30 48zM24 112l.1 .8 40 392 .7 7.2H72 376h7.2l.7-7.2 40-392 .1-.8H408L368.8 496H79.2L40 112H24zM325.7 229.7l5.7-5.7L320 212.7l-5.7 5.7L192 340.7l-58.3-58.3-5.7-5.7L116.7 288l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fast',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      'M134.9 13.6l-7.4-13L120.8 14c-23 46-77.5 91.5-117.3 118.4l9 13.3C45.9 123.1 91.3 86.5 120 46.1V256H8 0v16H8 120h16H504h16H632h8V256h-8H520V46.1c28.7 40.4 74.1 77 107.5 99.6l9-13.3C596.7 105.5 542.2 60.1 519.2 14L512.5 .7l-7.4 13C467 80.3 395.8 128 320 128s-147-47.7-185.1-114.4zM504 44.7V256H424V120v-4c31.3-17.5 58.8-42.2 80-71.4zm-96 79.5V256H328V144v-.2c27.9-1.1 55-8.1 80-19.7zm-96 19.7v.2V256H232V124.2c25 11.6 52.1 18.5 80 19.7zM216 116v4V256H136V44.7c21.2 29.2 48.7 53.9 80 71.4zM0 336v16H8h96V504v8h8 96 8v-8V352H424V504v8h8 96 8v-8V352h96 8V336h-8H528h-8v8V496H440V344v-8h-8H208h-8v8V496H120V344v-8h-8H8 0z'
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fast',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      'M48 0H44.2L41.8 3 9.8 43l-5 6.2 12.5 10 5-6.2L51.8 16H216V96H80 64v16V432v16H80h36.7L58.3 506.3 52.7 512l0 0H75.3l64-64H308.7l64 64h22.6l-5.7-5.7L331.3 448H368h16V432 112 96H368 232V16H396.2l29.6 37 5 6.2 12.5-10-5-6.2-32-40-2.4-3H400 48zM80 112H216h16H368V432H80V112zm80 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 176v64H144V176H304zM144 160H128v16 64 16h16H304h16V240 176 160H304 144z'
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fast',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      'M381.4 391.9l-69.3-97.8c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c3.7 0 7.4-.2 11.1-.6l68.6 96.8C279.1 458.4 252.2 464 224 464C109.1 464 16 370.9 16 256S109.1 48 224 48c112.6 0 204.4 89.5 207.9 201.3c.1 2.2 .1 4.5 .1 6.7c0 2.6 0 5.3-.1 7.9c-1.8 48.9-20.5 93.4-50.4 128zM429 408h-5H392.8l-1.9-2.6c28.8-32.1 48.4-72.6 54.8-117.4h1.7H560v69.1L429 408zm43 .4L576 368V288 272H560 463.5h-16c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2h16H560h16V224 144L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c31.5 0 62.8-4.4 93-12.9l11.8 16.7L343.2 504H368h56 48V408.4zM447.4 224h-1.7c-8.6-60.3-41.3-112.9-88-147.7L560 154.9V224H447.4zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-112a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM341.9 474.5L252.4 347.7c21.2-6.6 39.2-20.2 51.3-38.3L384.6 424H424h32v64H424 368 351.4l-9.6-13.5z'
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fast',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      'M384 144a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM24 496H488L421.3 336H90.7L24 496zM80 320H432l73.3 176 6.7 16H494.7 17.3 0l6.7-16L80 320z'
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fast',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M243.6 431.1C211.4 392.3 192 342.4 192 288c0-105.8 73.3-194.4 171.9-217.9C327 36.5 277.9 16 224 16C109.1 16 16 109.1 16 224s93.1 208 208 208c6.6 0 13.2-.3 19.6-.9zm18.9-2.7C359 410.4 432 325.7 432 224c0-54.1-20.7-103.4-54.6-140.4C281 101.6 208 186.3 208 288c0 54.1 20.7 103.4 54.6 140.4zm-5.7 17.2c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM396.4 80.9C428.6 119.7 448 169.6 448 224c0 105.8-73.3 194.4-171.9 217.9C313 475.5 362.1 496 416 496c114.9 0 208-93.1 208-208s-93.1-208-208-208c-6.6 0-13.2 .3-19.6 .9z'
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fast',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      'M240 16H16V496H240V408H160h-8V392h8 80V312H160h-8V296h8 80V216H160h-8V200h8 80V120H160h-8V104h8 80V16zm16 376v16 88 16H240 16 0V496 16 0H16 240h16V16v88 16 80 16 80 16 80z'
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fast',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      'M188.8 488L28.4 336 188.8 184H240v64H416v64h28.8L588.4 176 444.8 40H416v64H256V88H400V24h51.2L611.6 176 451.2 328H400V264H224V200H195.2L51.6 336 195.2 472H224V408H384v16H240v64H188.8z'
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fast',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      'M256 19.6C123.5 19.6 16 127 16 259.6l0 8-16 0 0-8C0 118.2 114.6 3.6 256 3.6s256 114.6 256 256l0 8-16 0 0-8c0-132.5-107.5-240-240-240zM121.9 352.7l-5.2-6.1L129 336.3l5.2 6.1L248 477.7l0-306.1 0-8 16 0 0 8 0 306.1L377.9 342.4l5.2-6.1 12.2 10.3-5.2 6.1-128 152L256 512l-6.1-7.3-128-152z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fast',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M213.6 76.5C192.7 58.7 165.6 48 136 48C69.7 48 16 101.7 16 168c0 29.6 10.7 56.7 28.5 77.6L53.3 256l-8.8 10.4C26.7 287.3 16 314.4 16 344c0 66.3 53.7 120 120 120c29.6 0 56.7-10.7 77.6-28.5l10.4-8.8 10.4 8.8c20.9 17.8 48 28.5 77.6 28.5c66.3 0 120-53.7 120-120c0-29.6-10.7-56.7-28.5-77.6L394.7 256l8.8-10.4c17.8-20.9 28.5-48 28.5-77.6c0-66.3-53.7-120-120-120c-29.6 0-56.7 10.7-77.6 28.5L224 85.3l-10.4-8.8zM448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM224 352l-11.3-11.3-73.4-73.4L128 256l11.3-11.3 73.4-73.4L224 160l11.3 11.3 73.4 73.4L320 256l-11.3 11.3-73.4 73.4L224 352zm0-169.4L150.6 256 224 329.4 297.4 256 224 182.6z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fast',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216H312V200H104v16z'
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fast',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM216.3 265.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 440.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm-3.4 18.9L224 294.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L224 417.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4z'
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fast',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      'M262.1 336H272h32 9.9l4.4 8.8L361.9 432H400c44.5 0 84.4-14.8 113.1-41.7C541.6 363.6 560 324 560 272c0-52.9-15-99.8-54.5-133.9C465.6 103.6 398.1 80 288 80s-177.6 23.6-217.5 58.1C31 172.2 16 219.1 16 272c0 52 18.4 91.6 46.9 118.3C91.6 417.2 131.5 432 176 432h38.1l43.6-87.2 4.4-8.8zM224 448H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176H352l-48-96H272l-48 96zM160 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm304 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fast',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      'M368 208H349 328l13.5 16L416 312v24 16H400 372.5 352l12.8 16L448 472v24 16H432 16 0V496 472L83.2 368 96 352H75.5 48 32V336 312l74.5-88L120 208H99 80 64V192 168L213 11.6 224 0l11 11.6L384 168v24 16H368zm-52.2 10.3L293.5 192H328h40V174.4L224 23.2 80 174.4V192h40 34.5l-22.3 26.3L48 317.9V336H96h33.3l-20.8 26L16 477.6V496H432V477.6L339.5 362l-20.8-26H352h48V317.9l-84.2-99.5zM176 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fast',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      'M128 368H112 16 0V352 16 0H16 368h16V16 352v16H368 272 256v16V496v16H240 144 128V496 384 368zm0-16h16v16V496h96V368 352h16H368V272H16v80H128zm240-96V16H272v88 8H256v-8V16H192V88v8H176V88 16H96V120v8H80v-8V16H16V256H368zM176 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fast',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      'M440 48h24V368H112V48H440zm40 176V48h24c48.6 0 88 39.4 88 88s-39.4 88-88 88H480zm0 144V240h24c57.4 0 104-46.6 104-104s-46.6-104-104-104H480 464 440 112 96V48 368v16h16H464h16V368zM8 464H0v16H8 568h8V464h-8H8z'
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fast',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      'M176 16h80V70.2c0 49.5 17.7 97.4 49.9 135L323 225.1c18.7 21.8 29 49.6 29 78.4C352 370.1 298.1 424 231.5 424H221.3C152.1 424 96 367.9 96 298.7c0-26.1 8.2-51.6 23.3-72.8l15.2-21.2c24-33.7 38.2-73.3 41-114.4c.3-3 .5-6 .5-9V75.2 56 16zm-16 0V56 75.2c0 4.6-.2 9.1-.5 13.6c-2 16.6-10.4 31.8-23.6 42.4L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448H152v56 8h16v-8V448h48v56 8h16v-8V448h48v56 8h16v-8V448h48v56 8h16v-8V448h11.5C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50V16 0H336 176 160V16zM146 143.7c1.1-.9 2.2-1.8 3.3-2.8c-6.5 19.3-15.8 37.7-27.8 54.4l-15.2 21.2C89.2 240.6 80 269.3 80 298.7c0 61.6 39.4 113.9 94.3 133.3H140.5C71.7 432 16 376.3 16 307.5c0-37.8 17.2-73.6 46.7-97.2L146 143.7zM371.5 432H277.7c52.7-18.9 90.3-69.3 90.3-128.5c0-32.6-11.7-64.1-32.9-88.8l-17.1-19.9C288.3 160.1 272 115.9 272 70.2V16h64V81.2c0 24.3 11 47.3 30 62.5l83.3 66.6c29.5 23.6 46.7 59.4 46.7 97.2C496 376.3 440.3 432 371.5 432z'
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fast',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM264 328V155.3l74.3 74.3 5.7 5.7L355.3 224l-5.7-5.7-88-88-5.7-5.7-5.7 5.7-88 88-5.7 5.7L168 235.3l5.7-5.7L248 155.3V328v8h16v-8z'
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fast',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      'M624 80V432H16V80H624zM16 64H0V80 432v16H16 624h16V432 80 64H624 16z'
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fast',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      'M512 464H0v16H512V464z'
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fast',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM64 64V80h8 80 8V64h-8H72 64zm0 64v16h8 80 8V128h-8H72 64zM224 432v16h8 80 8V432h-8H232h-8zm80-192v96H80V240H304zM80 224H64v16 96 16H80 304h16V336 240 224H304 80z'
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fast',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      'M216 0h8 80 8V8 32h72 8v8V96h72 8v8V344c0 92.8-75.2 168-168 168h-8.5c-63.7 0-124.7-25.3-169.7-70.3L36.5 352.3 8.2 324.1l-5.7-5.7 5.7-5.7 56.6-56.6 5.7-5.7 5.7 5.7 28.3 28.3L136 316.1V40 32h8 72V8 0zm96 184l0 64v8H296v-8V40l0-8 0-16H232V32v8 8V248v8H216v-8V48H152V335.4l-13.7 5.7L93 295.8 70.4 273.1 25.1 318.4 47.8 341l89.4 89.4c42 42 99 65.6 158.4 65.6H304c83.9 0 152-68.1 152-152V112H392V248v8H376v-8V104 96l0-48H312l0 136zM208 324a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm64 32a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm116 12a12 12 0 1 1 24 0 12 12 0 1 1 -24 0zm-20 52a12 12 0 1 1 0 24 12 12 0 1 1 0-24zM260 432a12 12 0 1 1 24 0 12 12 0 1 1 -24 0zm-84-44a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm148-52a12 12 0 1 1 24 0 12 12 0 1 1 -24 0z'
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fast',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      'M229.7 349.7l-5.7 5.7-5.7-5.7-136-136L76.7 208 88 196.7l5.7 5.7L216 324.7V200 40 32h16v8V200 324.7L354.3 202.3l5.7-5.7L371.3 208l-5.7 5.7-136 136zM16 432H48v32H16V432zm128 0v32H112V432h32zm96 32H208V432h32v32zm96-32v32H304V432h32zm64 0h32v32H400V432z'
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fast',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 144V408v8H248v-8V144v-8h16v8z'
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fast',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      'M228.2 66.2c-2.2 15.8-5.2 38.1-8.2 64.4c-6 52.7-11.9 121-11.9 183.9c0 40.9 9.7 75.3 19.4 99.4c4.9 12 9.7 21.5 13.3 27.9c1.1 2 2.2 3.8 3 5.2c21-1.8 41.8-5.8 61.3-11.9c.7-.7 1.4-1.6 2.2-2.4c5.3-6.1 12.5-15 19.7-26.3c14.3-22.7 28.4-54.5 28.4-91.8c0-48.6-18.3-106.1-37.1-151.9c-9.3-22.8-18.7-42.5-25.7-56.5c-2.6-5.2-4.9-9.7-6.7-13.2c-18.5-20.2-32.8-44.2-36.8-75.3L238.3 39.2l-8.8 17.5c-.4 2.8-.9 6-1.4 9.5zm104.9 90.4c18.9 46.3 38.3 106.1 38.3 158c0 41.4-15.6 76.2-30.9 100.4c-2 3.1-4 6.1-5.9 8.8c12.1-5.6 23.5-12.1 33.9-19.4C407.1 377 432 337.9 432 288c0-71.9-40.3-107.7-85.9-143.4c-2.8-2.2-5.7-4.4-8.6-6.7l0 0 0 0 0 0c-6.3-4.9-12.7-9.9-19.1-15c4.7 10.1 9.7 21.4 14.7 33.7zM212.6 419.9C202.3 394.4 192 358 192 314.6c0-63.9 6-132.8 12.1-185.7c3-26.5 6-49 8.3-64.9c.9-6 1.6-11.1 2.2-15.1l-4.8-9.7L198.9 17.6c-4 31.1-18.3 55-36.7 75.2c-1.7 3.3-3.9 7.5-6.3 12.5c-6.7 13.5-15.6 32.5-24.5 54.5C113.5 204 96 259.3 96 306.2c0 43.3 15.3 77.1 30.7 100.2c7.7 11.5 15.4 20.4 21.1 26.3c2.1 2.2 4 4 5.5 5.4c22.7 6.2 46.7 9.5 70.8 9.9l1.8 0c-3.8-6.8-8.5-16.3-13.2-28.1zm-99.2-4.6C96.7 390.3 80 353.5 80 306.2c0-50.1 18.5-107.9 36.6-152.5c4.6-11.3 9.1-21.8 13.4-31.2c-6.5 5.3-13.1 10.4-19.6 15.4c-2.9 2.2-5.8 4.5-8.6 6.7C56.3 180.3 16 216.1 16 288c0 49.9 24.9 89 63.5 116.3c12.9 9.1 27.2 16.9 42.6 23.2c-2.9-3.7-5.8-7.8-8.8-12.2zm35.4 38.1C67 431.2 0 374.4 0 288c0-84.5 51.3-124.3 99.7-162C143 92.3 184 60.4 184 0h16 8l7.1 14.1L224 32l8.9-17.9L240 0h8 16c0 60.4 41 92.3 84.3 126c48.4 37.7 99.7 77.5 99.7 162c0 86.4-67 143.2-148.7 165.5l20 44 3.3 7.3L308 511.4l-3.3-7.3-21.3-46.8c-16.8 3.6-34.1 5.8-51.4 6.5V504v8H216v-8V463.8c-17.3-.7-34.6-2.9-51.4-6.5l-21.3 46.8-3.3 7.3-14.6-6.6 3.3-7.3 20-44z'
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fast',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM21.7 496L75.8 320H326.6c1.5-5.4 3.3-10.8 5.4-16H64L4.9 496 0 512H16.7h378c-6.9-4.9-13.4-10.2-19.6-16H21.7zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-224H488v8 72 8h8 56 8V360h-8H504V296v-8z'
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fast',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zm48 56v-8H32v8 96 8H48v-8V376zm192 0v-8H224v8 96 8h16v-8V376zm192 0v-8H416v8 96 8h16v-8V376zM144 408v-8H128v8 96 8h16v-8V408zm192 0v-8H320v8 96 8h16v-8V408z'
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fast',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      'M256 32h8 80 8v8V91.2c0 29.7-6.4 58.6-18.1 84.9H448h48 8v8 96 8h-8-8v56 8h-8-8v56 8h-8H440v56 8h-8H384 272 257.1h-2.5l-2.1-1.4-12.3-8.5L160 414.8V395.4l89.3 61.6 10.3 7.1H272 384h40V408v-8h8 24V344v-8h8 8V280v-8h8 8V192H448 321.1 307.9l6.1-11.7c14.2-27 21.9-57.5 21.9-89.1V48H272V91.2c0 45.9-24.6 88.3-64.5 111.1l-30 17.2-.6 .3-.6 .2L160 226v-17l10.1-3.7 29.5-16.8c34.9-19.9 56.4-57.1 56.4-97.2V40 32zM16 208V464h96V208H16zM0 192H16h96 16v16V464v16H112 16 0V464 208 192z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fast',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm8-304H200v8 80H120h-8v16h8 80v80 8h16v-8V216h80 8V200h-8H216V120v-8z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fast',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      'M240 16h96v96H240V16zM224 0V16v96 16h16 96 16V112 16 0H336 240 224zM192 64H16 0V80 496v16H16 560h16V496 80 64H560 384V80H560V496H16V80H192V64zm48 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM214.2 368H367.1l21.3 64h16.9l-26.7-80h-176L176 432h16.9l21.3-64z'
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fast',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      'M383.8 459.2L356.7 432H296h-8v-8V360v-3.3l2.3-2.3 64-64 2.3-2.3H360h64 8v8 24h55.4c5.6-20.4 8.6-41.8 8.6-64c0-116.1-82.5-213-192-235.2V104v3.3l-2.3 2.3L272 139.3V216v8h-8H224v88 8h-8H152h-3.3l-2.3-2.3L116.7 288H18.1C33.8 405.4 134.3 496 256 496c47 0 90.8-13.5 127.8-36.8zM120 272h3.3l2.3 2.3L155.3 304H208V216v-8h8 40V136v-3.3l2.3-2.3L288 100.7V18.1c-10.5-1.4-21.2-2.1-32-2.1C123.5 16 16 123.5 16 256c0 5.4 .2 10.7 .5 16H120zM397.3 450c38.8-28.3 68.7-67.9 85-114H424h-8v-8V304H363.3L304 363.3V416h56 3.3l2.3 2.3L397.3 450zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM336 152v32 8H320v-8V152v-8h16v8zM288 264v32 8H272v-8V264v-8h16v8zM152 352h32 8v16h-8H152h-8V352h8z'
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fast',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      'M512 0H0V16H32V496H0v16H208h8 80 8H512V496H480V16h32V0zM288 496H224V400h64v96zm16-104v-8h-8H216h-8v8V496H48V16H464V496H304V392zM328 72v8 64 8h8 64 8v-8V80 72h-8H336h-8zm16 16h48v48H344V88zM224 72h-8v8 64 8h8 64 8v-8V80 72h-8H224zm8 64V88h48v48H232zm-16 64v8 64 8h8 64 8v-8V208v-8h-8H224h-8zm16 16h48v48H232V216zm104-16h-8v8 64 8h8 64 8v-8V208v-8h-8H336zm8 64V216h48v48H344zM104 72v8 64 8h8 64 8v-8V80 72h-8H112h-8zm16 16h48v48H120V88zm-8 112h-8v8 64 8h8 64 8v-8V208v-8h-8H112zm8 64V216h48v48H120zm70.4 101.3c16.1-18 39.5-29.3 65.6-29.3s49.5 11.3 65.6 29.3l11.9-10.7c-19-21.3-46.7-34.7-77.5-34.7s-58.5 13.4-77.5 34.7l11.9 10.7z'
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fast',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      'M304 192A144 144 0 1 1 16 192a144 144 0 1 1 288 0zM219.4 340.6L85.2 480h22.2l166-172.4C303.3 276.6 320 235.1 320 192c0-88.4-71.6-160-160-160S0 103.6 0 192s71.6 160 160 160c21 0 41.1-4 59.4-11.4z'
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fast',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      'M40 0H472h8V8 40v8H464V40 16H48V40v8H32V40 8 0h8zM16 80h8H488h8v8 32 8H480v-8V96H32v24 8H16v-8V88 80zM54.3 496H457.7l36.4-320H17.9L54.3 496zM472 512H40L1.8 176 0 160H16.1 495.9 512l-1.8 16L472 512zM416 340c0-30.3-16.3-58.9-45.1-80.5S301.5 224 256 224s-86 13.8-114.9 35.5S96 309.7 96 340s16.3 58.9 45.1 80.5S210.5 456 256 456s86-13.8 114.9-35.5S416 370.3 416 340zm16 0c0 72.9-78.8 132-176 132s-176-59.1-176-132s78.8-132 176-132s176 59.1 176 132zM281.8 368.6c-7.3 4.9-16.5 7.4-25.8 7.4s-18.5-2.5-25.8-7.4C223 363.8 216 355.4 216 344s7-19.8 14.2-24.6c7.3-4.9 16.5-7.4 25.8-7.4s18.5 2.5 25.8 7.4C289 324.2 296 332.6 296 344s-7 19.8-14.2 24.6zM256 360c13.3 0 24-7.2 24-16s-10.7-16-24-16s-24 7.2-24 16s10.7 16 24 16z'
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fast',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      'M111.4 4.9c-1.7-4.1-6.4-6-10.5-4.3s-6 6.4-4.3 10.5l30.5 73.1-82.9-51c-3.8-2.3-8.7-1.1-11 2.6s-1.1 8.7 2.6 11L115.7 96H8 0v8V504v8H8 184h8V496h-8H16V112H144h0H248h8V96h-8H172.3l79.9-49.2c3.8-2.3 4.9-7.2 2.6-11s-7.2-4.9-11-2.6L161.6 83.8l31.8-72.6c1.8-4-.1-8.8-4.1-10.5s-8.8 .1-10.5 4.1L144.2 83.6 111.4 4.9zM368.1 159.7L417.6 224H392 336c-22.1 0-40-17.9-40-40c0-22.1 18-40 40.2-40c12.5 0 24.4 5.8 32 15.7zM280 184c0 15.7 6.4 29.8 16.8 40H240 224v16V496v16h16H624h16V496 240 224H624 567.2c10.4-10.2 16.8-24.3 16.8-40c0-31-25.3-56-56.2-56c-17.4 0-34 8.1-44.7 22L432 216.5 380.8 150c-10.7-13.9-27.2-22-44.7-22c-30.9 0-56.2 25-56.2 56zm-40 56h96 56 32V352H240V240zm0 128H424V496H240V368zm384 0V496H440V368H624zM440 352V240h32 56 96V352H440zm32-128H446.4l49.5-64.3c7.6-9.9 19.5-15.7 32-15.7c22.1 0 40.2 17.9 40.2 40c0 22.1-17.9 40-40 40H472z'
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fast',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320-64v8V304h24 8v16h-8H320v56 8H304v-8V320H160 148.1l4.5-11 74-181h17.3l-72 176H304V200v-8h16z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fast',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM185.8 174.5l-11.3 11.3 5.7 5.7L244.7 256l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L256 267.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L267.3 256l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L256 244.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fast',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM312 352h8V336h-8H136h-8v16h8H312z'
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fast',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      'M480 112V400H624V112H480zm-16 0H176V400H464V112zM160 400V112H16V400H160zm0-304h16H464h16H624h16v16V400v16H624 480 464 176 160 16 0V400 112 96H16 160zm112 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fast',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      'M496 176H16V464H496V176zm0-16V48H483.3l-5.7 5.7L371.3 160H496zm-276.7 0H348.7l112-112H331.3l-5.7 5.7L219.3 160zm-22.6 0l112-112H179.3l-5.7 5.7L67.3 160H196.7zM16 48V160H44.7l112-112H16zM512 160v8 8V464v16H496 16 0V464 176v-8-8V48 32H16 496h16V48 160zM204.2 225.2l144 88 11.2 6.8-11.2 6.8-144 88L192 422.3V408 232 217.7l12.2 7.4zM328.7 320L208 246.3V393.7L328.7 320z'
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fast',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      'M16 48H432V226.4c5.5 1.1 10.8 2.6 16 4.4V48 32H432 16 0V48 464v16H16 224V464H16V48zm80 56V96H80v8V280v8H96v-8V104zm64 0V96H144v8V280v8h16v-8V104zM336 344c0-39.8 32.2-72 72-72c28.3 0 52.8 16.3 64.5 40l4.7 9.5 7.8-7.1c7.1-6.5 16.5-10.4 26.9-10.4c22.1 0 40 17.9 40 40l0 .4 0 7.3 7.2 .7C595.6 356 624 386.7 624 424v72H552h-8H344 272V424c0-34.8 24.7-63.9 57.6-70.6l6.5-1.3-.1-6.7c0-.5 0-1 0-1.4zm72-88c-47 0-85.4 36.9-87.9 83.3c-37 10.4-64.1 44.4-64.1 84.7v80 8h8 80H544h8 80 8v-8V424c0-43.3-31.2-79.2-72.4-86.6C564.3 309.6 540.7 288 512 288c-11 0-21.2 3.2-29.8 8.6c-15.6-24.4-43-40.6-74.2-40.6z'
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fast',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM240 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM171.5 256l-21.3 64H329.8l-21.3-64H171.5zM320 240l26.7 80 5.3 16H335.1 144.9 128l5.3-16L160 240H320z'
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fast',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      'M72 0H64V8 64H16 0V80 432v16H16 64l0 56v8h8l240 0h8v-8V448h48 16V432 80 64H368 320V8 0h-8H72zM304 432L80 432H64l-48 0V80H64 80 304h16 48V432H320 304zM80 448H304v48L80 496l0-48zM304 64H80V16H304V64zM200 160v-8H184v8 96 4l3.2 2.4 64 48 6.4 4.8 9.6-12.8-6.4-4.8L200 252V160z'
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fast',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      'M152.5 57.1l-1 6.9-7 0-.5 0c-26.5 0-48 21.5-48 48c0 7.7 1.8 14.9 5 21.3l4.8 9.7L95 144.7C68.4 149 48 172.1 48 200c0 12.3 4 23.6 10.7 32.9l5.9 8.2-9.3 3.9C32.2 254.6 16 277.4 16 304c0 28.8 19 53.2 45.3 61.2l7.7 2.4-2.4 7.7C64.9 380.5 64 386.2 64 392c0 30.9 25.1 56 56 56c5.1 0 10-.7 14.7-1.9l8.6-2.3 1.4 8.7c4 24.7 25.5 43.5 51.3 43.5h52V448v-4V64 16H200c-24.2 0-44.2 17.9-47.5 41.1zM248 512H196c-30.9 0-57-20.6-65.2-48.8c-3.5 .5-7.1 .8-10.8 .8c-39.8 0-72-32.2-72-72c0-4.8 .5-9.5 1.4-14.1C20.4 365.9 0 337.3 0 304c0-29.9 16.4-56 40.7-69.7C35.1 224.1 32 212.4 32 200c0-32.4 21.4-59.8 50.9-68.9C81 125.1 80 118.7 80 112c0-33.3 25.4-60.7 57.9-63.7C145 20.5 170.1 0 200 0h48 8 8 48c29.9 0 55 20.5 62.1 48.3C406.6 51.3 432 78.7 432 112c0 6.7-1 13.1-2.9 19.1c29.5 9 50.9 36.4 50.9 68.9c0 12.4-3.1 24.1-8.7 34.3C495.6 248 512 274.1 512 304c0 33.3-20.4 61.9-49.4 73.9c.9 4.6 1.4 9.3 1.4 14.1c0 39.8-32.2 72-72 72c-3.7 0-7.2-.3-10.8-.8C373 491.4 346.9 512 316 512H264h-8-8zm16-16h52c25.8 0 47.3-18.8 51.3-43.5l1.4-8.7 8.6 2.3c4.7 1.3 9.6 1.9 14.7 1.9c30.9 0 56-25.1 56-56c0-5.8-.9-11.5-2.5-16.7l-2.4-7.7 7.7-2.4c26.2-8 45.3-32.4 45.3-61.2c0-26.6-16.2-49.4-39.3-59.1l-9.3-3.9 5.9-8.2C460 223.6 464 212.3 464 200c0-27.9-20.4-51-47-55.3L406.2 143l4.8-9.7c3.2-6.4 5-13.6 5-21.3c0-26.5-21.5-48-48-48l-.5 0-7 0-1-6.9C356.2 33.9 336.2 16 312 16H264V64 444v4 48z'
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fast',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      'M252.4 21.9c48.4 33.4 55.8 107.1 22.9 172.3l17.4 12.6c48-53.8 117.9-73.1 165.9-38.6c61.5 43.5 70.5 136 23.9 204.9l0 0C398 497.8 223.7 558.4 101.3 470.6l4.7-6.5-4.6 6.5s0 0 0 0C-21.3 383-28 196.5 56.5 71.7c0 0 0 0 0 0l6.6 4.5-6.6-4.5s0 0 0 0C103.1 2.2 190.8-21.7 252.4 21.9zM243.2 35C190.6-2.3 112.6 16.7 69.8 80.7l0 0C-11.4 200.6-2.9 376.5 110.6 457.6l0 0C223.4 538.4 388 484 469.2 364.1c42.9-63.6 32.9-145.6-19.9-182.9l0 0c-39.9-28.6-103.8-13.4-149.1 41.5l-4.8 5.8-6.1-4.4-29-21-5.7-4.1 3.4-6.2c34.7-63 25.8-129.8-14.7-157.7l-.1-.1z'
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fast',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fast',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      'M448 16h8 16 43.7l33.8 50.8 10 104.5-67.9 34-28.4-56.8-2.2-4.4H456 440h-8v8 87.5 .2l0 .3c-.2 25.4-11.6 47.6-29.2 62.5l-2.8 2.4v3.7V496H328V325.7v-6.4l-6.3-1.4-120-26.3-9.7-2.1v9.9V304v40 8.2l-3.2 7.5-17.4 40.5-1.1 2.6 .8 2.7L196.2 496h-83L89.5 410.7l-3.8-13.5 5.5-12.9 20.1-46.9 .6-1.5v-1.6V314.4v-1.7l-.7-1.6L77.9 237.7c-3.9-8.6-5.9-18-5.9-27.4c0-36.6 29.7-66.3 66.3-66.3h53.5H248h72 8v-8c0-66.3 53.7-120 120-120zm97.6 16L534.9 16H552h8V0h-8H524.3 520 472 456h-8C375.6 0 316.4 56.6 312.2 128H248 191.8 138.3c-26.5 0-50.1 12.5-65.1 32H72 64c-35.3 0-64 28.7-64 64v88 8H16v-8V224c0-26.3 21.2-47.7 47.5-48c-4.8 10.4-7.5 22.1-7.5 34.3c0 11.7 2.5 23.4 7.4 34.1L96 316.1v16.4L76.5 377.9l-6.6 15.5L68.8 396l.8 2.7L74 415l25.3 91.2L101 512h6.1 99.6 10.5l-2.8-10.1L187.2 404l16.2-37.9 3.9-9.1 .6-1.5v-1.6V344 309.3l104 22.8V504v8h8 88 8v-8V312.1c17.3-15.8 29.1-37.9 31.5-63l.5 .1V240v-.5V160h3.1l29.8 59.6 3.6 7.2 7.2-3.6 80-40 4.9-2.5-.5-5.5-8.6-89.8 67.8-30.1 4.8-2.1V48 40 32h-8H545.6zm10.7 16h56L565.8 68.7l-.5-5.4-.2-2L564 59.6 556.3 48zM496 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fast',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      'M0 224l11.3 11.3L212.7 436.7 224 448l11.3-11.3L436.7 235.3 448 224l-11.3-11.3L235.3 11.3 224 0 212.7 11.3 11.3 212.7 0 224zM224 425.4L22.6 224 224 22.6 425.4 224 224 425.4zm96-28.1V496v16h16H624h16V496 208 192H624 461.3l9.4 9.4 6.6 6.6H624V496H336V381.3l-16 16zM192 120a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM120 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM224 104a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM88 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm104 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 104a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-88a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm104 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM224 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm72-88a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM496 352a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fast',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM368 160v22.8l-3.8 2.3L224 270.6 83.8 185.2 80 182.8V160H368zm0 41.6V352H80V201.6l139.8 85.3 4.2 2.5 4.2-2.5L368 201.6zM80 144H64v16V352v16H80 368h16V352 160 144H368 80z'
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fast',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      'M208 88a36 36 0 1 0 0-72 36 36 0 1 0 0 72zm0-88a52 52 0 1 1 0 104A52 52 0 1 1 208 0zm19.4 270.3l-3.2-6.4-10.5-21-6.6 22.5-11.7 39.9 52.3 57 5.2 5.7 2 7.5 24 88 4.2 15.4 4.2 15.4-15.4 4.2L241 507.1l-15.4 4.2-4.2-15.4-4.2-15.4-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l11.7-43.7 5.3-19.9-18.8 8.3-17.9 7.9L78.4 250.1l-5.1 15.2-5.1 15.2-15.2-5.1L22.7 265.3 7.5 260.2l5.1-15.2 5.1-15.2 16-48 4.5-13.4L51 162.8l72-32 9.3-4.1 10 2 80 16 15.3 3.1 7 14 35.2 70.5L304 244.2l14.3 7.2-7.2 14.3-14.3 28.6-7.2 14.3-14.3-7.2-33.7-16.8-9.5-4.8-4.8-9.5zm8.4 102.9l-52.3-57-6.1-6.7 2.5-8.7 18.4-62.4 11.5-39L228 235.8l13.7 27.4 2.4 4.8 4.8 2.4 33.7 16.8 14.3-28.6-24.1-12.1-4.8-2.4-2.4-4.8-35.2-70.5-3.5-7-7.7-1.5-80-16-5-1-4.6 2.1-72 32-6.4 2.9-2.2 6.7-16 48-5.1 15.2 30.4 10.1 5.1-15.2 11.5-34.6 2.2-6.7 6.4-2.9 36.7-16.3L150.6 171 142 203.3l-17 63.6c-4.2 15.8-.1 32.7 11 44.8L207 389.1l2.6 2.9 1 3.7 22 80.5 4.2 15.4 30.9-8.4-4.2-15.4-24-88-1-3.7-2.6-2.9zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l4.8 5.2L83.6 404l-1.2 3L80 409.3 36.7 452.7 25.4 464 48 486.6l11.3-11.3 48-48 2.3-2.3 1.2-3 18.6-46.4 12 13.1-15.7 39.3-2.4 6.1-4.6 4.6-48 48L59.3 497.9 48 509.3 36.7 497.9 14.1 475.3 2.7 464l11.3-11.3 11.3-11.3L68.7 398zM533.1 169.9l96 80 7.4 6.1-7.4 6.1-96 80-6.1 5.1L516.7 335l6.1-5.1 79-65.9H392h-8V248h8H601.9l-79-65.9-6.1-5.1L527 164.7l6.1 5.1z'
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fast',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zm64 96V384H96V128H80zm64 0H128V384h16V128zm32 0V384h16V128H176zm80 0H240V384h16V128zm64 0V384h16V128H320zm64 0H368V384h16V128zm48 0V384h16V128H432zm64 0H480V384h16V128z'
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fast',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM145 183.7c-2 10.6-.7 18.6 2.4 25c3.1 6.5 8.6 12 16.2 16.9c15.6 10 38.2 16.2 62.6 22.8l.9 .2c23.3 6.3 48.3 13 66.2 24.5c9.2 5.9 17.1 13.5 21.9 23.3c4.9 9.9 6.2 21.5 3.7 34.9c-4.2 22.2-20.2 37.1-41.5 45.1c-21.1 8-48.1 9.5-76.6 5.4l0 0c-17.9-2.7-49.4-11.6-65.9-16.7l-7.6-2.3 4.7-15.3 7.6 2.3c16.6 5.1 47 13.7 63.6 16.1c26.8 3.9 50.9 2.1 68.7-4.6c17.6-6.6 28.5-17.8 31.4-33.1c2-10.6 .7-18.6-2.4-25c-3.1-6.5-8.6-12-16.2-16.9c-15.6-10-38.2-16.2-62.6-22.8l-.9-.2c-23.3-6.3-48.3-13-66.2-24.5c-9.2-5.9-17.1-13.5-21.9-23.3c-4.9-9.9-6.2-21.5-3.7-34.9c4.2-22.2 20.2-37.1 41.5-45.1c21.1-8 48.1-9.5 76.6-5.4c8.8 1.3 27.7 5.2 36.5 7.3l7.8 1.9L287.8 155l-7.8-1.9c-8.5-2.1-26.9-5.9-35-7c-26.8-3.9-50.9-2.1-68.7 4.6c-17.6 6.6-28.5 17.8-31.4 33.1z'
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fast',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      'M160 336V320l0-224V80H144 16l0-64H224l0 304v16h16 96v9.4l-144 144L48 345.4V336h96 16zM32 352L180.7 500.7 192 512l11.3-11.3L352 352V336 320H336 256 240V304l0-288V0H224 16 0L0 16 0 80 0 96H16 128h16v16l0 192v16H128 48 32l0 16v16z'
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fast',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      'M400 52a36 36 0 1 0 -72 0 36 36 0 1 0 72 0zm-88 0a52 52 0 1 1 104 0A52 52 0 1 1 312 52zm-8 300A144 144 0 1 0 16 352a144 144 0 1 0 288 0zM0 352a160 160 0 1 1 320 0A160 160 0 1 1 0 352zm160-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zm104 88A104 104 0 1 1 56 352a104 104 0 1 1 208 0zm62.3-96c-3.2-5.5-6.6-10.9-10.3-16h92 21.6 16.2l-2.7 16-3.5 21.3-24 144L412.9 437l-2.6 15.8-15.8-2.6L363 444.9l-15.8-2.6 2.6-15.8 2.6-15.8L367.6 320l2.7-16H354 346c-1.4-5.4-3-10.8-4.9-16h29.1 18.9L386 306.6 368.2 413.4l-2.6 15.8 31.6 5.3 2.6-15.8 24-144 3.1-18.6H408 326.3zM232.1 155.6L244 143.7l-14.8-7.8-35.9-19L145 147.1l-13.6 8.5-13.6 8.5-8.5-13.6-17-27.1-8.5-13.6 13.6-8.5L111 92.9l64-40 15.6-9.8L207 51.7l136 72 23.5 12.4 14.8 7.8-11.8 11.8-18.8 18.8L302.2 223c-3.6-4-7.3-7.8-11.2-11.4l48.3-48.3L354.6 148l-19.1-10.1-136-72-8.1-4.3-7.8 4.9-64 40L106 114.9l17 27.1 13.6-8.5 48.4-30.2 7.8-4.9 8.1 4.3 50.7 26.8 19.1 10.1L255.3 155l-20.2 20.2c-5.4-2.3-10.9-4.3-16.5-6.1l13.5-13.5z'
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fast',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM128 304v80h48V304H128zm64 0v80h56V304H192zm128 80V304H264v80h56zm16 0h48V304H336v80zM128 288H384h16v16 80 16H384 128 112V384 304 288h16zm32.4-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fast',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      'M128 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm80-64c0 26.2-12.6 49.4-32 64h16 8v16h-8H178.9l15.4 128H178.1L162.8 256H128 93.2L77.9 384H61.8L77.1 256H64 56V240h8H80c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80s80 35.8 80 80zM48 416H208h3.7l2.4 2.9 40 48 1.9 2.2V472v32 8h-8H8 0v-8V472v-2.9l1.9-2.2 40-48 2.4-2.9H48zM16 474.9V496H240V474.9L204.3 432H51.7L16 474.9z'
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fast',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M160.2 4.9l5.5 5.5 104 104 5.7 5.7L264 131.3l-5.7-5.7L168 35.3V476.7l90.3-90.3 5.7-5.7L275.3 392l-5.7 5.7-104 104-5.7 5.7-5.7-5.7-104-104L44.7 392 56 380.7l5.7 5.7L152 476.7V34.3L53.4 125.9l-5.9 5.4L36.7 119.6l5.9-5.4 112-104 5.6-5.2z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fast',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      'M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v40 8H272v-8V112c0-35.3-28.7-64-64-64s-64 28.7-64 64V240.2H384V112c0-44.2 35.8-80 80-80s80 35.8 80 80v40 8H528v-8V112c0-35.3-28.7-64-64-64s-64 28.7-64 64V248.2v133c-5.5 1.2-10.8 1.9-16 1.9V256.2H144V369c-5.3-2.9-10.4-6.2-16-10.1V248.2 112zM96.6 395c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 449.8 553.5 464 576 464v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 462.2 28.7 480 0 480V464c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9z'
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fast',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM80 368V272h96v96H80zM64 256v16 96 16H80h96 16V368 272 256H176 80 64z'
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fast',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      'M264 0H248V32.2C163.4 36.4 96 106.3 96 192v93.2L33.8 363 32 365.2V368v40 8h8H472h8v-8V368v-2.8l-1.8-2.2L416 285.2V192c0-85.7-67.4-155.6-152-159.8V0zM112 192c0-79.5 64.5-144 144-144s144 64.5 144 144v96 2.8l1.8 2.2L464 370.8V400H48V370.8L110.2 293l1.8-2.2V288 192zm96 256H192c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3H304c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9zM32 176c0-61.1 26.3-116 68.3-154.1L89.5 10.1C44.4 51 16 110.2 16 176H32zM411.7 21.9C453.7 60 480 114.9 480 176h16c0-65.8-28.4-125-73.5-165.9L411.7 21.9z'
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fast',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM487.5 480l-20.3-16H48V133L32 120.4V464v16H48 487.5zM152.5 32l20.3 16H592V379l16 12.6V48 32H592 152.5zM344 183.2l16 12.6V176h56c44.2 0 80 35.8 80 80c0 14.2-3.7 27.6-10.2 39.1l12.7 10C507.1 290.8 512 274 512 256c0-53-43-96-96-96H352h-8v8 15.2zM182.3 239L129.9 352h17.6l29.7-64h67.2l-20.3-16H184.6l10.6-22.8L182.3 239z'
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fast',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM80 384h40v48H80V384zm0-16V320h40v48H80zm56 64V384h48v48H136zm0-64V320h48v48H136zm64 64V384h48v48H200zm0-112h48v48H200V320zm64 112V384h40v48H264zm0-64V320h40v48H264zm56 8v-8V320v-8-8V240 224H304 192 80 64v16 64 8 8 48 8 8 48 16H80h40 8 8 48 8 8 48 8 8 40 16V432 384v-8zm-64-72H192 128 80V240H192 304v64H256z'
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fast',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      'M451.5 15.7c-38.6-.2-70.5 30-72.3 68.6l-2.4 50.9 50.9-2.4c38.5-1.8 68.8-33.7 68.6-72.3l-.2-44.6-44.6-.2zm.1-16L512 0l.3 60.4c.2 47.2-36.7 86.1-83.8 88.4l-52.4 2.5-4.2 .2-26.2 26.2c39.9-7.2 82.6 4.6 113.4 35.4l11.3 11.3 11.3 11.3L470.5 247l-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-29.2-29.2-50.3 50.3c39.9-7.2 82.6 4.6 113.4 35.4l11.3 11.3L380 337.5l-11.3 11.3-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0l-29.2-29.2-50.3 50.3c39.9-7.2 82.6 4.6 113.5 35.4L266.8 428l11.3 11.3-11.3 11.3-11.3 11.3c-37.5 37.5-98.3 37.5-135.8 0L90.6 432.7 16.9 506.5l-5.7 5.7L-.1 500.8l5.7-5.7 73.7-73.7L51.9 394c-37.5-37.5-37.5-98.3 0-135.8L63.2 247l11.3-11.3L85.8 247l11.3 11.3c29.7 29.7 41.8 70.5 36.1 109.1l47.8-47.8-27.4-27.4c-37.5-37.5-37.5-98.3 0-135.8L165 145.1l11.3-11.3 11.3 11.3L199 156.5c29.7 29.7 41.8 70.5 36.1 109.1l47.8-47.8-27.4-27.4c-37.5-37.5-37.5-98.3 0-135.8l11.3-11.3L278.2 32l11.3 11.3 11.3 11.3c29.7 29.7 41.8 70.5 36.1 109.1l23.6-23.6 .2-4.2 2.5-52.4C365.5 36.4 404.4-.6 451.6-.3zM314.5 186.2c15.8-40.2 7.5-87.7-25-120.2L278.2 54.6 266.8 65.9c-31.2 31.2-31.2 81.9 0 113.1l27.4 27.4 20.3-20.3zM212.7 288c15.8-40.2 7.5-87.7-25-120.2l-11.3-11.3L165 167.8c-31.2 31.2-31.2 81.9 0 113.1l27.4 27.4L212.7 288zM110.9 389.8c15.8-40.2 7.5-87.7-25-120.2L74.5 258.3 63.2 269.6C32 300.8 32 351.5 63.2 382.7l27.4 27.4 20.3-20.3zM321.3 202l-15.8 15.8L334.7 247c31.2 31.2 81.9 31.2 113.1 0l11.3-11.3-11.3-11.3c-34.2-34.2-85.1-41.7-126.5-22.3zM219.5 303.8l-15.8 15.8 29.2 29.2c31.2 31.2 81.9 31.2 113.1 0l11.3-11.3L346 326.2c-34.2-34.2-85.1-41.7-126.5-22.3zM117.7 405.6l-15.8 15.8 29.2 29.2c31.2 31.2 81.9 31.2 113.1 0l11.3-11.3L244.2 428c-34.2-34.2-85.1-41.7-126.5-22.3z'
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fast',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      'M176 256l16 0 224 0 16 0 0 16 0 192 64 0 0-272-304 0-16 0 0-16 0-96-9.4 0L22.6 224l144 144 9.4 0 0-96 0-16zM160 384L11.3 235.3 0 224l11.3-11.3L160 64l16 0 16 0 0 16 0 80 0 16 16 0 288 0 16 0 0 16 0 272 0 16-16 0-64 0-16 0 0-16 0-176 0-16-16 0-192 0-16 0 0 16 0 80 0 16-16 0-16 0z'
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fast',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM192 128l0 16 0 224 0 16 16 0 24 0L352 256 232 128l-24 0-16 0zm33.1 240L208 368l0-224 17.1 0 105 112-105 112z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fast',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      'M576 96h-8l-64 0-8 0v8l0 32v25.7L415.6 22.4l-4-6.9-6.9 4L356.3 47.3l-12.4-21-4.1-6.9L333 23.5 277.9 56 271 60.1 275 67l12 20.4-.2 .1-48.5 28-6.9 4 4 6.9 .3 .4 16.3 6.8 8.1 3.4-6.8-11.8 41.6-24 38.5 66.8c10.6 4.9 20.6 10.6 29.9 17.1L292.9 65.7l41.3-24.4 8.2 14-.2 .1 4 6.9 64 110.9 4 6.9 13.9-8-4-6.9-60-103.9 41.6-24 91.4 158.3L512 221.4V191.5l0-55.5V112l48 0v24l0 90.5c0 56.5-29.9 108.8-78.6 137.5c-11.6 6.8-23.7 12-36.1 15.6c-1 5.9-2.2 11.8-3.8 17.6c16.5-4 32.6-10.4 47.9-19.4c53.6-31.5 86.5-89.1 86.5-151.3l0-90.5 0-32V96zM447.1 328.2l.5-.2-.6-1 .1 1.2zM210 150.7l-7.4-3.1-3.1 7.4-24.8 59-3.1 7.4 7.4 3.1 29.5 12.4 7.4 3.1H72 40 32v8 56H8 0v8 64 8H8l24 0v56 8h8H64v56 8h8 32H251c91.1 0 165-73.9 165-165c0-66.4-39.8-126.3-101-152.1l-75.5-31.8L210 150.7zM200 384h8V368h-8H48l-8 0H16V320H32l8 0H200h8V304h-8H48V256H72 255.5 264l3-11.9-8.3-3.5-44-18.5-22.1-9.3 18.6-44.2 22.1 9.3 75.5 31.8C364.1 232.9 400 287 400 347c0 82.3-66.7 149-149 149H104 80V448H200h8V432h-8L80 432H72 48V384H200z'
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fast',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M420 431.3C377.1 471.4 319.4 496 256 496s-121.1-24.6-164-64.7l102-102c16.7 14.2 38.4 22.7 62 22.7s45.3-8.5 62-22.7l102 102zM431.3 420l-102-102c14.2-16.7 22.7-38.4 22.7-62s-8.5-45.3-22.7-62l102-102C471.4 134.9 496 192.6 496 256s-24.6 121.1-64.7 164zm11.3 11.3C485.6 385.5 512 323.8 512 256s-26.4-129.5-69.4-175.3l11.1-11.1 5.7-5.7L448 52.7l-5.7 5.7L431.3 69.4C385.5 26.4 323.8 0 256 0S126.5 26.4 80.7 69.4L69.7 58.3 64 52.7 52.7 64l5.7 5.7L69.4 80.7C26.4 126.5 0 188.2 0 256s26.4 129.5 69.4 175.3L58.3 442.3 52.7 448 64 459.3l5.7-5.7 11.1-11.1C126.5 485.6 188.2 512 256 512s129.5-26.4 175.3-69.4l11.1 11.1 5.7 5.7L459.3 448l-5.7-5.7-11.1-11.1zM420 80.7l-102 102c-16.7-14.2-38.4-22.7-62-22.7s-45.3 8.5-62 22.7L92 80.7C134.9 40.6 192.6 16 256 16s121.1 24.6 164 64.7zM182.7 318L80.7 420C40.6 377.1 16 319.4 16 256s24.6-121.1 64.7-164l102 102c-14.2 16.7-22.7 38.4-22.7 62s8.5 45.3 22.7 62zM176 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fast',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      'M16 441.7V85c93.6 37.2 186.6 13.5 273.8-8.7l2.2-.6c93.8-23.9 181.1-45.6 268-5.5V427c-93.6-37.2-186.6-13.5-273.8 8.7l-2.2 .6c-93.8 23.9-181.1 45.6-268 5.5zm0-374C10.7 65.5 5.3 63 0 60.3V78.1 451.7c96 48.9 192 24.5 288 0c90.7-23.1 181.3-46.2 272-7.5c5.3 2.3 10.7 4.8 16 7.5V433.9 60.3c-96-48.9-192-24.5-288 0c-90.7 23.1-181.3 46.2-272 7.5zM384 256c0-59-40.4-112-96-112s-96 53-96 112s40.4 112 96 112s96-53 96-112zm-96 96c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM536 160h8V144h-8-8c-30.9 0-56-25.1-56-56V80 72H456v8 8c0 39.8 32.2 72 72 72h8zM32 216h8 8c39.8 0 72-32.2 72-72v-8-8H104v8 8c0 30.9-25.1 56-56 56H40 32v16zm504 80h-8c-39.8 0-72 32.2-72 72v8 8h16v-8-8c0-30.9 25.1-56 56-56h8 8V296h-8zM32 360c0 4.4 3.6 8 8 8h8c30.9 0 56 25.1 56 56v8c0 4.4 3.6 8 8 8s8-3.6 8-8v-8c0-39.8-32.2-72-72-72H40c-4.4 0-8 3.6-8 8zM272 200h-8v16h8 8v80H264h-8v16h8 16 16 16 8V296h-8H296V208v-8h-8H272z'
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fast',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      'M416 80l-8 0-96 0v48h24 80l96 64V432v16H496 256l-76.8-64H80 64V368 264H16v80 8H0v-8V168v-8H16v8 80H64V144 128H80h80H296V80l-96 0h-8V64h8H304 408h8V80zM80 248v16V368h99.2H185l4.5 3.7L261.8 432H496V200.6L411.2 144H336l-32 0-144 0H80V248zm96-8v32h32V240H176zm0-16h32 16v16 32 16H208 176 160V272 240 224h16zm96 16v32h32V240H272zm-16-16h16 32 16v16 32 16H304 272 256V272 240 224zm144 16H368v32h32V240zm-32-16h32 16v16 32 16H400 368 352V272 240 224h16zm192-16V432h64V208H560zm-16-16h16 64 16v16V432v16H624 560 544V432 208 192z'
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fast',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-40.1 63.5l0 80.3c57.7-3.2 106.3-40.2 126.3-91.6l-76.4-24.9c-9.2 19.4-27.8 33.5-50 36.2zm54.9-51.4L395.2 293c3.1-11.8 4.8-24.2 4.8-37c0-45-20.6-85.2-52.9-111.6l-47.2 65C312.3 221.1 320 237.6 320 256c0 4.1-.4 8.2-1.1 12.1zM334.1 135c-22.5-14.6-49.3-23-78.1-23s-55.6 8.5-78.1 23l38 52.3L225 200c9.2-5.1 19.7-8 31-8s21.8 2.9 31 8l47.1-65zm-169.2 9.4C132.6 170.8 112 211 112 256c0 12.8 1.7 25.2 4.8 37l76.4-24.9c-.8-3.9-1.1-8-1.1-12.1c0-18.4 7.7-34.9 20.1-46.6l-9.2-12.7-38-52.3zm33.2 138.9l-76.4 24.9c20 51.4 68.6 88.4 126.2 91.6l0-80.3c-22.1-2.8-40.7-16.8-49.8-36.2zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fast',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      'M416 32V48H576V32H416zM576 80H416V96H576V80zm0 48H416v16H576V128zm0 64H416v16H576V192zM416 272v16H576V272H416zm160 48H416v16H576V320zM416 376v16H576V376H416zm160 88H416v16H576V464zM21.5 394.1L97.5 256H112 244.5L130.1 458 21.5 394.1zm60-142.3L0 400l122.2 71.9L136 480l7.9-13.9L262.9 256H336h16V240 48 32H336 112C50.1 32 0 82.1 0 144c0 51.3 34.5 94.5 81.5 107.8zM112 240c-53 0-96-43-96-96s43-96 96-96H336V240H272 253.6 112z'
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fast',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      'M440 56h8V72h-8H168h-8V56h8H440zm0 128h8v16h-8H8 0V184H8 440zm8 128v16h-8H168h-8V312h8H440h8zm-8 128h8v16h-8H8 0V440H8 440z'
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fast',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      'M496 48V464H16V48H496zm16-16H496 16 0V48 464v16H16 496h16V464 48 32zM400 112v32h32V112H400zm-64 0H304v32h32V112zm-128 0v32h32V112H208z'
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fast',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      'M16 80V432H624V80H16zM0 64H16 624h16V80 432v16H624 16 0V432 80 64zm280 96h32 20c28.7 0 52 23.3 52 52c0 15.7-6.9 29.7-17.9 39.2c19.8 7.4 33.9 26.4 33.9 48.8c0 28.7-23.3 52-52 52H312 280h-8v-8V320 256 192 168v-8h8zM248.7 352H231.3l-17.4-40H106.1L88.7 352H71.3l1.4-3.2 80-184 2.1-4.8h10.5l2.1 4.8 80 184 1.4 3.2zM160 188.1L113.1 296h93.9L160 188.1zM288 192v56h44c19.9 0 36-16.1 36-36s-16.1-36-36-36H288v16zm44 72H288v56 16h60c19.9 0 36-16.1 36-36s-16.1-36-36-36H332z'
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fast',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      'M224 16H112V240H464V16H352V136v13.8l-12-6.8-52-29.7-52 29.7-12 6.8V136 16zm0-16h16 96 16H464h16V16 240v16H464 112 96V240 16 0h16H224zM336 16H240V122.2l44-25.2 4-2.3 4 2.3 44 25.2V16zM148.8 320h2.8H376h8v8 56 8h-8H256v24H394.8l120.9-83.1 6.6-4.5 4.5 6.6 36.3 52.7 4.5 6.6-6.6 4.5L398.5 510.6l-2 1.4h-2.5H8 0V496H8 391.5L545.4 390.2l-27.2-39.6-116.3 80-2 1.4h-2.5H248h-8v-8V384v-8h8H368V336H154.4L76.6 398.2 74.4 400H71.6 8 0V384H8 68.8l77.8-62.2 2.2-1.8z'
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fast',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      'M349 52.1l-35.8 71.6C295.6 116.2 276.3 112 256 112s-39.6 4.2-57.2 11.8L163 52.1l-7.2-14.3 0 0 0 0c4.8-2.2 9.8-4.3 14.8-6.2C197.2 21.5 225.9 16 256 16s58.8 5.5 85.4 15.6c5 1.9 9.9 4 14.8 6.2l0 0 0 0L349 52.1zM149.2 23.3l-.5 .2-.2-.5-7 3.8-7.3 3.3 .2 .5-.5 .3c-43.5 23.6-79.3 59.5-103 103l-.3 .5-.5-.2-3.3 7.3-3.8 7 .5 .2-.2 .5C8.3 181.7 0 217.9 0 256v16 16 96 16 96 16H16h96 16V496 400 384 288 272 256c0-18.1 3.7-35.2 10.5-50.8l2.8-6.5 3.5-6.2c11.3-19.8 27.8-36.3 47.6-47.6l6.2-3.5 6.5-2.8c15.6-6.7 32.7-10.5 50.8-10.5s35.2 3.7 50.8 10.5l6.5 2.8 6.2 3.5c19.8 11.3 36.3 27.8 47.6 47.6l3.5 6.2 2.8 6.5c6.7 15.6 10.5 32.7 10.5 50.8v16 16 96 16 96 16h16 96 16V496 400 384 288 272 256c0-38.1-8.3-74.3-23.3-106.8l-.2-.5 .5-.2-3.8-7-3.3-7.3-.5 .2-.3-.5c-23.6-43.5-59.5-79.3-103-103l-.5-.3 .2-.5-7.3-3.3-7-3.8-.2 .5-.5-.2C330.3 8.3 294.1 0 256 0s-74.3 8.3-106.8 23.3zM37.8 155.9l0 0 0 0L52.1 163l71.6 35.8C116.2 216.4 112 235.7 112 256v16H96 32 16V256c0-30.1 5.5-58.8 15.6-85.4c1.9-5 4-9.9 6.2-14.8zm146.7-24.9l0 0c-22.3 12.8-40.8 31.3-53.6 53.6l0 0L59.3 148.7 45 141.6c2.6-4.7 5.3-9.3 8.1-13.8c19-30 44.6-55.6 74.6-74.6c4.5-2.9 9.1-5.6 13.8-8.1l7.2 14.3 35.8 71.6zM381 184.5c-12.8-22.3-31.3-40.8-53.6-53.6l0 0 35.8-71.6L370.4 45l0 0c4.7 2.6 9.3 5.3 13.8 8.1c30 19 55.6 44.6 74.6 74.6c2.9 4.5 5.6 9.1 8.1 13.8l-14.3 7.2-71.6 35.8 0 0zm93.1-28.7l0 0c2.2 4.8 4.3 9.8 6.2 14.8C490.5 197.2 496 225.9 496 256v16H480 416 400V256c0-20.3-4.2-39.6-11.8-57.2L459.9 163l14.3-7.2zM400 288h16 64 16v16 64 16H480 416 400V368 304 288zM16 400H32 96h16v16 64 16H96 32 16V480 416 400zm384 0h16 64 16v16 64 16H480 416 400V480 416 400zM112 288v16 64 16H96 32 16V368 304 288H32 96h16zM264 184v-8H248v8V472v8h16v-8V184zm-72 32v-8H176v8V472v8h16v-8V216zm144 0v-8H320v8V472v8h16v-8V216z'
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fast',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      'M53.2 464L172.1 48H312v56 8h16v-8V48H467.9l41.3 144.5c5.8 .4 11.6 1.2 17.3 2.1L480 32H160L36.6 464 32 480H48.6 360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2.1-6.7-3.8-13.6-5.1-20.6H312v8 56H53.2zM328 312V200v-8H312v8V312v8h14.6c.4-1.5 .9-3.1 1.4-4.6V312zm40 56a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fast',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      'M0 288l18.5 7.9L192 370.3v0V384v40 72l48 16 52.4-98.7L277.7 407l-45.4 85.5L208 484.5V424 384v-6.9 0l16 6.9 208.7 89.5L448 480l2.2-16.5L509.4 19.8 512 0 494.6 9.8 17.6 278.1 0 288zm215 74.7L490.9 37.3 434.9 457 230.3 369.3 215 362.7zM462.2 46.4L199.6 356.1 36.1 286.1 462.2 46.4z'
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fast',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      'M448 48V464H624V48H448zm-16 0H208V464H432V48zM192 464V48H16V464H192zM0 32H16 624h16V48 464v16H624 16 0V464 48 32z'
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fast',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      'M512 144l-11.3-11.3L400 32H368 352V48v88h-8H8 0v16H8 344h8v88 16h16 32L500.7 155.3 512 144zM368 48h25.4l96 96-96 96H368V48zM160 464V376H504h8V360h-8H160V272 256H144 112L11.3 356.7 0 368l11.3 11.3L112 480h32 16V464zm-41.4 0l-96-96 96-96H144V464H118.6z'
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fast',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM264 112v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9l-4.1 15.5c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5V304v8H248v-8l0-16.6c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0 0 0c-1.9-.6-3.5-1.2-5-1.7l-7.6-2.5 5.1-15.2 7.6 2.5c1.7 .6 3.7 1.2 5.7 1.9l0 0c9.5 3.2 21.6 7.4 28.8 8.5c4.8 .7 9.3 1.1 13.6 1.1h.5c8.3 0 15.5-1.4 21.3-3.8c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V112v-8h16v8z'
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fast',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      'M16 144v96h96V144H16zM0 128H16h96 16v16 96 16H112 16 0V240 144 128zM16 304v96h96V304H16zM0 288H16h96 16v16 96 16H112 16 0V400 304 288zM272 144H176v96h96V144zm-96-16h96 16v16 96 16H272 176 160V240 144 128h16zm0 176v96h96V304H176zm-16-16h16 96 16v16 96 16H272 176 160V400 304 288zM432 144H336v96h96V144zm-96-16h96 16v16 96 16H432 336 320V240 144 128h16zm0 176v96h96V304H336zm-16-16h16 96 16v16 96 16H432 336 320V400 304 288z'
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fast',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 256a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fast',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      'M144 0H128V64h16V0zM272 0H256V64h16V0zM384 0V288h16V0H384zm64 0V288h16V0H448zM320 0V64h16V0H320zM192 0V64h16V0H192zM512 0H496V288h16V0zM336 112V496H16V112H336zM16 96H0v16V496v16H16 336h16V496 112 96H336 16zm64 80H272v64H80V176zM64 160v16 64 16H80 272h16V240 176 160H272 80 64zM80 400h64v32H80V400zM64 384v16 32 16H80h64 16V432 400 384H144 80 64zm208 16v32H208V400h64zm-64-16H192v16 32 16h16 64 16V432 400 384H272 208zM80 304h64v32H80V304zM64 288v16 32 16H80h64 16V336 304 288H144 80 64zm208 16v32H208V304h64zm-64-16H192v16 32 16h16 64 16V336 304 288H272 208z'
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fast',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      'M160 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm38.8 48l2.2-3.9 36-64 2.3-4.1 4.7 0 72 0h4.7l2.3 4.1 36 64 2.2 3.9-2.2 3.9-36 64-2.3 4.1H356 284h-4.7l-2.3-4.1-36-64-2.2-3.9zm49.9 56h62.6l31.5-56L351.3 56l-62.6 0-31.5 56 31.5 56zM0 44.7L13.7 58.3l440 440L467.3 512H448 8 0v-8V64 44.7zM16 83.3V496H428.7L16 83.3zM492.1 431l-64-36-4.1-2.3V388 316v-4.7l4.1-2.3 64-36 3.9-2.2 3.9 2.2 64 36 4.1 2.3V316v72 4.7l-4.1 2.3-64 36-3.9 2.2-3.9-2.2zM552 320.7l-56-31.5-56 31.5v62.6l56 31.5 56-31.5V320.7zM328 288a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fast',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      'M187.2 144l4-2.7 87.9-58.6c2.6-1.8 5.7-2.7 8.9-2.7h64c3.2 0 6.2 .9 8.9 2.7l87.9 58.6 4 2.7h4.8H512h16v16 64c0 51-18.4 97.8-48.9 134l-.8 .2 .1 .6C440.3 403.6 383.5 432 320 432s-120.3-28.4-158.4-73.2l.1-.6-.8-.2C130.4 321.8 112 275 112 224V160 144h16 8 46.3 4.8zm-4.8-16H136h-8H112 96 8 0v8V328v6.2l6.1 1.5 144 36 2 .5C193.1 418.7 253.1 448 320 448s126.9-29.3 167.9-75.7l2-.5 144-36 6.1-1.5V328 136v-8h-8H544 528 512 457.7L369.8 69.4C364.5 65.9 358.3 64 352 64H288c-6.3 0-12.5 1.9-17.8 5.4L182.3 128zM16 144H96v16 64c0 47.5 14.8 91.5 40 127.7l-120-30V144zM624 321.8l-120 30c25.2-36.2 40-80.3 40-127.7V160 144h80V321.8zM208 192h-8v16h8H432h8V192h-8H208zm-8 64v16h8H432h8V256h-8H208h-8zm40 64h-8v16h8H400h8V320h-8H240z'
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fast',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      'M88 0l8 0 8 0V0h16 80 16V0l8 0 8 0 0 16-8 0-8 0V140.9c42.6 20.8 72 64.5 72 115.1V496v16H272 48 32V496 256c0-50.6 29.4-94.4 72-115.1V16l-8 0-8 0L88 0zM200 16l-80 0V140.9v10l-9 4.4C73.7 173.4 48 211.7 48 256V496H272V256c0-44.3-25.7-82.6-63-100.7l-9-4.4v-10V16zm8 321c0-6.8-2.7-16-8.3-26.9c-5.4-10.6-12.8-21.6-20.5-31.7c-6.9-9-13.8-17-19.3-23.2c-5.5 6.1-12.4 14.2-19.3 23.2c-7.7 10.1-15.1 21-20.5 31.7C114.7 321 112 330.2 112 337c0 25.7 21.3 47 48 47c14.6 0 26.5-4.3 34.5-11.6c7.8-7.1 13.5-18.3 13.5-35.4zM96 337c0-30.9 34.7-73.2 53-93.4c3.3-3.6 6.1-6.5 8-8.5c1.9-2 3-3.1 3-3.1s1.1 1.1 3 3.1c1.9 2 4.7 4.9 8 8.5c18.3 20.2 53 62.5 53 93.4c0 42-28.7 63-64 63s-64-28.2-64-63z'
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fast',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      'M336 256H320L96 256H80V240 48L16 48V320l304 0h16v16 96h9.4l144-144-144-144H336l0 96v16zm16-128L500.7 276.7 512 288l-11.3 11.3L352 448H336 320V432 352 336H304L16 336H0V320 48 32l16 0 64 0 16 0V48 224v16h16l192 0h16V224l0-80V128h16 16z'
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fast',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      'M256 16C123.5 16 16 123.5 16 256c0 36.9 8.3 71.9 23.2 103.1L24.8 366C8.9 332.7 0 295.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256V496c132.5 0 240-107.5 240-240S388.5 16 256 16zM139 130.9l-7.1 4-6.9 4L117.1 125l6.9-4 7.1-4c32.3-18.5 72.7-14.6 100.9 9.6l13.2 11.3 6.1 5.2-10.4 12.1-6.1-5.2-13.2-11.3c-23.1-19.8-56.2-22.9-82.6-7.8zM176.4 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm17.8 88.3l112.4 31.5 4 1.1 1.4 3.9 2.7 7.5 21.9 60.1 2.7 7.5-7.5 2.7-30.1 10.9-42.8 15.6-29.3 80.5-7.7 21.1L220 512h-5.6H192 104 72 64v-8V472 328 296v-8h8 64 8v8 32 33.8l130.3-47.4 17.2-6.2L189.8 279.7l-7.7-2.2 4.3-15.4 7.7 2.2zM318.8 366.4l-16.4-45.1-22.6 8.2L138.7 380.7 128 384.6V373.2 328 304H80v24V472v24h24 88 16.8l5.7-15.8 30.6-84 1.3-3.5 3.5-1.3 46.3-16.8 22.6-8.2zM320.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fast',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      'M97.2 464.3C114.9 475.1 128 480 128 480s-10-10-18.8-27.2C102.2 439.2 96 421.2 96 400c0-61.9 50.1-112 112-112h64 16v16 64 16h16 16L500.2 218.9 512 208l-11.8-10.9L320 32H304 288V48v64 16H272 176C78.8 128 0 206.8 0 304c0 87.1 59.3 137.2 97.2 160.3zM85.6 437c-3.6-2.8-7.3-5.8-11-9C44.8 401.9 16 362 16 304c0-88.4 71.6-160 160-160H288h16V128 48h9.8L488.3 208 313.8 368H304V288 272H288 208c-70.7 0-128 57.3-128 128c0 13.6 2.2 26 5.6 37z'
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fast',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      'M251.3 315.3l73.4 73.4L336 400l-11.3 11.3L304 432H32 16V416 144l20.7-20.7L48 112l11.3 11.3 73.4 73.4L144 208l11.3-11.3L276.7 75.3 288 64l11.3 11.3 73.4 73.4L384 160l-11.3 11.3L251.3 292.7 240 304l11.3 11.3zM361.4 160L288 86.6 155.3 219.3 144 230.6l-11.3-11.3L48 134.6l-16 16V416H297.4l16-16-84.7-84.7L217.4 304l11.3-11.3L361.4 160z'
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fast',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M16 190.1l107.9 64.7 1.9 1.1H128 320h2.2l1.9-1.1L432 190.1V299.5L317.8 368H130.2L16 299.5V190.1zm0-18.7V88.9L132.6 16H315.4L432 88.9v82.6L317.8 240H130.2L16 171.5zm0 251.7v-105l107.9 64.7 1.9 1.1H128 320h2.2l1.9-1.1L432 318.1v105L315.4 496H132.6L16 423.1zM128 0L0 80V432l128 80H320l128-80V80L320 0H128z'
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fast',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      'M432 48V320H304 288v16V464H16V48H432zm-6.6 288L304 457.4V336H425.4zM16 480H288h16L448 336V320 48 32H432 16 0V48 464v16H16zM192 112h-8v8 64H120h-8v8 64 8h8 64v64 8h8 64 8v-8V264h64 8v-8V192v-8h-8H264V120v-8h-8H192zm8 80V128h48v64 8h8 64v48H256h-8v8 64H200V256v-8h-8H128V200h64 8v-8z'
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fast',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M9.1 464L0 480H18.4 493.6 512l-9.1-16L265.2 48.1 256 32l-9.2 16.1L9.1 464zm475.3 0H27.6L256 64.2 484.4 464zM264 176H248v8V344v8h16v-8V184v-8zM240 416h32V384H240v32z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fast',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      'M175.9 512l.1 0H348c72.9 0 132-59.1 132-132s-59.1-132-132-132H172c-24.3 0-44-19.7-44-44s19.7-44 44-44H288l80 64 144-64V64L368 0 288 64H172C94.7 64 32 126.7 32 204s62.7 140 140 140H348c19.9 0 36 16.1 36 36s-16.1 36-36 36H256.1l-.1 0H96L17.9 455.1 0 464l17.9 8.9L96 512h79.9zM99.8 496l-64-32 64-32L256 432l0 0 .1 0h0H348c28.7 0 52-23.3 52-52s-23.3-52-52-52H172c-68.5 0-124-55.5-124-124s55.5-124 124-124H288h5.6l4.4-3.5 72.4-57.9L496 74.4v75.2L370.4 205.4 298 147.5l-4.4-3.5H288 172c-33.1 0-60 26.9-60 60s26.9 60 60 60H348c64.1 0 116 51.9 116 116s-51.9 116-116 116H176h0l-.1 0h0H99.8zM384 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fast',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      'M336 0H304V32h32V0zM104 144H96v8 53.3C39.5 230 0 286.4 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-65.6-39.5-122-96-146.7V152v-8h-8H182.6L160 121.4 137.4 144H104zm104 55.3c-15.2-4.8-31.3-7.3-48-7.3s-32.8 2.6-48 7.3V160h96v39.3zM160 208a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM345.2 402.8c-2.1 7.6-4.6 15.1-7.6 22.3C364.2 476.7 418 512 480 512c88.4 0 160-71.6 160-160c0-65.6-39.5-122-96-146.7V152v-8h-8H502.6L480 121.4 457.4 144H424h-8v8 53.3c-33.8 14.8-61.6 40.9-78.4 73.6c3 7.2 5.5 14.6 7.6 22.3C365.7 246.7 418.3 208 480 208c79.5 0 144 64.5 144 144s-64.5 144-144 144c-61.7 0-114.3-38.7-134.8-93.2zM528 160v39.3c-15.2-4.8-31.3-7.3-48-7.3s-32.8 2.6-48 7.3V160h96zM56 352a104 104 0 1 1 208 0A104 104 0 1 1 56 352zm224 0A120 120 0 1 0 40 352a120 120 0 1 0 240 0zM480 248a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm0 224a120 120 0 1 0 0-240 120 120 0 1 0 0 240zM221.5 27L227 58.5 258.5 53 253 21.5 221.5 27zM188.7 65.9L161.9 83.3l17.4 26.8 26.8-17.4L188.7 65.9zm262.6 0L433.9 92.7l26.8 17.4 17.4-26.8L451.3 65.9zM418.5 27L387 21.5 381.5 53 413 58.5 418.5 27z'
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fast',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      'M427.4 51.3L556.2 83.5 515.7 230.4l13 13 43-156L576 72l-15.5-3.9L416 32l-20.8 78L408.3 123l19.1-71.7zM349.9 256l3-12.2L374.3 157l145 145L475.7 464 208 464V256H337.3h12.5zm11.3-112.2L337.3 240H208 192v16l0 208 0 16h16l280 0 49.2-182.8L378.8 138.8l-13.2-13.2-4.5 18.1zM32 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm128 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM96 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM48 352a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 96a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM96 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM48 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fast',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM302.3 87.1C346 109.7 376 155.3 376 208c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-52.7 30-98.3 73.7-120.9l10.2 11.8C180.4 109.3 176 122.1 176 136c0 17.3 6.9 33.1 18.1 44.6l4.7 4.9-4 5.5C188 200.2 184 211.6 184 224c0 28.2 20.9 51.6 48 55.4V246.9l-11.6 7.7-6.7 4.4-8.9-13.3 6.7-4.4 14-9.3-14-9.3-6.7-4.4 8.9-13.3 6.7 4.4 11.6 7.7V88 80h16v8V217.1l11.6-7.7 6.7-4.4 8.9 13.3-6.7 4.4-14 9.3 14 9.3 6.7 4.4-8.9 13.3-6.7-4.4L248 246.9v32.5c27.1-3.9 48-27.2 48-55.4c0-12.4-4-23.8-10.8-33.1l-4-5.5 4.7-4.9C297.1 169.1 304 153.3 304 136c0-13.9-4.4-26.7-11.9-37.2l10.2-11.8zM320 136c0 19.3-6.9 37.1-18.3 50.9c6.5 10.8 10.3 23.5 10.3 37.1c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-13.6 3.8-26.3 10.3-37.1C166.9 173.1 160 155.3 160 136c0-6.7 .8-13.3 2.4-19.5c-15.2 12.9-27.1 29.4-34.4 48.3l21.6 21.6 5.7 5.7L144 203.3l-5.7-5.7-15.5-15.5c-1.6 7.3-2.5 14.9-2.8 22.6l29.6 29.6 5.7 5.7L144 251.3l-5.7-5.7-16.5-16.5C131.9 285.4 181 328 240 328s108.1-42.6 118.1-98.8l-16.5 16.5-5.7 5.7L324.7 240l5.7-5.7L360 204.7c-.2-7.7-1.1-15.3-2.8-22.6l-15.5 15.5-5.7 5.7L324.7 192l5.7-5.7L352 164.7c-7.3-18.9-19.2-35.4-34.4-48.3c1.6 6.3 2.4 12.8 2.4 19.5z'
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fast',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      'M296 70.1V457.7c7.4-3.6 17.1-7.9 28.6-12.2c27.2-10.3 65.1-20.8 107.2-21.5c29.6-.5 67.1 5.9 96.3 12c12.2 2.6 23.2 5.1 31.9 7.3V81.4c-.8-.4-1.7-.9-2.7-1.4c-7-3.5-17.4-8.2-30.7-13C499.9 57.5 461.8 48 416 48c-30.2 0-60.8 5.7-84.1 11.5c-11.6 2.9-21.3 5.8-28 8c-3.4 1.1-6 2-7.7 2.6c-.1 0-.1 0-.2 .1zM280 457.7V70c-.1 0-.3-.1-.4-.2c-1.5-.6-3.8-1.5-6.8-2.5c-6-2.1-14.8-5-25.8-7.9C224.9 53.7 194.3 48 160 48c-45.8 0-83.9 9.5-110.6 19.1c-13.3 4.8-23.7 9.5-30.7 13c-.9 .5-1.8 .9-2.7 1.4V443.3c8.7-2.2 19.7-4.7 31.9-7.3c29.2-6.1 66.7-12.5 96.3-12c42.1 .7 80 11.2 107.2 21.5c11.5 4.3 21.2 8.7 28.6 12.2zM416 32c96 0 160 40 160 40V447.4 464s-6.1-1.7-16-4.2c-28.1-7-87.1-20.4-128-19.8c-79.3 1.2-144 40-144 40s-64.7-38.8-144-40c-40.9-.6-99.9 12.8-128 19.8C6.1 462.3 0 464 0 464V447.4 72s64-40 160-40c72 0 128 24 128 24s64-24 128-24z'
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fast',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M269.7 261.7l5.7-5.7-5.7-5.7-208-208L56 36.7 44.7 48l5.7 5.7L252.7 256 50.3 458.3 44.7 464 56 475.3l5.7-5.7 208-208zm192 0l5.7-5.7-5.7-5.7-208-208L248 36.7 236.7 48l5.7 5.7L444.7 256 242.3 458.3l-5.7 5.7L248 475.3l5.7-5.7 208-208z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fast',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      'M0 176H8 440h8v8V376v8H432v-8V192H8 0V176z'
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fast',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      'M144 0H128V64H32 16V80 248v16V432v16H32h96v64h16V448h60c55.2 0 100-44.8 100-100c0-48.6-34.7-89.1-80.7-98.1C252.5 232.4 272 200.5 272 164c0-55.2-44.8-100-100-100H144V0zM128 80V248H32V80h96zm16 168V80h28c46.4 0 84 37.6 84 84s-37.6 84-84 84H144zm-16 16V432H32V264h96zm16 168V264h28 32c46.4 0 84 37.6 84 84s-37.6 84-84 84H144z'
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fast',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      'M136 0h-8V8 96H64L3.2 400 0 416H16.3 431.7 448l-3.2-16L384 96H320V8 0h-8H136zM304 96H144V16H304V96zM136 112H312h58.9l57.6 288H19.5L77.1 112H136zm24 336c0 35.3 28.7 64 64 64s64-28.7 64-64H272c0 26.5-21.5 48-48 48s-48-21.5-48-48H160z'
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fast',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      'M352 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2C42.5 241.3 32 209.9 32 176C32 87.6 103.6 16 192 16s160 71.6 160 160zM128 432H256v64H128V432zm-16 0v64 16h16H256h16V496 432 416H256 128 112v16zM200 96V88H184v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V96z'
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fast',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      'M191.6 0h7.3H313.1h7.3l.7 7.2 3.4 35.4c11.8 3.8 23.1 8.5 33.9 14.1l27.5-22.6 5.6-4.6 5.1 5.1 80.8 80.8 5.1 5.1-4.6 5.6-22.6 27.5c5.6 10.8 10.3 22.1 14.1 33.9l35.4 3.4 7.2 .7v7.3V313.1v7.3l-7.2 .7-35.4 3.4c-3.8 11.8-8.5 23.1-14.1 33.9l22.6 27.5 4.6 5.6-5.1 5.1-80.8 80.8-5.1 5.1-5.6-4.6-27.5-22.6c-10.8 5.6-22.1 10.3-33.9 14.1l-3.4 35.4-.7 7.2h-7.3H198.9h-7.3l-.7-7.2-3.4-35.4c-11.7-3.8-23.1-8.5-33.9-14.1l-27.5 22.6-5.6 4.6-5.1-5.1L34.6 396.6l-5.1-5.1 4.6-5.6 22.6-27.5c-5.6-10.8-10.3-22.1-14.1-33.9L7.2 321.1 0 320.4v-7.3V198.9v-7.3l7.2-.7 35.4-3.4c3.8-11.7 8.5-23.1 14.1-33.9L34.1 126.1l-4.6-5.6 5.1-5.1 80.8-80.8 5.1-5.1 5.6 4.6 27.5 22.6c10.8-5.6 22.1-10.3 33.9-14.1l3.4-35.4 .7-7.2zm14.5 16l-3.2 33.5-.5 5.4-5.2 1.5c-14.3 4.2-27.9 9.9-40.7 16.9l-4.7 2.6-4.2-3.4L121.5 51 51 121.5l21.4 26 3.4 4.2-2.6 4.7c-7 12.8-12.7 26.5-16.9 40.7l-1.5 5.2-5.4 .5L16 206.1v99.7l33.5 3.2 5.4 .5 1.5 5.2c4.2 14.3 9.9 27.9 16.9 40.7l2.6 4.7-3.4 4.2L51 390.5 121.5 461l26-21.4 4.2-3.4 4.7 2.6c12.8 7 26.5 12.7 40.7 16.9l5.2 1.5 .5 5.4 3.2 33.5h99.7l3.2-33.5 .5-5.4 5.2-1.5c14.3-4.2 27.9-9.9 40.7-16.9l4.7-2.6 4.2 3.4 26 21.4L461 390.5l-21.4-26-3.4-4.2 2.6-4.7c7-12.8 12.7-26.5 16.9-40.7l1.5-5.2 5.4-.5 33.5-3.2V206.1l-33.5-3.2-5.4-.5-1.5-5.2c-4.2-14.3-9.9-27.9-16.9-40.7l-2.6-4.7 3.4-4.2 21.4-26L390.5 51l-26 21.4-4.2 3.4-4.7-2.6c-12.8-7-26.5-12.7-40.7-16.9l-5.2-1.5-.5-5.4L305.8 16H206.1zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-65.8 75.4a16 16 0 1 1 9.9-30.4 16 16 0 1 1 -9.9 30.4zM209 320.7a16 16 0 1 1 18.8-25.9A16 16 0 1 1 209 320.7zm97.6-22.3a16 16 0 1 1 -25.9 18.8 16 16 0 1 1 25.9-18.8zm25.5-67.1a16 16 0 1 1 -30.4 9.9 16 16 0 1 1 30.4-9.9z'
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fast',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      'M16 48V464H496V48H16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM185.8 174.5l5.7 5.7L256 244.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L267.3 256l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L256 267.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L244.7 256l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fast',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      'M112 0h-8V8 64H32 15.4L25.8 77l28 35-28 35L15.4 160H32h72v72 8 7.4L34.8 305.9 32 308.3V312v53.7c0 48.8 26.2 93.9 68.5 118.1l18 10.3C139.1 505.8 162.3 512 186 512H328c57.4 0 104-46.6 104-104V392 304 256v-8h-8H368V224v-8h-8H296V192v-8h-8H208V160 144 80 64 8 0h-8H112zm80 64H120V16h72V64zm0 16v64H48.6l21.6-27 4-5-4-5L48.6 80H192zm0 80v32 8h8 80v24 8h8 64v24 8h8 56v40 88 16c0 48.6-39.4 88-88 88H186c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C71.1 448.5 48 408.8 48 365.7v-50l56-47.4V344v8h16v-8V254.8v-3.7V240v-8V160h72z'
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fast',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      'M0 0H8 120h8V8 416h96H512 632h8v16h-8H547.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H259.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H120h-8v-8V16H8 0V0zM512 432a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 464a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM304 0h8H456h8V8 80h96 16V96 336v16H560 208 192V336 96 80h16 96V8 0zm16 96H304 288V336H480V96H464 448 320zM448 80V16H320V80H448zM272 96H208V336h64V96zM496 336h64V96H496V336z'
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fast',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      'M272 495.5V464H216h-3.3l-2.3-2.3-48-48-2.3-2.3V408 296v-8h8H312h3.3l2.3 2.3L363.3 336H392h3.3l2.3 2.3L427.3 368H456h8v7.8c7.3-12.6 13.4-25.9 18.3-39.8H440h-3.3l-2.3-2.3-48-48-2.3-2.3V280 200v-8h8 24V176H368v40 8h-8H280h-8v24 8h-8H200h-8v-8V216v-3.3l2.3-2.3L272 132.7V128H232h-8v-8V88 84.7l2.3-2.3 63.9-63.9C279.1 16.8 267.6 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c5.4 0 10.7-.2 16-.5zM240 91.3V112h40 8v8 16 3.3l-2.3 2.3L208 219.3V240h48V216v-8h8 16 72V168v-8h8 64 8v8 32 8h-8H400v68.7L443.3 320h44.1c5.6-20.4 8.6-41.8 8.6-64c0-114.2-79.8-209.8-186.6-234L240 91.3zm48 402.6c65.3-8.7 122.3-43.6 160-93.9h0V384H424h-3.3l-2.3-2.3L388.7 352H360h-3.3l-2.3-2.3L308.7 304H176V404.7L219.3 448H280h8v8 37.9zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM181.7 117.7l-32 32-5.7 5.7L132.7 144l5.7-5.7 32-32 5.7-5.7L187.3 112l-5.7 5.7z'
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fast',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      'M480 496H144V336H305.1l-20.3-16H144 128v16 64H80V208h63l-20.3-16H80 64v16V400v16H80h48v80 16h16H496h16V499.3l-4.2-3.3H496 480zM144 16h16H441.4L496 70.6V160h16V64L448 0H144 128V12.7l4.2 3.3H144zM560 192H355.1l20.3 16H560V353.7l16 12.6V208 192H560zm-48 96V256H480v32h32zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fast',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      'M0 64H8 32h8 8H592h8 8 24 8V80h-8H608v80h24 8v16h-8H608v72h24 8v16h-8H608v72h24 8v16h-8H608v80h24 8v16h-8H608h-8-8H48 40 32 8 0V432H8 32V352H8 0V336H8 32V264H8 0V248H8 32V176H8 0V160H8 32V80H8 0V64zm48 96v16 72 16 72 16 80h80V80H48v80zm96 272H496V80H144V432zM512 80V432h80V352 336 264 248 176 160 80H512z'
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fast',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM21.7 496L75.8 320H320V304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16-3.4-11.1-24.2-24.2L426.3 496H21.7zm607-123.3L480 224H384l-32 32v96L500.7 500.7 512 512l11.3-11.3L628.7 395.3 640 384l-11.3-11.3zM473.4 240l144 144L512 489.4l-144-144V262.6L390.6 240h82.7zM440 296a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fast',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM240 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM102.2 368H281.8l-21.3-64H123.5l-21.3 64zM272 288l26.7 80 5.3 16H287.1 96.9 80l5.3-16L112 288H272zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fast',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      'M306.3 138.2l-57.1 39.9L289.4 240l78.6 0 15 0 9.6 11.5 80 96 10.2 12.3 10.2 12.3-12.3 10.2-24.6 20.5-12.3 10.2-10.2-12.3-10.2-12.3L353 304l-57.7 0-19.1 0 10.4 16 81.9 126.6 8.7 13.4 8.7 13.4-13.4 8.7-26.9 17.4-13.4 8.7-8.7-13.4-8.7-13.4L176 266.9l-16-24.7 0 29.5 0 80.4 0 16 0 16H144l-32 0H96l0-16 0-16 0-128V207.3l13.6-9.6L256 95.3 256 32V16h16 32 16V32l0 80 0 16.7-13.6 9.6zM368 256l-78.6 0-8.7 0-4.7-7.3-40.1-61.8-8.4-13 12.7-8.9 57.1-39.9 6.8-4.8V112l0-80H272l0 63.3v8.3l-6.8 4.8L146.3 191.6l0 0-2.3 1.6v0l-25.2 17.6-6.8 4.8V224l0 128 0 16h0v0h32V352l0-119.7 19.7-13.8 9.7 15L328.2 472.7l8.7 13.4 26.9-17.4-8.7-13.4L262.8 312.7l-16-24.7 29.4 0 76.8 0h7.5l4.8 5.8 70.4 84.5 10.2 12.3L470.5 370l-10.2-12.3-80-96-4.8-5.8-7.5 0zM160 88A40 40 0 1 0 80 88a40 40 0 1 0 80 0zM120 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fast',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M136 0h-8V8 96H16 0v16V264 464v16H16 496h16V464 264 112 96H496 384V8 0h-8H136zM496 256H336 320 192 176 16V112H136 376 496V256zM320 272v64H192V272H320zm-144 0v64 16h16H320h16V336 272H496V464H16V272H176zM368 96H144V16H368V96z'
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fast',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      'M112 8V0H96V8c0 27.4 5.1 46.4 13.3 61.1c8 14.4 18.6 23.9 28.3 32.6l.3 .3c9.9 8.9 18.7 16.9 25.3 28.7c6.5 11.7 11.2 27.9 11.2 53.3v8h16v-8c0-27.4-5.1-46.4-13.3-61.1c-8-14.4-18.6-23.9-28.3-32.6l-.3-.3c-9.9-8.9-18.7-16.9-25.3-28.7C116.7 49.6 112 33.4 112 8zm97.6 0V0h-16V8c0 27.4 5.1 46.4 13.3 61.1c8 14.4 18.6 23.9 28.3 32.6l.3 .3c9.9 8.9 18.7 16.9 25.3 28.7c6.5 11.7 11.2 27.9 11.2 53.3v8h16v-8c0-27.4-5.1-46.4-13.3-61.1c-8-14.4-18.6-23.9-28.3-32.6l-.3-.3c-9.9-8.9-18.7-16.9-25.3-28.7C214.3 49.6 209.6 33.4 209.6 8zM32 256H24v16h8H66.8l.8 13.2C72.5 368.1 122 438.2 192 472.9V496v16h16H432h16V496 472.9c70-34.6 119.5-104.8 124.4-187.7l.8-13.2H608h8V256h-8H574.1l.9-16 .9-16H560 80 64l.9 16 .9 16H32zm490.5-64h16.8c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h16.8c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM208 472.9v-9.9l-8.9-4.4c-65-32.2-111-97.3-115.5-174.3L81 240H559l-2.6 44.2c-4.5 77-50.5 142.2-115.5 174.3l-8.9 4.4v9.9V496H208V472.9z'
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fast',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      'M524.3 34.6c-47.5 23.5-80.2 72.5-80.2 129.1c0 79.5 64.5 144 144 144c6.7 0 13.2-.5 19.7-1.3c9.3-1.3 18.3-3.4 27-6.4c-5.9 7.7-12.5 14.8-19.6 21.4c-31.4 29.2-73.4 47-119.5 47c-13.3 0-26.3-1.5-38.8-4.3c-8.2-10.8-18.4-20-29.9-27.2c20.8 10 44.1 15.5 68.7 15.5c33.9 0 65.4-10.6 91.3-28.7c-87.9-.6-158.9-72-158.9-160c0-54.6 27.3-102.8 69.1-131.7l-1.5 0C407.6 32 336 103.7 336 192.2c0 13.1 1.6 25.8 4.5 37.9c-5.6-1.9-11.4-3.4-17.3-4.5c-2.1-10.8-3.2-22-3.2-33.4C320 94.9 398.7 16 495.8 16c8.9 0 17.7 .7 26.2 2c9.7 1.5 19.2 3.7 28.4 6.7c-9.1 2.5-17.8 5.8-26.1 9.9zM176 224c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.8 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4l0 64 0 16h-16l-64 0H96 16 0v-16-80c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zM431.9 431.9c0-31.5-22.7-57.6-52.6-63L362.8 366l3.6-16.3c1-4.4 1.5-9 1.5-13.8c0-35.3-28.6-64-64-64c-13.6 0-26.2 4.3-36.6 11.5l-14 9.8-8.8-14.6C230.4 255.5 205 240 176 240c-44.2 0-79.9 35.8-80 79.9l0 1.3 .1 13.6-13.4 2.3C44.8 343.4 16 376.3 16 415.9v80H96 367.9l64 0v-64z'
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fast',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM236.5 96.3l.2-.2 40.1 40.1 11.3 11.3-11.3 11.3L156.9 278.7l-44.3 6.9L96 288.1l2.6-16.6 6.9-44.3 131-131zm.2 22.4L215.3 140l28.8 28.8 21.4-21.4-28.8-28.8zM120.5 234.9L115.2 269l34.1-5.3 83.5-83.5L204 151.3l-83.5 83.5z'
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fast',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      'M319.6 0H301L.4 512H19L319.6 0z'
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fast',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      'M248 20.3V216H40.3c-7.6-39.1-9.4-74.8-7.8-102.1l.6-10.3 9.6-3.7L248 20.3zM43.7 232H248V491.1C155.1 450.3 99.8 379.5 68.5 307.5c-11-25.4-19.1-51-24.8-75.5zM264 491.1V232H468.3c-5.7 24.6-13.8 50.2-24.8 75.5c-31.3 72-86.6 142.8-179.5 183.5zM471.7 216H264V20.3L469.3 99.9l9.6 3.7 .6 10.3c1.6 27.3-.2 63-7.8 102.1zm23.8-103l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fast',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M176 16V32 48 200h64V48 32 16H176zM160 200V48H96V200h64zm-80 0V48 32H96h64V16 0h16 64 16V16 32h64 16V48 64h64 16V80 192v8 24 16 24c0 48.7-25.6 91.4-64 115.4V504v8H336v-8V374.9v-4.6l4-2.3c35.9-20.8 60-59.5 60-104V240H336 320V224H256h-8v64 8h-8H136h-8V280h8 96V216H192 48v56 8c0 52.4 38.7 95.7 89.1 102.9l6.9 1v6.9V504v8H128v-8V397.6C75.8 387 35.8 342.5 32.3 288H32v-8-8V208v-8h8H80zm320 24V200v-8V80H336V208v16h64zM256 200v8h64V80 64 48H256V200z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fast',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      'M16 48H560V400H460.3l9.1 8.2 8.7 7.8H560h16V400 48 32H560 16 0V48 400v16H16 97.9l8.7-7.8 9.1-8.2H16V48zM144 464V439.1L288 309.5 432 439.1V464H144zm-16-32v32 16h16H432h16V464 432L288 288 128 432z'
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fast',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      'M17.1 256H0l6-16L96 0H352l90 240 6 16H430.9 17.1zm6-16H424.9l-84-224H107.1l-84 224zM160 320V288h16v32 7.8l-6.1 4.8 0 0 0 0 0 0-.1 .1-.4 .3c-.4 .3-1 .8-1.8 1.5c-1.6 1.3-3.9 3.4-6.7 6c-5.6 5.3-13 13-20.4 22.4C125.4 382.1 112 406.6 112 432c0 20.4 6.8 37.7 13.9 50.1c3.4 6 6.8 10.7 9.4 13.9H312.7c2.6-3.2 6-7.9 9.4-13.9c7.1-12.4 13.9-29.6 13.9-50.1c0-25.4-13.4-49.9-28.6-69.2c-7.4-9.4-14.9-17.1-20.4-22.4c-2.8-2.6-5.1-4.7-6.7-6c-.8-.7-1.4-1.2-1.8-1.5l-.4-.3-.1-.1 0 0 0 0 0 0 0 0-6.1-4.8V320 288h16v32s64 50.5 64 112c0 48-32 80-32 80H128s-32-32-32-80c0-61.5 64-112 64-112zM139.4 500.7s0 0 0 0l0 0z'
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fast',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      'M229.7 117.7l-5.7 5.7L212.7 112l5.7-5.7 96-96L320 4.7l5.7 5.7 96 96 5.7 5.7L416 123.3l-5.7-5.7L328 35.3V280v8 96V496H504h8v16h-8H320h-8v-8V384 296H35.3l82.3 82.3 5.7 5.7L112 395.3l-5.7-5.7L12.7 296H8v-4.7L4.7 288 8 284.7V280h4.7l93.7-93.7 5.7-5.7L123.3 192l-5.7 5.7L35.3 280H312V35.3l-82.3 82.3z'
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fast',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM85.6 144h16.6l58.3 218.5 55.9-188.7 4.1-13.7h7.2l4.1 13.7 55.9 188.7L345.9 144h16.6L295.7 394.1l-1.6 5.9H282l-1.7-5.7L224 204.2 167.7 394.3 166 400H153.9l-1.6-5.9L85.6 144z'
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fast',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      'M400 16V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H16V16H400zM16 416H64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632h8V400h-8H608V216v-3.3l-2.3-2.3-112-112L491.3 96H488 416V16 0H400 16 0V16 400v16H16zM416 112h68.7l104 104H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM237.7 82.3L232 76.7 220.7 88l5.7 5.7L292.7 160H104 96v16h8H292.7l-66.3 66.3-5.7 5.7L232 259.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80z'
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fast',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      'M496 304L16 304l0 160 480 0 0-160zm16 160l0 16-16 0L16 480 0 480l0-16L0 304l0-16 16 0 480 0 16 0 0 16 0 160zM272 48l-80 0L16 48l0 160 256 0 0-160zm16 0l0 160 0 16-16 0L16 224 0 224l0-16L0 48 0 32l16 0 176 0 80 0 16 0 128 0 8 0 0 8 0 164.7 50.3-50.3 5.7-5.7L491.3 160l-5.7 5.7-64 64-5.7 5.7-5.7-5.7-64-64-5.7-5.7L352 148.7l5.7 5.7L408 204.7 408 48 288 48zM80 376l352 0 8 0 0 16-8 0L80 392l-8 0 0-16 8 0z'
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fast',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      'M8 0H0V16H8 112V424v8h8 68.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H476.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H632h8V416h-8H512 224 128V8 0h-8H8zM544 464a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 496a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM208 80H368V336H208V80zM192 64V80 336v16h16H368h16V336 80 64H368 208 192zM432 80h96v96H432V80zM416 64V80v96 16h16 96 16V176 80 64H528 432 416zM592 240v96H432V240H592zM432 224H416v16 96 16h16H592h16V336 240 224H592 432z'
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fast',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M44.7 256l5.7-5.7 176-176 5.7-5.7L243.3 80l-5.7 5.7L67.3 256 237.7 426.3l5.7 5.7L232 443.3l-5.7-5.7-176-176L44.7 256z'
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fast',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      'M208 16V496H496V16H208zM192 0h16H496h16V16 496v16H496 208 192V496 16 0zM160 144H16V496H160v16H8 0v-8V136v-8H8 160v16zM64 320h8 64 8v8 64 8h-8H72 64v-8V328v-8zm16 16v48h48V336H80zM72 192h64 8v8 64 8h-8H72 64v-8V200v-8h8zm8 64h48V208H80v48zM368 400v-8V328v-8h8 64 8v8 64 8h-8H376h-8zm16-16h48V336H384v48zm-8-112h-8v-8V200v-8h8 64 8v8 64 8h-8H376zm8-64v48h48V208H384zM256 400v-8V328v-8h8 64 8v8 64 8h-8H264h-8zm16-16h48V336H272v48zM264 72h64 8v8 64 8h-8H264h-8v-8V80 72h8zm8 64h48V88H272v48zM256 272v-8V200v-8h8 64 8v8 64 8h-8H264h-8zm16-16h48V208H272v48zM376 72h64 8v8 64 8h-8H376h-8v-8V80 72h8zm8 64h48V88H384v48z'
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fast',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H368v0H352v0H224V320h32 70.6c1.5-5.4 3.3-10.8 5.4-16H216h-8v8V496H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 10 .3L293.2 9.9zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fast',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      'M287.5 294.9L512 40 472 0 217.1 224.5l11.3 11.3L471.3 21.9l18.8 18.8L276.1 283.6l11.3 11.3zM181.7 234.3l-5.7-5.7L164.7 240l5.7 5.7L180.7 256 112 324.7l-2.3-2.3-5.7-5.7-5.7 5.7-96 96L0 420.7V424v32 3.3l2.3 2.3 48 48 2.3 2.3H56 88h3.3l2.3-2.3 96-96 5.7-5.7-5.7-5.7-2.3-2.3L256 331.3l10.3 10.3 5.7 5.7L283.3 336l-5.7-5.7-16-16-64-64-16-16zm10.3 33L244.7 320 216 348.7 163.3 296 192 267.3zM123.3 336L152 307.3 204.7 360 176 388.7 123.3 336zM16 427.3l88-88 2.3 2.3 64 64 2.3 2.3-88 88H59.3L16 452.7V427.3z'
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fast',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      'M267 96.2c62.9 2.7 119.4 27.9 155.9 48.2l-38.7 11L368 160l5.3 15.9L384 208 261.6 162.1 256 160l-5.6 2.1L128 208l10.7-32.1L144 160l-16.1-4.6-39-11C139.3 115.5 192.1 97 250.9 96c-.4 6.9-1.3 14.4-2.8 22.5l-1.4 7.9 15.7 2.9 1.4-7.9c1.6-9 2.6-17.4 3.1-25.2zm.2-16c-.9-23.5-6.9-40.8-14.3-53.3c-5.5-9.4-11.6-15.8-16.5-19.9c-2.4-2.1-4.5-3.6-6.1-4.6c-.8-.5-1.4-.9-1.9-1.2c-.2-.1-.4-.2-.6-.3l-.2-.1-.1 0 0 0 0 0s0 0-3.6 7.1s-3.6 7.2-3.6 7.2l0 0 0 0 0 0 .2 .1c.2 .1 .6 .3 1.1 .7c1 .7 2.5 1.7 4.4 3.3c3.7 3.1 8.6 8.2 13 15.8c5.8 9.9 11.1 24.3 12 45c-67.7 1.1-127.4 24-183.5 58.3c-6.1 3.7-12.1 7.6-18.1 11.5l20.5 5.8 38 10.8 15.4 4.4L118.5 186l-9.7 29.2-6.5 19.5 19.3-7.2L256 177.1l134.5 50.4 19.3 7.2-6.5-19.5L393.5 186l-5.1-15.2 15.4-4.4 38-10.8 20.5-5.8c-4.7-3.1-10.8-7.1-18.2-11.5c-36.2-21.8-102.1-55.1-177.1-58.2zM0 304c0-48.7 15.9-90 43.2-122.7l17 4.8C32.3 216.8 16 256.4 16 304c0 60.2 26.1 107.6 68.7 140.4C127.7 477.4 188 496 256 496s128.3-18.6 171.3-51.6C469.8 411.6 496 364.2 496 304c0-47.6-16.3-87.2-44.2-117.8l17-4.8C496.1 214 512 255.3 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304z'
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fast',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM80 176H336V336H80V176zM64 160v16V336v16H80 336h16V336 176 160H336 80 64z'
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fast',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M443.3 112l-5.7 5.7-272 272-5.7 5.7-5.7-5.7-144-144L4.7 240 16 228.7l5.7 5.7L160 372.7 426.3 106.3l5.7-5.7L443.3 112z'
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fast',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      'M320 8V0H304V8 23.7l-2.1 .6-264 72L32 97.9V104 376v8h8H504h8v-8V248v-6.2l-6.1-1.5L320 193.8V136 8zM48 110.1L304 40.3V128H248h-8v16h8 56v48H248h-8v16h8 63l185 46.2V368H48V110.1zM128 424v-8H112v8 72H8 0v16H8 120 408 568h8v-8V440v-8H560v8 56H416V424v-8H400v8 72H128V424z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fast',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zM536 112H520v8 80H440h-8v16h8 80v80 8h16v-8V216h80 8V200h-8H536V120v-8z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fast',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400h56V16H56C33.9 16 16 33.9 16 56V416.8zM128 16V400H432V16H128zm48 112h8H376h8v16h-8H184h-8V128zm0 80h8H376h8v16h-8H184h-8V208z'
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fast',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      'M528 0c-30.9 0-56 25.1-56 56c0 11.8 3.6 22.7 9.8 31.7l-68.2 48.1C370.6 110.5 325.7 96 288 96C176 96 0 224 0 384V496v16H16 288 560h16V496 384c0-60.3-25-116.1-62.2-162.2l-13.1 9.2c35.8 44 59.3 96.8 59.3 152.9V496H288 16V384c0-74 40.8-142 96.7-192.1C168.8 141.6 237.1 112 288 112c32.5 0 72.2 12.1 111.3 34c-18 12.2-42.4 12-66.9 7.7c-32.7-5.6-64.5 2.5-89.6 20.2s-43.4 45-49 77.7c-11.2 65.3 32.6 127.4 97.9 138.6s127.4-32.6 138.6-97.9c5.3-30.7 13.7-60.4 36-76.2l74.5-52.6C551 176.1 566.6 184 584 184c30.9 0 56-25.1 56-56s-25.1-56-56-56c-.8 0-1.6 0-2.3 0c1.5-5.1 2.3-10.5 2.3-16c0-30.9-25.1-56-56-56zM488 56c0-22.1 17.9-40 40-40s40 17.9 40 40c0 6.1-1.4 11.8-3.8 17l-1.9 4.1 2.5 3.8 3 4.6 3 4.5 5.3-1.1c2.6-.5 5.2-.8 7.9-.8c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.6 0-27.4-7.9-34.4-19.6l-4.4-7.4-7.1 5-57.2 40.4s0 0 0 0l-13.4 9.4s0 0 0 0l-10.5 7.4c-28.3 20-37.3 56.1-42.6 86.5c-9.7 56.6-63.5 94.6-120.1 84.8s-94.6-63.5-84.8-120.1c4.9-28.3 20.7-51.9 42.5-67.3s49.3-22.4 77.6-17.5c25.5 4.4 55.9 5.7 79.6-11l88.8-62.7 7.6-5.4-6.5-6.7C492.3 76.6 488 66.8 488 56z'
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fast',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM157.7 237.7l-56 56L96 299.3l-5.7-5.7-24-24L60.7 264 72 252.7l5.7 5.7L96 276.7l50.3-50.3 5.7-5.7L163.3 232l-5.7 5.7zM192 256h8H312h8v16h-8H200h-8V256zM160 376h8H312h8v16h-8H168h-8V376zm-64-8a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fast',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M496 80V432H16V80H496zM16 64H0V80 432v16H16 496h16V432 80 64H496 16z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fast',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM222.8 187.8l-2.4-3.8-4.4 0-8 0-8 0v8 96 8h16v-8V207.1l33.2 53.1 6.8 10.9 6.8-10.9L296 207.1V288v8h16v-8V192v-8l-8 0-8 0-4.4 0-2.4 3.8L256 240.9l-33.2-53.1zM372.8 184c-15.9 0-28.8 12.9-28.8 28.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H352h-8v16h8 27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H392h8V184h-8H372.8zM104 212.8c0 9.6 4.8 18.7 12.8 24l29.4 19.6c3.6 2.4 5.7 6.4 5.7 10.7c0 7.1-5.8 12.8-12.8 12.8H112h-8v16h8 27.2c15.9 0 28.8-12.9 28.8-28.8c0-9.6-4.8-18.7-12.8-24l-29.4-19.6c-3.6-2.4-5.7-6.4-5.7-10.7c0-7.1 5.8-12.8 12.8-12.8H152h8V184h-8H132.8c-15.9 0-28.8 12.9-28.8 28.8z'
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fast',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      'M239 19.9l3.9-7L229 5.1l-3.9 7L123.3 192H48.5 32 0v16H36l76 304H464l76-304h36V192H544 527.5 452.7L351 12.1l-3.9-7L333.1 13l3.9 7L434.3 192H141.7L239 19.9zM52.5 208h471l-72 288h-327l-72-288zM208 344h-8v16h8H368h8V344h-8H208z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fast',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M160 48V176H496V48H160zm-16 0H16V176H144V48zM16 192V320H144V192H16zm0 144V464H144V336H16zM160 464H496V336H160V464zM496 320V192H160V320H496zM0 32H16 496h16V48 464v16H496 16 0V464 48 32z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fast',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      'M96 512l-8 0 0-8 0-224 0-8 0-7.4L18.8 206.1 16 203.7l0-3.7 0-53.7C16 97.5 42.2 52.4 84.5 28.2l18-10.3C123.1 6.2 146.3 0 170 0L312 0c57.4 0 104 46.6 104 104l0 16 0 88 0 48 0 8-8 0-56 0 0 24 0 8-8 0-64 0 0 24 0 8-8 0-80 0 0 176 0 8-8 0-88 0zM88 243.7L88 168l0-8 16 0 0 8 0 89.2 0 3.7 0 11.1 0 8 0 216 72 0 0-176 0-8 8 0 80 0 0-24 0-8 8 0 64 0 0-24 0-8 8 0 56 0 0-40 0-88 0-16c0-48.6-39.4-88-88-88L170 16c-20.9 0-41.4 5.4-59.5 15.8l-18 10.3C55.1 63.5 32 103.2 32 146.3l0 50 56 47.4z'
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fast',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      'M16 72V64H0v8V248 440v8H16v-8V256H304V440v8h16v-8V248 72 64H304v8V240H16V72zm416-8h-6.4l-1.4 6.2-40 176L382 256h10H536c48.6 0 88 39.4 88 88s-39.4 88-88 88H448.4c-20.7 0-39-13.2-45.5-32.8l-3.2-9.7-2.5-7.6-15.2 5.1 2.5 7.6 3.2 9.7c8.7 26.1 33.2 43.8 60.7 43.8H536c57.4 0 104-46.6 104-104s-46.6-104-104-104H402L438.4 80H600h8V64h-8H432z'
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fast',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      'M5.5 340.7L147.4 32H165L25.3 336H304V136v-8h16v8V336h56 8v16h-8H320V472v8H304v-8V352H12.8 .3l5.2-11.3z'
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fast',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      'M200 0H185.1l8.3 12.4 10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C208 53.8 197.8 64 185.3 64H108c-33.1 0-60 26.9-60 60c0 13.5 4.5 26 12 36H56v.5C24.4 164.4 0 191.4 0 224v56 8H8 376h8v-8V224c0-32.6-24.4-59.6-56-63.5V160h-8-1.8c11.1-12.5 17.8-29 17.8-47C336 50.6 285.4 0 223 0H200zm93.6 160H232h-8v16h8 33.1 30.6H320c26.5 0 48 21.5 48 48v48H16V224c0-26.5 21.5-48 48-48H80.3 104h3.9H112V160h-8H82.7C71.4 152 64 138.9 64 124c0-24.3 19.7-44 44-44h77.3C206.7 80 224 62.7 224 41.3c0-7.6-2.3-15.1-6.5-21.5L214.9 16H223c53.6 0 97 43.4 97 97c0 19.9-10.6 37.3-26.4 47zM64 328v-8H48v8 48 8h8H88.9l15.1 121 .9 7H112 272h7.1l.9-7 15.1-121H328h8v-8V328v-8H320v8 40H288h-7.1l-.9 7L264.9 496H119.1L103.9 375l-.9-7H96 64V328z'
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fast',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      'M8-.2H-.2V8 152v8.2H16.2V152 16.2H152h8.2V-.2H152 8zm496 0H360h-8.2V16.2H360 495.8V152v8.2h16.3V152 8-.2H504zM-.2 512.2H8 152h8.2V495.8H152 16.2V360v-8.2H-.2V360 504v8.2zM504 512h8v-8V360v-8H496v8V496H360h-8v16h8H504zM224 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-96c-20.7 0-38.8-11.2-48.5-28l-13.8 8c12.4 21.5 35.7 36 62.4 36s49.9-14.5 62.4-36l-13.8-8c-9.7 16.8-27.8 28-48.5 28z'
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fast',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      'M80 96A32 32 0 1 0 16 96a32 32 0 1 0 64 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM240 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fast',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      'M220 28h72V64c0 19.9-16.1 36-36 36s-36-16.1-36-36V28zM204 12V28 64c0 28.7 23.3 52 52 52s52-23.3 52-52V28 12H292 220 204zm68 436v16H240V448c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0v16 16h16 32 16V464 448c0-17.7-14.3-32-32-32s-32 14.3-32 32zM448 272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v32H448zm16 16h16V272 240 224l-16 0H448c-17.7 0-32 14.3-32 32s14.3 32 32 32h16zM64 280H40l0-48H64c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0-64H40 24v16 48 16H40 64c22.1 0 40-17.9 40-40s-17.9-40-40-40zm384.3-95.8L420 148.5c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6l28.3-28.3 56.6 56.6zM403.1 52.4L391.8 41 380.5 52.4 352.2 80.6c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l28.3-28.3L471 120.2l-11.3-11.3L403.1 52.4zM131.5 403.1l-11.3 11.3L97.6 391.8l11.3-11.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM97.6 369.1L86.3 380.5 75 391.8l11.3 11.3 22.6 22.6L120.2 437l11.3-11.3 11.3-11.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0zm282.8 33.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l11.3 11.3-22.6 22.6-11.3-11.3zm0 22.6L391.8 437l11.3-11.3 22.6-22.6L437 391.8l-11.3-11.3-11.3-11.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l11.3 11.3zM97.6 142.9L75 120.2 120.2 75l22.6 22.6c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zm56.6-56.6L131.5 63.7 120.2 52.4 108.9 63.7 63.7 108.9 52.4 120.2l11.3 11.3 22.6 22.6c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9z'
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fast',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M0 32v8V472v8H16v-8V65.1L217.5 348.6l6.5 9.2 6.5-9.2L432 65.1V464v8h16v-8V40 32H435.9l-2.4 3.4L224 330.2 14.5 35.4 12.1 32H0z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fast',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      'M560 16V400H344.2h-.3H232.1h-.3H16V16H560zM16 416H222.6l-13.3 80H136h-8v16h8 80H360h80 8V496h-8H366.8l-13.3-80H560h16V400 16 0H560 16 0V16 400v16H16zm209.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V272H80V80zM64 64V80 272v16H80 496h16V272 80 64H496 80 64z'
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fast',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      'M248 504l8 8 8-8 3.3-3.3L499.1 268.9l1.6-1.6L512 256l-6.3-6.3-5-5L267.3 11.3 264 8l-8-8-8 8-3.3 3.3L11.3 244.7l-5 5L0 256l11.3 11.3 1.6 1.6L244.7 500.7 248 504zm0-22.6L47.4 280.7l200.6 69V481.4zM23.1 255.5L248 30.6V332.8L23.1 255.5zM264 30.6L488.9 255.5 264 332.8V30.6zm0 319.1l200.6-69L264 481.4V349.7z'
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fast',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      'M8 32H0v8V472v8H16v-8V48h84.7l53.7 53.7 1 1c-38.2 44-36.4 110.7 5.5 152.5l18.3 18.3-16.8 16.8-5.7 5.7L168 307.3l5.7-5.7 192-192 5.7-5.7L360 92.7l-5.7 5.7-16.8 16.8L319.2 96.8C277.4 55 210.7 53.1 166.7 91.3l-1-1-56-56L107.3 32H104 8zm318.2 94.5L190.5 262.2l-18.3-18.3c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0l18.3 18.3zM416 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fast',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm80-48H96 416h16v16 64 16H416 96 80V288 224 208zm16 16v64H416V224H96z'
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fast',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-22.2-11.3-41.7-28.4-53.2l83.6-167.2 3.6-7.2-14.3-7.2-3.6 7.2L277.2 291.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.7-64 64s28.7 64 64 64z'
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fast',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      'M160 475.3l5.7-5.7 104-104 5.7-5.7L264 348.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L61.7 354.3 56 348.7 44.7 360l5.7 5.7 104 104 5.7 5.7zM336 320H320v16V464v16h16H464h16V464 336 320H464 336zm128 16V464H336V336H464zM320 32V48 240v16h16H528h16V240 48 32H528 336 320zM528 240H336V48H528V240z'
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fast',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM96 384h8H248h8v16h-8H104 96V384zm8-96H344h8v16h-8H104 96V288h8z'
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fast',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      'M328.7 127.5c31.6-3.9 56-30.9 56-63.5L536 64c4.4 0 8-3.6 8-8s-3.6-8-8-8L382.6 48c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48L104 48c-4.4 0-8 3.6-8 8s3.6 8 8 8l152.7 0c0 32.6 24.4 59.6 56 63.5V496H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H320.7h216c4.4 0 8-3.6 8-8s-3.6-8-8-8h-208V127.5zm40-63.5a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM119.3 112.9L.1 302.6l-.2 40L73.4 416H182.5l73.4-73.4v-40L138.1 112.9l-9.4-15.1-9.5 15.1zM237.9 304H18.1L128.7 128 237.9 304zm2 16v16l-64 64H80L16 336l.1-16H239.9zM503.3 112.9L384.1 302.6l-.2 40L457.4 416H566.5l73.4-73.4v-40L522.1 112.9l-9.4-15.1-9.5 15.1zM621.9 304H402.1L512.7 128 621.9 304zm2 16v16l-64 64H464l-64-64 .1-16H623.9z'
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fast',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      'M80 80A32 32 0 1 0 16 80a32 32 0 1 0 64 0zM56 127.3V384.7C76.1 388 92 403.9 95.3 424H352.7c1.8-10.9 7.3-20.5 15.2-27.6l-61.2-96.1c-5.7 2.4-12 3.8-18.7 3.8c-26.5 0-48-21.5-48-48s21.5-48 48-48c6.6 0 12.9 1.3 18.7 3.8l61.2-96.1c-7.9-7.1-13.3-16.7-15.2-27.6H95.3C92 108.1 76.1 124 56 127.3zM381.3 387.8c5.7-2.4 12-3.8 18.7-3.8c26.5 0 48 21.5 48 48s-21.5 48-48 48c-23.8 0-43.5-17.3-47.3-40H95.3c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V127.3C17.3 123.5 0 103.8 0 80C0 53.5 21.5 32 48 32c23.8 0 43.5 17.3 47.3 40H352.7c3.8-22.7 23.6-40 47.3-40c26.5 0 48 21.5 48 48s-21.5 48-48 48c-6.6 0-12.9-1.3-18.7-3.8l-61.2 96.1c9.7 8.8 15.8 21.5 15.8 35.6s-6.1 26.9-15.8 35.6l61.2 96.1zM432 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM48 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm384-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fast',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      'M448 400V232v-8h-8.3c-4.1-53.7-49-96-103.7-96c-57.4 0-104 46.6-104 104s46.6 104 104 104c43.2 0 80.3-26.4 96-63.9V401.9c0 5.4 .4 10.8 1.1 16.1c-43.9 47.9-107 78-177.1 78C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 54-17.9 103.9-48 144zm2.1 22.9C488.7 378.1 512 319.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c70.8 0 134.9-28.7 181.2-75.2c8.3 27.4 26.3 51.3 51.2 66.8l11.4 7.1 8.5-13.6-11.4-7.1c-24.4-15.2-41.1-39.7-46.7-67.2zM160.4 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM336 144a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM160 352v16h8c15.2 0 39.8 3.1 63.5 12.3c23.8 9.2 45.8 24.2 57.3 47.3l3.6 7.2 14.3-7.2-3.6-7.2c-14-28.1-40.1-45.1-65.9-55.1c-25.8-10-52.4-13.3-69.3-13.3h-8zM300.2 99.7c9.4-7.5 21.2-11.7 33.2-11.7c10.5 0 20.8 3.1 29.5 8.9l8.6 5.7 6.7 4.4 8.9-13.3-6.7-4.4-8.6-5.7C360.5 76 347.1 72 333.5 72c-15.7 0-31 5.3-43.2 15.2L267 105.8l-6.2 5 10 12.5 6.2-5 23.2-18.6z'
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fast',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      'M448 480C448 232.6 247.4 32 0 32V48c238.6 0 432 193.4 432 432h16zM0 192c159.1 0 288 128.9 288 288h16C304 312.1 167.9 176 0 176v16zM16 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fast',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      'M368 416h8H568h8v-8V216v-8H560v8V388.7L325.7 154.3l-5.7-5.7-5.7 5.7L192 276.7 13.7 98.3 2.3 109.7l184 184 5.7 5.7 5.7-5.7L320 171.3 548.7 400H376h-8v16z'
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fast',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      'M93.8 98.4l-61.1 126L56.9 362.5l100.3 97.4 138 19.5 123.1-65.8 61.1-126-3.2-18.3c-59-11.6-105.1-59.2-114.4-119C302 141 254.5 95.1 242.8 36.2l-25.9-3.7L93.8 98.4zM213.9 16l42.8 6.1c6.7 61.5 57.1 110 119.5 113.7c3.7 62.4 52.2 112.7 113.7 119.5l6.1 34.7L430.3 425.3 298.1 496 149.8 475 42 370.4 16 222.1 81.7 86.7 213.9 16zM164.7 363.3l-16-16L137.4 336l11.3-11.3 16-16L176 297.4l11.3 11.3 16 16L214.6 336l-11.3 11.3-16 16L176 374.6l-11.3-11.3zm16-16l6.6-6.6L192 336l-4.7-4.7-6.6-6.6L176 320l-4.7 4.7-6.6 6.6L160 336l4.7 4.7 6.6 6.6L176 352l4.7-4.7zM208 214.6l-11.3-11.3-16-16L169.4 176l11.3-11.3 16-16L208 137.4l11.3 11.3 16 16L246.6 176l-11.3 11.3-16 16L208 214.6zm11.3-33.9L224 176l-4.7-4.7-6.6-6.6L208 160l-4.7 4.7-6.6 6.6L192 176l4.7 4.7 6.6 6.6L208 192l4.7-4.7 6.6-6.6zM356.7 331.3l-16-16L329.4 304l11.3-11.3 16-16L368 265.4l11.3 11.3 16 16L406.6 304l-11.3 11.3-16 16L368 342.6l-11.3-11.3zm16-16l6.6-6.6L384 304l-4.7-4.7-6.6-6.6L368 288l-4.7 4.7-6.6 6.6L352 304l4.7 4.7 6.6 6.6L368 320l4.7-4.7z'
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fast',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM47.3 176H208.7l6.7 160H192 144 112 64 40.7l6.7-160zM120 352h16V504v8h8 48 8v-8V352h16 16l-.7-16L224 160H32L24.7 336 24 352H40 56V504v8h8 48 8v-8V352zm64 144H152V352h32V496zM104 352V496H72V352h32zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-51.9 48H435.9l54.9 192H448 400 368 320 277.2l54.9-192zM376 384h16V504v8h8 48 8v-8V384h39.4H512l-4.6-16L448 160H320L260.6 368 256 384h16.6H312V504v8h8 48 8v-8V384zm64 112H408V384h32V496zM360 384V496H328V384h32z'
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fast',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm71.4-108.7l11.9-10.7-5.4-5.9C318.9 370 292.9 352 256 352s-62.9 18-77.9 34.6l-5.4 5.9 11.9 10.7 5.4-5.9C202.7 383.1 224.7 368 256 368s53.3 15.1 66.1 29.4l5.4 5.9zM176.4 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM130.5 168.4l-7.6-2.5-5.1 15.2 7.6 2.5 96 32 7.6 2.5 5.1-15.2-7.6-2.5-96-32zm256 15.2l7.6-2.5-5.1-15.2-7.6 2.5-96 32-7.6 2.5 5.1 15.2 7.6-2.5 96-32z'
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fast',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M80 0h8H200h8V16h-8H96V192h88 8v16h-8H96V472v8H88 8 0V464H8 80V208H8 0V192H8 80V8 0zM240 320c0 60.6 17.2 116.9 46.8 163.7l-13.5 8.5C242.1 442.9 224 383.6 224 320s18.1-122.9 49.2-172.3l13.5 8.5C257.2 203.1 240 259.4 240 320zm384 0c0-60.6-17.2-116.9-46.8-163.7l13.5-8.5C621.9 197.1 640 256.4 640 320s-18.1 122.9-49.2 172.3l-13.5-8.5C606.8 436.9 624 380.6 624 320zM365.7 242.3L432 308.7l66.3-66.3 5.7-5.7L515.3 248l-5.7 5.7L443.3 320l66.3 66.3 5.7 5.7L504 403.3l-5.7-5.7L432 331.3l-66.3 66.3-5.7 5.7L348.7 392l5.7-5.7L420.7 320l-66.3-66.3-5.7-5.7L360 236.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fast',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M432 48V240l-208 0V48H432zm0 208V464H224V256l208 0zM208 240H16V48H208V240zM16 256H208V464H16V256zM16 32H0V48 464v16H16 432h16V464 48 32H432 16z'
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fast',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200h-8v16h8 80V496H88V291.3l58.3 58.3 11.3-11.3-72-72L80 260.7l-5.6 5.6 0 0-72 72 11.3 11.3L72 291.3V504v8h8H288 496h8v-8V291.3l58.3 58.3 11.3-11.3-72-72c0 0 0 0 0 0l-5.6-5.6-5.7 5.7-72 72 11.3 11.3L488 291.3V496H296V224h80 8V208h-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fast',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      'M16.5 240H240V16.5C120.2 24.4 24.4 120.2 16.5 240zm-16 0C8.4 111.4 111.4 8.4 240 .5c5.3-.3 10.6-.5 16-.5V16 240v16H240 16 0c0-5.4 .2-10.7 .5-16z'
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fast',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      'M392 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H8 0V496H8 32V416H8 0v-8V8 0H8 392zM48 416v80H392c22.1 0 40-17.9 40-40s-17.9-40-40-40H48zm344-16c15.7 0 29.8 6.4 40 16.8V56c0-22.1-17.9-40-40-40H16V400H392zM240 96c-66.3 0-120 53.7-120 120s53.7 120 120 120c15.8 0 30.8-3 44.6-8.6C228.1 321.7 184 274 184 216s44.1-105.7 100.6-111.4C270.8 99 255.8 96 240 96zM104 216c0-75.1 60.9-136 136-136c31 0 59.7 10.4 82.6 27.9L316 122.1c-6.5-1.4-13.2-2.1-20-2.1c-53 0-96 43-96 96s43 96 96 96c6.9 0 13.6-.7 20-2.1l6.5 14.2C299.7 341.6 271 352 240 352c-75.1 0-136-60.9-136-136zm199.4-59.1L316.3 188l33.6 2.7 19.2 1.5-14.6 12.5-25.6 21.9 7.8 32.8 4.5 18.7-16.4-10L296 250.6l-28.7 17.6-16.4 10 4.5-18.7 7.8-32.8-25.6-21.9-14.6-12.5 19.2-1.5 33.6-2.7 12.9-31.1 7.4-17.8 7.4 17.8zm-14.8 41.8l-1.9 4.5-4.9 .4-19.3 1.5 14.7 12.6 3.7 3.2-1.1 4.8-4.5 18.8 16.5-10.1 4.2-2.5 4.2 2.5 16.5 10.1-4.5-18.8-1.1-4.8 3.7-3.2 14.7-12.6-19.3-1.5-4.9-.4-1.9-4.5L296 180.8l-7.4 17.9z'
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fast',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      'M0 448H16 400L576 256 400 64H16 0V80 432v16zM554.3 256L393 432H16V80H393L554.3 256zM153.8 174.5l-11.3 11.3 5.7 5.7L212.7 256l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L224 267.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L235.3 256l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L224 244.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fast',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H440v64 8H424v-8V376H360h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fast',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      'M16 45.6C16 74.1 21.1 102 30.6 128H336.2c-.1-1.8-.2-3.6-.2-5.4c0-21.3 8.5-41.7 23.5-56.7L400 25.4V16H16V45.6zM37.1 144c20.1 44.6 53.6 82.8 97.2 108.4L194.8 288H428.3c-3.9-15.5-10.9-30.2-20.6-43.1L352 170.7c-6-8.1-10.5-17.1-13.1-26.7H37.1zM431.2 304H222l28.8 16.9c21.8 12.8 39.5 31.7 50.8 54.4c12.4 24.8 16.6 52.9 12.1 80.2l-3 17.8 75.7-60.6c28.8-23.1 45.6-58 45.6-95c0-4.7-.3-9.3-.8-13.9zM0 45.6V16 0H16 400h16V16 32L370.8 77.2c-12 12-18.8 28.4-18.8 45.4c0 13.9 4.5 27.4 12.8 38.5l55.6 74.2c17.9 23.8 27.5 52.8 27.5 82.6c0 41.8-19 81.3-51.6 107.4L306.7 497 288 512l3.9-23.6 5.9-35.4c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6z'
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fast',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      'M192 35.6v7.1c0 18 7.6 35.2 20.9 47.4l82.2 74.7C341.5 207 368 266.8 368 329.5C368 421.5 293.5 496 201.5 496H179.8C89.3 496 16 422.7 16 332.2c0-52.3 26.1-101.1 69.6-130L104 189.9V288c0 30.9 25.1 56 56 56s56-25.1 56-56V272.7c0-14.1-4.2-27.8-12-39.5l-33.3-49.9c-12.2-18.3-18.8-39.9-18.8-62c0-31.9 13.6-62.3 37.5-83.5l2.5-2.2zm0-21.4L178.9 25.9c-27.3 24.2-42.9 59-42.9 95.4c0 25.2 7.5 49.9 21.4 70.8l33.3 49.9c6.1 9.1 9.3 19.7 9.3 30.7V288c0 22.1-17.9 40-40 40s-40-17.9-40-40V179.2 160l-16 10.7L76.7 188.9C28.8 220.8 0 274.6 0 332.2C0 431.5 80.5 512 179.8 512h21.8C302.3 512 384 430.3 384 329.5c0-67.2-28.4-131.3-78.1-176.5L223.7 78.3c-10-9.1-15.7-22-15.7-35.5V21.4 0L192 14.2z'
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fast',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      'M336 32h8H488h8v8 8 3.1l-2.1 2.3L354.8 208H488h8v16h-8H344h-8v-8-8-3.1l2.1-2.3L477.2 48H344h-8V32zM160 36.7l5.7 5.7 112 112 5.7 5.7L272 171.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L53.7 165.7 48 171.3 36.7 160l5.7-5.7 112-112 5.7-5.7zM408.7 292.6l2.1-4.6h10.2l2.2 4.6L510.1 480H492.5l-22.3-48H361.8l-22.3 48H321.9l86.9-187.4zM416 315L369.2 416h93.6L416 315z'
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fast',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      'M208 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zm0 88A52 52 0 1 0 208 0a52 52 0 1 0 0 104zm19.4 166.3l4.8 9.5 9.5 4.8 33.7 16.8 14.3 7.2 7.2-14.3 14.3-28.6 7.2-14.3L304 244.2l-24.1-12.1-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-5.1 15.2L7.5 260.2l15.2 5.1 30.4 10.1 15.2 5.1 5.1-15.2 5.1-15.2 11.5-34.6 17.9-7.9 18.8-8.3-5.3 19.9-11.7 43.7c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 4.2 15.4 4.2 15.4 15.4-4.2 30.9-8.4 15.4-4.2L283.1 479l-4.2-15.4-24-88-2-7.5-5.2-5.7-52.3-57 11.7-39.9 6.6-22.5 10.5 21 3.2 6.4zm8.4 102.9l2.6 2.9 1 3.7 24 88 4.2 15.4-30.9 8.4-4.2-15.4-22-80.5-1-3.7-2.6-2.9-70.9-77.4c-11.1-12.1-15.2-29-11-44.8l17-63.6 8.6-32.3-30.6 13.6L83.4 200.9l-6.4 2.9-2.2 6.7L63.2 245.1l-5.1 15.2L27.8 250.1l5.1-15.2 16-48 2.2-6.7 6.4-2.9 72-32 4.6-2.1 5 1 80 16 7.7 1.5 3.5 7 35.2 70.5 2.4 4.8 4.8 2.4 24.1 12.1-14.3 28.6-33.7-16.8-4.8-2.4-2.4-4.8L228 235.8l-18.2-36.4-11.5 39L180 300.8l-2.5 8.7 6.1 6.7 52.3 57zM68.7 398L25.4 441.4 14.1 452.7 2.7 464l11.3 11.3 22.6 22.6L48 509.3l11.3-11.3 11.3-11.3 48-48 4.6-4.6 2.4-6.1 15.7-39.3-12-13.1-18.6 46.4-1.2 3-2.3 2.3-48 48L48 486.6 25.4 464l11.3-11.3L80 409.3l2.3-2.3 1.2-3 21.8-54.6-4.8-5.2c-2.5-2.7-4.8-5.6-7-8.6L68.7 398zm382.2 40.1l6.1 5.1L467.3 431l-6.1-5.1-79-65.9L632 360h8v-8V72 64h-8L328 64l-8 0V80l8 0 296 0V344l-241.9 0 79-65.9 6.1-5.1L457 260.7l-6.1 5.1-96 80-7.4 6.1 7.4 6.1 96 80z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fast',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M16 496H336V384h16V496v16H336 16 0V496 176 160H16 128v16H16V496zM160 352V336 16 0h16H496h16V16 336v16H496 176 160zm16-16H496V16H176V336z'
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fast',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zm564 239.7c50-50 50-131 0-181s-131-50-181 0l-17 17L393.5 92l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-71.2 71.2 12.6 10 69.9-69.9zM398.7 409.9L383.6 398c-37.5 10.3-79.4 .7-108.9-28.8c-22.8-22.8-33.7-53.1-32.7-83l-15.1-11.9c-4.6 37.8 7.5 77.2 36.5 106.2c36.6 36.6 89.8 46.4 135.3 29.4zM376.6 131.5C340 95 286.8 85.2 241.3 102.1L256.4 114c37.5-10.3 79.4-.7 108.9 28.8c22.8 22.8 33.7 53.1 32.7 83l15.1 11.9c4.6-37.8-7.5-77.2-36.5-106.2zM142.3 207.4l-12.6-10L59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17L246.5 420l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l71.2-71.2z'
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fast',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM444 444V420H420v24h24zm-4-164H424v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fast',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      'M148.8 320h2.8H376h8v8 56 8h-8H256v24H394.8l120.9-83.1 6.6-4.5 4.5 6.6 36.3 52.7 4.5 6.6-6.6 4.5L398.5 510.6l-2 1.4h-2.5H8 0V496H8 391.5L545.4 390.2l-27.2-39.6-116.3 80-2 1.4h-2.5H248h-8v-8V384v-8h8H368V336H154.4L76.6 398.2 74.4 400H71.6 8 0V384H8 68.8l77.8-62.2 2.2-1.8z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fast',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      'M256 16C123.5 16 16 123.5 16 256c0 100.3 61.5 186.2 148.8 222.1c2.4 7.3 5.7 14.3 9.7 20.7C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8c4-6.4 7.3-13.4 9.7-20.7C434.5 442.2 496 356.3 496 256C496 123.5 388.5 16 256 16zm96 385.1V380.7c16.6-14.2 30.1-32 39.2-52.2c-40.9 12.4-86.7 19.3-135 19.3s-94.1-6.9-135-19.3c9 20 22.3 37.6 38.7 51.7v20.4c-26.7-19.5-47.3-46.8-58.5-78.7c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3s99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2C399.8 354 379 381.6 352 401.1zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM118.6 227.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9zM336 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 368h48 3.3l2.3 2.3L256 380.7l10.3-10.3 2.3-2.3H272h48 8v8 64c0 39.8-32.2 72-72 72s-72-32.2-72-72V376v-8h8zm44.7 16H200v56c0 30.9 25.1 56 56 56s56-25.1 56-56V384H275.3L264 395.3V424v8H248v-8V395.3L236.7 384z'
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fast',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm8-352H248v8 80H168h-8v16h8 80v80 8h16v-8V264h80 8V248h-8H264V168v-8z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fast',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      'M327.2 145.7l-3.4-1.7H320 272V45.6L446.7 16.4 624 75.5v88L449.9 207 327.2 145.7zM256 160h16 48l128 64 192-48V64L448 0 256 32V144v16zM199.2 366.3L321.9 305 496 348.5v88L318.7 495.6 144 466.4V368h48 3.8l3.4-1.7zM128 352v16V480l192 32 192-64V336L320 288 192 352H144 128zM0 352v8V472v8H8 96V464H16V368H96V352H8 0zM136 160h88V144H144V48h80V32H136h-8v8V152v8h8z'
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fast',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      'M272 0h24H424h16 88 3.7L534 2.8l104 120 2 2.3v3 64 8h-8H536h-3.3l-2.3-2.3L500.7 168H480v48L614.4 316.8l22.4 16.8L640 336v4 28 80 56 8h-8H576 528 456 40 8 0v-8V440v-8H8 37.8l400.9-43.7-78.2-99.5-4.4-5.6-.9-.7L352 280v-4V248 137.6l-59.2-26.3-12.5-5.5 10.9-8.2L346.7 56 291.2 14.4 272 0zm48 16l44.8 33.6 8.5 6.4-8.5 6.4-53.1 39.8 51.5 22.9 4.8 2.1v5.2V248v24.3l.1 .1 5.1 6.4 81.2 103.3 1.7 2.2v2.8 8.2 7.2l-7.1 .8L39.1 448l-.4 0h-.4H16v48H40 456h72 48 48V448 368 344l-19.2-14.4L467.2 226.4 464 224v-4V160v-8h8 32 3.3l2.3 2.3L539.3 184H624V131L524.3 16H440 424 320zm0 177.1l0 19.2L161.1 106.4 43 230l148.2-14 22.1-2.1-15.7 15.7L123.3 304H332.3c1.9 5.4 4.1 10.8 6.5 16H104 84.7l13.7-13.7 72.3-72.3L23.2 248 1.8 250l14.8-15.5 137.6-144 4.6-4.9 5.6 3.7L320 193.1zM491.6 64.8l32 16 7.2 3.6-7.2 14.3-7.2-3.6-32-16-7.2-3.6 7.2-14.3 7.2 3.6z'
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fast',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      'M320 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fast',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      'M0 480H448V464H0v16zM16 368H48V336H16v32zm416 0V336H400v32h32zm-224 0h32V336H208v32zM48 176V144H16v32H48zm352 0h32V144H400v32zm-160 0V144H208v32h32zM16 272H48V240H16v32zm416 0V240H400v32h32zm-224 0h32V240H208v32zM48 80V48H16V80H48zm352 0h32V48H400V80zM240 80V48H208V80h32zM112 272h32V240H112v32zM144 80V48H112V80h32zm160 0h32V48H304V80zm32 192V240H304v32h32z'
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fast',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM576 256c0-62.8-30.2-118.6-76.8-153.6l-9.6 12.8C532.4 147.3 560 198.4 560 256c0 29.5-7.3 57.4-20.1 81.8l12.8 10.1C567.5 320.6 576 289.3 576 256zM352 48V32H336 304L232.7 95.4l12.8 10.1L310.1 48H336V176.9l16 12.6V48zM48 176h54.5L82.2 160H48 32v16V336v16H48 160L304 480h32 16V464 373l-16-12.6V464H310.1L170.6 340l-4.5-4H160 48V176zm416 80c0 6.9-.9 13.6-2.5 20L475 286.6c3.2-9.6 5-19.9 5-30.6c0-31.4-15.1-59.3-38.4-76.8L432 192c19.4 14.6 32 37.8 32 64z'
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fast',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      'M368 16V496H16V134.6L134.6 16H368zM128 0L0 128V496v16H16 368h16V496 16 0H368 128zm48 72V64H160v8 80 8h16v-8V72zm64 0V64H224v8 80 8h16v-8V72zm64 0V64H288v8 80 8h16v-8V72z'
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fast',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      'M256 0c-43 0-82.8 25.6-111.2 49.9c-14.3 12.3-26.1 24.6-34.3 33.8c-4.1 4.6-7.3 8.4-9.5 11.2c-.3 .4-.6 .8-.9 1.2H16 0v16V256v8 8V496v16H16 496h16V496 272v-8-8V112 96H496 411.9c-.3-.4-.6-.7-.9-1.2c-2.2-2.7-5.4-6.6-9.5-11.2c-8.2-9.2-19.9-21.5-34.3-33.8C338.8 25.6 299 0 256 0zM407.9 112c.1 0 .1 0 .2 0H496V256H16V112H407.9zM391 96H121c.5-.5 1-1.1 1.5-1.7c7.8-8.8 19.1-20.5 32.7-32.2C182.8 38.4 219 16 256 16s73.2 22.4 100.8 46.1c13.7 11.7 24.9 23.4 32.7 32.2c.5 .6 1 1.1 1.5 1.7zM496 496H16V272H496V496zM88 320v24h24V320H88zm0 104v24h24V424H88zm88-104H152v24h24V320zM152 424v24h24V424H152zm-8-52H120v24h24V372zm72-52v24h24V320H216zm24 104H216v24h24V424zm-56-52v24h24V372H184zm120-52H280v24h24V320zM280 424v24h24V424H280zm-8-52H248v24h24V372zm72-52v24h24V320H344zm88 0H408v24h24V320zM344 424v24h24V424H344zm88 0H408v24h24V424zM312 372v24h24V372H312zm88 0H376v24h24V372zM80 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fast',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      'M11.3 .7L4.8 15.3l144 64 7.3 3.2 6.5-14.6-7.3-3.2L11.3 .7zM162.6 188.1l-6.5-14.6-7.3 3.2-144 64 6.5 14.6 144-64 7.3-3.2zM237.4 176H402.6l58.2 320L368 496V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v64l-92.8 0 58.2-320zM477.1 496L418.9 176H424h8V160h-8-8H224h-8-8v16h8 5.1L162.9 496 144 496h-8v16h8l16 0h16.3l95.7 0h16 64 16l95.7 0H480l16 0h8V496h-8l-18.9 0zM352 496H288V432c0-17.7 14.3-32 32-32s32 14.3 32 32v64zM484.8 64.7l-7.3 3.2 6.5 14.6 7.3-3.2 144-64L628.8 .7l-144 64zm0 126.6l144 64 6.5-14.6-144-64-7.3-3.2-6.5 14.6 7.3 3.2zM324.2 3.6L320 1l-4.2 2.6-112 69.6L197 77.4 205.4 91l6.8-4.2L224 79.5V128h16V69.5l80-49.7 80 49.7V128h16V79.5l11.8 7.3 6.8 4.2L443 77.4l-6.8-4.2L324.2 3.6z'
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fast',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      'M325.6 133.6L296.3 29.5 288 0l-8.3 29.5L250.4 133.6l-4.6 16.2-14-9.5L141.4 79.1 115.7 61.8l13 28.1 45.4 98 7.1 15.4-16.9 1.6-109 10.3-31.3 3 28.5 13.4 98.7 46.3 15.4 7.2-12 12L78 373.8 55.8 395.9l30.3-7.7 106.2-27.1 16.4-4.2-1.4 16.9-8.6 107.5L196.3 512l18-24.9L278.1 399l9.9-13.6 9.9 13.6 63.8 88.1 18 24.9-2.5-30.7-8.6-107.5L367.3 357l16.4 4.2 106.2 27.1 30.3 7.7L498 373.8l-76.6-76.7-12-12 15.4-7.2 98.7-46.3L552 218.1l-31.3-3-109-10.3-16.9-1.6 7.1-15.4 45.4-98 13-28.1L434.6 79.1l-90.5 61.3-14 9.5-4.6-16.2zm96-26.3l-41.3 89.2L370.8 217l22.5 2.1 98.9 9.4-89.5 42L382 280.2l16.1 16.1 69.6 69.7-96.5-24.6-21.7-5.5 1.8 22.3 7.9 98.1L301 376l-13-17.9L275 376l-58.2 80.4 7.9-98.1 1.8-22.3-21.7 5.5-96.5 24.6 69.6-69.7L194 280.2l-20.6-9.7-89.5-42 98.9-9.4 22.5-2.1-9.5-20.5-41.3-89.2 82.5 55.8 18.4 12.4 6-21.3L288 59.1l26.8 95.1 6 21.3 18.4-12.4 82.5-55.8z'
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fast',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      'M336 128a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM75.8 320H136v48.7c-22.7 3.8-40 23.6-40 47.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V320H296v48.7c-22.7 3.8-40 23.6-40 47.3v40 8h8 16 8V448h-8-8V416c0-17.7 14.3-32 32-32s32 14.3 32 32v32h-8-8v16h8 16 8v-8V416c0-23.8-17.3-43.5-40-47.3V320h60.2l54.2 176H21.7L75.8 320zM176 416a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zm240-80h16V208 16 0H624 400 384V16 208v16h16 32 16v16 36 4 16l12.8-9.6L464 284l80-60h80zm-89.6-12.8L464 264V224 208H448 400V16H624V208H544h-5.3l-4.3 3.2z'
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fast',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M0 32H8 520h8v8V368H632h8v16h-8H528 512 320h-8V368h8H512V48H16V368H64h8v16H64 8 0v-8V40 32zM80 96v8V248v8H64v-8V104 96H80zm96 0v8V248v8H160v-8V104 96h16zm96 0v8V248v8H256v-8V104 96h16zm96 0v8V312v8H352v-8V104 96h16zm96 0v8V312v8H448v-8V104 96h16zM272 384a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 384a96 96 0 1 1 192 0A96 96 0 1 1 96 384z'
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fast',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      'M17.5 176H216V48H74.4L17.5 176zm413 0L373.6 48H232V176H430.5zM16 192V464H432V192H16zM64 32H384l64 144V464v16H432 16 0V464 176L64 32zm77.7 226.2c-17.4 17.4-17 45.9 1 62.7L224 397l81.3-76.1c18-16.9 18.5-45.3 1-62.7c-17.1-17.1-44.7-17.1-61.8 0l-14.9 14.9-5.7 5.7-5.7-5.7-14.9-14.9c-17.1-17.1-44.7-17.1-61.8 0zm73.1-11.3l9.2 9.2 9.2-9.2c23.3-23.3 61.1-23.3 84.4 0c23.8 23.8 23.2 62.7-1.4 85.7l-86.7 81.2L224 419l-5.5-5.1-86.7-81.2c-24.6-23-25.3-61.9-1.4-85.7c23.3-23.3 61.1-23.3 84.4 0z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fast',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8z'
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fast',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      'M8 0H64V16H16V504v8H0v-8V8 0H8zM432 16V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H432zm64 419.8c-8.5 7.6-19.7 12.2-32 12.2c-16.7 0-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5s-31.4-8.5-40-21.5c-8.6 12.9-23.3 21.5-40 21.5c-26.5 0-48-21.5-48-48V16 0h16 64 16 64 16 64 16 64 16 64 8 8V8v8V400 504v8H496v-8V435.8zM112 16V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H112zm80 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H192zm80 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H272zm80 0V400c0 17.7 14.3 32 32 32s32-14.3 32-32V16H352z'
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fast',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      'M514.3 11.8c-9.5-4.3-19.7-7.6-30.2-9.6C476.2 .7 468 0 459.7 0C398.1 0 346.3 42.3 332 99.5c5.2 1.4 10.3 3.1 15.2 5.1C359.2 54.5 403.9 17 457.5 16c-29.7 20.7-49.1 55.2-49.1 94.2c0 63.4 51.4 114.8 114.8 114.8c1.8 0 3.6 0 5.3-.1c-18 13.3-40 21.5-63.9 22.5c2.9 4.9 5.4 10.1 7.6 15.5c34-3.2 64.2-19.2 85.7-43.3c7-7.9 13.2-16.6 18.2-26c-8.3 5.3-17.5 9.3-27.2 12c-8.2 2.2-16.8 3.4-25.7 3.4c-54.6 0-98.8-44.2-98.8-98.8c0-41.2 25.2-76.5 61.1-91.3c9-3.7 18.7-6.2 28.9-7.1zM250.8 131.9C233.2 110 206.2 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v80 16H16 96 367.9l64 0h16l0-16 0-64c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4zm181 236l-64 0H96 16v-80c0-39.6 28.8-72.5 66.6-78.9l13.4-2.3L96 193.2l0-1.3c0-44.1 35.8-79.9 80-79.9c29 0 54.5 15.5 68.5 38.7l8.8 14.6 14-9.8c10.4-7.3 23-11.5 36.6-11.5c35.3 0 64 28.6 64 64c0 4.8-.5 9.4-1.5 13.8L362.8 238l16.4 2.9c29.9 5.3 52.6 31.5 52.6 63v64zM72 416L8 512H32l64-96H72zm96 0l-64 96h24l64-96H168zm120 0H264l-64 96h24l64-96zm72 0l-64 96h24l64-96H360z'
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fast',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      'M192 352H176V336 176 160h16 48 16V144 128L139.3 11.3 128 0 116.7 11.3 0 128v16 16H16 64 80v16V336v16H64 16 0v16 16L116.7 500.7 128 512l11.3-11.3L256 384V368 352H240 192zm48 16v9.4l-112 112L16 377.4V368H80 96V352 160 144H80 16v-9.4l112-112 112 112V144H176 160v16V352v16h16 64z'
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fast',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      'M384 48l36.7-36.7L432 0l11.3 11.3 57.4 57.4L512 80 500.7 91.3 464 128l4.7 4.7L480 144l-11.3 11.3L192 432 44.8 478.5 11.3 512 0 500.7l33.5-33.5L80 320 294.3 105.7 248 59.3 125.7 181.7l-5.7 5.7L108.7 176l5.7-5.7 128-128 5.7-5.7 5.7 5.7 52 52 51-51L368 32l11.3 11.3L384 48zm11.3 11.3l57.4 57.4L489.4 80 432 22.6 395.3 59.3zM194.3 407l263-263L368 54.6l-263 263L194.3 407zm-11.5 11.1L93.9 329.2l-41 130 130-41z'
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fast',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      'M208 48C119.6 48 48 119.6 48 208v56 8H32v-8V208c0-97.2 78.8-176 176-176s176 78.8 176 176v56 8H368v-8V208c0-88.4-71.6-160-160-160zm208 80h8 64c48.6 0 88 39.4 88 88v64 8h-8H488v88 8h-8H336v88 8h-8H248h-8v-8V384H176v88 8h-8H88 80v-8V384H8 0v-8V312v-8H8 416V136v-8zM240 368h16v16 32 48h64V416 384 368h16H472V280v-8h8 80V216c0-39.8-32.2-72-72-72H432V312v8h-8H320 256 160 96 16v48H80 96v16 32 48h64V416 384 368h16 64zM496 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fast',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      'M16 48V400H97.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H288 560V192c0-79.5-64.5-144-144-144H16zM96 416H16 0V400 48 32H16 416c88.4 0 160 71.6 160 160V400l56 0h8v16h-8l-56 0H560 288c0 53-43 96-96 96s-96-43-96-96zM240 144H80v96H240V144zM80 128H240h16v16 96 16H240 80 64V240 144 128H80zm256 16v96h96V144H336zm-16-16h16 96 16v16 96 16H432 336 320V240 144 128zM272 416a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fast',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      'M396 52a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zm88 0A52 52 0 1 0 380 52a52 52 0 1 0 104 0zM448.2 263.9l3.2 6.4 4.8 9.5 9.5 4.8 33.7 16.8 14.3 7.2 7.2-14.3 14.3-28.6 7.2-14.3L528 244.2l-24.1-12.1-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-5.1 15.2-5.1 15.2 15.2 5.1 30.4 10.1 15.2 5.1 5.1-15.2 5.1-15.2 11.5-34.6 17.9-7.9 18.8-8.3-5.3 19.9-11.7 43.7c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 4.2 15.4 4.2 15.4 15.4-4.2 30.9-8.4 15.4-4.2L507.1 479l-4.2-15.4-24-88-2-7.5-5.2-5.7-52.3-57 11.7-39.9 6.6-22.5 10.5 21zM462.4 376l1 3.7 24 88 4.2 15.4-30.9 8.4-4.2-15.4-22-80.5-1-3.7-2.6-2.9-70.9-77.4c-11.1-12.1-15.2-29-11-44.8l17-63.6 8.6-32.3-30.6 13.6-36.7 16.3-6.4 2.9-2.2 6.7-11.5 34.6-5.1 15.2-30.4-10.1 5.1-15.2 16-48 2.2-6.7 6.4-2.9 72-32 4.6-2.1 5 1 80 16 7.7 1.5 3.5 7 35.2 70.5 2.4 4.8 4.8 2.4 24.1 12.1-14.3 28.6-33.7-16.8-4.8-2.4-2.4-4.8L452 235.8l-18.2-36.4-11.5 39L404 300.8l-2.5 8.7 6.1 6.7 52.3 57 2.6 2.9zM317.7 335.6l-25 62.4-43.4 43.4-11.3 11.3L226.7 464l11.3 11.3 22.6 22.6L272 509.3l11.3-11.3 11.3-11.3 48-48 4.6-4.6 2.4-6.1 15.7-39.3-12-13.1-18.6 46.4-1.2 3-2.3 2.3-48 48L272 486.6 249.4 464l11.3-11.3L304 409.3l2.3-2.3 1.2-3 21.8-54.6-4.8-5.2c-2.5-2.7-4.8-5.6-7-8.6zM209 351.5L129 490 45.9 442l80-138.6 83.1 48zm-75.1-61.9l-13.9-8-8 13.9L32 434l-8 13.9 13.9 8 83.1 48 13.9 8 8-13.9 40-69.3 0 0 77-133.4-13.9-8-29 50.2 0 0-83.1-48z'
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fast',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      'M304 16h40 8V0h-8H208h-8H184 136C78.6 0 32 46.6 32 104s46.6 104 104 104h56V312v8h16v-8l0-104v-8V24 16h80V312v8h16v-8V16zM192 24V192H136c-48.6 0-88-39.4-88-88s39.4-88 88-88h48 8v8zM109.4 341.9l5.9-5.4-10.8-11.8-5.9 5.4-88 80L4.1 416l6.5 5.9 88 80 5.9 5.4 10.8-11.8-5.9-5.4L36.7 424H376h8V408h-8H36.7l72.7-66.1z'
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fast',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      'M144 96c0-44.2 35.8-80 80-80s80 35.8 80 80v64H144V96zm-16 64H16 0v16V464v16H16 160V464H16V176H432v48h16V176 160H432 320V96c0-53-43-96-96-96s-96 43-96 96v64zm80 112H560V496H208V272zm-16-16v16V496v16h16H560h16V496 272 256H560 208 192zm128 72v-8H304v8 40c0 44.2 35.8 80 80 80s80-35.8 80-80V328v-8H448v8 40c0 35.3-28.7 64-64 64s-64-28.7-64-64V328z'
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fast',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      'M257.3 146.7l-3 30.1 26.6-14.5c21.5-11.7 46-18.3 71.2-18.4c74.4-.3 134.5 53.2 142.9 126.3l-129.6-13-30.1-3 14.4 26.6c11.7 21.5 18.3 46 18.4 71.2c.3 74.4-53.2 134.5-126.3 142.9l13-129.7 3-30.1-26.6 14.5c-21.5 11.7-46 18.3-71.2 18.4C85.5 368.3 25.5 314.8 17 241.7l129.6 13 30.1 3-14.4-26.6c-11.7-21.5-18.3-46-18.4-71.2C143.7 85.5 197.1 25.5 270.2 17l-13 129.7zM512 288c0-5.5-.3-10.9-.8-16.2C503.4 189 435.8 127.7 352 128c-21.5 .1-42.6 4.4-61.9 12.3c-5.8 2.4-11.4 5-16.9 8l1.9-18.9L286.4 16 288 0c-5.5 0-10.9 .3-16.2 .8C189 8.6 127.6 76.2 128 160c.1 21.5 4.4 42.5 12.3 61.9c2.4 5.8 5 11.4 8 16.9l-18.9-1.9L16 225.6 0 224c0 5.5 .3 10.9 .8 16.2C8.6 323 76.2 384.3 160 384c21.5-.1 42.6-4.4 61.9-12.3c5.8-2.4 11.4-5 16.9-8l-1.9 18.9L225.6 496 224 512c5.5 0 10.9-.3 16.2-.8C323 503.4 384.4 435.8 384 352c-.1-21.5-4.4-42.5-12.3-61.9c-2.4-5.8-5-11.4-8-16.9l18.9 1.9L496 286.4l16 1.6zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fast',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      'M128 48v80h88 16 88V48H128zm-16 80V48H16v80h96zM16 144V248H216V144H16zm0 224h96V264H16V368zm0 16v80H216V384H128 112 16zm112-16H320V264H128V368zm208 0h96V264H336V368zm96 16H336 320 232v80H432V384zm0-240H232V248H432V144zm0-16V48H336v80h96zM0 32H16 432h16V48 464v16H432 16 0V464 48 32z'
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fast',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      'M144 368a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM288 240c0 55.7-31.7 104.1-78 128H430c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 368a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM144 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm416 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fast',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zm-3.1 72H251.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L246.1 144H137.9L55.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5h5zM136 240v8V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V496H632h8v16h-8H8 0V496H8 120V248v-8h16zm48 256h16V352H184V496zM488 40V32h16v8l0 347.5 82.1-89 5.4-5.9 11.8 10.9-5.4 5.9-96 104-5.9 6.4-5.9-6.4-96-104-5.4-5.9 11.8-10.9 5.4 5.9 82.1 89L488 40z'
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fast',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      'M96 16H16V96H0V16 0H16 96V16zm32 0V0h96V16H128zM0 128H16v96H0V128zM336 16H256V0h80 16V16 128H336V16zm0 144h16v16 80 80 16H336 224 176 160V336 256 176 160h16H288h48zM160 384h16V496h80v16H176 160V496 384zm-32-32H16 0V336 256H16v80H128v16zM384 176V160H496h16v16 80H496V176H384zm32 336V496h80V416h16v80 16H496 416zm80-224h16v96H496V288zM288 512V496h96v16H288zM176 176V336H336V176H176z'
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fast',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      'M16 48v96H432V48H16zM0 32H16 432h16V48v96 16H432l-16 0V264 376v96 8H400v-8V384H280 176v88 8H160v-8V384H48v88 8H32v-8V376 264 160H16 0V144 48 32zM48 160v96H160V160H48zm128 0v96H280 400V160l-224 0zm-8 208H272V272H168 48v96H168zm120 0H400V272H288v96z'
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fast',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      'M0 32H8 32 48 208h16 24 8V48h-8H224V266.8c-6.1 8.7-11.5 18-16 27.8V208H48V384c0 44.2 35.8 80 80 80c31.4 0 58.6-18.1 71.7-44.4c2 6.6 4.4 13 7.1 19.2C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V48H8 0V32zM48 48V192H208V48H48zM368 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm75.3 104l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L304 348.7l5.7 5.7L352 396.7l74.3-74.3 5.7-5.7L443.3 328z'
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fast',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      'M0 112H8 176h3.2l2.3 2.2L320 245 458.5 114.2l2.3-2.2H464 632h8v8V392v8h-8H464h-3.2l-2.3-2.2L320 267 181.5 397.8l-2.3 2.2H176 8 0v-8V120v-8zM308.3 256L172.8 128H16V384H172.8L308.3 256zm23.3 0L467.2 384H624V128H467.2L331.7 256z'
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fast',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      'M16 160H560V464H16V160zm0-16V48H560v96H16zm560 8v-8V48 32H560 16 0V48v96 8 8V464v16H16 560h16V464 160v-8zM112 208h-2.7l-2.1 1.6L112 216c-4.8-6.4-4.8-6.4-4.8-6.4l0 0 0 0 0 0-.1 .1-.4 .3c-.4 .3-.9 .7-1.5 1.2c-1.2 1.1-2.9 2.6-5 4.6c-4 4-9.4 10-14.7 17.9C74.7 249.7 64 273.2 64 304s10.7 54.3 21.4 70.1C90.7 382 96 388 100.1 392c2 2 3.7 3.6 5 4.6c.6 .5 1.1 .9 1.5 1.2l.4 .3 .1 .1 0 0 0 0 0 0s0 0 4.8-6.4l-4.8 6.4 2.1 1.6H112 216 360 464h2.1l1.8-1-3.9-7c3.9 7 3.9 7 3.9 7l0 0 0 0 .1 0 .2-.1 .5-.3c.4-.2 .9-.6 1.6-1c1.3-.9 3.1-2.2 5.2-3.9c4.2-3.5 9.7-8.8 15.1-16.3c11-15.1 21.5-38.7 21.5-73.3s-10.6-58.2-21.5-73.3c-5.4-7.5-10.9-12.8-15.1-16.3c-2.1-1.7-3.9-3-5.2-3.9c-.6-.4-1.2-.8-1.6-1l-.5-.3-.2-.1-.1 0 0 0 0 0s0 0-3.9 7l3.9-7-1.8-1H464 360 216 112zm-.6 19.3c1.4-1.4 2.6-2.5 3.5-3.3H208V384H114.9c-.9-.8-2.1-1.9-3.5-3.3c-3.5-3.4-8.1-8.7-12.8-15.6C89.3 351.4 80 330.9 80 304s9.3-47.3 18.6-61.1c4.7-6.9 9.3-12.1 12.8-15.6zM352 384H224V224H352V384zm109.7 0H368V224h93.7c.9 .6 2.1 1.5 3.5 2.7c3.3 2.8 7.8 7.1 12.4 13.4c9 12.5 18.5 32.9 18.5 63.9s-9.4 51.4-18.5 63.9c-4.6 6.3-9.1 10.7-12.4 13.4c-1.4 1.2-2.6 2.1-3.5 2.7zM176 264h8V248h-8c-30.9 0-56 25.1-56 56s25.1 56 56 56h8V344h-8c-22.1 0-40-17.9-40-40s17.9-40 40-40zm264 40c0 22.1-17.9 40-40 40h-8v16h8c30.9 0 56-25.1 56-56s-25.1-56-56-56h-8v16h8c22.1 0 40 17.9 40 40z'
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fast',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm432 72v16V352v16H416V352 128 112h32zM256 176v16V352v16H224V352 192 176h32zm-96 96v16 64 16H128V352 288 272h32zm208-48H352 320 304v16 16 96 16 16h16 32 16V368 352 256 240 224zm-48 32V240h32v16 96 16H320V352 256zM464 128V112 96H448 416 400v16 16V352v16 16h16 32 16V368 352 128zM272 192V176 160H256 224 208v16 16V352v16 16h16 32 16V368 352 192zm-96 96V272 256H160 128 112v16 16 64 16 16h16 32 16V368 352 288z'
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fast',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      'M411 108.1c-7 10.2-11 22.6-11 35.9v32 8l-6.4 4.8C378 200.5 368 219.1 368 240c0 30.9 22 56.8 51.2 62.7l6.3 1.3H432h40 16 48 16 8c9.1 0 17.8-1.9 25.6-5.3l6.8-3 6-4.5C614 279.5 624 260.9 624 240c0 0 0 0 0 0c0-9.2-1.9-17.9-5.4-25.8c-5.7-8.5-15.5-14.2-26.6-14.2c-17.7 0-32 14.3-32 32v8H544v-8c0-26.2 21-47.5 47-48c-5.6-3.1-11.7-5.4-18.2-6.7L560 174.7V161.6 144c0-10-2.3-19.4-6.3-27.8l-5-10.2 8-8 6.6-6.6L574.6 80 552 57.4 540.7 68.7 530.6 78.8l-6.8 6.8-9.2-2.8C508.8 81 502.5 80 496 80H464c-2.8 0-5.5 .2-8.1 .5l-7.8 1-5.5-5.5-9.8-9.8L421.4 54.8 398.8 77.4l10.3 10.3 9.4 9.4L411 108.1zM640 240s0 0 0 0c0 26.2-12.6 49.4-32 64v9.3V344v8 8h-8-8H552h-8-8v-8-8-8V320H520 504 488v16 8 8 8h-8-8H432h-8-8v-8-8V320v-1.6c-36.5-7.4-64-39.7-64-78.4c0-26.2 12.6-49.4 32-64V144c0-15.1 4.2-29.2 11.4-41.2l-24.2-9.1C347 84.7 321.3 80 295.4 80H216C123.2 80 48 155.2 48 248v8 0l0 80 0 2.6-1.5 2.1L18 380.6l-4.6 6.5-13-9.3L5 371.4l27-37.9L32 256v0-8C32 146.4 114.4 64 216 64h79.4c27.8 0 55.4 5 81.5 14.8l1.1 .4-1.7-1.7 11.3-11.3 22.6-22.6 11.3-11.3 11.3 11.3 11.3 11.3 9.8 9.8c3.3-.4 6.7-.6 10.1-.6h32c8.1 0 15.9 1.2 23.3 3.4l10.1-10.1 11.3-11.3L552 34.7l11.3 11.3 22.6 22.6L597.3 80 585.9 91.3l-11.3 11.3-6.6 6.6c5.1 10.5 7.9 22.3 7.9 34.8v17.6c25.2 5.1 46.1 22.1 56.7 44.9c4.7 7.4 7.3 16.1 7.3 25.5v8zm-48 73.3c-5.1 2.2-10.4 3.9-16 5.1c-5.2 1-10.5 1.6-16 1.6h-8v8 8 8h16 8 16V330.5 328 313.3zM472 328v-8H456h-8H432v8 8 8h16 8 16v-8-8zm-40 55.3c2.6 .4 5.3 .7 8 .7h8v88 8h-8H328h-8v-8V371.1l-5.8 1.9c-37.8 12.6-78.6 12.6-116.4 0l-5.8-1.9V472v8h-8H72 64v-8V344v-8H80v8V464h96V360 348.9l10.5 3.5 16.3 5.4c34.5 11.5 71.8 11.5 106.3 0l16.3-5.4 10.5-3.5V360 464h96V383.3zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-56 56c-17.7 0-32 14.3-32 32v8H408v-8c0-26.5 21.5-48 48-48s48 21.5 48 48v8H488v-8c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fast',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      'M112 8V0H96V8 48H48 40V64h8H96V96H48 40v16h8H96v48H40 8 0v16H8 32V496H8 0v16H8 40 344h32 8V496h-8H352V176h24 8V160h-8H344 288V112h48 8V96h-8H288V64h48 8V48h-8H288V8 0H272V8 48H224h-8V64h8 48V96H224h-8v16h8 48v48H112V112h48 8V96h-8H112V64h48 8V48h-8H112V8zM272 176h16 48V496H48V176H96h16H272zM201.8 311.7L198 329.9l18.6 1.1 48.3 2.8-95 85.5 12.4-59 3.8-18.2-18.6-1.1-48.3-2.8 95-85.5-12.4 59zM304 320l-22.5-1.3-47.9-2.8-16.2-.9 3.3-15.8 13.6-64.6L240 208l-20.2 18.2L96.7 336.9 80 352l22.5 1.3 47.9 2.8 16.2 .9-3.3 15.8-13.6 64.6L144 464l20.2-18.2L287.3 335.1 304 320z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fast',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M8 32H0V48H8 184V472v8h16v-8V48H376h8V32h-8H200h-8-8H8z'
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fast',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      'M264 80h88V64H160V80l88 0v80H112 96 16 0v16V304l96 41.1V400v16h16H384h48L640 192l-32-32L448 192l-64-32H264V80zM16 176H96V327.7L16 293.4V176zm424.8 30.3l4.9 2.5 5.4-1.1 151.6-30.3 15 15L425 400H384 112V352 334.6 176H380.2l60.6 30.3z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fast',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M331.3 43.3l21.4 21.4L364 76 352.7 87.3l-85.4 85.4L256 184l11.3 11.3 49.4 49.4L328 256l11.3-11.3 85.4-85.4L436 148l11.3 11.3 21.4 21.4L480 192l11.3-11.3L512 160V16 0H496 352L331.3 20.7 320 32l11.3 11.3zm44 44L386.6 76 375.3 64.7 342.6 32l16-16H496V153.4l-16 16-32.7-32.7L436 125.4l-11.3 11.3L328 233.4 278.6 184l96.7-96.7zM180.7 468.7l-21.4-21.4L148 436l11.3-11.3 85.4-85.4L256 328l-11.3-11.3-49.4-49.4L184 256l-11.3 11.3L87.3 352.7 76 364 64.7 352.7 43.3 331.3 32 320 20.7 331.3 0 352V496v16H16 160l20.7-20.7L192 480l-11.3-11.3zm-44-44L125.4 436l11.3 11.3L169.4 480l-16 16H16V358.6l16-16 32.7 32.7L76 386.6l11.3-11.3L184 278.6 233.4 328l-96.7 96.7z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fast',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M353.6 32H370L345.1 144H445.9l-3.2 16H341.5L298.9 352H404.3l-3.2 16H295.3L270.4 480H254l24.9-112H103.3L78.4 480H62L86.9 368H2.1l3.2-16H90.5l42.7-192H43.7l3.2-16h89.8L161.6 32H178L153.1 144H328.7L353.6 32zM149.5 160L106.9 352H282.5l42.7-192H149.5z'
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fast',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      'M192 208h16V192 176h40 8V160h-8H208 192 160 128c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.6 0 11 1 16 2.7c1.1 .4 2.2 .8 3.2 1.3c5 2.2 9.6 5.2 13.5 8.9c-.5-2.9-.8-5.9-.8-8.9c0-3.7 .4-7.3 1.1-10.8C166.1 33.7 187 16 212 16c12.6 0 24.1 4.5 33.1 11.9c4.3 3.5 7.9 7.7 10.9 12.4c3-4.7 6.7-8.9 10.9-12.4c9-7.4 20.5-11.9 33.1-11.9c25 0 45.9 17.7 50.9 41.2c.7 3.5 1.1 7.1 1.1 10.8c0 3-.3 6-.8 8.9c3.9-3.7 8.5-6.7 13.5-8.9c1-.5 2.1-.9 3.2-1.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48s-21.5 48-48 48H320 304v16 16 16h16V192 176h64c35.3 0 64-28.7 64-64s-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C358.1 21.5 331.6 0 300 0c-16.8 0-32.1 6.1-44 16.2C244.1 6.1 228.8 0 212 0c-31.6 0-58.1 21.5-65.8 50.6C140.5 48.9 134.3 48 128 48c-35.3 0-64 28.7-64 64s28.7 64 64 64h32 32v16 16zM255.8 96h.3l-.2-.3-.2 .3zM23.2 271.1l5.8 2 5.7-2.4 50.7-21.4L136 270.7l7.8 3.3 7.1-4.6L193 242.4l55.9 27.9 6.6 3.3 6.8-2.9 50.7-21.4 50.7 21.4 6.2 2.6 6.2-2.6 50.7-21.4 50.7 21.4 5.7 2.4 5.8-2 6.9-2.4C489 395.4 384.3 496 256 496S23 395.4 16.3 268.7l6.9 2.4zm119-15.1L85.3 232 28.4 256 16 251.7 .2 246.2c-.1 3.2-.2 6.5-.2 9.8c0 2.4 0 4.8 .1 7.1C3.9 401.2 117 512 256 512s252.1-110.8 255.9-248.9c.1-2.4 .1-4.7 .1-7.1c0-3.3-.1-6.5-.2-9.8L496 251.7 483.6 256l-56.9-24-56.9 24-56.9-24L256 256l-64-32-49.8 32zm34.1 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-8.8 80c-4-36-34.5-64-71.6-64s-67.6 28-71.6 64c-.3 2.6-.4 5.3-.4 8v8h16H312h16v-8c0-2.7-.2-5.4-.4-8zm-127 0c3.9-27.1 27.2-48 55.4-48s51.6 20.9 55.4 48H200.6z'
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fast',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM153.8 174.5l5.7 5.7L224 244.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L235.3 256l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L224 267.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L212.7 256l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fast',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.1-85.1l-1.4-14.8C347 364.7 305.8 328 256 328s-91 36.7-95.6 84.2l-1.4 14.8 13.1-6.9c24-12.6 52.8-20 84-20c31.1 0 60 7.4 84 20l13.1 6.9zM332.8 399c-23.1-9.6-49.2-15-76.8-15c-27.6 0-53.7 5.4-76.7 15c9.8-31.7 40.3-55 76.7-55s66.9 23.3 76.8 55zM176.4 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM130.5 168.4l-7.6-2.5-5.1 15.2 7.6 2.5 96 32 7.6 2.5 5.1-15.2-7.6-2.5-96-32zm256 15.2l7.6-2.5-5.1-15.2-7.6 2.5-96 32-7.6 2.5 5.1 15.2 7.6-2.5 96-32z'
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fast',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      'M8 32H0V48H8 32V464H8 0v16H8 32 48 592h16 24 8V464h-8H608V48h24 8V32h-8H608 592 48 32 8zM48 464V48H592V464H48zm88-360V96H120v8V408v8h16v-8V104zm96 0V96H216v8V408v8h16v-8V104zm96 0V96H312v8V408v8h16v-8V104zm96 0V96H408v8V408v8h16v-8V104zm96 0V96H504v8V408v8h16v-8V104z'
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fast',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm432 8v32 8H416v-8V264v-8h16v8zM405.7 373.7l-32 32-5.7 5.7L356.7 400l5.7-5.7 32-32 5.7-5.7L411.3 368l-5.7 5.7zM248 432h32 8v16h-8H248h-8V432h8zM176 112h8 96 8v8 48 8h-8H216h-3.3l-2.3-2.3-32-32-2.3-2.3V136 120v-8zm16 16v4.7L219.3 160H272V128H192zm-40 80h32 8v8 24h16V216v-8h8 32 3.3l2.3 2.3 64 64 2.3 2.3V280v96 8h-8H216h-3.3l-2.3-2.3L180.7 352H88 80v-8V280v-3.3l2.3-2.3 64-64 2.3-2.3H152zM96 283.3V336h88 3.3l2.3 2.3L219.3 368H304V283.3L244.7 224H224v24 8h-8H184h-8v-8V224H155.3L96 283.3z'
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fast',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      'M112 0V8 32h80V8 0h16V8 32h96V8 0h16V8 32h80V8 0h16V8 32 48 80v8 24h16 16v16 96h16 16v16V352h16 16v16V496v16H496 320 304 208 192 16 0V496 368 352H16 32V240 224H48 64V128 112H80 96V88 80 48 32 8 0h16zm96 496h96V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v32zm112 0h80V368H384 304 288 224 208 128 112V496h80V464c0-35.3 28.7-64 64-64s64 28.7 64 64v32zM112 80v8 24H400V88 80 48H320 304 208 192 112V80zm304 48H400 352v96h32 16 32V128H416zm-240 0v96h48V192c0-17.7 14.3-32 32-32s32 14.3 32 32v32h48V128H176zm96 112H240 224 128V352h80V320c0-26.5 21.5-48 48-48s48 21.5 48 48v32h80V240H288 272zm0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h32V192zM160 224V128H112 96 80v96h32 16 32zM288 352V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64zM400 240V352h64V240H448 432 400zM80 240H64 48V352h64V240H80zM480 368H464 416V496h80V368H480zM96 496V368H48 32 16V496H96z'
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fast',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      'M496 256c0-58.5-20.9-112.1-55.7-153.8c3.6 48.3-1.3 153-93.2 244.9s-196.6 96.8-244.9 93.2C143.9 475.1 197.5 496 256 496c132.5 0 240-107.5 240-240zM75.3 414c1.5-50.3 13.4-173 89.5-249.1C250.1 79.6 362.8 72.2 412 73.6C370 37.7 315.5 16 256 16C123.5 16 16 123.5 16 256c0 60.5 22.4 115.8 59.3 158zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM101.8 422.6c14.8 1.2 35.8 1.6 60.6-1.6c49.4-6.5 113.5-27.5 172.3-86.3s79.8-122.9 86.3-172.3c3.3-24.8 2.8-45.8 1.6-60.6c-.3-3.8-.7-7.2-1.1-10.2c-3.4-.2-7.4-.4-11.9-.5c-15.9-.3-38.3 .3-64.1 4.3c-51.6 8-115.6 29.3-168.2 81.9c-45.2 45.2-66.6 109-76.6 163.3c-4.9 26.9-6.9 50.9-7.6 68.1c-.2 4.9-.3 9.3-.4 13c2.7 .3 5.7 .6 9 .9z'
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fast',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      'M336 3.8V14 83.8L470 50.3l9.9-2.5V58v69.8V138v6.2V218v6.2l0 0V298v6.2l-6.1 1.5L367.9 332.3V368H400h16v16 64 16H400 368v40 8h-8H280h-8v-8V464H240 224V448 384 368h16H351.9V326v-6.2l6.1-1.5 105.9-26.5V228.3l-150 37.5 0 0L170 301.7l-9.9 2.5V294 224.2 214v0-6.2V144.2 134v-6.2V54 47.7l6.1-1.5L326 6.3 336 3.8zm127.9 208V148.3L176.1 220.2v63.5L310 250.2l153.9-38.5zm0-143.5L336 100.3l-6.1 1.5L176.1 140.2v63.5l287.8-71.9V68.3zM176.1 123.7L320 87.8V24.3l-143.9 36v63.5zM240 384v64h40 80 40V384H240zm112 80H288v32h64V464zM272 309.2l16-4V368H272V309.2zM17.1 20.1l75 45L99 69.3 90.7 83l-6.9-4.1-75-45L2 29.7 10.3 16l6.9 4.1zm614 13.7l-75 45L549.3 83 541 69.3l6.9-4.1 75-45 6.9-4.1L638 29.7l-6.9 4.1zM8 176H88h8v16H88 8 0V176H8zm544 0h80 8v16h-8H552h-8V176h8zM92.1 286.9l-75 45L10.3 336 2 322.3l6.9-4.1 75-45 6.9-4.1L99 282.7l-6.9 4.1zm464-13.7l75 45 6.9 4.1L629.7 336l-6.9-4.1-75-45-6.9-4.1 8.2-13.7 6.9 4.1z'
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fast',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM184.3 177.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 352.1l-11.1-10.7L98.2 261.8C86.6 250.7 80 235.3 80 219.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm-3.4 18.9l-7.7-7.4c-8.5-8.2-19.8-12.7-31.6-12.7h-2.4C115.3 176 96 195.3 96 219.2c0 11.7 4.8 23 13.2 31.1L192 329.9l82.8-79.6c8.5-8.1 13.2-19.4 13.2-31.1c0-23.9-19.3-43.2-43.2-43.2h-2.4c-11.8 0-23.1 4.6-31.6 12.7l-7.7 7.4L192 206.8l-11.1-10.7z'
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fast',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM244.9 196.1L256 206.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L256 329.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4zm-82.8 65.7L256 352.1l93.8-90.3c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7z'
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fast',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      'M232 0h-6.4l-1.4 6.2L173.9 224h16.4l48-208H528c53 0 96 43 96 96c0 39.5-23.9 73.4-58 88.2c-35.2-44-89.3-72.2-150-72.2H368 352v16V292c5.2-1.3 10.6-2.4 16-3V144h48c97.2 0 176 78.8 176 176V496H483.9c-4.6 5.8-9.7 11.1-15.3 16H592h16V496 320c0-39.5-11.9-76.1-32.3-106.6c38-17.9 64.3-56.6 64.3-101.4C640 50.1 589.9 0 528 0H232zM183 256H166.6L129.6 416H48L0 464v32 16H16 208h16V496 432 416H208 146.1L183 256zM135.8 432h.3H208v64H16V470.6L54.6 432h81.2zM384 336a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-16-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fast',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      'M343.3 244l46.3 46.3 2.3 2.3V296v16 7.1l-7 .9L336.5 326l2.5 32.7c3.2 41.4-11.9 82.2-41.3 111.6C271 497 234.8 512 197 512L16 512H0V496 480l93.3-80L112 384l-24.6 0L80 384H64l0-5c0-3.7 .1-7.3 .4-11c2.6-33.7 17.2-65.6 41.3-89.7c29.4-29.4 70.2-44.5 111.6-41.3l32.7 2.5 6.1-48.5 .9-7H264h16 3.3l2.3 2.3L332 232.7 562.3 2.3l11.3 11.3L343.3 244zM376 304.9v-5.6L276.7 200h-5.6l-6.1 48.9 62.1 62.1 48.9-6.1zM80.5 368H112l43.3 0-32.8 28.1L16 487.4l0 8.6 181 0c33.5 0 65.7-13.3 89.4-37c26.1-26.1 39.5-62.3 36.6-99l-2.5-32.8-71.6-71.6L216.1 253c-36.8-2.8-73 10.6-99 36.6C95.9 310.7 83 338.5 80.5 368z'
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fast',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      'M82.8 295.9C38.8 271.1 16 239.4 16 208s22.8-63.1 66.8-87.9C126.3 95.6 187.5 80 256 80s129.7 15.6 173.2 40.1c44 24.8 66.8 56.5 66.8 87.9s-22.8 63.1-66.8 87.9C385.7 320.4 324.5 336 256 336s-129.7-15.6-173.2-40.1zM256 64C114.6 64 0 128.5 0 208l0 16 0 96c0 70.7 114.6 128 256 128s256-57.3 256-128l0-96 0-16c0-79.5-114.6-144-256-144zm-8 287.9l0 80c-28.2-.4-55.2-3.2-80-8l0-80.7c25.1 5.2 52 8.2 80 8.7zM88 316.7c19.1 9.3 40.6 17.1 64 23l0 81c-23.8-5.5-45.4-12.8-64-21.6l0-82.4zm-16-8.5l0 82.7C34.2 369.5 16 344 16 320l0-61.8C28.4 277 47.7 294 72 308.1zM264 431.9l0-80c28-.5 54.9-3.5 80-8.7l0 80.7c-24.8 4.7-51.8 7.5-80 8zm96-11.3l0-81c23.4-5.9 44.9-13.6 64-23l0 82.4c-18.6 8.7-40.2 16-64 21.6zm80-29.8l0-82.7c24.3-14.1 43.6-31.1 56-49.9l0 61.8c0 24-18.2 49.5-56 70.8z'
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fast',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 160h-8v8V312v8h16v-8V187.3L338.3 349.7l5.7 5.7L355.3 344l-5.7-5.7L187.3 176H312h8V160h-8H168z'
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fast',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 256c0-61.9 50.1-112 112-112c28.7 0 54.8 10.8 74.7 28.5l6 5.3 10.7-11.9-6-5.3C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128v-8h-8H290.3h-8v16h8 77.4c-4.1 58.1-52.6 104-111.7 104c-61.9 0-112-50.1-112-112z'
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fast',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      'M264 0V8 80H416h8V96h-8H264v80H480h8v16h-8H264v80H384h8v16h-8H264v77.7L368 336h64 16v16 88l-64 72H128L64 440V352 336H80h64l104 29.7V288H128h-8V272h8H248V192H32 24V176h8H248V96H96 88V80h8H248V8 0h16zm0 384h-5.8l-2.2 .6-2.2-.6H248v-1.6L141.8 352H80v81.9L135.2 496H376.8L432 433.9V352H370.2L264 382.4V384zm-96 48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm136-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fast',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      'M560 16H16V400H231.8h.3 90.8c1 5.4 2.2 10.8 3.7 16H238.8l-13.3 80H288h62.6 16.2 8.4c6.1 5.8 12.7 11.1 19.6 16H360 216 136h-8V496h8 73.2l13.3-80H16 0V400 16 0H16 560h16V16 211.2c-5.2-2.7-10.5-5.1-16-7.2V16zM512 192.7c-5.3-.5-10.6-.7-16-.7V80H80V336H322.9c-1 5.3-1.7 10.6-2.2 16H80 64V336 80 64H80 496h16V80 192.7zm-64 5.9c-5.4 1.5-10.8 3.3-16 5.4V155.3L325.7 261.7l-5.7 5.7-5.7-5.7L240 187.3 133.7 293.7l-5.7 5.7L116.7 288l5.7-5.7 112-112 5.7-5.7 5.7 5.7L320 244.7 420.7 144H352h-8V128h8 88 8v8 62.6zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm56.3-11.1l21.4 21.4-11.3 11.3-21.4-21.4C528.6 434.1 513 440 496 440s-32.6-5.9-44.9-15.7l-21.4 21.4-11.3-11.3 21.4-21.4C429.9 400.6 424 385 424 368s5.9-32.6 15.7-44.9l-21.4-21.4 11.3-11.3 21.4 21.4C463.4 301.9 479 296 496 296s32.6 5.9 44.9 15.7l21.4-21.4 11.3 11.3-21.4 21.4C562.1 335.4 568 351 568 368s-5.9 32.6-15.7 44.9z'
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fast',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      'M392 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM616 376a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM504 248a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM240 384A112 112 0 1 1 16 384a112 112 0 1 1 224 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM325.1 121.8c-3-2.5-7.3-2.4-10.3 .1L235.3 190c-20.3 17.4-18.1 49.4 4.3 64L336 316.4V416v8h16v-8V312v-4.4l-3.7-2.4-100-64.7c-13.5-8.7-14.8-27.9-2.6-38.4l74.4-63.8 82.8 67.8 2.2 1.8H408h80 8V192h-8H410.9l-85.8-70.2z'
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fast',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      'M416 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM104.9 261.6l7.1-4.8v-8.5V16H240V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM256 0H240 112 96V16 248.3C57.4 274.1 32 318.1 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264c0-4.4-3.6-8-8-8s-8 3.6-8 8v40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fast',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M416 160v88 16 88H224V160H416zm16 88V160 144H416 224 208v16 88h-8H8 0v16H8 200h8v88 16h16H416h16V352 264H632h8V248h-8H432z'
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fast',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm80 220.5l-10.8 4.1-128 48-5.2 1.9V280 386.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40V285.5l112-42V354.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40V232 220.5zM256 360c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM128 392c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fast',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V229.6l49.3-74 4.4-6.7 13.3 8.9-4.4 6.7-64 96-14.7 22V256 104 96h16v8z'
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fast',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      'M455.1 454.4C416.6 480.6 370.1 496 320 496C187.5 496 80 388.5 80 256c0-30.1 5.5-58.9 15.6-85.4L82.5 160.2C70.6 189.8 64 222.1 64 256c0 141.4 114.6 256 256 256c55.2 0 106.4-17.5 148.2-47.2l-13.1-10.4zM320 0C264.8 0 213.6 17.5 171.8 47.2l13.1 10.4C223.4 31.4 269.9 16 320 16c132.5 0 240 107.5 240 240c0 30.1-5.5 58.9-15.6 85.4l13.1 10.4C569.4 322.2 576 289.9 576 256C576 114.6 461.4 0 320 0zM198.3 365L192 384l19-6.3 103.3-34.4-15-11.9-82 27.3 24.3-72.9-13.4-10.5L198.3 365zM325.7 168.8l15 11.9 82-27.3-24.3 72.9 13.4 10.5L441.7 147l6.3-19-19 6.3L325.7 168.8zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fast',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      'M512 5.2V16 128 368s0 0 0 0c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c33.4 0 62.8 14.2 80 35.8V139L192 237.8V432v0c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c33.4 0 62.8 14.2 80 35.8V232 112v-6l5.7-1.7 320-96L512 5.2zM496 368c0-32.7-33-64-80-64s-80 31.3-80 64s33 64 80 64s80-31.3 80-64c0 0 0 0 0 0zM96 368c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64v0c0-32.7-33-64-80-64zm96-147l304-98.8V26.8L192 118V221z'
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fast',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      'M496 256c0 132.5-107.5 240-240 240c-66.5 0-120-52.2-120-116s53.5-116 120-116c74.9 0 136-58.9 136-132c0-39.1-17.4-74.1-45.1-98.2C434.4 69.6 496 155.6 496 256zM256 16c66.5 0 120 52.2 120 116s-53.5 116-120 116c-74.9 0-136 58.9-136 132c0 39.1 17.4 74.1 45.1 98.2C77.6 442.4 16 356.4 16 256C16 123.5 123.5 16 256 16zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-179.3l-5.7 5.7-40 40-5.7 5.7 5.7 5.7 40 40 5.7 5.7 5.7-5.7 40-40 5.7-5.7-5.7-5.7-40-40-5.7-5.7zM227.3 384L256 355.3 284.7 384 256 412.7 227.3 384zM261.7 82.3L256 76.7l-5.7 5.7-40 40-5.7 5.7 5.7 5.7 40 40 5.7 5.7 5.7-5.7 40-40 5.7-5.7-5.7-5.7-40-40zM256 156.7L227.3 128 256 99.3 284.7 128 256 156.7z'
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fast',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      'M336 16H16V336H128v16H16 0V336 16 0H16 336h16V16 128H336V16zM288 128H272V80H80V272h48v16H80 64V272 80 64H80 272h16V80v48zM160 160h16H496h16v16V496v16H496 176 160V496 176 160zm16 16V496H496V176H176z'
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fast',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      'M16 272V464H496V272H16zm10.1-16H496c0-113.1-90.2-205.1-202.6-207.9L26.1 256zM0 256L288 32c123.7 0 224 100.3 224 224V464v16H496 16 0V464 256z'
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fast',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm233 81.1l39.9 75.5 84.2 14.6 19.1 3.3-13.5 13.9-59.5 61.3 12.2 84.5 2.8 19.2-17.4-8.6L224 339.2l-76.7 37.7L130 385.4l2.8-19.2 12.2-84.5L85.3 220.5 71.8 206.6l19.1-3.3 84.2-14.6L215 113.1 224 96l9 17.1zm37.1 91.3l-7.8-1.3-3.7-7L224 130.3l-34.8 65.9-3.7 7-7.8 1.3-73.4 12.7 51.9 53.4 5.5 5.6-1.1 7.8-10.6 73.7 66.8-32.9 7.1-3.5 7.1 3.5 66.8 32.9L287.3 284l-1.1-7.8 5.5-5.6 51.9-53.4-73.4-12.7z'
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fast',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      'M30.4 194.1L46.6 16H273.4l16.2 178.1C296.5 270.3 236.5 336 160 336S23.5 270.3 30.4 194.1zM168 351.8c82.1-4.4 145-76.2 137.5-159.1L288 0H32L14.5 192.7C7 275.5 69.9 347.4 152 351.8V496H72 64v16h8 88 88 8V496h-8H168V351.8z'
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fast',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      'M323.2 350.2L215.8 457.6 86 490l32.5-129.8 95.9-95.9-12.6-10L104 352 68.4 494.4 64 512l17.6-4.4L224 472 335.8 360.2l-12.6-10zM444.7 11.3L304.2 151.8l12.6 10L377.7 101 475 198.3l-49.4 49.4 12.6 10L564.7 131.3 576 120l-11.3-11.3L467.3 11.3 456 0 444.7 11.3zM486.3 187L389 89.7l67-67L553.4 120l-67 67zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fast',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      'M287.6 41.2c-9.9-2.9-20.1-5.2-30.5-6.7C246.3 32.8 235.2 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c51.3 0 98.6-17.3 136.4-46.3c8.3-6.4 16.1-13.3 23.4-20.7c-9.6 2.5-19.5 4.3-29.7 5.3c-6.2 .6-12.6 .9-19 .9c-105.8 0-191.5-86-191.5-192c0-78.9 47.5-146.7 115.4-176.3c9.2-4 18.7-7.3 28.5-9.8zm-58 6.9c-61.1 36.2-102 102.9-102 179.1c0 113 90 205.1 202.1 207.9C298.8 453.5 262.6 464 224 464C109.1 464 16 370.9 16 256S109.1 48 224 48c1.9 0 3.8 0 5.6 .1z'
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fast',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      'M197.7 42.3L192 36.7l-5.7 5.7-136 136L44.7 184 56 195.3l5.7-5.7L184 67.3 184 376l0 8 16 0 0-8 0-308.7L322.3 189.7l5.7 5.7L339.3 184l-5.7-5.7-136-136zM8 464l-8 0 0 16 8 0 368 0 8 0 0-16-8 0L8 464z'
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fast',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      'M336 11.2l4.5-6.6-4.8-3.3-4.6 3.6 4.9 6.3zM500.8 173.3c6.5-4.7 6.5-4.7 6.5-4.7l0 0 0 0 0 0-.1-.1-.3-.5c-.3-.4-.7-.9-1.2-1.6c-1.1-1.3-2.6-3.2-4.6-5.4c-4-4.4-9.9-10.2-17.6-16.1c-15.2-11.7-37.8-23.6-66.1-23.6c-12.6 0-22.1 1.1-29.3 2.6c1.5-7.2 2.6-16.7 2.6-29.3c0-28.5-12.8-51.1-25.1-66.3c-6.2-7.6-12.4-13.5-17-17.5c-2.3-2-4.3-3.5-5.7-4.6c-.7-.5-1.3-.9-1.7-1.2l-.5-.3-.1-.1 0 0 0 0 0 0s0 0-4.5 6.6c-4.9-6.3-4.9-6.3-5-6.3l0 0 0 0 0 0-.1 .1-.4 .3c-.3 .3-.8 .7-1.4 1.2c-1.2 1-2.9 2.5-4.9 4.5c-4 3.8-9.3 9.4-14.6 16.5C299.1 41.5 288 61.9 288 86c0 22.4 5 37.9 13.7 51.2c-14.9-5.9-31.2-9.2-48.3-9.2c-51.9 0-98.8 30.7-119.6 78.2L9.4 490.4 0 512l21.6-9.4L305.8 378.2c47.5-20.8 78.2-67.8 78.2-119.6c0-17.1-3.3-33.3-9.2-48.3C388.1 219 403.6 224 426 224c24.3 0 44.7-11.9 58.7-23.1c7-5.7 12.6-11.3 16.5-15.5c1.9-2.1 3.4-3.9 4.4-5.2c.5-.6 .9-1.1 1.2-1.5l.3-.4 .1-.1 0 0 0 0 0 0s0 0-6.4-4.8zm0 0l6.5-4.7 3.4 4.7-3.4 4.7-6.4-4.7zm-132.5-41s0 0 5.7 5.6s5.7 5.7 5.6 5.7l0 0 0 0 0 0-.1 .1-.1 .1c-.1 0-.1 .1 0 0c0 0 .3-.2 .7-.4c.8-.5 2.4-1.3 5.2-2.2c5.5-1.8 15.4-3.9 32.1-3.9c23.7 0 42.9 10 56.4 20.4c6.7 5.2 11.9 10.3 15.5 14.2c.5 .5 .9 1 1.3 1.5c-.4 .4-.8 .9-1.2 1.3c-3.4 3.8-8.4 8.8-14.6 13.8C462 198.6 445.1 208 426 208c-20.2 0-32.8-4.5-43.5-11.8c-8.6-5.9-16-13.4-25.2-22.9c-2.9-2.9-5.9-6.1-9.2-9.4s-6.4-6.3-9.4-9.2c-9.5-9.2-17-16.6-22.9-25.2C308.5 118.9 304 106.2 304 86c0-19.2 8.9-36.2 18.4-48.8c4.7-6.2 9.4-11.2 12.9-14.6l1-1c.5 .4 1.1 .9 1.7 1.4c4.1 3.5 9.6 8.7 15 15.5c11 13.5 21.5 32.7 21.5 56.2c0 16.7-2.1 26.6-3.9 32.1c-.9 2.7-1.8 4.4-2.2 5.2c-.2 .4-.4 .6-.4 .7c0 0 0 0 0 0l.1-.1 .1-.1 0 0 0 0 0 0zM31 481l114-260.6 41.3 41.3 5.7 5.7L203.3 256l-5.7-5.7-45.5-45.5c19.8-37.2 58.6-60.9 101.2-60.9C316.7 144 368 195.3 368 258.6c0 45.5-27 86.7-68.7 105L173.8 418.5l-.2-.2-40-40-5.7-5.7L116.7 384l5.7 5.7 35.7 35.7L31 481z'
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fast',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      'M96 32H88v8 80.3c0 22.4 8.5 43.9 23.9 60.3l53.3 56.8L75.8 300.8C48.3 320.3 32 351.9 32 385.6V472v8h8H256h4.1l2.4-3.3 55.1-77.1L393.2 480h22l-88-93.7 84.2-117.7 4.7-6.5-13-9.3-4.7 6.5L316 374.4 189.4 239.8l69.5-49.3c23.3-16.5 37.1-43.2 37.1-71.8V40 32h-8H96zM249.7 177.4L178.4 228l-54.8-58.4c-12.5-13.4-19.5-31-19.5-49.3V48H280v70.7c0 23.3-11.3 45.2-30.3 58.7zM85.1 313.8l91.2-64.7L306.5 387.7 251.9 464H48V385.6c0-28.5 13.8-55.3 37.1-71.8z'
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fast',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      'M180.1 453.3c19.3-6.4 39.8-15.7 60.6-27.7c-28.7-18.8-57.5-42.1-84.9-69.5s-50.7-56.2-69.5-84.9c-11.9 20.8-21.2 41.2-27.7 60.6C41.2 384.4 45.9 423.9 67 445s60.5 25.8 113.1 8.3zM256 416.4c29.8-18.8 60.1-42.8 88.8-71.6s52.8-59 71.6-88.8c-18.8-29.8-42.8-60.1-71.6-88.8s-59-52.8-88.8-71.6c-29.8 18.8-60.1 42.8-88.8 71.6s-52.8 59-71.6 88.8c18.8 29.8 42.8 60.1 71.6 88.8s59 52.8 88.8 71.6zm0 18.8c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1zM425.6 271.3c-18.8 28.7-42.1 57.5-69.5 84.9s-56.2 50.7-84.9 69.5c20.8 11.9 41.2 21.2 60.6 27.7c52.6 17.5 92.1 12.8 113.1-8.3s25.8-60.5 8.3-113.1c-6.4-19.3-15.7-39.8-27.7-60.6zm0-30.6c11.9-20.8 21.2-41.2 27.7-60.6C470.8 127.6 466.1 88.1 445 67s-60.5-25.8-113.1-8.3c-19.3 6.4-39.8 15.7-60.6 27.7c28.7 18.8 57.5 42.1 84.9 69.5s50.7 56.2 69.5 84.9zM240.7 86.4c-20.8-11.9-41.2-21.2-60.6-27.7C127.6 41.2 88.1 45.9 67 67s-25.8 60.5-8.3 113.1c6.4 19.3 15.7 39.8 27.7 60.6c18.8-28.7 42.1-57.5 69.5-84.9s56.2-50.7 84.9-69.5zM201.4 256l11.3-11.3 32-32L256 201.4l11.3 11.3 32 32L310.6 256l-11.3 11.3-32 32L256 310.6l-11.3-11.3-32-32L201.4 256zm65.9 20.7l9.4-9.4L288 256l-11.3-11.3-9.4-9.4L256 224l-11.3 11.3-9.4 9.4L224 256l11.3 11.3 9.4 9.4L256 288l11.3-11.3z'
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fast',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      'M4.4 494.4L0 512l17.6-4.4L160 472 500.7 131.3 512 120l-11.3-11.3L403.3 11.3 392 0 380.7 11.3 40 352 4.4 494.4zM22 490L54.4 360.2 313.7 101 411 198.3 151.8 457.6 22 490zM489.4 120l-67 67L325 89.7l67-67L489.4 120zM232 496h-8v16h8H568h8V496h-8H232z'
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fast',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      'M336 345.2v24.2V496h80l0-246.7-4-2.4L317.8 192h-3.2H184h-8H152 104.5c-24.2 0-44.6-18-47.6-42l-1-7.9-2-15.9-31.8 4 2 15.9 1 7.9c3.5 28.1 21.3 51.3 45.6 62.6l9.2 4.3v10.2V496h80V369.4 345.2l22.3 9.5c20.2 8.6 42.4 13.3 65.7 13.3s45.6-4.8 65.7-13.3l22.3-9.5zm89.6-155.8l2.2-13.4h13.6H464h40c30.9 0 56-25.1 56-56V80H496h-6.6l-4.7-4.7L457.4 48H400h-8l-4.8-6.4L368 16H357.6L330.4 178.6l-.3 2 88.3 51.5 7.1-42.8zM6.3 132.1l-2-15.9 15.9-2 31.8-4 15.9-2 2 15.9 2 15.9 1 7.9c2 16 15.6 28 31.8 28H152h24 8H314.7L344 0h32l24 32h64l32 32h64 16V80v40c0 39.8-32.2 72-72 72H464 441.3L432 248l0 248v16H416 336 320V496 386.6 369.4c-5.2 2.2-10.6 4.2-16 5.9c-17.7 5.6-36.5 8.7-56 8.7s-38.3-3-56-8.7c-5.4-1.7-10.8-3.7-16-5.9v17.3V496v16H160 80 64V496 231.1c-29.1-13.6-50.5-41.4-54.8-75.1l-1-7.9-2-15.9zM444 80a12 12 0 1 1 0 24 12 12 0 1 1 0-24z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fast',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M80 512l11.3-11.3L500.7 91.3 512 80 500.7 68.7 443.3 11.3 432 0 420.7 11.3 11.3 420.7 0 432l11.3 11.3 57.4 57.4L80 512zM432 22.6L489.4 80l-135 135L297 157.7l135-135zM285.7 169L343 226.3 80 489.4 22.6 432l263-263z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fast',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      'M236.1 120L416 0 608 128l29.5 192 2.5 16H623.8 463.3L461 320H621.4L593.3 137.4 416 19.2 250.5 129.6l-4.3-2.9L236.1 120zM16.2 512H0l2.3-16L32 288 224 160 416 288l29.7 208 2.3 16H431.8 16.2zm305.6-16L232 348.5V496h89.8zM216 184.6L46.8 297.3 18.4 496H216V184.6zM401.2 297.3L232 184.6V317.8L340.5 496h89.1L401.2 297.3z'
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fast',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      'M350.6 172.7l159-159L498.3 2.3l-159 159-64-64L264 86.1 252.7 97.4 .2 349.8C-.2 367.1 .6 384 3.8 401c4 21.4 13.1 51.4 35.2 71.9c20.6 22.1 50.6 31.2 71.9 35.2c17 3.2 34 4 51.2 3.6L414.6 259.3 425.9 248l-11.3-11.3-64-64zM50.7 462.1l-.4-.4-.4-.4c-18.3-17-26.5-42.8-30.4-63.2c-2.6-13.6-3.5-27.3-3.4-41.5L200 172.7V304v8h8H339.3L155.5 495.9c-14.2 .1-28-.8-41.5-3.4c-20.4-3.8-46.2-12.1-63.2-30.4zM355.3 296H216V156.7l48-48L403.3 248l-48 48zM432 368a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fast',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      'M496 208L16 208 16 48l480 0V208zm16 16V208 48 32H496 16 0V48 208v16H16l480 0h16zm0 248V296v-8h-8L8 288H0v8V472v8H8l496 0h8v-8zM16 464l0-160 480 0V464L16 464z'
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fast',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM146.2 375.7l-4.4-15.4 224-64 4.4 15.4-224 64zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fast',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      'M106.6 2.1l10.8 11.8L36.6 88H472c57.4 0 104 46.6 104 104v56 8H560v-8V192c0-48.6-39.4-88-88-88H36.6l80.8 74.1-10.8 11.8-96-88L4.2 96l6.4-5.9 96-88zM80.2 512H64l2.3-16L96 288 288 160 480 288l29.7 208 2.3 16H495.8 80.2zm305.6-16L296 348.5V496h89.8zM280 184.6L110.8 297.3 82.4 496H280V184.6zM465.2 297.3L296 184.6V317.8L404.5 496h89.1L465.2 297.3z'
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fast',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      'M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7l84 84V136v-8h8H288c48.6 0 88 39.4 88 88c0 40.3-27.1 74.2-64 84.7L431.3 420zM192 180.7L298.5 287.2c34.8-5.1 61.5-35.1 61.5-71.2c0-39.8-32.2-72-72-72H192v36.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176 40V249.9l16 16V288h22.1l16 16H192v72 8H176v-8V296z'
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fast',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      'M410.3 207l79-79L384 22.6l-79 79L410.3 207zm-9.8 12.8L292.2 111.5 108.9 172.6 18.1 467.5l7.5 7.5L163.1 337.5c-7-9.3-11.1-21-11.1-33.5c0-30.9 25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56c-12.6 0-24.2-4.1-33.5-11.1L37 486.3l7.5 7.5 294.9-90.7 61.1-183.3zM352 416L40 512 0 472 96 160 288 96l84.7-84.7L384 0l11.3 11.3L500.7 116.7 512 128l-11.3 11.3L416 224 352 416zM168 304a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z'
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fast',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      'M352 0H540.6l-3.2 16H352C221 16 137 69.7 85.5 123.1c-25.9 26.8-43.6 53.6-54.8 73.7c-2.3 4-4.2 7.8-6 11.2H499l-3.2 16H17.2 0s2.1-6 6.9-16C31.3 156.8 124.5 0 352 0zM636.6 16l-18.3 85.5 5.8-29.1L569.6 326.7 529.9 512H480.8 464.4l3.4-16 27.4-128 3.4-16H482.3 416 400 384V336 304 288h16 16 96.4L574.1 0h49.1 15.3 1 .4l-3.4 16zM416 336h82.7 19.8l-4.1 19.4L484.2 496h32.7l37-172.6L619.8 16H587.1l-59 275.4L525.4 304H512.4 416 400v32h16z'
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fast',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1L512 197.5V40 32h-8H392h-8v8V87.7L293.2 9.9zM496 48V183.7l-96-82.3V48h96zm0 156.8V496H80V204.8L288 26.5 496 204.8zM224 184h-8v8V320v8h8H352h8v-8V192v-8h-8H224zm8 128V200H344V312H232z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fast',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-341.7-5.7l-5.7 5.7 5.7 5.7 120 120 5.7 5.7L307.3 376l-5.7-5.7L187.3 256 301.7 141.7l5.7-5.7L296 124.7l-5.7 5.7-120 120z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fast',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      'M312.8 320c34-32.1 55.2-77.6 55.2-128c0-97.2-78.8-176-176-176S16 94.8 16 192c0 50.4 21.2 95.9 55.2 128H48.9C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128H312.8zM56 352h8H320h8v8 24 5.1l-4.6 2.1L224 437.1V504v8H208v-8V432v-5.1l4.6-2.1L312 378.9V368H72v10.9l99.4 45.9 4.6 2.1V432v72 8H160v-8V437.1L60.6 391.3 56 389.1V384 360v-8zM224 176c0 22.1-17.9 40-40 40h-8V200h8c13.3 0 24-10.7 24-24v-8h16v8zm80 8v8c0 22.1-17.9 40-40 40h-8V216h8c13.3 0 24-10.7 24-24v-8h16zm-64 72c0 22.1-17.9 40-40 40h-8V280h8c13.3 0 24-10.7 24-24v-8h16v8z'
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fast',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H496V204.8L288 26.5zM256 176h64 8v8 64h64 8v8 64 8h-8H328v64 8h-8H256h-8v-8V328H184h-8v-8V256v-8h8 64V184v-8h8zm8 80v8h-8H192v48h64 8v8 64h48V320v-8h8 64V264H320h-8v-8V192H264v64z'
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fast',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      'M319.7 331.5L331.8 416H352h16 16v16 32 16H368 352 304 276.2l-3.9-27.5L260.2 368H160c-35.3 0-64-28.7-64-64V192 176 160h16 16 32 16 16v16 16h16 48 16 16v16 32 16H272 256 208 192v16 16 16h16 80 27.8l3.9 27.5zM352 432H331.8 317.9l-2-13.7-12.1-84.5-2-13.7H288 192 176V304 256 240h16 64 16V208H256 192 176V192 176H160 128 112v16V304c0 26.5 21.5 48 48 48H260.2h13.9l2 13.7 12.1 84.5 2 13.7H304h48 16V432H352zM176 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zM16 136V432H216h8v16h-8H8 0v-8V136v-8H16v8z'
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fast',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      'M52.8 272L16 110.2V48h96v62.2L75.2 272H52.8zM128 32H112 16 0V48v64L40 288H88l40-176V48 32zM244.8 272L208 110.2V48h96v62.2L267.2 272H244.8zM320 32H304 208 192V48v64l40 176h48l40-176V48 32z'
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fast',
    iconName: 'phone-plus',
    icon: [
      640,
      512,
      [],
      'f4d2',
      
      'M512 512C264.6 512 64 311.4 64 64l0-32L208 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L432 288l144 80L544 512H512zM80 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L436 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C286.2 348.3 227.7 289.8 190 218.5l-6.2-11.7 10.3-8.3L267.4 140 199.8 18.2 80 44.8 80 64zM480 16v8 80h80 8v16h-8H480v80 8H464v-8V120H384h-8V104h8 80V24 16h16z'
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fast',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      'M66.1 33.1l7.3 1.3 80 13.8 7.9 1.4-2.7 15.8-7.9-1.4L77.9 51.4 23.4 267.7C47.8 231.7 89.2 208 136 208c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c46.8 0 88.2 23.7 112.6 59.7L498.1 51.4 425.4 63.9l-7.9 1.4-2.7-15.8 7.9-1.4 80-13.8 7.3-1.3 1.8 7.2 64 253.8 .2 1v1 40 8c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-13.9 2.1-27.4 6-40H266c3.9 12.6 6 26.1 6 40c0 75.1-60.9 136-136 136S0 419.1 0 344v0-8V296v-1l.2-1 64-253.8 1.8-7.2zM560 344a120 120 0 1 0 -240 0 120 120 0 1 0 240 0zM16 344c0 66.3 53.7 120 120 120s120-53.7 120-120s-53.7-120-120-120S16 277.7 16 344v0z'
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faBinary = {
    prefix: 'fast',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      'M232 0h-8V16h8 64V208H232h-8v16h8 72 72 8V208h-8H312V8 0h-8H232zM8 288H0v16H8 72V496H8 0v16H8 80h72 8V496h-8H88V296v-8H80 8zM16 0V8 216v8h8H168h8v-8V8 0h-8H24 16zM32 16H160V208H32V16zM216 288h-8v8V504v8h8H360h8v-8V296v-8h-8H216zm8 208V304H352V496H224z'
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fast',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      'M404.6 288.4l53.9-53.9c50-50 50-131 0-181s-131-50-181 0l-53.9 53.9-4.8 4.8L212 112c-50.5-1-101.2 17.7-139.7 56.2c-75 75-75 196.5 0 271.5s196.5 75 271.5 0C382.3 401.3 401 350.5 400 300l-.1-6.8 4.8-4.8zm65.2-42.6L416 299.7c1.1 54.7-19.2 109.7-60.9 151.4c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c41.7-41.7 96.7-62 151.4-60.9l53.9-53.9c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6zM170.5 234.5c-40 40-44.8 95.1-16.4 123.4s83.5 23.6 123.4-16.4s44.8-95.1 16.4-123.4s-83.5-23.6-123.4 16.4zm134.8-27.7c37 37 27.1 102.6-16.4 146.1s-109.1 53.4-146.1 16.4s-27.1-102.6 16.4-146.1s109.1-53.4 146.1-16.4z'
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fast',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM480 240h3.3l2.3-2.3L515.3 208H600h8v-8V72 64h-8H544V40 32H528v8V64H193l20.3 16H528h16 48V192H512h-3.3l-2.3 2.3L476.7 224h-81l20.3 16H480zM48 224V133L32 120.4V232v8h8 84L68 464l-4 16H80.5 240l40.8-163.2L267 305.9 227.5 464H84.5l56-224h43l-20.3-16H48zm488-80h8V128h-8H274.1l20.3 16H536z'
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fast',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      'M0 272v-8V96 88H8 419.3L346.6 21.9l-5.9-5.4L351.5 4.7l5.9 5.4 88 80 6.5 5.9-6.5 5.9-88 80-5.9 5.4-10.8-11.8 5.9-5.4L419.3 104H16V264v8H0zm512-32v8V416v8h-8H92.7l72.7 66.1 5.9 5.4-10.8 11.8-5.9-5.4-88-80L60.1 416l6.5-5.9 88-80 5.9-5.4 10.8 11.8-5.9 5.4L92.7 408H496V248v-8h16zM240 192h32 8v8V312v8H264v-8V208H240h-8V192h8z'
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fast',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      'M133.7 42.3L128 36.7l-5.7 5.7-104 104L12.7 152 24 163.3l5.7-5.7L120 67.3V472v8h16v-8V67.3l90.3 90.3 5.7 5.7L243.3 152l-5.7-5.7-104-104zM296 48h-8V64h8 80 8V48h-8H296zm0 144h-8v16h8H440h8V192h-8H296zm0 128h-8v16h8H504h8V320h-8H296zm0 128h-8v16h8H568h8V448h-8H296z'
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fast',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      'M256 17.2l-5.8 2.2L42.7 99.9l-9.6 3.7-.6 10.3c-2.8 47.8 4.7 121.5 36 193.6c31.4 72.4 87.2 143.6 181.1 184.3l6.4 2.7 6.4-2.7C356.2 451.2 412 379.9 443.5 307.5c31.3-72.1 38.8-145.8 36-193.6l-.6-10.3-9.6-3.7L261.8 19.4 256 17.2zM494.3 92.5l1.2 20.5c2.9 50-4.9 126.3-37.3 200.9c-32.7 75.2-91.1 150-189.4 192.6L256 512l-12.7-5.5C144.9 463.9 86.5 389.2 53.9 313.9C21.4 239.3 13.6 162.9 16.6 113l1.2-20.5L36.9 85 244.4 4.5 256 0l11.6 4.5L475.1 85l19.2 7.4z'
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fast',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      'M368 352V496H16V16H208V168v8h8H368v80h16V160L224 0H16 0V16 496v16H16 368h16V496 352H368zm-6.6-192H224V22.6L361.4 160zm92.3 26.3l-5.7-5.7L436.7 192l5.7 5.7L540.7 296H200h-8v16h8H540.7l-98.3 98.3-5.7 5.7L448 427.3l5.7-5.7 112-112 5.7-5.7-5.7-5.7-112-112z'
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fast',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      'M104 0H248h8V16h-8H123.3l168 168h57.4L506.3 26.3l5.7-5.7L523.3 32l-5.7 5.7-160 160-2.3 2.3H352 288h-3.3l-2.3-2.3L112 27.3V152v8H96v-8V8 0h8zM416 464V384c-62.3-20.8-129.7-20.8-192 0v80L64 512 0 384c37.3-48 153.6-144 320-144s282.7 96 320 144L576 512 416 464zM208 384V372.5l10.9-3.6c65.6-21.9 136.5-21.9 202.1 0l10.9 3.6V384v68.1l135.7 40.7L621 386.1C580.1 339 471.7 256 320 256S59.9 339 19 386.1L72.3 492.8 208 452.1V384z'
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fast',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      'M352.8 88.5l-12-13.9c-15.7-18.2-31.4-33.7-43.3-44.8c-3.6-3.3-6.8-6.2-9.5-8.6c-2.6 2.3-5.7 5.1-9.1 8.3c-11.7 10.8-27.3 26.1-42.8 44c-15.6 18-30.8 38.2-42 59c-11.3 20.9-18.1 41.3-18.1 59.7c0 31 9.8 59.8 26.5 83.3c-2.3 2.5-4.5 5-6.6 7.6c-4.2-3-8.5-5.8-13.1-8.4c-14.5-24.1-22.9-52.3-22.9-82.5c0-88.4 128-192 128-192s25.8 20.9 54.2 51.9c3.5 3.9 7.1 7.9 10.7 12c3.8-4.3 7.5-8.3 10.9-11.9C375.6 39.7 384 32.2 384 32.2s96 86.4 96 160c0 30.2-8.3 58.4-22.9 82.5c-4.5 2.6-8.9 5.3-13.1 8.4c-2.1-2.6-4.3-5.1-6.6-7.6c16.7-23.5 26.5-52.2 26.5-83.3c0-31-20.8-67.2-44.6-97.8C407.8 79.6 396.2 66.9 387.5 58c-1.2-1.3-2.4-2.5-3.5-3.6c-5.2 5.2-11.8 12.1-19 20.3L352.8 88.5zM238.4 246.3C229.2 232 224 214.4 224 194.2c0-15.1 4.8-28.8 13.5-43.8c8.6-14.8 21.4-31.2 37.9-51.5l6.2-7.7 6.2 7.7c2.3 2.8 19.9 25.4 36.9 47.3L347.9 176l4 5.1 31.5-41.2 6.4-8.4 6.3 8.4c3.7 5 6.2 9.9 8.4 14.2c0 0 0 0 0 .1c16.2 29.6 14.9 65.6-2.3 92.6c-4.6-2.8-9.3-5.3-14.2-7.6c14.6-22 16.2-52.2 2.3-77.5l-.1-.3s0 0 0 0c-.4-.9-.9-1.8-1.3-2.6l-30.7 40.2-6.3 8.3-6.4-8.2 6.3-4.9-6.3 4.9s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.1-.2-.6-.7-2.1-2.7-7.5-9.7-23.1-29.7c-11.7-15-23.6-30.2-30.6-39.2c-13.4 16.6-23.4 29.9-30.2 41.7c-7.8 13.4-11.3 24.4-11.3 35.7c0 17.8 4.7 32.8 12.6 44.6c-4.9 2.3-9.6 4.8-14.2 7.5zM112 288c30.7 0 58.5 12.4 78.8 32.4c4.2 4.1 8 8.6 11.5 13.3c2.3-5.4 5-10.7 8-15.7c22.4-37.2 63.1-62 109.7-62s87.3 24.9 109.7 62c3 5 5.7 10.2 8 15.7c3.5-4.7 7.3-9.2 11.5-13.3c20.2-20 48.1-32.4 78.8-32.4c61.9 0 112 50.1 112 112l0 96 0 16-16 0-96 0-208 0-208 0-96 0L0 512l0-16 0-96c0-61.9 50.1-112 112-112zM624 400c0-53-43-96-96-96c-31.7 0-59.9 15.4-77.4 39.2L434 365.7 423 340c-17.1-40-56.8-68-103-68s-85.9 28-103 68l-11 25.7-16.6-22.5C171.9 319.4 143.7 304 112 304c-53 0-96 43-96 96l0 96 96 0 208 0 208 0 96 0 0-96z'
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fast',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      'M380.3 32.2C343.5 11.7 301.1 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-27.3-4.3-53.7-12.2-78.4c-4.6 2.8-9.5 5.2-14.5 7.2c7 22.5 10.7 46.4 10.7 71.2c0 132.5-107.5 240-240 240S16 388.5 16 256S123.5 16 256 16c41.8 0 81.1 10.7 115.4 29.5c2.9-4.6 5.9-9.1 9-13.3zm10.9 296.4c-23.3 51.6-75 87.5-135 87.5s-111.7-35.8-135-87.5c40.9 12.4 86.7 19.3 135 19.3s94.1-6.9 135-19.3zm7.1-19.1c-42.1 14.2-90.5 22.3-142 22.3s-99.9-8.1-142-22.3c-6.2-2.1-12.3-4.3-18.2-6.7c1.4 6.5 3.3 12.9 5.4 19.2c22.5 64.1 83.3 110 154.8 110s132.3-45.9 154.8-110c2.2-6.2 4-12.6 5.4-19.2c-5.9 2.4-12 4.6-18.2 6.7zm-262.6-84c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9zm175.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9c2.5-13.5 7.8-28.4 15.2-39.8zM496 101.3c0 22.4-20.2 42.7-48 42.7s-48-20.4-48-42.7c0-4.6 1.7-11 5.9-19.4c4-8.1 9.8-16.9 16.4-25.8C431 44.4 440 34 448 24.8c1.7 2 3.5 4 5.2 6.1c6.7 7.9 13.9 16.5 20.5 25.3c6.6 8.9 12.4 17.6 16.4 25.8c4.1 8.3 5.9 14.8 5.9 19.3zM436.9 13.1C415.9 37.4 384 74.3 384 101.3c0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-26.7-31.5-63.3-52.4-87.5l-1.1-1.3C454.4 7.7 450.8 3.5 448 0c-2.9 3.5-6.5 7.7-10.5 12.4l-.6 .7z'
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fast',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      'M603.1 64H608h24 8v8V224 392v8h-8H608h-4.9l-2.2-4.4 0 0 0 0 0 0 0 0-.1-.2c-.1-.2-.3-.5-.5-1c-.5-.9-1.2-2.2-2.2-3.8c-1.9-3.3-4.9-8.2-8.9-14c-8-11.6-20.1-27.2-36.6-42.7c-33-31-83.1-61.8-152.5-61.8H368V400h32c35.3 0 64-28.7 64-64c0-7.8-1.4-15.2-3.9-22.1c6.5 2.2 12.7 4.8 18.6 7.6c.9 4.7 1.3 9.6 1.3 14.6c0 44.2-35.8 80-80 80H368 352 280 264 192 176 144c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64H16v8 8H0v-8V184v-8H16v8 8H176V160v-8h16v8 32h72V160v-8h16v8 32h72V160v-8h16v8 32h32c69.4 0 119.5-30.8 152.5-61.8c16.5-15.5 28.6-31.1 36.6-42.7c4-5.8 7-10.6 8.9-14c1-1.7 1.7-3 2.2-3.8c.2-.4 .4-.8 .5-1l.1-.2 0 0 0 0 0 0 0 0 2.2-4.4zM144 256h32 16 72 16 72 16 32c74.6 0 128.5 33.2 163.5 66.2c17.5 16.5 30.4 32.9 38.9 45.3c4.3 6.2 7.4 11.4 9.5 15l.9 1.5H624V224 80H612.8l-.9 1.5c-2.1 3.7-5.3 8.8-9.5 15c-8.5 12.4-21.4 28.8-38.9 45.3c-35 33-88.9 66.2-163.5 66.2H368 352 280 264 192 176 16v48H144zm0 16c-35.3 0-64 28.7-64 64s28.7 64 64 64h32V272H144zm48 0V400h72V272H192zm88 0V400h72V272H280z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fast',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M16 166.7V56 48H0v8V184v8H8 136h8V176h-8H29.7C62.6 82.8 151.5 16 256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240c-73.5 0-139.3-33.1-183.4-85.2l-5.2-6.1L55.2 415.1l5.2 6.1C107.3 476.7 177.6 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C146 0 52.2 69.4 16 166.7zM264 128H248v8V256v3.3l2.3 2.3 88 88 5.7 5.7L355.3 344l-5.7-5.7L264 252.7V136v-8z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fast',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      'M80 128v96H64V128C64 57.3 121.3 0 192 0s128 57.3 128 128v96H304V128c0-61.9-50.1-112-112-112S80 66.1 80 128zM631 496c5.3 9.9 9 16 9 16H621.5 306.5 288s3.7-6.1 9-16c13.9-25.8 39-77.3 39-112V352c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 34.7 25.1 86.2 39 112zm-18.1 0c-3.5-6.8-7.5-14.7-11.4-23.3c-12-26-25.5-60.8-25.5-88.7V352c0-61.9-50.1-112-112-112s-112 50.1-112 112v32c0 27.9-13.5 62.7-25.5 88.7c-4 8.6-7.9 16.5-11.4 23.3H612.9zM464 288.6l7.2 14.8c11.7 24 36.3 40.6 64.8 40.6c2.3 0 4.6-.1 6.9-.3l9.6-.9-.9 9.6C547.4 397.1 509.8 432 464 432s-83.4-34.9-87.6-79.6l-.9-9.6 9.6 .9c2.3 .2 4.6 .3 6.9 .3c28.5 0 53.1-16.5 64.8-40.6l7.2-14.8zm0 34c-15.6 22.2-41.2 36.8-70.2 37.4c7.3 32.1 36 56 70.2 56s63-23.9 70.2-56c-29-.6-54.6-15.2-70.2-37.4zM190.7 35.7l7.2 14.8c11.7 24 36.3 40.6 64.8 40.6c2.3 0 4.6-.1 6.9-.3l9.6-.9-.9 9.6c-4.2 44.7-41.8 79.6-87.6 79.6s-83.4-34.9-87.6-79.6l-.9-9.6 9.6 .9c2.3 .2 4.6 .3 6.9 .3c28.5 0 53.1-16.5 64.8-40.6l7.2-14.8zm0 34c-15.6 22.2-41.2 36.8-70.2 37.4c7.3 32.1 36 56 70.2 56s63-23.9 70.2-56c-29-.6-54.6-15.2-70.2-37.4zM55.2 496H260.3l-9.6 16H48s-48-48-48-128c0-44.4 20.2-84.4 37.9-119.4l0 0c1.5-2.9 2.9-5.8 4.3-8.6H336c-3.8 5.1-7.4 10.4-10.6 16H52.1C34.2 307.4 16 343.9 16 384c0 36.7 11 66.1 22 86.3c6.5 12 13.1 20.7 17.2 25.7z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fast',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM288 93.8l-9.9 2.5-64 16-6.1 1.5V120v64 54.4c-10.2-8.9-24.3-14.4-40-14.4c-30.9 0-56 21.5-56 48s25.1 48 56 48s56-21.5 56-48V190.2l57.9-14.5 6.1-1.5V168 104 93.8zM168 240c24.5 0 40 16.6 40 32s-15.5 32-40 32s-40-16.6-40-32s15.5-32 40-32zm56-66.2V126.2l48-12v47.5l-48 12z'
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fast',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      'M336 16V256h16V16 0H336 112 96V16 256h16V16H336zM232 448V384H400h16V368 352l-32-64H64L32 352v16 16H48 216v64H136h-8v8 48 8h16v-8V464h72v40 8h16v-8V464h72v40 8h16v-8V456v-8h-8H232zM48 160H32v8 80 8H48v-8V168v-8zm368 0H400v8 80 8h16v-8V168v-8zM48 368V355.8L73.9 304H374.1L400 355.8V368H232 216 48z'
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fast',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      'M115.8 171.8l10.2 5.1 8.1-7.9C183.3 121 255.4 80 320 80c81.6 0 141.6 44.4 182 90.5c20.1 23 35 46.1 44.9 63.4c4.9 8.6 8.6 15.8 11 20.8l.6 1.3-.6 1.3c-2.4 5-6 12.1-11 20.8c-9.9 17.3-24.8 40.4-44.9 63.4C461.6 387.6 401.6 432 320 432c-69.2 0-146.8-47-195.6-98.7l-9.1-9.6-11.2 7.1L16 386.9V370.2L47.4 260.4l1.3-4.4-1.3-4.4L16 141.8V121.9l99.8 49.9zM320 64c-70.4 0-146.4 44.1-197.1 93.5L16 104 0 96v17.9V144L32 256 0 368v29 19l16-10.2 96.8-61.6C163.1 397.6 244.7 448 320 448c176 0 256-192 256-192s-80-192-256-192zM309.7 165.7l5.7-5.7L304 148.7l-5.7 5.7-64 64-5.7 5.7L240 235.3l5.7-5.7 64-64zm112 16l5.7-5.7L416 164.7l-5.7 5.7-160 160-5.7 5.7L256 347.3l5.7-5.7 160-160zm16 112l5.7-5.7L432 276.7l-5.7 5.7-64 64-5.7 5.7L368 363.3l5.7-5.7 64-64z'
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fast',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      'M83.3 11.3L72 0 60.7 11.3 11.3 60.7 0 72 11.3 83.3 153.4 225.4l11.3-11.3L22.6 72 72 22.6 214.1 164.7l11.3-11.3L83.3 11.3zM304 408c0 54.7 42.3 99.6 96 103.7v.3h8 8 96 32 16 16V496 464 448H560 544 528 512V432 408c0-57.4-46.6-104-104-104c-.9 0-1.9 0-2.8 0l-18.6 18.6c6.8-1.7 14-2.6 21.4-2.6c48.6 0 88 39.4 88 88v40 16h16 32 16v32H544 512 408h-3.4l-3.4-.3C355.8 492.3 320 454.3 320 408c0-7.4 .9-14.5 2.6-21.4L304 405.2c0 .9 0 1.9 0 2.8zM36.4 494.4L32 512l17.6-4.4L192 472 532.7 131.3 544 120l-11.3-11.3L435.3 11.3 424 0 412.7 11.3 72 352 36.4 494.4zM54 490L86.4 360.2 345.7 101 443 198.3 183.8 457.6 54 490zM521.4 120l-67 67L357 89.7l67-67L521.4 120z'
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fast',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      'M128 48V96v48H496V48H128zm-16 0H16v96h96V96 48zM16 160V464H496V160H120 16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32z'
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fast',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      'M624 16V80H16V16H624zM16 0H0V16 80 96H16 32V504v8h8H152h8v-8V352c0-88.4 71.6-160 160-160s160 71.6 160 160V504v8h8H600h8v-8V96h16 16V80 16 0H624 16zM48 496V96H592V496H496V352c0-97.2-78.8-176-176-176s-176 78.8-176 176V496H48zM331.1 299.2l-33.5-33.5C267.7 284.4 208 337.4 208 400.1c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.7-13.4-67.2-67.2-112l-11.1 11.1-11.3 11.3-11.3-11.3zm34.4 10.9c41.3 39.1 50.5 77.8 50.5 90c0 29.3-13.1 55.6-33.8 73.2c3.3-7.4 5-15.4 5-23.9c0-49.3-67.2-94.1-67.2-94.1s-67.2 44.8-67.2 94.1c0 8.5 1.8 16.5 5 23.9c-20.7-17.6-33.8-43.9-33.8-73.2c0-26.3 12.6-51.8 30.1-73.8c13.4-16.8 28.9-30.6 41.6-40l35.4 35.4 11.3 11.3 11.3-11.3 11.7-11.7zM320 496.1c-29.3 0-51.2-21.9-51.2-46.7c0-18 12.8-37.5 29.1-54.4c7.8-8 15.6-14.7 21.5-19.4l.6-.5 .6 .5c5.9 4.7 13.7 11.3 21.5 19.4c16.3 16.9 29.1 36.4 29.1 54.4c0 24.8-21.9 46.7-51.2 46.7z'
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fast',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      'M248 505l8 7 8-7L500 298.5l4.4-3.8L512 288l-8.7-9.8-1.9-2.2L269.8 15.5 266.7 12l-4.6-5.2L256 0l-6.1 6.9L245.3 12l-3.1 3.5L10.6 276l-1.9 2.2L0 288l7.6 6.7 4.4 3.8L248 505zM27.6 290.9l138.5-26.4L248 324.1V483.7L27.6 290.9zM177.5 253L256 24.6 334.5 253 256 310.1 177.5 253zM283.3 54.8L477.5 273.3 350.1 249 283.3 54.8zM484.4 290.9L264 483.7V324.1l81.9-59.6 138.5 26.4zM228.7 54.8L161.9 249 34.5 273.3 228.7 54.8z'
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fast',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      'M176 48V208H16V48H176zM16 32H0V48 208v16H16 176h16V208 48 32H176 16zM176 304V464H16V304H176zM16 288H0v16V464v16H16 176h16V464 304 288H176 16zM272 48H432V208H272V48zM256 32V48 208v16h16H432h16V208 48 32H432 272 256zm0 256v8V472v8h16v-8V304h32V408v8h8 48 8v-8V304h32V408v8h8 32 8V400h-8H416V296v-8h-8H360h-8v8V400H320V296v-8h-8H264h-8zm80-176h32v32H336V112zM320 96v16 32 16h16 32 16V144 112 96H368 336 320zM112 112v32H80V112h32zM80 96H64v16 32 16H80h32 16V144 112 96H112 80zm0 272h32v32H80V368zM64 352v16 32 16H80h32 16V400 368 352H112 80 64zm256 96v32h32V448H320zm128 0H416v32h32V448z'
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fast',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM467.3 464H48V133L32 120.4V464v16H48 487.5l-20.3-16zM592 32H152.5l20.3 16H592V379l16 12.6V48 32H592zM456.5 272l20.3 16H496h8V272h-8H456.5zM144 272h-8v16h8H244.3l-20.3-16H144zm160 96h-8v16h8 61.9l-20.3-16H304zm-160 0h-8v16h8 96 8V368h-8H144z'
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fast',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      'M432 48H16V464H284.5c3.6 5.6 7.6 10.9 11.8 16H16 0V464 48 32H16 432h16V48 192.7c-5.3-.5-10.6-.7-16-.7V48zM224 96c69.3 0 128.3 44 150.5 105.6c-5.1 1.8-10 3.7-14.9 5.9C339.7 151.8 286.5 112 224 112c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c.8 5.3 1.9 10.5 3.2 15.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm16 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM508.5 470.7L476.3 432H387.7l-32.2 38.7C376.9 486.6 403.3 496 432 496s55.1-9.4 76.5-25.3zm12.2-10.3C544.9 437 560 404.3 560 368c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 36.3 15.1 69 39.3 92.3l34.5-41.4 2.4-2.9H384h96 3.7l2.4 2.9 34.5 41.4zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fast',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      'M61.9 90.3C51.9 98.2 48 105.6 48 112c0 5.6 2.9 11.8 10.2 18.5s18.3 13.3 32.9 19.3l5 2v5.4V336v16h32V336 171.9v-10l9.7 2.2c23.3 5.2 50 8.9 78.8 10.7l7.5 .5v7.5V288v16h32V288 184 176l7.9-.1c57.2-.7 108.3-8.9 144.8-21.5c18.3-6.3 32.5-13.6 42-21.2c9.5-7.7 13.3-14.9 13.3-21.2c0-6.4-3.9-13.8-13.9-21.7c-9.9-7.8-24.8-15.2-43.9-21.6c-15.7-5.2-34-9.7-54.2-13.1V96v16H336 176 160V96 55.6c-20.2 3.4-38.5 7.8-54.2 13.1C86.7 75 71.9 82.4 61.9 90.3zM176 53.2V96H336V53.2c-24.6-3.3-51.6-5.2-80-5.2s-55.4 1.8-80 5.2zm-75.3 .3C140.8 40.1 195.7 32 256 32s115.2 8.1 155.3 21.5c20 6.7 36.8 14.8 48.7 24.2c11.8 9.3 20 20.9 20 34.3c0 13.1-7.8 24.5-19.2 33.7c-11.5 9.3-27.6 17.3-46.8 23.9c-36.8 12.7-86.7 20.9-142 22.2V288v24 8h-8H216h-8v-8V288 190.2c-22.8-1.7-44.4-4.6-64-8.5V336v24 8h-8H88 80v-8V336 162.5c-13.3-5.9-24.5-12.7-32.7-20.2C38.1 133.8 32 123.6 32 112c0-13.4 8.2-25 20-34.3C64 68.3 80.7 60.2 100.7 53.5zM16 168c0 15.9 9.7 30.9 32 43.8v18.1c-8.8-4.4-16.6-9.3-23.1-14.6C18.8 223.2 16 231.5 16 240c0 15.9 9.7 30.9 32 43.8v18.1c-8.8-4.4-16.6-9.3-23.1-14.6C18.8 295.2 16 303.5 16 312c0 15.9 9.7 30.9 32 43.8V368v5.9c-8.8-4.4-16.6-9.3-23.1-14.6C18.8 367.2 16 375.5 16 384c0 22.1 18.8 42.5 64.1 57.9c44 14.9 106 22.1 175.9 22.1s131.9-7.3 175.9-22.1C477.2 426.5 496 406.1 496 384c0-8.5-2.8-16.8-8.9-24.7C445.9 392.8 357.9 408 256 408c-27.9 0-54.8-1.1-80-3.5V388.4c24.9 2.4 51.8 3.6 80 3.6c69.9 0 131.9-7.3 175.9-22.1C477.2 354.5 496 334.1 496 312c0-8.5-2.8-16.8-8.9-24.7C452.6 315.4 385 330.6 304 334.8v-16c50.2-2.6 94.3-9.6 127.9-20.9C477.2 282.5 496 262.1 496 240c0-8.5-2.8-16.8-8.9-24.7C452.6 243.4 385 258.6 304 262.8v-16c50.2-2.6 94.3-9.6 127.9-20.9C477.2 210.5 496 190.1 496 168c0-3.3-.4-6.6-1.3-9.8c4-4.8 7.6-10.3 10.6-16.5c4.4 8 6.7 16.7 6.7 26.2c0 13.5-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36s-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36s-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36c0 66.7-114.6 96-256 96S0 450.7 0 384c0-13.5 4.7-25.5 13.4-36C4.7 337.5 0 325.5 0 312s4.7-25.5 13.4-36C4.7 265.5 0 253.5 0 240s4.7-25.5 13.4-36C4.7 193.5 0 181.5 0 168c0-9.5 2.3-18.3 6.7-26.3c2.9 6.2 6.6 11.7 10.6 16.5c-.9 3.2-1.3 6.5-1.3 9.8z'
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fast',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      'M56 32H48v8V160H16 0v16V464v16H16 368h16V464 398.5 370.8 269.2 241.5 176 160H368 64V48H312h8V32h-8H56zM48 176H64 368v93.2V370.8 464H16V176H48zM560 455.9L416 394.9v17.4l144 60.9 16 6.8V462.6 177.4 160l-16 6.8L416 227.7v17.4l144-60.9V455.9zM64 240v16h8H312h8V240h-8H72 64z'
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fast',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M50.3 250.3L44.7 256l5.7 5.7 176 176 5.7 5.7L243.3 432l-5.7-5.7L67.3 256 237.7 85.7l5.7-5.7L232 68.7l-5.7 5.7-176 176zm192 0l-5.7 5.7 5.7 5.7 176 176 5.7 5.7L435.3 432l-5.7-5.7L259.3 256 429.7 85.7l5.7-5.7L424 68.7l-5.7 5.7-176 176z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fast',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M16 16V496H144V384 368h16 64 16v16V496H368V16H16zM160 496h64V384H160V496zm-16 16H16 0V496 16 0H16 368h16V16 496v16H368 240 224 160 144zM80 232h64 8v8 64 8h-8H80 72v-8V240v-8h8zm8 64h48V248H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V240v-8zm16 16v48h48V248H248zM80 104h64 8v8 64 8h-8H80 72v-8V112v-8h8zm8 64h48V120H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V112v-8zm16 16v48h48V120H248z'
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fast',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      'M0 80V64H16 560h16V80 192v16c-26.5 0-48 21.5-48 48s21.5 48 48 48v16V432v16H560 16 0V432 320 304c26.5 0 48-21.5 48-48s-21.5-48-48-48V192 80zM16 194c27.6 7.1 48 32.2 48 62s-20.4 54.9-48 62V432H560V318c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62V80H16V194z'
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fast',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm42.4 15l20.2 36.9L301 83l4.1 2.3 36.9 20.2-1 42-.1 4.7 2.4 4L365.3 192l-21.9 35.9-2.4 4 .1 4.7 1 42-36.9 20.2L301 301l-2.3 4.1-20.2 36.9-42-1-4.7-.1-4 2.4L192 365.3l-35.9-21.9-4-2.4-4.7 .1-42 1L85.2 305.2 83 301l-4.1-2.3L41.9 278.6l1-42 .1-4.7-2.4-4L18.7 192l21.9-35.9 2.4-4-.1-4.7-1-42L78.8 85.2 83 83l2.3-4.1 20.2-36.9 42 1 4.7 .1 4-2.4L192 18.7l35.9 21.9 4 2.4 4.7-.1 42-1zM49.2 339.3L6.7 440 0 456H17.4 75.8L116 499.2 128 512l6.8-16.2 36.6-86.9-13.8-8.4L122.8 483 87.5 445.1 82.7 440h-7H24.1L59 357.2l-9.8-17.9zm163.4 69.7l36.6 86.9L256 512l12-12.8L308.2 456h58.4H384l-6.7-16L334.9 339.3 325 357.2 359.9 440H308.2h-7l-4.7 5.1L261.2 483l-34.7-82.5-13.8 8.4zM264 192a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176z'
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fast',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      'M72 136a88 88 0 1 1 176 0A88 88 0 1 1 72 136zm192 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm128 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm192 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM75.5 304H244.5l53.3 160H22.2L75.5 304zM256 288H64L5.3 464 0 480H16.9 303.1 320l-5.3-16L256 288zm86.2 16H617.8L564.5 464H395.5L342.2 304zM384 480H576l58.7-176 5.3-16H623.1 336.9 320l5.3 16L384 480z'
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fast',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      'M96 336c-44.2 0-80 35.8-80 80s35.8 80 80 80H544c44.2 0 80-35.8 80-80s-35.8-80-80-80H96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm144 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fast',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      'M16 8V0H0V8 32 48 336v16V504v8H16v-8V352L425 200.5l23-8.5-23-8.5L16 32V8zm0 41.1L401.9 192 16 334.9V49.1z'
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fast',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      'M505.4 90.1L472.8 19.2 464 0l-8.8 19.2L422.6 90.1 346.9 71.3l-20.5-5.1 9.5 18.8L371 154.8l-61.9 47.5-16.7 12.8 20.6 4.3 76.4 16-.9 48.9 22.2 31.1L464 271.4l60.1 49.7 16.2 13.4-.4-21.1-1.4-78 76.4-16 20.6-4.3-16.7-12.8L557 154.8l35.1-69.7 9.5-18.8-20.5 5.1L505.4 90.1zm66.3 .1l-28.9 57.4-6 11.8 10.5 8.1 51 39.2-62.9 13.2-13 2.7 .2 13.2 1.2 64.3-49.5-41L464 250.6l-10.2 8.4-49.5 41 1.2-64.3 .2-13.2-13-2.7-62.9-13.2 51-39.2 10.5-8.1-6-11.8L356.4 90.2l62.4 15.4 12.9 3.2 5.5-12L464 38.3l26.9 58.4 5.5 12 12.9-3.2 62.4-15.4zm-386.4 88l57.1-39.9 13.6-9.6 0-16.7 0-80V16H240 208 192V32l0 63.3L45.6 197.8 32 207.3V224l0 128 0 16 0 16H48l32 0H96l0-16 0-16 0-80.4 0-29.5 16 24.7L250.8 481.4l8.7 13.4 8.7 13.4 13.4-8.7 26.9-17.4 13.4-8.7L313.2 460l-8.7-13.4L222.6 320l-10.4-16 19.1 0 57.7 0 70.4 84.5 10.2 12.3 10.2 12.3 12.3-10.2 24.6-20.5 12.3-10.2-10.2-12.3-10.2-12.3-80-96L319 240l-15 0-78.6 0-40.1-61.8zM311.5 256l4.8 5.8 80 96L406.5 370l-24.6 20.5-10.2-12.3-70.4-84.5-4.8-5.8H289l-76.8 0-29.4 0 16 24.7 92.3 142.6 8.7 13.4-26.9 17.4-8.7-13.4L109.4 233.5l-9.7-15L80 232.3 80 352v16H48v0h0l0-16 0-128v-8.3l6.8-4.8L80 193.3v0l2.3-1.6 0 0 118.8-83.2 6.8-4.8V95.3L208 32h32l0 80v8.3l-6.8 4.8-57.1 39.9-12.7 8.9 8.4 13L212 248.7l4.7 7.3 8.7 0 78.6 0 7.5 0zM56 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm56 40A56 56 0 1 0 0 88a56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fast',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 72l0-8-16 0 0 8 0 368 0 8 16 0 0-8 0-368zM349.7 261.7l5.7-5.7-5.7-5.7-136-136-5.7-5.7L196.7 120l5.7 5.7L324.7 248 8 248l-8 0 0 16 8 0 316.7 0L202.3 386.3l-5.7 5.7L208 403.3l5.7-5.7 136-136z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fast',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      'M520 0l-3.3 0-2.3 2.3L469.8 46.8c-.4 .4-.7 .7-1 1.2l-.9 0c-55.2 0-100 44.8-100 100c0 19.6 5.6 37.9 15.4 53.3c-5-.9-10.1-1.3-15.4-1.3c-31.2 0-58.6 16.2-74.3 40.7C282.9 185.6 234.3 144 176 144C78.8 144 0 222.8 0 320l0 56 0 8 8 0 122.2 0L57.1 512l18.4 0 72.8-127.4 .3-.6 35.3 0c9.8 0 19.2-1.3 28.3-3.6L137.1 512l18.4 0 77.8-136.2 2.6-4.5c21.8-11.4 39.3-29.8 49.7-52.2c4.9 13 12.8 24.6 22.9 33.8L292.9 379l-.1 .1s0 0 0 0L216.9 512l18.4 0 71.3-124.8 14.7-24.5c13.5 8.5 29.5 13.4 46.6 13.4c13.1 0 25.5-2.9 36.7-8l60.4 60.4L496.8 512l17.1 0-34.5-90.8-.6-1.6-1.2-1.2L419 359.7c11.3-8.1 20.6-18.7 27.1-31.2l115 84.4L592.3 512l16.8 0L575.6 405.6l-.8-2.5-2.1-1.6-120-88-.4-.3c2.4-8 3.7-16.5 3.7-25.3c0-15.5-4-30-11-42.7c7.4 1.7 15.1 2.7 23 2.7l132 0 8 0 0-8 0-56c0-69-51.3-125.9-117.9-134.8L523.3 16 600 16l8 0 0-16-8 0L520 0zM468 64l4 0c66.3 0 120 53.7 120 120l0 48-124 0c-46.4 0-84-37.6-84-84s37.6-84 84-84zm44 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM440 288a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zM176 160c57.4 0 104 46.6 104 104l0 8c0 53-43 96-96 96L16 368l0-48c0-88.4 71.6-160 160-160z'
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fast',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      'M8 56H0V72H8 216h8V56h-8H8zM8 184H0v16H8 216h8V184h-8H8zM0 312v16H8 216h8V312h-8H8 0zM8 440H0v16H8 216h8V440h-8H8zM288 184v16h8H504h8V184h-8H296h-8zm8-128h-8V72h8H504h8V56h-8H296zm-8 256v16h8H504h8V312h-8H296h-8zm8 128h-8v16h8H504h8V440h-8H296z'
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fast',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM192 120.9l5.7 5.7 39.6 39.6L297 225.9c25 25 25 65.5 0 90.5s-65.5 25-90.5 0l-6.5-6.5V366h24 8v16h-8H200 184 160h-8V366h8 24V309.9l-6.5 6.5c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5l59.7-59.7 39.6-39.6 5.7-5.7zm0 22.6l-33.9 33.9L98.3 237.2c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0l20.1-20.1 5.7-5.7 5.7 5.7 20.1 20.1c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9l-59.7-59.7L192 143.5z'
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fast',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      'M279.8 408.2l-12.6-12.8-3.2-3.3V496h80 8v16h-8H264 248 168h-8V496h8 80V392.1l-3.2 3.3-12.6 12.8c-53.1 53.1-139.2 53.1-192.3 0s-53.1-139.2 0-192.3L256 0l0 0L472.2 215.8c53.1 53.1 53.1 139.2 0 192.3s-139.2 53.1-192.3 0zM51.1 396.9c46.9 46.8 122.8 46.9 169.7 0l0 0 23.8-24.1L256 361.2l11.4 11.6 23.8 24.1 0 0c46.9 46.8 122.8 46.8 169.7 0c46.9-46.9 46.9-122.8 0-169.7l0 0L256 22.6 51.1 227.1l0 0C4.3 274 4.3 350 51.1 396.9z'
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fast',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      'M8 16L0 16 0 0 8 0 192 0l8 0 0 8 0 476.7L330.3 354.3l5.7-5.7L347.3 360l-5.7 5.7-144 144-5.7 5.7-5.7-5.7-144-144L36.7 360 48 348.7l5.7 5.7L184 484.7 184 16 8 16z'
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fast',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      'M448 32l0 448-16 0 0-448 16 0zM336 48l0 32-32 0 0-32 32 0zm0 416l-32 0 0-32 32 0 0 32zm0-224l0 32-32 0 0-32 32 0zM144 80l-32 0 0-32 32 0 0 32zm0 352l0 32-32 0 0-32 32 0zm0-160l-32 0 0-32 32 0 0 32zM240 48l0 32-32 0 0-32 32 0zm0 416l-32 0 0-32 32 0 0 32zm0-224l0 32-32 0 0-32 32 0zM48 80L16 80l0-32 32 0 0 32zm0 352l0 32-32 0 0-32 32 0zm0-160l-32 0 0-32 32 0 0 32zM240 144l0 32-32 0 0-32 32 0zM48 176l-32 0 0-32 32 0 0 32zm0 160l0 32-32 0 0-32 32 0zm192 32l-32 0 0-32 32 0 0 32z'
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fast',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      'M480.6 6.9l88 80 6 5.4-5.5 5.9L464 211.1V272v5.3l-4.8 2.1-56 24-5 2.1-3.8-3.8-104-104-5.7-5.7 5.7-5.7L469.5 7.1l5.4-5.4 5.6 5.1zM307.3 192l94.5 94.5L448 266.7V208v-3.1l2.1-2.3L551.8 93.3 475.5 23.9 307.3 192zM11.3 468.5L243.2 231.1l11.3 11.3L25.3 477c2.7 1.4 5.8 2.8 9.2 4.3c17 7.2 42.9 14.7 77.4 14.7c111.3 0 182.7-47.6 255.4-118.2l-20.6-20.6-11.3-11.3 11.3-11.3 43.3 43.3c-3.8 3.8-7.6 7.5-11.4 11.2C304.6 461.2 229.3 512 112 512c-48.2 0-81.2-13.6-98.3-23.1C4.6 483.9 0 480 0 480l11.3-11.5zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fast',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      'M160 192l-16 0-64 0-16 0 0-16 0-16L212.7 11.3 224 0l11.3 11.3L384 160l0 16 0 16-16 0-64 0-16 0 0 16 0 128 0 16-16 0-96 0-16 0 0-16 0-128 0-16zm0-16l16 0 0 16 0 144 96 0 0-144 0-16 16 0 80 0 0-9.4L224 22.6 80 166.6l0 9.4 80 0zM16 328l0 168 416 0 0-168 0-8 16 0 0 8 0 176 0 8-8 0L8 512l-8 0 0-8L0 328l0-8 16 0 0 8z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fast',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M309.5 0l-3.4-3.3L302.9 0h-.1C275.1 29.5 235.7 48 192 48S108.9 29.5 81.1 0h-.1L77.8-3.3 74.5 0H60.1c2.1 2.7 4.3 5.2 6.5 7.8l-.1 .1L72 13.6c3.2 3.3 6.5 6.4 10 9.4c.7 .6 1.3 1.1 2 1.7c16.3 13.7 35.3 24.4 56 31.1C68.2 78 16 144.9 16 224c0 94.5 74.5 171.6 168 175.8V448H128h-8v16h8 56v40 8h16v-8V464h56 8V448h-8H200V399.8c93.5-4.2 168-81.3 168-175.8c0-79.1-52.2-146-124-168.2c17.1-5.6 33-13.8 47.2-24.2c2-1.5 4-3 6-4.6c5.2-4.2 10.2-8.7 14.9-13.5l5.6-5.7-.1-.1c2.2-2.5 4.4-5.1 6.5-7.8H309.5zM191.9 384C103.6 383.9 32 312.3 32 224c0-88.4 71.6-160 160-160s160 71.6 160 160c0 88.3-71.6 159.9-159.9 160l-.1 0-.1 0z'
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fast',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      'M144 0h-8H24 16V8 120v8H32v-8V27.3L92.7 88 74.3 106.3 68.7 112 80 123.3l5.7-5.7L104 99.3l26 26c-21.3 27.2-34 61.4-34 98.7c0 85.7 67.4 155.6 152 159.8V432H200h-8v16h8 48v56 8h16v-8V448h48 8V432h-8H264V383.8c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120v8h16v-8V8 0h-8H376h-8V16h8 92.7l-97.2 97.2C342.3 82.9 301.4 64 256 64s-86.3 18.9-115.5 49.2L115.3 88l18.3-18.3 5.7-5.7L128 52.7l-5.7 5.7L104 76.7 43.3 16H136h8V0zM256 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fast',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      'M16 16V496H368V134.6L249.4 16H16zM256 0L384 128V496v16H368 16 0V496 16 0H16 256zM80 288v64h72 80 72V288H232 152 80zm160 80v64h64V368H240zm80 80H304 240h-8-8H160h-8-8H80 64V432 208 192H80h64 8 8 64 8 8 64 16v16V432v16zM240 208v64h64V208H240zm-80 0v64h64V208H160zm-16 0H80v64h64V208zm0 224V368H80v64h64zm16 0h64V368H160v64z'
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fast',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM128 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM304 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fast',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      'M451.9 2.2l4.9 4.9 48 48 4.9 4.9-4.2 5.6-51.2 67.2-1.8 2.4-3 .6-77.6 15.5-51.1 51.1C324.5 257.7 332.9 512 176 512C78.8 512 0 433.2 0 336C0 179.1 254.3 187.5 309.5 191.2l51.1-51.1 15.5-77.6 .6-3 2.4-1.8L446.4 6.4l5.6-4.2zM294.3 206.4c-7-.3-15.2-.5-24.4-.6c-29.4-.2-68.4 1.2-107.1 8c-39 6.8-76.2 18.8-103.4 38.4C33 271.4 16 297.8 16 336c0 88.4 71.6 160 160 160c38.2 0 64.6-17 83.8-43.4c19.7-27.2 31.6-64.4 38.4-103.4c6.8-38.7 8.3-77.7 8-107.1c-.1-9.2-.3-17.5-.6-24.4l-63.1 63.1C251 291.6 256 305.2 256 320c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.8 0 28.4 5 39.2 13.4l63.1-63.1zm83.9-72.6l65.3-13.1 45.1-59.2L450.5 23.4 391.3 68.5l-13.1 65.3zM192 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fast',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM144 144v64h32V144H144zm-16-16h16 32 16v16 64 16H176 144 128V208 144 128zm112 16v64h32V144H240zm0-16h32 16v16 64 16H272 240 224V208 144 128h16zm96 16v64h32V144H336zm-16-16h16 32 16v16 64 16H368 336 320V208 144 128z'
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fast',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM197.2 136.9c-13.5-3.6-27.4 4.4-31.1 17.9l-4.3 16.1-2.1 7.7-7.7-2.1-16.1-4.3c-13.5-3.6-27.4 4.4-31.1 17.9s4.4 27.4 17.9 31.1l72.8 19.5 19.5-72.8c3.6-13.5-4.4-27.4-17.9-31.1zm-46.5 13.8c5.9-22.1 28.6-35.2 50.6-29.2s35.2 28.6 29.2 50.6L209 252.6l-2.1 7.7-7.7-2.1-80.6-21.6C96.6 230.7 83.5 208 89.4 186s28.6-35.2 50.6-29.2l8.4 2.2 2.2-8.3zm210.6 0l2.2 8.3 8.4-2.2c22.1-5.9 44.7 7.2 50.6 29.2s-7.2 44.7-29.2 50.6l-80.6 21.6-7.7 2.1-2.1-7.7-21.6-80.5c-5.9-22.1 7.2-44.7 29.2-50.6s44.7 7.2 50.6 29.2zm-46.5-13.8c-13.5 3.6-21.6 17.5-17.9 31.1l19.5 72.8 72.8-19.5c13.5-3.6 21.6-17.5 17.9-31.1s-17.5-21.6-31.1-17.9L360 176.5l-7.7 2.1-2.1-7.7-4.3-16.1c-3.6-13.5-17.5-21.6-31.1-17.9z'
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fast',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4L16 368v79.9V464l16-1.5L192 448c20.7 0 40.8 7 57 20l55 44h79.9H400l-1.8-16-6.7-59.9c-4.7-42.2 13.3-83.8 47.3-109.3L512 272V192l-74.4-27.9c-33.9-12.7-60.3-40.1-71.7-74.4L336 0H256L220.8 42.2c-27.7 33.2-71.1 49-113.7 41.2L16 66.9 0 64V80.3 160l51 77.8zM16 155.2V83.2l88.3 16.1c48.2 8.8 97.4-9.1 128.8-46.7L263.5 16h61l26.2 78.7c13 38.9 42.8 69.9 81.3 84.3l64 24V264l-66.8 50.1c-38.5 28.9-58.9 76-53.6 123.8l6.5 58.1H309.6L259 455.5c-19-15.2-42.6-23.5-67-23.5c-.5 0-1 0-1.4 .1L32 446.5V373.3l29-38.7c12.4-16.5 18.9-36.7 18.4-57.3c-.4-17.2-5.6-33.9-15-48.2L16 155.2z'
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fast',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm112 96h11.7l2.4 2.8L320 354.6V136v-8h16v8V376v8H324.3l-2.4-2.8L128 157.4V376v8H112v-8V136v-8z'
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fast',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      'M152 0h-8V16h8H292.7L18.3 290.3 12.7 296 24 307.3l5.7-5.7L304 27.3V168v8h16v-8V8 0h-8H152zM528 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM240 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM112 464a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fast',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm320 80H219.3l34.3 34.3 6.9 6.9-8.1 5.4-39.1 26.1 39.8 33.1 6.1 5.1L249 235.3l-6.1-5.1-48-40-8.2-6.9 8.9-5.9 39.9-26.6L196.7 112H128v96c0 53 43 96 96 96s96-43 96-96V112zM128 96H320h16v16 96c0 59.2-45.9 107.6-104 111.7V400h56v16H160V400h56V319.7c-58.1-4.1-104-52.6-104-111.7V112 96h16z'
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fast',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      'M448 16c-61.9 0-112 50.1-112 112v64h96 16v16V496v16H432 16 0V496 208 192H16 320V128C320 57.3 377.3 0 448 0s128 57.3 128 128v88 8H560v-8V128c0-61.9-50.1-112-112-112zM16 208V496H432V208H336 320 16zM272 336H176v32h96V336zm16-16v16 32 16H272 176 160V368 336 320h16 96 16z'
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fast',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      'M128 0V16h8 94.7l-7.4 48c-26.2 .4-47.3 21.7-47.3 48c0 26.5 21.5 48 48 48c21.6 0 39.8-14.2 45.9-33.8L456 151v57 8h16v-8V144v-7l-6.9-.9L272 110.3c-.7-20.5-14.3-37.7-32.9-43.9L246.9 16H344h8V0h-8H136h-8zm64 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 272v48H432V272h64zm-80 0v48H352V272 256H336 272 256v16 48H192V272 256H176 112 96v16l0 48c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H512V272 256H496 432 416v16zM176 336h16 64 16 64 16 64 16 64 16 32c44.2 0 80 35.8 80 80s-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80h16 64zm0-64v48H112V272h64zm96 48V272h64v48H272zM80 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fast',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      'M320 7.4l2.9 1.1 312 120 5.1 2V136 504v8H624v-8V141.5L320 24.6 16 141.5V504v8H0v-8V136v-5.5l5.1-2 312-120L320 7.4zM96 192h8H536h8v8V504v8h-8v0H104v0H96v-8V200v-8zm16 304H528V416H112v80zM528 304H112v96H528V304zm0-16V208H112v80H528z'
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fast',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      'M264 0V8v96 8H248v-8V8 0h16zM0 248H8h96 8v16h-8H8 0V248zm400 0h8 96 8v16h-8H408h-8V248zM264 400v8 96 8H248v-8V408v-8h16zM80.6 69.3L86.3 75l67.9 67.9 5.7 5.7-11.3 11.3-5.7-5.7L75 86.3l-5.7-5.7L80.6 69.3zm-11.3 362l5.7-5.7 67.9-67.9 5.7-5.7 11.3 11.3-5.7 5.7L86.3 437l-5.7 5.7L69.3 431.4zM352.2 148.5l5.7-5.7L425.7 75l5.7-5.7 11.3 11.3L437 86.3l-67.9 67.9-5.7 5.7-11.3-11.3zm11.3 203.6l5.7 5.7L437 425.7l5.7 5.7-11.3 11.3-5.7-5.7-67.9-67.9-5.7-5.7 11.3-11.3zM360 256a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zm-224 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z'
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fast',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      'M205 56.1L195 8H125L115 56.1c-13.8 5.2-26.5 12.7-37.5 22L34.4 64 0 123.4l33.9 30.3C32.7 160.9 32 168.4 32 176s.7 15.1 1.9 22.3L0 228.6 34.4 288l43.1-14.2c11.1 9.3 23.7 16.8 37.5 22L125 344h70l10-48.1c13.8-5.2 26.5-12.7 37.5-22L285.6 288 320 228.6l-33.9-30.3c1.3-7.3 1.9-14.7 1.9-22.3s-.7-15.1-1.9-22.3L320 123.4 285.6 64 242.5 78.2c-11.1-9.3-23.7-16.8-37.5-22zm73.3 27.1l21.3 36.9-24.2 21.6-6.7 5.9 1.5 8.8c1.1 6.3 1.7 12.9 1.7 19.6s-.6 13.2-1.7 19.6l-1.5 8.8 6.7 5.9 24.2 21.6-21.3 36.9-30.8-10.1-8.5-2.8-6.8 5.8c-9.7 8.2-20.8 14.7-32.8 19.3l-8.2 3.1-1.8 8.6L182 328H138l-7.4-35.4-1.8-8.6-8.2-3.1c-12.1-4.5-23.1-11.1-32.8-19.3L81 255.8l-8.5 2.8L41.7 268.7 20.4 231.9l24.2-21.6 6.7-5.9-1.5-8.8C48.6 189.2 48 182.7 48 176s.6-13.2 1.7-19.6l1.5-8.8-6.7-5.9L20.4 120.1 41.7 83.3 72.5 93.4l8.5 2.8 6.8-5.8c9.7-8.2 20.8-14.7 32.8-19.3l8.2-3.1 1.8-8.6L138 24h44l7.4 35.4 1.8 8.6 8.2 3.1c12.1 4.5 23.1 11.1 32.8 19.3l6.8 5.8 8.5-2.8 30.8-10.1zM160 216a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-56-40a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM344.1 307L296 317v70l48.1 10c5.2 13.8 12.7 26.5 22 37.5L352 477.6 411.4 512l30.3-33.9c7.3 1.3 14.7 1.9 22.3 1.9s15.1-.7 22.3-1.9L516.6 512 576 477.6l-14.2-43.1c9.3-11.1 16.8-23.7 22-37.5L632 387V317l-48.1-10c-5.2-13.8-12.7-26.5-22-37.5L576 226.4 516.6 192l-30.3 33.9c-7.3-1.3-14.7-1.9-22.3-1.9s-15.1 .7-22.3 1.9L411.4 192 352 226.4l14.2 43.1c-9.3 11.1-16.8 23.7-22 37.5zm27.1-73.3l36.9-21.3 21.6 24.2 5.9 6.7 8.8-1.5c6.3-1.1 12.9-1.7 19.6-1.7s13.2 .6 19.6 1.7l8.8 1.5 5.9-6.7 21.6-24.2 36.9 21.3-10.1 30.8-2.8 8.5 5.8 6.8c8.2 9.7 14.7 20.8 19.3 32.8l3.1 8.2 8.6 1.8L616 330v44l-35.4 7.4-8.6 1.8-3.1 8.2c-4.5 12.1-11.1 23.1-19.3 32.8l-5.8 6.8 2.8 8.5 10.1 30.8-36.9 21.3-21.6-24.2-5.9-6.7-8.8 1.5c-6.3 1.1-12.9 1.7-19.6 1.7s-13.2-.6-19.6-1.7l-8.8-1.5-5.9 6.7-21.6 24.2-36.9-21.3 10.1-30.8 2.8-8.5-5.8-6.8c-8.2-9.7-14.7-20.8-19.3-32.8l-3.1-8.2-8.6-1.8L312 374V330l35.4-7.4 8.6-1.8 3.1-8.2c4.5-12.1 11.1-23.1 19.3-32.8l5.8-6.8-2.8-8.5-10.1-30.8zM504 352a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-40 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fast',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      'M64 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 0a32 32 0 1 1 0 64A32 32 0 1 1 64 0zm64.9 460.2L51.8 383.1 18.5 475.9l17.7 17.7 92.8-33.3zm16.7-6l77.5-27.8L85.6 288.9 57.8 366.4l87.8 87.8zm93.7-33.6l75.6-27.1L118.5 197.2 91.4 272.8c.8 .4 1.6 .9 2.3 1.6l144 144c.7 .7 1.2 1.4 1.6 2.3zM32 512L0 480 106 184.7l6-16.7 12.5 12.5 207 207L344 400l-16.6 6L32 512zM496 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 8c0 38.7-21.3 76.4-41.6 103.8c-10.2 13.8-20.5 25.3-28.1 33.4c-3.8 4-7 7.2-9.3 9.4c-1.1 1.1-2 1.9-2.6 2.5l-.7 .7-.2 .2-.1 0 0 0 0 0s0 0-5.4-5.9l5.4 5.9-5.9 5.4-10.7-11.9 5.9-5.3 0 0 0 0 0 0 0 0 .1-.1 .6-.6c.6-.5 1.4-1.3 2.4-2.3c2.1-2 5.2-5.1 8.8-8.9c7.3-7.7 17.1-18.7 26.9-31.9C221.3 75.6 240 41.3 240 8V0h16V8zM366.6 348.5l0 0 0 0 0 0-4.5 6.6-13.3-9 4.5-6.6L360 344c-6.6-4.5-6.6-4.5-6.6-4.5l0 0 0 0 0-.1 .1-.2 .5-.8c.5-.6 1.1-1.6 2-2.7c1.7-2.3 4.3-5.6 7.7-9.5c6.7-7.8 16.6-18.1 29.4-28.5C418.8 277.1 456.5 256 504 256h8v16h-8c-42.5 0-76.8 18.9-100.7 38.2c-11.9 9.6-21.1 19.3-27.4 26.5c-3.1 3.6-5.5 6.6-7 8.7c-.8 1-1.4 1.8-1.7 2.4l-.4 .6-.1 .1 0 0zM492.5 28.8c-12.6 11.1-28.9 17-45.6 16.5c-25.2-.7-47 17.4-51 42.4L389 131.7c-5.9 37.4-36.8 65.8-74.6 68.6c-13.8 1-27 6.4-37.5 15.3l-7.7 6.6-6.1 5.2-10.3-12.2 6.1-5.2 7.7-6.5c13.2-11.1 29.5-17.8 46.7-19.1c30.4-2.2 55.2-25.1 59.9-55.1l6.9-43.9c5.2-32.9 33.9-56.8 67.2-55.9c12.7 .3 25.1-4.1 34.6-12.5L498.7 2l10.6 12L492.5 28.8z'
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fast',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      'M248 495.9V273.1L76.8 415.7C119.2 463.1 180 493.6 248 495.9zM66.6 403.4L248 252.3V16.1C119.2 20.4 16 126.1 16 256c0 55.6 18.9 106.7 50.6 147.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm179.2-96.3L264 273.1V495.9c68-2.2 128.8-32.7 171.2-80.2zm10.2-12.3C477.1 362.7 496 311.6 496 256C496 126.1 392.8 20.4 264 16.1V252.3L445.4 403.4z'
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fast',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M328 0V8 96H528h16v16V496v16H528 112 96V496 112 96h16H312V8 0h16zM112 112V496H528V112H328 312 112zm88 288h48 8v16h-8H200h-8V400h8zm96 0h48 8v16h-8H296h-8V400h8zm96 0h48 8v16h-8H392h-8V400h8zM224 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm96 0a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM16 224H64v16H16V400H64v16H16 0V400 240 224H16zM624 400V240H576V224h48 16v16V400v16H624 576V400h48z'
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fast',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      'M168 20.4l14.2 85.3L267.6 120l5.6 .9 13.8 2.3-9.9 9.9-4 4-60 60-2.6 2.6-3.7-.6-73.6-12.3L90.6 255c-6.7 10.7-8.3 23.9-4.3 35.9c5.8 17.3 22 29 40.3 29h1.1c10.5 0 20.7-3.8 28.6-10.6l103.8-89C329.7 160.8 418.4 128 510.1 128H624h16v16V464v16H624 162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l57.6-57.6L88.9 81.2l-.6-3.7 2.6-2.6 60-60 4-4L164.8 1l2.3 13.8 .9 5.6zm11.6 101.1l-11.3-1.9-1.9-11.3L154.1 34.3 105.4 83 117 152.2l1.4 8.1-5.8 5.8L54.9 223.7C30 248.6 16 282.4 16 317.6C16 398.5 81.5 464 162.4 464H624V144H510.1c-87.8 0-172.8 31.4-239.5 88.6l-103.8 89C155.9 330.9 142 336 127.7 336h-1.1c-25.2 0-47.5-16.1-55.5-40c-5.5-16.5-3.4-34.7 5.9-49.5l42.6-68.2 5.7-9.1 10.5 1.8L205 182.6l48.7-48.7-74.1-12.3zM400 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fast',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      'M296 224h18.9H517.1 536l-10-16L425.4 47.1 416 32l-9.4 15.1L306 208l-10 16zm211.1-16H324.9L416 62.2 507.1 208zM336 304H496V464H336V304zm0-16H320v16V464v16h16H496h16V464 304 288H496 336zM165.7 42.3L160 36.7l-5.7 5.7-104 104L44.7 152 56 163.3l5.7-5.7L152 67.3V472v8h16v-8V67.3l90.3 90.3 5.7 5.7L275.3 152l-5.7-5.7-104-104z'
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fast',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      'M169 0h-8V16h8 48V80H137h-8v8 40H17 6.6l2.6 10L56.7 320H48 32v16 32 16H48 81V504v8H97v-8V384H353V504v8h16v-8V384h31 16V368 336 320H400h-6.8l47.5-182 2.6-10H433 321V88 80h-8H233V16h48 8V0h-8H225 169zM376.7 320H321V168.1l0-.1V144H422.6L377.2 318l-.5 2zM305 320H145V168.1l0-.1V144H305v15.9l0 .1V320zm-176 0H73.2l-.5-2L27.3 144H129v15.9l0 .1V320zM305 128H145V96H305v32zm8 208h87v32H369 353 97 81 48V336h89H313z'
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fast',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      'M224 80h64V16l-64 0V80zM208 96V80 16 0h16 64 16V16 80 96l-16 0H224 208zM80 224H16v64H80V224zM16 208H80 96v16 64 16H80 16 0V288 224 208H16zM224 432v64h64V432H224zm-16 64V432 416h16 64 16v16 64 16H288 224 208V496zM432 224v64h64V224H432zm-16-16h16 64 16v16 64 16H496 432 416V288 224 208zM108.9 357.8L63.7 403.1l45.3 45.3 45.3-45.3-45.3-45.3zM52.4 391.8l45.3-45.3 11.3-11.3 11.3 11.3 45.3 45.3 11.3 11.3-11.3 11.3-45.3 45.3L108.9 471 97.6 459.6 52.4 414.4 41 403.1l11.3-11.3zm305.5 11.3l45.3 45.3 45.3-45.3-45.3-45.3-45.3 45.3zm33.9 56.6l-45.3-45.3-11.3-11.3 11.3-11.3 45.3-45.3 11.3-11.3 11.3 11.3 45.3 45.3L471 403.1l-11.3 11.3-45.3 45.3L403.1 471l-11.3-11.3zM108.9 154.2l45.3-45.3L108.9 63.7 63.7 108.9l45.3 45.3zm0 22.6L97.6 165.5 52.4 120.2 41 108.9 52.4 97.6 97.6 52.4 108.9 41l11.3 11.3 45.3 45.3 11.3 11.3-11.3 11.3-45.3 45.3-11.3 11.3z'
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fast',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      'M420 431.3l-164-164L92 431.3C134.9 471.4 192.6 496 256 496s121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256s-24.6-121.1-64.7-164l-164 164 164 164zM420 80.7C377.1 40.6 319.4 16 256 16S134.9 40.6 92 80.7l164 164 164-164zM80.7 92C40.6 134.9 16 192.6 16 256s24.6 121.1 64.7 164l164-164L80.7 92zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fast',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M118.1 79.5c-47.4 37-75.8 89.3-83.8 144.5H50.5c7.8-50.4 34.1-98 77.5-131.9c81.9-64 196.6-57 270.1 11.9l-47.7 47.7L339 163l11.3 11.3L368 192H480h16V176 64L478.3 46.3 467 35 455.7 46.3 409.4 92.7c-79.1-74.5-203-82.2-291.3-13.2zM467 57.7l13 13V176H374.6l-13-13L467 57.7zM45 477l11.3-11.3 45.8-45.8c79.2 74 202.6 81.5 290.7 12.7c47.4-37 75.8-89.3 83.8-144.5H460.4c-7.8 50.4-34.1 98-77.5 131.9c-81.6 63.8-196 57-269.5-11.4l48.2-48.2L173 349l-11.3-11.3L144 320H32 16v16V448l17.7 17.7L45 477zm0-22.6l-13-13V336H137.4l13 13L45 454.3z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fast',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96h8 16 12l21.6-28.8L220 128h4 64 4l2.4 3.2L316 160h12 16 8 8v16h-8-9.1L328 384H184L169.1 176H160h-8V160h8zm56 0h80l-12-16H228l-12 16zm110.8 16H185.2l13.7 192H313.1l13.7-192z'
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fast',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      'M205.2 3.3l8 .8 79.6 8.2 8 .8-.8 8-4.1 39.8L283 184h77 8v8 8h72 8v8 72 64 8 8c0 83.9-68.1 152-152 152H216c-83.9 0-152-68.1-152-152V264v-8h8H96.3L48.4 93.6 37 55.2l-2.3-7.7 7.7-2.3 76.7-22.7 7.7-2.3 2.3 7.7 11.3 38.4 43.1 146.1L200.3 51.1l4.1-39.8 .8-8zM113 256h66.7l-.1-.2-5-16.9-49.6-168L116 40.2 54.6 58.4l9.1 30.7L113 256zm82.1 0h64.3L279.8 59.3l3.3-31.8-63.7-6.6-3.3 31.8L195.3 254.4l-.2 1.6zM432 216H368V336h64V280 216zM368 352h-8-8H288h-8-8H168h-8V336h8H272V272H80v88c0 75.1 60.9 136 136 136h80c75.1 0 136-60.9 136-136v-8H368zm-16-16V208v-8H288l0 56v8l0 72h64z'
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fast',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm277.7 37.7L395.3 192c50.7 56.5 48.8 143.5-5.5 197.8c-56.2 56.2-147.4 56.2-203.6 0s-56.2-147.4 0-203.6c54.3-54.3 141.3-56.2 197.8-5.5L282.3 282.3l-5.7 5.7L288 299.3l5.7-5.7zM401.1 174.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9z'
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fast',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      'M472 64h-3.8l-2.4 2.9L164.2 432H8 0v16H8 168h3.8l2.4-2.9L475.8 80H632h8V64h-8H472zM424 432h-8v16h8H632h8V432h-8H424z'
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fast',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      'M512 48V336H624V48H512zm-16 0H384V192H496V48zM368 48H272V336h96V48zM256 48H144V192H256V48zM128 48H16V336H128V48zM16 352V464H312V352H16zM328 464H624V352H328V464zM0 32H16 624h16V48 464v16H624 16 0V464 48 32zM256 336V208H144V336H256zM496 208H384V336H496V208z'
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fast',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      'M232 48V85l54 61.7 2 2.3v3 96 8h-8H168h-8v-8V152v-3l2-2.3L216 85V48H112V368H464V48H440 232zm248 0V224h24c48.6 0 88-39.4 88-88s-39.4-88-88-88H480zm0 192V368v16H464 112 96V368 48 32h16H440h24 16 24c57.4 0 104 46.6 104 104s-46.6 104-104 104H480zM0 464H8 568h8v16h-8H8 0V464zM176 155v85h96V155l-48-54.9L176 155z'
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fast',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      'M448 512C200.6 512 0 311.4 0 64L0 32 144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448zM16 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L372 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C222.2 348.3 163.7 289.8 126 218.5l-6.2-11.7 10.3-8.3L203.4 140 135.8 18.2 16 44.8 16 64zM304 80v32h32V80H304zM288 64h16 32 16V80v32 16H336 304 288V112 80 64zm48 112H304v32h32V176zm-32-16h32 16v16 32 16H336 304 288V208 176 160h16zm96-80v32h32V80H400zM384 64h16 32 16V80v32 16H432 400 384V112 80 64zM528 80H496v32h32V80zM496 64h32 16V80v32 16H528 496 480V112 80 64h16zm96 16v32h32V80H592zM576 64h16 32 16V80v32 16H624 592 576V112 80 64zm48 112H592v32h32V176zm-32-16h32 16v16 32 16H624 592 576V208 176 160h16zM400 176v32H528V176H400zm-16-16h16H528h16v16 32 16H528 400 384V208 176 160z'
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fast',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      'M16 16H256V0H16 0V16 496v16H16 256V496H16V16zM176 224c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6V389.1C238.8 415 209.4 432 176 432c-53 0-96-43-96-96s43-96 96-96c33.4 0 62.8 17 80 42.9V257.6c-20.3-20.7-48.7-33.6-80-33.6zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM624 16V496H304V16H624zM304 0H288V16 496v16h16H624h16V496 16 0H624 304zM464 240a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM432 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fast',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      'M288 16C155.5 16 48 123.5 48 256c0 61.5 23.1 117.5 61.1 160c2.9 3.3 2.7 8.4-.6 11.3s-8.3 2.7-11.3-.6C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7c-2.9 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3c38-42.5 61.1-98.5 61.1-160C528 123.5 420.5 16 288 16zM164.4 157.3l7.2 3.6 80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L230.1 208l-65.7-32.8-7.2-3.6 7.2-14.3zm240 3.6l7.2-3.6 7.2 14.3-7.2 3.6L345.9 208l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L310.1 208l14.3-7.2 80-40zM32 496a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm496-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM304 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-51.3-85c-20.3 11.3-34.7 26.4-46.3 41.8l-12.8-9.6C158 346.6 174 329.7 196.9 317c22.9-12.7 52.3-21 91.1-21s68.1 8.3 91 21c22.9 12.7 38.9 29.6 51.4 46.2l-12.8 9.6c-11.6-15.4-26-30.5-46.3-41.8c-20.3-11.3-46.9-19-83.3-19s-63 7.7-83.3 19zM368 360v-2.9c5.9 4 11.2 8.5 16 13.3v18.2c0 33.3 18.8 63.8 48.6 78.7l42.9 21.5 4.4 2.2V496v8 8h-8H104 96v-8-8-4.9l4.4-2.2 42.9-21.5C173.2 452.5 192 422 192 388.7V370.5c4.8-4.8 10.1-9.3 16-13.3V360v28.7c0 39.4-22.3 75.4-57.5 93L121.9 496H454.1l-28.6-14.3c-35.2-17.6-57.5-53.6-57.5-93V360z'
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fast',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      'M492.7 147.3l-1.4 1.4L480 160l11.3 11.3 1.4 1.4L504 184l11.3-11.3 1.4-1.4L528 160l11.3 11.3 25.4 25.4L576 208l-11.3 11.3-97.4 97.4L456 328l-11.3-11.3-25.4-25.4L408 280l11.3-11.3 1.4-1.4L432 256l-11.3-11.3-1.4-1.4L408 232l-11.3 11.3-1.4 1.4L384 256l-11.3-11.3L272 144V96L193 56.5 176 48l16.3-9.8 33.3-20C245.5 6.3 268.3 0 291.5 0H315c33.9 0 66.5 13.5 90.5 37.5l87.2 87.2L504 136l-11.3 11.3zm22.6 48L504 206.6l-11.3-11.3-24-24L457.4 160l11.3-11.3L481.4 136 394.2 48.8C373.2 27.8 344.7 16 315 16H291.5c-20.3 0-40.2 5.5-57.6 16L209.2 46.7l69.9 35 8.8 4.4V96v41.4l96 96 12.7-12.7L408 209.4l11.3 11.3 24 24L454.6 256l-11.3 11.3L430.6 280 456 305.4 553.4 208 528 182.6l-12.7 12.7zM12 405.4L264 181.3l11.3 11.3L23.3 416.7l72 72L319.4 236.6 330.7 248 106.6 500 96 512 84.7 500.7 11.3 427.3 0 416l12-10.6z'
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fast',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      'M240 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM156.7 144h-4.8l-2.2 4.3L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H40 32v8 64 8h8H274.2 280l1.8-5.5L302 445.3l1.8-5.5-4.7-3.4L187.7 354l45-90 42.9 58.9 5 6.8 6.6-5.4L410.2 223.7l6.2-5.1-5.1-6.2-40.5-49.5-5.1-6.2-6.2 5.1-64.1 52.5-48.7-66.9-2.4-3.3h-4.1H156.7zM94 288.4L161.5 160h74.7l51.3 70.5 5 6.8L299 232l64.5-52.8 30.4 37.2L283.5 306.7l-45.6-62.7-7.7-10.6-5.9 11.8L170.4 352.9l-3 6 5.4 4L285 445.8 268.4 496H48V448H182.9h24.3l-19.5-14.4-72.8-53.8c-28.6-21.1-37.5-60-20.9-91.4z'
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fast',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      'M106.6 119.8l11.3-1.9 1.9-11.3 13.2-79 65.9 46.1 9.2 6.4 9.2-6.4 65.9-46.1 13.2 79 1.9 11.3 11.3 1.9 6.7 1.1c6.1-5 12.8-9.3 19.8-12.9L312 104 297.6 17.5 294.7 0 280.1 10.2 208 60.7 135.9 10.2 121.3 0l-2.9 17.5L104 104 17.5 118.4 0 121.3l10.2 14.5L60.7 208 10.2 280.1 0 294.7l17.5 2.9L104 312l14.4 86.5 2.9 17.5 14.5-10.2 27.5-19.3c2.1-9.1 5.2-17.7 9.1-25.9l-39.6 27.7-13.2-79-1.9-11.3-11.3-1.9-79-13.2 46.1-65.9 6.4-9.2-6.4-9.2L27.7 132.9l79-13.2zm181.8 35.8C271.3 129.4 241.7 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c3.5-1.7 7.1-3.3 10.7-4.7c1.2-6.4 2.8-12.6 4.9-18.6C235.5 284.3 222.2 288 208 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c33 0 61.4 20 73.6 48.5c1.4-7.3 3.7-14.3 6.9-20.9zm118.3-11.5h10.5l4.2-9.6c9.9-22.6 32.5-38.4 58.7-38.4c30.9 0 56.8 22 62.7 51.2l2.6 12.8h13.1H568c30.9 0 56 25.1 56 56v56H587.9c3.5 5 6.6 10.4 9.3 16H624h16v-16-56c0-39.8-32.2-72-72-72h-9.6c-7.4-36.5-39.7-64-78.4-64c-32.8 0-61 19.7-73.3 48H384.1c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c5-2 10.2-3.7 15.5-5c-.1-1.3-.2-2.6-.2-3.9c0-26.5 21.5-48 48-48h22.6zM368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v80 16h16 80H559.9l64 0h16l0-16 0-64c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4C425.2 238 398.2 224 368 224zM623.9 431.9v64l-64 0H288 208v-80c0-39.6 28.8-72.5 66.6-78.9l13.4-2.3-.1-13.6 0-1.3c0-44.1 35.8-79.9 80-79.9c29 0 54.5 15.5 68.5 38.7l8.8 14.6 14-9.8c10.4-7.3 23-11.5 36.6-11.5c35.3 0 64 28.6 64 64c0 4.8-.5 9.4-1.5 13.8L554.8 366l16.4 2.9c29.9 5.3 52.7 31.5 52.7 63z'
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fast',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      'M270.6 380.7c3.6 1.1 6.8 1.9 9.4 2.3V496H168h-8v16h8H288 408h8V496h-8H296V383c2.6-.5 5.8-1.2 9.4-2.3l0 0c33.2-5.8 100.5-31.4 159.6-80.9C524.3 250 576 175.5 576 72V64h-8H446.4c.8-15.3 1.3-31.2 1.5-48c.1-5.3 .1-10.6 .1-16H432 144 128c0 5.4 0 10.7 .1 16c.2 16.8 .7 32.7 1.5 48H8 0v8C0 175.5 51.7 250 111 299.8c59.1 49.6 126.4 75.1 159.6 80.9l0 0zm3.8-15.6c-1.7-.6-3.5-1.2-5.5-2c-12.6-5-30.4-15.5-48.7-37.4c-35.6-42.7-74-130.4-76.2-309.8H431.9c-2.2 179.4-40.6 267.1-76.2 309.8c-18.2 21.9-36 32.3-48.7 37.4c-1.9 .8-3.8 1.4-5.5 2l-6.8 1.2 .1 .6c-1 .2-1.9 .4-2.7 .5c-1.7 .3-2.9 .4-3.7 .5l-.5 0-.5 0c-.7-.1-2-.2-3.7-.5c-.8-.1-1.7-.3-2.7-.5l.1-.6-6.8-1.2zm83.7-18.2c37.1-37.7 77-113.7 87.3-266.9H559.9c-2.6 93.4-49.9 161.2-105.2 207.5c-32.3 27.1-67 46.6-96.6 59.4zm-140.3 0c-29.6-12.8-64.3-32.4-96.6-59.4C66.1 241.2 18.7 173.4 16.1 80H130.6c10.3 153.2 50.3 229.2 87.3 266.9z'
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fast',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      'M515.5 15.7l44.6 .2 .2 44.6c.2 38.6-30 70.5-68.6 72.3l-50.9 2.4 2.4-50.9c1.8-38.5 33.7-68.8 72.3-68.6zm.1-16c-47.2-.2-86.1 36.7-88.4 83.8l-2.5 52.4-.2 4.2-23.6 23.6c5.7-38.7-6.4-79.4-36.1-109.1L353.5 43.3 342.2 32 330.8 43.3 319.5 54.6c-26.2 26.2-34.1 63.8-23.6 96.9l35.2 27.8-.3-.3c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-17.1 17.1 12.6 10L385.3 202c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L511.9 247c-18.1 18.1-42.6 25.7-66.2 22.9l20.2 16c20.9-2.3 41.2-11.5 57.2-27.5L534.5 247l11.3-11.3-11.3-11.3L523.2 213c-30.9-30.9-73.5-42.7-113.4-35.4l26.2-26.2 4.2-.2 52.4-2.5c47.1-2.2 84.1-41.2 83.8-88.4L576 0 515.6-.3zM258.9 305.8l-61.6 61.6c5.7-38.7-6.4-79.4-36.1-109.1L149.8 247l-11.3-11.3L127.2 247l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L69.5 495.1l-5.7 5.7 11.3 11.3 5.7-5.7 73.7-73.7 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3 11.3-11.3L330.8 428l-11.3-11.3C288.7 385.8 246 374 206.1 381.2l65.5-65.5-12.6-10zm-84 84l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2zm6.8 15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2 15.8-15.8zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fast',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      'M295.4 201.1l6 4.3c23.6 17.2 40.4 39.7 51.3 60.5C363.9 287.2 368 305 368 312v24H200V232v-8H184v8V336H16V312v0c0-9.4 4.3-28 15.3-49c10.9-20.7 27.6-42.4 51.2-58.9l6.2-4.3 .6-7.5L102.8 16H281.2l13.7 177.7 .6 7.3zM200 352H368h16V336 312c0-21.3-21.3-81.6-73.2-119.5L297.2 16H336h8V0h-8H296 88 48 40V16h8H86.8L73.3 191C21.3 227.5 0 286.4 0 312v24 16H16 184V504v8h16v-8V352z'
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fast',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM345.7 368H328h-8v16h8 37.9l-20.3-16zM454 181.6l-37 59.2 12.6 10 49.1-78.6L490 154.4l-20.2 6L357.1 193.6l15.4 12.1L454 181.6zM304 135.9V120c0-48.6-39.4-88-88-88c-17.1 0-33.1 4.9-46.6 13.4L182.9 56c9.9-5.1 21.2-8 33.1-8c39.8 0 72 32.2 72 72v15.9c0 1 0 2.1 0 3.1l15.8 12.5c.2-5.2 .2-10.4 .2-15.6zM117.7 264.3L112 266v6V472v8h8 72 4.8l2.3-4.3 39.7-74.9c14.9-28.2 27.2-57.8 36.8-88.2L262 302c-9.4 31.6-22 62.2-37.4 91.3L187.2 464H128V278l75.4-22.3L188 243.6l-70.3 20.8zM632 384h8V368h-8H578.1l20.3 16H632zm-64-80c4.4 0 8-3.6 8-8s-3.6-8-8-8H476.7L497 304h71zM8 368H0v16H8 56h8V368H56 8z'
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fast',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      'M416 256V360l160 32 64-144c-37.3-48-153.6-144-320-144S37.3 200 0 248L64 392l160-32V256c62.3-20.8 129.7-20.8 192 0zM208 346.9L73.4 373.8 18.6 250.5C59.3 203.5 167.9 120 320 120s260.7 83.5 301.4 130.5L566.6 373.8 432 346.9V256 244.5l-10.9-3.6c-65.6-21.9-136.5-21.9-202.1 0L208 244.5V256v90.9z'
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fast',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm137.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fast',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      'M274.7 204.8l-58.7-66.1L206.4 128H192 104 84.7l-9 17L11.2 266.9 3.7 281l14.1 7.5 28.3 15L60.3 311l3.7-7 3.8-7.1L80 273.7v34.2V480v16 16H96h32 16V496 480 368 352h16 4.2L192 407.6V480v16 16h16 32 16V496 480 400v-7.6l-3.4-6.8L216 312.4V259.3 235.2l16 18 .1 .1 5.3 5.9 7.4 2.8 63.3 23.8-11.6 31.5-2.8 7.5 15 5.5 2.8-7.5 11.6-31.4 .7 .2 15 5.6 5.6-15 11.2-30 5.6-15-15-5.6-1-.4 16.1-43.7 82.9 30.8 15 5.6 5.4-15.1L512 75.6 415.8 39.8l9.2-25 2.8-7.5-15-5.5-2.8 7.5-9.2 24.9L323.8 5.6 308.8 0l-5.4 15.1L256 148.4 346.3 182l-16.1 43.7-55.6-20.8zm65.9 41.8l-11.2 30-15-5.6-64-24-3.7-1.4-2.6-3L228 224.5l-28-31.5v42.1 77.3 3.8l1.7 3.4 36.6 73.2 1.7 3.4V400v80 16H208V480 407.6v-3.8l-1.7-3.4-27.8-55.6-4.4-8.8h-9.9H144 128v16V480v16H96V480 273.7 209.3L65.9 266.2 53.6 289.3l-28.3-15L89.9 152.5l4.5-8.5H104h88 7.2l4.8 5.4 58.7 66.1 2.6 3 3.7 1.4L325.6 241l15 5.6zM144 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM318.5 20.7L491.6 85.1 449.5 203.3 276.4 138.9 318.5 20.7z'
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fast',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      'M560 16V400H344.2h-.3H232.1h-.3H16V16H560zM16 416H222.6l-13.3 80H136h-8v16h8 80H360h80 8V496h-8H366.8l-13.3-80H560h16V400 16 0H560 16 0V16 400v16H16zm209.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V336H80V80zM64 64V80 336v16H80 496h16V336 80 64H496 80 64z'
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fast',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      'M272 256c0-68.5-15.6-129.7-40.1-173.2C207.1 38.8 175.4 16 144 16s-63.1 22.8-87.9 66.8C31.6 126.3 16 187.5 16 256s15.6 129.7 40.1 173.2c24.8 44 56.5 66.8 87.9 66.8s63.1-22.8 87.9-66.8C256.4 385.7 272 324.5 272 256zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h16 96c70.7 0 128 114.6 128 256s-57.3 256-128 256H160 144zM279.3 344H360c4.7-24.8 7.5-51.8 8-80h-80c-.5 28-3.5 54.9-8.7 80zm-3.6 16c-5.9 23.4-13.6 44.9-23 64H335c8.7-18.6 16-40.2 21.6-64h-81zM194.2 496H256c24 0 49.5-18.2 70.8-56H244.1c-14.1 24.3-31.1 43.6-49.9 56zM360 168H279.3c5.2 25.1 8.2 52 8.7 80h80c-.4-28.2-3.2-55.2-8-80zm-84.3-16h81c-5.5-23.8-12.8-45.4-21.6-64H252.7c9.3 19.1 17.1 40.6 23 64zM256 16H194.2C213 28.4 230 47.7 244.1 72h82.7C305.5 34.2 280 16 256 16zM64 256c0 49.9 9.3 94.8 23.9 126.8c14.9 32.7 34 49.2 52.1 49.2s37.2-16.5 52.1-49.2c14.6-32 23.9-76.9 23.9-126.8s-9.3-94.8-23.9-126.8C177.2 96.5 158.1 80 140 80s-37.2 16.5-52.1 49.2C73.3 161.2 64 206.1 64 256zM140 64c28.2 0 51.2 24.7 66.7 58.6C222.5 157.1 232 204.3 232 256s-9.5 98.9-25.3 133.4C191.2 423.3 168.2 448 140 448s-51.2-24.7-66.7-58.6C57.5 354.9 48 307.7 48 256s9.5-98.9 25.3-133.4C88.8 88.7 111.8 64 140 64z'
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fast',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM171 251l-5.7 5.7-5.7-5.7-60-60L111 179.7 165.3 234 273 126.3l11.3 11.3L171 251z'
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fast',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      'M496 16V272H144V16H256V124v20l16-12 48-36 48 36 16 12V124 16H496zM272 16h96v96L329.6 83.2 320 76l-9.6 7.2L272 112V16zM496 0H384 368 272 256 144 128V16 272v16h16H496h16V272 16 0H496zM624 416c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80H544c44.2 0 80 35.8 80 80zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fast',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      'M41.4 324.9l15.3 6.8c29.8 13.3 64.5 9.6 90.9-9.6c26.4-19.2 62.3-19.2 88.7 0c26.4 19.2 61.1 22.9 90.9 9.6l15.3-6.8L329.2 496H54.8L41.4 324.9zM40 306.8L17.3 16H366.7L344 306.8l-23.2 10.3c-24.6 10.9-53.2 7.9-75-7.9c-32.1-23.3-75.5-23.3-107.5 0c-21.8 15.8-50.4 18.9-75 7.9L40 306.8zM40 512H344L382.7 16 384 0H368 16 0L1.3 16 40 512zM192 224c-27.5 0-48-20.7-48-44c0-4.2 2.4-12.1 8.2-23.5c5.5-10.8 13.1-22.6 20.9-33.7c6.7-9.6 13.4-18.4 18.9-25.4c5.5 7 12.2 15.8 18.9 25.4c7.8 11.1 15.3 22.9 20.9 33.7c5.9 11.4 8.2 19.4 8.2 23.5c0 23.3-20.5 44-48 44zM181.7 84.6C163.6 107.4 128 155.3 128 180c0 33.1 28.7 60 64 60s64-26.9 64-60c0-24.7-35.6-72.6-53.7-95.4C196.1 76.8 192 72 192 72s-4.1 4.8-10.3 12.6z'
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fast',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      'M448 48V384H302.4c-7.4-36.5-39.7-64-78.4-64c-31.7 0-59 18.4-72 45.1C139 338.4 111.7 320 80 320c-26.2 0-49.4 12.6-64 32V304 48H448zM152 434.9c13 26.7 40.3 45.1 72 45.1c44.2 0 80-35.8 80-80H448c0 44.2 35.8 80 80 80c41.5 0 75.6-31.6 79.6-72H640v-8-8V232v-2.7l-1.6-2.1-72-96L564 128h-4H464V48 32H448 16 0V48 304v80 16c0 44.2 35.8 80 80 80c31.7 0 59-18.4 72-45.1zM624 240V392H607.6c-4-40.4-38.1-72-79.6-72c-26.2 0-49.4 12.6-64 32V240H624zm-68-96l60 80H464V144h92zM528 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM160 400a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fast',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M112 80v96H16V80h96zM16 64H0V80v96 16H16h96 16V176 80 64H112 16zM368 336v96H272V336h96zm-96-16H256v16 96 16h16 96 16V432 336 320H368 272zM362.3 74.3l-352 352 11.3 11.3 352-352L362.3 74.3z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fast',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      'M192 0h-8V8 192H112h-8v8 47.4L34.8 305.9 32 308.3V312v53.7c0 48.8 26.2 93.9 68.5 118.1l18 10.3C139.1 505.8 162.3 512 186 512H328c57.4 0 104-46.6 104-104V392 304 256v-8h-8H368V224v-8h-8H288V8 0h-8H192zm8 200V16h72V224v8h8 72v24 8h8 56v40 88 16c0 48.6-39.4 88-88 88H186c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C71.1 448.5 48 408.8 48 365.7v-50l56-47.4V344c0 4.4 3.6 8 8 8s8-3.6 8-8V256c0-.4 0-.8-.1-1.1l.1-.1v-3.7V208h72 8v-8z'
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fast',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      'M240 64V96h32V64H240zm16 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM131.5 108.9l-22.6 22.6 22.6 22.6 22.6-22.6-22.6-22.6zM64 272H96l0-32H64v32zm44.9 108.5l22.6 22.6 22.6-22.6-22.6-22.6-22.6 22.6zM272 416H240v32h32V416zm108.5-58.2l-22.6 22.6 22.6 22.6 22.6-22.6-22.6-22.6zM416 240v32h32V240H416zM357.8 131.5l22.6 22.6 22.6-22.6-22.6-22.6-22.6 22.6z'
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fast',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80 72h16v8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 152h-8l-144 0h-8V360h8H568h8v16z'
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fast',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      'M78.8 82.3L73 83.9l-.1 6L70.2 250.2l-35 9.4-15.5 4.1 4.1 15.5L65.3 433.8l4.1 15.5 12.4 46.4 .1 .4H8 0v16H8 632h8V496h-8H142.1l21.2-5.7 15.5-4.1-4.1-15.5-12.4-46.4 278.2-74.5 12.4 46.4 4.1 15.5 15.5-4.1 61.8-16.6 15.5-4.1-4.1-15.5L533.1 325 529 309.5 487.5 155l-4.1-15.5-15.5 4.1-35 9.4L350.5 15.5l-3.1-5.2-5.8 1.6L78.8 82.3zm63.8 330.8L80.8 429.6 39.4 275.1l432.7-116 41.4 154.5-61.8 16.6-15.5 4.1L158 408.9l-15.5 4.1zm-57.7 32l61.8-16.6 12.4 46.4L97.3 491.4 84.9 445.1zm332-287.7L86.3 245.9 88.8 96.2 339.8 28.9l77 128.4zM468.2 392l-12.4-46.4 61.8-16.6 12.4 46.4L468.2 392zM121.9 335.8a16 16 0 1 1 30.9-8.3 16 16 0 1 1 -30.9 8.3zm46.4-12.4a32 32 0 1 0 -61.8 16.6 32 32 0 1 0 61.8-16.6zm243.1-81.7a16 16 0 1 1 8.3 30.9 16 16 0 1 1 -8.3-30.9zM423.8 288a32 32 0 1 0 -16.6-61.8A32 32 0 1 0 423.8 288z'
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fast',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      'M294.1 304H304h32 9.9l4.4 8.8L409.9 432H624V80H16V432H230.1l59.6-119.2 4.4-8.8zM240 448H16 0V432 80 64H16 624h16V80 432v16H624 400L336 320H304L240 448zM176 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm352 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fast',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM152 264H360V248H152v16z'
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fast',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      'M355.1 40.2C370.6 24.7 391.6 16 413.5 16C459.1 16 496 52.9 496 98.5c0 21.9-8.7 42.9-24.2 58.3L228.7 400H112V283.3l48-48 50.3 50.3 5.7 5.7L227.3 280l-5.7-5.7L171.3 224 224 171.3l50.3 50.3 5.7 5.7L291.3 216l-5.7-5.7L235.3 160 288 107.3l50.3 50.3 5.7 5.7L355.3 152l-5.7-5.7L299.3 96l55.8-55.8zM96 280V404.7L5.9 494.8 .2 500.5l11.3 11.3 5.7-5.7L107.3 416H232h3.3l2.3-2.3L483.1 168.2c18.5-18.5 28.9-43.5 28.9-69.7C512 44.1 467.9 0 413.5 0c-26.1 0-51.2 10.4-69.7 28.9L288 84.7 276.7 96 224 148.7 212.7 160 160 212.7 148.7 224 98.3 274.3 96 276.7V280z'
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fast',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zm216-40V280H424v16H216z'
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fast',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      'M16 16V352c0 79.5 64.5 144 144 144s144-64.5 144-144V16H16zM0 0H16 304h16V16 352c0 88.4-71.6 160-160 160S0 440.4 0 352V16 0zM120 392a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm96 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM120 120a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm96 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fast',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM416 180.5V192 344c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V203.5l-112 42V376c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V240v-5.5l5.2-1.9 128-48 10.8-4.1zM368 320c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM240 352c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fast',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      'M16 480H48V448H16v32zm128 0V448H112v32h32zm96 0V448H208v32h32zm96 0V448H304v32h32zm64 0h32V448H400v32zM160 208H144 80 64v16 16L212.7 388.7 224 400l11.3-11.3L384 240V224 208H368 304 288V192 64 48H272 176 160V64 192v16zm0 16h16V208 64h96V208v16h16 80v9.4l-144 144L80 233.4V224h80z'
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fast',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80H352h8v16h-8H160h-8V336h8zM128 192h8 80 8v16h-8H136h-8V192zm168 0h80 8v16h-8H296h-8V192h8z'
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fast',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      'M118.3 20.7L232.6 176l19.9 0L122.9 0C56.7 33.5 9.3 98.9 1.1 176l16.1 0C24.8 109.8 63.5 53.1 118.3 20.7zM440 112l-8 0 0 8 0 88-208 0L16 208 0 208c0 5.3 .2 10.7 .7 16c4.2 49 27.4 96.2 64.9 131.1C107.2 393.7 165.2 416 224 416s116.8-22.3 158.4-60.9c37.5-34.8 60.7-82.1 64.9-131.1c.5-5.3 .7-10.7 .7-16l0-80 56 0 8 0 0-16-8 0-64 0zM80 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm288-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm63.3-288c-4.1 44.4-25.4 87.4-59.7 119.4C333 379.1 279 400 224 400s-109-20.9-147.5-56.6C42.1 311.4 20.9 268.4 16.7 224L224 224l207.3 0z'
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fast',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      'M501 19l7.8-1.9L505.1 1.6l-7.8 1.9L6.1 120.2 0 121.7V128v0 16 96 8V496v16H16 496h16V496 144 128H496 42.6L501 19zM16 144H496V496H16V248v-8V144zM352 400a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0-176a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM88 240H80v16h8H200h8V240h-8H88zM72 312H64v16h8H216h8V312h-8H72zm16 72H80v16h8H200h8V384h-8H88z'
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fast',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      'M96 288h64V224l-64 0 0 64zM80 304V288 224 208H96h64 16l0 16v64 16l-16 0H96 80zm144-80v64h64V224l-64 0zm-16 64V224l0-16h16 64 16v16 64 16l-16 0H224 208V288zm144-64v64h64V224l-64 0zm-16 64V224 208h16 64 16v16 64 16l-16 0H352 336V288z'
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fast',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM80 176h96V336H80V176zM64 160v16V336v16H80h96 16V336 176 160H176 80 64z'
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fast',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM416 177.9V160 80 64H400 193l20.3 16H400v88 59.4l16 12.6V177.9zM48 432V133L32 120.4V432v16H48 400h16V432v-8.5l-16-12.6V432H48zM592 89.9V379l16 12.6V81.9 64l-16 8L448 144v17.9l144-72z'
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fast',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      'M448 112l0-16-64 0 0-64-16 0 0 64L80 96l0-64L64 32l0 64L0 96l0 16 64 0 0 288L0 400l0 16 64 0 0 64 16 0 0-64 288 0 0 64 16 0 0-64 64 0 0-16-64 0 0-288 64 0zM80 400l0-288 288 0 0 288L80 400z'
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fast',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      'M432 16V416H416 400 48 32 16V16H432zM416 432h16 16V416 16 0H432 16 0V16 416v16H16 32v64 16H48 400h16V496 432zM48 432H400v64H48V432zM368 80V256H80V80H368zM80 64H64V80 256v16H80 368h16V256 80 64H368 80zM224 336v16h8H376h8V336h-8H232h-8zM80 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fast',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      'M136 0H248h8V8 56h80 3.3l2.3 2.3 56 56 5.7 5.7L392 131.3l-5.7-5.7L332.7 72H256v56H240V16H144V128H128V8 0h8zM48 512H32l1.1-16L56 160H328l22.9 336 1.1 16H336 48zm286.8-16L313.1 176H70.9L49.1 496H334.9zM192 240.5l6.9 11.4 48.6 80.9c5.6 9.4 8.6 20.1 8.6 31c0 33.2-27 60.2-60.2 60.2h-7.6C155 424 128 397 128 363.8c0-10.9 3-21.6 8.6-31l48.6-80.9 6.9-11.4zm0 31.1L150.3 341c-4.1 6.9-6.3 14.7-6.3 22.7c0 24.4 19.8 44.2 44.2 44.2h7.6c24.4 0 44.2-19.8 44.2-44.2c0-8-2.2-15.9-6.3-22.7L192 271.5z'
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fast',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      'M114 32h6H392h6l1.7 5.7L446 192h50 16v16V384v16H496 480v64 16H464 400 384V464 400H128v64 16H112 48 32V464 400H16 0V384 208 192H16 66L112.3 37.7 114 32zM384 384h16 64 16 16V336H424h-8v-8V264v-8h8 72V208H16v48H88h8v8 64 8H88 16v48H32 48h64 16H384zm16 16v64h64V400H400zM48 464h64V400H48v64zM386 48H126L82.8 192H429.2L386 48zM496 272H432v48h64V272zM16 320H80V272H16v48zm192-16v32h96V304H208zm-16-16h16 96 16v16 32 16H304 208 192V336 304 288z'
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fast',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      'M16 176H176v-9.4l-80-80-80 80V176zM0 160L84.7 75.3 96 64l11.3 11.3L192 160v16 16H176 104V400H312h8v16h-8H96 88v-8V192H16 0V176 160zM400 336v9.4l80 80 80-80V336H400zm-16 16V336 320h16 72V112H264h-8V96h8H480h8v8V320h72 16v16 16l-84.7 84.7L480 448l-11.3-11.3L384 352z'
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fast',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V253.6l62.7 94 4.4 6.7-13.3 8.9-4.4-6.7-64-96-1.3-2V256 104 96h16v8z'
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fast',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      'M72 384v8V504v8H56v-8V392v-8H72z'
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fast',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M307.3 256l-5.7 5.7-208 208L88 475.3 76.7 464l5.7-5.7L284.7 256 82.3 53.7 76.7 48 88 36.7l5.7 5.7 208 208 5.7 5.7z'
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fast',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      'M192 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fast',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      'M128 0h8H376h8V8 96H496h16v16V464v16H496 16 0V464 112 96H16 128V8 0zM368 16H144V96H368V16zM16 112V464H496V112H376 136 16zm208 64h64 8v8 64h64 8v8 64 8h-8H296v64 8h-8H224h-8v-8V328H152h-8v-8V256v-8h8 64V184v-8h8zm8 80v8h-8H160v48h64 8v8 64h48V320v-8h8 64V264H288h-8v-8V192H232v64z'
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fast',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM224 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm144 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm194.5 79.2l28.6 14.3-16.8 33.7-7.2 14.3-28.6-14.3 7.2-14.3 16.8-33.7zM436.2 328l-16.8 33.7L412.2 376l-7.2 14.3 14.3 7.2L448 411.8l14.3 7.2 7.2-14.3 7.2-14.3 16.8-33.7 7.2-14.3-14.3-7.2-7.2-3.6 32-64 .8-1.7V264 104 96H496v8V262.1l-31.2 62.3-7.2-3.6-14.3-7.2L436.2 328z'
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fast',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      'M276.3 240.2l15.1 30.1 8.8 17.7H320h64 16 16V272 240 224H400 384 339.8l-39.2-78.3-5.4-10.9-11.3-4.5-80-32L198.2 96H192 128 114.7l-9.4 9.4-48 48L46.1 164.7 34.7 176l11.3 11.3 22.6 22.6L80 221.3l11.3-11.3 11.3-11.3L141.3 160h10.8 16.9l-5.3 16-26 78c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8L218.1 496l-4.6 16h16.6 49.9l6.6-23.2 32-112 6.6-23.2L305 340.9l-68.3-42.7L258.8 241l7.8-20.1 9.7 19.3zm30.4 120.6l-3.3 11.6-32 112L268.1 496H234.8l5.8-20.4L266 386.8l3.3-11.6-10.2-6.4-86.2-53.9c-18.8-11.8-27.1-34.8-20.1-55.9l31.3-94 7-21.1H168.9 141.3h-6.6l-4.7 4.7L91.3 187.3 80 198.6 57.4 176l11.3-11.3 48-48 4.7-4.7H128h64 3.1l2.9 1.1 80 32 5.6 2.3 2.7 5.4 39.2 78.3 4.4 8.8h9.9H384h16v32H384 320h-9.9l-4.4-8.8L281 213.7l-16.1-32.3-13.1 33.6-30 77.3-4.8 12.3 11.2 7 68.3 42.7 10.2 6.4zM272 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM111.3 314.8L97.6 352H16 0v16 32 16H16 142.4l19-51.7-13.9-8.7 0 0L131.2 400H16V368H97.6h11.2l3.8-10.5 9.2-25.2c-4.2-5.5-7.7-11.4-10.6-17.6zM560 16V496H400V320H384V496v16h16H560h16V496 16 0H560 400 384V16 192h16V16H560z'
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fast',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      'M240.3 84.4c-24.8 37.2-69.1 56.4-113.2 49.1l-59.6-9.9C40.6 119 16 139.8 16.1 167.1c0 11.7 4.7 22.9 12.9 31.2l29.2 29.2c14 14 21.9 33 21.9 52.8c0 20.1-8.1 39.4-22.5 53.4L44.5 346.5C36.5 354.3 32 365 32 376.2c0 26.6 24.6 46.3 50.6 40.6L144.9 403c8.9-2 18-3 27.1-3h10c30.9 0 60.8 10.5 85 29.8l30.9 24.7c7.7 6.1 17.2 9.5 27 9.5c23.9 0 43.3-19.4 43.3-43.3l0-25.2c0-41.5 25.5-78.7 64.1-93.7L469 287.5c16.3-6.3 27-22 27-39.4c0-20.4-14.6-37.9-34.7-41.6l-28-5.1c-42.8-7.8-76.8-40.5-86.3-82.9L340 87c-5.1-22.8-25.4-39-48.7-39c-16.7 0-32.3 8.3-41.5 22.2l-9.4 14.1zM227 75.5l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1zM165.7 186.3l32 32 5.7 5.7-5.7 5.7-32 32-5.7 5.7-5.7-5.7-32-32-5.7-5.7 5.7-5.7 32-32 5.7-5.7 5.7 5.7zM160 244.7L180.7 224 160 203.3 139.3 224 160 244.7zm128 32l5.7 5.7 32 32 5.7 5.7-5.7 5.7-32 32-5.7 5.7-5.7-5.7-32-32-5.7-5.7 5.7-5.7 32-32 5.7-5.7zM267.3 320L288 340.7 308.7 320 288 299.3 267.3 320zM304 232l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fast',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      'M0 0H8 376h8V8 504v8h-8H8 0v-8V8 0zM16 482.5L182.1 256 16 29.5V482.5zM25.9 496H358.1L192 269.5 25.9 496zm176-240L368 482.5V29.5L201.9 256zM358.1 16H25.9L192 242.5 358.1 16z'
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fast',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM219.3 192.5l-5.9 5.4L140.7 264H248c39.8 0 72 32.2 72 72v40 8H304v-8V336c0-30.9-25.1-56-56-56H140.7l72.7 66.1 5.9 5.4-10.8 11.8-5.9-5.4-88-80-6.5-5.9 6.5-5.9 88-80 5.9-5.4 10.8 11.8z'
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fast',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM576 96V48 32H560 152.5l20.3 16H560V90.1L425.2 247.3l12.6 9.9L576 96zM368 385.6v91.1l-96-84V309.8l-16-12.6V400l112 98 16 14V490.7 398.3l-16-12.6z'
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fast',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      'M16 48V160H128V48H16zm0 128V464H128V176H16zm128 0V464H496V176H144zm352-16V48H144V160H496zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM440 291.3l-5.7-5.7L408 259.3V368v8h-8H291.3l26.3 26.3 5.7 5.7L312 419.3l-5.7-5.7-40-40-5.7-5.7 5.7-5.7 40-40c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L291.3 360H392V259.3l-26.3 26.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l40-40 5.7-5.7 5.7 5.7 40 40 5.7 5.7L440 291.3z'
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fast',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      'M0 64H8 344h4.2l2.4 3.5 160 232 1.4 2.1V304 440v8H496v-8V306.5L339.8 80H16v64H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H80v64H272h2.6l2.1 1.5 88 64 3.3 2.4V408v32 8H352v-8V412.1L269.4 352H72 64v-8V264v-8h8H240c26.5 0 48-21.5 48-48s-21.5-48-48-48H8 0v-8V72 64z'
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fast',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      'M16 80V432H560V80H16zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM368 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fast',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      'M96 272H16V192c0-44.2 35.8-80 80-80l0 0 1 0 14 .1 2-13.8C119.6 51.8 159.6 16 208 16c38.3 0 71.3 22.4 86.8 54.9l4.3 9.1h10.1H352c44.2 0 80 35.8 80 80c0 12.2-2.7 23.8-7.6 34.2c5.9-1.1 12-1.8 18.1-2.1c3.6-10 5.5-20.9 5.5-32.1c0-53-43-96-96-96H309.2C291.2 26.2 252.7 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192v80 16H16 96h64.9c.6-5.4 1.5-10.8 2.7-16H96zm432 48v16h16c44.2 0 80 35.8 80 80v80H544 224 144V416c0-34.8 22.2-64.5 53.3-75.5l10.7-3.8V325.5 304c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4c12.5-8.2 27.5-12.9 43.7-12.9c44.2 0 80 35.8 80 80zM128 512h16 80H544h80 16V496 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112v21.5c-37.3 13.2-64 48.7-64 90.5v80 16z'
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fast',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      'M311.3 19.2l3.2-7.3L299.9 5.5l-3.2 7.3-5.5 12.6c-11-2-22.5-1.9-34.1 .8c-12.5 2.9-24.4 6.3-35.7 10.1l-4-9.4-3.2-7.4-14.7 6.3 3.2 7.4 3.7 8.6C182.8 51 162.1 62.2 144 74.7l-9.2-14.9L130.6 53 117 61.4l4.2 6.8 9.8 16c-19.7 15.2-36 31.9-49.5 49l-4.7-3.6-6.4-4.8-9.6 12.8 6.4 4.8L72 146c-3.8 5.4-7.3 10.9-10.5 16.3c-9.5 15.8-16.5 31-21.7 44.6l-12.2-6.1-7.2-3.6-7.2 14.3 7.2 3.6 14 7c-1.2 3.6-2.2 7.1-3.1 10.4c-3.2 11.7-5.8 23.8-7 35.9c-.7 7.8-.3 15.5 1 22.8l-12.6 5.5-7.3 3.2 6.4 14.7 7.3-3.2 10.6-4.6c8.5 21.5 25.6 38.9 47.5 47.5l-4.6 10.6-3.2 7.3 14.7 6.4 3.2-7.3 5.5-12.6c2.5 .5 5 .8 7.6 1c22.8 2.1 44.4-5.2 60.8-18.7l9 9.5 5.5 5.8 11.6-11-5.5-5.8-9.2-9.8c10.2-12.3 17.1-27.6 18.9-44.6c.9-6 2.6-12 4.8-17.8l8.2 3.9 7.2 3.4 6.9-14.5-7.2-3.4-8.3-3.9c.8-1.4 1.6-2.8 2.4-4.1c8.3-13.8 22.2-30.8 47.8-44l2.9 13 1.7 7.8 15.6-3.5-1.7-7.8L268.2 198c8-3.1 16.8-5.9 26.7-8.1c12.3-2.8 23.3-8.2 32.6-15.4l10.3 6.4 6.8 4.2 8.4-13.6-6.8-4.2-6.7-4.2c16.2-18.7 23.9-44.3 19.1-70.2l12.6-5.5 7.3-3.2-6.4-14.7-7.3 3.2-10.6 4.6c-8.7-22.2-26.2-39.1-47.5-47.5l4.6-10.6zM224 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm47.6 91.4c-4 36.8-36.8 63.7-73.8 60.3c-37.4-3.4-64.9-36.5-61.6-73.8c1-10.8 3.4-22 6.5-33.1c4.8-17.6 13.4-41.2 28.4-66.2c31-51.7 87.8-106.2 185.5-128.8c36.6-8.4 73.1 14.4 81.5 51s-14.4 73.1-51 81.5c-58.2 13.4-85.5 42.9-99.5 66.2c-7.3 12.1-13.8 26.7-16.1 42.2c0 .2-.1 .5-.1 .7zM325.5 500.2l14.7 6.4 3.2-7.3 5.5-12.6c11 2 22.5 1.9 34.1-.8c12.5-2.9 24.4-6.3 35.7-10.1l4 9.4 3.2 7.4 14.7-6.3-3.1-7.4-3.7-8.6c23.5-9.2 44.2-20.5 62.4-32.9l9.2 14.9 4.2 6.8 13.6-8.4-4.2-6.8-9.8-16c19.7-15.2 36-31.9 49.5-49l4.7 3.6 6.4 4.8 9.6-12.8-6.4-4.8L568 366c3.8-5.4 7.3-10.9 10.5-16.3c9.5-15.8 16.5-31 21.7-44.6l12.2 6.1 7.2 3.6 7.2-14.3-7.2-3.6-14-7c1.2-3.6 2.2-7.1 3.1-10.4c3.2-11.7 5.8-23.8 7-35.9c.7-7.8 .3-15.5-1-22.8l12.6-5.5 7.3-3.2-6.4-14.7-7.3 3.2-10.6 4.6c-8.5-21.5-25.6-38.9-47.5-47.5l4.6-10.6 3.2-7.3-14.7-6.4-3.2 7.3-5.5 12.6c-2.5-.5-5-.8-7.6-1c-22.8-2.1-44.4 5.2-60.8 18.7l-9-9.5-5.5-5.8-11.6 11 5.5 5.8 9.2 9.8c-10.2 12.3-17.1 27.6-18.9 44.6c-.9 6-2.6 12-4.8 17.8l-8.2-3.9-7.2-3.4-6.9 14.5 7.2 3.4 8.3 3.9c-.8 1.4-1.6 2.8-2.4 4.1c-8.3 13.8-22.2 30.8-47.8 44l-2.9-13-1.7-7.8-15.6 3.5 1.7 7.8 3.6 16.3c-8 3.1-16.8 5.9-26.7 8.1c-12.3 2.8-23.3 8.2-32.6 15.4l-10.3-6.4-6.8-4.2L287 340.6l6.8 4.2 6.7 4.2c-16.2 18.7-23.9 44.3-19.1 70.2l-12.6 5.5-7.3 3.2 6.4 14.7 7.3-3.2 10.6-4.6c8.7 22.2 26.2 39.1 47.5 47.5l-4.6 10.6-3.2 7.3zM400 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm48.4-187.4c4-36.8 36.8-63.7 73.8-60.3c37.4 3.4 65 36.5 61.6 73.8c-1 10.8-3.4 22-6.5 33.1c-4.8 17.6-13.4 41.2-28.4 66.2c-31 51.7-87.8 106.2-185.5 128.8c-36.6 8.4-73.1-14.4-81.5-51s14.4-73.1 51-81.5c58.2-13.4 85.5-42.9 99.5-66.2c7.3-12.1 13.8-26.7 16.1-42.2c0-.2 .1-.5 .1-.7z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fast',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M12.7 256l5.7 5.7 208 208 5.7 5.7L243.3 464l-5.7-5.7L35.3 256 237.7 53.7l5.7-5.7L232 36.7l-5.7 5.7-208 208L12.7 256z'
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fast',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      'M16 256C16 123.5 123.5 16 256 16h8V0h-8C114.6 0 0 114.6 0 256S114.6 512 256 512h8V496h-8C123.5 496 16 388.5 16 256zM314.8 121.9l-152 128-7.3 6.1 7.3 6.1 152 128 6.1 5.2L331.3 383l-6.1-5.2L189.9 264H504h8V248h-8H189.9L325.2 134.1l6.1-5.2L321 116.7l-6.1 5.2z'
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fast',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      'M169.8 13L432 338.8V496H291.3l-5.7-5.7-72-72-2.3-2.3H208 176c-26.5 0-48 21.5-48 48s21.5 48 48 48H440h8v-8V336v-2.8l-1.8-2.2L182.2 3 169.8 13zm34.9 419l64 64H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h28.7zm-83-128.2l7.8-1.7-3.4-15.6-7.8 1.7-22.8 4.9C39.8 305 0 354.2 0 411.2C0 447 15.9 481 43.5 504l7.4 6.2 10.2-12.3-7.4-6.2C29.8 471.8 16 442.3 16 411.2c0-49.4 34.5-92.1 82.8-102.5l22.8-4.9z'
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fast',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      'M256 16a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm64 48A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM15.3 348.7L80 327.1l1.1-61.8 .3-16.1 16 2.4 62.6 9.3 62.2-28.6L240 224l-3.6 19.3L224 310.6l24.5 58.5 6.2 14.8-15.3 4.9L176 408.9l-2.2 63.4-.6 16.2-15.9-3.3L97.8 472.9 34 503.4 16 512l3.9-19.6 13.9-69.3L7.1 368.3 0 353.8l15.3-5.1zM96 327.4l-.2 11.3-10.7 3.6L22.4 363.2l25.8 52.9 2.4 4.9-1.1 5.3L38 483.8l52.9-25.3 4.9-2.3 5.3 1.1L158 469l2.1-60.7 .4-11.3 10.8-3.4 62-19.7-23.9-57.2-1.8-4.4 .9-4.7 10.4-56.3-52 23.9-4.3 2-4.7-.7-60.6-9L96 327.4zm400.7 21.3l15.3 5.1-7.1 14.5-26.7 54.8 13.9 69.3L496 512l-18-8.6-63.7-30.5-59.6 12.4-15.9 3.3-.6-16.2L336 408.9l-63.4-20.1-15.3-4.9 6.2-14.8L288 310.6l-12.4-67.4L272 224l17.8 8.2L352 260.8l62.6-9.3 16-2.4 .3 16.1 1.1 61.8 64.7 21.6zM416 327.4l-1.1-59.8-60.6 9-4.7 .7-4.3-2-52-23.9 10.4 56.3 .9 4.7-1.8 4.4L278.8 374l62 19.7 10.8 3.4 .4 11.3L354 469 411 457.2l5.3-1.1 4.9 2.3L474 483.8l-11.5-57.5-1.1-5.3 2.4-4.9 25.8-52.9-62.7-20.9-10.7-3.6-.2-11.3zM112 144c0-33.2 25.2-60.4 57.5-63.7c1 5.4 2.5 10.7 4.5 15.7c-25.6 1-46 22.1-46 48c0 26.5 21.5 48 48 48c25.8 0 46.9-20.4 48-46c5 2 10.3 3.5 15.7 4.5C236.4 182.8 209.2 208 176 208c-35.3 0-64-28.7-64-64zm224 64c-33.2 0-60.4-25.2-63.7-57.5c5.4-1 10.7-2.5 15.7-4.5c1 25.6 22.1 46 48 46c26.5 0 48-21.5 48-48c0-25.8-20.4-46.9-46-48c2-5 3.5-10.3 4.5-15.7C374.8 83.6 400 110.8 400 144c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fast',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM406.5 416H320c-61.9 0-112-50.1-112-112c0-13.8 2.5-27 7-39.1l-13.1-10.4c-6.4 15.2-9.9 31.9-9.9 49.5c0 70.7 57.3 128 128 128H426.7l-20.3-16zM432 208c0 13.8-2.5 27-7 39.1l13.1 10.4c6.4-15.2 9.9-31.9 9.9-49.5c0-70.7-57.3-128-128-128H213.3l20.3 16H320c61.9 0 112 50.1 112 112zM46.2 131.5l-12.6-9.9C12.7 144.4 0 174.7 0 208c0 70.7 57.3 128 128 128h24V320H128C66.1 320 16 269.9 16 208c0-29.6 11.5-56.4 30.2-76.5zM640 304c0-70.7-57.3-128-128-128H488v16h24c61.9 0 112 50.1 112 112c0 29.6-11.4 56.4-30.2 76.5l12.6 9.9C627.3 367.6 640 337.3 640 304z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fast',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      'M230.6 336H336c5.6 0 11.2-.3 16.6-.9C342.1 316.5 336 295 336 272c0-70.7 57.3-128 128-128c10.1 0 20 1.2 29.5 3.4C480 72.7 414.6 16 336 16c-88.4 0-160 71.6-160 160V281.4L230.6 336zM336 0c89.3 0 163.1 66.5 174.5 152.7c.8 5.9 1.3 11.9 1.5 18c-5.2-2.5-10.7-4.6-16.3-6.2c-10-2.9-20.6-4.5-31.6-4.5c-61.9 0-112 50.1-112 112c0 22.3 6.5 43 17.7 60.4c3.2 4.9 6.7 9.6 10.6 13.9c-5.8 1.5-11.7 2.7-17.8 3.6c-8.6 1.3-17.5 2-26.5 2H227.3l-52.4 52.4C185.5 415.9 192 431.2 192 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1L160 284.7V176C160 78.8 238.8 0 336 0zM168 296v0l1.7 1.7-56.6 56.6-6.3 6.3-5.6-6.9C92.4 342.9 79 336 64 336c-26.5 0-48 21.5-48 48s21.5 48 48 48c2.5 0 5-.2 7.4-.6l10.8-1.7-1.7 10.8c-.4 2.4-.6 4.9-.6 7.4c0 26.5 21.5 48 48 48s48-21.5 48-48c0-15-6.9-28.4-17.7-37.2l-6.9-5.6 6.3-6.3 56.6-56.6L216 344h0l-48-48zm112-64l0 0h0v0z'
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fast',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      'M427.1 0H432h24C557.6 0 640 82.4 640 184v34.2c0 76.4-37.6 147.9-100.6 191.2L512 428.2V504v8h-8H392h-8v-8V458.4c-6.1 1.5-14.5 3.5-24.4 5.5c-11.6 2.3-25.3 4.7-39.6 6.2V454c13-1.5 25.6-3.7 36.4-5.8c9.9-2 18.2-3.9 24.1-5.4c3-.7 5.3-1.4 6.9-1.8l1.8-.5 .4-.1 .1 0 0 0 0 0 0 0 10.2-2.9V448v48h96V424v-4.2l3.5-2.4 30.9-21.2C589 355.9 624 289.3 624 218.2V184c0-92.8-75.2-168-168-168H436.9L423.2 43.6l-1.4 2.7L419 47.4l-35 14V112H488c39.8 0 72 32.2 72 72v72 8h-8H480h-2.5l-2-1.4-72.4-49.8c-34.9-24-76.2-36.8-118.6-36.8c-52.4 0-102.8 19.6-141.4 55L16 347.5V496H272V457.2L102.5 423.8 96 422.6V416 360v-8h16v8 49.4l169.5 33.4 6.5 1.3v6.6V456v16 32 8h-8H8 0v-8V344v-3.5l2.6-2.4L132.3 219.2c41.5-38.1 95.9-59.2 152.2-59.2c45.6 0 90.1 13.8 127.6 39.6L482.5 248H544V184c0-30.9-25.1-56-56-56H376h-8v-8V56 50.6l5-2 37.2-14.9L424.8 4.4 427.1 0zM464 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fast',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M224 140.7l5.7 5.7 176 176 5.7 5.7L400 339.3l-5.7-5.7L224 163.3 53.7 333.7 48 339.3 36.7 328l5.7-5.7 176-176 5.7-5.7z'
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fast',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      'M160 432V416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432zm0-32h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm0-192H352c4.4 0 8 3.6 8 8s-3.6 8-8 8H160c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fast',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      'M11.3 283.3L0 272l11.3-11.3 135-135-104-104L36.7 16 48 4.7l5.7 5.7 104 104 103-103L272 0l11.3 11.3L500.7 228.7 512 240l-11.3 11.3L251.3 500.7 240 512l-11.3-11.3L32 304h0v0L11.3 283.3zM54.6 304L240 489.4 425.4 304H54.6zm386.7-16l48-48L272 22.6l-103 103 84.7 84.7 5.7 5.7L248 227.3l-5.7-5.7L157.7 137 22.6 272l16 16H441.4z'
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fast',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      'M36 256H348L329.2 496H54.8L36 256zm-1.2-16L17.3 16H366.7L349.2 240H34.8zM40 512H344L382.7 16 384 0H368 16 0L1.3 16 40 512z'
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fast',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm53.7-258.3L147.3 208l66.3 66.3 5.7 5.7L208 291.3l-5.7-5.7-72-72-5.7-5.7 5.7-5.7 72-72 5.7-5.7L219.3 136l-5.7 5.7zm96-11.3l72 72 5.7 5.7-5.7 5.7-72 72-5.7 5.7L292.7 280l5.7-5.7L364.7 208l-66.3-66.3-5.7-5.7L304 124.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fast',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      'M400 16V64H296V32 16H400zM280 76.1L173.2 160H8 0v8V504v8H8 224h16 96 16H568h8v-8V168v-8h-8H402.8L300.9 80H400h16V64 16 0H400 296 280V16 32 64 76.1zM336 416v80H240V416c0-26.5 21.5-48 48-48s48 21.5 48 48zm224 80H352V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H16V176H176h2.8l2.2-1.7L288 90.2l107.1 84.1 2.2 1.7H400 560V496zM328 240a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-40-56a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM72 224H64v8 80 8h8 80 8v-8V232v-8h-8H72zm8 80V240h64v64H80zm336-80v8 80 8h8 80 8v-8V232v-8h-8H424h-8zm16 16h64v64H432V240zM72 352H64v8 80 8h8 80 8v-8V360v-8h-8H72zm8 80V368h64v64H80zm336-80v8 80 8h8 80 8v-8V360v-8h-8H424h-8zm16 16h64v64H432V368z'
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fast',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      'M16 16V496H432V16H16zM0 0H16 432h16V16 496v16H432 16 0V496 16 0zM176 432h96 8v16h-8H176h-8V432h8z'
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fast',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM224 160v40 8 32H144V160h80zm-80 96h80v42.5l-58.8 22.1-7.5 2.8 5.6 15 7.5-2.8 64-24 5.2-1.9V304 256 240 208v-8V160 144H224 144 128v16 80 16h16zm224-96v40 8 32H288V160h80zm-80 96h80v42.5l-58.8 22.1-7.5 2.8 5.6 15 7.5-2.8 64-24 5.2-1.9V304 256 240 208v-8V160 144H368 288 272v16 80 16h16z'
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fast',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM487.5 480l-20.3-16H80V158.3L64 145.6V464v16H80 487.5zM209.1 76.7l13.4 10.5L235.5 48H404.5l17.7 53.1 3.6 10.9h11.5H560V353.7l16 12.6V112 96H560 437.3L416 32H224L209.1 76.7zm2 185c-2 8.4-3.1 17.2-3.1 26.2c0 61.9 50.1 112 112 112c18.3 0 35.6-4.4 50.8-12.2l-14.1-11.1C345.4 381.4 333 384 320 384c-53 0-96-43-96-96c0-5.1 .4-10.2 1.2-15.1l-14.1-11.1z'
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fast',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      'M106.6 119.8l-79 13.2 46.1 65.9 6.4 9.2-6.4 9.2L27.7 283.1l79 13.2 11.3 1.9 1.9 11.3 13.2 79L160 369.4v19.5l-24.1 16.9L121.3 416l-2.9-17.5L104 312 17.5 297.6 0 294.7l10.2-14.5L60.7 208 10.2 135.9 0 121.3l17.5-2.9L104 104l14.4-86.5L121.3 0l14.5 10.2L208 60.7l72.1-50.5L294.7 0l2.9 17.5L307.8 79c-5.1 2.7-10 5.8-14.7 9.2L283.1 27.7 217.2 73.8 208 80.2l-9.2-6.4L132.9 27.7l-13.2 79-1.9 11.3-11.3 1.9zM208 112c18.4 0 35.6 5.2 50.2 14.1c-2.7 4.6-5.2 9.3-7.4 14.3C238.4 132.5 223.7 128 208 128c-44.2 0-80 35.8-80 80c0 26.6 13 50.1 32.9 64.7c-.6 5-.9 10.1-.9 15.3v3.2c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96zM368 96c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.8 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4l0 64 0 16h-16l-64 0H544v-16h15.9l64 0v-64c0-31.5-22.7-57.6-52.7-63L554.8 238l3.6-16.3c1-4.4 1.5-9 1.5-13.8c0-28.3-18.3-52.2-43.7-60.7l1.2-5-5 3.9c-5.3-1.4-10.8-2.1-16.5-2.1c-13.6 0-26.2 4.3-36.6 11.5l-14 9.8-8.8-14.6C422.4 127.5 397 112 368 112c-44.2 0-79.9 35.8-80 79.9l0 1.3 .1 13.6-13.4 2.3c-37.8 6.3-66.6 39.3-66.6 78.9v80h48v16H208 192v-16-80c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zM342.3 486.9L364 400l4-16H351.5 304 288V368v-8L443.6 239.8 464 224l-6.3 25.1L436 336l-4 16h16.5H496h16v16 8L356.4 496.2 336 512l6.3-25.1zM368 368h20.5l-5 19.9-20.8 83.3L496 368.1V368H432 411.5l5-19.9 20.8-83.3L304 367.9v.1h64z'
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fast',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      'M406.5 416l-20.3-16H112V370.8L174.2 293l1.8-2.2V288 234l-16-12.6v63.8L97.8 363 96 365.2V368v40 8h8H406.5zM209.1 76.7l12.7 10C247.5 62.7 282 48 320 48c79.5 0 144 64.5 144 144v86l16 12.6v-5.4V192c0-85.7-67.4-155.6-152-159.8V0H312V32.2c-39.9 2-76 18.5-102.9 44.5zM272 448H256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3H368c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fast',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      'M168 384H384l0-16H176V256v-8H160v8V376v8h8zM385.1 224c19.4 0 37.1-6.3 51.5-16.7c6.7-9.4 14.8-17.8 24-24.8l-10.3-11.4-11.8 13.1c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1L308 184.3c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1-11.9 13.1c-13 14.4-31.9 23.7-53.3 23.7c-3.3 0-6.7-.2-10-.7c-42.3-5.7-64.6-56.7-40.5-94.9L136.7 16H503.3l62.8 96.4c11.4 18 12.4 38.9 5.9 56.5c5 2.1 9.7 4.6 14.3 7.4c8.9-22.7 7.7-49.8-6.7-72.6L512 0H128L60.3 103.8c-26.5 42-8.2 98.6 35.7 115.3V256 384 504v8h8H384l0-16H112V384 256 223.2l.2 0c4 .5 8.1 .8 12.1 .8c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8C216 217.2 234.5 224 254.7 224c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fast',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      'M223.1 170.4l-11.3-11.3L192 139.3l-5.7-5.7-5.7-5.7L192 116.7l5.7 5.7 5.7 5.7 8.5 8.5 11.3 11.3 11.3-11.3L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L375.5 277.6l-11.3 11.3 11.3 11.3 8.5 8.5 5.7 5.7 5.7 5.7L384 331.3l-5.7-5.7-5.7-5.7-19.8-19.8-11.3-11.3L223.1 170.4zM352.9 277.6L471.5 159.1c32.7-32.7 32.7-85.8 0-118.5s-85.8-32.7-118.5 0L234.4 159.1 352.9 277.6zM191.7 184.3L203 195.6 86.6 312H313.4l3-3 11.3 11.3L168 480H80L32 512 0 480l32-48V344L191.7 184.3zM70.6 328L48 350.6V432v4.8l-2.7 4L20.6 478 34 491.4l37.1-24.7 4-2.7H80h81.4l136-136H70.6z'
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fast',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      'M368 80v41.4 16.1V176H272V137.5 121.4 80h96zm56.1 56H528c.2 0 .4 0 .6 0c3.9 27.1 27.2 48 55.4 48c30.9 0 56-25.1 56-56s-25.1-56-56-56c-28.2 0-51.6 20.9-55.4 48c-.2 0-.4 0-.6 0H384V80 64H368 272 256V80v40H112c-.2 0-.4 0-.6 0C107.6 92.9 84.2 72 56 72C25.1 72 0 97.1 0 128s25.1 56 56 56c28.2 0 51.6-20.9 55.4-48c.2 0 .4 0 .6 0H215.9C143.1 166.4 91.3 237 88.2 320H48 32v16 96 16H48h96 16V432 336 320H144 104.2c3.6-88.7 67.5-162 151.8-179.8V176v16h16 96 16V176 140.2C468.3 158 532.2 231.3 535.8 320H496 480v16 96 16h16 96 16V432 336 320H592 551.8c-3.1-83-54.9-153.6-127.7-184zM16 128a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm528 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM48 336h96v96H48V336zm448 96V336h96v96H496z'
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fast',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM576 256c0-72.2-26.6-138.3-70.5-188.8L493.4 77.7C534.9 125.4 560 187.8 560 256c0 30.3-5 59.4-14.1 86.6l13.3 10.5c10.9-30.3 16.8-63 16.8-97.1zm-96 0c0-48.2-17.7-92.2-47-125.9l-12.1 10.5C447.7 171.5 464 211.8 464 256c0 7.1-.4 14.1-1.2 21l14.5 11.5c1.8-10.5 2.7-21.4 2.7-32.4zM123.7 192.8l-13.1-10.3C101.2 205.1 96 229.9 96 256c0 48.2 17.7 92.2 47 125.9l12.1-10.5C128.3 340.5 112 300.2 112 256c0-22.3 4.1-43.6 11.7-63.2zM46.1 131.5L33.3 121.4C12 161.6 0 207.4 0 256c0 72.2 26.6 138.3 70.5 188.8l12.1-10.5C41.1 386.6 16 324.2 16 256c0-44.9 10.9-87.2 30.1-124.5z'
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fast',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm85.7 117.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L160 276.7l5.7 5.7L224 340.7 346.3 218.3l5.7-5.7L363.3 224l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fast',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM208 144v32h32V144H208zm-16-16h16 32 16v16 32 16H240 208 192V176 144 128zM120 248H328h8v16h-8H120h-8V248h8zm120 88H208v32h32V336zm-32-16h32 16v16 32 16H240 208 192V368 336 320h16z'
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fast',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      'M80 0V8 64l424 0h8V80h-8L80 80V504v8H64v-8V80H8 0V64H8l56 0V8 0H80zm64 144V368H464V144H144zm-16-16h16H464h16v16V368v16H464 144 128V368 144 128z'
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fast',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 228.7L196.7 240l5.7 5.7 64 64 5.7 5.7L283.3 304l-5.7-5.7-64-64-5.7-5.7zm-72 8L124.7 248l5.7 5.7 128 128 5.7 5.7L275.3 376l-5.7-5.7-128-128-5.7-5.7zm-8 72L116.7 320l5.7 5.7 64 64 5.7 5.7L203.3 384l-5.7-5.7-64-64-5.7-5.7zM151.3 148c28.2-28.2 66.5-44 106.3-44C340.7 104 408 171.3 408 254.4c0 39.9-15.8 78.1-44 106.3l-9.6 9.6 11.3 11.3 9.6-9.6c31.2-31.2 48.7-73.5 48.7-117.7C424 162.5 349.5 88 257.6 88c-44.1 0-86.5 17.5-117.7 48.7l-9.6 9.6 11.3 11.3 9.6-9.6z'
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fast',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      'M216.8 36.5L5.6 468.5 0 480H12.8 440h8V464h-8H25.6L231.2 43.5l-14.4-7zm1 141.2l-7.2 14.5c29 20.3 54.3 45.3 75 74l13.5-8.6c-22.2-31.1-49.7-58.1-81.2-79.8zM342.4 416h16.1c-4.1-42-16.1-81.7-34.5-117.5l-13.5 8.7c16.9 33.3 28 70 31.9 108.9z'
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fast',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      'M204.2 103.2c4-1.8 7.8-3.6 11.5-5.5L385.8 16H632h8V0h-8H384c-1.2 0-2.4 .3-3.5 .8L259.2 59c-1.4-1.4-3.2-3.1-5.2-5l-1.4-1.3C232.4 34.4 186.6 0 128 0C48 0 0 64 0 64s35.6 41.5 96.6 53.1C39.8 141.6 0 198.2 0 264v16 16H16 32c88.4 0 160-71.6 160-160V120 109l12.2-5.9zm-6.7-14.5C177.9 97.3 154.3 104 128 104c-36.2 0-65.2-12.6-85.4-25.5C34 73.1 27.2 67.6 22.1 63.2C27.3 58 34.4 51.5 43.4 44.9C63.6 30.2 92.4 16 128 16c35.7 0 66.6 14.3 89.1 29.3c9.5 6.3 17.3 12.7 23.2 17.9c-5.7 4.4-13.3 9.7-22.4 15c-3 1.7-6.1 3.5-9.4 5.2l-11.1 5.3zM425 446.2c-23.8 31.7-55.4 49.8-89 49.8s-65.2-18.1-89-49.8s-39-76.3-39-126.2s15.2-94.4 39-126.2s55.4-49.8 89-49.8s65.2 18.1 89 49.8s39 76.3 39 126.2s-15.2 94.4-39 126.2zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c7.2 5.5 14 11.6 20.3 18.2c37.9 6.7 78.3 27.9 112.4 63.2c35.3 36.6 56.2 80.6 61.8 121.6c5.7 41-4 77.8-27.9 102.6c-23.8 24.7-58.9 34.5-97.9 28.7c-6.9-1-13.9-2.5-20.9-4.5c-2.9 4.8-6 9.4-9.3 13.9zM16 280V264c0-79.5 64.5-144 144-144h16v16c0 79.5-64.5 144-144 144H16z'
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fast',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-136V360h-8H360h-8v16h8H504h8z'
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fast',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      'M368 96h8H568h8v8V296v8H560v-8V123.3L325.7 357.7l-5.7 5.7-5.7-5.7L192 235.3 13.7 413.7 2.3 402.3l184-184 5.7-5.7 5.7 5.7L320 340.7 548.7 112H376h-8V96z'
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fast',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      'M483.4 224c4.1 0 8.1-.3 12.1-.8l.5-.1V256 384 496H80V384 256 223.2l.2 0c4 .5 8.1 .8 12.1 .8c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8C184 217.2 202.5 224 222.7 224c20.3 0 38.7-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1c20.3 0 38.8-6.8 53.4-18.1c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1zM28.3 103.8c-26.5 42-8.2 98.6 35.7 115.3V256 384 504v8h8H504h8v-8V384 256 219.1c43.9-16.7 62.2-73.3 35.6-115.3L480 0H96L28.3 103.8zM92.4 208c-3.3 0-6.7-.2-10-.7c-42.3-5.7-64.6-56.7-40.5-94.9L104.7 16H471.3l62.8 96.4c24.1 38.2 1.7 89.3-40.7 94.9c-3.3 .4-6.6 .7-10 .7c-21.3 0-40.2-9.3-53.3-23.7l-11.9-13.1-11.8 13.1c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1L276 184.3c-13 14.4-31.9 23.7-53.3 23.7c-21.3 0-40.3-9.3-53.3-23.7l-11.9-13.1-11.9 13.1c-13 14.4-31.9 23.7-53.3 23.7zM144 256v-8H128v8V376v8h8H440h8v-8V256v-8H432v8V368H144V256z'
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fast',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      'M16 0H248V16H16V400H231.8h.3H343.9h.3H560V16H328V0H560h16V16 400v16H560 353.4l13.3 80H440h8v16h-8H360 216 136h-8V496h8 73.2l13.3-80H16 0V400 16 0H16zM80 64H248V80H80V336H496V80H328V64H496h16V80 336v16H496 80 64V336 80 64H80zM225.4 496H350.6l-13.3-80H238.8l-13.3 80zM296 8V244.7l74.3-74.3 5.7-5.7L387.3 176l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L200 164.7l5.7 5.7L280 244.7V8 0h16V8z'
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fast',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 144c35.3 0 64 28.7 64 64l0 8 0 8-16 0 0-8 0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16-40 0-8 0 0-16 8 0 48 0 8 0 0 8 0 24c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-96c0-35.3 28.7-64 64-64zm96 0l8 0 80 0 8 0 0 16-8 0-72 0 0 96 56 0 8 0 0 16-8 0-56 0 0 88 0 8-16 0 0-8 0-88 0-16 0-104 0-8z'
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fast',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm144 80h-8v8 64 8h8 64 8v-8V128v-8h-8H160zm8 64V136h48v48H168zm-48 96v8 64 8h8 64 8v-8V288v-8h-8H128h-8zm16 16h48v48H136V296zm120-80h-8v8 64 8h8 64 8v-8V224v-8h-8H256zm8 64V232h48v48H264zm80 0v8 64 8h8 64 8v-8V288v-8h-8H352h-8zm16 16h48v48H360V296zM384 88h-8v8 64 8h8 64 8v-8V96 88h-8H384zm56 64H392V104h48v48z'
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fast',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 48h16c44.2 0 80 35.8 80 80v8 8h-8H176h-8v-8-8c0-44.2 35.8-80 80-80zm-64 80H328c0-35.3-28.7-64-64-64H248c-35.3 0-64 28.7-64 64zM148.7 192l-42.3-42.3 11.3-11.3L160 180.7l42.3-42.3 11.3 11.3L171.3 192l42.3 42.3-11.3 11.3L160 203.3l-42.3 42.3-11.3-11.3L148.7 192zm192 0l-42.3-42.3 11.3-11.3L352 180.7l42.3-42.3 11.3 11.3L363.3 192l42.3 42.3-11.3 11.3L352 203.3l-42.3 42.3-11.3-11.3L340.7 192z'
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fast',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      'M512 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM224 496c114.9 0 208-93.1 208-208c0-98.5-68.4-180.9-160.3-202.5l8.2 57.4 .5 3.6-2.4 2.8L186.9 255.6 211.3 280H320h8v8 64 2l-1 1.8-56 104-2.3 4.2H264 224h-8v-8V392H192h-8v-8V323.3L124.7 264H64 60.7l-2.3-2.3L24.8 228.1c-5.7 19-8.8 39.1-8.8 59.9c0 114.9 93.1 208 208 208zM30.6 211.3L67.3 248H128h3.3l2.3 2.3 64 64 2.3 2.3V320v56h24 8v8 64h27.2L312 350V296H208h-3.3l-2.3-2.3-32-32-5.2-5.2 4.8-5.6 93.6-109.2-8.5-59.2C245 80.8 234.6 80 224 80C136.2 80 61.1 134.4 30.6 211.3zM269.3 68.6C371.3 89.5 448 179.8 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288S100.3 64 224 64c9.7 0 19.3 .6 28.8 1.8c5.5 .7 11 1.6 16.4 2.7c.1 0 .1 0 .2 0z'
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fast',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zM152 304V288H360v16H152z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fast',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      'M16 480H0V464 48 32H16 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7V150.6L329.4 48H320V184c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V48H16V464H284.5c3.6 5.6 7.6 10.9 11.8 16H16zM224 240c25 0 47.6 10.5 63.7 27.3c-3.2 4.5-6.1 9.2-8.9 14C265.6 265.8 245.9 256 224 256c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.1 0 23.6-3 33.6-8.3c.7 5.5 1.7 11 3 16.4c-11.1 5.1-23.5 7.9-36.6 7.9c-48.6 0-88-39.4-88-88s39.4-88 88-88zM80 48V176H304V48H80zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm8 68.7l5.7 5.7 64 64 5.7 5.7-5.7 5.7-64 64-5.7 5.7L428.7 432l5.7-5.7L484.7 376H360h-8V360h8H484.7l-50.3-50.3-5.7-5.7L440 292.7z'
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fast',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      'M208 16V260.7L314.3 154.3l5.7-5.7 5.7 5.7L384 212.7 506.3 90.3l5.7-5.7 5.7 5.7L624 196.7V16H208zm0 267.3V336h52.7l112-112L320 171.3l-112 112zM283.3 336H624V219.3l-112-112L389.7 229.7 283.3 336zM640 218.9V336v16H624 208 192V336 16 0h16H624h16V16 213.9c.5 1.6 .5 3.4 0 5zM288 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM128 160h32v16H128v80 80 72 88H384V408 384h16v16h64V384h16v16 8 8 80 16H464 400h-8-8H128h-8-8H16 0V496 416v-8-8V344v-8-8V264v-8-8V176 160H16h96 8 8zM112 416H16v80h96V416zm0-16V344H16v56h96zm0-72V264H16v64h96zm0-80V176H16v72h96zM464 416H400v80h64V416z'
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fast',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      'M368 80v88V344v88H16V80H368zm16 352V352 334.1 177.9 160 80 64H368 16 0V80 432v16H16 368h16V432zm176-9.9l-144-72V368l144 72 16 8V430.1 81.9 64l-16 8L416 144v17.9l144-72V422.1zM232 352h8V336h-8H123.3L285.7 173.7l5.7-5.7L280 156.7l-5.7 5.7L112 324.7V216v-8H96v8V344v8h8H232z'
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fast',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      'M160 176c-35.3 0-64-28.7-64-64c0-7.9 3.4-17.9 10.3-29.6c6.7-11.5 16-23 25.5-33.6c9.5-10.5 19.1-19.6 26.4-26.1L160 21l1.8 1.6c7.2 6.5 16.8 15.6 26.4 26.1c9.6 10.6 18.8 22.1 25.5 33.6C220.6 94.1 224 104.1 224 112c0 35.3-28.7 64-64 64zM160 0s-80 64-80 112c0 44.2 35.8 80 80 80s80-35.8 80-80C240 64 160 0 160 0zM112 240h16v48 8h16v-8V240h64c17.7 0 32 14.3 32 32V496H80V272c0-17.7 14.3-32 32-32zM256 496V272c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48V496H8 0v16H8 64 80 240h16H384c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H256zm80-48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fast',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V241.1l-83.6-55.7-6.7-4.4-8.9 13.3 6.7 4.4 96 64 12.4 8.3V256 104 96H248v8z'
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fast',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      'M44.1 33.1l80 48 6.9 4.1L122.7 99l-6.9-4.1-80-48L29 42.7 37.3 29l6.9 4.1zm560 13.7l-80 48L517.3 99 509 85.3l6.9-4.1 80-48 6.9-4.1L611 42.7l-6.9 4.1zM8 192H88h8v16H88 8 0V192H8zm544 0h80 8v16h-8H552h-8V192h8zM464 96l28 224H475.9l-26-208H190.1l-26 208H148L176 96H464zM245 160L225 320H208.9l20-160H245zM528 368H112v96H528V368zM112 352H528h16v16 96 16H528 112 96V464 368 352h16z'
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fast',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M181.4 409.8s17.2-7 42.6-17.9L224 496l0 12.9 11.6-5.8 144-72 4.4-2.2V424 312.1c4-2.5 7.7-4.9 11.3-7.3C527.1 215.4 519.9 78.3 502.7 9.3c-68.9-17.2-206-24.5-295.4 107.4c-2.4 3.6-4.9 7.3-7.3 11.3H88 83.1l-2.2 4.4-72 144L3.1 288H16 118.5c-10.9 24.4-17.9 40.9-17.9 40.9l80.8 80.8zM240 483.1l0-98.3c38.5-17 88.9-40.6 128-63.1v97.4l-128 64zM190.2 144c-22.9 39.2-47 89.7-64.5 128H28.9l64-128h97.3zM119.6 325.3c1.6-3.7 3.6-8.2 5.9-13.5c6.4-14.5 15.3-34.6 25.7-56.7c20.9-44.6 47.1-96.6 69.3-129.3C300.5 7.7 421 8 489.3 22.7C504 91 504.3 211.5 386.3 291.5c-32.7 22.2-85 47.9-130 68.4c-22.3 10.2-42.6 18.9-57.2 25.1c-5.5 2.3-10.1 4.3-13.9 5.8l-65.6-65.6zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fast',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V229.6l-49.3-74-4.4-6.7-13.3 8.9 4.4 6.7 64 96 14.7 22V256 104 96H248v8z'
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fast',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      'M0 176C0 78.8 128.9 0 288 0V16C137.8 16 16 87.6 16 176c0 53.9 45.3 101.6 114.7 130.6l0 0c5.9 2.5 12 4.8 18.3 7l0 0c40.7 14.2 88.2 22.4 139 22.4c150.2 0 272-71.6 272-160c0-68.5-73.2-126.9-176-149.7V10C495.9 34.2 576 99.4 576 176c0 97.2-128.9 176-288 176c-30.4 0-59.6-2.9-87.1-8.2C220.4 361.9 232 387.6 232 415c0 53.6-43.4 97-97 97H40 32V496h8 95c44.7 0 81-36.3 81-81c0-30.7-17.3-58.7-44.8-72.4l-30.7-15.3C56.4 296.5 0 240.3 0 176zM344 8v8V72h56 8V88h-8H344v56 8H328v-8V88H272h-8V72h8 56V16 8h16zM504 368v56h56 8v16h-8H504v56 8H488v-8V440H432h-8V424h8 56V368v-8h16v8z'
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fast',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 413.4C309.3 399.1 287.3 384 256 384s-53.3 15.1-66.1 29.4l-5.4 5.9-11.9-10.7 5.4-5.9C193.1 386 219.1 368 256 368s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7-5.4-5.9zM211.3 248l-5.7 5.7-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L211.3 248zm95 5.7l-5.7-5.7L312 236.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fast',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156-76v24H420V292h24zM408 456V440h8 8V360h-8-8V344h8 16 8v8 88h8 8v16h-8-8H424h-8-8z'
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fast',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      'M492.4 256c0-132.5-107.4-240-240-240h-8V0h8c141.4 0 256 114.6 256 256s-114.6 256-256 256h-8V496h8c132.5 0 240-107.5 240-240zM159.3 121.9l6.1-5.2L175.7 129l-6.1 5.2L34.3 248H340.4h8v16h-8H34.3L169.6 377.9l6.1 5.2-10.3 12.2-6.1-5.2-152-128L0 256l7.3-6.1 152-128z'
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fast',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      'M176 401.8L16 457.5V107.4L176 51.7V401.8zm208 59L192 401.7V51.2l192 59.1V460.8zm16-.5V110.2L560 54.5V404.6L400 460.3zM0 480l16-5.6L184 416l208 64 184-64V48.9 32l-16 5.6L392 96 184 32 0 96V463.1 480z'
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fast',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216l-104 0v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zm3.7 54.9C319.1 242.1 275.1 272 224 272s-95.1-29.9-115.7-73.1L48 251.6V272h72 8v16h-8H40 32v-8V248v-3.6l2.7-2.4L96 188.4V144v-8-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8 8 44.4L413.3 242l2.7 2.4V248v32 8h-8H328h-8V272h8 72V251.6l-60.3-52.8zM331.4 96c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96h47.4zM212.2 112L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1zM22.2 496H425.8L372.5 336H75.5L22.2 496zM64 320H384l58.7 176 5.3 16H431.1 16.9 0l5.3-16L64 320z'
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fast',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      'M94.2 15.5c11.6 25.8 40.9 76.9 97.8 100.3V133c-35.7-13.1-62-36.2-80.4-58.9C97.6 56.9 88 39.8 81.9 27C74.7 34.3 66 44.3 57.2 57.1C36.6 87 16 131.9 16 192s20.6 105 41.2 134.9C66 339.7 74.7 349.7 81.9 357c6.1-12.8 15.8-29.9 29.7-47.1C130 287.2 156.3 264.2 192 251v17.2c-56.9 23.4-86.2 74.5-97.8 100.3C89.9 377.9 88 384 88 384s-5.2-3.7-13-11.2C50.6 349.3 0 289 0 192S50.6 34.7 75 11.2C82.8 3.7 88 0 88 0s1.9 6.1 6.2 15.5zM320 133V115.8c56.9-23.4 86.2-74.5 97.8-100.3C422.1 6.1 424 0 424 0s5.2 3.7 13 11.2c22.5 21.6 67 74.1 74.1 157.7l-11.7 11.7L488 192l11.3 11.3L511 215c-7.1 83.6-51.6 136.2-74.1 157.7c-7.8 7.5-13 11.2-13 11.2s-1.9-6.1-6.2-15.5c-11.6-25.8-40.9-76.9-97.8-100.3V251c35.7 13.1 62 36.2 80.4 58.9c14 17.2 23.6 34.3 29.7 47.1c6.1-6.2 13.4-14.4 20.9-24.7c18.3-25.1 37.7-62.2 43.4-111.3l-17.7-17.7L465.4 192l11.3-11.3L494.4 163c-5.7-49.1-25-86.2-43.4-111.3c-7.5-10.2-14.8-18.5-20.9-24.7c-6.1 12.8-15.8 29.9-29.7 47.1C382 96.8 355.7 119.8 320 133zM240 48V496h32V48H240zM224 32h16 32 16V48 496v16H272 240 224V496 48 32z'
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fast',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      'M88 0H82L80.3 5.8 50 112H16 0v16V256v16 48 16H16 64 80V320 272H271.2l4.6-16H80 64 16V128H368v16h16V128 112H368 334L303.7 5.8 302 0h-6H88zM64 272v48H16V272H64zM317.4 112H66.6L94 16H290l27.4 96zM80 208a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM48 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm296-16h-6l-1.7 5.8L306 288H272 256v16V432v16 48 16h16 48 16V496 448H560v48 16h16 48 16V496 448 432 304 288H624 590L559.7 181.8 558 176h-6H344zM624 432H576 560 336 320 272V304H624V432zm-48 16h48v48H576V448zm-304 0h48v48H272V448zM573.4 288H322.6L350 192H546l27.4 96zM336 384a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm272 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fast',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      'M24 32H16v8V472v8H32v-8V48H192c48.6 0 88 39.4 88 88V352v8h16v-8V136c0-57.4-46.6-104-104-104H24zM328 480c57.4 0 104-46.6 104-104V40 32H416v8V376c0 48.6-39.4 88-88 88H168V168v-8H152v8V472v8h8H328z'
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fast',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      'M136 40V32H120v8V472v8h16v-8V40zm128 0V32H248v8V472v8h16v-8V40z'
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fast',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM168 220c0-24.3-19.7-44-44-44s-44 19.7-44 44v44h88V220zM80 280v44c0 24.3 19.7 44 44 44s44-19.7 44-44V280H80zm92.4 79.4C161.5 374.3 143.9 384 124 384c-33.1 0-60-26.9-60-60V272 220c0-33.1 26.9-60 60-60c17.9 0 34.1 7.9 45.1 20.4c5.5-29.8 31.6-52.4 62.9-52.4c24.1 0 45.1 13.3 56 33c10.9-19.7 31.9-33 56-33c31.4 0 57.5 22.6 62.9 52.4c11-12.5 27.1-20.4 45.1-20.4c33.1 0 60 26.9 60 60v52 52c0 33.1-26.9 60-60 60c-19.9 0-37.5-9.7-48.4-24.6C394.2 383.2 371.1 400 344 400c-24.1 0-45.1-13.3-56-33c-10.9 19.7-31.9 33-56 33c-27.1 0-50.2-16.8-59.6-40.6zM232 144c-26.5 0-48 21.5-48 48v28 44h96V192c0-26.5-21.5-48-48-48zM184 324v12c0 26.5 21.5 48 48 48s48-21.5 48-48V280H184v44zm224-60h88V220c0-24.3-19.7-44-44-44s-44 19.7-44 44v44zm0 60c0 24.3 19.7 44 44 44s44-19.7 44-44V280H408v44zm-64 60c26.5 0 48-21.5 48-48V324 280H296v56c0 26.5 21.5 48 48 48zm48-120V220 192c0-26.5-21.5-48-48-48s-48 21.5-48 48v72h96z'
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fast',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      'M8 0H0V8 232v8H8 148l9.3 112H112 96v16V496v16h16H464h16V496 368 352H464 424L508 16l4-16H495.5 160 144.1 128 8zM129.3 16l17.3 208H16V16H129.3zM407.5 352H173.4l-28-336H160 491.5l-20 80H296h-8v16h8H467.5l-20 80H296h-8v16h8H443.5l-36 144zM112 496V368H464V496H112zm176-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fast',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      'M267.3 171.3l4.7-4.7V160 27.2c57 29.1 96 88.4 96 156.8c0 65.1-35.4 122-88 152.5l-8 4.6v9.2V416v80 16h16V496 350.3c57.4-33.2 96-95.2 96-166.3c0-77.5-45.9-144.3-112-174.6c-5.2-2.4-10.5-4.6-16-6.5V20 160l-52.7 52.7L192 224l-11.3-11.3L128 160V20 2.9c-5.5 1.9-10.8 4.1-16 6.5C45.9 39.7 0 106.5 0 184c0 71.1 38.6 133.1 96 166.3V496v16h16V496 416 350.3v-9.2l-8-4.6C51.4 306 16 249.1 16 184c0-68.4 39-127.7 96-156.8V160v6.6l4.7 4.7 64 64L192 246.6l11.3-11.3 64-64z'
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fast',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      'M468.2 253.1c-14.1 14-30.3 24.6-47.6 31.7c-11.2 4.6-22.9 7.6-34.6 10.4c-22.4 5.6-44.6 11.1-62.1 28.6c-17.6 17.6-25.4 42.2-30.3 66.7c-5.4 29.9-19.4 56.9-41.8 78.9C225.1 495.8 188.5 512 148 512H16 0V496 364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c22-22 48.6-35.6 78.1-41c24.5-4.8 49.1-12.6 66.7-30.3c17.6-17.6 23.1-39.7 28.6-62.1c2.9-11.7 5.8-23.4 10.4-34.6c7.2-17.5 18-34 32.3-48.2c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0H496h16V16 148c0 41.1-16.7 78.2-43.8 105.1zM364 16c-17.9 0-35 3.6-50.5 10l0 0c-15.5 6.4-30 15.9-42.7 28.5c-12.7 12.7-22.4 27.4-28.8 43l0 0c-4.2 10.1-6.6 19.9-9.3 30.9l0 0c-1.4 5.6-2.9 11.6-4.7 18c-5 17.7-12.3 36.8-28.6 53.1c-21.1 21.1-49.7 29.7-74.9 34.6l-.2 0 0 0c-26.3 4.8-50 16.9-69.6 36.5C42 283.3 32.4 297.9 26 313.5l0 0C19.6 329 16 346.1 16 364V496H148c36.1 0 68.8-14.5 92.6-37.9l10.5 10.6-10.5-10.6c20-19.7 32.4-43.7 37.3-70.3l0-.2 0 0c5-25.2 13.5-53.8 34.6-74.9c16.2-16.2 35.3-23.5 53.1-28.6c6.4-1.8 12.3-3.3 18-4.7c11-2.7 20.8-5.1 30.9-9.3l0 0c15.4-6.4 29.9-15.8 42.5-28.3l0 0c24.1-23.9 39-57.1 39-93.7V16H364zm36 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM176 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'building-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e61c',
      
      'M16 16H368V181.4c5.2-3 10.5-5.7 16-8.1V16 0H368 16 0V16 496v16H16 144h16 64 16H368h16V496 466.7c-5.5-2.4-10.8-5.1-16-8.1V496H240V384 368H224 160 144v16V496H16V16zM312 232h-8H240h-8v8 64 8h8 48.2c.3-5.4 .8-10.7 1.6-16H248V248h48v21.9c4-12.1 9.4-23.6 16-34.2V232zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zm200 88.1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l89.7 89.5 5.7 5.7L639.3 500l-5.7-5.7L544 404.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fast',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      'M286.1 51.4L26.5 256H496c0-69.1-30.4-121.4-70.5-156.1C385.8 65.6 336.1 48 296 48h-5.5l-4.4 3.4zM16 272v80H496v-.4-.5-.5-.5-.5-.5-.5V348v-.5V347v-.5V346v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V339v-.5V338v-.5-.5-.5-.6-.6-.6-.6-.6V333v-.6-.6-.6-.6-.6-.6V329v-.6-.6-.6-.6-.6-.6V325v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V318v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V310v-.6-.6-.6-.6-.6-.6-.6V305v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V298v-.7-.7V296v-.7-.7V294v-.7-.7-.7-.7-.7-.7-.7-.7V288v-.7-.7V286v-.7-.7V284v-.7-.7-.7-.7-.7-.7-.7-.7-.7V277v-.7-.7-.7-.7-.7-.7-.7V272H16zm480 96H16v80 16H32 480h16V448v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V447 447v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V446 446v-.1-.1-.1-.1-.1-.1-.1-.1-.1V445v-.1-.1-.1-.1-.1-.1-.1-.1-.1V444v-.1-.1-.1-.1-.1-.1-.1V443v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V441v-.1-.1-.1-.1-.1-.1V440v-.1-.1-.1-.1-.1-.1V439v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V437v-.2-.2-.2-.2-.2V436v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V434v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V429v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V425v-.2-.2-.2V424v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3V419v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V416v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V412v-.3-.3-.3-.3-.3-.3-.3-.3-.3V409v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4-.4-.4-.4V396v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V392v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V387v-.4-.4-.4-.4V385v-.4-.4-.4-.4V383v-.4-.4-.4-.4V381v-.4-.4-.4-.4-.4-.4V378v-.4-.4-.4-.4-.4-.4V375v-.4-.4-.4-.4-.4-.4V372v-.4-.4-.4-.4-.5-.4-.5-.5V368zm16 80v16 16H496 480 32 16 0V464 448 272 256.5l12.2-9.6 264-208 8.7-6.9H296c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1z'
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fast',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      'M24 160H16v16h8H424h8V160h-8H24zm0 176H16v16h8H424h8V336h-8H24z'
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fast',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      'M16 72V64H0v8V248 440v8H16v-8V256H304V440v8h16v-8V248 72 64H304v8V240H16V72zm485.2 8h4.2c52.2 0 94.6 42.4 94.6 94.6c0 24.5-9.5 48-26.5 65.7L386.2 434.4l-2.2 2.3V448h8H624h8V432h-8H410.8L585 251.4c19.9-20.6 31-48.1 31-76.8C616 113.5 566.5 64 505.4 64h-4.2c-31.1 0-61.1 11.1-84.7 31.3l-21.7 18.6-6.1 5.2 10.4 12.1 6.1-5.2 21.7-18.6c20.7-17.7 47-27.5 74.2-27.5z'
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fast',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      'M440 264l5.7-5.7-5.7-5.7-136-136-5.7-5.7L287 122.3l5.7 5.7L415 250.3l-308.7 0-8 0 0 16 8 0 308.7 0L292.7 388.7l-5.7 5.7 11.3 11.3L304 400 440 264zM18.3 74.3l0-8-16 0 0 8 0 368 0 8 16 0 0-8 0-368z'
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fast',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      'M112 96V72 64h16v8V96h37.9 21.8l-16.6 14.1c-3.6 3.1-7.3 6.4-10.9 10.1c-55.7 55.7-46.7 114.7-27.8 140.9l74.7-74.7-12.7-12.7-5.7-5.7L200 156.7l5.7 5.7 12.7 12.7 44.7-44.7 2.3-2.3h3.3H400V104 96h16v8 24h47.3C458.1 96.1 422.8 48 344 48c-26 0-47.2 5.3-64.2 13.4l-5.8 2.8-4-5C252 36.3 219.1 16 168 16C89.3 16 53.9 64.1 48.7 96H112zm0 16H40 32v-8C32 63.1 74.5 0 168 0c52.4 0 88.7 19.7 110.6 44.4C296.8 36.7 318.5 32 344 32c93.5 0 136 63.1 136 104v8h-8H416 400 306.8c2 10.3 4 22.1 5.5 35.3c5.2 45.4 5 106.7-15.6 173C363.4 356.8 416 412.2 416 480v16 16H400 48 32V496 480c0-70.7 57.3-128 128-128h42.5c26-58.4 37.4-113.8 42.3-154.9c1.2-10.5 2.1-20 2.6-28.4L137.5 278.6l-5.7 5.7-5.7-5.7c-28.5-28.5-43-101.2 19.5-166.6H128 112zm148.7 87c-4.9 40.7-16 95.2-40.7 153h60.1c21.1-65.3 21.5-126.1 16.4-170.9c-1.6-14.1-3.7-26.6-5.9-37.1H272.1l-7.9 7.9c-.3 12-1.2 28.1-3.5 47.1zM160 368C98.1 368 48 418.1 48 480v16H400V480c0-61.9-50.1-112-112-112H160z'
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fast',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      'M0 32H8 152h8V48h-8H16V464H152h8v16h-8H8 0v-8V40 32z'
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fast',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      'M320 416H231.4l-52.7 52.7L167.4 480l-11.3-11.3L75.3 387.9 64 376.6l11.3-11.3L128 312.6V224L464 0l80 80L320 416zm-99.9-11.3l4.7-4.7h6.6 80l30.9-46.4-152-152L144 232.6v80.1 6.6l-4.7 4.7L86.6 376.6l80.8 80.8 52.7-52.7zm131.3-64.6l172-258L462 20.6l-258 172L351.4 340.1zM65.1 411.6l11.3 11.3L16 483.3V496H92.7l28.4-28.4 11.3 11.3-30.7 30.7L99.3 512H96 8 0v-8V480v-3.3l2.3-2.3 62.7-62.7zM232 496H568h8v16h-8H232h-8V496h8z'
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fast',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      'M288 214.9v5l2.8 4.1L324 271.9l8.8-15.3L304 214.9V16h24 8V0h-8H304 288 160 144 120h-8V16h8 24V214.9L0 422.9V496v16H16 352V496H16V427.9L68.6 352H72 325.5l.5-.3L298.8 336H79.7l77.5-112 2.8-4.1v-5V16H288V214.9zm236.1 33.8V222.4v-16h-16H452 436v16 26.2c-8 3.4-15.6 7.8-22.5 12.9l-21.1-12.2-13.9-8-8 13.9-28.9 50.1-8 13.9 13.9 8 21.1 12.2c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4l-21.1 12.2-13.9 8 8 13.9 37 64 34.9-20.1c6.9 5.1 14.5 9.4 22.5 12.9V481v16h16 56.1 16V481 454.6c7.9-3.4 15.4-7.7 22.3-12.8l35.1 20.2 37-64 8-13.9-13.9-8L591.2 364c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3l21.3-12.3 13.9-8-8-13.9-37-64 0 0-35 20.2c-6.9-5.1-14.3-9.4-22.3-12.8zm51.5 14.4l29 50.1-21.3 12.3-9 5.2 1.1 10.4c.4 3.5 .6 7 .6 10.5s-.2 7.1-.6 10.5l-1.1 10.4 9 5.2 21.3 12.3-29 50.1L554.3 428l-9.1-5.2-8.4 6.2c-5.9 4.3-12.3 8-19.1 11l-9.7 4.2v10.5V481H452V454.8 444.2l-9.7-4.1c-6.9-2.9-13.3-6.6-19.3-11l-8.4-6.2-9.1 5.2-21.1 12.1-29-50.1L376.5 378l9.1-5.2-1.1-10.4c-.4-3.5-.6-7-.6-10.6s.2-7.1 .6-10.6l1.1-10.4-9-5.2-21.1-12.2 28.9-50.1 21.1 12.2 9.1 5.2 8.4-6.2c5.9-4.4 12.4-8.1 19.3-11l9.7-4.1V248.6 222.4h56.1v26.4 10.5l9.7 4.2c6.8 2.9 13.2 6.6 19.1 11l8.4 6.2 9.1-5.2 21.2-12.2zM480 319.7a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fast',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.8 335.2c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0l5.7 5.7 11.3-11.3-5.7-5.7c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0l5.7-5.7-11.3-11.3-5.7 5.7c-43.7 43.7-114.7 43.7-158.4 0z'
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fast',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      'M8 0H216h8V16h-8H8 0V0H8zM8 80h96 16 96 8V96h-8H120V216v8H104v-8V96H8 0V80H8zM512 6.2V16 176v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V25.8L352 54.6V208v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V48 41.4l6.4-1.3 160-32L512 6.2zM483.7 154.9c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zm-160 32c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zM328 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm181.7 13.7l-208 208-11.3-11.3 208-208 11.3 11.3zM496 472a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM32 256h96 8v8 37.5c0 19.1-7.6 37.4-21.1 50.9L91.3 376 152 436.7l50.3-50.3 11.3 11.3L163.3 448l50.3 50.3-11.3 11.3L152 459.3l-50.3 50.3L99.3 512H96 16 8v-8V479.8c0-27.6 11-54 30.5-73.5L68.7 376 45.1 352.4C31.6 338.9 24 320.6 24 301.5V264v-8h8zm71.6 85.1c10.5-10.5 16.4-24.7 16.4-39.6V272H40v29.5c0 14.9 5.9 29.1 16.4 39.6L80 364.7l23.6-23.6zM49.8 417.5C33.3 434 24 456.4 24 479.8V496H92.7l48-48L80 387.3 49.8 417.5z'
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fast',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M224 304H208V288l0-64V208 128 112l0-96V0H192 16 0V16 304 496v16H16 208l288 0h16V496 320 304H496 400 384 304 288 224zm160 16v88 8h16v-8V320h96l0 176-288 0H16l0-192L16 16l176 0 0 96-88 0H96v16h8l88 0v80H104 96v16h8 88l0 80H104 96v16h8 88l0 88v8h16v-8l0-88h80v88 8h16v-8V320h80z'
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fast',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM112 256c0 61.9 50.1 112 112 112c27.8 0 53.2-10.1 72.7-26.8L220.4 256h21.5l66.3 73.9C325.5 310.2 336 284.3 336 256c0-61.9-50.1-112-112-112s-112 50.1-112 112zm240 0c0 33.1-12.5 63.2-33.1 85.9L356.6 384H335.1l-27.7-30.9C285 372.4 255.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z'
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fast',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      'M175.5 42.7l2.7-7.5-15.1-5.3-2.7 7.5-152 432-2.7 7.5 15.1 5.3 2.7-7.5 152-432zm114.2-8.4l-15.5-4-2 7.7-112 432-2 7.7 15.5 4 2-7.7 112-432 2-7.7zM384 32H368v8V472v8h16v-8V40 32z'
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fast',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      'M229.7 349.7l-5.7 5.7-5.7-5.7-136-136L76.7 208 88 196.7l5.7 5.7L216 324.7 216 8l0-8 16 0 0 8 0 316.7L354.3 202.3l5.7-5.7L371.3 208l-5.7 5.7-136 136zM16 328l0 168 416 0 0-168 0-8 16 0 0 8 0 176 0 8-8 0L8 512l-8 0 0-8L0 328l0-8 16 0 0 8z'
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fast',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      'M128 507.3l5.7-5.7 96-96 5.7-5.7L224 388.7l-5.7 5.7L136 476.7V264H416.3c.4-5.5 1.2-10.8 2.3-16H328V35.3l82.3 82.3 5.7 5.7L427.3 112l-5.7-5.7-96-96L320 4.7l-5.7 5.7-96 96-5.7 5.7L224 123.3l5.7-5.7L312 35.3V248H8 0v16H8 120V476.7L37.7 394.3 32 388.7 20.7 400l5.7 5.7 96 96 5.7 5.7zM120 40V192h16V40 32H120v8zM312 320V472v8h16v-8V320H312zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fast',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      'M160 0h-4.4l-2.4 3.8L115.6 64H0V80H448V64H332.4L294.8 3.8 292.4 0H288 160zM313.6 64H134.4l30-48H283.6l30 48zM24 112l.1 .8 40 392 .7 7.2H72 376h7.2l.7-7.2 40-392 .1-.8H408L368.8 496H79.2L40 112H24zm200 64c-2.1 0-4.2 .8-5.7 2.3l-80 80-5.7 5.7L144 275.3l5.7-5.7L216 203.3V400h16V203.3l66.3 66.3 5.7 5.7L315.3 264l-5.7-5.7-80-80c-1.5-1.5-3.5-2.3-5.7-2.3z'
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fast',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      'M304 272c-32.5 0-62.3-12.1-84.8-32.2l-11-11c-20-22.6-32.2-52.3-32.2-84.8c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128zM160 144c0 36.9 13.9 70.5 36.7 96L72 364.7 60.7 376 10.3 426.3 4.7 432l5.7 5.7 64 64 5.7 5.7L91.3 496l-5.7-5.7L27.3 432 72 387.3l58.3 58.3 5.7 5.7L147.3 440l-5.7-5.7L83.3 376 208 251.3c25.5 22.8 59.1 36.7 96 36.7c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144z'
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fast',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      'M288 320l16 0 64 0 16 0 0 16 0 16L235.3 500.7 224 512l-11.3-11.3L64 352l0-16 0-16 16 0 64 0 16 0 0-16 0-128 0-16 16 0 96 0 16 0 0 16 0 128 0 16zm0 16l-16 0 0-16 0-144-96 0 0 144 0 16-16 0-80 0 0 9.4 144 144 144-144 0-9.4-80 0zM432 184l0-168L16 16l0 168 0 8L0 192l0-8L0 8 0 0 8 0 440 0l8 0 0 8 0 176 0 8-16 0 0-8z'
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fast',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      'M104 0H96V8 136v8h16v-8V16H282.8l64.8 144h-.9-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-8v16h8 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .7 .1 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .2 .2 .2 .2 .2 .2 .1v84.4L557 320H352V290.2v-7.2l-7.2-.7-31.4-3.1 20-24.4 4.6-5.6-5.1-5.1-64.8-64.8-5.1-5.1-5.6 4.6-24.4 20-3.1-31.4-.7-7.2h-7.2H130.2h-7.2l-.7 7.2-3.1 31.4-24.4-20L89.1 174l-5.1 5.1L19.2 243.9 14 249.1l4.6 5.6 20 24.4L7.2 282.2 0 282.9v7.2 91.6 7.2l7.2 .7 31.4 3.1-20 24.4L14 422.9l5.1 5.1 64.8 64.8 5.1 5.1 5.6-4.6 24.4-20 3.1 31.4 .7 7.2h7.2 91.6 7.2l.7-7.2 3.1-31.4 24.4 20 5.6 4.6 5.1-5.1 64.8-64.8 5.1-5.1-4.6-5.6-20-24.4 31.4-3.1 7.2-.7v-7.2V336H560h3l2.3-2 72-64 2.7-2.4V264 168v-8h-8v8l0-8h0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1H631h-.1-.1-.1-.1-.1-.1-.1-.1-.1H630h-.1-.1-.1-.1-.1-.1-.1H629h-.1-.1-.2-.2-.2H628h-.2-.2-.2-.2-.2H627h-.2-.2-.2-.2-.2-.2-.2-.2-.2H625h-.2-.2-.2-.2-.2-.2-.2-.2H623h-.2-.2-.2H622h-.3-.3-.3H621h-.3-.3-.3-.3-.3-.3H619h-.3-.3-.3-.3-.3-.3H617h-.3-.3H616h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3H612h-.4-.4H611h-.4-.4-.4-.4-.4-.4-.4H608h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H602h-.4-.4-.4-.4-.4-.4H599h-.4-.4-.4-.4-.5-.5-.5-.5-.5-.5H594h-.5H593h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H582h-.5H581h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H575h-.6-.6-.6-.6-.6-.6H571h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H564h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H556h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7-.7H545h-.7-.7H543h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H532h-.7-.7-.7-.7-.7-.7H527h-.7-.7-.7-.7-.7-.7H522h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H512V75.3l29.7-29.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-32 32L496 68.7V72v88h-.5-.8H494h-.8-.8-.8-.8H490h-.8-.8-.8-.8H486h-.8-.8-.8-.8H482h-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8H473h-.8-.8-.8-.8-.8H468h-.8-.8-.8-.8-.8H463h-.8-.8-.8-.8-.8-.8H457h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H445h-.9-.9-.9-.9-.9-.9-.9H438h-.9-.9-.9-.9-.9-.9-.9H431h-.9-.9-.9-.9-.9-.9-.9-.9H423h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H413h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H403h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H392 391h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H378 377h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.6L295.3 4.7 293.2 0H288 104zM336 320v16 38.6l-32.6 3.3-4.9 .5-1.8 4.6c-.7 1.8-1.4 3.5-2.2 5.3l-2 4.5 3.1 3.8 20.8 25.4-54.6 54.6-25.4-20.8-3.8-3.1-4.5 2c-1.7 .8-3.5 1.5-5.3 2.2l-4.6 1.8-.5 4.9L214.6 496H137.4l-3.3-32.6-.5-4.9-4.6-1.8c-1.8-.7-3.5-1.4-5.3-2.2l-4.5-2-3.8 3.1L90.1 476.4 35.6 421.9l20.8-25.4 3.1-3.8-2-4.5c-.8-1.7-1.5-3.5-2.2-5.3l-1.8-4.6-4.9-.5L16 374.6V297.4l32.6-3.3 4.9-.5 1.8-4.6c.7-1.8 1.4-3.5 2.2-5.3l2-4.5-3.1-3.8L35.6 250.1l54.6-54.6 25.4 20.8 3.8 3.1 4.5-2c1.7-.8 3.5-1.5 5.3-2.2l4.6-1.8 .5-4.9 3.3-32.6h77.2l3.3 32.6 .5 4.9 4.6 1.8c1.8 .7 3.5 1.4 5.3 2.2l4.5 2 3.8-3.1 25.4-20.8 54.6 54.6-20.8 25.4-3.1 3.8 2 4.5c.8 1.7 1.5 3.5 2.2 5.3l1.8 4.6 4.9 .5 32.6 3.3V320zm200 64a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 128a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM240 336a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-64-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fast',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      'M0 216C0 149.7 53.7 96 120 96h16 8v16h-8H120C62.6 112 16 158.6 16 216v8H176h16v16V400v16H176 16 0V400 312 240 224v-8zm16 96v88H176V240H16v72zm240-96c0-66.3 53.7-120 120-120h16 8v16h-8H376c-57.4 0-104 46.6-104 104v8H432h16v16V400v16H432 272 256V400 312 240 224v-8zm16 96v88H432V240H272v72z'
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fast',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      'M321.6 208a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM440.9 368l-36-96H235.1l-36 96H440.9zM224 256H416l42 112 6 16H446.9 193.1 176l6-16 42-112zM8 448H632h8v16h-8H8 0V448H8zM195.2 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM496 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM75.5 240L54.2 304H171.8l-6 16H48.9 32l5.3-16L64 224H201.8l-6 16H75.5zm392.6 64H585.8l-21.3-64H444.2l-6-16H576l26.7 80 5.3 16H591.1h-117l-6-16z'
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fast',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      'M95.5 135.7L173 192H275l77.5-56.3 19.4-14.1 12.9-9.4 9.4 12.9 28.2 38.8 9.4 12.9-12.9 9.4-19.4 14.1L320 258.2V288l0 16v24 1l46.1 52.7L389 407.8l-22.7 26.3-40 46.4-15.7 18.2-10.4 12.1-12.1-10.4L251.7 469l-12.1-10.4L250 446.5l15.7-18.2L283 408.2 261.8 384H256 192h-5.8L165 408.2l17.3 20.1L198 446.5l10.4 12.1L196.3 469l-36.4 31.3-12.1 10.4-10.4-12.1-15.7-18.2-40-46.4L59 407.8l22.9-26.1L128 329v-1V304l0-16V258.2L48.5 200.3 29.1 186.2l-12.9-9.4 9.4-12.9 28.2-38.8 9.4-12.9 12.9 9.4 19.4 14.1zM144 304v16.7L198 368h52l54-47.3V304H144zm160-16V258.2 250l6.6-4.8 79.5-57.8 19.4-14.1-28.2-38.8-19.4 14.1-77.5 56.3-4.2 3.1H275 173h-5.2l-4.2-3.1L86.1 148.6 66.7 134.5 38.5 173.3l19.4 14.1 79.5 57.8L144 250v8.1V288l160 0zm3.5 51l-36.1 31.6 2.5 2.9 21.2 24.2 9.2 10.5-9.1 10.5-17.3 20.1-15.7 18.2 36.4 31.3 15.7-18.2 40-46.4 13.6-15.8-13.7-15.7L308 339.5l-.5-.6zM176.6 370.6L140.5 339l-.5 .6L93.9 392.2 80.2 407.9l13.6 15.8 40 46.4 15.7 18.2 36.4-31.3-15.7-18.2-17.3-20.1-9.1-10.5 9.2-10.5 21.2-24.2 2.5-2.9zM280 88A56 56 0 1 0 168 88a56 56 0 1 0 112 0zM152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88z'
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fast',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm49 124.1l2.9-5.2 5.8 1.3 72 16 6.3 1.4 0 6.4 0 16v0c0 128.1-103.9 232-232 232H144h-6.4l-1.4-6.3-16-72-1.3-5.8 5.2-2.9 72-40 5.9-3.3 4.2 5.3 29.3 36.6c28.3-16.3 51.8-39.8 68.1-68.1L267 206.3l-5.3-4.2 3.3-5.9 40-72zM376 160l0-9.6-59.9-13.3L282.3 198l36.6 29.3 5.2 4.1-3.1 5.8c-18.8 35.6-48.1 64.9-83.7 83.7l-5.8 3.1-4.1-5.2L198 282.3l-60.9 33.8L150.4 376H160c119.3 0 216-96.7 216-216v0z'
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fast',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      'M368 16H16V496H144V384 368h16 64 16v16V496H342.2c6.3 5.7 12.9 11 19.9 16H240 224 160 144 16 0V496 16 0H16 368h16V16 208.3l-16 6.2V16zM256.5 312H240h-8v-8V240v-8h8 16v16h-8v48h8v8c0 .9 .1 1.8 .2 2.7c.1 1.8 .2 3.6 .3 5.3zM224 496V384H160V496h64zM72 232h8 64 8v8 64 8h-8H80 72v-8V240v-8zm16 16v48h48V248H88zM72 104h8 64 8v8 64 8h-8H80 72v-8V112v-8zm16 16v48h48V120H88zm152-16h64 8v8 64 8h-8H240h-8v-8V112v-8h8zm8 64h48V120H248v48zM560 290.7L440 244.3V491.9c79.1-33.5 120-119 120-195.9v-5.3zm-256 0V296c0 76.9 40.9 162.4 120 195.9V244.3L304 290.7zM432 512c-96-32-144-130.2-144-216V279.8L432 224l144 55.8V296c0 85.8-48 184-144 216z'
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fast',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fast',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 10.5-.7 20.8-2 31l15.9 2c1.4-10.8 2.1-21.8 2.1-33C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c48.3 0 93.6-13.4 132.1-36.7l-8.3-13.7C343.7 483.4 301.3 496 256 496C123.5 496 16 388.5 16 256zm404.1 25.1l-9.1-5.3-2.7 10.2C389.4 356.7 328.1 408 256 408s-133.4-51.3-152.3-122.1l-15.5 4.1C108.8 367.1 175.9 424 256 424c31.3 0 60.6-8.7 85.9-23.8l56.4 34.3c33.8 20.6 78 9.3 97.8-25c19.7-34.1 8.6-78.4-25.5-98.5l-50.5-29.7zM406.6 420.7l-50.1-30.4c29.5-22.1 52.2-53.6 64.2-90.2l41.7 24.5c26.4 15.6 35.2 50 19.8 76.7c-15.3 26.5-49.4 35.3-75.6 19.4zm-255.7-235c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9c2.5-13.5 7.8-28.4 15.2-39.8zm144.8 39.8c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9z'
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fast',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      'M48 32h8H184c70.1 0 129.1 47.5 146.7 112H384v16H334.1c1.2 7.8 1.9 15.8 1.9 24c0 13.8-1.8 27.3-5.3 40H384v16H325.4c-22.3 56.2-77.2 96-141.4 96H64V472v8H48v-8V328 240H0V224H48V160H0V144H48V40 32zM64 240v80H184c55.1 0 102.6-32.8 124-80H64zm250-16c3.9-12.6 6-26.1 6-40c0-8.2-.7-16.2-2.1-24H64v64H314zM184 48H64v96H314c-17.1-55.6-68.8-96-130-96z'
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fast',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      'M168 147.3L34.3 13.7 45.7 2.3l136 136 2.3 2.3V144v56h56 3.3l2.3 2.3 128 128 2.3 2.3V336v56h56 3.3l2.3 2.3 104 104-11.3 11.3L428.7 408H368h-8v-8V339.3L236.7 216H176h-8v-8V147.3zm-32 192L34.3 237.7l11.3-11.3 104 104 2.3 2.3V336v56h56 3.3l2.3 2.3 104 104-11.3 11.3L204.7 408H144h-8v-8V339.3zM258.3 13.7L269.7 2.3l40 40 2.3 2.3V48v56h56 3.3l2.3 2.3 64 64 2.3 2.3V176v56h56 3.3l2.3 2.3 40 40-11.3 11.3L492.7 248H432h-8v-8V179.3L364.7 120H304h-8v-8V51.3L258.3 13.7z'
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fast',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      'M213.4 499.9L224 512l10.6-12.1L448 256 234.6 12.1 224 0 213.4 12.1 0 256 213.4 499.9zM224 487.7L21.3 256 224 24.3 426.7 256 224 487.7z'
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fast',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      'M624 16H176V97c-5.2-.7-10.6-1-16-1V16 0h16H624h16V16 400v16H624 544h-8H392h-8H324.6l-4.8-16H384V328v-8h8H536h8v8 72h80V16zM528 400V336H400v64H528zM240 224A80 80 0 1 0 80 224a80 80 0 1 0 160 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM21.5 496h277L260.1 368H59.9L21.5 496zM48 352H272l43.2 144 4.8 16H303.3 16.7 0l4.8-16L48 352z'
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fast',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      'M162.3 98.3l-5.7 5.7L168 115.3l5.7-5.7L248 35.3V248L35.3 248l74.3-74.3 5.7-5.7L104 156.7l-5.7 5.7-88 88L4.7 256l5.7 5.7 88 88 5.7 5.7L115.3 344l-5.7-5.7L35.3 264H248l0 212.7-74.3-74.3-5.7-5.7L156.7 408l5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7L344 396.7l-5.7 5.7L264 476.7 264 264l212.7 0-74.3 74.3-5.7 5.7L408 355.3l5.7-5.7 88-88 5.7-5.7-5.7-5.7-88-88-5.7-5.7L396.7 168l5.7 5.7L476.7 248 264 248V35.3l74.3 74.3 5.7 5.7L355.3 104l-5.7-5.7-88-88L256 4.7l-5.7 5.7-88 88z'
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fast',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm383.9 89.3l-.2 1.2c-5.1 30.9-31.8 53.5-63.1 53.5H200h-8V384h8H320.6c23.5 0 43.5-17 47.3-40.1l.2-1.2 1.3-7.9 15.8 2.6-1.3 7.9zM104 192h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H104 96V192h8zm72 16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm112-16h8 72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H296h-8V192zm64 32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fast',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M192 244.7L45.9 98.6 34.6 109.9 180.7 256 34.6 402.1l11.3 11.3L192 267.3 338.1 413.4l11.3-11.3L203.3 256 349.4 109.9 338.1 98.6 192 244.7z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fast',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM421.7 229.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L224 276.7l5.7 5.7L288 340.7 410.3 218.3l5.7-5.7L427.3 224l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fast',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      'M176 72H160 144 128V56 16H96V56 72H80 64 48V56 16H16V56v72 48H208V128 56 16H176V56 72zM48 0H64V16 40 56H80V40 16 0H96h32 16V16 40 56h16V40 16 0h16 32 16V16 56v72 48 16H208 192v16H448V192H432 416V176 128 56 16 0h16 32 16V16 40 56h16V40 16 0h16 32 16V16 40 56h16V40 16 0h16 32 16V16 56v72 48 16H624 608V504v8h-8H400 384 256 240 40 32v-8V192H16 0V176 128 56 16 0H16 48zM448 224H192V496h48V392c0-44.2 35.8-80 80-80s80 35.8 80 80V496h48V224zM176 192H48V496H176V192zm96 304h96 16V480 392c0-35.3-28.7-64-64-64s-64 28.7-64 64v88 16h16zm320 0V192H464V496H592zM464 72V56 16H432V56v72 48H624V128 56 16H592V56 72H576 560 544V56 16H512V56 72H496 480 464z'
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fast',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      'M16 48V368H178.2 184h80 5.8H432V48H16zM172.9 384H16 0V368 48 32H16 432h16V48 368v16H432 275.1l26.7 80H384v16H307.1 296 152 140.9 64V464h82.2l26.7-80zm16.9 0l-26.7 80H284.9l-26.7-80H189.8zM624 48H496V464H624V48zM496 32H624h16V48 464v16H624 496 480V464 48 32h16zm24 96h8 64 8v16h-8H528h-8V128zm8 64h64 8v16h-8H528h-8V192h8zm16 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM64 96V320H384V96H64zM48 80H64 384h16V96 320v16H384 64 48V320 96 80z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fast',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M152 32c4.4 0 8 3.6 8 8s-3.6 8-8 8H16V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V40c0-4.4 3.6-8 8-8H152zM0 328c0-4.4 3.6-8 8-8s8 3.6 8 8V464H152c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V328zM296 32H440c4.4 0 8 3.6 8 8V184c0 4.4-3.6 8-8 8s-8-3.6-8-8V48H296c-4.4 0-8-3.6-8-8s3.6-8 8-8zM448 328V472c0 4.4-3.6 8-8 8H296c-4.4 0-8-3.6-8-8s3.6-8 8-8H432V328c0-4.4 3.6-8 8-8s8 3.6 8 8z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fast',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M232 72V64H216v8V248H40 32v16h8H216V440v8h16v-8V264H408h8V248h-8H232V72z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fast',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      'M176 224c0 3 1.5 7.5 7.6 13.3c6.1 5.8 15.9 11.8 29.2 17.1C239.4 265.1 277.3 272 320 272c23.3 0 45.2-2.1 64.6-5.7c-.4-2.5-.6-5-.6-7.6c0-12 4.8-23.5 13.3-32L400 224l-2.7-2.7c-2-2-3.7-4.1-5.3-6.3c-24.8 6.4-50.4 9.1-72 9.1c-23 0-50.4-3.1-76.8-10.4c-22.3-6.2-44.2-15.6-61.8-29.1c-3.6 12.5-5.5 25.8-5.5 39.5zm208-34.7c0-25 20.3-45.3 45.3-45.3c3.9 0 7.8 .5 11.5 1.5C415 106.1 370.6 80 320 80c-59.8 0-111.2 36.5-132.9 88.5c15.9 13.6 37.3 23.3 60.4 29.8c24.8 6.9 50.8 9.8 72.5 9.8c19.6 0 42.8-2.4 65.3-7.9c-.9-3.5-1.3-7.2-1.3-10.8zM320 64c64.9 0 120.8 38.6 145.9 94.1l.9-.9c8.5-8.5 20-13.3 32-13.3c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 224l2.7 2.7c6.2 6.2 10.4 14 12.2 22.4L635 286l5 2v5.4V320c0 17.7-9 34.5-25.1 49.8s-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7S0 337.7 0 320V293.4 288l5-2 155-62c0-88.4 71.6-160 160-160zM498.7 304c-12 0-23.5-4.8-32-13.3L464 288l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-3.2-3.1-5.9-6.3-7.9-9.5L16 298.8V320c0 11.9 5.9 24.8 20.1 38.2c14.2 13.5 35.7 26.3 63.5 37.5C155.3 417.9 233.1 432 320 432s164.7-14.1 220.3-36.3c27.8-11.1 49.3-24 63.5-37.5C618.1 344.8 624 331.9 624 320V298.8l-80.7-32.3c-3.7 21.3-22.3 37.4-44.6 37.4zM429.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l8.4 8.4 5.7 5.7-5.7 5.7-8.4 8.4c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l8.4-8.4 5.7-5.7 5.7 5.7 8.4 8.4c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-8.4-8.4-5.7-5.7 5.7-5.7 8.4-8.4c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-8.4 8.4-5.7 5.7-5.7-5.7-8.4-8.4c-5.5-5.5-12.9-8.6-20.7-8.6zm40.4 37.5l20.8 20.8 5.7 5.7-5.7 5.7-20.8 20.8-5.7 5.7-5.7-5.7-20.8-20.8-5.7-5.7 5.7-5.7 20.8-20.8 5.7-5.7 5.7 5.7zM454.5 224l9.5 9.5 9.5-9.5-9.5-9.5-9.5 9.5z'
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fast',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm175 92.1l40 72 3.3 5.9-5.3 4.2-36.6 29.3c16.3 28.3 39.8 51.8 68.1 68.1L273.7 267l4.2-5.3 5.9 3.3 72 40 5.2 2.9-1.3 5.8-16 72-1.4 6.3H336 320C191.9 392 88 288.1 88 160v0l0-16 0-6.4 6.3-1.4 72-16 5.8-1.3 2.9 5.2zM104 160c0 119.3 96.7 216 216 216h9.6l13.3-59.9L282 282.3l-29.3 36.6-4.1 5.2-5.8-3.1c-35.6-18.8-64.9-48.1-83.7-83.7l-3.1-5.8 5.2-4.1L197.7 198l-33.8-60.9L104 150.4l0 9.6-8 0 8 0z'
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fast',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      'M63.4 79.7C86.4 59.3 116.3 48 147 48c68.7 0 125 55.7 125 124.3c0 35.7-15.3 69.6-42.1 93.2L2.7 466 0 468.4V480H8 312h8V464h-8H29.2L240.5 277.5c30.2-26.6 47.5-64.9 47.5-105.2C288 94.8 224.4 32 147 32c-34.6 0-68.3 12.7-94.2 35.7L18.7 98l-6 5.3 10.6 12 6-5.3L63.4 79.7z'
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fast',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      'M512 32v8V64h56 8v8V200v8h-8H483.3l-29.7 29.7-2.3 2.3H448 381.8l-30.2 90.5-1.8 5.5H344 244L208 480H48.5 32l4-16L92 240H8 0v-8V72 64H8 496V40 32h16zM338.2 320l26.7-80H268l-20 80h90.2zM108.5 240l-56 224h143l56-224h-143zM16 80V224H444.7l29.7-29.7 2.3-2.3H480h80V80H512 496 16zm56 48H504h8v16h-8H72 64V128h8z'
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fast',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      'M224 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 64a64 64 0 1 1 128 0A64 64 0 1 1 112 64zm4.9 96H235.1h4.8l2.3 4.2 76.9 144-14.1 7.5L230.3 176H121.7L47.1 315.8l-14.1-7.5 76.9-144 2.3-4.2h4.8zM112 280v8V496h40V376v-8h8 32 8v8V496h40V288v-8h16v8V504v8h-8H192h-8v-8V384H168V504v8h-8H104 96v-8V288v-8h16zM448 144V128 16H432V128v16H416v16 32 16V384h30.9H470h2 56V368H480 464V352 325.3 313.8 291.5 269.3 256 144H448zM416 496h72.9L455 405.6l-2.1-5.6H416v96zm56-96h-2l6 16 30 80 6 16H494.9 416 400V496 416 400H384 368 352V384 208 192h16 16 16V176 160 144 128h16V112 32 16H400V0h16 16 16 16V16v96 16h16v16 32 16 60.5V256v8 5.3l16-5.3V208 192h16 16 16v16 96l-64 21.3V336v16h16 32 16v16 16 16H528 487.1 472zm8-91.5l48-16V208H512v56 11.5l-10.9 3.6-16 5.3-5.1 1.7v22.3zM368 384h32V208H368V384z'
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fast',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      'M312 16c13.3 0 24 10.7 24 24s-10.7 24-24 24H208V16H312zM208 0H192V16 32h-8c-39.8 0-72 32.2-72 72v40H64L0 272v24 56 16H16 496h16V352 296 272L448 144H128V104c0-30.9 25.1-56 56-56h8V64 80h16H312c22.1 0 40-17.9 40-40s-17.9-40-40-40H208zM16 352V304H496v48H16zm0-64V275.8L73.9 160H112h16H438.1L496 275.8V288H16zM128 496v16h8H256 376h8V496h-8H264V400H248v96H136h-8z'
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fast',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      'M400 240V224H384 326.5c-52.2 0-94.5 42.3-94.5 94.5c0 9.8 1.6 18.8 4.2 27c-3.6-2.2-7.2-4.7-10.8-7.3C195.3 316.8 168 285 168 240c0-79.5 64.5-144 144-144h72 16V80 16h9.4l144 144-144 144H400V240zM280 384s-11.7-9.6-21-25.9c-6-10.6-11-24.1-11-39.6c0-43.4 35.2-78.5 78.5-78.5H368h16v16 48 16h16 16L564.7 171.3 576 160l-11.3-11.3L416 0H400 384V16 64 80H368 312c-88.4 0-160 71.6-160 160c0 70.4 57.8 111.2 95.7 130.4C266.2 379.8 280 384 280 384zM8 32H0v8V504v8H8 472h8v-8V392v-8H464v8V496H16V48H152h8V32h-8H8z'
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fast',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      'M432 400l0-96-96 0 0 96 96 0zm16 16l-16 0-96 0-16 0 0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16zM432 208l0-96-96 0 0 96 96 0zm16 16l-16 0-96 0-16 0 0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16zM176 400l96 0 0-96-96 0 0 96zm96 16l-96 0-16 0 0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16-16 0zm0-208l0-96-96 0 0 96 96 0zm16 16l-16 0-96 0-16 0 0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16zM16 400l96 0 0-96-96 0 0 96zm96 16l-96 0L0 416l0-16 0-96 0-16 16 0 96 0 16 0 0 16 0 96 0 16-16 0zm0-208l0-96-96 0 0 96 96 0zm16 16l-16 0-96 0L0 224l0-16 0-96L0 96l16 0 96 0 16 0 0 16 0 96 0 16z'
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fast',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      'M296 20.1l40 15v66.1c5.4 1.2 10.8 2.6 16 4.1V24L288 0 238.5 101.5c6.4-1.4 12.9-2.6 19.5-3.5l38-77.9zM169.5 130.4c6.1-3.9 12.4-7.6 19-10.9c-12.8-4.9-26.4-7.5-40.4-7.5c-41.8 0-79 23.3-105.5 59.5S0 257.5 0 312s16.1 104.2 42.5 140.5S106.2 512 148 512c25.5 0 49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6s49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6c41.8 0 79-23.3 105.5-59.5S576 366.5 576 312s-16.1-104.2-42.5-140.5S469.8 112 428 112c-14.1 0-27.6 2.6-40.4 7.5c6.5 3.3 12.9 7 19 10.9c7-1.6 14.2-2.4 21.5-2.4c35.5 0 68.3 19.7 92.5 52.9S560 260.5 560 312s-15.2 97.8-39.5 131c-24.2 33.2-57.1 53-92.5 53c-23.5 0-45.7-8.6-65-24l-5-3.9-5 3.9c-19.4 15.4-41.6 24-65 24s-45.7-8.6-65-24l-5-3.9-5 3.9c-19.4 15.4-41.6 24-65 24c-35.5 0-68.3-19.7-92.5-53C31.2 409.8 16 363.5 16 312s15.2-97.8 39.5-131.1S112.5 128 148 128c7.3 0 14.5 .8 21.5 2.4zM288 144c54.2 0 101.6 24.3 129.7 60.9l4.9 6.3 12.7-9.7-4.9-6.3C399.2 154.4 346.9 128 288 128s-111.2 26.4-142.3 67.1l-4.9 6.3 12.7 9.7 4.9-6.3c28-36.6 75.5-60.9 129.7-60.9zM169.6 272L160 288h18.7 58.7H256l-9.6-16-29.1-48.5L208 208l-9.3 15.5L169.6 272zm58.1 0H188.3L208 239.1 227.7 272zm101.9 0L320 288h18.7 58.7H416l-9.6-16-29.1-48.5L368 208l-9.3 15.5L329.6 272zm58.1 0H348.3L368 239.1 387.7 272zM104 320.5l8-.5c-8 .5-8 .5-8 .5l0 0 0 0 0 .1 0 .2 0 .5c0 .4 .1 1.1 .2 1.8c.2 1.6 .5 3.8 1.1 6.5c1.1 5.4 3 13 6.4 21.7c6.8 17.4 19.5 39.6 43.3 58.3L168 419.8V403.3 400h32v28.5 5.8l5.5 1.8c22.4 7.4 49.6 11.9 82.5 11.9s60.1-4.5 82.5-11.9l5.5-1.8v-5.8V400h32v3.3 16.5l12.9-10.2c23.8-18.7 36.5-40.8 43.3-58.3c3.4-8.7 5.3-16.3 6.4-21.7c.5-2.7 .9-4.9 1.1-6.5c.1-.8 .2-1.4 .2-1.8l0-.5 0-.2 0-.1 0 0 0 0s0 0-8-.5l8 .5 .2-3.6-2.6-2.6-8-8-4.9-4.9-5.5 4.2 0 0 0 0 0 0 0 0-.1 .1-.5 .3c-.4 .3-1.1 .8-2 1.4c-1.8 1.2-4.6 3-8.3 5.2c-7.3 4.3-18.2 10.2-32.3 16C379.8 340.3 338.9 352 288 352h-8v8 24H248V356.5v-6.9l-6.8-1c-36.8-5.4-66-16.2-86-25.7c-10-4.7-17.7-9.1-22.8-12.3c-2.6-1.6-4.5-2.9-5.8-3.7c-.6-.4-1.1-.8-1.4-1l-.3-.2-.1 0 0 0 0 0-5.5-4.2-4.9 4.9-8 8-2.6 2.6 .2 3.6zm17 6c-.3-1.4-.5-2.6-.6-3.6l.6-.6c.9 .6 1.9 1.2 3 1.9c5.6 3.5 13.8 8.1 24.3 13.2c19.9 9.4 48.3 20.1 83.7 26V392v8h8 48 8v-8V367.9c49.7-1.1 89.9-12.8 118.1-24.5c14.9-6.2 26.4-12.3 34.3-17c2.6-1.5 4.8-2.9 6.6-4l.6 .6c-.2 1-.4 2.2-.6 3.6c-.9 4.7-2.6 11.3-5.6 19c-4.6 11.9-12.4 26.2-25.4 39.8V384h-8H368h-8v8 30.6c-19.6 5.8-43.3 9.4-72 9.4s-52.4-3.6-72-9.4V392v-8h-8H160h-8v1.3c-13-13.5-20.7-27.9-25.4-39.8c-3-7.7-4.7-14.3-5.6-19z'
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fast',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      'M336 128v16c0 61.9-50.1 112-112 112s-112-50.1-112-112V128l104 0h3.8l2.4-2.9 33.2-40.6 18.2 24.3L276 112h4 54.9c.7 5.2 1.1 10.6 1.1 16zM284 96L265.8 71.8l26.6-32.5c18.4 14.2 32.2 33.9 39 56.7H284zm-5-65.6L212.2 112H113.1c7.8-54.3 54.4-96 110.9-96c20 0 38.7 5.2 55 14.4zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM211.9 410.4L224 424.6l12.1-14.2L313.6 320h58.5l54.2 176H21.7L75.8 320h58.5l77.5 90.4zM384 304H306.3l-71.8 83.7L224 400l-10.5-12.3L141.7 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304z'
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fast',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      'M76.9 76.9C154.3-.5 277.6-4.1 359.3 66L66 359.3C-4.1 277.6-.5 154.3 76.9 76.9zM370.7 54.7c-88-76.4-221.4-72.8-305.1 10.9s-87.3 217.1-10.9 305.1c3.5 4 7.1 7.9 10.9 11.7l11.3-11.3L371.1 76.9l11.3-11.3c-3.8-3.8-7.7-7.4-11.7-10.9zM496 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-48 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 480a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-48 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM504 256h8V240h-8c-33.3 0-67.6-18.7-94.2-38.4c-13.2-9.8-24.2-19.5-31.9-26.9c-3.8-3.7-6.9-6.7-8.9-8.8c-1-1.1-1.8-1.9-2.3-2.4l-.6-.6-.1-.1 0 0 0 0 0 0-5.4-5.9-11.9 10.7 5.4 5.9L360 168c-5.9 5.4-5.9 5.4-5.9 5.4l0 0 0 0 .1 .1 .2 .2 .7 .7c.6 .6 1.4 1.5 2.5 2.6c2.2 2.3 5.4 5.5 9.4 9.3c8 7.7 19.6 17.9 33.4 28.1C427.6 234.7 465.3 256 504 256zM163.5 366.6l0 0 .1 .1 .6 .4c.5 .4 1.3 1 2.4 1.7c2.1 1.6 5.1 3.9 8.7 7c7.2 6.2 16.9 15.5 26.5 27.4C221.1 427.2 240 461.4 240 504v8h16v-8c0-47.5-21.1-85.2-41.8-110.8c-10.4-12.8-20.7-22.7-28.5-29.4c-3.9-3.4-7.2-5.9-9.5-7.7c-1.2-.9-2.1-1.5-2.7-2l-.8-.5-.2-.1-.1 0 0 0 0 0s0 0-4.5 6.6l4.5-6.6-6.6-4.5-9 13.3 6.6 4.5 0 0 0 0 0 0zM483.2 492.5L498 509.3l12-10.6-14.8-16.8c-8.4-9.5-12.9-21.9-12.5-34.6c.9-33.2-23-62-55.9-67.2l-43.9-6.9c-30.1-4.7-52.9-29.6-55.1-59.9c-1.3-17.2-7.9-33.5-19.1-46.7l-6.5-7.7-5.2-6.1-12.2 10.3 5.2 6.1 6.6 7.7c8.9 10.6 14.3 23.7 15.3 37.5c2.8 37.8 31.2 68.6 68.6 74.6l43.9 6.9c24.9 3.9 43 25.7 42.4 51c-.5 16.7 5.5 33 16.5 45.6z'
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fast',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      'M504 0L492.7 11.3l-295 295L196 308l-.3-.3c-8.8-2.4-18.1-3.7-27.7-3.7c-57.4 0-104 46.6-104 104v24 16H48 32 16 0v16 32 16H16 32 64h96 8 8v-.3c53.7-4.1 96-49 96-103.7c0-9.6-1.3-18.9-3.7-27.7l-.3-.3 1.7-1.7 295-295L576 72 564.7 60.7 515.3 11.3 504 0zM209 317.7L289.7 237 339 286.3 258.3 367 209 317.7zM168 320c8.3 0 16.4 1.2 24 3.3L252.7 384c2.2 7.6 3.3 15.7 3.3 24c0 46.3-35.8 84.3-81.2 87.7l-3.4 .3H168 64 32 16V464H32 64 80V448 408c0-48.6 39.4-88 88-88zm182.3-45L301 225.7l203-203L553.4 72l-203 203zM163.3 11.3L152 0 140.7 11.3 43.3 108.7 32 120l11.3 11.3L176.1 264.1l11.3-11.3L133 198.3 230.3 101l54.4 54.4 11.3-11.3L163.3 11.3zM420.5 291.2l69 69L522 490 392.2 457.6l-69-69-11.3 11.3L384 472l142.4 35.6L544 512l-4.4-17.6L504 352l-72.2-72.2-11.3 11.3zM121.7 187l-67-67L152 22.6l67 67L121.7 187z'
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fast',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      'M0 80H448V96H0V80zM64 240H384v16H64V240zM288 400v16H160V400H288z'
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fast',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      'M280 0h8 80 8V8 32h72 8v8V96h72 8v8V312H520V112H456V248v8H440v-8V104 96l0-48H376l0 136 0 64v8H360v-8V40l0-8 0-16H296V32v8 8V248v8H280v-8V48H216V335.4l-13.7 5.7L157 295.8l-22.6-22.6L89.1 318.4 111.8 341l89.4 89.4c42 42 99 65.6 158.4 65.6H368c26.1 0 50.6-6.6 72-18.1l0 17.9c-21.8 10.4-46.2 16.2-72 16.2h-8.5c-63.7 0-124.7-25.3-169.7-70.3l-89.4-89.4L72.2 324.1l-5.7-5.7 5.7-5.7 56.6-56.6 5.7-5.7 5.7 5.7 28.3 28.3L200 316.1V40 32h8 72V8 0zM88 80v56h56 8v16h-8H88v56 8H72v-8V152H16 8V136h8H72V80 72H88v8zM328 304v40h40 8v16h-8H328v40 8H312v-8V360H272h-8V344h8 40V304v-8h16v8zm240 64v56h56 8v16h-8H568v56 8H552v-8V440H496h-8V424h8 56V368v-8h16v8z'
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fast',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      'M138.6 340l-4.5-4H128 16V176H128h6.1l4.5-4L278.1 48H304V464H278.1L138.6 340zM0 352H16 128L272 480h32 16V464 48 32H304 272L128 160H16 0v16V336v16zm413.7-18.3L480 267.3l66.3 66.3 11.3-11.3L491.3 256l66.3-66.3-11.3-11.3L480 244.7l-66.3-66.3-11.3 11.3L468.7 256l-66.3 66.3 11.3 11.3z'
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fast',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      'M29.8 176l25 320H272v8.2c0 2.7 .3 5.3 .8 7.8H40L1.3 16 0 0H16 368h16l-1.3 16L369.3 188.4c-5.9 2.8-11.5 5.9-16.8 9.1l1.7-21.6H29.8zm-1.2-16H355.5L366.7 16H17.3L28.5 160zM304 303.8s32-104 160-104s160 104 160 104v32h16v16 64 16H624v72c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-72H288v-16-64-16h16v-32zm304 2.7c0-.1-.1-.2-.1-.3c-.1-.3-.2-.6-.4-1c-1-2.4-2.5-6-4.7-10.4c-4.5-8.8-11.7-20.5-22.5-32.2C558.9 239.6 523 215.8 464 215.8s-94.9 23.7-116.2 46.9c-10.8 11.7-18 23.4-22.5 32.2c-2.2 4.4-3.8 7.9-4.7 10.4c-.2 .5-.4 .9-.5 1.3v29.3H608V306.5zM304 415.8h8H616h8v-64H608 320 304v64zm16 16v64H608v-64H320zm74-168a10 10 0 1 1 -20 0 10 10 0 1 1 20 0zm70-6a10 10 0 1 1 0-20 10 10 0 1 1 0 20zm90 6a10 10 0 1 1 -20 0 10 10 0 1 1 20 0z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fast',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M432 368H176V16H345.4L432 102.6V368zM448 96L352 0H176 160V16 368v16h16H432h16V368 96zM16 128H0v16V496v16H16 272h16V496 416H272v80H16V144H128V128H16z'
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fast',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      'M80 16H368V176h16V16 0H368 80 64V16 176H80V16zM368 224h5.9c26.4 32.9 42.1 74.6 42.1 120c0 61.8-29.2 116.9-74.7 152H106.7C61.2 460.9 32 405.8 32 344c0-45.4 15.8-87.1 42.1-120H80 368zM8 208H0v16H8 54.1C30.1 257.9 16 299.3 16 344c0 69 33.6 130.2 85.3 168H346.7c51.7-37.8 85.3-99 85.3-168c0-44.7-14.1-86.1-38.1-120H440h8V208h-8H384 368 80 64 8zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-97.2 16C197 320 176 341 176 366.8c0 7.3 1.7 14.4 4.9 20.9l35.9 71.8 7.2 14.3 7.2-14.3 35.9-71.8c3.3-6.5 4.9-13.7 4.9-20.9c0-25.9-21-46.8-46.8-46.8h-2.3zM192 366.8c0-17 13.8-30.8 30.8-30.8h2.3c17 0 30.8 13.8 30.8 30.8c0 4.8-1.1 9.5-3.3 13.8L224 438.1l-28.7-57.5c-2.1-4.3-3.3-9-3.3-13.8z'
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fast',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      'M496 48V464H224V48H496zM16 48H208V464H16V48zm0-16H0V48 464v16H16 496h16V464 48 32H496 16zM160 96H64v16h96V96zM64 160v16h96V160H64zm96 64H64v16h96V224z'
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fast',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      'M9.1 464L0 480H18.4 493.6 512l-9.1-16L265.2 48.1 256 32l-9.2 16.1L9.1 464zm329-256H173.9L256 64.2 338.1 208zm9.1 16l64 112H100.7l64-112H347.3zm73.1 128l64 112H27.6l64-112H420.4z'
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fast',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      'M400 16H48V464H32V16 0H48 400h16V16 464H400V16zM8 496H440h8v16h-8H8 0V496H8zM96 96a32 32 0 1 1 64 0A32 32 0 1 1 96 96zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM320 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fast',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M176 48V208H16V48H176zM16 32H0V48 208v16H16 176h3.5L224 298.2V304 464v16h16H400h16V464 304 288H400 240h-3.5L192 213.8V208 136H384v72 16h16H560h16V208 48 32H560 400 384V48v72H192V48 32H176 16zM400 304V464H240V304H400zm0-256H560V208H400V48z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fast',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      'M248 0h-5.4l-2 5-56 136-.6 1.5V144v70.7l-4.1 2.4L16 314V264v-8H0v8 64 48 32 8H16v-8V384H184v5.1l-54.2 65.8-1.8 2.2V460v44 8h8H248h16H376h8v-8V460v-2.9l-1.8-2.2L328 389.1V384H496v24 8h16v-8V376 328 264v-8H496v8 50L332.1 217.1l-4.1-2.4V144v-1.6l-.6-1.5L271.4 5l-2-5H264 248zm16 496V416v-8H248v8 80H144V462.9l54.2-65.8 1.8-2.2V392 145.6L253.4 16h5.3L312 145.6V392v2.9l1.8 2.2L368 462.9V496H264zM496 368H328V233.3l168 99.3V368zm-312 0H16V332.6l168-99.3V368z'
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fast',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm42.4 15l20.2 36.9L301 83l4.1 2.3 36.9 20.2-1 42-.1 4.7 2.4 4L365.3 192l-21.9 35.9-2.4 4 .1 4.7 1 42-36.9 20.2L301 301l-2.3 4.1-20.2 36.9-42-1-4.7-.1-4 2.4L192 365.3l-35.9-21.9-4-2.4-4.7 .1-42 1L85.2 305.2 83 301l-4.1-2.3L41.9 278.6l1-42 .1-4.7-2.4-4L18.7 192l21.9-35.9 2.4-4-.1-4.7-1-42L78.8 85.2 83 83l2.3-4.1 20.2-36.9 42 1 4.7 .1 4-2.4L192 18.7l35.9 21.9 4 2.4 4.7-.1 42-1zM192 264a72 72 0 1 1 0-144 72 72 0 1 1 0 144zm-88-72a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM92.1 390.4L68.7 491.8 64 512l18.6-9.3L192 448l109.4 54.7L320 512l-4.7-20.2L291.9 390.4l-4.7-.1-11.8-.3 21.3 92.5-97.6-48.8-7.2-3.6-7.2 3.6L87.2 482.5 108.6 390l-11.8 .3-4.7 .1z'
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fast',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128h-8v8V296v80 8h16v-8V304h96c48.6 0 88-39.4 88-88s-39.4-88-88-88H168zM272 288H176V144h96c39.8 0 72 32.2 72 72s-32.2 72-72 72z'
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fast',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      'M266.5 495.8c-1.7-10.3-2.5-21-2.5-31.8c0-5.6 .2-11.2 .7-16.7l.7-8 15.9 1.3-.7 8c-.4 5.1-.6 10.2-.6 15.3c0 10.4 .9 20.6 2.5 30.6c111.4-12.2 199.8-100.7 212-212c-9.9-1.7-20.1-2.5-30.6-2.5c-5.2 0-10.3 .2-15.3 .6l-8 .7-1.3-15.9 8-.7c5.5-.5 11.1-.7 16.7-.7c10.8 0 21.4 .9 31.8 2.5c.2-3.5 .2-7 .2-10.5C496 123.5 388.5 16 256 16c-3.5 0-7 .1-10.5 .2c1.7 10.3 2.5 21 2.5 31.8c0 5.6-.2 11.2-.7 16.7l-.7 8-15.9-1.3 .7-8c.4-5.1 .6-10.2 .6-15.3c0-10.4-.9-20.6-2.5-30.6c-111.4 12.2-199.8 100.7-212 212c9.9 1.7 20.1 2.5 30.6 2.5c5.2 0 10.3-.2 15.3-.6l8-.7 1.3 15.9-8 .7c-5.5 .5-11 .7-16.7 .7c-10.8 0-21.4-.9-31.8-2.5c-.2 3.5-.2 7-.2 10.5c0 132.5 107.5 240 240 240c3.5 0 7-.1 10.5-.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm124.7-40.7c40-18.4 72.3-50.7 90.7-90.7l3.3-7.3 14.5 6.7-3.3 7.3c-20 43.5-55 78.6-98.5 98.5l-7.3 3.3-6.7-14.5 7.3-3.3zm262.7 81.4c-40 18.4-72.3 50.7-90.7 90.7l-3.3 7.3-14.5-6.7 3.3-7.3c20-43.5 55-78.6 98.5-98.5l7.3-3.3 6.7 14.5-7.3 3.3z'
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fast',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      'M34.3 354.3L28.7 360 40 371.3l5.7-5.7L61 350.3c43.5 40.4 99.5 59.6 155 57.6V496H64v16H384V496H232V406.7c47-5.2 92.7-25.9 128.7-61.9c82.5-82.5 84.3-215 5.6-299.7l15.4-15.4 5.7-5.7L376 12.7l-5.7 5.7L349.4 39.3l-5.7 5.7 5.7 5.7c78.1 78.1 78.1 204.7 0 282.8s-204.7 78.1-282.8 0l-5.7-5.7-5.7 5.7L34.3 354.3zM64 192a144 144 0 1 1 288 0A144 144 0 1 1 64 192zm304 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fast',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      'M288 16C166 16 65.2 107.1 50 225l-15.9-2C50.3 97.2 157.8 0 288 0C429.4 0 544 114.6 544 256c0 112.9-73.1 208.7-174.5 242.8c4-6.4 7.3-13.4 9.7-20.7C466.5 442.2 528 356.3 528 256C528 123.5 420.6 16 288 16zM196.8 478.1c2.4 7.3 5.7 14.3 9.7 20.7c-37.6-12.6-71.3-33.7-98.9-61.1l11.3-11.4c22.2 22 48.6 39.7 77.9 51.7zm.9-304.4l-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L203.3 168l-5.7 5.7zm180.7 0l-5.7-5.7L384 156.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.2-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zm5.3 98.3a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 281.6L28.1 326.5c-7.4 9.2-10.9 21-9.7 32.8c2.3 23.1 21.8 40.7 45 40.7h1.2c23.2 0 42.7-17.6 45-40.7c1.2-11.8-2.3-23.5-9.7-32.8L64 281.6zM53.8 268.8L64 256l10.2 12.8 38.2 47.7c10 12.5 14.7 28.4 13.1 44.4C122.4 392.2 96 416 64.6 416H63.4C32 416 5.6 392.2 2.5 360.9C.9 344.9 5.6 329 15.6 316.5l38.2-47.7zM184 392c0 5.1 3.2 11.2 11.7 17.6l-9.5 12.9C175.7 414.6 168 404.3 168 392c0-9.3 4.4-17.6 11.1-24.3c6.6-6.7 15.8-12.4 26.5-17c21.5-9.2 50.6-14.7 82.3-14.7s60.9 5.5 82.3 14.7c10.7 4.6 19.9 10.3 26.5 17c6.7 6.7 11.1 15 11.1 24.3c0 12.3-7.7 22.6-18.2 30.4l-9.5-12.9c8.5-6.3 11.7-12.4 11.7-17.6c0-3.9-1.8-8.3-6.5-13.1c-4.7-4.8-11.9-9.4-21.5-13.5C345 357.2 318.1 352 288 352s-57 5.2-76 13.4c-9.5 4.1-16.8 8.8-21.5 13.5c-4.7 4.7-6.5 9.1-6.5 13.1zm32-8h8 48 3.3l2.3 2.3L288 396.7l10.3-10.3 2.3-2.3H304h48 8v8 48c0 39.8-32.2 72-72 72s-72-32.2-72-72V392v-8zm64 27.3L268.7 400H232v40c0 30.9 25.1 56 56 56s56-25.1 56-56V400H307.3L296 411.3V432v8H280v-8V411.3z'
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fast',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM182.9 113.4l-4-6.9-6.9 4c-50.2 29-84 83.3-84 145.5v8h8 96.5c-.3-2.6-.5-5.3-.5-8s.2-5.4 .5-8H104.2c2.6-50.1 29.4-93.7 69-119.5L217.3 205c4.2-3.2 8.9-5.9 13.8-8l-48.3-83.6zM280.8 197c5 2.1 9.6 4.8 13.8 8l44.2-76.5c39.6 25.8 66.4 69.4 69 119.5H319.5c.3 2.6 .5 5.3 .5 8s-.2 5.4-.5 8H416h8v-8c0-62.2-33.8-116.5-84-145.5l-6.9-4-4 6.9L280.8 197zm13.8 110c-4.2 3.2-8.9 5.9-13.8 8L325 391.5C304.3 402 280.8 408 256 408s-48.3-6-69-16.5L231.2 315c-5-2.1-9.6-4.8-13.8-8l-48.3 83.6-4 6.9 6.9 4c24.7 14.3 53.4 22.5 84 22.5s59.3-8.2 84-22.5l6.9-4-4-6.9L294.7 307zM272 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fast',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      'M512 160V16.6 0L496 4.4 336 48v80 48.9L365.3 200 512 160zM336 360.4v30.4c-19.6-23.2-55.3-38.8-96-38.8c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V373l-16-12.6zM352 128V60.2L496 20.9V147.8L352 187.1V128zM309.9 388.5c17.3 12.3 26.1 28 26.1 43.5s-8.8 31.2-26.1 43.5C292.6 487.9 268 496 240 496s-52.6-8.1-69.9-20.5c-17.3-12.3-26.1-28-26.1-43.5s8.8-31.2 26.1-43.5C187.4 376.1 212 368 240 368s52.6 8.1 69.9 20.5zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fast',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      'M408 0H336h-8-8V8 128c-48.7 .2-97.4 17.5-134.6 51.9c-45.7 34.4-67.6 72.9-88.1 108.8c-19 33.2-36.7 64.3-70.8 88L0 393.8l1.8 59.1 43.7 19.2s99.8 39.9 243.3 39.9C454.7 512 512 375.9 512 305.2c0-45.4-18.7-90.7-56-125.3c-25.2-23.4-55.7-38.8-88-46.4V150c28.3 7.3 54.9 21.2 77.1 41.7c34.1 31.6 50.9 72.7 50.9 113.6c0 31.8-13.1 79.9-45.8 119.8c-32.1 39.3-83.4 71-161.4 71c-70.3 0-129.9-9.8-171.8-19.5c-21-4.9-37.5-9.7-48.7-13.4c-5.6-1.8-9.9-3.3-12.7-4.3c-1.4-.5-2.5-.9-3.2-1.2l-.7-.3-34.2-15-1.2-39.9 18.8-12.2 .2-.1 .2-.2c37.2-25.8 56.5-59.8 75.2-92.5l2.7-4.8c19.7-34.5 40.4-68.9 81.6-99.9l.6-.5 .6-.6C230.4 160 275.2 144.2 320 144v24 8h16v-8V144.6v-16-70C351.9 81.2 378.2 96 408 96h80 8V88c0-48.6-39.4-88-88-88zm0 80c-37.1 0-67.6-28-71.6-64H408c37.1 0 67.6 28 71.6 64H408zm16 240v-8H408v8c0 48.6-39.4 88-88 88h-8v16h8c57.4 0 104-46.6 104-104z'
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fast',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      'M512 432c70.7 0 128-57.3 128-128s-57.3-128-128-128H488v16h24c61.9 0 112 50.1 112 112s-50.1 112-112 112H320c-61.9 0-112-50.1-112-112s50.1-112 112-112h56V176H320c-70.7 0-128 57.3-128 128s57.3 128 128 128H512zM128 80C57.3 80 0 137.3 0 208s57.3 128 128 128h24V320H128C66.1 320 16 269.9 16 208S66.1 96 128 96H320c61.9 0 112 50.1 112 112s-50.1 112-112 112H264v16h56c70.7 0 128-57.3 128-128s-57.3-128-128-128H128z'
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fast',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      'M112 48V464H16V48h96zM16 32H0V48 464v16H16h96 16V464 48 32H112 16zM496 48V464H176V48H496zM176 32H160V48 464v16h16H496h16V464 48 32H496 176zm64 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-32v16h8 80 8V336h-8H360h-8zm0 48v16h8 80 8V384h-8H360h-8zM240 112H432V240H240V112zM224 96v16V240v16h16H432h16V240 112 96H432 240 224z'
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fast',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      'M16 464l416 0 0-416L16 48l0 416zM0 480l0-16L0 48 0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480zM138.3 250.3l120-120 5.7-5.7L275.3 136l-5.7 5.7L155.3 256 269.7 370.3l5.7 5.7L264 387.3l-5.7-5.7-120-120-5.7-5.7 5.7-5.7z'
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fast',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      'M16 192H496V464H16V192zm339.3-16L477.7 53.7l5.7-5.7H496V176H355.3zm-22.6 0H203.3L325.7 53.7l5.7-5.7H460.7L338.3 170.3l-5.7 5.7zm-152 0H51.3L173.7 53.7l5.7-5.7H308.7L186.3 170.3l-5.7 5.7zm-152 0H16V48H156.7L34.3 170.3 28.7 176zM512 184v-8V48 32H496 16 0V48 176v8 8V464v16H16 496h16V464 192v-8z'
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fast',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      'M11.3 267.3L0 256l11.3-11.3L244.7 11.3 256 0l11.3 11.3L500.7 244.7 512 256l-11.3 11.3L267.3 500.7 256 512l-11.3-11.3L11.3 267.3zM248 481.4V30.6L22.6 256 248 481.4zm16 0L489.4 256 264 30.6V481.4z'
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fast',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zm229.7-98.3l104-104 5.7-5.7L328 260.7l-5.7 5.7L232 356.7V136v-8H216v8V356.7l-90.3-90.3-5.7-5.7L108.7 272l5.7 5.7 104 104 5.7 5.7 5.7-5.7z'
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fast',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      'M640 72V440v8H624v-8V72 64h16v8zM512 256l-5.7 5.7-152 152-5.7 5.7L337.4 408l5.7-5.7L481.4 264 8 264H0l0-16H8l473.4 0L343 109.7l-5.7-5.7 11.3-11.3 5.7 5.7 152 152L512 256z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fast',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M264 495.9c128.8-4.2 232-110 232-239.9S392.8 20.4 264 16.1V495.9zm-16 0V16.1C119.2 20.4 16 126.1 16 256s103.2 235.6 232 239.9zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fast',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      'M281.1 0l-1 6.8-40 272-.1 .6v.6V472v8h8H392h8v-8V280v-.6l-.1-.6-40-272-1-6.8H352 288h-6.9zm13.8 16h50.2L384 280.6V464H256V280.6L294.9 16zM608 96V88H592v8 32H576h-8v16h8 16V320H512V280v-8h-8H440h-8v16h8 56v32 16V464H440h-8v8 32 8h16v-8V480h56 8v-8V453.3L592 420v28 8h16v-8V144h16 8V128h-8H608V96zM512 336h80v66.7L512 436V336zM344 256v56H296V256c0-13.3 10.7-24 24-24s24 10.7 24 24zm-64 0v56 16h16 48 16V312 256c0-22.1-17.9-40-40-40s-40 17.9-40 40zM32 96v32H16 8v16h8H32V448v8H48v-8V420l80 33.3V472v8h8 56v24 8h16v-8V472v-8h-8H144V336 320 288h56 8V272h-8H136h-8v8 40H48V144H64h8V128H64 48V96 88H32v8zm96 240V436L48 402.7V336h80z'
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fast',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      'M30.2 72L224 16.6 417.8 72 224 127.4 30.2 72zM224 144L448 80V64L224 0 0 64V80l32 9.1v77.7L3.5 261.7 .4 272H11.2 68.8 79.6l-3.1-10.3L48 166.8V93.7L224 144zm8 352V438.8l3.7-3.9 93.1-99h43.7l53.3 160H232zM22.2 496L75.5 336h43.7l93.1 99 3.7 3.9V496H22.2zM321.9 320L235 412.3 224 424l-11-11.7L126.1 320H64L5.3 496 0 512H16.9 431.1 448l-5.3-16L384 320H321.9zM96 176c0 70.7 57.3 128 128 128s128-57.3 128-128V140.7l-16 4.6V176c0 61.9-50.1 112-112 112s-112-50.1-112-112V145.3l-16-4.6V176zM22 256l18-60.2L58 256H22z'
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fast',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      'M144 352h16v16V496v16h16H496h16V496 176 160H496 368 352V144 16 0H336 16 0V16 336v16H16 144zM16 336V16H336V160v16h16H496V496H176V352 336H160 16z'
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fast',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      'M64 0h8 56 6.2l1.6 6 6.8 26H623.2 640l-5 16L560 288H209.3l20.9 80H560h8v16h-8H224h-6.2l-1.6-6L121.8 16H72 64V0zM205.1 272H548.2l70-224H146.7l58.4 224zM272 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM8 128H120h8v16h-8H8 0V128H8zm0 64H136h8v16h-8H8 0V192H8zm0 64H152h8v16h-8H8 0V256H8z'
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fast',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zm136 96H248v8V296v8h16v-8V136v-8zM240 336v32h32V336H240z'
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fast',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      'M224 128v59.1l144-39.3V20.9L224 60.2V128zm-16 0V48L368 4.4 384 0V16.6 160L224 203.6V432c0 44.2-50.1 80-112 80S0 476.2 0 432s50.1-80 112-80c40.7 0 76.4 15.5 96 38.8V208 191.4 128zM181.9 388.5C164.6 376.1 140 368 112 368s-52.6 8.1-69.9 20.5C24.8 400.8 16 416.4 16 432s8.8 31.2 26.1 43.5C59.4 487.9 84 496 112 496s52.6-8.1 69.9-20.5c17.3-12.3 26.1-28 26.1-43.5s-8.8-31.2-26.1-43.5z'
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fast',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 72v80h80V104 96h16v8 48h48 8v16h-8H360v80h80 8v16h-8H360v80h48 8v16h-8H360v48 8H344v-8V360H264v80 8H248v-8V360H168v48 8H152v-8V360H104 96V344h8 48V264H72 64V248h8 80V168H104 96V152h8 48V104 96h16v8 48l80 0V72 64h16v8zm-96 96v80h80V168l-80 0zm0 96v80h80V264H168zm96 0v80h80V264H264zm0-16h80V168H264v80z'
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fast',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      'M464 128v16h16c44.2 0 80 35.8 80 80v80H480 160 80V224c0-34.8 22.2-64.5 53.3-75.5l10.7-3.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C352.9 52.8 367.9 48 384 48c44.2 0 80 35.8 80 80zM64 320H80h80H480h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112v21.5C90.7 146.6 64 182.2 64 224v80 16zM0 400v16H8 568h8V400h-8H8 0zm64 96v16h8H216h8V496h-8H72 64zm224 0v16h8H632h8V496h-8H296h-8z'
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fast',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      'M135.6 197.7l11.5 5.7 8.1-9.9C193.4 146.6 253.7 96 336 96c73.7 0 129.7 40.5 168.2 82.8c19.1 21.1 33.5 42.2 43.2 58c4.8 7.9 8.4 14.5 10.7 19l.1 .2-.1 .2c-2.4 4.5-5.9 11.1-10.7 19c-9.6 15.9-24 37-43.2 58C465.7 375.5 409.7 416 336 416c-82.3 0-142.6-50.6-180.8-97.5l-8.1-9.9-11.5 5.7L35.2 364.5 19.5 348.8l42.8-85.7 3.6-7.2-3.6-7.2L19.5 163.2l15.7-15.7 100.5 50.2zM336 432c160 0 240-176 240-176s-80-176-240-176c-89.4 0-153.8 54.9-193.2 103.4L32 128 0 160l48 96L0 352l32 32 110.8-55.4C182.2 377.1 246.6 432 336 432zm80-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fast',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm9-398.9L256 96l-9 17.1-39.9 75.5-84.2 14.6-19.1 3.3 13.5 13.9 59.5 61.3-12.2 84.5L162 385.4l17.4-8.6L256 339.2l76.6 37.7 17.4 8.6-2.8-19.2-12.2-84.5 59.5-61.3 13.5-13.9-19.1-3.3-84.2-14.6L265 113.1zm37.1 91.3l73.4 12.7-51.9 53.4-5.5 5.6 1.1 7.8 10.6 73.7-66.8-32.9-7.1-3.5-7.1 3.5-66.8 32.9L192.7 284l1.1-7.8-5.5-5.6-51.9-53.4 73.4-12.7 7.8-1.3 3.7-7L256 130.3l34.8 65.9 3.7 7 7.8 1.3z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fast',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM184 368h8 56V145.8l-51.4 36.7-4.6 3.3V166.2l51.4-36.7 2.1-1.5H248h8 8v8V368h56 8v16h-8H256 192h-8V368z'
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fast',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM248.3 177.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm-3.4 18.9L256 206.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L256 329.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4z'
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fast',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      'M351.6 195.6L296.5 25.9 288.1 0l-8.4 25.9L224.5 195.6H46.1 18.9l22 16L185.2 316.4 130.1 486.1 121.7 512l22-16L288.1 391.1 432.4 496l22 16L446 486.1 390.9 316.4 535.2 211.6l22-16H530 351.6zm156.4 16L381.5 303.5l-9.4 6.8 3.6 11.1L424 470.1 297.5 378.2l-9.4-6.8-9.4 6.8L152.1 470.1l48.3-148.7 3.6-11.1-9.4-6.8L68.1 211.6H224.5h11.6l3.6-11.1L288.1 51.8l48.3 148.7 3.6 11.1h11.6H508z'
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM21.7 496L75.8 320H288c0-5.4 .3-10.7 .8-16H64L4.9 496 0 512H16.7 431.3 448l-4.9-16-5-16.3c-5.9-.4-11.7-1-17.4-2l5.6 18.3H21.7zM448 208.1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l89.7 89.5 5.7 5.7L639.3 500l-5.7-5.7L544 404.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fast',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      'M80 16H400V400H236.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4V288H64V400v16h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632h8V400h-8H608V216v-3.3l-2.3-2.3-112-112L491.3 96H488 416V16 0H400 80 64V16 96H8 0v16H8 216h8V96h-8H80V16zM416 216V112h68.7l104 104H416zm0 16H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4V232zM80 424a72 72 0 1 1 144 0A72 72 0 1 1 80 424zm408-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM40 160H32v16h8H280h8V160h-8H40zM8 224H0v16H8 216h8V224h-8H8z'
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fast',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      'M344.1 16l.3 0c34.8 0 72.6 21.6 101.3 50.3C474.4 95 496 132.9 496 167.7l0 .1 0 .2v0c0 51.2-32.8 96.7-81.4 112.9l-39.9 13.3-2.8 .9-2.3 1.9-58.5 47.9c-18.3 15-41.2 23.1-64.8 23.1C189.8 368 144 322.2 144 265.7c0-23.6 8.2-46.5 23.1-64.8L215 142.4l1.9-2.3 .9-2.8 13.3-39.9C247.3 48.8 292.8 16 344 16l.1 0zm.2-16L344 0C285.9 0 234.3 37.2 215.9 92.3l-13.3 39.9-47.9 58.5c-17.3 21.1-26.7 47.6-26.7 74.9c0 29.8 11 57 29.2 77.8l-151 151L.5 500.2l11.3 11.3 5.7-5.7 151-151c20.8 18.2 48 29.2 77.8 29.2c27.3 0 53.8-9.4 74.9-26.7l58.5-47.9 39.9-13.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0zm87.2 432a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fast',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16l0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32l16 0 416 0 16 0zM309.7 261.7l-120 120-5.7 5.7L172.7 376l5.7-5.7L292.7 256 178.3 141.7l-5.7-5.7L184 124.7l5.7 5.7 120 120 5.7 5.7-5.7 5.7z'
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fast',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      'M349.7 82.1l6 4.6 144 112 12.6 9.8 12.6 9.8L515.1 231l-19.6 25.3-9.8 12.6L473 259.1l-12.6-9.8-72.1-56.1L333 217.7l-16.3 7.2 13.7 11.4 42.1 35.1L387.6 284l-4.4 19.2-24 104-3.6 15.6L352 438.4l-15.6-3.6-31.2-7.2L289.6 424l3.6-15.6 3.6-15.6L316.4 308 272 271l-16-13.3 0 20.8V288v23.1l-21.9 7.3-96 32-15.2 5.1-15.2 5.1-5.1-15.2L92.6 314.9l-5.1-15.2 15.2-5.1 15.2-5.1L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l21.9-10.9 23.3-11.7-22.8-4.6-2.7-.5-12.6-2.5-7-14L194.5 44.6l-7.2-14.3 14.3-7.2L230.3 8.8l14.3-7.2L251.8 16l25.8 51.7 64.7 12.9 7.4 1.5zM489.8 211.4l-144-112-3-2.3-3.7-.7L274.5 83.4l-7.7-1.5-3.5-7L237.5 23.2 208.8 37.5l32.8 65.7 3.5 7 7.7 1.5 22.8 4.6 45.7 9.1-41.7 20.9-45.2 22.6C218.3 177 208 193.6 208 211.8l0 53.2v11.5l-10.9 3.6-74.1 24.7-15.2 5.1 10.1 30.4 15.2-5.1 96-32 10.9-3.6V288l0-30.3 0-34.2 26.2 21.9 60.4 50.3 7.6 6.3-2.2 9.6-19.6 84.8L308.8 412l31.2 7.2 3.6-15.6 24-104 2.2-9.6-7.6-6.3-55.8-46.5-19.8-16.5 23.5-10.4 71.5-31.8 8.8-3.9 7.6 5.9 72.1 56.1 12.6 9.8 19.6-25.3-12.6-9.8zM464 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM20 292.5l25.8 53.2L425.5 496H488h8v16h-8H424c-1 0-2-.2-2.9-.6l-384-152c-1.9-.7-3.4-2.1-4.3-3.9l-27.2-56-3.5-7.2 14.4-7 3.5 7.2z'
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fast',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      'M133.7 66.3L128 60.7l-5.7 5.7-88 88L28.7 160 40 171.3l5.7-5.7L120 91.3V408v8h8H344h8V400h-8H136V91.3l74.3 74.3 5.7 5.7L227.3 160l-5.7-5.7-88-88zM498.3 445.7l5.7 5.7 5.7-5.7 88-88 5.7-5.7L592 340.7l-5.7 5.7L512 420.7V104 96h-8H288h-8v16h8H496V420.7l-74.3-74.3-5.7-5.7L404.7 352l5.7 5.7 88 88z'
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fast',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      'M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160V304H272V272 256H256 192 176v16 32 16h16 32 32 16H392h8v-8V192c0-97.2-78.8-176-176-176S48 94.8 48 192v16 8H64v-8V192zM256 304H224 192V272h64v32zM59.9 368H388.1l38.4 128H21.5L59.9 368zM400 352H48L4.8 496 0 512H16.7 431.3 448l-4.8-16L400 352zm-96-81.6v21.5c29.3-23.5 48-59.5 48-99.9c0-70.7-57.3-128-128-128S96 121.3 96 192c0 40.4 18.7 76.5 48 99.9V270.4c-19.8-20.2-32-47.9-32-78.4c0-61.9 50.1-112 112-112s112 50.1 112 112c0 30.5-12.2 58.2-32 78.4z'
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fast',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M184 290.5L2.5 32H22.1L192 274.1 361.9 32h19.5L200 290.5V472v8H184v-8V290.5z'
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fast',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      'M217.4 90.1l38.8-9.6L244.6 99.8l-23.3 5.8-12.9 3.2-5.5-12L176 38.3 149.1 96.7l-5.5 12-12.9-3.2L68.4 90.2l28.9 57.4 6 11.8-10.5 8.1-51 39.2 62.9 13.2 13 2.7-.2 13.2-1.2 64.3 8.9-7.3L118 319.4l-2.1 1.7L99.6 334.6l.4-21.1 1.4-78L25 219.5 4.4 215.2l16.7-12.8L83 154.8 47.9 85.1 38.4 66.3l20.5 5.1 75.7 18.7 32.6-70.9L176 0l8.8 19.2 32.6 70.9zM320.2 35.9l5.8 1.6 247.3 66.3 5.8 1.6 .1 6 2.2 135.4 33.9 9.1 15.5 4.1-4.1 15.5L587.4 422.2l-4.1 15.5L570.8 484l-4.1 15.5-15.5-4.1-61.8-16.6-15.5-4.1 4.1-15.5 12.4-46.4L243.2 346.5l-12.4 46.4-4.1 15.5-15.5-4.1-61.8-16.6-15.5-4.1 4.1-15.5 12.4-46.4 4.1-15.5L194 159.4l4.1-15.5 15.5 4.1 33.9 9.1L317.1 41l3.1-5.2zm243.1 81.7L327.7 54.4l-64.2 107 301.9 80.9-2.1-124.8zM571.9 418l39.3-146.8L209.4 163.5 170.1 310.3l61.8 16.6 15.5 4.1 247.3 66.3 15.5 4.1L571.9 418zm-66-1.1l-12.4 46.4 61.8 16.6 12.4-46.4L506 416.9zM227.8 342.4L166 325.8l-12.4 46.4 61.8 16.6 12.4-46.4zm48-86.5a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zm-46.4-12.4A32 32 0 1 1 291.3 260a32 32 0 1 1 -61.8-16.6zm289.5 94.1a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zm12.4-46.4A32 32 0 1 1 514.8 353a32 32 0 1 1 16.6-61.8z'
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fast',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      'M17.5 176H216V48H74.4L17.5 176zm413 0L373.6 48H232V176H430.5zM16 192V464H432V192H16zM64 32H384l64 144V464v16H432 16 0V464 176L64 32zM232 232v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9l-4.1 15.5c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5l0 16.1v8H216v-8l0-16.6c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0 0 0c-1.9-.6-3.5-1.2-5-1.7l-7.6-2.5 5.1-15.2 7.6 2.5c1.7 .6 3.7 1.2 5.7 1.9l0 0c9.5 3.2 21.6 7.4 28.8 8.5c4.8 .7 9.3 1.1 13.6 1.1h.5c8.3 0 15.5-1.4 21.3-3.8c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V232v-8h16v8z'
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fast',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      'M288 0V16h8 64c39.8 0 72 32.2 72 72s-32.2 72-72 72H8 0v16H8 360c48.6 0 88-39.4 88-88s-39.4-88-88-88H296h-8zm64 416h8 68c46.4 0 84-37.6 84-84s-37.6-84-84-84H8 0v16H8 428c37.6 0 68 30.4 68 68s-30.4 68-68 68H360h-8v16zM104 512h64c48.6 0 88-39.4 88-88s-39.4-88-88-88H8 0v16H8 168c39.8 0 72 32.2 72 72s-32.2 72-72 72H104 96v16h8z'
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fast',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      'M16 256C16 123.5 123.5 16 256 16c99.6 0 185 60.7 221.4 147.1l14.8-6.2C453.4 64.7 362.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c93 0 174.5-49.7 219.3-123.9l-13.7-8.3C419.6 449.5 343.2 496 256 496C123.5 496 16 388.5 16 256zM264 136v-8H248v8V296v8h16v-8V136zm8 232V336H240v32h32zM619.3 192L608 180.7l-5.7 5.7L480 308.7l-58.3-58.3-5.7-5.7L404.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128 5.7-5.7z'
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fast',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      'M272 16H256c-53 0-96 43-96 96v16h16c53 0 96-43 96-96V16zM160 144c-1.4 0-2.7-.2-4-.5c-28.2 30.6-44 70.7-44 112.5c0 114.9 93.1 208 208 208h88 1.9l1.7 .8 64 32-7.2 14.3L406.1 480H320.2l-.2 0H233.9l-62.3 31.2-7.2-14.3 64-32 1.7-.8H232h4.7c-21.5-8.6-41.3-20.5-58.9-34.9c-58.3 23.7-126.6 1.4-158.9-54.6l-8-13.9-8-13.9 13.9-8c17.8-10.3 37.3-15.1 56.4-15C29.9 303.2 0 259.1 0 208V192 176H16c20.6 0 39.8 5.5 56.4 15.2C45.2 151.8 41.3 98.7 66.9 54.4l8-13.9 8-13.9 13.9 8c23.5 13.6 40.2 34.3 48.9 57.9C154.9 40 200.8 0 256 0h16 16V16 32c0 61.9-50.1 112-112 112H160zm-23.8-2c3.9-36.6-13.5-73.8-47.5-93.4l-8 13.9C53.5 109.6 64.5 168.3 104 202.7c6.7-22 17.7-42.7 32.2-60.8zM116.8 350.4c-28.1-14.5-62.7-14.8-92.1 2.2l8 13.9C59.6 413.1 115 433 164.3 417c-19.6-19-35.8-41.5-47.4-66.6zM96 256c0-6.5 .4-13 1-19.5C80 209.8 50.1 192 16 192v16c0 53.8 38 98.8 88.6 109.5C99 298 96 277.3 96 256zM480 128V112c0-53-43-96-96-96H368V32c0 53 43 96 96 96h16zm23.8 14c14.6 18.1 25.5 38.8 32.2 60.8c39.5-34.5 50.5-93.2 23.2-140.3l-8-13.9c-33.9 19.6-51.4 56.8-47.5 93.4zm63.8 49.2c16.6-9.7 35.8-15.2 56.4-15.2h16v16 16c0 51.1-29.9 95.2-73.2 115.7c19.2-.1 38.6 4.7 56.4 15l13.9 8-8 13.9-8 13.9c-32.3 56-100.6 78.3-158.9 54.6c-6.5 5.4-13.4 10.4-20.5 15l-16.8-8.4C486.5 399.6 528 332.6 528 256c0-41.8-15.8-81.9-44-112.5c-1.3 .3-2.6 .5-4 .5H464c-61.9 0-112-50.1-112-112V16 0h16 16c55.2 0 101.1 40 110.3 92.6c8.8-23.6 25.5-44.3 49-57.9l13.9-8 8 13.9 8 13.9c25.5 44.2 21.7 97.4-5.5 136.8zM523.2 350.4c-11.7 25.1-27.8 47.6-47.4 66.6c49.2 16 104.6-3.9 131.5-50.6l8-13.9c-29.4-17-64-16.6-92.1-2.2zM543 236.5c.7 6.4 1 12.9 1 19.5c0 21.3-3 42-8.6 61.5C586 306.8 624 261.8 624 208V192c-34.1 0-64 17.8-81 44.5z'
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fast',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      'M528 48h32V464H528V48zM512 32V48 464v16h16 32 16V464 48 32H560 528 512zM480 65.8L16 181.8V168v-8H0v8 17.8V192 320v6.2V344v8H16v-8V330.2l145.6 36.4c-1 5.6-1.6 11.4-1.6 17.4c0 53 43 96 96 96c42.9 0 79.1-28.1 91.5-66.8l-1.7-.5L480 446.2V429.8L16 313.8V198.2l464-116V65.8zM176 384c0-4.6 .4-9.1 1.1-13.5l154.8 38.7C321.4 441 291.4 464 256 464c-44.2 0-80-35.8-80-80zm80-96l-.4 0h.7l-.4 0z'
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fast',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM21.7 496L75.8 320H321.1c-.5-5.4-.8-10.7-1-16H64L4.9 496 0 512H16.7 426.1c-7-5-13.7-10.3-19.9-16H21.7zM624 290.7V296c0 76.9-40.9 162.4-120 195.9V244.3l120 46.5zm-256 0l120-46.5V491.9c-79.1-33.5-120-119-120-195.9v-5.3zM496 512c96-32 144-130.2 144-216V279.8L496 224 352 279.8V296c0 85.8 48 184 144 216z'
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fast',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      'M136 82.8c13 26.7 40.3 45.2 72 45.2c43.4 0 78.8-34.6 80-77.7c-10.4-1.5-21.1-2.3-32-2.3c-44.2 0-85.3 12.8-120 34.8zM122.7 92C67.6 132.8 32 198.2 32 272v32H480V272c0-25.9-4.4-50.8-12.5-74c-11.7 15.8-30.4 26-51.5 26c-35.3 0-64-28.7-64-64c0-29 19.3-53.6 45.8-61.4c-26.8-22-58.9-37.8-94-45.5C301.2 103.8 259.3 144 208 144c-37.2 0-69.4-21.1-85.3-52zm290.2 20.1c-25 1.6-44.9 22.4-44.9 47.9c0 26.5 21.5 48 48 48c19.7 0 36.5-11.8 44-28.7c-11.5-25.3-27.5-48-47.1-67.2zM496 272v32 16H480 32 16V304 272C16 139.5 123.5 32 256 32s240 107.5 240 240zM168.5 442.1L185.4 352h16.3l-17.4 93.1L180.7 464H200 312h19.3l-3.6-18.9L310.3 352h16.3l16.9 90.1 4.1 21.9 3 16H334.3 312 200 177.7 161.4l3-16 4.1-21.9zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fast',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      'M183.6 433.9c39.7-26.7 85.4-63.4 136.1-114.2s87.5-96.4 114.2-136.1C443 205.9 448 230.4 448 256c0 106-86 192-192 192c-25.6 0-50.1-5-72.4-14.1zm-32.5 1.8c-24.8 15.1-46.7 25.8-65.4 33.4c-25.8 10.5-45.5 15.2-58.5 17.3c-.6 .1-1.3 .2-1.9 .3c.1-.6 .2-1.2 .3-1.9c2-13 6.7-32.7 17.3-58.5c4.2-10.3 9.4-21.6 15.6-33.8c-3.5-5.1-6.8-10.3-9.9-15.5C5 457.9 8.1 503.9 8.1 503.9s58.4 4 159.4-59.6C194.4 456.9 224.4 464 256 464c114.9 0 208-93.1 208-208c0-31.6-7.1-61.6-19.7-88.5C507.9 66.5 503.9 8.1 503.9 8.1s-46-3.1-126.9 40.5c5.3 3.1 10.5 6.4 15.5 9.9c12.2-6.3 23.5-11.4 33.8-15.6c25.8-10.5 45.5-15.2 58.5-17.3c.6-.1 1.3-.2 1.9-.3c-.1 .6-.2 1.2-.3 1.9c-2 13-6.7 32.7-17.3 58.5c-7.6 18.7-18.4 40.6-33.4 65.4C399.6 89.4 332.6 48 256 48C141.1 48 48 141.1 48 256c0 76.6 41.4 143.6 103.1 179.7zm15.5-9.7C105.6 393.8 64 329.7 64 256C64 150 150 64 256 64c73.7 0 137.8 41.6 169.9 102.6c-26.4 40.6-64 88.2-117.6 141.8S207.2 399.6 166.6 425.9z'
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fast',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216l-104 0v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zM284 96h47.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96zm-5-65.6C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1L279 30.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM21.7 496H426.3L372.2 320H312v48.7c22.7 3.8 40 23.6 40 47.3v40 8h-8H328h-8V448h8 8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8 8v16h-8H264h-8v-8V416c0-23.8 17.3-43.5 40-47.3V320H152v48.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V320H75.8L21.7 496zM112 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 304H384l59.1 192 4.9 16H431.3 16.7 0l4.9-16L64 304z'
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fast',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM216 274.9L93.3 128h20.8L224 259.5 333.9 128h20.8L232 274.9V376v8H216v-8V274.9z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fast',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M408.5 441.4C461.9 397.3 496 330.7 496 256C496 123.5 388.5 16 256 16S16 123.5 16 256c0 74.7 34.1 141.3 87.5 185.4L144 320H368l40.5 121.4zM395 451.7L356.5 336H155.5L117 451.7c39.2 27.9 87.2 44.3 139 44.3s99.8-16.4 139-44.3zm5.3 15.8C359.2 495.6 309.5 512 256 512s-103.2-16.4-144.3-44.5c-4.3-2.9-8.5-6-12.5-9.1c-.3-.3-.7-.5-1-.8C38.4 410.7 0 337.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 81.8-38.4 154.7-98.1 201.6c-4.4 3.4-8.9 6.7-13.4 9.9c0 0-.1 0-.1 .1zM176 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fast',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      'M112 16h96V80H112V16zM96 80H64V96H96h16 96 16 32V80H224V16 0H208 112 96V16 80zm272 64V496H16V256c0-61.9 50.1-112 112-112H368zM128 128C57.3 128 0 185.3 0 256V496v16H16 368h16V496 144 128H368 128zm120 80h-8v8V360v8h8 64 8v-8V216v-8h-8H248zm8 144V224h48V352H256z'
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fast',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      'M496 48V208H16V48H496zM16 32H0V48 208v16H16 120V384v8h8 96v72 16h16H496h16V464 304 288H496 240 224v16 72H136V224H496h16V208 48 32H496 16zM496 304V464H240V304H496z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fast',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M157.7 53.7l5.7-5.7L152 36.7l-5.7 5.7L63.5 125.2 21.1 89.9 15 84.7 4.7 97l6.1 5.1 48 40 5.6 4.7 5.2-5.2 88-88zm0 160l5.7-5.7L152 196.7l-5.7 5.7L63.5 285.2 21.1 249.9 15 244.7 4.7 257l6.1 5.1 48 40 5.6 4.7 5.2-5.2 88-88zM200 88v16h8H496h8V88h-8H208h-8zm0 160v16h8H496h8V248h-8H208h-8zM168 408v16h8H496h8V408h-8H176h-8zm-88 8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fast',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      'M0 32H8 440h8V48h-8H16v80H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H288h-8H232 207l20.3-14.5L275 431.4l-48.2-41.4-20.5-17.6 26.8 3.6 110.6 14.7c5.4 .7 10.8 .5 16.2-.5c14.1-2.8 24.2-15.2 24.2-29.6V356c0-19.9-16.1-36-36-36H240c-97.2 0-176-78.8-176-176H8 0v-8V40 32zM240 304H348c28.7 0 52 23.3 52 52v4.8c0 22-15.5 40.9-37.1 45.2c-7 1.4-14.3 1.6-21.4 .7l-83.8-11.2 35.5 30.4 7.8 6.6-8.3 5.9L257 464h23 8 48c2.7 0 5.4-.1 8-.2V432v-8h16v8 30.2c46.8-7 87-34.3 111.3-72.7l-41.8-13.9-7.6-2.5 5.1-15.2 7.6 2.5 44.7 14.9C490 353.8 496 329.6 496 304c0-24.7-5.6-48.2-15.6-69.1l-42.7 42.7-5.7 5.7L420.7 272l5.7-5.7 46-46C444.2 174.5 393.7 144 336 144V248v8H320v-8V144H80c0 88.4 71.6 160 160 160zM192 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fast',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 176V144h32v32H240zm-16-48v16 32 16h16 32 16V176 144 128H272 240 224zM152 248h-8v16h8H360h8V248h-8H152zM272 368H240V336h32v32zm-32-48H224v16 32 16h16 32 16V368 336 320H272 240z'
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fast',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      'M0 480L0 32l16 0 0 448L0 480zm112-16l0-32 32 0 0 32-32 0zm0-416l32 0 0 32-32 0 0-32zm0 224l0-32 32 0 0 32-32 0zM304 432l32 0 0 32-32 0 0-32zm0-352l0-32 32 0 0 32-32 0zm0 160l32 0 0 32-32 0 0-32zM208 464l0-32 32 0 0 32-32 0zm0-416l32 0 0 32-32 0 0-32zm0 224l0-32 32 0 0 32-32 0zM400 432l32 0 0 32-32 0 0-32zm0-352l0-32 32 0 0 32-32 0zm0 160l32 0 0 32-32 0 0-32zM208 368l0-32 32 0 0 32-32 0zm192-32l32 0 0 32-32 0 0-32zm0-160l0-32 32 0 0 32-32 0zM208 144l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fast',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      'M624 16V432H16V16H624zM16 0H0V16 432v16H16 624h16V432 16 0H624 16zM96 496v16h8H536h8V496h-8H104 96zM80 80H560V368H80V80zM64 64V80 368v16H80 560h16V368 80 64H560 80 64z'
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fast',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      'M16 48V80H48V48H16zm128 0H112V80h32V48zm96 0H208V80h32V48zm96 0H304V80h32V48zm64 0V80h32V48H400zM160 288H144 80 64v16 16L212.7 468.7 224 480l11.3-11.3L384 320V304 288H368 304 288V272 144 128H272 176 160v16V272v16zm0 16h16V288 144h96V288v16h16 80v9.4l-144 144L80 313.4V304h80z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fast',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      'M197.8 42.5l-5.8-6-5.8 6-176 184-5.5 5.8 11.6 11.1 5.5-5.8L184 67.9V472v8h16v-8V67.9L362.2 237.5l5.5 5.8 11.6-11.1-5.5-5.8-176-184z'
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fast',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      'M328 0H312V8 120v8h16v-8V8 0zM168 60.7L156.7 72l5.7 5.7 80 80 5.7 5.7L259.3 152l-5.7-5.7-80-80L168 60.7zM483.3 72L472 60.7l-5.7 5.7-80 80-5.7 5.7L392 163.3l5.7-5.7 80-80 5.7-5.7zm-217 156.2l-91.6 24.6-15.5 4.1c-11.4-42.7-55.3-68-98-56.6s-68 55.3-56.6 98c8.5 31.7 34.9 53.8 65.3 58.4l3.4 12.9c-24.1 19.2-35.9 51.6-27.4 83.3c11.4 42.7 55.3 68 98 56.6s68-55.3 56.6-98l15.5-4.1 91.6-24.6-4.1-15.5L196.5 396l-15.5 4.1 4.1 15.5c9.1 34.1-11.1 69.2-45.3 78.4s-69.2-11.1-78.4-45.3c-6.8-25.3 2.6-51.2 21.9-66.6l8.2-6.5L89 365.5l-3.4-12.9-2.7-10.1L72.4 341c-24.4-3.7-45.5-21.4-52.3-46.7C11 260.1 31.3 225 65.4 215.8s69.2 11.1 78.4 45.3l4.1 15.5 15.5-4.1 107.1-28.7-4.1-15.5zm200.9 24.6l-91.6-24.6-4.1 15.5 107.1 28.7 15.5 4.1 4.1-15.5c9.1-34.1 44.2-54.4 78.4-45.3s54.4 44.2 45.3 78.4c-6.8 25.3-27.9 43-52.3 46.7l-10.4 1.6-2.7 10.1L553 365.5l-2.7 10.1 8.2 6.5c19.3 15.4 28.7 41.3 21.9 66.6c-9.1 34.1-44.2 54.4-78.4 45.3s-54.4-44.2-45.3-78.4l4.1-15.5L445.4 396 338.3 367.3l-4.1 15.5 91.6 24.6 15.5 4.1c-11.4 42.7 13.9 86.5 56.6 98s86.5-13.9 98-56.6c8.5-31.7-3.3-64-27.4-83.3l3.4-12.9c30.5-4.6 56.9-26.7 65.3-58.4c11.4-42.7-13.9-86.5-56.6-98s-86.5 13.9-98 56.6l-15.5-4.1z'
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fast',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      'M264 0V8v8.2c97 4 175.4 79.9 183.3 175.8H464h8v16h-8H448 432 80 64 48 40V192h8H64.7C72.6 96.1 151 20.1 248 16.2V8 0h16zM80.7 192H431.3C423.2 102.3 347.8 32 256 32S88.8 102.3 80.7 192zM80 248V368H184V248v-8h16v8V368H312V248v-8h16v8V368H432V248v-8h16v8V376v8h-8H328 312 200 184 72 64v-8V248v-8H80v8zM40 432H472h8v16h-8H40 32V432h8zM8 496H504h8v16h-8H8 0V496H8z'
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fast',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      'M408 8V0H392V8 64h-8.9c-52.5 0-95.1 42.6-95.1 95.1c0 41.3 26.6 77.8 65.9 90.5l87.3 28.1c32.7 10.5 54.8 40.9 54.8 75.3c0 43.7-35.4 79.1-79.1 79.1l-8.9 0-12.6 0-.1 0c-21.7 0-43-5.9-61.6-17l-25.6-15.3-8.2 13.7 25.6 15.3c20.1 12.1 43 18.7 66.5 19.3v56 8h16v-8V448h8.9c52.5 0 95.1-42.6 95.1-95.1c0-41.3-26.6-77.8-65.9-90.5l-87.3-28.1c-32.7-10.5-54.8-40.9-54.8-75.3c0-43.7 35.4-79.1 79.1-79.1H392h11c18 0 35.9 3.6 52.6 10.6l13.3 5.6 6.2-14.8-13.3-5.6c-17.1-7.2-35.3-11.1-53.8-11.7V8zM0 32v8V296 480H16V304H120c.7 0 1.5 0 2.2 0l58.7 176h16.9L138.7 302.7C205 293.6 256 236.8 256 168c0-75.1-60.9-136-136-136H8 0zM16 288V48H120c66.3 0 120 53.7 120 120s-53.7 120-120 120H16z'
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fast',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      'M267.2 11.5l12.1 12.4 17.3-.2 16-.2-.2 16-.2 17.3 12.4 12.1L336 80 324.6 91.2l-12.4 12.1 .2 17.3 .2 16-16-.2-17.3-.2-12.1 12.4L256 160l-11.2-11.5-12.1-12.4-17.3 .2-16 .2 .2-16 .2-17.3L187.5 91.2 176 80l11.5-11.2 12.4-12.1-.2-17.3-.2-16 16 .2 17.3 .2 12.1-12.4L256 0l11.2 11.5zm12.3 28.4l-6.9 .1L267.8 35 256 22.9 244.2 35l-4.8 4.9-6.9-.1-16.9-.2 .2 16.9 .1 6.9L211 68.2 198.9 80 211 91.8l4.9 4.8-.1 6.9-.2 16.9 16.9-.2 6.9-.1 4.8 4.9L256 137.1 267.8 125l4.8-4.9 6.9 .1 16.9 .2-.2-16.9-.1-6.9 4.9-4.8L313.1 80 301 68.2l-4.9-4.8 .1-6.9 .2-16.9-16.9 .2zM16 496H496V416H16v80zM0 400H16 496h16v16 80 16H496 16 0V496 416 400zm33.6-32c5.9-47 31.5-184.3 133.9-236l0 4.2-.2 14.1C125.9 174 98.7 213.5 80.6 254.5c-8.2 18.5-14.4 37.1-19 54.3l63.1-28.1 3.4-1.5 3.4 1.7L192 311.1l60.4-30.2 3.6-1.8 3.6 1.8L320 311.1l60.4-30.2 3.4-1.7 3.4 1.5 63.1 28.1c-4.7-17.2-10.8-35.8-19-54.3c-18.1-41-45.3-80.5-86.6-104.1l-.2-14.1-.1-4.2c102.4 51.7 128 189.1 133.9 236H462.3c-.8-6.4-2-14.4-3.7-23.6c-.9-5-2-10.4-3.3-16l-2.5-1.1-68.6-30.5-60.6 30.3-3.6 1.8-3.6-1.8L256 296.9l-60.4 30.2-3.6 1.8-3.6-1.8-60.6-30.3L59.2 327.3l-2.5 1.1c-1.3 5.6-2.3 11-3.3 16c-1.7 9.1-2.9 17.1-3.7 23.6H33.6z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fast',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM145.8 134.7V281.3v18.5l16-9.3 126.2-73.3 15.9-9.3-15.9-9.3L161.8 125.5l-16-9.3v18.5zm16 137.3V144L272 208 161.8 272z'
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fast',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8zM95.9 128h5H219.1h4.3l2.4 3.6 100.9 152 4.4 6.7-13.3 8.9-4.4-6.7L214.8 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM463.4 492.7l-42.7-42.7L408.8 438l-7.5 15.1-14 27.9-7.2 14.3-7.2 14.3-14.3-7.2L330 488.2 315.7 481l7.2-14.3 7.2-14.3 41.4-82.7 51.2-8.3L448 386.7l16 16 0-22.6 0-44.1 0-13.3 9.4-9.4 16-16 9.4-9.4H512h32 16 16v16 16V446.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3zm-90.5-18.8l21.5-43 9.9-19.9 15.7 15.7 54.7 54.7c9.4 9.4 22.1 14.6 35.3 14.6c27.6 0 49.9-22.4 49.9-49.9V320 304H544 512h-6.6l-4.7 4.7-16 16-4.7 4.7 0 6.6 0 66.7 0 38.6-27.3-27.3-35.6-35.6L382 384.2l-37.7 75.4-7.2 14.3 28.6 14.3 7.2-14.3zM464 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM296 40h8 56 8V56h-8H304h-8V40zm-12.4 64.8l48 24 7.2 3.6-7.2 14.3-7.2-3.6-48-24-7.2-3.6 7.2-14.3 7.2 3.6z'
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fast',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      'M432 48H16V464H263.1l-2.5 16H16 0V464 48 32H16 432h16V48 229.5l-16 16V48zm-64 72V309.5l-16 16V128H232v88.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V120v-8h8H360h8v8zM277.5 400H88 80v-8V120v-8h8 64 8v16h-8H96V384H293.5l-16 16zM448 480h-5.8l5.8-5.8V480zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm274.9-8.1l11.3 11.3 54.5 54.5L576 300.9l-11.3 11.3L379.3 497.6l-74.7 11.6L288 511.9l2.6-16.6 11.6-74.7L498.9 223.9zM317.2 428.2l-10 64.5 64.5-10L509.5 344.8 455 290.4 317.2 428.2zM553.4 300.9l-54.5-54.5L466.4 279l54.5 54.5 32.5-32.5z'
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fast',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      'M232 0V8 56h56 8V72h-8H232v88H440h8v8 56 1.6l-.6 1.5L381 384H363.6L432 222.4V176H232 216 16v46.4L84.4 384H67L.6 227.1 0 225.6V224 168v-8H8 216V72H160h-8V56h8 56V8 0h16zM48 496H400V475.5L360.9 432H87.1L48 475.5V496zm-16 0V469.3L80 416H368l48 53.3V496v16H400 48 32V496z'
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fast',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      'M327.1 14l28.4 55.7 61.7 9.8L432.7 82 421.7 93.1l-44.2 44.3 9.7 61.8 2.4 15.5-14-7.1L320 179.2l-55.7 28.4-14 7.1 2.4-15.5 9.7-61.8L218.3 93.1 207.3 82l15.5-2.5 61.7-9.8L312.9 14 320 0l7.1 14zM296.9 80.6L295 84.2l-4 .6-50.3 8 36 36.1 2.9 2.9-.6 4L271 186.2l45.4-23.1 3.6-1.8 3.6 1.8L369 186.2l-7.9-50.4-.6-4 2.9-2.9 36-36.1-50.3-8-4-.6-1.8-3.6L320 35.2 296.9 80.6zM240 496H400V272H240V496zM224 256h16H400h16v16V496v16H400 240 224V496 272 256zM16 336V496H176V336H16zM0 320H16 176h16v16V496v16H176 16 0V496 336 320zm624 80H464v96H624V400zM464 384H624h16v16 96 16H624 464 448V496 400 384h16z'
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fast',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      'M224 16V32 48 432H96V48 32 16H224zM80 16V32H16 0V48 496v16H16 560h16V496 48 32H560 240V16 0H224 96 80V16zM16 48H80V432v16H96 224h16V432 48H560V496H16V48zm304 64H480v80H320V112zM304 96v16 80 16h16H480h16V192 112 96H480 320 304zm0 160v8 64 8h8 64 8v-8V264v-8h-8H312h-8zm16 16h48v48H320V272zm104-16h-8v8 64 8h8 64 8v-8V264v-8h-8H424zm8 64V272h48v48H432zm-16 48v8 64 8h8 64 8v-8V376v-8h-8H424h-8zm16 16h48v48H432V384zM312 368h-8v8 64 8h8 64 8v-8V376v-8h-8H312zm8 64V384h48v48H320z'
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fast',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      'M560 48v65.8l-4.7 3.5L336 278.1 116.7 117.3l-4.7-3.5V48H560zm0 85.7V368H112V133.7L331.3 294.5l4.7 3.5 4.7-3.5L560 133.7zM112 32H96V48 368v16h16H560h16V368 48 32H560 112zM64 128H16 0v16V464v16H16 464h16V464 416H464v48H16V144H64V128z'
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fast',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      'M120 336V320l0-304h80l0 304v16h16 88v9.4l-144 144L16 345.4V336h88 16zM0 352L148.7 500.7 160 512l11.3-11.3L320 352V336 320H304 232 216V304l0-288V0H200 120 104V16l0 288v16H88 16 0l0 16 0 16z'
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fast',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      'M384 190.1V172.4 160 144 128H368 352 128C57.3 128 0 185.3 0 256V480v16 16H16 32 352h16 16V496 480 207.8 190.1zM416 496v16H608l32-32V416l-12.7-12.7L616 392l11.3-11.3L640 368V304l-12.7-12.7L616 280l11.3-11.3L640 256V190.1L575.7 160H448.3L416 175.1v17.7L451.8 176H572.2L624 200.3v49.1l-19.3 19.3L593.4 280l11.3 11.3L624 310.6v50.7l-19.3 19.3L593.4 392l11.3 11.3L624 422.6v50.7L601.4 496H416zM64 96H80 96h16 96 16 16 16V80H240 224V64 16 0H208 112 96V16 64 80H80 64V96zM368 215.3V480v16H352 32 16V480 256c0-61.9 50.1-112 112-112H352h16v16 30.1 25.2zM192 16h16V32 64 80H192 128 112V64 32 16h16 64zm56 192h-8v8 8V352v8 8h8 8 48 8 8v-8-8V224v-8-8h-8-8H256h-8zm8 32V224h16 16 16v16 96 16H288 272 256V336 240zM448 64v8 56h16V80h96v48h16V72 64h-8H456h-8z'
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fast',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      'M432 416V16H214.6L96 134.6V416H432zM98.7 109.3L208 0H432h16V16 416v16H432 96 80V416 128l18.7-18.7 0 0zM248 72v8 64 8H232v-8V80 72h16zm64 0v8 64 8H296v-8V80 72h16zm64 0v8 64 8H360v-8V80 72h16zM0 208l48-48v22.6l-32 32V496H352V464h16v32 16H352 16 0V496 208z'
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fast',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      'M24 128C24 85.6 34 45.4 51.8 9.9L37.5 2.8C18.6 40.4 8 83 8 128s10.6 87.6 29.5 125.2l14.3-7.2C34 210.6 24 170.4 24 128zm80 0c0 29.6 7 57.5 19.4 82.3l14.3-7.2C126.4 180.5 120 155 120 128s6.4-52.5 17.7-75.1l-14.3-7.2C111 70.5 104 98.4 104 128zM452.6 45.7l-14.3 7.2C449.6 75.5 456 101 456 128s-6.4 52.5-17.7 75.1l14.3 7.2C465 185.5 472 157.6 472 128s-7-57.5-19.4-82.3zM552 128c0 42.4-10 82.6-27.8 118.1l14.3 7.2C557.4 215.6 568 173 568 128s-10.6-87.6-29.5-125.2L524.2 9.9C542 45.4 552 85.6 552 128zM288 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm41.2 97c14-11.7 22.8-29.3 22.8-49c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 19.7 8.9 37.3 22.8 49L155.3 384H152v7.6L98.8 512h17.5l49.5-112H410.2l49.5 112h17.5l-148-335zm74 207H172.8l35.4-80H367.8l35.4 80zm-42.4-96H215.3l45.2-102.2c8.3 4 17.7 6.2 27.6 6.2s19.2-2.2 27.6-6.2L360.7 288z'
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fast',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      'M16 112H160L320 0 480 112H624h16v16V288H624V256 128H480h-5l-4.1-2.9L320 19.5 169.2 125.1 165 128h-5H16V496H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64V496v16H368 272 256 16 0V496 128 112H16zM368 496V384c0-26.5-21.5-48-48-48s-48 21.5-48 48V496h96zM64 192h8 64 8v8 80 8h-8H72 64v-8V200v-8zm16 16v64h48V208H80zm240 32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm8 48v24h16 8v16h-8H320h-8v-8V144v-8h16v8zM64 320h8 64 8v8 80 8h-8H72 64v-8V328v-8zm16 16v64h48V336H80zM528 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H624 432 416V496 336 320h16 32V256zm-32 80V496H624V336H592 576 480 464 432z'
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fast',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM176 240l0 32-32 0 0-32 32 0zm192 0l0 32-32 0 0-32 32 0zm-128 0l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fast',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      'M208 496c159.1 0 288-128.9 288-288c0-69.7-24.7-133.6-66-183.4L391 63.7c35.5 40.8 57 94 57 152.3c0 128.1-103.9 232-232 232c-58.3 0-111.6-21.5-152.3-57L24.6 430c49.8 41.2 113.7 66 183.4 66zM75 379.6c37.8 32.6 87.1 52.4 141 52.4c119.3 0 216-96.7 216-216c0-53.9-19.7-103.2-52.4-141L75 379.6zM13.2 441.4c-4.1-3.4-8.1-7-12-10.6l11.3-11.3 407-407L430.8 1.2c3.6 3.9 7.2 7.9 10.6 12C485.5 66 512 133.9 512 208c0 167.9-136.1 304-304 304c-74.1 0-142-26.5-194.8-70.6zM336 164.7l5.7 5.7 24 24 5.7 5.7L360 211.3l-5.7-5.7-24-24-5.7-5.7L336 164.7zm-80 80l5.7 5.7 24 24 5.7 5.7L280 291.3l-5.7-5.7-24-24-5.7-5.7L256 244.7zm88 8l5.7 5.7 24 24 5.7 5.7L368 299.3l-5.7-5.7-24-24-5.7-5.7L344 252.7zm-168 72l5.7 5.7 24 24 5.7 5.7L200 371.3l-5.7-5.7-24-24-5.7-5.7L176 324.7zm88 8l5.7 5.7 24 24 5.7 5.7L288 379.3l-5.7-5.7-24-24-5.7-5.7L264 332.7z'
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fast',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      'M144 80c0-35.3 28.7-64 64-64H328c57.4 0 104 46.6 104 104s-46.6 104-104 104H256h-8v8 40 8h16v-8V240h64c66.3 0 120-53.7 120-120S394.3 0 328 0H208c-44.2 0-80 35.8-80 80s35.8 80 80 80h88 8V144h-8H208c-35.3 0-64-28.7-64-64zm7.6 240h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fast',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 160a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 88h-8v16h8H496h8V88h-8H176zm0 160h-8v16h8H496h8V248h-8H176zm0 160h-8v16h8H496h8V408h-8H176z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fast',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      'M480 16v96H384V16h96zM384 0H368V16v96 16h16 40V320c0 48.6-39.4 88-88 88H244.7l72.7-66.1-10.8-11.8-88 80-6.5 5.9 6.5 5.9 88 80 10.8-11.8L244.7 424H336c57.4 0 104-46.6 104-104V128h40 16V112 16 0H480 384zM205.4 10.1L194.6 21.9 267.3 88H176C118.6 88 72 134.6 72 192V384H32 16v16 96 16H32h96 16V496 400 384H128 88V192c0-48.6 39.4-88 88-88h91.3l-72.7 66.1 10.8 11.8 88-80 6.5-5.9-6.5-5.9-88-80zM32 400h96v96H32V400z'
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fast',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      'M368 320c0-22.5-10.5-52.9-28.2-87.4c-17.5-34-41-70-64.8-103c-23.7-33-47.5-62.7-65.3-84.3c-6.9-8.3-12.9-15.4-17.7-21c-4.8 5.6-10.8 12.6-17.7 21c-17.8 21.5-41.6 51.3-65.3 84.3c-23.8 33-47.3 69-64.8 103C26.5 267.1 16 297.5 16 320c0 97.2 78.8 176 176 176s176-78.8 176-176zM0 320C0 229.1 141.1 58.9 181.4 12.1C188.1 4.4 192 0 192 0s3.9 4.4 10.6 12.1C242.9 58.9 384 229.1 384 320c0 106-86 192-192 192S0 426 0 320zM496 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM384 96a64 64 0 1 1 128 0A64 64 0 1 1 384 96z'
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fast',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      'M295.8 220.7C330.3 200.2 352 165.9 352 128c0-60.1-55.5-112-128-112S96 67.9 96 128c0 37.9 21.7 72.2 56.2 92.7l7.8 4.7v9.1V272H288V234.4v-9.1l7.8-4.7zM368 128c0 44.4-25.4 83.5-64 106.4V272v16H288 160 144V272 234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM176 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM436.1 511L224 393.2 11.9 511 4.1 497 207.5 384 4.1 271l7.8-14L224 374.8 436.1 257l7.8 14L240.5 384 443.9 497l-7.8 14z'
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fast',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      'M372.5 164.7l-4.4 18.1 18.6 1.6C447.9 189.9 496 241.3 496 304c0 66.3-53.7 120-120 120c-45.8 0-85.7-25.7-105.9-63.5L256 334.1l-14.1 26.4C221.7 398.3 181.8 424 136 424C69.7 424 16 370.3 16 304c0-62.7 48.1-114.1 109.3-119.5l18.6-1.6-4.4-18.1c-2.3-9.2-3.5-18.8-3.5-28.7c0-66.3 53.7-120 120-120s120 53.7 120 120c0 9.9-1.2 19.5-3.5 28.7zm31.4 6.2c-5.2-1.1-10.5-1.9-15.9-2.4c1.3-5.2 2.2-10.4 2.9-15.8c.7-5.5 1-11.1 1-16.7C392 60.9 331.1 0 256 0S120 60.9 120 136c0 5.7 .3 11.2 1 16.7c.7 5.4 1.6 10.6 2.9 15.8c-5.4 .5-10.7 1.3-15.9 2.4C46.3 183.8 0 238.5 0 304c0 75.1 60.9 136 136 136c45.5 0 85.7-22.3 110.4-56.6c.5-.8 1.1-1.5 1.6-2.3V496H168h-8v16h8 80 16 80 8V496h-8H264V381.2c.5 .8 1.1 1.5 1.6 2.3C290.3 417.7 330.5 440 376 440c75.1 0 136-60.9 136-136c0-65.5-46.3-120.2-108-133.1z'
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fast',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      'M264 0h-8V8 64h16V16H560V288H328h-8v16h8H560v80H328h-8v16h8H560v96H320v16H568h8v-8V8 0h-8H264zM16 112H272V352H16V112zm0 256H272v48H16V368zm0 64H272v64H16V432zM0 96v16V496v16H16 272h16V496 112 96H272 16 0zM400 72v8 32H368h-8v8 48 8h8 32v32 8h8 48 8v-8V176h32 8v-8V120v-8h-8H464V80 72h-8H408h-8zm16 16h32v32 8h8 32v32H456h-8v8 32H416V168v-8h-8H376V128h32 8v-8V88zM120 168h-8v8 32H80 72v8 48 8h8 32v32 8h8 48 8v-8V272h32 8v-8V216v-8h-8H176V176v-8h-8H120zm8 48V184h32v32 8h8 32v32H168h-8v8 32H128V264v-8h-8H88V224h32 8v-8z'
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fast',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440h8V496h-8H416V416h24 8v-8V256H432V400H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V160h16V8 0h-8H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM525.7 98.3L520 92.7 508.7 104l5.7 5.7L604.7 200H264h-8v16h8H604.7l-90.3 90.3-5.7 5.7L520 323.3l5.7-5.7 104-104 5.7-5.7-5.7-5.7-104-104z'
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fast',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      'M216 0h16V32.2c84.6 4.2 152 74.1 152 159.8v93.2L446.2 363l1.8 2.2V368v40 8h-8H8 0v-8V368v-2.8L1.8 363 64 285.2V192c0-85.7 67.4-155.6 152-159.8V0zm8 48C144.5 48 80 112.5 80 192v96 2.8L78.2 293 16 370.8V400H432V370.8L369.8 293l-1.8-2.2V288 192c0-79.5-64.5-144-144-144zM190.1 481.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9h16c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3h16c0 12.7 5.1 24.9 14.1 33.9zM232 160v8 64h64 8v16h-8H232v64 8H216v-8V248H152h-8V232h8 64V168v-8h16z'
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fast',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM80 176H448V336H80V176zM64 160v16V336v16H80 448h16V336 176 160H448 80 64z'
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fast',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 403.3l5.7-5.7 208-208 5.7-5.7L464 172.7l-5.7 5.7L256 380.7 53.7 178.3 48 172.7 36.7 184l5.7 5.7 208 208 5.7 5.7z'
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fast',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      'M284 436.2l2.2-.6c87.2-22.2 180.2-45.9 273.8-8.7V70.3c-86.9-40.1-174.2-18.4-268 5.5l-2.2 .6C202.6 98.5 109.6 122.3 16 85V441.7c86.9 40.1 174.2 18.4 268-5.5zM0 60.3c5.3 2.7 10.7 5.2 16 7.5c90.7 38.7 181.3 15.6 272-7.5c96-24.5 192-48.9 288 0V433.9v17.8c-5.3-2.7-10.7-5.2-16-7.5c-90.7-38.7-181.3-15.6-272 7.5c-96 24.5-192 48.9-288 0V78.1 60.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104z'
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fast',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      'M320 256l11.3-11.3L436.7 139.3 448 128l-11.3-11.3L331.3 11.3 320 0 308.7 11.3 203.3 116.7 192 128l11.3 11.3L308.7 244.7 320 256zm0-233.4L425.4 128 320 233.4 214.6 128 320 22.6zM96 72c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8V384c0 2.1 .8 4.2 2.3 5.7l120 120 11.3-11.3L16 380.7V80H80V288c0 2.1 .8 4.2 2.3 5.7l10.8 10.8 5.2 5.2 80 80 8 8 5.7 5.7L203.3 392l-5.7-5.7-8-8-74.8-74.8 37.6-43.8L288 395.3V504v8h16v-8V392v-3.3l-2.3-2.3-144-144-6.1-6.1-5.6 6.6-42.4 49.4L96 284.7V72zm456-8c-4.4 0-8 3.6-8 8V284.7l-7.5 7.5-42.4-49.4-5.6-6.6-6.1 6.1-144 144-2.3 2.3V392 504v8h16v-8V395.3L487.5 259.8l37.6 43.8-74.8 74.8-8 8-5.7 5.7L448 403.3l5.7-5.7 8-8 80-80 5.2-5.2 10.8-10.8c1.5-1.5 2.3-3.5 2.3-5.7V80h64V380.7L506.3 498.3l11.3 11.3 120-120c1.5-1.5 2.3-3.5 2.3-5.7V72c0-4.4-3.6-8-8-8H552z'
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faTransporter2 = {
    prefix: 'fast',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M56 8V0H40V8 40H8 0V56H8 40V88v8H56V88 56H88h8V40H88 56V8zM472 328v-8H456v8 32H424h-8v16h8 32v32 8h16v-8V376h32 8V360h-8H472V328zM104 448H96v8 48 8h16v-8V464H400v40 8h16v-8V456v-8h-8H104zM288 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM193.4 128h-3.8l-2.4 3-74.5 93h20.5l64.1-80H314.8l64.1 80h20.5l-74.5-93-2.4-3h-3.8H193.4zm144.5 96l-11.6-14.5L312 191.7v22.8V224h25.9zM200 224v-9.5V191.7l-14.2 17.8L174.1 224H200zM168 384h-8v16h8H344h8V384h-8H168zm-8-64v16h8H344h8V320h-8H168h-8zm-56-64H96v16h8H408h8V256h-8H104z'
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fast',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM95.9 128h5H219.1h5l2.2 4.5 63.5 131.7c-3.7 5-7.1 10.2-10.2 15.6L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156 76H420V420h24v24zm-4-164v8 96 8H424v-8V288v-8h16z'
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fast',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      'M104 0H96V8 128H16 0v16V464v16H16 64v24 8h8 48 8v-8V480H256v24 8h8 48 8v-8V480h48 16V464 144 128H368 288V8 0h-8H104zM304 464H272 256 128 112 80 64 16V144H96h16H272h16 80V464H320 304zm-32 16h32v16H272V480zm-160 0v16H80V480h32zM272 128H112V16H272V128zM80 240v16h8H296h8V240h-8H88 80zm0 112v16h8H296h8V352h-8H88 80z'
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fast',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      'M592 16V389.3L608 402v-2V16 0H592 48 32V.2H99L119.1 16H592zM32 110.3V400v16H48 254.6l-13.3 80H168h-8v16h8 80H392h80 8V496h-8H398.8l-13.3-80h33.7l-20.3-16H376.2h-.3H264.1h-.3H48V123L32 110.3zM112 352H338.1l-20.3-16H112V173.5L96 160.8V336v16h16zm432-16V80 64H528 179.9l20.3 16H528V336h-3.6L544 351.5V336zM257.4 496l13.3-80h98.4l13.3 80H257.4zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fast',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM200 96H312h8v8V256c0 35.3-28.7 64-64 64s-64-28.7-64-64V104 96h8zm8 160c0 26.5 21.5 48 48 48s48-21.5 48-48V240H264h-8V224h8 40V176H264h-8V160h8 40V112H208V256zm-64-32v8 24c0 61.9 50.1 112 112 112s112-50.1 112-112V232v-8h16v8 24c0 68-53 123.6-120 127.8V408v8H248v-8V383.8C181 379.6 128 324 128 256V232v-8h16z'
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fast',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm295.3 79.9l11.3 11.3 50.2 50.2 11.3 11.3L356.8 196 182.3 370.6l-69.7 10.9L96 384l2.6-16.6 10.9-69.7L295.3 111.9zM124.4 305.4l-9.3 59.5 59.5-9.3L304.4 225.8l-50.2-50.2L124.4 305.4zM345.5 184.7l-50.2-50.2-29.8 29.8 50.2 50.2 29.8-29.8z'
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fast',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      'M64 64h8H440h8V80h-8H328.7L403 256H504h8v16h-8l-94.2 0H392.4l-272.8 0 0 0H102.2l0 0H8 0V256H8 109L183.3 80H72 64V64zM200.7 80l-1.3 3.1L126.4 256H385.6l-73-172.9L311.3 80H200.7zM423.3 304l60.8 144H466.7L405.9 304h17.4zm-317.2 0L45.3 448H27.9L88.7 304h17.4z'
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fast',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      'M81.3 459l-8.2-5.9L64.2 458 16 484.8V27.2L64.2 54l8.8 4.9L81.3 53l47.3-33.8 54.9 34.3 8.5 5.3 8.5-5.3 54.9-34.3L302.7 53l8.2 5.9 8.8-4.9L368 27.2V484.8L319.8 458l-8.8-4.9-8.2 5.9-47.3 33.8-54.9-34.3-8.5-5.3-8.5 5.3-54.9 34.3L81.3 459zM0 512l16-8.9L72 472l56 40 64-40 64 40 56-40 56 31.1 16 8.9V493.7 18.3 0L368 8.9 312 40 256 0 192 40 128 0 72 40 16 8.9 0 0V18.3 493.7 512zM96 152H88v16h8H288h8V152h-8H96zM88 344v16h8H288h8V344h-8H96 88zm8-96H88v16h8H288h8V248h-8H96z'
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fast',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      'M16 496H258.1l-2.5 16H16 0V496 16 0H16 224L384 160V293.5l-16 16V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zm137.5 63.9l11.3 11.3 54.5 54.5L576 300.9l-11.3 11.3L379.3 497.6l-74.7 11.6L288 511.9l2.6-16.6 11.6-74.7L498.9 223.9zM317.2 428.2l-10 64.5 64.5-10L509.5 344.8 455 290.4 317.2 428.2zM553.4 300.9l-54.5-54.5L466.4 279l54.5 54.5 32.5-32.5z'
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fast',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      'M96 8V0H80V8 96H8c-4.4 0-8 3.6-8 8V312c0 2.1 .8 4.2 2.3 5.7L32 347.3V504c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8V347.3l29.7-29.7c1.5-1.5 2.3-3.5 2.3-5.7V104c0-4.4-3.6-8-8-8H320V64 56h-8H264h-8v8V96H224V64 56h-8H168h-8v8V96H96V8zM272 96V72h32V96H272zM208 72V96H176V72h32zM80 112H96 368V308.7l-29.7 29.7c-1.5 1.5-2.3 3.5-2.3 5.7V496H48V344c0-2.1-.8-4.2-2.3-5.7L16 308.7V112H80zm16 64v16h8H280h8V176h-8H104 96zm0 64v16h8H280h8V240h-8H104 96zm0 64v16h8H280h8V304h-8H104 96z'
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fast',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      'M378.6 176h7H416V142v-6.3l4.3-4.6 69.5-74.7L455.6 22.2l-264 245.5L187 272h-6.3H128v47.9 7l-5.1 4.7L23 424.4 87.6 489 373.8 181.1l4.7-5.1zM98.9 500.3L88 512 76.7 500.7 11.3 435.3 0 424l11.7-10.9L112 319.9V272 256h16 52.7L456 0l56 56-80 86v34 16H416 385.5L98.9 500.3z'
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fast',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      'M0 0H8 64h6.2l1.6 6 69.4 266h341L557.6 32h16.8L495.6 282.4l-1.8 5.6H488 145.3l20.9 80H496h8v16h-8H160h-6.2l-1.6-6L57.8 16H8 0V0zM208 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM328 8l0 172.7 66.3-66.3 5.7-5.7L411.3 120l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-80-80-5.7-5.7L240 108.7l5.7 5.7L312 180.7 312 8V0h16V8z'
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fast',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      'M48 80v96h96V80H48zM32 64H48h96 16V80v96 16H144 48 32V176 80 64zM48 336v96h96V336H48zM32 320H48h96 16v16 96 16H144 48 32V432 336 320z'
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fast',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      'M0 0H8 120h8V8 416h96H512 632h8v16h-8H547.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H259.8c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32H120h-8v-8V16H8 0V0zM512 432a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 464a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fast',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      'M72 16C41.1 16 16 41.1 16 72v56c0 26.5 21.5 48 48 48s48-21.5 48-48V80 72h16v8 48c0 18.6-7.9 35.4-20.6 47.1L146.9 208H184c0-27.8 11.6-52.8 25.5-71.9c2.1-2.9 4.3-5.6 6.5-8.3V120 38.8l-41.3-6.9-7.9-1.3 2.6-15.8 7.9 1.3 48 8 6.7 1.1V32v79.3c7.4-6.5 14.5-11.5 20.4-14.4l3.6-1.8 3.6 1.8c5.9 3 13.1 7.9 20.4 14.4V32 25.2l6.7-1.1 48-8 7.9-1.3 2.6 15.8-7.9 1.3L296 38.8V120v7.8c2.2 2.6 4.4 5.4 6.5 8.3c14 19.1 25.5 44.1 25.5 71.9h37.1l39.5-32.9C391.9 163.4 384 146.6 384 128V80 72h16v8 48c0 26.5 21.5 48 48 48s48-21.5 48-48V72c0-30.9-25.1-56-56-56h-5.9l21.7 94.2 1.8 7.8L442 121.6l-1.8-7.8-24-104L413.9 0H424h16c39.8 0 72 32.2 72 72v56c0 35.3-28.7 64-64 64c-10.8 0-20.9-2.7-29.9-7.4l-45 37.5-2.2 1.9H368 328v32h54.1l46.3-23.2 7.2-3.6 7.2 14.3-7.2 3.6-48 24-1.7 .8H384 328v32h70.5L437 288.6l7.4-3 5.9 14.9-7.4 3-40 16-1.4 .6H400 328v32h24 2.4l2 1.3 24 16 6.7 4.4-8.9 13.3-6.7-4.4-22-14.7H326.1l-19.9 74.6C332.7 450.5 352 475 352 504v8h-8H168h-8v-8c0-29 19.3-53.5 45.8-61.4L185.9 368H162.4l-22 14.7-6.7 4.4-8.9-13.3 6.7-4.4 24-16 2-1.3H160h24V320H112h-1.5l-1.4-.6-40-16-7.4-3 5.9-14.9 7.4 3L113.5 304H184V272H128h-1.9l-1.7-.8-48-24-7.2-3.6 7.2-14.3 7.2 3.6L129.9 256H184V224H144h-2.9l-2.2-1.9-45-37.5C84.9 189.3 74.8 192 64 192c-35.3 0-64-28.7-64-64V72C0 32.2 32.2 0 72 0H88 98.1L95.8 9.8l-24 104L70 121.6 54.4 118l1.8-7.8L77.9 16H72zM200 256v16 25.8l56 14 56-14V272 256 208c0-23.4-9.8-45.1-22.5-62.5c-11.2-15.4-24.3-26.7-33.5-32.4c-9.3 5.7-22.3 17-33.5 32.4C209.8 162.9 200 184.6 200 208v48zm0 58.2V320v25.8l56 14 56-14V320v-5.8l-54.1 13.5-1.9 .5-1.9-.5L200 314.2zm9.4 80.1L256 407.7l46.6-13.3 8.5-31.9-53.1 13.3-1.9 .5-1.9-.5-53.1-13.3 8.5 31.9zm4.8 18l9.1 34.2 2.3 8.6-8.9 1.3c-20.5 3.1-36.7 19.1-40.2 39.5H335.3c-3.4-20.4-19.7-36.4-40.2-39.5l-8.9-1.3 2.3-8.6 9.1-34.2-39.6 11.3-2.2 .6-2.2-.6-39.6-11.3z'
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fast',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      'M72 32H64v8V188.7L2.3 250.3 0 252.7v6.6l2.3 2.3L64 323.3V472v8h8H200h8V464h-8H80V320v-3.3l-2.3-2.3L19.3 256l58.3-58.3 2.3-2.3V192 48H200h8V32h-8H72z'
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fast',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      'M16 104V76.9C27.1 57.7 76.3 16 192 16s164.9 41.7 176 60.9V96h16V74.9 73l-.8-1.7C370.1 45.2 313.9 0 192 0S13.9 45.2 .8 71.3L0 73v1.9V409.5v8H8 32V464v16H48 96h16V464 417.5H224v-16H112V400H96 48 32v1.5H16V248H192h86.1l4.6-16H200V120H336V104H192 16zm0 16H184V232H16V120zM48 417.5H96V464H48V417.5zM96 336a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM64 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM384 144v32H512V144H384zm-16 32V144 128h16H512h16v16 32h24 6l1.7 5.8L590 288h34 16v16V432v16 48 16H624 576 560V496 448H336v48 16H320 272 256V496 448 432 304 288h16 34l30.3-106.2L338 176h6 24zM560 432h16 48V304H272V432h48 16H560zm16 16v48h48V448H576zm-304 0v48h48V448H272zM528 192H512 384 368 350l-27.4 96H573.4L546 192H528zM320 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faPeach = {
    prefix: 'fast',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      'M96 0H88V8 40c0 18.7 4.9 36.2 13.5 51.3c5.2-1.8 10.4-3.4 15.7-4.8C108.9 73 104 57.1 104 40V16h56c45.1 0 82.2 33.9 87.4 77.5c5.7 .6 11.5 .6 17.2 0C269.8 49.9 306.9 16 352 16h56V40c0 17.1-4.9 33-13.3 46.5c5.3 1.4 10.6 3 15.8 4.8C419.1 76.2 424 58.7 424 40V8 0h-8H352c-43.2 0-80.3 26.4-96 63.9C240.3 26.4 203.2 0 160 0H96zM256 136.9c-25.6-15.8-55.7-24.9-88-24.9h-8v.2C70.9 116.4 0 189.9 0 280C0 432 248 512 248 512h16s248-80 248-232c0-92.8-75.2-168-168-168c-32.3 0-62.4 9.1-88 24.9zM283.4 156c-4-3.3-8.2-6.4-12.4-9.4c21.7-11.9 46.5-18.6 73-18.6c83.9 0 152 68.1 152 152c0 67-55.1 120.8-116.5 159.5c-30.1 18.9-60.2 33.3-83 42.9c-11.3 4.8-20.8 8.4-27.3 10.8c-3.3 1.2-5.8 2.1-7.6 2.7l-.2 .1H250.6l-.2-.1c-1.7-.6-4.3-1.5-7.6-2.7c-6.6-2.4-16-6-27.3-10.8c-22.7-9.7-52.9-24-83-42.9C71.1 400.8 16 347 16 280c0-83.9 68.1-152 152-152c36.2 0 75.3 15.9 105.3 40.4c30.2 24.6 49.9 56.5 49.9 87.6v8h16v-8c0-37.7-23.5-73.8-55.8-100z'
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fast',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      'M72 32H64v8V256H8 0v16H8 64V472v8H80v-8V272H225.2L364 476.5l2.4 3.5h4.2H376h8v-8V272h56 8V256h-8H384V40 32H368v8V256H233.7L84 35.5 81.6 32H77.3 72zM244.5 272H368V453.8L244.5 272zm-30.2-16H80V58.2L214.3 256z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fast',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      'M16 480H0V464 48 32H16 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7V150.6L329.4 48H320V184c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V48H16V464H284.5c3.6 5.6 7.6 10.9 11.8 16H16zM224 240c25 0 47.6 10.5 63.7 27.3c-3.2 4.5-6.1 9.2-8.9 14C265.6 265.8 245.9 256 224 256c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.1 0 23.6-3 33.6-8.3c.7 5.5 1.7 11 3 16.4c-11.1 5.1-23.5 7.9-36.6 7.9c-48.6 0-88-39.4-88-88s39.4-88 88-88zM80 48V176H304V48H80zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3 5.7 5.7L488 435.3l-5.7-5.7L432 379.3l-50.3 50.3-5.7 5.7L364.7 424l5.7-5.7L420.7 368l-50.3-50.3-5.7-5.7L376 300.7l5.7 5.7L432 356.7l50.3-50.3 5.7-5.7L499.3 312l-5.7 5.7z'
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fast',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM104 152c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L200 246.9V272v8H184v-8V242.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H160c-22.1 0-40 17.9-40 40l0 6.5-16 0V152zm72 184V304h32v32H176z'
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fast',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M328 200v-8H312v8V504v8h16v-8V200zM200 288H184v8V504v8h16v-8V296v-8zM72 384H56v8V504v8H72v-8V392v-8z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fast',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM224 172.7l5.7 5.7 80 80 5.7 5.7L304 275.3l-5.7-5.7L232 203.3V400H216V203.3l-66.3 66.3-5.7 5.7L132.7 264l5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fast',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      'M250.3 269.7l5.7 5.7 5.7-5.7 208-208 5.7-5.7L464 44.7l-5.7 5.7L256 252.7 53.7 50.3 48 44.7 36.7 56l5.7 5.7 208 208zm0 192l5.7 5.7 5.7-5.7 208-208 5.7-5.7L464 236.7l-5.7 5.7L256 444.7 53.7 242.3 48 236.7 36.7 248l5.7 5.7 208 208z'
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fast',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      'M288 16a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 160A88 88 0 1 0 288 0a88 88 0 1 0 0 176zm-72.7 32h-1.7l-1.6 .7L7.7 301.6 .4 304.9l3.3 7.3L36.9 385l3.3 7.3 7.3-3.3L176 330.5V456v8h16v-8V318.1 305.7l-11.3 5.1L48.1 371.1 21.6 312.8 217.1 224H358.9l195.4 88.8-26.5 58.3L395.3 310.8 384 305.7v12.4V456v8h16v-8V330.5L528.6 389l7.3 3.3 3.3-7.3 33.1-72.8 3.3-7.3-7.3-3.3L364 208.7l-1.6-.7h-1.7H215.3zM8 496H0v16H8 568h8V496h-8H8zM80 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM336 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM464 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fast',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      512,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      'M240 480l-56-56-11.3-11.3-10.9 11.7L90.9 500.3 80 512 68.7 500.7 11.3 443.3 0 432l11.7-10.9 75.9-70.8 11.7-10.9L88 328 32 272l0-108.8 97.6-97.6c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3c-4.3-3.3-8.8-6.3-13.6-9c31.9-75.7 17.1-166.4-44.6-228c-81.2-81.2-212.9-81.2-294.2 0L82.6 135.3 303 355.7c-2.7 5-5 10.2-7 15.6L71.3 146.6 48 169.8v95.5L110.6 328l11.7 11.7L110.2 351 23 432.4 79.6 489 161 401.8l11.3-12.1L184 401.4 246.6 464h50.7c2.2 5.5 4.9 10.9 7.8 16H240zm256-64a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3L511.3 499.9l-11.3 11.3L349.3 360.6z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fast',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      'M0 32H8 120c75.1 0 136 60.9 136 136c0 68.8-51 125.6-117.3 134.7L197.8 480H180.9L122.2 304c-.7 0-1.5 0-2.2 0H16V480H0V296 40 32zM16 288H120c66.3 0 120-53.7 120-120s-53.7-120-120-120H16V288zM296 160H400c61.9 0 112 50.1 112 112s-50.1 112-112 112H304V504v8H288v-8V384 368 168v-8h8zM400 368c53 0 96-43 96-96s-43-96-96-96H304V368h96z'
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fast',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      'M16 48l480 0 0 117.5c5.1-1.8 10.5-3.2 16-4.1L512 48l0-16-16 0L16 32 0 32 0 48 0 464l0 16 16 0 368 0 0-16-32 0 0-128 32 0 0-16-32 0 0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L16 176 16 48zm0 144l144 0 0 128L16 320l0-128zm0 144l144 0 0 128L16 464l0-128zM176 464l0-128 160 0 0 128-160 0zm0-144l0-128 160 0 0 128-160 0zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-32 0-16 0 0 16 0 160 0 16 16 0 192 0 16 0 0-16 0-160 0-16-16 0-32 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80l32 0 16 0 96 0 16 0 32 0 0 160-192 0 0-160z'
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fast',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      'M32 224H48 464h16V208 192s-16-160-224-160S32 192 32 192v16 16zm432-31v15H48V193l.1-.5c.1-.9 .4-2.4 .7-4.3c.7-3.8 2-9.5 4.2-16.3c4.3-13.7 12.1-32 25.8-50.2C105.6 85.8 156.8 48 256 48s150.4 37.8 177.2 73.6c13.7 18.2 21.5 36.5 25.8 50.2c2.2 6.8 3.5 12.5 4.2 16.3c.4 1.9 .6 3.4 .7 4.3l.1 .5zm.1 .7l0 0s0 0 0 0zM48 464V400H464v64H48zM32 384v16 64 16H48 464h16V464 400 384H464 48 32zM168 279.5l-2.7 1L80 311.5l-61.2-23-5.6 15 64 24 2.8 1 2.8-1 85.3-31 85.3 31 2.7 1 2.7-1 85.3-31 85.3 31 2.8 1 2.8-1 64-24-5.6-15-61.2 23-85.2-31-2.7-1-2.7 1-85.3 31-85.3-31-2.7-1zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm240-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fast',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zM284.7 332.7l-25.4-25.4L248 296l11.3-11.3 73.4-73.4L344 200l-11.3-11.3-41.4-41.4L280 136l-11.3 11.3-73.4 73.4L184 232l-11.3-11.3-25.4-25.4L136 184l-11.3 11.3L112 208V352v16h16H272l12.7-12.7L296 344l-11.3-11.3zm-48-48L225.4 296l11.3 11.3L273.4 344l-8 8H128V214.6l8-8 36.7 36.7L184 254.6l11.3-11.3L280 158.6 321.4 200l-84.7 84.7z'
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fast',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      'M384 0H64L32 64H16 0V80v32 16H16 32 416h16 16V112 80 64H432 416L384 0zm32 80h16v32H416 32 16V80H32h9.9l4.4-8.8L73.9 16H374.1l27.6 55.2 4.4 8.8H416zM47.4 160L80 512H368l32.6-352H384.5l-5.9 64H69.4l-5.9-64H47.4zm23.5 80H377.1L363.8 384H84.2L70.9 240zM85.7 400H362.3l-8.9 96H94.6l-8.9-96z'
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fast',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M216.6 37l2-5h10.8l2 5 174 427H440h8v16h-8H344h-8V464h8 44.1L336 336H112L59.9 464H104h8v16h-8H8 0V464H8 42.6l174-427zm-98 283H329.4L224 61.2 118.6 320z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fast',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M16 470.7L0 480V461.5 50.5 32l16 9.3L368.1 246.7 384 256l-15.9 9.3L16 470.7zM352.2 256L16 59.9V452.1L352.2 256z'
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fast',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      'M288 0h8H504h8V8 192h48V104 96h16v8 88h56 8v8V504v8H624v-8V208H576 560 504h-8v-8V16H304V504v8H288v-8V8 0zM205.5 182.3l1.5-9.7c.6-4.1 1-8.3 1-12.6c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 4.3 .3 8.5 1 12.6l1.5 9.7-8 5.8C26.4 199.7 16 218.7 16 240v64H120V232v-8h16v8 72H240V240c0-21.3-10.4-40.3-26.6-51.9l-8-5.8zM16 320H0V304 240c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.1-.4 10.2-1.2 15.1C242.9 189.7 256 213.3 256 240v64 16H240 136V504v8H120v-8V320H16zM368 72h64 8v8 64 8h-8H368h-8v-8V80 72h8zm8 64h48V88H376v48zM488 264h8 64 8v8 64 8h-8H496h-8v-8V272v-8zm16 64h48V280H504v48zm-8 64h64 8v8 64 8h-8H496h-8v-8V400v-8h8zm8 64h48V408H504v48zM360 200h8 64 8v8 64 8h-8H368h-8v-8V208v-8zm16 64h48V216H376v48zm-8 64h64 8v8 64 8h-8H368h-8v-8V336v-8h8zm8 64h48V344H376v48z'
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fast',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM88 320H296V304H88v16z'
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fast',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      'M496 232c0-93.4-51.6-174.7-127.8-217l7.8-14C457.1 46 512 132.6 512 232H496zM160 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM32 464a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16A32 32 0 1 1 0 480a32 32 0 1 1 64 0zm5.7-101.7l64 64 5.7 5.7L128 459.3l-5.7-5.7-64-64L52.7 384 64 372.7l5.7 5.7zM240 80C151.6 80 80 150.9 80 238.2v8H64v-8C64 141.9 142.9 64 240 64s176 77.9 176 174.2c0 55.6-26.3 105-67.2 136.9V392c0 66.3-53.7 120-120 120H206.4h-8V496h8 22.4c57.4 0 104-46.6 104-104V371.1c0-2.5 1.2-4.9 3.2-6.4c38.9-28.9 64-74.8 64-126.5C400 150.9 328.4 80 240 80zm0 64c-53 0-96 43-96 96v8H128v-8c0-61.9 50.1-112 112-112s112 50.1 112 112v8H336v-8c0-53-43-96-96-96z'
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fast',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M580.2 244.7c50-50 50-131 0-181s-131-50-181 0l-17 17L393.5 92l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4L433.1 369.1c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l39.6-39.6L303 159.8l-39.6 39.6c-50 50-50 131 0 181s131 50 181 0L580.2 244.7zM59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17L246.5 420l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4L206.9 142.9c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-39.6 39.6L337 352.2l39.6-39.6c50-50 50-131 0-181s-131-50-181 0L59.8 267.3z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fast',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      'M432 16V496H16V16H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM192 120v16h8H376h8V120h-8H200h-8zm0 128v16h8H376h8V248h-8H200h-8zm0 128v16h8H376h8V376h-8H200h-8zm-56-32H120 72 56v16 48 16H72h48 16V408 360 344zM72 360H88h16 16v16 16 16H104 88 72V392 376 360zM56 88v16 48 16H72h48 16V152 104 88H120 72 56zm32 16h16 16v16 16 16H104 88 72V136 120 104H88zm69.7 125.7l5.7-5.7L152 212.7l-5.7 5.7L96 268.7 69.7 242.3 64 236.7 52.7 248l5.7 5.7 32 32 5.7 5.7 5.7-5.7 56-56z'
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fast',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      'M112 8V0H96V8v9.4c0 16.9 8.8 32.5 23.3 41.2l41.2 24.7C170.1 89 176 99.4 176 110.6V120v8h16v-8-9.4c0-16.9-8.8-32.5-23.3-41.2L127.5 44.8C117.9 39 112 28.6 112 17.4V8zm96 0V0H192V8v9.4c0 16.9 8.8 32.5 23.3 41.2l41.2 24.7C266.1 89 272 99.4 272 110.6V120v8h16v-8-9.4c0-16.9-8.8-32.5-23.3-41.2L223.5 44.8C213.9 39 208 28.6 208 17.4V8zM138.7 376.5c16.9 4.9 34.8 7.5 53.3 7.5h64c18.5 0 36.4-2.6 53.3-7.5L338.1 440H159.5c-2.4-19.2-13.3-35.8-28.8-45.8l8-17.7zm-15.3-5.1l-7.2 15.9c-6.4-2.1-13.2-3.3-20.3-3.3c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56H345.4l21.1 46.3 3.3 7.3 14.6-6.6-3.3-7.3L324.5 371.4C396.7 343.8 448 273.9 448 192V176 160H432 16 0v16 16c0 81.9 51.3 151.8 123.5 179.4zM96 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM16 176H432v16c0 97.2-78.8 176-176 176H192C94.8 368 16 289.2 16 192V176z'
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      'M448 288c-5.4 0-10.7-.3-16-.8V368H328V233.8c-5.9-6.7-11.3-13.9-16-21.5V368H200V200v-8H184v8V368H80V200v-8H64v8V376v8h8H184h16H312h16H440h8v-8V288zM16 160H291.2c-1.1-5.2-1.9-10.6-2.4-16H16V122.5l240-105 56.8 24.9c2.9-4.6 6.1-9.1 9.5-13.3L256 0 0 112v32 16H16zM40 432H32v16h8H472h8V432h-8H40zM8 496H0v16H8 504h8V496h-8H8zM448 16.1a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c32.5 0 62.1-12.1 84.7-32l89.7 89.5 5.7 5.7L639.3 308l-5.7-5.7L544 212.8c19.9-22.6 32-52.2 32-84.7c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fast',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      'M416 16V208h16V16 0H416 336 320 256 240 160 144V16 208h16V16h80V96v16h16 64 16V96 16h80zM256 16h64V96H256V16zm64 496H560h16V496 256 240H560 480 464 400 384 320v16h64v80 16h16 64 16V336 256h80V496H320v16zm80-256h64v80H400V256zm-128 0V496H16V256H96v80 16h16 64 16V336 256h80zM112 336V256h64v80H112zm160-96H192 176 112 96 16 0v16V496v16H16 272h16V496 256 240H272z'
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fast',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      'M256 0h-8V8 120v8h16v-8V16.1c128.8 4.2 232 110 232 239.9c0 132.5-107.5 240-240 240S16 388.5 16 256c0-66.3 26.9-126.3 70.3-169.7L75 75C28.7 121.3 0 185.3 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM165.7 154.3l-5.7-5.7L148.7 160l5.7 5.7 96 96 5.7 5.7L267.3 256l-5.7-5.7-96-96z'
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fast',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM288 336A96 96 0 1 0 96 336a96 96 0 1 0 192 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm112 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32-176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fast',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      'M16 104H192 368V76.9C356.9 57.7 307.7 16 192 16S27.1 57.7 16 76.9V104zm0 16V232H184V120H16zm0 128V400H32 48 96h16H224v16H112v48 16H96 48 32v-8-8V416H8 0v-8V74.9 73l.8-1.7C13.9 45.2 70.1 0 192 0S370.1 45.2 383.2 71.3L384 73v1.9V144h-3.8H368V120H200V232h82.7l-4.6 16H192 16zM96 464V416H48v48H96zM80 320a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM338 176h6H552h6l1.7 5.8L590 288h34 16v16V432v16 48 16H624 576 560V496 448H336v48 16H320 272 256V496 448 432 304 288h16 34l30.3-106.2L338 176zM272 304V432h48 16H560h16 48V304H272zM624 496V448H576v48h48zM320 448H272v48h48V448zM546 192H350l-27.4 96H573.4L546 192zM320 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fast',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      'M148.1 328.5L124.4 493.4 121.7 512l17.2-7.4 173.1-74.4V28.6 0l-16 23.7L201.6 164 38 192.3l-19.1 3.3 13.5 13.9 115.7 119zM51.5 206.2l152.8-26.4 6.7-1.2 3.8-5.7L296.1 52.4V419.7L141.6 486l22.3-155.3L165 323l-5.5-5.6L51.5 206.2z'
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fast',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      'M0 0H8 632h8V8 152v8H624v-8V16H16V152v8H0v-8V8 0zM512 80v8l0 416v8h-8l-368 0h-8v-8l0-416V80h16v8l0 408 352 0 0-408V80h16zM320 200c-50 0-88 33.5-88 72s38 72 88 72s88-33.5 88-72s-38-72-88-72zm104 72c0 49.9-48 88-104 88s-104-38.1-104-88s48-88 104-88s104 38.1 104 88zm48 120c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zm-296-8h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fast',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      'M112 48V408H464V48H112zm368 0V408h32 8v16h-8H480 464 112 96 64 56V408h8H96V48 32h16H464h16V48zM16 352H64v16H16v96H560V368H512V352h48 16v16 96 16H560 16 0V464 368 352H16zM373.7 176.3L267 283l-5.7 5.7-5.7-5.7-53.3-53.3-5.7-5.7L208 212.7l5.7 5.7L261.3 266l101-101 5.7-5.7 11.3 11.3-5.7 5.7z'
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fast',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zm128 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM96 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 496a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm240-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 496a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm240-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM320 496a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fast',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      'M256 16c82.6 0 155.4 41.7 198.6 105.2L493.4 160C455.4 66.2 363.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.5 0 65.5-6.4 94.8-18.1c-4.3-3.9-8.5-8.1-12.4-12.4C312.7 490.9 284.9 496 256 496C123.5 496 16 388.5 16 256S123.5 16 256 16zM384 144V128H368 336 320v16 64 16h14.1c2.9-4 5.9-7.9 8.9-11.7c1.2-1.4 2.3-2.9 3.5-4.3H336V144h32v40.1c5.3-5.4 10.7-10.5 16-15.3V144zm-240 0h32v64H144V144zm-16-16v16 64 16h16 32 16V208 144 128H176 144 128zm112 16h32v64H240V144zm0-16H224v16 64 16h16 32 16V208 144 128H272 240zm260.7 84.8L448 160.2c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-20.7 20.7L512 224.2l-11.3-11.3zM576 422.6c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 18.2 5.8 35.1 15.7 49.2C361.3 445.9 336 402 336 352.2c0-39.7 19-77.6 44.5-109.6c21.3-26.7 46.2-48.2 65.4-61.8l54.7 54.7L512 246.8l11.3-11.3L544.8 214C609.1 272.5 624 332 624 352.2c0 49.8-25.3 93.7-63.7 119.6c9.9-14.1 15.7-31 15.7-49.2zm-96 73.6c-45.2 0-80-34-80-73.6c0-28.5 20-58.2 43.5-82.5c11.4-11.8 22.8-21.5 31.4-28.3c1.8-1.5 3.5-2.8 5.1-3.9c1.5 1.2 3.2 2.5 5.1 3.9c8.6 6.8 20 16.5 31.4 28.3C540 364.4 560 394 560 422.6c0 39.6-34.8 73.6-80 73.6z'
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fast',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm136 96H312h8v16h-8H144V248H272h8v16h-8H144V368H312h8v16h-8H136h-8v-8V256 136v-8h8z'
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fast',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zm200.3-78.8c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 320.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm-3.4 18.9L224 174.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L224 297.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4z'
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fast',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      'M32 176C32 96.5 96.5 32 176 32h72 8H432h8V48h-8H368l0 424v8H352v-8l0-424H272l0 256v16l0 152v8H256v-8V320H176C96.5 320 32 255.5 32 176zM256 304l0-256h-8H176C105.3 48 48 105.3 48 176s57.3 128 128 128h80z'
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fast',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      'M152 0c-4.4 0-8 3.6-8 8V128H16 0v16V496v16H16 144h8 8H504c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8H160V144 128 16H396.7L448 67.3V160h16V64c0-2.1-.8-4.2-2.3-5.7l-56-56C404.2 .8 402.1 0 400 0H152zm8 208H496V496H160l0-288zM144 496H16V144H144v56V496zm56-128v8 48 8h8 48 8v-8V376v-8h-8H208h-8zm16 16h32v32H216V384zm88-16h-8v8 48 8h8 48 8v-8V376v-8h-8H304zm8 48V384h32v32H312zm80-48v8 48 8h8 48 8v-8V376v-8h-8H400h-8zm16 16h32v32H408V384zM208 272h-8v8 48 8h8 48 8v-8V280v-8h-8H208zm8 48V288h32v32H216zm80-48v8 48 8h8 48 8v-8V280v-8h-8H304h-8zm16 16h32v32H312V288zm88-16h-8v8 48 8h8 48 8v-8V280v-8h-8H400zm8 48V288h32v32H408z'
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fast',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      'M240 8V0H224V8 32c0 26.5 21.5 48 48 48h16 8 8 6.1l-49.7 24.8-4.4 2.2V112v24 8h8 48 6.5l-11.3 32H112h0H88c-48.6 0-88 39.4-88 88v48 8H16v-8V264c0-39.8 32.2-72 72-72h24 0H312.9h5.7l1.9-5.3 15-42.7h.6 8V128h-2.9H336h-6.2H312 272V116.9L345.9 80h58.8l75.5 75.5c1 11.7 7 21.9 15.9 28.5v24H400h-6.1l-1.6 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7V496H296V352v-8h-8H218.8L181 313.8l-16.3-13.1 3.4 20.6 7.1 42.9-43.7 29.1-5 3.3 1.8 5.7L157.2 496H85.9L56.4 400.1l15.2-45.6 .4-1.2V352 320v-4.3l-3.6-2.4L43.8 296.9C39 293.7 35 289.5 32 284.7v23.4c1 .7 1.9 1.4 3 2.1l21 14v26.4L40.4 397.5l-.8 2.4 .8 2.5 32 104 1.7 5.6H80h88 10.8l-3.2-10.4-30.2-98.3 43-28.7 4.3-2.9-.9-5.1-4.6-27.4L211 358.2l2.2 1.8H216h64V504v8h8 88 8v-8V310.4c0-3.6 .5-7.1 1.4-10.5L406.1 224H504h8v-8V191.2c2.6 .5 5.3 .8 8 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L427.2 79.9C452.2 78.2 472 57.4 472 32V8 0H456V8 32c0 17.7-14.3 32-32 32h-8-4.7H408h0H344h-1.9-2.3c7.6-8.5 12.2-19.7 12.2-32V8 0H336V8 32c0 17.7-14.3 32-32 32h-8-8H272c-17.7 0-32-14.3-32-32V8zM544 152a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-128-8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fast',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      'M62.1 248H144V160v-8h16v8 88h80V160v-8h16v8 88h80V160v-8h16v8 88h64V128 112h16 16L576 256 448 400H432 416V384 264H352v88 8H336v-8V264H256v88 8H240v-8V264H160v88 8H144v-8V264H62.1L18.6 380 34 395.4l62-41.3v19.2L32 416 0 384 48 256 0 128 32 96l64 42.7v19.2L34 116.6 18.6 132 62.1 248zM432 264V384h8.8L554.6 256 440.8 128H432V248v16z'
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fast',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24.8 56.8l-5 24.8L444.2 344H496h20l-14.5 13.8-84 80-18.3 17.5 5-24.8 7.7-38.4H360 340l14.5-13.8 84-80 18.3-17.5zM380 376h41.6 9.8l-1.9 9.6-4.6 23.2L476 360H434.4h-9.8l1.9-9.6 4.6-23.2L380 376z'
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fast',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      'M224 0C135.6 0 64 71.6 64 160c0 5.6 .3 11 .8 16.5C37.3 180 16 203.5 16 232v48 8h8H64h66.7H317.3 384h40 8v-8V232c0-28.5-21.3-52-48.8-55.5c.6-5.4 .8-10.9 .8-16.5C384 71.6 312.4 0 224 0zM80 160C80 80.5 144.5 16 224 16s144 64.5 144 144c0 7.7-.6 15.3-1.8 22.7l-1.5 9.3h9.4H376c22.1 0 40 17.9 40 40v40H384 317.3 130.7 64 32V232c0-22.1 17.9-40 40-40h1.9 9.4l-1.5-9.3c-1.2-7.4-1.8-15-1.8-22.7zM214.5 497.2L224 512l9.5-14.8L347.4 320h-19L224 482.4 119.6 320h-19L214.5 497.2z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fast',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fast',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      'M508.3 46.7L407 112.3c63.7 16.9 105 47.6 105 95.7V368c0 32-28.6 60-75 80c-5.9 2.5-12 4.9-18.4 7.2C374.5 470.8 317.8 480 256 480s-118.5-9.2-162.7-24.8C87 452.9 80.8 450.5 75 448C28.6 428 0 400 0 368V208C0 128 114.6 96 256 96c47.2 0 91.4 3.6 129.3 11.3l114.4-74 8.7 13.4zM16 247.9V368c0 21.6 20 45.7 65.3 65.3c2.2 .9 4.4 1.9 6.7 2.8V293.2c-32-12-56.9-27.4-72-45.3zm88 50.8V441.9c39.5 13.2 89.3 21.3 144 22V320c-53.8-.7-103.5-8.4-144-21.2zM264 320v144c54.7-.7 104.5-8.8 144-22V298.8c-40.5 12.8-90.2 20.5-144 21.2zm160-26.7V436.1c2.3-.9 4.5-1.8 6.7-2.8C476 413.8 496 389.6 496 368V247.9c-15.1 17.9-40 33.3-72 45.3zM496 208c0-30.2-21-54.1-64.8-71.1c-12.8-5-27.1-9.2-42.8-12.6L236.3 222.7l-6.7 4.3-8.7-13.4 6.7-4.3L365.7 120c-32.7-5.4-69.9-8-109.7-8c-69.9 0-131.6 8-175.2 24.9C37 153.9 16 177.8 16 208c0 21.6 20 45.7 65.3 65.3C125.2 292.2 186.9 304 256 304s130.8-11.8 174.7-30.7C476 253.7 496 229.6 496 208z'
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fast',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      'M328.4 28.4l-80 344L246 382.7 468.7 160 330.3 21.7l-.3-.3-1.6 7zM238.6 414.8l-2.6 .6-94.3 94.3-2.3 2.3H136 88 80v-8V318.1L12.1 358.9 0 366.1V352 256 241.9l12.1 7.3L80 289.9V160H8 0V144H8 88h8v8V289.9l67.9-40.7 12.1-7.3V256v96 14.1l-12.1-7.3L96 318.1V496h36.7l91.9-91.9 .6-2.6 7.6-32.7 80-344L318.6 0H344 608h16 16V16 32 296v25.4l-24.8 5.8-344 80-32.7 7.6zM480 171.3L257.3 394l10.3-2.4 344-80 7-1.6-.3-.3L480 171.3zM624 32V27.3L491.3 160 624 292.7V32zM608 16H347.3L480 148.7 612.7 16H608zM16 270.1v67.7L72.5 304 16 270.1zm144 67.7V270.1L103.5 304 160 337.9z'
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fast',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      'M496 48V464H16V48H496zM16 32H0V48 464v16H16 496h16V464 48 32H496 16zM92.7 160.5l5.9 5.4L196.2 256 98.6 346.1l-5.9 5.4 10.9 11.8 5.9-5.4 104-96 6.4-5.9-6.4-5.9-104-96-5.9-5.4L92.7 160.5zM200 368h-8v16h8H408h8V368h-8H200z'
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fast',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      'M16 40V32H0v8V472v8H8 440h8V464h-8H16V40zm48 88v16c42.8 0 83.3 9.9 119.4 27.5l8.4-13.7C153.3 138.7 109.9 128 64 128zm147.2 59.3c32.6 21 60.5 48.9 81.5 81.5l13.6-8.4c-22.4-34.8-52-64.4-86.7-86.7l-8.4 13.6zM336 416v0h16v0c0-45.9-10.7-89.3-29.8-127.8l-13.7 8.4c17.6 36 27.5 76.5 27.5 119.4z'
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fast',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      'M294.4 307.2L240 234.7l-16-21.3V240v48 18.7l54.6 54.6 9.4 9.4V384v96 16 16H272 240 224V496 480 397.3L146.7 320c-12-12-18.7-28.3-18.7-45.3v-7.4V231.6l-16 32L92.6 302.3l-7.2 14.3-7.2 14.3L64 323.8 35.4 309.5l-14.3-7.2L28.2 288l7.2-14.3 64-128 8.8-17.7H128h32 64 16l9.6 12.8 96 128 9.6 12.8 9.6 12.8L352 304l-25.6 19.2-12.8 9.6L304 320l-9.6-12.8zm-27.1 65.5l-54.6-54.6-4.7-4.7v-6.6V288 213.3 176h8l20.8 27.7 70.4 93.9 9.6 12.8 25.6-19.2-9.6-12.8-96-128L232 144h-8H160 128h-9.9l-4.4 8.8-64 128-7.2 14.3 17 8.5 11.6 5.8 7.2-14.3 35.4-70.8L137.9 176H144v55.6 43.2c0 12.7 5.1 24.9 14.1 33.9l77.3 77.3 4.7 4.7v6.6V480v16h32V480 384v-6.6l-4.7-4.7zM208 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM176 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM121 376.2l7.4-29.4L141.5 360l-5 20.1-12 48-6 24-6 24-5 19.9h33l3-12.1 6-24 6-24 12-48 .4-1.5 13.2 13.2-10 40.2-6 24-6 24-6 24-.1 .2H87L91 496.2l.1-.2L97 472.2l6-24 6-24 12-48zM462.1 503.9L350.4 345.2l12.8-9.6 112 159.1 4.6 6.5-13.1 9.2-4.6-6.5z'
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fast',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M96 448h8H408h8v8 48 8H400v-8V464H112v40 8H96v-8V456v-8z'
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fast',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      'M466 232.7L489.4 256 256 489.4 232.7 466l-11.3 11.3 23.3 23.3L256 512l11.3-11.3L500.7 267.3 512 256l-11.3-11.3-23.3-23.3L466 232.7zM11.3 267.3l23.3 23.3L46 279.3 22.6 256 256 22.6 279.3 46l11.3-11.3L267.3 11.3 256 0 244.7 11.3 11.3 244.7 0 256l11.3 11.3zM474.9 138.9l-336 336c-28.1 28.1-73.7 28.1-101.8 0S9 401.2 37.1 373.1l336-336C401.2 9 446.8 9 474.9 37.1s28.1 73.7 0 101.8zm11.3 11.3c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.4 0l-336 336c-34.4 34.4-34.4 90.1 0 124.4s90.1 34.4 124.5 0l336-336zm-75.7-10.2l-6.5-14.6-7.3 3.2-72 32-2.4 1.1-1.3 2.3L282.2 234l-61.8 30.9-2.2 1.1-1.2 2.2-38.9 70-70 38.9-7 3.9 7.8 14 7-3.9 72-40 2-1.1 1.1-2L229.8 278l61.8-30.9 2.2-1.1 1.2-2.2 38.7-69.7 69.6-30.9 7.3-3.2z'
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fast',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      'M112 0h8H520h8V8 195.3c-5.2-1.5-10.5-2.5-16-3V16H128V192.4c-5.5 .5-10.8 1.5-16 3V8 0zM528 229.4c2.2 1 4.2 2.2 6.2 3.5c3.2-.6 6.4-.8 9.8-.8c25.6 0 47.2 17.2 53.9 40.6C613.6 282.5 624 300 624 320c0 2.8-.2 5.5-.6 8.2C633.7 338.4 640 352.4 640 368s-6.3 29.6-16.6 39.8c.4 2.7 .6 5.4 .6 8.2c0 19.9-10.4 37.5-26.1 47.4C591.2 486.8 569.6 504 544 504c-3.3 0-6.6-.3-9.8-.9c-8.7 5.6-19.1 8.9-30.2 8.9c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6c5.6 .8 11 2.5 16 4.8zm-416 0c5-2.4 10.4-4 16-4.8c2.6-.4 5.3-.6 8-.6c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-11.1 0-21.5-3.2-30.2-8.9c-3.2 .6-6.4 .9-9.8 .9c-25.6 0-47.2-17.2-53.9-40.6C26.4 453.5 16 435.9 16 416c0-2.8 .2-5.5 .6-8.2C6.3 397.6 0 383.6 0 368s6.3-29.6 16.6-39.8c-.4-2.7-.6-5.4-.6-8.2c0-20 10.4-37.5 26.1-47.4C48.8 249.2 70.4 232 96 232c3.3 0 6.6 .3 9.8 .8c2-1.3 4.1-2.4 6.2-3.5zM166 308l4.6-8c3.4-5.9 5.3-12.7 5.3-20c0-22.1-17.9-40-40-40c-8 0-15.4 2.3-21.6 6.3l-5.3 3.4-6.2-1.1c-2.3-.4-4.6-.6-7-.6c-18.3 0-33.7 12.2-38.5 29l-1.7 5.9-5.2 3.3C39.4 293.3 32 305.8 32 320c0 2 .1 4 .4 5.9l1.2 8-5.7 5.7C20.5 346.8 16 356.9 16 368s4.5 21.2 11.9 28.4l5.7 5.7-1.2 8c-.3 1.9-.4 3.9-.4 5.9c0 14.2 7.4 26.7 18.7 33.9l5.2 3.3 1.7 5.9c4.8 16.8 20.2 29 38.5 29c2.4 0 4.7-.2 7-.6l6.2-1.1 5.3 3.4c6.2 4 13.6 6.3 21.6 6.3c22.1 0 40-17.9 40-40c0-7.3-1.9-14.1-5.3-20l-4.6-8 4.6-8c3.4-5.9 5.3-12.7 5.3-20c0-8.5-2.6-16.4-7.2-22.8l-6.4-9.2 6.4-9.2c4.5-6.5 7.2-14.3 7.2-22.8c0-7.3-1.9-14.1-5.3-20l-4.6-8zm303.3-8l4.6 8-4.6 8c-3.4 5.9-5.3 12.7-5.3 20c0 8.5 2.6 16.4 7.2 22.8l6.4 9.2-6.4 9.2c-4.5 6.5-7.2 14.3-7.2 22.8c0 7.3 1.9 14.1 5.3 20l4.6 8-4.6 8c-3.4 5.9-5.3 12.7-5.3 20c0 22.1 17.9 40 40 40c8 0 15.4-2.3 21.6-6.3l5.3-3.4 6.2 1.1c2.3 .4 4.6 .6 7 .6c18.3 0 33.7-12.2 38.5-29l1.7-5.9 5.2-3.3c11.3-7.1 18.7-19.6 18.7-33.9c0-2-.1-4-.4-5.9l-1.2-8 5.7-5.7c7.3-7.3 11.9-17.3 11.9-28.4s-4.5-21.2-11.9-28.4l-5.7-5.7 1.2-8c.3-1.9 .4-3.9 .4-5.9c0-14.2-7.4-26.7-18.7-33.9l-5.2-3.3-1.7-5.9c-4.8-16.8-20.2-29-38.5-29c-2.4 0-4.7 .2-7 .6l-6.2 1.1-5.3-3.4c-6.2-4-13.6-6.3-21.6-6.3c-22.1 0-40 17.9-40 40c0 7.3 1.9 14.1 5.3 20z'
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fast',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      'M259.8 9l-4-2.2-3.9 2.4c-39 23.4-81.9 37-121.7 40.9C90.3 53.9 54.1 48 28 33.1L17.3 27 16 39.1C4 151.5 6.9 244.5 41.3 321.2c34.6 77 100.5 136.2 211.6 182.2l3.2 1.3 3.2-1.5C368.3 453 434 393.9 469.1 318c35-75.6 38.9-166.5 26.8-278.9L494.7 27 484 33.1C431.5 63.1 346.7 56.4 259.8 9zM131.8 66c40.8-4 84.5-17.6 124.4-40.8c82.7 44 166.6 54.1 225.1 27.3c3.8 38.7 5.5 74.4 4.7 107.5H256 25.7c-.6-33.3 1.2-69.1 5.1-107.6C59.1 65.3 94.5 69.6 131.8 66zM26.2 176h459c-2.8 50.9-12.2 95.6-30.6 135.3c-32.7 70.6-94 127-198.8 175.9C149.2 442.5 88 386.1 55.9 314.6C37.6 274 28.6 228.1 26.2 176z'
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fast',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      'M256 0c-37.8 0-70.4 21.8-86.1 53.5C160.6 49.9 150.5 48 140 48c-46.4 0-84 37.6-84 84c0 12 2.5 23.4 7.1 33.8C26.3 179.2 0 214.5 0 256c0 53 43 96 96 96h8s56 64 88 160H320c32-96 88-160 88-160h8c53 0 96-43 96-96c0-41.5-26.3-76.8-63.1-90.2c4.6-10.3 7.1-21.8 7.1-33.8c0-46.4-37.6-84-84-84c-10.5 0-20.6 1.9-29.9 5.5C326.4 21.8 293.8 0 256 0zM387.4 352l-1.4 1.8c-6 7.8-14.2 19.2-23.5 33.6C345.4 414 324.7 451.3 308.6 496H203.4c-16.1-44.7-36.8-82-53.9-108.7c-9.3-14.4-17.5-25.8-23.5-33.6l-1.4-1.8h88.6l28 69.9 4 10.1h21.7l4-10.1 28-69.9h88.6zm-157 0h51.2l-17 42.5L256 416l-8.6-21.5-17-42.5zm-49-285.1C193.1 37.1 222.1 16 256 16s62.9 21.1 74.6 50.9l3.2 8.2 7.8-3.9c9.1-4.6 19.5-7.2 30.4-7.2c37.6 0 68 30.4 68 68c0 12.6-3.4 24.4-9.4 34.6l-5.5 9.2 10.4 2.6c34.8 8.7 60.5 40.2 60.5 77.6c0 44.2-35.8 80-80 80H96c-44.2 0-80-35.8-80-80c0-37.4 25.7-68.9 60.5-77.6l10.4-2.6-5.5-9.2c-6-10.1-9.4-21.9-9.4-34.6c0-37.6 30.4-68 68-68c10.9 0 21.3 2.6 30.4 7.2l7.8 3.9 3.2-8.2z'
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fast',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      'M320 16c116.6 0 213.9 83.2 235.5 193.5l15.7-3.1C548.1 88.8 444.4 0 320 0S91.9 88.8 68.8 206.5l15.7 3.1C106.1 99.2 203.4 16 320 16zM259.3 488.3l-4 15.5c20.7 5.4 42.4 8.3 64.7 8.3s44.1-2.9 64.7-8.3l-4-15.5c-19.4 5-39.7 7.7-60.7 7.7s-41.3-2.7-60.7-7.7zM256 364.5V338.4v-20-16H240 200 184v12.3l-57.4-57.4-11.3-11.3L104 234.7 92.7 246.1 72 266.7l-4.7-4.7L56 250.7 44.7 262.1 22.1 284.7 10.7 296l11.3 11.3 4.7 4.7L6.1 332.7 0 338.7v10.5l6.1 6.1 11.3 11.3 9.4 9.4L6.1 396.7 0 402.7v10.5l6.1 6.1 11.3 11.3 48.8 48.8c20.7 20.7 48.8 32.4 78.2 32.6h.9c61.2-.2 110.7-49.9 110.7-111.2V388v-4.8c18.1 10.1 39.4 16.8 64 16.8s45.9-6.6 64-16.8V388v12.8c0 61.3 49.5 110.9 110.7 111.2h.9c29.3-.1 57.4-11.8 78.2-32.6l48.8-48.8 11.3-11.3 6.1-6.1V402.7l-6.1-6.1L613.3 376l9.4-9.4 11.3-11.3 6.1-6.1V338.7l-6.1-6.1L613.3 312l4.7-4.7L629.3 296l-11.3-11.3-22.6-22.6L584 250.7l-11.3 11.3-4.7 4.7-20.7-20.7L536 234.7l-11.3 11.3-11.3 11.3L456 314.7V302.4H440 400 384v16 20 26.1c-17.7 11.6-39 19.5-64 19.5s-46.3-7.9-64-19.5zm-56.3-139c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9zm175.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9c2.5-13.5 7.8-28.4 15.2-39.8zM128 345.4l11.3 11.3 9.4-9.4L137.4 336 92.7 291.3 81.4 280l1.9-1.9 9.4-9.4L104 257.4l11.3 11.3L184 337.4l1 1 15 15v-15-4-3.7V318.4h16 8 16v16 4V368v20 12.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L28.7 419.3 17.4 408l11.3-11.3 9.4-9.4 1.9-1.9 11.3 11.3L64 409.4l11.3 11.3 9.4-9.4L73.4 400 60.7 387.3 49.4 376 38.1 364.7l-9.4-9.4L17.4 344l11.3-11.3 9.4-9.4 1.9-1.9 11.3 11.3L96 377.4l11.3 11.3 9.4-9.4L105.4 368 60.7 323.3 49.4 312l-4.7-4.7-6.6-6.6L33.4 296l11.3-11.3L56 273.4l4.7 4.7 6.6 6.6 4.7 4.7 11.3 11.3L128 345.4zm384 0l44.7-44.7L568 289.4l4.7-4.7 6.6-6.6 4.7-4.7 11.3 11.3L606.6 296l-4.7 4.7-6.6 6.6-4.7 4.7-11.3 11.3L534.6 368l-11.3 11.3 9.4 9.4L544 377.4l44.7-44.7L600 321.4l1.9 1.9 9.4 9.4L622.6 344l-11.3 11.3-9.4 9.4L590.6 376l-11.3 11.3L566.6 400l-11.3 11.3 9.4 9.4L576 409.4l12.7-12.7L600 385.4l1.9 1.9 9.4 9.4L622.6 408l-11.3 11.3-48.8 48.8C544.7 486 520.4 496 495.2 496c-52.6 0-95.2-42.6-95.2-95.2V388 368 338.4v-4-16h16 8 16v12.3 3.7 4 15l15-15 1-1 68.7-68.7L536 257.4l11.3 11.3 9.4 9.4 1.9 1.9-11.3 11.3L502.6 336l-11.3 11.3 9.4 9.4L512 345.4z'
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fast',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      'M352 80H264v80H384l64 32 160-32 32 32L432 416H384 112 96V400 345.1L0 304V176 160H16 96h16H248V80l-88 0V64H352V80zM96 176H16V293.4l80 34.3V176zm349.8 32.8l-4.9-2.5L380.2 176H112V334.6 352v48H384h41L617.8 192.4l-15-15L451.1 207.7l-5.4 1.1zM624 400c0-4.7-1.9-12.2-6.2-22.2c-4.1-9.6-9.7-19.9-15.5-29.6c-3.5-5.9-7.1-11.4-10.3-16.3c-3.2 4.9-6.8 10.4-10.3 16.3c-5.8 9.7-11.4 20-15.5 29.6c-4.3 10-6.2 17.5-6.2 22.2c0 17.7 14.3 32 32 32c10.1 0 18-3 23.1-7.8c4.9-4.5 8.9-12 8.9-24.2zm-80 0c0-22.7 24.2-61.6 38.2-82.2C588 309.4 592 304 592 304s4 5.4 9.8 13.8c14 20.6 38.2 59.5 38.2 82.2c0 32-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fast',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      'M0 512L0 0 16 0l0 512L0 512zM112 208l384 0 0-128L112 80l0 128zM96 80l0-16 16 0 384 0 16 0 0 16 0 128 0 16-16 0-384 0-16 0 0-16L96 80zm16 352l256 0 0-128-256 0 0 128zM96 304l0-16 16 0 256 0 16 0 0 16 0 128 0 16-16 0-256 0-16 0 0-16 0-128z'
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fast',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      'M264 8V0H248V8 48.2c-51.4 1.9-98 22.5-133.3 55.2L86.3 75l-5.7-5.7L69.3 80.6 75 86.3l28.4 28.4C70.7 150 50.1 196.6 48.2 248H8 0v16H8 48.2c1.9 51.4 22.5 98 55.2 133.3L75 425.7l-5.7 5.7 11.3 11.3 5.7-5.7 28.4-28.4c35.3 32.7 81.9 53.3 133.3 55.2V504v8h16v-8V463.8c51.4-1.9 98-22.5 133.3-55.2L425.7 437l5.7 5.7 11.3-11.3-5.7-5.7-28.4-28.4c32.7-35.3 53.3-81.9 55.2-133.3H504h8V248h-8H463.8c-1.9-51.4-22.5-98-55.2-133.3L437 86.3l5.7-5.7L431.4 69.3 425.7 75l-28.4 28.4C362 70.7 315.4 50.1 264 48.2V8zM248 64.2v96.2c-20.5 1.7-39.2 9.8-54 22.4l-68-68c32.4-29.8 75-48.6 122-50.5zm16 96.2V64.2c47 1.9 89.6 20.7 122 50.5l-68 68c-14.8-12.5-33.5-20.7-54-22.4zM329.3 194l68-68c29.8 32.4 48.6 75 50.5 122H351.7c-1.7-20.5-9.8-39.2-22.4-54zm22.4 70h96.2c-1.9 47-20.7 89.6-50.5 122l-68-68c12.5-14.8 20.7-33.5 22.4-54zM199.5 199.4A80 80 0 1 1 312.5 312.6 80 80 0 1 1 199.5 199.4zM264 351.7c20.5-1.7 39.2-9.8 54-22.4l68 68c-32.4 29.8-75 48.6-122 50.5V351.7zm-16 0v96.2c-47-1.9-89.6-20.7-122-50.5l68-68c14.8 12.5 33.5 20.7 54 22.4zM114.7 386c-29.8-32.4-48.6-75-50.5-122h96.2c1.7 20.5 9.8 39.2 22.4 54l-68 68zM64.2 248c1.9-47 20.7-89.6 50.5-122l68 68c-12.5 14.8-20.7 33.5-22.4 54H64.2z'
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fast',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.7-332.7L328 168l-11.3-11.3L304 144H160 144v16V304l12.7 12.7L168 328l11.3-11.3 25.4-25.4L216 280l11.3 11.3 73.4 73.4L312 376l11.3-11.3 41.4-41.4L376 312l-11.3-11.3-73.4-73.4L280 216l11.3-11.3 25.4-25.4zm-48 48L353.4 312 312 353.4l-84.7-84.7L216 257.4l-11.3 11.3L168 305.4l-8-8V160H297.4l8 8-36.7 36.7L257.4 216l11.3 11.3z'
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fast',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      'M400 144V128c0-44.2-35.8-80-80-80c-16.1 0-31.1 4.8-43.7 12.9l-12.9 8.4-8.9-12.6C237.1 32.1 208.4 16 176 16c-53 0-96 43-96 96v21.5 11.3l-10.7 3.8C38.2 159.5 16 189.2 16 224v80H96 416h80V224c0-44.2-35.8-80-80-80H400zM16 320H0V304 224c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96c53 0 96 43 96 96v80 16H496 416 96 16zM32 464a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16A32 32 0 1 1 0 480a32 32 0 1 1 64 0zm144 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352h16L73.6 416h-16L96 352zm96 0h16L112 512H96l96-160zm112 0l-38.4 64h-16L288 352h16zm80 0h16L304 512H288l96-160zm96 0h16l-38.4 64h-16L480 352z'
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fast',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      'M331.3 32H336 568h8V48h-8H340.7L247 219.8l-2.3 4.2H240 8 0V208H8 235.3L329 36.2l2.3-4.2zM155.6 304H8 0V288H8 568h8v16h-8H174.6L276.4 464H568h8v16h-8H272h-4.4l-2.4-3.7L155.6 304z'
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fast',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 80H448V96H0V80zM64 240H512v16H64V240zM448 400v16H0V400H448z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fast',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      'M88.7 138l113.3 30.2 5.9 1.6V176 301l16 2.8 16-2.8V176v-6.1l5.9-1.6L359.3 138c-.3-3.4-.8-6.7-1.4-10H352 224 96 90.1c-.6 3.3-1.1 6.7-1.4 10zM94 112h2H224 352h2c-17.2-55.9-69.1-96-130-96s-112.9 40.1-130 96zM368.4 278.6l-6.5-101.5c-1.2 .5-2.7 1.1-4.4 1.9c-5.3 2.5-12.7 6.6-20.5 12.8c-15.6 12.3-33.3 32.8-41.2 66l-1.9 7.8-15.6-3.7 1.9-7.8c8.9-37.3 29-60.7 46.9-74.8c8.9-7 17.3-11.7 23.5-14.7c3.1-1.5 5.7-2.5 7.5-3.2c.9-.3 1.6-.6 2.2-.8l.5-.2-.4-6.2L256 182.1v116l112.4-19.6zM80 278.1l112 20v-116L87.6 154.3l-.5 7.8c1.6 .6 3.6 1.5 5.8 2.6c6.2 3 14.6 7.7 23.5 14.7c17.9 14.1 38 37.6 46.9 74.8l1.9 7.8-15.6 3.7-1.9-7.8c-7.9-33.1-25.6-53.7-41.2-66c-7.8-6.2-15.2-10.3-20.5-12.8l0 0-6 92.7v6.4zM224 320l-1.4-.2 0 .1-25.2-4.5L62.7 291.9 64 271.2V8 0h8H96h8V16H96 80v87.3C100.4 42.9 157.4 0 224 0c80.1 0 146.5 62.2 151.7 142.2l9.7 149.7L224 320zM59.9 368L21.5 496H132.7l85.7-85.7 5.7-5.7 5.7 5.7L315.3 496H426.5L388.1 368H59.9zM292.7 496L224 427.3 155.3 496H292.7zM400 352l43.2 144 4.8 16H431.3 16.7 0l4.8-16L48 352H400z'
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fast',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      'M40 32H32v8V200v3.3l2.3 2.3 53.5 53.5L80.9 384h16L104 256.4l.2-3.6-2.5-2.5L48 196.7V48h64V96v8h8 64 8V96 48h64V96v8h8 64 8V96 48h64V196.7l-53.7 53.7-2.5 2.5 .2 3.6L351.1 384h16l-6.9-124.9 53.5-53.5 2.3-2.3V200 40 32h-8H328h-8v8V88H272V40 32h-8H184h-8v8V88H128V40 32h-8H40zM184 216v64 8h8 64 8v-8V216c0-22.1-17.9-40-40-40s-40 17.9-40 40zm40-24c13.3 0 24 10.7 24 24v56H200V216c0-13.3 10.7-24 24-24zM48 496V475.5L87.1 432H360.9L400 475.5V496H48zm-16 0v16H48 400h16V496 469.3L368 416H80L32 469.3V496z'
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fast',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      'M417.2 5.9L411.5 .2 400.2 11.5l5.7 5.7 10.5 10.5L318.1 126c-45.8-19.1-100.6-10-137.9 27.3L11.3 322.2 0 333.5l11.3 11.3L167.2 500.7 178.5 512l11.3-11.3L358.7 331.8c37.3-37.3 46.4-92.1 27.3-137.9l98.3-98.3 10.5 10.5 5.7 5.7 11.3-11.3-5.7-5.7-89-89zM473 84.3L412.3 145 367 99.7 427.7 39 473 84.3zM355.7 111L401 156.3l-26.3 26.3-7.6 7.6 4.1 9.9c16.7 40 8.7 87.9-23.8 120.4l-7.8 7.8L183.7 172.4l7.8-7.8c32.5-32.5 80.4-40.5 120.4-23.8l9.9 4.1 7.6-7.6L355.7 111zM172.4 183.7L328.3 339.6l-84.7 84.7L87.7 268.4l84.7-84.7zm-96 96L232.3 435.6l-53.8 53.8L22.6 333.5l53.8-53.8z'
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fast',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      'M77.9 464H434.1L493.6 48H18.4L77.9 464zM448 480H64L2.3 48 0 32H16.2 495.8 512l-2.3 16L448 480zM255.4 195.3L242.7 208H112V368h89.8l16 16H112 96V368 208 192h16H258.9c-1.2 1.1-2.4 2.2-3.5 3.3zM312 206.6L210.2 308.5 312 410.3 413.8 308.5 312 206.6zm0-22.6l11.3 11.3L425.1 297.1l11.3 11.3-11.3 11.3L323.3 421.6 312 432.9l-11.3-11.3L198.9 319.8l-11.3-11.3 11.3-11.3L300.7 195.3 312 184z'
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fast',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      'M112 48A32 32 0 1 0 48 48a32 32 0 1 0 64 0zM32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zm480 0V176H624V48H512zm-16 0H240V176H496V48zM224 32h16H624h16V48 176v16H624 240 224V176 48 32zM384 336V464H624V336H384zm-16 0H240V464H368V336zM224 320h16H624h16v16V464v16H624 240 224V464 336 320zM112 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm11.5 96L22.2 496H137.8l-21.3-64H43.5zM128 416l26.7 80 5.3 16H143.1 16.9 0l5.3-16L32 416h96zM22.2 208H137.8l-21.3-64H43.5L22.2 208zM32 128h96l26.7 80 5.3 16H143.1 16.9 0l5.3-16L32 128z'
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fast',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      'M160 0h8H472h8V8 96H632h8v8V504v8h-8H416v0H384h-8H264h-8H224v0H8 0v-8V104 96H8 160V8 0zm16 16V96v16V496h80V360v-8h8H376h8v8V496h80V336 112 96 16H176zm448 96H480V336 496H624V304H520h-8V288h8H624V208H520h-8V192h8H624V112zm-464 0H16v80H120h8v16h-8H16v80H120h8v16h-8H16V496H160V112zM368 496V368H272V496h96zM296 56h48 8v8V96h32 8v8 48 8h-8H352v32 8h-8H296h-8v-8V160H256h-8v-8V104 96h8 32V64 56h8zm8 48v8h-8H264v32h32 8v8 32h32V152v-8h8 32V112H344h-8v-8V72H304v32z'
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fast',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M374.6 80l-4.7-4.7L331.9 37.3C318.3 23.6 299.8 16 280.6 16C240.5 16 208 48.5 208 88.6c0 19.2 7.6 37.7 21.3 51.3l38.1 38.1 4.7 4.7v6.6 76.1l32 32L489.4 112l-32-32H381.3h-6.6zM464 64l36.7 36.7L512 112l-11.3 11.3L315.3 308.7 304 320l-11.3-11.3L256 272V189.3l-25-25-94.1 94.1L198.2 496H376h8v16h-8H192 8 0V496H8 181.7L120.3 258l-1.1-4.4 3.2-3.2L219.7 153l-1.8-1.8C201.3 134.6 192 112.1 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9L381.3 64H464zM386 280.5l12-12c5.6 2.3 11.6 3.5 18 3.5c26.5 0 48-21.5 48-48c0-6.4-1.2-12.4-3.5-18l12-12c4.8 9 7.5 19.2 7.5 30c0 35.3-28.7 64-64 64c-10.9 0-21.1-2.7-30-7.5z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fast',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      'M256 396.6L16 231.6V200l48-36v61.7l16 11V80H432V236.7l16-11V164l48 36v31.6l-240 165zM64 80v64L0 192v48V496v16H16 496h16V496 240 192l-64-48V80 64H432 341.3L256 0 170.7 64H80 64V80zM256 20l58.7 44H197.3L256 20zm0 396L496 251V496H16V251L256 416zM168 160h-8v16h8H344h8V160h-8H168zm0 80h-8v16h8H344h8V240h-8H168z'
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fast',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm144 96h8H256h8v8 43.3c0 15.6-7.6 30.2-20.3 39.2l-37.5 26.4 69.6 72.5 45.9-58.4 4.9-6.3 12.6 9.9-4.9 6.3L287 329.1 339.7 384H317.5L277 341.8l-30.7 39.1-2.4 3.1H240 224 120h-8v-8V329.2c0-23.4 11.4-45.3 30.5-58.8l39.3-27.7-22.2-23.1c-10-10.4-15.6-24.3-15.6-38.8V136v-8zm51 105.3l39.4-27.8c8.5-6 13.5-15.7 13.5-26.1V144H160v36.7c0 10.3 4 20.2 11.1 27.7L195 233.3zm-2 21l-41.3 29.1C136.8 293.9 128 311 128 329.2V368H236.1l29.7-37.8L193 254.3z'
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fast',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 352a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-22.2-11.3-41.7-28.4-53.2l83.6-167.2 3.6-7.2-14.3-7.2-3.6 7.2L277.2 291.6c-6.6-2.3-13.8-3.6-21.2-3.6c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM160 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fast',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM352 384v16H96V384H352zM128 116.7l5.7 5.7 64 64 5.7 5.7L192 203.3l-5.7-5.7L136 147.3V312v8H120v-8V147.3L69.7 197.7 64 203.3 52.7 192l5.7-5.7 64-64 5.7-5.7zm192 0l5.7 5.7 64 64 5.7 5.7L384 203.3l-5.7-5.7L328 147.3V312v8H312v-8V147.3l-50.3 50.3-5.7 5.7L244.7 192l5.7-5.7 64-64 5.7-5.7z'
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fast',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      'M16.6 78.8C21 54.3 37 36.8 61.5 26.5c24.8-10.4 58.2-13.3 95.6-7.5c11.6 1.8 47.2 8.6 58.8 11.6l4-15.5c-12.4-3.2-48.5-10.1-60.4-11.9c-39.3-6-75.8-3.3-104.2 8.6C26.7 23.7 6.3 45.3 .8 76.2l0 0-.1 .4c-2.2 18.5 .5 34.2 7.3 47.5c6.8 13.2 17.4 23.5 29.9 31.8c7.3 4.8 15.4 9.1 24 12.9c-2 .7-4 1.4-5.9 2.2C27.7 182.4 7.2 202.9 1.7 232.4c0 .1-.1 .3-.1 .4c-2.2 17.7 .5 32.7 7.4 45.4c6.8 12.6 17.4 22.4 29.9 30.2c23.8 15 56.3 24.1 87.2 32.7l2.9 .8c32.6 9.1 63.1 17.9 84.1 32.3c10.3 7.1 17.9 15.2 22.4 25c4.4 9.7 6 21.8 3.1 37.2c-4.3 23-20 39.6-44.6 49.4c-24.8 9.9-58.1 12.6-95.4 7.1c-18.9-2.9-50.7-13-74.5-20.5l0 0 0 0 0 0c-5-1.6-9.6-3.1-13.7-4.3L5.6 483.6c3.8 1.2 8.2 2.6 13 4.1l0 0 0 0c23.6 7.5 57.2 18.2 77.5 21.3l0 0c39.1 5.7 75.5 3.1 103.7-8.1c28.4-11.4 48.9-31.8 54.4-61.4c3.4-18.1 1.7-33.6-4.3-46.8c-6-13.1-15.9-23.4-27.9-31.6c-3.7-2.6-7.7-4.9-11.9-7.2c23-12.6 39.3-32.3 44.1-59.5c3.3-19 1.7-35.1-4.3-48.9c-5.9-13.8-15.8-24.5-27.9-33.2c-23.7-17.1-57.2-27.1-89.2-36.5l-1.6-.5c-32.2-9.5-62.7-18.4-84.6-33c-10.9-7.3-19.3-15.7-24.5-25.8c-5.1-10-7.5-22.3-5.7-38.1zM191.3 345.3c-18.2-7.4-38.4-13.1-58-18.5l-1.5-.4c-32-9-62.6-17.5-84.4-31.2c-10.9-6.9-19.2-14.8-24.3-24.3c-5.1-9.4-7.4-20.9-5.6-35.6c4.3-22.8 20.1-39.4 44.6-49.2c7.7-3.1 16.3-5.5 25.6-7.1c12.4 4.3 25.3 8 37.9 11.7l2.9 .9c32.7 9.6 63.3 18.9 84.4 34.1c10.3 7.4 18 16.1 22.5 26.5c4.5 10.4 6.1 23.3 3.2 39.8c-4.4 25.1-21.3 43.3-47.2 53.5z'
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fast',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm224 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-80 96v64c0 44.2 35.8 80 80 80s80-35.8 80-80V224c0-44.2-35.8-80-80-80s-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fast',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      'M16 464H496V322l-.5-2H388.9l-29.8 59.6-2.2 4.4H352 160h-4.9l-2.2-4.4L123.1 320H16.5l-.5 2V464zM491.5 304l-64-256H84.5l-64 256H128h4.9l2.2 4.4L164.9 368H347.1l29.8-59.6 2.2-4.4H384 491.5zM0 464V320L72 32H440l72 288V464v16H496 16 0V464z'
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fast',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      'M256 496C123.5 496 16 388.5 16 256c0-37.6 8.6-73.1 24-104.7V184v1.3l.4 1.2 32 96 1.8 5.5H80 208h5.8l1.8-5.5 32-96 .4-1.2V184v-8h16v16 1.4l.5 1.3 32 88 1.9 5.3H304 432h5.6l1.9-5.3 32-88 .5-1.3V192 151.3c15.4 31.7 24 67.2 24 104.7c0 132.5-107.5 240-240 240zm8-336H248V136v-8h-8H52.9C95.5 60.7 170.5 16 256 16s160.5 44.7 203.1 112H272h-8v8 24zm16 0V144H380.7l-50.3 50.3L336 208h44.7l-64 64h-7.1L280 190.6V176 160zm123.3-16H456v46.6L426.4 272H339.3l66.3-66.3L400 192H355.3l48-48zM232 144v16 16 6.7L202.2 272H115.3l66.3-66.3L176 192H131.3l48-48H232zm-75.3 64l-64 64H85.8L56 182.7V144H156.7l-50.3 50.3L112 208h44.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-96c56.7 0 96.1-35.4 118.6-67.4l-13.1-9.2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6l-13.1 9.2c22.4 32 61.9 67.4 118.6 67.4z'
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fast',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      'M288 104V96H144V16H288V0H144 128V16 96v8 8V272L38.4 339.2 48 352l89.6-67.2L144 280v-8V112H288v-8zM38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-2.6-4.8-4.9-9.8-6.8-14.9L144 480c-13.8 10.4-30.7 16-48 16c-44.2 0-80-35.8-80-80c0-25.2 11.9-48.9 32-64l-9.6-12.8zM336 112H496V360L336 480c-13.8 10.4-30.7 16-48 16c-44.2 0-80-35.8-80-80c0-25.2 11.9-48.9 32-64l89.6-67.2L336 280v-8V112zM320 272l-89.6 67.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2L512 368V112v-8V96 16 0H496 336 320V16 96v8 8V272zM336 96V16H496V96H336z'
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fast',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      'M16 48v57.6H73.6V48H16zm0 119.5v57.6H73.6V167.5H16zM0 270.9H16 73.6h16v16 57.6 16h-16H16 0v-16V286.9v-16zm73.6 73.6V286.9H16v57.6H73.6zM16 406.4V464H73.6V406.4H16zM89.6 32V48v57.6 16h-16H16 0v-16V48 32H16 73.6h16zm0 119.5v16 57.6 16h-16H16 0v-16V167.5v-16H16 73.6h16zm0 238.9v16V464v16h-16H16 0V464 406.4v-16H16 73.6h16zM135.5 48v57.6h57.6V48H135.5zm0 119.5v57.6h57.6V167.5H135.5zm-16 103.5h16 57.6 16v16 57.6 16h-16H135.5h-16v-16V286.9v-16zm73.6 73.6V286.9H135.5v57.6h57.6zm-57.6 61.9V464h57.6V406.4H135.5zM209.1 32V48v57.6 16h-16H135.5h-16v-16V48 32h16 57.6 16zm0 119.5v16 57.6 16h-16H135.5h-16v-16V167.5v-16h16 57.6 16zm0 238.9v16V464v16h-16H135.5h-16V464 406.4v-16h16 57.6 16zM312.5 48H254.9v57.6h57.6V48zm0 119.5H254.9v57.6h57.6V167.5zM238.9 286.9v-16h16 57.6 16v16 57.6 16h-16H254.9h-16v-16V286.9zm16 57.6h57.6V286.9H254.9v57.6zm57.6 61.9H254.9V464h57.6V406.4zm0-374.4h16V48v57.6 16h-16H254.9h-16v-16V48 32h16 57.6zm0 119.5h16v16 57.6 16h-16H254.9h-16v-16V167.5v-16h16 57.6zm0 238.9h16v16V464v16h-16H254.9h-16V464 406.4v-16h16 57.6zM374.4 48v57.6H432V48H374.4zm0 119.5v57.6H432V167.5H374.4zm-16 103.5h16H432h16v16 57.6 16H432 374.4h-16v-16V286.9v-16zM432 344.5V286.9H374.4v57.6H432zm-57.6 61.9V464H432V406.4H374.4zM448 32V48v57.6 16H432 374.4h-16v-16V48 32h16H432h16zm0 119.5v16 57.6 16H432 374.4h-16v-16V167.5v-16h16H432h16zm0 238.9v16V464v16H432 374.4h-16V464 406.4v-16h16H432h16z'
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fast',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      'M16 112V400H512V320 304 208 192 112H16zM528 320v80 16H512 16 0V400 112 96H16 512h16v16 80h32 16v16 96 16H560 528zm0-112v96h32V208H528z'
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fast',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      'M328 8V0H312V8 108.7L261.7 58.3 256 52.7 244.7 64l5.7 5.7L312 131.3V242.1l-96-55.4-22.6-84.2-2.1-7.7-15.5 4.1 2.1 7.7 18.4 68.8-80.3-46.3-6.9-4-8 13.9 6.9 4 80.3 46.3-68.8 18.4-7.7 2.1 4.1 15.5 7.7-2.1L208 200.6 304 256l-96 55.4-84.2-22.6-7.7-2.1-4.1 15.5 7.7 2.1 68.8 18.4-62.2 35.9 7.3 14.2 62.8-36.3L178 405.4l-2.1 7.7 15.5 4.1 2.1-7.7L216 325.3l96-55.4V380.7l-61.7 61.7-5.7 5.7L256 459.3l5.7-5.7L312 403.3V504v8h16v-8V403.3l50.3 50.3 5.7 5.7L395.3 448l-5.7-5.7L328 380.7V269.9l96 55.4 22.6 84.2 2.1 7.7 15.5-4.1-2.1-7.7-18.4-68.8 62.8 36.3 7.3-14.2-62.2-35.9 68.8-18.4 7.7-2.1-4.1-15.5-7.7 2.1L432 311.4 336 256l96-55.4 84.2 22.6 7.7 2.1 4.1-15.5-7.7-2.1-68.8-18.4 80.3-46.3 6.9-4-8-13.9-6.9 4-80.3 46.3L462 106.6l2.1-7.7-15.5-4.1-2.1 7.7L424 186.7l-96 55.4V131.3l61.7-61.7 5.7-5.7L384 52.7l-5.7 5.7L328 108.7V8zM576 352.2l41.8 73.1c4.1 7.1 6.2 15.2 6.2 23.4c0 26.1-21.1 47.2-47.2 47.2h-1.6c-26.1 0-47.2-21.1-47.2-47.2c0-8.2 2.1-16.3 6.2-23.4L576 352.2zm-9.2-16.1l-46.5 81.3c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4l-46.5-81.3L576 320l-9.2 16.1zM22.2 425.4L64 352.2l41.8 73.1c4.1 7.1 6.2 15.2 6.2 23.4c0 26.1-21.1 47.2-47.2 47.2H63.2C37.1 496 16 474.9 16 448.8c0-8.2 2.1-16.3 6.2-23.4zM8.3 417.4C2.9 427 0 437.8 0 448.8C0 483.7 28.3 512 63.2 512h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L73.2 336.1 64 320l-9.2 16.1L8.3 417.4z'
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fast',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      'M196.6 42.8c9.6 52.1 41.6 95.2 77.7 128.2c1.9 1.7 3.8 3.4 5.7 5.1l0-21.6c-36.3-34.5-65.6-78.5-69.8-130.8c-.6-7.6-.7-15.4-.2-23.3c-4.1 3.6-9.7 9.7-16.2 18.3c-12.6 16.8-28.3 43.2-41.4 78.9c3.7 5 7.7 9.8 11.9 14.4c9.9-29.3 21.7-52.4 32.2-69.1zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM87.8 38.4L84.1 19.5 73.3 35.6 73 36l0 0-.1 .1-.2 .3-1.1 1.7v0C59.5 56.4 32 100.6 32 176c0 111.4 81.5 170.2 126.7 195.7L11.3 432.6 .1 437.2l8.7 8.5 65.6 64 2.3 2.3H80h72 2.7l2.2-1.7 81-62.3H328c83.9 0 152-68.1 152-152V137.6l26.6-62.5L511.3 64H499.2 392c-39.8 0-72 32.2-72 72v72h-7.7c-31-2.6-81.3-14.4-126.7-40.9c-45.5-26.6-85.6-67.6-97.8-128.7zM48 176c0-56.7 16.4-94.3 28.8-115.9c17.2 56.7 57.3 95.4 100.8 120.8c48 28 100.8 40.3 133.8 43.1l.3 0h.3 16 8v-8V136c0-30.9 25.1-56 56-56h95.1l-22.5 52.9-.6 1.5V136 296c0 75.1-60.9 136-136 136H235.2h-2.7l-2.2 1.7-81 62.3h-66L28.7 442.8l151.7-62.7 16-6.6L181 365.5C142.6 345.9 48 291.2 48 176z'
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fast',
    iconName: 'hand-back-point-right',
    icon: [
      512,
      512,
      [],
      'e1a1',
      
      'M512 128l0-8-8 0-224 0-8 0-7.4 0L206.1 50.8 203.7 48 200 48l-53.7 0C97.5 48 52.4 74.2 28.2 116.5l-10.3 18C6.2 155.1 0 178.3 0 202L0 344c0 57.4 46.6 104 104 104l16 0 88 0 48 0 8 0 0-8 0-56 24 0 8 0 0-8 0-64 24 0 8 0 0-8 0-80 176 0 8 0 0-8 0-88zm-268.3-8L168 120l-8 0 0 16 8 0 89.2 0 3.7 0 11.1 0 8 0 216 0 0 72-176 0-8 0 0 8 0 80-24 0-8 0 0 8 0 64-24 0-8 0 0 8 0 56-40 0-88 0-16 0c-48.6 0-88-39.4-88-88l0-142c0-20.9 5.4-41.4 15.8-59.5l10.3-18C63.5 87.1 103.2 64 146.3 64l50 0 47.4 56z'
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fast',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      'M256 16c-39.4 0-74.1 20.4-94.1 51.2l-5.1 7.9-7-6.3C135.6 55.9 116.7 48 96 48c-44.2 0-80 35.8-80 80c0 7.5 1 14.7 2.9 21.6l.1 .2 0 .2c6.9 31.6 23.8 79.1 39.3 119.1C66 289.1 73.3 307 78.6 320c2.7 6.5 4.9 11.7 6.4 15.3l.3 .7h65.1L120.1 169.4l-1.4-7.9 15.7-2.9 1.4 7.9L166.7 336H248V136v-8h16v8V336h81.3l30.8-169.4 1.4-7.9 15.7 2.9-1.4 7.9L361.6 336h65.1l.3-.7c1.5-3.6 3.7-8.8 6.4-15.3c5.3-12.9 12.6-30.9 20.3-50.8c15.4-40 32.4-87.6 39.3-119.1l.1-.2 .1-.2c1.9-6.9 2.9-14.1 2.9-21.6c0-44.2-35.8-80-80-80c-20.7 0-39.6 7.9-53.8 20.8l-7 6.3-5.1-7.9C330.1 36.4 295.4 16 256 16zM432 344l7.4 3.2-2.1 4.8H432 80 74.7l-2.1-4.8L80 344c-7.4 3.2-7.4 3.2-7.4 3.1l0 0 0 0 0-.1-.1-.3-.5-1.1-1.8-4.2c-1.5-3.6-3.7-8.9-6.4-15.4c-5.4-13-12.7-31.1-20.4-51.1C28 235.1 10.7 186.6 3.5 153.7C1.2 145.5 0 136.9 0 128C0 75 43 32 96 32c21.6 0 41.6 7.1 57.6 19.2C176.9 20.1 214.1 0 256 0s79.1 20.1 102.4 51.2c16-12 36-19.2 57.6-19.2c53 0 96 43 96 96c0 8.9-1.2 17.5-3.5 25.7c-7.2 32.9-24.6 81.4-39.9 121.3c-7.7 20.1-15 38.1-20.4 51.1c-2.7 6.5-4.9 11.8-6.4 15.4l-1.8 4.2-.5 1.1-.1 .3 0 .1 0 0 0 0s0 0-7.4-3.1zM64 384H80V496H432V384h16V496v16H432 80 64V496 384z'
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fast',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM136 96v56h80V96 88h16v8 56h80V96 88h16v8 56h56 8v16h-8H328v80h56 8v16h-8H328v80h56 8v16h-8H328v56 8H312v-8V360H232v56 8H216v-8V360H136v56 8H120v-8V360H64 56V344h8 56V264H64 56V248h8 56V168H64 56V152h8 56V96 88h16v8zm0 152h80V168H136v80zm96 0h80V168H232v80zm0 16v80h80V264H232zm-16 0H136v80h80V264z'
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fast',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      'M184.8 19.2l32.6 70.9 75.7-18.7 20.5-5.1-9.5 18.8L269 154.8l61.9 47.5 16.7 12.8L327 219.5l-76.4 16 1.4 78 .4 21.1-16.2-13.4L176 271.4l-60.1 49.7L99.6 334.6l.4-21.1 1.4-78L25 219.5 4.4 215.2l16.7-12.8L83 154.8 47.9 85.1 38.4 66.3l20.5 5.1 75.7 18.7 32.6-70.9L176 0l8.8 19.2zm36.4 86.4l-12.9 3.2-5.5-12L176 38.3 149.1 96.7l-5.5 12-12.9-3.2L68.4 90.2l28.9 57.4 6 11.8-10.5 8.1-51 39.2 62.9 13.2 13 2.7-.2 13.2-1.2 64.3 49.5-41 10.2-8.4 10.2 8.4 49.5 41-1.2-64.3-.2-13.2 13-2.7 62.9-13.2-51-39.2-10.5-8.1 6-11.8 28.9-57.4-62.4 15.4zM520 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 424 56zm-3.1 72H539.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L534.1 144H425.9L343.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5h5zM424 240v8V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H496h-8v-8V352H472V504v8h-8H416h-8v-8V248v-8h16z'
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fast',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      'M213.7 21.7l-32 32L176 59.3 164.7 48l5.7-5.7 32-32L208 4.7 219.3 16l-5.7 5.7zm192 0l-32 32L368 59.3 356.7 48l5.7-5.7 32-32L400 4.7 411.3 16l-5.7 5.7zM160 98.3L224 80c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6H270.6c.9-6.6 1.4-13.5 1.4-20.6c0-19.6-4.7-39.4-13.3-53.8c-8-13.3-18.8-20.9-32.6-21.6l-61.7 17.6-4.4 1.3-4.4-1.3L93.9 96.1c-13.8 .7-24.6 8.4-32.6 21.6C52.7 132 48 151.8 48 171.4c0 7.1 .5 14 1.4 20.6H33.2c-.8-6.7-1.2-13.5-1.2-20.6C32 127.8 52.4 80 96 80l64 18.3zM478.8 192H462.6c.9-6.6 1.4-13.5 1.4-20.6c0-19.6-4.7-39.4-13.3-53.8c-8-13.3-18.8-20.9-32.6-21.6l-61.7 17.6-4.4 1.3-4.4-1.3-43.2-12.3c-1.5-2.9-3-5.8-4.7-8.5c-2.5-4.1-5.2-8-8.3-11.8L352 98.3 416 80c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6zM496 376H16V496H496V376zm0-16V240H16V360H496zm16 0v8 8V496v16H496 16 0V496 376v-8-8V240 224H16 496h16v16V360zM64 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fast',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM205.7 368H232h8v16h-8H205.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H176h-8V496h8 34.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C176.1 433 168 419.9 168 405.7c0-20.8 16.9-37.7 37.7-37.7zM312 376v35c0 18.2 3.3 36.3 9.7 53.4L333.5 496h4.9l11.9-31.6c6.4-17.1 9.7-35.1 9.7-53.4V376v-8h16v8 35c0 20.1-3.6 40.1-10.7 59l-13.8 36.8-1.9 5.2H344 328h-5.5l-1.9-5.2L306.7 470c-7.1-18.9-10.7-38.8-10.7-59V376v-8h16v8zm112 24c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v16H488V400c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464h-8-8V448h8 16 8v8 24c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400z'
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fast',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      'M495.5 272C487.2 397.1 383.2 496 256 496C123.5 496 16 388.5 16 256c0-30 5.5-58.7 15.5-85.1l66.8 66.8 2.3 2.3H104h44.7L192 283.3V344v3.3l2.3 2.3L224 379.3V440v8h8 64 8v-8V395.3l61.7-61.7 2.3-2.3V328 248v-8h-8H235.3L208 212.7V192h72 8v-8V152v-3.3l-2.3-2.3L256 116.7v-9.4l29.7-29.7 2.3-2.3V72 18.1c70.4 9.4 131.2 49.3 168.6 106l-54.2 54.2-2.3 2.3V184v80 8h8 87.5zM465.1 138.2C484.8 173 496 213.2 496 256l-80 0V187.3l49.1-49.1zM256 16c5.4 0 10.7 .2 16 .5V68.7L242.3 98.3l-2.3 2.3V104v16 3.3l2.3 2.3L272 155.3V176H200h-8v8 32 3.3l2.3 2.3 32 32 2.3 2.3H232 352v68.7l-61.7 61.7-2.3 2.3V392v40H240V376v-3.3l-2.3-2.3L208 340.7V280v-3.3l-2.3-2.3-48-48-2.3-2.3H152 107.3L38.3 154.9C76.4 72.9 159.6 16 256 16zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fast',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      'M135.3 460.5L81 365.5l79.1-79.1 72.6 70.2L135.3 460.5zM72.8 351.1L18.4 256 137.3 48H374.7L493.6 256l-32 56.1-87.7-93.5-5.8-6.2-5.8 6.2L243.7 344.9l-78.1-75.5-5.7-5.5-5.6 5.6L72.8 351.1zm380.4-24.5L374.7 464H154L368 235.7l85.2 90.9zM128 32L0 256 128 480H384L512 256 384 32H128zm64 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fast',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      'M166.6 464H288h25.4L383 394.3 181.7 193 38.6 336l128 128zM288 480H160L27.3 347.3 16 336l11.3-11.3L324.7 27.3 336 16l11.3 11.3L548.7 228.7 560 240l-11.3 11.3L336 464H536h8v16h-8H320 288zm106.3-97l143-143L336 38.6l-143 143L394.3 383z'
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fast',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      'M496 256c0 132.5-107.5 240-240 240c-9 0-17.8-.5-26.6-1.5L225 510.1c10.2 1.2 20.5 1.9 31 1.9c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.5 .6 20.8 1.9 31l15.6-4.5C16.5 273.8 16 265 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240zM249.6 423.9c2.1 .1 4.2 .1 6.4 .1c92.8 0 168-75.2 168-168s-75.2-168-168-168S88 163.2 88 256c0 2.1 0 4.3 .1 6.4l15.9-4.5c0-.6 0-1.2 0-1.8c0-83.9 68.1-152 152-152s152 68.1 152 152s-68.1 152-152 152c-.6 0-1.2 0-1.8 0l-4.5 15.9zM278 324.6c29-9.3 50-36.5 50-68.6c0-39.8-32.2-72-72-72c-32.1 0-59.3 21-68.6 50l19.9-5.7C217 211.4 235.1 200 256 200c30.9 0 56 25.1 56 56c0 20.9-11.4 39-28.3 48.7L278 324.6zm-14.3-66.4l4-13.8-13.8 4-224 64L4.4 319.6l25.2 8.1 108.7 34.8L2.3 498.3l11.3 11.3L149.6 373.7l34.8 108.7 8.1 25.2 7.3-25.4 64-224zM59.6 320.4l184.8-52.8L191.6 452.4l-30.7-96-1.3-3.9-3.9-1.3-96-30.7z'
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fast',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      'M368 320c0-22.5-10.5-52.9-28.2-87.4c-17.5-34-41-70-64.8-103c-23.7-33-47.5-62.7-65.3-84.3c-6.9-8.3-12.9-15.4-17.7-21c-4.8 5.6-10.8 12.6-17.7 21c-17.8 21.5-41.6 51.3-65.3 84.3c-23.8 33-47.3 69-64.8 103C26.5 267.1 16 297.5 16 320c0 97.2 78.8 176 176 176s176-78.8 176-176zM0 320C0 229.1 141.1 58.9 181.4 12.1C188.1 4.4 192 0 192 0s3.9 4.4 10.6 12.1C242.9 58.9 384 229.1 384 320c0 106-86 192-192 192S0 426 0 320zm192 88v16c-57.4 0-104-46.6-104-104h16c0 48.6 39.4 88 88 88z'
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fast',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm410.9-26.9C372.8 186.7 317.5 160 256 160s-116.8 26.7-154.9 69.1L89.8 217.8C130.8 172.5 190.1 144 256 144s125.2 28.5 166.2 73.8l-11.3 11.3zM352 288l-11.4 11.4C321.7 273.1 290.8 256 256 256s-65.7 17.1-84.6 43.4L160 288c21.9-29.1 56.7-48 96-48s74.1 18.9 96 48zm-96 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fast',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      'M208 16H464V496H208V16zm-16 0V496H80V392h40 8V376h-8H80V264h40 8V248h-8H80V136h40 8V120h-8H80V16H192zM64 392V496v16H80 464h16V496 16 0H464 80 64V16 120H8 0v16H8 64V248H8 0v16H8 64V376H8 0v16H8 64z'
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zM240 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 16c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 23.7-8.6 45.3-22.8 62.1l44.4 44.4 5.7 5.7L352 395.5l-5.7-5.7-44.4-44.4C285.2 359.5 263.6 368 240 368z'
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fast',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      'M320 128V32s32-32 160-32S640 32 640 32v96L512 416H448L320 128zM602.9 31.2C580.9 23.8 542.7 16 480 16s-100.9 7.8-122.9 15.2c-10.3 3.4-17 6.7-21.1 9.1v84.3l2 4.6 4.2-1L344 136l-1.8-7.8 0 0 0 0 0 0 .2 0 .6-.1c.5-.1 1.3-.3 2.4-.5c2.1-.4 5.1-1.1 8.9-1.8c7.7-1.5 18.5-3.5 31.5-5.6c25.9-4 60.4-8.1 94.1-8.1s68.2 4.1 94.1 8.1c13 2 23.9 4 31.5 5.6c3.8 .8 6.8 1.4 8.9 1.8c1 .2 1.8 .4 2.4 .5l.6 .1 .2 0 0 0 0 0 0 0L616 136l1.8-7.8 4.2 1 2-4.6V40.3c-4-2.3-10.8-5.7-21.1-9.1zM344.6 144.1l52.6 118.4C421.4 259 451 256 480 256s58.6 3 82.8 6.4l52.6-118.3-1.1-.3 0 0 0 0 0 0-.1 0-.6-.1c-.5-.1-1.3-.3-2.3-.5c-2-.4-4.9-1-8.7-1.8c-7.5-1.5-18.1-3.5-30.9-5.4c-25.5-4-59-7.9-91.7-7.9s-66.2 3.9-91.7 7.9c-12.7 2-23.4 4-30.9 5.4c-3.7 .7-6.7 1.4-8.7 1.8c-1 .2-1.8 .4-2.3 .5l-.6 .1-.1 0 0 0 0 0 0 0-1.1 .3zM458.4 400h43.2L556 277.6c-22.8-3.1-49.7-5.6-76-5.6s-53.2 2.6-76 5.6L458.4 400zM67.9 398.8L0 330.9s0-45.3 90.5-135.8s135.8-90.5 135.8-90.5l67.9 67.9L407.3 466.7 362 511.9 67.9 398.8zM199.5 130.3c-20.7 10.4-53.3 31.9-97.7 76.2S36 283.4 25.6 304.1c-4.9 9.7-7.3 16.8-8.5 21.3l59.6 59.6 4.7 1.8 2.3-3.6 0-.1 .1-.1 .3-.5c.3-.5 .7-1.2 1.3-2c1.2-1.8 2.8-4.4 5-7.6c4.3-6.5 10.6-15.6 18.4-26.2c15.5-21.2 37-48.4 60.8-72.3s51.1-45.4 72.3-60.8c10.6-7.7 19.7-14 26.2-18.4c3.2-2.2 5.8-3.9 7.6-5c.9-.6 1.6-1 2.1-1.3l.5-.3 .1-.1 0 0 3.7-2.3-1.8-4.7-59.6-59.6c-4.5 1.2-11.6 3.6-21.3 8.5zM96.7 392.7l120.9 46.5c14.7-19.5 33.5-42.5 54-63s43.5-39.3 63-54L288.1 201.3l-1 .6 0 0-.1 .1-.5 .3c-.4 .3-1.1 .7-2 1.3c-1.7 1.1-4.2 2.7-7.4 4.9c-6.3 4.2-15.3 10.4-25.7 18c-20.8 15.2-47.3 36.2-70.4 59.2s-44 49.6-59.2 70.4c-7.6 10.4-13.7 19.3-18 25.7c-2.1 3.2-3.8 5.7-4.9 7.4c-.6 .9-1 1.5-1.3 2l-.3 .5-.1 .1 0 0-.6 1zM358.1 493.3l30.6-30.6-48.1-125c-18.3 13.9-39.1 31.2-57.7 49.8s-35.8 39.4-49.8 57.7l125 48.1z'
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fast',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm64-272H144v80h80V176v-8V128zm-80 96H128V208 128 112h16 80 16v16 40 8 32 16 48 5.5l-5.2 1.9-64 24-7.5 2.8-5.6-15 7.5-2.8L224 266.5V224H144zm224-96H288v80h80V176v-8V128zm-80 96H272V208 128 112h16 80 16v16 40 8 32 16 48 5.5l-5.2 1.9-64 24-7.5 2.8-5.6-15 7.5-2.8L368 266.5V224H288z'
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fast',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      'M232 8V0H216V8 64H80 64V80 304v16H80 368h16V304 80 64H368 232V8zM80 80H368V304H80V80zM32 128H16V256H32V128zm400 0H416V256h16V128zM232 232H216v48h16V232zM21.5 496L59.9 368H388.1l38.4 128H368V432 416H352 96 80v16 64H21.5zm409.8 16H448l-4.8-16L400 352H48L4.8 496 0 512H16.7 80 96 352h16 63.3zM280 232v48h16V232H280zm-128 0v48h16V232H152zM352 432v64H296V432h56zm-72 0v64H232V432h48zm-64 0v64H168V432h48zm-64 0v64H96V432h56zM128 116.7L116.7 128l5.7 5.7L148.7 160l-26.3 26.3-5.7 5.7L128 203.3l5.7-5.7L160 171.3l26.3 26.3 5.7 5.7L203.3 192l-5.7-5.7L171.3 160l26.3-26.3 5.7-5.7L192 116.7l-5.7 5.7L160 148.7l-26.3-26.3-5.7-5.7zm133.7 5.7l-5.7-5.7L244.7 128l5.7 5.7L276.7 160l-26.3 26.3-5.7 5.7L256 203.3l5.7-5.7L288 171.3l26.3 26.3 5.7 5.7L331.3 192l-5.7-5.7L299.3 160l26.3-26.3 5.7-5.7L320 116.7l-5.7 5.7L288 148.7l-26.3-26.3z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fast',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M197.8 469.5l-5.8 6-5.8-6-176-184-5.5-5.8 11.6-11.1 5.5 5.8L184 444.1V40 32h16v8V444.1L362.2 274.5l5.5-5.8 11.6 11.1-5.5 5.8-176 184z'
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fast',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      'M316.7 205.6l115.7 99.2c4.7-2.6 9.3-5.5 14.2-8.9l-107.3-92-12.2-10.4 11.3-11.3 6.1-6.1H456h24 16V160 112 96H480 456 328 311.4l-11.7 11.7-128 128L160 247.4V264v48.3c5.3 2 10.7 3.7 16 4.8V264v-9.9l7-7L311 119l7-7H328 456h24v48H456 344.6h-6.6l-4.7 4.7-17.5 17.5-12.2 12.2 13.1 11.2zM144 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128zm.6 107c-.2-.3-.4-.6-.6-.9c-.2 .3-.4 .6-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 385.8 22.5 400 0 400v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V400c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 385.8 406.5 400 384 400s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9c-.2 .3-.4 .6-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 385.8 214.5 400 192 400s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fast',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      'M352 80c0-44.2 35.8-80 80-80h72 3.3l2.3 2.3L547.3 40H568c39.8 0 72 32.2 72 72v72 8h-8H608h-4.7l-29.7 29.7-2.3 2.3H568 475.1l-51.5 47.7L468 297.1l4 2.3V304v32 8H456v-8V308.6l-44.7-25.5-.8 .8c-1.7-5.5-3.9-10.8-6.3-15.9l62.4-57.8 2.3-2.1H472h92.7l16-16H544h-3.3l-2.3-2.3L508.7 160H480h-8V144h8 32 3.3l2.3 2.3L547.3 176h49.4H600h8 16V112c0-30.9-25.1-56-56-56H544h-3.3l-2.3-2.3L500.7 16H432c-35.3 0-64 28.7-64 64v8 3.7l-2.8 2.4-56 48L307 144h-3H264c-66.3 0-120 53.7-120 120v24 8h-8H88 83.1l-2.2-4.4L36 201.9l-4.8 9.6c-10 20-15.2 42-15.2 64.3C16 348.8 75.2 408 148.2 408H208V360v-8h16v8 52.9L299.5 496H400V480c0-17.7-14.3-32-32-32h-8-6l-1.7-5.8-16-56-.9-3 1.4-2.8L368 318.2c-1-38.9-32.8-70.2-72-70.2h-8V232h8c48.6 0 88 39.4 88 88v1.9l-.8 1.7-30.6 61.2L366 432h2c26.5 0 48 21.5 48 48v24 8h-8H296h-3.5l-2.4-2.6L212.5 424H148.2C66.3 424 0 357.7 0 275.8c0-24.8 5.8-49.3 16.9-71.5l8-15.9 2.2-4.4H32h8 4.9l2.2 4.4L92.9 280H128V264c0-75.1 60.9-136 136-136h37l51-43.7V80zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fast',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      'M16 178.6C16 106.5 74.5 48 146.6 48H152c38.6 0 73.5 16.1 98.2 41.9l5.8 6 5.8-6C286.5 64.1 321.4 48 360 48h5.4C437.5 48 496 106.5 496 178.6c0 76.7-36.4 144.9-92.9 188.4l-6 4.6 4.3 6.3 11 15.9 18.2 26.3-52.6 36.4-18.2-26.3-16.2-23.4c0 0-.1-.1-.1-.1l-48.4-69.9c0 0-.1-.1-.1-.1l-32.5-46.9-6.6-9.5-6.6 9.5-32.6 47-7.1 10.2 12.2 2.2c10.2 1.9 20.7 2.8 31.4 2.8H256h2.6c8.9 0 17.7-.7 26.3-2l39.3 56.8c-20.8 6-42.8 9.2-65.6 9.2H256h-2.6c-26.5 0-52-4.3-75.8-12.4l-5.7-1.9-3.4 4.9-16.2 23.4L134 456.4 81.4 419.9l18.2-26.3 10.9-15.7c0 0 0 0 0-.1l4.3-6.3L151.3 319l4.9-7.1 0 0c0 0 0 0 0-.1L210.2 234c9-13 13.8-28.4 13.8-44.2V184c0-39.8-32.2-72-72-72h-5.4C109.8 112 80 141.8 80 178.6c0 51.9 22.8 98.5 58.9 130.2l-36.6 52.9C49.6 318.1 16 252.3 16 178.6zM146.6 32C65.6 32 0 97.6 0 178.6c0 79.2 36.3 149.9 93.1 196.3l-6.7 9.6L63.7 417.4 59.2 424l6.6 4.6 65.8 45.5 6.6 4.6 4.6-6.6 22.8-32.9 12.8-18.5c23.8 7.4 49 11.3 75.2 11.3H256h2.6c26.2 0 51.4-4 75.2-11.3l12.9 18.7 22.8 32.9 4.6 6.6 6.6-4.6 65.8-45.5 6.6-4.6-4.6-6.6-22.8-32.9-6.8-9.8C475.7 328.4 512 257.8 512 178.6C512 97.6 446.4 32 365.4 32H360c-40.2 0-76.8 15.6-104 41.1C228.8 47.6 192.2 32 152 32h-5.4zM96 178.6c0-27.9 22.7-50.6 50.6-50.6H152c30.9 0 56 25.1 56 56v5.7c0 12.6-3.8 24.8-11 35.1l-49 70.7C116.1 266.7 96 225 96 178.6zM304 184c0-30.9 25.1-56 56-56h5.4c27.9 0 50.6 22.7 50.6 50.6c0 46.4-20.1 88.2-52.1 117l-49-70.7c-7.1-10.3-11-22.6-11-35.1V184zm56-72c-39.8 0-72 32.2-72 72v5.7c0 15.8 4.8 31.2 13.8 44.2l54 78 4.9 7.1 6.7-5.4c39.4-31.8 64.6-80.5 64.6-135c0-36.8-29.8-66.6-66.6-66.6H360zM253.4 336c-5.4 0-10.7-.3-16-.8L256 308.3l18.6 26.9c-5.3 .5-10.6 .8-16 .8H256h-2.6z'
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fast',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      'M0 80C0 35.8 35.8 0 80 0h8 8V16H88 80C44.7 16 16 44.7 16 80V96h96 16v16 96 16H112 16 0V208 160 112 96 80zm16 32v48 48h96V112H16zM160 80c0-44.2 35.8-80 80-80h8 8V16h-8-8c-35.3 0-64 28.7-64 64V96h96 16v16 96 16H272 176 160V208 160 112 96 80zm16 80v48h96V112H176v48zM576 432c0 44.2-35.8 80-80 80h-8-8V496h8 8c35.3 0 64-28.7 64-64V416H464 448V400l0-96V288h16 96 16v16 48 48 16 16zm-16-32V352 304H464l0 96h96zM416 432c0 44.2-35.8 80-80 80h-8-8V496h8 8c35.3 0 64-28.7 64-64V416H304 288V400l0-96V288h16 96l16 0v16l0 48v48 16 16zm-16-80l0-48H304l0 96h96V352z'
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fast',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      'M8 67.1L371.6 248.8l4.4 2.2v9.9l-4.4 2.2L8 444.9V427.1L350.1 256 8 84.9V67.1z'
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fast',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M368 496V176H216h-8v-8V16H16V496H368zm-6.6-336L224 22.6V160H361.4zM16 0H224L384 160V496v16H368 16 0V496 16 0H16z'
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fast',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      'M256 16c61.9 0 112 50.1 112 112v8h16v-8C384 57.3 326.7 0 256 0S128 57.3 128 128v8h16v-8c0-61.9 50.1-112 112-112zM65.2 152.1l-6.2-.9L56.6 157 8.6 277l-3.4 8.4 8.7 2.3 210.7 56 5.5 1.5 3.2-4.7L320 211.7l86.7 128.8 3.2 4.7 5.5-1.5 210.7-56 8.7-2.3-3.4-8.4-48-120-2.3-5.9-6.2 .9L320 189.2 65.2 152.1zM26.8 274.6L69.1 168.8l237.2 34.6L223.2 326.8 26.8 274.6zM560 336.1v99.4l-232 58V296v-8H312v8V493.5l-232-58V336.1l-16-4.6V448l256 64 256-64V331.6l-16 4.6zm10.9-167.3l42.3 105.8L416.8 326.8l-83-123.4 237.2-34.6zM502.9 20.1l4.1-6.9L493.3 5l-4.1 6.9-72 120-4.1 6.9 13.7 8.2 4.1-6.9 72-120z'
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fast',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      'M192 0h-8H104C46.6 0 0 46.6 0 104v64 4.6l4 2.3 107.2 61.3C98.5 250.9 89 268.6 84 288H49.9L19.6 272.8l-7.2-3.6L5.3 283.6l7.2 3.6 32 16c1.1 .6 2.3 .8 3.6 .8H81c-.7 5.2-1 10.6-1 16v13.3L52.9 344.6c-1.2 .5-2.3 1.3-3.2 2.4l-32 40-5 6.2 12.5 10 5-6.2L61 358.6l28.3-11.8 44 51.4L85.2 416.5c-1.1 .4-2 1-2.8 1.8l-32 32L44.7 456 56 467.3l5.7-5.7 30.8-30.8 51.9-19.8 22.4 26.1L131 465.8c-1.9 1.5-3 3.8-3 6.2v32 8h16v-8V475.8L178.8 448H333.2L368 475.8V504v8h16v-8V472c0-2.4-1.1-4.7-3-6.2l-35.7-28.6 22.4-26.1 51.9 19.8 30.8 30.8 5.7 5.7L467.3 456l-5.7-5.7-32-32c-.8-.8-1.8-1.4-2.8-1.8l-48.1-18.3 44-51.4L451 358.6 481.8 397l5 6.2 12.5-10-5-6.2-32-40c-.8-1-1.9-1.9-3.2-2.4L432 333.3V320c0-5.4-.3-10.8-1-16h33c1.2 0 2.5-.3 3.6-.8l32-16 7.2-3.6-7.2-14.3-7.2 3.6L462.1 288H428c-5-19.4-14.5-37.1-27.2-51.8L508 174.9l4-2.3V168 128h0V112h0v-8C512 46.6 465.4 0 408 0H328h-8V12.5l3.9 2.3 80 48 6.9 4.1L419 53.3l-6.9-4.1L356.9 16H408c48.6 0 88 39.4 88 88v8H379.3L365.7 98.3 360 92.7 348.7 104l5.7 5.7 16 16 2.3 2.3H376 496v35.4L389.1 224.4C366.5 204.3 336.7 192 304 192l0-56v-8H288v8 56H224V136v-8H208v8 56c-32.7 0-62.5 12.3-85.1 32.4L16 163.4V128H136h3.3l2.3-2.3 16-16 5.7-5.7L152 92.7l-5.7 5.7L132.7 112H16v-8c0-48.6 39.4-88 88-88h51.1L99.9 49.1 93 53.3 101.3 67l6.9-4.1 80-48 3.9-2.3V0zM304 208c61.9 0 112 50.1 112 112v10.1L328.6 432H183.4L96 330.1V320c0-61.9 50.1-112 112-112h16 64 16z'
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fast',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fast',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm277.7 26.3L192 180.7c56.5-50.7 143.5-48.8 197.8 5.5c56.2 56.2 56.2 147.4 0 203.6s-147.4 56.2-203.6 0C131.8 335.5 130 248.5 180.7 192L282.3 293.7l5.7 5.7L299.3 288l-5.7-5.7zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9z'
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fast',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-80 96c0-44.2 35.8-80 80-80s80 35.8 80 80v64c0 44.2-35.8 80-80 80s-80-35.8-80-80V224z'
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fast',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      'M482.3 2.3L420.7 64H216h-8v8V296v8h8 96 8v-8V224H496v72H472h-8v8 72H424h-8v8 48H368l-136 0h-3.3l-2.3 2.3-64 64 11.3 11.3L235.3 448H376l48 0h8v-8V392h40 8v-8V312h24 8v-8V216v-8h-8H320V160v-8H304v8V288H224V80H424h3.3l2.3-2.3 64-64L482.3 2.3zM176 144H104 96v8V276.7L2.3 370.3l11.3 11.3 96-96 2.3-2.3V280 160h64V144zm368 68.7v22.6l93.7-93.7-11.3-11.3L544 212.7z'
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fast',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      'M48 75.2L136.6 208h28.3L130.6 16H48V75.2zM144 0l37.1 208 2.9 16H167.7 128L32 80V16 0H48h96z'
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fast',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      'M400 16V144H16V16H400zM16 0H0V16 144v16H16 400h16V144 88 72 16 0H400 16zM272 496H176V336h96V496zM176 320H160v16V496v16h16 96 16V496 336 320H272 232V248H496h8v-8V80 72h-8H448V88h40V232H224h-8v8 80H176z'
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fast',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      'M304 16V352c0 79.5-64.5 144-144 144S16 431.5 16 352V16H304zM16 0H0V16 352c0 88.4 71.6 160 160 160s160-71.6 160-160V16 0H304 16zM160 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 40a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fast',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      'M511.8 512c-104.9 0-201.4-36.1-277.8-96.5L247 405.3C320.1 462.1 412 496 511.8 496H531l26.6-119.8L435.9 308.6l-58.6 73.2L369 392.1l-11.7-6.2c-16.7-8.8-32.8-18.8-48-29.9l13.1-10.3c13.5 9.6 27.7 18.3 42.4 26l67-83.8 144 80-32 144h-32zM79.8 64c0 86.6 25.5 167.3 69.4 235l-12.6 10C90.6 238.5 63.8 154.4 63.8 64l0-32 144-32 80 144L204 211c5.5 10.5 11.5 20.6 18 30.5l-12.6 10c-7-10.7-13.5-21.7-19.5-33l-6.2-11.7 10.3-8.3L267.3 140 199.7 18.2 79.8 44.8l0 19.2 0 0zM623.7 5l6.3-5 9.9 12.5-6.3 5L16.1 507l-6.3 5L-.1 499.5l6.3-5L623.7 5z'
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fast',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      'M208 0h8 80 8V8 172.9L446.8 90.4l6.9-4 4 6.9 40 69.3 4 6.9-6.9 4L352 256l142.8 82.4 6.9 4-4 6.9-40 69.3-4 6.9-6.9-4L304 339.1V504v8h-8H216h-8v-8V339.1L65.2 421.6l-6.9 4-4-6.9-40-69.3-4-6.9 6.9-4L160 256 17.2 173.6l-6.9-4 4-6.9 40-69.3 4-6.9 6.9 4L208 172.9V8 0zm16 16V186.7v13.9l-12-6.9L64.2 108.3l-32 55.4L180 249.1l12 6.9-12 6.9L32.2 348.3l32 55.4L212 318.4l12-6.9v13.9V496h64V325.3 311.4l12 6.9 147.8 85.4 32-55.4L332 262.9 320 256l12-6.9 147.8-85.4-32-55.4L300 193.6l-12 6.9V186.7 16H224z'
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fast',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L488 300.7l-5.7 5.7L432 356.7l-50.3-50.3-5.7-5.7L364.7 312l5.7 5.7L420.7 368l-50.3 50.3-5.7 5.7L376 435.3l5.7-5.7L432 379.3l50.3 50.3 5.7 5.7L499.3 424l-5.7-5.7L443.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fast',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zM357.7 197.7l5.7-5.7L352 180.7l-5.7 5.7L224 308.7l-58.3-58.3-5.7-5.7L148.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fast',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      'M224 128v16 32 16H208 112C50.1 192 0 149 0 96S50.1 0 112 0h96 16V16 48 64h16H480h16 16V80v32 16H496 480 240 224zm-16 0V112h16H480h16V80H480 224 208V64 16H112C56.6 16 16 54 16 96s40.6 80 96 80h96V128zM144 472.9V496H368V472.9v-9.9l8.9-4.4c65-32.2 111-97.3 115.5-174.3L495 240H17l2.6 44.2c4.5 77 50.5 142.2 115.5 174.3l8.9 4.4v9.9zM3.6 285.2L.9 240 0 224H16 496h16l-.9 16-2.7 45.2C503.5 368.1 454 438.2 384 472.9V496v16H368 144 128V496 472.9C58 438.2 8.5 368.1 3.6 285.2z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fast',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      'M424 0h-8V16h8 24V144H416v16h40 8 32 8V144h-8H464V8 0h-8H424zM8 64H0V80H8 36L166.1 256 36 432H8 0v16H8 40h4l2.4-3.2L176 269.5 305.6 444.8 308 448h4 32 8V432h-8H316L185.9 256 316 80h28 8V64h-8H312h-4l-2.4 3.2L176 242.5 46.4 67.2 44 64H40 8z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fast',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M224 4.7l-5.7 5.7-88 88-5.7 5.7L136 115.3l5.7-5.7L216 35.3V184v8h16v-8V35.3l74.3 74.3 5.7 5.7L323.3 104l-5.7-5.7-88-88L224 4.7zm0 502.6l5.7-5.7 88-88 5.7-5.7L312 396.7l-5.7 5.7L232 476.7V328v-8H216v8V476.7l-74.3-74.3-5.7-5.7L124.7 408l5.7 5.7 88 88 5.7 5.7zM8 248H0v16H8 440h8V248h-8H8z'
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fast',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM296 368h8 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40 8H296v-8V456 376v-8zm16 80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64zM168 368h8 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H184v40 8H168v-8V456 376v-8zm16 80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H184v64zm232-80h8 40 40 8v16h-8H472V504v8H456v-8V384H424h-8V368z'
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fast',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      'M176 0h8 64 8V8 232H504h8v8V504v8h-8H408h-8v-8V408H224v96 8h-8H104 96v-8V220.9L4.4 175.2 0 172.9V168 72 64H8 176V8 0zm16 16V72v8h-8H16v83.1l91.6 45.8 4.4 2.2V216v28.7l34.3-12.2 2.5-.9 2.5 .7 51.5 15.3L240 234.4V16H192zM112 316.4l31.3-11.9 3.2-1.2 3.1 1.5 30.6 14.5 38.9-14.8 3.2-1.2 3.1 1.5 30.6 14.5 38.9-14.8 3.2-1.2 3.1 1.5 30.6 14.5 38.9-14.8 3.2-1.2 3.1 1.5 30.6 14.5 38.9-14.8 3.2-1.2 3.1 1.5 30.6 14.5 12.7-4.8V248H249.4l-43.7 15.5-2.5 .9-2.5-.7-51.5-15.3L112 261.6v54.8zm0 17.1v70.7l29-11.6 2.7-1.1 2.8 .9L192 407.6l16-5.3V400v-8h8H408h8v8 7.6l45.5-15.2 2.8-.9 2.7 1.1 29 11.6V331.6l-10.2 3.9-3.2 1.2-3.1-1.5-30.6-14.5L410 335.5l-3.2 1.2-3.1-1.5-30.6-14.5-38.9 14.8-3.2 1.2-3.1-1.5-30.6-14.5-38.9 14.8-3.2 1.2-3.1-1.5-30.6-14.5-38.9 14.8-3.2 1.2-3.1-1.5-30.6-14.5L112 333.5zm384 87.9l-32.2-12.9-45.2 15.1-2.5 .8V496h80V421.4zm-288-2.3l-13.5 4.5-2.5 .8-2.5-.8-45.2-15.1L112 421.4V496h96V419.1zM176 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fast',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M224 267.3L13.7 477.7 2.3 466.3 212.7 256 2.3 45.7 13.7 34.3 224 244.7 434.3 34.3l11.3 11.3L235.3 256 445.7 466.3l-11.3 11.3L224 267.3z'
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fast',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      'M166.8 64H173 320h8 8H624h16V80 432v16H624 336h-8-8H8 0v-8V237v-6.2l6-1.5C44 219.5 72 185 72 144v-8h8c41 0 75.5-28 85.2-66l1.5-6zM184 80V192H320V80H184zm-16 23.4c-17.1 27.1-46.5 45.8-80.3 48.3c-1.1 14.4-5.1 28.1-11.4 40.3H168V103.4zM66 208c-12.7 16.2-30 28.5-50 35v77H168V208H66zM16 336v96H168V336H16zm168 96H320V336H184v96zM336 320v16 96H624V80H336V192v16V320zM320 208H184V320H320V208z'
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fast',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M216 0h16V32.2c84.6 4.2 152 74.1 152 159.8v93.2L446.2 363l1.8 2.2V368v40 8h-8H8 0v-8V368v-2.8L1.8 363 64 285.2V192c0-85.7 67.4-155.6 152-159.8V0zm8 48C144.5 48 80 112.5 80 192v96 2.8L78.2 293 16 370.8V400H432V370.8L369.8 293l-1.8-2.2V288 192c0-79.5-64.5-144-144-144zM190.1 481.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9h16c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3h16c0 12.7 5.1 24.9 14.1 33.9z'
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fast',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      'M96 256.8l-7.1 4.8C54.6 284.6 32 323.7 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-44.4-22.6-83.5-56.9-106.5l-7.1-4.8v-8.5V16H96V248.3v8.5zM224 0h16V16 248.3c38.6 25.8 64 69.8 64 119.8c0 79.5-64.5 144-144 144S16 447.6 16 368c0-49.9 25.4-93.9 64-119.8V16 0H96 224zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V72 64h16v8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fast',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      'M233.8 53.1L194.3 13.7 205.7 2.3l40 40c.4 .4 .7 .8 1 1.2C258.7 36.2 272.9 32 288 32s29.3 4.2 41.4 11.5c.3-.4 .6-.8 1-1.2l40-40 11.3 11.3L342.2 53.1C358.1 67.8 368 88.7 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2l0-1c52.4-6.5 96-44.6 96-95c0-55.4-52.8-96-112-96c-45.2 0-86.6 23.6-103.7 59.4c51.6 21.9 87.7 73 87.7 132.6c0 96-144 208-144 208s-144-112-144-208c0-59.6 36.2-110.7 87.7-132.6C214.6 135.6 173.2 112 128 112c-59.2 0-112 40.6-112 96c0 50.4 43.6 88.5 96 95l0 1c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-23.3 9.9-44.2 25.8-58.9zm17.8 111.5c11.6-3 23.8-4.6 36.4-4.6s24.8 1.6 36.4 4.6C341.1 153.1 352 133.8 352 112c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 21.8 10.9 41.1 27.6 52.6zM169.3 256c-6 14.8-9.3 31-9.3 48H416c0-17-3.3-33.2-9.3-48H169.3zm7.8-16H398.9c-22.1-38.3-63.5-64-110.9-64s-88.7 25.7-110.9 64zm237.4 80h-253c2.7 15.3 9.2 31.5 18.3 48H396.2c9.2-16.5 15.6-32.7 18.3-48zm-28 64H189.5c11 16.9 24 33.1 37.3 48H349.3c13.3-14.9 26.3-31.1 37.3-48zm-52.2 64H241.6c12.7 13.1 24.8 24.4 34.5 33c4.5 4 8.6 7.5 11.9 10.3c3.3-2.8 7.3-6.2 11.9-10.3c9.7-8.6 21.8-19.9 34.5-33z'
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fast',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      'M432 224c0 84-49.8 156.4-121.6 189.2l-2.7 18.6C390 398.6 448 318.1 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 94.1 58 174.6 140.2 207.8l-2.7-18.6C65.8 380.4 16 308 16 224C16 109.1 109.1 16 224 16s208 93.1 208 208zm-80 0c0 37.9-16.5 72-42.7 95.4L313 324l6.3 7.9C349.2 305.5 368 267 368 224c0-79.5-64.5-144-144-144S80 144.5 80 224c0 43 18.8 81.5 48.7 107.9L135 324l3.7-4.6C112.5 296 96 261.9 96 224c0-70.7 57.3-128 128-128s128 57.3 128 128zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm26.1 208H197.9L176.8 348.6 199.7 320h48.6l22.9 28.6L250.1 496zM160 344l24 168h80l24-168-32-40H192l-32 40z'
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fast',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      'M224 8V0H208V8 64H112 96V80v96 16h16 48H480h48 16V176 80 64H528 432V8 0H416V8 64H224V8zM379.2 512l5.6-16H255.2l5.6 16H379.2zM208 80v40 8h16v-8V80H416v40 8h16v-8V80h96v96H112V80h96zM112 240a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM43.5 432H180.5l21.3 64H22.2l21.3-64zm175.1 64L192 416H32L5.3 496 0 512H16.9 207.1 224l-5.3-16zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zm272 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM438.2 496l21.3-64H596.5l21.3 64H438.2zM608 416H448l-26.7 80L416 512h16.9H623.1 640l-5.3-16L608 416zm-80-32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fast',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM208 336h32v32H208V336zm0-64V240h32v32H208zm0-128h32v32H208V144z'
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fast',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V241.1l83.6-55.7 6.7-4.4 8.9 13.3-6.7 4.4-96 64L248 270.9V256 104 96h16v8z'
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fast',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM144.8 176.8c-43.7 43.7-43.7 114.7 0 158.4s114.7 43.7 158.4 0l5.7-5.7 11.3 11.3-5.7 5.7c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0l5.7 5.7-11.3 11.3-5.7-5.7c-43.7-43.7-114.7-43.7-158.4 0z'
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fast',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM304 136v-8h16v8V256 376v8H304v-8V264H144l0 112v8H128v-8V264 248l0-112v-8h16v8V248H304V136z'
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fast',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      'M208 56c0-22.1 17.9-40 40-40H560V304H536 248c-15.7 0-29.8 6.4-40 16.8V56zM192 359.6l0 .1 0 .3c0 30.9 25.1 56 56 56H536h32 8V400h-8H544V320h24 8v-8V8 0h-8H248c-30.9 0-56 25.1-56 56V359.6zM528 320v80H248c-22.1 0-40-17.9-40-40s17.9-40 40-40H528zM352 496V448H336v48H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H180.1c-4.1-4.9-7.6-10.3-10.5-16H56c-15.7 0-29.8 6.4-40 16.8V152c0-22.1 17.9-40 40-40H160V96H56C25.1 96 0 121.1 0 152V455.6l0 .1 0 .3c0 30.9 25.1 56 56 56H344h32 8V496h-8H352z'
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fast',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      'M16 40V32H0v8V328v80 64 8H16v-8V416H624v56 8h16v-8V408 328 232c0-57.4-46.6-104-104-104H280h-8v8V320H16V40zM624 400H16V336H280 624v64zm0-168v88H288V144H536c48.6 0 88 39.4 88 88zM80 208a64 64 0 1 1 128 0A64 64 0 1 1 80 208zm144 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fast',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      'M320 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM239.3 176l-6.7 160H256h48 32 48 23.3l-6.7-160H239.3zM312 352V504v8h-8H256h-8v-8V352H232 216l.7-16L224 160H416l7.3 176 .7 16H408 392V504v8h-8H336h-8v-8V352H312zm64 144V352H344V496h32zM296 352H264V496h32V352zM112 464c38.3 0 74-11.2 104-30.6v18.7C185.4 469.9 149.9 480 112 480H72 64v-8V448c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V40 32H8 34.9c84.9 0 161.1 37.1 213.4 96H226.3C177.6 78.6 109.8 48 34.9 48H16v64c0 81.6 38.1 154.2 97.6 201.2l6 4.8 6 4.8-4.5 6.2-4.5 6.2C93.6 366.8 80 405.8 80 448v16h32zm312-11.8V433.4c30 19.4 65.7 30.6 104 30.6h32V448c0-42.2-13.6-81.2-36.7-112.9l-4.5-6.2-4.5-6.2 6-4.8 6-4.8C585.9 266.2 624 193.6 624 112V48H605.1c-74.9 0-142.7 30.6-191.5 80H391.7C444 69.1 520.2 32 605.1 32H632h8v8 72c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448v24 8h-8H528c-37.9 0-73.4-10.1-104-27.8z'
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fast',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      'M266.5 128.3c6.1 .3 12.1 .9 18.1 1.7L360.6 16H482.1l-102 153c4.3 3.2 8.5 6.6 12.5 10.1L501.3 16 512 0H492.8 352L266.5 128.3zM119.4 179.1c4-3.5 8.2-6.9 12.5-10.1L29.9 16H151.4l76 113.9c6-.8 12-1.4 18.1-1.7L160 0H19.2 0L10.7 16 119.4 179.1zM256 176a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm7.2-275.5L256 221.9l-7.2 14.5-26.4 53.4-58.9 8.6-16 2.3 11.6 11.3 42.6 41.6-10.1 58.7-2.7 16 14.3-7.5L256 393l52.7 27.7 14.3 7.5-2.7-16-10.1-58.7 42.6-41.6 11.6-11.3-16-2.3-58.9-8.6-26.4-53.4zM235 300.7l21-42.6 21 42.6 1.9 3.8 4.2 .6 47 6.8-34 33.2-3 2.9 .7 4.1 8 46.9-42.1-22.1-3.7-2-3.7 2L210.2 399l8-46.9 .7-4.1-3-2.9-34-33.2 47-6.8 4.2-.6 1.9-3.8z'
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fast',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      'M104.9 261.6l7.1-4.8v-8.5V16H240V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM256 0H240 112 96V16 248.3C57.4 274.1 32 318.1 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72 64H168v8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zM450.3 34.3l-80 80 11.3 11.3L448 59.3V472v8h16v-8V59.3l66.3 66.3 11.3-11.3-80-80L456 28.7l-5.7 5.7z'
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fast',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3 5.7 5.7L488 435.3l-5.7-5.7L432 379.3l-50.3 50.3-5.7 5.7L364.7 424l5.7-5.7L420.7 368l-50.3-50.3-5.7-5.7L376 300.7l5.7 5.7L432 356.7l50.3-50.3 5.7-5.7L499.3 312l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fast',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      'M400 16V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H16V16H400zM16 416H64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632h8V400h-8H608V216v-3.3l-2.3-2.3-112-112L491.3 96H488 416V16 0H400 16 0V16 400v16H16zM416 112h68.7l104 104H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM272 211c0 33.1-28.1 61-64 61s-64-27.9-64-61c0-6.8 3.5-18.5 10.9-34c7.1-14.9 16.7-31.4 26.5-46.8c9.6-15 19.2-28.9 26.5-39.1c7.3 10.2 16.9 24.1 26.5 39.1c9.8 15.4 19.4 31.9 26.5 46.8c7.4 15.6 10.9 27.3 10.9 34zm-144 0c0 42.5 35.8 77 80 77s80-34.5 80-77c0-33.2-48.6-104-70.1-133.6C211.9 69.1 208 64 208 64s-3.9 5.1-9.9 13.4C176.6 107 128 177.8 128 211z'
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fast',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      'M112 16c48 0 87.8 35.2 94.9 81.2c.7 4.8 1.1 9.7 1.1 14.8h16c0-5.9-.4-11.6-1.3-17.2C214.4 41.1 168 0 112 0C50.1 0 0 50.1 0 112c0 56 41.1 102.4 94.8 110.7c5.6 .9 11.4 1.3 17.2 1.3V208c-5 0-10-.4-14.8-1.1C51.2 199.8 16 160 16 112c0-53 43-96 96-96zm33.4 118.1c4.2-6.3 6.6-13.9 6.6-22.1c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40c8.2 0 15.7-2.4 22.1-6.6L160 171.3V340.7l-25.9 25.9c-6.3-4.2-13.9-6.6-22.1-6.6c-22.1 0-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40c0-8.2-2.4-15.7-6.6-22.1L171.3 352H340.7l25.9 25.9c-4.2 6.3-6.6 13.9-6.6 22.1c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40c-8.2 0-15.7 2.4-22.1 6.6L352 340.7V171.3l25.9-25.9c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1L340.7 160H171.3l-25.9-25.9zM176 176H336V336H176V176zm320-64c0 48-35.2 87.8-81.2 94.9c-4.8 .7-9.8 1.1-14.8 1.1v16c5.9 0 11.6-.4 17.2-1.3C470.9 214.4 512 168 512 112C512 50.1 461.9 0 400 0C344 0 297.6 41.1 289.3 94.8c-.9 5.6-1.3 11.4-1.3 17.2h16c0-5 .4-10 1.1-14.8C312.2 51.2 352 16 400 16c53 0 96 43 96 96zM112 496c-53 0-96-43-96-96c0-48 35.2-87.8 81.2-94.9c4.8-.7 9.7-1.1 14.8-1.1V288c-5.9 0-11.6 .4-17.2 1.3C41.1 297.6 0 344 0 400c0 61.9 50.1 112 112 112c56 0 102.4-41.1 110.7-94.8c.9-5.6 1.3-11.4 1.3-17.2H208c0 5-.4 10-1.1 14.8C199.8 460.8 160 496 112 496zm384-96c0 53-43 96-96 96c-48 0-87.8-35.2-94.9-81.2c-.7-4.8-1.1-9.8-1.1-14.8H288c0 5.9 .4 11.6 1.3 17.2C297.6 470.9 344 512 400 512c61.9 0 112-50.1 112-112c0-56-41.1-102.4-94.8-110.7c-5.6-.9-11.4-1.3-17.2-1.3v16c5 0 10 .4 14.8 1.1c46 7.1 81.2 46.9 81.2 94.9zM112 424a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24-312a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM400 424a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24-312a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fast',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      'M248 507.4l8 4.6 8-4.6L480 384v-8s0 0 0 0V137.8 128l-7.6-4.4L256 0 39.6 123.6 32 128v9.8V376s0 0 0 0v8L248 507.4zM67.9 386.1L248 399.4V489L67.9 386.1zM264 399.4l180.1-13.3L264 489V399.4zm200-51.6L378.7 210.2 464 149.3V347.9zM370.5 196.4L272 27.6 458 133.9l-87.5 62.5zM240 27.6L141.5 196.4 54 133.9 240 27.6zM48 149.3l85.3 60.9L48 347.9V149.3zm95.9 74l97.1 159.6L53.7 369l90.2-145.7zm127 159.6l97.1-159.6L458.3 369 270.9 382.9zM256 376.6L158.2 216H353.8L256 376.6zM157.9 200L256 31.9 354.1 200H157.9z'
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fast',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      'M208 0c29 0 54.6 14 70.7 35.6C291.5 23.4 308.9 16 328 16c39.8 0 72 32.2 72 72s-32.2 72-72 72c-19.1 0-36.5-7.4-49.3-19.6C262.6 162 237 176 208 176s-54.6-14-70.7-35.6C124.5 152.6 107.1 160 88 160c-39.8 0-72-32.2-72-72s32.2-72 72-72c19.1 0 36.5 7.4 49.3 19.6C153.4 14 179 0 208 0zM145.3 52.5l-5.9 10.4-7.4-9.4C121.8 40.4 105.9 32 88 32C57.1 32 32 57.1 32 88s25.1 56 56 56c17.9 0 33.8-8.4 44.1-21.5l7.4-9.4 5.9 10.4C157.7 145.3 181.2 160 208 160s50.3-14.7 62.7-36.5l5.9-10.4 7.4 9.4C294.2 135.6 310.1 144 328 144c30.9 0 56-25.1 56-56s-25.1-56-56-56c-17.9 0-33.8 8.4-44.1 21.5l-7.4 9.4-5.9-10.4C258.3 30.7 234.8 16 208 16s-50.3 14.7-62.7 36.5zM368 496V192v-8-8h8 7.4l.6-.3v.3H504h8v8V376v5.2l-4.8 2.1L384 437.2V496v16H368 48 32V496 175.7c5.1 3.2 10.4 6 16 8.4V496H368zm16-76.2l112-49V192H384V419.8zM144 224v8V440v8H128v-8V232v-8h16zm72 0v8V440v8H200v-8V232v-8h16zm72 0v8V440v8H272v-8V232v-8h16z'
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fast',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM93.7 305.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4L192 419.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8zm87.4-20.4L192 295l10.9-10.2 5.2-4.8c7.3-6.8 16.9-10.6 26.9-10.6h3.5c19.8 0 35.8 16 35.8 35.8c0 9.9-4.1 19.4-11.3 26.1L192 397.6l-70.9-66.4c-7.2-6.8-11.3-16.2-11.3-26.1c0-19.8 16-35.8 35.8-35.8H149c10 0 19.6 3.8 26.9 10.6l5.2 4.8z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fast',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM112 208a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm112-32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fast',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      'M0 128l0-8 8 0 224 0 8 0 7.4 0 58.5-69.2 2.4-2.8 3.7 0 53.7 0c48.8 0 93.9 26.2 118.1 68.5l10.3 18C505.8 155.1 512 178.3 512 202l0 142c0 57.4-46.6 104-104 104l-16 0-88 0-48 0-8 0 0-8 0-56-24 0-8 0 0-8 0-64-24 0-8 0 0-8 0-80L8 224l-8 0 0-8 0-88zm268.3-8l75.7 0 8 0 0 16-8 0-89.2 0-3.7 0L240 136l-8 0L16 136l0 72 176 0 8 0 0 8 0 80 24 0 8 0 0 8 0 64 24 0 8 0 0 8 0 56 40 0 88 0 16 0c48.6 0 88-39.4 88-88l0-142c0-20.9-5.4-41.4-15.8-59.5l-10.3-18C448.5 87.1 408.8 64 365.7 64l-50 0-47.4 56z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fast',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M16 64v8l0 368v8H0v-8V72 64H16zm195.3 96l-5.7 5.7L123.3 248l393.4 0-82.3-82.3-5.7-5.7L440 148.7l5.7 5.7 96 96 5.7 5.7-5.7 5.7-96 96-5.7 5.7L428.7 352l5.7-5.7L516.7 264l-393.4 0 82.3 82.3 5.7 5.7L200 363.3l-5.7-5.7-96-96L92.7 256l5.7-5.7 96-96 5.7-5.7L211.3 160zM640 72V440v8H624v-8V72 64h16v8z'
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fast',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      'M184 1.2l12.9 10.1 152 118.4 8 6.3-8 6.3L202.3 258.1 349.1 377.8l8 6.6-8.4 6.1-152 110.4L184 510.1V494.4 272.5L45 382.3 35 369.7 176.7 257.9 34.9 142.2l10.1-12.4L184 243.1V17.6 1.2zm16 275.6V478.7l130.9-95.1L200 276.8zm0-37.4L331 136 200 34V239.5z'
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fast',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      'M432 208L16 208l0 96 416 0 0-96zm16 96l0 16-16 0L16 320 0 320l0-16 0-96 0-16 16 0 416 0 16 0 0 16 0 96zM240 368L16 368l0 96 224 0 0-96zm16 96l0 16-16 0L16 480 0 480l0-16 0-96 0-16 16 0 224 0 16 0 0 16 0 96zM368 144l0-96L16 48l0 96 352 0zm16 16l-16 0L16 160 0 160l0-16L0 48 0 32l16 0 352 0 16 0 0 16 0 96 0 16z'
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fast',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      'M496 80a64 64 0 1 1 128 0A64 64 0 1 1 496 80zm144 0A80 80 0 1 0 480 80a80 80 0 1 0 160 0zM16 444.9L256 92.4 496 444.9V496h-.2H16V444.9zM16 512H457h39 16H624h16V496 433.7L489.6 206.5 480 192l-9.6 14.5-57.9 87.4L265.7 78.2 256 64l-9.7 14.2L0 440v56 16H16zm608-16H512V440L422.3 308.2 480 221 624 438.5V496z'
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fast',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      'M16 240H32 48 176h16H320h16H464h16 16V184.4L256 19.4 16 184.4V240zm16 16H16 0V240 176L256 0 368 77V40 32h8 96 8v8V154l32 22v64 16H496 480v48 16 48 16 48 16 48 16H464 336 320V496 448 432 384 368 320 304 256H192v48 16 48 16 48 16 48 16H176 48 32V496 448 432 384 368 320 304 256zm144 0H48v48H176V256zm160 0v48H464V256H336zM464 143V48H384V88l80 55zM256 120a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM176 320H48v48H176V320zm0 64H48v48H176V384zM48 496H176V448H48v48zM464 320H336v48H464V320zm0 64H336v48H464V384zM336 496H464V448H336v48z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fast',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141.6 128L245.7 256 141.6 384h20.6L256 268.7 349.8 384h20.6L266.3 256 370.4 128H349.8L256 243.3 162.2 128H141.6z'
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fast',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      'M80 64a48 48 0 1 1 96 0A48 48 0 1 1 80 64zm112 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM21.2 368L76.1 176h92.3c.5-5.5 1.5-10.8 3-16H64L4.6 368 0 384H16.6 56V504v8h8 48 8v-8V384h16V504v8h8 32V496H152V384h8V368H144 112 64 21.2zM376 512v-8V384h16V504v8h8 48 8v-8V384h39.4H512l-4.6-16L448 160H340.7c1.5 5.2 2.5 10.5 3 16h92.3l54.9 192H448 400 368 352v16h8V496H336v16h32 8zM72 384h32V496H72V384zM336 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 320 64a64 64 0 1 0 128 0zm-8 320V496H408V384h32zM256 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm64 32V400H304 288 224 208 192V272H320zM208 416v88 8h16v-8V416h64v88 8h16v-8V416h16 16V400 272 256H320 192 176v16V400v16h16 16z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fast',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M176 96a80 80 0 1 1 160 0A80 80 0 1 1 176 96zm176 0A96 96 0 1 0 160 96a96 96 0 1 0 192 0zM256 240s-63.4-45.3-240-47.9c-5.2-.1-10.6-.1-16-.1v16V448v16c160 0 256 48 256 48s96-48 256-48V448 208 192c-5.4 0-10.8 0-16 .1C316.4 194.7 256 240 256 240zm240-31.9v240c-74.2 1.5-134 12.9-176.2 24.4c-22.6 6.2-40.1 12.3-52.1 17c-1.3 .5-2.5 1-3.7 1.5V254l1.5-1.1 .3-.2c.3-.2 .9-.6 1.8-1.1c1.7-1.1 4.5-2.7 8.6-4.7c8.1-4.1 21.3-9.7 40.4-15.5c36.1-10.8 93.6-22 179.4-23.2zm-249.2 45l1.2 .9V491.1c-1.2-.5-2.4-1-3.7-1.5c-12-4.7-29.5-10.9-52.1-17C150 461.1 90.2 449.6 16 448.2v-240c84.3 1.3 141.8 12.4 178.2 23.2c19.4 5.8 32.9 11.4 41.3 15.6c4.2 2.1 7.2 3.7 9 4.8c.9 .5 1.5 .9 1.9 1.2l.3 .2 0 0 0 0 0 0z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fast',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      'M468.9 212.9l5.7-5.7 2.3-2.3c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-2.3 2.3-5.7 5.7-5.7 5.7L283.1 59.1c-21.7 21.7-33.4 49.7-35 78.1l-2.5 3L0 432l80 80L248 370.5V504v8h16v-8V360c0-.9-.2-1.8-.4-2.6l108.1-91.1 3-2.5c28.4-1.6 56.4-13.2 78.1-35l10.3-10.3 5.7-5.7zM267.4 139.4l-3.1-3.1c1.8-24 11.8-47.5 30.2-65.8l10.3-10.3L451.9 207.2l-10.3 10.3c-18.3 18.3-41.8 28.4-65.8 30.2l-3.1-3.1L267.4 139.4zm51.1-92.9c40.6-40.6 106.5-40.6 147.1 0s40.6 106.5 0 147.1l-2.3 2.3L316.1 48.8l2.3-2.3zM360.4 255L80.9 490.3 21.7 431.1 257 151.6 360.4 255z'
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fast',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      'M224 256c-61.9 0-112-50.1-112-112v-8-8c0-8.2 .9-16.3 2.6-24H192h4.3l2.4-3.6 25.3-38 25.3 38 2.4 3.6H256h77.4c1.7 7.7 2.6 15.8 2.6 24v8 8c0 61.9-50.1 112-112 112zM102.4 88H96 88v16h8 2.2c-1.5 7.8-2.2 15.8-2.2 24v8 8c0 16 0 39.6-2.9 63c-3 23.7-8.8 45.9-19.5 60.2L62 282.7l19.1-2.7 50.3-7.2 13.4 26.8 3.1 6.2 6.6-2.2 24-8 7.6-2.5-5.1-15.2-7.6 2.5-17.4 5.8-12.9-25.8-2.6-5.2-5.7 .8-39.6 5.7c7.4-15.8 11.4-34.7 13.6-52.7c.3-2.4 .6-4.8 .8-7.2C130.9 243.4 174.1 272 224 272s93.1-28.6 114.2-70.2c.2 2.4 .5 4.8 .8 7.2c2.3 18.1 6.3 36.9 13.6 52.7l-39.6-5.7-5.7-.8-2.6 5.2-12.9 25.8-17.4-5.8-7.6-2.5-5.1 15.2 7.6 2.5 24 8 6.6 2.2 3.1-6.2 13.4-26.8 50.3 7.2 19.1 2.7-11.6-15.5c-10.7-14.2-16.5-36.5-19.5-60.2c-2.9-23.4-2.9-47-2.9-63v-8-8c0-8.2-.8-16.2-2.2-24H352h8V88h-8-6.4C328.8 36.9 280.7 0 224 0S119.2 36.9 102.4 88zm17 0C135.5 45.9 176.2 16 224 16s88.5 29.9 104.6 72H260.3L230.7 43.6l-6.7-10-6.7 10L187.7 88H119.4zM75.5 336H372.5l53.3 160H22.2L75.5 336zM384 320H64L5.3 496 0 512H16.9 431.1 448l-5.3-16L384 320z'
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fast',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      'M192 16h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H192V16zM176 0V16 40h-8c-39.8 0-72 32.2-72 72v48H8 0v16H8 440h8V160h-8H112V112c0-30.9 25.1-56 56-56h8V80 96h16 96c26.5 0 48-21.5 48-48s-21.5-48-48-48H192 176zM45.5 208L80 512H368l34.5-304H386.4L353.7 496H94.3L61.6 208H45.5zm185.8 28.6L224 220.9l-7.3 15.7-27.5 59.5-65.1 7.7-17.2 2 12.7 11.8 48.1 44.5L155 426.6l-3.4 17 15.1-8.5 57.2-32 57.2 32 15.1 8.5-3.4-17-12.8-64.3 48.1-44.5L341.1 306l-17.2-2-65.1-7.7-27.5-59.5zM201.9 307L224 259.1 246.1 307 248 311l4.4 .5 52.3 6.2L266 353.6l-3.3 3 .9 4.4 10.3 51.7-46-25.7-3.9-2.2-3.9 2.2-46 25.7L184.4 361l.9-4.4-3.3-3-38.7-35.8 52.3-6.2 4.4-.5 1.9-4.1z'
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fast',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216 112v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zM284 96h47.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96zm-5-65.6C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1L279 30.4zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zm72.5 176H184h80 15.5l-9 12.6-37.2 52.1 23.2 46.3L304 320h80l58.7 176 5.3 16H431.1 225.9h-3.8H16.9 0l5.3-16L64 320h80l47.5 95.1 23.2-46.3-37.2-52.1-9-12.6zm80 16H199.5l23.2 32.5 1.2-2.4 1.2 2.4L248.5 320zM209.7 487.2L134.1 336H75.5L22.2 496H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM233.9 496H425.8L372.5 336H313.9L238.3 487.2l-4.4 8.8z'
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fast',
    iconName: 'hand-holding-hand',
    icon: [
      576,
      512,
      [],
      'e4f7',
      
      'M424.4 224h2.8l2.2-1.8L507.2 160H568h8V144h-8H504.4h-2.8l-2.2 1.8L421.6 208H208V168H328h8v-8V120v-8h-8H178.7h-2.5l-2 1.4-116.3 80L30.6 153.8 184.5 48H568h8V32h-8H182.1h-2.5l-2 1.4L15 145.2l-6.6 4.5 4.5 6.6L49.2 209l4.5 6.6 6.6-4.5L181.2 128H320v24H200h-8v8 56 8h8H424.4zM151.6 288h-2.8l-2.2 1.8L68.8 352H8 0v16H8 71.6h2.8l2.2-1.8L154.4 304H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 464H8 0v16H8 393.9h2.5l2-1.4L561 366.8l6.6-4.5-4.5-6.6L526.8 303l-4.5-6.6-6.6 4.5L394.8 384H256V360H376h8v-8V296v-8h-8H151.6z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fast',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      'M112 32h-6l-1.7 5.7L58 192H16 0v16V384v16 64 16H16 80 96V464 400H416v64 16h16 64 16V464 400 384 208 192H496 454L407.7 37.7 406 32h-6H112zM496 384H432 416 96 80 16V208H496V384zm-64 16h64v64H432V400zM16 400H80v64H16V400zM437.2 192H74.8L118 48H394l43.2 144zM80 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fast',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      'M144 16V240H432V16H144zM128 0h16H432h16V16 240v16H432 144 128V240 16 0zM16 160H96v16H16V320H560V176H480V160h80 16v16V320v8 8V496v16H560 16 0V496 336v-8-8V176 160H16zM560 336H16V496H560V336z'
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fast',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM177 183.7c2.9-15.3 13.7-26.4 31.4-33.1c17.8-6.7 41.9-8.4 68.7-4.6c8.1 1.2 26.5 5 35 7l7.8 1.9 3.8-15.5-7.8-1.9c-8.8-2.2-27.7-6.1-36.5-7.3c-28.5-4.1-55.5-2.5-76.6 5.4c-21.3 8-37.3 22.9-41.5 45.1c-2.5 13.4-1.1 25 3.7 34.9c4.8 9.9 12.7 17.4 21.9 23.3c17.9 11.5 42.9 18.2 66.2 24.5l0 0 .9 .2c24.4 6.6 47 12.8 62.6 22.8c7.6 4.9 13 10.4 16.2 16.9c3.1 6.4 4.3 14.4 2.4 25c-2.9 15.3-13.7 26.4-31.4 33.1c-17.8 6.7-41.8 8.4-68.7 4.6c-16.5-2.5-46.9-11-63.6-16.1l-7.6-2.3-4.7 15.3 7.6 2.3c16.5 5.1 48 14 65.9 16.7l0 0c28.5 4.1 55.5 2.5 76.6-5.4c21.3-8 37.3-22.9 41.5-45.1c2.5-13.4 1.1-25-3.7-34.9c-4.8-9.9-12.7-17.4-21.9-23.3c-17.9-11.5-42.9-18.2-66.2-24.5l-.9-.2c-24.4-6.6-47-12.8-62.6-22.8c-7.6-4.9-13-10.4-16.2-16.9c-3.1-6.4-4.3-14.4-2.4-25z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fast',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M16 48v80H560V48H16zm0 96v96H560V144H16zm0 112V464H560V256H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM96 352h96v16H96V352zm128 0H384v16H224V352z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fast',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      'M505.6 18.1l7.8-1.6L510.2 .8l-7.8 1.6L8.3 104.2 .5 105.8l3.2 15.7 7.8-1.6L505.6 18.1zm6.9 117.4l-1-16-8 .5L7.5 152l-8 .5 1 16 8-.5 496-32 8-.5zM144 462.9l-8.9-4.4c-65-32.2-111-97.3-115.5-174.3L17 240H495l-2.6 44.2c-4.5 77-50.5 142.2-115.5 174.3l-8.9 4.4v9.9V496H144V472.9v-9.9zM.9 240l2.7 45.2C8.5 368.1 58 438.2 128 472.9V496v16h16H368h16V496 472.9c70-34.6 119.5-104.8 124.4-187.7l2.7-45.2 .9-16H496 16 0l.9 16z'
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fast',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      'M256 16c-44.2 0-80 35.8-80 80v16H336V96c0-44.2-35.8-80-80-80zM160 96c0-53 43-96 96-96s96 43 96 96v16 16H336 176 160V112 96zM40 92.7l5.7 5.7L107.3 160H112 400h4.7l61.7-61.7 5.7-5.7L483.3 104l-5.7 5.7L416 171.3V176 280h88 8v16h-8H416v24c0 33.1-10.1 63.9-27.3 89.4l.9 .9 80 80 5.7 5.7L464 507.3l-5.7-5.7L379 422.3c-27.8 33.3-68.8 55.2-115 57.5v.2h-8-8v-.2c-46.2-2.3-87.3-24.2-115-57.5L53.7 501.7 48 507.3 36.7 496l5.7-5.7 80-80 .9-.9C106.1 383.9 96 353.1 96 320V296H8 0V280H8 96V176v-4.7L34.3 109.7 28.7 104 40 92.7zM400 320V296 280 176H112V280v16 24c0 76.8 60.2 139.6 136 143.8V232v-8h16v8V463.8c75.8-4.2 136-66.9 136-143.8z'
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fast',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      'M208 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM96 72c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8V384c0 2.1 .8 4.2 2.3 5.7l120 120 11.3-11.3L16 380.7V80H80V288c0 2.1 .8 4.2 2.3 5.7l10.8 10.8 5.2 5.2 80 80 8 8 5.7 5.7L203.3 392l-5.7-5.7-8-8-74.8-74.8 37.6-43.8L288 395.3V504v8h16v-8V392v-3.3l-2.3-2.3-144-144-6.1-6.1-5.6 6.6-42.4 49.4L96 284.7V72zm456-8c-4.4 0-8 3.6-8 8V284.7l-7.5 7.5-42.4-49.4-5.6-6.6-6.1 6.1-144 144-2.3 2.3V392 504v8h16v-8V395.3L487.5 259.8l37.6 43.8-74.8 74.8-8 8-5.7 5.7L448 403.3l5.7-5.7 8-8 80-80 5.2-5.2 10.8-10.8c1.5-1.5 2.3-3.5 2.3-5.7V80h64V380.7L506.3 498.3l11.3 11.3 120-120c1.5-1.5 2.3-3.5 2.3-5.7V72c0-4.4-3.6-8-8-8H552z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fast',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 104V96H176v8V312v8h16v-8V104zm-64 32v-8H112v8V280v8h16v-8V136zm128 0v-8H240v8V280v8h16v-8V136zm64 32v-8H304v8 80 8h16v-8V168z'
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fast',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      'M464 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM512 176V160c-5.5 0-10.8-.5-16-1.3v8.9l-240 165L16 167.6V80H417.3c-.9-5.2-1.3-10.5-1.3-16H16 0V80v96V432v16H16 496h16V432 176zm-16 11V432H16V187L256 352 496 187z'
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faToolbox = {
    prefix: 'fast',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      'M136 40l8 0 224 0 8 0 0 8 0 80 56 0 80 80 0 120 0 16 0 120 0 16-16 0L16 480 0 480l0-16L0 344l0-16L0 208l80-80 56 0 0-80 0-8zM16 344l0 120 480 0 0-120-144 0 0 48 0 8-16 0 0-8 0-48-160 0 0 48 0 8-16 0 0-8 0-48L16 344zm480-16l0-113.4L425.4 144 376 144l-16 0-208 0-16 0-49.4 0L16 214.6 16 328l144 0 0-48 0-8 16 0 0 8 0 48 160 0 0-48 0-8 16 0 0 8 0 48 144 0zM360 56L152 56l0 72 208 0 0-72z'
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fast',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      'M16 16H624V432H411.2l10.7 16H624h16V432 16 0H624 16 0V16 432v16H16 308.2l24.7 37.1 8.9 13.3 8.9 13.3 13.3-8.9 26.6-17.8 13.3-8.9-8.9-13.3-8.9-13.3L321.1 352l-10.7-16 19.2 0 55.3 0 40 48H379.2l10.7 16H576h16V384 64 48H576 352 336 304 288 64 48V64 384v16H64 96V384H64V64H288v63.3L141.6 229.8 128 239.3l0 16.7 0 128 0 16v16h16l32 0h16V400 384l0-81.5 0-28.8 16 24L265.5 384H224v16h52.2l21.3 32H200 120 16V16zM304 64h32v80 8.3l-6.8 4.8-57.1 39.9-12.7 8.9 8.4 13L308 280.7l4.7 7.3h8.7l78.6 0h7.5l4.8 5.8L487.5 384H445.8l-48.5-58.2-4.8-5.8H385l-74.6 0-29.9 0 16.6 24.9 75.7 113.6 8.9 13.3-26.6 17.8-8.9-13.3L205.3 264.8l-9.5-14.3L176 264.3l0 9.4L176 384v16l0 0H144V384l0-128v-8.3l0 0 6.8-4.8L176 225.3v0l2-1.4 0 0 119.2-83.4 6.8-4.8v-8.3V64zm48 0H576V384H508.3l-3.7-4.5-80-96L415 272l-15 0-78.6 0-40.1-61.8 57.1-39.9 13.6-9.6V144 64zM112 132a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zm36 52a52 52 0 1 0 0-104 52 52 0 1 0 0 104z'
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fast',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      'M20.5 295.5l5.8-15.9 63.2-45.2 4-2.9 1.7-4.7 36.4-100c21.6-59.3 85-91.1 144.8-74.4c5.3-4 10.9-7.8 16.8-11.3c-.8-.3-1.7-.6-2.5-1c-70.5-25.6-148.4 10.7-174 81.2l-36.4 100-67.2 48L5.5 290 0 305l15 5.5 226.9 82.6 4-15.6-225.4-82zm76.3 88.5c0 35.4 28.7 64 64.1 64c23.1 0 43.3-12.2 54.5-30.4l-15.5-5.6c-8.7 12.2-23 20.1-39.1 20.1c-26.5 0-48.1-21.5-48.1-48c0-1.3 0-2.5 .1-3.7l-15.5-5.6c-.4 3-.7 6.2-.7 9.3zM540.4 254.7l1.7 4.6 4 2.9 66.9 48 6.5 17.9L288.4 448.6l-6.5-17.9L302.2 351l1.2-4.8-1.7-4.6L263 235.2c-24-65.9 10-138.8 75.9-162.7s138.8 10 162.8 75.9l38.7 106.4zm94.1 68l-8.2-22.6-70.9-50.9L516.7 142.9c-27-74.2-109.1-112.5-183.3-85.5s-112.5 109-85.4 183.2L286.7 347l-21.6 84.5 13.7 37.6 .1 0L625 343.2l15-5.5-5.5-15zM481.2 464c-1 0-2 0-3-.1c-13.4-.8-25.4-7.2-33.6-16.8l0 0-15.8 5.7c3.4 4.8 7.4 9 11.9 12.7c10.1 8.2 22.7 13.5 36.6 14.3c1.3 .1 2.6 .1 3.9 .1c22 0 41.4-11.1 53-28c4.9-7.1 8.3-15.3 10-24.1c.2-1.1 .4-2.2 .5-3.3c.4-2.7 .6-5.4 .6-8.2l0-.5c0-1.8-.1-3.6-.2-5.4L530.3 416l-1 .4c-.2 26.4-21.6 47.7-48.1 47.7z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fast',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M208 48H48V208H208V48zM48 32H208h16V48 208v16H208 48 32V208 48 32H48zM208 304H48V464H208V304zM48 288H208h16v16V464v16H208 48 32V464 304 288H48zM304 48V208H464V48H304zM288 32h16H464h16V48 208v16H464 304 288V208 48 32zM392 272v8 96h96 8v16h-8H392v96 8H376v-8V392H280h-8V376h8 96V280v-8h16z'
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fast',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      'M112 464V48H464V464H112zm-16 0H16V48H96V464zm8-432H96 16 0V48 464v16H16 96h8 8H464h8 8 80 16V464 48 32H560 480h-8-8H112h-8zM560 464H480V48h80V464zM256 144h-8v8 64H184h-8v8 64 8h8 64v64 8h8 64 8v-8V296h64 8v-8V224v-8h-8H328V152v-8h-8H256zm8 80V160h48v64 8h8 64v48H320h-8v8 64H264V288v-8h-8H192V232h64 8v-8z'
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fast',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      'M256 144A96 96 0 1 0 64 144a96 96 0 1 0 192 0zm16 0c0 40.7-21.8 76.4-54.3 96h4.9H256h8v16h-8H225.7l24.8 128H234.2L209.4 256H160 110.6L85.8 384H69.5L94.3 256H64 56V240h8H97.4h4.9C69.8 220.4 48 184.7 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112zM16 496H304V475.5L264.9 432H55.1L16 475.5V496zM0 496V469.3L48 416H272l48 53.3V496v16H304 16 0V496z'
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fast',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM544 48V32H528 152.5l20.3 16H528V328.5l16 12.6V48zM96 170.9V464v16h16H487.5l-20.3-16H112V183.5L96 170.9zM184 400H386.2l-20.3-16H192V246.7L176 234V392v8h8zM464 120v-8h-8H320h-8v8 38l16 12.6V128H448V265.3L464 278V120zm-208-8h-2.2l2.2 1.7V112z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fast',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M80 272l0-32 32 0 0 32-32 0zm128 0l0-32 32 0 0 32-32 0zm128-32l32 0 0 32-32 0 0-32z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fast',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200h-8v16h8 80V496H88V291.3l58.3 58.3 11.3-11.3-72-72L80 260.7l-5.6 5.6 0 0-72 72 11.3 11.3L72 291.3V504v8h8H288 394.8c-6.9-4.9-13.4-10.2-19.6-16H296V224h80 8V208h-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zm80 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fast',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      'M16 496H272V208H16V496zm272 0H426.7L288 232.4V496zM560 156.5C501.9 125.6 452.3 80.8 415.7 26.1C382.2 60.5 336.2 80 288 80s-94.2-19.5-127.7-53.9C123.7 80.8 74.1 125.6 16 156.5V192H560V156.5zM293.3 208L444.8 496H560V208H293.3zM7.9 142.7C65.1 112.4 113.7 68.1 149.2 13.9l1-1.6 8-12.3 8.5 9.5c.9 1 1.7 1.9 2.6 2.8C199.9 45.3 242.9 64 288 64s88.1-18.7 118.7-51.6c.9-.9 1.7-1.9 2.6-2.8L417.8 0l8 12.3 1 1.6c35.5 54.1 84.1 98.5 141.3 128.8l7.9 4.2V496v16H560 16 0V496 146.9l7.9-4.2z'
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fast',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      'M112 48V368H624V270c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62V48H112zM640 160c-26.5 0-48 21.5-48 48s21.5 48 48 48v16 96 16H624 112 96V368 48 32h16H624h16V48v96 16zM480 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 88v8V464H552h8v16h-8H8 0v-8V96 88H16zm224 0h56 4.6l2.3 4 44.4 76h43.7c18.2 0 35.6 7.2 48.5 20.1c11 11 11 28.8 0 39.9c-12.9 12.9-30.3 20.1-48.5 20.1H339.3l-44.4 76-2.3 4H288 232 220.9l3.5-10.5L247.6 248H220l-21.6 28.8L196 280h-4H160 149.8l2.5-9.9L167.8 208l-15.5-62.1-2.5-9.9H160h32 4l2.4 3.2L220 168h35.6L232.4 98.5 228.9 88H240zm34.3 85.5l3.5 10.5H266.7 216h-4l-2.4-3.2L188 152H170.2l13.5 54.1 .5 1.9-.5 1.9L170.2 264H188l21.6-28.8L212 232h4 42.7 11.1l-3.5 10.5L243.1 312h40.3l44.4-76 2.3-4h4.6 56.3c13.9 0 27.3-5.5 37.1-15.4c4.8-4.8 4.8-12.5 0-17.2c-9.9-9.9-23.2-15.4-37.1-15.4H342.7h-4.6l-2.3-4-44.4-76H251.1l23.2 69.5z'
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fast',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      'M506.3 261.7L512 256l-5.7-5.7-152-152-5.7-5.7L337.4 104l5.7 5.7L481.4 248 8 248l-8 0 0 16 8 0 473.4 0L343 402.3l-5.7 5.7 11.3 11.3 5.7-5.7 152-152z'
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fast',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      'M112 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm240 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM21.7 496L75.8 320H372.2L384 358.4l0-54.4H64L4.9 496 0 512H16.7 384l0-16H21.7zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fast',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      'M256 480h8 80 8v-8V420.9c0-29.7-6.4-58.6-18.1-84.9H448h48 8v-8V232v-8h-8-8V168v-8h-8-8V104 96h-8H440V40 32h-8H384 272 257.1h-2.5l-2.1 1.4-12.3 8.5L160 97.2v19.4l89.3-61.6L259.5 48H272 384h40v56 8h8 24v56 8h8 8v56 8h8 8v80H448 321.1 307.9l6.1 11.7c14.2 27 21.9 57.5 21.9 89.1V464H272V420.9c0-45.9-24.6-88.3-64.5-111.1l-30-17.2-.6-.3-.6-.2L160 286.1v17l10.1 3.7 29.5 16.8c34.9 19.9 56.4 57 56.4 97.2V472v8zM16 368V112h96V368H16zM0 384H16h96 16V368 112 96H112 16 0v16V368v16z'
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fast',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 200l0-16L0 184l0 16 448 0zm0 128l0-16L0 312l0 16 448 0z'
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fast',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      'M224 16C109.1 16 16 109.1 16 224c0 55.7 22.7 108.1 61.7 147.9l2.3 2.3v3.3V504v8H64v-8V380.7C23.7 338.4 0 283.1 0 224C0 100.3 100.3 0 224 0h24C351.6 0 434.3 83.3 439.8 184.7l69.5 61.8 2.7 2.4v3.6V328v8h-8H448v0 32 7.4l-7.4 .5L336 383.4v25.2l88.7 7.4 7.3 .6V424v48 8h-8H320v24 8H304v-8V472v-8h8H416V431.4L327.3 424l-7.3-.6V416 376v-7.4l7.4-.5L432 360.6V336v-8 0-8h8 56V256l-69.3-61.6-2.6-2.3-.1-3.4C420.5 93.9 343.7 16 248 16H224zm96 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm288 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM608 496a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fast',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      'M560 256A240 240 0 1 0 80 256a240 240 0 1 0 480 0zm-2.6 96c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160H16 0V336 176 160H16 82.6C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160H624h16v16V336v16H624 557.4zm5.9-16H624V176H563.3c8.3 25.2 12.7 52.1 12.7 80s-4.5 54.8-12.7 80zM76.7 176H16V336H76.7C68.5 310.8 64 283.9 64 256s4.5-54.8 12.7-80zM363.4 315.2c-1.2-1.1-2.4-2.2-3.5-3.3L352 304l11.3-11.3L464 192l8.4 8.4 .2 .2c.9 .9 1.8 1.8 2.6 2.8c13.3 14.7 20.8 34 20.8 53.9v2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-1.6 0c-20.2 0-39.7-7.4-54.7-20.8zM463.9 214.7l-89.2 89.2c12 10.4 27.4 16.1 43.4 16.1l1.6 0c10.5 0 20.8-2.7 29.9-7.9c18.8-10.7 30.4-30.7 30.4-52.3v-2.4c0-15.7-5.8-30.9-16.1-42.6zM197.7 197.7l-32 32-5.7 5.7L148.7 224l5.7-5.7 32-32 5.7-5.7L203.3 192l-5.7 5.7zM304 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM229.7 293.7L219.3 304l16 16H240h48c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64V336v-4.7l-16-16-10.3 10.3-5.7 5.7L180.7 320l5.7-5.7 16-16 16-16 5.7-5.7L235.3 288l-5.7 5.7zM336 384c0-26.5-21.5-48-48-48H240v48c0 26.5 21.5 48 48 48s48-21.5 48-48zM320 80c-35.3 0-64 28.7-64 64H384c0-35.3-28.7-64-64-64zm-80 64c0-44.2 35.8-80 80-80s80 35.8 80 80v16H384 256 240V144z'
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fast',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      'M48 48a32 32 0 1 1 64 0A32 32 0 1 1 48 48zm80 0A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM112 265.7l5.4 8.1 9.5 14.3H144h80 5.7l24.6 105.6C236.1 404.9 224 425 224 448c0 35.3 28.7 64 64 64c33.8 0 61.6-26.3 63.8-59.5l154-36.7-3.7-15.6-151.2 36C345.4 406.5 319.3 384 288 384c-6.6 0-12.9 1-18.9 2.8L215.8 158.2l-1.8-7.8L198.4 154l1.8 7.8L214.7 224H161.1l-54.5-81.7L97.1 128H80 32 16 0v16 16V274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 4 24 4 24 0 0 4 24 .5 2.7h48.7 16.2l-2.2-13.3-.5-2.7-3.5-21.3 0 0-4-24-4-24-8-48-1.7-10.1-7.3-7.3L96 306.7V270.5 241.7l16 24zM218.5 240l7.5 32H224 144h-8.6l-4.7-7.1-21.4-32.1L80 188.8v52.8 65.1 6.6l4.7 4.7 54.6 54.6 3.6 3.6 .8 5.1 8 48 4 24 4 24 0 0 0 0 0 0 3.1 18.6H130.4l-2.2-13.4 0 0 0 0 0 0-4-24-4-24-6.3-37.9-.8-5.1-3.6-3.6L52.7 331.3 30.1 308.7c-9-9-14.1-21.2-14.1-33.9V160 144H32 80h8.6l4.7 7.1 54.5 81.7 4.8 7.1h8.6 57.3zM0 346.5L0 480l0 16 0 16 16 0 32 0 16 0 0-16 0-16 0-32.1V410.5l-16-16L48 480l0 16-32 0 0-16 0-117.5-16-16zM288 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fast',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      'M256 16C123.5 16 16 123.5 16 256V504v8H0v-8V256C0 114.6 114.6 0 256 0S512 114.6 512 256V504v8H496v-8V256C496 123.5 388.5 16 256 16zM159.1 224H352.9h6.3l1.5 6.1L382.3 320H408h8v8V448v8 8 32 16H400 352 336V496 464H176v32 16H160 112 96V496 464v-8-8V328v-8h8 25.7l21.6-89.9 1.5-6.1h6.3zM400 448V336H112V448h48 16H336h16 48zm-48 16v32h48V464H352zm-240 0v32h48V464H112zM365.8 320l-19.3-80H165.4l-19.3 80H365.8zM176 376a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fast',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      'M224 48C109.1 48 16 141.1 16 256c0 78.7 43.7 147.2 108.2 182.5l4.2 2.3v4.7l0 26.5v8h-8H8 0V464H8 112.3l0-13.8C45.2 411.5 0 339.1 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 83.1-45.2 155.5-112.3 194.2V464H440h8v16h-8H327.7h-8v-8V445.5v-4.7l4.2-2.3C388.3 403.2 432 334.7 432 256c0-114.9-93.1-208-208-208z'
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fast',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      'M16 464H495.8h.2V412.9L256 60.4 16 412.9V464zm441 16H16 0V464 408L246.3 46.2 256 32l9.7 14.2L412.5 261.9l57.9-87.4L480 160l9.6 14.5L640 401.7V464v16H624 512 496 457zm55-16H624V406.5L480 189l-57.7 87.2L512 408v56z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fast',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M224 371.3l5.7-5.7 176-176 5.7-5.7L400 172.7l-5.7 5.7L224 348.7 53.7 178.3 48 172.7 36.7 184l5.7 5.7 176 176 5.7 5.7z'
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fast',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      'M16 16V208H560V16H16zM0 0H16 560h16V16 208v16H560 16 0V208 16 0zM256 424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-28.9 13.9-54.5 35.4-70.5l9.6 12.8C107.4 379.4 96 400.4 96 424c0 39.8 32.2 72 72 72s72-32.2 72-72V256h16V424zm64-168h16V392c0 39.8 32.2 72 72 72s72-32.2 72-72c0-23.5-11.3-44.4-28.7-57.5l9.6-12.8c21.3 16 35.1 41.6 35.1 70.3c0 48.6-39.4 88-88 88s-88-39.4-88-88V256zM104 128H472h8v16h-8H104 96V128h8z'
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fast',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM136 200c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L232 294.9V320v8H216v-8V290.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H192c-22.1 0-40 17.9-40 40l0 6.5-16 0V200zm72 152h32v32H208V352z'
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fast',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      'M280 0h8 88 8V16h-8H296V96h80 8v16h-8H296V224.4c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6V104 8 0zM224 304a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm-93.8 18.1c15.9 14.4 35.9 27.7 56.5 29.7c2.7 5.7 5.8 11.1 9.3 16.1c-1.3 .1-2.7 .1-4 .1c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 350.2 28.7 368 0 368V352c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2zM384 368c-1.3 0-2.6 0-4-.1c3.5-5.1 6.7-10.5 9.3-16.2c20.6-2 40.6-15.2 56.4-29.7c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 0 0 .6-.9 .6 .9 0 0c4.3 6.1 8.5 12.1 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 337.8 553.5 352 576 352v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1zM96.6 427c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 0 0 .6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 481.8 553.5 496 576 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 494.2 28.7 512 0 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 .6-.9 .6 .9z'
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fast',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      'M256 496c5.4 0 10.7-.2 16-.5v16c-5.3 .3-10.6 .5-16 .5C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9v-21c49.1-43.9 80-107.8 80-178.9C496 123.5 388.5 16 256 16S16 123.5 16 256s107.5 240 240 240zM135.5 218.7l-2.7 7.5-15.1-5.4 2.7-7.5c7.3-20.4 34.8-61.3 87.5-61.3h8v16h-8c-43.3 0-66.4 33.7-72.5 50.7zm-6.3 90.1l5 6.2c23.8 29.7 64.3 61 121.8 61s98-31.3 121.8-61l5-6.2 12.5 10-5 6.2c-2 2.5-4.1 4.9-6.2 7.4V504v8H368v-8V348.5c-13.3 11.8-29.3 22.7-48 30.7V472v8H304v-8V385c-14.6 4.4-30.6 7-48 7c-63.8 0-108.5-34.9-134.2-67l-5-6.2 12.5-10zM304 168h-8V152h8c52.7 0 80.3 40.9 87.5 61.3l2.7 7.5-15.1 5.4-2.7-7.5c-6.1-17-29.2-50.7-72.5-50.7z'
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fast',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      'M16 16V400H231.8h.3H343.9h.3H560V16H16zM222.6 416H16 0V400 16 0H16 560h16V16 400v16H560 353.4l13.3 80H440h8v16h-8H360 216 136h-8V496h8 73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80V336H496V80zM80 64H496h16V80 336v16H496 80 64V336 80 64H80zm165.7 77.7L179.3 208l66.3 66.3 5.7 5.7L240 291.3l-5.7-5.7-72-72-5.7-5.7 5.7-5.7 72-72 5.7-5.7L251.3 136l-5.7 5.7zm96-11.3l72 72 5.7 5.7-5.7 5.7-72 72-5.7 5.7L324.7 280l5.7-5.7L396.7 208l-66.3-66.3-5.7-5.7L336 124.7l5.7 5.7z'
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fast',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      'M376 67.1L12.4 248.8 8 251.1v9.9l4.4 2.2L376 444.9V427.1L33.9 256 376 84.9V67.1z'
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fast',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      'M133.7 469.7l-5.7 5.7-5.7-5.7-104-104L12.7 360 24 348.7l5.7 5.7L120 444.7V40 32h16v8V444.7l90.3-90.3 5.7-5.7L243.3 360l-5.7 5.7-104 104zM296 48h80 8V64h-8H296h-8V48h8zm0 144H440h8v16h-8H296h-8V192h8zm0 128H504h8v16h-8H296h-8V320h8zm0 128H568h8v16h-8H296h-8V448h8z'
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fast',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      'M323 32c-29.3 0-55.6 17.7-66.7 44.8L189.9 240H32v16H183.4L112.8 429.1C104.2 450.2 83.7 464 61 464H8 0v16H8 61c29.3 0 55.6-17.7 66.7-44.8l73-179.2H352V240H207.2l64-157.1C279.8 61.8 300.3 48 323 48h53 8V32h-8H323z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fast',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M491.2 65.2l-6.2 5-160 128-5.4 4.3-5.1-4.7L191.6 82.6 21.1 222.2l-6.2 5.1L4.7 214.9l6.2-5.1 176-144 5.4-4.4 5.1 4.8L320.4 181.4 475 57.8l6.2-5 10 12.5zM80 336H48V464H80V336zM48 320H80 96v16V464v16H80 48 32V464 336 320H48zm128-80V464h32V240H176zm-16-16h16 32 16v16V464v16H208 176 160V464 240 224zm176 80H304V464h32V304zm-32-16h32 16v16V464v16H336 304 288V464 304 288h16zm128-48V464h32V240H432zm-16-16h16 32 16v16V464v16H464 432 416V464 240 224z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fast',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M274.3 34.3l5.7-5.7L291.3 40l-5.7 5.7L211.3 120 504 120h8v8V248v8H496v-8V136l-284.7 0 74.3 74.3 5.7 5.7L280 227.3l-5.7-5.7-88-88-5.7-5.7 5.7-5.7 88-88zm-36.7 256l88 88 5.7 5.7-5.7 5.7-88 88-5.7 5.7L220.7 472l5.7-5.7L300.7 392 16 392l0 112v8H0v-8V384v-8H8l292.7 0-74.3-74.3-5.7-5.7L232 284.7l5.7 5.7zM448 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM16 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm112 0A64 64 0 1 1 0 128a64 64 0 1 1 128 0z'
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fast',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      'M432 48V96c0 114.9-93.1 208-208 208S16 210.9 16 96V48H432zM16 32H0V48 96c0 93.9 57.8 174.3 139.8 207.6l-23.5 51.7c-6.4-2.1-13.2-3.3-20.3-3.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.5-.7-10.9-2-16H334.5l32.4 71.3 3.3 7.3 14.6-6.6-3.3-7.3L308.2 303.6C390.2 270.3 448 189.9 448 96V48 32H432 16zM327.2 384H151.4c-5.1-8.8-12.2-16.3-20.7-21.8l24.1-53.1c21.8 7.1 45 10.9 69.2 10.9s47.4-3.8 69.2-10.9l34 74.9zM96 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fast',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM224 256v16H208 144v1.4l112 112 112-112V272H304 288V256 144H224V256zm20.7 140.7L128 280v-8V256h16 48 16V240 144 128h16 64 16v16 96 16h16 48 16v16 8L267.3 396.7 256 408l-11.3-11.3z'
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fast',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      'M372.3 240.2l15.1 30.1 8.8 17.7H416h64 16 16V272 240 224H496 480 435.8l-39.2-78.3-5.4-10.9-11.3-4.5-80-32L294.2 96H288 224 210.7l-9.4 9.4-48 48-11.3 11.3L130.7 176l11.3 11.3 22.6 22.6L176 221.3l11.3-11.3 11.3-11.3L237.3 160h10.8 16.9l-5.3 16-26 78c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8L314.1 496l-4.6 16h16.6 49.9l6.6-23.2 32-112 6.6-23.2L401 340.9l-68.3-42.7L354.8 241l7.8-20.1 9.7 19.3zm30.4 120.6l-3.3 11.6-32 112L364.1 496H330.8l5.8-20.4L362 386.8l3.3-11.6-10.2-6.4-86.2-53.9c-18.8-11.8-27.1-34.8-20.1-55.9l31.3-94 7-21.1H264.9 237.3h-6.6l-4.7 4.7-38.6 38.6L176 198.6 153.4 176l11.3-11.3 48-48 4.7-4.7H224h64 3.1l2.9 1.1 80 32 5.6 2.3 2.7 5.4 39.2 78.3 4.4 8.8h9.9H480h16v32H480 416h-9.9l-4.4-8.8L377 213.7l-16.1-32.3-13.1 33.6-30.1 77.3-4.8 12.3 11.2 7 68.3 42.7 10.2 6.4zM368 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM207.3 314.8L193.6 352H112 96v16 32 16h16H238.4l19-51.7-13.9-8.7 0 0L227.2 400H112V368h81.6 11.2l3.8-10.5 9.2-25.2c-4.2-5.5-7.7-11.4-10.6-17.6zM8 95.8H0v16H8 152h8v-16h-8H8zm-8 64v16H8 88h8v-16H88 8 0zm8 64H0v16H8 136h8v-16h-8H8z'
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fast',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      'M224 336l0-16 0-224 0-16 16 0 128 0 0-64L160 16l0 304 0 16-16 0-96 0 0 9.4 144 144 144-144 0-9.4-96 0-16 0zm128 16L203.3 500.7 192 512l-11.3-11.3L32 352l0-16 0-16 16 0 80 0 16 0 0-16 0-288 0-16 16 0L368 0l16 0 0 16 0 64 0 16-16 0L256 96l-16 0 0 16 0 192 0 16 16 0 80 0 16 0 0 16 0 16z'
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fast',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      'M176.1 34.1l6.5 9.4L464.1 450.1 622.3 227.4l4.6-6.5 13 9.3-4.6 6.5-164.8 232-6.6 9.3-6.5-9.4L175.9 61.9 17.7 284.6l-4.6 6.5L0 281.9l4.6-6.5 164.8-232 6.6-9.3z'
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fast',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      'M432 352H16V464H432V352zm-11.3-16L288 203.3l-90.3 90.3L155.3 336H420.7zm-282.3-5.7L180.7 288 128 235.3 27.3 336H132.7l5.7-5.7zM16 48V324.7L122.3 218.3l5.7-5.7 5.7 5.7L192 276.7l90.3-90.3 5.7-5.7 5.7 5.7L432 324.7V48H16zM448 336v8 8V464v16H432 16 0V464 352v-8-8V48 32H16 432h16V48 336zM88 144a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fast',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      'M32 32h8H184h8v8V200.7l164-95.6 12-7V112v84.9L532.1 105 544 98.4V112 256v64V472v8h-8H40 32v-8V384 256 40 32zM48 48V256 384v80H528V320 256 125.6L363.9 217.5 352 224.2V210.6 125.9L188 221.6l-12 7V214.7 48H48z'
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fast',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      'M264 8V272.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V8 0h16V8zM208 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM496 144H368V336c0 61.9-50.1 112-112 112s-112-50.1-112-112V144H16V496H496V144zM144 128h16v16V336c0 53 43 96 96 96s96-43 96-96V144 128h16H496h16v16V496v16H496 16 0V496 144 128H16 144z'
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fast',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M0 264v8H16v-8V104H419.3l-72.7 66.1-5.9 5.4 10.8 11.8 5.9-5.4 88-80 6.5-5.9-6.5-5.9-88-80-5.9-5.4L340.7 16.5l5.9 5.4L419.3 88H8 0v8V264zm512-16v-8H496v8V408H92.7l72.7-66.1 5.9-5.4-10.8-11.8-5.9 5.4-88 80L60.1 416l6.5 5.9 88 80 5.9 5.4 10.8-11.8-5.9-5.4L92.7 424H504h8v-8V248z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fast',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      'M430.7 6.8l-3.4-5.3-5.9 2.1L239.8 68C134.4 105.4 64 205.1 64 316.9V504v8h8H402.9h13.5l-6.5-11.8L330.4 354.3c12.6-2.8 24.9-7.9 36.1-15.4L425.8 413l2.4 3H432h88 3.6l2.4-2.7 64-72 3.8-4.2-2.8-5-120-216-1.7-3-3.4-.8L414.5 99.4l39.6-46.2 3.9-4.6-3.3-5-24-36.8zM228.5 322.2c22.5 24.5 53.9 36.3 85 34.5l76 139.3H80V316.9c0-105 66.1-198.7 165.1-233.7L420.7 20.8 438 47.3 393.9 98.8l-8.4 9.8 12.6 3.1 60.6 15.2 115.6 208L516.4 400H435.8l-61.6-77-4.9-6.2-6.2 4.8c-37.4 29.1-90.8 24.6-122.8-10.3l-26.4-28.8-5.4-5.9-11.8 10.8 5.4 5.9 26.4 28.8zM416 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fast',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM263.6 140.8c5.6 .2 11.3 .7 17 1.6c7.5 1.1 30.5 5.3 38.4 7.3l7.8 1.9-3.9 15.5-7.8-1.9c-7.2-1.8-29.6-5.9-36.9-7c-23.1-3.4-43.8-.9-59 5.6c-15.3 6.5-24.3 16.6-26.4 28.3c-2.7 14.8 3.4 26.4 15.8 34.4c14 8.9 30.6 13.5 46.6 18c2.4 .7 4.9 1.4 7.3 2c20.3 5.8 42.4 12.1 58.2 23c18.1 12.4 26.2 31.7 22.3 53.3c-3.7 20.1-17.5 33.9-36.3 41.4c-12.4 5-27.2 7.4-43.2 7.3v44.7h-16V370.6c-2.7-.3-5.4-.6-8.1-1l0 0c-13.2-2-34.8-9-49.7-13.8l0 0c-5.2-1.7-10.5-3.3-15.7-5l4.8-15.3c5.5 1.7 11 3.5 16.5 5.2l0 0c15.1 4.8 34.9 11.2 46.6 13c23.3 3.4 43.8 1.7 58.9-4.4c14.9-6 24-16 26.5-29.5c2.8-15.5-2.6-28.4-15.6-37.2c-13.2-9.1-32.5-14.8-53.5-20.8c-2-.6-4.1-1.2-6.2-1.7c-17.9-5-36.3-10.2-52-20.2c-17.9-11.4-26.8-29.6-23-50.8c3.4-18.6 17.4-32.2 35.9-40.1c10.1-4.3 21.9-7.1 34.6-8V96h16v44.8z'
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fast',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      'M386.4 215.6c.4-.1 .8-.3 1.2-.5c.6-.3 1.2-.7 1.8-1.2l5.2-2.9-2.7-4.8c-.1-.6-.4-1.2-.6-1.8C379.9 182 358.8 168 336 168c-.1 0-.1 0-.2 0s-.1 0-.2 0c-8 0-15.8 1.8-23.1 5.2c-10.5 4.8-19.7 12.6-26.7 22.9c-1.8 2.5-3.5 5.2-5.1 8.1l-3.9 7 13.9 7.8 2.9-5.1c.6-.6 1.2-1.3 1.6-2.2c1.2-2.4 2.5-4.7 4-6.8c6.6-9.1 14.4-15 22.5-18.1c4.5-1.7 9.3-2.6 14.2-2.7c14.5 .1 30 8.7 40.8 27.9l3.9 7 5.8-3.3zM176 208l.2 0 .2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-.2 0-.2 0c-8.8 0-16 7.1-16 16s7.2 16 16 16zM107.2 322.4C122.7 385.3 179.9 432 248 432H264c68.1 0 125.3-46.7 140.8-109.6c1.9-6 3.6-12.1 4.8-18.4c1-5.2 1.8-10.6 2.4-16H395.9 116.1 100c.5 5.4 1.3 10.8 2.4 16c1.2 6.3 2.9 12.4 4.8 18.4zm15.7-3.5c-1.2-4.8-2.1-9.8-2.7-14.9H391.9c-.6 5.1-1.6 10.2-2.8 15.1C370 375.6 317.4 416 256 416c-61.5 0-114.1-40.5-133.2-97.1zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480z'
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fast',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      'M200 296v-8H184v8V504v8h16v-8V296zM72 392v-8H56v8V504v8H72v-8V392z'
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fast',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      'M421.7 10.3L416 4.7l-5.7 5.7L287.1 133.6l12.3 10.3L416 27.3l144 144V176H488 471.1l10.7 13.1L592 324v12H504 485.8l12.2 13.4L624 487.1V496H416v16 0H632h8v-8V484v-3.1l-2.1-2.3L522.2 352H600h8v-8V321.1v-2.9l-1.8-2.2L504.9 192H568h8v-8V168v-3.3l-2.3-2.3-152-152zM16 263.5L192 116.8 368 263.5V496H16V263.5zM0 256V496v16H16 368h16V496 256L192 96 0 256zm152 24h80v80H152V280zm0-16H136v16 80 16h16 80 16V360 280 264H232 152z'
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fast',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      'M328.3 330.7L496.9 4.3l14.2 7.3-256.3 496-2.2 4.3h-4.9H8 0v-8V338.7v-8H8 328.3zM96 346.7H16V496H96V346.7zm16 0V496H242.9L320 346.7H112zM624 432H400v64H624V432zM400 416H624h16v16 64 16H624 400 384V496 432 416h16z'
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fast',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      'M80 32H280V48H80V352H64V48 32H80zM560 48H360V32H560h16V48 352H560V48zM54.6 464H585.4L624 425.4V400H16v25.4L54.6 464zM640 384v16 32l-48 48H48L0 432V400 384H16 624h16zM328 40V292.7l74.3-74.3 5.7-5.7L419.3 224l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L232 212.7l5.7 5.7L312 292.7V40 32h16v8z'
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fast',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      'M440 32h8v8V472v8h-8H296h-8V464h8H432V48H296h-8V32h8H440zM8 32H152h8V48h-8H16V464H152h8v16h-8H8 0v-8V40 32H8z'
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fast',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      'M560 256c0-19.5-2.3-38.5-6.7-56.7l13.1-13.1c6.3 22.2 9.6 45.6 9.6 69.8c0 23.6-3.2 46.5-9.2 68.2c-5.1 1.8-10.1 4-14.8 6.8c-1.1-.6-2.2-1.3-3.4-1.9C556 306.1 560 281.5 560 256zM454.3 454.9l.5 .5 .4 .4 10.5 10.5C424.5 495.2 374.2 512 320 512c-58.3 0-112.1-19.5-155.1-52.3l11.4-11.4c40.1 30 89.8 47.7 143.7 47.7c49.8 0 96-15.2 134.3-41.1zM320 0c41.2 0 80.2 9.7 114.7 27.1c-1.4 5.4-2.3 10.9-2.6 16.7C398.6 26 360.5 16 320 16C187.5 16 80 123.5 80 256c0 20.2 2.5 39.8 7.2 58.5c-5.7-3.3-11.8-5.8-18.1-7.6c-3.3-16.5-5.1-33.5-5.1-51C64 114.6 178.6 0 320 0zm0 400c-56.7 0-96.1-35.4-118.6-67.4l13.1-9.2C235.4 353.2 270.6 384 320 384s84.6-30.8 105.4-60.6l13.1 9.2C416.1 364.6 376.7 400 320 400zM198.6 227.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9zm201-27.9c-14.6 0-30.2 8.6-41 27.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9zM47.6 336c12.6 0 24.7 5 33.7 13.9l6.7 6.7 6.7-6.7c8.9-8.9 21-13.9 33.7-13.9c26.3 0 47.6 21.3 47.6 47.6c0 12.6-5 24.7-13.9 33.7L93.7 485.7 88 491.3l-5.7-5.7L13.9 417.3C5 408.3 0 396.2 0 383.6C0 357.3 21.3 336 47.6 336zM16 383.6c0 8.4 3.3 16.4 9.3 22.3L88 468.7l62.7-62.7c5.9-5.9 9.3-14 9.3-22.3c0-17.4-14.1-31.6-31.6-31.6c-8.4 0-16.4 3.3-22.3 9.3L93.7 373.7 88 379.3l-5.7-5.7L69.9 361.3C64 355.3 56 352 47.6 352C30.1 352 16 366.1 16 383.6zm448-336C464 21.3 485.3 0 511.6 0c12.6 0 24.7 5 33.7 13.9l6.7 6.7 6.7-6.7C567.7 5 579.8 0 592.4 0C618.7 0 640 21.3 640 47.6c0 12.6-5 24.7-13.9 33.7l-68.4 68.4-5.7 5.7-5.7-5.7L477.9 81.3C469 72.3 464 60.2 464 47.6zM511.6 16C494.1 16 480 30.1 480 47.6c0 8.4 3.3 16.4 9.3 22.3L552 132.7l62.7-62.7c5.9-5.9 9.3-14 9.3-22.3C624 30.1 609.9 16 592.4 16c-8.4 0-16.4 3.3-22.3 9.3L557.7 37.7 552 43.3l-5.7-5.7L533.9 25.3C528 19.3 520 16 511.6 16zm33.7 349.9l6.7 6.7 6.7-6.7c8.9-8.9 21-13.9 33.7-13.9c26.3 0 47.6 21.3 47.6 47.6c0 12.6-5 24.7-13.9 33.7l-68.4 68.4-5.7 5.7-5.7-5.7-68.4-68.4c-8.9-8.9-13.9-21-13.9-33.7c0-26.3 21.3-47.6 47.6-47.6c12.6 0 24.7 5 33.7 13.9zM480 399.6c0 8.4 3.3 16.4 9.3 22.3L552 484.7l62.7-62.7c5.9-5.9 9.3-14 9.3-22.3c0-17.4-14.1-31.6-31.6-31.6c-8.4 0-16.4 3.3-22.3 9.3l-12.4 12.4-5.7 5.7-5.7-5.7-12.4-12.4c-5.9-5.9-14-9.3-22.3-9.3c-17.4 0-31.6 14.1-31.6 31.6z'
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fast',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm216 96H216c-35.3 0-64 28.7-64 64c0 22.3 11.4 41.9 28.7 53.4C154.5 256.1 136 281.9 136 312c0 39.8 32.2 72 72 72h32c39.8 0 72-32.2 72-72c0-30.1-18.5-55.9-44.7-66.6C284.6 233.9 296 214.3 296 192c0-35.3-28.7-64-64-64zM216 240c-26.5 0-48-21.5-48-48c0-26.5 21.5-48 48-48h16c26.5 0 48 21.5 48 48c0 26.5-21.5 48-48 48c0 0 0 0 0 0H216c0 0 0 0 0 0zm0 16c0 0 0 0 0 0h16c0 0 0 0 0 0h8c30.9 0 56 25.1 56 56s-25.1 56-56 56H208c-30.9 0-56-25.1-56-56s25.1-56 56-56h8z'
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fast',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      'M16 464l416 0 0-416L16 48l0 416zM0 480l0-16L0 48 0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480zM98.3 250.3l104-104 5.7-5.7L219.3 152l-5.7 5.7L123.3 248 344 248l8 0 0 16-8 0-220.7 0 90.3 90.3 5.7 5.7L208 371.3l-5.7-5.7-104-104L92.7 256l5.7-5.7z'
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fast',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      'M451.9 2.2l4.9 4.9 48 48 4.9 4.9-4.2 5.6-51.2 67.2-1.8 2.4-3 .6-77.6 15.5-56.9 56.9c43.3 47.9 49.6 113.8 13.2 150.2c-11 11-24.6 18-39.6 21.4c-16.6 3.7-30.7 19.1-31.6 36.1c-1.3 25.6-10.7 49.3-28.6 67.3C183.6 528 102.6 519.6 47.5 464.5S-16 328.4 28.8 283.6c17.9-17.9 41.7-27.4 67.3-28.6c17-.9 32.3-15 36.1-31.6c3.4-15 10.5-28.6 21.4-39.6c36.4-36.4 102.3-30.1 150.2 13.2l56.9-56.9 15.5-77.6 .6-3 2.4-1.8L446.4 6.4l5.6-4.2zM235.8 264.9l56.6-56.6c-43.9-39.4-99.5-41.2-127.5-13.2c-8.6 8.6-14.4 19.5-17.1 31.8c-5.2 22.9-26 42.8-50.9 44.1c-22.1 1.1-42 9.2-56.8 24C3.7 331.3 7.6 402 58.8 453.2s121.8 55.2 158.3 18.7c14.8-14.8 22.9-34.6 24-56.8c1.3-24.9 21.2-45.7 44.1-50.9c12.3-2.8 23.1-8.5 31.8-17.1c28-28 26.2-83.6-13.2-127.5l-56.6 56.6c5.6 7.8 8.9 17.4 8.9 27.8c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c10.4 0 20 3.3 27.8 8.9zM378.2 133.8l65.3-13.1 45.1-59.2L450.5 23.4 391.3 68.5l-13.1 65.3zM240 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fast',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      'M592 16H48V236.8c-5.7 3.3-11.1 7.2-16 11.6V16 0H48 592h16V16 248.4c-4.9-4.4-10.3-8.3-16-11.6V16zM96 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM320 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm272 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM43.5 432L16.9 512H0l32-96H160l32 96H175.1l-26.7-80H43.5zm197.3 80H224l32-96H384l32 96H399.1l-26.7-80H267.5l-26.7 80zm250.7-80l-26.7 80H448l32-96H608l32 96H623.1l-26.7-80H491.5z'
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fast',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      'M512 315.8V112H496V303.2l16 12.6zm-88-69.5V160v-8H408v8 73.7l16 12.6zm-112 95V416v8h16v-8V354l-16-12.6zm-96-75.8V416v8h16v-8V278.3l-16-12.6zm-72-56.8l-16-12.6V504v8h8H504h8v-8-4.7l-4.2-3.3H496 448 144V208.8zM193 64l20.3 16H544V64H428.4L390.8 3.8 388.4 0H384 256h-4.4l-2.4 3.8L211.6 64H193zM379.6 16l30 48H230.4l30-48H379.6zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fast',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M164.3 7.7L256 57.1 347.7 7.7 362 0l4.7 15.6 29.9 99.7 99.7 29.9L512 150l-7.7 14.4L454.9 256l49.4 91.7L512 362l-15.6 4.7-99.7 29.9-29.9 99.7L362 512l-14.4-7.7L256 454.9l-91.7 49.4L150 512l-4.7-15.6-29.9-99.7L15.6 366.7 0 362l7.7-14.4L57.1 256 7.7 164.3 0 150l15.6-4.7 99.7-29.9 29.9-99.7L150 0l14.4 7.7zm99.2 63.5L256 75.3l-7.6-4.1L159.7 23.4l-29 96.6-2.5 8.3-8.3 2.5-96.6 29 47.8 88.8 4.1 7.6-4.1 7.6L23.4 352.3l96.6 29 8.3 2.5 2.5 8.3 29 96.6 88.8-47.8 7.6-4.1 7.6 4.1 88.8 47.8 29-96.6 2.5-8.3 8.3-2.5 96.6-29-47.8-88.8-4.1-7.6 4.1-7.6 47.8-88.8-96.6-29-8.3-2.5-2.5-8.3-29-96.6L263.6 71.2zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm96 112a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fast',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      'M264 64V0H248V64L48 64H32V80 208v16H48 248v64H112 96v16l0 128v16h16H248v64h16V448H400h16V432 304 288H400 264V224H464h16V208 80 64H464L264 64zm0 240H400V432H264 248 112l0-128H248h16zm200-96H264 248L48 208 48 80l416 0V208z'
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fast',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      'M60.5 144l-9.2 67.5C42.3 277.3 93.5 336 160 336s117.7-58.7 108.7-124.5L259.5 144H60.5zm2.2-16H257.3L242 16H78L62.7 128zm221.9 81.3c9.9 72.8-44.3 137.9-116.5 142.4V496h80 8v16h-8H160 72 64V496h8 80V351.8C79.8 347.2 25.5 282.1 35.5 209.3L64 0H256l28.5 209.3z'
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fast',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      'M155.6 0H160 288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0zm128 16H164.4l-30 48H313.6l-30-48zM24 112.8L24 112H40L79.2 496H368.8L408 112H424l-.1 .8-40 392-.7 7.2H376 72 64.8l-.7-7.2-40-392zm195.3 79.7l-5.9 5.4L140.7 264H248c39.8 0 72 32.2 72 72v40 8H304v-8V336c0-30.9-25.1-56-56-56H140.7l72.7 66.1 5.9 5.4-10.8 11.8-5.9-5.4-88-80-6.5-5.9 6.5-5.9 88-80 5.9-5.4 10.8 11.8z'
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fast',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      'M72 32H64v8V288H0v16H64v64H0v16H64v80 8H80v-8V384H320V368H80V304H232c75.1 0 136-60.9 136-136s-60.9-136-136-136H72zm8 256V48H232c66.3 0 120 53.7 120 120s-53.7 120-120 120H80z'
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fast',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      'M112 416H96V400 48 32h16H464h16V48 304L368 416H112zm256-22.6L457.4 304H368v89.4zM352 400V296v-8h8H464V48H112V400H352zM64 128v16H16V496H368V448h16v48 16H368 16 0V496 144 128H16 64z'
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fast',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      'M188.9 93.2l7.7-3.2 1.8-8.2L212.9 16h86.2l14.4 65.8 1.8 8.2 7.7 3.2c14.5 6 28.1 13.9 40.3 23.3l6.6 5.1 8-2.5 64.3-20.5 43.1 74.7-49.8 45.4-6.2 5.6 1.1 8.3c1 7.6 1.5 15.4 1.5 23.3s-.5 15.7-1.5 23.3l-1.1 8.3 6.2 5.6 49.8 45.4-43.1 74.7L378 392.9l-8-2.5-6.6 5.1c-12.3 9.5-25.8 17.3-40.3 23.3l-7.7 3.2-1.8 8.2L299.1 496H212.9l-14.4-65.8-1.8-8.2-7.7-3.2c-14.5-6-28.1-13.9-40.3-23.3l-6.6-5.1-8 2.5L69.7 413.3 26.6 338.7l49.9-45.4 6.2-5.6-1.1-8.3c-1-7.6-1.5-15.4-1.5-23.3s.5-15.7 1.5-23.3l1.1-8.3-6.2-5.6L26.6 173.3 69.7 98.7 134 119.1l8 2.5 6.6-5.1c12.3-9.5 25.8-17.3 40.3-23.3zM312 0H200L182.8 78.4c-15.8 6.5-30.6 15.1-44 25.4L62.3 79.5l-56 97 59.4 54.1C64.6 238.9 64 247.4 64 256s.6 17.1 1.7 25.4L6.3 335.5l56 97 76.5-24.4c13.4 10.3 28.2 18.9 44 25.4L200 512H312l17.2-78.4c15.8-6.5 30.6-15.1 44-25.4l76.5 24.4 56-97-59.4-54.1c1.1-8.3 1.7-16.8 1.7-25.4s-.6-17.1-1.7-25.4l59.4-54.1-56-97-76.5 24.4C359.8 93.6 345 85 329.2 78.4L312 0zM279.9 161.3l1.3-7.9-15.8-2.6-1.3 7.9-32 192-1.3 7.9 15.8 2.6 1.3-7.9 32-192zm-98.2 60.3l5.7-5.7L176 204.7l-5.7 5.7-40 40-5.7 5.7 5.7 5.7 40 40 5.7 5.7L187.3 296l-5.7-5.7L147.3 256l34.3-34.3zm160-11.3l-5.7-5.7L324.7 216l5.7 5.7L364.7 256l-34.3 34.3-5.7 5.7L336 307.3l5.7-5.7 40-40 5.7-5.7-5.7-5.7-40-40z'
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fast',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      'M-1 32L144.6 240H40 32v16h8H152v80H40 32v16h8H152V472v8h16v-8V352H280h8V336h-8H168V256H280h8V240h-8H175.4L321 32H301.4L160 234 18.6 32H-1z'
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fast',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      'M258.8 2.8C239 2.8 223 19 212.5 36.1C201.7 53.6 194.8 75.4 194.8 92l0 78.8 0 9.3L6.9 283.8l-4.1 2.3v4.7 88 10.5l10.1-2.8 181.9-50.2 0 10.5 0 44L134 436.4l-3.2 2.4v4l0 56v10.4l10.1-2.7 117.9-31.5L368 504.2V487.6L260.9 459.1l-2.1-.6-2.1 .6L146.8 488.4l0-41.6 60.8-45.6 3.2-2.4v-4l0-48 0-21V315.3 184.9l0-14.1 0-78.8c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 78.8 0 14.1v4.7l0 125.7v10.5 21l0 48v4l3.2 2.4 26 19.5c-2.5-7.9-4.4-16-5.8-24.3l-7.5-5.6 0-44V336.3l7.7 2.1c.9-5.3 2-10.5 3.4-15.7l-11.1-3.1V198.4l66.1 36.5c4.4-3.8 9-7.4 13.7-10.7l-79.8-44 0-9.3 0-78.8c0-16.6-6.7-38.3-17.3-55.8C295 19 279 2.8 258.8 2.8zM18.8 295.5l176-97.1V319.7l-176 48.6 0-72.8zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fast',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      'M8 0H0V16H8 440h8V0h-8H8zM32 48V209.7c-2.9 1.5-5.6 3-8.1 4.6C10.6 222.6 0 233.7 0 248c0 67 32.9 117.2 77.2 150.4c3.8 2.8 7.6 5.5 11.6 8.1L67.8 496 64 512H80.4 367.6 384l-3.8-16-21-89.5c3.9-2.6 7.8-5.3 11.6-8.1C415.1 365.2 448 315 448 248c0-14.3-10.6-25.4-23.9-33.7c-2.5-1.6-5.3-3.1-8.1-4.6V48H400V202.6c-9-3.5-19-6.6-29.5-9.4C327.8 182.1 273.1 176 224 176s-103.8 6.1-146.5 17.3C67 196 57 199.2 48 202.6V48H32zM344.8 415.3l19 80.7H84.2l19-80.7C142 437.1 185.9 448 224 448s82-10.9 120.8-32.7zm-258-29.7c-34-25.5-60.3-61.3-68.3-107.5c1.7 1.2 3.5 2.4 5.3 3.6c13.6 8.5 32.4 15.5 53.7 21.1C120.2 313.9 174.9 320 224 320s103.8-6.1 146.5-17.3c21.3-5.6 40-12.6 53.7-21.1c1.8-1.1 3.6-2.3 5.3-3.6c-8 46.2-34.3 82-68.3 107.5C319.9 416.5 267.6 432 224 432s-95.9-15.5-137.2-46.4zM415.7 268.1c-11.7 7.3-28.7 13.8-49.3 19.2C325.4 298.1 272.1 304 224 304s-101.4-5.9-142.4-16.7C61 281.9 44 275.3 32.3 268.1C20.3 260.6 16 253.7 16 248s4.3-12.6 16.3-20.1C44 220.7 61 214.1 81.6 208.7C122.6 197.9 175.9 192 224 192s101.4 5.9 142.4 16.7c20.6 5.4 37.6 11.9 49.3 19.2c12 7.5 16.3 14.4 16.3 20.1s-4.3 12.6-16.3 20.1zM104 80H96V96h8 48 8V80h-8H104z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fast',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M296 32h-8V48h8H420.7l-126 126c-31.3-28.6-72.9-46-118.7-46C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-45.7-17.4-87.4-46-118.7l126-126V184v8h16v-8V40 32h-8H296zM16 304a160 160 0 1 1 320 0A160 160 0 1 1 16 304z'
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fast',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      'M16 16V464H64 80 496h16 48V16H16zM64 480H16 0V464 16 0H16 560h16V16 464v16H560 512v24 8H496v-8V480H80v24 8H64v-8V480zM368 240A144 144 0 1 0 80 240a144 144 0 1 0 288 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm272 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 0c0 23.8-17.3 43.5-40 47.3V344v8H456v-8V223.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fast',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      'M341.7 146.3l5.7 5.7L336 163.3l-5.7-5.7L200 27.3 200 496l176 0 8 0 0 16-8 0-184 0-8 0 0-8 0-476.7L53.7 157.7 48 163.3 36.7 152l5.7-5.7 144-144L192-3.3l5.7 5.7 144 144z'
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fast',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM40.7 336H64h48 32 48 23.3l-6.7-160H47.3L40.7 336zM136 352H120V504v8h-8H64 56v-8V352H40 24l.7-16L32 160H224l7.3 176 .7 16H216 200V504v8h-8H144h-8v-8V352zm48 0H152V496h32V352zM72 352V496h32V352H72z'
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fast',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      'M512.9 65.4c-9.1-34.1-44.2-54.4-78.4-45.3l-30.9 8.3 74.5 278.2 30.9-8.3c34.1-9.1 54.4-44.2 45.3-78.4L512.9 65.4zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-30.9 8.3-15.5 4.1-4.1-15.5L428.6 183.7 80 274V496h50.2l69-210.2 18.4-4.8-23.3 71H349.7l-31.8-97 15.5-4L413.8 496H568h8v16h-8H80 64 8 0V496H8 64V168v-8H80v8 89.5l140.4-36.4 39.2-119.6 1.8-5.5h5.8 9.6 5.8l1.8 5.5 31.1 94.9 108.9-28.2L388.1 32.6 384 17.1 399.5 13l30.9-8.3zM300 200.5L272 115 238.8 216.4 300 200.5zM397 496L355 368H189L147 496H397z'
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fast',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      'M29.1 166.7l27.5 12.5c29.9 13.6 64.7 10 91.2-9.3c26.3-19.1 62-19.1 88.3 0c26.5 19.3 61.4 22.8 91.2 9.3l27.5-12.5L329.2 496H54.8L29.1 166.7zm-1.4-18.2L17.3 16H366.7L356.3 148.5l-35.6 16.2c-24.6 11.2-53.3 8.3-75.2-7.6c-31.9-23.2-75.2-23.2-107.1 0c-21.9 15.9-50.6 18.8-75.2 7.6L27.7 148.5zM40 512H344L382.7 16 384 0H368 16 0L1.3 16 40 512z'
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fast',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM325.7 229.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L128 276.7l5.7 5.7L192 340.7 314.3 218.3l5.7-5.7L331.3 224l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fast',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M291.4 203.7l52.9-178L352 0 330.5 16.1 32 240v48l112.7 3.9 16.5 .6-4.7 15.8-52.9 178L96 512l21.5-16.1L416 272V224l-112.7-3.9-16.5-.6 4.7-15.8zM400 239.5V264L125.1 470.2 176.6 297l5.9-19.8-20.7-.7L48 272.5V248L322.9 41.9 271.4 215l-5.9 19.8 20.7 .7L400 239.5z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fast',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      'M576 16V0H560 111.9l20.3 16H560V353.7l16 12.6V16zM64 145.6V400v16H80 208h16v16 60.8V512l16-10.7L368 416h38.5l-20.3-16H368h-4.8l-4 2.7L240 482.1V416 400H224 80V158.3L64 145.6zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fast',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.3 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM165.7 138.3L152 124.7V144 272c0 57.4 46.6 104 104 104s104-46.6 104-104V144 124.7l-13.7 13.7L284.7 200H227.3l-61.7-61.7zM168 272V163.3l50.3 50.3 2.3 2.3H224h64 3.3l2.3-2.3L344 163.3V272c0 48.6-39.4 88-88 88s-88-39.4-88-88zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fast',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      'M416 48c79.5 0 144 64.5 144 144V400H288h-1.3c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H16V48H416zM16 416H96c0 53 43 96 96 96s96-43 96-96H560h16l56 0h8V400h-8l-56 0V192c0-88.4-71.6-160-160-160H16 0V48 400v16H16zM80 144H240v96H80V144zM64 128v16 96 16H80 240h16V240 144 128H240 80 64zm368 16v80H392h-8v16h8 40v96H336V144h96zm16 80V144 128H432 336 320v16V336v16h16 96 16V336 240 224zM192 336a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fast',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      'M421.7 469.7l-5.7 5.7-5.7-5.7-112-112-5.7-5.7L304 340.7l5.7 5.7L408 444.7V40 32h16v8V444.7l98.3-98.3 5.7-5.7L539.3 352l-5.7 5.7-112 112zM165.7 42.3l112 112 5.7 5.7L272 171.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L53.7 165.7 48 171.3 36.7 160l5.7-5.7 112-112 5.7-5.7 5.7 5.7z'
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fast',
    iconName: 'hand-wave',
    icon: [
      482,
      512,
      [],
      'e1a7',
      
      'M341.3 61.4c-6.9-27.5-30.1-47.8-58.3-50.9L256.9 7.6l-1.7 15 26.1 2.9c21.9 2.4 40 18.2 45.3 39.6l4.9 19.6L346.2 81l-4.9-19.6zM1.8 376.1c3.8 30.8 28.1 55 58.8 58.8l13.7 1.7 1.9-14.9L62.5 420c-23.9-3-42.8-21.8-45.8-45.8l-1.7-13.7L.1 362.3l1.7 13.7zM110.1 49.3l-5.3 5.3L51.5 107.8l-5.3 5.3 5.3 5.3 16 16L19.6 182.4l-5.3 5.3 5.3 5.3 37.3 37.3L8.9 278.2l-5.3 5.3 5.3 5.3L151.2 432.4c28 28.3 65.1 45.5 104.5 48.8l0 .5 7.5 .1 14.1 .1c96.1 .7 174.5-77 174.5-173.2l0-173.3 0-37.6 0-7.5-7.5 0-75.3 0-7.5 0 0 7.5 0 37.6 0 58.6L190 22.7l-5.3-5.3-5.3 5.3L131.4 70.6l-16-16-5.3-5.3zM142 81.2l42.6-42.6 179 179 12.9 12.9 0-18.2 0-76.8 0-30.1 60.2 0 0 30.1 0 173.3c0 87.8-71.5 158.8-159.3 158.1l-10-.1-3.8-.2c-38.3-1.6-74.6-17.5-101.7-44.9L24.9 283.6l42.6-42.6 .9 .9 94 94 5.3 5.3 10.6-10.6-5.3-5.3-94-94-5.3-5.3 0 0-.9-.9L35.6 187.7l42.6-42.6 3.1 3.1 5.3 5.3 70.9 70.9 3.1 3.1 55.1 55.1 5.3 5.3 10.6-10.6-5.3-5.3-49-49 0 0-9.2-9.2L67.5 113.2l42.6-42.6L134.5 95l0 0 5.3 5.3L268.9 229.4l5.3 5.3 10.6-10.6-5.3-5.3-16.8-16.8 0 0-9.4-9.4L142 81.2z'
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fast',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-48 48h8 48 8v8 29.6c11 4.4 20.9 10.2 30.3 17.5l25.6-14.8 6.9-4 4 6.9 24 41.6 4 6.9-6.9 4-25.6 14.8c.9 5.6 1.6 11.5 1.6 17.5s-.7 11.9-1.6 17.5l25.6 14.8 6.9 4-4 6.9-24 41.6-4 6.9-6.9-4-25.6-14.8c-9.3 7.3-19.2 13.1-30.3 17.5V408v8h-8H232h-8v-8V378.4c-11-4.4-20.9-10.2-30.3-17.5l-25.6 14.8-6.9 4-4-6.9-24-41.6-4-6.9 6.9-4 25.6-14.8c-.9-5.6-1.6-11.5-1.6-17.5s.7-11.9 1.6-17.5l-25.6-14.8-6.9-4 4-6.9 24-41.6 4-6.9 6.9 4 25.6 14.8c9.3-7.3 19.2-13.1 30.3-17.5V168v-8zm16 16v27.1 5.7l-5.3 1.9c-13.1 4.6-24.3 11.1-34.9 20.2l-4.3 3.7-4.9-2.8L167 218.1l-16 27.7 23.5 13.6 4.9 2.8-1 5.6c-1.3 7.1-2.4 13.7-2.4 20.2s1 13.1 2.4 20.2l1 5.6-4.9 2.8L151 330.1l16 27.7 23.5-13.6 4.9-2.8 4.3 3.7c10.6 9.1 21.8 15.6 34.9 20.2l5.3 1.9v5.7V400h32V372.9v-5.7l5.3-1.9c13.2-4.6 24.3-11.1 34.9-20.2l4.3-3.7 4.9 2.8L345 357.9l16-27.7-23.5-13.6-4.9-2.8 1-5.6c1.3-7.1 2.4-13.7 2.4-20.2s-1-13.1-2.4-20.2l-1-5.6 4.9-2.8L361 245.9l-16-27.7-23.5 13.6-4.9 2.8-4.3-3.7c-10.6-9.1-21.8-15.6-34.9-20.2l-5.3-1.9v-5.7V176H240zm16 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z'
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fast',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-48 64h64 8v8 64h64 8v8 64 8h-8H296v64 8h-8H224h-8v-8V328H152h-8v-8V256v-8h8 64V184v-8h8zm8 80v8h-8H160v48h64 8v8 64h48V320v-8h8 64V264H288h-8v-8V192H232v64z'
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fast',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      'M544 224C544 100.3 443.7 0 320 0C265.7 0 215.9 19.3 177.1 51.5L190 61.6C225.6 33.1 270.8 16 320 16c114.9 0 208 93.1 208 208c0 31.8-7.1 61.9-19.9 88.8L521 323c14.7-29.8 23-63.4 23-99zM527.9 511.9L507.8 496H495.3l0 0H144.7l61.5-79c33.4 19.7 72.3 31 113.8 31c35.3 0 68.6-8.1 98.3-22.7l-14.1-11.1C378.5 425.7 350 432 320 432c-114.9 0-208-93.1-208-208c0-12.9 1.2-25.5 3.4-37.8l-14.1-11.1C97.8 190.9 96 207.2 96 224c0 76.4 38.3 143.9 96.7 184.3L124.4 496 112 512h20.3H507.7 528l-.1-.1zM320 368c7.9 0 15.7-.6 23.3-1.9l-18-14.2c-1.7 .1-3.5 .1-5.3 .1c-62.3 0-114.2-44.5-125.7-103.5l-18-14.2C181.7 309 243.9 368 320 368zM448 224c0 12.9-1.9 25.3-5.4 37l13.4 10.6c5.2-14.9 8.1-30.9 8.1-47.6c0-79.5-64.5-144-144-144c-28.7 0-55.4 8.4-77.8 22.8l13.4 10.6C274.5 102.3 296.5 96 320 96c70.7 0 128 57.3 128 128zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fast',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      'M102.4 .1C68.3 21.5 0 82 0 153.7c0 7.6 .7 15 1.9 22.3H18.2c-1.5-7.2-2.2-14.7-2.2-22.3C16 122.9 30.7 93.3 50.9 68c16-20.1 34.7-36.5 49.5-47.2l41.9 41.9 11.3 11.3 11.3-11.3 15-15c49 45.5 60.1 91.2 60.1 106.1c0 7.6-.8 15.1-2.2 22.3h16.3c1.3-7.2 1.9-14.7 1.9-22.3c0-21.3-15.4-76.8-76.8-128L164.9 40 153.6 51.3 142.3 40 102.4 .1zM128 102.5s-48.2 32.1-68.2 73.5H77.9c6.1-10.4 14.2-20.4 23.2-29.7s18-17 24.8-22.3c.7-.6 1.4-1.1 2.1-1.6c.7 .5 1.4 1.1 2.1 1.6c6.8 5.4 15.8 13.1 24.8 22.3s17.1 19.4 23.2 29.7h18.1c-20-41.4-68.2-73.5-68.2-73.5zM512 64h-3.3l-2.3 2.3-55.2 53.7L429.7 98.3 424 92.7 412.7 104l5.7 5.7 21.4 21.4-37.2 36.2-21-21-5.7-5.7L364.7 152l5.7 5.7 20.8 20.8L354 214.6l-20.3-20.3-5.7-5.7L316.7 200l5.7 5.7 20.1 20.1L207 357.6l-13.7-9L230 224h18 8V208h-8H224 40 8 0v16H8 29.4L6.2 305C2.1 319.5 0 334.5 0 349.6v2.1C0 440.2 71.8 512 160.3 512c47.8 0 93.1-21.3 123.6-58.2L539.8 144H632h8v-8V112v-3.3l-2.3-2.3-40-40L595.3 64H592 512zM46 224H213.3l-37 125.7-1.7 5.7 4.9 3.3 24 15.8 5.4 3.5 4.6-4.5L515.3 80h73.4L624 115.3V128H536h-3.8l-2.4 2.9L271.5 443.6C244.1 476.8 203.3 496 160.3 496C80.6 496 16 431.4 16 351.7v-2.1c0-13.6 1.9-27.1 5.6-40.2L46 224zM80 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fast',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM200 232v-8H184v8V420.7l-74.3-74.3-5.7-5.7L92.7 352l5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7L280 340.7l-5.7 5.7L200 420.7V232z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fast',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM88 256H72C72 154.4 154.4 72 256 72V88C163.2 88 88 163.2 88 256z'
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fast',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      'M24 0H16V8 96v16V448v16 40 8H32v-8V464H288v40 8h16v-8V464 448 112 96 8 0h-8H24zm8 448V112H288V448H32zM32 96V16H288V96H32zM232 216h-8v8 96 8h8 32 8V312h-8H240V232h24 8V216h-8H232z'
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fast',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      'M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 432a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm8-344v-8H312v8V296v8h16v-8V136zM304 336v32h32V336H304zM62.7 96.3l4.3-6.7L53.6 80.9l-4.3 6.7C18.1 136.2 0 194 0 256s18.1 119.8 49.3 168.3l4.3 6.7 13.5-8.6-4.3-6.7C33.2 369.6 16 314.8 16 256s17.2-113.6 46.7-159.7zm528-8.6l-4.3-6.7-13.5 8.6 4.3 6.7C606.8 142.4 624 197.2 624 256s-17.2 113.6-46.7 159.7l-4.3 6.7 13.5 8.6 4.3-6.7C621.9 375.8 640 318 640 256s-18.1-119.8-49.3-168.3z'
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fast',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      'M240 16.5v479C114.9 487.2 16 383.2 16 256S114.9 24.8 240 16.5zm0-16C106.1 8.8 0 120 0 256S106.1 503.2 240 511.5c5.3 .3 10.6 .5 16 .5V496 16 0c-5.4 0-10.7 .2-16 .5z'
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fast',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      'M16 0V8 128H96V64.3 48l16 3.1L512 128V288L112 364.9 96 368V351.7 288H16V504v8H0v-8V280 136 8 0H16zm0 144V272H96V144H16zm96-76.6V348.6l104-20V87.4l-104-20zM232 90.4V325.6l144-27.7V118.1L232 90.4zm160 30.8V294.8l104-20V141.2l-104-20z'
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fast',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      'M547.7 400H28.3L156.3 186.6C184.1 140.3 234.1 112 288 112s103.9 28.3 131.7 74.6L547.7 400zm18.7 0l-133-221.7C402.7 127.2 347.6 96 288 96s-114.7 31.2-145.4 82.3L9.6 400 0 416H18.7 557.3 576l-9.6-16z'
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fast',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM100.9 128h-5l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H214.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H100.9zM104 240H88v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H216v8V496H184V344v-8h-8H144h-8v8V496H104V248v-8zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM420.9 128h-5l-2.2 4.5-84.9 176-3.5 7.2 14.4 7 3.5-7.2L425.9 144H534.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H420.9zM424 240H408v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H536v8V496H504V344v-8h-8H464h-8v8V496H424V248v-8z'
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fast',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      'M48 128a80 80 0 1 0 160 0A80 80 0 1 0 48 128zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM48 384a80 80 0 1 0 160 0A80 80 0 1 0 48 384zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c4.4 0 8 3.6 8 8v96h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V392H280c-4.4 0-8-3.6-8-8s3.6-8 8-8h96V280c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fast',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M0 208C0 93.1 93.1 0 208 0h8V8 99.2c95.7 18.7 168 103 168 204.2c0 114.9-93.1 208-208 208h-8v-8V412.2C72.3 393.5 0 309.2 0 208zM200 16.2C97.7 20.4 16 104.6 16 208c0 95.6 69.8 174.9 161.3 189.6l6.7 1.1v6.8 89.8c102.3-4.2 184-88.5 184-191.8c0-95.6-69.8-174.9-161.3-189.6l-6.7-1.1v-6.8V16.2zM192 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fast',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M264 376v8H248v-8V35.3L133.7 149.7l-5.7 5.7L116.7 144l5.7-5.7 128-128L256 4.7l5.7 5.7 128 128 5.7 5.7L384 155.3l-5.7-5.7L264 35.3V376zm-48-40H16V496H496V336H296V320H496h16v16V496v16H496 16 0V496 336 320H16 216v16zm216 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fast',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      'M128 224l-16 0-64 0-16 0 0-16 0-16L180.7 43.3 192 32l11.3 11.3L352 192l0 16 0 16-16 0-64 0-16 0 0 16 0 128 0 16-16 0-96 0-16 0 0-16 0-128 0-16zm0-16l16 0 0 16 0 144 96 0 0-144 0-16 16 0 80 0 0-9.4L192 54.6 48 198.6l0 9.4 80 0zM8 480l-8 0 0-16 8 0 368 0 8 0 0 16-8 0L8 480z'
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fast',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      'M16 80H560V188.4l4.4-4.4 0 0L576 172.4V80 64H560 16 0V80 432v16H16 326.6l2.3-16H16V80zM256 304v16H384V304H256zm224-96H256v16H480V208zM152 152H136v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0 0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8l0-16.1c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V160v-8zm410.9 71.9L366.2 420.6l-11.6 74.7L352 511.9l16.6-2.6 74.7-11.6L628.7 312.3 640 300.9l-11.3-11.3-54.5-54.5-11.3-11.3zM381.2 428.2L519 290.4l54.5 54.5L435.7 482.6l-64.5 10 10-64.5zM617.4 300.9l-32.5 32.5L530.4 279l32.5-32.5 54.5 54.5z'
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fast',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      'M128 16v96H32V16h96zM32 0H16V16v96 16H32 72v16V384H32 16v16 96 16H32h96 16V496 400 384H128 88V208.1c22.9 42.8 68 71.9 120 71.9H320v40 16h16 96 16V320 224 208H432 336 320v16 40H208c-66.3 0-120-53.7-120-120V128h40 16V112 16 0H128 32zm96 400v96H32V400h96zM336 224h96v96H336V224z'
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fast',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M368 80V432H16V80H368zM16 64H0V80 432v16H16 368h16V432 80 64H368 16z'
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fast',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      'M120 176v16l0 304h80l0-304V176h16 88v-9.4L160 22.6 16 166.6V176h88 16zM0 160L148.7 11.3 160 0l11.3 11.3L320 160v16 16H304 232 216v16l0 288v16H200 120 104V496l0-288V192H88 16 0l0-16 0-16z'
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fast',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      'M8 88H0v16H8 440h8V88h-8H8zM136 248h-8v16h8H440h8V248h-8H136zm-8 160v16h8H440h8V408h-8H136h-8zM0 440v8H16v-8l0-208 0-8H0v8V440z'
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fast',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      'M232 32h-8v8V192H48 32v16V368H8 0v16H8 32 48 80c0 53 43 96 96 96s96-43 96-96h96c0 53 43 96 96 96s96-43 96-96h32 16 24 8V368h-8H608V208 192H592 514.2l-3.9-5L390.3 35l-2.4-3H384 232zM592 208V368H558.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H270.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H48V208H592zm-98.2-16H240V48H380.1L493.8 192zM96 384a80 80 0 1 1 160 0A80 80 0 1 1 96 384zm368-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fast',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      'M560 128c0-43.3-10.1-84.2-28.1-120.5L546.3 .5C565.3 38.9 576 82.2 576 128s-10.7 89.1-29.7 127.5l-14.3-7.1c18-36.3 28.1-77.2 28.1-120.5zM16 128c0 43.3 10.1 84.2 28.1 120.5l-14.3 7.1C10.7 217.1 0 173.8 0 128S10.7 38.9 29.7 .5L44.1 7.5C26.1 43.8 16 84.7 16 128zm80 0c0-30.5 7.1-59.4 19.8-85l14.3 7.1C118.5 73.5 112 100 112 128s6.5 54.5 18.2 77.9L115.8 213C103.1 187.4 96 158.5 96 128zm384 0c0 30.5-7.1 59.4-19.8 85l-14.3-7.1C457.5 182.5 464 156 464 128s-6.5-54.5-18.2-77.9L460.2 43C472.9 68.6 480 97.5 480 128zM288 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64-48c0 32.6-24.4 59.6-56 63.5V504v8H280v-8V191.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64z'
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fast',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      'M432 48H80V192H64V48 32H80 432h16V48 192H432V48zM16 464h96V240H16V464zM0 224H16h96 16v16 48H384V240 224h16 96 16v16V464v16H496 400 384V464 432H128v32 16H112 16 0V464 240 224zM128 416H384V304H128V416zm272 48h96V240H400V464z'
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fast',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM119.6 210.5l2.5-7.6-15.2-5.1-2.5 7.6-56 168L44.9 384H56 88V504v8h8 48 8v-8V384h16V504v8h8 48 8v-8V384h32 11.1l-3.5-10.5-56-168-2.5-7.6-15.2 5.1 2.5 7.6L252.9 368H232 216 184 168 152 136 104 88 67.1l52.5-157.5zM104 496V384h32V496H104zm80-112h32V496H184V384zM95.9 128l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H214.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H100.9h-5zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM439.6 210.5l2.5-7.6-15.2-5.1-2.5 7.6-56 168L364.9 384H376h32V504v8h8 48 8v-8V384h16V504v8h8 48 8v-8V384h32 11.1l-3.5-10.5-56-168-2.5-7.6-15.2 5.1 2.5 7.6L572.9 368H552 536 504 488 472 456 424 408 387.1l52.5-157.5zM424 496V384h32V496H424zm80-112h32V496H504V384zM415.9 128l-2.2 4.5-84.9 176-3.5 7.2 14.4 7 3.5-7.2L425.9 144H534.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H420.9h-5z'
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fast',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      'M352.5 224.7l-10.4 5.3 1.9 11.5 5.1 30.4H226.9l5.1-30.4 1.9-11.5-10.4-5.3C184.8 204.9 160 168.5 160 128c0-60.1 55.5-112 128-112s128 51.9 128 112c0 40.5-24.8 76.9-63.5 96.7zM368 288l-2.7-16-5.5-33C403 216.9 432 175.4 432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 47.4 29 88.9 72.2 111l-5.5 33L208 288h16.2H351.8 368zM256 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM151.6 320h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fast',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      'M351.6 30.9L307.2 61.3C315.5 87.3 320 115.1 320 144c0 40.6-8.9 79-24.8 113.6l-12.3-11.7C296.5 214.7 304 180.2 304 144c0-31.4-5.6-61.3-15.9-89l65.1-44.6C411.4 63.1 448 139.3 448 224c0 17.8-1.6 35.3-4.7 52.2l-17.4 5.5c4-18.6 6.1-37.9 6.1-57.7c0-75.5-30.8-143.8-80.4-193.1zM258.8 289.3l-16.6-15.9L147 311.4l-7.4 3-5.9-14.9 7.4-3 100-40 4.8-1.9 3.7 3.6 88.6 84.7 147.5-46.6 5.4-1.7 3.4 4.5 72 96 4.8 6.4-12.8 9.6-4.8-6.4L485 313.3l-57.8 18.2C384.6 437.3 281 512 160 512L16 512H0V496 416 400H16 48c87.4 0 164.6-43.8 210.8-110.7zm148.2 48.7l-68.6 21.7-4.5 1.4-3.4-3.3-59.9-57.3C221.3 370.3 140 416 48 416H16v80l144 0c109.5 0 203.9-64.7 247.1-158.1z'
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fast',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      'M8 0H0V8 216v3l2 2.3L64 291V496v8H80v-8V288v-3l-2-2.3L16 213V16H96V88v8h16V88 16H240V88v8h16V88 16h80V147.7l16-13.3V8 0h-8H8zM208 176v48H144V176c0-17.7 14.3-32 32-32s32 14.3 32 32zm-80 0v48 16h16 64 16V224 176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm144 87.5L448 116.8 624 263.5V496H272V263.5zM256 256V496v16h16H624h16V496 256L448 96 256 256zm152 24h80v80H408V280zm0-16H392v16 80 16h16 80 16V360 280 264H488 408z'
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fast',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      'M16 32v8V464H504h8v16h-8H8 0v-8V40 32H16zM176 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm224 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fast',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48-336V336H144V176H304zM144 160H128v16V336v16h16H304h16V336 300.7l69.9 19.1 10.1 2.8V312 200 189.5l-10.1 2.8L320 211.3V176 160H304 144zm176 67.9l64-17.5v91.1l-64-17.5V227.9z'
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fast',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM64 88H224h8v8V248H384h8v8V416v8h-8H224h-8v-8V264H64 56v-8V96 88h8zm152 16H72V248H216V104zm16 304H376V264H232V408z'
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fast',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      'M406.8 385.8c54.9-38.5 89.2-97 89.2-161.8C496 111.1 390.6 16 256 16S16 111.1 16 224c0 64.8 34.3 123.3 89.2 161.8l6.8 4.8v8.3V496h72V448v-8h16v8 48h48V448v-8h16v8 48h48V448v-8h16v8 48h72V398.9v-8.3l6.8-4.8zM312 512H264 248 200 184 112 96V496 398.9C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9V496v16H400 328 312zM208 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fast',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      'M176 32v96H80V32h96zM80 16H64V32v96 16H80h40V248H8 0v16H8 120h16 80V368H176 160v16 96 16h16 96 16V480 384 368H272 232V264H604.7l-66.3 66.3-5.7 5.7L544 347.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80-5.7-5.7L532.7 176l5.7 5.7L604.7 248H360V144h40 16V128 32 16H400 304 288V32v96 16h16 40V248H136V144h40 16V128 32 16H176 80zM360 128H344 304V32h96v96H360zM176 384h96v96H176V384z'
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fast',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      'M176 32V48 64 80h16 8 16 8 16V64 48 32H224h-8H200h-8H176zm24 32h-8V48h8 16 8V64h-8H200zm-8 56h8 16 8v16h-8H200h-8V120zM32 176v16 16 16H48h8H72h8H96V208 192 176H80 72 56 48 32zm24 32H48V192h8H72h8v16H72 56zm168-32v16 16 16h16 8 16 8 16V208 192 176H272h-8H248h-8H224zm24 32h-8V192h8 16 8v16h-8H248zM128 176v16 16 16h16 8 16 8 16V208 192 176H176h-8H152h-8H128zm24 32h-8V192h8 16 8v16h-8H152zM96 120h8 16 8v16h-8H104 96V120zm224 56v16 16 16h16 8 16 8 16V208 192 176H368h-8H344h-8H320zm24 32h-8V192h8 16 8v16h-8H344zm-56-88h8 16 8v16h-8H296h-8V120zm128 56v16 16 16h16 8 16 8 16V208 192 176H464h-8H440h-8H416zm24 32h-8V192h8 16 8v16h-8H440zm-56-88h8 16 8v16h-8H392h-8V120zM288 48h8 16 8V64h-8H296h-8V48zm-88 56h-8H176v16 16 16h16 8 16 8 16V136 120 104H224h-8H200zm-96 0H96 80v16 16 16H96h8 16 8 16V136 120 104H128h-8H104zm192 0h-8H272v16 16 16h16 8 16 8 16V136 120 104H320h-8H296zm96 0h-8H368v16 16 16h16 8 16 8 16V136 120 104H416h-8H392zM296 32h-8H272V48 64 80h16 8 16 8 16V64 48 32H320h-8H296zM112 431.8V421.7l-9.1-4.3C51.5 393 16 340.6 16 280v-8H496v8c0 60.6-35.5 113-86.9 137.4l-9.1 4.3v10.1V464H112V431.8zM512 256H496 16 0v16 8c0 67 39.2 124.9 96 151.8V464v16h16H400h16V464 431.8c56.8-27 96-84.8 96-151.8v-8V256z'
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fast',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      'M184 254.6L96.5 501.3l15.1 5.4L184 302.5V440v8h16v-8V257.4l41.9-118.1c12.4-7.2 26.8-11.3 42.1-11.3c46.4 0 84 37.6 84 84V440v8h16v-8V212c0-55.2-44.8-100-100-100c-12.2 0-23.8 2.2-34.6 6.1L287.5 10.7 272.5 5.3 228.7 128.7c-16.1 10.7-29 26-36.7 44.1C176.7 137 141.3 112 100 112c-35.2 0-66.2 18.2-84 45.7V112H0V212v12V440v8H16v-8V224 212c0-46.4 37.6-84 84-84s84 37.6 84 84v42.6zm16-45.2c.5-18.2 6.9-34.9 17.2-48.4L200 209.4z'
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fast',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      'M182.9 346.8l0 0 0 0 .2-.1 .9-.7c.8-.6 2.1-1.5 3.8-2.8c3.3-2.5 8.1-6.2 13.9-11c11.6-9.6 26.9-23.6 42.3-40.8c31.1-35 60-81.3 60-131.4c0-79.5-64.5-144-144-144S16 80.5 16 160c0 50.1 28.8 96.4 60 131.4c15.3 17.3 30.7 31.2 42.3 40.8c5.8 4.8 10.6 8.5 13.9 11c1.7 1.2 2.9 2.2 3.8 2.8l.9 .7 .2 .1 0 0 0 0 0 0 0 0 7.5 5.2h30.8l7.5-5.2 0 0 0 0zM118.8 432h82.3l-23.3-64H176 144h-1.9l-23.3 64zm99.3 0l5.8 16H207 113 96l5.8-16L128 360s-128-88-128-200C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 200-128 200l26.2 72zM324.7 261.8c4.3-8.2 8.3-16.8 11.8-25.6c4.1 45.4 30.8 87.1 59.4 119.2c15.3 17.3 30.7 31.2 42.3 40.8c5.8 4.8 10.6 8.5 13.9 11c1.7 1.2 2.9 2.2 3.8 2.8l.9 .7 .2 .1 0 0 0 0 0 0 0 0 7.5 5.2h30.8l7.5-5.2 0 0 0 0 0 0 0 0 .2-.1 .9-.7c.9-.6 2.1-1.5 3.8-2.8c3.3-2.5 8.1-6.2 13.9-11c11.6-9.6 26.9-23.6 42.3-40.8c31.1-35 60-81.3 60-131.4c0-79.5-64.5-144-144-144c-55.7 0-104.1 31.7-128 78c-.1-9.2-.8-18.2-2.2-27c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 112-128 200-128 200l26.2 72 5.8 16H527 433 416l5.8-16L448 424s-100.1-68.8-123.3-162.2zM462.1 432l-23.3 64h82.3l-23.3-64H496 464h-1.9zM96 152v8H80v-8c0-39.8 32.2-72 72-72h8V96h-8c-30.9 0-56 25.1-56 56zm320 64v8H400v-8c0-39.8 32.2-72 72-72h8v16h-8c-30.9 0-56 25.1-56 56z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fast',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      'M272 240H375.2c-5.3 5-10.3 10.4-15 16H272 256V240 .6c5.6-.4 11.3-.6 17.1-.6c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-1.7 0-3.3 0-4.9 .1C469.5 91.4 380.1 16 273.1 16L272 16V240zm-32 48h99.2c-2.7 5.2-5.1 10.5-7.2 16H224 208V288 50.3C99.5 65.8 16 159.2 16 272c0 123.7 100.3 224 224 224c40.1 0 77.8-10.6 110.4-29.1c3 4.5 6.3 8.8 9.7 12.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 150.3 90.6 49.8 208 34.1c5.3-.7 10.6-1.2 16-1.6v16V272v16h16zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7 8H488v-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9l-7.7-2.3 4.5-15.3 7.7 2.3c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280v-8h16v8 16.4c10.2 .8 20.4 2.8 29.8 5l7.8 1.8-3.7 15.6-7.8-1.8c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fast',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M133.7 42.3L128 36.7l-5.7 5.7-104 104L12.7 152 24 163.3l5.7-5.7L120 67.3V472v8h16v-8V67.3l90.3 90.3 5.7 5.7L243.3 152l-5.7-5.7-104-104zM296 464h80 8V448h-8H296h-8v16h8zm0-144H440h8V304h-8H296h-8v16h8zm0-128H504h8V176h-8H296h-8v16h8zm0-128H568h8V48h-8H296h-8V64h8z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fast',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      'M190.8 0H174.6l1.6 9.3 0 0 23.1 138.8c.5 3 .8 6.1 .8 9.2V168c0 30.9-25.1 56-56 56H80c-30.9 0-56-25.1-56-56V157.3c0-3.1 .3-6.2 .8-9.2L35.9 81.3l6-36 6-36 0 0L49.4 0H33.2L32.1 6.7l0 0-6 36-6 36L9 145.5c-.7 3.9-1 7.9-1 11.8V168c0 39.8 32.2 72 72 72h24V504v8h16v-8V240h24c39.8 0 72-32.2 72-72V157.3c0-4-.3-7.9-1-11.8L191.9 6.7l0 0L190.8 0zM143.6 0h-16l.4 8.4 8 160 .4 7.6h16l-.4-8.4-8-160L143.6 0zM96.4 0h-16L80 7.6l-1 20-1 20-2 40-4 80-.4 8.4h16l.4-7.6 4-80 2-40 1-20 1-20L96.4 0zM304 176c0-67.7 24.2-107.4 48.9-130.3c12.5-11.6 25.5-19.2 36-23.8c5.3-2.3 9.9-3.8 13.4-4.8c3.7-1 5.6-1.1 5.7-1.1l0 0h8V336H304V176zM432 336V16 0H416h-8C392 0 288 32 288 176V336v16h16H416V504v8h16v-8V352v-8-8z'
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fast',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      'M92.1 384.1c70.7 90.5 201.4 106.6 292 35.8c22.9-17.9 41.1-39.7 54.2-63.7l14 7.7c-14.2 25.8-33.7 49.3-58.4 68.6c-97.5 76.2-238.3 58.9-314.4-38.6S20.6 155.7 118.1 79.5c89.8-70.2 216.4-61 295.3 17.1l-11.3 11.3c-73.3-72.5-190.8-81-274.2-15.8c-90.5 70.7-106.6 201.4-35.8 292zM475 35l11.3 11.3L504 64V192v16H488 360l-17.7-17.7L331 179l11.3-11.3L463.7 46.3 475 35zm0 22.6L353.7 179l13 13H488V70.6l-13-13z'
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fast',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M437.7 133.7l5.7-5.7-5.7-5.7-104-104L328 12.7 316.7 24l5.7 5.7L412.7 120 8 120H0v16H8l404.7 0-90.3 90.3-5.7 5.7L328 243.3l5.7-5.7 104-104zM10.3 389.7l104 104 5.7 5.7L131.3 488l-5.7-5.7L35.3 392 440 392h8V376h-8L35.3 376l90.3-90.3 5.7-5.7L120 268.7l-5.7 5.7-104 104L4.7 384l5.7 5.7z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fast',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      'M496.8 4.4L309.6 378.8l-299.6-81L0 295.2v10.4V376v16 48 16 48 8H8 256h4.9l2.2-4.4L321 391.8 511.2 11.6 496.8 4.4zM16 456H80h8V440H80 16V392H80h8V376H80 16V316l286.3 77.4L251.1 496H16V456z'
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fast',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      'M128 0h8 64 8V8 72h24V8 0h8 56 8V8 72h32V8 0h8 56 8V8 72h24V8 0h8 64 8V8 224h48V168v-8h8 64 8v8V504v8h-8H8 0v-8V168v-8H8 72h8v8 56h48V8 0zm16 240h-8-8H72 64v-8V176H16V496H240V392c0-44.2 35.8-80 80-80s80 35.8 80 80V496H624V176H576v56 8h-8H512h-8-8H144zm352-16V16H448V80v8h-8H400h-8V80 16H352V80v8h-8H296h-8V80 16H248V80v8h-8H200h-8V80 16H144V224H496zM384 392c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H384V392z'
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fast',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      'M339.8 320l-4.8 6.7C303 371.1 250.9 400 192 400c-22.6 0-44.2-4.3-64-12V328v-8H112v8 52.8C55 351.7 16 292.4 16 224C16 126.8 94.8 48 192 48c58.9 0 111 28.9 143 73.3l4.8 6.7H348 464c53 0 96 43 96 96l0 8 0 88H348h-8.2zm162.9 16H560l0 89.5L502.6 336zM348 336H483.6l77.6 121.1 14.7 23V452.8L576 336V320 224c0-61.9-50.1-112-112-112H348c-34.9-48.5-91.7-80-156-80C86 32 0 118 0 224c0 77.5 45.9 144.3 112 174.6V472v8h16v-8V405.1c20 7.1 41.6 10.9 64 10.9c10.9 0 21.6-.9 32-2.7V472v8h16v-8V410c44.1-11.4 82.1-38 108-74zm100-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fast',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      'M8 0H0V8 272v8 8V440v8H8 313.8c-3-5.2-5.8-10.5-8.3-16H16V288H299.5c2-5.4 4.1-10.8 6.5-16H16V16H432V132.1l16-10V8 0h-8H8zM288 352H88 80v16h8H288.7c-.4-5.3-.7-10.6-.7-16zM500.7 212.8L448 160.2c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-20.7 20.7L512 224.2l-11.3-11.3zM576 422.6c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 18.2 5.8 35.1 15.7 49.2C361.3 445.9 336 402 336 352.2c0-39.7 19-77.6 44.5-109.6c21.3-26.7 46.2-48.2 65.4-61.8l54.7 54.7L512 246.8l11.3-11.3L544.8 214C609.1 272.5 624 332 624 352.2c0 49.8-25.3 93.7-63.7 119.6c9.9-14.1 15.7-31 15.7-49.2zm-96 73.6c-45.2 0-80-34-80-73.6c0-28.5 20-58.2 43.5-82.5c11.4-11.8 22.8-21.5 31.4-28.3c1.8-1.5 3.5-2.8 5.1-3.9c1.5 1.2 3.2 2.5 5.1 3.9c8.6 6.8 20 16.5 31.4 28.3C540 364.4 560 394 560 422.6c0 39.6-34.8 73.6-80 73.6z'
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fast',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      'M480 80V288H464V80H80V288H64V80 64H80 464h8 8 80 16V80 288H560V80H480zM0 320H8 32 48 592h16 24 8v16h-8H608v96 16H592 48 32V432 336H8 0V320zm48 16v96H592V336H48z'
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fast',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      'M64 0L48 56 0 224v16 16H16 48 64V240 58.2 0zM48 114.2V240H16V226.2l32-112zM288 0S96 80 96 224c0 80-32 192-32 192l192 96h16V496 264l-96-40V208h16H384h16v16l-96 40V496v16h16l192-96s-32-112-32-192C480 80 288 0 288 0zM493.1 407.5L320 494.1V274.7l86.2-35.9 9.8-4.1V224 208 192H400 176 160v16 16 10.7l9.8 4.1L256 274.7V494.1L82.9 407.5c.5-1.9 1.1-4 1.6-6.3c3-11.9 7.1-28.6 11.2-47.9C103.7 315 112 265.7 112 224c0-64.5 43.2-116.4 89.9-153.5c23.1-18.3 46.2-32.3 63.7-41.7c8.7-4.7 15.9-8.3 20.9-10.6l1.4-.7 1.4 .7c5 2.4 12.2 5.9 20.9 10.6c17.4 9.4 40.6 23.5 63.7 41.7c46.8 37 89.9 88.9 89.9 153.5c0 41.7 8.3 91 16.3 129.3c4.1 19.3 8.1 36 11.2 47.9c.6 2.3 1.1 4.4 1.6 6.3zM528 56L512 0V58.2 240v16h16 32 16V240 224L528 56zm32 170.2V240H528V114.2l32 112z'
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fast',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-5.1-400l-2.2 4.6L129.8 368h17.7l30.3-64H334.2l30.3 64h17.7l-119-251.4-2.2-4.6H250.9zm75.7 176H185.3L256 138.7 326.7 288z'
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fast',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM240 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fast',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      'M107.3 219.3l1.4-1.4 1-1.7 45.9-76.6 76.6-45.9 1.7-1 1.4-1.4 36.9-36.9C296.8 29.8 330.2 16 364.9 16C437.3 16 496 74.7 496 147.1c0 34.8-13.8 68.1-38.4 92.7l-4.9 4.9-1.6 1.6-1.1 2L372.7 387.4l-107 45.8-2.8 1.2-2.2 2.2-20.9 20.9c-24.6 24.6-57.9 38.4-92.7 38.4C74.7 496 16 437.3 16 364.9c0-34.8 13.8-68.1 38.4-92.7l52.9-52.9zM224 80l-80 48L96 208 43.1 260.9C15.5 288.5 0 325.9 0 364.9C0 446.2 65.8 512 147.1 512c39 0 76.4-15.5 104-43.1L272 448l112-48 80-144 4.9-4.9c27.6-27.6 43.1-65 43.1-104C512 65.8 446.2 0 364.9 0c-39 0-76.4 15.5-104 43.1L224 80zm128 80v24h24V160H352zM184 224H160v24h24V224zM152 384H128v24h24V384z'
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fast',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM160 208h-8v8 64H88 80v8 64 8h8 64v64 8h8 64 8v-8V360h64 8v-8V288v-8h-8H232V216v-8h-8H160zm8 80V224h48v64 8h8 64v48H224h-8v8 64H168V352v-8h-8H96V296h64 8v-8z'
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fast',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      'M40 0V8 504v8H24v-8V8 0H40z'
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fast',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      'M256 57.1L164.3 7.7 150 0l-4.7 15.6-29.9 99.7L15.6 145.3 0 150l7.7 14.4L57.1 256 7.7 347.7 0 362l15.6 4.7 99.7 29.9 29.9 99.7L150 512l14.4-7.7L256 454.9l91.7 49.4L362 512l4.7-15.6 29.9-99.7 99.7-29.9L512 362l-7.7-14.4L454.9 256l49.4-91.7L512 150l-15.6-4.7-99.7-29.9L366.7 15.6 362 0 347.7 7.7 256 57.1zm96.3-33.7l29 96.6 2.5 8.3 8.3 2.5 96.6 29-47.8 88.8-4.1 7.6 4.1 7.6 47.8 88.8-96.6 29-8.3 2.5-2.5 8.3-29 96.6-88.8-47.8-7.6-4.1-7.6 4.1-88.8 47.8-29-96.6-2.5-8.3-8.3-2.5-96.6-29 47.8-88.8 4.1-7.6-4.1-7.6L23.4 159.6l96.6-29 8.3-2.5 2.5-8.3 29-96.6 88.8 47.8 7.6 4.1 7.6-4.1 88.8-47.8zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 210c-45.3 0-82-36.7-82-82c0-40.2 28.9-73.6 67.1-80.6c-12.9 16.2-20.7 36.7-20.7 59c0 45.9 32.6 83.9 75.9 93.1C284.4 334.2 270.6 338 256 338zM236.4 234.4c0-24 10.8-45.4 27.7-60c5.9-5 12.5-9.2 19.7-12.4c-7.9-2.3-16.2-3.7-24.8-4c-1 0-2 0-3 0c-54.1 0-98 43.9-98 98s43.9 98 98 98c24.9 0 47.6-9.3 64.9-24.6c6.2-5.5 11.7-11.7 16.3-18.6c-6.7 1.8-13.7 2.7-20.9 2.7c-.6 0-1.2 0-1.9 0c-43.3-1-78.1-36-78.1-79.1z'
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fast',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      'M16 8V0H0V8 160v1.7l.7 1.6 112 248 2.1 4.7H120 232v80H104 96v16h8H232h16H376h8V496h-8H248V416H392h5.9l1.8-5.6 40-128 3.2-10.4H432 72 67.4L38.5 208H344h8V192h-8H32h-.8L16 158.3V8zM125.2 400L74.6 288H421.1l-35 112h-261z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fast',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M8 32H0v8V240v8 8V472v8H8 200c66.3 0 120-53.7 120-120c0-56.7-39.3-104.2-92.1-116.7C263.6 224.5 288 187.1 288 144c0-61.9-50.1-112-112-112H8zM176 240H16V48H176c53 0 96 43 96 96s-43 96-96 96zM16 256H176h24c57.4 0 104 46.6 104 104s-46.6 104-104 104H16V256z'
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fast',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      'M432 464V48H16V464H432zm16 16H432 16 0V464 48 32H16 432h16V48 464v16zM163.3 332.7l25.4-25.4L200 296l-11.3-11.3-73.4-73.4L104 200l11.3-11.3 41.4-41.4L168 136l11.3 11.3 73.4 73.4L264 232l11.3-11.3 25.4-25.4L312 184l11.3 11.3L336 208V352v16H320 176l-12.7-12.7L152 344l11.3-11.3zm48-48L222.6 296l-11.3 11.3L174.6 344l8 8H320V214.6l-8-8-36.7 36.7L264 254.6l-11.3-11.3L168 158.6 126.6 200l84.7 84.7z'
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fast',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      'M80 48H560V352h16V48 32H560 80 64V48 352H80V48zM16 425.4V400H624v25.4L585.4 464H54.6L16 425.4zM624 384H16 0v16 32l48 48H592l48-48V400 384H624zM288 104h-8v8 64H216h-8v8 64 8h8 64v64 8h8 64 8v-8V256h64 8v-8V184v-8h-8H360V112v-8h-8H288zm8 80V120h48v64 8h8 64v48H352h-8v8 64H296V248v-8h-8H224V192h64 8v-8z'
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fast',
    iconName: 'flying-disc',
    icon: [
      448,
      512,
      [],
      'e3a9',
      
      'M413 67c21.1 21.1 25.8 60.5 8.3 113.1c-17.2 51.6-54.5 110.8-108.4 164.7s-113.2 91.3-164.7 108.4C95.5 470.8 56.1 466.1 35 445s-25.8-60.5-8.3-113.1c.2-.7 .5-1.5 .7-2.2c.8 15.3 5.7 32.9 20.3 47.5c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-14.5-14.5-32.2-19.4-47.5-20.3c.7-.3 1.5-.5 2.2-.7C352.4 41.2 391.9 45.9 413 67zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.1 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zm11.9 10.7c5.8-6.4 11.9-12.8 18.2-19.1c6.3-6.3 12.7-12.4 19.1-18.3C182 124 210.3 104 236 91.3c15.7-7.8 32-13.7 47.5-15.4c15.2-1.7 35.2 .1 50.3 15.2s16.9 35.1 15.2 50.3c-1.8 15.5-7.7 31.8-15.4 47.5c-15.7 31.6-42.4 67.4-75.9 100.9s-69.2 60.2-100.9 75.9c-15.7 7.8-32 13.7-47.5 15.4c-15.2 1.7-35.2-.1-50.3-15.2S42.1 330.7 43.8 315.5c1.8-15.5 7.7-31.8 15.4-47.5C72 242.3 92 213.9 116.9 186.3z'
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fast',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM80 272H368v96H80V272zM64 256v16 96 16H80 368h16V368 272 256H368 80 64z'
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fast',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      'M112 32h-6l-1.7 5.7L58 192H16 0v16V384v16 64 16H16 80 96V464 400H322.9c-1-5.3-1.7-10.6-2.2-16H96 80 16V208H422.6c10.4-4.8 21.4-8.6 32.8-11.3l-47.7-159L406 32h-6H112zM16 400H80v64H16V400zM437.2 192H432 74.8L118 48H394l43.2 144zM80 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm368-48a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24.8-231.2l-18.3 17.5-84 80L404 392h20 51.8l-7.7 38.4-5 24.8 18.3-17.5 84-80L580 344H560 508.2l7.7-38.4 5-24.8zM444 376l51.2-48.8-4.6 23.2-1.9 9.6h9.8H540l-51.2 48.8 4.6-23.2 1.9-9.6h-9.8H444z'
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fast',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      'M288 16H224V42.4s0 0 0 0V58.5s0 0 0 0V80h64V16zM208 45.4V16 0h16 64 16V16 45.4C384.8 63.7 448.3 127.2 466.6 208H496h16v16 64 16H496 466.6C448.3 384.8 384.8 448.3 304 466.6V496v16H288 224 208V496 466.6C127.2 448.3 63.7 384.8 45.4 304H16 0V288 224 208H16 45.4C63.7 127.2 127.2 63.7 208 45.4zM61.8 208H80 96v16 64 16H80 61.8C79.5 375.9 136.1 432.5 208 450.2V432 416h16 64 16v16 18.2c71.9-17.7 128.5-74.3 146.2-146.2H432 416V288 224 208h16 18.2C432.5 136.1 375.9 79.5 304 61.8V80 96H288 224 208V80 61.8C136.1 79.5 79.5 136.1 61.8 208zm-3.3 80H80V224H16v64H42.4s0 0 0 0H58.5s0 0 0 0zM224 469.6V496h64V432H224v21.5s0 0 0 0v16.2s0 0 0 0zM469.6 288H496V224H432v64h21.5s0 0 0 0h16.2s0 0 0 0z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fast',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H208V312v-8h8H360h8v8V496H496V204.8L288 26.5zM224 496H352V320H224V496z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fast',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156 76H420V420h24v24zm-4-164v8 96 8H424v-8V288v-8h16z'
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fast',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      'M16 48v80h96 16v16V368v16H112 16v80H312V351.7c-49.3-4.1-88-45.3-88-95.7s38.7-91.6 88-95.7V48H16zM328 351.7V464H624V384H528 512V368 144 128h16 96V48H328V160.3c49.3 4.1 88 45.3 88 95.7s-38.7 91.6-88 95.7zm0-175.3V335.6c40.4-4 72-38.1 72-79.6s-31.6-75.6-72-79.6zm-16 0c-40.4 4-72 38.1-72 79.6s31.6 75.6 72 79.6V176.4zM16 144V368h96V144H16zM528 368h96V144H528V368zM0 32H16 624h16V48 464v16H624 16 0V464 48 32z'
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fast',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      'M0 56V72H8 440h8V56h-8H8 0zM192 184v16h8H440h8V184h-8H200h-8zm8 128h-8v16h8H440h8V312h-8H200zM0 440v16H8 440h8V440h-8H8 0zM13.3 246L0 256l13.3 10L112 340l16 12V332 180 160l-16 12L13.3 246zM112 192V320L26.7 256 112 192z'
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fast',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM340 428c-24-12.6-52.9-20-84-20c-31.1 0-60 7.4-84 20l-13.1 6.9 1.4-14.8C165 372.7 206.3 336 256 336s91 36.7 95.7 84.2l1.4 14.8L340 428zm-84-76c-36.4 0-66.9 23.3-76.7 55c23-9.6 49.1-15 76.7-15c27.6 0 53.7 5.4 76.8 15c-9.8-31.7-40.3-55-76.8-55zm-95.6-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200.5 143.5l-8 .5c-32.5 2-61.6 16.5-82.7 38.7l-5.5 5.8-11.6-11 5.5-5.8c23.7-25.1 56.6-41.4 93.3-43.7l8-.5 1 16zm119 .5l-8-.5 1-16 8 .5c36.7 2.3 69.6 18.6 93.3 43.7l5.5 5.8-11.6 11-5.5-5.8C381.1 160.5 352 146 319.5 144z'
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fast',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      'M256 0c-19.6 0-38.7 2.2-57 6.4l-7.8 1.8 3.5 15.6 7.8-1.8c17.2-3.9 35.1-6 53.4-6s36.3 2.1 53.4 6l7.8 1.8 3.5-15.6L313 6.4C294.7 2.2 275.6 0 256 0zM128.3 52.8l6.8-4.3L126.5 35l-6.8 4.3C87.3 59.7 59.7 87.3 39.2 119.8L35 126.5l13.5 8.5 4.3-6.8c19.2-30.5 45.1-56.4 75.5-75.5zM392.2 39.2L385.5 35l-8.5 13.5 6.8 4.3c30.5 19.2 56.4 45.1 75.6 75.5l4.3 6.8 13.5-8.5-4.3-6.8c-20.5-32.5-48.1-60.1-80.6-80.6zM22 202.6l1.8-7.8L8.1 191.2 6.4 199C2.2 217.3 0 236.4 0 256s2.2 38.7 6.4 57l1.8 7.8 15.6-3.5L22 309.4c-3.9-17.2-6-35.1-6-53.4s2.1-36.3 6-53.4zM505.6 199l-1.8-7.8-15.6 3.5 1.8 7.8c3.9 17.2 6 35.1 6 53.4s-2.1 36.3-6 53.4l-1.8 7.8 15.6 3.5 1.8-7.8c4.2-18.3 6.4-37.4 6.4-57s-2.2-38.7-6.4-57zM52.8 383.7l-4.3-6.8L35 385.5l4.3 6.8c20.5 32.5 48.1 60.1 80.6 80.6l6.8 4.3 8.5-13.5-6.8-4.3c-30.5-19.2-56.4-45.1-75.5-75.6zm420 8.5l4.3-6.8-13.5-8.5-4.3 6.8c-19.2 30.5-45.1 56.4-75.6 75.6l-6.8 4.3 8.5 13.5 6.8-4.3c32.5-20.5 60.1-48.1 80.6-80.6zM202.6 490l-7.8-1.8-3.5 15.6 7.8 1.8c18.3 4.2 37.4 6.4 57 6.4s38.7-2.2 57-6.4l7.8-1.8-3.5-15.6-7.8 1.8c-17.2 3.9-35.1 6-53.4 6s-36.3-2.1-53.4-6zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM184 344h-8v16h8H328h8V344h-8H184z'
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fast',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      'M16 48v64H560V48H16zm0 80V464H560V128H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM192 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM102.2 416H85.3L112 336H272l26.7 80H281.8l-21.3-64H123.5l-21.3 64zM352 224h8H504h8v16h-8H360h-8V224zm0 64h8H504h8v16h-8H360h-8V288zm0 64h8H504h8v16h-8H360h-8V352z'
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fast',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440h8V496h-8H416V416h24 8v-8V8 0h-8H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM56 400c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V400H56zm76.7-178.8l-7.6 14.1 7 3.8 90.9 49-90.9 49-7 3.8 7.6 14.1 7-3.8 100.2-54 100.2 54 7 3.8 7.6-14.1-7-3.8-90.9-49 90.9-49 7-3.8-7.6-14.1-7 3.8L240 278.9 139.8 225l-7-3.8zM168 136c0-29.4 30.5-56 72-56s72 26.6 72 56c0 17.5-10.5 33.8-28.1 44.3l-3.9 2.3v4.5V208H200V187.2v-4.5l-3.9-2.3C178.5 169.8 168 153.5 168 136zm72-72c-46.8 0-88 30.7-88 72c0 22.9 12.9 42.7 32 55.6V216v8h8 96 8v-8V191.6c19.1-12.9 32-32.7 32-55.6c0-41.3-41.2-72-88-72zm-32 88a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fast',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      'M104 56H96V72h8H344h8V56h-8H104zM8 184H0v16H8 440h8V184h-8H8zM96 312v16h8H344h8V312h-8H104 96zM8 440H0v16H8 440h8V440h-8H8z'
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fast',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM168 344h-8v16h8H344h8V344h-8H168z'
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fast',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      'M64 16v96h96V16H64zM48 0H64h96 16V16v96 16H160 120V384h40 16v16 96 16H160 64 48V496 400 384H64h40V128H64 48V112 16 0zM458.3 149.7L400 91.3l-58.3 58.3-11.3-11.3L388.7 80 330.3 21.7l11.3-11.3L400 68.7l58.3-58.3 11.3 11.3L411.3 80l58.3 58.3-11.3 11.3zM400 192c4.4 0 8 3.6 8 8V384h40 16v16 96 16H448 352 336V496 400 384h16 40V200c0-4.4 3.6-8 8-8zM352 496h96V400H352v96zM160 400H64v96h96V400z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fast',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      'M48 16V496H336V16H48zM32 0H48 336h16V16 496v16H336 48 32V496 16 0zM144 432h96 8v16h-8H144h-8V432h8z'
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fast',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      'M400 80L368 99.2V144c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2L48 80V48L224 0 400 48V80zM352 99.2V90.1l7.8-4.7L384 70.9V60.2L224 16.6 64 60.2V70.9L88.2 85.5 96 90.1v9.1 35.6c19.2 9.7 63.8 25.2 128 25.2s108.8-15.5 128-25.2V99.2zM96.3 183.3c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.9 .1-5.8 .3-8.7zM216 430.4l-2.9-2.6L148.4 368H59.9L21.5 496H216V430.4zm16 0V496H426.5L388.1 368H299.6l-64.7 59.8-2.9 2.6zM224 416l69.3-64H400l43.2 144 4.8 16H431.3 224 16.7 0l4.8-16L48 352H154.7L224 416zm96 16h8 48 8v16h-8H328h-8V432zM163.6 64.8L224 95.1l60.4-30.2 7.2-3.6 7.2 14.3-7.2 3.6-64 32-3.6 1.8-3.6-1.8-64-32-7.2-3.6 7.2-14.3 7.2 3.6z'
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fast',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      'M497.6 265.6L512 256l-14.4-9.6L240 74.7 224 64V83.2 198.4L16 73.6 0 64V82.7 429.3 448l16-9.6L224 313.6V428.8 448l16-10.7L497.6 265.6zM224 294.9L16 419.7V92.3L224 217.1v77.9zm16 123.2V93.9L483.2 256 240 418.1z'
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fast',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      'M264 8V96v8H248V96 8 0h16V8zm0 408v88 8H248v-8V416v-8h16v8zM-8 248H0 96h8v16H96 0-8V248zm424 0h88 8v16h-8H416h-8V248h8zM441.5 83.5l-5.7 5.7-62.2 62.2L368 157l-11.3-11.3 5.7-5.7 62.2-62.2 5.7-5.7 11.3 11.3zM147.3 377.6L85.1 439.8l-5.7 5.7L68.2 434.2l5.7-5.7L136 366.3l5.7-5.7L153 372l-5.7 5.7zM73.8 66.5l5.7 5.7L147.3 140l5.7 5.7L141.7 157l-5.7-5.7L68.2 83.5l-5.7-5.7L73.8 66.5zM373.6 366.3l62.2 62.2 5.7 5.7-11.3 11.3-5.7-5.7-62.2-62.2-5.7-5.7L368 360.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fast',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      'M26 128H358L329.2 496H54.8L26 128zm-1.2-16L17.3 16H366.7l-7.5 96H24.8zM40 512H344L382.7 16 384 0H368 16 0L1.2 16 40 512z'
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fast',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm75.3 104l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L368 348.7l5.7 5.7L416 396.7l74.3-74.3 5.7-5.7L507.3 328z'
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fast',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      'M256 48c65.3 0 123.6 30.1 161.7 77.2L456 176H376h-8v16h8 96 8v-8V88 80H464v8 72.1l-33.6-44.6 0 0-.2-.2C389.2 64.5 326.4 32 256 32C155.4 32 70.3 98.3 42 189.6l15.3 4.7C83.5 109.6 162.6 48 256 48zm8 88v-8H248v8V296v8h16v-8V136zm8 200H240v32h32V336zM32 424v8H48v-8V349.8l35.2 46.8 0 0 .2 .2C124.4 447.5 187.2 480 257.6 480c100.6 0 185.7-66.3 214-157.6l-15.3-4.7C430.1 402.4 351 464 257.6 464c-65.3 0-123.6-30.1-161.7-77.2L57.7 336H136h8V320h-8H40 32v8 96z'
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fast',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      'M210 17.5C222.1 6.2 238 0 254.6 0h.9C291.1 0 320 28.9 320 64.6c0 17.1-6.8 33.5-18.9 45.7L62.2 349.1C53.1 358.2 48 370.6 48 383.4C48 410.3 69.7 432 96.6 432c12.9 0 25.2-5.1 34.3-14.2L401.8 146.9c12.1-12.1 28.5-18.9 45.7-18.9c35.7 0 64.6 28.9 64.6 64.6c0 17.1-6.8 33.5-18.9 45.7L356.9 374.5c-13.4 13.4-20.9 31.5-20.9 50.3v2.6c0 37.9 30.7 68.6 68.6 68.6c11.2 0 22.3-3.1 31.9-8.8l63.4-38 8.2 13.7-63.4 38c-12.1 7.3-26 11.1-40.2 11.1c-46.7 0-84.6-37.9-84.6-84.6v-2.6c0-23.1 9.2-45.3 25.5-61.7L481.8 226.9c9.1-9.1 14.2-21.5 14.2-34.3c0-26.8-21.7-48.6-48.6-48.6c-12.9 0-25.2 5.1-34.3 14.2L142.2 429.1C130.1 441.2 113.7 448 96.6 448C60.9 448 32 419.1 32 383.4c0-17.1 6.8-33.5 18.9-45.7L289.8 98.9c9.1-9.1 14.2-21.5 14.2-34.3C304 37.7 282.3 16 255.4 16h-.9c-12.5 0-24.5 4.7-33.6 13.2L13.4 221.9 2.6 210.1 210 17.5z'
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fast',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      'M56.5 274.7l-4.7 9.3L28.9 329.9l76-15.2 5.1-1 4.7 2.2C142.3 328.7 174.1 336 208 336c108.6 0 192-74 192-160s-83.4-160-192-160S16 90 16 176c0 33.4 12.3 64.7 33.9 90.7l6.7 8zM19.9 348L0 352l9.1-18.1 28.5-57C13.9 248.3 0 213.5 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.2 0-70.3-7.8-99.9-21.6L19.9 348zm211.6 35c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c33.9 0 65.7-7.3 93.2-20.1l4.7-2.2 5.1 1 76 15.2-22.9-45.8-4.7-9.3 6.7-8c21.5-26 33.9-57.2 33.9-90.7c0-81.7-75.3-152.6-176-159.5l0-.5c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9l28.5 57L640 512l-19.9-4-88.2-17.6C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM143.3 125c0-23.2 18.8-42 42-42h39.8c26.2 0 47.5 21.3 47.5 47.5c0 16-8 30.9-21.4 39.7L216 193.4V210v8H200v-8V189.1v-4.3l3.6-2.4 38.9-25.6c8.8-5.8 14.2-15.7 14.2-26.3c0-17.4-14.1-31.5-31.5-31.5H185.3c-14.4 0-26 11.6-26 26l0 4.6-16 0 0-4.6zm53.3 107.7h22.7v22.7H196.7V232.7z'
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fast',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM72 240H64v16h8H312h8V240h-8H72zm304 0h-8v16h8 64 8V240h-8H376zM104 304H96v16h8 64 8V304h-8H104zm128 0h-8v16h8H408h8V304h-8H232z'
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fast',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      'M211.8 159.1l11.3 11.3L341.6 288.9l11.3 11.3L372.7 320l5.7 5.7 5.7 5.7L395.3 320l-5.7-5.7-5.7-5.7-8.5-8.5-11.3-11.3 11.3-11.3L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0L234.4 136.5l-11.3 11.3-11.3-11.3-8.5-8.5-5.7-5.7-5.7-5.7L180.7 128l5.7 5.7 5.7 5.7 19.8 19.8zm259.7 0L352.9 277.6 234.4 159.1 352.9 40.5c32.7-32.7 85.8-32.7 118.5 0s32.7 85.8 0 118.5zM32 344v88L0 480l32 32 48-32h88L327.7 320.3 316.4 309l-155 155H80 75.2l-4 2.7L34 491.4 20.6 478l24.7-37.1 2.7-4V432 350.6l155-155-11.3-11.3L32 344z'
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fast',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      'M528 240.4l12 3.1c48.3 12.4 84 56.3 84 108.5V464H512 144 16V336c0-55.7 35.6-103.1 85.3-120.7l10.7-3.8V200.2 192c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2l8.5 14.8 14.2-9.5c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80v36 12.4zM96 200.2C40.1 220 0 273.3 0 336V464v16H16 144 512 624h16V464 352c0-59.6-40.8-109.8-96-124V192c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192v8.2zM296 192v16h8 8v72 8h16v-8V200v-8h-8H304h-8zm-120 0h-8v8 80 8h8 64 8v-8V200v-8h-8H176zm8 80V208h48v64H184zm208-80v8 80 8h8 64 8v-8V200v-8h-8H400h-8zm16 16h48v64H408V208zm8 112h-8v16h8 8v72 8h16v-8V328v-8h-8H416zm-232 0v16h8 8v72 8h16v-8V328v-8h-8H192h-8zm104 0h-8v8 80 8h8 64 8v-8V328v-8h-8H288zm8 80V336h48v64H296z'
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fast',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      'M16 16V160H432V16H16zM0 168V16 0H16 432h16V16 168 496v16H432 16 0V496 168zm432 8H16V496H432V176zM80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 240V432H368V240H80zM64 224H80 368h16v16V432v16H368 80 64V432 240 224zm64 64h8H312h8v16h-8H136h-8V288z'
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fast',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      'M576 448H560 176L0 256 176 64H560h16V80 432v16zM21.7 256L183 432H560V80H183L21.7 256zm400.5-81.5l11.3 11.3-5.7 5.7L363.3 256l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L352 267.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L340.7 256l-64.6-64.6-5.7-5.7 11.3-11.3 5.7 5.7L352 244.7l64.6-64.6 5.7-5.7z'
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fast',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fast',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zm72 40H56v8 40l-40 0H8v16h8l40 0v40 8H72v-8V424l40 0h8l0-16h-8l-40 0V368v-8zm384 8v-8H440v8 40l-40 0h-8v16h8l40 0v40 8h16v-8V424l40 0h8l0-16h-8l-40 0V368zM264 392H248v8 40l-40 0h-8v16h8l40 0v40 8h16v-8V456l40 0h8l0-16h-8l-40 0V400v-8z'
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fast',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      'M16 0V8 176H624V8 0h16V8 176v8 8V432v8 8 56 8H624v-8V448H16v56 8H0v-8V448v-8-8V192v-8-8V8 0H16zm0 432H624V192H16V432zM464 16H368v96h96V16zM368 0h96 16V16v96 16H464 368 352V112 16 0h16zM112 272v96h96V272H112zM96 256h16 96 16v16 96 16H208 112 96V368 272 256zm176 16v96h96V272H272zm-16-16h16 96 16v16 96 16H368 272 256V368 272 256z'
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fast',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      'M229.1 486.2l176-144 6.2-5.1-10.1-12.4-6.2 5.1L224 469.7 53.1 329.8l-6.2-5.1L36.7 337.1l6.2 5.1 176 144 5.1 4.1 5.1-4.1zm0-460.4L224 21.7l-5.1 4.1-176 144-6.2 5.1 10.1 12.4 6.2-5.1L224 42.3 394.9 182.2l6.2 5.1 10.1-12.4-6.2-5.1-176-144z'
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fast',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M264 8V0H248V8 356.7L133.7 242.3l-5.7-5.7L116.7 248l5.7 5.7 128 128 5.7 5.7 5.7-5.7 128-128 5.7-5.7L384 236.7l-5.7 5.7L264 356.7V8zM143.4 320H16 0v16V496v16H16 496h16V496 336 320H496 368.6l-16 16H496V496H16V336H159.4l-16-16zM432 432a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fast',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      'M8 464l560 0 8 0 0 16-8 0L8 480l-8 0 0-16 8 0zm8-203.3l5.7 5.7L120 364.7 120 40l0-8 16 0 0 8 0 324.7 98.3-98.3 5.7-5.7L251.3 272l-5.7 5.7-112 112-5.7 5.7-5.7-5.7-112-112L4.7 272 16 260.7zm320 0l5.7 5.7L440 364.7 440 40l0-8 16 0 0 8 0 324.7 98.3-98.3 5.7-5.7L571.3 272l-5.7 5.7-112 112-5.7 5.7-5.7-5.7-112-112-5.7-5.7L336 260.7z'
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fast',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      'M8 32H0V48H8 184V217.8L62.1 248.2l-7.8 1.9 3.9 15.5 7.8-1.9L184 234.2v79.5L62.1 344.2l-7.8 1.9 3.9 15.5 7.8-1.9L184 330.2V472v8h16v-8V326.2l121.9-30.5 7.8-1.9-3.9-15.5-7.8 1.9L200 309.8V230.2l121.9-30.5 7.8-1.9-3.9-15.5-7.8 1.9L200 213.8V48H376h8V32h-8H192 8z'
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fast',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zm370 395H48V133L32 120.4V400v16H48 406.5l-20.3-16zM544 96H233.5l20.3 16H544v80 16 96 16 21.1l16 12.6V320h32 16V304 208 192H592 560V112 96H544zm16 112h32v96H560V208z'
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fast',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256v-8H248v8V408v8h16v-8z'
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fast',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      'M200 0h-8V8 64H104 96v8V229.7L13.5 256.4 2.7 259.9l7 9 112 144 12.6-9.8-105-135L280 187V376v8h16v-8V187l250.7 81.1-105 135 12.6 9.8 112-144 7-9-10.9-3.5L480 229.7V72 64h-8H384V8 0h-8H200zM368 64H208V16H368V64zM192 80h8H376h8 80V224.5L290.5 168.4l-2.5-.8-2.5 .8L112 224.5V80h80zM96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l0 0-.6-.9-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9 0 0c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9L96 426z'
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fast',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM80 80V240H304V80H80zM64 64H80 304h16V80 240v16H304 80 64V240 80 64zM232 344a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM104 288h16v40h40v16H120v40H104V344H64V328h40V288z'
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fast',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      'M358.6 198.6l11.3-11.3L381.3 176l-11.3-11.3-11.3-11.3-3.2-3.2-12.8-12.8-9.4-9.4H320 160 144 128v16 32 16h16 16 57.5 28.8l-24 16-36.1 24.1c-39.5 26.3-20.9 87.9 26.6 87.9H304h16v16 32 16 16h16 32 16V384 368 288 272 256H368 352 323.9 301.3l16-16 41.4-41.4zM352 272h16v16 80 16H336V368 320 304H320 212.8c-31.7 0-44.1-41.1-17.8-58.6l60.1-40.1 44-29.3H246.3 160 144V144h16H320h6.6l4.7 4.7 12.8 12.8 3.2 3.2L358.6 176l-11.3 11.3-57.4 57.4L262.6 272h38.6H352zM368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM4.5 271.2l424 205.1 2.9 1.4 3.1-1 64-21.1 7.6-2.5-5-15.2-7.6 2.5-60.9 20.1L11.5 256.8l-7 14.4z'
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fast',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      'M16 16H368V247.2c5-5.3 10.4-10.3 16-15V16 0H368 16 0V16 496v16H16 144h16 64 16H368h16v-8.2c-5.6-4.7-11-9.7-16-15V496H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fast',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M480 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm224 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm400 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM16 0a16 16 0 1 1 0 32A16 16 0 1 1 16 0zM264 64v8V256H400h16v16 24l-96 88V496v16H304 208 192V496 384L96 296V272 256h16H248V72 64h16zm0 208H248 112v17l90.8 83.2L208 377v7V496h96V384v-7l5.2-4.8L400 289V272H264z'
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fast',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c85.5 0 160.5-44.7 203.1-112l13.5 8.5C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7L487.4 192C459.4 90.5 366.4 16 256 16zM160.4 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-154 220.8l-4.8 6.4-12.8-9.6 4.8-6.4C173.3 361 204.7 344 240 344c15.3 0 30 3.2 43.2 9l7.3 3.2-6.4 14.7-7.3-3.2c-11.3-4.9-23.7-7.7-36.8-7.7c-30.1 0-56.8 14.4-73.6 36.8zM288 232H448c30.9 0 56 25.1 56 56s-25.1 56-56 56H352h-8V328h8 96c22.1 0 40-17.9 40-40s-17.9-40-40-40H288h-8V232h8z'
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fast',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zM68.9 444.3L96 399.1l27.1 45.2c3.2 5.3 4.9 11.4 4.9 17.6V464c0 17.7-14.3 32-32 32s-32-14.3-32-32v-2.1c0-6.2 1.7-12.2 4.9-17.6zm-13.7-8.2c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-31.5-52.5L96 368l-9.3 15.5L55.1 436.1zm173.7 8.2L256 399.1l27.1 45.2c3.2 5.3 4.9 11.4 4.9 17.6V464c0 17.7-14.3 32-32 32s-32-14.3-32-32v-2.1c0-6.2 1.7-12.2 4.9-17.6zm-13.7-8.2c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-31.5-52.5L256 368l-9.3 15.5-31.5 52.5zm200.9-37l27.1 45.2c3.2 5.3 4.9 11.4 4.9 17.6V464c0 17.7-14.3 32-32 32s-32-14.3-32-32v-2.1c0-6.2 1.7-12.2 4.9-17.6L416 399.1zm-9.3-15.5l-31.5 52.5c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-31.5-52.5L416 368l-9.3 15.5z'
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fast',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      'M418.5 5.5L412.8-.1l-5.7 5.7L372.6 40.1C359.4 53.3 352 71.2 352 89.8c0 16.5 5.7 31.7 15.2 43.7L266.3 234.3 192 160 12.9 294.3 0 304l11.4 11.4L196.6 500.6 208 512l9.7-12.9L352 320l-74.3-74.3L378.5 144.8c12 9.5 27.2 15.2 43.7 15.2c18.6 0 36.5-7.4 49.7-20.6l34.6-34.6 5.7-5.7-5.7-5.7-88-88zM383.9 51.4l28.9-28.9 76.7 76.7-28.9 28.9c-10.2 10.2-24 15.9-38.3 15.9c-29.9 0-54.2-24.3-54.2-54.2c0-14.4 5.7-28.2 15.9-38.3zM24.4 305.7L190.5 181.1 330.9 321.5 206.3 487.6 24.4 305.7zm173.3-44.1l5.7-5.7L192 244.7l-5.7 5.7-72 72-5.7 5.7L120 339.3l5.7-5.7 72-72zm64 64l5.7-5.7L256 308.7l-5.7 5.7-72 72-5.7 5.7L184 403.3l5.7-5.7 72-72z'
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fast',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      'M272 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 240V496H48V240H248h16H464zm0-16H264V126.3L497.8 71.8l7.8-1.8L502 54.4l-7.8 1.8-240 56-240 56L6.4 170 10 185.6l7.8-1.8L248 130.1V224H48 32v16V496v16H48 464h16V496 240 224H464zM96 384V288h96v96H96zm112 0V288h96v96H208zm112 0V288h96v96H320zM80 272v16 96 16H96 416h16V384 288 272H416 96 80z'
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fast',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M320 7.4l2.9 1.1 312 120 5.1 2V136 504v8H624v-8V141.5L320 24.6 16 141.5V504v8H0v-8V136v-5.5l5.1-2 312-120L320 7.4zM96 192h8H536h8v8V320v16V504v8H528v-8V336H112V504v8H96v-8V336 320 200v-8zm16 128H528V208H112V320zm152 96H376h8v16h-8H264h-8V416h8z'
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fast',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      'M32 110.6l80-80 80 80V128H32V110.6zm68.7-91.3L16 104v24 16H32h72V472v8h8H320h8v-8V48l192 0 0 320H448 432v16 24l84.7 84.7L528 504l11.3-11.3L624 408V384 368H608 536V40 32h-8L320 32h-8v8V464H120V144h72 16V128 104L123.3 19.3 112 8 100.7 19.3zM448 401.4V384H608v17.4l-80 80-80-80z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fast',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M0 40V32H11.7l2.4 2.8L368 450.3V40 32h16v8V472v8H372.3l-2.4-2.8L16 61.7V472v8H0v-8V40z'
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fast',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      'M128 52A36 36 0 1 0 56 52a36 36 0 1 0 72 0zM40 52a52 52 0 1 1 104 0A52 52 0 1 1 40 52zM8 128H136h1.5l1.4 .6 120 48 7.4 3-5.9 14.9-7.4-3L134.5 144H16V336H48V232v-8H64v8 47.3L102.7 496h31.5L104.2 345.6l-1.9-9.6H112h32 6.2l1.5 6.1L190.2 496h31.6L152.2 201.8l-3.6-15 14.3 5.7 80 32 7.4 3-5.9 14.9-7.4-3-65.7-26.3 68.4 289 2.3 9.8H232 184h-6.2l-1.5-6.1L137.8 352h-16l30.1 150.4 1.9 9.6H144 96 89.3l-1.2-6.6L60.7 352H56 8 0v-8V136v-8H8zM464 88a36 36 0 1 0 0-72 36 36 0 1 0 0 72zm0-88a52 52 0 1 1 0 104A52 52 0 1 1 464 0zm19.4 270.3l-3.2-6.4-10.5-21-6.6 22.5-11.7 39.9 52.3 57 5.2 5.7 2 7.5 24 88 4.2 15.4 4.2 15.4-15.4 4.2L497 507.1l-15.4 4.2-4.2-15.4-4.2-15.4-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l11.7-43.7 5.3-19.9-18.8 8.3-17.9 7.9-11.5 34.6-5.1 15.2-5.1 15.2-15.2-5.1-30.4-10.1-15.2-5.1 5.1-15.2 5.1-15.2 16-48 4.5-13.4 12.9-5.7 72-32 9.3-4.1 10 2 80 16 15.3 3.1 7 14 35.2 70.5L560 244.2l14.3 7.2-7.2 14.3-14.3 28.6-7.2 14.3-14.3-7.2-33.7-16.8-9.5-4.8-4.8-9.5zm8.4 102.9l-52.3-57-6.1-6.7 2.5-8.7 18.4-62.4 11.5-39L484 235.8l13.7 27.4 2.4 4.8 4.8 2.4 33.7 16.8 14.3-28.6-24.1-12.1-4.8-2.4-2.4-4.8-35.2-70.5-3.5-7-7.7-1.5-80-16-5-1-4.6 2.1-72 32-6.4 2.9-2.2 6.7-16 48-5.1 15.2 30.4 10.1 5.1-15.2 11.5-34.6 2.2-6.7 6.5-2.9 36.7-16.3L406.6 171 398 203.3l-17 63.6c-4.2 15.8-.1 32.7 11 44.8L463 389.1l2.6 2.9 1 3.7 22 80.5 4.2 15.4 30.9-8.4-4.2-15.4-24-88-1-3.7-2.6-2.9zM324.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l4.8 5.2L339.6 404l-1.2 3-2.3 2.3-43.4 43.4L281.4 464 304 486.6l11.3-11.3 48-48 2.3-2.3 1.2-3 18.6-46.4 12 13.1-15.7 39.3-2.4 6.1-4.6 4.6-48 48-11.3 11.3L304 509.3l-11.3-11.3-22.6-22.6L258.7 464l11.3-11.3 11.3-11.3L324.7 398z'
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fast',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      'M260.5 103.2c-15.6 3.9-30.3 9.3-44 15.9l-4.7 2.3-5.2-1-88.1-16.2 28.4 57.1 4.2 8.5-5.5 7.8c-6 8.5-11 17.4-15 26.7l-2.3 5.4-5.2 2.6L35.8 256l87.4 43.7 5.2 2.6 2.3 5.4c4 9.3 9 18.2 15 26.7l5.5 7.8-4.2 8.6-28.4 57.1 88.1-16.2 5.2-1 4.7 2.3c13.6 6.6 28.4 12 44 15.9l5.7 1.4 3.4 4.7L320 484.7l50.4-69.7 3.4-4.7 5.7-1.4c15.6-3.9 30.3-9.3 44-15.9l4.7-2.3 5.2 1 88.1 16.2-28.4-57.1-4.2-8.6 5.5-7.8c6-8.5 11-17.4 15-26.7l2.3-5.4 5.2-2.6L604.2 256l-87.4-43.7-5.2-2.6-2.3-5.4c-4-9.3-9-18.2-15-26.7l-5.5-7.8 4.2-8.5 28.4-57.1-88.1 16.2-5.2 1-4.7-2.3c-13.6-6.6-28.4-12-44-15.9l-5.7-1.4-3.4-4.7L320 27.3 269.6 97.1l-3.4 4.7-5.7 1.4zm-3.9-15.5l53.5-74L320 0l9.9 13.7 53.5 74c16.6 4.2 32.4 9.9 47.1 17l99.9-18.4L550 82.7l-8.9 17.9-33.7 67.8c6.6 9.4 12.2 19.3 16.6 29.6l98.1 49.1L640 256l-17.9 8.9L524 314c-4.4 10.3-10 20.2-16.6 29.6l33.7 67.8 8.9 17.9-19.7-3.6-99.9-18.4c-14.7 7.1-30.5 12.9-47.1 17l-53.5 74L320 512l-9.9-13.7-53.5-74c-16.6-4.2-32.4-9.9-47.1-17l-99.9 18.4L90 429.3l8.9-17.9 33.7-67.8c-6.6-9.4-12.2-19.3-16.6-29.6L17.9 264.9 0 256l17.9-8.9L116 198c4.4-10.3 10-20.2 16.6-29.6L98.9 100.6 90 82.7l19.7 3.6 99.9 18.4c14.7-7.1 30.4-12.9 47.1-17zM232 248c0 48.6 39.4 88 88 88s88-39.4 88-88c0-12.3-2.5-24.1-7.1-34.7c-13 6.4-26.9 11.3-41.4 14.4c-1.9 23.8-9.2 41.4-16.7 53.6c-4.3 7-8.7 12.2-12.1 15.6c-1.7 1.7-3.1 3-4.1 3.9c-.5 .4-.9 .8-1.3 1l-.4 .3-.1 .1 0 0 0 0 0 0s0 0-4.8-6.4l4.7 6.4-4.7 3.5-4.8-3.5L320 296c-4.8 6.4-4.8 6.4-4.8 6.4l0 0 0 0 0 0-.1-.1-.4-.3c-.3-.3-.7-.6-1.3-1c-1-.9-2.5-2.2-4.1-3.9c-3.4-3.5-7.7-8.6-12.1-15.6c-7.5-12.2-14.9-29.8-16.7-53.6c-14.5-3.2-28.4-8.1-41.4-14.4c-4.6 10.6-7.1 22.4-7.1 34.7zm78.8 24.9c3.3 5.4 6.6 9.4 9.2 12.1c2.6-2.7 5.9-6.8 9.2-12.1c5.9-9.5 11.9-23.4 14-42.4c-6.5 .8-13 1.3-19.7 1.4c-.7 0-1.4 0-2.1 0c-.5 0-1 0-1.5 0c-.3 0-.6 0-.8 0c-.7 0-1.4 0-2.1 0c-6.9-.1-13.6-.6-20.3-1.4c2.1 19 8.1 32.9 14 42.4zm104-67.7c.1 .1 .1 .2 .2 .4c5.8 12.9 9 27.3 9 42.4c0 57.4-46.6 104-104 104s-104-46.6-104-104c0-15.1 3.2-29.4 9-42.4c.1-.1 .1-.2 .2-.4c-4.8-3-9.5-6.1-14-9.5l-6.4-4.8 9.6-12.8 6.4 4.8c27 20.3 60.5 32.5 96.8 33c.8 0 1.6 0 2.4 0s1.6 0 2.4 0c36.3-.5 69.7-12.7 96.8-33l6.4-4.8 9.6 12.8-6.4 4.8c-4.5 3.4-9.2 6.6-14 9.5z'
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fast',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216l-104 0v16c0 61.9 50.1 112 112 112s112-50.1 112-112V128zm-4.6-32c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96h47.4zM212.2 112L279 30.4C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128zM22.2 496H425.8L372.5 336H75.5L22.2 496zM64 320H384l58.7 176 5.3 16H431.1 16.9 0l5.3-16L64 320z'
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fast',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      'M224 0h-5l-2.2 4.5L93.8 258.2l-9.1 9.1L33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l51.5-51.5 9.1-9.1 253.7-123L512 293v-5V216v-8h-8H416V104 96h-8H304V8 0h-8H224zM330 363.5l-85.2 41.3-.1-.1-63-63L260.3 263l137.1-43.3L330 363.5zM292.3 114.6L249 251.7l-78.6 78.6-63-63-.1-.1L148.5 182l143.8-67.5zM288 98.9L159.6 159.2 229 16h59V98.9zM268.3 243.7L309.9 112H400v90.1L268.3 243.7zM53 321.7l43-43L233.4 416l-43 43L53 321.7zM179 470.3c-17.9 16.5-41.4 25.7-65.8 25.7C59.5 496 16 452.5 16 398.9c0-24.4 9.2-47.9 25.7-65.8L179 470.3zM352.8 352.4L413.1 224H496v59L352.8 352.4z'
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fast',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM80 80v64H304V80H80zM64 64H80 304h16V80v64 16H304 80 64V144 80 64zm48 144H80v32h32V208zM80 192h32 16v16 32 16H112 80 64V240 208 192H80zm0 112v32h32V304H80zM64 288H80h32 16v16 32 16H112 80 64V336 304 288zM208 400H80v32H208V400zM80 384H208h16v16 32 16H208 80 64V432 400 384H80zm96-176v32h32V208H176zm-16-16h16 32 16v16 32 16H208 176 160V240 208 192zm48 112H176v32h32V304zm-32-16h32 16v16 32 16H208 176 160V336 304 288h16zm96-80v32h32V208H272zm-16-16h16 32 16v16 32 16H304 272 256V240 208 192zm48 112H272v32h32V304zm-32-16h32 16v16 32 16H304 272 256V336 304 288h16zm0 112v32h32V400H272zm-16-16h16 32 16v16 32 16H304 272 256V432 400 384z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fast',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M560 48V228.7l-90.3-90.3-5.7-5.7-5.7 5.7L304 292.7l-90.3-90.3-5.7-5.7-5.7 5.7L112 292.7V48H560zM112 368V315.3l96-96L292.7 304 229 367.7c-.1 .1-.2 .2-.3 .3H112zm448 0H251.3l58.3-58.3L464 155.3l96 96V368zM112 32H96V48 368v16h16H560h16V368 48 32H560 112zm136 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 88a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM16 128H0v16V464v16H16 464h16V464 416H464v48H16V144H64V128H16z'
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fast',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      'M192 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM368 176c0 94.5-74.5 171.6-168 175.8V416h80 8v16h-8H200v72 8H184v-8V432H104 96V416h8 80V351.8C90.5 347.6 16 270.5 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM354.5 305.9c26.3 19 58.6 30.1 93.5 30.1c88.4 0 160-71.6 160-160s-71.6-160-160-160c-34.9 0-67.2 11.2-93.5 30.1C351.2 42 347.6 37.9 344 34C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 94.5-74.5 171.6-168 175.8V416h80 8v16h-8H456v72 8H440v-8V432H360h-8V416h8 80V351.8c-35.8-1.6-68.9-13.9-96-33.8c3.7-3.9 7.2-8 10.5-12.1z'
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fast',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      'M256 192l0-16 0-64 0-16 16 0 16 0L436.7 244.7 448 256l-11.3 11.3L288 416l-16 0-16 0 0-16 0-64 0-16-16 0-128 0-16 0 0-16 0-96 0-16 16 0 128 0 16 0zm16 0l0 16-16 0-144 0 0 96 144 0 16 0 0 16 0 80 9.4 0 144-144-144-144-9.4 0 0 80zM0 72l0-8 16 0 0 8 0 368 0 8L0 448l0-8L0 72z'
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fast',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      'M261.4 257.8l-6.1-9.1-12-18-5.2 21L224.2 307l54.4 54.4 9.4 9.4V384v96 16 16H272 240 224V496 480 397.3l-69.7-69.7-1.1-.3 .2-.7-3.3-3.3c-15.8-15.8-22.2-38.6-16.9-60.3l27.8-114.5 3.8-15.8 3.8-15.5L184 121l15.7 3.9 48 12 12 3 6.9 10.3L305.1 208H352h16V168v-8h16v8 40h0v16 32 16h0V504v8H368v-8V272H352 288 270.9l-9.5-14.2zM368 256V224H352 305.1h-8.6l-4.8-7.1-38.5-57.8-3.4-5.1-6-1.5-48-12-15.6-3.9-3.8 15.7L148.7 266.8c-3.9 16.3 .9 33.4 12.7 45.3l1.1 1.1 2.2 2.2 .9 .9 5.5 5.5 64.2 64.2 4.7 4.7v6.6V480v16h32V480 384v-6.6l-4.7-4.7-54.4-54.4-6.4-6.4 2.2-8.8 19.1-76.3 8.8-35.1 20.1 30.1 18.1 27.1 4.7 7.1H288h64 16zM272 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM117.3 334c3 4.2 6.4 8.2 10.1 11.9l2.6 2.6L91.2 496h33.1l31.9-121.2 13.1 13.1L136.7 512H87 70.5l4.2-16 42.6-162zM127.5 96H144l-4 16L96 288 15.9 274.6 0 272l4.2-15.5L48 96h79.5zM84.1 269.8L123.5 112H60.2L20.1 259.1l64 10.7z'
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fast',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM192 176c27.3 0 51.4 13.7 65.9 34.6l13.2-9.1C253.8 176.5 224.8 160 192 160c-53 0-96 43-96 96s43 96 96 96c32.8 0 61.8-16.5 79.1-41.5l-13.2-9.1C243.4 322.3 219.3 336 192 336c-44.2 0-80-35.8-80-80s35.8-80 80-80zm128 80c0-44.2 35.8-80 80-80c27.3 0 51.4 13.7 65.9 34.6l13.2-9.1C461.8 176.5 432.8 160 400 160c-53 0-96 43-96 96s43 96 96 96c32.8 0 61.8-16.5 79.1-41.5l-13.2-9.1C451.4 322.3 427.3 336 400 336c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fast',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      'M349 16c39.2 0 77 13.5 105.3 41.8S496 123.8 496 163c0 49.6-21.5 101.9-62.3 142.7c-72.2 72.2-183.4 85.1-248 20.5C157.5 297.9 144 260.2 144 221c0-49.6 21.5-101.9 62.3-142.7S299.3 16 349 16zm0-16c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 40.3 13.1 79.8 40.9 110.8l-34.6 34.6-19-19L104 336 92.7 347.3 11.3 428.7 0 440l11.3 11.3 49.4 49.4L72 512l11.3-11.3 81.4-81.4L176 408l-11.3-11.3-19-19 34.6-34.6c73.3 66.3 190.4 48.3 264.8-26c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 358.6L153.4 408 72 489.4 22.6 440 104 358.6zM512 368c17.7 0 32 14.3 32 32v32H480V400c0-17.7 14.3-32 32-32zm48 64V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v32 16h16 64 16V432zM448 506.6l15.4 4.4 13.4-47H460.1L448 506.6zm56-2.6v8h16v-8V464H504v40zm56.6 7l15.4-4.4L563.8 464H547.2l13.4 47z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fast',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 9.9 .3L293.2 9.9zm74 238.1H328V184v-8h-8H256h-8v8 64H184h-8v8 64 8h8 64v64 8h8 64 2.9c-1.4-7.8-2.4-15.8-2.7-24H312v8H264V320v-8h-8H192V264h64 8v-8V192h48v64 8h8 34c4.1-5.6 8.5-10.9 13.3-16zm.7 120a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fast',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      'M319.7 12.9L317.1 0H304 208 194.9l-2.6 12.9-9.7 48.5c-4.2 1.6-8.3 3.3-12.4 5.1L129.1 39l-10.9-7.3L108.9 41 41 108.9l-9.3 9.3L39 129.1l27.4 41.1c-1.8 4.1-3.6 8.2-5.1 12.4l-48.5 9.7L0 194.9V208v96 13.1l12.9 2.6 48.5 9.7c1.6 4.2 3.3 8.3 5.1 12.4L39 382.9l-7.3 10.9 9.3 9.3L108.9 471l9.3 9.3 10.9-7.3 41.1-27.4c4.1 1.8 8.2 3.6 12.4 5.1l9.7 48.5 2.6 12.9H208h96 13.1l2.6-12.9 9.7-48.5c4.2-1.6 8.3-3.3 12.4-5.1L382.9 473l10.9 7.3 9.3-9.3L471 403.1l9.3-9.3L473 382.9l-27.4-41.1c1.8-4.1 3.6-8.2 5.1-12.4l48.5-9.7 12.9-2.6V304 208 194.9l-12.9-2.6-48.5-9.7c-1.6-4.2-3.3-8.3-5.1-12.4L473 129.1l7.3-10.9-9.3-9.3L403.1 41l-9.3-9.3L382.9 39 341.8 66.5c-4.1-1.8-8.2-3.6-12.4-5.1l-9.7-48.5zm-150.7 72c8.8-4.5 18-8.3 27.6-11.4L208 16h96l11.5 57.4c9.5 3.1 18.8 6.9 27.6 11.4l48.7-32.5 67.9 67.9-32.5 48.7c4.5 8.8 8.3 18 11.4 27.6L496 208v96l-57.4 11.5c-3.1 9.5-6.9 18.8-11.4 27.6l32.5 48.7-67.9 67.9-48.7-32.5c-8.8 4.5-18 8.3-27.6 11.4L304 496H208l-11.5-57.4c-9.5-3.1-18.8-6.9-27.6-11.4l-48.7 32.5L52.4 391.8l32.5-48.7c-4.5-8.8-8.3-18-11.4-27.6L16 304V208l57.4-11.5c3.1-9.5 6.9-18.8 11.4-27.6L52.4 120.2l67.9-67.9 48.7 32.5zm110.9 76.5l1.3-7.9-15.8-2.6-1.3 7.9-32 192-1.3 7.9 15.8 2.6 1.3-7.9 32-192zm-98.2 60.3l5.7-5.7L176 204.7l-5.7 5.7-40 40-5.7 5.7 5.7 5.7 40 40 5.7 5.7L187.3 296l-5.7-5.7L147.3 256l34.3-34.3zm160-11.3l-5.7-5.7L324.7 216l5.7 5.7L364.7 256l-34.3 34.3-5.7 5.7L336 307.3l5.7-5.7 40-40 5.7-5.7-5.7-5.7-40-40z'
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fast',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM410.9 230.6c-85.6-83.5-224.3-83.5-309.8 0L90.4 241l-4.7 4.6 3.6 5.5 37.3 57.2 3.2 4.9 5.6-1.6 74.7-20.8 6.6-1.8-.8-6.8L211.1 240c29.4-7.7 60.4-7.7 89.7 0l-4.8 42.3-.8 6.8 6.6 1.8 74.7 20.8 5.6 1.6 3.2-4.9 37.3-57.2 3.6-5.5-4.7-4.6-10.7-10.4zM112.3 242.1c79.4-77.4 208.1-77.4 287.5 0l0 0 6 5.8-30.5 46.8-62.4-17.4 4.8-42.3 .8-6.6-6.4-1.9c-36.4-11-75.4-11-111.8 0l-6.4 1.9 .8 6.6 4.8 42.3-62.4 17.4-30.5-46.8 6-5.8z'
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fast',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      'M144 72V64h16v8V216v8h-8H8 0V208H8 144V72zm8 216h8v8V440v8H144v-8V304H8 0V288H8 152zM368 72V208H504h8v16h-8H360h-8v-8V72 64h16v8zm-8 216H504h8v16h-8H368V440v8H352v-8V296v-8h8z'
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fast',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM299.6 406.7l-43.6-29-43.6 29-4.4 3-4.4-3-44.1-29.4-27.8 13.9-7.2 3.6-7.2-14.3 7.2-3.6 32-16 4.2-2.1 3.9 2.6 43.6 29 43.6-29 4.4-3 4.4 3 43.6 29 43.6-29 3.9-2.6 4.2 2.1 32 16 7.2 3.6-7.2 14.3-7.2-3.6-27.8-13.9-44.1 29.4-4.4 3-4.4-3zm-129.3-287l-8 .3c-49.1 2-86.3 47-81.9 88.7l0 .2 0 .2c2.1 42.5 43 74.7 80.6 70.5l.4 0 0 0c38.5-2.2 66.2-37.7 62.1-69l0-.2 0-.2c-2.3-32.2-33.5-55-60.5-51.2l-.4 .1 0 0c-27.9 2.3-46.1 28.4-42.5 49.2l0 .2 0 .2c2.4 21.8 23.9 35.3 40.2 32l.2 0 .2 0c17.3-2.4 25.9-18.8 23.2-29l-.1-.2 0-.2c-1.1-5.5-4.4-9.5-8.4-11.9c-4.2-2.5-8.3-2.6-10.7-1.7l-.3 .1-.3 .1c-2.8 .8-4.4 2.5-5.2 4.1l10.1-.9 .7 8c.7 8-6.4 11.6-10.6 12.1c-5.1 .6-10.5-1.7-13.9-6.8c-4-5.4-3.6-12.5-1.4-18c2.4-5.9 7.6-11.3 15.3-13.7c7.8-2.8 16.9-1.2 24.2 3c7.5 4.4 13.9 12 16 22.3c5.2 20.3-10.7 45-36.3 48.7c-25.4 4.9-55.5-15-59-45.8c-5.1-30.6 20.5-64.4 56.8-67.6c36-4.9 75.4 24.4 78.5 65.7c5.1 40.9-29.9 84-76.9 86.8c-46.6 5.1-95.5-33.7-98.2-85.4c-5.3-51.4 39.4-103.8 97.2-106.2l8-.3 .6 16zM349.8 296c49.1-2 86.3-47 81.9-88.7l0-.2 0-.2c-2.1-42.5-43-74.7-80.6-70.5l-.4 0 0 0c-38.5 2.2-66.2 37.7-62.1 69l0 .2 0 .2c2.3 32.2 33.5 55 60.5 51.2l.4-.1 0 0c27.9-2.3 46.1-28.4 42.5-49.2l0-.2 0-.2c-2.4-21.8-24-35.3-40.2-32l-.2 0-.2 0c-17.3 2.4-25.9 18.8-23.2 29l.1 .2 0 .2c1.1 5.5 4.5 9.5 8.4 11.9c4.2 2.5 8.3 2.6 10.7 1.7l.3-.1 .3-.1c2.8-.8 4.4-2.5 5.2-4.1l-10.1 .9-.7-8c-.7-8 6.4-11.6 10.6-12.1c5.1-.6 10.5 1.7 13.9 6.8c4 5.4 3.6 12.5 1.4 18c-2.4 5.9-7.6 11.3-15.3 13.7c-7.8 2.8-16.9 1.2-24.2-3c-7.5-4.4-13.9-12-16-22.3c-5.2-20.3 10.7-45 36.3-48.7c25.4-4.9 55.5 15 59 45.8c5.1 30.6-20.5 64.4-56.8 67.6c-36 4.9-75.4-24.4-78.5-65.7c-5.1-40.9 29.9-84 76.9-86.8c46.6-5.1 95.5 33.7 98.2 85.4c5.3 51.4-39.4 103.8-97.2 106.2l-8 .3-.6-16 8-.3z'
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fast',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      'M256 496C123.5 496 16 388.5 16 256l0-8L0 248l0 8C0 397.4 114.6 512 256 512s256-114.6 256-256l0-8-16 0 0 8c0 132.5-107.5 240-240 240zM121.9 162.8l-5.2 6.1L129 179.3l5.2-6.1L248 37.9 248 344l0 8 16 0 0-8 0-306.1L377.9 173.2l5.2 6.1L395.3 169l-5.2-6.1-128-152L256 3.6l-6.1 7.3-128 152z'
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fast',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      'M264 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V70.8L112 50.4 96 48V64.2v63.6V144l16-2.4 136-20.4V192H64V176 160H48 16 0v16V464v16H16 48 64V464 448H448v16 16h16 32 16V464 176 160H496 464 448v16 16H264V121.2l136 20.4 16 2.4V127.8 64.2 48l-16 2.4L264 70.8V40zM448 208V432H64V208H256 448zM248 87v18L112 125.4V66.6L248 87zm16 18V87L400 66.6v58.8L264 105zM48 176V464H16V176H48zm416 0h32V464H464V176z'
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fast',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V282.4l49.3 74 4.4 6.7 13.3-8.9-4.4-6.7-64-96-14.7-22V256 408v8h16v-8z'
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fast',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      'M336 192H320 160 137.2l-11.6 19.7L29.7 373.9l-8.1 13.8 13.8 8.1 41.3 24.4 13.8 8.1 8.1-13.8L128 364.8l16-27.1v31.4V496v16h16H320h16V306.2l-16-27.1v58.5V496H160V337.7 279.2l-29.8 50.4L84.8 406.4 43.5 382l95.9-162.2 7-11.8H160 320h0 13.7H336V192zM176 80a64 64 0 1 1 128 0A64 64 0 1 1 176 80zm144 0A80 80 0 1 0 160 80a80 80 0 1 0 160 0zm128 64h16V256v13.3 22.2 22.3 11.5V352v16h16 48v16H472h-2H446.9 416V208 192 160 144h16V128 16h16V128v16zM416 496V400h36.9l2.1 5.6L488.9 496H416zm56-96h15.1H528h16V384 368 352H528 496 480V336 325.3L544 304V208 192H528 512 496v16 56l-16 5.3V264v-8-3.5V192 176 144 128H464V112 16 0H448 432 416 400V16h16V32v80 16H400v16 16 16 16H384 368v16V384v16h16 16v16 80 16h16 78.9H512l-6-16-30-80-6-16h2zm8-91.5V286.2l5.1-1.7 16-5.3 10.9-3.6V264 208h16v84.5l-48 16zM384 208h16V384H384V208z'
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fast',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      'M496 208L16 208 16 48l480 0V208zm16 16V208 48 32H496 16 0V48 208v16H16 248V348.7l-50.3-50.3-5.7-5.7L180.7 304l5.7 5.7 64 64 5.7 5.7 5.7-5.7 64-64 5.7-5.7L320 292.7l-5.7 5.7L264 348.7V224H496h16zm0 248V296v-8h-8H400h-8v16h8 96V464L16 464l0-160h96 8V288h-8H8 0v8V472v8H8l496 0h8v-8z'
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fast',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      'M208 48V224H16V48H208zM16 32H0V48 224v16H16 208h16V224 48 32H208 16zM208 288V464H16V288H208zM16 272H0v16V464v16H16 208h16V464 288 272H208 16zM272 48H496v96H272V48zM256 32V48v96 16h16H496h16V144 48 32H496 272 256zM496 208v96H272V208H496zM272 192H256v16 96 16h16H496h16V304 208 192H496 272zm0 176H496v96H272V368zm-16-16v16 96 16h16H496h16V464 368 352H496 272 256z'
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fast',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      'M338 237.2V148.8c-53.3-17.4-110.7-17.4-164 0v88.4L32 256-8 152.6C22.8 112.4 118.7 32 256 32s233.2 80.4 264 120.6L480 256 338 237.2zM158 148.8c0-6.9 4.4-13.1 11-15.2c56.5-18.5 117.4-18.5 173.9 0c6.6 2.2 11 8.3 11 15.2v74.4l115.6 15.3 32.1-82.9C468 116.5 379.6 48 256 48S44 116.5 10.3 155.5l32.1 82.9L158 223.2V148.8zM56 288h64 8v8 64 8h-8H56 48v-8V296v-8h8zm8 64h48V304H64v48zm-8 48h64 8v8 64 8h-8H56 48v-8V408v-8h8zm8 64h48V416H64v48zm328-64h64 8v8 64 8h-8H392h-8v-8V408v-8h8zm8 64h48V416H400v48zM160 400h8H344h8v8 64 8h-8H168h-8v-8V408v-8zm16 16v48H336V416H176zM160 288h8 64 8v8 64 8h-8H168h-8v-8V296v-8zm16 16v48h48V304H176zm104-16h64 8v8 64 8h-8H280h-8v-8V296v-8h8zm8 64h48V304H288v48zm96-64h8 64 8v8 64 8h-8H392h-8v-8V296v-8zm16 16v48h48V304H400z'
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fast',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      'M496 16H80V288H320v16H80 64 16v25.4L54.6 368H320v16H48L0 336V304 288H16 64V16 0H80 496h16V16 96H496V16zM640 248V496v16H624 368 352V496 144 128h16H520h8L640 240v8zM528 150.6V240h89.4L528 150.6zM512 144H368V496H624V256H520h-8v-8V144z'
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fast',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      'M16 8V0H0V8 64 383.5 400 504v8H16v-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V33.9 16l-16 8L393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 301.9l121.4-26c35.2-7.5 71.7-4.6 105.2 8.4l25.8 10c43.5 16.9 91.5 18.1 135.7 3.3l27.7-9.2v60.5l-45.1 16.9c-42.1 15.8-88.8 13.3-129-6.8c-41.3-20.7-88.7-25.9-133.5-14.7L16 379.5V309.9zm0-16.4V237.9l116.6-25c38.1-8.2 77.7-4 113.3 11.8l13.8 6.2c48.7 21.6 104 23 153.7 3.6l18.6-7.2v52.3l-32.8 10.9c-40.7 13.6-84.9 12.5-124.9-3.1l-25.8-10c-36.4-14.2-76.2-17.3-114.4-9.2L16 293.5zm0-72V76.5L136.8 46.3c7.6-1.9 15.4-3.2 23.2-3.9V193.1c-10.3 .6-20.6 1.9-30.8 4.1L16 221.5zm160-28.6v-64c24 .6 47.7 5.9 69.9 15.8l13.8 6.2c48.7 21.6 104 23 153.7 3.6l18.6-7.2v62.8l-24.4 9.5c-45.7 17.8-96.6 16.6-141.4-3.3l-13.8-6.2c-24.2-10.8-50.2-16.5-76.4-17.2zm0-80v-71c21.8 .5 43.5 5.7 63.3 15.6c50.8 25.4 110.6 25.4 161.5 0L432 41.9v88.2l-24.4 9.5c-45.7 17.8-96.6 16.6-141.4-3.3l-13.8-6.2c-24.2-10.8-50.2-16.5-76.4-17.2zM72 108a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm44-4a12 12 0 1 0 0-24 12 12 0 1 0 0 24zM72 164a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm44-4a12 12 0 1 0 0-24 12 12 0 1 0 0 24z'
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fast',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      'M384 112c44.2 0 80-35.8 80-80V16H384c-44.2 0-80 35.8-80 80v16h80zm-96 16V112 96c0-15.8 3.8-30.8 10.6-43.9C284.8 49.4 270.6 48 256 48C132.3 48 32 148.3 32 272s100.3 224 224 224s224-100.3 224-224c0-46.6-14.2-89.8-38.5-125.6c4.8-2.4 9.4-5.1 13.8-8.1C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272S123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0h80 16V16 32c0 53-43 96-96 96H304 288z'
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fast',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      'M3.8 78.8l5.7 3.5c91.7 56 197.1 85.7 304.5 85.7H320h5.9c107.5 0 212.8-29.6 304.5-85.7l5.7-3.5-8.3-13.7-5.7 3.5C532.9 123.2 430.4 152 325.9 152H320h-5.9c-104.5 0-207-28.8-296.2-83.3l-5.7-3.5L3.8 78.8zM112.1 239.8c-31-7.2-62.8 8.7-73.5 38.2c-22.7 62.5 21 129.4 21 129.4s76.6-23.2 99.3-85.7c10.7-29.5-3.4-62.2-31.7-76.5l27.2-74.6c-5.2-1.4-10.3-2.9-15.4-4.4l-26.8 73.6zM312 272.5c-31.6 3.8-56 29.7-56 61.1C256 400 320 448 320 448s64-48 64-114.5c0-31.4-24.4-57.3-56-61.1V192l-2.1 0H320h-5.9l-2.1 0v80.5zm200.9-27.2c-28.4 14.4-42.5 47-31.7 76.5c22.7 62.5 99.3 85.7 99.3 85.7s43.7-67 21-129.4c-10.7-29.5-42.5-45.5-73.5-38.2l-26.8-73.6c-5.1 1.5-10.3 3-15.4 4.4l27.2 74.6zM114.3 257.1c25.5 9.3 37.9 36.1 29.5 59.2c-9.6 26.4-31 45.4-51.6 58.1c-9.6 5.9-18.6 10.3-25.5 13.2c-3.4-6.6-7.5-15.8-11-26.5c-7.6-22.9-11.8-51.2-2.1-77.7c8.4-23.1 35.2-35.6 60.7-26.4zM320 288c27.1 0 48 21 48 45.5c0 28.1-13.6 53.3-28.6 72.2c-7 8.9-14 16-19.4 21.1c-5.4-5.1-12.4-12.2-19.4-21.1c-14.9-19-28.6-44.1-28.6-72.2c0-24.6 20.9-45.5 48-45.5zm266.4-4.5c9.6 26.4 5.4 54.7-2.1 77.7c-3.5 10.7-7.7 19.9-11 26.5c-6.8-2.9-15.9-7.3-25.5-13.2c-20.5-12.7-41.9-31.7-51.6-58.1c-8.4-23.1 4.1-49.9 29.5-59.2s52.3 3.3 60.7 26.4z'
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fast',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      'M90.5 0l47.2 47.2C172.6 27.3 213 16 256 16c42.4 0 82.3 11 116.9 30.3L418.3 0H496h16V16 90.5l-47.2 47.2C484.7 172.6 496 213 496 256s-11.3 83.4-31.2 118.3L512 421.5l.6 75.2 .1 16-16-.1-75.2-.6-47.2-47.2C339.4 484.7 299 496 256 496s-83.4-11.3-118.3-31.2L90.5 512H16 0V496 421.5l47.2-47.2C27.3 339.4 16 299 16 256s11.3-83.4 31.2-118.3L-.7 89.8 0 0H90.5zM384.3 57.5l-8.6 8.7-10.7-6C332.8 42.3 295.6 32 256 32c-40.2 0-77.9 10.6-110.4 29.1l-10.6 6-8.6-8.6L83.9 16h-68l-.5 67.2 43.1 43.1 8.6 8.6-6 10.6C42.6 178.1 32 215.8 32 256s10.6 77.9 29.1 110.4l6 10.6-8.6 8.6L16 428.1V496H83.9l42.5-42.5 8.6-8.6 10.6 6C178.1 469.4 215.8 480 256 480s77.9-10.6 110.4-29.1l10.6-6 8.6 8.6 42.5 42.5 68.4 .5-.5-68.4-42.5-42.5-8.6-8.6 6-10.6C469.4 333.9 480 296.2 480 256s-10.6-77.9-29.1-110.4l-6-10.6 8.6-8.6L496 83.9V16H425L384.3 57.5zM64 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256z'
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fast',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM21.2 368H64h48 32 48 42.8L179.9 176H76.1L21.2 368zM136 384H120V504v8h-8H64 56v-8V384H16.6 0l4.6-16L64 160H192l59.4 208 4.6 16H239.4 200V504v8h-8H144h-8v-8V384zm48 0H152V496h32V384zM72 384V496h32V384H72z'
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fast',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v8V248v8 8V376v8h8H292c37.6 0 68-30.4 68-68c0-31.6-21.6-58.2-50.9-65.8C325.4 237.8 336 218.1 336 196c0-37.6-30.4-68-68-68H168h-8zm160 68c0 28.7-23.3 52-52 52H176V144h92c28.7 0 52 23.3 52 52zM176 368V264h92 24c28.7 0 52 23.3 52 52s-23.3 52-52 52H176z'
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fast',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      'M336 216l-16 0L16 216l0 80 304 0 16 0 0 16 0 88 9.4 0 144-144-144-144-9.4 0 0 88 0 16zM352 96L500.7 244.7 512 256l-11.3 11.3L352 416l-16 0-16 0 0-16 0-72 0-16-16 0L16 312 0 312l0-16 0-80 0-16 16 0 288 0 16 0 0-16 0-72 0-16 16 0 16 0z'
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fast',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM487.3 480l-20.3-16H54.6L16 425.4V400H386l-20.3-16H16 0v16 32l48 48H487.3zM560 352h16V48 32H560 152.3l20.3 16H560V352zM64 145.8V352H80V158.4L64 145.8z'
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fast',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      'M256 336c68.5 0 129.7-15.6 173.2-40.1c44-24.8 66.8-56.5 66.8-87.9s-22.8-63.1-66.8-87.9C385.7 95.6 324.5 80 256 80s-129.7 15.6-173.2 40.1C38.8 144.9 16 176.6 16 208s22.8 63.1 66.8 87.9C126.3 320.4 187.5 336 256 336zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 16 0 96c0 70.7-114.6 128-256 128S0 390.7 0 320l0-96 0-16zM168 343.3l0 80.7c24.8 4.7 51.8 7.5 80 8l0-80c-28-.5-54.9-3.5-80-8.7zm-16-3.6c-23.4-5.9-44.9-13.6-64-23L88 399c18.6 8.7 40.2 16 64 21.6l0-81zM16 258.2L16 320c0 24 18.2 49.5 56 70.8l0-82.7C47.7 294 28.4 277 16 258.2zM344 424l0-80.7c-25.1 5.2-52 8.2-80 8.7l0 80c28.2-.4 55.2-3.2 80-8zm16-84.3l0 81c23.8-5.5 45.4-12.8 64-21.6l0-82.4c-19.1 9.3-40.6 17.1-64 23zM496 320l0-61.8c-12.4 18.8-31.7 35.7-56 49.9l0 82.7c37.8-21.3 56-46.8 56-70.8zM256 128c-49.9 0-94.8 9.3-126.8 23.9C96.5 166.8 80 185.9 80 204s16.5 37.2 49.2 52.1c32 14.6 76.9 23.9 126.8 23.9s94.8-9.3 126.8-23.9c32.7-14.9 49.2-34 49.2-52.1s-16.5-37.2-49.2-52.1C350.8 137.3 305.9 128 256 128zm192 76c0 28.2-24.7 51.2-58.6 66.7C354.9 286.5 307.7 296 256 296s-98.9-9.5-133.4-25.3C88.7 255.2 64 232.2 64 204s24.7-51.2 58.6-66.7C157.1 121.5 204.3 112 256 112s98.9 9.5 133.4 25.3C423.3 152.8 448 175.8 448 204z'
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fast',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      'M264 8V0H248V8 248v8h16v-8V8zM40 263.1c0-83.6 47.5-156.1 117-192l-7.3-14.2C75 95.5 24 173.3 24 263.1c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2L355 71.1c69.5 35.9 117 108.4 117 192c0 119.3-96.7 216-216 216s-216-96.7-216-216z'
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fast',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      'M0 64V80 192v16c26.5 0 48 21.5 48 48s-21.5 48-48 48v16V432v16H16 560h16V432 320 304c-26.5 0-48-21.5-48-48s21.5-48 48-48V192 80 64H560 16 0zM64 256c0-29.8-20.4-54.9-48-62V80H560V194c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62V432H16V318c27.6-7.1 48-32.2 48-62zm80-80H432V336H144V176zm-16-16v16V336v16h16H432h16V336 176 160H432 144 128z'
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fast',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M349.9 224H328.6L490.1 40.7 471.3 21.9 241.9 224H217.7L472 0l40 40L349.9 224zM107.3 500.7L96 512 84.7 500.7 11.3 427.3 0 416l11.3-11.3L160 256H329.4 352l-16 16L107.3 500.7zM96 489.4l81.5-81.5c-2.5 .5-5.2-.2-7.2-2.2L144 379.3l-79 79 31 31zM313.4 272H166.6l-56.1 56.1c2.5-.5 5.2 .2 7.2 2.2l32 32 32 32c1.9 2 2.7 4.7 2.2 7.2L313.4 272zM22.6 416l31 31 79-79-26.3-26.3c-1.9-2-2.7-4.7-2.2-7.2L22.6 416z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fast',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M48 112H80v32H48V112zm0 128H80v32H48V240zM80 368v32H48V368H80z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fast',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      'M352 0c71.4 0 136.7 26 187 69L527.7 80.3C480.3 40.2 419 16 352 16s-128.3 24.2-175.7 64.3L165 69C215.3 26 280.6 0 352 0zm0 112c40.4 0 77.7 13.6 107.4 36.6L448 160c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32l-11.4-11.4c29.7-22.9 67-36.6 107.4-36.6zm8 112v8 88H560h16v16V496v16H560 16 0V496 336 320H16 344V232v-8h16zM344 336v0H16V496H560V336H360v0H344zM208 400v32H176V400h32zM80 400h32v32H80V400z'
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fast',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      'M385.5 176h-7l-4.7 5.1L87.6 489 23 424.4l99.8-92.8 5.1-4.7v-7V272h52.7H187l4.6-4.3 264-245.5 34.2 34.2-69.5 74.7-4.3 4.6V142v34H385.5zM88 512l10.9-11.7L385.5 192H416h16V176 142l80-86L456 0 180.7 256H128 112v16 47.9L11.7 413.1 0 424l11.3 11.3 65.4 65.4L88 512zM248 32V24H232v8V72H192h-8V88h8 40v40 8h16v-8V88h40 8V72h-8H248V32zM88 80V72H72v8 56H16 8v16h8H72v56 8H88v-8V152h56 8V136h-8H88V80zM440 304v-8H424v8 56H368h-8v16h8 56v56 8h16v-8V376h56 8V360h-8H440V304z'
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fast',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM128 152V288c0 53 43 96 96 96s96-43 96-96V152v-8h16v8V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V152v-8h16v8z'
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fast',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      'M216 368H200h-8-8H168 136V288 270.8 204.6l-30.2 58.9L89.4 295.3l-7.3 14.2L53.7 294.9 61 280.7l65.7-128 4.5-8.7H136h4.9H192h32 18.7l15.9 84.7 2 10.7 10.7 2.1c36.9 7.1 64.7 39.6 64.7 78.5v48H304 272h-8H248 216zm56 16h8 24 32 16V368 320c0-46.8-33.4-85.7-77.7-94.3L256 128H224 192h0H140.9 136 121.4l-8.9 17.4-65.7 128-7.3 14.2-7.3 14.2 14.2 7.3 28.5 14.6 14.2 7.3 7.3-14.2 7.3-14.2 .3-.6 7.2-14 8.8-17.2V288v17.8V480v16 16h16 32 16l0-16V480 400 384h8 8v16l0 80 0 16v16h16 32 16V496 480 400 384h8zm-24 0v96 16H216V480 384h32zm-80 0v96 16H136V480 384h32zM248 56c0-30.9-25.1-56-56-56s-56 25.1-56 56s25.1 56 56 56h0c30.9 0 56-25.1 56-56zm-96 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fast',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M288 219.9l2.8 4.1 66.4 96H90.7l66.4-96 2.8-4.1v-5V16H288V214.9v5zM368.3 336L432 427.9V496H16V427.9L79.7 336H80 368h.3zM304 214.9V16h24 8V0h-8H304 288 160 144 120h-8V16h8 24V214.9L0 422.9V496v16H16 432h16V496 422.9l-144-208z'
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fast',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M384 182.6v7.7L168 0 128 40 384 330.6V352L532.7 500.7 544 512l11.3-11.3 73.4-73.4L640 416l-11.3-11.3L400 176l-16-16 0 22.6zM149.9 40.7l18.8-18.8L384 211.6v94.8L149.9 40.7zM535.9 334.5L617.4 416l-31 31-79-79 26.3-26.3c1.9-2 2.7-4.7 2.2-7.2zm-6.3-6.3c-2.5-.5-5.2 .2-7.2 2.2l-32 32-32 32c-1.9 2-2.7 4.7-2.2 7.2L400 345.4V198.6L529.5 328.1zm-67 79.7c2.5 .5 5.2-.2 7.2-2.2L496 379.3l79 79-31 31-81.5-81.5zm-228-198.6l-41.4 36.5-11.4-11.4-5.7-5.7L164.7 240l5.7 5.7L180.7 256l-5.3 5.3L170 266l.3 .3L112 324.7l-2.3-2.3-5.7-5.7-5.7 5.7-96 96L0 420.7V424v32 3.3l2.3 2.3 48 48 2.3 2.3H56 88h3.3l2.3-2.3 96-96 5.7-5.7-5.7-5.7-2.3-2.3 58.3-58.3 .3 .3 4.7-5.3 5.3-5.3 10.3 10.3 5.7 5.7L283.3 336l-5.7-5.7-11.4-11.4 32.4-36.8L288 270l-33.1 37.6-50.5-50.5L245 221.3l-10.6-12zM417 147.8L512 40 472 0 364.2 95l11.3 11.3 95.8-84.4 18.8 18.8-84.4 95.8 .9 .9L417 147.8zM186.3 273l6-5.3 52 52-5.3 6-23 23L163.3 296l23-23zm-63 63L152 307.3 204.7 360 176 388.7 123.3 336zM16 427.3l88-88 2.3 2.3 64 64 2.3 2.3-88 88H59.3L16 452.7V427.3z'
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fast',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      'M232 0V8 64c43.7 .4 84.1 14.6 116.7 38.3l-9.4 12.9C308.9 93.1 271 80 230 80C129.2 80 48 159 48 256s81.2 176 182 176c41.1 0 78.9-13.1 109.3-35.3l9.4 12.9c-32.6 23.7-73 37.9-116.7 38.3v56 8H216v-8V447.5C113.4 440.6 32 357.7 32 256S113.4 71.4 216 64.5V8 0h16z'
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fast',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      'M200 0h8 96 8V8 40h88 8v8V272h96 8v8 56 3.3l-2.3 2.3L398.2 453.1C360.5 490.8 309.3 512 256 512s-104.5-21.2-142.2-58.9L2.3 341.7 0 339.3V336 280v-8H8h96V48 40h8 88V8 0zM312 208v8 8H296v-8-8V48 40 16H216V40v8V208v8 8H200v-8-8V56H120V280v8h-8H16v44.7L125.1 441.8C159.8 476.5 206.9 496 256 496s96.2-19.5 130.9-54.2L496 332.7V288H400h-8v-8V56H312V208zM174.3 356.7c5.1 5.8 12.4 13.6 21 21.3c17.8 15.8 39.8 30 60.7 30s42.9-14.2 60.7-30c8.7-7.7 15.9-15.5 21-21.3c1.6-1.8 2.9-3.4 4-4.7c-1.1-1.4-2.5-3-4-4.7c-5.1-5.8-12.4-13.6-21-21.3c-17.8-15.8-39.8-30-60.7-30s-42.9 14.2-60.7 30c-8.7 7.7-15.9 15.5-21 21.3c-1.6 1.8-2.9 3.4-4 4.7c1.1 1.4 2.5 3 4 4.7zm184.1-9.5s0 0-6.4 4.8c6.4 4.8 6.4 4.8 6.4 4.8l0 0 0 0 0 0-.1 .2-.5 .6c-.4 .5-1 1.2-1.7 2.1c-1.5 1.8-3.6 4.4-6.3 7.5c-5.4 6.2-13.1 14.4-22.5 22.7c-18.2 16.2-44.2 34-71.3 34s-53.1-17.8-71.3-34c-9.3-8.3-17.1-16.5-22.5-22.7c-2.7-3.1-4.8-5.7-6.3-7.5c-.7-.9-1.3-1.6-1.7-2.1l-.5-.6-.1-.2 0 0 0 0 0 0s0 0 6.4-4.8c-6.4-4.8-6.4-4.8-6.4-4.8l0 0 0 0 0 0 .1-.2 .5-.6c.4-.5 1-1.2 1.7-2.1c1.5-1.8 3.6-4.4 6.3-7.5c5.4-6.2 13.1-14.4 22.5-22.7c18.2-16.2 44.2-34 71.3-34s53.1 17.8 71.3 34c9.3 8.3 17 16.5 22.5 22.7c2.7 3.1 4.8 5.7 6.3 7.5c.7 .9 1.3 1.6 1.7 2.1l.5 .6 .1 .2 0 0 0 0 0 0zM352 352l6.4 4.8L362 352l-3.6-4.8L352 352zm-198.4-4.8L160 352l-6.4 4.8L150 352l3.6-4.8zM272 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fast',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      'M160 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM304 144c0 76.8-60.2 139.6-136 143.8V504v8H152v-8V287.8C76.2 283.6 16 220.8 16 144C16 64.5 80.5 0 160 0s144 64.5 144 144zM80 136H64c0-48.6 39.4-88 88-88V64c-39.8 0-72 32.2-72 72z'
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fast',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      'M19.7 182.9C48.9 108.3 108.3 49 182.9 19.8L318.6 269.1l-49.4 49.4L19.7 182.9zM190.4 0C100.9 30.3 30.2 100.9 0 190.4l14.3 7.8C5 226.4 0 256.6 0 288c0 60.9 18.9 117.4 51.2 163.9c3 4.3 6 8.5 9.2 12.6l.2 .3 0 0 23.8-18.5c26.9 29 60.5 51.7 98.2 65.7L224 480l-16-96V350.2l35.3-27.5L272 338.4 338.4 272l-15.6-28.7L350.2 208H384l96 16 32-41.3c-14.1-37.8-36.8-71.3-65.7-98.2l18.5-23.8 0 0-.3-.2c-4.1-3.2-8.3-6.3-12.6-9.2C405.4 18.9 348.9 0 288 0c-31.4 0-61.6 5-89.8 14.3L190.4 0zm246 97.2c24.6 23.1 44.2 51.3 57.4 82.9l-20.6 26.5-86.6-14.4-1.3-.2H384 362.7l73.8-94.8zM192 362.7V384v1.3l.2 1.3 14.4 86.6-26.5 20.6c-31.6-13.1-59.8-32.8-82.9-57.4L192 362.7zM16 288c0-28.6 4.4-56.2 12.6-82L228 314.4 63.8 442.1C33.7 398.3 16 345.2 16 288zM442.1 63.8L314.4 228 206 28.6C231.9 20.4 259.4 16 288 16c57.2 0 110.3 17.7 154.1 47.8z'
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fast',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      'M432 16V176H208V16H432zM208 0H192V16 176v16h16H312v56H8 0v16H8 152v56H48 32v16V496v16H48 272h16V496 336 320H272 168V264H472v56H368 352v16V496v16h16H592h16V496 336 320H592 488V264H632h8V248h-8H328V192H432h16V176 16 0H432 208zM48 336H272V496H48V336zm544 0V496H368V336H592z'
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fast',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      'M0 0V128 416v8H8 256V408H16V136H256V120H16V0H0zM433.4 48H440 560V208H304V16h97.4l27.3 27.3 4.7 4.7zM560 32H440L408 0H304 288V16 208v16h16H560h16V208 48 32H560zM433.4 336H440 560V496H304V304h97.4l27.3 27.3 4.7 4.7zM560 320H440l-32-32H304 288v16V496v16h16H560h16V496 336 320H560z'
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fast',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM100.9 128h-5l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H214.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H100.9zM104 240H88v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H216v8V496H184V344v-8h-8H144h-8v8V496H104V248v-8zM440 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM439.6 210.5l2.5-7.6-15.2-5.1-2.5 7.6-56 168L364.9 384H376h32V504v8h8 48 8v-8V384h16V504v8h8 48 8v-8V384h32 11.1l-3.5-10.5-56-168-2.5-7.6-15.2 5.1 2.5 7.6L572.9 368H552 536 504 488 472 456 424 408 387.1l52.5-157.5zM424 496V384h32V496H424zm80-112h32V496H504V384zM415.9 128l-2.2 4.5-84.9 176-3.5 7.2 14.4 7 3.5-7.2L425.9 144H534.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H420.9h-5z'
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fast',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      'M144 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM46.1 237.2c14.4-26.5 30.7-48.7 41.2-61.2H224 360.7c10.5 12.5 26.8 34.7 41.2 61.2c16.9 31 30.1 65.9 30.1 97.2c0 50.9-24.5 90.8-62.7 118.4C330.7 480.7 278.1 496 224 496s-106.7-15.3-145.3-43.2c-18.3-13.2-33.4-29.2-44.2-47.9L32 400v.5c-10.3-19.3-16-41.4-16-66.1c0-31.2 13.2-66.2 30.1-97.2zM0 334.4c0 37.4 11.9 69.4 32 95.5V512H48V447.9C90.7 489.6 156.7 512 224 512s133.3-22.4 176-64.1V512h16V429.9c20.1-26.1 32-58.1 32-95.5c0-58.8-40.9-124.6-66.8-158.4H448V160H368 224 80 0v16H66.8C40.9 209.8 0 275.6 0 334.4z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fast',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 408l0 16 8 0 88 0 0 40 0 16 16 0 96 0 16 0 0-16 0-40 280 0 8 0 0-16-8 0-280 0 0-40 0-16-16 0-96 0-16 0 0 16 0 40L8 408l-8 0zm208 16l0 40-96 0 0-40 0-16 0-40 96 0 0 40 0 16zM0 248l0 16 8 0 280 0 0 40 0 16 16 0 96 0 16 0 0-16 0-40 88 0 8 0 0-16-8 0-88 0 0-40 0-16-16 0-96 0-16 0 0 16 0 40L8 248l-8 0zm400 0l0 16 0 40-96 0 0-40 0-16 0-40 96 0 0 40zM8 88L0 88l0 16 8 0 120 0 0 40 0 16 16 0 96 0 16 0 0-16 0-40 248 0 8 0 0-16-8 0L256 88l0-40 0-16-16 0-96 0-16 0 0 16 0 40L8 88zm232 16l0 40-96 0 0-40 0-16 0-40 96 0 0 40 0 16z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fast',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM80 256c0 39.4 15.7 67.9 31.5 86.7c7.9 9.5 15.9 16.4 21.8 21c2.3 1.8 4.3 3.2 5.8 4.3H308.9c1.5-1 3.5-2.5 5.8-4.3c5.9-4.6 13.8-11.6 21.8-21C352.3 323.9 368 295.4 368 256s-15.7-67.9-31.5-86.7c-7.9-9.5-15.9-16.4-21.8-21c-2.3-1.8-4.3-3.2-5.8-4.3H139.1c-1.5 1-3.5 2.5-5.8 4.3c-5.9 4.6-13.8 11.6-21.8 21C95.7 188.1 80 216.6 80 256zm-16 0c0-88 70.4-128 70.4-128H313.6s70.4 40 70.4 128s-70.4 128-70.4 128H134.4s-70.4-40-70.4-128zm104-64v8 64 8H152v-8V200v-8h16zm128 0v8 64 8H280v-8V200v-8h16zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32V304zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32v16 16H240 208 192V320 304z'
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fast',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      'M128 232V351.6l96 66V232v-7l5.1-4.7L336 121V80H16v41l106.9 99.3L128 225v7zm-16 0L0 128V80 64H16 336h16V80v48L240 232V428.6 448l-16-11L112 360V232zM384 80h8H504h8V96h-8H392h-8V80zM328 240H504h8v16h-8H328h-8V240h8zm0 160H504h8v16h-8H328h-8V400h8z'
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fast',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      'M256 .6l4.7 3.5 64 47 4.7 3.5-1.9 5.5L316.9 91.7C343 110.6 360 141.3 360 176c0 34.8-17.1 65.6-43.4 84.5l11 32.9 1.8 5.5-4.6 3.5L264 348v23.8l52.6-32.3c56.8-34.8 91.4-96.6 91.4-163.2c0-20.6-3.3-41-9.8-60.5L384.4 74.5l-5.6-16.9 16.4 7 1.4 .6C466.6 95.3 512 164.1 512 240.4c0 62.5-30.7 121.1-82.1 156.7l-25.4 17.6-4.4 3-4.5-2.9-84-53.4-40.4 24.8 67.9 41.6c3.7-2.3 8.1-3.7 12.8-3.7c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24c0-2.7 .4-5.3 1.2-7.7l-65.2-40V449c13.8 3.6 24 16.1 24 31c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-14.9 10.2-27.4 24-31V400.4l-65.2 40c.8 2.4 1.2 5 1.2 7.7c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24c4.7 0 9.1 1.4 12.8 3.7l67.9-41.6-40.4-24.8-84 53.4-4.5 2.9-4.4-3L82.1 397C30.7 361.4 0 302.9 0 240.4C0 164.1 45.4 95.3 115.5 65.2l1.4-.6 16.4-7-5.6 16.9-13.8 41.3c-6.5 19.5-9.8 39.9-9.8 60.5c0 66.6 34.6 128.4 91.4 163.2L248 371.8V348l-60.8-45.6-4.6-3.5 1.8-5.5 11-32.9C169.1 241.7 152 210.8 152 176c0-34.7 17-65.4 43.1-84.3L184.4 60.2l-1.9-5.5 4.7-3.5 64-47L256 .6zM200.5 107.7C180.7 123.9 168 148.4 168 176c0 27.7 12.8 52.4 32.7 68.5l10.1-30.3c8.3-24.8 8.2-51.6-.2-76.4l-10.2-30.1zM311.3 244.5c20-16.1 32.7-40.8 32.7-68.5c0-27.6-12.7-52.1-32.5-68.3l-10.2 30.1c-8.4 24.8-8.4 51.6-.2 76.4l10.1 30.3zM201.5 60.6l24.4 72.2c9.5 28.1 9.5 58.4 .2 86.5l-24.6 73.8L256 334l54.6-40.9L286 219.3c-9.4-28.1-9.3-58.5 .2-86.5l24.4-72.2L256 20.5 201.5 60.6zM168 448a8 8 0 1 0 -16 0 8 8 0 1 0 16 0zm104 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80-24a8 8 0 1 0 0-16 8 8 0 1 0 0 16zM185.1 352C124.7 314.1 88 247.8 88 176.4c0-22.3 3.6-44.4 10.6-65.6l7.8-23.3C51 117.9 16 176.3 16 240.4c0 57.3 28.1 110.9 75.2 143.5l21 14.5L185.1 352zm214.7 46.4l21-14.5c47.1-32.6 75.2-86.2 75.2-143.5c0-64.1-35-122.5-90.4-152.9l7.8 23.3c7 21.1 10.6 43.3 10.6 65.6c0 71.4-36.7 137.7-97.1 175.6l72.9 46.4z'
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fast',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      'M160 464C80.5 464 16 399.5 16 320c0-90.4 42.6-158.1 97.4-203.7C168.7 70.3 235.2 48 280 48c23.2 0 47.9 11.8 68.1 25.3c9.8 6.6 18.1 13.1 23.8 18.1c2.9 2.5 5.1 4.5 6.6 5.9c.7 .7 1.3 1.2 1.7 1.6l.4 .4 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .1 .1 .4 .4c.3 .4 .9 .9 1.6 1.7c1.4 1.5 3.4 3.7 5.9 6.6c4.9 5.8 11.5 14 18.1 23.8C420.2 152.1 432 176.8 432 200c0 44.8-22.3 111.3-68.3 166.6C318.1 421.4 250.4 464 160 464zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM234.4 113.1l0 0 0 0 0 .1 0 .2-.1 .6c-.1 .5-.2 1.3-.3 2.3c-.2 2-.4 4.7-.6 8.2c-.4 6.9-.5 16.4 .5 27.1c2 21.1 8.4 48.1 27.4 67.1s46 25.5 67.1 27.4c10.7 1 20.2 .9 27.1 .5c3.4-.2 6.2-.4 8.2-.6c1-.1 1.7-.2 2.3-.3l.6-.1 .2 0 .1 0 0 0 0 0s0 0-1.1-7.9c7.9 1.2 7.9 1.1 7.9 1.1l0 0 0 0 0-.1 0-.2 .1-.6c.1-.5 .2-1.3 .3-2.3c.2-2 .4-4.7 .6-8.2c.4-6.9 .5-16.4-.5-27.1c-2-21.1-8.4-48.1-27.4-67.1s-46-25.5-67.1-27.4c-10.7-1-20.2-.9-27.1-.5c-3.4 .2-6.2 .4-8.2 .6c-1 .1-1.7 .2-2.3 .3l-.6 .1-.2 0-.1 0 0 0 0 0s0 0 1.1 7.9c-7.9-1.2-7.9-1.1-7.9-1.1zM365.7 237.7l7.9 1.2-.9 5.9-5.9 .9-1.1-7.9zM249.3 125.3c.1-1.4 .2-2.6 .2-3.8c1.1-.1 2.4-.2 3.8-.2c6.3-.3 15.1-.4 24.8 .5c19.8 1.8 42.2 7.7 57.3 22.8s21 37.5 22.8 57.3c.9 9.7 .8 18.5 .5 24.8c-.1 1.4-.2 2.6-.2 3.8c-1.1 .1-2.4 .2-3.8 .2c-6.3 .3-15.1 .4-24.8-.5c-19.8-1.8-42.2-7.7-57.3-22.8s-21-37.5-22.8-57.3c-.9-9.7-.8-18.5-.5-24.8zm-8.2-19l1.2 7.9-7.9-1.2 .9-5.9 5.9-.9z'
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fast',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      'M400 48V96H320 240v16h80c61.9 0 112 50.1 112 112c0 5.4-.1 10.8-.4 16H16.4c-.2-5.2-.4-10.6-.4-16c0-61.9 50.1-112 112-112V96H48V48H152V160v8h8 40 8v-8V48H400zm30.5 208c-2.9 30-9.7 56.7-18.7 80H36.3c-9-23.3-15.8-50-18.7-80h413zM405 352c-10.1 22-21.9 40.8-33.7 56.3c-15.2 19.9-30.4 34.6-41.7 44.3c-5.6 4.8-10.3 8.4-13.5 10.7l-1 .7H132.9l-1-.7c-3.2-2.3-7.8-5.8-13.5-10.7c-11.3-9.7-26.5-24.3-41.7-44.3C64.9 392.8 53 374 43 352H405zM168 48h24V152H168V48zM48 112H66C26.6 133.8 0 175.8 0 224C0 400 128 480 128 480H320s128-80 128-256c0-48.2-26.6-90.2-66-112h18 16V96 48 32H400 48 32V48 96v16H48z'
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fast',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      'M144 80c0 7 3.6 14.5 11.9 22.2c3.8 3.5 8.5 7 14 10.3c-8.4 .3-16.7 .8-24.8 1.5l-.1-.1c-10.3-9.5-17-21-17-33.9s6.7-24.4 17-33.9c10.3-9.5 24.8-17.7 42-24.5C221.4 8.2 268.5 0 320 0s98.6 8.2 133 21.6c17.2 6.7 31.7 14.9 41.9 24.5c10.3 9.5 17 21 17 33.9V184l0 105.9c0 12.7-6.8 24-17.1 33.2s-24.8 17.3-41.9 23.8c-11.1 4.2-23.5 7.9-37 11V341.5c11.4-2.7 21.9-5.9 31.3-9.5c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3V216.2c-.4 .3-.7 .7-1.1 1c-10.3 9.3-24.8 17.3-41.9 23.8c-11.1 4.2-23.5 7.9-37 11V235.6c11.4-2.7 21.9-5.9 31.3-9.5c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3l0-71.1c-.3 .3-.7 .6-1 1c-10.3 9.5-24.8 17.7-41.9 24.5c-20.1 7.9-44.6 13.9-71.7 17.6c-7.1-5-15-9.5-23.4-13.5c34.7-2.9 65.5-9.7 89.3-19c16.1-6.3 28.6-13.6 36.9-21.3C492.4 94.5 496 87 496 80s-3.6-14.5-11.9-22.2c-8.3-7.7-20.8-15-36.9-21.3C415 24 370.1 16 320 16s-95 8-127.2 20.5c-16.1 6.3-28.6 13.6-36.9 21.3C147.6 65.5 144 73 144 80zM16 224c0 7 3.6 14.5 11.9 22.2c8.3 7.7 20.8 15 36.9 21.3C97 280 141.9 288 192 288s95-8 127.2-20.5c16.1-6.3 28.6-13.6 36.9-21.3C364.4 238.5 368 231 368 224s-3.6-14.5-11.9-22.2c-8.3-7.7-20.8-15-36.9-21.3C287 168 242.1 160 192 160s-95 8-127.2 20.5c-16.1 6.3-28.6 13.6-36.9 21.3C19.6 209.5 16 217 16 224zM0 224c0-12.9 6.7-24.4 17-33.9c10.3-9.5 24.8-17.7 42-24.5C93.4 152.2 140.5 144 192 144s98.6 8.2 133 21.6c17.2 6.7 31.7 14.9 41.9 24.5c10.3 9.5 17 21 17 33.9V328l0 105.9c0 12.7-6.8 24-17.1 33.2s-24.8 17.3-41.9 23.8C290.5 504.1 243.5 512 192 512s-98.5-7.9-133-21.1c-17.2-6.5-31.6-14.5-41.9-23.8S0 446.6 0 433.9V328 224zm368 32.9c-.3 .3-.7 .6-1 1c-10.3 9.5-24.8 17.7-41.9 24.5C290.6 295.8 243.5 304 192 304s-98.6-8.2-133-21.6c-17.2-6.7-31.7-14.9-42-24.5c-.3-.3-.7-.6-1-1V328c0 6.6 3.5 13.8 11.8 21.3s20.8 14.6 36.9 20.7c32.2 12.3 77.2 20 127.3 20s95.1-7.8 127.3-20c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3l0-71.1zM17.1 361.2c-.4-.3-.7-.7-1.1-1v73.7c0 6.6 3.5 13.8 11.8 21.3s20.8 14.6 36.9 20.7c32.2 12.3 77.2 20 127.3 20s95.1-7.7 127.3-20c16.1-6.1 28.6-13.3 36.9-20.7s11.8-14.7 11.8-21.3V360.2c-.4 .3-.7 .7-1.1 1c-10.3 9.3-24.8 17.3-41.9 23.8c-34.4 13.1-81.4 21.1-133 21.1s-98.5-7.9-133-21.1c-17.2-6.5-31.6-14.5-41.9-23.8z'
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fast',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      'M288 0h8H504h8V8 192h48V104 96h16v8 88h56 8v8V496v8H624v-8V208H576 560 504h-8v-8V16H304V170l-16-25.6V8 0zm72 72h8 64 8v8 64 8h-8H368h-8v-8V80 72zm16 16v48h48V88H376zm8 112h48 8v8 48 8H424v-8V216H384h-8V200h8zm104 64h8 64 8v8 64 8h-8H496h-8v-8V272v-8zm16 64h48V280H504v48zm-8 64h64 8v8 64 8h-8H496h-8v-8V400v-8h8zm8 64h48V408H504v48zm-34 40l10 16H461.1 18.9 0l10-16L230.6 143.1 240 128l9.4 15.1L470 496zM341.1 320H242.7l-44.6 53.1-6 7.2-6.1-7-46.9-53.6L28.9 496H451.1l-110-176zm-10-16L240 158.2 147.9 305.5l43.9 50.2 41-48.8 2.4-2.9H239h92.1z'
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fast',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM312 96c39.8 0 72 32.2 72 72s-32.2 72-72 72h-8v16h8c48.6 0 88-39.4 88-88s-39.4-88-88-88c-32.6 0-61 17.7-76.2 44l-4 6.9 13.8 8 4-6.9c12.5-21.5 35.7-36 62.4-36zM172.6 293.6l5.6-5.7-11.4-11.2-5.6 5.7C145.6 298.3 136 320 136 344c0 48.6 39.4 88 88 88s88-39.4 88-88c0-24-9.6-45.7-25.2-61.6l-5.6-5.7-11.4 11.2 5.6 5.7c12.7 13 20.6 30.8 20.6 50.4c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-19.6 7.8-37.4 20.6-50.4zM128 148.7L116.7 160l5.7 5.7L216 259.3V352v8h16v-8V259.3l93.7-93.7 5.7-5.7L320 148.7l-5.7 5.7L224 244.7l-90.3-90.3-5.7-5.7zM198.5 132l4 6.9 13.8-8-4-6.9c-15.2-26.3-43.6-44-76.2-44c-48.6 0-88 39.4-88 88s39.4 88 88 88h8V240h-8c-39.8 0-72-32.2-72-72s32.2-72 72-72c26.6 0 49.9 14.5 62.4 36z'
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fast',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM80 176H272V336H80V176zM64 160v16V336v16H80 272h16V336 176 160H272 80 64z'
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fast',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      'M291.4 203.7l52.9-178L352 0 330.5 16.1 32 240v48l112.7 3.9 16.5 .6-4.7 15.8-52.9 178L96 512l21.5-16.1L416 272V224l-112.7-3.9-16.5-.6 4.7-15.8zM400 239.5V264L125.1 470.2 176.6 297l5.9-19.8-20.7-.7L48 272.5V248L322.9 41.9 271.4 215l-5.9 19.8 20.7 .7L400 239.5zM384.4 448H384v.8L354.6 512h17.7l22.4-48H533.4l22.4 48h17.7L544 448.8V448h-.4L471.3 292.6l-2.2-4.6H458.9l-2.2 4.6L384.4 448zM526 448H402l62-133.1L526 448z'
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fast',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      'M40 32H32v8V256 384v88 8h8H536h8v-8V320 256 112 98.4L532.1 105 368 196.9V112 98.1l-12 7L192 200.7V40 32h-8H40zm8 224V48H176V214.7v13.9l12-7 164-95.6v84.6 13.6l11.9-6.7L528 125.6V256v64V464H48V384 256zm80 48h-8v8 64 8h8 64 8v-8V312v-8h-8H128zm8 64V320h48v48H136zm112-64v8 64 8h8 64 8v-8V312v-8h-8H256h-8zm16 16h48v48H264V320zm120-16h-8v8 64 8h8 64 8v-8V312v-8h-8H384zm8 64V320h48v48H392z'
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fast',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      'M144 32h-6l-1.7 5.7L104 145.5V144H8 0v8 48 8H8 32V384v16 64 16H48h64 16V464 400H448v64 16h16 64 16V464 400 384 208h24 8v-8V152v-8h-8H472v1.5L439.7 37.7 438 32h-6H144zM528 384H464 448 128 112 48V208H528V384zm-64 16h64v64H464V400zM48 400h64v64H48V400zM476.4 160H560v32H544 528 486l-9.6-32zM16 160H99.6L90 192H48 32 16V160zm453.2 32H106.8L150 48H426l43.2 144zM112 288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fast',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      'M349 16c39.2 0 77 13.5 105.3 41.8S496 123.8 496 163c0 49.6-21.5 101.9-62.3 142.7c-72.2 72.2-183.4 85.1-248 20.5C157.5 297.9 144 260.2 144 221c0-49.6 21.5-101.9 62.3-142.7S299.3 16 349 16zm0-16c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 40.3 13.1 79.8 40.9 110.8l-30.6 30.6-23-23L104 328 92.7 339.3 11.3 420.7 0 432l11.3 11.3 57.4 57.4L80 512l11.3-11.3 81.4-81.4L184 408l-11.3-11.3-23-23 30.6-30.6c73.3 66.3 190.4 48.3 264.8-26c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 350.6L161.4 408 80 489.4 22.6 432 104 350.6z'
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fast',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      'M176 112c0-53 43-96 96-96c48 0 87.8 35.2 94.9 81.2l15.8-2.4C374.4 41.1 328 0 272 0C210.1 0 160 50.1 160 112h16zm207.6 32l4.8-5.3C403 122.3 424.3 112 448 112h27.5l-11 44.1-2.6 10.3 8.5 6.4c19.8 14.9 35.6 34.7 45.6 57.6l4.2 9.6h10.5H560V368H512h-8l-4.8 6.4c-14.9 19.8-34.7 35.6-57.6 45.6l-9.6 4.2v10.5V496H336V448h8 8V432h-8-8H320 256 240h-8-8v16h8 8v48H144V416v-8l-6.4-4.8C102.6 376.9 80 335.1 80 288c0-79.5 64.5-144 144-144H376.4h7.2zM256 464V448h16 32 16v16 32 16h16 96 16V496 434.7c25.5-11.1 47.5-28.7 64-50.7h48 16V368 240 224H560 530.7c-11.1-25.5-28.7-47.5-50.7-64l12-48 4-16H479.5 448c-28.4 0-54 12.4-71.6 32H224c-83 0-151.2 63.1-159.2 144H52c-19.9 0-36-16.1-36-36s16.1-36 36-36h4 8V184H56 52c-28.7 0-52 23.3-52 52s23.3 52 52 52H64c0 52.3 25.1 98.8 64 128v80 16h16 96 16V496 464zM416 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fast',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      'M78.8 74.3L73 75.9l-.1 6L70.2 242.2l-35 9.4-15.5 4.1 4.1 15.5L65.3 425.8l4.1 15.5 12.4 46.4L86 503l15.5-4.1 61.8-16.6 15.5-4.1-4.1-15.5-12.4-46.4 278.2-74.5 12.4 46.4 4.1 15.5 15.5-4.1 61.8-16.6 15.5-4.1-4.1-15.5L533.1 317 529 301.5 487.5 147l-4.1-15.5-15.5 4.1-35 9.4L350.5 7.5l-3.1-5.2-5.8 1.6L78.8 74.3zm63.8 330.8L80.8 421.6 39.4 267.1l432.7-116 41.4 154.5-61.8 16.6-15.5 4.1L158 400.9l-15.5 4.1zm-57.7 32l61.8-16.6 12.4 46.4L97.3 483.4 84.9 437.1zm332-287.7L86.3 237.9 88.8 88.2 339.8 20.9l77 128.4zM468.2 384l-12.4-46.4 61.8-16.6 12.4 46.4L468.2 384zM121.9 327.8a16 16 0 1 1 30.9-8.3 16 16 0 1 1 -30.9 8.3zm46.4-12.4a32 32 0 1 0 -61.8 16.6 32 32 0 1 0 61.8-16.6zm243.1-81.7a16 16 0 1 1 8.3 30.9 16 16 0 1 1 -8.3-30.9zM423.8 280a32 32 0 1 0 -16.6-61.8A32 32 0 1 0 423.8 280zm77.8 152c47.3 0 86.5 34.7 93.5 80h16.1c0-.4 0-.8-.1-1.1c-7.7-53.6-53.8-94.9-109.5-94.9s-101.9 41.2-109.5 94.9c-.1 .4-.1 .8-.1 1.1h16.1c7-45.3 46.2-80 93.5-80z'
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fast',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      'M0 360v3.3l1.3 3C2.8 369.7 52.4 480 224 480s221.2-110.3 222.7-113.6l1.3-3V360v0V128v-2 0 0c0-17-9.2-31.3-21.7-42.3c-12.5-11.1-29.7-20.4-49.6-27.8C336.8 40.9 282.8 32 224 32s-112.8 8.9-152.7 23.9C51.4 63.3 34.2 72.6 21.7 83.7C9.2 94.7 0 109 0 126v0 0 0 0 0 0 0 0 2V360v0zM16 165.4c1.8 1.9 3.6 3.8 5.6 5.5c12.5 11.4 29.7 20.9 49.6 28.5C111.1 214.8 165.1 224 224 224s112.9-9.2 152.8-24.5c19.9-7.7 37.1-17.2 49.6-28.5c2-1.8 3.8-3.6 5.6-5.5V360c-.1 .2-45.3 104-208 104S16.1 360.2 16 360V165.4zM224 48l2.5 0L236 72.9l-89.6 31.5-1.8 .6-1.3 1.4L70.5 182C36.7 167.8 16 148.8 16 128c0-44.2 93.1-80 208-80zM86.8 188.1l66.7-69.2 88.2-31.1 20.4 53.2 1.3 3.4 3.4 1.3 104.1 38.9C333.3 199.1 281.3 208 224 208c-52.6 0-100.6-7.5-137.2-19.9zm189-56.2l-32-83.6C349.4 52.2 432 86.4 432 128c0 17.7-15 34.1-40.3 47.3L275.8 132z'
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fast',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      'M288 16c15.9 0 31.4 1.5 46.5 4.5l3.1-15.7C321.5 1.6 304.9 0 288 0C225.1 0 167.4 22.7 122.8 60.4l10.3 12.2C175 37.3 229 16 288 16zm0 480c-87.2 0-163.6-46.5-205.6-116.1l-13.7 8.3C113.5 462.3 194.9 512 288 512c141.4 0 256-114.6 256-256H528c0 132.5-107.4 240-240 240zM518.6 111.6l2.3 0L500.4 86.1c-20-25-44.4-46.4-72-63.1l-4.7-2.9-5.5 .7c-72.4 9-140.9 30.4-203.3 62c-50.8 3.9-100.4 11.8-148.6 23.4l-6.4 1.5-3.5 5.6c-14.9 24.2-26.2 50.9-33 79.4l-6.4 27 24.6-7.4c-7.4 7.9-14.6 16-21.6 24.2l-3.6 4.2-.2 5.6c-.1 3.2-.2 6.4-.2 9.7c0 29.7 4.8 58.3 13.6 85.1l10.2 31L58 345c46.9-69.5 109.8-127.2 183.5-167.8c15.4-.8 30.9-1.3 46.5-1.3c85 0 167 12.5 244.4 35.8l26.6 8-6.4-27c-6.8-28.5-18-55.2-33-79.4l-1.1-1.7zm-243 48.5l0 0c-12.9 .2-25.7 .6-38.5 1.4l0 0c-47.8 2.8-94.6 9.4-140 19.7l0 0c-10.9 2.5-21.7 5.1-32.5 8l0 0c-2.6 .7-5.2 1.4-7.8 2.1c-6 1.7-11.9 3.4-17.9 5.2c1.5-6.1 3.1-12.2 5-18.2c6.4-20 15.1-39 26-56.5C139.9 104.9 212.9 96 288 96s148.1 8.9 218 25.8c10.8 17.5 19.6 36.5 26 56.5c1.9 6 3.6 12 5 18.2c-5.9-1.8-11.9-3.5-17.9-5.2C445.6 170.9 368.1 160 288 160c-4.2 0-8.3 0-12.4 .1zM72.7 203.6c43-11.3 87.4-19.2 132.8-23.6c-58 36.7-108.7 84.1-149.1 139.5c-4 5.5-7.9 11-11.7 16.6c-2.1-6.5-4-13.2-5.7-19.9C34.5 296.8 32 276.7 32 256c0-3 .1-6.1 .2-9.1c12.8-15.1 26.3-29.6 40.5-43.3zm185-123.1c50.9-21.7 105.5-36.7 162.4-43.8c20 12.1 38.2 26.8 54.2 43.7c4.7 5 9.3 10.2 13.6 15.6c-6.8 .1-13.6 .3-20.4 .7l-1.3 .1C408.5 85.8 348.9 80 288 80c-10.1 0-20.2 .2-30.3 .5zM389.4 379.8C369 361.2 337.8 344 296 344c-15.6 0-29.7 2.4-42.4 6.4l4.8 15.3c11.2-3.5 23.7-5.6 37.6-5.6c37.1 0 64.6 15.2 82.6 31.6l10.8-11.8zM224.4 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fast',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm249 19l21.7 94.1 71.9-199.7L142.9 241.3 237 263l9.7 2.2L249 275zm-15.6 3.6L115.1 251.3l-28.8-6.6 27.8-10 235.5-84.8 19.5-7-7 19.5L277.3 397.9l-10 27.8-6.6-28.8L233.4 278.6z'
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fast',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-23.7 97.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 384.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm-3.4 18.9l-7.7-7.4c-8.5-8.2-19.8-12.7-31.6-12.7h-2.4c-23.9 0-43.2 19.3-43.2 43.2c0 11.7 4.8 23 13.2 31.1L256 361.9l82.8-79.6c8.5-8.1 13.2-19.4 13.2-31.1c0-23.9-19.3-43.2-43.2-43.2h-2.4c-11.8 0-23.1 4.6-31.6 12.7l-7.7 7.4L256 238.8l-11.1-10.7z'
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fast',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      'M212.5 36.1C223 19 239 2.8 258.8 2.8C279 2.8 295 19 305.4 36.1c10.7 17.6 17.3 39.3 17.3 55.8l0 78.8 0 9.3L510.7 283.8l4.1 2.3 0 4.7 0 88 0 10.5-10.1-2.8L322.8 336.3l0 10.5 0 44 60.8 45.6 3.2 2.4 0 4 0 56 0 10.4-10.1-2.7L258.8 475.1 140.9 506.5l-10.1 2.7 0-10.4 0-56 0-4 3.2-2.4 60.8-45.6 0-44 0-10.5L12.9 386.5 2.8 389.3l0-10.5 0-88 0-4.7 4.1-2.3L194.8 180.1l0-9.3 0-78.8c0-16.6 7-38.3 17.7-55.9zm-1.7 134.7l0 14.1 0 130.5 0 10.5 0 21 0 48 0 4-3.2 2.4-60.8 45.6 0 41.6 109.9-29.3 2.1-.6 2.1 .6 109.9 29.3 0-41.6L310 401.2l-3.2-2.4 0-4 0-48 0-21 0-10.5 0-125.7 0-4.7 0-14.1 0-78.8c0-13-5.6-31.9-15-47.5c-9.7-16-21.6-25.6-33-25.6c-10.9 0-22.8 9.6-32.7 25.7C216.5 60.1 210.8 79 210.8 92l0 78.8zm-16 27.6l-176 97.1 0 72.8 176-48.6 0-121.3zm128 121.3l176 48.6 0-72.8-176-97.1 0 121.3z'
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fast',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      'M336 16V384H48V16H336zm0 384v96H48V400H336zM48 0H32V16 496v16H48 336h16V496 16 0H336 48zm88 440v16h8 96 8V440h-8H144h-8z'
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fast',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      'M208 400a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm0 16c-48.3 0-92.7-16.4-128-44V496H272h64V372c-35.3 27.6-79.7 44-128 44zm64 96H72 64v-8V358.1C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1V496H456V447.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V504v8h-8H352h-8H272zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM496 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fast',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      'M96 256.8l-7.1 4.8C54.6 284.6 32 323.7 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-44.4-22.6-83.5-56.9-106.5l-7.1-4.8v-8.5V16H96V248.3v8.5zM224 0h16V16 248.3c38.6 25.8 64 69.8 64 119.8c0 79.5-64.5 144-144 144S16 447.6 16 368c0-49.9 25.4-93.9 64-119.8V16 0H96 224zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V136v-8h16v8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fast',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      'M8 0H0V8 320v3.3l2.3 2.3L32 355.3V384 504v8h8H344h8v-8V387.1l93.9-101.7 2.1-2.3V280 136v-8h-8H384V8 0h-8H8zm8 316.7V16H368V128H264h-8v8 56H115.3L77.7 154.3 72 148.7 60.7 160l5.7 5.7 40 40 2.3 2.3H112 256v72 8h8 72 8V272h-8H272V144h96 6 2 6 50V276.9L338.1 378.6l-2.1 2.3V384 496H48V384 352v-3.3l-2.3-2.3L16 316.7zm124.6 20.8l-6.5-4.6-9.3 13 6.5 4.6L178.2 384l-46.9 33.5-6.5 4.6 9.3 13 6.5-4.6L192 393.8l51.4 36.7 6.5 4.6 9.3-13-6.5-4.6L205.8 384l46.9-33.5 6.5-4.6-9.3-13-6.5 4.6L192 374.2l-51.4-36.7z'
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fast',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1L512 197.5V40 32h-8H392h-8v8V87.7L293.2 9.9zM400 101.5V48h96V183.7l-96-82.3zm96 103.4V496H80V204.8L288 26.5 496 204.8zM248 176v8 64H184h-8v8 64 8h8 64v64 8h8 64 8v-8V328h64 8v-8V256v-8h-8H328V184v-8h-8H256h-8zm16 16h48v64 8h8 64v48H320h-8v8 64H264V320v-8h-8H192V264h64 8v-8V192z'
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fast',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      'M216.8 490.1L443.1 359.5 248.1 21.9 21.9 152.5 216.8 490.1zM0 146.7L240.1 8 254 0l8 13.9L456.9 351.5l8 13.9-13.9 8L224.8 504l-13.9 8-8-13.9L0 146.7zM320 486l16-9.2V496H624V80H337.1l-9.2-16H624h16V80 496v16H624 336 320V496 486zM502 151.1c-8.4-8.5-21.7-9.5-29.9-2.4l0 0 0 0c-10.2 8.8-10.7 24.4-1.6 33.8l0 0L512 225.8l41.5-43.2 0 0c9.1-9.4 8.6-25.1-1.4-33.8c-8.6-7.2-21.7-6.1-30.1 2.3l-4 4.5-5.8 6.4-5.9-6.2-4.3-4.5zm10-12.6c13.6-12.6 35.2-14.8 50.5-2l.1 .1 0 0c17 14.8 17.8 41.1 2.5 57l0 0-47.3 49.2-5.8 6-5.8-6-47.3-49.2 0 0c-15.4-15.9-14.6-42.2 2.7-57.1c14.9-12.9 36.8-10.6 50.3 1.9zM245 284.8l1.8-8.4 8.3 2.4 19.5 5.7c21 5.8 42.8-4.9 49.1-23.4l0-.1c8.1-23.1-5.3-48.2-28.1-54.7l0 0L189.3 176.2 162.7 283l0 0c-5.7 23 9.3 47.2 32.9 51.9c20 3.5 39.7-10.1 45.2-30.8l4.2-19.4zm11.3 23.4c-7.4 28-34.3 47.6-63.5 42.5l-.2 0 0 0c-32.8-6.5-53.4-39.7-45.5-71.5l28.6-114.9 2-8 8 2.3L299.9 191l0 0c31.6 9.1 50 43.5 38.8 75.4c-9.5 27.5-40.5 41.3-68.6 33.5l-.1 0 0 0-.1 0L288.1 329l16.4-9.4 6.9-4 8 13.9-6.9 4-48.2 27.8-6.9 4-8-13.9 6.9-4 18-10.4-17.9-28.8z'
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fast',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      'M389.6 402.7c-19.1 25.2-37.4 47.6-51.8 64.7c-7 8.2-13 15.2-17.8 20.6c-4.8-5.4-10.8-12.4-17.8-20.6c-17.8-21-41.6-50.2-65.3-82.8c-23.7-32.6-47.2-68.4-64.7-102.6c-13.5-26.5-22.9-51-26.5-71.8l-17.6-13.9c4 96.5 141.3 258.7 181.2 303.8c6.8 7.7 10.7 12 10.7 12s4-4.3 10.7-12c14.6-16.5 42.1-48.6 71.5-87.4l-12.6-9.9zM320 0C266.7 0 218.5 21.7 183.8 56.7l12.6 10C228.2 35.3 271.8 16 320 16c97.2 0 176 78.8 176 176c0 23.9-10.4 54.9-27.9 89.2l12.8 10.1c18.6-36 31.1-70.8 31.1-99.3C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-17.5 0-33.8 5.6-46.9 15.2l13.2 10.4c9.8-6.1 21.4-9.6 33.8-9.6c35.3 0 64 28.7 64 64c0 7.1-1.1 13.9-3.3 20.2l13.2 10.4c3.9-9.4 6.1-19.8 6.1-30.6zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fast',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M16 232.9L160 362.5 304 232.9V208H16v24.9zM160 384L0 240V208 192H16 304h16v16 32L160 384z'
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fast',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M432 16V496H16V16H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM192 120v16h8H376h8V120h-8H200h-8zm0 128v16h8H376h8V248h-8H200h-8zm0 128v16h8H376h8V376h-8H200h-8zM72 344H56v16 48 16H72h48 16V408 360 344H120 72zm0 16H88h16 16v16 16 16H104 88 72V392 376 360zM56 216v16 48 16H72h48 16V280 232 216H120 72 56zm32 16h16 16v16 16 16H104 88 72V264 248 232H88zM72 88H56v16 48 16H72h48 16V152 104 88H120 72zm0 16H88h16 16v16 16 16H104 88 72V136 120 104z'
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fast',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      'M16 112V400H432V112H16zM0 96H16 432h16v16V400v16H432 16 0V400 112 96zM624 384H480V368H624V144H480V128H624h16v16V368v16H624zm-48-96H544v32h32V288zm-32-16h32 16v16 32 16H576 544 528V320 288 272h16zm0-80v32h32V192H544zm-16-16h16 32 16v16 32 16H576 544 528V224 192 176z'
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fast',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      'M224 4.7l5.7 5.7 88 88 5.7 5.7L312 115.3l-5.7-5.7L232 35.3V184v8H216v-8V35.3l-74.3 74.3-5.7 5.7L124.7 104l5.7-5.7 88-88L224 4.7zM48 240v32H16V240H48zm64 0h32v32H112V240zm128 0v32H208V240h32zm64 0h32v32H304V240zm128 0v32H400V240h32zM229.7 501.7l-5.7 5.7-5.7-5.7-88-88-5.7-5.7L136 396.7l5.7 5.7L216 476.7V328v-8h16v8V476.7l74.3-74.3 5.7-5.7L323.3 408l-5.7 5.7-88 88z'
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fast',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      'M16 80V432H560V80H16zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM80 336v32h32V336H80zM64 320H80h32 16v16 32 16H112 80 64V368 336 320zm336 16H176v32H400V336zM176 320H400h16v16 32 16H400 176 160V368 336 320h16zM80 240v32h32V240H80zM64 224H80h32 16v16 32 16H112 80 64V272 240 224zm144 16H176v32h32V240zm-32-16h32 16v16 32 16H208 176 160V272 240 224h16zm96 16v32h32V240H272zm-16-16h16 32 16v16 32 16H304 272 256V272 240 224zm144 16H368v32h32V240zm-32-16h32 16v16 32 16H400 368 352V272 240 224h16zm96 16v32h32V240H464zm-16-16h16 32 16v16 32 16H496 464 448V272 240 224zm48 112H464v32h32V336zm-32-16h32 16v16 32 16H496 464 448V368 336 320h16zM80 144v32h32V144H80zM64 128H80h32 16v16 32 16H112 80 64V176 144 128zm144 16H176v32h32V144zm-32-16h32 16v16 32 16H208 176 160V176 144 128h16zm96 16v32h32V144H272zm-16-16h16 32 16v16 32 16H304 272 256V176 144 128zm144 16H368v32h32V144zm-32-16h32 16v16 32 16H400 368 352V176 144 128h16zm96 16v32h32V144H464zm-16-16h16 32 16v16 32 16H496 464 448V176 144 128z'
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fast',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      'M112 32v96h96V32H112zM96 16h16 96 16V32v96 16H208 168V256H472V144H432 416V128 32 16h16 96 16V32v96 16H528 488V256H632h8v16h-8H328v96h40 16v16 96 16H368 272 256V480 384 368h16 40V272H8 0V256H8 152V144H112 96V128 32 16zM528 128V32H432v96h40 16 40zM272 384v96h96V384H272z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fast',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M75.7 60.9C44.1 73.7 23.4 95.7 17.8 126.2c-3.7 20.3-1.5 36.1 4.5 48.9c6.1 12.9 16.3 23.5 30.1 32.5c27.8 18.4 67.9 29.3 109.7 40.6l.9 .2c40.8 11 83.2 22.6 113.4 42.5c15.4 10.2 28.1 22.8 35.7 39.1c7.7 16.4 10 35.7 5.8 58.6c-6.8 37.1-32.1 62.8-67.6 77.2c-35.3 14.3-80.9 17.6-130.3 10.3l0 0c-25.6-3.9-67.9-17.6-97.8-27.3c-6.1-2-11.7-3.8-16.6-5.3l4.8-15.3c5.1 1.6 11 3.5 17.3 5.5c30 9.7 70.5 22.8 94.7 26.5c47.5 7 90.1 3.6 121.9-9.3c31.6-12.8 52.3-34.8 57.9-65.3c3.7-20.2 1.5-36.1-4.5-48.9c-6.1-12.9-16.3-23.5-30.1-32.5c-27.8-18.4-67.9-29.3-109.7-40.6l-.9-.2c-40.8-11-83.2-22.6-113.4-42.5c-15.4-10.2-28.1-22.8-35.7-39.1c-7.7-16.4-9.9-35.7-5.8-58.6C8.8 86.2 34.2 60.5 69.7 46.1c35.3-14.3 80.9-17.6 130.3-10.3c14.9 2.2 60.5 10.6 76 14.5L272 65.8c-14.8-3.7-59.8-12-74.5-14.2c-47.5-7-90.1-3.6-121.9 9.3z'
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fast',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      'M8 48H440h8V32h-8H8 0V48H8zm216 80c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160V288c0-88.4-71.6-160-160-160zM80 288c0-79.5 64.5-144 144-144s144 64.5 144 144v32c0 79.5-64.5 144-144 144s-144-64.5-144-144V288z'
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fast',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM284.7 179.3l-25.4 25.4L248 216l11.3 11.3 73.4 73.4L344 312l-11.3 11.3-41.4 41.4L280 376l-11.3-11.3-73.4-73.4L184 280l-11.3 11.3-25.4 25.4L136 328l-11.3-11.3L112 304V160 144h16H272l12.7 12.7L296 168l-11.3 11.3zm-48 48L225.4 216l11.3-11.3L273.4 168l-8-8H128V297.4l8 8 36.7-36.7L184 257.4l11.3 11.3L280 353.4 321.4 312l-84.7-84.7z'
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fast',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      'M408.9 7.1l-5.7-5.7-5.7 5.7L218.3 186.3l-.6 .6-.5 .8L121.7 339 28 432.7l-9.5-9.5-5.7-5.7L1.5 428.8l5.7 5.7 70.4 70.4 5.7 5.7 11.3-11.3-5.7-5.7L79.3 484 173 390.3l151.2-95.5 .8-.5 .6-.6L504.9 114.5l5.7-5.7-5.7-5.7-96-96zM39.3 444L124 359.3 152.7 388 68 472.7 39.3 444zm95.8-96.2L230.3 197 403.2 24.1l84.7 84.7L315 281.7 164.2 376.9l-29.1-29.1zM368 432a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fast',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      'M480 224l84.7-84.7L576 128l-11.3-11.3L459.3 11.3 448 0 436.7 11.3 352 96l-83.3 27.8 15 11.9 72.4-24.1L464.5 219.8l-15.4 46.3 13.4 10.5L480 224zM393.9 406.1L108.5 493.9l-7.5-7.5L238.5 348.9c9.3 7 21 11.1 33.5 11.1c16.2 0 30.7-6.9 41-17.8l-12.6-10c-7.2 7.3-17.3 11.8-28.3 11.8c-22.1 0-40-17.9-40-40c0-7.7 2.2-14.9 6-21l-12.6-10c-5.9 8.9-9.4 19.5-9.4 31c0 12.6 4.1 24.2 11.1 33.5L89.7 475l-7.5-7.5L158.3 220l-13.5-10.6L64 472l40 40 305.1-93.9-15.3-12zm80.5-199L369 101.7l79-79L553.4 128l-79 79zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fast',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      'M64 56a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96A56 56 0 1 1 64 40a56 56 0 1 1 0 112zM168 88h8H496h8v16h-8H176h-8V88zm0 160h8H496h8v16h-8H176h-8V248zm0 160h8H496h8v16h-8H176h-8V408zM64 216a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm0 96a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm40 104a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM8 416a56 56 0 1 1 112 0A56 56 0 1 1 8 416zM64 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fast',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      'M16 164C16 82.3 82.3 16 164 16h4c79.5 0 144 64.5 144 144h8c-100.7 0-183.2 77.4-191.3 176c-.4 5.3-.7 10.6-.7 16h16H496h16c0-5.4-.2-10.7-.7-16c-8.1-98.6-90.7-176-191.3-176h8C328 71.6 256.4 0 168 0h-4C73.4 0 0 73.4 0 164V504v8H16v-8V164zm304 12c91.8 0 167.2 70.3 175.3 160H144.7c8.1-89.7 83.5-160 175.3-160zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H382c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48H241.6z'
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fast',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zM0 512H16L88 352H72L0 512zM328 352L256 512h16l72-160H328zM184 368v-8H168v8 40l-40 0-8 0 0 16 8 0 40 0v40 8h16v-8V424l40 0 8 0 0-16-8 0-40 0V368zm256-8H424v8 40l-40 0-8 0 0 16 8 0 40 0v40 8h16v-8V424l40 0 8 0 0-16-8 0-40 0V368v-8z'
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fast',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M232 64v8 46.8L368 98.4 384 96v16.2 63.6V192l-16-2.4L232 169.2V208h40 3.3l2.3 2.3L323.3 256H376c75.1 0 136 60.9 136 136v48 8h-8H392h-8v-8V408.1c0-13.3-10.8-24-24-24l-40.1 .1C298 413.2 263.2 432 224 432s-74-18.8-95.9-47.8L8 384l-8 0 0-16 8 0 124.2 .2 4.2 0 2.4 3.4c18.8 26.9 50 44.4 85.3 44.4s66.4-17.5 85.3-44.4l2.4-3.4 4.2 0 44.1-.1c22.1 0 40.1 17.9 40.1 40V432h96V392c0-66.3-53.7-120-120-120H320h-3.3l-2.3-2.3L268.7 224H179.3l-45.7 45.7-2.3 2.3H128 8 0V256H8 124.7l45.7-45.7 2.3-2.3H176h40V169.2L80 189.6 64 192V175.8 112.2 96l16 2.4 136 20.4V72 64h16zM80 114.6v58.8L216 153V135L80 114.6zM232 135v18l136 20.4V114.6L232 135z'
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fast',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      'M328 32h-8V48h8H452.7L256 244.7 59.3 48H184h8V32h-8H40 32v8V184v8H48v-8V59.3L244.7 256 48 452.7V328v-8H32v8V472v8h8H184h8V464h-8H59.3L256 267.3 452.7 464H328h-8v16h8H472h8v-8V328v-8H464v8V452.7L267.3 256 464 59.3V184v8h16v-8V40 32h-8H328z'
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fast',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      'M112 32h-6l-1.7 5.7L58 192H16 0v16V384v16 64 16H16 80 96V464 400H416v64 16h16 64 16V464 400 384 208 192H496 454L407.7 37.7 406 32h-6H112zM437.2 192H416v16h80V384H432 416 96 80 16V208H96V192H74.8L118 48H394l43.2 144zM432 464V400h64v64H432zM80 400v64H16V400H80zm0-112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM297.7 98.3l7.9-26.5L284.8 90l-138 120-16.1 14H152h76.8l-18.5 61.7-7.9 26.5L223.2 294l138-120 16.1-14H356 279.2l18.5-61.7zM239.6 208H173.4l101-87.8-13.7 45.5L257.6 176h10.8 66.2l-101 87.8 13.7-45.5 3.1-10.3H239.6z'
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fast',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      'M8 352H0v16H8 80V496H8 0v16H8 80h8 8H312h8 8H544h8 8 72 8V496h-8H560V368h72 8V352h-8H560h-8-8H328h-8-8H96 88 80 8zm88 16H312V496H96V368zm232 0H544V496H328V368z'
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fast',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      'M48 72V64H32v8V248v16V440v8H48v-8V275.5l224 161L288 448V428.3 83.7 64L272 75.5 48 236.5V72zm.3 184L272 95.2V416.8L48.3 256z'
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fast',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      'M209.9 256H366.1L152.8 16H89.9l4.4 8.8L209.9 256zM384 252V120v-8h8H512h3.6l2.4 2.7 120 136 2 2.3v3V408v8h-8H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H8 0v-8V264v-8H8 192L80 32V168c0 22.1-17.9 40-40 40s-40-17.9-40-40V152c0-4.4 3.6-8 8-8s8 3.6 8 8v16c0 13.3 10.7 24 24 24s24-10.7 24-24V32 16 0H80h80L384 252zm1.3 148c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H624V272H16V400H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3zM508.4 128H400V256H621.3L508.4 128zM240 416A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm240 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fast',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      'M624 80V432H16V80H624zM16 64H0V80 432v16H16 624h16V432 80 64H624 16zm88 104v16h8 24V328H112h-8v16h8 64 8V328h-8H152V176v-8h-8H112h-8zm156 26.5c15.1-12.9 37.7-11.3 50.8 3.6c12.5 14.3 11.8 35.9-1.6 49.4l-74.8 74.8-2.3 2.3V328v8 8h8 96 8V328h-8H251.3l69.1-69.1c19.4-19.4 20.5-50.6 2.4-71.2c-18.8-21.5-51.5-23.9-73.2-5.3l-22.8 19.5 10.4 12.1L260 194.5z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fast',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256v4.3l3.6 2.4 96 64 6.7 4.4 8.9-13.3-6.7-4.4L264 251.7V104 96H248v8z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fast',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 248H8 504h8v16h-8H8 0V248z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fast',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      'M160 63.1L119.2 131c-4.7 7.9-7.2 16.9-7.2 26.1V160c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.8c0-9.2-2.5-18.2-7.2-26.1L160 63.1zm-9.3-15.5L160 32l9.3 15.5 45.1 75.2c6.2 10.4 9.5 22.3 9.5 34.4V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4l45.1-75.2zM64 255.1L23.2 323C18.5 330.9 16 340 16 349.2V352c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.8c0-9.2-2.5-18.2-7.2-26.1L64 255.1zm-9.3-15.5L64 224l9.3 15.5 45.1 75.2c6.2 10.4 9.5 22.3 9.5 34.4V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4l45.1-75.2zm172.4 53c-12.4 18.2-19.1 39.8-19.1 61.8C208 414.9 257.1 464 317.7 464h4.7C382.9 464 432 414.9 432 354.3c0-22.1-6.6-43.6-19.1-61.8L320 156.4 227.1 292.5zm-13.2-9l96.4-141.3L320 128l9.7 14.2 96.4 141.3c14.2 20.9 21.9 45.6 21.9 70.8C448 423.7 391.7 480 322.3 480h-4.7C248.3 480 192 423.7 192 354.3c0-25.3 7.6-50 21.9-70.8z'
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fast',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M421.7 42.3L416 36.7l-5.7 5.7-112 112-5.7 5.7L304 171.3l5.7-5.7L408 67.3V472v8h16v-8V67.3l98.3 98.3 5.7 5.7L539.3 160l-5.7-5.7-112-112zm-256 427.3l112-112 5.7-5.7L272 340.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L53.7 346.3 48 340.7 36.7 352l5.7 5.7 112 112 5.7 5.7 5.7-5.7z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fast',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM272 264H112V400H272V264zM112 248H272V112H112V248zM96 96h16H272h16v16V400v16H272 112 96V400 112 96zm96-56a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM152 160v48h80V160H152zm-16-16h16 80 16v16 48 16H232 152 136V208 160 144z'
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fast',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      'M346.2 32H352 568h8V48h-8H357.8L215.6 474.5l-1.8 5.5H203.1l-2.2-4.4L83.1 240H8 0V224H8 88h4.9l2.2 4.4L206.5 451.1 344.4 37.5l1.8-5.5zM400 228.7l5.7 5.7L480 308.7l74.3-74.3 5.7-5.7L571.3 240l-5.7 5.7L491.3 320l74.3 74.3 5.7 5.7L560 411.3l-5.7-5.7L480 331.3l-74.3 74.3-5.7 5.7L388.7 400l5.7-5.7L468.7 320l-74.3-74.3-5.7-5.7L400 228.7z'
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fast',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      'M229.7 42.3L224 36.7l-5.7 5.7-136 136L76.7 184 88 195.3l5.7-5.7L216 67.3V344v8h16v-8V67.3L354.3 189.7l5.7 5.7L371.3 184l-5.7-5.7-136-136zM16 432v32H48V432H16zm128 0H112v32h32V432zm96 32V432H208v32h32zm96-32H304v32h32V432zm64 0v32h32V432H400z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fast',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M16 32v8V288c0 97.2 78.8 176 176 176s176-78.8 176-176V40 32h16v8V288c0 106-86 192-192 192S0 394 0 288V40 32H16z'
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fast',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      'M8 496l-8 0 0 16 8 0 184 0 8 0 0-8 0-476.7L330.3 157.7l5.7 5.7L347.3 152l-5.7-5.7-144-144L192-3.3l-5.7 5.7-144 144L36.7 152 48 163.3l5.7-5.7L184 27.3 184 496 8 496z'
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faMobileSignalOut = {
    prefix: 'fast',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      'M48 16H224V0H48 32V16 496v16H48 336h16V496 288H336V496H48V16zm96 416h-8v16h8 96 8V432h-8H144zM256 16c132.5 0 240 107.5 240 240h16C512 114.6 397.4 0 256 0V16zm16 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32h16c0-88.4-71.6-160-160-160v16c79.5 0 144 64.5 144 144z'
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fast',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      'M16 464l0-96 96 0 0 96-96 0zM0 480l16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0L0 352l0 16 0 96 0 16zm208-16l0-96 96 0 0 96-96 0zm-16 16l16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0-16 0 0 16 0 96 0 16zM16 208l96 0 0 96-96 0 0-96zM0 304l0 16 16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0L0 192l0 16 0 96zm208 0l0-96 96 0 0 96-96 0zm-16 16l16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0-16 0 0 16 0 96 0 16zM16 48l96 0 0 96-96 0 0-96zM0 144l0 16 16 0 96 0 16 0 0-16 0-96 0-16-16 0L16 32 0 32 0 48l0 96zm208 0l0-96 96 0 0 96-96 0zm-16 16l16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0-16 0 0 16 0 96 0 16z'
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fast',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm136 96h88c70.7 0 128 57.3 128 128s-57.3 128-128 128H136h-8v-8V136v-8h8zm8 240h80c61.9 0 112-50.1 112-112s-50.1-112-112-112H144V368z'
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fast',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      'M75.3 500.7L313.4 262.6l-11.3-11.3L64 489.4 22.6 448 260.7 209.9l-11.3-11.3L11.3 436.7 0 448l11.3 11.3 41.4 41.4L64 512l11.3-11.3zM464 112l36.7-36.7L512 64 500.7 52.7 459.3 11.3 448 0 436.7 11.3 400 48 363.3 11.3 352 0 340.7 11.3 235.3 116.7 224 128l11.3 11.3L384 288V400v16h16 16c123.7 0 224-100.3 224-224V176 160H624 512l-48-48zM448 22.6L489.4 64l-36.7 36.7L411.3 59.3 448 22.6zM624 176v16c0 114.9-93.1 208-208 208H400V288v-6.6l-4.7-4.7L246.6 128 352 22.6 500.7 171.3l4.7 4.7H512 624zM448.5 360c72.7-4.8 130.6-62.7 135.4-135.4l-16-1.1c-4.3 64.7-55.8 116.2-120.6 120.6l1.1 16z'
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fast',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      'M248 32h8V48h-8H184v80H624h16v16V464v16H624 16 0V464 144 128H16 168V48H104 96V32h8 72 72zM184 144H168 16V464H624V144H184zM544 80V96h-8H392h-8V80h8H536h8zM176 400a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM531.9 371.9A96 96 0 1 0 396.1 236.1 96 96 0 1 0 531.9 371.9zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM168 240h16v8 56 8H168v-8V248v-8zm341.3 30.1l-39.6 39.6-5.7 5.7L452.7 304l5.7-5.7 39.6-39.6 5.7-5.7 11.3 11.3-5.7 5.7z'
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fast',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      'M416 16C195.1 16 16 195.1 16 416v80H96c220.9 0 400-179.1 400-400V16H416zm0-16h80 16V16 96c0 229.8-186.2 416-416 416H16 0V496 416C0 186.2 186.2 0 416 0zM304 144a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-112 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm48 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm48 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fast',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      'M128 480s-13.1-4.9-30.8-15.7C59.3 441.2 0 391.1 0 304c0-97.2 78.8-176 176-176h64 16V112 48 32h16 16L468.2 197.1 480 208l-11.8 10.9L288 384H272 256V368 304 288H240 208c-61.9 0-112 50.1-112 112c0 21.2 6.2 39.2 13.2 52.8C118 470 128 480 128 480zM74.5 428c3.7 3.2 7.4 6.2 11 9c-3.3-11-5.6-23.4-5.6-37c0-70.7 57.3-128 128-128h48 16v16 80h9.8L456.3 208 281.8 48H272v80 16H256 176C87.6 144 16 215.6 16 304c0 58 28.8 97.9 58.5 124zM378.6 59.9l-5.9-5.4 10.8-11.8 5.9 5.4 168 154 6.4 5.9-6.4 5.9-168 154-5.9 5.4-10.8-11.8 5.9-5.4L540.2 208 378.6 59.9z'
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fast',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      'M16 16V400H231.8h.3H343.9h.3H560V16H16zM222.6 416H16 0V400 16 0H16 560h16V16 400v16H560 353.4l13.3 80H440h8v16h-8H360 216 136h-8V496h8 73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80V336H496V80zM80 64H496h16V80 336v16H496 80 64V336 80 64H80zm181.3 49.3h53.3 8v8 52h52 8v8 53.3 8h-8-52v52 8h-8H261.3h-8v-8-52h-52-8v-8V181.3v-8h8 52v-52-8h8zm8 68v8h-8-52v37.3h52 8v8 52h37.3v-52-8h8 52V189.3l-52 0h-8v-8-52H269.3v52z'
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fast',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm80 68.5V192 344c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V203.5l-112 42V376c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V240v-5.5l5.2-1.9 128-48 10.8-4.1zM304 320c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM176 352c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fast',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      'M224 493.6L432 374.7V137.3L224 18.4 16 137.3V374.7L224 493.6zM0 128L224 0 448 128V384L224 512 0 384V128zM200 87.4l22.8-13L272 102.6V121L216 89V248h40 8v16h-8H216V432v1.7l-16-9.1V256 87.4zM336 374.3V157.6l-40-22.9V116.3L348 146l36 20.6V185l-32-18.3V365.1l-16 9.1zm-176 19v8.4l-16.8-9.6L80 202.6V356l-16-9.1V165.1l17.1-9.8L144 344V119.4l16-9.1V112 392v1.3z'
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fast',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      'M432 16V384H16V16H432zm0 384v96H16V400H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM168 440v16h8 96 8V440h-8H176h-8z'
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fast',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      'M26.4 467.8L14.7 496 8 512H25.3h324l8.2-19.7C395.6 400.3 400 289.5 400 192c0-87.3 34.7-159.7 80.1-173.6c5.2-1.6 10.5-2.4 15.9-2.4c53 0 96 78.8 96 176s-43 176-96 176c-26.6 0-50.7-19.9-68.1-51.9c-.7 8.7-1.5 17.4-2.4 26.1c18 24.7 42 41.8 70.5 41.8c35.1 0 63.4-25.9 81.9-59.9C596.8 289.5 608 242.8 608 192s-11.2-97.5-30.1-132.1C559.4 25.9 531.1 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8zM450.4 16c-14.4 10.8-26.7 26.2-36.3 43.9C395.2 94.5 384 141.2 384 192l0 .5c0 97.5-4.6 205.1-41.2 293.6l0 0-4.1 9.9H32l9.2-22.1 0 0 .1-.3C76.2 385.4 80 281.8 80 192c0-51.1 10.4-96.5 26.4-128.6C123 30.3 142.8 16 160 16H450.4zM496 264c8.7 0 15.7-4.2 20.6-9c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9zm24-72c0 30.9-10.7 56-24 56s-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56z'
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fast',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-86.2 94.5l5.7 5.7L256 276.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L267.3 288l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L256 299.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L244.7 288l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fast',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      'M96 0H88V8 48H40 8 0V64H8 32V496H8 0v16H8 40 312h32 8V496h-8H320V64h24 8V48h-8H312 264V8 0h-8H96zM248 48H104V16H248V48zM88 64h16H248h16 40V496H48V64H88zM384 176H368v16 32 16h16 32 16V224 192 176H416 384zm0 16h16 16v16 16H400 384V208 192zM368 336v16 32 16h16 32 16V384 352 336H416 384 368zm32 16h16v16 16H400 384V368 352h16zm80-176H464v16 32 16h16 32 16V224 192 176H512 480zm0 16h16 16v16 16H496 480V208 192zm80-48V328H504h-8v8 96H352v16H504h8v-8V344h56 8v-8V136v-8h-8H352v16H560z'
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fast',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      'M410.3 53.7L404.7 48 416 36.7l5.7 5.7 80 80 5.7 5.7-5.7 5.7-80 80-5.7 5.7L404.7 208l5.7-5.7L476.7 136H323.3l-120 120 120 120H476.7l-66.3-66.3-5.7-5.7L416 292.7l5.7 5.7 80 80 5.7 5.7-5.7 5.7-80 80-5.7 5.7L404.7 464l5.7-5.7L476.7 392H320h-3.3l-2.3-2.3L188.7 264H8 0V248H8 188.7L314.3 122.3l2.3-2.3H320 476.7L410.3 53.7z'
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fast',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      'M328 0V8 504v8H312v-8V8 0h16zM520 64v8V440v8H504v-8V72 64h16zM232 96v8V408v8H216v-8V104 96h16zm192 32v8V376v8H408v-8V136v-8h16zM136 192v8V312v8H120v-8V200v-8h16zM40 224v8 48 8H24v-8V232v-8H40zm576 0v8 48 8H600v-8V232v-8h16z'
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fast',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      'M296 256v-8V35.3l74.3 74.3 5.7 5.7L387.3 104l-5.7-5.7-88-88L288 4.7l-5.7 5.7-88 88-5.7 5.7L200 115.3l5.7-5.7L280 35.3V248v8h16zM96 298l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 353.8 22.5 368 0 368v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V368c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l0 0-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 353.8 406.5 368 384 368s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9 0 0c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 353.8 214.5 368 192 368s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9L96 298zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fast',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      'M224 192l-64 48V496H16V361.1l112-67.2V275.2L0 352V496v16H16 160v0h16 80 16 96 16 80 16v0H624h16V496 352L512 275.2v18.7l112 67.2V496H480V240l-64-48V96L331.3 11.3 320 0 308.7 11.3 224 96v96zM464 496H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H176V248l57.6-43.2L240 200v-8V102.6l80-80 80 80V192v8l6.4 4.8L464 248V496zm-96 0H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48V496z'
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fast',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      'M174.4 227.4l44-51.4 13.7-16H211.1 160 144 128V144 112 96h16 16H320h13.3l9.4 9.4 13.8 13.8L371 133.7l11.4 11.4-12.9 9.8-16.4 12.4L230.1 260.8 223 269l-12.1-10.4 7.1-8.3L219 249l1.4-1 123.1-93.5 14.6-11.1-13-13-13.8-13.8-4.7-4.7H320 160 144v32h16 72.1 34.8l-22.6 26.4-57.7 67.4c-5.5 6.5-10 13.8-13.3 21.7L116.1 398.6l29.6 12.2 57.2-139.2c1.9-4.7 4.6-9.1 8-13L223 269c-2.2 2.6-4 5.5-5.3 8.7L160.5 416.9l-1 2.4L496 251.1V184v-8h16v8 72 4.9l-4.4 2.2-496 248L4.4 496.8l139.2-69.6-4-1.6L110 413.4l-14.8-6.1 6.1-14.8 57.2-139.2c3.9-9.5 9.3-18.2 15.9-26zM432 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fast',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 296v-8H424v8 64H360h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H440V296z'
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fast',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-374V128h-8H168h-8v16h8H330.5L199.3 384h18.2L351 139.8l1-1.8z'
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fast',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      'M144 0H128V64h16V0zM272 0H256V64h16V0zM384 0V288h16V0H384zm64 0V288h16V0H448zM320 0V64h16V0H320zM192 0V64h16V0H192zM512 0H496V288h16V0zM336 112V496H16V112H336zM16 96H0v16V496v16H16 336h16V496 112 96H336 16zm64 80H272V432H80V176zM64 160v16V432v16H80 272h16V432 176 160H272 80 64z'
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fast',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      'M296 0V8 228.7l74.3-74.3 5.7-5.7L387.3 160l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L200 148.7l5.7 5.7L280 228.7V8 0h16zM96 298l.6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 353.8 169.5 368 192 368s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 353.8 361.5 368 384 368s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 353.8 553.5 368 576 368v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 366.2 28.7 384 0 384V368c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9zM96.6 427c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 481.8 553.5 496 576 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 494.2 28.7 512 0 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9z'
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fast',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      'M557.9 224H574C558.3 97.7 450.5 0 320 0S81.7 97.7 66 224H82.1C97.8 106.6 198.3 16 320 16s222.2 90.6 237.9 208zM256.4 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM186.9 101.9l-5.1 15.2 7.6 2.5 96 32 7.6 2.5 5.1-15.2-7.6-2.5-96-32-7.6-2.5zm271.2 15.2l-5.1-15.2-7.6 2.5-96 32-7.6 2.5 5.1 15.2 7.6-2.5 96-32 7.6-2.5zM624 272V496H16V272H624zM16 256H0v16V496v16H16 624h16V496 272 256H624 16zm272 96v64H264v16h24v24h16V432h64v24h16V432h24V416H384V352h24V336H384V312H368v24H304V312H288v24H264v16h24zm16 0h64v64H304V352zM470.7 460.4l96-144-13.3-8.9-96 144 13.3 8.9zM472 336a8 8 0 1 1 0-16 8 8 0 1 1 0 16zm0 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 88a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm16 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-368-8a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm8-152v-8H200v8 80 8h16v-8V312zM87 341c3.6-2.4 8.7-3.9 15-4.6c12.6-1.3 27.7 1.1 38.1 3.8l7.8 1.9 3.9-15.5-7.8-1.9c-6.5-1.6-15-3.3-23.9-4.1V312v-8H104v8 8.2c-1.3 .1-2.5 .2-3.7 .3c-7.7 .8-15.6 2.8-22.2 7.2c-6.8 4.5-11.7 11.3-13.5 20.6c-1.2 6.8-.5 12.9 2.2 18.3c2.7 5.3 6.9 9.2 11.6 12.1c8.5 5.4 20 8.6 30.1 11.5l1.5 .4c11.2 3.2 20.7 6 27 10.3c3 2 4.8 4.1 5.9 6.3c1 2.1 1.5 5 .7 9.3c-1.2 6.4-4.1 9.8-7.9 12c-4.2 2.4-10.2 3.5-17.6 3.4c-14.9-.2-32.1-5.3-43.7-8.9l-7.6-2.4L62 436l7.6 2.4c8.3 2.6 20.6 6.3 33.5 8.3V456v8h16v-8-8c8.4 0 17.1-1.3 24.5-5.5c8.1-4.6 13.8-12.2 15.8-23c1.3-7 .7-13.3-1.9-18.9c-2.6-5.5-6.7-9.7-11.4-12.8c-8.9-6.1-21.1-9.5-31.7-12.5l0 0 0 0 0 0c-11.3-3.2-20.8-5.9-27.3-10c-3.1-1.9-4.9-3.9-5.9-5.8c-.9-1.8-1.5-4.4-.8-8.2c.9-4.9 3.2-8 6.6-10.2z'
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fast',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      'M501 19l7.8-1.9L505.1 1.6l-7.8 1.9L6.1 120.2 0 121.7V128v16 96 8V496v16H16 496h16V496 144 128H496 42.6L501 19zM16 144H496v96H16V144zM496 256V496H16V256H496zM424 376a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm-128 0a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM64 336v16h8H216h8V336h-8H72 64zm16 64v16h8H200h8V400h-8H88 80z'
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fast',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      'M552 8V88h80 8v16h-8H552v80 8H536v-8V104H456c-4.4 0-8-3.6-8-8s3.6-8 8-8h80V8 0h16V8zM432 288A208 208 0 1 0 16 288a208 208 0 1 0 416 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM104.6 347l14.9-5.9c4.9 12.3 16.2 31.2 33.9 47c17.6 15.7 41.1 28 70.7 28s53.1-12.3 70.7-28c17.7-15.8 29-34.7 33.9-47l14.9 5.9c-5.8 14.4-18.4 35.4-38.1 53c-19.8 17.7-46.9 32-81.3 32s-61.6-14.4-81.3-32c-19.7-17.6-32.3-38.6-38.1-53z'
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fast',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      'M328 32h-8V48h8 74l59.6 201.1c-34.3 12.8-62.5 38.4-78.6 70.9H272 256V304 208 192H240 128C57.3 192 0 249.3 0 320v48 16H16 64c0 53 43 96 96 96s96-43 96-96H368h4 12c0-70.7 57.3-128 128-128c35.4 0 67.5 14.4 90.7 37.6L614 282.4C587.9 256.2 551.9 240 512 240c-12.1 0-23.9 1.5-35.1 4.3L445.9 139.9l54.5 27.2 1.7 .8H504h16 8v-8V64 56h-8H504h-1.9l-1.7 .8-64 32-4.9 2.4L415.7 37.7 414 32h-6H328zm40.9 336H16V320c0-61.9 50.1-112 112-112H240V320v16h16H376.2c-3.6 10.2-6.1 20.9-7.3 32zm74.7-247.2l-3.8-1.9-4.1-13.7 .8 1.5 7.2-3.6L505.9 72H512v80h-6.1l-62.3-31.2zM240 128v32H112V128H240zM112 112H96v16 32 16h16H240h16V160 128 112H240 112zM80 384H240c0 44.2-35.8 80-80 80s-80-35.8-80-80zm432-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fast',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      'M360.9 261.6l7.1-4.8v-8.5V16H496V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM512 0H496 368 352V16 248.3c-38.6 25.8-64 69.8-64 119.8c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM384 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264v-8H424v8 40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zM271.9 159.4l15.5-57.8 2.1-7.7L274 89.7l-2.1 7.7-19.6 73.3L184 210.1V131.3l53.7-53.7 5.7-5.7L232 60.7l-5.7 5.7L184 108.7V40 32H168v8 68.7L125.7 66.3 120 60.7 108.7 72l5.7 5.7L168 131.3v78.8L99.7 170.7 80.1 97.4 78 89.7 62.6 93.8l2.1 7.7 15.5 57.8L20.7 125.1l-6.9-4-8 13.9 6.9 4 59.5 34.3L14.3 188.8l-7.7 2.1 4.1 15.5 7.7-2.1 73.3-19.6L160 224 91.7 263.4 18.4 243.8l-7.7-2.1L6.6 257.2l7.7 2.1 57.8 15.5L12.7 309.1l-6.9 4 8 13.9 6.9-4 59.5-34.3L64.6 346.4l-2.1 7.7L78 358.3l2.1-7.7 19.6-73.3L168 237.9v78.8l-53.7 53.7-5.7 5.7L120 387.3l5.7-5.7L168 339.3V408v8h16v-8V339.3l42.3 42.3 5.7 5.7L243.3 376l-5.7-5.7L184 316.7V237.9l68.3 39.4 10.9 40.8c2.6-8.8 5.9-17.3 9.7-25.5l-1.1-4 2.4 1.4c2.4-4.8 5-9.5 7.8-14l-2.1-1.2 3.5-.9c4.6-7.3 9.8-14.2 15.4-20.7l-38.4 10.3L192 224l68.3-39.4 59.7 16V184l-40.1-10.8L320 150.1V131.6l-48.1 27.8z'
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fast',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      'M40 0H32V8 43.1L4.4 56.8 0 59.1V64v96 4.9l4.4 2.2L32 180.9v6.1L4.4 200.8 0 203.1V208v96 4.9l4.4 2.2L32 324.9v6.1L4.4 344.8 0 347.1V352v96 4.9l4.4 2.2L32 468.9V504v8h8H408h8v-8V468.9l27.6-13.8 4.4-2.2V448 352v-4.9l-4.4-2.2L416 331.1v-6.1l27.6-13.8 4.4-2.2V304 208v-4.9l-4.4-2.2L416 187.1v-6.1l27.6-13.8 4.4-2.2V160 64 59.1l-4.4-2.2L416 43.1V8 0h-8H40zm8 48V16H400V48v4.9l4.4 2.2L432 68.9v86.1l-27.6 13.8-4.4 2.2V176v16 4.9l4.4 2.2L432 212.9v86.1l-27.6 13.8-4.4 2.2V320v16 4.9l4.4 2.2L432 356.9v86.1l-27.6 13.8-4.4 2.2V464v32H48V464v-4.9l-4.4-2.2L16 443.1V356.9l27.6-13.8 4.4-2.2V336 320v-4.9l-4.4-2.2L16 299.1V212.9l27.6-13.8 4.4-2.2V192 176v-4.9l-4.4-2.2L16 155.1V68.9L43.6 55.2 48 52.9V48zm64 32H336V432H112V80zM96 64V80 432v16h16H336h16V432 80 64H336 112 96z'
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fast',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      'M32 512l16 0L48 0 32 0l0 512zM144 112l224 0 0 288-224 0 0-288zM128 400l0 16 16 0 224 0 16 0 0-16 0-288 0-16-16 0L144 96l-16 0 0 16 0 288zM464 0l0 512 16 0L480 0 464 0z'
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fast',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      'M211.8 159.1l11.3 11.3L341.6 288.9l11.3 11.3L372.7 320l5.7 5.7 5.7 5.7L395.3 320l-5.7-5.7-5.7-5.7-8.5-8.5-11.3-11.3 11.3-11.3L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0L234.4 136.5l-11.3 11.3-11.3-11.3-8.5-8.5-5.7-5.7-5.7-5.7L180.7 128l5.7 5.7 5.7 5.7 19.8 19.8zm259.7 0L352.9 277.6 234.4 159.1 352.9 40.5c32.7-32.7 85.8-32.7 118.5 0s32.7 85.8 0 118.5zM45.3 440.9l2.7-4V432 350.6L191.7 206.9 305.1 320.3 161.4 464H80 75.2l-4 2.7L34 491.4 20.6 478l24.7-37.1zM180.4 195.6L32 344v88L0 480l32 32 48-32h88L316.4 331.6l11.3-11.3L316.4 309 203 195.6l-11.3-11.3-11.3 11.3z'
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fast',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      'M16 32H8V48h8H32V264 400c0 44.2 35.8 80 80 80s80-35.8 80-80V264 48h16 8V32h-8H184 40 16zM48 256V48H176V256H48zm0 16H176V400c0 35.3-28.7 64-64 64s-64-28.7-64-64V272zM304 32h-8V48h8 16V264 400c0 44.2 35.8 80 80 80s80-35.8 80-80V264 48h16 8V32h-8H472 328 304zm32 224V48H464V256H336zm0 16H464V400c0 35.3-28.7 64-64 64s-64-28.7-64-64V272z'
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fast',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM264 160H248v8 80H168h-8v16h8 80v80 8h16v-8V264h80 8V248h-8H264V168v-8z'
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fast',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM244.9 96l2.2 4.4L356.9 320H339.1l-32-64H172.9l-32 64H123.1L232.8 100.4l2.2-4.4h9.9zm-64 144H299.1L240 121.9 180.9 240z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fast',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 496h8V368h-8H166.2l-20.9-80H496L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM82.7 48H554.2l-70 224H141.1L82.7 48zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fast',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      'M323.7 8.9l304 160 7.1 3.7-7.5 14.2-7.1-3.7L320 25 19.7 183.1l-7.1 3.7L5.2 172.6l7.1-3.7 304-160L320 7l3.7 2zM210 176h6H424h6l1.7 5.8L462 288h34 16v16V432v16 48 16H496 448 432V496 448H208v48 16H192 144 128V496 448 432 304 288h16 34l30.3-106.2L210 176zM144 304V432h48 16H432h16 48V304H144zM448 496h48V448H448v48zM192 448H144v48h48V448zM418 192H222l-27.4 96H445.4L418 192zM192 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fast',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      'M176 38.1l160-20V64H176V38.1zM336 2L160 24V64 80h16H336h16V64 16.1 0L336 2zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H318c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16H177.6c-1 5.2-1.6 10.5-1.6 16zM368 396.8l29.4 49.8 8.1 13.8 13.8-8.1 41.3-24.4 13.8-8.1-8.1-13.8-84-142.1 38.7-67.1 8-13.9-13.9-8 8-13.9 48-83.1 8-13.9-13.9-8-13.9-8-13.9-8-13.9-8-8 13.9 13.9 8-8 13.9-40 69.3-8 13.9-13.9-8-8 13.9L313 224H176 153.2l-11.6 19.7L45.7 405.9l-8.1 13.8 13.8 8.1 41.3 24.4 13.8 8.1 8.1-13.8L144 396.8l16-27.1v31.5V496v16h16H336h16V496 401.2 369.7l16 27.1zM331.4 224l34.2-59.3 13.9 8 8-13.9 56-97 13.9 8-56 97-8 13.9 13.9 8L373 248l-2.6-4.3L358.8 224H336h-4.6zM336 481.3L180.4 240H336h13.7l7 11.8L452.5 414l-41.3 24.4-45.4-76.9L355.4 344H336v25.7V481.3zM326.5 496H176V369.7 344H156.6l-10.4 17.6-45.4 76.9L59.5 414l95.9-162.2 6.5-11L326.5 496zM304 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fast',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      'M16 8V0H0V8 32 48 336v16V504v8H16v-8V352H428.5 448l-11.2-16L336 192 436.8 48 448 32H428.5 16V8zm0 40H417.3L322.9 182.8l-6.4 9.2 6.4 9.2L417.3 336H16V48z'
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fast',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      'M486 368l10 16H477.1 336L265.4 496.9 256 512l-9.4-15.1L176 384H34.9 16l10-16L96 256 26 144 16 128H34.9 176L246.6 15.1 256 0l9.4 15.1L336 128H477.1 496l-10 16L416 256l70 112zM406.6 240.9L467.1 144H346l60.6 96.9zM327.1 144H184.9l-70 112 70 112H327.1l70-112-70-112zm-10-16L256 30.2 194.9 128H317.1zM166 144H44.9l60.6 96.9L166 144zM105.4 271.1L44.9 368H166l-60.6-96.9zM346 368H467.1l-60.6-96.9L346 368zM194.9 384L256 481.8 317.1 384H194.9z'
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fast',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      'M459.1 14.7l-4.8 6.4L409.3 81 439 140.4l3.4 6.9-6.5 3.9-73.7 44.2 198.4 31.1c45.3 5.9 79.4 46.4 79.4 94.3c0 84.7-97.6 127.1-154.6 67.2L352 266.1V298l54 64.8 1.9 2.3v3l0 53.5 46.6 69.9 4.5 6.7-13 9.2-4.5-6.7-48-72-1.4-2.1V424 371L352 322.9l0 77.1v32H288V400l0-77.1L247.9 371v53 2.5l-1.4 2.1-48 72-4.5 6.7-13-9.2 4.5-6.7 46.6-69.9V368v-3l1.9-2.3L288 298V266.1L154.6 388C97.6 447.9 0 405.5 0 320.8c0-47.9 34-88.4 79.3-94.3l198.4-31.1L204 151.1l-6.5-3.9 3.4-6.9L230.7 81 185.8 21.1l-4.8-6.4 12.5-9.9 4.8 6.4 48 64 3.1 4.1L247 83.8 218.4 141 288 182.7v-6.6l0-32 23.8 0V63.8 55.6h16.3l0 8.2v80.3l23.8 0 0 32v6.6L421.6 141 393 83.8l-2.3-4.6 3.1-4.1 48-64 4.8-6.4 12.5 9.9zm37.1 361.5c.3 .2 .5 .5 .8 .8C542.9 425.2 624 392.7 624 320.8c0-40.5-28.6-73.6-65.4-78.5l-.4-.1 0 0L352 209.9l0 34.5L496.2 376.2zM81.8 242.3l-.4 .1 0 0c-36.8 4.8-65.4 38-65.4 78.5c0 71.9 81.1 104.4 127.1 56.2c.3-.3 .5-.5 .8-.8L288 244.4l0-34.5L81.8 242.3zM304 400v16h32V400l0-223.9 0-16-32 0 0 16L304 400z'
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fast',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      'M384 259V224.7c0-13.4 5.7-25 12.7-33.7c12.1-15.1 19.3-34.2 19.3-55c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 25.8 11.1 49.1 28.9 65.2c6.4 5.8 12.2 13.3 15.6 22.1l6.6 16.5L274 244.5 92.3 295.4l-5.4 1.5-5.2-2.2L28.7 272H16v16c0 97.2 78.8 176 176 176H312c61.9 0 112-50.1 112-112c0-32-13.4-60.9-35-81.3l-5-4.7V259zM88 280l166.1-46.5 15.6-4.4c-2.1-5.2-5.3-9.9-9.3-14c-.7-.7-1.4-1.4-2.2-2.1c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104c54.5 0 99.3 42 103.6 95.4c13 2.7 26.4 3.3 39.7 1.7l31.7-4 9-1.1V133v11c0 48.6-39.4 88-88 88H400v27c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128H192C86 480 0 394 0 288V272 256H16 32l56 24zm313.2-64H424c39.8 0 72-32.2 72-72v-1.9l-22.7 2.8c-13.9 1.7-27.9 1.3-41.6-1.2c-1.6 21.6-9.8 41.4-22.5 57.3c-3.6 4.5-6.4 9.6-8 15zM320 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-2.7 166.7c-5.8 43.4-38.5 81.1-84.7 92.6c-37.8 9.4-75.9-.9-102.5-24.5l-6-5.3 10.6-12 6 5.3c22.6 20.1 55.3 29 88 20.9c39.9-10 67.8-42.4 72.7-79.2l1.1-7.9 15.9 2.1-1.1 7.9z'
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fast',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      'M400 2.7l6.4 8.5c19.4 25.8 44.3 46.4 72.9 65.9c18 12.3 37.1 23.8 57.1 35.9l0 0c12 7.3 24.3 14.7 37 22.6c27.2 17.1 42.6 47.3 42.6 79c0 14.8-3.3 28.9-9.2 41.4H588.7c7.2-12.1 11.3-26.3 11.3-41.4c0-26.6-12.9-51.5-35.1-65.4c-12.1-7.6-24.2-14.9-36.1-22.1c-20.3-12.3-40.1-24.3-58.5-36.7C443.9 72.4 419.8 52.9 400 28.9c-19.8 24-43.9 43.4-70.3 61.4c-18.3 12.4-38.1 24.4-58.5 36.7l0 0c-11.9 7.2-24 14.5-36.1 22.1c-22.2 13.9-35.1 38.8-35.1 65.4c0 15.1 4.1 29.3 11.3 41.4H193.2c-5.9-12.6-9.2-26.6-9.2-41.4c0-31.7 15.4-61.9 42.6-79c12.6-7.9 24.9-15.4 37-22.6l0 0 0 0c20-12.1 39.1-23.6 57.1-35.9c28.6-19.4 53.5-40.1 72.9-65.9L400 2.7zM84.6 9.4L105 23.6c34.4 23.9 55 63.2 55 105.1V248v8H144v-8V160H16v16V496H120h8v16h-8H8 0v-8V176 128.8C0 86.8 20.5 47.6 55 23.6L75.4 9.4 80 6.3l4.6 3.2zM144 128.8c0-36.7-18-71.1-48.1-92L80 25.7l-15.9 11C34 57.7 16 92.1 16 128.8V144H144V128.8zM640 288v8V504v8h-8H576 560 528 512 464 448 352 336 288 272 240 224 168h-8v-8V296v-8h8H632h8zM448 416c0-15.1-7.1-29.3-19.2-38.4L400 356l-28.8 21.6C359.1 386.7 352 400.9 352 416v80h96V416zm64 80V400 384h16 32 16v16 96h48V304H176V496h48V400 384h16 32 16v16 96h48V416c0-20.1 9.5-39.1 25.6-51.2L400 336l38.4 28.8C454.5 376.9 464 395.9 464 416v80h48zm16 0h32V400H528v96zm-256 0V400H240v96h32z'
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fast',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM232.3 129.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L240 304.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm-3.4 18.9l-7.7-7.4c-8.5-8.2-19.8-12.7-31.6-12.7h-2.4c-23.9 0-43.2 19.3-43.2 43.2c0 11.7 4.8 23 13.2 31.1L240 281.9l82.8-79.6c8.5-8.1 13.2-19.4 13.2-31.1c0-23.9-19.3-43.2-43.2-43.2h-2.4c-11.8 0-23.1 4.6-31.6 12.7l-7.7 7.4L240 158.8l-11.1-10.7z'
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fast',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      'M443.6 445.3C411.8 476.7 368.2 496 320 496c-97.2 0-176-78.8-176-176c0-22.5 10.5-52.9 28.2-87.4l.6-1.1L160 221.4c-19.1 36.4-32 71.1-32 98.6c0 106 86 192 192 192c53.3 0 101.5-21.7 136.2-56.7l-12.6-10zM309.4 12.1c-14.4 16.7-41.6 49.1-70.6 88l12.6 9.9c18.8-25.1 36.8-47.6 51-64.7c6.9-8.3 12.9-15.4 17.7-21c4.8 5.6 10.8 12.6 17.7 21c17.8 21.5 41.6 51.3 65.3 84.3c23.8 33 47.3 69 64.8 103c13.3 25.9 22.5 49.5 26.3 69.1l17.8 14.1C507.7 223.9 370.3 58.2 330.6 12.1C323.9 4.4 320 0 320 0s-3.9 4.4-10.6 12.1zM320 408c-48.6 0-88-39.4-88-88H216c0 57.4 46.6 104 104 104V408zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fast',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M188.9 93.2l7.7-3.2 1.8-8.2L212.9 16h86.2l14.4 65.8 1.8 8.2 7.7 3.2c14.5 6 28.1 13.9 40.3 23.3l6.6 5.1 8-2.5 64.3-20.5 43.1 74.7-49.8 45.4-6.2 5.6 1.1 8.3c1 7.6 1.5 15.4 1.5 23.3s-.5 15.7-1.5 23.3l-1.1 8.3 6.2 5.6 49.8 45.4-43.1 74.7L378 392.9l-8-2.5-6.6 5.1c-12.3 9.5-25.8 17.3-40.3 23.3l-7.7 3.2-1.8 8.2L299.1 496H212.9l-14.4-65.8-1.8-8.2-7.7-3.2c-14.5-6-28.1-13.9-40.3-23.3l-6.6-5.1-8 2.5L69.7 413.3 26.6 338.7l49.9-45.4 6.2-5.6-1.1-8.3c-1-7.6-1.5-15.4-1.5-23.3s.5-15.7 1.5-23.3l1.1-8.3-6.2-5.6L26.6 173.3 69.7 98.7 134 119.1l8 2.5 6.6-5.1c12.3-9.5 25.8-17.3 40.3-23.3zM312 0H200L182.8 78.4c-15.8 6.5-30.6 15.1-44 25.4L62.3 79.5l-56 97 59.4 54.1C64.6 238.9 64 247.4 64 256s.6 17.1 1.7 25.4L6.3 335.5l56 97 76.5-24.4c13.4 10.3 28.2 18.9 44 25.4L200 512H312l17.2-78.4c15.8-6.5 30.6-15.1 44-25.4l76.5 24.4 56-97-59.4-54.1c1.1-8.3 1.7-16.8 1.7-25.4s-.6-17.1-1.7-25.4l59.4-54.1-56-97-76.5 24.4C359.8 93.6 345 85 329.2 78.4L312 0zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fast',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      'M432 16V400H337.8 319.5 128.5 110.2 16V16H432zM16 416h85.3L56.9 496 48 512H66.3 381.7 400l-8.9-16-44.4-80H432h16V400 16 0H432 16 0V16 400v16H16zm59.2 80l44.4-80H328.4l44.4 80H75.2zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM112 208a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fast',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      'M279 30.4L212.2 112H113.1c7.8-54.3 54.4-96 110.9-96c20 0 38.7 5.2 55 14.4zm13.4 8.9c18.4 14.2 32.2 33.9 39 56.7H284L265.8 71.8l26.6-32.5zm-70.2 85.8l33.2-40.6 18.2 24.3L276 112h4 54.9c.7 5.2 1.1 10.6 1.1 16v8 8c0 61.9-50.1 112-112 112s-112-50.1-112-112v-8-8l104 0h3.8l2.4-2.9zM224 0C153.3 0 96 57.3 96 128v8 8 36L35.2 225.6 32 228v4 32 8h8 80 8V256h-8H48V236l57.6-43.2c19.2 46.5 65 79.2 118.4 79.2s99.2-32.7 118.4-79.2L400 236v20H328h-8v16h8 80 8v-8V232v-4l-3.2-2.4L352 180V144v-8-8C352 57.3 294.7 0 224 0zM21.7 496L75.8 320H136v48.7c-22.7 3.8-40 23.6-40 47.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V320H296v48.7c-22.7 3.8-40 23.6-40 47.3v40 8h8 16 8V448h-8-8V416c0-17.7 14.3-32 32-32s32 14.3 32 32v32h-8-8v16h8 16 8v-8V416c0-23.8-17.3-43.5-40-47.3V320h60.2l54.2 176H21.7zM176 416a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 304L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304H64z'
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fast',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      'M496 496H224v16 0H496h16V496 160L352 0H144 128V16 134.7l16-6.5V16H336V168v8h8H496V496zm-6.6-336H352V22.6L489.4 160zM94.9 164.4L73 192.7l-35.5 4.8L32.7 233 4.4 254.9 17.9 288 4.4 321.1 32.7 343l4.8 35.5L64 382.1v112V512l16-8 48-24 48 24 16 8V494.1v-112l26.5-3.6 4.8-35.5 28.3-21.9L238.1 288l13.6-33.1L223.3 233l-4.8-35.5L183 192.7l-21.9-28.3L128 177.9 94.9 164.4zM80 368.1V368H79l-3.9-.5-23.4-3.2-3.2-23.4-.9-6.5-5.2-4L23.8 315.9l8.9-21.9 2.5-6.1-2.5-6.1-8.9-21.9 18.7-14.5 5.2-4 .9-6.5 3.2-23.4 23.4-3.2 6.5-.9 4-5.2 14.5-18.7 21.9 8.9 6.1 2.5 6.1-2.5 21.9-8.9 14.5 18.7 4 5.2 6.5 .9 23.4 3.2 3.2 23.4 .9 6.5 5.2 4 18.7 14.5-8.9 21.9-2.5 6.1 2.5 6.1 8.9 21.9-18.7 14.5-5.2 4-.9 6.5-3.2 23.4-23.4 3.2L177 368h-1v.1l-1.6 .2-4 5.2-14.5 18.7-21.9-8.9-6.1-2.5-6.1 2.5-21.9 8.9L85.6 373.5l-4-5.2-1.6-.2zm0 24.3l14.9 19.2L128 398.1l33.1 13.6L176 392.4v93.7l-40.8-20.4-7.2-3.6-7.2 3.6L80 486.1V392.4zM80 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 64 288a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fast',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm25.8-273.5l5.7 5.7L256 196.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L267.3 208l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L256 219.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L244.7 208l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fast',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      'M432 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zm0 88A52 52 0 1 0 432 0a52 52 0 1 0 0 104zM412.6 270.3l3.2-6.4 10.5-21 6.6 22.5 11.7 39.9-52.3 57-5.2 5.7-2 7.5-24 88L356.9 479l-4.2 15.4 15.4 4.2 30.9 8.4 15.4 4.2 4.2-15.4 4.2-15.4 22-80.5 70.9-77.4c14.8-16.1 20.3-38.6 14.7-59.7l-11.7-43.7-5.3-19.9 18.8 8.3 17.9 7.9 11.5 34.6 5.1 15.2 5.1 15.2 15.2-5.1 30.4-10.1 15.2-5.1-5.1-15.2-5.1-15.2-16-48-4.5-13.4L589 162.8l-72-32-9.3-4.1-10 2-80 16-15.3 3.1-7 14-35.2 70.5L336 244.2l-14.3 7.2 7.2 14.3 14.3 28.6 7.2 14.3 14.3-7.2 33.7-16.8 9.5-4.8 4.8-9.5zm-8.4 102.9l52.3-57 6.1-6.7-2.5-8.7-18.4-62.4-11.5-39L412 235.8l-13.7 27.4-2.4 4.8-4.8 2.4-33.7 16.8-14.3-28.6 24.1-12.1 4.8-2.4 2.4-4.8 35.2-70.5 3.5-7 7.7-1.5 80-16 5-1 4.6 2.1 72 32 6.5 2.9 2.2 6.7 16 48 5.1 15.2-30.4 10.1-5.1-15.2-11.5-34.6-2.2-6.7-6.5-2.9-36.7-16.3L489.4 171l8.6 32.3 17 63.6c4.2 15.8 .1 32.7-11 44.8L433 389.1l-2.6 2.9-1 3.7-22 80.5-4.2 15.4-30.9-8.4 4.2-15.4 24-88 1-3.7 2.6-2.9zM571.3 398l-25-62.4c-2.1 3-4.5 5.8-7 8.6l-4.8 5.2L556.4 404l1.2 3 2.3 2.3 43.4 43.4L614.6 464 592 486.6l-11.3-11.3-48-48-2.3-2.3-1.2-3-18.6-46.4-12 13.1 15.7 39.3 2.4 6.1 4.6 4.6 48 48 11.3 11.3L592 509.3l11.3-11.3 22.6-22.6L637.3 464l-11.3-11.3-11.3-11.3L571.3 398zM245.2 9.9L240 5.5l-5.2 4.5-224 192-6.1 5.2 10.4 12.1 6.1-5.2L64 177.4V408v8h8H343.7l4.4-16H80V163.7L240 26.5l132.9 114 7.4-14.8L245.2 9.9zM232 184v80H152V184h80zm-80-16H136v16 80 16h16 80 16V264 184 168H232 152z'
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fast',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM624 368a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zm-272 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm219.3 8L560 364.7l-5.7 5.7L504 420.7V296v-8H488v8V420.7l-50.3-50.3-5.7-5.7L420.7 376l5.7 5.7 64 64 5.7 5.7 5.7-5.7 64-64 5.7-5.7z'
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fast',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      'M496 80c0 3.6-2.4 9.9-13.6 18.3c-11 8.1-27.8 16.1-50.1 23C387.8 135.2 325.5 144 256 144s-131.9-8.8-176.2-22.7c-22.3-7-39.2-14.9-50.1-23C18.4 89.9 16 83.6 16 80s2.4-9.9 13.6-18.3c11-8.1 27.8-16.1 50.1-23C124.1 24.8 186.5 16 256 16s131.8 8.8 176.2 22.7c22.3 7 39.2 14.9 50.1 23C493.6 70.1 496 76.4 496 80zm16 0C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-4.8 2-9.9 4-15.1 5.8C469.6 194.7 480 232.1 480 272c0 123.7-100.3 224-224 224S32 395.7 32 272c0-39.9 10.4-77.3 28.7-109.7c-5.2-1.9-10.2-3.8-15.1-5.8zm105.3 85.2c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9c2.5-13.5 7.8-28.4 15.2-39.8zM256 416c56.7 0 96.1-35.4 118.6-67.4l-13.1-9.2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6l-13.1 9.2c22.4 32 61.9 67.4 118.6 67.4zm39.7-134.5c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9z'
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fast',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM198.3 374.9L220 288l4-16H207.5 160 144V256v-8L299.6 127.8 320 112l-6.3 25.1L292 224l-4 16h16.5H352h16v16 8L212.4 384.2 192 400l6.3-25.1zM224 256h20.5l-5 19.9-20.8 83.3L352 256.1V256H288 267.5l5-19.9 20.8-83.3L160 255.9v.1h64z'
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fast',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      'M8 0H0V16H8 568h8V0h-8H8zM48 56V48H32v8V344c0 4.4 3.6 8 8 8H280v52.7l-85.7 85.7-5.7 5.7L200 507.3l5.7-5.7L288 419.3l82.3 82.3 5.7 5.7L387.3 496l-5.7-5.7L296 404.7V352H536c4.4 0 8-3.6 8-8V56 48H528v8V336H288 48V56z'
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fast',
    iconName: 'hands-asl-interpreting',
    icon: [
      640,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      'M106.4 8.2L99 5.2l-3 7.4L83.9 42.2 8.4 227.6C2.9 241.2 0 255.7 0 270.4C0 333.1 50.9 384 113.6 384h90.3 0l.1 0h0l.1 0h0H208c2.1 0 4.1-.2 6.2-.5c35.7-3.3 66.4-24.1 83.4-53.5l16-27.7 4-6.9-6.9-4L284 276l26.6-15.4 6.9-4-4-6.9-16-27.7c-9.8-16.9-24.1-31-41.2-40.5l51.1-15.1 30.7-9.1 7.7-2.3-2.3-7.7L325.3 86 323 78.3l-7.7 2.3-30.7 9.1-44.4 13.2 35.5-33.9 5.8-5.5-5.5-5.8L231.7 11.3l-5.5-5.8-5.8 5.5L159.1 69.7l11-26.9 3-7.4-7.4-3L106.4 8.2zM98.7 48.3l9.1-22.2 44.5 18.1-9.1 22.2-13 32L116 133l27.1-25.9 82.5-79 33.2 34.7-53.5 51.2-23.9 22.8 31.7-9.4L289.2 105l23-6.8 13.6 46-23 6.8-72.5 21.5-25.8 7.6 25.8 7.7c22.7 6.8 41.7 22.1 53.4 42.2l12 20.8L264 269.1l-9.9 5.7-1.6-2.8-10.4-18c-7.7-13.2-21.9-22-38.1-22c-24.3 0-44 19.7-44 44c0 24.3 19.7 44 43.9 44h0l0 0h0l0 0h0c16.2 0 30.4-8.8 38.1-22l10.4-18 1.6-2.8 9.9 5.7 31.7 18.3-12 20.8c-14.5 25.1-40.7 42.8-71.2 45.6l-.3 0-.3 0c-1.3 .2-2.6 .3-3.9 .3h-3.9 0l-.1 0h0l-.1 0h0H113.6C59.7 368 16 324.3 16 270.4c0-12.6 2.4-25.1 7.2-36.8L98.7 48.3zM176 276c0-15.5 12.5-28 28-28c10.3 0 19.4 5.6 24.3 14l8.1 14-8.1 14c-4.9 8.5-13.9 14-24.2 14l0 0h0l0 0c-15.4 0-28-12.5-28-28zM533.6 503.9l7.4 3 3-7.4 12.1-29.6 75.5-185.4c5.5-13.6 8.4-28.2 8.4-42.9C640 178.9 589.2 128 526.4 128H436h-4c-2.1 0-4.1 .2-6.2 .5c-35.7 3.3-66.4 24.1-83.4 53.5l-16 27.7-4 6.9 6.9 4L356 236l-26.6 15.4-6.9 4 4 6.9 16 27.7c9.8 16.9 24.1 31 41.2 40.5l-51.1 15.1L302 354.7l-7.7 2.3 2.3 7.7L314.7 426l2.3 7.7 7.7-2.3 30.7-9.1 44.4-13.2-35.5 33.9-5.8 5.5 5.5 5.8 44.2 46.2 5.5 5.8 5.8-5.5 61.3-58.6-11 27-3 7.4 7.4 3 59.3 24.1zm7.7-40.1L532.2 486l-44.5-18.1 9.1-22.2 13.1-32L524 379l-27.1 25.9-82.5 79-33.2-34.7 53.5-51.2 23.9-22.8-31.7 9.4L350.8 407l-23 6.8-13.6-46 23-6.8 72.5-21.5 25.8-7.6-25.8-7.7c-22.7-6.8-41.7-22.1-53.4-42.2l-12-20.8L376 242.9l9.9-5.7 1.6 2.8 10.4 18c7.6 13.2 21.9 22 38.1 22c24.3 0 44-19.7 44-44s-19.7-44-44-44c-16.2 0-30.5 8.8-38.1 22l-10.4 18-1.6 2.8-9.9-5.7-31.7-18.3 12-20.8c14.5-25.2 40.7-42.8 71.2-45.6l.3 0 .3 0c1.3-.2 2.6-.3 3.9-.3h4 90.4c53.9 0 97.6 43.7 97.6 97.6c0 12.6-2.5 25.1-7.2 36.8L541.3 463.8zM464 236c0 15.5-12.5 28-28 28c-10.3 0-19.4-5.6-24.3-14l-8.1-14 8.1-14c4.9-8.5 14-14 24.3-14c15.5 0 28 12.5 28 28z'
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fast',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      'M624 16H176V97c-5.2-.7-10.6-1-16-1V16 0h16H624h16V16 400v16H624 324.6l-4.8-16H624V16zM416 112h8 96 8v8 96 8H512v-8V139.3L389.7 261.7l-5.7 5.7-5.7-5.7-80-80-5.7-5.7L304 164.7l5.7 5.7L384 244.7 500.7 128H424h-8V112zM160 304a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM59.9 368L21.5 496h277L260.1 368H59.9zM272 352l43.2 144 4.8 16H303.3 16.7 0l4.8-16L48 352H272z'
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fast',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H394.8c-6.9-4.9-13.4-10.2-19.6-16H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H326.6c-1.5-5.2-2.7-10.6-3.7-16H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V204c5.2-2 10.6-3.8 16-5.4V8 0h-8H56zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-219.3L492.7 304l5.7 5.7L548.7 360H424h-8v16h8H548.7l-50.3 50.3-5.7 5.7L504 443.3l5.7-5.7 64-64 5.7-5.7-5.7-5.7-64-64-5.7-5.7z'
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fast',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      'M134.1 336l4.5 4L278.1 464H304V48H278.1L138.6 172l-4.5 4H128 16V336H128h6.1zM16 352H0V336 176 160H16 128L272 32h32 16V48 464v16H304 272L128 352H16z'
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fast',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      'M160 170.6V159.9 16H288V159.9v10.7l9.8 4.1C367.3 203.7 416 272.2 416 352c0 57.3-25.1 108.8-65 144H97c-39.9-35.2-65-86.7-65-144c0-79.8 48.7-148.3 118.2-177.3l9.8-4.1zm144-10.7V16h24c4.4 0 8-3.6 8-8s-3.6-8-8-8H304 288 160 144 120h-8V16h8 24V159.9C68.8 191.3 16 265.5 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-86.5-52.8-160.7-128-192.1zM120 312c0-42.5 44.7-80 104-80s104 37.5 104 80c0 26.3-16.7 50.3-43.8 65.2l-4.2 2.3v4.7V416H168V384.2v-4.7l-4.2-2.3c-27.2-14.9-43.8-39-43.8-65.2zm104-96c-64.4 0-120 41.3-120 96c0 32 19.4 59.7 48 76.9V424v8h8H288h8v-8V388.9c28.6-17.2 48-44.8 48-76.9c0-54.7-55.6-96-120-96zm40 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fast',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      'M72 32H64v8V208v16V336H0v16H64V472v8H80v-8V352H224V336H80V224H288V208H80V48H312h8V32h-8H72z'
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fast',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      'M40 416H32v-8V168v-8H48v8V388.7L330.3 106.3l5.7-5.7L347.3 112l-5.7 5.7L59.3 400H280h8v16h-8H40z'
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fast',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      'M336 304h16V288 224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64v64 16h16 17.8L208 432h96l14.2-128H336zm-33.7-1.8L289.7 416H222.3L209.7 302.2 208.1 288H193.8 176V224c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64H318.2 303.9l-1.6 14.2zM208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 64A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM16 425.5c0-9.1 7.5-19.9 26.5-30.8c18.4-10.6 45.3-19.9 78.4-26.9l-3.3-15.7c-33.9 7.1-62.6 16.9-83.1 28.7C14.6 392.3 0 407.2 0 425.5c0 14.5 9.3 26.9 22.7 37c13.5 10.1 32.6 18.9 55.5 26.2C124.1 503.1 186.9 512 256 512s131.9-8.9 177.8-23.4c22.9-7.2 42-16 55.5-26.2c13.4-10 22.7-22.4 22.7-37c0-18.3-14.6-33.2-34.5-44.7c-20.4-11.8-49.1-21.5-83.1-28.7l-3.3 15.7c33.1 6.9 60 16.2 78.4 26.9c18.9 10.9 26.5 21.7 26.5 30.8c0 7.2-4.6 15.4-16.3 24.2c-11.6 8.6-28.8 16.8-50.8 23.7C385 487.3 323.9 496 256 496s-129-8.7-172.9-22.6c-22-7-39.2-15.1-50.8-23.7c-11.7-8.8-16.3-17-16.3-24.2z'
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fast',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      'M168.5 37.2l1.9-5.2h11.1l1.9 5.2L348.4 480H331.3L283.7 352H68.3L20.7 480H3.6L168.5 37.2zM74.3 336H277.7L176 62.9 74.3 336zM640 168V276v88V472v8H624v-8V422.8C603.8 457 566.6 480 524 480c-64.1 0-116-51.9-116-116V276c0-64.1 51.9-116 116-116c42.6 0 79.8 23 100 57.2V168v-8h16v8zm-116 8c-55.2 0-100 44.8-100 100v88c0 55.2 44.8 100 100 100s100-44.8 100-100V276c0-55.2-44.8-100-100-100z'
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fast',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L496 316.7l-5.7 5.7L416 396.7l-42.3-42.3-5.7-5.7L356.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fast',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      'M5.7 250.3L0 256l5.7 5.7 152 152 5.7 5.7L174.6 408l-5.7-5.7L30.6 264 504 264l8 0 0-16-8 0L30.6 248 169 109.7l5.7-5.7L163.3 92.7l-5.7 5.7-152 152z'
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fast',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      'M520 112.8l.1-.8H504L485.3 294.8l14.9 11.8L520 112.8zM468 464.6L464.8 496H175.2L146.1 210.4l-17.5-13.8L160 504.8l.7 7.2H168 472h7.2l.7-7.2 2.9-28.5L468 464.6zM211.6 64H193l20.3 16H544V64H428.4L390.8 3.8 388.4 0H384 256h-4.4l-2.4 3.8L211.6 64zm168-48l30 48H230.4l30-48H379.6zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fast',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      'M136 0V8 32h32 8V48h-8H136V96h64 16v16 16l-36.9 96H192h8v16h-8H177.3l23 144H184.1l-23-144H94.9l-23 144H55.7l23-144H64 56V224h8H76.9L40 128V112 96H56h64V48H88 80V32h8 32V8 0h16zM56 125l38.1 99h67.9L200 125V112H136 120 56v13zM44.3 416H48 208h3.7l2.4 2.9 40 48 1.9 2.2V472v32 8h-8H8 0v-8V472v-2.9l1.9-2.2 40-48 2.4-2.9zm7.5 16L16 474.9V496H240V474.9L204.3 432H51.7zM296 192h8 40 8v8 24h16V200v-8h8 48 8v8 24h16V200v-8h8 40 8v8 88 3.3l-2.3 2.3L464 331.3V384H448V328v-3.3l2.3-2.3L488 284.7V208H464v24 8h-8H424h-8v-8V208H384v24 8h-8H344h-8v-8V208H312v76.7l37.7 37.7 2.3 2.3V328v56H336V331.3l-37.7-37.7-2.3-2.3V288 200v-8zm35.9 224H336 464h4.1l2.4 3.4 40 56 1.5 2.1V480v24 8h-8H296h-8v-8V480v-2.6l1.5-2.1 40-56 2.4-3.4zm8.2 16L304 482.6V496H496V482.6L459.9 432H340.1z'
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fast',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM304 160H288v8V344v8h16v-8V168v-8zm64 0v8 96 80 8h16v-8V272h80 8V256h-8H384V176h96 8V160h-8H376h-8zM96 256c0-44.2 35.8-80 80-80c19.3 0 37.1 6.9 50.9 18.3l6.2 5.1L243.3 187l-6.2-5.1C220.5 168.2 199.2 160 176 160c-53 0-96 43-96 96s43 96 96 96c23.2 0 44.5-8.2 61.1-21.9l2.9-2.4v-3.8V256v-8h-8H160h-8v16h8 64v56c-13.4 10-30 16-48 16c-44.2 0-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fast',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      'M432 72l0-8 16 0 0 8 0 368 0 8-16 0 0-8 0-368zM160 192l0-16 0-64 0-16 16 0 16 0L340.7 244.7 352 256l-11.3 11.3L192 416l-16 0-16 0 0-16 0-64 0-16-16 0L16 320 0 320l0-16 0-96 0-16 16 0 128 0 16 0zm16 0l0 16-16 0L16 208l0 96 144 0 16 0 0 16 0 80 9.4 0 144-144-144-144-9.4 0 0 80z'
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fast',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      'M0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2zM191.4 21.8C116.8 87.1 59.9 170.2 26 263.5c-6.6 18.1-10 37.4-10 56.7C16 416.5 95.6 496 192 496s176-79.5 176-175.8c0-19.3-3.4-38.6-10-56.7C324.1 170.2 267.2 87.1 192.6 21.8l-.6-.5-.6 .5zm14.3 136.7c.1 2 .3 4 .6 5.9c1.6 9.6 6.2 18.6 13.1 25.7l51.4 52.3c21.2 21.6 33.1 50.7 33.1 81C304 383.3 255.3 432 195.3 432h-5.9C129 432 80 383 80 322.6c0-25.5 12.4-49.4 33.1-64.1c.8-.6 1.7-1.2 2.6-1.7l13.4-8.7v19.1 27.2c0 23 18.7 41.7 41.7 41.7h2.5c21.7 0 39.3-17.6 39.3-39.3c0-10.2-3.9-19.9-11-27.3l-9-9.4c-13.5-14-21.1-32.8-21.1-52.3c0-18.2 6.6-35.7 18.3-49.2c.7-.8 1.3-1.5 2-2.2c2.1-2.3 4.5-4.5 6.9-6.5l7.1-5.9v12.4c0 .7 0 1.4 0 2.1zM96 322.6c0 51.6 41.8 93.4 93.4 93.4h5.9c51.2 0 92.7-41.5 92.7-92.7c0-26.1-10.3-51.2-28.5-69.8l-51.4-52.3c-6-6.1-10.7-13.3-13.8-21.1c-4.5 8.4-6.9 17.9-6.9 27.7c0 15.4 6 30.1 16.6 41.2l9 9.4c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7V279.6c-10.9 11.5-17.1 26.9-17.1 43z'
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fast',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M424 264h-8L32 264H24l0-16 8 0 384 0 8 0v16z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fast',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128h-6.4l-1.4 6.2-24 104-2.1 8.9 9.1 .8 110.7 10.1c28.4 2.6 50.1 26.4 50.1 54.9c0 30.4-24.7 55.1-55.1 55.1H227.9c-21.3 0-41.3-10.7-53.2-28.5l-13.3 8.9c14.8 22.1 39.8 35.5 66.5 35.5h53.1c39.3 0 71.1-31.8 71.1-71.1c0-36.8-28-67.4-64.6-70.8l-101.5-9.3L206.4 144H328h8V128h-8H200z'
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fast',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.6 136c-24.7 0-44.6 20.1-44.4 44.7l.4 59.3H280h8v16h-8H223.6l.4 57.3 0 3.4-2.4 2.4L187.7 352H344h8v16h-8H168 148.3l14.1-13.7L208 310l-.3-54H168h-8V240h8 39.5l-.4-59.2c-.2-33.5 26.9-60.8 60.4-60.8c9.4 0 18.6 2.2 27 6.4l20.9 10.5 7.2 3.6-7.2 14.3-7.2-3.6-20.9-10.5c-6.2-3.1-13-4.7-19.9-4.7z'
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fast',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      'M136.2 108.7C105.4 71.2 68.5 45.3 43.6 32.8L36.4 47.2c23.1 11.5 58.2 36.1 87.4 71.7C153 154.5 176 200.7 176 256s-23 101.5-52.2 137.1c-29.2 35.7-64.3 60.2-87.4 71.7l7.2 14.3c24.9-12.5 61.8-38.3 92.6-75.9C167 365.7 192 315.9 192 256s-25-109.7-55.8-147.3z'
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fast',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      'M532.5 288H560h16V272 240 224H560 532.5c-49.9 0-74.9-60.3-39.6-95.6l19.5-19.5 11.3-11.3L512.3 86.3 489.7 63.7 478.4 52.4 467.1 63.7 447.6 83.1C412.3 118.4 352 93.4 352 43.5V16 0H336 304 288V16 43.5c0 31.3-23.8 52.9-50.3 55.8L254 112.1c27.7-9 50-34.2 50-68.6V16h32V43.5c0 64.2 77.6 96.2 122.9 50.9l0 0L478.4 75 501 97.6l-19.5 19.5C436.2 162.4 468.3 240 532.5 240H560v32H532.5c-20.6 0-37.8 8-50.3 20.3l12.7 10c9.6-8.7 22.4-14.3 37.6-14.3zM145.1 209.7c-9.6 8.7-22.4 14.3-37.6 14.3H80 64v16 32 16H80h27.5c49.9 0 74.9 60.3 39.6 95.6l-19.5 19.5-11.3 11.3 11.3 11.3L139 437l11.3 11.3 11.3 11.3 11.3-11.3 19.5-19.5 0 0c35.3-35.2 95.6-10.3 95.6 39.6V496v16h16 32 16V496 468.5c0-31.3 23.8-52.9 50.3-55.8L386 399.9c-27.7 9-50 34.2-50 68.6V496H304V468.5c0-64.1-77.5-96.3-122.9-50.9l0 0 0 0 0 0L161.6 437l-11.3-11.3L139 414.4l19.5-19.5C203.8 349.6 171.7 272 107.5 272H80V240h27.5c20.6 0 37.8-8 50.3-20.3l-12.7-10zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fast',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      'M416 0V8c0 60.3-24.1 107.6-59.5 147.9c-35.1 40-81.7 73.5-127.4 106.3l-.4 .3C188.5 291.4 149 319.8 117.2 352H330.8c-21.7-22-47-42.2-73.7-62.1l2.6-1.9 0 0 0 0c3.7-2.6 7.4-5.3 11-7.9c31.4 23.5 61.4 48.2 85.8 76C391.9 396.4 416 443.7 416 504v8H400v-8c0-14.1-1.4-27.4-4.1-40H52.1c-2.7 12.6-4.1 25.9-4.1 40v8H32v-8c0-60.3 24.1-107.6 59.5-147.9c32.9-37.4 75.9-69.2 118.8-100.1c-42.9-30.9-85.9-62.7-118.8-100.1C56.1 115.6 32 68.3 32 8V0H48V8c0 14.1 1.4 27.4 4.1 40H395.9c2.6-12.6 4.1-25.9 4.1-40V0h16zM391.8 64H56.2c9.1 29.9 25.4 56.1 46.3 80.1c.5-.1 1-.1 1.5-.1H344c.5 0 1 0 1.5 .1c20.9-24 37.2-50.2 46.3-80.1zm-61 96H117.2c30.6 31 68.2 58.4 106.8 86.1c38.6-27.7 76.2-55.2 106.8-86.1zM56.2 448H391.8c-9.1-29.9-25.4-56.1-46.3-80.1c-.5 .1-1 .1-1.5 .1H104c-.5 0-1 0-1.5-.1c-20.9 24-37.2 50.2-46.3 80.1z'
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fast',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      'M224 176l0 16 0 224 0 16 16 0 128 0 0 64-208 0 0-304 0-16-16 0-96 0 0-9.4 144-144 144 144 0 9.4-96 0-16 0zm128-16L203.3 11.3 192 0 180.7 11.3 32 160l0 16 0 16 16 0 80 0 16 0 0 16 0 288 0 16 16 0 208 0 16 0 0-16 0-64 0-16-16 0-112 0-16 0 0-16 0-192 0-16 16 0 80 0 16 0 0-16 0-16z'
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fast',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      'M516.2 11.5c-10.1 .9-19.7 3.4-28.6 7.2c-34.3 14.6-58.4 48.7-58.4 88.4c0 53 42.8 96 95.6 96c8.3 0 16.4-1.1 24-3.1c9.7-2.5 18.9-6.6 27.1-11.8c-5 9.4-11.1 18.1-18.2 25.9c-20.1 22.2-47.9 37.3-79.2 41c-.8-5.4-2-10.6-3.5-15.7c19.8-2.1 38-9.3 53.4-20.4c-1.2 0-2.4 .1-3.7 .1c-61.7 0-111.6-50.2-111.6-112c0-37.5 18.3-70.7 46.5-91c-43 1.4-80 27.4-97.3 64.4c-4.5-2.8-9.3-5.3-14.2-7.4C368.7 29.9 412.6 0 463.5 0c7.7 0 15.3 .7 22.6 2c10.6 1.9 20.7 5.1 30.2 9.4zM176 64c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.8 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4l0 64 0 16h-16l-64 0H352v-16h15.9l64 0v-64c0-31.5-22.7-57.6-52.6-63L362.8 206l3.6-16.3c1-4.4 1.5-9 1.5-13.8c0-35.3-28.6-64-64-64c-13.6 0-26.2 4.3-36.6 11.5l-14 9.8-8.8-14.6C230.4 95.5 205 80 176 80c-44.2 0-79.9 35.8-80 79.9l0 1.3 .1 13.6-13.4 2.3C44.8 183.4 16 216.3 16 255.9v80H64v16H16 0v-16-80c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zm-4 336l4-16H159.5 112 96V368v-8L251.6 239.8 272 224l-6.3 25.1L244 336l-4 16h16.5H304h16v16 8L164.4 496.2 144 512l6.3-25.1L172 400zm-60-32h64 20.5l-5 19.9-20.8 83.3L304 368.1V368H240 219.5l5-19.9 20.8-83.3L112 367.9v.1z'
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fast',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM195.3 179.3L184 168l11.3-11.3L208 144H352h16v16V304l-12.7 12.7L344 328l-11.3-11.3-25.4-25.4L296 280l-11.3 11.3-73.4 73.4L200 376l-11.3-11.3-41.4-41.4L136 312l11.3-11.3 73.4-73.4L232 216l-11.3-11.3-25.4-25.4zm48 48L158.6 312 200 353.4l84.7-84.7L296 257.4l11.3 11.3L344 305.4l8-8V160H214.6l-8 8 36.7 36.7L254.6 216l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fast',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      'M16 16V272H560V16H16zM0 0H16 560h16V16 272v16H560 16 0V272 16 0zM80 176v32h32V176H80zM64 160H80h32 16v16 32 16H112 80 64V208 176 160zM208 80H176v32h32V80zM176 64h32 16V80v32 16H208 176 160V112 80 64h16zm0 112v32H400V176H176zm-16-16h16H400h16v16 32 16H400 176 160V208 176 160zm336 16H464v32h32V176zm-32-16h32 16v16 32 16H496 464 448V208 176 160h16zM80 80v32h32V80H80zM64 64H80h32 16V80v32 16H112 80 64V112 80 64zM304 80H272v32h32V80zM272 64h32 16V80v32 16H304 272 256V112 80 64h16zm96 16v32h32V80H368zM352 64h16 32 16V80v32 16H400 368 352V112 80 64zM496 80H464v32h32V80zM464 64h32 16V80v32 16H496 464 448V112 80 64h16zM149.7 349.5L288 487.9 426.3 349.5l5.7-5.7 11.3 11.3-5.7 5.7-144 144-5.7 5.7-5.7-5.7-144-144-5.7-5.7L144 343.9l5.7 5.7z'
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fast',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      'M176 296l16 0 304 0 0-80-304 0-16 0 0-16 0-88-9.4 0L22.6 256l144 144 9.4 0 0-88 0-16zM160 416L11.3 267.3 0 256l11.3-11.3L160 96l16 0 16 0 0 16 0 72 0 16 16 0 288 0 16 0 0 16 0 80 0 16-16 0-288 0-16 0 0 16 0 72 0 16-16 0-16 0z'
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fast',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      'M560 80V432H16V80H560zM16 64H0V80 432v16H16 560h16V432 80 64H560 16zM544 184V168h-8-8c-30.9 0-56-25.1-56-56v-8V96H456v8 8c0 39.8 32.2 72 72 72h8 8zM40 184h8c39.8 0 72-32.2 72-72v-8V96H104v8 8c0 30.9-25.1 56-56 56H40 32v16h8zM544 328h-8-8c-39.8 0-72 32.2-72 72v8 8h16v-8-8c0-30.9 25.1-56 56-56h8 8V328zM40 328H32v16h8 8c30.9 0 56 25.1 56 56v8 8h16v-8-8c0-39.8-32.2-72-72-72H40zM288 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM272 200h-8v16h8 8v80H264h-8v16h8 16 16 16 8V296h-8H296V208v-8h-8H272z'
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fast',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      'M112 8V0H96V8 96H8 0v16H8 96V408v8h8H352V400H112V8zM400 504v8h16v-8V416h88 8V400h-8H416l0-296V96h-8L160 96v16l240 0 0 392z'
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fast',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      'M0 32H8 112s0 0 0 0h8H312h8V48h-8H178c44.1 22.8 74.9 67.7 77.7 120H312h8v16h-8H255.8c-4.2 75.8-66.9 136-143.8 136H23L252.3 465.2l-8.6 13.5-240-152L0 324.4V320v-8-8H8 112c68 0 123.6-53 127.8-120H8 0V168H8 239.8C235.6 101 180 48 112 48c0 0 0 0 0 0H8 0V32z'
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fast',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M144 96l11.3-11.3L208 32H432h16V48v96 16H432 208l-52.7-52.7L144 96zm288 48V48H214.6l-48 48 48 48H432zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 80a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm80-48l11.3-11.3L208 352H432h16v16 96 16H432 208l-52.7-52.7L144 416zm288 48V368H214.6l-48 48 48 48H432zM155.3 267.3L144 256l11.3-11.3L208 192H496h16v16 96 16H496 208l-52.7-52.7zM214.6 304H496V208H214.6l-48 48 48 48z'
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fast',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      'M624 48V368H112V48H624zM112 32H96V48 368v16h16H624h16V368 48 32H624 112zM64 128H16 0v16V464v16H16 528h16V464 416H528v48H16V144H64V128zm224 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fast',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2l3.1 5.8 6.3-1.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1l-1.9 6.3 5.8 3.1C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2l-5.8 3.1 1.9 6.3c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1l-6.3-1.9-3.1 5.8C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2l-3.1-5.8-6.3 1.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1l1.9-6.3-5.8-3.1C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2l5.8-3.1-1.9-6.3c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1l6.3 1.9 3.1-5.8zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-62-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zm8.9 149.3v-8h-16v8 19.1c-9.6 .7-18.4 2.8-26.1 6.3c-13.6 6.1-23.9 16.8-26.4 31.4c-1.5 8.9-.6 16.8 2.6 23.7c3.2 6.8 8.4 12 14.4 16c11 7.5 26 12 39.6 16.1l1.8 .5c14.9 4.5 27.9 8.6 36.8 15.1c4.2 3.1 7.2 6.5 8.8 10.3c1.7 3.8 2.4 8.8 1.2 15.5c-1.6 9.4-7.6 16.2-17.3 20.4c-5.4 2.3-12 3.8-19.5 4.2v-.8h-16v.2c-1.4-.2-2.9-.4-4.3-.6c-8-1.3-21.6-5.9-32.1-9.5l0 0 0 0 0 0 0 0c-2.3-.8-4.4-1.5-6.3-2.1l-7.6-2.5-5.1 15.2 7.6 2.5c1.6 .5 3.5 1.2 5.5 1.9l0 0 0 0 0 0c10.4 3.6 25.9 8.8 35.4 10.4l0 0c2.3 .4 4.6 .7 6.8 .9l0 19.2v8h16v-8V343.9c9.4-.5 18.2-2.3 25.8-5.5c13.8-5.9 24-16.8 26.7-32.4c1.6-9.3 .8-17.5-2.3-24.6c-3.1-7.1-8.2-12.6-14.1-16.9c-11.5-8.3-27.4-13.2-41.6-17.5l-.4-.1c-14.8-4.5-27.8-8.4-36.7-14.4c-4.3-2.9-7.2-6.1-8.9-9.6c-1.6-3.4-2.4-7.9-1.3-14.1c1.4-8 7.2-14.9 17.3-19.5c5.5-2.5 12.1-4.2 19.5-4.8v.5h16v-.2c1.4 .2 2.9 .3 4.4 .6c5.1 .8 20.6 3.8 25.6 5.1l4.1-15.5c-5.7-1.5-21.9-4.6-27.2-5.5c-2.3-.4-4.6-.6-6.8-.9V149.3z'
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fast',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      'M368 96A80 80 0 1 0 208 96a80 80 0 1 0 160 0zm-51.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM272 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM176 416A80 80 0 1 0 16 416a80 80 0 1 0 160 0zm208-80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM288 496a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm272-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fast',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM137.4 179.4l13.1 9.2C171.4 158.8 206.6 128 256 128s84.6 30.8 105.4 60.6l13.1-9.2C352.1 147.4 312.7 112 256 112s-96.1 35.4-118.6 67.4zM192.4 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fast',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm128 88l16 0 96 0h16v32l-16 0-96 0-16 0V128zm144 48V160l0-32V112H272 256l-96 0-16 0H128v16 32 16h16l16 0 96 0 16 0 16 0zm-80 48h16H352h16v32H352 224 208V224zm128 96h16 96 16v32H448 352 336V320zM224 208H208 192v16 32 16h16 16H352h16 16V256 224 208H368 352 224zm128 96H336 320v16 32 16h16 16 96 16 16V352 320 304H464 448 352z'
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fast',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      'M16 16V432H432V16H16zM0 0H16 432h16V16 432v16H432 363.3l58.3 58.3 5.7 5.7H404.7l-64-64H107.3l-64 64H20.7l5.7-5.7L84.7 448H16 0V432 16 0zM112 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm176 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM368 80H232V240H368V80zM80 80V240H216V80H80zm0-16H368h16V80 240v16H368 80 64V240 80 64H80z'
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fast',
    iconName: 'game-console-handheld-crank',
    icon: [
      576,
      512,
      [],
      'e5b9',
      
      'M432 48V272v16V464H16V48H432zm16 416V288h40 8v-8V208h71.9 8v-8V136v-8h-8H488h-8v8 64 72H448V48 32H432 16 0V48 464v16H16 432h16V464zM368 112V256H80V112H368zM80 96H64v16V256v16H80 368h16V256 112 96H368 80zm32 224h-8v8 32H72 64v8 8h8 32v32 8h8 8v-8V376h32 8v-8-8h-8H120V328v-8h-8zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM496 192V144h63.9v48H496z'
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fast',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      'M266.8 37.6c53.1-10.3 116.6-10.6 192 2l1.9 .3L331.1 169.6c-33.5-35.7-56.5-81.3-64.2-132zm-1.9-15.9s0 0 0 0c-5.3 1-10.6 2.1-15.8 3.4c0 0 0 0 0 0c-14.1 3.3-27.5 7.4-40.3 12.1C169 51.9 136.3 73.1 110 98.6l0 0c-3.9 3.7-7.6 7.6-11.2 11.5l0 0C86.3 123.7 75.4 138.3 66 153.6c-18.4 29.9-31 62.5-39.2 95.7c0 0 0 0 0 0c-1.3 5.2-2.5 10.5-3.6 15.7c0 0 0 0 0 0c-14.6 70.8-10.1 143.1 1.2 198l4.4 21.5 21.6 3.6c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5l-4.4-21.5-21.6-3.6c-76.3-12.7-141.4-12.7-196.6-2.2zM39.2 267.1c50 7.9 95.1 30.8 130.5 64L40.2 460.4l-.1-.6c-11.1-53.9-15.3-124.4-1-192.8zm12.1 205L180.9 342.4c33.5 35.7 56.5 81.3 64.2 132c-53.1 10.3-116.6 10.6-192-2l-1.9-.3zM260.8 471c-8.4-53.7-33-102.1-68.6-139.9L256 267.3 390.7 402c-24.8 23.9-55.5 43.8-93.2 57.8c-11.6 4.3-23.8 8-36.7 11.1zm141.1-80.4L267.3 256l63.8-63.8c37.4 35.2 85.1 59.7 138.2 68.3c-7.9 31.2-19.8 61.6-36.9 89.5c-8.8 14.3-18.9 27.9-30.4 40.5zm71-145.7c-50-7.9-95.1-30.8-130.5-64L471.8 51.5l.1 .6c11.1 53.9 15.3 124.4 1 192.8zM42.8 251.4c7.9-31.2 19.8-61.6 36.9-89.5c8.8-14.3 18.9-27.9 30.4-40.5L244.7 256l-63.8 63.8c-37.4-35.2-85.1-59.7-138.2-68.3zM121.3 110c24.8-23.9 55.5-43.8 93.2-57.8c11.6-4.3 23.8-8 36.7-11.1c8.4 53.7 33 102.1 68.6 139.9L256 244.7 121.3 110z'
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fast',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      'M208 272V496h64V272H208zm-16-16h16 64 16v16V496v16H272 208 192V496 272 256zM48 400v96h64V400H48zM32 384H48h64 16v16 96 16H112 48 32V496 400 384z'
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fast',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      'M512 480l0-16L0 464l0 16 512 0zM112 368l0-224 288 0 0 224-288 0zm288 16l16 0 0-16 0-224 0-16-16 0-288 0-16 0 0 16 0 224 0 16 16 0 288 0zM0 48l512 0 0-16L0 32 0 48z'
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fast',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM256 288l-16 0 0 16 0 64-1.4 0-112-112 112-112 1.4 0 0 64 0 16 16 0 112 0 0 64-112 0zM115.3 267.3L232 384l8 0 16 0 0-16 0-48 0-16 16 0 96 0 16 0 0-16 0-64 0-16-16 0-96 0-16 0 0-16 0-48 0-16-16 0-8 0L115.3 244.7 104 256l11.3 11.3z'
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fast',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      'M136 0h-8V8 96H64L3.2 400 0 416H16.3 262.6c-1.5-5.2-2.7-10.6-3.7-16H19.5L77.1 112H136 312h58.9L388 197.5c5.1-1.3 10.4-2.4 15.7-3.3L384 96H320V8 0h-8H136zM272 448c0 26.5-21.5 48-48 48s-48-21.5-48-48H160c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6H272zM304 96H144V16H304V96zm0 272a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 296v-8H424v8 64H360h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H440V296z'
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fast',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      'M256 0L385 229.3l96.5 28.5c15.9 4.7 30.8 12.5 43.7 22.8l27.4 21.9c25.2 20.2 16.5 60.6-14.8 68.6c-34.2 8.7-70.2 8.7-104.4-.2L104.7 285.4 .3 180.1 0 64.4 0 48l16 3.6L72 64l24 80 114.1 33.7 18.2 5.4-5.2-18.2L180.6 16 176 0l16.6 0L256 0zM437.5 355.4c31.6 8.2 64.7 8.3 96.4 .2c18.5-4.7 23.7-28.6 8.8-40.6l-27.4-21.9c-11.3-9.1-24.3-15.9-38.3-20l-96.5-28.5-6.2-1.8-3.2-5.7L246.6 16l-49.4 0 46.5 162.7 8 28-27.9-8.2L91.5 159.3l-8.3-2.5-2.5-8.3-21.3-71L16 68l.2 105.5L113 271l324.5 84.5zM8 496H632h8v16h-8H8 0V496H8zM160 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fast',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      'M121.5 449.6l.6-1.6H139c-14.6 45.4-35.6 64-59 64C35.8 512 0 445.4 0 256S35.8 0 80 0c34.8 0 64.4 41.3 75.4 151.3l46-46 9.4-9.4H224h64 6.2l5.7 2.3 80 32 11.3 4.5 5.4 10.9L435.8 224H480h16 16v16 32 16H496 480 416 396.2l-8.8-17.7-15.1-30.1-9.7-19.3L354.8 241l-22.2 57.1L401 340.9l20.4 12.8-6.6 23.2-32 112L376.1 512H326.2 309.6l4.6-16 7.1-24.8 25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l26-78 5.3-16H248.1 237.3l-38.6 38.6-11.3 11.3L176 221.3l-11.3-11.3-5.7-5.7c.6 16.1 1 33.3 1 51.7c0 36.4-1.3 68.3-3.8 96H140.2c2.5-27.4 3.8-59.2 3.8-96c0-94.1-8.9-155.9-22.5-193.6C107.8 24.3 91.8 16 80 16s-27.8 8.3-41.5 46.4C24.9 100.1 16 161.9 16 256s8.9 155.9 22.5 193.6C52.2 487.7 68.2 496 80 496s27.8-8.3 41.5-46.4zm36.3-269.2L176 198.6l11.3-11.3 38.6-38.6 4.7-4.7h6.6 27.7 22.2l-7 21.1-31.3 94c-7 21 1.3 44.1 20.1 55.9l86.2 53.9 10.2 6.4L362 386.8l-25.4 88.8L330.8 496h33.3l3.3-11.6 32-112 3.3-11.6-10.2-6.4-68.3-42.7-11.2-7 4.8-12.3 30.1-77.3 13.1-33.6L377 213.7l24.7 49.4 4.4 8.8H416h64 16V240H480 435.8h-9.9l-4.4-8.8-39.2-78.3-2.7-5.4-5.6-2.3-80-32-2.9-1.1H288 224h-6.6l-4.7 4.7-48 48-7.5 7.5c.2 2.7 .4 5.5 .6 8.2zM400 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM193.6 352l13.7-37.2c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L204.8 368H193.6 112v32H227.2l16.3-44.4 0 0 13.9 8.7-19 51.7H112 96V400 368 352h16 81.6z'
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fast',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM320 352h-8H232v80 8H216v-8V352H136h-8V336h8 80V256v-8h16v8 80h80 8v16z'
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fast',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      'M340.3 240.2l-9.7-19.3L322.8 241l-22.2 57.1L369 340.9l20.4 12.8-6.6 23.2-32 112-2.1 7.2H416c0-.4 0-.8 .1-1.2L446.7 288H384 364.2l-8.8-17.7-15.1-30.1zM448 272h7.9 .3H464V240H448 403.8h-9.9l-4.4-8.8-39.2-78.3-2.7-5.4-5.6-2.3-80-32-2.9-1.1H256 192h-6.6l-4.7 4.7-48 48L121.4 176 144 198.6l11.3-11.3 38.6-38.6 4.7-4.7h6.6 27.7 22.2l-7 21.1-31.3 94c-7 21 1.3 44.1 20.1 55.9l86.2 53.9 10.2 6.4L330 386.8l-25.4 88.8L298.8 496h33.3l3.3-11.6 32-112 3.3-11.6-10.2-6.4-68.4-42.7-11.2-7 4.8-12.3 30-77.3 13.1-33.6L345 213.7l24.7 49.4 4.4 8.8H384h64zm16 16h-1.1L432.1 496H560V440v-8h16v8 64 8h-8H344.1 294.2 277.6 8 0V496H8 64c0-.5 0-1 .1-1.4l54.9-298.2-9-9L98.7 176l11.3-11.3 11.3-11.3 48-48 9.4-9.4H192h64 6.2l5.7 2.3 80 32 11.3 4.5 5.4 10.9L403.8 224H448h16 16v16 32 16H464zM132.8 210.1L80.1 496h37.1l0 0 73.6-157.7c3.7 4.1 7.8 8 12.3 11.5L134.9 496h35.3l60-128.6 13.7 8.5L187.8 496h94.3l7.1-24.8 25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l26-78 5.3-16H216.1 205.3l-38.6 38.6-11.3 11.3L144 221.3l-11.2-11.2zM336 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fast',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      'M344 416h8v-8V168v-8H336v8V388.7L53.7 106.3 48 100.7 36.7 112l5.7 5.7L324.7 400H104 96v16h8H344z'
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fast',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM72 96h80 72 72 80 8v8V256 408v8h-8H296 224 152 72 64v-8V256 104 96h8zm8 152h64V112H80V248zm80 0h56V112H160V248zm72 0h56V112H232V248zm72 0h64V112H304V248zm0 16V400h64V264H304zm-16 0H232V400h56V264zm-72 0H160V400h56V264zm-72 0H80V400h64V264z'
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fast',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      'M210.4 0H216h80 5.6l1.9 5.3 160 448 2.7 7.5-15.1 5.4-2.7-7.5L404.6 336H107.4L63.5 458.7l-2.7 7.5-15.1-5.4 2.7-7.5 160-448L210.4 0zM113.1 320H398.9L347.5 176h-183L113.1 320zm57.1-160H341.8L290.4 16H221.6L170.2 160zM0 496H8 504h8v16h-8H8 0V496z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fast',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 9.9 .3L293.2 9.9zm74 238.1H328V184v-8h-8H256h-8v8 64H184h-8v8 64 8h8 64v64 8h8 64 2.9c-1.4-7.8-2.4-15.8-2.7-24H312v8H264V320v-8h-8H192V264h64 8v-8V192h48v64 8h8 34c4.1-5.6 8.5-10.9 13.3-16zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fast',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      'M157.4 25l5.9 5.4L152.4 42.2l-5.9-5.4C132.7 23.9 114.1 16 93.7 16C50.8 16 16 50.8 16 93.7c0 15.4 4.4 29.7 12.1 41.7l4.3 6.7-13.5 8.6L14.6 144C5.4 129.5 0 112.2 0 93.7C0 42 42 0 93.7 0c24.6 0 47 9.5 63.7 25zm-54.1 427L53.7 501.7 48 507.3 36.7 496l5.7-5.7 49.7-49.7C54.8 400.6 32 347 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 59-22.8 112.6-60.1 152.6l49.7 49.7 5.7 5.7L464 507.3l-5.7-5.7-49.7-49.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1zM464 288A208 208 0 1 0 48 288a208 208 0 1 0 416 0zM354.6 25C371.3 9.5 393.7 0 418.3 0C470 0 512 42 512 93.7c0 18.5-5.4 35.8-14.6 50.3l-4.3 6.7-13.5-8.6 4.3-6.7c7.7-12 12.1-26.3 12.1-41.7C496 50.8 461.2 16 418.3 16c-20.4 0-39 7.9-52.8 20.7l-5.9 5.4L348.7 30.4l5.9-5.4zM264 160v8V328v8H248v-8V168v-8h16zM240 368h32v32H240V368z'
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fast',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      'M344 113.5c0-5.2-2.9-14.5-9.5-27.4c-6.3-12.2-14.8-25.6-23.6-38.2c-8.2-11.7-16.4-22.5-22.9-30.6c-6.4 8.1-14.7 18.9-22.9 30.6c-8.8 12.6-17.3 25.9-23.6 38.2c-6.6 12.9-9.5 22.2-9.5 27.4c0 27.5 24.1 51.5 56 51.5s56-24 56-51.5zm-128 0c0-28.4 41.8-84 61.7-108.9C283.9-3.2 288-8 288-8s4.1 4.8 10.3 12.6C318.2 29.5 360 85.1 360 113.5c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5zM16 128H193.3c.9 5.5 2.3 10.9 4.1 16L16 144l0 352 384 0 0-152v-8h8H560V144l-181.5 0c1.8-5.1 3.2-10.5 4.1-16H560h16v16V352L416 512H16 0V496 144 128H16zM553.4 352H416l0 137.4L553.4 352zM72 216a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fast',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM192 152v16h8H440h8V152h-8H200h-8zm0 96v16h8H440h8V248h-8H200h-8zm0 96v16h8H440h8V344h-8H200h-8zM128 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fast',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      'M208 48V248v16V464H128V416 400 112 96 48h80zM112 416v48 16h16 80 16V464 264H416V464v16h16 80 16V464 416h64 16V400 264h24 8V248h-8H608V112 96H592 528V48 32H512 432 416V48 248H224V48 32H208 128 112V48 96H48 32v16V248H8 0v16H8 32V400v16H48h64zM528 112h64V248v16V400H528V112zM512 416v48H432V264 248 48h80V96v16V400v16zM112 400H48V264 248 112h64V400z'
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fast',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      'M483.6 28.4C467.2 12 441.4 12 425.9 27.6c-1.6 1.6-4.5 6.3-7.7 15.2c-3 8.3-5.8 18.6-8.3 29.6c-2.8 12.6-5.1 25.5-6.9 36.8c11.2-1.7 24.2-4 36.8-6.7c11-2.4 21.2-5.1 29.6-8.1c8.9-3.2 13.5-6 15.1-7.6l0 0C500 71 500 44.9 483.6 28.4zm12.2 69.4c-14 14.1-63.9 23.1-95.3 27.8c-6.4 1-12.1 1.7-16.5 2.4c.6-4.4 1.4-10.1 2.4-16.5c4.8-31.3 14.1-81.1 28.1-95.2c22-22.1 58-21.6 80.4 .9s22.8 58.6 .9 80.7zM496 256c0-40.2-9.9-78-27.3-111.3c5.3-1.5 10.6-3.1 15.5-4.8C502 174.7 512 214.2 512 256c0 141.4-114.6 256-256 256c-42 0-81.6-10.1-116.5-28c1.8-5 3.4-10.2 4.9-15.5C177.7 486.1 215.7 496 256 496c132.5 0 240-107.5 240-240zM256 0c42 0 81.6 10.1 116.5 28c-1.8 5-3.4 10.2-4.9 15.5C334.3 25.9 296.3 16 256 16C123.5 16 16 123.5 16 256c0 40.2 9.9 78 27.3 111.3c-5.3 1.5-10.6 3.1-15.5 4.8C10 337.3 0 297.8 0 256C0 114.6 114.6 0 256 0zm65.1 320.7c-34.1 34.1-71.4 61.6-109 81.8c53 20 114.9 8.8 157.3-33.6s53.6-104.3 33.6-157.3c-20.2 37.7-47.7 74.9-81.8 109zm-11.3-11.3c36.4-36.4 64.9-76.3 84.7-116.2c2.9-5.9 5.6-11.8 8.2-17.6c3.6 5.6 6.8 11.5 9.7 17.4c29.4 61.2 18.9 136.7-31.7 187.3s-126 61.1-187.3 31.7c-5.9-2.9-11.8-6.1-17.4-9.7c5.9-2.5 11.7-5.2 17.6-8.2c39.9-19.7 79.8-48.3 116.2-84.7zm-211-35.8l7.6-2.5 84.9-28.3 15.2-5.1-5.1 15.2-28.3 84.9-2.5 7.6-15.2-5.1 2.5-7.6L181.1 263l-69.7 23.2-7.6 2.5-5.1-15.2zM271 106.4l2.5-7.6 15.2 5.1-2.5 7.6L263 181.1l69.7-23.2 7.6-2.5 5.1 15.2-7.6 2.5-84.9 28.3-15.2 5.1 5.1-15.2L271 106.4zM27.6 425.4C12 441 12 467.1 28.4 483.6c16.4 16.5 42.2 16.4 57.7 .9c1.6-1.6 4.5-6.3 7.7-15.2c3-8.3 5.8-18.6 8.3-29.6c2.8-12.6 5.1-25.5 6.9-36.7c-11.2 1.7-24.2 4-36.8 6.7c-11 2.4-21.2 5.1-29.6 8.1c-8.9 3.2-13.5 6-15.1 7.6l0 0zm83.9-39.1c6.4-1 12.1-1.7 16.5-2.4c-.6 4.4-1.4 10.1-2.4 16.5c-4.8 31.3-14.1 81.1-28.1 95.2c-22 22.1-58 21.6-80.4-.9s-22.8-58.6-.9-80.7c14-14.1 63.9-23.1 95.3-27.8z'
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fast',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      'M0 0H8 72 376h64 8V16h-8H384V96v8h-8H72 64V96 16H8 0V0zM80 16V88H368V16H80zM64 152h8H376h8v16h-8H72 64V152zm0 64h8H440h8v16h-8H72 64V216zm0 64h8H376h8v16h-8H72 64V280zm0 64h8H376h8v16h-8H72 64V344zM8 512H0V496H8 64V416v-8h8H376h8v8 80h56 8v16h-8H376 72 8zm72-88v72H368V424H80z'
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fast',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      'M16 48V288H496V48H16zm0 256V464H496V304H16zM0 288V48 32H16 496h16V48 288v16V464v16H496 16 0V464 304 288zm320 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fast',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      'M16 16V432H624V16H16zM0 0H16 624h16V16 432v16H624 16 0V432 16 0zM104 496H536h8v16h-8H104 96V496h8zM560 80H80V368H560V80zM80 64H560h16V80 368v16H560 80 64V368 80 64H80zm336 36.5V112 264c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V123.5l-112 42V296c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V160v-5.5l5.2-1.9 128-48 10.8-4.1zM368 240c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM240 272c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fast',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M127.9 419.9c90.5 70.7 221.2 54.7 292-35.8s54.7-221.2-35.8-292C293.6 21.4 162.9 37.4 92.1 127.9L56 176H184h8v16h-8H40 32v-8V40 32H48v8V160l31.4-41.8 0 0 .1-.1C155.6 20.6 296.4 3.3 393.9 79.5s114.8 216.9 38.6 314.4s-216.9 114.8-314.4 38.6C93.4 413.2 73.9 389.8 59.7 364l14-7.7c13.2 24 31.3 45.7 54.3 63.7z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fast',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      'M93.8 98.4l-61.1 126L56.9 362.5l100.3 97.4 138 19.5 123.1-65.8 61.1-126L455.1 149.5 354.8 52.1l-138-19.5L93.8 98.4zM213.9 16L362.2 37 470 141.6l26 148.3L430.3 425.3 298.1 496 149.8 475 42 370.4 16 222.1 81.7 86.7 213.9 16zM164.7 363.3l-16-16L137.4 336l11.3-11.3 16-16L176 297.4l11.3 11.3 16 16L214.6 336l-11.3 11.3-16 16L176 374.6l-11.3-11.3zm16-16l6.6-6.6L192 336l-4.7-4.7-6.6-6.6L176 320l-4.7 4.7-6.6 6.6L160 336l4.7 4.7 6.6 6.6L176 352l4.7-4.7zM208 214.6l-11.3-11.3-16-16L169.4 176l11.3-11.3 16-16L208 137.4l11.3 11.3 16 16L246.6 176l-11.3 11.3-16 16L208 214.6zm11.3-33.9L224 176l-4.7-4.7-6.6-6.6L208 160l-4.7 4.7-6.6 6.6L192 176l4.7 4.7 6.6 6.6L208 192l4.7-4.7 6.6-6.6zM356.7 331.3l-16-16L329.4 304l11.3-11.3 16-16L368 265.4l11.3 11.3 16 16L406.6 304l-11.3 11.3-16 16L368 342.6l-11.3-11.3zm16-16l6.6-6.6L384 304l-4.7-4.7-6.6-6.6L368 288l-4.7 4.7-6.6 6.6L352 304l4.7 4.7 6.6 6.6L368 320l4.7-4.7z'
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fast',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm80 144h32v32H240V144zm-16-16v16 32 16h16 32 16V176 144 128H272 240 224zM152 248h-8v16h8H360h8V248h-8H152zm120 88v32H240V336h32zm-32-16H224v16 32 16h16 32 16V368 336 320H272 240z'
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fast',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM200 152h-8v16h8H308.7L170.3 306.3l-5.7 5.7L176 323.3l5.7-5.7L320 179.3V288v8h16v-8V160v-8h-8H200z'
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fast',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      'M166.6 496H345.4L496 345.4V166.6L345.4 16H166.6L16 166.6V345.4L166.6 496zM0 160L160 0H352L512 160V352L352 512H160L0 352V160z'
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fast',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      'M448 56l0-8-16 0 0 8 0 408L24 464l-8 0 0 16 8 0 416 0 8 0 0-8 0-416zM336 80l0-32-32 0 0 32 32 0zM144 80l0-32-32 0 0 32 32 0zm96-32l-32 0 0 32 32 0 0-32zM48 80l0-32L16 48l0 32 32 0zm0 160l-32 0 0 32 32 0 0-32zm0-64l0-32-32 0 0 32 32 0zm0 160l-32 0 0 32 32 0 0-32z'
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fast',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      'M16 16H304V144h16V16 0H304 16 0V16 464v16H16 224V464H16V16zM224 288H184h-8v8 64 8h8 40V352H192V304h32V288zm0-32h24 8v-8V184v-8h-8H184h-8v8 64 8h8 40zM72 176H64v8 64 8h8 64 8v-8V184v-8h-8H72zm8 64V192h48v48H80zm112-48h48v48H192V192zM72 64H64v8 64 8h8 64 8v-8V72 64h-8H72zm8 64V80h48v48H80zm96-64v8 64 8h8 64 8v-8V72 64h-8H184h-8zm16 16h48v48H192V80zM72 288H64v8 64 8h8 64 8v-8V296v-8h-8H72zm8 64V304h48v48H80zM338 176l-1.7 5.8L306 288H272 256v16V432v16 48 16h16 48 16V496 448H560v48 16h16 48 16V496 448 432 304 288H624 590L559.7 181.8 558 176h-6H344h-6zM272 304H624V432H576 560 336 320 272V304zM576 496V448h48v48H576zM320 448v48H272V448h48zM546 192l27.4 96H322.6L350 192H546zM352 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm224 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fast',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM352 84.5V96 248c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V107.5l-112 42V280c0 22.1-21.5 40-48 40s-48-17.9-48-40s21.5-40 48-40c12.3 0 23.5 3.9 32 10.2V144v-5.5l5.2-1.9 128-48L352 84.5zM304 224c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24zM176 256c-20.5 0-32 13.4-32 24s11.5 24 32 24s32-13.4 32-24s-11.5-24-32-24z'
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fast',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      'M8 0H152h8V16h-8H16V152v8H0v-8V8 0H8zM512 0V8 152v8H496v-8V16H360h-8V0h8H504h8zM192 96H320l12 32h68 16v16V368v16H400 112 96V368 144 128h16 68l12-32zm140 48H320.9L317 133.6 308.9 112H203.1L195 133.6 191.1 144H180 112V368H400V144H332zM304 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM0 512v-8V360v-8H16v8V496H152h8v16h-8H8 0zm504 0H360h-8V496h8H496V360v-8h16v8V504v8h-8z'
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fast',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      'M176 16c16.2 0 31.1 6 42.3 16C231.6 43.7 240 60.9 240 80c-35.3 0-64-28.7-64-64zm112 0c16.2 0 31.1 6 42.3 16C343.6 43.7 352 60.9 352 80c-35.3 0-64-28.7-64-64zm112 0c16.2 0 31 6 42.3 16C455.6 43.7 464 60.9 464 80c-35.3 0-64-28.7-64-64zm64 128c0 19.1-8.4 36.3-21.7 48c-11.3 10-26.1 16-42.3 16c0-35.3 28.7-64 64-64zm-112 0c0 19.1-8.4 36.3-21.7 48c-11.3 10-26.1 16-42.3 16c0-35.3 28.7-64 64-64zm-112 0c0 19.1-8.4 36.3-21.7 48c-11.3 10-26.1 16-42.3 16c0-35.3 28.7-64 64-64zM160 0V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80H160zM272 0V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80H272zM400 0H384V16c0 44.2 35.8 80 80 80h16V80c0-44.2-35.8-80-80-80zm80 128H464c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128zm-128 0c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128H352zm-96 0H240c-44.2 0-80 35.8-80 80v16h16c44.2 0 80-35.8 80-80V128zM40 32H32V48h8 80 8V32h-8H40zM8 104H0v16H8 152h8V104h-8H8zm24 72v16h8 80 8V176h-8H40 32zm40 96c0 30.9-25.1 56-56 56V272H72zM16 424V344c39.8 0 72-32.2 72-72H424c0 39.8 32.2 72 72 72v80c-39.8 0-72 32.2-72 72H88c0-39.8-32.2-72-72-72zm480-96c-30.9 0-56-25.1-56-56h56v56zM440 496c0-30.9 25.1-56 56-56v56H440zM16 440c30.9 0 56 25.1 56 56H16V440zm192-56a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM16 256H0v16V496v16H16 496h16V496 272 256H496 16z'
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fast',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      'M264 8l0-8H248l0 8 0 240L8 248H0v16l8 0 240 0 0 240v8h16v-8l0-240 240 0 8 0 0-16-8 0-240 0L264 8z'
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fast',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      'M528.1 512l-20.3-16H416V423.5l-16-12.6V496H336 144V372c35.3 27.6 79.7 44 128 44c36.7 0 71.3-9.5 101.2-26.2l-13.7-10.8c-26.2 13.5-56 21.1-87.5 21.1C166 400 80 314 80 208c0-15.7 1.9-30.9 5.4-45.5L71.7 151.7c-5 17.9-7.7 36.8-7.7 56.3c0 59 24.6 112.2 64 150.1V504v8h8H336h72 8H528h.1zM480 208C480 93.1 386.9 0 272 0c-42.8 0-82.6 12.9-115.6 35.1l13.3 10.5C199.3 26.8 234.4 16 272 16c106 0 192 86 192 192c0 21.7-3.6 42.5-10.2 61.9l13.3 10.5c8.4-22.5 12.9-46.9 12.9-72.4zM349.3 187.4c-8.9-33.6-39.1-58.5-75.2-59.4l75.2 59.4zM219.8 268.7c1.7 1.5 3.5 2.9 5.3 4.2l-5.3-4.2zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fast',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      'M433 220.4L447.5 176H499l60.2 191.9L517.8 496H428.6l-20.4-59.7c-3.6 5.5-7.4 10.8-11.5 15.9L417.2 512H529.4L576 368 513.3 168l22-86c1.4-5.3 2-10.8 2-16.2V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.7c0 5.5 .7 10.9 2 16.2l22 86-9.8 30.2c3.6 7.2 6.7 14.6 9.6 22.2zM498.8 160H447.8L426.9 78c-1-4-1.5-8.1-1.5-12.3V64c0-26.5 21.5-48 48-48s48 21.5 48 48v1.7c0 4.1-.5 8.3-1.5 12.3l-20.9 82zM208 112a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm16-240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fast',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M165.7 469.7l-5.7 5.7-5.7-5.7-112-112L36.7 352 48 340.7l5.7 5.7L152 444.7V40 32h16v8V444.7l98.3-98.3 5.7-5.7L283.3 352l-5.7 5.7-112 112zM344 288H488h8v8 8 3.1l-2.1 2.3L354.8 464H488h8v16h-8H344h-8v-8-8-3.1l2.1-2.3L477.2 304H344h-8V288h8zm17.8-112l-22.3 48H321.9L408.7 36.6l2.2-4.6h10.2l2.1 4.6L510.1 224H492.5l-22.3-48H361.8zm101.1-16L416 59 369.2 160h93.6z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fast',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      'M325.7 69.7l5.7-5.7L320 52.7l-5.7 5.7L160 212.7 85.7 138.3 80 132.7 68.7 144l5.7 5.7 80 80 5.7 5.7 5.7-5.7 160-160zm112 112l5.7-5.7L432 164.7l-5.7 5.7L160 436.7 21.7 298.3 16 292.7 4.7 304l5.7 5.7 144 144 5.7 5.7 5.7-5.7 272-272z'
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fast',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM76.1 176H179.9l54.9 192H192 144 112 64 21.2L76.1 176zM120 384h16V504v8h8 48 8v-8V384h39.4H256h16.6H312V504v8h8 48 8v-8V384h16V504v8h8 48 8v-8V384h39.4H512l-4.6-16L448 160H320L260.6 368 256 384l-4.6-16L192 160H64L4.6 368 0 384H16.6 56V504v8h8 48 8v-8V384zm64 112H152V384h32V496zM104 384V496H72V384h32zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-51.9 48H435.9l54.9 192H448 400 368 320 277.2l54.9-192zM440 496H408V384h32V496zM360 384V496H328V384h32z'
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fast',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      'M143 0h-1.5H136 104 56 48V8 197.8L1.1 275.9 0 277.8V280 504v8H8 160V496H16V282.2l46.9-78.1 1.1-1.9V200 16h40 26.4l64.1 172.7 8.7-22.6L154.9 35.8c.7 .7 1.5 1.4 2.3 2.1C171.4 50.9 193.5 64 224 64s52.6-13.1 66.9-26.1l.9-.8L192.6 285l-.6 1.4V288 504v8h8H440h8v-8V280v-2.2l-1.1-1.9L400 197.8V8 0h-8H344 312h-5.4H305h-4.9l-2.2 4.3 0 0 0 0 0 0 0 0 0 0 0 0-.2 .3c-.2 .3-.4 .7-.8 1.3c-.7 1.2-1.8 2.9-3.3 4.9c-3 4.1-7.5 9.7-13.6 15.2C267.9 37.1 249.5 48 224 48s-43.9-10.9-56.1-21.9c-6.1-5.5-10.6-11.1-13.6-15.2c-1.5-2.1-2.6-3.8-3.3-4.9c-.3-.6-.6-1-.8-1.3l-.2-.3 0 0 0 0 0 0 0 0L147.9 0H143zm65 289.5L317.4 16H344h40V200v2.2l1.1 1.9L432 282.2V496H208V289.5zM80 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM88 236.7L76.7 248l5.7 5.7L100.7 272 82.3 290.3 76.7 296 88 307.3l5.7-5.7L112 283.3l18.3 18.3 5.7 5.7L147.3 296l-5.7-5.7L123.3 272l18.3-18.3 5.7-5.7L136 236.7l-5.7 5.7L112 260.7 93.7 242.3 88 236.7zM320 256c-17.7 0-32 14.3-32 32v8 48 8h8 48 8c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16v8 8h8 8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8H304V296v-8z'
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fast',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      'M80 48H560V352h16V48 32H560 80 64V48 352H80V48zM16 425.4V400H624v25.4L585.4 464H54.6L16 425.4zM624 384H16 0v16 32l48 48H592l48-48V400 384H624zM176 120h-8v8 96 8h8 64 8v-8V128v-8h-8H176zm8 96V136h48v80H184zm120-96h-8v16h8 8v88 8h16v-8V128v-8h-8H304zm88 0v8 96 8h8 64 8v-8V128v-8h-8H400h-8zm16 16h48v80H408V136zM192 280h-8v16h8 8v56h16V288v-8h-8H192zm248 8v-8h-8H416h-8v16h8 8v56h16V288zm-80 0v-8h-8H288h-8v8 64h16V296h48v56h16V288z'
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fast',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      'M16.1 512H0l1.5-16L32 160 288 0 544 176l30.5 320 1.5 16H559.9 16.1zM280 496V23.9L47.2 169.4 17.5 496H280zm16 0H426.6L296 255.5V496zm148.8 0H558.4L528.8 185 296 24.9V222L444.8 496z'
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fast',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      'M224 16C109.1 16 16 109.1 16 224c0 81.1 51.8 149.1 106.7 198.1c27.2 24.3 54.4 43.2 74.9 56.2c10.2 6.5 18.7 11.4 24.6 14.6l1.8 1 1.8-1c5.9-3.3 14.4-8.2 24.6-14.6c20.5-12.9 47.7-31.9 74.9-56.2C380.2 373.1 432 305.1 432 224c0-114.9-93.1-208-208-208zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 176-224 288-224 288S0 400 0 224zm368 0H336c-44.2 0-80 35.8-80 80h32c44.2 0 80-35.8 80-80zm-32-16h32 16v16c0 53-43 96-96 96H256 240V304c0-53 43-96 96-96zM112 224H80c0 44.2 35.8 80 80 80h32c0-44.2-35.8-80-80-80zm96 80v16H192 160c-53 0-96-43-96-96V208H80h32c53 0 96 43 96 96z'
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fast',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      'M184 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 168 56a56 56 0 1 0 112 0zM136 248v-8H120v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H248v8V496H216V344v-8h-8H176h-8v8V496H136V248zm224 88c13.3 0 24 10.7 24 24V504v8h16v-8V360c0-22.1-17.9-40-40-40s-40 17.9-40 40v16 8h16v-8V360c0-13.3 10.7-24 24-24zM132.9 128c-3.1 0-5.9 1.8-7.2 4.5l-84.9 176-3.5 7.2 14.4 7 3.5-7.2L137.9 144H246.8l98.5 148.4 4.4 6.7 13.3-8.9-4.4-6.7-100.9-152c-1.5-2.2-4-3.6-6.7-3.6H132.9z'
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fast',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      'M568 16h8V0h-8C434.5 0 319.1 77.9 264.9 190.7c4.4 3.4 8.5 7.1 12.5 11C328.2 92.1 439.2 16 568 16zM447.8 292c17.9-49 65-84 120.2-84h8V192h-8c-54.5 0-101.9 30.2-126.3 74.8c2.8 8 4.7 16.4 5.7 25l.4 .1zm-76-94.1c5.2 1.8 10.3 3.9 15.1 6.4C427.6 148.3 493.6 112 568 112h8V96h-8c-81.1 0-152.8 40.2-196.3 101.8zM400 320v16h16c44.2 0 80 35.8 80 80v80H416 96 16V416c0-34.8 22.2-64.5 53.3-75.5L80 336.8V325.5 304c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4c12.5-8.2 27.5-12.9 43.7-12.9c44.2 0 80 35.8 80 80zM0 512H16 96 416h80 16V496 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112v21.5C26.7 338.6 0 374.2 0 416v80 16z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fast',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      'M264 8V0H248V8 48.2C139.5 52.3 52.3 139.5 48.2 248H8 0v16H8 48.2C52.3 372.5 139.5 459.7 248 463.8V504v8h16v-8V463.8c108.5-4.1 195.7-91.3 199.8-199.8H504h8V248h-8H463.8C459.7 139.5 372.5 52.3 264 48.2V8zM120 264h8V248h-8H64.2C68.2 148.3 148.3 68.2 248 64.2V120v8h16v-8V64.2c99.7 4.1 179.8 84.2 183.8 183.8H392h-8v16h8 55.8c-4.1 99.7-84.2 179.8-183.8 183.8V392v-8H248v8 55.8C148.3 443.8 68.2 363.7 64.2 264H120zm112-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      'M528 208c0 100.7-77.4 183.2-176 191.3v1.7c0 5-.5 9.8-1.5 14.5c48.8-3.4 93-23.6 126.8-54.9L627.9 511.3l11.3-11.3L488.6 349.3C523 312.2 544 262.6 544 208C544 93.1 450.9 0 336 0C227.9 0 139.1 82.5 129 187.9l16.7-5.6C158.3 88.4 238.7 16 336 16c106 0 192 86 192 192zM320 156.8l-10.5 3.5-192 64-5.5 1.8v5.8 72V432.3c-11.7-10-28.9-16.3-48-16.3c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-.1 0-.1V309.7L304 251V368.2c-11.7-10-28.9-16.2-48-16.2c-35.3 0-64 21.5-64 48s28.7 48 64 48c35.2 0 63.7-21.3 64-47.6l0-.2v-.2-160-72V156.8zm-28.3 222c8.6 6.4 12.3 14.1 12.3 21.1s-3.8 14.7-12.3 21.1s-21.1 10.9-35.7 10.9s-27.1-4.4-35.7-10.9s-12.3-14.1-12.3-21.1s3.8-14.7 12.3-21.1s21.1-10.9 35.7-10.9s27.1 4.4 35.7 10.9zM128 292.8V237.7L304 179v55.1L128 292.8zM112 464.1c0 7.1-3.8 14.7-12.3 21.1s-21.1 10.9-35.7 10.9s-27.1-4.4-35.7-10.9S16 471.2 16 464.1s3.8-14.7 12.3-21.1s21.1-10.9 35.7-10.9s27.1 4.4 35.7 10.9s12.3 14.1 12.3 21.1z'
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fast',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      'M16 16V400H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V16H16zM64.4 416H16 0V400 16 0H16 400h16V16 96h72 3.3l2.3 2.3 112 112 2.3 2.3V216 400h24 8v16h-8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588.7l-104-104H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fast',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M16 144H496V122.5L256 17.5 16 122.5V144zM0 112L256 0 512 112v32 16H496 16 0V144 112zm80 88V368H184V200v-8h16v8V368H312V200v-8h16v8V368H432V200v-8h16v8V376v8h-8H328 312 200 184 72 64v-8V200v-8H80v8zM40 432H472h8v16h-8H40 32V432h8zM8 496H504h8v16h-8H8 0V496H8z'
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fast',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H496V204.8L288 26.5zM224 184H352h8v8V320v8h-8H224h-8v-8V192v-8h8zm8 128H344V200H232V312z'
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fast',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      'M80 256C80 123.5 187.5 16 320 16s240 107.5 240 240v96H536.1c-.1 0-.1 0-.2 0H520h-8v16h8 8.8l14.2 128H536v16h8 7.9c.1 0 .1 0 .2 0h31.8c.1 0 .1 0 .2 0H592h8V496h-7.1l14.2-128H616h8V352h-8H600.1c-.1 0-.1 0-.2 0H576V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c59.2 0 113.7-20.1 157.1-53.8l-9.8-12.6C426.6 477.2 375.5 496 320 496C187.5 496 80 388.5 80 256zM591.1 368L576.8 496H559.2L544.9 368h46.1zM320 408a152 152 0 1 1 0-304 152 152 0 1 1 0 304zM152 256a168 168 0 1 0 336 0 168 168 0 1 0 -336 0zm232 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-64-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fast',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      'M80 64a48 48 0 1 1 96 0A48 48 0 1 1 80 64zm112 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM40.7 336l6.7-160h121c.5-5.5 1.5-10.8 3-16H32L24.7 336 24 352H40 56V504v8h8 48 8v-8V352h16V504v8h8 32V496H152V352h8V336H144 112 64 40.7zM376 512v-8V352h16V504v8h8 48 8v-8V352h16 16l-.7-16L480 160H340.7c1.5 5.2 2.5 10.5 3 16h121l6.7 160H448 400 368 352v16h8V496H336v16h32 8zM72 352h32V496H72V352zM336 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 320 64a64 64 0 1 0 128 0zm-8 288V496H408V352h32zM256 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM208 416v88 8h16v-8V416h64v88 8h16v-8V416h16 16V400 272 256H320 192 176v16V400v16h16 16zM320 272V400H304 288 224 208 192V272H320z'
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fast',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      'M16 16H0v8V184c0 22.1 17.9 40 40 40H64V488v8H80v-8V224h24c22.1 0 40-17.9 40-40V24 16H128v8V184c0 13.3-10.7 24-24 24H80V24 16H64v8V208H40c-13.3 0-24-10.7-24-24V24 16zM498 78.9C455.3 39.8 398.4 16 336 16c-61.5 0-117.5 23.1-160 61.1V99.2C216.7 57.7 273.3 32 336 32c60.3 0 115 23.8 155.3 62.5c2-5.5 4.3-10.7 6.7-15.6zm40.6 272.9C502.6 427.6 425.4 480 336 480c-91.4 0-170.1-54.8-204.9-133.3c-4.9 2-10.1 3.5-15.6 4.4C152.4 436.3 237.2 496 336 496c98.4 0 183-59.2 220-144H544c-1.8 0-3.7-.1-5.4-.2zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-272 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM624 21.2C589.7 34.1 512 72.8 512 160V304v16h16 96V488v8h16v-8V320v-8-8V32.6 16s-6.3 1.6-16 5.2zm0 17.2V304H528V160c0-48.8 27.6-80.5 57.1-100.8C599 49.6 613 42.8 624 38.4z'
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fast',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      'M368 16v96H16V16H368zM16 0H0V16v96 16H16 368h16V112 16 0H368 16zM32 160V496v16H48 336h16V496 160H336V496H48V160H32zm133.3 33.3h-8v8 52h-52-8v8 53.3 8h8 52v52 8h8 53.3 8v-8-52h52 8v-8V261.3v-8h-8-52v-52-8h-8H165.3zm8 68v-52h37.3v52 8h8 52v37.3h-52-8v8 52H173.3v-52-8h-8-52V269.3h52 8v-8z'
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fast',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      'M64 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM16 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm48 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM16 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM176 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM528 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-48 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fast',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16 .7c-5.3-.5-10.6-.7-16-.7H16V496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 192 176 80 64H16h96V8 0h16zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm8 64v8 64h48 8v16h-8H432h-8v-8V296v-8h16z'
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fast',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      'M16 224a208 208 0 1 1 416 0A208 208 0 1 1 16 224zm416 83.3V496H16V307.3C49.1 389.8 129.7 448 224 448s174.9-58.2 208-140.7zM0 224V504v8H8 440h8v-8V224C448 100.3 347.7 0 224 0S0 100.3 0 224zM232 96H216v8V224v3.3l2.3 2.3 56 56 5.7 5.7L291.3 280l-5.7-5.7L232 220.7V104 96z'
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fast',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM333.7 285.7l5.7-5.7L328 268.7l-5.7 5.7L208 388.7l-66.3-66.3-5.7-5.7L124.7 328l5.7 5.7 72 72 5.7 5.7 5.7-5.7 120-120z'
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fast',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      'M249.3 0H256h64 6.7l1.1 6.7L336.3 56H384V40 32h16v8V88h8 8v16h-8-8v48 8H384v-8V136H350l8.2 48H474.3c18.9 0 43.7 7.8 63.8 20c10.1 6.1 19.4 13.6 26.3 22.2s11.6 18.7 11.6 29.8c0 22.5-18.2 40.5-37.9 52.4C518 320.4 493.1 328 474.3 328l-116.1 0L350 376h34V360v-8h8 8v8 48h8 8v8 8h-8-8v48 8h-8-8v-8V456H336.3l-8.4 49.3-1.1 6.7H320 256h-6.7l-1.1-6.7L239.7 456H192h-8v-8V384v-8h8 34l-8.9-52.1L135.2 313l-15.4 64.8-1.5 6.1H112 64 57.6l-1.4-6.2L38.7 300.2l0 0C16.5 297.2 0 278.3 0 256s16.5-41.2 38.7-44.2l0 0 17.5-77.6 1.4-6.2H64h48 6.3l1.5 6.1L135.2 199l81.9-10.9L226 136H192h-8v-8V64 56h8 47.7l8.4-49.3L249.3 0zm98 120H384V104 88 72H339.1l8.2 48zM236.9 72H200v48h28.7l8.2-48zM339.1 440H384V424 408 392H347.3l-8.2 48zM228.7 392H200v48h36.9l-8.2-48zM313.3 16H262.7l-29 169.8 13.2-1.8 .5-.1h.5 94L313.3 16zM248 328h-.5l-.5-.1-13.2-1.8 29 169.8h50.5L342 328H248zM70.4 144L53.1 220.8l-1.2 5.4-5.5 .7-5.6 .7C26.6 229.6 16 241.7 16 256s10.6 26.4 24.8 28.3l5.6 .7 5.5 .7 1.2 5.4L70.4 368h35.3l15.7-65.7 1.7-7 7.2 1L248.5 312l225.8 0c15.3 0 37.4-6.4 55.5-17.4C548.5 283.5 560 269.5 560 256c0-6.4-2.7-13.1-8.1-19.8s-13.1-13-22.1-18.5c-18.2-11.1-40.2-17.7-55.5-17.7H248.5L130.2 215.8l-7.2 1-1.7-7L105.7 144H70.4z'
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fast',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      'M432 48H16V464H228c-.9 5.3-1.6 10.6-2.2 16H16 0V464 48 32H16 432h16V48 231.1c-5.4 1.2-10.7 2.6-16 4.1V48zm-64 72V262.5c-5.4 3.2-10.8 6.5-16 10V128H232v88.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V120v-8h8H360h8v8zM246.6 400H88 80v-8V120v-8h8 64 8v16h-8H96V384H253.9c-2.6 5.2-5.1 10.6-7.3 16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm288 40c-132.5 0-240 107.5-240 240H256c0-141.4 114.6-256 256-256v16zM464 480a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm48 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM368 512H352c0-88.4 71.6-160 160-160v16c-79.5 0-144 64.5-144 144z'
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fast',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      'M296.5 25.9l55.1 169.7H530h27.2l-22 16L390.9 316.4 446 486.1l8.4 25.9-22-16L288.1 391.1 143.7 496l-22 16 8.4-25.9 55.1-169.7L40.9 211.6l-22-16H46.1 224.5L279.6 25.9 288.1 0l8.4 25.9zm55.1 185.7H340l-3.6-11.1L296 76.2V377.1l1.5 1.1L424 470.1 375.7 321.4l-3.6-11.1 9.4-6.8L508 211.6H351.6zM280 76.6L239.7 200.5l-3.6 11.1H224.5 68.1l126.5 91.9 9.4 6.8-3.6 11.1L152.1 470.1l126.5-91.9 1.3-1V76.6z'
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fast',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      'M96 74l.6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 129.8 169.5 144 192 144s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 129.8 361.5 144 384 144s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 129.8 553.5 144 576 144v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 142.2 28.7 160 0 160V144c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0L96 74zm0 288l.6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 417.8 169.5 432 192 432s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 417.8 361.5 432 384 432s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 417.8 553.5 432 576 432v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 430.2 28.7 448 0 448V432c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9zM96.6 219c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 273.8 169.5 288 192 288s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 273.8 361.5 288 384 288s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 273.8 553.5 288 576 288v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 286.2 28.7 304 0 304V288c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9z'
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fast',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      'M441.1 64H455l.9 7 41.3 316.3 38.9-220.6 1.2-6.6h12.9l1.6 5.9L582.1 280H632h8v16h-8H576h-6.1l-1.6-5.9-22.7-85L503.9 441.4l-1.2 6.6H489l-.9-7L447.5 130 391.9 505.2l-1 6.8H377l-.9-7L320 70.5 263.9 505l-.9 7H249.1l-1-6.8L192.5 130 151.9 441l-.9 7H137.3l-1.2-6.6L94.4 205l-22.7 85L70.1 296H64 8 0V280H8 57.9L88.3 165.9l1.6-5.9h12.9l1.2 6.6 38.9 220.6L184.1 71l.9-7h13.9l1 6.8 55.5 374.9L312.1 7l.9-7H327l.9 7 56.6 438.7L440.1 70.8l1-6.8z'
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fast',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      'M296 64h-8V80h8 51.8L449.1 227.8 380 320H352.8L157.3 278.1C140.6 264.3 119.3 256 96 256c-8.9 0-17.5 1.2-25.7 3.5L17.7 248.2l-7.8-1.7L6.5 262.1l7.8 1.7 31 6.6C18.1 287.4 0 317.6 0 352c0 53 43 96 96 96s96-43 96-96c0-19.9-6-38.3-16.3-53.6l88.5 19c5 10.5 7.9 22.2 7.9 34.6c0 44.2-35.8 80-80 80c-11.9 0-23.2-2.6-33.3-7.3c-4.5 3.9-9.4 7.4-14.7 10.4c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-10.7-1.8-21-5-30.6l67.3 14.4 .8 .2h.8 32 4l2.4-3.2 68.3-91.1 24.6 35.9C461.8 295.2 448 322 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-17.3 0-33.5 4.6-47.5 12.6L358.6 67.5 356.2 64H352 296zM464 352c0-24.5 11-46.4 28.4-61.1l45 65.6 4.5 6.6 13.2-9-4.5-6.6-45-65.7c11.4-6.3 24.5-9.8 38.4-9.8c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80zm-288.1 .1A80 80 0 1 1 16 352a80 80 0 1 1 159.9 .1zM55.5 109.3l-2.7-7.5-15 5.5 2.7 7.5 32 88 1.5 4.1 4.3 .9 112 24.8 7.8 1.7 3.5-15.6-7.8-1.7L86 193.1 55.5 109.3z'
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fast',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM168 368h8 64 8v16h-8H184v48h40 8v16h-8H184v48h56 8v16h-8H176h-8v-8V440 376v-8zm136 0h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40 8H296v-8V456 376v-8h8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64h24zm117.7-80H480h8v16h-8H453.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H424h-8V496h8 34.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C424.1 433 416 419.9 416 405.7c0-20.8 16.9-37.7 37.7-37.7z'
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fast',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      'M224 112l64-85.3L352 112c10.4 13.8 16 30.7 16 48c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-17.3 5.6-34.2 16-48zm-12.8-9.6C198.7 119 192 139.2 192 160c0 53 43 96 96 96s96-43 96-96c0-20.8-6.7-41-19.2-57.6L298 13.3 288 0 278 13.3l-66.8 89.1zM151.6 320h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fast',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM288 192H272v8V304H139.9l72-176H194.6l-74 181-4.5 11H128 272v56 8h16v-8V320h24 8V304h-8H288V200v-8z'
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fast',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      'M280 0h16V48h80 6.7l1.2 6.6 60.3 339c-5 3.3-9.7 6.2-14.7 8.8L412 304H164l-17.5 98.4c-5-2.6-9.7-5.5-14.7-8.8l60.3-339 1.2-6.6H200h80V0zM166.9 288H409.1L369.3 64H206.7L166.9 288zM96.6 427c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 481.8 553.5 496 576 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 494.2 28.7 512 0 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9z'
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fast',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M160 475.3l5.7-5.7 112-112 5.7-5.7L272 340.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L53.7 346.3 48 340.7 36.7 352l5.7 5.7 112 112 5.7 5.7zM368 32V48h8 48V208H376h-8v16h8 56 56 8V208h-8H440V40 32h-8H376h-8zm60 240c36.9 0 67 29.4 68 66.1c-.2 9.2-1.8 18.3-4.7 26.9c-10 25.2-34.5 43-63.2 43c-37.6 0-68-30.4-68-68s30.4-68 68-68zm0 152c9.2 0 18-1.5 26.3-4.2L405.7 480h20.6l62-76.7c7.9-9.8 14-20.9 18-32.6c3.7-9.5 5.8-19.8 5.8-30.6c0-.6 0-1.3 0-1.9c0-.7 0-1.4 0-2.1h-.1c-2.1-44.5-38.9-80-83.9-80c-46.4 0-84 37.6-84 84s37.6 84 84 84z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fast',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      'M8 32H0V48H8 32V256c0 70.7 57.3 128 128 128v80H40 32v16h8H632h8v-8V392v-8H624v8 72H432V384h16c70.7 0 128-57.3 128-128V112h24 8V96h-8H576 560h-8-8H480 464v16V224v16H448 407c-83.1 0-159.6-45.7-199-118.9C178.4 66.2 121.1 32 58.8 32H56 48 32 8zM416 464H176V384H416v80zM552 112h8V256c0 61.9-50.1 112-112 112H160C98.1 368 48 317.9 48 256V48h8 2.8c56.5 0 108.4 31 135.2 80.7C236.1 207.1 318 256 407 256h57 16V240 112h64 8z'
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fast',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      'M264 8V120v8H248v-8V8 0h16V8zM146 176h6H360h6l1.7 5.8L398 288h34 16v16V432v16 48 16H432 384 368V496 448H144v48 16H128 80 64V496 448 432 304 288H80h34l30.3-106.2L146 176zM80 304V432h48 16H368h16 48V304H80zM384 496h48V448H384v48zM128 448H80v48h48V448zM354 192H158l-27.4 96H381.4L354 192zM128 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM40 28.7l5.7 5.7 80 80 5.7 5.7L120 131.3l-5.7-5.7-80-80L28.7 40 40 28.7zm426.3 5.7l5.7-5.7L483.3 40l-5.7 5.7-80 80-5.7 5.7L380.7 120l5.7-5.7 80-80z'
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fast',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      'M302.5 35.3l-1.8 23.1-1.3 17.5L315.9 70 492.5 7 512 0l-7 19.5L442 196.1l-5.9 16.5 17.5-1.3 23.1-1.8L496 208l-9.7 16.8L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L287.2 25.7 304 16l-1.5 19.3zM304.8 91l-23.2 8.3 1.9-24.6 2.3-29.6L109.3 147.2C51.6 180.6 16 242.3 16 309c0 103.3 83.7 187 187 187c66.7 0 128.4-35.6 161.8-93.3L466.9 226.3l-29.6 2.3-24.6 1.9 8.3-23.2L485.6 26.4 304.8 91zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM304 320A112 112 0 1 0 80 320a112 112 0 1 0 224 0zM192 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fast',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      'M0 0H8 64h6.2l1.6 6 69.4 266h341L557.6 32h16.8L495.6 282.4l-1.8 5.6H488 145.3l20.9 80H496h8v16h-8H160h-6.2l-1.6-6L57.8 16H8 0V0zM208 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM312 232V59.3l-66.3 66.3-5.7 5.7L228.7 120l5.7-5.7 80-80 5.7-5.7 5.7 5.7 80 80 5.7 5.7L400 131.3l-5.7-5.7L328 59.3V232v8l-16 0v-8z'
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fast',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM208 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 72a8 8 0 1 0 0-16 8 8 0 1 0 0 16zm0-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM215.8 109.6v10c0 42.8-51.7 64.2-81.9 33.9l-7.1-7.1-11.3 11.3 7.1 7.1c30.2 30.2 8.8 81.9-33.9 81.9h-10v16h10c42.8 0 64.2 51.7 33.9 81.9l-7.1 7.1 11.3 11.3 7.1-7.1c30.2-30.2 81.9-8.8 81.9 33.9v10h16v-10c0-42.8 51.7-64.2 81.9-33.9l7.1 7.1 11.3-11.3-7.1-7.1c-30.2-30.2-8.8-81.9 33.9-81.9h10v-16H359c-42.8 0-64.2-51.7-33.9-81.9l7.1-7.1-11.3-11.3-7.1 7.1c-30.2 30.2-81.9 8.8-81.9-33.9v-10h-16zm105 14.3l11.3 11.3 11.3 11.3 11.3 11.3-11.3 11.3-7.1 7.1c-20.2 20.2-5.9 54.6 22.6 54.6h10 16v16 16 16h-16H359c-28.5 0-42.8 34.5-22.6 54.6l7.1 7.1 11.3 11.3-11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3-7.1-7.1c-20.2-20.2-54.6-5.9-54.6 22.6v10 16h-16-16-16v-16-10c0-28.5-34.5-42.8-54.6-22.6l-7.1 7.1-11.3 11.3-11.3-11.3-11.3-11.3L92.9 351.9l11.3-11.3 7.1-7.1c20.2-20.2 5.9-54.6-22.6-54.6h-10-16v-16-16-16h16 10c28.5 0 42.8-34.5 22.6-54.6l-7.1-7.1L92.9 157.8l11.3-11.3 11.3-11.3 11.3-11.3 11.3 11.3 7.1 7.1c20.2 20.2 54.6 5.9 54.6-22.6v-10-16h16 16 16v16 10c0 28.5 34.5 42.8 54.6 22.6l7.1-7.1 11.3-11.3z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fast',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M352 32l21.3 64H496h16v16V464v16H496 16 0V464 112 96H16 138.7L160 32H352zm21.3 80H361.8l-3.6-10.9L340.5 48H171.5l-17.7 53.1L150.2 112H138.7 16V464H496V112H373.3zM256 176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm96 112a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fast',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      'M496 256v4.8l2.7 4L546.1 336H29.9l47.4-71.1 2.7-4V256 48H496V256zM19.2 352H24 552h4.8l3.2 4.8V464H16V356.8l3.2-4.8zM576 464V352l-64-96V48 32H496 80 64V48 256L0 352V464v16H16 560h16V464zM392 96h-8v8 48 8h8 48 8v-8V104 96h-8H392zm8 16h32v32H400V112zm-32 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM104 400H96v16h8H472h8V400h-8H104z'
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fast',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      'M176 0c37.1 0 70 18.9 90.3 48.1c.4 .6 .8 1.2 1.3 1.8c.5-.3 1-.7 1.5-1c14.8-9.7 32.2-15.3 50.9-15.3c53 0 96 45.1 96 100.8c53 0 96 45.1 96 100.8V320v16H496 416 378.4l2.9-14.4-1.6-1.6H416h80V235.2c0-47.6-36.5-84.8-80-84.8H400v-16c0-47.6-36.5-84.8-80-84.8c-16 0-30.8 4.9-43.4 13.5l-13.3 9.1-9-13.4C236.8 32.7 208.1 16 176 16c-52.3 0-96 44.7-96 101.6v22.5 11.1l-10.4 3.9C38.7 166.6 16 197.8 16 235.2V320H96h36.4l-1.6 1.6 2.9 14.4H96 16 0V320 235.2c0-43.9 26.7-81.2 64-95.1V117.6C64 52.7 114.1 0 176 0zm11.8 437.9l-4.9 24.7 10.5 10.5 24.7-4.9 10.5-2.1 5.9 8.9 14 21h14.9l14-21 5.9-8.9 10.5 2.1 24.7 5 10.5-10.5-5-24.7-2.1-10.5 8.9-5.9 21-14V392.6l-21-14-8.9-5.9 2.1-10.5 4.9-24.7-10.5-10.5-24.7 5-10.5 2.1-5.9-8.9-14-21H248.6l-14 21-5.9 8.9-10.5-2.1-24.7-5-10.5 10.5 4.9 24.7 2.1 10.5-8.9 5.9-21 14v14.9l21 14 8.9 5.9-2.1 10.5zM144 384l28.1-18.7-6.6-33.1 22.6-22.6 33.1 6.6L240 288h32l18.7 28.1 33.1-6.6 22.6 22.6-6.6 33.1L368 384v32l-28.1 18.7 6.6 33.1-22.6 22.6-33.1-6.6L272 512H240l-18.7-28.1-33.1 6.6-22.6-22.6 6.6-33.1L144 416V384zM80 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 416a48 48 0 1 1 96 0A48 48 0 1 1 0 416zm464 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fast',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm88.3-270.8l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 304.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm-3.4 18.9l-7.7-7.4c-8.5-8.2-19.8-12.7-31.6-12.7h-2.4c-23.9 0-43.2 19.3-43.2 43.2c0 11.7 4.8 23 13.2 31.1L256 281.9l82.8-79.6c8.5-8.1 13.2-19.4 13.2-31.1c0-23.9-19.3-43.2-43.2-43.2h-2.4c-11.8 0-23.1 4.6-31.6 12.7l-7.7 7.4L256 158.8l-11.1-10.7z'
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fast',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      'M281.4 378.7l12.8-51.8 14.7 7.3-8.6 35 81.6-41.1 11.8-6 8.1 10.5L457.3 405 476 315.6l2.7-13 13.2 .2 91.3 1.6-58.2-70.4L516.6 224l8.4-10.2 58.2-70.4L492 145.1l-13.2 .2-2.7-13L457.3 43l-41 53.4-14.6-7.3L453 22.3 465.8 5.6l4.3 20.6 21.5 102.8 105-1.9 21.1-.4-13.4 16.2-67 80.9 67 80.9 13.4 16.2-21.1-.4-105-1.9L470.2 421.7l-4.3 20.6L453 425.7l-64-83.3-93.8 47.3-18.8 9.5 5.1-20.5zM21.5 136.8L312.8 282.5l73.7-147.4L180.2 32H73.9L21.5 136.8zm-7.2 14.3L0 144l7.2-14.3L64 16H184L393.7 120.8 408 128l-7.2 14.3L327.2 289.7 320 304l-14.3-7.2L14.3 151.2zm94.8 83.2l14.3 7.2L21.5 445.4 78.8 474 180.7 270.1l14.3 7.2L93.1 481.1l-7.2 14.3-14.3-7.2L14.4 459.7 .1 452.5l7.2-14.3L109.2 234.4z'
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fast',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      'M288 0h-1.3l-1.2 .4-224 72L56 74.2V80 288H16 0v16V496v16H16h96 16V496 304 288H112 72V85.8L289.3 16H344V152v8h16v-8V8 0h-8H288zM16 304h96V496H16V304zm336-97.1l-3.8 2.1C318.1 225.4 256 270.7 256 352c0 33 14.5 73.3 56.1 106l-25.6 41.8L279.1 512h14.3H410.7h14.3l-7.4-12.2L391.9 458c41.5-32.8 56.1-73 56.1-106c0-81.3-62.1-126.6-92.2-143l-3.8-2.1zm0 18.3c29.4 17 80 57.7 80 126.8c0 29.4-13.4 67-55.4 97.5l-6 4.3 3.8 6.3L396.4 496H307.6l21.9-35.8 3.8-6.3-6-4.3C285.4 419 272 381.4 272 352c0-69.1 50.6-109.8 80-126.8zM368 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fast',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352h-8v16h8 40 16 40 8V352h-8H264V216v-8h-8H224h-8v16h8 24V352H208zm64-176V144H240v32h32z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fast',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      'M.4 0H19L319.6 512H301L.4 0z'
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fast',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM21.7 496H426.3L372.2 320H312v48.7c22.7 3.8 40 23.6 40 47.3v40 8h-8H328h-8V448h8 8V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h8 8v16h-8H264h-8v-8V416c0-23.8 17.3-43.5 40-47.3V320H152v48.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V320H75.8L21.7 496zM144 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM64 304H384l59.1 192 4.9 16H431.3 16.7 0l4.9-16L64 304z'
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fast',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      'M496 256l0 1.7 15.8-12.2C506.3 109 393.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c80.2 0 151.7-36.8 198.6-94.5l.4-1.5H434.9c-43.9 49.1-107.8 80-178.9 80C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240zM144 144h32v64H144V144zm-16-16v16 64 16h16 32 16V208 144 128H176 144 128zm112 16h32v64H240V144zm0-16H224v16 64 16h16 32 16V208 144 128H272 240zm96 16h32v64H336V144zm-16-16v16 64 16h16 32 16V208 144 128H368 336 320zM470.3 486.9L464 512l20.4-15.8L640 376v-8V352H624 576.5 560l4-16 21.7-86.9L592 224l-20.4 15.8L416 360v8 16h16 47.5H496l-4 16-21.7 86.9zM496 368H432v-.1l133.3-103-20.8 83.3-5 19.9H560h64v.1l-133.3 103 20.8-83.3 5-19.9H496z'
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fast',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      'M288 5.5l5.2 4.5L384 87.7V40 32h8H504h8v8V197.5l61.2 52.5-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zM496 183.7V48H400v53.5l96 82.3zM288 26.5L80 204.8V496H496V204.8L288 26.5z'
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fast',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H496V204.8L288 26.5zm-7.7 214.7l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 416.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm-3.4 18.9l-7.7-7.4c-8.5-8.2-19.8-12.7-31.6-12.7h-2.4c-23.9 0-43.2 19.3-43.2 43.2c0 11.7 4.8 23 13.2 31.1L288 393.9l82.8-79.6c8.5-8.1 13.2-19.4 13.2-31.1c0-23.9-19.3-43.2-43.2-43.2h-2.4c-11.8 0-23.1 4.6-31.6 12.7l-7.7 7.4L288 270.8l-11.1-10.7z'
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fast',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM121.8 238.5l-11.3 11.3 5.7 5.7L180.7 320l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L192 331.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L203.3 320l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L192 308.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fast',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      'M16 464H496V412.9L367.4 224H259.3l-61.7 61.7-5.7 5.7-5.7-5.7-49.8-49.8L16 412.9V464zM356.5 208L256 60.4l-110.3 162L192 268.7l58.3-58.3 2.3-2.3H256 356.5zM126.5 222.2L246.3 46.2 256 32l9.7 14.2L512 408v56 16H496 16 0V464 408L125 224.4l-.4-.4 1.8-1.8z'
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fast',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      'M8 0H0V16H8 32V144v4l3.3 2.4L178.5 256 35.3 361.6 32 364v4V496H8 0v16H8 376h8V496h-8H352V368v-4l-3.3-2.4L205.5 256 348.7 150.4 352 148v-4V16h24 8V0h-8H8zM336 16V140L192 246.1 48 140V16H336zM192 265.9L336 372V496H48V372L192 265.9z'
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fast',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      'M432 48H16V464H380.5l1.1 16H16 0V464 48 32H16 432h16V48 160h-8.7L432 174.6V48zm-64 72v88H352V128H232v88.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V120v-8h8H360h8v8zM352 384V288h15.9l.1 1.1V392v8h-8H88 80v-8V120v-8h8 64 8v16h-8H96V384H352zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm235.1-39.9H464h96 4.9l2.2 4.4 21.8 43.6H632h8v16h-8H584 440 392h-8v-16h8 43.1l21.8-43.6 2.2-4.4zm-6.1 48H571.1l-16-32H468.9l-16 32zM400 288.2h16l14.9 207.9H593.1L608 288.2h16L608 512.1H416L400 288.2z'
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fast',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      'M48 48v80 16V272v16 80H75.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H368V224 208 104 48H48zM32 368V288H16 0V272 144 128H16 32V48 32H48 368h16V48 96h72c3 0 5.8 1.7 7.2 4.4L516.9 208H592h16v16V368h24c4.4 0 8 3.6 8 8s-3.6 8-8 8H608 592 567.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H384 368 247.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32zm0-224H16V272H32V144zm352-32v96H499.1l-48-96H384zm0 112V368h11.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H592V224H512.2h-.3H384zM246.9 132L304 231.9V136v-8h16v8V248v8h-8-8-4.6l-2.3-4L240 152.1V248v8H224v-8V136v-8l8 0 8 0 4.6 0 2.3 4zM112 136v72c0 17.7 14.3 32 32 32s32-14.3 32-32V136v-8h16v8 72c0 26.5-21.5 48-48 48s-48-21.5-48-48V136v-8h16v8zM232 392A72 72 0 1 0 88 392a72 72 0 1 0 144 0zm248 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fast',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      'M128 64h8H288h8v8V95.5v4.9l-4.4 2.2C274.7 111.2 264 126.8 264 144c0 25.5 24 48 56 48s56-22.5 56-48c0-17.2-10.7-32.8-27.6-41.4l-4.4-2.2V95.5 72 64h8H504h8v8V216h25.4c9.6-18.5 26.4-32 46.6-32c16.3 0 30.5 8.8 40.3 21.9S640 236.8 640 256s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-20.3 0-37-13.5-46.6-32H512V440v8h-8H352h-8v-8V416.5v-4.9l4.4-2.2c16.9-8.6 27.6-24.2 27.6-41.4c0-25.5-24-48-56-48s-56 22.5-56 48c0 17.2 10.7 32.8 27.6 41.4l4.4 2.2v4.9V440v8h-8H136h-8v-8V296H102.6C93 314.5 76.3 328 56 328c-16.3 0-30.5-8.8-40.3-21.9S0 275.2 0 256s5.8-37 15.7-50.1S39.7 184 56 184c20.3 0 37 13.5 46.6 32H128V72 64zm16 16V224v8h-8H97.6 92.3l-2.1-4.8C82.7 209.9 69.6 200 56 200c-10.2 0-20 5.5-27.5 15.5S16 239.9 16 256s4.9 30.4 12.5 40.5S45.8 312 56 312c13.6 0 26.7-9.9 34.2-27.2l2.1-4.8h5.2H136h8v8V432H280V421.2c-19-11.3-32-30.7-32-53.2c0-36.3 33.3-64 72-64s72 27.7 72 64c0 22.6-13 41.9-32 53.2V432H496V288v-8h8 38.4 5.2l2.1 4.8c7.5 17.3 20.7 27.2 34.2 27.2c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S594.2 200 584 200c-13.6 0-26.7 9.9-34.2 27.2l-2.1 4.8h-5.2H504h-8v-8V80H360V90.8c19 11.3 32 30.7 32 53.2c0 36.3-33.3 64-72 64s-72-27.7-72-64c0-22.6 13-41.9 32-53.2V80H144z'
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fast',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      'M168.7 92.9l-1.2 9.6-9.2-3c-7-2.3-14.5-3.5-22.3-3.5c-39.8 0-72 32.2-72 72c0 12.2 3 23.7 8.4 33.7l4.3 8.1L68.1 213C37.7 224.3 16 253.6 16 288v80H248V320 256 136v-8h16v8V256v64 48H496V288c0-34.4-21.7-63.7-52.1-75l-8.6-3.2 4.3-8.1c5.3-10.1 8.4-21.5 8.4-33.7c0-39.8-32.2-72-72-72c-7.8 0-15.3 1.2-22.3 3.5l-9.2 3-1.2-9.6C337.9 49.5 300.8 16 256 16s-81.9 33.5-87.3 76.9zM248 384H8 0v-8V288c0-38.2 22.3-71.2 54.6-86.6C50.3 191.1 48 179.8 48 168c0-48.6 39.4-88 88-88c6.3 0 12.4 .7 18.4 1.9C164.5 35.1 206.1 0 256 0s91.5 35.1 101.6 81.9c5.9-1.3 12.1-1.9 18.4-1.9c48.6 0 88 39.4 88 88c0 11.8-2.3 23.1-6.6 33.4C489.7 216.8 512 249.8 512 288v88 8h-8H264V504v8H248v-8V384z'
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fast',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      'M0 56H8 440h8V72h-8H8 0V56zM192 184h8H440h8v16h-8H200h-8V184zm8 128H440h8v16h-8H200h-8V312h8zM0 440H8 440h8v16h-8H8 0V440zM114.7 246L128 256l-13.3 10L16 340 0 352V332 180 160l16 12 98.7 74zM16 192V320l85.3-64L16 192z'
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fast',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM352 116.5l-10.8 4.1-128 48-5.2 1.9V176 282.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40V181.5l112-42V250.2c-8.5-6.3-19.7-10.2-32-10.2c-26.5 0-48 17.9-48 40s21.5 40 48 40s48-17.9 48-40V128 116.5zM304 256c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24zM176 288c20.5 0 32 13.4 32 24s-11.5 24-32 24s-32-13.4-32-24s11.5-24 32-24z'
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fast',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      'M425.4 32l3.7 3.7L230.5 112.8l-1.6 .6-1.2 1.2L114.6 227.7l-1.2 1.2-.6 1.6L35.7 429 32 425.4V336C32 168.1 168.1 32 336 32h89.4zM70.6 464L48 441.4l79-203.6L237.8 127.1 441.4 48 464 70.6l-79 203.6L274.2 384.9 70.6 464zM83 476.3l198.6-77.1 1.6-.6 1.2-1.2L397.4 284.3l1.2-1.2 .6-1.6L476.3 83l3.7 3.7V176c0 167.9-136.1 304-304 304H86.6L83 476.3zM496 80L432 16H336C159.3 16 16 159.3 16 336v96l64 64h96c176.7 0 320-143.3 320-320V80z'
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fast',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM224 88h64 8v8 64h64 8v8 64 8h-8H296v64 8h-8H224h-8v-8V240H152h-8v-8V168v-8h8 64V96 88h8zm8 80v8h-8H160v48h64 8v8 64h48V232v-8h8 64V176H288h-8v-8V104H232v64z'
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fast',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      'M264 0l0 8 0 496 0 8-16 0 0-8L248 8l0-8 16 0zM180.7 244.7L192 256l-11.3 11.3L32 416l-16 0L0 416l0-16L0 112 0 96l16 0 16 0L180.7 244.7zM25.4 112L16 112l0 288 9.4 0 144-144L25.4 112zM320 256l11.3-11.3L480 96l16 0 16 0 0 16 0 288 0 16-16 0-16 0L331.3 267.3 320 256zM496 112l-9.4 0-144 144 144 144 9.4 0 0-288z'
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fast',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      'M512 224c0-5.2-.2-10.6-.7-16C503.3 114.4 425.4 0 256 0S8.7 114.4 .7 208c-.5 5.4-.7 10.8-.7 16H16 52.7L160 331.3V336 496v16h16H336h16V496 336v-4.7L459.3 224H496h16zm-75.3 0l-96 96H336 264V224H383.6h16 37.1zM248 224v96H176h-4.7l-96-96h37.1 16H248zm88 272H176V336H336V496zM16.8 208C23.5 134.9 76.6 47.1 190.6 22.6C144 57 112 127.1 112 208H16.8zM167.3 70c24-34.7 55.6-54 88.7-54s64.6 19.3 88.7 54c24 34.6 39.3 83.4 39.3 138H128c0-54.6 15.3-103.3 39.3-138zm154-47.4C435.4 47.1 488.5 134.9 495.2 208H400c0-80.9-32-151-78.6-185.4z'
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fast',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      'M464 80A64 64 0 1 0 336 80a64 64 0 1 0 128 0zm16 0c0 44.2-35.8 80-80 80c-2.1 0-4.3-.1-6.4-.2L358.1 355.1c33.4 9.6 57.9 40.4 57.9 76.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-17.3 5.5-33.3 14.8-46.4L134.6 266.4C120.3 279.8 101.1 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c30.8 0 57.6 17.4 70.9 43l172.2-68.9c-2-7-3.1-14.5-3.1-22.1c0-44.2 35.8-80 80-80s80 35.8 80 80zM329 117L156.9 185.9c2 7 3.1 14.5 3.1 22.1c0 17.3-5.5 33.3-14.8 46.4L281.4 373.6C295.7 360.2 314.9 352 336 352c2.1 0 4.3 .1 6.4 .2l35.5-195.3c-21.2-6.1-38.8-20.7-48.8-39.9zm71 315a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fast',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      'M256 16c110.5 0 203.5 74.6 231.4 176.2c2.8-.1 5.7-.2 8.6-.2c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-3.7-4.1-7.3-8.3-10.6-12.7C325.4 488.3 291.6 496 256 496C123.5 496 16 388.5 16 256S123.5 16 256 16zm0 128c-65.9 0-125.2 28.5-166.2 73.8l11.3 11.3C139.2 186.7 194.5 160 256 160c56.7 0 108.1 22.7 145.6 59.4c4.7-3 9.5-5.7 14.4-8.2C375.3 169.7 318.7 144 256 144zm0 96c-39.3 0-74.1 18.9-96 48l11.4 11.4C190.3 273.1 221.2 256 256 256c32.3 0 61.2 14.8 80.3 37.9c2.4-5.2 5.1-10.3 8-15.2C322.4 254.9 290.9 240 256 240zm0 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm97.8-162.6C570.3 321.6 535.2 304 496 304s-74.3 17.6-97.8 45.4l12.7 9.8c20.5-24 51-39.2 85.1-39.2s64.5 15.2 85.1 39.2l12.7-9.8zM496 360c-21.4 0-40.9 8.4-55.2 22.1l12.9 9.9c11.3-10 26.1-16 42.4-16s31.1 6.1 42.4 16l12.9-9.9C536.9 368.4 517.4 360 496 360zm0 88a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fast',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M496 40V32h16v8V288v8h-8H27.3L157.7 426.3l5.7 5.7L152 443.3l-5.7-5.7-144-144L-3.3 288l5.7-5.7 144-144 5.7-5.7L163.3 144l-5.7 5.7L27.3 280H496V40z'
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fast',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      'M16 432l0 32 32 0 0-32-32 0zM112 80l32 0 0-32-32 0 0 32zm0 384l32 0 0-32-32 0 0 32zm0-224l0 32 32 0 0-32-32 0zM304 464l32 0 0-32-32 0 0 32zm0-416l0 32 32 0 0-32-32 0zm0 224l32 0 0-32-32 0 0 32zM208 432l0 32 32 0 0-32-32 0zm0-352l32 0 0-32-32 0 0 32zm0 160l0 32 32 0 0-32-32 0zM400 464l32 0 0-32-32 0 0 32zm0-384l32 0 0-32-32 0 0 32zM16 48l0 32 32 0 0-32L16 48zM400 272l32 0 0-32-32 0 0 32zM16 240l0 32 32 0 0-32-32 0zM208 368l32 0 0-32-32 0 0 32zm192-32l0 32 32 0 0-32-32 0zM16 368l32 0 0-32-32 0 0 32zM400 144l0 32 32 0 0-32-32 0zM16 176l32 0 0-32-32 0 0 32zm192-32l0 32 32 0 0-32-32 0z'
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fast',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M160 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fast',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      'M176 80l48-32 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 48 32 0 32 16 0 0 16 0 32 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 496l0 16-16 0-288 0-16 0 0-16 0-212.4c0-38.2 15.2-74.8 42.2-101.8L160 160l0-32 0-16 16 0 0-32zm16 32l128 0 0-23.4L279.1 61.3 272 56.6l0-8.6 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 0 8.6-7.1 4.8L192 88.6l0 23.4zm144 16l-16 0-128 0-16 0 0 32 160 0 0-32zM149.5 193.1c-24 24-37.5 56.6-37.5 90.5l0 20.4 144 0 0 16-144 0 0 80 144 0 0 16-144 0 0 80 288 0 0-212.4c0-33.9-13.5-66.5-37.5-90.5L345.4 176l-9.4 0-160 0-9.4 0-17.1 17.1z'
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fast',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      'M96 40V32H80v8V230.8L6.2 248.2-1.6 250 2 265.6l7.8-1.8L80 247.3V472v8h8H376h8V464h-8H96V243.5l185.8-43.7 7.8-1.8L286 182.4l-7.8 1.8L96 227.1V40z'
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fast',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      'M16 64v8V240H304V72 64h16v8V248 440v8H304v-8V256H16V440v8H0v-8V248 72 64H16zM496 432c70.7 0 128-57.3 128-128s-57.3-128-128-128c-69.9 0-126.7 56-128 125.5c0 .8 0 1.6 0 2.5c0 0 0 0 0 0c0 70.7 57.3 128 128 128zM352 304c0-1.2 0-2.5 0-3.7c.8-31.6 11.7-62.1 31.2-87L500.1 64h20.3L434.5 173.7C453.2 164.9 474 160 496 160c79.5 0 144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fast',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-8-237.1V376v8h16v-8V274.9L386.7 128H365.9L256 259.5 146.1 128H125.3L248 274.9z'
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fast',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      'M208 96c35.3 0 64-28.7 64-64V16H256c-35.3 0-64 28.7-64 64V96h16zm-32 16V96 80c0-44.2 35.8-80 80-80h16 16V16 32c0 44.2-35.8 80-80 80H192 176zM80 128l112 32 112-32c20.6 0 38.3 6.1 53 16.5c4.5 3.2 8.8 6.8 12.8 10.8c-4.6 2.9-9.1 6-13.4 9.4C314.8 196.8 288 247.3 288 304c0 54.7 25 103.6 64.1 135.9c4.1 3.4 8.4 6.6 12.8 9.6c-3.3 4.3-6.7 8.5-10.2 12.4C326.3 493.5 291.1 512 256 512l-64-16-64 16c-35.1 0-70.3-18.5-98.7-50.2c-3.5-3.9-6.9-8.1-10.2-12.4c4.4-3 8.7-6.2 12.8-9.6C71 407.6 96 358.7 96 304c0-56.7-26.8-107.2-68.5-139.3c-4.3-3.3-8.8-6.4-13.3-9.4c4-4 8.3-7.6 12.8-10.8C41.7 134.1 59.4 128 80 128zm116.4 47.4l-4.4 1.3-4.4-1.3L77.8 144c-14.1 .3-26.4 4.1-37.2 10.6C84.2 189.8 112 243.7 112 304c0 59.7-27.2 112.9-69.9 148.1c25.4 27.9 55.4 43.2 84 43.8l62-15.5 3.9-1 3.9 1 62 15.5c28.5-.6 58.6-15.9 84-43.8C299.2 416.9 272 363.7 272 304c0-60.3 27.8-114.2 71.3-149.3c-10.7-6.5-23-10.3-37.2-10.6L196.4 175.4z'
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fast',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      'M428 48a68 68 0 1 0 -.2 136.1A68 68 0 1 0 428 48zm0 152c-46.4 0-84-37.6-84-84s37.6-84 84-84c45 0 81.8 35.5 83.9 80h.1c0 .7 0 1.4 0 2.1c0 .6 0 1.3 0 1.9c0 10.8-2 21.1-5.8 30.6c-4 11.8-10.1 22.8-18 32.6l-62 76.7H405.7l48.6-60.2c-8.3 2.7-17.1 4.2-26.3 4.2zM160 36.7l5.7 5.7 112 112 5.7 5.7L272 171.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L53.7 165.7 48 171.3 36.7 160l5.7-5.7 112-112 5.7-5.7zM368 288h8 56 8v8V464h48 8v16h-8H432 376h-8V464h8 48V304H376h-8V288z'
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fast',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      'M112 265.7l5.4 8.1 9.5 14.3H144h48 16V408v96 8h16v-8V416H624v88 8h16v-8V408 200v-9.7V8 0h-8H488h-8V8 64v1.2l.4 1.2 46 145.8L224 270.3V240 224H208 192 161.1l-54.5-81.7L97.1 128H80 32 16 0v16 16V274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6L96 397.3V480v16 16h16 32 16V496 480 384 370.7l-9.4-9.4L96 306.7V270.5 241.7l16 24zM224 288v-1.4l400-76.9V400H224V288zm-80 89.4V384v96 16H112V480 397.3v-6.6l-4.7-4.7L52.7 331.3 30.1 308.7c-9-9-14.1-21.2-14.1-33.9V160 144H32 80h8.6l4.7 7.1 54.5 81.7 4.8 7.1h8.6H192h16v32H192 144h-8.6l-4.7-7.1-21.4-32.1L80 188.8v52.8 65.1 6.6l4.7 4.7 54.6 54.6 4.7 4.7zM80 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM624 193.4l-81.8 15.7L496 62.8V16H624V193.4zM320 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 480l0 16 0 16 16 0 32 0 16 0 0-16 0-16v0V410.5l-16-16L48 480l0 16-32 0 0-16 0-117.5-16-16L0 480z'
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fast',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      'M312 0V8v8V219.6l-56 35.6V112 96H240 152c-26.9 35.8-51.5 73.2-73.8 112.1C42.3 271.1 0 348.4 0 423c0 49.1 39.8 89 89 89c38.2 0 78.8-12.6 117.7-24.7c16.8-5.2 33.4-10.4 49.3-14.3V305.6l-16 10.2V460.7c-12.6 3.5-25.8 7.6-38.8 11.6l0 0 0 0 0 0 0 0c-11 3.4-21.9 6.8-32.3 9.8c-28 8-54.8 14-79.9 14c-40.3 0-73-32.7-73-73c0-69.7 39.7-143.3 76.1-207c20.6-36 43.3-70.7 67.9-104.1h80V265.4L139.7 329.3l-6.7 4.3 8.6 13.5 6.7-4.3L320 233.5 491.7 342.7l6.7 4.3 8.6-13.5-6.7-4.3L400 265.4V112h80c24.7 33.4 47.3 68 67.9 104.1C584.3 279.7 624 353.3 624 423c0 40.3-32.7 73-73 73c-25.1 0-51.9-5.9-79.9-14c-10.4-3-21.3-6.4-32.3-9.8l0 0 0 0c-13.1-4-26.2-8.1-38.8-11.6V315.8l-16-10.2V473c15.9 4 32.5 9.1 49.3 14.3C472.2 499.4 512.8 512 551 512c49.1 0 89-39.8 89-89c0-74.6-42.3-152-78.2-214.9C539.5 169.2 514.9 131.8 488 96H400 384v16V255.2l-56-35.6V16 8 0H312z'
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fast',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      'M232 16l67.8 0L376 130.4v63.4l-56.5 59.6 10.8 11.9 59.5-62.7 2.2-2.3V197 128v-2.4l-1.3-2L310.7 3.6 308.4 0l-4.3 0L224 0V0H144h-4.3l-2.4 3.6-79.9 120-1.3 2V128v69 3.2l2.2 2.3L346.2 506.3l4.6 4.9 5.6-3.7 80-52.8 7.8-5.2-6.3-6.9L160.1 137.9V104H224h16 48v33.9l-36.9 40.5 10.8 11.9 40-43.8 2.1-2.3V141 96 88h-8H240 224 152.1h-8v8 45 3.1l2.1 2.3L419.8 446.5l-66.6 44L72.1 193.8V130.4L148.3 16H232v0zM118.3 324L10.2 442.6l-6.3 6.9 7.8 5.2 80 52.8 5.6 3.7 4.6-4.9 94.6-99.8-11-11.6L94.9 490.4l-66.6-44 101-110.8-11-11.6z'
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fast',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      'M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h80 16v16V496v16H432 16 0V496 208 192H16 96zm0 16H16V496H432V208H352 336 112 96zm135.3 52.7L317.4 448H299.8l-22.1-48H170.3l-22.1 48H130.6l86.1-187.3 2.1-4.7h10.3l2.1 4.7zM270.3 384L224 283.2 177.7 384h92.7z'
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fast',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      'M296 0h-8V8 504v8h16v-8V16H496V200v8h8 56 16 48V504v8h16v-8V200v-8h-8H576V104 96H560v8 88H512V8 0h-8H296zm64 72v8 64 8h8 64 8v-8V80 72h-8H368h-8zm16 16h48v48H376V88zM496 264h-8v8 64 8h8 64 8v-8V272v-8h-8H496zm8 64V280h48v48H504zm-16 64v8 64 8h8 64 8v-8V400v-8h-8H496h-8zm16 16h48v48H504V408zM368 200h-8v8 64 8h8 64 8v-8V208v-8h-8H368zm8 64V216h48v48H376zm-16 64v8 64 8h8 64 8v-8V336v-8h-8H368h-8zm16 16h48v48H376V344zM157.7 154.3l-5.7-5.7L140.7 160l5.7 5.7L228.7 248H8 0v16H8 228.7l-82.3 82.3-5.7 5.7L152 363.3l5.7-5.7 96-96 5.7-5.7-5.7-5.7-96-96z'
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fast',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zM352 352H472h8v-8V224v-8H464v8V324.7L293.7 154.3l-5.7-5.7-5.7 5.7L192 244.7l-90.3-90.3L96 148.7 84.7 160l5.7 5.7 96 96 5.7 5.7 5.7-5.7L288 171.3 452.7 336H352h-8v16h8z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fast',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      'M386.3 61.7c-32.2-32.2-84.5-32.2-116.7 0l-192 192c-49.9 49.9-49.9 130.8 0 180.7s130.8 49.9 180.7 0l152-152 5.7-5.7L427.3 288l-5.7 5.7-152 152c-56.1 56.1-147.2 56.1-203.3 0s-56.1-147.2 0-203.3l192-192c38.5-38.5 100.8-38.5 139.3 0s38.5 100.8 0 139.3L213.9 373.4c-24.8 24.8-65.7 22.6-87.7-4.9c-18.8-23.4-16.9-57.2 4.3-78.5L282.3 138.3l5.7-5.7L299.3 144l-5.7 5.7L141.9 301.4c-15.5 15.5-16.8 40.1-3.2 57.2c16 20 45.8 21.6 63.9 3.5L386.3 178.3c32.2-32.2 32.2-84.5 0-116.7z'
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fast',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      'M560 48v64H544 527.9 48.1 32 16V48H560zM16 128H33.4L64 480H512l30.6-352H560h16V112 48 32H560 16 0V48v64 16H16zm33.5 0H526.5L497.3 464H78.7L49.5 128zM288 192c7.5 0 14.6 3.6 19.1 9.6l40.2 54.5 13.6-8.5-40.9-55.5C312.5 182 300.6 176 288 176s-24.5 6-31.9 16.1l-40.9 55.5 13.6 8.5 40.2-54.5c4.5-6.1 11.5-9.6 19.1-9.6zm-91.9 81.5l-36.7 49.8c-4.8 6.5-7.4 14.5-7.4 22.6c0 21 17.1 38.1 38.1 38.1H272V368H190.1c-12.2 0-22.1-9.9-22.1-22.1c0-4.7 1.5-9.3 4.3-13.1L209.8 282l-13.6-8.5zM304 384h81.9c21 0 38.1-17.1 38.1-38.1c0-8.1-2.6-16.1-7.4-22.6l-36.7-49.8L366.2 282l37.4 50.8c2.8 3.8 4.3 8.4 4.3 13.1c0 12.2-9.9 22.1-22.1 22.1H304v16z'
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fast',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M229.7 50.3L224 44.7l-5.7 5.7-176 176L36.7 232 48 243.3l5.7-5.7L224 67.3 394.3 237.7l5.7 5.7L411.3 232l-5.7-5.7-176-176zm0 192l-5.7-5.7-5.7 5.7-176 176L36.7 424 48 435.3l5.7-5.7L224 259.3 394.3 429.7l5.7 5.7L411.3 424l-5.7-5.7-176-176z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fast',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      'M256 16C123.5 16 16 123.5 16 256c0 10.5 .7 20.8 2 31L2.1 289C.7 278.2 0 267.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-11.2 0-22.2-.7-33-2.1l2-15.9c10.1 1.3 20.5 2 31 2c132.5 0 240-107.5 240-240S388.5 16 256 16zm48 326.4l4.4 3 44.1 29.4 27.8-13.9 7.2-3.6 7.2 14.3-7.2 3.6-32 16-4.2 2.1-3.9-2.6-43.6-29-43.6 29-6.7 4.4-8.9-13.3 6.7-4.4 48-32 4.4-3zM139.6 160.8l80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L198.1 208l-65.7-32.8-7.2-3.6 7.2-14.3 7.2 3.6zm240-3.6l7.2 14.3-7.2 3.6L313.9 208l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L278.1 208l14.3-7.2 80-40 7.2-3.6zM79.2 389.1L57.3 454.7l65.6-21.9 9.4-3.1 7 7 41.4 41.4 24.5-171.2L33.9 331.3l41.4 41.4 7 7-3.1 9.4zM0 320l19.8-2.8 187.7-26.8L224 288l-2.4 16.5L194.8 492.2 192 512l-14.1-14.1L128 448 51 473.7 32 480l6.3-19L64 384 14.1 334.1 0 320z'
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fast',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      'M0 0H8 120c3.5 0 6.6 2.3 7.6 5.6L247 384.6c3-.4 6-.6 9-.6c23.2 0 43.5 12.3 54.7 30.8l254.9-78.4 7.6-2.4 4.7 15.3-7.6 2.4L317.3 429.5c1.8 5.9 2.7 12.1 2.7 18.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.7 16.3-49.5 39.5-59.1L114.1 16H8 0V0zM304 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fast',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M16 167.6l240 165 240-165V80H16v87.6zM496 187L256 352 16 187V432H496V187zM0 432V176 80 64H16 496h16V80v96V432v16H496 16 0V432z'
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fast',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      'M352 32V48H328V160h24v16H232 216 136 120 40 24 0V160H24V48H0V32H352zM312 48H232V160h80V48zm-96 0H136V160h80V48zm-96 0H40V160h80V48zM384 96h8H504h3.3l2.3 2.3 128 128 2.3 2.3V232 408v8h-8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H8 0v-8V232v-8H8 384V104 96zm0 144H16V400H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H403.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H624V240H400 384zm228.7-16l-112-112H400V224H612.7zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fast',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zm320 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fast',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M70.4 60.8C66.2 66.3 64 73.1 64 80c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.7-6.4-19.2L96 26.7 70.4 60.8zM57.6 51.2L86 13.3 96 0l10 13.3 28.4 37.9c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zm140.8 9.6C194.2 66.3 192 73.1 192 80c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.7-6.4-19.2L224 26.7 198.4 60.8zm-12.8-9.6L214 13.3 224 0l10 13.3 28.4 37.9c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM352 26.7L326.4 60.8C322.2 66.3 320 73.1 320 80c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.7-6.4-19.2L352 26.7zM342 13.3L352 0l10 13.3 28.4 37.9c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L342 13.3zM16 381.9l68.9-29.3 3.2-1.4 3.2 1.4 68.6 30.5 60.6-30.3 3.6-1.8 3.6 1.8 60.6 30.3 68.6-30.5 3.2-1.4 3.2 1.4L432 381.9V240H360v24 8H344v-8V240H232v24 8H216v-8V240H104v24 8H88v-8V240H16V381.9zm0 17.4V496H432V399.3l-71.9-30.6-68.8 30.6-3.4 1.5-3.4-1.7L224 368.9l-60.4 30.2-3.4 1.7-3.4-1.5L87.9 368.7 16 399.3zM16 224H88V168v-8h16v8 56H216V168v-8h16v8 56H344V168v-8h16v8 56h72 16v16V496v16H432 16 0V496 240 224H16z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fast',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM160 185.8V166.2l51.4-36.7 2.1-1.5H216h8 8v8V368h56 8v16h-8H224 160h-8V368h8 56V145.8l-51.4 36.7-4.6 3.3z'
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fast',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      'M75.5 366.8l-3.6 9.6-29.6 79 119.5-35.8 4.6-1.4 4.6 1.4c26.4 8 55 12.4 85 12.4c135.8 0 240-88.9 240-192S391.8 48 256 48S16 136.9 16 240c0 44.7 19.2 86.3 52.3 119.5l7.3 7.3zM35.3 474.2L16 480l7.1-18.8 33.9-90.4C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L35.3 474.2z'
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fast',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      'M64 96l0 64 64 0 0-64L64 96zM48 80l16 0 64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16zm80 144l-64 0 0 64 64 0 0-64zM64 208l64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16 16 0zm64 144l-64 0 0 64 64 0 0-64zM64 336l64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16 16 0z'
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fast',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      'M96 32h8H224h8V48h-8H112V192v3.3l-2.3 2.3L51.3 256l58.3 58.3 2.3 2.3V320 464H224h8v16h-8H104 96v-8V323.3L34.3 261.7 32 259.3v-6.6l2.3-2.3L96 188.7V40 32zm384 0v8V188.7l61.7 61.7 2.3 2.3v6.6l-2.3 2.3L480 323.3V472v8h-8H352h-8V464h8H464V320v-3.3l2.3-2.3L524.7 256l-58.3-58.3-2.3-2.3V192 48H352h-8V32h8H472h8z'
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fast',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160.2 152h20.1L256 251.5 331.7 152h20.1L271.6 257.4H320h8v16h-8H264V319h56 8v16h-8H264v41 8H248v-8V335H192h-8V319h8 56V273.4H192h-8v-16h8 48.4L160.2 152z'
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fast',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      'M389.6 85.8c32.8 32.8 45.6 80.9 38 133.9s-35.5 109.7-82.8 157s-104 75.2-157 82.8c-43.6 6.2-83.9-1.4-115.1-22.5l61.4-111.6L324.4 198.7l1.8-1.2 1-1.9L384.5 81c1.8 1.6 3.5 3.2 5.1 4.9zm-18-15L313.8 186.5 123.6 313.3l-1.6 1.1-.9 1.7L59.9 427.3c-2.1-1.8-4.1-3.7-6-5.7c-32.8-32.8-45.6-80.9-38-133.9s35.5-109.7 82.8-157s104-75.2 157-82.8c44-6.3 84.7 1.5 116 23.1zm7.8-14.1c-77.6-52.2-202-27.5-292.1 62.5c-99 99-119 239.4-44.8 313.6c3.1 3.1 6.2 5.9 9.5 8.7c3.9 3.2 7.9 6.3 12.1 9.1c.3 .2 .6 .4 .9 .6c77.6 51.5 201.4 26.6 291.2-63.1c99-99 119-239.4 44.8-313.6c-2.9-2.9-5.9-5.7-9.1-8.3c-4-3.4-8.2-6.5-12.5-9.4z'
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fast',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      'M16 176H139.1l29.8 59.6c1.4 2.7 4.1 4.4 7.2 4.4H336c3 0 5.8-1.7 7.2-4.4L372.9 176H496V304H16V176zm5.5-16L90.1 16H421.9l68.6 144H368c-3 0-5.8 1.7-7.2 4.4L331.1 224H180.9l-29.8-59.6c-1.4-2.7-4.1-4.4-7.2-4.4H21.5zM80 0L0 168V304v16H16 496h16V304 168L432 0H80zM184 416l-32-64H16 0v16V496v16H16 496h16V496 368 352H496 360l-32 64H184zm185.9-48H496V496H16V368H142.1l27.6 55.2c2.7 5.4 8.3 8.8 14.3 8.8H328c6.1 0 11.6-3.4 14.3-8.8L369.9 368z'
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fast',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM318.9 222c-3.3 16-14.9 28.1-32.5 35.3c22.4 9.6 38.1 24.4 32.5 52.1c-6.5 32-45.1 48.1-98.3 41c-16.3-2.1-32-7-47.7-11.9c-2.4-.7-4.8-1.5-7.2-2.2l4.6-15.3c2.6 .8 5.2 1.6 7.8 2.4c14.6 4.6 29.3 9.2 44.5 11.1c43.4 5.8 75.9-5.5 80.5-28.3c5.5-27.4-20.9-35.9-65.1-46.7c-1-.2-1.9-.5-2.9-.7c-33.4-8.2-83-20.4-74-64.7c3.3-16.1 15-28.1 32.5-35.4c-20.8-9.1-38.2-24-32.5-52c6.5-32 45.1-48.2 98.3-41c10 1.3 21.7 4 36.8 8.5l-4.5 15.3c-14.3-4.2-25.3-6.7-34.4-8c-43.7-5.8-75.9 5.6-80.5 28.3c-4.9 24.4 14.8 34.1 55.6 44.3c2.9 .7 6 1.4 9.2 2.2c35.6 8.4 86.5 20.3 77.3 65.6zM176.8 197.2c-6.1 30.5 31.8 39.1 56.9 44.8c2.9 .7 5.7 1.3 8.1 1.9c5.7 1.4 11.5 2.9 17.3 4.4c18.8-3.5 40-9.5 44.1-29.5c6.6-32.5-36.8-41.4-66.9-47.7c-5.8-1.2-11.1-2.3-15.4-3.4c-19.2 3.6-40 9.6-44.1 29.5z'
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fast',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      'M105.7 103.4L188.8 192H592h32 16v16 64 16H624 592 168 147.2L133 272.8 35.7 169.1 13.8 145.7 2.9 134l11.7-10.9L61.2 79.3 72.9 68.4 83.8 80.1l21.9 23.3zM592 208H188.8c-4.4 0-8.6-1.8-11.7-5.1L94.1 114.3 72.2 91 25.5 134.8l21.9 23.3 97.3 103.8 9.5 10.1H168 592h32V208H592zM272 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 0c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c14.2 0 27 6.2 35.7 16L353 383.2 253 320h30l85 53.7L453 320h30L383 383.2 460.3 432c8.8-9.8 21.5-16 35.7-16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-6.6 1.3-12.8 3.7-18.5L368 392.6l-83.7 52.9c2.4 5.7 3.7 12 3.7 18.5zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fast',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      'M224 457.4L16 249.4V48H217.4l208 208L224 457.4zM436.7 244.7L224 32H16 0V48 256L212.7 468.7 224 480l11.3-11.3L436.7 267.3 448 256l-11.3-11.3zM112 184a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM88 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fast',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      'M248 395.3V495.9C129.9 492 33.4 402.8 18.1 288H140.7L248 395.3zM260.7 376h-9.4l-97.6-97.6L180.9 224H331.1l27.2 54.4L260.7 376zm3.3 19.3L371.3 288H493.9C478.6 402.8 382.1 492 264 495.9V395.3zM372.9 272l-29.8-59.6-2.2-4.4H336 176h-4.9l-2.2 4.4L139.1 272H16.5c-.3-5.3-.5-10.6-.5-16C16 123.5 123.5 16 256 16s240 107.5 240 240c0 5.4-.2 10.7-.5 16H372.9zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fast',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      'M258.8 2.8C239 2.8 223 19 212.5 36.1C201.7 53.6 194.8 75.4 194.8 92l0 78.8 0 9.3L6.9 283.8l-4.1 2.3v4.7 88 10.5l10.1-2.8 181.9-50.2 0 10.5 0 44L134 436.4l-3.2 2.4v4l0 56v10.4l10.1-2.7 117.9-31.5L368 504.2V487.6L260.9 459.1l-2.1-.6-2.1 .6L146.8 488.4l0-41.6 60.8-45.6 3.2-2.4v-4l0-48 0-21V315.3 184.9l0-14.1 0-78.8c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 78.8 0 14.1v4.7l0 125.7v10.5 21l0 48v4l3.2 2.4 58 43.5v-20l-45.2-33.9 0-44V336.3L384 353.2l0-16.6-61.2-16.9V198.4L418 250.9c1-5.5 2.5-10.8 4.3-15.9l-99.5-54.9 0-9.3 0-78.8c0-16.6-6.7-38.3-17.3-55.8C295 19 279 2.8 258.8 2.8zM18.8 295.5l176-97.1V319.7l-176 48.6 0-72.8zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fast',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      'M640 0H0V16H80V96H16 0v16V400v16H16 64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H624h16V400 112 96H624 560V88c0-22.1-17.9-40-40-40s-40 17.9-40 40v8H384V16H640V0zM368 16V96H288V16h80zm-96 0V96H192V16h80zm-96 0V96H96V16h80zM544 96H496V88c0-13.3 10.7-24 24-24s24 10.7 24 24v8zm0 16h16 64V400H572.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H16V272H424h8v-8V112h48 16 48zm-128 0V256H16V112H416zm160 48v96H480V160h96zm-96-16H464v16 96 16h16 96 16V256 160 144H576 480zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0z'
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fast',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      'M400 400l11.3-11.3 89.4-89.4L512 288l-11.3-11.3L432 208l52.7-52.7L496 144l-11.3-11.3L379.3 27.3 368 16 356.7 27.3 174.8 209.2c5.8 1.5 11.5 3.4 17.1 5.5l176-176L473.4 144l-176 176c2.1 5.6 4 11.4 5.5 17.1L320 320l68.7 68.7L400 400zm-68.7-91.3l89.4-89.4L489.4 288 400 377.4l-68.7-68.7zM192 192l11.3-11.3L134.6 112 224 22.6l68.7 68.7L304 80 235.3 11.3 224 0 212.7 11.3l-89.4 89.4L112 112l11.3 11.3L192 192zm64 320l7.7-8.7c1-1.1 1.9-2.2 2.9-3.3C326.7 428.4 322.4 322.4 256 256s-172.4-70.7-243.9-10.6c-1.1 .9-2.2 1.9-3.3 2.9L0 256l11.3 11.3 111 111-20.3 20.3C95.7 394.4 88.2 392 80 392c-22.1 0-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40c0-8.2-2.4-15.7-6.6-22.1l20.3-20.3 111 111L256 512zm-.8-23.4L23.4 256.8c65.2-53.9 161.1-49.7 221.3 10.5s64.4 156.1 10.5 221.3zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fast',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      'M392 32h-8V48h8 64v80H16 0v16V464v16H16 624h16V464 144 128H624 472V48h64 8V32h-8H464 392zm64 112h16H624V464H16V144H456zM96 80V96h8H248h8V80h-8H104 96zM464 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM108.1 236.1A96 96 0 1 1 243.9 371.9 96 96 0 1 1 108.1 236.1zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM472 240H456v8 56 8h16v-8V248v-8zM221.3 270.1l5.7-5.7-11.3-11.3-5.7 5.7-39.6 39.6-5.7 5.7L176 315.3l5.7-5.7 39.6-39.6z'
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fast',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM200 232v-8H184v8 56H128h-8v16h8 56v56 8h16v-8V304h56 8V288h-8H200V232zM128 416h-8v16h8H256h8V416h-8H128z'
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fast',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      'M331.4 160c-13.8 46.3-56.6 80-107.4 80s-93.6-33.7-107.4-80H331.4zM96 160h4c14.2 55.2 64.3 96 124 96s109.8-40.8 124-96h4 16V144 80 64H352 334.9C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64H96 80V80v64 16H96zM224 16c38.1 0 71.7 19 91.9 48H132.1c20.2-29 53.9-48 91.9-48zM352 80v64H96V80H352zM128 104h-8v16h8H320h8V104h-8H128zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zm-56.7 60.7l-7.3-16-7.3 16-40 88-2.3 5 3.9 3.9 8 8 4.4 4.4 5.4-3.2 34.6-20.8 19.6 19.6 5.7 5.7 5.7-5.7 8-8 3.9-3.9-2.3-5-40-88zm-3.4 68.5l-34 20.4L320 387.3l27.8 61.1-14.1-14.1-4.4-4.4-5.4 3.2z'
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fast',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      'M80 142c0-51.9 42.1-94 94-94c11 0 21.8 1.9 32.1 5.7l71.1 25.9 7.5 2.7 5.5-15-7.5-2.7L211.6 38.6C199.6 34.2 186.8 32 174 32C113.3 32 64 81.3 64 142v82H0v16H64v80H0v16H59.4L.8 460.6 0 462.2V464v8 8H8 312h8V464h-8H16.8L77.1 336H256V320H80V240H256V224H80V142z'
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fast',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      'M160 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM96.1 160h4.8H219.1h4.8l2.3 4.2 76.9 144 3.8 7.1-14.1 7.5-3.8-7.1L214.3 176H105.7L31.1 315.8l-3.8 7.1-14.1-7.5 3.8-7.1 76.9-144 2.3-4.2zM96 288V496h32V376c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V496h32V288v-8h16v8V504c0 4.4-3.6 8-8 8H184c-4.4 0-8-3.6-8-8V384H144V504c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V288v-8H96v8z'
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fast',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      'M432 16V496H16V16H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 336c-70.7 0-128-57.3-128-128c0-8.5 .8-16.8 2.4-24.9c15-4.2 30.9-7.1 45.6-7.1c26.5 0 46.6 13 71.1 29.3l1.2 .8C239.6 317.6 267.1 336 304 336c16.2 0 31.3-1.9 45.1-4.8c1.2-5.5 2-11.2 2.5-16.9c-14.3 3.4-30.4 5.7-47.6 5.7c-32 0-56-16-80-32s-48-32-80-32c-13.4 0-27.4 2.2-40.7 5.3c17.6-49.7 65-85.3 120.7-85.3c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0 16a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fast',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H440h8V496h-8H416V416h24 8v-8V8 0h-8H56zM400 416v80H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H400zM56 400c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V400H56zM288 149.7l-7.2 14.8-27.6 56.7-56.7 27.6L181.7 256l14.8 7.2 56.7 27.6 27.6 56.7 7.2 14.8 7.2-14.8 27.6-56.7 56.7-27.6 14.8-7.2-14.8-7.2-56.7-27.6-27.6-56.7L288 149.7zm0 36.6l21.6 44.4 1.2 2.5 2.5 1.2L357.7 256l-44.4 21.6-2.5 1.2-1.2 2.5L288 325.7l-21.6-44.4-1.2-2.5-2.5-1.2L218.3 256l44.4-21.6 2.5-1.2 1.2-2.5L288 186.3zM174.8 75.8L168 64.7l-6.8 11.1-20.3 33-33 20.3L96.7 136l11.1 6.8 33 20.3 20.3 33 6.8 11.1 6.8-11.1 20.3-33 33-20.3 11.1-6.8-11.1-6.8-33-20.3-20.3-33zm-21.3 43.1L168 95.3l14.5 23.6 1 1.6 1.6 1L208.7 136l-23.6 14.5-1.6 1-1 1.6L168 176.7l-14.5-23.6-1-1.6-1.6-1L127.3 136l23.6-14.5 1.6-1 1-1.6z'
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fast',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      'M432 464V48H16V464H432zm16 16H432 16 0V464 48 32H16 432h16V48 464v16zM312 352H168h-8V336h8H292.7L130.3 173.7l-5.7-5.7L136 156.7l5.7 5.7L304 324.7V200v-8h16v8V344v8h-8z'
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fast',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM576 312v-8-8V216v-8-8V120v-8-8V48 32H560 464h-8-8H192h-8-8H152.5l20.3 16H176v2.6l16 12.6V48H448v64 96 57.3L464 278V216h96v80H486.9l20.3 16H560v41.7l16 12.6V312zm-384-8V246.7L176 234v62H80V216h73.1l-20.3-16H80V158.3L64 145.6V200v8 8 80 8 8 80 8 8 56 16H80h96 8 8H448h8 8 23.5l-20.3-16H464v-2.6l-16-12.6V464H192V400 304zM464 48h96v56H464V48zm96 72v80H464V120h96zM176 464H80V408h96v56zM80 392V312h96v80H80z'
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fast',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      'M40 240H64V70.6 68.6l1-1.8c7-12.5 25.4-29.1 56.1-42.6C152.2 10.6 196.4 0 256 0C383.7 0 433.3 42.3 447 66.7l1 1.8v2.1V240h24 8v8V440v8h-8H448v48 16H432 368 352V496 448H160v48 16H144 80 64V496 448H40 32v-8V248v-8h8zM352 432h16 64 16 16V256H264 248 48V432H64 80h64 16H352zm16 16v48h64V448H368zM80 448v48h64V448H80zM432 112H264V240H432V112zM80 240H248V112H80V240zM248 96h16H432V72.8C420.6 54.7 376.7 16 256 16c-57.8 0-99.7 10.3-128.4 22.8C100.4 50.7 85.6 64.3 80 72.9V96H248zM88 344a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM192 48H320h8V64h-8H192h-8V48h8zM0 96H8 32h8v16H32 16v96H32h8v16H32 8 0v-8V104 96zm504 0h8v8V216v8h-8H480h-8V208h8 16V112H480h-8V96h8 24z'
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fast',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM123.5 368l-21.3 64H281.8l-21.3-64H123.5zM272 352l26.7 80 5.3 16H287.1 96.9 80l5.3-16L112 352H272z'
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fast',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 64h16c44.2 0 80 35.8 80 80v8 8h-8H176h-8v-8-8c0-44.2 35.8-80 80-80zm-64 80H328c0-35.3-28.7-64-64-64H248c-35.3 0-64 28.7-64 64zM144.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm208-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200.5 95.5l-8 .5c-32.5 2-61.6 16.5-82.7 38.7l-5.5 5.8-11.6-11 5.5-5.8c23.7-25.1 56.6-41.4 93.3-43.7l8-.5 1 16zm119 .5l-8-.5 1-16 8 .5c36.7 2.3 69.6 18.6 93.3 43.7l5.5 5.8-11.6 11-5.5-5.8C381.1 112.5 352 98 319.5 96zM160 168a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm72 56A72 72 0 1 1 88 224a72 72 0 1 1 144 0zm64 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z'
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fast',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM200 96v8V264v8H184v-8V104 96h16zM176 336V304h32v32H176z'
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fast',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      'M16 48l112 0 0 416L16 464 16 48zM496 464l-352 0 0-200 352 0 0 200zm0-216l-352 0 0-200 352 0 0 200zM0 464l0 16 16 0 480 0 16 0 0-16 0-416 0-16-16 0L16 32 0 32 0 48 0 464z'
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fast',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      'M447.9 41.8l-1.4-7.9-7.9 1.4-288 52.8-6.1 1.1-.4 6.2-7.7 114.8C59 223.3 0 290.6 0 371.7V440v8H8 472h40 56c39.8 0 72-32.2 72-72c0-26.3-11-50-26.7-70.4c-15.7-20.4-36.4-37.9-56.8-52.2c-20.4-14.3-40.8-25.5-56-33.1c-7.6-3.8-14-6.7-18.5-8.7c-1.5-.6-2.7-1.2-3.7-1.6L447.9 41.8zm34 187.3c3.4 1.6 7.3 3.4 11.6 5.6c14.8 7.4 34.4 18.2 54 31.9c19.6 13.7 38.9 30.2 53.2 48.8C615 334 624 354.3 624 376c0 30.9-25.1 56-56 56H514.7L324.4 288H476.3l11.9 65.4 1.4 7.9 15.7-2.9-1.4-7.9-22-121.5zM473.4 272H303.3l-40.7-30.8c-28.4-21.5-63.1-33.2-98.8-33.2c-3.8 0-7.5 .1-11.2 .4l7-105.6 274-50.2L473.4 272zm-322-47.5l.1 0 0 0c4-.3 8.1-.5 12.3-.5c32.2 0 63.5 10.5 89.1 29.9L296 286.6V288h1.9L488.2 432H472 16V371.7c0-77.4 59.6-140.9 135.4-147.2z'
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fast',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      'M32 32h8H472h8v8V464h24 8v16h-8H472 40 8 0V464H8 32V40 32zM48 464H464V48H48V464zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM256 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fast',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      'M448 512C200.6 512 0 311.4 0 64L0 32 144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448zM16 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L372 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C222.2 348.3 163.7 289.8 126 218.5l-6.2-11.7 10.3-8.3L203.4 140 135.8 18.2 16 44.8 16 64zM256 16V0C397.4 0 512 114.6 512 256H496C496 123.5 388.5 16 256 16zm48 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm144 32c0-79.5-64.5-144-144-144V96c88.4 0 160 71.6 160 160H400z'
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fast',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      'M267.3 11.3L323 67l98 0 16 0 0 16 0 98 63.7 63.7L512 256l-11.3 11.3L437 331l0 98 0 16-16 0-98 0-55.7 55.7L256 512l-11.3-11.3L189 445l-98 0-16 0 0-16 0-98L11.3 267.3 0 256l11.3-11.3L75 181l0-98 0-16 16 0 98 0 55.7-55.7L256 0l11.3 11.3zM323 83l-6.6 0-4.7-4.7L256 22.6 200.3 78.3 195.6 83 189 83 91 83l0 98 0 6.6-4.7 4.7L22.6 256l63.7 63.7 4.7 4.7 0 6.6 0 98 98 0 6.6 0 4.7 4.7L256 489.4l55.7-55.7 4.7-4.7 6.6 0 98 0 0-98 0-6.6 4.7-4.7L489.4 256l-63.7-63.7-4.7-4.7 0-6.6 0-98-98 0zM168 184c0-30.9 25.1-56 56-56l56.2 0c35.2 0 63.8 28.6 63.8 63.8l0 8-.5 0c-2.3 18.3-12.5 34.9-28.2 45.3L264 278.9l0 25.1 0 8-16 0 0-8 0-29.5 0-4.3 3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8L224 144c-22.1 0-40 17.9-40 40l0 6.5-16 0 0-6.5zm72 152l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fast',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M273.9 495.3c31.7-2.4 61.5-10.8 88.3-24.1c2.6 4.6 5.7 9.1 9.3 13.2c-29.2 14.8-61.8 24.2-96.5 26.8C134.1 521.9 11.3 416.1 .7 275.1c-4.5-60.1 12.1-116.9 43.6-163.1C36.6 103.6 32 92.3 32 80c0-26.5 21.5-48 48-48c12.3 0 23.5 4.6 32 12.3l0 0c.6 .5 1.2 1.1 1.8 1.7C122.6 54.6 128 66.7 128 80c0 26.5-21.5 48-48 48c-8.4 0-16.3-2.2-23.2-5.9c-29.1 43.1-44.4 96-40.2 151.9c9.9 132.2 125.1 231.3 257.3 221.4zM140.4 27.5C169.6 12.7 202.2 3.3 236.9 .7c141-10.6 263.9 95.2 274.4 236.1c4.5 60.1-12.1 116.9-43.6 163.1c7.6 8.5 12.3 19.7 12.3 32.1c0 26.5-21.5 48-48 48c-12.3 0-23.5-4.6-32-12.3l0 0c-.6-.6-1.3-1.2-1.9-1.8c-3.3-3.3-6-6.9-8.1-10.8l0 0c-3.8-6.9-6-14.8-6-23.2c0-26.5 21.5-48 48-48c8.4 0 16.3 2.2 23.2 5.9c29.1-43.1 44.4-96 40.2-151.9C485.4 105.9 370.2 6.8 238.1 16.7c-31.7 2.4-61.5 10.8-88.3 24.1c-2.6-4.6-5.7-9.1-9.3-13.2zM112 256c0 79.5 64.5 144 144 144s144-64.5 144-144c0-22.7-5.3-44.2-14.6-63.3c-7.4 4.6-16.1 7.3-25.4 7.3c-26.5 0-48-21.5-48-48c0-9.3 2.7-18 7.3-25.4C300.2 117.3 278.7 112 256 112c-79.5 0-144 64.5-144 144zm304 0c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c26.8 0 52.1 6.6 74.3 18.3c8.2-6.4 18.5-10.3 29.7-10.3c26.5 0 48 21.5 48 48c0 11.2-3.8 21.5-10.3 29.7C409.4 203.9 416 229.2 416 256zM80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm312 40a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm40 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 336l-11.3-11.3-57.4-57.4L176 256l11.3-11.3 57.4-57.4L256 176l11.3 11.3 57.4 57.4L336 256l-11.3 11.3-57.4 57.4L256 336zm0-137.4L198.6 256 256 313.4 313.4 256 256 198.6z'
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fast',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      'M392 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56H8 0V496H8 32V416H8 0v-8V8 0H8 392zM48 416v80H392c22.1 0 40-17.9 40-40s-17.9-40-40-40H48zm344-16c15.7 0 29.8 6.4 40 16.8V56c0-22.1-17.9-40-40-40H16V400H392zM216 64l9.2 16 32.3 56h64.7 18.5l-9.2 16-32.3 56 32.3 56 9.2 16H322.2 257.6l-32.3 56L216 352l-9.2-16-32.3-56H109.8 91.3l9.2-16 32.3-56-32.3-56-9.2-16h18.5 64.7l32.3-56L216 64zm32.3 88H183.7l-32.3 56 32.3 56h64.7l32.3-56-32.3-56zm-9.2-16L216 96l-23.1 40h46.2zm50.8 56L313 152H266.8l23.1 40zm0 32l-23.1 40H313l-23.1-40zm-50.8 56H192.9L216 320l23.1-40zm-73.9-16l-23.1-40L119 264h46.2zm-23.1-72l23.1-40H119l23.1 40z'
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fast',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      'M264 48V248H496V48H264zm-16 0H16V248H248V48zM16 264V464H248V264H16zM264 464H496V264H264V464zM0 32H16 496h16V48 464v16H496 16 0V464 48 32z'
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fast',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zm64 48v-8H48v8 56 8H64v-8V368zm192 0v-8H240v8 56 8h16v-8V368zm192 0v-8H432v8 56 8h16v-8V368zM160 448v-8H144v8 56 8h16v-8V448zm192 0v-8H336v8 56 8h16v-8V448z'
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fast',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      'M128 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM47.3 176H208.7l6.7 160H192 144 112 64 40.7l6.7-160zM120 352h16V504v8h8 48 8v-8V352h16 16l-.7-16L224 160H32L24.7 336 24 352H40 56V504v8h8 48 8v-8V352zm64 144H152V352h32V496zM104 352V496H72V352h32zM384 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-80.7 48H464.7l6.7 160H448 400 368 320 296.7l6.7-160zM376 352h16V504v8h8 48 8v-8V352h16 16l-.7-16L480 160H288l-7.3 176-.7 16h16 16V504v8h8 48 8v-8V352zm64 144H408V352h32V496zM360 352V496H328V352h32z'
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fast',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      'M128 28.8L179.5 70 192 80l10-12.5 43.8-54.7L256 0l10.2 12.8L310 67.5 320 80l12.5-10L384 28.8 400 16V36.5 128c0 70.7-57.3 128-128 128h-8V422.6C291.8 362 353 320 424 320h72 16v16c0 97.2-78.8 176-176 176H264 248 176C78.8 512 0 433.2 0 336V320H16 88c71 0 132.2 42 160 102.6V256h-8c-70.7 0-128-57.3-128-128V36.5 16l16 12.8zM204.5 90l-10 12.5L182 92.5 128 49.3V128c0 61.9 50.1 112 112 112h32c61.9 0 112-50.1 112-112V49.3L330 92.5l-12.5 10L307.5 90 256 25.6 204.5 90zM88 336H16c0 88.4 71.6 160 160 160h72c0-88.4-71.6-160-160-160zM264 496h72c88.4 0 160-71.6 160-160H424c-88.4 0-160 71.6-160 160z'
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fast',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      'M136 0h-8V8 96H16 0v16V264 464v16H16 360.2c-4.2-5.1-8.1-10.4-11.8-16H16V272H176v64 16h16H320.7c.5-5.4 1.2-10.7 2.2-16H192V272H348.5c3.6-5.6 7.6-10.9 11.8-16H352 192 176 16V112H136 376 496v80c5.4 0 10.7 .2 16 .7V112 96H496 384V8 0h-8H136zM368 96H144V16H368V96zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-224H488v8 72 8h8 56 8V360h-8H504V296v-8z'
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fast',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM264 144v-8H248v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8V319.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V144z'
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fast',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM122.1 202.9l-2.5 7.6L67.1 368H88h16 32 16 16 16 32 16 20.9L200.4 210.5l-2.5-7.6 15.2-5.1 2.5 7.6 56 168 3.5 10.5H264 232V504v8h-8H176h-8v-8V384H152V504v8h-8H96 88v-8V384H56 44.9l3.5-10.5 56-168 2.5-7.6 15.2 5.1zM104 384V496h32V384H104zm80 112h32V384H184V496zM100.9 128H219.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5h5z'
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fast',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      'M316.3 175l90.3 90.3 11.3 11.3L429.3 288l-11.3 11.3-11.3 11.3-160 160-9.4 9.4H224 32 16 0V464 448 256 242.7l9.4-9.4 160-160 11.3-11.3L192 50.7l11.3 11.3 11.3 11.3L305 163.7 434.3 34.3l11.3 11.3L316.3 175zM16 249.4V256 448v16H32 224h6.6l4.7-4.7L317.7 377 103 162.3 20.7 244.7 16 249.4zm379.3 49.9L406.6 288l-11.3-11.3-192-192L192 73.4 180.7 84.7 114.3 151 329 365.7l66.3-66.3z'
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fast',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      'M170.8 204.1l22.1-14.7 7.1-4.8V176 160 144H184 136 120v16 16 8.6l7.1 4.8 22.1 14.7L122.7 224H48v0H32V144c0-53 43-96 96-96h64c53 0 96 43 96 96v48.5 28.6V224h-1.3H280v0H264v0H197.3l-26.6-19.9zM192 240h74.3c6.9 23.1 28.3 40 53.7 40h77.4c-22.6 15.9-37.4 42.2-37.4 72H264V296v-8h-8H104c-28.2 0-51.6-20.9-55.4-48H128l32-24 32 24zM16 240H32v18.9C32 381 131 480 253.1 480H416.9C540.1 480 640 380.1 640 256.9c0-84.4-56.5-158.4-138-180.6l-43.9-12-7 14.1 66.3 51c21.8 16.8 34.6 42.7 34.6 70.2c0 20.3-9.4 38.4-24 50.2V184v-8h-8H448h-8v8 80H344v-8c0-8.8 7.2-16 16-16h8 32 8v-8V168v-8h-8H368h-8c-20.9 0-40.2 6.7-56 18V144c0-5.4-.4-10.8-1.1-16H312h8V112h-8H299.4C285.6 65.7 242.7 32 192 32H128C77.3 32 34.4 65.7 20.6 112H8 0v16H8h9.1c-.7 5.2-1.1 10.6-1.1 16v80 16zm288-16V198.9c14.4-14.1 34.2-22.9 56-22.9h8 24v48H368h-8c-17.7 0-32 14.3-32 32v8h-8c-16.4 0-30.5-9.9-36.7-24H288h16V224zM253.1 464C146.4 464 58.7 382.5 48.9 278.4C62.1 294 81.9 304 104 304H248v48H208h-8H160h-8v16h8 40 8 48 8H368h8v-8-8c0-39.7 32.1-71.8 71.7-72h.3v0h8v-8V192h56v67.2 17 87.7l-52.6 37.6-6.5 4.6 9.3 13 6.5-4.6 56-40 3.4-2.4V368 269.1c23.9-13.9 40-39.9 40-69.6c0-32.5-15.1-63.1-40.8-82.9L493 90.4l4.8 1.3C572.3 112 624 179.7 624 256.9C624 371.3 531.3 464 416.9 464H253.1zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-88 16V160h16 16 16v16l-24 16-24-16z'
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fast',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M174.3 7.2L224 32 273.7 7.2 288 0l6.5 14.6 44.9 101.1c3-1.1 5.9-2.1 8.7-3.2c15.2-5.9 27.1-11.7 35.2-16.1c4.1-2.2 7.2-4 9.2-5.2c1-.6 1.8-1.1 2.3-1.4l.6-.4 .1-.1 0 0 0 0 0 0 0 0 6.6-4.4 8.9 13.3-6.7 4.4L400 96c4.4 6.7 4.4 6.7 4.4 6.7l0 0 0 0-.1 0-.2 .1-.7 .4c-.6 .4-1.5 .9-2.6 1.6c-2.3 1.4-5.6 3.3-9.9 5.6c-8.6 4.6-21.2 10.8-37 16.9C322.2 139.7 277.2 152 224 152c-57.2 0-102.2-12.3-133-24.6c-15.4-6.2-27.2-12.3-35.3-17c-4-2.3-7.1-4.3-9.2-5.7c-1-.7-1.9-1.3-2.4-1.7l-.6-.5-.2-.1-.1 0 0 0 0 0s0 0 4.8-6.4l-4.8 6.4-6.4-4.8 9.6-12.8 6.4 4.8 0 0 0 0 .1 .1 .5 .3c.4 .3 1.1 .8 2 1.4c1.8 1.2 4.6 3 8.4 5.2c7.5 4.3 18.6 10.1 33.2 16c3.5 1.4 7.2 2.8 11.1 4.2L153.5 14.6 160 0l14.3 7.2zM280.2 21.8l-49 24.5L224 49.9l-7.2-3.6-49-24.5-44.4 100c26.7 8 60.5 14.2 100.6 14.2c38.6 0 72.7-6.8 100.2-15.2l-44-99zM96 192c0-9.5 1-18.7 3-27.6c4.9 1.6 10 3.2 15.4 4.7c-1.5 7.4-2.3 15-2.3 22.9c0 61.9 50.1 112 112 112s112-50.1 112-112c0-8.2-.9-16.2-2.5-23.9c5.3-1.6 10.4-3.2 15.3-4.8c2.1 9.2 3.2 18.8 3.2 28.7c0 11-1.4 21.8-4 32h66.7H432l-6.5 16-32.7 80-6.5 16h17.3H416l29.1 160 2.9 16H431.7 16.3 0l2.9-16L32 336H44.5 61.8l-6.5-16L22.5 240 16 224H33.3 100c-2.6-10.2-4-21-4-32zm9.3 48H39.8l36.8 89.9 9 22.1H61.8 45.4L19.2 496H167.7L136.3 386.2l-2.2-7.7 15.4-4.4 2.2 7.7 29.1 101.9 33.8-74.4-36.8-44.1L166.9 352H184h80 17.1l-10.9 13.1-36.8 44.1 33.8 74.4 29.1-101.9 2.2-7.7 15.4 4.4-2.2 7.7L280.3 496H428.8L402.6 352H386.2 362.3l9-22.1L408.2 240H342.7c-19 46.9-65 80-118.7 80s-99.7-33.1-118.7-80zM224 427.3L192.8 496h62.4L224 427.3zM128 186.7v-14c5.2 1.3 10.5 2.4 16 3.5v10.4c0 17.7 14.3 32 32 32h4.5c13.8 0 26-8.8 30.4-21.9l4.3-12.9c2.9 .1 5.9 .1 8.8 .1s5.9 0 8.8-.1l4.3 12.9c4.4 13.1 16.6 21.9 30.4 21.9H272c17.7 0 32-14.3 32-32V175.6c5.5-1.2 10.8-2.4 16-3.7v14.8c0 26.5-21.5 48-48 48h-4.5c-18.8 0-35.7-11-43.5-27.7c-7.8 16.7-24.7 27.7-43.5 27.7H176c-26.5 0-48-21.5-48-48zm96 208.8L246.9 368H201.1L224 395.5z'
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fast',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      'M240 16V32H368V16H240zM224 32V16 0h16H368h16V16 32H600h8v8V152v8h-8H384V392v8h-8H284.7c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L3.3 310.5 0 308.1V304 40 32H8 224zM384 48H368 240 224 16V299.9l108.2 79.3C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48H368V152v-8h8H592V48H384zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM288 128H96v96H288V128zM96 112H288h16v16 96 16H288 96 80V224 128 112H96zm320 80h8H528h2.7l2.2 1.7 104 80 3.1 2.4V280 392v8h-8H592h-8V384h8 32V288H424h-8V272h8H608.5l-83.2-64H424h-8V192z'
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fast',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V258.4l-62.7-94-4.4-6.7 13.3-8.9 4.4 6.7 64 96 1.3 2V256 408v8H248v-8z'
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fast',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      'M120 64h8V80h-8H16V184v8H0v-8V72 64H8 120zM0 328v-8H16v8V432H120h8v16h-8H8 0v-8V328zM392 64H504h8v8V184v8H496v-8V80H392h-8V64h8zM512 328V440v8h-8H392h-8V432h8H496V328v-8h16v8z'
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fast',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      'M128 0h8H376h8V8 96H496h16v16V464v16H496 16 0V464 112 96H16 128V8 0zM368 16H144V96H368V16zM16 112V464H496V112H376 136 16zm277.7 82.3l88 88 5.7 5.7-5.7 5.7-88 88-5.7 5.7L276.7 376l5.7-5.7L356.7 296H136h-8V280h8H356.7l-74.3-74.3-5.7-5.7L288 188.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fast',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      'M128 0h8H376h8V8 96H496h16v16V464v16H496 16 0V464 112 96H16 128V8 0zM368 16H144V96H368V16zM104 112V464H408V112H376 136 104zM88 464V112H16V464H88zM424 112V464h72V112H424zM224 176h64 8v8 64h64 8v8 64 8h-8H296v64 8h-8H224h-8v-8V328H152h-8v-8V256v-8h8 64V184v-8h8zm8 80v8h-8H160v48h64 8v8 64h48V320v-8h8 64V264H288h-8v-8V192H232v64z'
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fast',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fast',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM208 80h64 8v8 56h56 8v8 64 8h-8H280V328v8h-8H208h-8v-8V224H144h-8v-8V152v-8h8 56V88 80h8zm8 72v8h-8H152v48h56 8v8V320h48V216v-8h8 56V160H272h-8v-8V96H216v56z'
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fast',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M80 320H96v16 30.1V384l16-8 112-56H400h16V304 16 0H400 16 0V16 304v16H16 80zM16 304V16H400V304H224h-3.8l-3.4 1.7L112 358.1V320 304H96 16zm240 48v80 16h16H416l112 56 16 8V494.1 464 448h16 64 16V432 144 128H624 448v16H624V432H544 528v16 38.1L423.2 433.7l-3.4-1.7H416 272V352H256zM143.3 125l0 4.6 16 0 0-4.6c0-14.4 11.6-26 26-26h39.8c17.4 0 31.5 14.1 31.5 31.5c0 10.6-5.3 20.5-14.2 26.3l-38.9 25.6-3.6 2.4v4.3V210v8h16v-8V193.4l35.3-23.3c13.3-8.8 21.4-23.7 21.4-39.7c0-26.2-21.3-47.5-47.5-47.5H185.3c-23.2 0-42 18.8-42 42zm53.3 107.7v22.7h22.7V232.7H196.7z'
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fast',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      'M440 480l-16-96H216l-16 96H16.1 0l1.8-16 41-368L160 32H320 480L597.2 96l41 368 1.8 16H623.9 440zM200.2 381.4l2.2-13.4H216 424h13.6l2.2 13.4L453.6 464H622.1L582.2 106.1 475.9 48H320 164.1L57.8 106.1 17.9 464H186.4l13.8-82.6zM200 160v56h56 8v16h-8H200v56 8H184v-8V232H128h-8V216h8 56V160v-8h16v8zM392 272a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fast',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      'M184 32h-8v8V160H104 96v8 56H64L0 288v24 24 80l64 64H512l64-64V336 312 288l-64-64H480V168v-8h-8H192V48H408h8V32h-8H184zM464 224H112V176h72H464v48zM70.6 240H464h16 25.4L560 294.6V312v24 8H16v-8V312 294.6L70.6 240zM16 360H560v49.4L505.4 464H70.6L16 409.4V360z'
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fast',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      'M184 32H16 0V48 464v16H16 432h16V464 48 32H432 264l12 16H432V336c-20.8 0-42.9-14.2-60.7-30c-8.7-7.7-15.9-15.5-21-21.3c-2.5-2.9-4.5-5.3-5.9-7c-.7-.8-1.2-1.5-1.5-1.9l-.4-.5-.1-.1 0 0 0 0 0 0 0 0-6.2-8.3-6.4 8.2 0 0 0 0 0 0-.1 .1-.4 .5c-.4 .4-.9 1.1-1.6 1.9c-1.4 1.7-3.5 4.1-6.3 7c-5.5 5.8-13.4 13.5-23.2 21.2c-19.8 15.6-46 30.3-74.1 30.3s-54.3-14.7-74.1-30.3c-9.8-7.7-17.7-15.4-23.2-21.2c-2.7-2.9-4.9-5.3-6.3-7c-.7-.8-1.2-1.5-1.6-1.9l-.4-.5-.1-.1 0 0 0 0 0 0-6.4-8.2-6.2 8.3 0 0 0 0 0 0 0 0-.1 .1-.4 .5c-.3 .4-.8 1.1-1.5 1.9c-1.3 1.7-3.3 4.1-5.9 7c-5.1 5.8-12.4 13.6-21 21.3C58.9 321.8 36.8 336 16 336V48H172l12-16zM16 352c27.2 0 53.1-17.8 71.3-34c9.3-8.3 17.1-16.5 22.5-22.7c.9-1 1.7-1.9 2.4-2.8c.9 .9 1.8 2 2.8 3.1c5.9 6.2 14.4 14.5 24.9 22.8c20.8 16.4 50.6 33.7 84 33.7s63.2-17.3 84-33.7c10.5-8.3 19-16.6 24.9-22.8c1-1.1 2-2.1 2.8-3.1c.7 .9 1.6 1.8 2.4 2.8c5.4 6.2 13.1 14.4 22.5 22.7c18.2 16.2 44.2 34 71.3 34V464H16V352zM212 48l-45.6 60.8C157.1 121.3 152 136.4 152 152c0 39.8 32.2 72 72 72s72-32.2 72-72c0-15.6-5.1-30.7-14.4-43.2L236 48l-2-2.7L224 32 214 45.3 212 48zm12 10.7l44.8 59.7c7.3 9.7 11.2 21.5 11.2 33.6c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-12.1 3.9-23.9 11.2-33.6L224 58.7z'
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fast',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M16 80V432H40c0-1.8 .6-3.6 1.8-5.1l144-176 6.6-8 6.1 8.4 45.6 62.8L345.8 187l6.2-7.8 6.2 7.8 192 240-6.2 5h16V80H16zM58.3 432h91.4l4-5 80-100-42.1-57.9L58.3 432zm111.9 0H533.8L352 204.8 250.1 332.2 170.2 432zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM128 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fast',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      'M16 48V80H48V48H16zm128 0H112V80h32V48zm96 0H208V80h32V48zm96 0H304V80h32V48zm64 0V80h32V48H400zM229.7 162.3l-5.7-5.7-5.7 5.7-136 136L76.7 304 88 315.3l5.7-5.7L216 187.3V312 472v8h16v-8V312 187.3L354.3 309.7l5.7 5.7L371.3 304l-5.7-5.7-136-136z'
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fast',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      'M368 96l28 224H379.9l-26-208H94.1l-26 208H52L80 96H368zM149 160L129 320H112.9l20-160H149zM16 368v96H432V368H16zM0 352H16 432h16v16 96 16H432 16 0V464 368 352z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fast',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M16 496l96 0 0 16-96 0L0 512l0-16L0 16 0 0 16 0 224 0 384 160l0 144-16 0 0-128-152 0-8 0 0-8 0-152L16 16l0 480zM361.4 160L224 22.6 224 160l137.4 0zM176 368l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-24 0 0 48-16 0 0-56 0-80 0-8 8 0zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0 0 64 24 0zm96-80l32 0c22.1 0 40 17.9 40 40l0 64c0 22.1-17.9 40-40 40l-32 0-8 0 0-8 0-128 0-8 8 0zm8 128l24 0c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24l-24 0 0 112zM424 368l8 0 48 0 8 0 0 16-8 0-40 0 0 48 40 0 8 0 0 16-8 0-40 0 0 56 0 8-16 0 0-8 0-64 0-64 0-8z'
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fast',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      'M224 16c44.2 0 80 35.8 80 80v32H144V96c0-44.2 35.8-80 80-80zM128 96v32H16 0v16V496v16H16 432h16V496 144 128H432 320V96c0-50.3-38.7-91.6-88-95.7V0h-8c-53 0-96 43-96 96zM16 144H128h16H304h16H432V496H16V144zM144 312h-8v16h8H304h8V312h-8H144z'
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fast',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      'M352 48V176H496V48H352zm-16 0H176V176H336V48zM160 48H16V176H160V48zM16 192V320H160V192H16zm0 144V464H160V336H16zM176 464H336V336H176V464zm176 0H496V336H352V464zM496 320V192H352V320H496zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM176 320H336V192H176V320z'
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fast',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 199.4l96-82.3 96 82.3V208H160v-8.6zM256 96L144 192v16 16h16H352h16V208 192L256 96zM160 312.6V304H352v8.6l-96 82.3-96-82.3zM256 416l112-96V304 288H352 160 144v16 16l112 96z'
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fast',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      'M352 16H488h8v8V160v3.3l-2.3 2.3-24 24-5.7 5.7-5.7-5.7L396 127.3 213.7 309.7l-5.7 5.7L196.7 304l5.7-5.7L384.7 116 322.3 53.7 316.7 48l5.7-5.7 24-24 2.3-2.3H352zM339.3 48L464 172.7l16-16V32H355.3l-16 16zM0 32H8 200h8V48h-8H16V496H464V312v-8h16v8V504v8h-8H8 0v-8V40 32z'
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fast',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      'M291.7 6.3L288 13.4c3.7-7.1 3.7-7.1 3.7-7.1l0 0 0 0 .1 .1 .4 .2c.3 .2 .8 .4 1.4 .8c1.2 .7 3 1.7 5.3 3c4.5 2.7 10.9 6.7 18.6 12c15.3 10.6 35.8 26.5 56.2 47.8c39.8 41.4 80 103.7 82.1 186.9C470.2 245.7 502.8 224 544 224c0 0 96 8 96 112c0 144-144 176-192 176c-21.2 0-61.2-6.2-99.2-25.7c4.3-3.7 8.5-7.5 12.6-11.6c33.8 16 68.4 21.3 86.6 21.3c21.6 0 66.5-7.4 105.6-31.6C591.8 440.8 624 401.5 624 336c0-45.9-20.7-69-40.5-81.4c-10.3-6.4-20.7-10.1-28.6-12.2c-3.9-1-7.2-1.7-9.3-2c-1.1-.2-1.9-.3-2.4-.3c-23.9 .2-44.8 8.8-60.1 17.8c-7.7 4.5-13.8 9-17.9 12.4c-2.1 1.7-3.6 3-4.6 3.9c-.5 .5-.9 .8-1.1 1l-.2 .2 0 0 0 0 0 0 0 0L448 286.6l-11.3-11.3 0 0 0 0 0 0 0 0-.2-.2c-.2-.2-.6-.5-1.1-1c-1-.9-2.6-2.3-4.6-3.9c-4.1-3.3-10.2-7.9-17.9-12.4c-7-4.1-15.2-8.1-24.2-11.3c-6.1-8.2-13-15.3-20.2-21.3c33.2 4.6 59 21.9 71.4 31.8c-2.2-77.7-39.7-136.2-77.7-175.7c-19.5-20.3-39.1-35.6-53.8-45.7c-5-3.4-9.4-6.3-13-8.5c-.2 3.4-.5 7.3-1 11.7c-1.5 15.7-4.6 37.6-10.7 62.9c-10.3 42.6-29.4 95-64.8 142.4c17-10 41-20 69-20c0 0 96 8 96 112c0 144-144 176-192 176S0 480 0 336C0 224 96 224 96 224c47.1 0 82.8 28.3 93 37.3l-2.9-2.7c46.8-50.7 70.3-111.9 82.1-160.7c5.9-24.4 8.8-45.6 10.3-60.7c.7-7.5 1.1-13.5 1.3-17.6c.1-2 .1-3.6 .2-4.6l0-1.2 0-.3 0-.1 0 0v0V.3l11.7 6zm-88.4 269l0 0 0 0 0 0 0 0L192 286.6l-11.3-11.3 0 0 0 0 0 0 0 0-.2-.2c-.2-.2-.6-.5-1.1-1c-1-.9-2.6-2.3-4.6-3.9c-4.1-3.3-10.2-7.9-17.9-12.4c-15.5-9.1-36.6-17.8-60.8-17.8l0 0-.5 0c-.5 0-1.3 .1-2.3 .1c-2.1 .2-5.3 .5-9.2 1.3c-7.8 1.5-18 4.5-28 10.4C37 262.9 16 285.6 16 336c0 65.5 32.2 104.8 70.4 128.4c39 24.2 84 31.6 105.6 31.6s66.5-7.4 105.6-31.6C335.8 440.8 368 401.5 368 336c0-45.9-20.7-69-40.5-81.4c-10.3-6.4-20.7-10.1-28.6-12.2c-3.9-1-7.2-1.7-9.3-2c-1.1-.2-1.9-.3-2.4-.3c-23.9 .2-44.8 8.8-60.1 17.8c-7.7 4.5-13.8 9-17.9 12.4c-2.1 1.7-3.6 3-4.6 3.9c-.5 .5-.9 .8-1.1 1l-.2 .2z'
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fast',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm16 272v26.5V304v64 5.5V400H96V272H240zm16 128V379.5l53.2 19.9 10.8 4.1V392 280 268.5l-10.8 4.1L256 292.5V272 256H240 96 80v16V400v16H96 240h16V400zm48-19.5l-48-18V309.5l48-18v88.9z'
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fast',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      'M0 0V8 120v8H16v-8V16H120h8V0h-8H8 0zM640 0h-8H520h-8V16h8H624V120v8h16v-8V8 0zM8 512H120h8V496h-8H16V392v-8H0v8V504v8H8zm632 0v-8V392v-8H624v8V496H520h-8v16h8H632h8zM272 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM235.5 304H404.5l21.3 64H214.2l21.3-64zM416 288H224l-26.7 80L192 384h16.9H431.1 448l-5.3-16L416 288zM144 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM116.9 328l15.3-56h63.4l5.3-16H120l-19.6 72L96 344h16.6 59l5.3-16h-60zm406.1 0h-60l5.3 16h59H544l-4.4-16L520 256H439.1l5.3 16h63.4l15.3 56z'
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fast',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M128 184c0-92.8 75.2-168 168-168h27.3l-9.8 8.9c-31.4 28.6-52.7 66.1-61.2 107l-3.1 14.9 14-5.9c19.9-8.3 41.8-13 64.8-13c92.8 0 168 75.2 168 168v27.3l-8.9-9.8c-28.6-31.4-66.1-52.7-107-61.2l-14.9-3.1 5.9 14c8.3 19.9 13 41.8 13 64.8c0 92.8-75.2 168-168 168H188.7l9.8-8.9c31.4-28.6 52.7-66.1 61.2-107l3.1-14.9-14 5.9c-19.9 8.3-41.8 13-64.8 13C91.2 384 16 308.8 16 216V188.7l8.9 9.8c28.6 31.4 66.1 52.7 107 61.2l14.9 3.1-5.9-14c-8.3-19.9-13-41.8-13-64.8zM296 0C194.4 0 112 82.4 112 184c0 19.7 3.1 38.7 8.8 56.5c-32-9.4-61.2-27.5-84-52.7L13.9 162.6 0 147.3V168v48C0 317.6 82.4 400 184 400c19.7 0 38.7-3.1 56.5-8.8c-9.4 32-27.5 61.2-52.7 84l-25.2 22.9L147.3 512H168h48c101.6 0 184-82.4 184-184c0-19.7-3.1-38.7-8.8-56.5c32 9.4 61.2 27.5 84 52.7l22.9 25.2L512 364.7V344 296c0-101.6-82.4-184-184-184c-19.7 0-38.7 3.1-56.5 8.8c9.4-32 27.5-61.2 52.7-84l25.2-22.9L364.7 0H344 296zM244.7 307.3L256 318.6l11.3-11.3 40-40L318.6 256l-11.3-11.3-40-40L256 193.4l-11.3 11.3-40 40L193.4 256l11.3 11.3 40 40zM256 296l-11.3-11.3-17.4-17.4L216 256l11.3-11.3 17.4-17.4L256 216l11.3 11.3 17.4 17.4L296 256l-11.3 11.3-17.4 17.4L256 296z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fast',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M320 32v8V320c0 88.4-71.6 160-160 160S0 408.4 0 320V264v-8H16v8 56c0 79.5 64.5 144 144 144s144-64.5 144-144V40 32h16z'
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fast',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM320 160v8V344v8h8 56c53 0 96-43 96-96s-43-96-96-96H328h-8zm64 16c44.2 0 80 35.8 80 80s-35.8 80-80 80H336V176h48zm-256-8v-8H112v8 88 88 8h16v-8V264H256v80 8h16v-8V256 168v-8H256v8 80H128V168z'
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fast',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      'M144 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM79.7 128h5.2H203.1h5.2l2.1 4.8 76.9 176-14.7 6.4L197.8 144H90.2L15.3 315.2 .7 308.8l76.9-176 2.1-4.8zM88 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H160h-8v-8V352H136V504v8h-8H80 72v-8V248v-8H88v8zM496 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM458.1 202.9l-2.5 7.6L403.1 368H424h16 32 16 16 16 32 16 20.9L536.4 210.5l-2.5-7.6 15.2-5.1 2.5 7.6 56 168 3.5 10.5H600 568V504v8h-8H512h-8v-8V384H488V504v8h-8H432h-8v-8V384H392 380.9l3.5-10.5 56-168 2.5-7.6 15.2 5.1zM440 384V496h32V384H440zm80 112h32V384H520V496zM436.9 128H555.1h5.2l2.1 4.8 76.9 176-14.7 6.4L549.8 144H442.2L367.3 315.2l-14.7-6.4 76.9-176 2.1-4.8h5.2zM328 8V504v8H312v-8V8 0h16V8z'
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fast',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      'M216 507.4l8 4.6 8-4.6L448 384V130.8v-9.3l-8.2-4.4L224 0 8.1 120.4 0 125v9.3V384L216 507.4zM16 374.7V143.6l200 117V489L16 374.7zm8.1-244.9l200-111.5L423.9 126.6l-200 120.1L24.1 129.8zM432 140.4V374.7L232 489V260.5L432 140.4z'
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fast',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      'M8 56H0V72H8 280h8V56h-8H8zM8 184H0v16H8 440h8V184h-8H8zM0 312v16H8 280h8V312h-8H8 0zM8 440H0v16H8 440h8V440h-8H8z'
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fast',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      'M352 110.7L312 104 297.6 17.5 294.7 0 280.1 10.2 208 60.7 135.9 10.2 121.3 0l-2.9 17.5L104 104 17.5 118.4 0 121.3l10.2 14.5L60.7 208 10.2 280.1 0 294.7l17.5 2.9L104 312l14.4 86.5 2.9 17.5 14.5-10.2L208 355.3l72.1 50.5L294.6 416c-1.9-6.7-3.4-13.6-4.5-20.7L208 336l.1-.1-.1-.1-9.2 6.4-65.9 46.1-13.2-79-1.9-11.3-11.3-1.9-79-13.2 46.1-65.9 6.4-9.2-6.4-9.2L27.7 132.9l79-13.2 11.3-1.9 1.9-11.3 13.2-79 65.9 46.1 9.2 6.4 9.2-6.4 65.9-46.1 13.2 79 1.9 11.3 11.3 1.9 42.6 7.1V110.7zM304 208c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c18.2 0 35.1-5 49.6-13.8L286 264c11.4-15.8 18-35.1 18-56zm-96-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM392.9 261.6l7.1-4.8v-8.5V16H528V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM544 0H528 400 384V16 248.3c-38.6 25.8-64 69.8-64 119.8c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM416 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72 64H456v8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fast',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      'M217.8 0H224h56 8V16h-8H230.2l-28 112H376h8v16h-8H8 0V128H8 185.8L216.2 6.1 217.8 0zM64 512L36 176H52.1L68.7 375.8c40.3-2.1 66.6-10.2 85.5-20.8c19.7-11 32.2-25.2 44.6-40.2l2.9-3.5c11.4-13.9 23.4-28.5 41.3-40.1c19.3-12.5 44.8-21.2 82.9-23.1l6-72.1H348L320 512H64zM324.6 264.2c-34.7 2-56.8 10-72.9 20.4c-15.7 10.2-26.2 23-37.9 37.1l-2.7 3.3c-12.6 15.3-26.6 31.4-49.1 44c-21.5 12-50.2 20.5-92 22.7L78.7 496H305.3l19.3-231.8z'
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fast',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      'M5.7 250.3L0 256l5.7 5.7 136 136 5.7 5.7L158.6 392l-5.7-5.7L30.6 264l308.7 0 8 0 0-16-8 0L30.6 248 153 125.7l5.7-5.7-11.3-11.3-5.7 5.7-136 136zM328 464l-8 0 0 16 8 0 176 0 8 0 0-8 0-432 0-8-8 0L328 32l-8 0 0 16 8 0 168 0 0 416-168 0z'
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fast',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      'M500.7 148.7L512 160l-11.3 11.3L171.3 500.7 160 512l-11.3-11.3L11.3 363.3 0 352l11.3-11.3L340.7 11.3 352 0l11.3 11.3L500.7 148.7zM489.4 160L352 22.6l-63 63 52.7 52.7 5.7 5.7L336 155.3l-5.7-5.7L277.7 97 225 149.7l52.7 52.7 5.7 5.7L272 219.3l-5.7-5.7L213.7 161 161 213.7l52.7 52.7 5.7 5.7L208 283.3l-5.7-5.7L149.7 225 97 277.7l52.7 52.7 5.7 5.7L144 347.3l-5.7-5.7L85.7 289l-63 63L160 489.4 489.4 160z'
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fast',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM95.9 128h5H219.1h5l2.2 4.5 63.5 131.7c-3.7 5-7.1 10.2-10.2 15.6L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3 5.7 5.7L488 435.3l-5.7-5.7L432 379.3l-50.3 50.3-5.7 5.7L364.7 424l5.7-5.7L420.7 368l-50.3-50.3-5.7-5.7L376 300.7l5.7 5.7L432 356.7l50.3-50.3 5.7-5.7L499.3 312l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fast',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M10.5 250.2l-6 5.8 6 5.8 184 176 5.8 5.5 11.1-11.6-5.8-5.5L35.9 264 440 264l8 0 0-16-8 0L35.9 248 205.5 85.8l5.8-5.5L200.3 68.7l-5.8 5.5-184 176z'
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fast',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      'M474.8 50.1L448 144l49.7 31.1L512 184l-12.9 10.8-66.8 55.7L416 264l20.8 3.5 11.3 1.9L464 272l-3.9 15.6L448 336l43.7 37.5L504 384l-12.3 10.5L448 432l6.3 63 1.7 17-16.5-4.3L272 464l-36.2 36.2L224 512l-8.1-14.5L148 375.3 17.2 506.1l-5.7 5.7L.2 500.5l5.7-5.7L136.7 364 14.5 296.1 0 288l11.8-11.8L48 240 4.3 72.5 0 56l17 1.7L80 64l37.5-43.7L128 8l10.5 12.3L176 64l48.4-12.1L240 48l2.6 15.8 1.9 11.3L248 96l13.5-16.2 55.7-66.8L328 0l8.9 14.3L368 64l93.9-26.8L480 32l-5.2 18.1zM148.5 352.2L306.3 194.3l5.7-5.7L323.3 200l-5.7 5.7L159.8 363.5l67.9 122.2 33-33 6.5-6.5 8.9 2.3 161.8 42.2-5.7-57.1-.8-8.3 6.3-5.4L479.4 384l-41.8-35.9-7.5-6.4 2.4-9.6 11.8-47.2-30.9-5.2L379 274l26.8-22.3 79-65.9-45.3-28.3-10.2-6.4 3.3-11.6 24.1-84.3L372.4 79.4l-11.6 3.3-6.4-10.2L326.1 27.2l-65.9 79L238 133l-5.7-34.4-5.2-30.9L179.9 79.5l-9.6 2.4-6.4-7.5L128 32.6 92.1 74.4l-5.4 6.3-8.3-.8L21.3 74.2 63.5 236l2.3 8.9-6.5 6.5-33 33 122.2 67.9z'
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fast',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      'M0 168C0 92.9 60.9 32 136 32H376c75.1 0 136 60.9 136 136V280v56 8 8 8 16c0 13.3 10.7 24 24 24s24-10.7 24-24V280v-8h8 64 8v8 96c0 57.4-46.6 104-104 104c-37.1 0-69.6-19.4-88-48.6V472v8h-8H296h-8v-8V368H160V472v8h-8H8 0v-8V280 168zM496 288H16V464H144V360v-8h8H296h8v8V464H432V376v-8-8h16v8 8c0 48.6 39.4 88 88 88s88-39.4 88-88V288H576v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V360v-8-8-8V288zM16 272H496V168c0-66.3-53.7-120-120-120H136C69.7 48 16 101.7 16 168V272zM136 128v24h24 8v16h-8H136v24 8H120v-8V168H96 88V152h8 24V128v-8h16v8zm128-8v8 24h24 8v16h-8H264v24 8H248v-8V168H224h-8V152h8 24V128v-8h16zm128 8v24h24 8v16h-8H392v24 8H376v-8V168H352h-8V152h8 24V128v-8h16v8z'
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fast',
    iconName: 'hands-clapping',
    icon: [
      512,
      512,
      [],
      'e1a8',
      
      'M328 8V0H312V8 80v8h16V80 8zM225.9 20.8l-13 9.3 4.6 6.5 40 56 4.6 6.5 13-9.3-4.6-6.5-40-56-4.6-6.5zm188.3 0l-4.6 6.5-40 56-4.6 6.5 13 9.3 4.6-6.5 40-56 4.7-6.5-13-9.3zM165.7 122.3l-5.7-5.7-5.7 5.7L112 164.7 85.7 138.3 80 132.7l-5.7 5.7-48 48L20.7 192l5.7 5.7L52.7 224 10.3 266.3 4.7 272l5.7 5.7L52.7 320 10.3 362.3 4.7 368l5.7 5.7 32 32 0 0 16 16 5.7 5.7 36 35.9c31.2 31.2 73.5 48.7 117.7 48.7C309.5 512 384 437.5 384 345.6V168v-8h-8H312h-8v8 92.7L165.7 122.3zM64 212.7L43.3 192 80 155.3 100.7 176l5.7 5.7 96 96h0l5.7 5.7L219.3 272l-5.7-5.7h0L123.3 176 160 139.3 306.3 285.7 320 280V176h48V345.6C368 428.7 300.7 496 217.6 496c-39.9 0-78.1-15.8-106.3-44l-36-36-5.7-5.7-16-16L27.3 368 64 331.3l42.3 42.3 5.7 5.7L123.3 368l-5.7-5.7-48-48L64 308.7 27.3 272 64 235.3l90.3 90.3 5.7 5.7L171.3 320l-5.7-5.7-96-96L64 212.7zM432 280v8h16v-8V176h48V345.6c0 73.8-53.1 135.2-123.2 147.9c-6.2 6.5-12.8 12.6-19.8 18.3C441.5 508 512 435 512 345.6V168v-8h-8H440h-8v8 32 80z'
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fast',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      'M232 8V0H216V8 108.7L165.6 58.3 160 52.7 148.7 64l5.7 5.7L216 131.3V242.1l-96-55.4L97.4 102.5l-2.1-7.7L79.9 98.9l2.1 7.7 18.4 68.8L20.1 129.1l-6.9-4-8 13.9 6.9 4 80.3 46.3L23.6 207.7l-7.7 2.1 4.1 15.5 7.7-2.1L112 200.6 208 256l-96 55.4L27.8 288.8l-7.7-2.1-4.1 15.5 7.7 2.1 68.8 18.4L12.1 369.1l-6.9 4 8 13.9 6.9-4 80.3-46.3L82 405.4l-2.1 7.7 15.5 4.1 2.1-7.7L120 325.3l96-55.4V380.7l-61.7 61.7-5.7 5.7L160 459.3l5.7-5.7L216 403.3V504v8h16v-8V403.3l50.3 50.3 5.7 5.7L299.3 448l-5.7-5.7L232 380.7V269.9l96 55.4 22.6 84.2 2.1 7.7 15.5-4.1-2.1-7.7-18.4-68.8 80.3 46.3 6.9 4 8-13.9-6.9-4-80.3-46.3 68.8-18.4 7.7-2.1-4.1-15.5-7.7 2.1L336 311.4 240 256l96-55.4 84.2 22.6 7.7 2.1 4.1-15.5-7.7-2.1-68.8-18.4 80.3-46.3 6.9-4-8-13.9-6.9 4-80.3 46.3L366 106.6l2.1-7.7-15.5-4.1-2.1 7.7L328 186.7l-96 55.4V131.3l61.7-61.7 5.7-5.7L288 52.7l-5.7 5.7L232 108.7V8zM496 4.7L484.7 16l5.7 5.7L532.7 64l-42.3 42.3-5.7 5.7L496 123.3l5.7-5.7L544 75.3l42.3 42.3 5.7 5.7L603.3 112l-5.7-5.7L555.3 64l42.3-42.3 5.7-5.7L592 4.7l-5.7 5.7L544 52.7 501.7 10.3 496 4.7zm32 192L516.7 208l5.7 5.7L564.7 256l-42.3 42.3-5.7 5.7L528 315.3l5.7-5.7L576 267.3l42.3 42.3 5.7 5.7L635.3 304l-5.7-5.7L587.3 256l42.3-42.3 5.7-5.7L624 196.7l-5.7 5.7L576 244.7l-42.3-42.3-5.7-5.7z'
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fast',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128v8 44.7c0 14.5 5.6 28.3 15.6 38.8l22.2 23.1-39.3 27.7c-19.1 13.5-30.5 35.4-30.5 58.8V376v8h8H256h16 3.9l2.4-3.1L309 341.8 349.5 384h22.2L319 329.1l47.3-60.2 4.9-6.3-12.6-9.9-4.9 6.3-45.9 58.4-69.6-72.5 37.5-26.4c12.7-9 20.3-23.6 20.3-39.2V136v-8h-8H184h-8zm51 105.3l-23.9-24.9C196 200.9 192 191 192 180.7V144h88v35.3c0 10.4-5.1 20.1-13.5 26.1L227 233.3zm-2 21l72.8 75.9L268.1 368H160V329.2c0-18.2 8.8-35.3 23.7-45.7L225 254.3z'
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fast',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      'M273.6 47.2L227.2 0C188.8 24.4 112 93.9 112 176c0 77.8 61.7 141.2 138.9 143.9c2.2 .1 4.3 .2 6.5 .2c4 0 7.9-.3 11.8-.7C342.6 312.7 400 251.1 400 176c0-24.4-17.3-88-86.4-146.7L296 47.2 284.8 58.7 273.6 47.2zM128 176c0-36.1 17-70.6 39.8-99.8c18.6-23.8 40.3-43 57.4-55.5l48.2 49.1 11.4 11.6 11.4-11.6 18.1-18.5C370.9 104.4 384 157.9 384 176c0 41.2-19.4 77.8-49.6 101.2c6.6-11.5 10.4-24.6 10.4-38.5c0-64-87.3-122.2-87.3-122.2s-87.3 58.2-87.3 122.2c0 15.5 4.7 30.1 12.8 42.4C149.7 258 128 219.5 128 176zM256 304c-1.4 0-2.9 0-4.3-.1c-37.6-2.7-65.5-31.8-65.5-65.2c0-25.3 17.8-51.9 39.1-74c10.3-10.6 20.6-19.4 28.4-25.6c1.3-1 2.6-2 3.7-2.9c1.2 .9 2.4 1.8 3.7 2.9c7.8 6.1 18.1 14.9 28.4 25.6c21.4 22.1 39.1 48.6 39.1 74c0 32.1-25.7 60.2-61 64.8c-3.9 .4-7.8 .5-11.7 .5zM19.1 293.4l-7.4-3.1L5.6 305.1l7.4 3.1L235.1 400 12.9 491.8l-7.4 3.1 6.1 14.8 7.4-3.1L256 408.7l236.9 97.9 7.4 3.1 6.1-14.8-7.4-3.1L276.9 400l222.1-91.8 7.4-3.1-6.1-14.8-7.4 3.1L256 391.3 19.1 293.4z'
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fast',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      'M88 64c4.4 0 8 3.6 8 8V284.7l7.5 7.5 42.4-49.4 5.6-6.6 6.1 6.1 144 144 2.3 2.3V392 504v8H288v-8V395.3L152.5 259.8l-37.6 43.8 74.8 74.8 8 8 5.7 5.7L192 403.3l-5.7-5.7-8-8-80-80-5.2-5.2L82.3 293.7c-1.5-1.5-2.3-3.5-2.3-5.7V80H16V380.7L133.7 498.3l-11.3 11.3-120-120C.8 388.2 0 386.1 0 384V72c0-4.4 3.6-8 8-8H88zm456 8c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8V384c0 2.1-.8 4.2-2.3 5.7l-120 120-11.3-11.3L624 380.7V80H560V288c0 2.1-.8 4.2-2.3 5.7l-10.8 10.8-5.2 5.2-80 80-8 8-5.7 5.7L436.7 392l5.7-5.7 8-8 74.8-74.8-37.6-43.8L352 395.3V504v8H336v-8V392v-3.3l2.3-2.3 144-144 6.1-6.1 5.6 6.6 42.4 49.4 7.5-7.5V72z'
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fast',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      'M256 48C134.3 48 33.8 138.6 18.1 256H32h96V480H0V368 288C0 146.6 114.6 32 256 32s256 114.6 256 256v80V480H384V256H493.9C478.2 138.6 377.7 48 256 48zM495.5 272H400V464h96V368 288c0-5.4-.2-10.7-.5-16zm-479 0c-.3 5.3-.5 10.6-.5 16v80 96h96V272H16.5z'
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fast',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      'M0 32H384V48H0V32zM200 160H384v16H200V480H184V176H0V160H184h16z'
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fast',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM320 138l-1 1.8L185.5 384H167.3L298.5 144H136h-8V128h8H312h8v10z'
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fast',
    iconName: 'lamp-floor',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M144.6 224H128l4.6-16L192 0H448l59.4 208 4.6 16H495.4 144.6zm346.1-16L435.9 16H204.1L149.2 208H490.8zM200 496H312V256h16V496H440h8v16h-8H320 200h-8V496h8z'
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fast',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      'M164.3 7.7L256 57.1 347.7 7.7 362 0l4.7 15.6 29.9 99.7 99.7 29.9L512 150l-7.7 14.4L488 194.6c-5.5-1.2-11.1-2-16.9-2.4l17.5-32.6-96.6-29-8.3-2.5-2.5-8.3-29-96.6L263.6 71.2 256 75.3l-7.6-4.1L159.7 23.4l-29 96.6-2.5 8.3-8.3 2.5-96.6 29 47.8 88.8 4.1 7.6-4.1 7.6L23.4 352.3l96.6 29 8.3 2.5 2.5 8.3 29 96.6 88.8-47.8 7.6-4.1 7.6 4.1 88.8 47.8L364.5 448h16.7l-14.5 48.3L362 512l-14.4-7.7L256 454.9l-91.7 49.4L150 512l-4.7-15.6-29.9-99.7L15.6 366.7 0 362l7.7-14.4L57.1 256 7.7 164.3 0 150l15.6-4.7 99.7-29.9 29.9-99.7L150 0l14.4 7.7zM256 144c58.8 0 107 45.3 111.6 102.9c-2.2 3.8-4.3 7.7-6.1 11.7c-3.3 .8-6.6 1.8-9.7 2.9c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c11.3 0 22.1-1.9 32.2-5.5c-.1 1.8-.2 3.7-.2 5.5v11.4c-10.1 3-20.9 4.6-32 4.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zM400.3 297.4l-.9 8.3-8.3-1.2c-2.3-.4-4.7-.5-7.2-.5c-26.5 0-48 21.5-48 48v48h48H568h56V344c0-30.9-25.1-56-56-56c-10.7 0-20.8 3-29.3 8.3l-9.7 6L526.7 291c-6-29.1-31.8-51-62.7-51c-33.1 0-60.4 25.2-63.7 57.4zM464 224c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72v64 8h-8H568 384 328h-8v-8V352c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64z'
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fast',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      'M176 80v96h96V80H176zM160 64h16 96 16V80v96 16H272 176 160V176 80 64zM432 264h-8H24 16V248h8H424h8v16zM272 336H176v96h96V336zm-96-16h96 16v16 96 16H272 176 160V432 336 320h16z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fast',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      'M256 396.6L16 231.6V200l48-36v61.7l16 11V80H432V236.7l16-11V164l48 36v31.6l-240 165zM64 80v64L0 192v48V496v16H16 496h16V496 240 192l-64-48V80 64H432 341.3L256 0 170.7 64H80 64V80zM256 20l58.7 44H197.3L256 20zm0 396L496 251V496H16V251L256 416zm8-288v-8H248v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8V303.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V128z'
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fast',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      'M290.7 6.5l-2.7-1-2.7 1L149.3 55 144 56.9v5.6V218.5L5.4 265.2 0 267v5.7V434.9v5.2l4.7 2.1 136 61.2 3 1.3 3.1-1.1L288 451.4l141.2 52.2 3.1 1.1 3-1.3 136-61.2 4.7-2.1v-5.2V272.8 267l-5.4-1.8L432 218.5V62.6 56.9L426.7 55 290.7 6.5zM280 437.3L152 484.6v-143l128-49.8V437.3zM136 483.8l-120-54v-145l120 56.5V483.8zm15.7-251l114.1 47.4L144.3 327.4 30.2 273.7l121.5-40.9zm144.3 59l128 49.8v143L296 437.3V291.8zm-16-23L160 218.9V70.8l120 46v152zm16 0v-152l120-46V218.9L296 268.8zM396.4 61.2L288 102.7 179.6 61.2 288 22.5 396.4 61.2zm-86.1 219l114.1-47.4 121.9 41.1L431.7 327.4 310.2 280.2zM560 429.7l-120 54V341.2L560 285V429.7z'
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fast',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm128 96h8H240c44.2 0 80 35.8 80 80c0 39.2-28.2 71.8-65.3 78.7L325 384H305.2l-69.3-96H144v88 8H128v-8V280 136v-8zm16 144h96c35.3 0 64-28.7 64-64s-28.7-64-64-64H144V272z'
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fast',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      'M424 8V0H408V8 32H232V8 0H216V8 32H48 32V48 368H0v16H32 48 312V504v8h16v-8V384H592h16 32V368H608V48 32H592 424V8zM328 368H312 48V48H216v80H192h-8v16h8 32 32 8V128h-8H232V48H408v80H384h-8v16h8 32 32 8V128h-8H424V48H592V368H328z'
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fast',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 48C80.5 48 16 112.5 16 192V320c0 79.5 64.5 144 144 144s144-64.5 144-144V192c0-79.5-64.5-144-144-144z'
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fast',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      'M166.3 0h-2.9l-2.2 1.8L141.3 18.1l-78.2 64L7.4 127.7l-6.2 5.1 5.1 6.2L97.5 250.4l5.1 6.2 6.2-5.1 51.3-42V504v8h8H472h8v-8V209.5l51.3 42 6.2 5.1 5.1-6.2 91.2-111.4 5.1-6.2-6.2-5.1L576.9 82.1l-78.2-64L478.8 1.8 476.6 0h-2.9H448 416h-8-8H240h-8-8H192 166.3zM224 16h.3c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88h.3 32 22.8l17.7 14.5 78.2 64L616.3 135l-81.1 99.1-49.5-40.5-8.6-7.1L464 175.8v16.9V496H176V192.7 175.8l-13.1 10.7-8.6 7.1-49.5 40.5L23.7 135 73.3 94.5l78.2-64L169.2 16H192h32zm16.4 0H399.6c-4 40.4-38.1 72-79.6 72s-75.6-31.6-79.6-72z'
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fast',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V376v8H248v-8V104 96h16v8z'
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fast',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      'M304 103.2L432 88.9V96h16V88 80.1v-.2V48.1v-.2V40 32l-16 0v7.1L304 24.8V16 8H288v8V31.9v.2V95.9v.2V112v8h16v-8-8.8zm0-16.1V40.9L432 55.2V72.8L304 87.1zM32 432V384H416v48H32zm400 0V384v-8-8V320v-8-8V248v-8h-8H164c-37.6 0-68-30.4-68-68s30.4-68 68-68h92V88H164c-46.4 0-84 37.6-84 84s37.6 84 84 84H416v48H164C91.1 304 32 244.9 32 172S91.1 40 164 40h92V24H164C82.3 24 16 90.3 16 172c0 57.6 32.9 107.6 81 132H24 16v8 56 8 8 48 8 8 56 8h8H424h8v-8V448v-8-8zM164 320H416v48H32V320H164zM416 448v48H32V448H416z'
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fast',
    iconName: 'phone-xmark',
    icon: [
      640,
      512,
      [],
      'e227',
      
      'M512 512C264.6 512 64 311.4 64 64l0-32L208 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L432 288l144 80L544 512H512zM80 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L436 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C286.2 348.3 227.7 289.8 190 218.5l-6.2-11.7 10.3-8.3L267.4 140 199.8 18.2 80 44.8 80 64zM417.8 6.5l5.7 5.7L488 76.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L499.3 88l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L488 99.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L476.7 88 412.1 23.4l-5.7-5.7L417.8 6.5z'
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fast',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      'M88 0h80 8V8 88v2.6l-1.5 2.1L136 146.6v29.7c58.1 3.2 104 41.3 104 87.8c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-.8 1.6-1.7 3.1-2.4 4.8c-3.4-10.5-9.2-20.4-17.2-29.2c-15.6-17.3-16.2-44.2-4.5-62.7c6-9.4 9.2-19.8 9.2-30.6c0-34.7-35.5-68.6-88-71.8v88.6c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V192.2c-52.5 3.2-88 37.1-88 71.8c0 10.8 3.2 21.1 9.2 30.6c11.7 18.5 11.1 45.4-4.5 62.7C23.4 371.9 16 389.4 16 408c0 45.7 46.9 88 112 88c43 0 78-18.5 96.9-44.1c.9 6.8 2.4 13.3 4.5 19.6C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-46.5 45.9-84.6 104-87.8V146.6L81.5 92.6 80 90.6V88 8 0h8zm72 85.4V16H96V85.4l32 44.8 32-44.8zM392 240c56 0 64-48 64-48h16 16v16 21.5c0 12.9-4.3 25.4-8.5 37.8l0 0 0 0 0 0 0 0 0 0c-1.4 4-2.7 7.9-3.9 11.8c-2.1 6.8-3.6 15.1-3.6 24.8c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8H329.8C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-9.8-1.5-18-3.6-24.8c-1.2-3.9-2.5-7.9-3.9-11.8l0 0 0 0 0 0 0 0 0 0c-4.2-12.4-8.5-25-8.5-37.8V192 176h16 16s0 64 64 64V163l-46.1-53.8-2.4-2.8 .6-3.7 16-96L345.2 0H352h32c22.1 0 40 17.9 40 40c0 19.4-13.7 35.5-32 39.2V160v80zm-61.9 3.3c-11.8-7.9-19.5-18.3-24.4-28.2c-4.2-8.3-6.5-16.6-7.9-23.2H296v37.5c0 6.2 1.4 12.9 3.7 20.5c1.1 3.8 2.5 7.7 3.9 11.8l.2 .5c1.3 3.9 2.8 8.1 4 12.3c2.5 8.2 4.3 18.1 4.3 29.5c0 37.8-18.7 78.2-30.7 100.4c-5.9 11-9.3 22.5-9.3 33.8c0 31.9 25.9 57.8 57.8 57.8H438.2c31.9 0 57.8-25.9 57.8-57.8c0-11.3-3.4-22.8-9.3-33.8C474.7 382.2 456 341.8 456 304c0-11.4 1.7-21.3 4.3-29.5c1.3-4.2 2.7-8.4 4-12.3l0 0 .2-.5c1.4-4.1 2.7-8 3.9-11.8c2.3-7.7 3.7-14.3 3.7-20.5V208h-4.3c-2.1 5.1-5.3 11.3-9.9 17.6C446 241.3 425.4 256 392 256H376c-18.8 0-34-4.7-45.9-12.7zM128 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM376 138.4V72 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H358.8l-14.3 85.6L376 138.4zM352 320h64 8v16h-8H352h-8V320h8zm0 64h64 8v16h-8H352h-8V384h8z'
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fast',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      'M16 104c0-30.9 25.1-56 56-56s56 25.1 56 56v91.3L156.7 224 128 252.7V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V344v-8H412.2L384 371.2 355.8 336H272v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V259.3L179.3 224 144 188.7V104c0-22.6-10.4-42.8-26.7-56H408c30.9 0 56 25.1 56 56v20.7L428.7 160 464 195.3v25.4L428.7 256 464 291.3V304h16V284.7L451.3 256 480 227.3V188.7L451.3 160 480 131.3V104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104V208H96V192H16V104zM496 464H256c19.4-14.6 32-37.8 32-64V352h60.2L384 396.8 419.8 352H560l0 48c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fast',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 296c0 66.3-53.7 120-120 120H312h-8V400h8 16c57.4 0 104-46.6 104-104v-8H272 256V272 112 96h16H432h16v16 88 72 16 8zm-16-96V112H272V272H432V200zM192 296c0 66.3-53.7 120-120 120H56 48V400h8H72c57.4 0 104-46.6 104-104v-8H16 0V272 112 96H16 176h16v16 88 72 16 8zm-16-96V112H16V272H176V200z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fast',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      'M327.6 353.8L216.1 465.3 84.4 491.6l26.3-131.7 99.1-99.1-12.6-10L96 352 67.4 495 64 512l17-3.4L224 480 340.3 363.7l-12.6-10zM298.3 42.3l-58.6 58.6 12.6 10L304 59.3l42.3 42.3-46.6 46.6 12.6 10L357.7 113 463 218.3l-32.9 32.9 12.6 10 31.6-31.6 0 0 11.3-11.3 0 0 79-79L576 128l-11.3-11.3L459.3 11.3 448 0 436.7 11.3l-79 79-48-48L304 36.7l-5.7 5.7zM474.3 207L369 101.7l79-79L553.4 128l-79 79zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fast',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      'M224 0H204.7l13.7 13.7 5.3 5.3C234.1 29.4 240 43.7 240 58.5V74.7c0 25-20.3 45.3-45.3 45.3H183.2 160c-39.8 0-72 32.2-72 72c0 11.9 2.9 23.1 8 32.9c-36.3 5.8-64 37.2-64 75.1c0 22 9.3 41.7 24.2 55.6C23.6 365.7 0 396.1 0 432v72 8H8 504h8v-8V432c0-35.9-23.6-66.3-56.2-76.4C470.7 341.7 480 322 480 300c0-37.9-27.7-69.3-64-75.1c5.1-9.9 8-21.1 8-32.9c0-37.1-28-67.6-64-71.6C359.5 53.8 305.4 0 238.6 0H224zm32 58.5c0-15.4-4.9-30.2-13.8-42.5C298.7 17.9 344 64.4 344 121.4c0 1.9-.1 3.8-.3 5.7l-1 8.9h9 .4c30.9 0 56 25.1 56 56c0 13.3-4.6 25.4-12.3 35l-10.4 13H402h2c33.1 0 60 26.9 60 60c0 23-12.9 42.9-31.9 53l-25.5 13.5 28.8 1.5c33.8 1.8 60.6 29.7 60.6 63.9v64H16V432c0-34.2 26.8-62.1 60.6-63.9l28.8-1.5L79.9 353C60.9 342.9 48 323 48 300c0-33.1 26.9-60 60-60h2 16.7l-10.4-13c-7.7-9.6-12.3-21.7-12.3-35c0-30.9 25.1-56 56-56h23.2 11.5c33.9 0 61.3-27.5 61.3-61.3V58.5zM192 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 368H148.5l4.1 10.8L160 376c-7.5 2.8-7.5 2.8-7.5 2.8l0 0 0 0 0 .1 .1 .2 .3 .7c.2 .6 .6 1.3 1 2.3c.9 1.9 2.2 4.6 4 7.9c3.6 6.4 9.2 15 17.3 23.5C191.3 430.7 217.3 448 256 448s64.7-17.3 80.8-34.5c8-8.6 13.6-17.1 17.3-23.5c1.8-3.2 3.1-5.9 4-7.9c.4-1 .8-1.7 1-2.3l.3-.7 .1-.2 0-.1 0 0 0 0s0 0-7.5-2.8l7.5 2.8 4.1-10.8H352 160zm26.8 34.5c-6.2-6.6-10.7-13.2-13.9-18.5H339c-3.1 5.3-7.7 11.9-13.9 18.5C311.3 417.3 289.3 432 256 432s-55.3-14.7-69.2-29.5z'
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fast',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      'M555.7 301.7c-5.6 28.9 12.7 61.7 44.3 65.8v.4h6.7l.1 0H608l16 0v15.9 .2V400H608l0 0-8 0H560l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v16 16H544h-8H320 40 32 16V480 464H32h8 4.9c26.6 0 45.8-18.3 55.5-38.6c9.7-20.3 12-46.4 1.9-68.2C88 326.4 80 292.2 80 256C80 123.5 187.5 16 320 16s240 107.5 240 240c0 15.6-1.5 30.9-4.3 45.7zm51 50.3c-23.6 0-39.8-24.1-35.3-47.2c3-15.8 4.6-32.1 4.6-48.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 38.5 8.5 75.1 23.8 107.9c15.5 33.4-6 84.1-42.9 84.1H40 32 8 0v8 24 24 8H8 32h8H320 536h8 24 8v-8V480 456v-8h-8H544c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0 8 0 0 0h24 8v-8V384.1l0-.1 0-.1V360v-8h-8l-24 0h-1.3l0 0zM271 193.2a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zm135 52.7a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zM284.8 371.4c50.4 13.5 92.7-2.4 119.4-20.6l-9-13.3c-24.1 16.3-61.6 30.3-106.3 18.3s-70.2-42.9-82.9-69.1l-14.4 7c14.1 29.1 42.8 64 93.2 77.5z'
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fast',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zM200 96h64 8v8 64h64 8v8 64 8h-8H272v64 8h-8H200h-8v-8V248H128h-8v-8V176v-8h8 64V104 96h8zm8 80v8h-8H136v48h64 8v8 64h48V240v-8h8 64V184H264h-8v-8V112H208v64z'
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fast',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      'M160 475.3l5.7-5.7 104-104 5.7-5.7L264 348.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L61.7 354.3 56 348.7 44.7 360l5.7 5.7 104 104 5.7 5.7zM336 192H464h16V176 48 32H464 336 320V48 176v16h16zm128-16H336V48H464V176zM320 480h16H528h16V464 272 256H528 336 320v16V464v16zM528 272V464H336V272H528z'
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fast',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V80 72H248v8V288.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fast',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M155.6 0H160 288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0zm128 16H164.4l-30 48H313.6l-30-48zM24 112.8L24 112H40L79.2 496H368.8L408 112H424l-.1 .8-40 392-.7 7.2H376 72 64.8l-.7-7.2-40-392z'
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fast',
    iconName: 'hand-fingers-crossed',
    icon: [
      384,
      512,
      [],
      'e1a3',
      
      'M89.5 4l3.1 7.4 15.6 36.8L120 76.1l11.8-27.9 15.6-36.8L150.5 4l7.4 3.1 73.7 31.2 7.4 3.1-3.1 7.4L220.2 85.6 148.1 256H208V192v-8h8 80 8v8 8h72 8v8 72 64 8 8c0 83.9-68.1 152-152 152H152C68.1 512 0 443.9 0 360V264v-8H8 43.9l7.9-18.7 16.1-38L19.8 85.6 4.2 48.8 1.1 41.4l7.4-3.1L82.1 7.1 89.5 4zM76.6 178.7l34.7-82.1L93.5 54.4 81 25 22.1 49.9 34.5 79.4l42 99.4zM61.3 256h69.5L205.5 79.4l12.5-29.5L159 25 146.5 54.4l-80 189.1L61.3 256zM368 280V216H304V336h64V280zm0 72H304h-8-8H224h-8-8H104 96V336h8H208V272H16v88c0 75.1 60.9 136 136 136h80c75.1 0 136-60.9 136-136v-8zM224 336h64V208v-8H224l0 56v8l0 72z'
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fast',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      'M528 240.4l12 3.1c48.3 12.4 84 56.3 84 108.5V464H512 144 16V336c0-55.7 35.6-103.1 85.3-120.7l10.7-3.8V200.2 192c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2l8.5 14.8 14.2-9.5c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80v36 12.4zM96 200.2C40.1 220 0 273.3 0 336V464v16H16 144 512 624h16V464 352c0-59.6-40.8-109.8-96-124V192c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192v8.2zM512 368h-8H296h-8v16h8H504h8V368zm-264 0H136h-8v16h8H248h8V368h-8zM128 304v16h8H344h8V304h-8H136h-8zm264 0h-8v16h8H504h8V304h-8H392z'
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fast',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      'M448 512C200.6 512 0 311.4 0 64L0 32 144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448zM16 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L372 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C222.2 348.3 163.7 289.8 126 218.5l-6.2-11.7 10.3-8.3L203.4 140 135.8 18.2 16 44.8 16 64zM501.7 21.7L315.3 208H440h8v16h-8H296h-8v-8V72 64h16v8V196.7L490.3 10.3 496 4.7 507.3 16l-5.7 5.7z'
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fast',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      'M224 80H160V48c0-17.7 14.3-32 32-32s32 14.3 32 32V80zm16 0V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V80H112 96V96v48 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V144 96 80H272 240zm25.4 80c38.7 17.8 69.8 49.1 87.2 88H31.4c17.4-38.9 48.6-70.2 87.2-88H265.4zM144 96h16 64 16 32v48H112V96h32zM16 320c0-19.6 3.2-38.4 9.1-56H358.9c5.9 17.6 9.1 36.4 9.1 56s-3.2 38.4-9.1 56H25.1c-5.9-17.6-9.1-36.4-9.1-56zM192 496c-71.6 0-133.1-42.7-160.6-104H352.6C325.1 453.3 263.6 496 192 496z'
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fast',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM408 368v8V504v8H392v-8V397.6l-32.9 62.1-6.9 13.1-7.1-13-33-60V504v8H296v-8V376v-8l8 0 4 0 4.7 0 2.3 4.1 36.9 67 35.5-66.9 2.3-4.3 4.8 0 5.6 0 8 0zm-224 0v8c0 8.9 2.6 17.5 7.5 24.9L208 425.6l16.5-24.7c4.9-7.4 7.5-16 7.5-24.9v-8h16v8c0 12-3.6 23.8-10.2 33.8L217.6 440l20.2 30.2c6.7 10 10.2 21.7 10.2 33.8v8H232v-8c0-8.9-2.6-17.5-7.5-24.9L208 454.4l-16.5 24.7c-4.9 7.4-7.5 16-7.5 24.9v8H168v-8c0-12 3.6-23.8 10.2-33.8L198.4 440l-20.2-30.2C171.6 399.8 168 388 168 376v-8h16zM456 512v-8V376v-8h16v8V496h24 8v16h-8H464h-8z'
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fast',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      'M128 32h-5.4l-2 5-62 155H16 0v16V384v16H16 65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H624h16V384 208 192H624 515.8L390.2 35l-2.4-3H384 128zM576 384c0-53-43-96-96-96s-96 43-96 96H256c0-53-43-96-96-96s-96 43-96 96H16V208H128V192H75.8L133.4 48H380.2L495.4 192H448v16H624V384H576zM160 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM334.2 97.9l6.1-24.3L321.2 89.9 186.8 205.1l-16.4 14.1H192h66.6l-16.7 66.9-6.1 24.3 19.1-16.3L389.2 178.9l16.4-14.1H384 317.4l16.7-66.9zM268.8 203.2H213.6l98.9-84.8-13.1 52.5-2.5 9.9h10.2 55.2l-98.9 84.8 13.1-52.5 2.5-9.9H268.8z'
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fast',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      'M248 104v8h16v-8V8 0H248V8v96zm8 72a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-8 160h16v-8V408v-8H248v8 96 8zM0 248v16H8h96 8V248h-8H8 0zm408 0h-8v16h8 96 8V248h-8H408zM69.3 431.4l11.3 11.3 5.7-5.7 67.9-67.9 5.7-5.7-11.3-11.3-5.7 5.7L75 425.7l-5.7 5.7zM357.8 142.9l-5.7 5.7 11.3 11.3 5.7-5.7L437 86.3l5.7-5.7L431.4 69.3 425.7 75l-67.9 67.9zM80.6 69.3L69.3 80.6 75 86.3l67.9 67.9 5.7 5.7 11.3-11.3-5.7-5.7L86.3 75l-5.7-5.7zM369.1 357.8l-5.7-5.7-11.3 11.3 5.7 5.7L425.7 437l5.7 5.7 11.3-11.3-5.7-5.7-67.9-67.9z'
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fast',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      'M17.5 176L74.4 48H216V176H17.5zm413 0H232V48H373.6l56.9 128zM16 192H352h80 16V176L384 32H64L0 176V464v16H16 296.2c-4.2-5.1-8.1-10.4-11.8-16H16V192zm416 48a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L496 316.7l-5.7 5.7L416 396.7l-42.3-42.3-5.7-5.7L356.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fast',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      'M144 0h8 80 8V8 39c69.4 20.7 120 84.9 120 161v24h16 8v16h-8H352 32 8 0V224H8 24V200C24 123.9 74.6 59.6 144 39V8 0zM344 200c0-70.8-48.4-130.3-114-147.2l-6-1.5V45 16H160V45v6.2l-6 1.5C88.4 69.7 40 129.2 40 200v24H344V200zM242.1 472.6c-1.3 2.4-2.1 5-2.1 7.7c0 8.6 7 15.6 15.6 15.6h.8c8.6 0 15.6-7 15.6-15.6c0-2.7-.7-5.4-2.1-7.7L256 448.2l-13.9 24.4zm-13.9-7.9l18.6-32.6L256 416l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7zM320 320.2l-13.9 24.4c-1.3 2.4-2.1 5-2.1 7.7c0 8.6 7 15.6 15.6 15.6h.8c8.6 0 15.6-7 15.6-15.6c0-2.7-.7-5.4-2.1-7.7L320 320.2zm-9.2-16.1L320 288l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zM114.1 472.6c-1.3 2.4-2.1 5-2.1 7.7c0 8.6 7 15.6 15.6 15.6h.8c8.6 0 15.6-7 15.6-15.6c0-2.7-.7-5.4-2.1-7.7L128 448.2l-13.9 24.4zm-13.9-7.9l18.6-32.6L128 416l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8C110.2 512 96 497.8 96 480.4c0-5.5 1.4-10.9 4.2-15.7zM192 320.2l-13.9 24.4c-1.3 2.4-2.1 5-2.1 7.7c0 8.6 7 15.6 15.6 15.6h.8c8.6 0 15.6-7 15.6-15.6c0-2.7-.7-5.4-2.1-7.7L192 320.2zm-9.2-16.1L192 288l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6h-.8c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zM50.1 344.6c-1.3 2.4-2.1 5-2.1 7.7C48 361 55 368 63.6 368h.8C73 368 80 361 80 352.4c0-2.7-.7-5.4-2.1-7.7L64 320.2 50.1 344.6zm-13.9-7.9l18.6-32.6L64 288l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7C96 369.8 81.8 384 64.4 384h-.8C46.2 384 32 369.8 32 352.4c0-5.5 1.4-10.9 4.2-15.7z'
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fast',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      'M256 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96 304H288l-26.7 80L256 512h16.9H560h16V496 464L457.8 301.5 448 288l-10 13.4-54.8 73-6-3.3-60.6-33.7-4.9-12.2L253.7 180.1l-5.1-12.7-12.7-5.1-80-32-22-8.8L119 140 70.5 200.7 27.9 177l-7-3.9-7.8 14 7 3.9L369.5 385.1l4 2.2L352 416zM238.9 186.1l55.6 139.1L84.7 208.6 131.5 150l7.4-9.3 11 4.4 80 32 6.4 2.5 2.5 6.4zM447.8 314.9L560 469.2V496H278.2l21.3-64H352h8l4.8-6.4 83-110.7zm-383.9-26l-.2 .7L6.8 496 2.4 512H19 68.8l40.8-148.2 4.4-16.1 14.2 8.8L160 376.2V480v16 16h16 32 16V496 480 358.3 340.9L208 332v26.4V480v16H176V480 376.2v-8.9l-7.6-4.7-45.9-28.4-18.2-11.2-5.7 20.6L56.6 496H23.4L79.1 293.9l.2-.5 8.5-28.2-14.3-8-9.5 31.7z'
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fast',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      'M402.7 16.2C390.6 17.4 379.6 22.4 371 30l0 0c-.6 .5-1.1 1-1.6 1.5C383.4 47.7 392 68.8 392 92v12.6l.6 0c17 1.2 33 6 47.3 13.5c1.8-1.3 3.5-2.6 5.2-4.1l0 0c2.9-2.6 5.5-5.4 7.9-8.5c.9-1.2 1.7-2.4 2.5-3.6C460.8 93.2 464 83 464 72c0-30.9-25.1-56-56-56c-1.8 0-3.5 .1-5.3 .2zM408 0c39.8 0 72 32.2 72 72c0 2.7-.1 5.3-.4 8c-1.2 10.9-4.8 21.1-10.3 29.9c-3.7 6-8.3 11.5-13.6 16.1l0 0c-.4 .4-.8 .7-1.2 1.1C484.6 149 504 184.5 504 224.3V256v8h-8H373.2l-35.8 78.8 57 17.5 5.6 1.7V368v40 8h-8H344h-8H104 96 56c-22.1 0-40 17.9-40 40s17.9 40 40 40H472h8v16h-8H56c-30.9 0-56-25.1-56-56s25.1-56 56-56H96V336c0-87.3 66.6-159 151.7-167.2C223.4 153.9 208 127.3 208 98V92c0-50.8 41.2-92 92-92c21.9 0 42 7.6 57.8 20.4c.8-.8 1.7-1.6 2.6-2.4l0 0c3.8-3.4 8-6.4 12.5-8.9C383.3 3.3 395.3 0 408 0zM336 96v32 8h-8H296h-8V120h8 24V96 88h16v8zm80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 336v64H336h8 40V373.9l-98.4-30.3-7.6-2.4 4.7-15.3 7.6 2.4 31.6 9.7 38.8-85.4 2.1-4.7H368 488V224.3c0-54.6-42.2-99.8-96.6-103.7l-8-.6-7.4-.5V112 92c0-42-34-76-76-76s-76 34-76 76v6c0 28.8 18.4 54.4 45.8 63.5l20.7 6.9L288 184H264c-83.9 0-152 68.1-152 152z'
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fast',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M0 32H8 109.2 120h8H462.8 480l-6.4 16-53 132.4C475.5 214.3 512 274.9 512 344c0 80-72 136-72 136H136s-72-56-72-136c0-69 36.4-129.5 91-163.3L97.1 50.6c-.4-.8-.6-1.7-.8-2.6H16V216v8H0v-8V40 32zM170.4 176H405.2L456.4 48H128h-8-6.5l56.9 128zM416 192H160v0h7.2c-41.1 24.1-71.6 64.3-82.7 112H491.4c-11.1-47.7-41.6-87.9-82.7-112H416v0zm78.4 128H81.6c-1.1 7.8-1.6 15.9-1.6 24c0 35.2 15.9 65.9 32.8 88.4c8.4 11.2 16.8 20 23 26.1c2.3 2.3 4.4 4.1 6 5.5H434.2c1.6-1.4 3.6-3.3 6-5.5c6.3-6 14.7-14.9 23-26.1C480.1 409.9 496 379.2 496 344c0-8.1-.6-16.2-1.6-24z'
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fast',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      'M192 240L64 280 0 480l10.3 10.3 11.3 11.3L32 512l200-64 40-128L500.1 114.7 512 104 500.7 92.7 419.3 11.3 408 0 397.3 11.9 192 240zM105.9 417.4c6.3 4.2 13.9 6.6 22.1 6.6c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 8.2 2.4 15.7 6.6 22.1l-73 73-3.4-3.4L76.7 292.8l119.4-37.3 60.4 60.4L219.2 435.3 36.4 493.8 33 490.3l73-73zm102.7-172L408.6 23.2l80.2 80.2L266.6 303.3l-57.9-57.9zM104 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fast',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      'M336 464l0-416h96l0 416H336zm-16 16h16 96 16V464l0-416V32H432 336 320V48l0 416v16zM112 400H16L16 48h96l0 352zM16 416h96 16V400l0-352 0-16H112 16 0L0 48 0 400l0 16H16zM272 272l-96 0 0-224 96 0V272zm-96 16l96 0h16V272 48 32H272l-96 0H160l0 16 0 224v16h16z'
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fast',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      'M426.9 20.4L384 192l74.3 208h-17L368.9 197.4l-1.6-4.6 1.2-4.7L408 29.9 188.3 139.7 72.6 400H55.1L176 128 413.2 9.4 432 0l-5.1 20.4zM496 448H16v48H496V448zM16 432H496h16v16 48 16H496 16 0V496 448 432H16zM280 144v24h24 8v16h-8H280v24 8H264v-8V184H240h-8V168h8 24V144v-8h16v8zM232 280v48h48 8v16h-8H232v56H216V344H168h-8V328h8 48V280v-8h16v8z'
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fast',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      'M16 464L16 48l416 0 0 416L16 464zM0 480l16 0 416 0 16 0 0-16 0-416 0-16-16 0L16 32 0 32 0 48 0 464l0 16zM112 144l32 0 0 16 0 128 0 16-32 0 0-16 0-128 0-16zm48 144l0-128 0-16 0-16-16 0-32 0-16 0 0 16 0 16 0 128 0 16 0 16 16 0 32 0 16 0 0-16 0-16zM336 160l0 192 0 16-32 0 0-16 0-192 0-16 32 0 0 16zm16-32l-16 0-32 0-16 0 0 16 0 16 0 192 0 16 0 16 16 0 32 0 16 0 0-16 0-16 0-192 0-16 0-16zM240 160l0 64 0 16-32 0 0-16 0-64 0-16 32 0 0 16zm16 0l0-16 0-16-16 0-32 0-16 0 0 16 0 16 0 64 0 16 0 16 16 0 32 0 16 0 0-16 0-16 0-64z'
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fast',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M322.9 8.5L320 7.4l-2.9 1.1-312 120-5.1 2V136 504v8H16v-8V141.5L320 24.6 624 141.5V504v8h16v-8V136v-5.5l-5.1-2-312-120zM104 192H96v8V504v8h16v-8V208H528V504v8h16v-8V200v-8h-8H104zm121.3 48h5.8H408.9h5.8l1.8 5.5L445.8 336H472h8v8V504v8H464v-8V464H176v40 8H160v-8V344v-8h8 26.2l29.3-90.5 1.8-5.5zM176 448H464V352H176v96zM403.1 256H236.9L211 336H429l-25.9-80zM208 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm208-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fast',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      'M8 32H0v8 64 8H16v-8V48H216l0 224H160h-8v16h8 64 64 8V272h-8H232l0-224H432v56 8h16v-8V40 32h-8H224 8zM442.1 389.7l5.7-5.7-5.7-5.7-80-80-5.7-5.7L345.2 304l5.7 5.7L417.2 376 30.5 376l66.3-66.3 5.7-5.7L91.2 292.7l-5.7 5.7-80 80L-.1 384l5.7 5.7 80 80 5.7 5.7L102.5 464l-5.7-5.7L30.5 392l386.6 0-66.3 66.3-5.7 5.7 11.3 11.3 5.7-5.7 80-80z'
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fast',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      'M224 0h8 46.1H288 568h8V8 440v8 56c0 4.4-3.6 8-8 8s-8-3.6-8-8V448H312h-8v-8V368v-1.2l.4-1.1 31.4-102L281.6 16H240V192H224V8 0zm73.9 16l53.9 246.3 .5 2.1-.6 2L320 369.2V432H560V16H297.9zM240 320V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V320h16zm-82.7-96H224h16 16v16 32 16H240 224 144 130.7l-2.7-2.7-6.6-6.6-9.4-9.4 0 18.7 0 3.9 0 49.4 41.6 55.5 6.4 8.5V416v64 16 16H144 112 96V496 480 426.7L80 405.3 64 384v26.7V480v16 16H48 16 0V496 480 298.7l0 0V288 192 176 160H16 32 80 93.3l9.4 9.4L157.3 224zM240 240H224 157.3h-6.6l-4.7-4.7L91.3 180.7 86.6 176H80 32 16v16 96 5.3l0 0v5.3V480v16H48V480 384 336l28.8 38.4 32 42.7 3.2 4.3v5.3V480v16h32V480 416v-5.3l-3.2-4.3L99.2 350.9 96 346.7l0-5.3 0-72.1 0-38.6 27.3 27.3 9.4 9.4 4.7 4.7H144h80 16V240zM64 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 80a48 48 0 1 1 96 0A48 48 0 1 1 16 80z'
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fast',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      'M256 496C123.5 496 16 388.5 16 256c0-63.4 24.6-121.1 64.7-164L420 431.3C377.1 471.4 319.4 496 256 496zM92 80.7C134.9 40.6 192.6 16 256 16c132.5 0 240 107.5 240 240c0 63.4-24.6 121.1-64.7 164L92 80.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm40.4-159l-15 15H230.6L192 329.4V248.6l-31.6-31.6-30.2-8.6-7.7-2.2-4.4 15.4 7.7 2.2L176 238v43l-49.1 7-7.9 1.1 2.3 15.8 7.9-1.1 46.9-6.7V336l.6 .6-37.1 24.7-6.7 4.4 8.9 13.3 6.7-4.4 39.7-26.5L224 384h64l19.7-19.7L296.4 353zM224 128l-19.7 19.7L215.6 159l15-15h50.7L320 182.6v49.2 .3 31.3l16 16V238l50.2-14.3 7.7-2.2-4.4-15.4-7.7 2.2L336 221.4V176l-.6-.6 37.1-24.7 6.7-4.4-8.9-13.3-6.7 4.4-39.7 26.5L288 128H224zM385.1 288.1l-47.2-6.7 18.9 18.9 26.1 3.7 7.9 1.1 2.3-15.8-7.9-1.1z'
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fast',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      'M576 192V176 80 64H560 16 0V80v96 16c53 0 96 43 96 96v48l0 0 16 11.5V288c0-56.4-41.7-103.1-96-110.9V80H560v97.1c-54.3 7.8-96 54.4-96 110.9v59.5L480 336V288c0-53 43-96 96-96zM368 272V381.1c5.5 1.2 10.8 1.9 16 1.9V272c0-53-43-96-96-96s-96 43-96 96V383c5.2 0 10.5-.7 16-1.9V272c0-44.2 35.8-80 80-80s80 35.8 80 80zM96.6 395c-.2-.3-.4-.6-.6-.9c-.2 .3-.4 .6-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 449.8 22.5 464 0 464v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V464c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 449.8 406.5 464 384 464s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9c-.2 .3-.4 .6-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 449.8 214.5 464 192 464s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fast',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      'M80 80v56V376v56H560V376 136 80H80zm496 0v48h56c4.4 0 8 3.6 8 8V376c0 4.4-3.6 8-8 8H576v48 16H560 80 64V432 384H8c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8H64V80 64H80 560h16V80zm0 288h48V144H576V368zM64 144H16V368H64V144zm64-16V384H512V128H128zm-16-16h16H512h16v16V384v16H512 128 112V384 128 112zm72 64H456h8v16h-8H184h-8V176h8zm0 72H456h8v16h-8H184h-8V248h8zm0 72H456h8v16h-8H184h-8V320h8z'
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fast',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      'M376.7 80.8L415 11.9 401 4.1l-40 72-1.7 3.1 1.1 3.3 14.1 42.2L320 161.1V137.9v-32H296.2V63.7 55.5H279.8v8.2 42.2H256v32V161l-54.5-36.3 14.1-42.2 1.1-3.3L215 76.1l-40-72-14 7.8 38.3 68.9-14.9 44.7-1.9 5.8 5.1 3.4 62.3 41.5L76.3 202.1C32.7 207.6 0 244.6 0 288.6c0 77.6 93.8 116.5 148.8 61.9L256 257.1v19.6l-53.7 53.7-2.3 2.3V336v45.9l-39 70.2 14 7.8 40-72 1-1.8V384 339.3l40-40v61.3 32h64v-32V299.3l18.3 18.3 11.3-11.3L320 276.7V257.1l26.7 23.3 6 5.3 10.5-12.1-6-5.3L320 235.9V191.4l177.4 26.5 0 0 .2 0c4.2 .5 8.2 1.4 12.1 2.6l7.7 2.3 4.7-15.3-7.6-2.3c-4.7-1.4-9.6-2.5-14.7-3.1L326.2 176.2l62.3-41.5 5.1-3.4-1.9-5.8L376.7 80.8zM256 191.4v44.5L138.1 338.6c-.1 .1-.3 .2-.4 .4C92.8 383.9 16 352.1 16 288.6c0-35.9 26.8-66.2 62.4-70.7l0 0 .2 0L256 191.4zM392 376h-8v16h8 32v64H392h-8v16h8 32v32 8l16 0v-8V472h64v32 8l16 0v-8V472h64v32 8l16 0v-8V472h32 8V456h-8H600V392h32 8V376h-8H600V312h32 8V296h-8H600V264v-8H584v8 32H520V264v-8H504v8 32H440V264v-8H424v8 32H392h-8v16h8 32v64H392zm192 16v64H520V392h64zm0-80v64H520V312h64zM440 392h64v64H440V392zm0-16V312h64v64H440zM272 360.6l0-222.7v-16h32v16l0 222.7v16H272v-16z'
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fast',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      'M209.7 302.3c-15.3-15.3-34.9-25.3-55.9-28.9C187 138.8 252.2 72.6 317.8 41.7c63-29.7 128.7-27.9 171.5-19c8.8 42.8 10.7 108.5-19 171.5c-30.9 65.6-97.1 130.8-231.8 164c-3.6-21-13.6-40.6-28.9-55.9zM240 375.6l0-1.2c51.4-12.5 93.6-29.6 128-49.8l0 94.5-128 64 0-107.5zM384 424l0-109.4C522.4 223.2 520.1 79 502.7 9.3C433-8.1 288.8-10.4 197.4 128H88l-4.9 0-2.2 4.4-72 144L3.1 288H16 136.4c23.2 0 45.5 9.2 61.9 25.7s25.7 38.7 25.7 61.9V496l0 12.9 11.6-5.8 144-72 4.4-2.2 0-4.9zM137.7 272l-1.2 0H28.9l64-128h94.5c-20.2 34.4-37.3 76.6-49.8 128zm17.5 186.7c-20.7 20.7-57.3 30.6-92.1 34.7c-16.9 2-32.4 2.5-43.6 2.6c-1.2 0-2.3 0-3.4 0c0-1.1 0-2.2 0-3.4c0-11.3 .6-26.7 2.6-43.6c4.1-34.8 14.1-71.5 34.7-92.2c28.1-28.1 73.8-28.1 101.9 0s28.1 73.8 0 101.9zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5s116.5 8 166-41.5zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fast',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      'M16 40V32H0v8V209.6 216v80 6.4V472v8H16v-8V306l133.2 29.6C176.8 383.6 228.6 416 288 416s111.2-32.4 138.8-80.4L560 306V472v8h16v-8V302.4 296 216v-6.4V40 32H560v8V206L426.8 176.4C399.2 128.4 347.4 96 288 96s-111.2 32.4-138.8 80.4L16 206V40zM435.9 194.8L560 222.4v67.2L435.9 317.2c7.8-18.8 12.1-39.5 12.1-61.2s-4.3-42.3-12.1-61.2zM140.1 317.2L16 289.6V222.4l124.1-27.6C132.3 213.7 128 234.3 128 256s4.3 42.3 12.1 61.2zM288 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM257 263.9a32 32 0 1 1 62-15.9 32 32 0 1 1 -62 15.9zm3.2 31.2c5.8 4.1 12.5 7 19.8 8.2v48.3c-20.5-1.7-39.2-9.8-54-22.4l34.2-34.2zM350 329.3c-14.8 12.5-33.5 20.7-54 22.4V303.3c7.3-1.2 14-4.1 19.8-8.2L350 329.3zM383.7 264c-1.7 20.5-9.8 39.2-22.4 54l-34.2-34.2c4.1-5.8 7-12.5 8.2-19.8h48.3zm-48.3-16c-1.2-7.3-4.1-14-8.2-19.8L361.3 194c12.5 14.8 20.7 33.5 22.4 54H335.3zM296 160.3c20.5 1.7 39.2 9.8 54 22.4l-34.2 34.2c-5.8-4.1-12.5-7-19.8-8.2V160.3zm-16 48.3c-7.3 1.2-14 4.1-19.8 8.2L226 182.7c14.8-12.5 33.5-20.7 54-22.4v48.3zm-31.1 19.5c-4.1 5.8-7 12.5-8.2 19.8H192.3c1.7-20.5 9.8-39.2 22.4-54l34.2 34.2zm0 55.6L214.7 318c-12.5-14.8-20.7-33.5-22.4-54h48.3c1.2 7.3 4.1 14 8.2 19.8zM288 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fast',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM128 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM304 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-32 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fast',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      'M2.3 146.3l144-144 11.3 11.3L16 155.3v51.1l165.2-30C208.8 128.3 260.6 96 320 96s111.2 32.3 138.8 80.4l165.2 30V155.3L482.3 13.7 493.7 2.3l144 144 2.3 2.3V152v57.3V216v80 6.7V360v3.3l-2.3 2.3-144 144-11.3-11.3L624 356.7V305.6l-165.2 30C431.2 383.7 379.4 416 320 416s-111.2-32.3-138.8-80.4L16 305.6v51.1L157.7 498.3l-11.3 11.3-144-144L0 363.3V360 302.7 296 216v-6.7V152v-3.3l2.3-2.3zm465.3 47.9c8 19 12.4 39.9 12.4 61.8s-4.4 42.8-12.4 61.8L624 289.3V222.7L467.6 194.2zM16 289.3l156.4 28.4c-8-19-12.4-39.9-12.4-61.8s4.4-42.8 12.4-61.8L16 222.7v66.6zM464 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-113-7.9a32 32 0 1 0 -62 15.9 32 32 0 1 0 62-15.9zM272.7 264H224.3c1.7 20.5 9.8 39.2 22.4 54l34.2-34.2c-4.1-5.8-7-12.5-8.2-19.8zM312 351.7V303.3c-7.3-1.2-14-4.1-19.8-8.2L258 329.3c14.8 12.5 33.5 20.7 54 22.4zm70-22.4l-34.2-34.2c-5.8 4.1-12.5 7-19.8 8.2v48.3c20.5-1.7 39.2-9.8 54-22.4zM415.7 264H367.3c-1.2 7.3-4.1 14-8.2 19.8L393.3 318c12.5-14.8 20.7-33.5 22.4-54zm-22.4-70l-34.2 34.2c4.1 5.8 7 12.5 8.2 19.8h48.3c-1.7-20.5-9.8-39.2-22.4-54zM328 160.3v48.3c7.3 1.2 14 4.1 19.8 8.2L382 182.7c-14.8-12.5-33.5-20.7-54-22.4zm-70 22.4l34.2 34.2c5.8-4.1 12.5-7 19.8-8.2V160.3c-20.5 1.7-39.2 9.8-54 22.4zM224.3 248h48.3c1.2-7.3 4.1-14 8.2-19.8L246.7 194c-12.5 14.8-20.7 33.5-22.4 54zM320 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fast',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.3 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM240 96h-8v8 16c0 22.9-27.7 34.4-43.9 18.2l-11.3-11.3-5.7-5.7-5.7 5.7-11.3 11.3 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-11.3 11.3-5.7 5.7 5.7 5.7 11.3 11.3c16.2 16.2 4.7 43.9-18.2 43.9H120h-8v8 16 16 8h8 16c22.9 0 34.4 27.7 18.2 43.9l-11.3 11.3-5.7 5.7 5.7 5.7 11.3 11.3 0 0 0 0 0 0 0 0 11.3 11.3 5.7 5.7 5.7-5.7 11.3-11.3c16.2-16.2 43.9-4.7 43.9 18.2v16 8h8 16 16 8v-8V360c0-22.9 27.7-34.4 43.9-18.2l11.3 11.3 5.7 5.7 5.7-5.7 11.3-11.3 11.3-11.3 5.7-5.7-5.7-5.7-11.3-11.3C341.6 291.7 353.1 264 376 264h16 8v-8V240 224v-8h-8H376c-22.9 0-34.4-27.7-18.2-43.9l11.3-11.3 5.7-5.7-5.7-5.7-11.3-11.3-11.3-11.3-5.7-5.7-5.7 5.7-11.3 11.3C307.7 154.4 280 142.9 280 120V104 96h-8H256 240zm8 24v-8h8 8v8c0 37.2 44.9 55.8 71.2 29.5l5.7-5.7 5.7 5.7 5.7 5.7-5.7 5.7C320.2 187.1 338.8 232 376 232h8v8 8h-8c-37.2 0-55.8 44.9-29.5 71.2l5.7 5.7-5.7 5.7-5.7 5.7-5.7-5.7C308.9 304.2 264 322.8 264 360v8h-8-8v-8c0-37.1-44.9-55.8-71.2-29.5l-5.7 5.7-5.6-5.6 0 0 0 0 0 0 0 0-5.6-5.6 5.7-5.7c26.3-26.3 7.7-71.2-29.5-71.2h-8v-8-8h8c37.2 0 55.8-44.9 29.5-71.2l-5.7-5.7 5.7-5.7 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 5.7-5.7 5.7 5.7c26.3 26.3 71.2 7.7 71.2-29.5zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fast',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      'M336 16V272H80V16H336zM80 0H64V16 272v16H80 336h16V272 16 0H336 80zM560 80V272H400V80H560zM400 64H384V80 272v16h16H560h16V272 80 64H560 400zM544 336c44.2 0 80 35.8 80 80s-35.8 80-80 80H96c-44.2 0-80-35.8-80-80s35.8-80 80-80H544zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm176-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fast',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      'M80 16H496V96h16V16 0H496 80 64V16 288H16 0v16 32l48 48H352V368H54.6L16 329.4V304H64 80 352V288H80V16zM400 496V144H624V496H400zM384 128v16V496v16h16H624h16V496 144 128H624 400 384z'
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fast',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      'M464 16V496H112V16H464zM96 16V496H8 0v16H8 96h16H464h16 88 8V496h-8H480V16 0H464 112 96V16zM408 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fast',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm272 24H144.2c4.2-75.8 66.9-136 143.8-136c79.5 0 144 64.5 144 144s-64.5 144-144 144c-76.8 0-139.6-60.2-143.8-136H288h8V280h-8zm-160 8a160 160 0 1 0 320 0 160 160 0 1 0 -320 0z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fast',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM264 128H248v8V296v8h16v-8V136v-8zM240 336v32h32V336H240z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fast',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M368 32h8 56 8v8V208h48 8v16h-8H432 376h-8V208h8 48V48H376h-8V32zM160 36.7l5.7 5.7 112 112 5.7 5.7L272 171.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L53.7 165.7 48 171.3 36.7 160l5.7-5.7 112-112 5.7-5.7zM428 272a68 68 0 1 0 -.2 136.1A68 68 0 1 0 428 272zm0 152c-46.4 0-84-37.6-84-84s37.6-84 84-84c45 0 81.8 35.5 83.9 80h.1c0 .7 0 1.4 0 2.1c0 .6 0 1.3 0 1.9c0 10.8-2 21.1-5.8 30.6c-4 11.8-10.1 22.8-18 32.6l-62 76.7H405.7l48.6-60.2c-8.3 2.7-17.1 4.2-26.3 4.2z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fast',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      'M48 112V400H16V112H48zM16 96H0v16V400v16H16 48 64V400 384H320.7c-.5-5.3-.7-10.6-.7-16H64V144H448v54.6c5.2-1.5 10.6-2.7 16-3.7V112h32v80c5.4 0 10.7 .2 16 .7V112 96H496 464 448v16 16H64V112 96H48 16zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fast',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H296.2l9.2-16H64L4.9 496 0 512H16.7 352V496H21.7L75.8 320zm448.3-71.2V222.4v-16h-16H452 436v16 26.2c-8 3.4-15.6 7.8-22.5 12.9l-21.1-12.2-13.9-8-8 13.9-28.9 50.1-8 13.9 13.9 8 21.1 12.2c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4l-21.1 12.2-13.9 8 8 13.9 37 64 34.9-20.1c6.9 5.1 14.5 9.4 22.5 12.9V481v16h16 56.1 16V481 454.6c7.9-3.4 15.4-7.7 22.3-12.8l35.1 20.2 37-64 8-13.9-13.9-8L591.2 364c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3l21.3-12.3 13.9-8-8-13.9-37-64 0 0-35 20.2c-6.9-5.1-14.3-9.4-22.3-12.8zm51.5 14.4l29 50.1-21.3 12.3-9 5.2 1.1 10.4c.4 3.5 .6 7 .6 10.5s-.2 7.1-.6 10.5l-1.1 10.4 9 5.2 21.3 12.3-29 50.1L554.3 428l-9.1-5.2-8.4 6.2c-5.9 4.3-12.3 8-19.1 11l-9.7 4.2v10.5V481H452V454.8 444.2l-9.7-4.1c-6.9-2.9-13.3-6.6-19.3-11l-8.4-6.2-9.1 5.2-21.1 12.1-29-50.1L376.5 378l9.1-5.2-1.1-10.4c-.4-3.5-.6-7-.6-10.6s.2-7.1 .6-10.6l1.1-10.4-9-5.2-21.1-12.2 28.9-50.1 21.1 12.2 9.1 5.2 8.4-6.2c5.9-4.4 12.4-8.1 19.3-11l9.7-4.1V248.6 222.4h56.1v26.4 10.5l9.7 4.2c6.8 2.9 13.2 6.6 19.1 11l8.4 6.2 9.1-5.2 21.2-12.2zM480 319.7a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fast',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      'M296 0h-8V8 72v8h8 32c13.3 0 24 10.7 24 24s-10.7 24-24 24H296h-8v8 56 8h8 56v16c0 22.1 17.9 40 40 40s40-17.9 40-40V200h72 8v-8V8 0h-8H296zm8 64V16H496V184H424h-8v8 24c0 13.3-10.7 24-24 24s-24-10.7-24-24V192v-8h-8H304V144h24c22.1 0 40-17.9 40-40s-17.9-40-40-40H304zM8 64H0v8V288 504v8H8 224 440h8v-8V288v-8h-8H352h-8v8 32c0 13.3-10.7 24-24 24s-24-10.7-24-24V288v-8h-8H232V72 64h-8H8zM216 80V280H168V256c0-22.1-17.9-40-40-40s-40 17.9-40 40v24H16V80H216zM96 296h8v-8V256c0-13.3 10.7-24 24-24s24 10.7 24 24v32 8h8 56v48H192c-22.1 0-40 17.9-40 40s17.9 40 40 40h24v72H16V296H96zM232 416v-8h-8H192c-13.3 0-24-10.7-24-24s10.7-24 24-24h32 8v-8V296h48v24c0 22.1 17.9 40 40 40s40-17.9 40-40V296h72V496H232V416z'
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fast',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM211.5 185.9l-9.3-11.6c-11.3-14.1-28.5-22.4-46.6-22.4c-32.9 0-59.6 26.7-59.6 59.6v3.6c0 16.8 6.7 32.8 18.5 44.7l24.8 24.8L224 369.3l84.7-84.7 24.8-24.8c11.8-11.9 18.5-27.9 18.5-44.7v-3.6c0-32.9-26.7-59.6-59.6-59.6c-18.1 0-35.3 8.2-46.6 22.4l-9.3 11.6L224 201.5l-12.5-15.6zm12.5 206l-11.3-11.3L128 295.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56v-3.6c0-41.8 33.9-75.6 75.6-75.6c22.5 0 43.7 10 58.1 27.2c.3 .4 .6 .8 1 1.2l9.3 11.6 9.3-11.6c.3-.4 .6-.8 1-1.2c14.4-17.2 35.6-27.2 58.1-27.2c41.8 0 75.6 33.9 75.6 75.6v3.6c0 21-8.3 41.1-23.2 56L320 295.9l-84.7 84.7L224 391.9z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fast',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm168 96H296h8v16h-8H174.4l-20.5 88.9 101.5 9.3c36.6 3.3 64.6 34 64.6 70.8c0 39.3-31.8 71.1-71.1 71.1H195.9c-26.7 0-51.7-13.4-66.5-35.5l13.3-8.9c11.9 17.7 31.9 28.5 53.2 28.5h53.1c30.4 0 55.1-24.7 55.1-55.1c0-28.5-21.7-52.3-50.1-54.9L143.3 248l-9.1-.8 2.1-8.9 24-104 1.4-6.2H168z'
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fast',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1-280-240zM496 204.8V496H80V204.8L288 26.5 496 204.8z'
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fast',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      'M451.5 267.2c-2.1 3.1-4.3 6.2-6.6 9.3l12.6 9.9c2.4-3.4 4.8-6.7 7.1-10.1c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C263.5 0 213.1 26.7 180.9 68.1L193.5 78c29.3-37.7 75-62 126.5-62c88.4 0 160 71.6 160 160c0 33.9-10.5 65.3-28.5 91.2zM228.7 105.8l12.6 9.9C257.3 94 283 80 312 80V64c-34.1 0-64.4 16.4-83.3 41.8zM400 424.5L389.2 416H384 256 240v16 64 16h16H384h16V496 432v-7.5zM152 228.8c5.4 17.1 13.3 33.1 23.3 47.6c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0 0 0c-5-6.9-10-13.7-14.5-20.2c-4.1-5.8-7.7-12-11-18.3L152 228.8zM256 432H384v64H256V432zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fast',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      'M192 496H80V416H192v80zm0-384v56h16V112H320V400H208V344H192v56H176 80 64v8 8 80 16H80 192h16H320h16V496 416v-8-8V170.9l59.6 222.6 2.1 7.7 2.1 7.7 23.5 87.5 4.1 15.5 15.5-4.1 116.7-31.3 15.5-4.1L570.9 457l-23.5-87.5-2.1-7.7-2.1-7.7L480.2 118.5l-2.1-7.7L476 103 452.6 15.5 448.4 0 433 4.1l-97 26V16 0H320 208 192 80 64V16 96v8 8H80h96 16zm0-96V96H80V16H192zM336 46.7L437.1 19.6l23.5 87.5L343.9 138.4 336 109.1V104 96 46.7zM320 496H208V416H320v80zm0-400H208V16H320V96zM438.7 492.4l-23.5-87.5L532 373.6l23.5 87.5L438.7 492.4zm-27.6-103L348 153.9l116.7-31.3 63.1 235.5L411.1 389.4zM72 144H64v8 64H0-8v8 64 8H0 64v64 8h8 64 8v-8V296h64 8v-8V224v-8h-8H144V152v-8h-8H72zm8 80V160h48v64 8h8 64v48H136h-8v8 64H80V288v-8H72 8V232H72h8v-8z'
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fast',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      'M101.7 178.3L96 172.7 84.7 184l5.7 5.7 104 104 5.7 5.7L211.3 288l-5.7-5.7-104-104zM312 240v8h16v-8V96 88H312v8V240zm122.3 42.3l-5.7 5.7L440 299.3l5.7-5.7 104-104 5.7-5.7L544 172.7l-5.7 5.7-104 104zM0 400v16H8 120h8V400h-8H8 0zm200 0h-8v16h8H440h8V400h-8H200zm320 0h-8v16h8H632h8V400h-8H520z'
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fast',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zM208 64h-8v8V88v3c-2.2 20-26.1 29.9-41.7 17.3l-2.1-2.1L144.8 94.9l-5.7-5.7-5.7 5.7-22.6 22.6-5.7 5.7 5.7 5.7 11.3 11.3 2.1 2.1c12.6 15.7 2.7 39.6-17.3 41.7h-3H88 80v8 32 8h8 16 3c20 2.2 29.9 26.1 17.3 41.7l-2.1 2.1-11.3 11.3-5.7 5.7 5.7 5.7 22.6 22.6 5.7 5.7 5.7-5.7 11.3-11.3 2.1-2.1c15.7-12.6 39.6-2.7 41.7 17.3v3 16 8h8 32 8v-8V328v-3c2.2-20 26.1-29.9 41.7-17.3l2.1 2.1 11.3 11.3 5.7 5.7 5.7-5.7 22.6-22.6 5.7-5.7-5.7-5.7-11.3-11.3-2.1-2.1C311.1 258.1 321 234.1 341 232h3 16 8v-8V192v-8h-8H344h-3c-20-2.2-29.9-26.1-17.3-41.7l2.1-2.1 11.3-11.3 5.7-5.7-5.7-5.7L314.5 94.9l-5.7-5.7-5.7 5.7-11.3 11.3-2.1 2.1C274.1 120.9 250.1 111 248 91V88 72 64h-8H208zm8 24V80h16v8 3.4 .4l0 .4c3.1 33.1 42.5 49.4 68.2 28.2l.3-.2 .3-.3 2.4-2.4 5.7-5.7 11.3 11.3-5.7 5.7-2.4 2.4-.3 .3-.2 .3c-21.2 25.6-4.9 65 28.2 68.2l.4 0h.4H344h8v16h-8-3.4-.4l-.4 0c-33.1 3.1-49.4 42.5-28.2 68.2l.2 .3 .3 .3 2.4 2.4 5.7 5.7-11.3 11.3-5.7-5.7-2.4-2.4-.3-.3-.3-.2c-25.6-21.2-65-4.9-68.2 28.2l0 .4v.4V328v8H216v-8-3.4-.4l0-.4c-3.1-33.1-42.5-49.5-68.2-28.2l-.3 .2-.3 .3-2.4 2.4-5.7 5.7-11.3-11.3 5.7-5.7 2.4-2.4 .3-.3 .2-.3c21.2-25.6 4.9-65-28.2-68.2l-.4 0h-.4H104 96V200h8 3.4 .4l.4 0c33.1-3.1 49.5-42.5 28.2-68.2l-.2-.3-.3-.3-2.4-2.4-5.7-5.7 11.3-11.3 5.7 5.7 2.4 2.4 .3 .3 .3 .2c25.6 21.2 65 4.9 68.2-28.2l0-.4v-.4V88zM192 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fast',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      'M496 48V464H16V48H496zM16 32H0V48 464v16H16 496h16V464 48 32H496 16zM292.7 176l5.7 5.7L372.7 256l-74.3 74.3-5.7 5.7L304 347.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80-5.7-5.7L292.7 176zm-79 5.7l5.7-5.7L208 164.7l-5.7 5.7-80 80-5.7 5.7 5.7 5.7 80 80 5.7 5.7L219.3 336l-5.7-5.7L139.3 256l74.3-74.3z'
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fast',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      'M304 16V352c0 79.5-64.5 144-144 144S16 431.5 16 352V16H304zM16 0H0V16 352c0 88.4 71.6 160 160 160s160-71.6 160-160V16 0H304 16zM160 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fast',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      'M432 176c0-32.5-20.5-64.1-58.3-88.4C336.2 63.5 283.3 48 224 48S111.9 63.5 74.3 87.6C36.5 111.9 16 143.5 16 176s20.5 64.1 58.3 88.4C111.9 288.5 164.7 304 224 304s112.2-15.5 149.7-39.6C411.5 240.1 432 208.5 432 176zm16 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zm-16 53.5c-33.1 53-113.7 90.5-208 90.5s-174.9-37.4-208-90.5V256c0 114.9 93.1 208 208 208s208-93.1 208-208V229.5zM178.1 172.3c-1.8 1.9-2.1 3.1-2.1 3.7s.3 1.9 2.1 3.7c1.9 1.9 5 4 9.5 5.9c8.9 3.8 21.8 6.4 36.4 6.4s27.5-2.6 36.4-6.4c4.5-1.9 7.6-4 9.5-5.9c1.8-1.9 2.1-3.1 2.1-3.7s-.3-1.9-2.1-3.7c-1.9-1.9-5-4-9.5-5.9c-8.9-3.8-21.8-6.4-36.4-6.4s-27.5 2.6-36.4 6.4c-4.5 1.9-7.6 4-9.5 5.9zm3.2-20.6c11.3-4.9 26.5-7.7 42.7-7.7s31.4 2.8 42.7 7.7c5.7 2.4 10.8 5.5 14.5 9.4c3.8 3.9 6.7 8.9 6.7 15s-2.9 11.1-6.7 15c-3.8 3.8-8.9 6.9-14.5 9.4c-11.3 4.9-26.5 7.7-42.7 7.7s-31.4-2.8-42.7-7.7c-5.7-2.4-10.8-5.5-14.5-9.4c-3.8-3.9-6.7-8.9-6.7-15s2.9-11.1 6.7-15c3.8-3.8 8.9-6.9 14.5-9.4zM232 88v24 8H216v-8V88 80h16v8zm-82.3 18.3l16 16 5.7 5.7L160 139.3l-5.7-5.7-16-16-5.7-5.7L144 100.7l5.7 5.7zm160 11.3l-16 16-5.7 5.7L276.7 128l5.7-5.7 16-16 5.7-5.7L315.3 112l-5.7 5.7zM96 168h32 8v16h-8H96 88V168h8zm224 0h32 8v16h-8H320h-8V168h8zM165.7 229.7l-16 16-5.7 5.7L132.7 240l5.7-5.7 16-16 5.7-5.7L171.3 224l-5.7 5.7zm128-11.3l16 16 5.7 5.7L304 251.3l-5.7-5.7-16-16-5.7-5.7L288 212.7l5.7 5.7zM232 240v24 8H216v-8V240v-8h16v8z'
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fast',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      'M400 128h0c.2 11.3-1.5 23.2-5.5 35.1c-14.3 42.9-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5c4 1.3 7.8 3.1 11.2 5.4C361.8 45.1 344.2 29 332.4 23.2l7.2-14.3C363.7 20.9 400 61.1 400 128zM212.5 180.3c4.7-13.9 5-31.9-1.2-50.3s-17.2-32.8-29.4-41.2s-24.5-10.5-34.9-7.1c-10.3 3.4-18.9 12.3-23.6 26.2c-4.7 13.9-5 31.9 1.2 50.3s17.2 32.8 29.4 41.2s24.5 10.5 34.9 7.1c10.3-3.4 18.9-12.3 23.6-26.2zm-18.6 41.4c-32.3 10.6-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.1h0c0-66.9 36.3-107.1 60.4-119.2l7.2 14.3c-11.8 5.9-29.4 22-40.7 48.6c3.5-2.3 7.2-4.1 11.2-5.4c32.3-10.6 70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8zm-98.3 56c1.4-11.4-1.3-25.5-9.1-39s-18.8-22.8-29.6-27.4s-20.2-4-27.2-.1c-6.9 4-12.1 11.8-13.4 23.2c-1.4 11.4 1.3 25.5 9.1 39s18.8 22.8 29.6 27.4s20.2 4 27.2 .1c6.9-4 12.1-11.8 13.4-23.2zm-5.5 37.1c-24.5 14-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240H0c0-66.9 36.3-107.1 60.4-119.2l7.2 14.3c-13.6 6.8-35.1 27.3-45.5 62c24.5-13.9 59.5 1.1 78.3 33.4c18.9 32.4 14.3 70.1-10.2 84.1zM256 447.5l3.9 1 171.5 42.9c-4.5-73.1-32.9-126.5-67-162.3c-37.8-39.7-81.9-57-108.4-57s-70.6 17.3-108.4 57c-34.1 35.8-62.4 89.2-67 162.3l171.5-42.9 3.9-1zM80 508l-16 4c0-5.6 .1-11.2 .4-16.6C72.1 331 194 256 256 256s183.9 75 191.6 239.4c.3 5.4 .4 11 .4 16.6l-16-4L256 464 80 508zM425.5 238.6c-7.9 13.5-10.5 27.6-9.1 39c1.4 11.4 6.5 19.3 13.4 23.2c6.9 4 16.4 4.5 27.2-.1s21.7-13.9 29.6-27.4s10.5-27.6 9.1-39c-1.4-11.4-6.5-19.3-13.4-23.2c-6.9-4-16.4-4.5-27.2 .1s-21.7 13.9-29.6 27.4zm-13.8-8c18.8-32.3 53.8-47.3 78.3-33.4c-10.4-34.7-31.9-55.2-45.5-62l7.2-14.3C475.7 132.9 512 173.1 512 240h0c.1 13.3-3.7 27.8-11.6 41.4c-18.9 32.4-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.1zm-119-100.7c-6.2 18.5-5.9 36.4-1.2 50.3c4.7 13.9 13.3 22.8 23.6 26.2c10.3 3.4 22.7 1.3 34.9-7.1s23.2-22.7 29.4-41.2s5.9-36.4 1.2-50.3c-4.7-13.9-13.3-22.8-23.6-26.2c-10.3-3.4-22.7-1.3-34.9 7.1s-23.2 22.7-29.4 41.2z'
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fast',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      'M216 472l0 8 16 0 0-8 0-208 208 0 8 0 0-16-8 0-208 0 0-208 0-8-16 0 0 8 0 208L8 248l-8 0 0 16 8 0 208 0 0 208zM16 464l32 0 0-32-32 0 0 32zm384 0l32 0 0-32-32 0 0 32zM16 368l32 0 0-32-32 0 0 32zm384 0l32 0 0-32-32 0 0 32zm32-192l0-32-32 0 0 32 32 0zM16 176l32 0 0-32-32 0 0 32zM432 80l0-32-32 0 0 32 32 0zM48 80l0-32L16 48l0 32 32 0zm288 0l0-32-32 0 0 32 32 0zM304 464l32 0 0-32-32 0 0 32zM144 80l0-32-32 0 0 32 32 0zM112 464l32 0 0-32-32 0 0 32z'
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fast',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      'M16 160c0-26.5 21.5-48 48-48H288c11.8 0 22.2-2.6 30.9-8.3c8.7-5.7 14.3-13.5 17.9-21.8c4.4-10.2 6.2-22 6.8-33.1c20.8 2.3 41 9.1 56.7 20.1c19.2 13.4 31.6 32.8 31.6 59c0 44.2-35.8 80-80 80H16V160zM344 32.8c-5.3-.5-10.7-.8-16-.8c0 30.8-2.3 64-40 64H64C28.7 96 0 124.7 0 160v48 16H16 352c53 0 96-43 96-96c0-58.4-51.6-89.9-104-95.2zM64 264v-8H48v8V416H8 0v8 48 8H8 568h8V464h-8H16V432H56h64 64 64 64 64H568h8V416h-8H384V264v-8H368v8V416H320V264v-8H304v8V416H256V264v-8H240v8V416H192V264v-8H176v8V416H128V264v-8H112v8V416H64V264z'
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fast',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 330.8c-6.9-4.9-13.5-10.2-19.6-16H16V192H352h80 16V176 80 64H432 336V8 0H320V8 64H128V8zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM440 296v-8H424v8 64H360h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H440V296z'
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fast',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      'M48 16H400V387.8L415.4 416h.6V400 16 0H400 48 32V16 400v16h.6L48 387.8V16zm96 272h-4.8l-2.3 4.2L25 500.2 18.6 512H32 416h13.4L423 500.2l-112-208-2.3-4.2H304 144zM402.6 496H45.4L148.8 304H299.2L402.6 496z'
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fast',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      'M630 34.5L580.6 204.6c-.5-.5-1.1-1-1.6-1.4c37.3 32.3 61 79.8 61 132.8c0 97.2-78.8 176-176 176H224c-88.4 0-160-71.6-160-160V253.1l-57.2-40L0 208.3 0 200l0-88 0-11.2L0 81.3 16 92.5l9.2 6.4L96 148.5l70.8-49.6 9.2-6.4 16-11.2 0 19.5 0 11.2 0 88 0 8.3-6.8 4.8-57.2 40v94.3V368l16-13L322.9 209.6c39.5-32.1 89.3-49.6 140.2-49.6c9.4 0 18.7 .7 27.7 2.2L615.7 26.5 640 0 630 34.5zM509 166c21.2 5.7 40.8 15.2 58.1 27.7L605.6 61 509 166zM96 168l-9.2-6.4L16 112l0 88 57.2 40 6.8 4.8v8.3V352c0 79.5 64.5 144 144 144H464c88.4 0 160-71.6 160-160c0-88.3-72.4-160-160.9-160c-47.3 0-93.4 16.3-130.1 46L138.1 380.4 112 401.6V368 253.1v-8.3l6.8-4.8L176 200l0-88-70.8 49.6L96 168zM480 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fast',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      'M16 48l480 0 0 112L16 160 16 48zm0 416l0-288 128 0 0 288L16 464zm144 0l0-288 336 0 0 288-336 0zM0 464l0 16 16 0 480 0 16 0 0-16 0-416 0-16-16 0L16 32 0 32 0 48 0 464z'
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fast',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      'M192 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 192 0a64 64 0 1 0 0 128zm-87.3 64h4.2H275.1h4.2l2.4-3.5 65.7-96 4.5-6.6-13.2-9-4.5 6.6L270.9 176H113.1L49.8 83.5l-4.5-6.6-13.2 9 4.5 6.6 65.7 96 2.4 3.5zM128 232v-8H112v8V504v8h8 48 8v-8V384h32V504v8h8 48 8v-8V232v-8H256v8V496H224V376v-8h-8H168h-8v8V496H128V232z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fast',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM296 419.3l-5.7-5.7L224 347.3l-66.3 66.3-5.7 5.7L140.7 408l5.7-5.7L212.7 336l-66.3-66.3-5.7-5.7L152 252.7l5.7 5.7L224 324.7l66.3-66.3 5.7-5.7L307.3 264l-5.7 5.7L235.3 336l66.3 66.3 5.7 5.7L296 419.3z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fast',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      'M224 496c79.5 0 144-64.5 144-144V16H16V352c0 79.5 64.5 144 144 144h64zM0 0H16 368h16V16 352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V16 0zM176 112v64h32V112H176zM160 96h16 32 16v16 64 16H208 176 160V176 112 96z'
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fast',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M0 64C0 311.4 200.6 512 448 512h32l32-144L368 288l-67 83.8C232.5 335.7 176.3 279.5 140.2 211L224 144 144 0 0 32 0 64zM16 44.8L135.8 18.2 203.4 140l-73.2 58.6-10.3 8.3 6.2 11.7c37.6 71.3 96.2 129.8 167.4 167.4l11.7 6.2 8.3-10.3L372 308.6l121.7 67.6L467.1 496H448C209.4 496 16 302.6 16 64l0 0 0-19.2z'
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fast',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      'M87.1 197.9C113.1 93.4 207.5 16 320 16s206.9 77.4 232.9 181.9c5.6 1 11.4 2 17.2 3.2C545 86.1 442.5 0 320 0S95 86.1 69.9 201.1c5.8-1.2 11.6-2.2 17.2-3.2zm20.9 170.6c-4.5 3.1-9.1 5.7-13.9 7.9C137.1 457.1 222.1 512 320 512s182.9-54.9 226-135.6c-4.8-2.2-9.5-4.8-13.9-7.9C491.7 444.3 411.9 496 320 496s-171.7-51.6-212.1-127.5zm91.7-143c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9zm160 0c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9zM28.4 323.6C12 307.1 12 281 27.6 265.4l0 0c1.6-1.6 6.2-4.4 15.1-7.6c8.3-3 18.6-5.7 29.6-8.1c12.6-2.8 25.6-5 36.8-6.7c-1.8 11.2-4.1 24.2-6.9 36.8c-2.5 11-5.2 21.2-8.3 29.6c-3.2 8.9-6.1 13.6-7.7 15.2C70.6 340 44.8 340 28.4 323.6zM16.2 254.1c-22 22.1-21.5 58.2 .9 80.7s58.4 22.9 80.4 .9c14-14.1 23.3-63.9 28.1-95.2c1-6.4 1.8-12.1 2.4-16.5c-4.4 .6-10.1 1.4-16.5 2.4C80.2 231 30.3 240 16.2 254.1zm596.2 11.3c15.5 15.6 15.6 41.7-.9 58.2c-16.4 16.5-42.2 16.4-57.7 .9c-1.6-1.6-4.5-6.3-7.7-15.2c-3-8.3-5.8-18.6-8.3-29.6c-2.8-12.6-5.1-25.5-6.9-36.8c11.2 1.7 24.2 4 36.8 6.7c11 2.4 21.2 5.1 29.6 8.1c8.9 3.2 13.5 6 15.1 7.6l0 0zm-83.9-39.1c-6.4-1-12.1-1.7-16.5-2.4c.6 4.4 1.4 10.1 2.4 16.5c4.8 31.3 14.1 81.1 28.1 95.2c22 22.1 58 21.6 80.4-.9s22.8-58.6 .9-80.7c-14-14.1-63.9-23.1-95.3-27.8zM320.3 347.8c48.2 0 94.1-6.9 135-19.3c-23.3 51.6-75 87.5-135 87.5s-111.7-35.8-134.9-87.5c40.9 12.4 86.7 19.3 134.9 19.3zm0-16c-51.5 0-99.9-8.1-142-22.3c-6.2-2.1-12.3-4.3-18.2-6.7c1.4 6.5 3.3 12.9 5.4 19.2c22.5 64.1 83.3 110 154.8 110s132.3-45.9 154.8-110c2.2-6.2 4-12.6 5.4-19.2c-5.9 2.4-12 4.6-18.2 6.7c-42.1 14.2-90.5 22.3-142 22.3z'
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fast',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0V16c132.5 0 240 107.5 240 240c0 43.7-11.7 84.7-32.1 120l13.9 8z'
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fast',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      'M312 0h16V8v8V144H312V16 8 0zM256 112v64.8l-16-16V112H160c-24.7 33.4-47.3 68-67.9 104.1C55.7 279.7 16 353.3 16 423c0 40.3 32.7 73 73 73c25.1 0 51.9-5.9 79.9-14c10.4-3 21.3-6.4 32.3-9.8l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c5.7-1.8 11.4-3.5 17-5.2L231 479.9c-8 2.4-16.1 4.9-24.3 7.4l0 0C167.8 499.4 127.2 512 89 512c-49.1 0-89-39.8-89-89c0-74.6 42.3-152 78.2-214.9C100.5 169.2 125.1 131.8 152 96h88 16v16zM438.8 472.3l0 0 0 0c11 3.4 21.9 6.8 32.3 9.8c28 8 54.8 14 79.9 14c40.3 0 73-32.7 73-73c0-69.7-39.7-143.3-76.1-207C527.3 180 504.6 145.4 480 112H400v48.8l-16 16V112 96h16 88c26.9 35.8 51.5 73.2 73.8 112.1C597.7 271.1 640 348.4 640 423c0 49.1-39.8 89-89 89c-38.2 0-78.8-12.6-117.7-24.7c-8.2-2.5-16.3-5.1-24.3-7.4L421.8 467c5.7 1.7 11.4 3.5 17 5.2zM304 176h16 16 8v8 16c0 22.9 27.7 34.4 43.9 18.2l11.3-11.3 5.7-5.7 5.7 5.7 11.3 11.3 11.3 11.3 5.7 5.7-5.7 5.7-11.3 11.3C405.6 268.3 417.1 296 440 296h16 8v8 16 16 8h-8H440c-22.9 0-34.4 27.7-18.2 43.9l11.3 11.3 5.7 5.7-5.7 5.7-11.3 11.3-11.3 11.3-5.7 5.7-5.7-5.7-11.3-11.3C371.7 405.6 344 417.1 344 440v16 8h-8H320 304h-8v-8V440c0-22.9-27.7-34.4-43.9-18.2l-11.3 11.3-5.7 5.7-5.7-5.7-11.3-11.3 0 0 0 0 0 0 0 0-11.3-11.3-5.7-5.7 5.7-5.7 11.3-11.3c16.2-16.2 4.7-43.9-18.2-43.9H184h-8v-8V320 304v-8h8 16c22.9 0 34.4-27.7 18.2-43.9l-11.3-11.3-5.7-5.7 5.7-5.7 11.3-11.3 5.7 5.7-5.7-5.7 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 11.3-11.3 5.7-5.7 5.7 5.7 11.3 11.3c16.2 16.2 43.9 4.7 43.9-18.2V184v-8h8zm8 24c0 37.2-44.9 55.8-71.2 29.5l-5.7-5.7-5.7 5.7 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-5.7 5.7 5.7 5.7c26.3 26.3 7.7 71.2-29.5 71.2h-8v8 8h8c37.2 0 55.8 44.9 29.5 71.2l-5.7 5.7 5.6 5.6 0 0 0 0 0 0 0 0 5.6 5.6 5.7-5.7c26.3-26.3 71.2-7.7 71.2 29.5v8h8 8v-8c0-37.2 44.9-55.8 71.2-29.5l5.7 5.7 5.7-5.7 5.7-5.7-5.7-5.7C384.2 372.9 402.8 328 440 328h8v-8-8h-8c-37.1 0-55.8-44.9-29.5-71.2l5.7-5.7-5.7-5.7-5.7-5.7-5.7 5.7C372.9 255.8 328 237.2 328 200v-8h-8-8v8zm-24 72a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fast',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      'M0 0H8 632h8V16h-8H8 0V0zM0 496H8 632h8v16h-8H8 0V496zm440.9-96l-36-96H235.1l-36 96H440.9zM224 288H416l42 112 6 16H446.9 193.1 176l6-16 42-112zm97.6-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM195.2 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM496 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM75.5 272L54.2 336H171.8l-6 16H48.9 32l5.3-16L64 256H201.8l-6 16H75.5zm392.6 64H585.8l-21.3-64H444.2l-6-16H576l26.7 80 5.3 16H591.1h-117l-6-16z'
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fast',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      'M160 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zm59.8 245.4l3.4 7.2 64 136 5.4 11.4H280 240V504v8h-8H184h-8v-8V400H144V504v8h-8H88 80v-8V400H40 27.4l5.4-11.4 64-136 3.4-7.2 14.5 6.8-3.4 7.2L52.6 384H88h48 48 48 35.4L208.8 259.4l-3.4-7.2 14.5-6.8zM128 400H96v96h32V400zm64 0v96h32V400H192zM108.9 160H211.1h4.6l2.3 3.9 84.9 144 4.1 6.9L293.2 323l-4.1-6.9L206.5 176h-93L30.9 316.1 26.8 323 13 314.8l4.1-6.9 84.9-144 2.3-3.9h4.6z'
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fast',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      'M368 16V496H16V16H368zM16 0H0V16 496v16H16 368h16V496 16 0H368 16zM200 326.6c10.2 6 22.1 9.4 34.9 9.4c38.2 0 69.1-30.9 69.1-69.1c0-29-17.8-53.8-43.1-64c.2-1.9 .2-3.8 .2-5.8c0-38.2-30.9-69.1-69.1-69.1s-69.1 30.9-69.1 69.1c0 1.9 .1 3.9 .2 5.8C97.8 213.1 80 237.9 80 266.9c0 38.2 30.9 69.1 69.1 69.1c12.7 0 24.7-3.4 34.9-9.5V368H160h-8v16h8 24 16 24 8V368h-8H200V326.6zM138.9 197.1c0-29.3 23.8-53.1 53.1-53.1s53.1 23.8 53.1 53.1c0 3.3-.3 6.6-.9 9.7l-1.3 7.1 6.9 2c22.1 6.5 38.1 26.8 38.1 51c0 29.3-23.8 53.1-53.1 53.1c-14.5 0-27.7-5.8-37.3-15.3l-5.6-5.5-5.6 5.5c-9.6 9.5-22.7 15.3-37.3 15.3C119.8 320 96 296.2 96 266.9c0-24.1 16.1-44.5 38.1-51l6.9-2-1.3-7.1c-.6-3.1-.9-6.4-.9-9.7z'
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fast',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      'M16 16V496H496V470.6L434.3 409l-20.7 20.7-5.7 5.7L396.7 424l5.7-5.7L423 397.7 354.3 329l-20.7 20.7-5.7 5.7L316.7 344l5.7-5.7L343 317.7 274.3 249l-20.7 20.7-5.7 5.7L236.7 264l5.7-5.7L263 237.7 194.3 169l-20.7 20.7-5.7 5.7L156.7 184l5.7-5.7L183 157.7 114.3 89 93.7 109.7 88 115.3 76.7 104l5.7-5.7L103 77.7 41.4 16H16zM205.7 157.7l68.7 68.7 11.3 11.3 68.7 68.7 11.3 11.3 68.7 68.7 11.3 11.3L512 464v32 16H496 16 0V496 16 0H16 48l66.3 66.3 11.3 11.3 68.7 68.7 11.3 11.3zm-85.7 79l13.7 13.7 128 128L275.3 392H256 128h-8v-8V256 236.7zm16 38.6V376H236.7L136 275.3z'
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fast',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      'M528 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zm0 88A52 52 0 1 0 528 0a52 52 0 1 0 0 104zm19.4 166.3l4.8 9.5 9.5 4.8 33.7 16.8 14.3 7.2 7.2-14.3 14.3-28.6 7.2-14.3L624 244.2l-24.2-12.1-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-5.1 15.2-5.1 15.2 15.2 5.1 30.4 10.1 15.2 5.1 5.1-15.2 5.1-15.2 11.5-34.6 17.9-7.9 18.8-8.3-5.3 19.9-11.7 43.7c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 4.2 15.4 4.2 15.4 15.4-4.2 30.9-8.4 15.4-4.2L603.1 479l-4.2-15.4-24-88-2-7.5-5.2-5.7-52.3-57L527 265.4l6.6-22.5 10.5 21 3.2 6.4zm8.4 102.9l2.6 2.9 1 3.7 24 88 4.2 15.4-30.9 8.4-4.2-15.4-22-80.5-1-3.7-2.6-2.9-70.9-77.4c-11.1-12.1-15.2-29-11-44.8l17-63.6 8.6-32.3-30.6 13.6-36.7 16.3-6.4 2.9-2.2 6.7-11.5 34.6-5.1 15.2-30.4-10.1 5.1-15.2 16-48 2.2-6.7 6.4-2.9 72-32 4.6-2.1 5 1 80 16 7.7 1.5 3.5 7 35.2 70.5 2.4 4.8 4.8 2.4 24.2 12.1-14.3 28.6-33.7-16.8-4.8-2.4-2.4-4.8L548 235.8l-18.2-36.4-11.5 39L500 300.8l-2.6 8.7 6.1 6.7 52.3 57zM388.7 398l-43.4 43.4-11.3 11.3L322.7 464l11.3 11.3 22.6 22.6L368 509.3l11.3-11.3 11.3-11.3 48-48 4.6-4.6 2.4-6.1 15.7-39.3-12-13.1-18.6 46.4-1.2 3-2.3 2.3-48 48L368 486.6 345.4 464l11.3-11.3L400 409.3l2.3-2.3 1.2-3 21.8-54.6-4.8-5.2c-2.5-2.7-4.8-5.6-7-8.6l-25 62.4zM245.2 9.9L240 5.5l-5.2 4.5-224 192-6.1 5.2 10.4 12.1 6.1-5.2L64 177.4V408v8h8H322.7l16-16H80V163.7L240 26.5 361.5 130.7l16.2-7.2L245.2 9.9zM232 184v80H152V184h80zm-80-16H136v16 80 16h16 80 16V264 184 168H232 152z'
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fast',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      'M192 320l0 16 0 64 0 16-16 0-16 0L11.3 267.3 0 256l11.3-11.3L160 96l16 0 16 0 0 16 0 64 0 16 16 0 128 0 16 0 0 16 0 96 0 16-16 0-128 0-16 0zm-16 0l0-16 16 0 144 0 0-96-144 0-16 0 0-16 0-80-9.4 0L22.6 256l144 144 9.4 0 0-80zM328 464l168 0 0-416L328 48l-8 0 0-16 8 0 176 0 8 0 0 8 0 432 0 8-8 0-176 0-8 0 0-16 8 0z'
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fast',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      'M640 32v8V184v8H624v-8V59.3l-126 126c63.1 69.1 61.3 176.3-5.5 243.1c-48.6 48.6-118.5 62.8-179.6 42.7c4.8-4 9.5-8.2 14-12.5c53.3 14.1 112.5 .3 154.3-41.5c62.5-62.5 62.5-163.8 0-226.3l-5.7-5.7 5.7-5.7L612.7 48 488 48l-8 0V32h8H632h8zM288 32h8H440h8v8V184v8H432v-8V59.3l-126 126c28.6 31.3 46 72.9 46 118.7c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c45.7 0 87.4 17.4 118.7 46l126-126H296h-8V32zM176 464a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fast',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      'M264 0V8 64.2c99.7 4.1 179.8 84.2 183.8 183.8H504h8v16h-8H447.8c-4.1 99.7-84.2 179.8-183.8 183.8V504v8H248v-8V447.8C148.3 443.8 68.2 363.7 64.2 264H8 0V248H8 64.2C68.2 148.3 148.3 68.2 248 64.2V8 0h16zM80 256a176 176 0 1 0 352 0A176 176 0 1 0 80 256zm256 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fast',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      'M144 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 32a32 32 0 1 1 64 0A32 32 0 1 1 96 32zM56 224h8H74.7L19.2 120.1 29.5 109c4.4 1.9 9.3 3 14.5 3c16.5 0 30.4-11.1 34.7-26.3l14.6-1.8c6.9 12 19.9 20.1 34.7 20.1s27.8-8.1 34.7-20.1l14.6 1.8c4.3 15.2 18.2 26.3 34.7 26.3c5.2 0 10.1-1.1 14.5-3l10.3 11.1L181.3 224H192h8v16h-8l-14.9 0 18.8 144H179.8L161 240H95L76.2 384H60.1L78.9 240 64 240H56V224zm107.2 0l51.2-96.1c-.8 0-1.6 .1-2.4 .1c-18.7 0-35-9.8-44.2-24.6C157.7 113.6 143.6 120 128 120s-29.7-6.4-39.8-16.6C79 118.2 62.7 128 44 128c-.8 0-1.6 0-2.4-.1L92.8 224h70.4zM44.3 416H48 208h3.7l2.4 2.9 40 48 1.9 2.2V472v32 8h-8H8 0v-8V472v-2.9l1.9-2.2 40-48 2.4-2.9zm7.5 16L16 474.9V496H240V474.9L204.3 432H51.7z'
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fast',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      'M156 8h4 .9 8.9l-1 8.9c-3.7 32.6 4.6 66.5 24.4 92c19.6 25.4 51 43.1 94.8 43.1s75.2-17.7 94.8-43.1c19.8-25.6 28-59.4 24.4-92l-1-8.9h8.9 .9 4l2.4 3.2C443.5 39.3 456 74.2 456 112c0 20.8-3.8 40.7-10.7 59.1c17.7 3.5 35.1 9.9 51.6 19.4c32.7 18.9 56.7 47.2 70.5 79.5l1.6 3.7-2 3.5-.5 .8-4.5 7.7-7.2-5.3c-26.4-19.5-59.9-29.3-91.9-24.9c-31.8 4.3-62.8 22.6-84.7 60.6s-22.3 74-10.1 103.6c12.3 29.9 37.5 54 67.5 67.1l8.2 3.6-4.5 7.8-.5 .8-2 3.5-4 .5c-34.9 4.2-71.4-2.4-104.1-21.3c-15.7-9.1-29.3-20.3-40.9-33c-11.5 12.8-25.2 24-40.9 33c-32.7 18.9-69.2 25.5-104.1 21.3l-4-.5-2-3.5-.5-.8-4.5-7.8 8.2-3.6c30.1-13.1 55.3-37.2 67.5-67.1C220 390 219.7 354 197.8 316s-52.9-56.3-84.7-60.6c-32-4.3-65.5 5.5-91.9 24.9L14 285.7l-4.5-7.7-.5-.8-2-3.5L8.6 270c13.8-32.3 37.8-60.6 70.5-79.5c16.5-9.5 33.9-15.9 51.6-19.4C123.8 152.7 120 132.8 120 112c0-37.8 12.5-72.7 33.6-100.8L156 8zm-3.6 35.2C141.9 63.9 136 87.2 136 112c0 22.1 4.7 43.2 13.2 62.1l4.4 9.8L143 185.3c-19.1 2.5-38.1 8.8-55.8 19.1C65.7 216.8 48.4 233.6 35.8 253c24.5-11.8 52.2-17.1 79.5-13.4c36.9 5 72.1 26.3 96.4 68.4s25.1 83.3 11 117.7c-10.4 25.4-28.8 46.8-51.3 62.1c23.1-1.2 46.3-7.8 67.8-20.2c16.9-9.7 31.1-22.2 42.6-36.5l6.2-7.8 6.2 7.8c11.5 14.3 25.8 26.8 42.6 36.5c21.4 12.4 44.6 18.9 67.8 20.2c-22.5-15.3-40.9-36.7-51.3-62.1c-14.1-34.4-13.3-75.6 11-117.7s59.6-63.4 96.4-68.4c27.2-3.7 54.9 1.6 79.5 13.4c-12.6-19.4-29.9-36.2-51.4-48.6c-17.8-10.3-36.7-16.5-55.8-19.1l-10.6-1.4 4.4-9.8c8.5-19 13.2-40 13.2-62.1c0-24.8-5.9-48.1-16.4-68.8c-2 27.1-11.3 53.8-28.1 75.5C372.7 148.1 336.6 168 288 168s-84.7-19.9-107.5-49.3C163.8 97 154.4 70.4 152.4 43.2zm2.1 388.3c-40.1-33.6-67.4-82.1-73.3-136.9c5.3-1.1 10.7-1.7 15.9-1.7c5.5 50.6 30.6 95.3 67.6 126.3c-3 4.3-6.4 8.5-10.2 12.3zM288 80c-21.2 0-41.7 3.4-60.7 9.8c-1.3-1.4-2.5-2.9-3.7-4.4c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-1.2 1.5-2.4 2.9-3.7 4.4C329.7 83.4 309.2 80 288 80zM478.9 292.9c5.3 .1 10.6 .6 15.9 1.7c-5.9 54.9-33.2 103.3-73.3 136.9c-3.8-3.8-7.3-8-10.2-12.3c37-31 62.1-75.7 67.6-126.3zM288 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fast',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      'M284.2 52a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zM323 103.9L437.5 204l5.9 5.2 7.7-1.5 115.3-23.1c3.3 2.1 6.9 3.8 10.7 5L453.7 464l-267.3 0L62.9 189.6c3.8-1.2 7.4-2.9 10.7-5l115.3 23.1 7.7 1.5 5.9-5.2L317 103.9c1.1 .1 2.1 .1 3.2 .1c1 0 1.9 0 2.9-.1zM46.4 192L176 480l288 0L593.6 192c25.8-.9 46.4-22 46.4-48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 10.1 3.1 19.4 8.4 27.1L448 192 342 99.2C359.8 91 372.2 72.9 372.2 52c0-28.7-23.3-52-52-52s-52 23.3-52 52c0 20.8 12.3 38.8 30 47.1L192 192 87.6 171.1c5.3-7.7 8.4-17.1 8.4-27.1c0-26.5-21.5-48-48-48S0 117.5 0 144c0 26 20.6 47.1 46.4 48zM592 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM16 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fast',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      'M214.4 427.2l0 0 0 0 .1 0 .3-.2 1.2-.9c1.1-.9 2.7-2.1 4.8-3.8c4.2-3.4 10.3-8.4 17.6-14.9c14.6-12.9 34.1-31.4 53.5-53.8C331.4 308.1 368 249.9 368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 57.9 36.6 116.1 76.1 161.5c19.4 22.3 38.9 40.8 53.5 53.8c7.3 6.5 13.4 11.5 17.6 14.9c2.1 1.7 3.7 3 4.8 3.8l1.2 .9 .3 .2 .1 0 0 0 0 0 0 0L176 432h32l6.4-4.8 0 0zM210 448H174l-21.3 48h78.8L210 448zm38.8 48l7.1 16H238.5h-93H128l7.1-16L160 440S0 320 0 192C0 86 86 0 192 0S384 86 384 192c0 128-160 248-160 248l24.9 56zM168 96c-39.8 0-72 32.2-72 72v8H80v-8c0-48.6 39.4-88 88-88h8V96h-8z'
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fast',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM96 96H80v8V280v8H96v-8V104 96zm64 0H144v8V280v8h16v-8V104 96zM604.1 78.9l6.9-4.1L602.7 61l-6.9 4.1-80 48-6.9 4.1 8.2 13.7 6.9-4.1 80-48zM520 248h-8v16h8H632h8V248h-8H520zm4.1 137.1l-6.9-4.1L509 394.7l6.9 4.1 80 48 6.9 4.1 8.2-13.7-6.9-4.1-80-48z'
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fast',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      'M80 320H96v16 30.1V384l16-8 112-56H400h16V304 16 0H400 16 0V16 304v16H16 80zM16 304V16H400V304H224h-3.8l-3.4 1.7L112 358.1V320 304H96 16zm240 48v80 16h16H416l112 56 16 8V494.1 464 448h16 64 16V432 144 128H624 448v16H624V432H544 528v16 38.1L423.2 433.7l-3.4-1.7H416 272V352H256zM215.1 85.3V78.2H200.9v7.1V97.3c-6.5 .6-12.6 2-17.9 4.4c-10 4.4-17.9 12.2-19.9 23.1c-1.2 6.5-.5 12.4 2 17.6c2.5 5.1 6.4 8.9 10.8 11.8c8.1 5.3 19.1 8.6 28.8 11.4l0 0 1.4 .4c10.8 3.2 19.9 6 26.1 10.4c2.9 2.1 4.8 4.2 5.9 6.6c1 2.3 1.6 5.5 .8 9.9c-1.1 5.9-4.9 10.4-11.6 13.2c-6.9 2.9-16.7 3.8-28 2.1c-5.6-.9-15.3-4.1-22.9-6.6l0 0 0 0c-1.7-.5-3.2-1.1-4.6-1.5l-6.8-2.2-4.4 13.5 6.8 2.2c1.1 .4 2.5 .8 4 1.3l0 0 0 0c7.5 2.5 18.8 6.2 25.7 7.3l0 0c1.3 .2 2.5 .4 3.8 .5v12.1 7.1h14.2v-7.1V223c6.4-.4 12.4-1.7 17.7-3.9c10.3-4.3 18.1-12.2 20.1-23.8c1.2-6.8 .6-12.8-1.8-18.2c-2.4-5.3-6.3-9.3-10.7-12.4c-8.5-6-20.2-9.4-30.3-12.4l-.1 0 0 0c-10.8-3.2-20-5.9-26.3-10c-3-2-4.8-4-5.9-6.1c-1-2.1-1.5-4.8-.8-8.9c.9-4.9 4.6-9.4 11.6-12.5c7-3.1 16.9-4.4 28-2.7c3.6 .6 14.8 2.7 18.3 3.6l3.6-13.8c-4.2-1.1-15.9-3.3-19.7-3.9c-1.3-.2-2.5-.4-3.8-.5V85.3z'
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fast',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M384.1 419.9c-90.5 70.7-221.2 54.7-292-35.8s-54.7-221.2 35.8-292c90.5-70.7 221.2-54.7 291.9 35.8L456 176H328h-8v16h8H472h8v-8V40 32H464v8V160l-31.4-41.8 0 0-.1-.1C356.4 20.6 215.6 3.3 118.1 79.5S3.3 296.4 79.5 393.9s216.9 114.8 314.4 38.6c24.7-19.3 44.2-42.7 58.4-68.6l-14-7.7c-13.2 24-31.3 45.7-54.3 63.7z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fast',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM21.7 496H295.3c2.9 5.8 6.5 11.2 10.7 16H16.7 0l4.9-16L64 304H384l16 52v30.1c-2.6-.4-5.1-.6-7.7-.8L372.2 320H75.8L21.7 496zM640 156.8v11.1 72 152c0 .9-.1 1.7-.4 2.5c.3 1.8 .4 3.6 .4 5.5c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V251L448 309.7V463.9l0 .1c0 26.5-28.7 47.9-64 47.9c-35.3 0-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V303.9v-72-5.8l5.5-1.8 192-64 10.5-3.5zm-220.3 286c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1s-3.8-14.7-12.3-21.1zm28.3-150l176-58.7V179L448 237.7v55.1zM624 399.9c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1z'
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fast',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 392h96 8v16h-8H208h-8V392h8zm143.6-88c14.6 0 30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7c10.9 19.3 26.4 27.9 41 27.9zm-233-27.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7zM77.7 211.3l7.5-2.8 20.7-7.8c26.2-9.8 48.2-28.5 62.1-52.8l9.1-15.9 4-6.9 13.9 7.9-4 6.9-9.1 15.9c-15.7 27.5-40.6 48.7-70.3 59.9l-20.7 7.8-7.5 2.8-5.6-15zm349.1-2.8l7.5 2.8-5.6 15-7.5-2.8-20.7-7.8c-29.7-11.1-54.6-32.3-70.3-59.9L321.1 140l-4-6.9 13.9-7.9 4 6.9 9.1 15.9c13.9 24.3 35.8 43 62.1 52.8l20.7 7.8z'
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fast',
    iconName: 'hands-praying',
    icon: [
      603,
      512,
      ["praying-hands"],
      'f684',
      
      'M247.2 26.4l6.5 5.5 47.5 40.7 47.5-40.7 6.5-5.5 4.7 7.1L480.2 214.2l1.3 1.9v2.3V318.5l115.6 43.3L591.8 376 471.3 330.8l-4.9-1.8v-5.2V220.6L352 48.9 310.3 84.6l64.9 122.6 .1 .3 .8 1.5v1.9V316.2v7.5H361v-7.5V218.4H309v183l287.8 95.9-4.8 14.3-290.9-97-290.9 97L5.5 497.3l287.8-95.9v-183h-52v97.9 7.5H226.2v-7.5V210.8 209l.8-1.5 .1-.3L292 84.6 250.3 48.9 135.9 220.6V323.8 329l-4.9 1.8L10.5 376 5.2 361.9l115.6-43.3V218.4v-2.3l1.3-1.9L242.5 33.5l4.7-7.1zm46 176.9h7.5 .7H309h47L301.1 99.6 246.2 203.3h47z'
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fast',
    iconName: 'hand-scissors',
    icon: [
      512,
      512,
      [],
      'f257',
      
      'M7.8 168.7L.1 166.6l2.1-7.7L25.5 74l2.1-7.7 7.7 2.1L77.8 80.1l187.5 51.6 48.3-64.4L316 64l4 0 32 0c38 0 74.2 15.9 99.9 43.8l24 26C499.1 158.9 512 191.9 512 226l0 102c0 75.1-60.9 136-136 136l-32 0-32 0-64 0-8 0 0-8 0-64-32 0-8 0 0-8 0-62.4L59.8 331.9l-43.9 3.2-8 .6-.6-8L.9 239.9l-.6-8 8-.6 43.9-3.2 135.7-9.9L50.2 180.3 7.8 168.7zm45.6 75.4l-35.9 2.6 5.3 71.8 35.9-2.6L207.4 305l8.6-.6 0 8.6 0 63 32 0 8 0 0 8 0 64 56 0 32 0 32 0c66.3 0 120-53.7 120-120l0-102c0-30.2-11.4-59.2-31.8-81.4l-24-26C417.4 94 385.4 80 352 80l-28 0-42.9 57.1 81.1 23.2 7.7 2.2-4.4 15.4-7.7-2.2L168.1 121.5l-94.5-26L38.8 85.9 19.7 155.4l34.7 9.5 182.5 50.2-1.5 15.7-182 13.3z'
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fast',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      'M560 160c0-30-24.1-58-74.6-79.3C459.1 69.6 427 61.1 391 55.5L376.2 159l39.2 94 2.8 6.7c25.1-5.3 47.7-12.1 67.3-20.3C535.9 218 560 190 560 160zM400.6 259.1l-40-96-.5-1.2-69.7 21.8-2.4 .7-2.4-.7-69.7-21.8-.5 1.2-40 96-1.5 3.6c34.6 6.1 73.2 9.3 114.1 9.3s79.5-3.2 114.1-9.3l-1.5-3.6zM362.1 144.4l13-91.2C347.9 49.8 318.6 48 288 48s-59.9 1.8-87.2 5.3l13 91.2L288 167.6l74.1-23.2zM90.6 239.3c19.5 8.2 42.2 15.1 67.3 20.3l2.8-6.7 39.2-94L185 55.5c-36 5.6-68.1 14.1-94.4 25.2C40.1 102 16 130 16 160s24.1 58 74.6 79.3zM576 160V352c0 40-32.2 72-84.4 94c-52.1 22-124.1 34-203.6 34s-151.5-12-203.6-34C32.2 424 0 392 0 352V160C0 80 128.9 32 288 32s288 48 288 128zm-16 45.8C520.8 258 413.8 288 288 288s-232.8-30-272-82.2V352c0 30 24.2 58 74.6 79.3C140.1 452.2 209.8 464 288 464s147.9-11.8 197.4-32.7C535.8 410 560 382 560 352V205.8z'
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fast',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      'M120 0h-8V8 316l-5.9-8.2L82.6 275.4 77.9 269l-6.5 4.7-64.8 47L.2 325.3l4.7 6.5 23.5 32.4 64.1 88.3C119.5 489.9 162.8 512 209 512h47 16 72c57.4 0 104-46.6 104-104V320l0-80v-8h-8H376V208v-8h-8H296V184v-8h-8H216V8 0h-8H120zm8 326.3V16h72V184v8h8 72v16 8h8 72v24 8h8 64l0 72v88c0 48.6-39.4 88-88 88H272 256 209c-41 0-79.6-19.7-103.6-52.9L41.3 354.8 22.5 328.9l51.8-37.6 18.8 25.9L107.5 337l5.5 7.6 6.6-6.6 6.1-6.1 2.3-2.3v-3.3zM224 312v-8H208v8V424v8h16v-8V312zm64 0v-8H272v8V424v8h16v-8V312zm64 0v-8H336v8V424v8h16v-8V312z'
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fast',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M409.9 10.5l-2.2 7.7-5.5 19.1c31.2 10 57.3 33.5 69.8 65.2l21.8-6.2 7.7-2.2 4.4 15.4-7.7 2.2-21.3 6.1 .2 1c7.9 34.2-.8 68.4-20.9 94.1l13.4 13.4 5.7 5.7L464 243.3l-5.7-5.7-12.8-12.8c-14.1 13.5-31.9 23.6-52.3 28.3c-13.9 3.2-26.2 7.1-37.3 11.5l3.8 13.2 2.2 7.7-15.4 4.4-2.2-7.7-3.1-11c-36.3 17.9-55.7 41.4-67.1 60.4c-.9 1.5-1.8 3-2.6 4.6l19.8 8.5 7.4 3.2-6.3 14.7-7.4-3.2-20.6-8.8c-4.2 9.5-7.3 19.5-8.9 29.6c-2.8 25.5-13.9 48.1-30.5 65.4l12.8 12.8 5.7 5.7L232 475.3l-5.7-5.7-13.4-13.4c-21.7 16.9-49.6 26-79.1 23.3c-5.5-.5-10.9-1.4-16.1-2.6l-6.1 21.3-2.2 7.7-15.4-4.4 2.2-7.7 6.2-21.7c-28.7-11.4-51.3-34.3-62.6-62.6l-21.7 6.2-7.7 2.2L6.1 402.5l7.7-2.2 21.3-6.1c-2.8-11.6-3.8-23.8-2.6-36.4c2.2-21.3 7-42.7 13.8-63.5L29 287.4l-7.4-3 5.9-14.9 7.4 3 16.6 6.6c8.3-22 18.6-43.2 30.4-62.8c4.6-7.6 9.6-15.3 15-23L83 182.2l-6.2-5 10-12.5 6.2 5 13.4 10.7c19.5-25.3 43.7-50 73.5-72.2L169.3 92.4l-4.4-6.7 13.3-8.9 4.4 6.7L192.9 99c25.4-17.3 54.4-32.8 87.6-45.3l-7.9-18.5-3.2-7.4 14.7-6.3 3.2 7.4 8.3 19.4c14.9-5.1 30.6-9.5 47.2-13.3c14.9-3.4 29.7-3.7 43.9-1.3l5.6-19.7 2.2-7.7 15.4 4.4zM239.5 378.1l.1-.4c3-19.8 11.3-38.5 20.8-54.3c18-30 53.2-68.3 129.3-85.9c51.7-11.9 83.9-63.5 72-115.1s-63.5-83.9-115.1-72C214.5 80.9 137.7 154.5 95.7 224.6c-24.4 40.7-42.4 88.2-47.3 134.8c-4.7 52.8 34.2 99.4 86.9 104.2c52.2 4.7 98.5-33.3 104.1-85.2l0-.3zM240 192a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM160 272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fast',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      'M0 0H512V16H0V0zM48 112v96h96V112H48zM32 96H48h96 16v16 96 16H144 48 32V208 112 96zM48 400v96h96V400H48zM32 384H48h96 16v16 96 16H144 48 32V496 400 384zM304 112H208v96h96V112zM208 96h96 16v16 96 16H304 208 192V208 112 96h16zm0 304v96h96V400H208zm-16-16h16 96 16v16 96 16H304 208 192V496 400 384zM464 112H368v96h96V112zM368 96h96 16v16 96 16H464 368 352V208 112 96h16zm0 304v96h96V400H368zm-16-16h16 96 16v16 96 16H464 368 352V496 400 384zm160-96v16H0V288H512z'
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fast',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      'M296 32V24H280v8V48.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V224v8h16v-8V207.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V32zM151.6 320h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fast',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240 80h32v32H240V336zm0-192l32 0v32l-32 0V144zm0 128l0-32 32 0v32H240z'
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fast',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM132.4 157.3l7.2 3.6 80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L198.1 208l-65.7-32.8-7.2-3.6 7.2-14.3zm240 3.6l7.2-3.6 7.2 14.3-7.2 3.6L313.9 208l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L278.1 208l14.3-7.2 80-40z'
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fast',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      'M16 464l416 0 0-416L16 48l0 416zM0 480l0-16L0 48 0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480zM224 288l112 0 0-64-112 0-16 0 0-16 0-64-1.4 0L94.6 256l112 112 1.4 0 0-64 0-16 16 0zM83.3 267.3L72 256l11.3-11.3L200 128l8 0 16 0 0 16 0 48 0 16 16 0 96 0 16 0 0 16 0 64 0 16-16 0-96 0-16 0 0 16 0 48 0 16-16 0-8 0L83.3 267.3z'
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fast',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      'M0 256l11.3 11.3L244.7 500.7 256 512l11.3-11.3L500.7 267.3 512 256l-11.3-11.3L267.3 11.3 256 0 244.7 11.3 11.3 244.7 0 256zM256 489.4L22.6 256 256 22.6 489.4 256 256 489.4z'
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fast',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      'M112 144v0H336v0V66.5l-112-49-112 49V144zm224 16H244.9l-21.8 43.6-2.2 4.4H216 116.6c13.8 46.3 56.6 80 107.4 80c61.9 0 112-50.1 112-112V160v0zm.8 76.6C315.2 276.7 272.8 304 224 304s-91.2-27.3-112.8-67.4l-2.4 1.8L48 284v20h72 8v16h-8H40 32v-8V280v-4l3.2-2.4L96 228V176 160v0-8-8 0V56L224 0 352 56v88 0 8 8 0 16 52l60.8 45.6L416 276v4 32 8h-8H328h-8V304h8 72V284l-60.8-45.6-2.4-1.8zM112 160v16c0 5.4 .4 10.8 1.1 16h97.9l16-32H112v0zM224 452.6l-11.3-11.3L139.4 368H74.8L23.6 496H424.4L373.2 368H308.6l-73.2 73.2L224 452.6zM301.9 352H384l57.6 144 6.4 16H430.8 17.2 0l6.4-16L64 352h82.1l66.6 66.6L224 429.9l11.3-11.3L301.9 352zM232 48V72h24 8V88h-8H232v24 8H216v-8V88H192h-8V72h8 24V48 40h16v8z'
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fast',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      'M432 48H16V464H284.5c3.6 5.6 7.6 10.9 11.8 16H16 0V464 48 32H16 432h16V48 192.7c-5.3-.5-10.6-.7-16-.7V48zM224 96c69.3 0 128.3 44 150.5 105.6c-5.1 1.8-10 3.7-14.9 5.9C339.7 151.8 286.5 112 224 112c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c.8 5.3 1.9 10.5 3.2 15.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm16 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H440v64 8H424v-8V376H360h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fast',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      'M171.2 0H176 336h4.8l2.3 4.3 72 136 .9 1.8v2 64 3.7l-2.8 2.4-49.4 42.4 56.7 56.7 5.7 5.7 3.5 3.5 5.7 5.7 70.8 70.8 5.7 5.7-11.3 11.3-5.7-5.7L424 339.3 387.3 376l70.8 70.8 5.7 5.7-11.3 11.3-5.7-5.7L376 387.3 339.3 424l70.8 70.8 5.7 5.7-11.3 11.3-5.7-5.7-76.4-76.4L98.4 213.8 96 211.4V208 144v-2l.9-1.8 72-136L171.2 0zM346.3 261.7l-144-144-2.3-2.3V112v-8V96h8 88 8v16h-8H219.3L352.4 245.1 400 204.3V146L331.2 16H180.8L112 146v58.6L324.3 409.3l.2-.2 3.5 3.5L412.7 328l-3.5-3.5-62.8-62.8zM227.7 391.6L113.2 506.1l-5.7 5.7L96.2 500.5l5.7-5.7L216.4 380.3l11.3 11.3zm-48-48L65.2 458.1l-5.7 5.7L48.2 452.5l5.7-5.7L168.4 332.3l11.3 11.3zm-48-48L17.2 410.1l-5.7 5.7L.2 404.5l5.7-5.7L120.4 284.3l11.3 11.3z'
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fast',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      'M280 88c0-39.8 32.2-72 72-72s72 32.2 72 72v40.3c-42.8 3-72 30.2-72 74.8c0 29.3 35.8 79.4 80 116.9c44.2-37.5 80-88 80-116.9c0-44.6-29.2-71.8-72-74.8V88c0-48.6-39.4-88-88-88s-88 39.4-88 88v88.5c-18.4-29.2-50.9-48.5-88-48.5c-57.4 0-104 46.6-104 104v24.3c-42.8 3-72 30.2-72 74.8C0 360.4 35.8 410.5 80 448c44.2-37.5 80-88 80-116.9c0-44.6-29.2-71.8-72-74.8V232c0-48.6 39.4-88 88-88s88 39.4 88 88v48 8V504v8h16v-8V288v-8V232 88zm144 56.3V200v8h16v-8V144.3c16.6 1.4 29.7 7 38.9 15.3c10.4 9.5 17.1 23.7 17.1 43.4c0 9.3-6.4 25.6-20.6 46.1c-11.4 16.4-26.5 33.7-43.4 49.4c-17-15.7-32.1-32.9-43.4-49.3c-14.2-20.4-20.6-36.8-20.6-46.2c0-19.7 6.7-34 17.1-43.4c9.1-8.3 22.3-13.9 38.9-15.3zM33.1 287.6c9.1-8.3 22.3-13.9 38.9-15.3v55.9 8H88v-8V272.3c16.6 1.4 29.7 7 38.9 15.3c10.4 9.5 17.1 23.7 17.1 43.4c0 9.3-6.4 25.6-20.6 46.1C112 393.6 96.9 410.9 80 426.6C63 410.9 47.9 393.7 36.6 377.3C22.4 356.9 16 340.5 16 331.1c0-19.7 6.7-34 17.1-43.4z'
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fast',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM144 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm144 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fast',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM216 424v8h16v-8l0-156.7 74.3 74.3 5.7 5.7L323.3 336l-5.7-5.7-88-88-5.7-5.7-5.7 5.7-88 88-5.7 5.7L136 347.3l5.7-5.7L216 267.3 216 424z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fast',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M16 183.1L160 53.5 304 183.1V208H16V183.1zM160 32L0 176v32 16H16 304h16V208 176L160 32z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fast',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM144 136V368H312h8v16h-8H136h-8v-8V136v-8h16v8z'
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fast',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      'M266.5 495.8c-9.8-61.2 8.9-126 56.1-173.2s112-65.8 173.2-56.1c.2-3.5 .2-7 .2-10.5C496 123.5 388.5 16 256 16c-3.5 0-7 .1-10.5 .2c9.8 61.2-8.9 126-56.1 173.2s-112 65.8-173.2 56.1c-.2 3.5-.2 7-.2 10.5c0 132.5 107.5 240 240 240c3.5 0 7-.1 10.5-.2zm16-1.2c111.3-12.2 199.8-100.7 212-212c-56.7-9.5-116.9 7.6-160.7 51.4s-60.8 104-51.4 160.7zM229.5 17.5c-111.3 12.2-199.8 100.7-212 212c56.7 9.5 116.9-7.6 160.7-51.4s60.8-104 51.4-160.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fast',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 10.8-.7 21.3-2.1 31.7c-10 76-55.7 140.8-119.6 177.1c-3.6 8.8-8.2 17.2-13.7 24.9c79.4-35.6 137.4-110.6 149.1-200.1c1.4-11 2.2-22.2 2.2-33.6C512 114.6 397.4 0 256 0S0 114.6 0 256c0 1.4 0 2.7 0 4.1C1.6 362.4 63.3 450.2 151.3 489.7c-5.4-7.7-10-16-13.7-24.9C73.7 428.5 28 363.6 18.1 287.5C16.7 277.2 16 266.7 16 256zm336 64h39.8c-2 34.5-16.8 65.5-39.8 88.3V320zM256 512c48 0 87.8-35.2 94.9-81.2C385.7 402.9 408 360.1 408 312v-8h-8H352 336 176 160 112h-8v8c0 48.1 22.3 90.9 57.1 118.8c7.1 46 46.9 81.2 94.9 81.2zM120.2 320H160v88.3c-23-22.9-37.8-53.9-39.8-88.3zm71.8 0H320h16v16 80c0 44.2-35.8 80-80 80s-80-35.8-80-80V336 320h16zm47.9 59.1c2-1.4 5.1-2.4 9.2-2.8c8.3-.9 18.5 .9 25.9 2.8l7.8 2 3.9-15.5-7.8-2c-4.1-1-9.3-2.2-15-2.9V352v-8H248v8 8.3l-.6 .1c-5.6 .6-11.6 2.1-16.6 5.6c-5.3 3.6-9 9.1-10.3 16.3c-1 5.3-.5 10.3 1.6 14.8c2.1 4.4 5.4 7.6 8.9 9.9c6.5 4.3 15.2 6.7 22.3 8.6l.7 .2c8 2.2 14.3 4 18.3 6.7c1.8 1.2 2.8 2.3 3.2 3.4c.4 1 .8 2.5 .3 5.2c-.7 3.9-2.4 5.8-4.4 7c-2.3 1.3-5.7 2.1-10.3 2.1h-.3l-.5 0c-10-.2-21.7-3.6-29.9-6.2l-7.6-2.4L218 446.6l7.6 2.4c5.5 1.7 13.7 4.3 22.4 5.8v6.6 8h16v-8-5.4c5.2-.3 10.6-1.4 15.3-4.1c6.3-3.6 10.7-9.7 12.2-18c1-5.3 .5-10.3-1.6-14.8c-2.1-4.4-5.4-7.6-8.9-9.9c-6.5-4.3-15.2-6.7-22.3-8.6l-.7-.2c-8-2.2-14.3-4-18.3-6.7c-1.8-1.2-2.8-2.3-3.2-3.4c-.4-1-.8-2.5-.3-5.2c.6-3.1 1.9-4.8 3.7-6zM184 101.3v-8H168v8 11.1c-6.3 .6-12.2 2.1-17.4 4.4c-10.2 4.5-18.4 12.5-20.4 23.7c-1.2 6.7-.5 12.8 2.1 18.1c2.6 5.3 6.7 9.2 11.2 12.1c8.2 5.4 19.3 8.7 29 11.5l1.4 .4c10.8 3.2 19.8 6 25.8 10.2c2.8 2 4.6 4.1 5.6 6.3c1 2.2 1.5 5.1 .7 9.4c-1 5.6-4.6 9.8-11 12.5c-6.7 2.8-16.3 3.7-27.6 2c-5.6-.9-15.1-4-22.7-6.6l0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.7-1.5l-7.6-2.5-4.9 15.2 7.6 2.5c1.1 .4 2.4 .8 3.9 1.3l0 0c7.5 2.5 18.9 6.3 25.9 7.4l0 0c1 .2 2 .3 3 .4v11.3 8h16v-8V239.8c6.2-.5 12-1.7 17.1-3.9c10.5-4.4 18.5-12.5 20.6-24.5c1.2-6.9 .6-13.2-1.9-18.7c-2.5-5.5-6.5-9.6-11-12.8c-8.6-6.1-20.4-9.6-30.5-12.5l-.1 0c-10.9-3.2-20-5.9-26.1-9.9c-2.9-1.9-4.6-3.8-5.6-5.8c-.9-1.9-1.4-4.4-.7-8.3c.8-4.5 4.2-8.9 11.1-11.9c6.9-3 16.5-4.3 27.5-2.6c3.6 .5 14.7 2.7 18.2 3.6l4-15.5c-4.2-1.1-15.9-3.3-19.8-3.9c-1-.2-2-.3-3-.4V101.3zm160-8H328v8 11.1c-6.3 .6-12.2 2.1-17.4 4.4c-10.2 4.5-18.4 12.5-20.4 23.7c-1.2 6.7-.5 12.8 2.1 18.1c2.6 5.3 6.7 9.2 11.2 12.1c8.2 5.4 19.3 8.7 29 11.5l1.4 .4c10.8 3.2 19.8 6 25.8 10.2c2.8 2 4.6 4.1 5.6 6.3c1 2.2 1.5 5.1 .7 9.4c-1 5.6-4.6 9.8-11 12.5c-6.7 2.8-16.3 3.7-27.6 2c-5.6-.9-15.1-4-22.7-6.6l0 0c-1.7-.6-3.2-1.1-4.7-1.5l-7.6-2.5-4.9 15.2 7.6 2.5c1.1 .4 2.4 .8 3.9 1.3l0 0c7.5 2.5 18.9 6.3 25.9 7.4l0 0c1 .2 2 .3 3 .4v11.3 8h16v-8V239.8c6.2-.5 12-1.7 17.1-3.9c10.5-4.4 18.5-12.5 20.6-24.5c1.2-6.9 .6-13.2-1.9-18.7c-2.5-5.5-6.5-9.6-11-12.8c-8.6-6.1-20.4-9.6-30.5-12.5l-.1 0c-10.9-3.2-20-5.9-26.1-9.9c-2.9-1.9-4.6-3.8-5.6-5.8c-.9-1.9-1.4-4.4-.7-8.3c.8-4.5 4.2-8.9 11.1-11.9c6.9-3 16.5-4.3 27.5-2.6c3.6 .5 14.7 2.7 18.2 3.6l4-15.5c-4.2-1.1-15.9-3.3-19.8-3.9c-1-.2-2-.3-3-.4V101.3v-8z'
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fast',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      'M400 80V48L224 0 48 48V80L80 99.2V144c16 10.7 67.2 32 144 32s128-21.3 144-32V99.2L400 80zM352 99.2v35.6c-16.2 8.2-50.5 20.5-99.4 24.2c21.5-20.4 27.4-48.8 27.4-67.7V85.8l-5-2L227 64.6l-3-1.2-3 1.2L173 83.8l-5 2v5.4c0 19 5.9 47.4 27.4 67.7c-48.9-3.6-83.2-16-99.4-24.2V99.2 90.1l-7.8-4.7L64 70.9V60.2L224 16.6 384 60.2V70.9L359.8 85.5 352 90.1v9.1zM207.8 458.5L224 431.6l16.2 26.9-6.2 8.2L224 480l-10-13.3-6.2-8.2zm-10.4-13.8L128 352H48L4.8 496 0 512H16.7 431.3 448l-4.8-16L400 352H320l-69.5 92.6-17-28.3 37-51.7 9-12.6H264 184 168.5l9 12.6 37 51.7-17 28.3zm51-76.6l-23.9 33.4-.6-1-.6 1L199.5 368h48.9zM236.8 489.6L328 368h60.1l38.4 128H232l4.8-6.4zm-25.6 0L216 496H21.5L59.9 368H120l91.2 121.6zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-4.8 2.3-10.1 4.5-15.7 6.7c0 .7 0 1.3 0 2c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-.7 0-1.3 0-2c-5.7-2.2-10.9-4.4-15.7-6.7c-.2 2.9-.3 5.8-.3 8.7zm128-32.7c-29-13.7-38.5-41.8-39.8-62.7L224 80.6l39.8 15.9c-1.3 20.9-10.8 49-39.8 62.7z'
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fast',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM192 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-68.5 48H260.5l21.3 64H102.2l21.3-64zM272 368H112L85.3 448 80 464H96.9 287.1 304l-5.3-16L272 368z'
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fast',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      'M534.1 .4L383.3 50.7C377.1 21.7 351.4 0 320.7 0c-35.3 0-64 28.7-64 64c0 9.6 2.1 18.7 5.9 26.9L102.1 144.4l-7.6 2.5 5.1 15.2 7.6-2.5 164.2-54.7c10.1 12.2 24.7 20.6 41.3 22.6V504v8h8 216 8V496h-8-208V127.5c30.6-3.8 54.4-29.2 55.9-60.4L539.2 15.6 534.1 .4zM320.7 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM503.3 80.9L384.2 270.6l-.2 40L457.4 384H566.5l73.4-73.4v-40L522.1 80.9l-9.4-15.1-9.5 15.1zM621.9 272H402.1L512.7 96 621.9 272zm2 16v16l-64 64H464l-64-64 .1-16H623.9zm-495-96l-9.5 15.1L.3 396.8l-.2 40 73.4 73.4H182.6L256 436.8v-40L138.3 207.1 128.9 192zm-.1 30.2L238 398.2H18.3l110.5-176zM240 430.2l-64 64H80.1l-64-64 .1-16H240v16z'
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fast',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240 24c1.4-7.9 1.4-7.9 1.4-7.9l0 0 0 0 0 0 .2 0 .6 .1c.5 .1 1.2 .2 2.2 .4c1.8 .4 4.4 1 7.6 1.8c6.2 1.6 14.6 4 23 7.4c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-8.5 3.2-16.9 5.3-23.2 6.6c-3.1 .7-5.8 1.1-7.6 1.4c-.9 .2-1.7 .3-2.2 .3l-.6 .1-.2 0-.1 0 0 0 0 0s0 0-1-7.9l-1-7.9 0 0 .1 0 .5-.1c.4-.1 1.1-.2 1.9-.3c1.6-.3 4-.7 6.9-1.3c5.8-1.2 13.3-3.1 20.8-5.9c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.9-.5-5.3-.8-7-1c-.8-.1-1.5-.2-1.9-.2l-.5-.1-.1 0 0 0 0 0 0 0 0 0V344.1l0 0 0 0 0 0 0 0 .1 0 .5-.1c.4-.1 1.1-.1 1.9-.2c1.7-.2 4.1-.6 7-1c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-2.9-.7-5.3-1.3-6.9-1.6c-.8-.2-1.5-.3-1.9-.4l-.5-.1-.1 0 0 0 0 0L240 280zm-64.4-80c-14.6 0-30.2 8.6-41 27.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9zm119 27.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fast',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      'M320 3.9l6 6.8c25.9 29.2 49.3 52.5 76.8 69.5c27.3 16.9 59.1 27.9 102 31.8l8 .7-1.4 15.9-8-.7c-8.1-.7-15.8-1.7-23.3-2.9v51l34.9 30.6c19.1 16.7 41.9 28.7 66.6 34.8L608 248v8 16H592 544v48l25.3 33.8c14.9 19.9 34.2 36 56.4 47.1L640 408v8 16H624 576v72 8H560v-8V432H416v72 8H400v-8V432H240v72 8H224v-8V432H80v72 8H64v-8V432H16 0V416v-8l14.2-7.1c22.2-11.1 41.5-27.2 56.4-47.1L96 320V272H48 32V256v-8l26.5-6.6c24.6-6.2 47.4-18.1 66.6-34.8L160 176V124.3c-7.6 1.5-15.3 2.7-23.1 3.6l-8 .9-1.8-15.9 8-.9C204.6 104.3 262.9 68.4 314 10.7l6-6.8zM104 336L83.5 363.4C67.1 385.2 45.8 403 21.4 415.2l-1.6 .8H72 568h52.2l-1.6-.8c-24.4-12.2-45.7-30-62.1-51.8L536 336H104zm424-16V272H112v48H528zM464 121.9c-26.8-6-49.3-15.5-69.7-28.1C367 76.9 343.9 54.5 320 28c-41.9 45.5-89.3 77.8-144 92.6V176H464V121.9zM574.2 256c-25.8-7-49.7-19.8-69.8-37.4L474 192h-2H168h-2l-30.4 26.6c-20.1 17.6-44 30.4-69.8 37.4H104 536h38.2z'
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fast',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M16 480H0V464 48 32H16 336L448 144V464v16H432 16zm416-16V150.6L329.4 48H320V184c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V48H16V464H432zM80 48V176H304V48H80zm72 280a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zm72 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fast',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      'M624 224h16V208 176L544 0H96L0 176v32 16H16 64V504v8h8H376h8v-8V256H368V496H80V224H560V496H512V256H496V504v8h8 64 8v-8V224h48zM105.5 16h429L624 180.1V208H16V180.1L105.5 16zM128 376v8h8H312h8v-8V256H304V368H144V256H128V376z'
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fast',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      'M8 0H0V8 216v96 8H16v-8V224H148.7l128 128L130.3 498.3l11.3 11.3L288 363.3 434.3 509.7l11.3-11.3L299.3 352 445.7 205.7l-11.3-11.3L288 340.7 171.3 224H176c61.9 0 112-50.1 112-112S237.9 0 176 0H8zM176 208H16V16H176c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fast',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      'M129.7 0H136 392h8V8l0 408c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208H95.1L23.8 497.9l-1.9 7.8L6.3 501.9l1.9-7.8 120-488L129.7 0zM99 192H384V16H142.3L99 192zM400 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fast',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      'M560 48H16V192.4c-5.3-.3-10.6-.4-16-.4V48 32H16 560h16V48 464v16H560 288c0-5.4-.1-10.7-.4-16H560V48zM0 240V224c141.4 0 256 114.6 256 256H240C240 347.5 132.5 240 0 240zM48 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm144 32c0-79.5-64.5-144-144-144V320c88.4 0 160 71.6 160 160H144z'
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fast',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      'M246.8 66.6C237.6 54.8 223.5 48 208.6 48C181.8 48 160 69.8 160 96.6V144h80 16 51.7L246.8 66.6zM144 144V96.6C144 60.9 172.9 32 208.6 32c19.8 0 38.6 9.1 50.8 24.7L320 133.8l60.6-77.1c12.2-15.6 31-24.7 50.8-24.7C467.1 32 496 60.9 496 96.6V144H624h16v16V288L576 416 400 383v79.8V480l-16-6.4L320 448l-64 25.6L240 480V462.8 383L64 416 0 288V160 144H16 144zm96 222.7V160H160 144 16V284.2L72.9 398.1 240 366.7zm160 0l167.1 31.3L624 284.2V160H496 480 400V366.7zM400 144h80V96.6C480 69.8 458.2 48 431.4 48c-14.9 0-29 6.8-38.2 18.6L332.3 144H384h16zm-72 16H312 256V456.4l58.1-23.2 5.9-2.4 5.9 2.4L384 456.4V160H328z'
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fast',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      'M48 0h8 48 8V8 80c0 44.2 35.8 80 80 80s80-35.8 80-80V8 0h8 48 8V8 134.5L383.4 253l.6 1.4V256 504v8h-8H8 0v-8V256v-1.5L.6 253 48 134.5V8 0zM64 16V136v1.5l-.6 1.4L16 257.5V496H368V257.5L320.6 139l-.6-1.4V136 16H288V80c0 53-43 96-96 96s-96-43-96-96V16H64z'
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fast',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      'M96 32H88V48h8 9.7c-7 6.4-15.4 14.8-23.9 24.9C61.3 97.6 40 133.3 40 176c0 21.4 8 37 17.8 48H56 48v16h8H68.3L51.6 384H67.7L84.4 240h87.3l16.6 144h16.1L187.7 240H200h8V224h-8-1.8c9.8-11 17.8-26.6 17.8-48c0-42.7-21.3-78.4-41.9-103.1c-8.4-10.1-16.8-18.5-23.9-24.9H160h8V32h-8H128h0H96zm78.1 192l0 0H81.9l0 0C69.7 215.7 56 201 56 176c0-37.3 18.7-69.6 38.1-92.9c9.7-11.6 19.3-20.8 26.6-27.1c2.9-2.5 5.3-4.5 7.3-6c1.9 1.5 4.4 3.5 7.3 6c7.3 6.3 16.9 15.5 26.6 27.1c4.6 5.6 9.2 11.6 13.5 18.2l-45.1 45.1-5.7 5.7L136 163.3l5.7-5.7 42.2-42.2c9.5 17.8 16.1 38.3 16.1 60.5c0 25-13.7 39.7-25.9 48zM48 416H44.3l-2.4 2.9-40 48L0 469.1V472v32 8H8 248h8v-8V472v-2.9l-1.9-2.2-40-48-2.4-2.9H208 48zM16 474.9L51.7 432H204.3L240 474.9V496H16V474.9z'
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fast',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM151.6 378.4l-15.3-4.7C151.8 323.9 199.7 288 256 288s104.2 35.9 119.6 85.6l-15.3 4.7C347.1 335.5 305.5 304 256 304s-91.1 31.5-104.4 74.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fast',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      'M432 16V496H16V16H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 336c-68 0-123.6-53-127.8-120H184h8V296h-8H96.2C100.4 229 156 176 224 176c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0 16a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fast',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      'M19.2 51.2V176H492.8V51.2H19.2zm0 140.8V460.8H492.8V192H19.2zM0 32H19.2 492.8 512V51.2 460.8 480H492.8 19.2 0V460.8 51.2 32z'
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fast',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1L512 197.5V40 32h-8H392h-8v8V87.7L293.2 9.9zM400 101.5V48h96V183.7l-96-82.3zm96 103.4V496H368V312v-8h-8H216h-8v8V496H80V204.8L288 26.5 496 204.8zM352 496H224V320H352V496z'
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fast',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      'M8 0H0V8 184v8H16v-8V27.3L314.3 325.7l5.7 5.7L331.3 320l-5.7-5.7L27.3 16H184h8V0h-8H8zM288 64h-8V80h8c114.9 0 208 93.1 208 208s-93.1 208-208 208S80 402.9 80 288v-8H64v8c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z'
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fast',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3 5.7 5.7L488 435.3l-5.7-5.7L432 379.3l-50.3 50.3-5.7 5.7L364.7 424l5.7-5.7L420.7 368l-50.3-50.3-5.7-5.7L376 300.7l5.7 5.7L432 356.7l50.3-50.3 5.7-5.7L499.3 312l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fast',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      'M80 83.7V96H496l0-12.3C482.5 61.9 430.7 16 288 16c-68 0-117.4 12.1-151.3 26.9C104.3 57 86.6 73.4 80 83.7zM80 256H280V112H80V256zm216 0H496V112H296V256zM80 432l16 0h16 64 16l178.3 0 13.7 0h16 64 16l16 0 0-160H80V432zm304 16l-13.7 0L192 448v48 16H176 112 96V496 448l-24 0H64v-8V81.5 79.4l1-1.8c8-14.4 29.3-33.7 65.2-49.4C166.5 12.4 218.1 0 288 0C437.6 0 495.3 49.6 511 77.6l1 1.8v2.1V440v8h-8l-24 0v48 16H464 400 384V496 448zm80 0H400v48h64V448zm-352 0v48h64V448H112zm8-96a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 48H352h8V64h-8H224h-8V48h8zM0 112H8 32h8v16H32 16V256H32h8v16H32 8 0v-8V120v-8zm568 0h8v8V264v8h-8H544h-8V256h8 16V128H544h-8V112h8 24z'
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fast',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      'M304 48L112 48V16l192 0V48zm16-32V0H304 112 96V16 48 64l16 0 16 0V224H64V208 192H48 16 0v16V400v16H16 48 64V400 384H320V368H64V240h72 8v-8V64H272V232v8h8 40V224H288V64h16 16V48 16zm48 152.6L452.8 112H624V496H452.8L368 439.4V168.6zM448 96l-96 64V448l96 64H624h16V496 112 96H624 448zm0 128v16h8H568h8V224h-8H456h-8zm0 72v16h8H568h8V296h-8H456h-8zm0 72v16h8H568h8V368h-8H456h-8zM16 208H48V400H16V208z'
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fast',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      'M584 8V0H568V8 504v8h16v-8V8zM456 96H440v8V504v8h16v-8V104 96zM328 200v-8H312v8V504v8h16v-8V200zM200 288H184v8V504v8h16v-8V296v-8zM72 384H56v8V504v8H72v-8V392v-8z'
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fast',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM149.7 269.7l5.7-5.7L144 252.7l-5.7 5.7-56 56L76.7 320l5.7 5.7 56 56 5.7 5.7L155.3 376l-5.7-5.7L99.3 320l50.3-50.3zm96-11.3l-5.7-5.7L228.7 264l5.7 5.7L284.7 320l-50.3 50.3-5.7 5.7L240 387.3l5.7-5.7 56-56 5.7-5.7-5.7-5.7-56-56z'
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fast',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      'M45.4 65.8C63.6 33.7 87.4 16 112 16H354.8c-13.6 10.2-25.5 24.7-35.3 42C299.9 92.7 288 140.1 288 192s11.9 99.3 31.5 134c9.8 17.3 21.7 31.8 35.3 42H112c-24.6 0-48.4-17.7-66.6-49.8C27.4 286.3 16 241.7 16 192s11.4-94.3 29.4-126.2zM400 16c24.6 0 48.4 17.7 66.6 49.8C484.6 97.7 496 142.3 496 192s-11.4 94.3-29.4 126.2c-18.2 32.1-42 49.8-66.6 49.8s-48.4-17.7-66.6-49.8C315.4 286.3 304 241.7 304 192s11.4-94.3 29.4-126.2C351.6 33.7 375.4 16 400 16zm96 275.5V496H176V416H160v88 8h8H504h8v-8V192c0-51.9-11.9-99.3-31.5-134C461 23.5 432.9 0 400 0H112C79.1 0 51 23.5 31.5 58C11.9 92.7 0 140.1 0 192s11.9 99.3 31.5 134C51 360.5 79.1 384 112 384H400c32.9 0 61-23.5 80.5-58c5.9-10.4 11.1-22 15.5-34.6zM420.6 255c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM400 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56z'
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fast',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      'M96 416h16H496h16V400 112L400 0H176 160 112 96V16 400v16zM112 16h48V136v8h8H376h8v-8V16h9.4L496 118.6V400H112V16zM368 128H176V16H368V128zM240 272a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM16 96H0v16V496v16H16 400h16V496 448H400v48H16V112H64V96H16z'
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fast',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      'M256 7l3.7 1.9L411.3 88H416v2.5l27.7 14.5 7.1 3.7-7.4 14.2-7.1-3.7L416 108.5V216v8h-8H345.7l52.9 272H504h8v16h-8H392.1h-.3H120.2h-.3H8 0V496H8 113.4l52.9-272H104 96v-8V108.5L75.7 119.1l-7.1 3.7-7.4-14.2 7.1-3.7L96 90.5V88h4.7L252.3 8.9 256 7zm0 18L112 100.2V208h63.8 .3H335.9h.3H400V100.2L256 25zM382.3 496L377 468.7 256 373.6 135 468.7 129.7 496H382.3zM170.5 286.1L256 353.3l85.5-67.2L329.4 224H182.6l-12.1 62.1zm-3.4 17.7L139.7 444.6l103.4-81.2-76-59.7zm101.9 59.7l103.4 81.2L344.9 303.7l-76 59.7zM160 112v48H352V112H160zM144 96h16H352h16v16 48 16H352 160 144V160 112 96z'
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fast',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M0 512l4.4-17.6L40 352 380.7 11.3 392 0l11.3 11.3 97.4 97.4L512 120l-11.3 11.3L160 472 17.6 507.6 0 512zm151.8-54.4L411 198.3 313.7 101 54.4 360.2 22 490l129.8-32.5zM422.3 187l67-67L392 22.6l-67 67L422.3 187z'
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fast',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      'M528.1 512l-20.3-16H117.7l54.2-176H284.9l-20.3-16H160L100.9 496 96 512h16.7H527.3h.8zM448 128C448 57.3 390.7 0 320 0c-51 0-95 29.8-115.6 73l12.9 10.2C234.6 43.6 274.1 16 320 16c61.9 0 112 50.1 112 112c0 36.6-17.5 69-44.6 89.5l12.9 10.2C429.4 204.2 448 168.3 448 128zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fast',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM221.5 82.9l-12.6 3.5C134.6 106.9 80 175.1 80 256s54.6 149.1 128.9 169.6l12.6 3.5 5.9-11.6c5.3-10.4 16.1-17.5 28.5-17.5s23.2 7.1 28.5 17.5l5.9 11.6 12.6-3.5C377.4 405.1 432 336.9 432 256s-54.6-149.1-128.9-169.6l-12.6-3.5-5.9 11.6C279.2 104.9 268.4 112 256 112s-23.2-7.1-28.5-17.5l-5.9-11.6zm-8.3 18.9c7.9 15.6 24.1 26.2 42.8 26.2s34.8-10.7 42.8-26.2C366.4 120.5 416 182.5 416 256s-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2C145.6 391.5 96 329.5 96 256s49.6-135.5 117.2-154.2zM204 180H180v24h24V180zm0 64H180v24h24V244zm-24 64v24h24V308H180zm88-104V180H244v24h24zm0 128V308H244v24h24zm40-152v24h24V180H308zm-64 64v24h24V244H244zm88 0H308v24h24V244zm-24 64v24h24V308H308z'
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fast',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      'M137.3 464l237.4 0L493.6 256 374.7 48 137.3 48 18.4 256 137.3 464zM0 256L128 32l256 0L512 256 384 480l-256 0L0 256z'
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fast',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      'M16 496H342.2c6.3 5.7 12.9 11 19.9 16H16 0V496 16 0H16 224L384 160v48.3l-16 6.2V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 290.7L440 244.3V491.9c79.1-33.5 120-119 120-195.9v-5.3zm-256 0V296c0 76.9 40.9 162.4 120 195.9V244.3L304 290.7zM432 512c-96-32-144-130.1-144-216V279.7L432 224l144 55.8V296c0 85.9-48 184-144 216z'
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fast',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      'M64 48H192V18.3L64 35.3V48zM48 21.3L192 2.1 208 0V16.1 48 64H192 64 48V48 21.3zM312 192h13.3H442.7 456l2.4 13.1 18 96 .6 2.9 3 16H463.7h-3H307.3h-3H288l3-16 .6-2.9 18-96L312 192zM460.7 304l-3-16-15-80H325.3l-15 80-3 16h16.3H444.4h16.3zM432 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM64 96c0-5.5 .7-10.9 2-16H82.7C81 85 80 90.4 80 96c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H190c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64zM51.3 304H194.1L68 215 51.3 304zm150.8-14l-15.4-82H85.9l116.2 82zM56 192H200l21 112 3 16H207.7 48.3 32l3-16L56 192zm87.3 164.7l6 5.3 72 64 6.7 6-6.7 6-72 64-6 5.3-10.6-12 6-5.3L195 440H8 0V424H8 195l-56.3-50-6-5.3 10.6-12zM362.7 362l6-5.3 10.6 12-6 5.3L317 424H504h8v16h-8H317l56.3 50 6 5.3-10.6 12-6-5.3-72-64-6.7-6 6.7-6 72-64z'
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fast',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM186.9 160h10.2l2.1 4.6L286.1 352H268.5l-29.7-64H145.2l-29.7 64H97.9l86.9-187.4 2.1-4.6zm44.5 112L192 187l-39.4 85h78.8zM312 160h8 64c53 0 96 43 96 96s-43 96-96 96H320h-8v-8V168v-8zm16 16V336h56c44.2 0 80-35.8 80-80s-35.8-80-80-80H328z'
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fast',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      'M40 28.7l5.7 5.7L208 196.7V72 64h16v8V216v8h-8H72 64V208h8H196.7L34.3 45.7 28.7 40 40 28.7zM483.3 40l-5.7 5.7L315.3 208H440h8v16h-8H296h-8v-8V72 64h16v8V196.7L466.3 34.3l5.7-5.7L483.3 40zM64 288h8H216h8v8V440v8H208v-8V315.3L45.7 477.7 40 483.3 28.7 472l5.7-5.7L196.7 304H72 64V288zm224 0h8H440h8v16h-8H315.3L477.7 466.3l5.7 5.7L472 483.3l-5.7-5.7L304 315.3V440v8H288v-8V296v-8z'
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fast',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      'M8 0H0V8 32v.6l.1 .6L31.9 231.8 .2 382.4l-.2 .8v.8 56 64 8H8 112h8v-8V448h22.1l126.3 63.2 1.7 .8H272 472h32 8V496h-8H480V432v-4.5l-3.8-2.3L272 299.5V8 0h-8H8zm8 448h88v48H16V448zm96-16H16V384.8L47.8 233.6l.3-1.4-.2-1.5L16 31.4V16h96V248v8h16v-8V16H256V304v4.5l3.8 2.3L464 436.5V496H273.9L147.6 432.8l-1.7-.8H144 112z'
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fast',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      'M0 80V64H16 624h16V80 208v16H624c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v16 96 16H624 16 0V432 80zM16 432H624V336c-35.3 0-64-28.7-64-64s28.7-64 64-64V80H16V432zM464 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 128h56 4.6l2.3 4 49 84h39c18.2 0 35.6 7.2 48.5 20.1c11 11 11 28.8 0 39.9c-12.9 12.9-30.3 20.1-48.5 20.1h-39l-49 84-2.3 4H232 176 164.9l3.5-10.5L194.2 296H156l-21.6 28.8L132 328h-4H96 85.8l2.5-9.9L103.8 256 88.2 193.9 85.8 184H96h32 4l2.4 3.2L156 216h38.2l-25.8-77.5L164.9 128H176zm36.9 93.5l3.5 10.5H205.3 152h-4l-2.4-3.2L124 200H106.2l13.5 54.1 .5 1.9-.5 1.9L106.2 312H124l21.6-28.8L148 280h4 53.3 11.1l-3.5 10.5L187.1 368h40.3l49-84 2.3-4h4.6 43.6c13.9 0 27.3-5.5 37.1-15.4c4.8-4.8 4.8-12.5 0-17.2c-9.9-9.9-23.2-15.4-37.1-15.4H283.3h-4.6l-2.3-4-49-84H187.1l25.8 77.5z'
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fast',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      'M184 32v8V144c0 39.8 12.9 78.6 36.8 110.4L240 280c26 34.6 40 76.7 40 120v72 8H264v-8V400c0-39.8-12.9-78.6-36.8-110.4L208 264c-26-34.6-40-76.7-40-120V40 32h16zM16 96v8 53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C100.3 340 112 378.6 112 418.1V472v8H96v-8V418.1c0-36.3-10.8-71.8-30.9-102.1L33.6 268.8C11.7 236 0 197.4 0 157.9V104 96H16zm336 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C436.3 340 448 378.6 448 418.1V472v8H432v-8V418.1c0-36.3-10.8-71.8-30.9-102.1l-31.5-47.3C347.7 236 336 197.4 336 157.9V104 96h16v8z'
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fast',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      'M384 459.1V264v-8H368v8V468.3C334.6 486 296.5 496 256 496s-78.6-10-112-27.7V264v-8H128v8V459.1C60.7 416.5 16 341.5 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 85.5-44.7 160.5-112 203.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48-128c0 26.5-21.5 48-48 48s-48-21.5-48-48V352c0-26.5 21.5-48 48-48s48 21.5 48 48v32zm-48-96c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64s64-28.7 64-64V352c0-35.3-28.7-64-64-64zM118.6 227.9c10.9-19.3 26.4-27.9 41-27.9s30.2 8.6 41 27.9l3.9 7 13.9-7.8-3.9-7c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1l-3.9 7 13.9 7.8 3.9-7zm233-27.9c14.6 0 30.2 8.6 41 27.9l3.9 7 13.9-7.8-3.9-7c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1l-3.9 7 13.9 7.8 3.9-7c10.9-19.3 26.4-27.9 41-27.9z'
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fast',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M106.9 384.5C62.9 342 32.6 291.4 17.3 256c15.2-35.4 45.5-86 89.6-128.5C153.5 82.7 214.2 48 288 48s134.5 34.7 181 79.5c44.1 42.5 74.4 93.1 89.6 128.5c-15.2 35.4-45.5 86-89.6 128.5C422.5 429.3 361.8 464 288 464s-134.5-34.7-181.1-79.5zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z'
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fast',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      'M16 96V83.7C22.6 73.4 40.3 57 72.7 42.9C106.6 28.1 156 16 224 16c142.7 0 194.5 45.9 208 67.7L432 96H16zm0 16H432V256H16V112zm0 160H432l0 160-16 0H400 336 320l-13.7 0L128 432H112 48 32l-16 0V272zM416 448l24 0h8v-8V81.5 79.4l-1-1.8C431.3 49.6 373.6 0 224 0C154.1 0 102.5 12.4 66.3 28.2C30.3 43.9 9.1 63.3 1 77.6L0 79.4v2.1V440v8H8l24 0v48 16H48h64 16V496 448l178.3 0 13.7 0v48 16h16 64 16V496 448zm-16 0v48H336V448h64zM48 448h64v48H48V448zm48-56a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM72 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm320 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fast',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      'M16 368H432V352c0-89.5-48.3-153.6-100.9-202.3c-21-19.4-42.2-36-61.1-50.8l0 0c-4.9-3.8-9.7-7.5-14.2-11.2c-10.9-8.6-21-16.9-28.9-24.8c-1-1-2-2-3-3c-1 1-2 2-3 3c-7.9 7.8-17.9 16.1-28.9 24.8c-4.6 3.6-9.3 7.3-14.2 11.2c-19 14.8-40.1 31.4-61.1 50.8C64.3 198.4 16 262.5 16 352v16zm0 16v25.4L70.6 464H377.4L432 409.4V384H16zM168.4 86.2c19.1-15 35.4-27.7 45.5-38.8c5-5.5 8.5-10.6 10.1-15.4c1.6 4.8 5.1 9.9 10.1 15.4c10.1 11.1 26.4 23.8 45.5 38.8C346.3 138.2 448 217.7 448 352v32 32l-64 64H64L0 416V384 352C0 217.7 101.7 138.2 168.4 86.2z'
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fast',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      'M224 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm83.3 416C389.8 430.9 448 350.3 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H568h8V464h-8H307.3zM224 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fast',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      'M242.9 13l-3.9 7L141.7 192H434.3L337 19.9l-3.9-7L347 5.1l3.9 7L452.7 192h74.8H544h32v16H540L464 512H112L36 208H0V192H32 48.5h74.8L225 12.1l3.9-7L242.9 13zM52.5 208l72 288h327l72-288H52.5zM208 296V408v8H192v-8V296v-8h16v8zm88-8v8V408v8H280v-8V296v-8h16zm88 8V408v8H368v-8V296v-8h16v8z'
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fast',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      'M464 8V32H624h16V48 176v16H624 464V512H448V192h0V176 48 32h0V8 0h16V8zM624 176V48H464V176H624zM276.8 33.6L416 138v20L272 50 80 194V496l336 0v16H72 64v-8V206L20.8 238.4l-6.4 4.8L4.8 230.4l6.4-4.8 256-192L272 30l4.8 3.6zM240 184h64 8v8 56h56 8v8 64 8h-8H312v56 8h-8H240h-8v-8V328H176h-8v-8V256v-8h8 56V192v-8h8zm8 72v8h-8H184v48h56 8v8 56h48V320v-8h8 56V264H304h-8v-8V200H248v56z'
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fast',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      'M48 16V496H336V16H48zM32 0H48 336h16V16 496v16H336 48 32V496 16 0zM176 432a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fast',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      'M42.1 53.4l-5.4-5.9L48.5 36.7l5.4 5.9 192 208 5 5.4-5 5.4-192 208-5.4 5.9L36.7 464.5l5.4-5.9L229.1 256 42.1 53.4zM232 464H568h8v16h-8H232h-8V464h8z'
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fast',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM345.4 304L256 393.4 166.6 304H144L244.7 404.7 256 416l11.3-11.3L368 304H345.4zM160 208v-8.6l96-82.3 96 82.3V208H160zm-16-16v16 16h16H352h16V208 192L256 96 144 192z'
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fast',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      'M80.7 92L420 431.3C377.1 471.4 319.4 496 256 496C123.5 496 16 388.5 16 256c0-63.4 24.6-121.1 64.7-164zM235.3 224L92 80.7C134.9 40.6 192.6 16 256 16c132.5 0 240 107.5 240 240c0 63.4-24.6 121.1-64.7 164l-100-100H408h8v-8V232v-8h-8H235.3zm16 16H400v64H315.3l-64-64zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16-408H256v8c0 22.1 17.9 40 40 40h48c13.3 0 24 10.7 24 24v8h16v-8c0-22.1-17.9-40-40-40H296c-13.3 0-24-10.7-24-24v-8zM252.1 304H112V240h76.1l-16-16H104 96v8 80 8h8H268.1l-16-16z'
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fast',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      'M8 0H0V16H8 112V424v8h8 68.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H476.2c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32H632h8V416h-8H512 224 128V8 0h-8H8zM544 464a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 496a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM592 80V336H208V80H336V204v20l16-12 48-36 48 36 16 12V204 80H592zM352 80h96V192l-38.4-28.8L400 156l-9.6 7.2L352 192V80zM592 64H464 448 352 336 208 192V80 336v16h16H592h16V336 80 64H592z'
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fast',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v8V280v96 8h16v-8V288h91.9l69.3 96H357l-70.3-97.3c37.2-6.9 65.3-39.5 65.3-78.7c0-44.2-35.8-80-80-80H168h-8zm16 144V144h96c35.3 0 64 28.7 64 64s-28.7 64-64 64H176z'
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fast',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      'M344 96h8v8V344v8H336v-8V123.3L53.7 405.7 48 411.3 36.7 400l5.7-5.7L324.7 112H104 96V96h8H344z'
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fast',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      'M48 140C48 71.5 103.5 16 172 16h40.3c44.1 0 85.9 10.1 123.2 28.1l2.5 1.2 2.7-.6L454 19.8l8.1 6.5-36.5 79.1-2.2 4.7 3.4 3.9C469.9 163.8 496 228.7 496 299.7C496 381.6 429.6 448 347.7 448H261.3h-5.2l-2.1 4.8L234.8 496H180.3l27-60.8 1.4-3.2-1.4-3.2-27-60.8h54.5L254 411.2l2.1 4.8h5.2H332c42 0 76-34 76-76s-34-76-76-76h-4-8v8 80H293.3l-79.3-77.7-2.3-2.3h-3.3H32 16V256 240v-9.2l7.9-4.6 34.2-19.9 6.5-3.8-3.4-6.7C52.8 179 48 160.1 48 140zM172 0C94.7 0 32 62.7 32 140c0 19.9 4.2 38.9 11.7 56.1L15.9 212.4 4 219.3l-4 2.3v4.6V240v16 24 8H8 32 205.1l79.3 77.7 2.3 2.3H290h38 8v-8V280.1c31.3 2.1 56 28.1 56 59.9c0 33.1-26.9 60-60 60H266.5l-19.2-43.2-2.1-4.8H240 168 155.7l5 11.2L191.2 432l-30.6 68.8-5 11.2H168h72 5.2l2.1-4.8L266.5 464h81.2C438.5 464 512 390.5 512 299.7c0-73.1-26.2-140.2-69.7-192.2l37-80.2 2.6-5.7L477 17.8 461 5l-3-2.4-3.7 .8L339.9 28.4C301.2 10.2 257.9 0 212.3 0H172zM144 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fast',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M224 195.3l5.7-5.7 88-88 5.7-5.7L312 84.7l-5.7 5.7L232 164.7V8 0H216V8 164.7L141.7 90.3 136 84.7 124.7 96l5.7 5.7 88 88 5.7 5.7zm0 121.4l-5.7 5.7-88 88-5.7 5.7L136 427.3l5.7-5.7L216 347.3V504v8h16v-8V347.3l74.3 74.3 5.7 5.7L323.3 416l-5.7-5.7-88-88-5.7-5.7zM8 248H0v16H8 440h8V248h-8H8z'
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fast',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      'M232 8V0H216V8 54.8L80 34.4 64 32V48.2v63.6V128l16-2.4 136-20.4V144H176h-3.3l-2.3 2.3L124.7 192H8 0v16H8 128h3.3l2.3-2.3L179.3 160h89.4l45.7 45.7 2.3 2.3H320h56c66.3 0 120 53.7 120 120v40H400V344.1c0-22.1-18-40-40.1-40l-44.1 .1-4.2 0-2.4 3.4c-18.8 26.9-50 44.4-85.3 44.4s-66.4-17.5-85.3-44.4l-2.4-3.4-4.2 0L8 304l-8 0 0 16 8 0 120.1 .2C150 349.2 184.8 368 224 368s74-18.8 95.9-47.8l40.1-.1c13.3 0 24.1 10.7 24.1 24V376v8h8H504h8v-8V328c0-75.1-60.9-136-136-136H323.3l-45.7-45.7-2.3-2.3H272 232V105.2l136 20.4 16 2.4V111.8 48.2 32l-16 2.4L232 54.8V8zM216 71V89L80 109.4V50.6L216 71zm16 18V71L368 50.6v58.8L232 89zM434.1 472.6L448 448.2l13.9 24.4c1.3 2.4 2.1 5 2.1 7.7c0 8.6-7 15.6-15.6 15.6h-.8c-8.6 0-15.6-7-15.6-15.6c0-2.7 .7-5.4 2.1-7.7zm-13.9-7.9c-2.7 4.8-4.2 10.2-4.2 15.7c0 17.5 14.2 31.6 31.6 31.6h.8c17.5 0 31.6-14.2 31.6-31.6c0-5.5-1.4-10.9-4.2-15.7l-18.6-32.6L448 416l-9.2 16.1-18.6 32.6z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fast',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M496 80V208H320V80H496zM16 80H304V208H16V80zm0-16H0V80 208v16H16 496h16V208 80 64H496 16zM496 304V432H192V304H496zM16 304H176V432H16V304zm0-16H0v16V432v16H16 496h16V432 304 288H496 16z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fast',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      'M376.9 474.3l4.4 4.1 5.2-3c75.3-44 126.1-125 126.1-219.4c0-94.2-50.6-178.8-126.1-222.9l-8.1 13.8C448.9 88.2 496.5 167.5 496.5 256c0 86.2-45.2 160.5-113 202.5l-186-176.3-5.8-5.5-11 11.6 5.8 5.5L376.9 474.3zM137.8 37.4l-4.3-4.2-5.2 3C51.7 80.3 0 161.6 0 256c0 94.3 51.5 178.9 128.3 222.9l8-13.9C64.4 423.8 16 344.5 16 256C16 169.8 62 95.2 131.1 53.2L314.5 229.8l5.8 5.5 11.1-11.5-5.8-5.5L137.8 37.4z'
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fast',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM229.7 170.3l120 120 5.7 5.7L344 307.3l-5.7-5.7L224 187.3 109.7 301.7l-5.7 5.7L92.7 296l5.7-5.7 120-120 5.7-5.7 5.7 5.7z'
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fast',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      'M336 5.5l5.2 4.5 224 192 6.1 5.2-10.4 12.1-6.1-5.2L512 177.4V408v8h-8H271.6c-1.9-5.4-4-10.7-6.2-16H496V163.7L336 26.5 176 163.7V284c-5.2-4-10.5-7.9-16-11.5V177.4l-42.8 36.7-6.1 5.2-10.4-12.1 6.1-5.2 224-192L336 5.5zM280 176H392h8v8V296v8h-8H280h-8v-8V184v-8h8zm8 112h96V192H288v96zM0 272V256c141.4 0 256 114.6 256 256H240C240 379.4 132.5 272 0 272zM48 480a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480zm144 32c0-79.5-64.5-144-144-144V352c88.4 0 160 71.6 160 160H144z'
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fast',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.4 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm36-115l4.9 7.4 4.4 6.7 13.3-8.9-4.4-6.7-4.9-7.4c-16.8-25.2-52.5-28.7-73.9-7.3l-29.5 29.5-5.7 5.7L288 171.3l5.7-5.7 29.5-29.5c14.3-14.3 38.1-11.9 49.3 4.9zM120 152v16h8 64 8V152h-8H128h-8zm48 192h-8v16h8H344h8V344h-8H168z'
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fast',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c31.7 0 62-6.1 89.7-17.3l7.2 14.4c-29.9 12.2-62.6 19-96.9 19C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 34.3-6.7 67-19 96.9l-14.4-7.2C489.9 318 496 287.7 496 256C496 123.5 388.5 16 256 16zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm62.2 134.2l5.2 2.8 120 64 4.2 2.3V416v40 3.3l-2.3 2.3-48 48-2.3 2.3H456 416h-4.8l-2.3-4.2-64-120-2.8-5.2 4.2-4.2 32-32 4.2-4.2zm2.9 19.7l-23.6 23.6 59 110.5h31.9L496 452.7V420.8l-110.5-59zM144 328v48 8H128v-8V328v-8h16v8zm64-8v8 48 8H192v-8V328v-8h16zm64 8v48 8H256v-8V328v-8h16v8zm64-8v8 24 8H320v-8V328v-8h16zM461.7 445.7l-16 16-5.7 5.7L428.7 456l5.7-5.7 16-16 5.7-5.7L467.3 440l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fast',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM203.3 148.7l96 96L310.6 256l-11.3 11.3-96 96L192 374.6l-11.3-11.3-96-96L73.4 256l11.3-11.3 96-96L192 137.4l11.3 11.3zM96 256l11.3 11.3 73.4 73.4L192 352l11.3-11.3 73.4-73.4L288 256l-11.3-11.3-73.4-73.4L192 160l-11.3 11.3-73.4 73.4L96 256z'
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fast',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm152 96H256c48.6 0 88 39.4 88 88s-39.4 88-88 88H160v72 8H144v-8V304 288 136v-8h8zM256 288c39.8 0 72-32.2 72-72s-32.2-72-72-72H160V288h96z'
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fast',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      'M232 8V0H216V8 64H80 64V80 304v16H80 368h16V304 80 64H368 232V8zM80 80H368V304H80V80zM32 128H16V256H32V128zm400 0H416V256h16V128zM160 184a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm192 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM232 232H216v48h16V232zM21.5 496L59.9 368H388.1l38.4 128H368V432 416H352 96 80v16 64H21.5zm409.8 16H448l-4.8-16L400 352H48L4.8 496 0 512H16.7 80 96 352h16 63.3zM352 432v64H296V432h56zm-72 0v64H232V432h48zm-64 0v64H168V432h48zm-64 0v64H96V432h56zm0-200v48h16V232H152zm128 0v48h16V232H280z'
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fast',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fast',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      'M496 64v8V244.7L256 75.3 240 64V83.6 233.4L16 75.3 0 64V83.6 428.4 448l16-11.3L240 278.6V428.4 448l16-11.3L496 267.3V440v8h16v-8V256 72 64H496zM256 267.3V244.7 94.9L484.3 256 256 417.1V267.3zM240 259L16 417.1V94.9L240 253v6z'
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fast',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      'M35 144l-4.6 50.1C23.5 270.3 83.5 336 160 336s136.5-65.7 129.6-141.9L285 144H35zm1.5-16H283.6L273.4 16H46.6L36.4 128zm269.1 64.7C313 275.5 250.1 347.4 168 351.8V496h80 8v16h-8H160 72 64V496h8 80V351.8c-82.1-4.4-145-76.2-137.5-159.1L32 0H288l17.5 192.7z'
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fast',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      'M224 457.4L16 249.4V48H217.4L400 230.6v50.7l-176 176zM416 224L224 32H16 0V48 256L212.7 468.7 224 480l11.3-11.3L416 288V224zM344 36.7L332.7 48l5.7 5.7L494.2 209.6v92.9L338.3 458.3l-5.7 5.7L344 475.3l5.7-5.7L507.9 311.4l2.3-2.3v-3.3V206.2v-3.3l-2.3-2.3L349.7 42.3 344 36.7zM152 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fast',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      'M365.7 373.7l-5.7 5.7L348.7 368l5.7-5.7L484.7 232H16V472v8H0v-8V224v-8H8 484.7L354.3 85.7 348.7 80 360 68.7l5.7 5.7 144 144 5.7 5.7-5.7 5.7-144 144z'
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fast',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zM208 96h-8v8 64H136h-8v8 64 8h8 64v64 8h8 64 8v-8V248h64 8v-8V176v-8h-8H280V104 96h-8H208zm8 80V112h48v64 8h8 64v48H272h-8v8 64H216V240v-8h-8H144V184h64 8v-8z'
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fast',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 152h-8H360h-8V360h8H504h8v16z'
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fast',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      'M336 128c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216l-104 0v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112v-8-8s0 0 0 0zm16 0v8 8 52l60.8 45.6L416 244v4 32 8h-8H328h-8V272h8 72V252l-60.8-45.6-2.4-1.8C315.2 244.7 272.8 272 224 272s-91.2-27.3-112.8-67.4L96 128C96 57.3 153.3 0 224 0s128 57.3 128 128M108.8 206.4L48 252v20h72 8v16h-8H40 32v-8V248v-4l3.2-2.4L96 196V144v-8-8l15.2 76.6-2.4 1.8zM284 96h47.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96zm-5-65.6C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1L279 30.4zM168.5 304H184h80 15.5l-9 12.6-37.2 52.1 23.2 46.3L304 320h80l58.7 176 5.3 16H431.1 225.9h-3.8H16.9 0l5.3-16L64 320h80l47.5 95.1 23.2-46.3-37.2-52.1-9-12.6zm80 16H199.5l23.2 32.5 1.2-2.4 1.2 2.4L248.5 320zM209.7 487.2L134.1 336H75.5L22.2 496H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM233.9 496H425.8L372.5 336H313.9L238.3 487.2l-4.4 8.8z'
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fast',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      'M560 48V240H512V196c0-33.1-26.9-60-60-60c-17.9 0-34.1 7.9-45.1 20.4C401.5 126.6 375.4 104 344 104c-24.1 0-45.1 13.3-56 33c-10.9-19.7-31.9-33-56-33c-31.4 0-57.5 22.6-62.9 52.4c-11-12.5-27.1-20.4-45.1-20.4c-33.1 0-60 26.9-60 60v44H16V48H560zM168 196v44H80V196c0-24.3 19.7-44 44-44s44 19.7 44 44zm112-28v72H184V196 168c0-26.5 21.5-48 48-48s48 21.5 48 48zm112 28v44H296V168c0-26.5 21.5-48 48-48s48 21.5 48 48v28zm104 0v44H408V196c0-24.3 19.7-44 44-44s44 19.7 44 44zM16 256H72 176 288 400 504h56 16V240 48 32H560 16 0V48 240v16H16zm496 48h48V464H16V304H64v36c0 33.1 26.9 60 60 60c19.9 0 37.5-9.7 48.4-24.6c9.4 23.8 32.5 40.6 59.6 40.6c24.1 0 45.1-13.3 56-33c10.9 19.7 31.9 33 56 33c27.1 0 50.2-16.8 59.6-40.6C414.5 390.3 432.1 400 452 400c33.1 0 60-26.9 60-60V304zM168 340c0 24.3-19.7 44-44 44s-44-19.7-44-44V304h88v36zm112 12c0 26.5-21.5 48-48 48s-48-21.5-48-48V340 304h96v48zm112-12v12c0 26.5-21.5 48-48 48s-48-21.5-48-48V304h96v36zm104 0c0 24.3-19.7 44-44 44s-44-19.7-44-44V304h88v36zM16 288H0v16V464v16H16 560h16V464 304 288H560 504 400 288 176 72 16z'
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fast',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM224 128h-8v8 64H152h-8v8 64 8h8 64v64 8h8 64 8v-8V280h64 8v-8V208v-8h-8H296V136v-8h-8H224zm8 80V144h48v64 8h8 64v48H288h-8v8 64H232V272v-8h-8H160V216h64 8v-8z'
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fast',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      'M0 48V32H16 53.5C138.3 62.3 230.5 72 320 72s181.7-9.7 266.5-40H624h16V48 464v16H624 586.5c-84.8-30.3-176.9-40-266.5-40c-73.4 0-148.5 6.5-219.9 25.6c-1.2 .7-2.7 1.1-4.1 1.1C81.7 470.6 67.5 475 53.5 480H16 0V464 48zM220.7 428.4L270 362.7l-46-61.3L116.2 445c34.4-8 69.4-13.3 104.5-16.6zM320 424c74 0 150.4 6.6 223.5 25.9L384 237.3 286.4 367.5 242 426.7c26.1-1.9 52.2-2.7 78-2.7zm269.2 40H624V48H589.2C502.8 78.4 409.6 88 320 88s-182.8-9.6-269.2-40H16V464H50.8c13.4-4.7 27-8.9 40.7-12.7L217.6 283.2l6.4-8.5 6.4 8.5L280 349.3l97.6-130.1 6.4-8.5 6.4 8.5L569 457.3c6.8 2.1 13.5 4.3 20.2 6.7zM128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fast',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM104 264c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L200 358.9V384v8H184v-8V354.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H160c-22.1 0-40 17.9-40 40l0 6.5-16 0V264zm72 184V416h32v32H176z'
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fast',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fast',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      'M482.7 140.8c-8.4 16.8-19.8 34-31.5 49.6c-11.6 15.5-23.3 29.1-32.1 38.9c-1.1 1.2-2.1 2.3-3.1 3.4c-1-1.1-2-2.2-3.1-3.4c-8.8-9.8-20.5-23.4-32.1-38.9c-11.7-15.6-23.1-32.7-31.5-49.6C340.8 123.8 336 108.4 336 96c0-44.2 35.8-80 80-80s80 35.8 80 80c0 12.4-4.8 27.8-13.3 44.8zM427 244.4c25.2-27.5 85-97.9 85-148.4c0-53-43-96-96-96s-96 43-96 96c0 48 54 114 81 144H264h-8v8V376v8h8H496V496H160c-4.4 0-8 3.6-8 8s3.6 8 8 8H504h8v-8V376v-8h-8H272V256H416s4.3-4.3 11-11.6zM162.7 396.8c-8.4 16.8-19.8 34-31.5 49.6c-11.6 15.5-23.3 29.1-32.1 38.9c-1.1 1.2-2.1 2.3-3.1 3.4c-1-1.1-2-2.2-3.1-3.4c-8.8-9.8-20.5-23.4-32.1-38.9c-11.7-15.6-23.1-32.7-31.5-49.6C20.8 379.8 16 364.4 16 352c0-44.2 35.8-80 80-80s80 35.8 80 80c0 12.4-4.8 27.8-13.3 44.8zM107 500.4c25.2-27.5 85-97.9 85-148.4c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 120.9 85 148.4c6.7 7.3 11 11.6 11 11.6s4.3-4.3 11-11.6zM416 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fast',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      'M368 48v56V208v16V368H244.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H48V288 272 144 128 48H368zM32 288v80H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H32 48 72.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H368h16 8.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H592h16 24c4.4 0 8-3.6 8-8s-3.6-8-8-8H608V224 208H592 516.9L463.2 100.4C461.8 97.7 459 96 456 96H384V48 32H368 48 32V48v80H16 0v16V272v16H16 32zm0-16H16V144H32V272zm352-64V112h67.1l48 96H384zm0 160V224H511.8h.3H592V368H564.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H384zM88 392a72 72 0 1 1 144 0A72 72 0 1 1 88 392zm392-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144z'
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fast',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      'M242.9 13l-3.9 7L141.7 192H434.3L337 19.9l-3.9-7L347 5.1l3.9 7L452.7 192h74.8H544h32v16H540L464 512H112L36 208H0V192H32 48.5h74.8L225 12.1l3.9-7L242.9 13zM523.5 208H52.5l72 288h327l72-288zM200 344h8 72V272v-8h16v8 72h72 8v16h-8H296v72 8H280v-8V360H208h-8V344z'
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fast',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      'M279.1 49.9l7.4-3.3 49.5-22V112H112V24.6l49.5 22 7.4 3.3 7-4L224 18.4l48.1 27.5 7 4zM336 128v16c0 61.9-50.1 112-112 112s-112-50.1-112-112V128H336zM336 7.1L280 32 224 0 168 32 112 7.1 96 0V17.5 144c0 70.7 57.3 128 128 128s128-57.3 128-128V17.5 0L336 7.1zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304z'
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fast',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      'M16 144H32 64h64 32 56 40 16V128 88c0-30.9-25.1-56-56-56c-9.7 0-18.7 2.4-26.7 6.8c-2 1.1-3.9 2.3-5.8 3.6c-1.2-1.9-2.5-3.8-4-5.6C169.3 24.1 153.6 16 136 16c-22.3 0-41.6 13.1-50.6 32H64C37.5 48 16 69.5 16 96v32 16zM136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72v56 16H272 216 160 128 64 16 0V144 96C0 60.7 28.7 32 64 32H76.1C89 12.7 111 0 136 0zM288.3 1.9C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-4.9-3.1-10-5.7-15.5-7.8c.3-4.6 .4-9.2 .4-13.8C560 123.5 452.5 16 320 16c-6.6 0-13.1 .3-19.5 .8c-3.6-5.3-7.7-10.3-12.1-14.8zM224 476v17.4c-93.8-38-160-130-160-237.4c0-22.1 2.8-43.5 8.1-64H88.6C83 212.4 80 233.8 80 256c0 98.4 59.2 183 144 220zm.4-268a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM640 512H624 560 336 272 256V496 432c0-39.1 28-71.6 65.1-78.6c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6C616.4 365.8 640 396.1 640 432v64 16zM575.1 369.8c-2.6-.6-5.2-1.1-7.8-1.4c.3-1.9 .6-3.9 .7-5.9c0-.8 .1-1.6 .1-2.5c0-26.5-21.5-48-48-48c-8.1 0-15.7 2-22.3 5.5c-4.8 2.5-9.1 5.8-12.8 9.8c-2.8-4.7-6-9-9.6-13C460.6 298.1 439.5 288 416 288c-44.2 0-80 35.8-80 80c-35.3 0-64 28.7-64 64v48 16h16 48H560h48 16V480 432c0-30.1-20.8-55.4-48.9-62.2z'
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fast',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200h-8v16h8 80V496H88V291.3l58.3 58.3 11.3-11.3-72-72L80 260.7l-5.6 5.6 0 0-72 72 11.3 11.3L72 291.3V504v8h8H288 394.8c-6.9-4.9-13.4-10.2-19.6-16H296V224h80 8V208h-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zm80 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fast',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      'M144 400H432V112H344h-8v-8V16H144V400zM344 0l96 96 8 8V400v16H432 144 128V400 16 0h16H344zm8 96h65.4L352 30.6V96zM16 96H96v16H16V496H304V448h16v48 16H304 16 0V496 112 96H16z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fast',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM320 384l0-16 0-224 0-16-16 0-24 0L160 256 280 384l24 0 16 0zM286.9 144l17.1 0 0 224-17.1 0-105-112 105-112z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fast',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      'M160 0h-4.4l-2.4 3.8L115.6 64H0V80H448V64H332.4L294.8 3.8 292.4 0H288 160zM313.6 64H134.4l30-48H283.6l30 48zM24 112l.1 .8 40 392 .7 7.2H72 376h7.2l.7-7.2 40-392 .1-.8H408L368.8 496H79.2L40 112H24zm129.8 94.5l-11.3 11.3 5.7 5.7L212.7 288l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L224 299.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L235.3 288l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L224 276.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fast',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      'M328 0h16 3.7l2.4 2.9L387.7 48h88.5L513.9 2.9 516.3 0H520h16 8V8 128c0 61.9-50.1 112-112 112s-112-50.1-112-112V8 0h8zm8 128c0 53 43 96 96 96s96-43 96-96V16h-4.3L486.1 61.1 483.7 64H480 384h-3.7l-2.4-2.9L340.3 16H336V128zM112 334.7c29.5-79.5 97.5-141.2 183.5-160.8c1.7 5.2 3.8 10.2 6 15C191.3 212.8 112 310.5 112 424v72H328h8v0h32V482.7c0-19.1-15.5-34.7-34.7-34.7H288h-8v-8l0-40c0-26.5-21.5-48-48-48H200h-8V336h8 32c35.3 0 64 28.7 64 64v12.9L404.4 306.3 418 292.9V312 496h46V268.4c5.5-1.2 10.8-2.8 16-4.6V504v8h-8H410h-8v-8V331.1L299.4 432h33.9c28 0 50.7 22.7 50.7 50.7V504v8h-8H184v0H104 96v-8V424 168c0-30.9-25.1-56-56-56H32V96h8c39.8 0 72 32.2 72 72V334.7zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fast',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      'M480 16V224H437.5L391.5 101.2 389.5 96H384 128h-5.5l-1.9 5.2L74.5 224H32V16H480zm16 208V16 0H480 32 16V16 224v16V432v16H32 48v48 16H64h64 16V496 448H368v48 16h16 64 16V496 448h16 16V432 240 224zM448 448v48H384V448h64zm16-16H448 384 368 144 128 64 48 32V240H480V432H464zM64 496V448h64v48H64zM420.5 224H91.5l42-112H378.5l42 112zM112 352a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM80 336a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm336 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fast',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      'M420.7 48H27.3L224 244.7 420.7 48zM16 59.3V452.7L212.7 256 16 59.3zM27.3 464H420.7L224 267.3 27.3 464zM432 452.7V59.3L235.3 256 432 452.7zM0 32H16 432h16V48 464v16H432 16 0V464 48 32z'
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fast',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM176 368h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H176h-8v-8V376v-8h8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H184V496zM456 368h16c17.7 0 32 14.3 32 32v8 8H488v-8-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8-8h16v8 8c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zM296 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H328c-17.7 0-32-14.3-32-32V400zm32-16c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H328z'
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fast',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      'M16 48H48V80H16V48zm128 0V80H112V48h32zm96 0V80H208V48h32zm96 0V80H304V48h32zm64 0h32V80H400V48zM229.7 469.7l-5.7 5.7-5.7-5.7-136-136L76.7 328 88 316.7l5.7 5.7L216 444.7V168v-8h16v8V444.7L354.3 322.3l5.7-5.7L371.3 328l-5.7 5.7-136 136z'
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fast',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      'M512 64c0 247.4-200.6 448-448 448H32L0 368l144-80 67 83.8c68.4-36.1 124.6-92.3 160.8-160.8L288 144 368 0 512 32l0 32zM496 44.8L376.2 18.2 308.6 140l73.2 58.6 10.3 8.3L386 218.5c-37.6 71.3-96.2 129.8-167.4 167.4l-11.7 6.2-8.3-10.3L140 308.6 18.2 376.2 44.9 496H64c238.6 0 432-193.4 432-432l0 0 0-19.2z'
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fast',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      'M8 32H0V48H8 88v96H8 0v16H8 568h8V144h-8H488V48h80 8V32h-8H8zM472 48v96H360V48H472zM344 48v96H232V48H344zM216 48v96H104V48H216zM8 256H0v16H8 32c39.8 0 72 32.2 72 72V472v8h8 96 8v-8V344c0-39.8 32.2-72 72-72s72 32.2 72 72V472v8h8 96 8v-8V344c0-39.8 32.2-72 72-72h24 8V256h-8H544c-48.6 0-88 39.4-88 88V464H376V344c0-48.6-39.4-88-88-88s-88 39.4-88 88V464H120V344c0-48.6-39.4-88-88-88H8z'
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fast',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      'M230.7 38.8L216 32l-4.4 15.6-59.9 213c4.9 1.7 9.9 3.5 15.2 5.1L226.3 54.4l87 40.1 6.7 3.1 6.7-3.1 87-40.1 59.4 211.3c5.2-1.7 10.3-3.4 15.2-5.1l-59.9-213L424 32l-14.7 6.8L320 80 230.7 38.8zM616 224s-4 4.1-12.1 10.5C572.6 259.4 480 320 320 320s-252.6-60.6-283.9-85.5C28 228.1 24 224 24 224l-9.7 12.9L0 256s96 192 320 192s320-192 320-192l-14.3-19.1L616 224zm-8.3 27.8c2.1-1.6 4-3.1 5.8-4.5l7.5 10c-2.9 4.9-7.1 11.6-12.6 19.6c-12 17.3-30.2 40.3-55.2 63.4C503.3 386.3 427 432 320 432s-183.3-45.7-233.1-91.8c-25-23-43.2-46.1-55.2-63.4c-5.6-8-9.7-14.7-12.6-19.6l7.5-10c1.8 1.4 3.7 2.9 5.8 4.5C45 261.3 64 273.9 89.4 286.4C140.2 311.4 216.6 336 320 336s179.8-24.6 230.6-49.6c25.4-12.5 44.3-25 57.1-34.6z'
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fast',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      'M320 7.4l2.9 1.1 312 120 5.1 2V136 504v8H624v-8V141.5L320 24.6 16 141.5V504v8H0v-8V136v-5.5l5.1-2 312-120L320 7.4zM96 192h8H536h8v8V504v8H528v-8V208H112V504v8H96v-8V200v-8zM336 384h16H464h16v16 96 16H464 176 160V496 400 384 304 288h16H320h16v16 64 16zm-16 0V368 304H176v80H320zm0 16H176v96H320V400zm16 96H464V400H336v96z'
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fast',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      'M128 16v96H32V16h96zM32 0H16V16v96 16H32 72V352v16 16H32 16v16 96 16H32h96 16V496 400 384H128 88V368 352c0-48.6 39.4-88 88-88h96c57.4 0 104-46.6 104-104V128h40 16V112 16 0H416 320 304V16v96 16h16 40v32c0 48.6-39.4 88-88 88H176c-37.1 0-69.6 19.4-88 48.5V128h40 16V112 16 0H128 32zM320 16h96v96H320V16zM32 400h96v96H32V400z'
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fast',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      'M16 16l80 0V0H16 0V16 96H16l0-80zm208 0V0H128V16l96 0zM16 128H0v96H16l0-96zm0 128H0v80 16H16 96V336H16l0-80zm112 96h32l16 0h48V336H176l-16 0H128v16zm32 32l0 112v16h16l320 0h16V496 176l0-16H496l-112 0v16l112 0 0 320-320 0 0-112H160zM352 176V160 128H336v32l0 16v48h16V176zm0-160V0H336 256V16l80 0V96h16V16zM256 336v16h80 16V336 256H336v80H256z'
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fast',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V390.9c-3.8-2.6-7.8-5.5-12.3-8.7l0 0-3.7-2.7V204.8L288 26.5 80 204.8V379.5l-2.6 1.9-1.1 .8c-4.4 3.2-8.5 6.1-12.3 8.7V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zM216 184h8H352h8v8V320v8h-8H224h-8v-8V192v-8zm16 16V312H344V200H232zM96.6 427c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 481.8 169.5 496 192 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 481.8 361.5 496 384 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 481.8 553.5 496 576 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 494.2 28.7 512 0 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9z'
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fast',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      'M181.3 26c8-15.4 24.1-26 42.7-26s34.7 10.6 42.7 26c8.1-6.3 18.3-10 29.3-10c23.8 0 43.5 17.3 47.3 40l.7 0c26.5 0 48 21.5 48 48c0 3.5-.4 7-1.1 10.4c19.2 6.3 33.1 24.3 33.1 45.6H408c0-16.4-12.4-30-28.3-31.8L368.8 127l4.4-10c1.8-4 2.7-8.4 2.7-13c0-17.7-14.3-32-32-32c-2.2 0-4.3 .2-6.4 .6l-9.7 2 .1-9.9 0-.7 0 0c0-17.7-14.3-32-32-32c-10.8 0-20.3 5.3-26.1 13.5L258.9 61l-3.4-18.7C252.8 27.3 239.7 16 224 16s-28.8 11.3-31.5 26.3L189.1 61l-11-15.5C172.3 37.3 162.8 32 152 32c-17.7 0-32 14.3-32 32l0 .8 .1 9.9-9.7-2c-2.1-.4-4.2-.6-6.4-.6c-17.7 0-32 14.3-32 32c0 7.2 2.4 13.8 6.4 19.2L88 136l-16 0c-14.9 0-27.4 10.2-31 24H24.7c3.1-18.5 16.8-33.5 34.7-38.3C57.2 116.2 56 110.2 56 104c0-26.5 21.5-48 48-48l.7 0c3.8-22.7 23.6-40 47.3-40c11 0 21.2 3.7 29.3 10zM92.5 496h263l72-288H344.1l-.2 1.1L310.9 440H294.8l33.1-232H232v0V440H216V208v0H120.1l33.1 232H137.1l-33-230.9-.2-1.1H20.5l72 288zM368 512H80L4 208 0 192H16.5h415H448l-4 16L368 512z'
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fast',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 99.6-60.7 185-147.1 221.4l6.2 14.8C447.3 453.4 512 362.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 86 42.4 162 107.3 208.4l9.3-13C55.7 407.9 16 336.6 16 256zm160.4-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 345.4l44.7-44.7L312 289.4l4.7-4.7 6.6-6.6 4.7-4.7 11.3 11.3L350.6 296l-4.7 4.7-6.6 6.6-4.7 4.7-11.3 11.3L278.6 368l-11.3 11.3 9.4 9.4L288 377.4l44.7-44.7L344 321.4l1.9 1.9 9.4 9.4L366.6 344l-11.3 11.3-9.4 9.4L334.6 376l-11.3 11.3L310.6 400l-11.3 11.3 9.4 9.4L320 409.4l12.7-12.7L344 385.4l1.9 1.9 9.4 9.4L366.6 408l-11.3 11.3-48.8 48.8C288.7 486 264.4 496 239.2 496c-52.6 0-95.2-42.6-95.2-95.2V388 368 338.4v-4-16h16 8 16v12.3 3.7 4 15l15-15 1-1 68.7-68.7L280 257.4l11.3 11.3 9.4 9.4 1.9 1.9-11.3 11.3L246.6 336l-11.3 11.3 9.4 9.4L256 345.4zm35.3-99.3L280 234.7l-11.3 11.3-11.3 11.3L200 314.7V302.4H184 144 128v16 20V368v20 12.8C128 462.2 177.8 512 239.2 512c29.5 0 57.8-11.7 78.6-32.6l48.8-48.8 11.3-11.3L389.3 408l-11.3-11.3L357.3 376l9.4-9.4 11.3-11.3L389.3 344l-11.3-11.3L357.3 312l4.7-4.7L373.3 296l-11.3-11.3-22.6-22.6L328 250.7l-11.3 11.3-4.7 4.7-20.7-20.7z'
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fast',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v8V298.5 376v8h16v-8V301.9l58.4-56L333.5 384h19.7L246.5 235.3l-.4-.6L357.5 128H334.4L176 279.8V136v-8H160z'
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fast',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      'M16 256C16 123.5 123.5 16 256 16h8V0h-8C114.6 0 0 114.6 0 256S114.6 512 256 512h8V496h-8C123.5 496 16 388.5 16 256zM349.2 121.9l-6.1-5.2L332.7 129l6.1 5.2L474.1 248H168h-8v16h8H474.1L338.8 377.9l-6.1 5.2L343 395.3l6.1-5.2 152-128 7.3-6.1-7.3-6.1-152-128z'
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fast',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      'M64 0V8 160H80V16H372.7L432 75.3V160h16V72 68.7l-2.3-2.3-64-64L379.3 0H376 72 64zM331.3 235.3L358.6 208H496v64H16V208H153.4l27.3 27.3c3 3 7.1 4.7 11.3 4.7H320c4.2 0 8.3-1.7 11.3-4.7zM352 192l-32 32H192l-32-32H16 0v16 64 16H16 32V496v16H48 464h16V496 288h16 16V272 208 192H496 352zm112 96V496H48V288H464zM160 448h-8v16h8H352h8V448h-8H160zM112 320v32h32V320H112zm64 64H144v32h32V384zm32-64H176v32h32V320zm32 64H208v32h32V384zm0-64v32h32V320H240zm64 64H272v32h32V384zm32-64H304v32h32V320zm32 96V384H336v32h32zm0-96v32h32V320H368z'
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fast',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      'M343 456.5c-7 6.7-17.9 13.5-32.7 19.6C280.9 488.2 239 496 192 496s-88.9-7.8-118.4-19.9c-14.8-6-25.7-12.8-32.7-19.6c-6.9-6.7-9-12.3-9-16.5V279.9c15.1 9.6 34.6 17.6 56.9 23.6c7.4 2 15.1 3.7 23.1 5.3V368v16h16H256h16V368 308.8c8-1.5 15.7-3.3 23.1-5.3c22.3-6 41.9-13.9 56.9-23.6V440c0 4.3-2 9.8-9 16.5zM112 292.5c-6.6-1.3-12.9-2.8-18.9-4.4c-26.6-7.1-47.6-16.8-61.1-27.8V107.4c9.5 8.8 22.6 16.5 38.2 22.7c31.6 12.6 74.6 20.3 121.8 20.3s90.2-7.6 121.8-20.3c15.6-6.2 28.8-13.9 38.2-22.7V260.3c-13.5 10.9-34.5 20.6-61.1 27.8c-6.1 1.6-12.4 3.1-18.9 4.4V240 224H256 128 112v16 52.5zM341.3 95.5c-7.5 7.1-18.8 13.9-33.5 19.7C278.6 127 237.6 134.4 192 134.4s-86.6-7.4-115.8-19.1c-14.6-5.9-26-12.6-33.5-19.7C35.2 88.4 32 81.6 32 75.2s3.2-13.2 10.7-20.3C50.2 47.7 61.5 41 76.2 35.1C105.4 23.4 146.4 16 192 16s86.6 7.4 115.8 19.1c14.6 5.9 26 12.6 33.5 19.7c7.5 7.1 10.7 14 10.7 20.3s-3.2 13.2-10.7 20.3zM368 440V75.2 72c0-39.8-78.8-72-176-72S16 32.2 16 72v3.2V440c0 39.8 78.8 72 176 72s176-32.2 176-72zM128 368V240H256V368H128z'
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fast',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      'M8 248l-8 0 0 16 8 0 432 0 8 0 0-16-8 0L8 248zM16 80l32 0 0-32L16 48l0 32zm0 384l32 0 0-32-32 0 0 32zM112 80l32 0 0-32-32 0 0 32zm0 384l32 0 0-32-32 0 0 32zm192-32l0 32 32 0 0-32-32 0zm0-352l32 0 0-32-32 0 0 32zM208 432l0 32 32 0 0-32-32 0zm0-352l32 0 0-32-32 0 0 32zM400 432l0 32 32 0 0-32-32 0zm0-384l0 32 32 0 0-32-32 0zM208 336l0 32 32 0 0-32-32 0zm192 32l32 0 0-32-32 0 0 32zM16 336l0 32 32 0 0-32-32 0zM400 176l32 0 0-32-32 0 0 32zM16 144l0 32 32 0 0-32-32 0zm192 32l32 0 0-32-32 0 0 32z'
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fast',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      'M0 56C0 25.1 25.1 0 56 0H160h8H344h8 88 8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM336 16H176V231.1l74.9-61.3 5.1-4.1 5.1 4.1L336 231.1V16zM160 16H56C33.9 16 16 33.9 16 56V416.8C26.2 406.4 40.3 400 56 400H432V16H352V248v16.9l-13.1-10.7L256 186.3l-82.9 67.9L160 264.9V248 16zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56z'
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fast',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zm351 369.8l-50.7 50.7-43-43-5.7-5.7-5.7 5.7-37 37-44.1-44.1 0 0-37-37-2.3-2.3h-3.3H112V173.3L96 160.7V384H16V144H74.8L54.6 128H16 0v16V384v16H16 96h16V384 352h23.2l50.1 50.1 5.7 5.7 0 0 28.7 28.7 5.7 5.7 5.7-5.7 37-37 43 43 5.7 5.7 5.7-5.7L376 388.7v-6.9l-8.8-6.9zM193.6 74.7l12.8 10.1 5.7-4.8h65L294 64H209.3c-1.9 0-3.7 .7-5.1 1.9l-10.5 8.8zm144.6-8.5l-70.6 66.9 12.7 10L346.9 80h79.5L496 138.5V117.6L434.5 65.9 432.2 64h-2.9H343.8h-3.2l-2.3 2.2zm24.5 142l12.5-12.5 5.7-5.7-11.3-11.3-5.7 5.7-13.9 13.9 12.6 10zM624 400h16V384 144 128H624 544 528v16V336h-3.4L544 351.3V144h80V384H585.4l20.3 16H624z'
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fast',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      'M160 32l233.1 87.4L496.5 67.7C512 60 528.9 55.5 546.2 54.5l52-3.1c27.2-1.6 47 25.3 37.5 50.8c-17.8 47.4-52.9 86.4-98.2 109.1L256 352H96L10.7 252.5 0 240l14.8-7.4L64 208l72 40 89.9-44.9 16.6-8.3-15.7-10.1L79.7 90.1 64 80l16.6-8.3L160 32zM530.3 196.9c41.7-20.9 74-56.7 90.4-100.4c5.5-14.7-5.9-30.1-21.5-29.2l-52 3.1c-15.1 .9-29.9 4.8-43.5 11.6L400.3 133.7l-6.2 3.1-6.5-2.4-226.6-85L96.3 81.7l154.9 99.6 23.6 15.2-25.1 12.6L143.2 262.3l-7.5 3.8-7.4-4.1L63.6 226.1 25.5 245.1 103.4 336H252.2L530.3 196.9zM8 496H632h8v16h-8H8 0V496H8z'
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fast',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      'M384 0H192V16h22.1L153.5 304H80 64v16 70.9c3.8-2.6 7.8-5.5 12.3-8.7l1.1-.8 2.6-1.9V320H496v59.5l3.7 2.7 0 0c4.4 3.2 8.5 6.1 12.3 8.7V320 304H496 422.5L361.9 16H384V0zM345.5 16l13.2 62.6-70.7 82-70.7-82L230.5 16h115zM213.2 98.3l64.3 74.5L171.6 295.5 213.2 98.3zM288 185.1L390.5 304H185.5L288 185.1zM404.4 295.5L298.6 172.8l64.3-74.5 41.5 197.3zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fast',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      'M16 48V464H496V48H16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM304 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM166.2 368H345.8l-21.3-64H187.5l-21.3 64zM336 288l26.7 80 5.3 16H351.1 160.9 144l5.3-16L176 288H336zM256 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fast',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      'M624 48v98c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62v98H112V48H624zm16 96V48 32H624 112 96V48 368v16h16H624h16V368 272 256c-26.5 0-48-21.5-48-48s21.5-48 48-48V144zM496 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM16 96V88H0v8V472v8H8 552h8V464h-8H16V96z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fast',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9V320v8H248v-8V290.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5-16 0V200zm72 184V352h32v32H240z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fast',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM136 224a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 66.1l-6.5 9.3-50.5 72.2-33.3-33.3-6.2-6.2-5.6 6.7-80 96L48 413.1V416v24 8h8H328h8v-8V416v-2.5l-1.5-2.1-96-136-6.6-9.3zm.1 27.8l88 124.6V432H64V418.9l72.5-87 33.8 33.8 6.7 6.7 5.5-7.8L232 293.9z'
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fast',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      'M0 32H8 120c75.1 0 136 60.9 136 136c0 68.8-51 125.6-117.3 134.7L197.8 480H180.9L122.2 304c-.7 0-1.5 0-2.2 0H16V480H0V296 40 32zM16 288H120c66.3 0 120-53.7 120-120s-53.7-120-120-120H16V288zm272.9-33.7c-1.8 11.7-.6 20.7 2.4 27.9c3 7.2 8.1 13.2 14.9 18.5c13.9 10.7 33.8 17.5 55.6 25l1.1 .4c21.4 7.3 44.7 15.4 61.2 29.1c8.5 7 15.4 15.6 19.6 26.5s5.3 23.5 3.1 38.2c-3.7 24-17.5 41.2-37.4 50.9c-19.6 9.5-44.7 11.6-71.3 6.9l-.1 0c-8.6-1.6-20.3-5.5-31.3-9.5c-7.3-2.7-14.7-5.5-21-7.9l0 0c-3.2-1.3-6.2-2.4-8.7-3.3l-7.5-2.8 5.7-15 7.5 2.8c2.7 1 5.8 2.2 9.1 3.5l0 0c6.2 2.4 13.2 5.1 20.4 7.7c11 4 21.5 7.4 28.7 8.8c24.3 4.3 45.7 2.1 61.4-5.5c15.4-7.5 25.8-20.3 28.6-38.9c1.9-12.5 .8-22.2-2.2-30.1c-3-7.8-8.1-14.3-14.8-19.9c-13.9-11.5-34.2-18.7-56.2-26.3l-2.5-.8c-20.6-7.1-42.7-14.6-58.7-26.9c-8.5-6.6-15.6-14.7-19.9-25c-4.3-10.4-5.6-22.4-3.5-36.5c6.8-44.8 55.7-67.2 108.7-57.8c8 1.4 32.1 6.7 40.5 9.2l7.7 2.3L425.3 221l-7.7-2.3c-7.6-2.3-31-7.5-38.7-8.8c-48.9-8.7-85.2 12.6-90.1 44.4z'
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fast',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      'M176 48V208H16V48H176zM16 32H0V48 208v16H16 88V384v8h8H256v72 16h16H432h16V464 304 288H432 272 256v16 72H104V224h72 16V208 48 32H176 16zM432 304V464H272V304H432z'
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fast',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      'M432 48v64H368V48h64zM368 32H352V48 72H96V48 32H80 16 0V48v64 16H16 40l0 256H16 0v16 64 16H16 80 96V464 440H352v24 16h16 64 16V464 400 384H432 374.1l-48-80H336V288 224 208h-9.9l48-80H432h16V112 48 32H432 368zM307.5 304l48 80H352v16 24H96V400 384H80 56l0-256H80 96V112 88H352v24 16h3.5l-48 80H256 240v16 64 16h16 51.5zM16 400H80v64H16V400zm352 0h64v64H368V400zM16 48H80v64H16V48zM320 224v64H256V224h64z'
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fast',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      'M118.3 96.7L79.4 4.9 64.6 11.1l38.2 90C84.8 108.9 71 124.7 66 144H36.9L15.2 100.4 .8 107.6l24 48 2.2 4.4H32 64v0 59.4L12 249.1 8.6 251l-.6 3.9-8 56 15.8 2.3L23.4 261l42-24c6 29.1 31.8 51 62.7 51s56.7-21.9 62.7-51l42 24 7.4 52.1 15.8-2.3-8-56-.6-3.9-3.4-1.9-52-29.7V160v0h32 4.9l2.2-4.4 24-48-14.3-7.2L219.1 144H190c-5-19.3-18.7-35.1-36.8-42.8l38.2-90L176.6 4.9 137.7 96.7c-3.2-.5-6.4-.7-9.7-.7s-6.5 .2-9.7 .7zM176 160v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V160c0-26.5 21.5-48 48-48s48 21.5 48 48zM445.5 391.1c-13.3 23-42.6 30.8-65.6 17.6s-30.8-42.6-17.6-65.6l32-55.4c13.3-23 42.6-30.8 65.6-17.6s30.8 42.6 17.6 65.6l-32 55.4zm-65-111.4l0 0L350.8 331l-59.9-.3-3.9 0-2.4 3.1-34.9 44.5 12.6 9.9 32.5-41.4 48.3 .2c-9.3 28.2 2 60 28.8 75.5s60 9.4 79.8-12.8L476 451.4l-19.6 48.9 14.8 6 21.1-52.5 1.5-3.6-2-3.4L461.7 395l29.7-51.4 0 0 27.7 16 4.3 2.5 4.1-2.7 44.8-29.6-8.8-13.4-40.7 26.8-25.2-14.5c5.4-19.2 1.3-39.8-10.4-55.5l78.1-58.9-9.6-12.8L476 261.7c-2.5-2-5.2-3.8-8-5.5s-5.8-3.1-8.8-4.2l12.2-99-15.9-2-12 97.1c-19.5-2.3-39.3 4.5-53.3 18.7l-25.2-14.5 2.9-48.6-16-1-3.2 53.6-.3 4.9 4.3 2.5 27.7 16z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fast',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      'M320 176v16h16 64 6.6l4.7-4.7 76.2-76.2c5.5 15.2 8.5 31.7 8.5 48.9c0 79.5-64.5 144-144 144c-15.2 0-29.9-2.4-43.7-6.7l-9.3-2.9-6.9 6.9L104 489.4 22.6 408 210.8 219.8l6.9-6.9-2.9-9.3c-4.4-13.8-6.7-28.4-6.7-43.7c0-79.5 64.5-144 144-144c17.2 0 33.6 3 48.9 8.5l-76.2 76.2-4.7 4.7V112v64zM492.5 83.5L480.7 95.3 400 176H352 336V160 112l80.7-80.7 11.8-11.8c-5-2.7-10.1-5.1-15.3-7.3C394.4 4.3 373.7 0 352 0C263.6 0 192 71.6 192 160c0 16.9 2.6 33.2 7.5 48.5L11.3 396.7 0 408l11.3 11.3 81.4 81.4L104 512l11.3-11.3L303.5 312.5c15.3 4.9 31.6 7.5 48.5 7.5c88.4 0 160-71.6 160-160c0-21.7-4.3-42.4-12.1-61.2c-2.2-5.2-4.6-10.4-7.3-15.3zM112 422.6L134.6 400 112 377.4 89.4 400 112 422.6z'
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fast',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      'M496 472v8h16v-8V224v-8h-8H27.3L157.7 85.7l5.7-5.7L152 68.7l-5.7 5.7-144 144L-3.3 224l5.7 5.7 144 144 5.7 5.7L163.3 368l-5.7-5.7L27.3 232H496V472z'
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fast',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      'M56 8V0H40V8 40H8 0V56H8 40V88v8H56V88 56H88h8V40H88 56V8zM472 360v-8H456v8 32H424h-8v16h8 32v32 8h16v-8V408h32 8V392h-8H472V360zM104 448H96v8 48 8h16v-8V464H400v40 8h16v-8V456v-8h-8H104zM96 256v16h8H408h8V256h-8H104 96zM232 0h-8V16h8 48 8V0h-8H232z'
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fast',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      'M240 16V80h32V16H240zM224 80V16 0h16 32 16V16 80H432V40 32h16v8V80h48V40 32h16v8V80 96v32 16H496 410.5L288 228.2V504v8H272v-8V224.1c0-.1 0-.1 0-.2V144H240v79.9c0 .1 0 .1 0 .2V504v8H224v-8V228.2L101.5 144H16 0V128 96 80 40 32H16v8V80H64V40 32H80v8V80H224zM104.1 128H224h16 32 16H407.9c.1 0 .1 0 .2 0H496V96H288 272 240 224 16v32h87.9c.1 0 .1 0 .2 0zm25.6 16L224 208.8V144H129.8zm252.5 0H288v64.8L382.2 144z'
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fast',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      'M48 224H32V208 192s16-160 224-160s224 160 224 160v16 16H464 48zm416-16V193l-.1-.5c-.1-.9-.4-2.4-.7-4.3c-.7-3.8-2-9.5-4.2-16.3c-4.3-13.7-12.1-32-25.8-50.2C406.4 85.8 355.2 48 256 48s-150.4 37.8-177.2 73.6C65.1 139.8 57.3 158.1 53 171.8c-2.2 6.8-3.5 12.5-4.2 16.3c-.4 1.9-.6 3.4-.7 4.3L48 193v15H464zM47.9 193.6s0 0 0 0l0 0zM480 272H32v64H480V272zM16 256H32 480h16v16 64 16H480 32 16V336 272 256zM464 400H48v64H464V400zM32 384H48 464h16v16 64 16H464 48 32V464 400 384zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm208 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fast',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      'M443.7 263.7l33.4-9.6 34.8-9.9V208 48 16 0H496 464 336 306.3L293.1 26.5l-16 32L262.8 87.2l-7.2 14.3 14.3 7.2 57.2 28.6 14.3 7.2 7.2-14.3 14.3-28.6 2.7-5.5H400h16v16 59.8L226.8 225.8l-12 3.4-8.8 8.8L156.1 288H112 96v16 44.1L38.1 406.1 15.4 428.7 4.1 440l11.3 11.3 45.3 45.3L72 507.9l11.3-11.3 22.6-22.6L265.1 314.7l96-27.4 38.6 21.8 13.9 7.9 7.9-13.9 22.2-39.4zm-36.1 31.5L369 273.4l-5.8-3.3-6.4 1.8-96 27.4-4 1.1-2.9 2.9L94.6 462.6 72 485.3 26.7 440l22.6-22.6 57.9-57.9 4.7-4.7v-6.6V304h44.1 6.6l4.7-4.7 49.9-49.9 5.9-5.9 8-2.3 189.2-54.1 11.6-3.3V171.8 96 80H416 365.7h-9.9l-4.4 8.8-2.7 5.5-14.3 28.6L277.1 94.3l14.3-28.6 16-32L316.2 16H336 464h32V48 208v24.1l-23.2 6.6-33.4 9.6-6.3 1.8-3.2 5.7-22.2 39.4z'
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fast',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      'M132 32h-4.6l-2.3 4L1.1 252l-2.3 4 2.3 4 124 216 2.3 4H132 380h4.6l2.3-4 124-216 2.3-4-2.3-4L386.9 36l-2.3-4H380 132zM17.2 256L136.6 48H375.4L494.8 256 375.4 464H136.6L17.2 256zM231 180c-4.4-5.5-7-12.4-7-20c0-17.7 14.3-32 32-32s32 14.3 32 32c0 10.6-5.1 20-13.1 25.8c-4.3 3.1-9.3 5.2-14.9 5.9l-.1 0c-1.3 .2-2.6 .2-4 .2c-4.3 0-8.4-.9-12.2-2.4c-5-2.1-9.4-5.4-12.8-9.6zm-23-20c0 12.8 5 24.5 13.2 33.1L182 245.3c-6.6-3.4-14.1-5.3-22-5.3c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.5 0 38-12.8 44.9-30.9L272 318.6c0 .5 0 1 0 1.4c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-3.5 0-6.9 .4-10.2 1.1L281 201c13.8-8.4 23-23.6 23-41c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 128c0-12.8-5-24.5-13.2-33.1L234 202.7c6.6 3.4 14.1 5.3 22 5.3c3.5 0 6.9-.4 10.2-1.1L295 279c-9 5.5-16 13.9-19.8 23.8L208 289.4c0-.5 0-1 0-1.4zm80 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fast',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      'M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h80 16v16V496v16H432 16 0V496 208 192H16 96zm0 16H16V496H432V208H352 336 112 96zm88 40v8 40h80V256v-8h16v8 40h40 8v16h-8H280v80h40 8v16h-8H280v40 8H264v-8V408H184v40 8H168v-8V408H128h-8V392h8 40V312H128h-8V296h8 40V256v-8h16zm0 144h80V312H184v80z'
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fast',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      'M176 256h16l224 0h16V240 48l64 0V320l-304 0H176v16 96h-9.4L22.6 288l144-144H176l0 96v16zM160 128L11.3 276.7 0 288l11.3 11.3L160 448h16 16V432 352 336h16l288 0h16V320 48 32l-16 0-64 0-16 0V48 224v16H400l-192 0H192V224l0-80V128H176 160z'
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fast',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm36.9 439.4C296.3 418.5 320 380 320 336s-23.7-82.5-59.1-103.4L252 245.9c31.1 18 52 51.6 52 90.1s-20.9 72.1-52 90.1l8.9 13.3zM225.3 386c18.2-9.2 30.7-28.1 30.7-50s-12.5-40.7-30.7-50l-9 13.4c13.9 6.3 23.7 20.3 23.7 36.5s-9.7 30.3-23.7 36.5l9 13.4zm-99.5-18H120 96V304h24 5.8l4.4-3.7L173.8 264H176V408h-2.2l-43.5-36.3-4.4-3.7zM96 384h24l48 40h8 16V408 264 248H176h-8l-48 40H96 80v16 64 16H96z'
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fast',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm26 6.4c17.8 9.4 30 28.1 30 49.6c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-21.5 12.2-40.2 30-49.6c-8.6-7.3-14-18.2-14-30.4c0-22.1 17.9-40 40-40s40 17.9 40 40c0 12.2-5.4 23.1-14 30.4zM256 176a40 40 0 1 0 0 80 40 40 0 1 0 0-80z'
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fast',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      'M16 16V400H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V16H16zM64.4 416H16 0V400 16 0H16 400h16V16 96h72 3.3l2.3 2.3 112 112 2.3 2.3V216 400h24 8v16h-8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588.7l-104-104H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM208 272a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 56v56h40 8v16h-8H200h-8v-8V120v-8h16v8z'
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fast',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 296v-8H488v8 64H424h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H504V296z'
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fast',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM293.7 261.7l-128 128-5.7 5.7-5.7-5.7-64-64L84.7 320 96 308.7l5.7 5.7L160 372.7 282.3 250.3l5.7-5.7L299.3 256l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fast',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      'M422.5 44.2l-75.9 9L255.9 3.4 185.1 78.8 83.6 98.9 77.8 202.2 13 282.9 75 365.7l.5 25.5 15.7-15.7L91 365.4l-.1-5.1-3.1-4.1L33.3 283.2l57-71 3.2-4 .3-5.1 5.1-90.9 89.3-17.7 5-1 3.5-3.7 62.3-66.3 79.8 43.8 4.5 2.5 5.1-.6 55.8-6.6 18.3-18.3zM464 70.6c88.9 100.5 85.2 254.2-11 350.4s-249.8 99.8-350.4 11L464 70.6zM79.7 432.3c3.8 3.8 7.7 7.5 11.6 11c106.8 95.1 270.6 91.4 373-11s106.1-266.2 11-373c-3.5-4-7.2-7.8-11-11.6L453 59 91 421 79.7 432.3zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM232 152c-61.9 0-112 50.1-112 112c0 23.5 7.2 45.2 19.5 63.2l11.5-11.5C141.5 300.8 136 283 136 264c0-53 43-96 96-96c19 0 36.8 5.5 51.7 15.1l11.5-11.5c-18-12.3-39.8-19.5-63.2-19.5z'
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fast',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM357.7 197.7l5.7-5.7L352 180.7l-5.7 5.7L224 308.7l-58.3-58.3-5.7-5.7L148.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fast',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      'M8 32H0v8V472v8H8 504h8v-8V120v-8h-8H72 64v16h8H496V464H16V48H472h8V32h-8H8zM376 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fast',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M21.7 10.3l72 72L99.3 88 88 99.3l-5.7-5.7-72-72L4.7 16 16 4.7l5.7 5.7zm608 11.3l-72 72L552 99.3 540.7 88l5.7-5.7 72-72L624 4.7 635.3 16l-5.7 5.7zm-536 408l-72 72L16 507.3 4.7 496l5.7-5.7 72-72 5.7-5.7L99.3 424l-5.7 5.7zm464-11.3l72 72 5.7 5.7L624 507.3l-5.7-5.7-72-72-5.7-5.7L552 412.7l5.7 5.7zM176 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm192 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM214.2 368H425.8l-21.3-64H235.5l-21.3 64zm9.8-80H416l26.7 80 5.3 16H431.1 208.9 192l5.3-16L224 288zM432 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM132.2 272l-15.3 56h60l-5.3 16h-59H96l4.4-16L120 256h80.9l-5.3 16H132.2zm330.8 56h60l-15.3-56H444.4l-5.3-16H520l19.6 72 4.4 16H527.4h-59l-5.3-16z'
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fast',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      'M524.8 486.4C594.8 433.9 640 350.2 640 256s-45.2-177.9-115.2-230.4l-9.6 12.8C581.3 88 624 167 624 256s-42.7 168-108.8 217.6l9.6 12.8zM544 256c0-62.8-30.2-118.6-76.8-153.6l-9.6 12.8C500.4 147.3 528 198.4 528 256s-27.6 108.7-70.4 140.8l9.6 12.8c46.6-35 76.8-90.8 76.8-153.6zm-96 0c0-31.4-15.1-59.3-38.4-76.8L400 192c19.4 14.6 32 37.8 32 64s-12.6 49.4-32 64l9.6 12.8C432.9 315.3 448 287.4 448 256zM138.6 340l-4.5-4H128 16V176H128h6.1l4.5-4L278.1 48H304V464H278.1L138.6 340zM0 352H16 128L272 480h32 16V464 48 32H304 272L128 160H16 0v16V336v16z'
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fast',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM467.3 464H144 16V336c0-55.7 35.6-103.1 85.3-120.7l10.7-3.8V200.2 192c0-2.8 .1-5.5 .2-8.3l-15-11.8c-.8 6.6-1.3 13.3-1.3 20.1v8.2C40.1 220 0 273.3 0 336V464v16H16 144 487.5l-20.3-16zM256 32c-28.3 0-54.9 7.3-77.9 20.2l13.7 10.8C211.1 53.4 232.9 48 256 48c53.3 0 99.9 29 124.8 72.2l8.5 14.8 14.2-9.5c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80v36 12.4l12 3.1c48.3 12.4 84 56.3 84 108.5v52.3l16 12.6V352c0-59.6-40.8-109.8-96-124V192c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4C357 58.3 309.6 32 256 32z'
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fast',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      'M264 312v8H248v-8V35.3L141.7 141.7l-5.7 5.7L124.7 136l5.7-5.7 120-120L256 4.7l5.7 5.7 120 120 5.7 5.7L376 147.3l-5.7-5.7L264 35.3V312zm-112 8l32 64H328l32-64H496h16v16V496v16H496 16 0V496 336 320H16 152zm190.3 71.2c-2.7 5.4-8.2 8.8-14.3 8.8H184c-6.1 0-11.6-3.4-14.3-8.8L142.1 336H16V496H496V336H369.9l-27.6 55.2z'
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fast',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V258.4l62.7-94 4.4-6.7-13.3-8.9-4.4 6.7-64 96-1.3 2V256 408v8h16v-8z'
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fast',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      'M336 16V352H48V16H336zm0 352V496H48V368H336zM48 0H32V16 496v16H48 336h16V496 16 0H336 48zM192 448a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fast',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      'M400 112V400H272V112H400zM272 96H256v16V400v16h16H400h16V400 264h88 8V248h-8H416V112 96H400 272zM0 264H8 224V248H8 0v16z'
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fast',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 256V240H208 144v-1.4l112-112 112 112V240H304 288v16V368H224V256zm20.7-140.7L128 232v8 16h16 48 16v16 96 16h16 64 16V368 272 256h16 48 16V240v-8L267.3 115.3 256 104l-11.3 11.3z'
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fast',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2l3.1 5.8 6.3-1.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1l-1.9 6.3 5.8 3.1C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2l-5.8 3.1 1.9 6.3c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1l-6.3-1.9-3.1 5.8C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2l-3.1-5.8-6.3 1.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1l1.9-6.3-5.8-3.1C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2l5.8-3.1-1.9-6.3c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1l6.3 1.9 3.1-5.8zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-61.9-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM357.7 197.7l5.7-5.7L352 180.7l-5.7 5.7L224 308.7l-58.3-58.3-5.7-5.7L148.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fast',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      'M192 16V0C368.7 0 512 143.3 512 320H496C496 152.1 359.9 16 192 16zM416 320H400c0-114.9-93.1-208-208-208V96c123.7 0 224 100.3 224 224zM16 304c0 106 86 192 192 192c34.9 0 67.6-9.3 95.8-25.6L41.6 208.2C25.3 236.4 16 269.1 16 304zM0 304c0-39.3 10.9-76.1 29.9-107.5c2.8-4.7 5.8-9.2 9-13.6l11.5 11.5 128 128 0 0 20.3-20.3c-4.2-6.3-6.6-13.9-6.6-22.1c0-22.1 17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40c-8.2 0-15.7-2.4-22.1-6.6l-20.3 20.3 0 0 128 128 11.5 11.5c-4.4 3.2-9 6.2-13.6 9C284.1 501.1 247.3 512 208 512C93.1 512 0 418.9 0 304zm256-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fast',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      'M38.4 6.2l5.7 5.6c-5.7-5.6-5.7-5.6-5.7-5.6l0 0 0 0 0 0-.1 .1-.4 .4c-.3 .3-.8 .8-1.3 1.4c-1.1 1.2-2.6 3-4.4 5.4c-3.6 4.7-8.4 11.4-13.1 20.1C9.6 51.2 0 76.3 0 107.2c0 44.5 15.4 81.7 42.6 119.5c26.1 36.2 63.5 73.4 109.1 118.4L163 333.8c-45.9-45.2-82.2-81.4-107.4-116.4C29.7 181.5 16 147.5 16 107.2c0-27.5 8.5-50.1 17.1-65.8c4.1-7.5 8.2-13.5 11.4-17.6l207 221.4L262.8 234 50 6.4 44.3 .3l-5.8 6zM495 506.3l5.5 5.9 11.7-10.9-5.5-5.9L339.3 315.9 328 327.2 495 506.3zM464.8 .8L341.3 89c-3.2 2.3-6.3 4.9-9.1 7.7l-7.6 7.6c-28.1 28.1-28.1 73.7 0 101.8l17 17L70.2 494.5l-5.7 5.7 11.3 11.3 5.7-5.7L353 234.3l17 17c28.1 28.1 73.7 28.1 101.8 0l7.6-7.6c2.8-2.8 5.4-5.8 7.7-9.1l88.2-123.5L563.7 99.7 474 225.4c-1.8 2.5-3.8 4.9-6 7l-7.6 7.6c-21.9 21.9-57.3 21.9-79.2 0L336 194.7c-21.9-21.9-21.9-57.3 0-79.2l7.6-7.6c2.2-2.2 4.5-4.2 7-6L476.3 12.3 464.8 .8zm33 33L370.2 149.2l-6.8 6.2 11.3 11.3 6.2-5.6 128.2-116L497.8 33.8zm33.1 33.1L409.3 201.3l11.3 11.3L542.2 78.2 530.9 66.9z'
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fast',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M286.4 494.1C282.2 479.4 280 464 280 448c0-43.5 16.5-83.2 43.7-113l94.7 94.7 1.6 1.6c-35.9 33.6-82.2 56.3-133.6 62.8zm-16.2 1.5c-4.7 .3-9.4 .4-14.2 .4c-63.4 0-121.1-24.6-164-64.7l1.6-1.6L256 267.3l56.4 56.4C282.3 356.4 264 400.1 264 448c0 16.5 2.2 32.4 6.2 47.6zm53.5-183.2L267.3 256 429.7 93.7l1.6-1.6C471.4 134.9 496 192.6 496 256c0 4.8-.1 9.5-.4 14.2c-15.2-4.1-31.1-6.2-47.6-6.2c-47.9 0-91.6 18.3-124.3 48.4zM335 323.7c29.8-27.1 69.5-43.7 113-43.7c16 0 31.4 2.2 46.1 6.4c-6.5 51.3-29.2 97.6-62.8 133.6l-1.6-1.6L335 323.7zM418.3 82.3L256 244.7l-56.4-56.4C229.7 155.6 248 111.9 248 64c0-16.5-2.2-32.4-6.2-47.6c4.7-.3 9.4-.4 14.2-.4c63.4 0 121.1 24.6 164 64.7l-1.6 1.6zM188.3 177L93.7 82.3 92 80.7C128 47.1 174.3 24.4 225.6 17.9C229.8 32.6 232 48 232 64c0 43.5-16.5 83.2-43.7 113zM177 188.3C147.2 215.5 107.5 232 64 232c-16 0-31.4-2.2-46.1-6.4C24.4 174.3 47.1 128 80.7 92l1.6 1.6L177 188.3zM16.4 241.8C31.6 245.8 47.5 248 64 248c47.9 0 91.6-18.3 124.3-48.4L244.7 256 82.3 418.3 80.7 420C40.6 377.1 16 319.4 16 256c0-4.8 .1-9.5 .4-14.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fast',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      'M0 96H8 248h8v16h-8H136V408v8H120v-8V112H8 0V96zm288 8V96h11.6l2.4 2.7L464 283.8 626 98.7l2.4-2.7H640v8V408v8H624v-8V125.3l-154 176-6 6.9-6-6.9-154-176V408v8H288v-8V104z'
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fast',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      'M1.1 232H17.2c4.8-48.3 23.9-92.3 53-127.9L58.8 92.7C26.9 131.3 6 179.3 1.1 232zm103-161.8C139.7 41.1 183.7 22 232 17.2V1.1C179.3 6 131.3 26.9 92.7 58.8l11.4 11.4zM280 494.8v16.1c52.7-4.9 100.7-25.8 139.3-57.7l-11.4-11.4c-35.6 29.1-79.6 48.2-127.9 53zm161.8-86.9l11.4 11.4c31.9-38.5 52.8-86.6 57.7-139.3H494.8c-4.8 48.3-23.9 92.3-53 127.9zM92.7 453.2c38.5 31.9 86.6 52.8 139.3 57.7V494.8c-48.3-4.8-92.3-23.9-127.9-53L92.7 453.2zM58.8 419.3l11.4-11.4C41.1 372.3 22 328.3 17.2 280H1.1C6 332.7 26.9 380.7 58.8 419.3zM419.3 58.8C380.7 26.9 332.7 6 280 1.1V17.2c48.3 4.8 92.3 23.9 127.9 53l11.4-11.4zm22.6 45.3c29.1 35.6 48.2 79.6 53 127.9h16.1c-4.9-52.7-25.8-100.7-57.7-139.3l-11.4 11.4z'
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fast',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      'M351.4 372.5L283.3 496H210.5l50.2-181.9 2.8-10.1H253 152h-4l-2.4 3.2L100 368H58.4L87.7 258.1l.5-2.1-.5-2.1L58.4 144h3.5L41.7 128H37.6l2.7 10.1L71.7 256 40.3 373.9 37.6 384H48h56 4l2.4-3.2L156 320h86.5L192.3 501.9 189.5 512H200h88 4.7l2.3-4.1 69.1-125.3-12.7-10zM192.3 10.1l18.8 68.2L232.3 95 210.5 16l72.8 0L386.9 203.9l2.3 4.1h4.7H518.8c13 0 31.8 5.7 47.5 15.3c16.1 9.9 25.7 21.8 25.7 32.7c0 11.3-9.6 23.2-25.6 33c-15.6 9.5-34.5 15-47.5 15H497l20.3 16h1.5c16.6 0 38.3-6.7 55.8-17.3C591.8 292.3 608 276.2 608 256c0-19.8-16.2-35.8-33.3-46.3C557.2 199 535.4 192 518.8 192H398.7L295 4.1 292.7 0H288 200 189.5l2.8 10.1zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fast',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      'M136 48C78.6 48 32 94.6 32 152v8H16v-8C16 85.7 69.7 32 136 32h48c66.3 0 120 53.7 120 120v6.3c0 33.8-16.4 65.5-44 85l-92 64.9V352v16 8H152v-8V352 304v-4.1V136v-8h16v8V288.6l82.7-58.4c23.4-16.5 37.3-43.3 37.3-71.9V152c0-57.4-46.6-104-104-104H136zm8 384h32v32H144V432z'
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fast',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      'M224 16a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 336A176 176 0 1 0 224 0a176 176 0 1 0 0 352zM184 144H168v8 16H152h-8v16h8 16v16 8h16v-8V184h16 8V168h-8H184V152v-8zM16 112V240H32V112H16zm400 0V240h16V112H416zM60 304H48L3.7 496 0 512H16.4 431.6 448l-3.7-16L400 304H388c-4.4 5.6-9 10.9-13.9 16h13.2l40.6 176H352V416v-8h-8H104 96v8 80H20.1L60.7 320H73.9c-4.9-5.1-9.5-10.4-13.9-16zm52 192V424H336v72H280V464v-8H264v8 32H184V464v-8H168v8 32H112zM240 272H208c-53 0-96-43-96-96V150.6L150.6 112H297.4L336 150.6V176c0 53-43 96-96 96zM144 96L96 144v32c0 61.9 50.1 112 112 112h32c61.9 0 112-50.1 112-112V144L304 96H144z'
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fast',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M219.4 0H224h64 4.6l2.3 3.9L399.2 179.3l15.8-77 1.6-7.8 15.7 3.2-1.6 7.8L411.3 200l-1.8 8.8-8.5-2.8-91.4-30.4-7.6-2.5 5-15.2 7.6 2.5 68.2 22.7L283.4 16H228.6l-66 111.1-13.7-8.2L217.1 3.9 219.4 0zM419.6 245l13.7-8.2 69.5 116.9 2.4 4.1-2.4 4.1-39.5 66.3-2.3 3.9h-4.5l-211.3 0 56.3 50 6 5.3-10.6 12-6-5.3-72-64-6.7-6 6.7-6 72-64 6-5.3 10.6 12-6 5.3L245 416l206.8 0 34.7-58.3L419.6 245zM116.4 173.4L42.5 197.9l-7.6 2.5-5-15.2 7.6-2.5 91.4-30.4 8.5-2.8 1.8 8.8 19.4 94.4 1.6 7.8-15.7 3.2L143 256l-14.7-71.4L25.4 357.7 60.2 416 176 416v16L55.6 432H51.1l-2.3-3.9L9.2 361.8l-2.4-4.1 2.4-4.1L116.4 173.4z'
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fast',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      'M16 64v8V244.7L256 75.3 272 64V83.6 233.4L496 75.3 512 64V83.6 428.4 448l-16-11.3L272 278.6V428.4 448l-16-11.3L16 267.3V440v8H0v-8V256 72 64H16zM256 267.3V244.7 94.9L27.7 256 256 417.1V267.3zm16-8.3L496 417.1V94.9L272 253v6z'
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fast',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      'M262.6 345.4L496 112l13.6-95.5L512 0 495.5 2.4 400 16 166.6 249.4l11.3 11.3L407.5 31.1l85.6-12.2-12.2 85.6L251.3 334.1l11.3 11.3zm-153-119l-5.7-5.7-5.7 5.7-32 32-4.4 4.4 3.2 5.4 44.8 74.6L68.7 384H32 28.7l-2.3 2.3L5.5 407.1l-5.7 5.7 5.7 5.7 88 88 5.7 5.7 5.7-5.7 20.8-20.8 2.3-2.3V480 443.3l41.2-41.2 74.6 44.8 5.4 3.2 4.4-4.4 32-32 5.7-5.7-5.7-5.7-176-176zm17.2 113.5L82.1 265.2 104 243.3 268.7 408l-21.9 21.9-74.6-44.8-5.4-3.2-4.4 4.4-48 48-2.3 2.3V440v36.7L99.2 489.5 22.5 412.8 35.3 400H72h3.3l2.3-2.3 48-48 4.4-4.4-3.2-5.4z'
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fast',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 280H488v8 96 8h16v-8V288v-8zm4 164V420H484v24h24z'
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fast',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      'M352 320l0 16 0 64 0 16-16 0-16 0L171.3 267.3 160 256l11.3-11.3L320 96l16 0 16 0 0 16 0 64 0 16 16 0 128 0 16 0 0 16 0 96 0 16-16 0-128 0-16 0zm-16 0l0-16 16 0 144 0 0-96-144 0-16 0 0-16 0-80-9.4 0-144 144 144 144 9.4 0 0-80zM184 464l8 0 0 16-8 0L8 480c-4.4 0-8-3.6-8-8L0 40c0-4.4 3.6-8 8-8l176 0 8 0 0 16-8 0L16 48l0 416 168 0z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fast',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fast',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16V48l0 416v16H432L16 480H0V464 48 32H16 432h16zM112 144v32h16l96 0 16 0 0-32H224l-96 0-16 0zm144 48l-16 0-16 0-96 0-16 0H96V176 144 128h16l16 0 96 0h16 16v16l0 32 0 16zM112 240v32h16H320h16V240H320 128 112zm0 96v32h16 32 16V336H160 128 112zm16-112H320h16 16v16 32 16H336 320 128 112 96V272 240 224h16 16zm0 96h32 16 16v16 32 16H176 160 128 112 96V368 336 320h16 16z'
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fast',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      'M144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM144 0a144 144 0 1 1 0 288A144 144 0 1 1 144 0zm8 68.7l5.7 5.7 64 64 5.7 5.7-5.7 5.7-64 64-5.7 5.7L140.7 208l5.7-5.7L196.7 152H72 64V136h8H196.7L146.3 85.7 140.7 80 152 68.7zm154.8 8.4c-2.1-5-4.3-9.9-6.8-14.7L379.6 9.3l4.4-3 4.4 3 216 144-8.9 13.3L560 142.9V289c-5.3-2.9-10.4-6.2-16-10.1V132.3L384 25.6 306.8 77.1zM128.6 315c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C179.4 369.8 201.5 384 224 384s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.1 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C371.4 369.8 393.5 384 416 384s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0 0 0c4.3 6.1 8.5 12.1 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C563.4 369.8 585.5 384 608 384v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C86.6 382.2 60.7 400 32 400V384c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9zM128 426l.6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C179.4 481.8 201.5 496 224 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C371.4 481.8 393.5 496 416 496s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C563.4 481.8 585.5 496 608 496v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C86.6 494.2 60.7 512 32 512V496c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9z'
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fast',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      'M352 0V16h8 92.7L287.6 181.1 181.2 89.9l-5.3-4.5L170.7 90 42.7 202l10.5 12L176.1 106.6l106.7 91.5 5.6 4.8 5.2-5.2L464 27.3V120v8h16v-8V8 0h-8H360h-8zM496 272v56c-30.9 0-56-25.1-56-56h56zM88 272H424c0 39.8 32.2 72 72 72v80c-39.8 0-72 32.2-72 72H88c0-39.8-32.2-72-72-72V344c39.8 0 72-32.2 72-72zM440 496c0-30.9 25.1-56 56-56v56H440zM16 440c30.9 0 56 25.1 56 56H16V440zM72 272c0 30.9-25.1 56-56 56V272H72zM16 256H0v16V496v16H16 496h16V496 272 256H496 16zM208 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fast',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      'M635.3 72l-5.7 5.7-64 64-11.3-11.3L604.7 80 408 80l-.1 0H48V332.1l-9.9 9.9L32 348.1V80 64H48 556.1l0 0 48.6 0L554.3 13.7 565.7 2.4l64 64 5.7 5.7zM35.3 448l50.3 50.3L74.3 509.7l-64-64L4.7 440l5.7-5.7 64-64 11.3 11.3L35.3 432l48.6 0 0 0H96.6L240 432l.2 0H592V179.9l9.9-9.9 6.1-6.1V432v16H592 96.6 83.9l-48.6 0zM480 408V392c0-39.8 32.2-72 72-72h16 8v16h-8H552c-30.9 0-56 25.1-56 56v16 8H480v-8zM160 96v8 16c0 39.8-32.2 72-72 72H72 64V176h8H88c30.9 0 56-25.1 56-56V104 96h16zM400 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fast',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      'M149.9 6.6l72 80 5.4 5.9-11.9 10.7-5.4-5.9L144 23.9 77.9 97.3l-5.4 5.9L60.7 92.6l5.4-5.9 72-80L144 0l5.9 6.6zm152 0L368 80 434.1 6.6l5.4-5.9 11.9 10.7-5.4 5.9-72 80-5.9 6.6-5.9-6.6-72-80-5.4-5.9L296.6 .7l5.4 5.9zM16 144V496H496V144H16zM0 128H16 496h16v16V496v16H496 16 0V496 144 128zM200 264a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM96.5 448H80l24-96H216l24 96H223.5l-20-80h-87l-20 80zm212-80l-20 80H272l24-96H408l24 96H415.5l-20-80h-87z'
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fast',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      'M136 32v8V472v8H120v-8V40 32h16zm128 0v8V472v8H248v-8V40 32h16zm128 8V472v8H376v-8V40 32h16v8z'
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fast',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1L512 197.5V40 32h-8H392h-8v8V87.7L293.2 9.9zM496 48V183.7l-96-82.3V48h96zm0 156.8V496H80V204.8L288 26.5 496 204.8zM280.3 241.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L288 416.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm-3.4 18.9L288 270.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L288 393.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4z'
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fast',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      'M16 48V160H496V48H16zm0 128V464H496V176H112v96h72 8v16h-8H112v80H248h8v16h-8H104 96v-8V288v-8V176H16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM224 272H416v16H224V272zm192 96v16H288V368H416z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fast',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M336 128c0-61.9 50.1-112 112-112s112 50.1 112 112v88 8h16v-8V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H16 0v16V496v16H16 432h16V496 208 192H432 336V128zm-16 80h16 96V496H16V208H320z'
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fast',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      'M16 326.3V368H312h16H624V326.3L556.9 16H83.1L16 326.3zM624 384H328V496H440h8v16h-8H328 312 200h-8V496h8H312V384H16 0V368 324.6L70.2 0H569.8L640 324.6V368v16H624zM82.8 320H66.5l3.5-16L121.8 64H518.2l51.9 240 3.5 16H557.2 82.8zm144.1-16l9-104H108.8L86.3 304H226.9zm16.1 0H397l-9-104H252l-9 104zm170.1 0H553.7L531.2 200H404.1l9 104zM527.8 184L505.3 80H393.7l9 104h125zM377.6 80H262.4l-9 104H386.6l-9-104zM246.3 80H134.7L112.2 184h125l9-104z'
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fast',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.3 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM144 128H128v16 72c0 22.3 15.2 41.1 35.8 46.4l-19 38c-2 4-.4 8.8 3.6 10.7s8.8 .4 10.7-3.6l21.9-43.8c24.1-2.5 42.9-22.9 42.9-47.7V144h83.1l13.8 27.6 2.2 4.4H328h72v32c0 39.8-32.2 72-72 72H280h-8v8 88c0 4.4 3.6 8 8 8s8-3.6 8-8V296h40c48.6 0 88-39.4 88-88V168v-8h-8H332.9l-13.8-27.6-2.2-4.4H312 224h-8-8H144zm31.9 120c-17.6-.1-31.9-14.4-31.9-32V160 144h16 32 16v16 56c0 17.6-14.2 31.9-31.8 32l-.3 0zM272 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fast',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      'M496 48V80H16V48H496zM16 32H0V48 80 96H16 496h16V80 48 32H496 16zm8 96L6 176 0 192H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24zM6 272L0 288H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24L6 272zm18 48L6 368 0 384H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24zM6 464L0 480H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24L6 464z'
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fast',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      'M80 0H96V64h64V0h16V64.1c53.4 2.1 96 46 96 99.9c0 36.5-19.5 68.4-48.7 85.9c46 9 80.7 49.5 80.7 98.1c0 55.2-44.8 100-100 100H176v64H160V448H96l0 64H80l0-64H32 16V432 264 248 80 64H32 80V0zM32 80V248H172c46.4 0 84-37.6 84-84s-37.6-84-84-84H32zM172 264H32V432H204c46.4 0 84-37.6 84-84s-37.6-84-84-84H172z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fast',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M165.7 469.7l-5.7 5.7-5.7-5.7-104-104L44.7 360 56 348.7l5.7 5.7L152 444.7V40 32h16v8V444.7l90.3-90.3 5.7-5.7L275.3 360l-5.7 5.7-104 104zM296 224l10-16L406.6 47.1 416 32l9.4 15.1L526 208l10 16H517.1 314.9 296zm211.1-16L416 62.2 324.9 208H507.1zM336 304V464H496V304H336zm0-16H496h16v16V464v16H496 336 320V464 304 288h16z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fast',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      'M256 7.5l2.7 .9 248 88 5.3 1.9V104 392v5.3l-4.9 2.1-248 104-3.1 1.3-3.1-1.3-248-104L0 397.3V392 104 98.4l5.3-1.9 248-88 2.7-.9zM16 386.7L248 484V213.3L16 116V386.7zM264 484l232-97.3V116L264 213.3V484zM256 24.5L30.2 104.6 256 199.3l225.8-94.7L256 24.5z'
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fast',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      'M328 8V0H312V8 32.3c-11.4 .9-23.5 4.2-33.5 10.4c-12.8 7.9-22.5 20.9-22.4 39.4c.1 17 9.2 28.1 21.2 35.7c11.1 7 25.5 11.6 38.7 15.8l1.4 .5c14.2 4.5 27 8.7 36.4 14.9c8.9 5.9 14 13 14.2 23.8c.2 12.9-5.6 21.5-14.3 27.1c-9 5.9-21.4 8.6-33.4 8.2c-15.4-.5-29.8-5.7-45.6-11.3c-2.6-.9-5.3-1.9-8-2.9l-7.6-2.6-5.3 15.1 7.6 2.6c2.5 .9 5 1.8 7.6 2.7l0 0c13.4 4.8 27.8 10 43.1 11.8V248v8h16v-8V223.8c12-.7 24.3-4 34.4-10.6c12.8-8.3 21.8-21.9 21.6-40.7c-.2-17.5-9.2-29-21.3-37c-11.6-7.7-26.7-12.4-40.4-16.8l-.2-.1c-14.2-4.5-26.9-8.5-36.2-14.4C277 98.6 272.1 92 272.1 82c-.1-11.9 5.8-20.1 14.8-25.7c9-5.6 20.9-8.3 31.8-8.3h.1l1 0c13 .2 26.7 3.2 40 6.9l7.7 2.2 4.3-15.4-7.7-2.1c-11.3-3.2-23.7-6-36.2-7V8zM96 72c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8V384c0 2.1 .8 4.2 2.3 5.7l120 120 11.3-11.3L16 380.7V80H80V288c0 2.1 .8 4.2 2.3 5.7l10.8 10.8 5.2 5.2 80 80 8 8 5.7 5.7L203.3 392l-5.7-5.7-8-8-74.8-74.8 37.6-43.8L288 395.3V504v8h16v-8V392v-3.3l-2.3-2.3-144-144-6.1-6.1-5.6 6.6-42.4 49.4L96 284.7V72zm456-8c-4.4 0-8 3.6-8 8V284.7l-7.5 7.5-42.4-49.4-5.6-6.6-6.1 6.1-144 144-2.3 2.3V392 504v8h16v-8V395.3L487.5 259.8l37.6 43.8-74.8 74.8-8 8-5.7 5.7L448 403.3l5.7-5.7 8-8 80-80 5.2-5.2 10.8-10.8c1.5-1.5 2.3-3.5 2.3-5.7V80h64V380.7L506.3 498.3l11.3 11.3 120-120c1.5-1.5 2.3-3.5 2.3-5.7V72c0-4.4-3.6-8-8-8H552z'
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fast',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      'M16 192c0 49.7 11.4 94.3 29.4 126.2C63.6 350.3 87.4 368 112 368H354.8c-13.6-10.2-25.5-24.7-35.3-42C299.9 291.3 288 243.9 288 192s11.9-99.3 31.5-134c9.8-17.3 21.7-31.8 35.3-42H112C87.4 16 63.6 33.7 45.4 65.8C27.4 97.7 16 142.3 16 192zM333.4 65.8C315.4 97.7 304 142.3 304 192s11.4 94.3 29.4 126.2c18.2 32.1 42 49.8 66.6 49.8s48.4-17.7 66.6-49.8c18-31.9 29.4-76.5 29.4-126.2s-11.4-94.3-29.4-126.2C448.4 33.7 424.6 16 400 16s-48.4 17.7-66.6 49.8zM496 496V291.5c-4.4 12.5-9.6 24.1-15.5 34.6c-19.5 34.5-47.6 58-80.5 58H112c-32.9 0-61-23.5-80.5-58C11.9 291.3 0 243.9 0 192S11.9 92.7 31.5 58C51 23.5 79.1 0 112 0H400c32.9 0 61 23.5 80.5 58C500.1 92.7 512 140.1 512 192V504v8h-8H168h-8v-8V416h16v80H496zM400 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM235.3 136l-5.7 5.7L179.3 192l50.3 50.3 5.7 5.7L224 259.3l-5.7-5.7L168 203.3l-50.3 50.3-5.7 5.7L100.7 248l5.7-5.7L156.7 192l-50.3-50.3-5.7-5.7L112 124.7l5.7 5.7L168 180.7l50.3-50.3 5.7-5.7L235.3 136z'
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fast',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      'M9.9 0l6.3 5L633.7 494.5l6.3 5L630.1 512l-6.3-5L6.3 17.5 0 12.5 9.9 0zM187 242.7c-19.4 10.9-37.4 24.1-53.5 39.3l-11-11.6C138 255.8 155 242.9 173.4 232L187 242.7zm171.4-48.2c61.2 8.1 116.4 35.5 159.2 75.8l-11 11.6c-33.5-31.6-75-54.7-121.1-66.1l-27.1-21.4zM195.7 66.1l-15.2-12C224.4 39.8 271.3 32 320 32c124.2 0 236.5 50.5 317.7 132.1l-11.3 11.3C548.1 96.7 439.7 48 320 48c-43.2 0-84.9 6.3-124.3 18.1zM42.3 128.5l12.9 10.2C40.6 150 26.7 162.3 13.7 175.4L2.3 164.1c12.6-12.7 25.9-24.6 39.9-35.6zM368 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fast',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM176 352h40V224H192h-8V208h8 32 8v8V352h40 8v16h-8H232 216 176h-8V352h8zm64-208v32H208V144h32z'
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fast',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      'M96 256.8l-7.1 4.8C54.6 284.6 32 323.7 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-44.4-22.6-83.5-56.9-106.5l-7.1-4.8v-8.5V16H96V248.3v8.5zM224 0h16V16 248.3c38.6 25.8 64 69.8 64 119.8c0 79.5-64.5 144-144 144S16 447.6 16 368c0-49.9 25.4-93.9 64-119.8V16 0H96 224zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V264v-8h16v8 40.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fast',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M8 32H0v8V280 472v8H16v-8V288H176h6.6l2.6 4.2L301.1 480h18.8L201.2 287.7C267.6 283 320 227.6 320 160c0-70.7-57.3-128-128-128H8zM176 272H16V48H192c61.9 0 112 50.1 112 112s-50.1 112-112 112H176z'
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fast',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      'M224 16c61.9 0 112 50.1 112 112v64H112V128c0-61.9 50.1-112 112-112zM96 128v64H16 0v16V496v16H16 432h16V496 208 192H432 352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM16 208H96h16H336h16 80V496H16V208zM208 400V304h32v96H208zM192 288v16 96 16h16 32 16V400 304 288H240 208 192z'
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fast',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      'M244.7 11.3L256 0V16v6.6V489.4 496v16l-11.3-11.3L240 496 11.3 267.3 0 256l11.3-11.3L240 16l4.7-4.7zM240 38.6L22.6 256 240 473.4V38.6z'
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fast',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      'M144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM287.8 152c-4.2 75.8-66.9 136-143.8 136C64.5 288 0 223.5 0 144S64.5 0 144 0c76.8 0 139.6 60.2 143.8 136H352v-8V112h16H528h16v16 32 16H528 368 352V160v-8H287.8zM528 160V128H368v16 16H528zM272 320h16 48V280v-8h8H456h8v8 40h48 16 16v16H528V496v16H512 288 272V496 336H256V320h16zm80 0h96V288H352v32zm160 16H288V496H512V336zM224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zM48 144a96 96 0 1 1 192 0A96 96 0 1 1 48 144zM0 496H224v16H0V496zM160 336v64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm16 80H160v32 16H144 48 32V448 336 320H48h96 16 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM48 336V448h96V416 400 336H48z'
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fast',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      'M240 96c35.3 0 64-28.7 64-64V16H288c-35.3 0-64 28.7-64 64V96h16zm-32 16V96 80c0-44.2 35.8-80 80-80h16 16V16 32c0 44.2-35.8 80-80 80H224 208zm-96 16l112 32 112-32c76.3 0 112 83.7 112 160c0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288c0-76.3 35.7-160 112-160zm116.4 47.4l-4.4 1.3-4.4-1.3L109.9 144c-30.1 .8-52.8 17.3-68.8 43.7C24.5 215.1 16 252 16 288c0 60.7 19 113.3 46.8 150.4c27.5 36.6 62.4 56.8 95.3 57.6l62-15.5 3.9-1 3.9 1 62 15.5c32.9-.7 67.8-20.9 95.3-57.6C413 401.3 432 348.7 432 288c0-36-8.5-72.9-25.1-100.3c-16-26.3-38.6-42.9-68.8-43.7L228.4 175.4z'
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fast',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5 24c-1.6-7.5-2.4-15.3-2.4-23.2c0-8.5 .9-16.8 2.7-24.8H120V216h46.7c16.3-42.1 57.3-72 105.2-72H313h8v16h-8H271.9c-38.9 0-72.4 22.9-87.8 56H312v16H178.3c-2.1 7.9-3.2 16.2-3.2 24.8c0 8 1 15.8 2.8 23.2H312v16H183.4c15.1 33.9 49 57.5 88.5 57.5H313h8v16h-8H271.9c-48.5 0-89.8-30.6-105.7-73.5H120V280h41.5z'
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fast',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      'M577.9 324.1C596.8 289.5 608 242.8 608 192s-11.2-97.5-30.1-132.1C559.4 25.9 531.1 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160c-11.7 0-22.8 4.2-33.2 11.8L140 22.2c6.8-4.2 13.6-6.2 20-6.2H450.4c-14.5 10.8-26.7 26.2-36.3 43.9C395.2 94.5 384 141.2 384 192l0 .5c0 7.4 0 14.8-.1 22.2l15.9 12.5c.2-11.9 .2-23.7 .2-35.2c0-87.3 34.7-159.7 80.1-173.6c5.2-1.6 10.5-2.4 15.9-2.4c53 0 96 78.8 96 176c0 63.8-18.5 119.6-46.2 150.5l12.6 9.9c7.4-8.4 13.9-18 19.6-28.3zM370.6 387.7c-6.1 34.3-15 67.5-27.8 98.4l0 0-4.1 9.9H32l9.2-22.1 0 0 .1-.3C76.2 385.4 80 281.8 80 192c0-11.2 .5-22.1 1.4-32.6L66.6 147.7C64.9 161.9 64 176.7 64 192c0 89.9-3.9 190.6-37.6 275.8L14.7 496 8 512H25.3h324l8.2-19.7c12.2-29.5 21-61 27.2-93.4l-14.2-11.2zM496 264c8.7 0 15.7-4.2 20.6-9c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9zm24-72c0 30.9-10.7 56-24 56s-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fast',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      'M324.4 112c17.4 0 34.5 4.2 49.9 12c12.6-27.2 17.3-57.9 12.9-88.4L384.5 16l-21.8 0-8.1 8c-10.5 10.4-19.1 22.1-25.9 34.7c-2.5-6-5.2-11.8-8.3-17.6c6.5-10.2 14.1-19.8 22.9-28.5L353.8 2.3 356.1 0l3.3 0 32 0 6.9 0 1 6.9 3.8 26.4c4.9 34.2-.6 68.6-15 99c2 1.4 3.9 2.9 5.8 4.4l59.1 48.2 2.9 2.4v3.8V280v8h-8H365.9L484.8 498.3c.4 .7 .8 1.4 1.1 2.2l5.6 11.5H478.8 405.3h-4.7l-2.3-4.1-70.6-125L283.6 432H304h32 8v8 64 8h-8H304 176 144l-40 0H96v-8V471.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.3 0 29.4 5.4 40.4 14.4c21-69.9 79.2-123.7 151.6-138.4V183.2c-40.3-38.7-59.6-94.5-51.7-149.9l3.8-26.4 1-6.9L216 0l32 0 3.3 0 2.3 2.3L264 12.6c27.6 27.4 44 63.1 47.4 100.6c4.2-.8 8.6-1.2 13-1.2zM100 384.2C91.2 374.3 78.3 368 64 368c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.3 0 23.5-4.6 32-12.2V424c0-13.6 1.4-26.9 4-39.8zM220.1 35.5C212.9 86.6 231 138 268.7 173.2l.8 .7 2.6 2.4 0 3.5 0 .6v54.2 6.8l-6.7 1.1C178.3 257.1 112 332.8 112 424v72l32 0h32H304h24V448H304 265.6h-18l12-13.4L323.3 364l7.4-8.3 5.5 9.7L410 496h55.1L345.3 283.9 338.5 272h13.7H440V194.9l-56.2-45.8C367 135.5 346.1 128 324.4 128c-6.2 0-12.2 1.1-17.7 3.1l-10.4 3.7-.3-11c-1.1-37-16.2-72.9-43.2-99.8l-8.1-8-21.8 0-2.8 19.5zM352 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fast',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      'M16 32H0v8V472v8H16v-8V40 32zM149.7 138.3l-5.7-5.7L132.7 144l5.7 5.7L244.7 256 138.3 362.3l-5.7 5.7L144 379.3l5.7-5.7L256 267.3 362.3 373.7l5.7 5.7L379.3 368l-5.7-5.7L267.3 256 373.7 149.7l5.7-5.7L368 132.7l-5.7 5.7L256 244.7 149.7 138.3zM512 40V32H496v8V472v8h16v-8V40z'
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fast',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      'M400 64c0-8.3-7.2-20.2-28.6-30.9C350.8 22.8 321.4 16 288 16s-62.8 6.8-83.4 17.1C183.2 43.8 176 55.7 176 64c0 6.3 4.1 14.7 15.5 23.1c-2.7 4.6-5.1 9.5-7.2 14.5C169 91 160 78 160 64c0-35.3 57.3-64 128-64s128 28.7 128 64c0 14-9 27-24.3 37.5c-2.1-5-4.5-9.9-7.2-14.5C395.9 78.7 400 70.3 400 64zM288 208a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM62.6 345.5l2.9 6.6-3 6.6L16 459.5V496h88L224 256h1.4l-80-80H32V276.6l30.6 68.9zM248 256h80l96-96H544h16v16V280l-32 72 48 104v40 16H560 480 462.1 113.9 96 16 0V496 456L48 352 16 280V176 160H32 152l96 96zm102.6 0H352L472 496h88V459.5L513.5 358.7l-3-6.6 2.9-6.6L544 276.6V176H430.6l-80 80zM121.9 496H454.1l-112-224H233.9l-112 224z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fast',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M304 32l64 64H560h16v16V368v16H560 112 96V368 48 32h16H304zm64 80h-6.6l-4.7-4.7L297.4 48H112V368H560V112H368zM16 128H64v16H16V464H464V416h16v48 16H464 16 0V464 144 128H16z'
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fast',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80 72h16v8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H504v64 8H488v-8V376H424h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fast',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-88V344v8H192v-8V168v-8h16v8zm112 0V344v8H304v-8V168v-8h16v8z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fast',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      'M104 0L96 0l0 8 0 84c-4 1.2-8 2.8-11.8 4.6l-13.2 6.2C47.2 113.9 32 137.8 32 164.2c0 18.1 7.1 34.5 18.6 46.7C39.1 222.4 32 238.4 32 256c0 19.1 8.4 36.3 21.7 48C40.4 315.7 32 332.9 32 352s8.4 36.3 21.7 48C40.4 411.7 32 428.9 32 448l0 56 0 8 8 0 240 0 8 0 0-8 0-56c0-19.1-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48c13.3-11.7 21.7-28.9 21.7-48c0-17.6-7.1-33.6-18.6-45.1c11.5-12.2 18.6-28.6 18.6-46.7c0-26.3-15.2-50.3-39.1-61.4l-13.2-6.2C232 94.8 228 93.3 224 92l0-84 0-8-8 0L104 0zm93.3 104c11 0 21.8 2.4 31.7 7.1l13.2 6.2c18.2 8.5 29.8 26.8 29.8 46.9c0 16.4-7.6 31.1-19.6 40.6l-8.1 6.5 8.4 6.2c11.8 8.8 19.4 22.8 19.4 38.6c0 17.5-9.3 32.7-23.3 41.1L237.4 304l11.4 6.9c14 8.4 23.3 23.7 23.3 41.1s-9.3 32.7-23.3 41.1L237.4 400l11.4 6.9c14 8.4 23.3 23.7 23.3 41.1l0 48L48 496l0-48c0-17.4 9.3-32.7 23.3-41.1L82.6 400l-11.4-6.9C57.3 384.7 48 369.4 48 352s9.3-32.7 23.3-41.1L82.6 304l-11.4-6.9C57.3 288.7 48 273.5 48 256c0-15.8 7.6-29.8 19.4-38.6l8.4-6.2-8.1-6.5c-12-9.5-19.6-24.2-19.6-40.6c0-20.1 11.6-38.4 29.8-46.9L91 111.1c9.9-4.6 20.7-7.1 31.7-7.1l74.6 0zm0-16l-74.6 0L112 88l0-72 96 0 0 72-10.7 0zM96 208l0 16 128 0 0-16L96 208zM224 368L96 368l0 16 128 0 0-16z'
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fast',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 352a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z'
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fast',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      'M496 256C496 123.5 388.5 16 256 16h-8V0h8C397.4 0 512 114.6 512 256s-114.6 256-256 256h-8V496h8c132.5 0 240-107.5 240-240zM197.2 121.9l152 128 7.3 6.1-7.3 6.1-152 128-6.1 5.2L180.7 383l6.1-5.2L322.1 264H8 0V248H8 322.1L186.8 134.1l-6.1-5.2L191 116.7l6.1 5.2z'
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fast',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      'M312 104v64c0 45.9-35.1 83.6-80 87.6V224v-8H216v8 31.6c-44.9-4-80-41.7-80-87.6V104c0-48.6 39.4-88 88-88s88 39.4 88 88zM112 128c0-8.1 3-15.5 8-21.2V168c0 57.4 46.6 104 104 104s104-46.6 104-104V106.8c5 5.6 8 13.1 8 21.2v24 4.8l2.7 4 29.3 44V240H326.5c-3.5 5.8-7.7 11.2-12.4 16H368h16V240 200l-32-48V128c0-18.4-10.4-34.4-25.6-42.5C317.6 36.9 275.1 0 224 0s-93.6 36.9-102.4 85.5c-15.2 8-25.6 24-25.6 42.5v24L64 200v40 16H80h53.9c-4.7-4.8-8.9-10.2-12.4-16H80V204.8l29.3-44 2.7-4V152 128zM236 416a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm0 48a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm-6.3-293.7l-5.7-5.7-5.7 5.7C203.8 184.9 188.5 188 184 188h-8v16h8c7.9 0 24.2-3.9 40.1-17.2c3.5 2.8 7.7 5.9 12.4 8.6c7.7 4.5 17.5 8.6 27.5 8.6h8V188h-8c-6 0-12.8-2.6-19.5-6.4c-6.5-3.8-12-8.4-14.9-11.2zM204 128a12 12 0 1 0 -24 0 12 12 0 1 0 24 0zm52 12a12 12 0 1 0 0-24 12 12 0 1 0 0 24zM144 304h-3.3l-2.3 2.3L124.7 320H64L5.3 496 0 512H16.9 431.1 448l-5.3-16L384 320H323.3l-13.7-13.7-2.3-2.3H304 144zM98.3 346.3L96 348.7V352v56 16.6l13-10.4L146.8 384H301.2L339 414.2l13 10.4V408 352v-3.3l-2.3-2.3L339.3 336h33.2l53.3 160H22.2L75.5 336h33.2L98.3 346.3zm13.7 9L147.3 320H216v48H144h-2.8l-2.2 1.8-27 21.6v-36zM232 368V320h68.7L336 355.3v36l-27-21.6-2.2-1.8H304 232z'
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fast',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      'M432 272c70.7 0 128-57.3 128-128s-57.3-128-128-128c-55.2 0-102.3 35-120.2 84H294.8C313.4 42 367.8 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-32.1 0-61.7-10.5-85.6-28.2l11.5-11.5C378.8 263.2 404.4 272 432 272zM0 144V128H16 400h16v16L219.3 340.7 216 344V496h96 8v16h-8H208 104 96V496h8 96V344l-3.3-3.3L0 144zm393.4 0H22.6l184 184h2.7l184-184z'
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fast',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      'M363.6 32.8c24.9 12.5 61.8 38.3 92.6 75.9C487 146.3 512 196.1 512 256s-25 109.7-55.8 147.3c-30.8 37.5-67.7 63.4-92.6 75.9l-7.2-14.3c23.1-11.5 58.2-36.1 87.4-71.7C473 357.5 496 311.3 496 256s-23-101.5-52.2-137.1c-29.2-35.7-64.3-60.2-87.4-71.7l7.2-14.3zm-215.2 0l7.2 14.3c-23.1 11.5-58.2 36.1-87.4 71.7C39 154.5 16 200.7 16 256s23 101.5 52.2 137.1c29.2 35.7 64.3 60.2 87.4 71.7l-7.2 14.3c-24.9-12.5-61.8-38.3-92.6-75.9C25 365.7 0 315.9 0 256s25-109.7 55.8-147.3c30.8-37.5 67.7-63.4 92.6-75.9z'
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fast',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      'M0 72V440v8H16v-8V72 64H0v8zM128 256l5.7 5.7 152 152 5.7 5.7L302.6 408l-5.7-5.7L158.6 264 632 264h8l0-16h-8l-473.4 0L297 109.7l5.7-5.7L291.3 92.7l-5.7 5.7-152 152L128 256z'
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fast',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      'M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM126 295.8l3.6-7.3L185.9 176h76.2l56.3 112.5 3.6 7.3 8 1.3c39.7 6.7 70 41.2 70 82.8c0 46.4-37.6 84-84 84c-20.9 0-39.9-7.6-54.6-20.2l-4.5-3.8H251 197h-5.9l-4.5 3.8C171.9 456.4 152.9 464 132 464c-46.4 0-84-37.6-84-84c0-41.6 30.3-76.2 70-82.8l8-1.3zM176 160L115.3 281.4C68 289.3 32 330.5 32 380c0 55.2 44.8 100 100 100c24.8 0 47.5-9 65-24h54c17.5 15 40.2 24 65 24c55.2 0 100-44.8 100-100c0-49.5-36-90.7-83.3-98.6L272 160H176zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0A48 48 0 1 0 0 192a48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fast',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H281.1l-55.7-83.6-4.8-7.1 7.4-4.3 102.1-58.4L226.8 254.1l-6.1-5.2 10.4-12.1 6.1 5.2 112 96 8.6 7.4-9.9 5.6L243.4 410.7 300.3 496H496V204.8L288 26.5z'
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fast',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      'M16 440l0 8L0 448l0-8L0 72l0-8 16 0 0 8 0 368zM288 320l0 16 0 64 0 16-16 0-16 0L107.3 267.3 96 256l11.3-11.3L256 96l16 0 16 0 0 16 0 64 0 16 16 0 128 0 16 0 0 16 0 96 0 16-16 0-128 0-16 0zm-16 0l0-16 16 0 144 0 0-96-144 0-16 0 0-16 0-80-9.4 0-144 144 144 144 9.4 0 0-80z'
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fast',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zm24 232H360V248H152v16z'
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fast',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      'M0 160H16.5h344c5.2-5.6 10.5-11 15.8-16h-236l24-96L280 48v96h16V48l115.8 0 14 56.1c1.8-1.2 3.6-2.3 5.3-3.4l9-5.6L428.2 48H531.5l18.9 75.5 14.1 11.7c2.3 1.9 4.6 3.8 6.8 5.8L544 32H32L4 144 0 160zM112 416H96l-17.1 0-31-217.1-1-6.9H30.8l1.3 9.1L38.8 248H8 0v16H8 41.1l23 161.1 1 6.9H72 96v40 8h16v-8V432H324.1c-3.7-5.1-7.2-10.5-10.4-16H112zM512 146.6l2.6-2.6h-5.2l2.6 2.6zM20.5 144l24-96H147.8l-24 96H20.5zm480.2 36.8L448 128.1c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-20.7 20.7L512 192.1l-11.3-11.3zM576 390.6c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 18.2 5.8 35.1 15.7 49.2C361.3 413.9 336 370 336 320.2c0-39.7 19-77.6 44.5-109.6c21.3-26.7 46.2-48.2 65.4-61.8l54.7 54.7L512 214.8l11.3-11.3L544.8 182C609.1 240.5 624 300 624 320.2c0 49.8-25.3 93.7-63.7 119.6c9.9-14.1 15.7-31 15.7-49.2zm-96 73.6c-45.2 0-80-34-80-73.6c0-28.5 20-58.2 43.5-82.5c11.4-11.8 22.8-21.5 31.4-28.3c1.8-1.5 3.5-2.8 5.1-3.9c1.5 1.2 3.2 2.5 5.1 3.9c8.6 6.8 20 16.5 31.4 28.3C540 332.4 560 362 560 390.6c0 39.6-34.8 73.6-80 73.6z'
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fast',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM168 352h-8v-8V200v-8h16v8V324.7L338.3 162.3l5.7-5.7L355.3 168l-5.7 5.7L187.3 336H312h8v16h-8H168z'
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fast',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      'M288 5.5l5.2 4.5 280 240-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zm0 21.1L80 204.8V496H496V204.8L288 26.5zM288 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM219.5 336l-21.3 64H377.8l-21.3-64H219.5zM368 320l26.7 80 5.3 16H383.1 192.9 176l5.3-16L208 320H368z'
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fast',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      'M376 0h-8V16h8 92.7l-97.2 97.2C342.3 82.9 301.4 64 256 64C167.6 64 96 135.6 96 224c0 85.7 67.4 155.6 152 159.8V432H200h-8v16h8 48v56 8h16v-8V448h48 8V432h-8H264V383.8c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120v8h16v-8V8 0h-8H376zM256 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fast',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM192 208v8 96 8h8 96 8v-8c0-57.4-46.6-104-104-104h-8zm16 16.4c42.2 3.8 75.8 37.4 79.6 79.6H208V224.4zm-48 8.9C110.2 240.9 72 284 72 336c0 57.4 46.6 104 104 104c52 0 95.1-38.2 102.8-88H262.6c-7.5 41-43.4 72-86.6 72c-48.6 0-88-39.4-88-88c0-43.1 31-79 72-86.5V233.2z'
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fast',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4 436.7 276.7l24.2-24.2C483.4 230 496 199.5 496 167.8C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zm11.3 350.1L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 267.3 468.7z'
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fast',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.3 117c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-2.6-15.8 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 11.3 11.3-7.4 7.4zm163.4 0l-7.4-7.4 11.3-11.3 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4-2.6 15.8-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5zm13.9 91a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM184 344c0-20.7-11.2-38.8-28-48.5l8-13.8c19.3 11.2 33 31.1 35.6 54.4H312.4c2.6-23.3 16.2-43.2 35.6-54.4l8 13.8c-16.8 9.7-28 27.8-28 48.5s11.2 38.8 28 48.5l-8 13.9c-19.3-11.2-33-31.1-35.6-54.4H199.6c-2.6 23.3-16.2 43.2-35.6 54.4l-8-13.9c16.8-9.7 28-27.8 28-48.5z'
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fast',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H394.8c-6.9-4.9-13.4-10.2-19.6-16H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H326.6c-1.5-5.2-2.7-10.6-3.7-16H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V204c5.2-2 10.6-3.8 16-5.4V8 0h-8H56zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-219.3-8L432 371.3l5.7-5.7L488 315.3V440v8h16v-8V315.3l50.3 50.3 5.7 5.7L571.3 360l-5.7-5.7-64-64-5.7-5.7-5.7 5.7-64 64-5.7 5.7z'
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fast',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      'M56 0H48V8 134.5L.6 253 0 254.5V256 504v8H8 376h8v-8V256v-1.5l-.6-1.4L336 134.5V8 0h-8H280h-8V8 80c0 44.2-35.8 80-80 80s-80-35.8-80-80V8 0h-8H56zm8 136V16H96V80c0 53 43 96 96 96s96-43 96-96V16h32V136v1.5l.6 1.4 11.9 29.7-1.2 .9L16 406V257.5L63.4 139l.6-1.4V136zM16 426l4.8-3.6L338.6 184l14.7 36.9-6.2 4.7-315 240L16 477.9V426zM359.5 236.3l8.5 21.2V496H18.7l23.1-17.6 315-240 2.7-2z'
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fast',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      'M80 0l0 32H16 0V48 400v16H16 80l0 96H96l0-96H348.5c-3.4-5.2-6.5-10.5-9.3-16H16V48H560V160h16V48 32H560 496l0-32H480l0 32H96L96 0H80zM431.9 192h-2l-1.8 .9C382.9 217.2 352 265 352 320c0 46.4 21.9 87.7 56 114v70 8h16v-8V430v-4.1l-3.3-2.4c-32-23.3-52.7-61-52.7-103.5c0-48.2 26.6-90.2 66-112h6v80 3.3l2.3 2.3 48 48 5.7 5.7 5.7-5.7 48-48 2.3-2.3V288 208h6c39.4 21.8 66 63.8 66 112c0 42.5-20.7 80.2-52.7 103.5l-3.3 2.4V430v74 8h16v-8V434c34.1-26.3 56-67.6 56-114c0-55-30.9-102.8-76.2-127.1l-1.8-.9h-2H544h-8v8 84.7l-40 40-40-40V200v-8h-8H431.9z'
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fast',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      'M44.8 48a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 90.7a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM73.6 315.7a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM193.1 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm73.6 119.5a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM312.5 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm73.6 119.5a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM432 76.8a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM432 315.7a28.8 28.8 0 1 1 -57.6 0 28.8 28.8 0 1 1 57.6 0zm-28.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 135.5a28.8 28.8 0 1 1 0 57.6 28.8 28.8 0 1 1 0-57.6zm-44.8 28.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z'
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fast',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      'M288 16C155.5 16 48 123.5 48 256s107.5 240 240 240c110.1 0 202.8-74.1 231.1-175.1L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-5.9-.1-11.7 .4-17.5 1.6C453.7 63.8 376.4 16 288 16zM482.5 185.2c16.4-15.8 42.5-15.5 58.6 .6c16.6 16.6 16.3 43.7-.7 59.9L400.5 379.3c2.1 2.7 4.1 5.4 6 8.1l-13.1 9.2C372.6 366.8 337.4 336 288 336s-84.6 30.8-105.4 60.6l-13.1-9.2c22.4-32 61.9-67.4 118.6-67.4c16.7 0 31.9 3.1 45.6 8.2l148.9-143zM438 321.4l-11.7-11.7-5.7-5.7L432 292.7l5.7 5.7 12 12 21.2-20.2-12.4-12.4-5.7-5.7L464 260.7l5.7 5.7 12.7 12.7 21.2-20.2-13.2-13.2-5.7-5.7L496 228.7l5.7 5.7 13.5 13.5 14.3-13.6c10.5-10 10.7-26.8 .4-37c-10-10-26.1-10.1-36.2-.4L349.3 335.3c16.1 8.5 29.7 19.8 40.8 31.8l15.2-14.5-11-11-5.7-5.7L400 324.7l5.7 5.7 11.2 11.2L438 321.4zM208.4 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fast',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c20-1 39-6 56.3-14c-.2-3.2-.3-6.5-.3-9.8c0-2.7 .1-5.4 .2-8.1c-19.1 10.3-41 16.1-64.2 16.1c-75.1 0-136-60.9-136-136V160H328v66c5.1-3.8 10.5-7.3 16-10.5V160h32 8V144h-8H344 328 56 40 8zm424 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm24.8-231.2l-18.3 17.5-84 80L340 392h20 51.8l-7.7 38.4-5 24.8 18.3-17.5 84-80L516 344H496 444.2l7.7-38.4 5-24.8zM380 376l51.2-48.8-4.6 23.2-1.9 9.6h9.8H476l-51.2 48.8 4.6-23.2 1.9-9.6h-9.8H380z'
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fast',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      'M280 383c-2.6-.5-5.8-1.2-9.4-2.3l0 0c-33.2-5.8-100.5-31.4-159.6-80.9C51.7 250 0 175.5 0 72V64H8 129.6c-.8-15.3-1.3-31.2-1.5-48c-.1-5.3-.1-10.6-.1-16h16H432h16c0 5.4 0 10.7-.1 16c-.2 16.8-.7 32.7-1.5 48H568h8v8c0 103.5-51.7 178-111 227.8c-59.1 49.6-126.4 75.1-159.6 80.9l0 0c-3.6 1.1-6.8 1.9-9.4 2.3V496H408h8v16h-8H288 168h-8V496h8H280V383zm-11.1-19.9c1.9 .8 3.8 1.4 5.5 2l6.8 1.2-.1 .6c1 .2 1.9 .4 2.7 .5c1.7 .3 2.9 .4 3.7 .5l.5 0 .5 0c.7-.1 2-.2 3.7-.5c.8-.1 1.7-.3 2.7-.5l-.1-.6 6.8-1.2c1.7-.6 3.5-1.2 5.5-2c12.6-5 30.4-15.5 48.7-37.4c35.6-42.7 74-130.4 76.2-309.8H144.1c2.2 179.4 40.6 267.1 76.2 309.8c18.2 21.9 36 32.3 48.7 37.4zm185.8-75.6C509.9 241.2 557.3 173.4 559.9 80H445.4c-10.3 153.2-50.3 229.2-87.3 266.9c29.6-12.8 64.3-32.4 96.6-59.4zm-333.5 0c32.3 27.1 67 46.6 96.6 59.4c-37.1-37.7-77-113.7-87.3-266.9H16.1c2.6 93.4 49.9 161.2 105.2 207.5zm173.9-203l21.7 43.9 48.4 7 16 2.3L369.7 149l-35 34.1 8.3 48.2 2.7 16-14.3-7.5L288 217l-43.3 22.8-14.3 7.5 2.7-16 8.3-48.2-35-34.1-11.6-11.3 16-2.3 48.4-7 21.7-43.9L288 69.9l7.2 14.5zm-23.5 54.7l-1.9 3.8-4.2 .6-36.5 5.3 26.4 25.8 3 2.9-.7 4.1-6.2 36.4 32.7-17.2 3.7-2 3.7 2 32.7 17.2-6.2-36.4-.7-4.1 3-2.9 26.4-25.8-36.5-5.3-4.2-.6-1.9-3.8L288 106.1l-16.3 33.1z'
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fast',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      'M240 272V256 16.5C114.9 24.8 16 128.8 16 256c0 132.5 107.5 240 240 240c127.2 0 231.2-98.9 239.5-224H256 240zm271.5 0C503.2 405.9 392 512 256 512C114.6 512 0 397.4 0 256C0 120 106.1 8.8 240 .5c5.3-.3 10.6-.5 16-.5V16 240v16h16H496h16c0 5.4-.2 10.7-.5 16z'
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fast',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      'M37.7 26.3L32 20.7 20.7 32l5.7 5.7L132.7 144H56 48v16h8 96 8v-8V56 48H144v8 76.7L37.7 26.3zm564.7 0L496 132.7V56 48H480v8 96 8h8 96 8V144h-8H507.3L613.7 37.7l5.7-5.7L608 20.7l-5.7 5.7zM202.8 334.3c-27.7-25.8-47.1-56.3-57.3-78.3c10.2-22 29.6-52.5 57.3-78.3C233.1 149.6 272.4 128 320 128s86.9 21.6 117.2 49.7c27.7 25.8 47.1 56.3 57.3 78.3c-10.2 22-29.6 52.5-57.3 78.3C406.9 362.4 367.6 384 320 384s-86.9-21.6-117.2-49.7zM320 400c105.6 0 172-96 192-144c-20-48-86.4-144-192-144s-172 96-192 144c20 48 86.4 144 192 144zm282.3 85.7l5.7 5.7L619.3 480l-5.7-5.7L507.3 368H584h8V352h-8H488h-8v8 96 8h16v-8V379.3L602.3 485.7zm-564.7 0L144 379.3V456v8h16v-8V360v-8h-8H56 48v16h8 76.7L26.3 474.3 20.7 480 32 491.3l5.7-5.7zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fast',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M11.3 396.7L0 408l11.3 11.3 81.4 81.4L104 512l11.3-11.3L231.7 384.3 220.4 373 104 489.4 22.6 408 181.4 249.3l-11.3-11.3L11.3 396.7zM496 160c0 49.8-25.3 93.8-63.8 119.6l11.5 11.5C485 262.2 512 214.3 512 160c0-21.7-4.3-42.4-12.1-61.2c-2.2-5.2-4.6-10.4-7.3-15.3L480.7 95.3 400 176H352 336V160 112l80.7-80.7 11.8-11.8c-5-2.7-10.1-5.1-15.3-7.3C394.4 4.3 373.7 0 352 0C297.7 0 249.8 27 220.9 68.3c4.2 4.3 7.3 9.5 9.1 15.2C255.5 42.9 300.6 16 352 16c17.2 0 33.6 3 48.9 8.5l-76.2 76.2-4.7 4.7V112v64 16h8 8 64 6.6l4.7-4.7 76.2-76.2c5.5 15.2 8.5 31.7 8.5 48.9zM112 422.6L134.6 400 112 377.4 89.4 400 112 422.6zM176 176H104L21.1 65.5 65.5 21.1 176 104v72zm0 16h4.7l93.7 93.7-31 31L232 328l11.3 11.3L404.7 500.7 416 512l11.3-11.3 73.4-73.4L512 416l-11.3-11.3L339.3 243.3 328 232l-11.3 11.3-31 31L192 180.7V176 96L64 0 0 64 96 192h80zM416 489.4L254.6 328 328 254.6 489.4 416 416 489.4z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fast',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      'M56 0H48V8 256H8 0v8 96c0 83.9 68.1 152 152 152h80c83.9 0 152-68.1 152-152v-8-8V280 72 64h-8H296h-8v8V184H224V160v-8h-8H144V8 0h-8H56zm88 168h64l0 16v8 64H144V168zm64 104l0 0 0 64H104 96v16h8H208h8 8 72 8v-8V280v-8V192v-8V80h64V280v64 8 8c0 75.1-60.9 136-136 136H152C76.9 496 16 435.1 16 360V272H48v0H64v0h64v0h16v0h64zm16 0l0-8v-8l0-56h64v72 8 56H224l0-64zm-96-16H64V16h64V152v8 96z'
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fast',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c39.3 0 76.3-9.4 109-26.1c.8 5.5 2.1 10.8 3.9 15.9C334.9 502.6 296.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 32.2-6 63-16.8 91.4c-4.3-3.9-8.6-7.5-13-10.9c9-25.2 13.8-52.3 13.8-80.5C496 123.5 388.5 16 256 16zM118.6 252.1c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7zm233 27.9c14.6 0 30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7c10.9 19.3 26.4 27.9 41 27.9zm1.5 162.9L340 436c-24-12.6-52.9-20-84-20c-31.1 0-60 7.4-84 20l-13.1 6.9 1.4-14.8C165 380.7 206.3 344 256 344s91 36.7 95.7 84.2l1.4 14.8zM332.8 415c-9.8-31.7-40.3-55-76.8-55s-66.9 23.3-76.7 55c23-9.6 49.1-15 76.7-15c27.6 0 53.7 5.4 76.8 15zm8.3-79.5l3-15.4c25.9 0 67.4 12.7 102.3 35.3C481.2 377.9 512 412 512 456c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.1 0-40.5-7.6-63.9c-7.5-23.1-22.1-44.9-51.4-56.6zm40 7.1c13.2 13.1 21.5 28.8 26.6 44.6c8.4 26 8.4 52.6 8.4 68.6v.3c0 22.1 17.9 40 40 40s40-17.9 40-40c0-36-25.2-65.9-58.3-87.3c-18.5-11.9-38.6-20.7-56.6-26.2z'
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fast',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      'M16 80l544 0V272H408l-8 0v8l0 152L16 432 16 80zM553.4 288L416 425.4 416 288H553.4zm22.6 0V80 64H560 16 0V80 432v16H16l400 0L576 288zM104 152a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM88 120a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fast',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      'M0 120C0 53.7 53.7 0 120 0H248h8V8 32h32V8 0h8 48 8V8 184v8h-8H296h-8v-8V160H256v16 8h-8H216.4l7.3 312 .4 16H208 112 96l.4-16 7.3-312H88 83.1l-2.2-4.4L68.1 154 10.8 175.5 0 179.5V168 120zm119.6 64l-7.3 312h95.2l-7.3-312H119.6zM240 168V152v-8h8 48 8v8 24h32V16H304V40v8h-8H248h-8V40 16H120C62.6 16 16 62.6 16 120v36.5l53.2-19.9 6.7-2.5 3.2 6.4L92.9 168H104 216h24zM640 288V496v16H624 368 352V496 288l88-88V16 0h16 80 16V16 200l88 88zM536 200V16H456V200v6.6l-4.7 4.7L374.6 288H617.4l-76.7-76.7-4.7-4.7V200zM368 352H624V304H368v48zm0 16V496h80V416v-8h16v8 80H624V368H368zM496 80a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fast',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256v8h-8H136h-8V248h8H248V104 96h16v8z'
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fast',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      'M307.5 49.9L320 65.5l12.5-15.6 9.3-11.6c11.3-14.1 28.5-22.4 46.6-22.4c32.9 0 59.6 26.7 59.6 59.6v3.6c0 16.8-6.7 32.8-18.5 44.7l-24.8 24.8L320 233.3l-84.7-84.7-24.8-24.8C198.7 111.9 192 95.9 192 79.1V75.6c0-32.9 26.7-59.6 59.6-59.6c18.1 0 35.3 8.2 46.6 22.4l9.3 11.6zm12.5 206l11.3-11.3L416 159.9l24.8-24.8c14.9-14.9 23.2-35 23.2-56V75.6C464 33.8 430.1-.1 388.4-.1c-22.5 0-43.7 10-58.1 27.2c-.3 .4-.6 .8-1 1.2L320 39.9l-9.3-11.6c-.3-.4-.6-.8-1-1.2C295.4 9.9 274.1-.1 251.6-.1C209.9-.1 176 33.8 176 75.6v3.6c0 21 8.3 41.1 23.2 56L224 159.9l84.7 84.7L320 255.9zM96 72c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8V384c0 2.1 .8 4.2 2.3 5.7l120 120 11.3-11.3L16 380.7V80H80V288c0 2.1 .8 4.2 2.3 5.7l10.8 10.8 5.2 5.2 80 80 8 8 5.7 5.7L203.3 392l-5.7-5.7-8-8-74.8-74.8 37.6-43.8L288 395.3V504v8h16v-8V392v-3.3l-2.3-2.3-144-144-6.1-6.1-5.6 6.6-42.4 49.4L96 284.7V72zm456-8c-4.4 0-8 3.6-8 8V284.7l-7.5 7.5-42.4-49.4-5.6-6.6-6.1 6.1-144 144-2.3 2.3V392 504v8h16v-8V395.3L487.5 259.8l37.6 43.8-74.8 74.8-8 8-5.7 5.7L448 403.3l5.7-5.7 8-8 80-80 5.2-5.2 10.8-10.8c1.5-1.5 2.3-3.5 2.3-5.7V80h64V380.7L506.3 498.3l11.3 11.3 120-120c1.5-1.5 2.3-3.5 2.3-5.7V72c0-4.4-3.6-8-8-8H552z'
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fast',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      'M242.9 13l-3.9 7L141.7 192H434.3L337 19.9l-3.9-7L347 5.1l3.9 7L452.7 192h74.8H544h32v16H540L464 512H112L36 208H0V192H32 48.5h74.8L225 12.1l3.9-7L242.9 13zM523.5 208H52.5l72 288h327l72-288zM160 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm208 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fast',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M368 240l0 232v8h16v-8l0-432V32H368v8V224L16 224V40 32H0v8V472v8H16v-8l0-232 352 0z'
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fast',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      'M192 320l0 16 0 64 0 16-16 0-16 0L11.3 267.3 0 256l11.3-11.3L160 96l16 0 16 0 0 16 0 64 0 16 16 0 128 0 16 0 0 16 0 96 0 16-16 0-128 0-16 0zm-16 0l0-16 16 0 144 0 0-96-144 0-16 0 0-16 0-80-9.4 0L22.6 256l144 144 9.4 0 0-80zM448 440l0 8-16 0 0-8 0-368 0-8 16 0 0 8 0 368z'
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fast',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      'M224 0h-6.2l-1.5 6.1L185.8 128H8 0v16H8 376h8V128h-8H202.2l28-112H280h8V0h-8H224zM36 176L64 512H320l28-336H331.9L305.3 496H78.7L52.1 176H36z'
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fast',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm32-256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM167.2 244.7l5.3 6C193 273.6 222.8 288 256 288s63-14.4 83.5-37.3l5.3-6 11.9 10.7-5.3 6C328 287.5 293.9 304 256 304s-72-16.5-95.4-42.7l-5.3-6 11.9-10.7z'
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fast',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 12.4-.9 24.5-2.7 36.4C419.6 320.6 339.6 336 256 336s-163.6-15.4-237.3-43.6c-1.8-11.9-2.7-24-2.7-36.4zm6.3 54.8C95.2 337.4 173.9 352 256 352s160.8-14.6 233.7-41.2C464.9 416.9 369.7 496 256 496S47.1 416.9 22.3 310.8zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM128 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fast',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      'M128 352c-8.1 0-16.2-.4-24.1-1.3L75 379.6c37.8 32.6 87.1 52.4 141 52.4c119.3 0 216-96.7 216-216c0-53.9-19.7-103.2-52.4-141l-28.9 28.9c.8 7.9 1.3 16 1.3 24.1c0 123.7-100.3 224-224 224zM63.7 391L24.6 430c49.8 41.2 113.7 66 183.4 66c159.1 0 288-128.9 288-288c0-69.7-24.7-133.6-66-183.4L391 63.7c35.5 40.8 57 94 57 152.3c0 128.1-103.9 232-232 232c-58.3 0-111.6-21.5-152.3-57zM336 128c0-10.1-.7-20.1-2.1-29.9l85.6-85.6L430.8 1.2c3.6 3.9 7.2 7.9 10.6 12C485.5 66 512 133.9 512 208c0 167.9-136.1 304-304 304c-74.1 0-142-26.5-194.8-70.6c-4.1-3.4-8.1-7-12-10.6l11.3-11.3 85.6-85.6c9.8 1.4 19.7 2.1 29.9 2.1c114.9 0 208-93.1 208-208z'
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fast',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM95.9 128h5H219.1h5l2.2 4.5 63.5 131.7c-3.7 5-7.1 10.2-10.2 15.6L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm117.9-80H454c23.2 0 42 18.8 42 42v8h-.8c-2.6 13.2-11.4 24.6-24 30.3L440 382.4V392v8H424v-8V377.2v-5.2l4.7-2.1 36-16.2C474 349.5 480 340.3 480 330c0-14.4-11.6-26-26-26H405.9c-12.1 0-21.9 9.8-21.9 21.9V328l0 8H368l0-8v-2.1c0-20.9 17-37.9 37.9-37.9zM444 420v24H420V420h24z'
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fast',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      'M48 16v96H168h16H304V16H48zM304 128H184v32H480l32 224V496v16H496 16 0V496 384L32 160H168V128H48 32V112 16 0H48 304h16V16v96 16H304zM168 176H45.9L16.2 384H495.8L466.1 176H184 168zM496 496V400H16v96H496zM128 224v16 16H112 96V240 224h16 16zm96 0v32H192V224h32zm-48 80v32H144V304h32zm64 32V304h32v32H240zm128-32v32H336V304h32zm16-80h32v32H384V224zM96 56H256h8V72h-8H96 88V56h8zM288 224h32v32H288V224z'
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fast',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM264 160H248v8 80H168h-8v16h8 80v80 8h16v-8V264h80 8V248h-8H264V168v-8z'
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fast',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      'M248 0h16V48H448l64 72-64 72H264v48H464h16v16V368v16H464 264V512H248V384H64L0 312l64-72H248V192H48 32V176 64 48H48 248V0zM440.8 64H48V176H440.8l49.8-56L440.8 64zM71.2 256L21.4 312l49.8 56H464V256H71.2z'
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fast',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M437.5 261.8l6-5.8-6-5.8-184-176-5.8-5.5L236.7 80.3l5.8 5.5L412.1 248 8 248l-8 0 0 16 8 0 404.1 0L242.5 426.2l-5.8 5.5 11.1 11.6 5.8-5.5 184-176z'
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fast',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      'M104 48c-39.8 0-72 32.2-72 72v40 8H16v-8V120c0-48.6 39.4-88 88-88s88 39.4 88 88v15.9c0 25.1-1.8 50.2-5.4 75l171.2-50.6 20.2-6-11.2 17.9L294.4 288H376h8v16h-8H280 265.6l7.6-12.2L342 181.6 183.7 228.4c-1.2 6.7-2.6 13.4-4.1 20.1l-4.8 21.8c-10.1 45.5-26.3 89.3-48 130.5L87.1 475.7 84.8 480H80 8 0v-8V272v-6l5.7-1.7 163.9-48.4c4.3-26.5 6.4-53.2 6.4-80V120c0-39.8-32.2-72-72-72zm62.4 185.5L16 278V464H75.2l37.4-70.7c21.1-39.9 36.8-82.4 46.6-126.5l4.8-21.8c.9-3.8 1.7-7.7 2.4-11.5zM208 368h8H376h8v16h-8H216h-8V368zM528 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H624 432 416V496 336 320h16 32V256zm-32 80V496H624V336H592 576 480 464 432z'
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fast',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      'M96 48V32h16H624h16V48v96 16c-26.5 0-48 21.5-48 48s21.5 48 48 48v16 96 16H624 112 96V368 272 256c26.5 0 48-21.5 48-48s-21.5-48-48-48V144 48zm16 98c27.6 7.1 48 32.2 48 62s-20.4 54.9-48 62v98H624V270c-27.6-7.1-48-32.2-48-62s20.4-54.9 48-62V48H112v98zM16 88v8V464H552h8v16h-8H8 0v-8V96 88H16zm208 40V288H512V128H224zm-16-16h16H512h16v16V288v16H512 224 208V288 128 112z'
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fast',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      'M144 300.8c0-49.1 23.3-119.3 61-173.9L264 48H376l58.6 78.9C472.5 181.6 496 251.8 496 300.8c0 64.2-40.2 120-98.6 146.6c16.5-18.5 26.6-43 26.6-70.1c0-23.6-8.5-53.1-20.7-80.4c-12.2-27.4-28.7-53.7-45.6-70.6l-2.3-2.3H352 288h-3.3l-2.3 2.3c-16.9 16.9-33.4 43.2-45.6 70.6c-12.2 27.3-20.7 56.8-20.7 80.4c0 27 10 51.7 26.7 70.3C183.6 421 144 364.8 144 300.8zM272 452c-24.2-15.8-40-43.3-40-74.6c0-20.4 7.5-47.5 19.3-73.9c11.2-25 25.7-48.3 40.1-63.4h57.2c14.4 15.2 28.9 38.5 40.1 63.4C400.5 329.8 408 357 408 377.3c0 31.4-16 58.7-40 74.5v22.5c56.6-13.6 103.4-50.8 127.2-100l139-38.6 5.9-1.6V328 136v-8h-8H456c-.5 0-.9 0-1.4 .1c-2.3-3.6-4.6-7.1-7-10.5L384 32H256l-64 85.6c-2.4 3.4-4.7 6.9-7 10.5c-.3 0-.7-.1-1-.1H8 0v8V328v6.1l5.9 1.6 138.8 38.6c23.5 49.2 70.1 86.6 127.3 100.2V452zM624 321.9L502.9 355.6c5.9-17.2 9.1-35.6 9.1-54.8c0-45.1-18.1-105-47.8-156.8H624V321.9zM16 144H175.4C145.9 195.8 128 255.7 128 300.8c0 19.1 3.2 37.5 9 54.7L16 321.9V144zM296 320h-8v8V504v8h16v-8V336h32V504v8h16v-8V328v-8h-8H296z'
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fast',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      'M240 16V240H16V16H240zM16 0H0V16 240v16H16 240h16V240 16 0H240 16zM624 272V496H400V272H624zM400 256H384v16V496v16h16H624h16V496 272 256H624 400zM160 288V400v16h16H352V400H176V288H160zM480 112V96H464 288v16H464V224h16V112zM176 80v96H80V80h96zM80 64H64V80v96 16H80h96 16V176 80 64H176 80zM464 336h96v96H464V336zm-16-16v16 96 16h16 96 16V432 336 320H560 464 448z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fast',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM232 248v-8H216v8V404.7l-74.3-74.3-5.7-5.7L124.7 336l5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7L312 324.7l-5.7 5.7L232 404.7V248z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fast',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zM477.7 141.7l5.7-5.7L472 124.7l-5.7 5.7L320 276.7l-90.3-90.3-5.7-5.7-5.7 5.7-128 128L84.7 320 96 331.3l5.7-5.7L224 203.3l90.3 90.3 5.7 5.7 5.7-5.7 152-152z'
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fast',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      'M144 4.2l11 4.4 80 32 5 2V48 272H224V53.4L160 27.8V272H144V16 4.2zM301.8 205.6l-19.7 28.1L317.7 66.2 272 75.4V59l54.4-10.9 11.9-2.4-2.5 11.9L305.6 200.2l-3.8 5.4zM348.6 192l19.5-97.6 1.6-7.8 15.7 3.1-1.6 7.8L365 192H348.6zM19 192L.2 97.6l-1.6-7.8 15.7-3.1 1.6 7.8L35.4 192H19zm63.2 13.6l-1-1.4L56.1 49.3l-.9-5.8 5.3-2.6L112 15.1V32.9L72.8 52.5l29.5 181.9L82.2 205.6zM64 224l48 80H272l48-80h47.6H384l-3.6 16L320 512H64L3.6 240 0 224H16.4 64zm221.7 88.2l-4.7 7.8H272 112h-9.1l-4.7-7.8L54.9 240h-35L76.8 496H307.2l56.9-256h-35l-43.3 72.2z'
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fast',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      'M48 48v64H72 88h24V48H48zm24 80H48 32V112 48 32H48h64 16V48 72H448V48 32h16 64 16V48v64 16H528 504V384h24 16v16 64 16H528 464 448V464 440H128v24 16H112 48 32V464 400 384H48 72l0-256zm16 0l0 256h24 16v16 24H448V400 384h16 24V128H464 448V112 88H128v24 16H112 88zm0 272H72 48v64h64V400H88zM528 112V48H464v64h24 16 24zM488 400H464v64h64V400H504 488zM136 136h8H304h8v8V272v8h-8H144h-8v-8V144v-8zm16 16V264H296V152H152zm208 80h72 8v8V368v8h-8H272h-8v-8V328v-8h16v8 32H424V248H360h-8V232h8z'
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fast',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      'M238.3 8.8L233.9 0H224 128h-9.9l-4.4 8.8-16 32-4.2 8.3 5.2 7.7L129 102.3C54.6 122.9 0 191.1 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c3.6 5.6 6.9 11.4 9.9 17.3C437.8 190.3 496 256.4 496 336c0 88.4-71.6 160-160 160c-47.2 0-89.5-20.4-118.8-52.8c0 0 0 0 0 0c-4-4.4-7.8-9.1-11.2-14c0 0 0 0 0 0C187.1 403 176 370.8 176 336c0-78.1 56-143.2 130.1-157.2C324.9 205 336 237.2 336 272c0 66.1-40.1 122.8-97.3 147.2c3.7 4.3 7.7 8.4 11.9 12.2C310.5 403.3 352 342.5 352 272c0-80.9-54.6-149.1-129-169.7l30.3-45.5 5.2-7.7-4.2-8.3-16-32zm56.5 156C217.5 183.4 160 253 160 336c0 35.2 10.3 68 28.2 95.5c-4 .3-8.1 .5-12.2 .5C87.6 432 16 360.4 16 272s71.6-160 160-160c47.2 0 89.5 20.4 118.8 52.8zM208 96H176 144L112 48l16-32h96l16 32L208 96z'
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fast',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      'M80 240H64c-26.5 0-48-21.5-48-48c0-54.9 37.2-90.6 86.7-113.5C152.2 55.7 209.8 48 240 48s87.8 7.7 137.3 30.5C426.8 101.4 464 137.1 464 192c0 26.5-21.5 48-48 48H400v16V464H320 80V256 240zm336 16H560V464H416V272 256zm152-16l-8 0-101.7 0c13.3-11.7 21.7-28.9 21.7-48c0-81.1-70.7-123.7-138.8-144H400c30.2 0 87.8 7.7 137.3 30.5C586.8 101.4 624 137.1 624 192c0 26.5-21.5 48-48 48l-8 0zM80 480H320h80 16H560h16V464 272 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v16V464v16H80z'
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fast',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 376H320h8v16h-8H192h-8V376h8zm-32-88c35.3 0 64-28.7 64-64c0-20.9-10-39.5-25.6-51.2c1 3.6 1.6 7.3 1.6 11.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-3.9 .6-7.6 1.6-11.2C106 184.5 96 203.1 96 224c0 35.3 28.7 64 64 64zM80 224a80 80 0 1 1 160 0A80 80 0 1 1 80 224zm56-40a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm280 40c0-20.9-10.1-39.5-25.6-51.2c1 3.6 1.6 7.3 1.6 11.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-3.9 .6-7.6 1.6-11.2C298 184.5 288 203.1 288 224c0 35.3 28.7 64 64 64s64-28.7 64-64zm-64 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0-144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fast',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      'M224 493.6L432 374.7V137.3L224 18.4 16 137.3V374.7L224 493.6zM0 128L224 0 448 128V384L224 512 0 384V128zm87.5 37.3L144 320.6V168v-8h16v8V344v8l-8 0-8 0-5.6 0-1.9-5.3L80 191.4V344v8H64v-8V168v-8l8 0 8 0 5.6 0 1.9 5.3zM200 160h64 8v16h-8H208v72h56 8v16h-8H208v80 8H192v-8V256 168v-8h8zm96 0h40 40 8v16h-8H344V344v8H328v-8V176H296h-8V160h8z'
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fast',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      'M224 32L174.3 7.2 160 0l-6.5 14.6-44 99.1c-9.4-2.7-17.9-5.6-25.6-8.6c-32.4-12.7-49.4-27.2-55-34.7L.8 85.1c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9l-28-14.7c-5.6 7.5-22.7 22-55 34.7c-7.7 3-16.2 5.9-25.6 8.6l-44-99L288 0 273.7 7.2 224 32zm0 96c-39.2 0-71.9-4.1-98.8-10.3l42.6-95.9 49 24.5 7.2 3.6 7.2-3.6 49-24.5 42.6 95.9C296 123.9 263.2 128 224 128zM23.1 496l36-96H388.9l36 96H23.1zM48 384L6 496 0 512H17.1 430.9 448l-6-16L400 384H48zM422.3 90.1l4.5 2.3c-10.8 21.9-31.9 47.8-61.6 69.5c-35.6 26-83.6 46-141.2 46s-105.6-20-141.2-46C53.1 140.3 32 114.4 21.2 92.5l4.5-2.3C36.4 99.5 53.6 110.4 78 120c34 13.3 82 24 146 24s112-10.7 146-24c24.4-9.6 41.6-20.5 52.3-29.9zM96 226c1.1 69.8 58 126 128 126s126.9-56.2 128-126c-5.3 2.6-10.8 5.2-16.4 7.5C330.8 290.9 282.6 336 224 336s-106.8-45.1-111.6-102.5c-5.6-2.4-11.1-4.9-16.4-7.5z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fast',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M331 75L267.3 11.3 256 0 244.7 11.3 181 75H91 75V91v90L11.3 244.7 0 256l11.3 11.3L75 331v90 16H91h90l63.7 63.7L256 512l11.3-11.3L331 437h90 16V421 331l63.7-63.7L512 256l-11.3-11.3L437 181V91 75H421 331zm90 16v90 6.6l4.7 4.7L489.4 256l-63.7 63.7-4.7 4.7V331v90H331h-6.6l-4.7 4.7L256 489.4l-63.7-63.7-4.7-4.7H181 91V331v-6.6l-4.7-4.7L22.6 256l63.7-63.7 4.7-4.7V181 91h90 6.6l4.7-4.7L256 22.6l63.7 63.7 4.7 4.7H331h90z'
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fast',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      'M258.8 2.8C239 2.8 223 19 212.5 36.1C201.7 53.6 194.8 75.4 194.8 92l0 78.8 0 9.3L6.9 283.8l-4.1 2.3v4.7 88 10.5l10.1-2.8 181.9-50.2 0 10.5 0 44L134 436.4l-3.2 2.4v4l0 56v10.4l10.1-2.7 117.9-31.5L368 504.2V487.6L260.9 459.1l-2.1-.6-2.1 .6L146.8 488.4l0-41.6 60.8-45.6 3.2-2.4v-4l0-48 0-21V315.3 184.9l0-14.1 0-78.8c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 78.8 0 14.1v4.7l0 125.7v10.5 21l0 48v4l3.2 2.4 26 19.5c-2.5-7.9-4.4-16-5.8-24.3l-7.5-5.6 0-44V336.3l7.7 2.1c.9-5.3 2-10.5 3.4-15.7l-11.1-3.1V198.4l66.1 36.5c4.4-3.8 9-7.4 13.7-10.7l-79.8-44 0-9.3 0-78.8c0-16.6-6.7-38.3-17.3-55.8C295 19 279 2.8 258.8 2.8zM18.8 295.5l176-97.1V319.7l-176 48.6 0-72.8zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fast',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm256-32l16 0 0-16 0-64 1.4 0 112 112-112 112-1.4 0 0-64 0-16-16 0-112 0 0-64 112 0zm140.7 20.7L280 128l-8 0-16 0 0 16 0 48 0 16-16 0-96 0-16 0 0 16 0 64 0 16 16 0 96 0 16 0 0 16 0 48 0 16 16 0 8 0L396.7 267.3 408 256l-11.3-11.3z'
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fast',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      'M16 336H432V310.3L224 87.4 16 310.3V336zM0 336V304L213.1 75.7 224 64l10.9 11.7L448 304v32 16H432 16 0V336zm8 96H440h8v16h-8H8 0V432H8z'
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fast',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M624 256a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zm16 0c0 106-86 192-192 192c-83.8 0-155.1-53.7-181.3-128.6L183.3 308l-1.7 1.7L139.3 352H232h8v8 64 8h-8H8 0v-8V360v-8H8 116.7l46.7-46.7-68.5-9.3L88 295v-7V224v-7l6.9-.9 68.5-9.3L116.7 160H8 0v-8V88 80H8 232h8v8 64 8h-8H139.3l42.3 42.3 1.7 1.7 83.4-11.4C292.9 117.7 364.2 64 448 64c106 0 192 86 192 192zM261.7 209.5L104 231v50l157.7 21.5C258 287.6 256 272 256 256s2-31.6 5.7-46.5zM16 144H224V96H16v48zm0 224v48H224V368H16zm432-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fast',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      'M96 416V16H313.4L432 134.6V416H96zM448 128L320 0H96 80V16 416v16H96 432h16V416 128zM48 80H16 0V96 496v16H16 352h16V496 464H352v32H16V96H48V80zm112 64h-8v8 64 64 64 8h8 64 80 64 8v-8V280 216 152v-8h-8H304 224 160zm8 64V160h48v48H168zm64 0V160h64v48H232zm80 0V160h48v48H312zm-8 16h56v48H304 224 168V224h56 80zm8 64h48v48H312V288zm-16 0v48H232V288h64zm-80 0v48H168V288h48z'
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fast',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM213.7 173.7l5.7-5.7L208 156.7l-5.7 5.7-72 72-5.7 5.7 5.7 5.7 72 72 5.7 5.7L219.3 312l-5.7-5.7L147.3 240l66.3-66.3zm96-11.3l-5.7-5.7L292.7 168l5.7 5.7L364.7 240l-66.3 66.3-5.7 5.7L304 323.3l5.7-5.7 72-72 5.7-5.7-5.7-5.7-72-72z'
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fast',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      'M224 32h-8v8V280v8h16v-8V48H344V280v8h16v-8V40 32h-8H224zM192 73.3C99.5 100.8 32 186.5 32 288v32H48V288c0-92.5 60.4-171 144-198V73.3zM384 90c82.9 26.8 143 104.1 144 195.6l0 34.4h16l0-32 0-2.4c-1.1-100.4-68.2-185-160-212.3V90zM16 400.2V368H560v32.2c-2.1 1.5-4.8 3.4-8.3 5.5c-9.9 6.2-25.5 14.8-47.6 23.4C460.1 446.3 390.1 464 288 464s-172.1-17.7-216.2-34.9c-22-8.6-37.6-17.2-47.6-23.4c-3.4-2.1-6.2-4-8.3-5.5zM576 408V368 352H560 16 0v16 40s80 72 288 72s288-72 288-72z'
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fast',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      'M14.7 496l11.8-28.2C60.1 382.6 64 281.9 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.5-.1 3.8-.1c35.1 0 63.4 25.9 81.9 59.9C596.8 94.5 608 141.2 608 192s-11.2 97.5-30.1 132.1c-18.6 34-46.8 59.9-81.9 59.9c-28.5 0-52.6-17.1-70.5-41.8c.9-8.7 1.7-17.4 2.4-26.1C445.3 348.1 469.4 368 496 368c53 0 96-78.8 96-176s-43-176-96-176c-5.4 0-10.7 .8-15.9 2.4C434.7 32.3 400 104.7 400 192c0 97.5-4.4 208.3-42.4 300.3L349.3 512H25.3 8l6.7-16zM160 16c-17.2 0-37 14.3-53.6 47.4C90.4 95.5 80 140.9 80 192c0 89.8-3.8 193.4-38.7 281.7l-.1 .3 0 0L32 496H338.7l4.1-9.9 0 0C379.4 397.5 384 289.9 384 192.5l0-.5c0-50.8 11.2-97.5 30.1-132.1c9.6-17.6 21.9-33.1 36.3-43.9H160zM516.6 255c-4.9 4.8-11.9 9-20.6 9s-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1zM496 248c13.3 0 24-25.1 24-56s-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56zM112 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fast',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      'M560 196.9L288 287.6 16 196.9V128v-2.7L288 216l272-90.7V128v68.9zm0 16.9v39.1l-48 16v16.9l48-16V404.5L288 495.1 16 404.5V269.8l48 16V268.9l-48-16V213.8l269.5 89.8 2.5 .8 2.5-.8L560 213.8zm0-106.2v.9L288 199.1 16 108.5v-.9L288 16.9l272 90.7zM576 128v-8V96L288 0 0 96v24 8V416l288 96 288-96V128zM96 279.6v16.9l96 32V311.6l-96-32zm189.5 80l2.5 .8 2.5-.8L352 339.1V322.2l-64 21.3-64-21.3v16.9l61.5 20.5zM384 328.4l96-32V279.6l-96 32v16.9z'
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fast',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM160 152v16h8H360h8V152h-8H168h-8zm0 96v16h8H360h8V248h-8H168h-8zm0 96v16h8H360h8V344h-8H168h-8zM96 144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 336a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fast',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M339.8 282c-17.5 34.2-40.9 70-64.7 102.6c-23.7 32.6-47.4 61.8-65.3 82.8c-7 8.2-13 15.2-17.8 20.6c-4.8-5.4-10.8-12.4-17.8-20.6c-17.8-21-41.6-50.2-65.3-82.8C85.2 351.9 61.7 316.2 44.2 282C26.6 247.3 16 216.1 16 192C16 94.8 94.8 16 192 16s176 78.8 176 176c0 24.1-10.6 55.3-28.2 90zM202.7 500C243.2 454.2 384 287.9 384 192C384 86 298 0 192 0S0 86 0 192c0 95.9 140.8 262.2 181.3 308c6.8 7.7 10.7 12 10.7 12s4-4.3 10.7-12z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fast',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      'M334.8 82.1l112 194 104.3-60.2-112-194L334.8 82.1zM565 207.8l8 13.9-13.9 8L454.8 289.9l-13.9 8-8-13.9-8.5-14.7-41.4 22.4c.6 4 .9 8.1 .9 12.2c0 25.3-11.7 47.8-30 62.4L417.6 512l-17.5 0L340.4 375.3c-10.9 5.6-23.3 8.7-36.4 8.7s-25.5-3.2-36.4-8.7L207.8 512l-17.5 0L254 366.4c-1.2-1-2.4-2-3.5-3L122.1 432.8l-16.3-28.2L63.8 428.9l-13.9 8-8-13.9L8 364.3 0 350.5l13.9-8 42.1-24.3L36.7 284.9 326.9 100.5l-6-10.4-8-13.9 13.9-8L431.1 8 445 0l8 13.9 112 194zM63.9 332L21.9 356.3 55.8 415l42.1-24.3L63.9 332zm271-217.7L58.2 290.1l70 121.2 111.2-60.1C229.7 338 224 321.7 224 304c0-44.2 35.8-80 80-80c34.3 0 63.5 21.5 74.9 51.8l37.5-20.3L334.9 114.3zM304 368a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fast',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      'M16 16H336V128h16V16 0H336 16 0V16 336v16H16 128V336H16V16zM160 384V496v16h16H496h16V496 176 160H496 384v16H496V496H176V384H160zm96-32h80 16V336 288H336v48H256v16zm96-176V160H336 288v16h48v80h16V176zM224 352V336H176V256H160v80 16h16 48zM160 224h16V176h80V160H176 160v16 48z'
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fast',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      'M204.7 0H224h14.6C305.4 0 359.5 53.8 360 120.4c36 4 64 34.5 64 71.6c0 11.9-2.9 23.1-8 32.9c36.3 5.8 64 37.2 64 75.1c0 22-9.3 41.7-24.2 55.6C488.4 365.7 512 396.1 512 432v72 8h-8H8 0v-8V432c0-35.9 23.6-66.3 56.2-76.4C41.3 341.7 32 322 32 300c0-37.9 27.7-69.3 64-75.1c-5.1-9.9-8-21.1-8-32.9c0-39.8 32.2-72 72-72h23.2 11.5c25 0 45.3-20.3 45.3-45.3V58.5c0-14.9-5.9-29.1-16.4-39.6l-5.3-5.3L204.7 0zm37.5 16.1C251.1 28.3 256 43.2 256 58.5V74.7c0 33.9-27.5 61.3-61.3 61.3H183.2 160c-30.9 0-56 25.1-56 56c0 13.3 4.6 25.4 12.3 35l10.4 13H110h-2c-33.1 0-60 26.9-60 60c0 23 12.9 42.9 31.9 53l25.5 13.5-28.8 1.5C42.8 369.9 16 397.8 16 432v64H496V432c0-34.2-26.8-62.1-60.6-63.9l-28.8-1.5L432.1 353c19-10.1 31.9-30.1 31.9-53c0-33.1-26.9-60-60-60h-2H385.3l10.4-13c7.7-9.6 12.3-21.7 12.3-35c0-30.9-25.1-56-56-56h-.4-9l1-8.9c.2-1.9 .3-3.8 .3-5.7c0-57-45.3-103.5-101.8-105.3z'
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fast',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      'M104 0H96V8 64H32 15.4L25.8 77l28 35-28 35L15.4 160H32 96v96H56 48v8 96c0 83.9 68.1 152 152 152h80c83.9 0 152-68.1 152-152v-8-8V280 208v-8h-8H352v-8-8h-8H272V160v-8h-8H192v-8h0V80h0V64h0V8 0h-8H104zm72 64H112V16h64V64zM96 80v64H48.6l21.6-27 4-5-4-5L48.6 80H96zm16 64V80h64v64H112zm0 16h64v96H112V160zm80 8h64l0 16v8 64H192V168zm64 104l0 0 0 64H152h-8v16h8H256h8 8 64 8 8 64v8c0 75.1-60.9 136-136 136H200c-75.1 0-136-60.9-136-136V272H96v0h16v0h64v0h16v0h64zm16 0v-8-8V200h64v8V336H272V272zm144 8v56H352V216h64v64z'
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fast',
    iconName: 'alien-8bit',
    icon: [
      576,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      'M112 32h-8v8 64 8h8 56v48H80V128v-8H72 8 0v8V312v8H8 64v56 8h8 56v88 8h8H248h8v-8V424v-8h-8H200V384H376v32H328h-8v8 48 8h8H440h8v-8V384h56 8v-8V320h56 8v-8V128v-8h-8H504h-8v8 32H408V112h56 8v-8V40 32h-8H400h-8v8V96H344h-8v8 56H240V104 96h-8H184V40 32h-8H112zM496 176v64 8h16v-8V136h48V304H504h-8v8 56H448 432 392 376 200 184 144 128 80V312v-8H72 16V136H64V240v8H80v-8V176h96 8v-8V112h40v56 8h8H344h8v-8V112h40v56 8h8 96zM168 48V96H120V48h48zM456 96H408V48h48V96zM144 464V384h40v40 8h8 48v32H144zm248-40V384h40v80H336V432h48 8v-8zM208 232v-8H192v8 80 8h16v-8V232zm176 0v-8H368v8 80 8h16v-8V232z'
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fast',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      'M256 496a240 240 0 1 1 0-480 240 240 0 1 1 0 480zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm88 352h8v-8V200v-8H336v8V324.7L173.7 162.3l-5.7-5.7L156.7 168l5.7 5.7L324.7 336H200h-8v16h8H344z'
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fast',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      'M496 256c0-19.3-2.3-38-6.6-56H431.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88c-7.2 0-14.2-.9-20.9-2.5l2.6 4.4 29.9 14.9 4.4 2.2V320v32 4.9l-4.4 2.2-23.1 11.6L358.2 403l5 6.2-12.5 10-5-6.2-28-35-19.6 9.8L311.4 421l3 7.4-14.9 5.9-3-7.4L283.8 395 264 404.9V432v8H248v-8V404.9L228.2 395 215.4 427l-3 7.4-14.9-5.9 3-7.4 13.3-33.2L194.2 378l-28 35-5 6.2-12.5-10 5-6.2 25.8-32.3-23.1-11.6-4.4-2.2V352 320v-4.9l4.4-2.2 29.9-14.9 2.6-4.4c-6.7 1.6-13.7 2.5-20.9 2.5c-48.6 0-88-39.4-88-88c0-2.7 .1-5.4 .4-8H22.6c-4.3 18-6.6 36.7-6.6 56c0 132.5 107.5 240 240 240s240-107.5 240-240zM240 205.9c-1.1-38.8-32.9-69.9-72-69.9c-39.8 0-72 32.2-72 72s32.2 72 72 72c10.5 0 20.4-2.2 29.3-6.2c1.1-.5 2.3-.7 3.4-.7L240 205.9zm-31.9-76.2c26.2 13.4 44.8 39.6 47.5 70.3h.7c2.8-30.7 21.3-56.9 47.5-70.3l-7-14.1-3.6-7.2 14.3-7.2 3.6 7.2 7.6 15.2c8-2.4 16.5-3.7 25.2-3.7V96 88h16v8 25.5c9.2 1.7 17.8 4.8 25.8 9.1l7.1-14.1 3.6-7.2 14.3 7.2-3.6 7.2-7.9 15.9c14 11.3 24.5 26.8 29.5 44.5H485C454.4 86.6 363.5 16 256 16S57.6 86.6 27 184H83.3c5-17.8 15.5-33.2 29.5-44.5l-7.9-15.9-3.6-7.2 14.3-7.2 3.6 7.2 7.1 14.1c7.9-4.3 16.6-7.4 25.8-9.1V96 88h16v8 24c8.8 0 17.2 1.3 25.2 3.7l7.6-15.2 3.6-7.2 14.3 7.2-3.6 7.2-7 14.1zM344 136c-39.1 0-70.9 31.1-72 69.9l39.2 67.2c1.2 0 2.3 .2 3.4 .7c8.9 4 18.9 6.2 29.3 6.2c39.8 0 72-32.2 72-72s-32.2-72-72-72zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm252.6-40l-53.7 92-1.2 2.1-2.1 1.1L168 324.9v22.1l88 44 88-44V324.9l-27.6-13.8-2.1-1.1-1.2-2.1-53.7-92h-6.8zM160 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fast',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      'M16 16V80H80V16H16zM0 0H16 80 96V16 40H352V16 0h16 64 16V16 80 96H432 408V256h24 16v16 64 16H432 368 352V336 312H96v24 16H80 16 0V336 272 256H16 40V96H16 0V80 16 0zM392 96H368 352V80 56H96V80 96H80 56V256H80 96v16 24H352V272 256h16 24V96zM80 272H16v64H80V272zM368 16V80h64V16H368zm64 256H368v64h64V272zm128-96v64h64V176H560zm-16-16h16 64 16v16 64 16H624 600V416h24 16v16 64 16H624 560 544V496 472H288v24 16H272 208 192V496 432 416h16 24V344h16v72h24 16v16 24H544V432 416h16 24V256H560 544V240 216H472V200h72V176 160zM272 432H208v64h64V432zm352 0H560v64h64V432z'
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fast',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM150.9 179.7c-7.4 11.4-12.7 26.3-15.2 39.8L120 216.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L216 219.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8L280 216.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L376 219.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fast',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      'M16 16V496H144V384 368h16 64 16v16V496H368V16H16zM160 496h64V384H160V496zm-16 16H16 0V496 16 0H16 368h16V16 496v16H368 240 224 160 144zM80 232h64 8v8 64 8h-8H80 72v-8V240v-8h8zm8 64h48V248H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V240v-8zm16 16v48h48V248H248zM80 104h64 8v8 64 8h-8H80 72v-8V112v-8h8zm8 64h48V120H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V112v-8zm16 16v48h48V120H248zM432 0V8 32H624h16V48 192v16H624 432V504v8H416v-8V208 192 48 32 8 0h16zm0 192H624V48H432V192z'
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fast',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 256c0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.3-10.5 54.2-27.9 73.9L273.9 256H252.4l76.4 85.2c-19.6 16.7-45 26.8-72.7 26.8c-61.9 0-112-50.1-112-112zm240 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c31.9 0 61-11.6 83.4-30.9L367.1 384h21.5l-37.7-42.1C371.5 319.2 384 289.1 384 256z'
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fast',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      'M264 32l77.8 64.1C497.9 99.9 576 256 576 256s-78.1 156.1-234.2 159.9L264 480l-40-24 7.6-64.7c-30.8-15.3-56.4-35.9-76.8-56.5L32 384 0 352l48-96L0 160l32-32 118.7 53.4c21-21.9 47.9-44.3 80.9-60.7L224 56l40-24zM548 240.4c-9.3-14.1-23.3-32.8-42-51.7c-37.4-37.8-92.2-74.9-164.7-76.6l-5.5-.1-4.3-3.5L262.5 51.5 241.1 64.4l6.4 54.4 1.3 11.2-10.1 5c-30.9 15.4-56.4 36.5-76.5 57.5l-7.8 8.2L144.1 196 35.5 147.1l-16 16 42.8 85.7 3.6 7.2-3.6 7.2L19.5 348.8l16.4 16.4L148.9 320l9.8-3.9 7.5 7.5c19.4 19.6 43.6 39 72.5 53.4l10.1 5-1.3 11.2-6.4 54.4 21.4 12.9 69.1-56.9 4.3-3.5 5.5-.1c72.5-1.8 127.3-38.8 164.7-76.6c18.6-18.9 32.6-37.6 42-51.7c4.2-6.3 7.4-11.7 9.7-15.6c-2.3-3.9-5.5-9.3-9.7-15.6zm13.7 22.8s0 0 0 0l0 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fast',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM72 64H64V80h8 80 8V64h-8H72zm0 64H64v16h8 80 8V128h-8H72zm48 168h-6.1l-1.6 5.9L89.9 384H64 56v16h8H96h6.1l1.6-5.9L126.1 312h3.8l22.4 82.1 1.6 5.9H160h8 4.6l2.3-4 29.7-52h14.7l29.7 52 2.3 4H256h64 8V384h-8H260.6l-29.7-52-2.3-4H224 200h-4.6l-2.3 4-27.8 48.7-21.5-78.8-1.6-5.9H136 120z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fast',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm46.9 224H251.7L192 313.6 132.3 224H113.1l69.3 104L113.1 432h19.2L192 342.4 251.7 432h19.2L201.6 328l69.3-104z'
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fast',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      'M16 496H144v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM216 376c0 8.9 2.6 17.5 7.5 24.9L240 425.6l16.5-24.7c4.9-7.4 7.5-16 7.5-24.9v-8h16v8c0 12-3.6 23.8-10.2 33.8L249.6 440l20.2 30.2c6.7 10 10.2 21.7 10.2 33.8v8H264v-8c0-8.9-2.6-17.5-7.5-24.9L240 454.4l-16.5 24.7c-4.9 7.4-7.5 16-7.5 24.9v8H200v-8c0-12 3.6-23.8 10.2-33.8L230.4 440l-20.2-30.2C203.6 399.8 200 388 200 376v-8h16v8zM328 512v-8V376v-8h16v8V496h32 8v16h-8H336h-8zm88-106.3c0-20.8 16.9-37.7 37.7-37.7H480h8v16h-8H453.7c-12 0-21.7 9.7-21.7 21.7c0 8.2 4.6 15.7 12 19.4l31.2 15.6c12.8 6.4 20.8 19.4 20.8 33.7c0 20.8-16.9 37.7-37.7 37.7H432h-8V496h8 26.3c12 0 21.7-9.7 21.7-21.7c0-8.2-4.6-15.7-12-19.4l-31.2-15.6C424.1 433 416 419.9 416 405.7z'
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fast',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      'M405 16l-62.9 91.2L333 120.4c4.1 2.6 8.6 5.6 13.3 8.8C406.9 170.8 512 262.9 512 416v80 16H496 16 0V496 416C0 262.9 105.1 170.8 165.7 129.2c4.7-3.3 9.2-6.2 13.3-8.8l-9.1-13.2L107 16 96 0h19.4H396.6 416L405 16zm91 400c0-156.4-115.8-246.4-171.6-282.1l-9.2-5.9H196.8l-9.2 5.9C131.8 169.6 16 259.6 16 416v80H496V416zM319.3 112l.5-.7L385.5 16H126.5l65.7 95.3 .5 .7H319.3zM197.7 250.3L256 308.7l58.3-58.3 5.7-5.7L331.3 256l-5.7 5.7L267.3 320l58.3 58.3 5.7 5.7L320 395.3l-5.7-5.7L256 331.3l-58.3 58.3-5.7 5.7L180.7 384l5.7-5.7L244.7 320l-58.3-58.3-5.7-5.7L192 244.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fast',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256v4.3l-3.6 2.4-96 64-6.7 4.4-8.9-13.3 6.7-4.4L248 251.7V104 96h16v8z'
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fast',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      'M227.2 144L252.8 16 256 0H239.7 32L1.8 272 0 288H16.1 159.6 176l-3.4 16L135.1 478.7 128 512l21.9-26.1L384 208V176 160H368 240.3 224l3.2-16zM368 176v26.2L157.1 452.6l34.6-161.3 4.1-19.4H176 17.9L46.3 16H236.5L208.3 156.9 204.5 176H224 368z'
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fast',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      'M528 224c0-114.9-93.1-208-208-208V224H528zM304 .6c5.3-.4 10.6-.6 16-.6C443.7 0 544 100.3 544 224c0 5.4-.2 10.7-.6 16H320 304V224 .6zM240 294.6V288 50.3C131.5 65.8 48 159.2 48 272c0 123.7 100.3 224 224 224c47.9 0 92.3-15 128.7-40.7l-156-156-4.7-4.7zm173.6 151L425 457c-4.1 3.4-8.4 6.7-12.8 9.9C372.8 495.3 324.3 512 272 512C139.5 512 32 404.6 32 272C32 150.3 122.6 49.8 240 34.1c5.3-.7 10.6-1.2 16-1.6v16V288L413.6 445.6zM320 288h22.6H559.4h16c-.4 5.4-.9 10.7-1.6 16c-8.2 61.3-39.5 115.4-84.9 153L336 304l-16-16zm38.6 16l131 131c36-34 60.8-79.7 68.1-131H358.6z'
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fast',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM95.9 128h5H219.1h5l2.2 4.5 63.5 131.7c-3.7 5-7.1 10.2-10.2 15.6L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H440v64 8H424v-8V376H360h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fast',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      'M168 0h-8V8 64H112h-6l-1.7 5.7L58 224H16 0v16V416v16 64 16H16 80 96V496 432H416v64 16h16 64 16V496 432 416 240 224H496 454L407.7 69.7 406 64h-6H352V8 0h-8H168zM496 416H432 416 96 80 16V240H496V416zm-64 16h64v64H432V432zM16 432H80v64H16V432zM336 64H176V16H336V64zM160 80h16H336h16 42l43.2 144H74.8L118 80h42zM96 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm304-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fast',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      'M21.2 464H280V408v-8h16v8 56H554.8L435.9 48H296v56 8H280v-8V48H140.1L21.2 464zM128 32H448L571.4 464l4.6 16H559.4 16.6 0l4.6-16L128 32zM296 200V312v8H280v-8V200v-8h16v8z'
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fast',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      'M16 8V0H0V8 200 439.7 504v8H16v-8V447.7H216 560V504v8h16v-8V439.7 280 200 136c0-57.4-46.6-104-104-104H216h-8v8V192H16V8zM208 280V431.7H16V208H216 560v64H216h-8v8zM560 136v56H224V48H472c48.6 0 88 39.4 88 88zM224 288H560V431.7H224V288zM112 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fast',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      'M97.1 252.5C106.8 164.5 181.4 96 272 96v0h16 88c42.3 0 79.1-23.4 98.2-58.1c3.6-6.5 6.5-13.3 8.8-20.5c3.1 7 6 14.2 8.7 21.5c13.1 36 20.4 75.8 20.4 117.6C512 317.1 405.1 447.3 273 448l-1 0c-97.1 0-175.9-78.7-176-175.8C47.7 305.3 16 361 16 424v48 8H0v-8V424c0-72.8 38.9-136.5 97.1-171.5zm15.2 9.7c-.2 3.2-.3 6.5-.3 9.8c0 88.4 71.6 160 160 160h0l.9 0C393.5 431.4 496 311.3 496 156.6c0-35.1-5.3-68.5-15-99.3C457.8 90.3 419.5 112 376 112H288v0H272c-78.5 0-143.8 56.5-157.4 131.1C140.5 230.8 169.5 224 200 224H312h8v16h-8H200c-31.8 0-61.6 8-87.7 22.2z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fast',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M8 32H0v8V248 472v8H16v-8V256H248h8V240h-8H16V48H312h8V32h-8H8z'
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fast',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM328 192v8 80h80 8v16h-8H328v80 8H312v-8V296H232h-8V280h8 80V200v-8h16z'
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fast',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      'M210.6 32H216h15 5.4l2 4.9L322.2 240H440h8v16h-8H328.9l33 80H440h8v16h-8H368.5l52.9 128H404L351.2 352H96.5L43.9 480H26.6L79.2 352H8 0V336H8 85.8l32.9-80H8 0V240H8 125.2L208.6 37l2-5zm15 16h-4.3L142.5 240H304.9L225.6 48zM103.1 336H344.6l-33-80H135.9l-32.9 80z'
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fast',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      'M283.9 237.2c2.2-86.1-67.2-157-153.3-156.8l-98.2 .2v8.2l22.4 20.2 5.9 5.3-5.3 5.9-23 26L32 261.4l43 19.2 88.3-63.1 6.5-4.6 9.3 13-6.5 4.6L64 308.1l-.3 76h-16L48 304l0-4.1 3.3-2.4 8.6-6.1L20.7 273.9 16 271.8l0-5.2 .4-123.4 0-3 2-2.3 19.8-22.3L19 98.4 16.4 96V92.4 72.7v-8l8 0 106.1-.3c95.2-.2 171.7 78.1 169.4 173.2c-.3 12.9-2.1 25.8-5.4 38.3L266.3 384.1H249.8L279 272c3-11.3 4.6-23 4.9-34.7zM84 160a12 12 0 1 1 0 24 12 12 0 1 1 0-24zM48 416H272h3.7l2.4 2.9 40 48 1.9 2.2V472v32 8h-8H8 0v-8V472v-2.9l1.9-2.2 40-48 2.4-2.9H48zM16 474.9V496H304V474.9L268.3 432H51.7L16 474.9z'
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fast',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      'M288 64C179.6 64 87.3 133.6 53.7 230.6L51.8 236H46.1 44.8h-28v56h28H56h6.6l5.9-3 49.5-24.8 3.2-1.6 3.3 1.3 65 26 9.9 4 10-3.7 75.7-27.5 2.7-1 2.7 1 75.7 27.5 10 3.7 9.9-4 65-26 3.3-1.3 3.2 1.6L507.5 289l5.9 3H520h11.2 28V236h-28-1.3-5.7l-1.9-5.4C488.7 133.6 396.5 64 288 64zM40.5 220C77.8 119.6 174.5 48 288 48s210.2 71.6 247.5 172h31.7 8v8 72 8h-8-36H520h-8.5-1.9l-1.7-.8-7.6-3.8L454 280.2l-61.7 24.7L379.6 310l-2.8 1.1-2.9-1L361 305.4l-73-26.5-73 26.5L202.1 310l-2.9 1-2.8-1.1-12.8-5.1L122 280.2 75.7 303.4l-7.6 3.8-1.7 .8H64.5 56 44.8 8.8 .8v-8V228v-8h8H40.5zm18 115.4c5.6-.5 11-1.2 16.2-2.1L107.5 432H468.5l32.9-98.7c5.2 .9 10.6 1.7 16.2 2.1L480 448H96L58.5 335.4zM199.2 139.6l-24 48-3.6 7.2-14.3-7.2 3.6-7.2 24-48 3.6-7.2 14.3 7.2-3.6 7.2zm192-7.2l24 48 3.6 7.2-14.3 7.2-3.6-7.2-24-48-3.6-7.2 14.3-7.2 3.6 7.2zM296 136v48 8H280v-8V136v-8h16v8z'
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fast',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16l0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32l16 0 416 0 16 0zM144 240l0 32-32 0 0-32 32 0zm64 0l32 0 0 32-32 0 0-32zm128 0l0 32-32 0 0-32 32 0z'
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fast',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      'M216 8h-8V24h8 32V72.2c-44.8 1.9-85.4 19.8-116.3 48.2L97.6 86.3l0 0 22.6-22.6 5.7-5.7L114.6 46.7l-5.7 5.7L52.4 108.9l-5.7 5.7L58 125.9l5.7-5.7L86.3 97.6l0 0 34.1 34.1C92 162.6 74.1 203.2 72.2 248H24l0-32v-8H8v8 80 8H24l0-8 0-32H72.2c1.9 44.8 19.8 85.4 48.2 116.3L86.3 414.4l0 0L63.7 391.8 58 386.1 46.7 397.4l5.7 5.7 56.6 56.6 5.7 5.7L125.9 454l-5.7-5.7L97.6 425.7l0 0 34.1-34.1c30.9 28.4 71.5 46.3 116.3 48.2V488H216h-8v16h8 80 8V488h-8H264V439.8c44.8-1.9 85.4-19.8 116.3-48.2l34.1 34.1 0 0-22.6 22.6-5.7 5.7 11.3 11.3 5.7-5.7 56.6-56.6 5.7-5.7L454 386.1l-5.7 5.7-22.6 22.6 0 0-34.1-34.1c28.4-30.9 46.3-71.5 48.2-116.3H488v32 8h16v-8V216v-8H488v8 32H439.8c-1.9-44.8-19.8-85.4-48.2-116.3l34.1-34.1 0 0 22.6 22.6 5.7 5.7 11.3-11.3-5.7-5.7L403.1 52.4l-5.7-5.7L386.1 58l5.7 5.7 22.6 22.6 0 0-34.1 34.1C349.4 92 308.8 74.1 264 72.2V24l32 0h8V8h-8H216zm40 80a168 168 0 1 1 0 336 168 168 0 1 1 0-336zM192 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fast',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      'M340 376h92v88H16V376h92 17.3H322.7 340zm-6.5-16L304 288H144l-29.5 72H16V48H432V360H333.5zm-201.6 0l22.9-56H293.3l22.9 56H131.8zM448 368v-8V48 32H432 16 0V48 360v8 8 88 16H16 432h16V464 376v-8zM176 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fast',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      'M83.1 272L19.9 32H36.5L99.6 272h90.4L244.2 38.2l1.4-6.2H252h8 6.4l1.4 6.2L321.9 272h90.4L475.5 32h16.5L428.9 272H504h8v16h-8H424.7l-49 186-1.6 6H368h-8-6.4l-1.4-6.2L309.2 288H202.8l-43 185.8-1.4 6.2H152h-8-6.2l-1.6-6-49-186H8 0V272H8 83.1zm20.8 16l43.9 166.8L186.4 288H103.9zm102.7-16h99L256 58.2 206.5 272zm119.1 16l38.6 166.8L408.1 288H325.6z'
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fast',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      'M560 48V368H458L416 256H256L214 368H112V48H560zM464 384h96 16V368 48 32H560 112 96V48 368v16h16 96 17.1H446.9 464zm-23.1-16H231.1l36-96H404.9l36 96zM64 128H16 0v16V464v16H16 464h16V464 416H464v48H16V144H64V128zm224 32a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fast',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      'M304 48H208v96h96V48zM208 32h96 16V48v96 16H304 208 192V144 48 32h16zM76.8 228.8l48 83.1L208 264l-48-83.1-83.1 48zM55 223l13.9-8L152 167l13.9-8 8 13.9 48 83.1 8 13.9-13.9 8-83.1 48-13.9 8L111 320 63 236.8 55 223zm313-15H272v96h96V208zM256 192h16 96 16v16 96 16H368 272 256V304 208 192zm80 272h96V368H336v96zM320 352h16 96 16v16 96 16H432 336 320V464 368 352zm-48 16H176v96h96V368zm-96-16h96 16v16 96 16H272 176 160V464 368 352h16zM16 368v96h96V368H16zM0 352H16h96 16v16 96 16H112 16 0V464 368 352z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fast',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M328 16h-8V32h8H468.7L202.3 298.3l-5.7 5.7L208 315.3l5.7-5.7L480 43.3V184v8h16v-8V24 16h-8H328zM8 32H0v8V504v8H8 472h8v-8V312v-8H464v8V496H16V48H200h8V32h-8H8z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fast',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM96 192H80v16 16l0 64v16 16H96h32 16V304 288 224 208 192H128 96zm96-96H176v16 16V288v16 16h16 32 16V304 288 128 112 96H224 192zm96 64H272v16 16 96 16 16h16 32 16V304 288 192 176 160H320 288zM112 208h16v16 64 16H112 96V288 224 208h16zm80 80V128 112h16 16v16V288v16H208 192V288zM320 176v16 96 16H304 288V288 192 176h16 16z'
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fast',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      'M256 16V56v8h-8H136h-8V56 16H48V496H336V16H256zm-16 0H144V48h96V16zM32 0H48 336h16V16 496v16H336 48 32V496 16 0z'
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fast',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      'M224.8 87.1C229.3 37.7 271.4 0 320.9 0c52 0 95.1 42.1 95.1 94.3c0 38.8-18.6 75.3-49.9 98.1L334 215.7 636.4 417.3l3.6 2.4V424v80 8h-8H8 0v-8V424v-4.3l3.6-2.4L315.4 209.4l41.2-30C383.9 159.6 400 128 400 94.3C400 51.2 364.3 16 320.9 16c-41.4 0-76.5 31.6-80.2 72.6l-.7 8.1-.7 8-15.9-1.4 .7-8 .7-8.1zM320 225.6L16 428.3V496H624V428.3L320 225.6z'
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fast',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      'M16 16H368V247.2c5-5.3 10.4-10.3 16-15V16 0H368 16 0V16 496v16H16 144h16 64 16H368h16v-8.2c-5.6-4.7-11-9.7-16-15V496H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fast',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      'M328 8V0H312V8 56H264h-8V72h8 48v48 8h16v-8V72h48 8V56h-8H328V8zM242.2 134.6c-9.7-2.6-19.7-4.5-29.9-5.6c-6.7-.7-13.5-1.1-20.3-1.1C86 128 0 214 0 320S86 512 192 512c50.5 0 96.5-19.5 130.8-51.4c7.4-6.9 14.3-14.4 20.5-22.4c-9 3.3-18.4 5.9-28.1 7.5c-8.8 1.5-17.9 2.3-27.2 2.3c-88.4 0-160-71.6-160-160c0-62.1 35.4-116 87.2-142.5c8.6-4.4 17.7-8.1 27.1-10.9zm-55.6 9.4C141.5 175.9 112 228.5 112 288c0 97.2 78.8 176 176 176c1.8 0 3.6 0 5.3-.1C264.7 484.1 229.7 496 192 496C94.8 496 16 417.2 16 320c0-95.4 75.9-173.1 170.7-175.9zM424 128H408v8 80H328h-8v16h8 80v80 8h16v-8V232h80 8V216h-8H424V136v-8z'
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fast',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      'M52.7 288H459.3L434.1 464H77.9L52.7 288zm-2.3-16L18.4 48H493.6l-32 224H50.4zM64 480H448L509.7 48 512 32H495.8 16.2 0L2.3 48 64 480z'
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fast',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M394.9 5.9l-2.5 7.6-160 480-2.5 7.6 15.2 5.1 2.5-7.6 160-480 2.5-7.6L394.9 5.9zm89.8 130.5l5.8 5.5L612.3 256 490.5 370.2l-5.8 5.5 10.9 11.7 5.8-5.5 128-120 6.2-5.8-6.2-5.8-128-120-5.8-5.5-10.9 11.7zM144.4 124.7l-5.8 5.5-128 120L4.3 256l6.2 5.8 128 120 5.8 5.5 10.9-11.7-5.8-5.5L27.7 256 149.5 141.8l5.8-5.5-10.9-11.7z'
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fast',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM200 208H184v8V360v8h16v-8V216v-8zM176 400v32h32V400H176z'
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fast',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      'M297.1 17.1L374.6 164l163.6 28.3 19.1 3.3-13.5 13.9L428 328.5l23.6 164.3 2.8 19.2L437 503.4l-149-73.2-149 73.2L121.7 512l2.8-19.2 23.6-164.3L32.4 209.5 18.9 195.6 38 192.3 201.5 164 279 17.1l9-17.1 9 17.1zm74.7 162.6l-7.8-1.3-3.7-7L296 49.3V416.3l138.3 68L412.2 330.8l-1.1-7.8 5.5-5.6L524.6 206.2 371.8 179.7zM280 49.6L215.7 171.4l-3.7 7-7.8 1.3L51.5 206.2 159.6 317.4 165 323l-1.1 7.8L141.9 484.3 280 416.3V49.6z'
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fast',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      'M16 80V432H560V80H16zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM256 240v16H96V240H256zM96 336H480v16H96V336zM336 176v80H464V176H336zm-16-16h16H464h16v16 80 16H464 336 320V256 176 160z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fast',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M173.9 15.7C187 5.8 204.8 0 224 0s37 5.8 50.1 15.7S296 39.7 296 56c0 20.3-13.5 37-32 46.6V128H376h8v8V248h25.4c9.6-18.5 26.4-32 46.6-32c16.3 0 30.5 8.8 40.3 21.9S512 268.8 512 288s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-20.3 0-37-13.5-46.6-32H384V504v8h-8H256h-8v-8V465.6v-5.2l4.8-2.1c17.3-7.5 27.2-20.7 27.2-34.2c0-10.2-5.5-20-15.5-27.5S240.1 384 224 384s-30.4 4.9-40.5 12.5S168 413.8 168 424c0 13.6 9.9 26.7 27.2 34.2l4.8 2.1v5.2V504v8h-8H8 0v-8V320v-8H8 46.4h5.2l2.1 4.8C61.3 334.1 74.4 344 88 344c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S98.2 232 88 232c-13.6 0-26.7 9.9-34.2 27.2L51.7 264H46.4 8 0v-8V136v-8H8 184V102.6C165.5 93 152 76.3 152 56c0-16.3 8.8-30.5 21.9-40.3zm9.6 12.8C173.5 36 168 45.8 168 56c0 13.6 9.9 26.7 27.2 34.2l4.8 2.1v5.2V136v8h-8H16V248H41.4C51 229.5 67.7 216 88 216c16.3 0 30.5 8.8 40.3 21.9S144 268.8 144 288s-5.8 37-15.7 50.1s-24 21.9-40.3 21.9c-20.3 0-37-13.5-46.6-32H16V496H184V470.6c-18.5-9.6-32-26.4-32-46.6c0-16.3 8.8-30.5 21.9-40.3S204.8 368 224 368s37 5.8 50.1 15.7s21.9 24 21.9 40.3c0 20.3-13.5 37-32 46.6V496H368V320v-8h8 38.4 5.2l2.1 4.8c7.5 17.3 20.7 27.2 34.2 27.2c10.2 0 20-5.5 27.5-15.5s12.5-24.3 12.5-40.5s-4.9-30.4-12.5-40.5S466.2 232 456 232c-13.6 0-26.7 9.9-34.2 27.2l-2.1 4.8h-5.2H376h-8v-8V144H256h-8v-8V97.6 92.3l4.8-2.1C270.1 82.7 280 69.6 280 56c0-10.2-5.5-20-15.5-27.5S240.1 16 224 16s-30.4 4.9-40.5 12.5z'
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fast',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      'M397.8 32H380.9l21.3 64H173.8l21.3-64H178.2L156.9 96H112h-8v16h8 39.6L114.2 224H72 64v16h8 36.9L71.6 352H32 24v16h8H66.2L28.9 480H45.8L83.1 368H492.9l37.3 112h16.9L509.8 368H544h8V352h-8H504.4L467.1 240H504h8V224h-8H461.8L424.4 112H464h8V96h-8H419.1L397.8 32zm9.8 80l37.3 112H131.1l37.3-112H407.6zm42.7 128l37.3 112H88.4l37.3-112H450.2z'
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fast',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      'M336 192H320V176 48 32h16H464h16V48 176v16H464 336zm128-16V48H336V176H464zM160 36.7l5.7 5.7 104 104 5.7 5.7L264 163.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L61.7 157.7 56 163.3 44.7 152l5.7-5.7 104-104 5.7-5.7zM320 480V464 272 256h16H528h16v16V464v16H528 336 320zM528 272H336V464H528V272z'
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fast',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      'M275.5 49.9L288 65.5l12.5-15.6 9.3-11.6c11.3-14.1 28.5-22.4 46.6-22.4c32.9 0 59.6 26.7 59.6 59.6v3.6c0 16.8-6.7 32.8-18.5 44.7l-24.8 24.8L288 233.3l-84.7-84.7-24.8-24.8C166.7 111.9 160 95.9 160 79.1V75.6c0-32.9 26.7-59.6 59.6-59.6c18.1 0 35.3 8.2 46.6 22.4l9.3 11.6zm12.5 206l11.3-11.3L384 159.9l24.8-24.8c14.9-14.9 23.2-35 23.2-56V75.6C432 33.8 398.1-.1 356.4-.1c-22.5 0-43.7 10-58.1 27.2c-.3 .4-.6 .8-1 1.2L288 39.9l-9.3-11.6c-.3-.4-.6-.8-1-1.2C263.4 9.9 242.1-.1 219.6-.1C177.9-.1 144 33.8 144 75.6v3.6c0 21 8.3 41.1 23.2 56L192 159.9l84.7 84.7L288 255.9zM151.6 320h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fast',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      'M288 5.5l5.2 4.5L384 87.7V40 32h8H504h8v8V197.5l61.2 52.5-10.4 12.1L512 218.5V504v8h-8H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zM496 183.7V48H400v53.5l96 82.3zM288 26.5L80 204.8V496H496V204.8L288 26.5zM336 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-4.5 112l-21.3 64H377.8l-21.3-64H219.5zM368 320l26.7 80 5.3 16H383.1 192.9 176l5.3-16L208 320H368z'
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fast',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      'M16 16V496H432V16H16zM0 0H16 432h16V16 496v16H432 16 0V496 16 0zM112 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zm128 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 304A128 128 0 1 0 96 304a128 128 0 1 0 256 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm101.7-77.7L194.3 239c8.7 8.7 13.7 20.6 13.7 33s-4.9 24.2-13.7 33l-9.4 9.4c-5.7 5.7-9 13.5-9 21.7s3.2 15.9 9 21.7l12.7 12.7-11.3 11.3L173.7 369c-8.7-8.7-13.7-20.6-13.7-33s4.9-24.2 13.7-33l9.4-9.4c5.7-5.7 9-13.5 9-21.7s-3.2-15.9-9-21.7l-12.7-12.7 11.3-11.3zM274.3 239c8.7 8.7 13.7 20.6 13.7 33s-4.9 24.2-13.7 33l-9.4 9.4c-5.7 5.7-9 13.5-9 21.7s3.2 15.9 9 21.7l12.7 12.7-11.3 11.3L253.7 369c-8.7-8.7-13.7-20.6-13.7-33s4.9-24.2 13.7-33l9.4-9.4c5.7-5.7 9-13.5 9-21.7s-3.2-15.9-9-21.7l-12.7-12.7 11.3-11.3L274.3 239z'
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fast',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      'M256 22.6l80 80V112l-160 0v-9.4l80-80zM160 96v16 16h16 72V248H128V176 160H112 96L11.3 244.7 0 256l11.3 11.3L96 352h16 16V336 264H248V384H176 160v16 16l84.7 84.7L256 512l11.3-11.3L352 416V400 384H336 264V264H384v72 16h16 16l84.7-84.7L512 256l-11.3-11.3L416 160H400 384v16 72H264V128l72 0h16V112 96L267.3 11.3 256 0 244.7 11.3 160 96zm-57.4 80H112V336h-9.4l-80-80 80-80zM256 489.4l-80-80V400H336v9.4l-80 80zM409.4 176l80 80-80 80H400V176h9.4z'
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fast',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      'M560 112H272V400H560V112zM272 416H256 16 0V400 112 96H16 256h16H560h16v16V400v16H560 272zm-16-16V112H16V400H256zm80-224V336H496V176H336zm-16-16h16H496h16v16V336v16H496 336 320V336 176 160z'
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fast',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      'M368 496H16V16H208V168v8h8H368v37.5l16-16V160L224 0H16 0V16 496v16H16 368h16V496 433.3l-16 2.5V496zm-6.6-336H224V22.6L361.4 160zM120 312h-6.1l-1.6 5.9L89.9 400H64 56v16h8H96h6.1l1.6-5.9L126.1 328h3.8l22.4 82.1 1.6 5.9H160h8 4.6l2.3-4 29.7-52h14.7l29.7 52 2.3 4H256h24 8l.2-.2 16.4-2.6 74.7-11.6L564.7 216.3 576 204.9l-11.3-11.3-54.5-54.5-11.3-11.3L302.2 324.6l-11.6 74.7-.1 .7H288h-8H260.6l-29.7-52-2.3-4H224 200h-4.6l-2.3 4-27.8 48.7-21.5-78.8-1.6-5.9H136 120zm187.2 84.7l10-64.5L455 194.4l54.5 54.5L371.7 386.6l-64.5 10zM520.8 237.5L466.4 183l32.5-32.5 54.5 54.5-32.5 32.5z'
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fast',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      'M32 152C32 94.6 78.6 48 136 48h48c57.4 0 104 46.6 104 104v6.3c0 28.6-13.9 55.4-37.3 71.9l-95.4 67.3-3.4 2.4V304v64 8h16v-8V308.1l92-64.9c27.6-19.5 44-51.2 44-85V152c0-66.3-53.7-120-120-120H136C69.7 32 16 85.7 16 152v8H32v-8zM176 432H144v32h32V432z'
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fast',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      'M112 144H336V66.5l-112-49-112 49V144zm-16 0V56L224 0 352 56v88 16 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128V160v0V144zm16 16v0 16c0 5.4 .4 10.8 1.1 16h97.9l16-32H112zm132.9 0l-21.8 43.6-2.2 4.4H216 116.6c13.8 46.3 56.6 80 107.4 80c61.9 0 112-50.1 112-112V160v0H244.9zM224 447.3L212.3 435l-93.1-99H75.5L22.2 496H425.8L372.5 336H328.8l-93.1 99L224 447.3zM321.9 320H384l58.7 176 5.3 16H431.1 16.9 0l5.3-16L64 320h62.1L213 412.3 224 424l11-11.7L321.9 320zM232 48V72h24 8V88h-8H232v24 8H216v-8V88H192h-8V72h8 24V48 40h16v8z'
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fast',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM104 208h72c26.5 0 48 21.5 48 48c0 23-16.2 42.2-37.8 46.9L240 356.7l42.3-42.3 5.7-5.7L299.3 320l-5.7 5.7L251.3 368l42.3 42.3 5.7 5.7L288 427.3l-5.7-5.7L240 379.3l-42.3 42.3-5.7 5.7L180.7 416l5.7-5.7L228.7 368l-64-64H112v72 8H96v-8V296 216v-8h8zm72 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64h64z'
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fast',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207 124.1l-2.9-5.2-5.8 1.3-72 16-6.3 1.4 0 6.4 0 16v0c0 128.1 103.9 232 232 232h16 6.4l1.4-6.3 16-72 1.3-5.8-5.2-2.9-72-40-5.9-3.3-4.2 5.3-29.3 36.6c-28.3-16.3-51.8-39.8-68.1-68.1L245 206.3l5.3-4.2-3.3-5.9-40-72zM136 160l-8 0 8 0 0-9.6 59.9-13.3L229.7 198l-36.6 29.3-5.2 4.1 3.1 5.8c18.8 35.6 48.1 64.9 83.7 83.7l5.8 3.1 4.1-5.2L314 282.3l60.9 33.8L361.6 376H352c-119.3 0-216-96.7-216-216z'
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fast',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM112 256c0 61.9 50.1 112 112 112c59.2 0 107.6-45.9 111.7-104H258.3h-8V248h8H344h8v8c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l6 5.3-10.7 11.9-6-5.3c-19.8-17.7-46-28.5-74.7-28.5c-61.9 0-112 50.1-112 112z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fast',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M208 314.1l-3.9-4.5L16 90.1V48H496V90.1L307.9 309.6l-3.9 4.5V320 476.7l-96-84V320v-5.9zM0 96L192 320v80l112 98 16 14V490.7 320L512 96V48 32H496 16 0V48 96z'
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fast',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      'M8 464l-8 0 0 16 8 0 368 0 8 0 0-16-8 0L8 464zM128 192l-16 0-64 0-16 0 0 16 0 16L180.7 372.7 192 384l11.3-11.3L352 224l0-16 0-16-16 0-64 0-16 0 0-16 0-128 0-16-16 0-96 0-16 0 0 16 0 128 0 16zm0 16l16 0 0-16 0-144 96 0 0 144 0 16 16 0 80 0 0 9.4-144 144L48 217.4l0-9.4 80 0z'
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fast',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      'M228.1 9.1L224 6.7l-4.1 2.5-8 4.8c-42.9 25.7-95.6 28.7-141.1 8L59.3 16.7l-5.9-2.7-3.9 5.1-48 64-3.2 4.2L1.1 92l6.7 11.7C23.6 131.5 32 163 32 195v8c0 23.4-4.5 46.6-13.2 68.3L7.4 300C2.5 312.2 0 325.2 0 338.3c0 40.7 24 77.6 61.1 94.1l159.6 70.9 3.2 1.4 3.2-1.4 159.6-70.9C424 415.8 448 379 448 338.3c0-13.1-2.5-26.1-7.4-38.2l-11.5-28.7C420.5 249.6 416 226.4 416 203v-8c0-32 8.4-63.5 24.2-91.3L446.9 92l2.6-4.6-3.2-4.2-48-64-3.9-5.1-5.9 2.7L377.2 22c-45.5 20.7-98.2 17.7-141.1-8l-8-4.8zm-8 18.5l3.8-2.3 3.8 2.3c47.4 28.4 105.7 31.7 156 8.9l5.7-2.6 41 54.7-4.1 7.2c-14.1 24.7-22.8 52.1-25.4 80.2H47.1c-2.7-28.2-11.3-55.5-25.4-80.2l-4.1-7.2 41-54.7 5.7 2.6c50.3 22.9 108.6 19.5 156-8.9zM48 192H400c0 1 0 2 0 3v8c0 25.4 4.9 50.7 14.3 74.3L425.8 306c4.1 10.3 6.2 21.2 6.2 32.3c0 34.4-20.2 65.5-51.6 79.5L224 487.2 67.6 417.8C36.2 403.8 16 372.7 16 338.3c0-11.1 2.1-22 6.2-32.3l11.5-28.7C43.1 253.7 48 228.5 48 203v-8c0-1 0-2 0-3z'
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fast',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      'M368 16H16V496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 368h16V16 198.6c-5.4 1.5-10.8 3.3-16 5.4V16zM64 128h8H312h8v16h-8H72 64V128zm8 96H280h8v16h-8H72 64V224h8zm0 96H216h8v16h-8H72 64V320h8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm75.3 104l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L368 348.7l5.7 5.7L416 396.7l74.3-74.3 5.7-5.7L507.3 328z'
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fast',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      'M288 16H192V80h96c17.7 0 32-14.3 32-32s-14.3-32-32-32zM192 0h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H192 176V80 56h-8c-30.9 0-56 25.1-56 56v48H440h8v16h-8H8 0V160H8 96V112c0-39.8 32.2-72 72-72h8V16 0h16zM80 512L45.5 208H61.6L94.3 496H353.7l32.7-288h16.1L368 512H80z'
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fast',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      'M200 0V8 128h40 16 56 64 8v8 32c0 22.1-17.9 40-40 40s-40-17.9-40-40V144H256 240 200 184 144 128 80v24c0 22.1-17.9 40-40 40s-40-17.9-40-40V136v-8H8 72h56 16 40V8 0h16zM64 144H16v24c0 13.3 10.7 24 24 24s24-10.7 24-24V144zm256 0v24c0 13.3 10.7 24 24 24s24-10.7 24-24V144H320zM144 426.4l48 60 48-60V176h16V432l-53.8 67.2L192 512l-10.2-12.8L128 432V176h16V426.4z'
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fast',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      'M329.2 484.6C306.1 492 281.5 496 256 496C123.5 496 16 388.5 16 256S123.5 16 256 16s240 107.5 240 240c0 27-4.5 53-12.7 77.2c5.1 1.6 10.1 3.7 14.8 6.2c9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c26.9 0 52.8-4.1 77.2-11.8l-2.1-8.2-1.9-7.3zM222.6 287.9l0 0 0 0 .1 0 .5 .1c.4 .1 1.1 .2 1.9 .4c1.7 .4 4.1 .9 6.9 1.6c5.8 1.5 13.4 3.7 21 6.7c7.6 3.1 14.8 6.8 19.8 11.1c5.1 4.3 7.2 8.3 7.2 12.2c0 2.6-1.6 5.7-6.6 9.2c-5 3.5-12 6.4-19.7 8.7c-7.6 2.3-15.2 3.8-21 4.8c-2.9 .5-5.3 .8-7 1c-.8 .1-1.5 .2-1.9 .2l-.5 .1-.1 0 0 0 0 0 0 0 0 0v15.9l0 0 0 0 0 0 0 0 .1 0 .5 .1c.4 0 1.1 .1 1.9 .2c1.7 .2 4.1 .6 7 1c5.8 1 13.4 2.5 21 4.8c7.7 2.3 14.7 5.2 19.7 8.7c5 3.5 6.6 6.6 6.6 9.2c0 5-2.4 9.5-7.3 13.7c-5 4.3-12 7.9-19.5 10.8c-7.5 2.8-15.1 4.7-20.8 5.9c-2.9 .6-5.2 1-6.9 1.3c-.8 .1-1.5 .2-1.9 .3l-.5 .1-.1 0 0 0 1 7.9c1 7.9 1 7.9 1 7.9l0 0 0 0 .1 0 .2 0 .6-.1c.5-.1 1.3-.2 2.2-.3c1.9-.3 4.5-.8 7.6-1.4c6.2-1.3 14.7-3.4 23.2-6.6c8.4-3.2 17.4-7.6 24.5-13.7C290.4 403.5 296 395 296 384c0-10.2-6.4-17.5-13.4-22.4c-5.9-4.1-13.2-7.3-20.3-9.6c7.1-2.4 14.4-5.5 20.3-9.6c7-4.9 13.4-12.2 13.4-22.4c0-10.4-5.9-18.5-12.8-24.4c-6.9-5.9-15.8-10.4-24.2-13.7c-8.4-3.4-16.8-5.8-23-7.4c-3.1-.8-5.7-1.4-7.6-1.8c-.9-.2-1.7-.3-2.2-.4l-.6-.1-.2 0 0 0 0 0 0 0s0 0-1.4 7.9l-1.4 7.9zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm159.3-24c14.6 0 30.2 8.6 41 27.9l3.9 7 13.9-7.8-3.9-7c-13.1-23.4-33.6-36.1-55-36.1s-41.8 12.7-55 36.1l-3.9 7 13.9 7.8 3.9-7c10.9-19.3 26.4-27.9 41-27.9zm97.9 163.1c-6.4-25-31.2-40.3-55.9-33.4c-24.5 6.9-38.5 32.9-32.1 57.7L369.8 482l2 7.9 7.9-2.2 90.6-25.4c24.5-6.9 38.5-32.9 32.1-57.7c-6.4-25-31.2-40.3-55.9-33.4L436.3 374l-2.8-11zM382 345c15.4-4.3 31.7 5.1 36.1 22l4.8 18.9 2 7.9 7.9-2.2 18.1-5.1c15.4-4.3 31.7 5.1 36.1 22c4.4 17-5.4 34-20.9 38.3l-82.8 23.2L361 383.4c-4.4-17 5.4-34 20.9-38.3z'
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fast',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zm507 253.3L534.5 247l11.3-11.3-11.3-11.3L523.2 213c-30.9-30.9-73.5-42.7-113.5-35.4L565.7 21.7l5.7-5.7L560 4.7l-5.7 5.7L400.9 163.8c5.7-38.7-6.4-79.4-36.1-109.1L353.5 43.3 342.2 32 330.8 43.3 319.5 54.6c-24.1 24.1-32.7 57.9-25.8 88.9L318.4 163c-18-30.7-13.9-70.7 12.5-97.1l11.3-11.3 11.3 11.3c32.5 32.5 40.9 80 25 120.2l-13.6 13.6 12.6 10 7.7-7.7c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L511.9 247c-15.8 15.8-36.7 23.7-57.4 23.4l18.3 14.4c18.5-3.4 36.2-12.2 50.5-26.5zM197.3 367.4c5.7-38.7-6.4-79.4-36.1-109.1L149.8 247l-11.3-11.3L127.2 247l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L69.5 495.1l-5.7 5.7 11.3 11.3 5.7-5.7 73.7-73.7 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3 11.3-11.3L330.8 428l-11.3-11.3C288.7 385.8 246 374 206.1 381.2l69-69-12.6-10-65.1 65.1zM429.7 61.7l48-48L466.3 2.3l-48 48L412.7 56 424 67.3l5.7-5.7zm96 96l48-48L562.3 98.3l-48 48-5.7 5.7L520 163.3l5.7-5.7zM149.8 269.6c32.5 32.5 40.9 80 25 120.2l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zm16.1 151.8l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fast',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      'M16 80V432H312V80H16zM328 432H624V80H328V432zM624 64h16V80 432v16H624 16 0V432 80 64H16 624zM488 160v8 24h56 16 8v16h-8H548.9l-52 104c3.4 2.2 6.8 4.3 10.3 6.3L540 337.1l6.9 4L539 354.9l-6.9-4-32.7-18.7c-5.1-2.9-10.1-6.1-15-9.4l-56.7 28.4-7.2 3.6-7.2-14.3 7.2-3.6L470 312c-5.1-4.2-10-8.6-14.6-13.3l-29.1-29.1-5.7-5.7L432 252.7l5.7 5.7 29.1 29.1c5.4 5.4 11.1 10.4 17.1 15.1L531.1 208H480 400h-8V192h8 72V168v-8h16zm-333.2 0h10.5l2.1 4.8 80 184 1.4 3.2H231.3l-17.4-40H106.1L88.7 352H71.3l1.4-3.2 80-184 2.1-4.8zm5.2 28.1L113.1 296h93.9L160 188.1z'
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fast',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      'M80 240v16V464H432V256 240h16c26.5 0 48-21.5 48-48c0-54.2-40.2-90.1-94.3-113.3C348.1 55.7 286.3 48 256 48s-92.1 7.7-145.7 30.7C56.2 101.9 16 137.8 16 192c0 26.5 21.5 48 48 48H80zM448 464v16H432 80 64V464 272 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v16V464z'
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fast',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      'M432 48v64H368V48h64zM368 32H352V48 72H96V48 32H80 16 0V48v64 16H16 40l0 256H16 0v16 64 16H16 80 96V464 440H352v24 16h16 64 16V464 400 384H432 408V128h24 16V112 48 32H432 368zM56 384l0-256H80 96V112 88H352v24 16h16 24V384H368 352v16 24H96V400 384H80 56zM16 400H80v64H16V400zm352 0h64v64H368V400zM16 48H80v64H16V48z'
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fast',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      'M16 80V432H560V80H16zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM480 304v16H256V304H480zM256 208H480v16H256V208zM152 160v16.6c1.8 .2 3.6 .4 5.5 .7c4.8 .8 19.4 3.6 24.6 4.9l-4.1 15.5c-4.4-1.2-18.4-3.9-22.9-4.6c-14.1-2.2-26.5-.5-35.4 3.5c-8.9 4-13.9 10.1-15.1 17c-.9 5.4-.3 9.3 1.1 12.2c1.4 3 3.9 5.7 7.7 8.3c7.9 5.4 19.5 8.9 32.9 12.9l0 0 0 0 .3 .1c12.7 3.8 27.2 8.2 37.6 15.8c5.4 3.9 10.1 9 13 15.5c2.9 6.6 3.6 14.1 2.1 22.6c-2.5 14.4-11.9 24.3-24.5 29.7c-6.8 2.9-14.5 4.5-22.7 5l0 16.1v8H136v-8l0-16.6c-1.8-.2-3.6-.4-5.5-.7l0 0c-8.6-1.4-22.6-6.2-32-9.4l0 0 0 0 0 0c-1.9-.6-3.5-1.2-5-1.7l-7.6-2.5 5.1-15.2 7.6 2.5c1.7 .6 3.7 1.2 5.7 1.9l0 0 0 0c9.5 3.2 21.6 7.4 28.8 8.5c4.8 .7 9.3 1.1 13.6 1.1h.5c8.3 0 15.5-1.4 21.3-3.8c8.5-3.7 13.7-9.6 15.1-17.8c1-5.9 .4-10.2-1.1-13.5c-1.4-3.3-4-6.3-7.7-9c-7.8-5.7-19.5-9.4-32.9-13.5l-1.7-.5c-12.2-3.7-25.9-7.8-35.9-14.6c-5.4-3.7-10.2-8.4-13.2-14.7c-3-6.4-3.8-13.6-2.4-21.8c2.3-13.4 11.9-23.2 24.2-28.8c6.8-3.1 14.6-5 23-5.7V160v-8h16v8z'
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fast',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      'M245.8 12.8L10 307.5 0 320l12.8 9.6L248 506l8 6 8-6L499.2 329.6 512 320l-10-12.5L266.2 12.8 264 10 256 0l-8 10-2.2 2.8zM248 35.6V486L22.8 317.1 248 35.6zM264 486V35.6L489.2 317.1 264 486z'
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fast',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      'M184.8 19.2l32.6 70.9 75.7-18.7 20.5-5.1-9.5 18.8L269 154.8l61.9 47.5 16.7 12.8L327 219.5l-76.4 16 1.4 78 .4 21.1-16.2-13.4L176 271.4l-60.1 49.7L99.6 334.6l.4-21.1 1.4-78L25 219.5 4.4 215.2l16.7-12.8L83 154.8 47.9 85.1 38.4 66.3l20.5 5.1 75.7 18.7 32.6-70.9L176 0l8.8 19.2zm36.4 86.4l-12.9 3.2-5.5-12L176 38.3 149.1 96.7l-5.5 12-12.9-3.2L68.4 90.2l28.9 57.4 6 11.8-10.5 8.1-51 39.2 62.9 13.2 13 2.7-.2 13.2-1.2 64.3 49.5-41 10.2-8.4 10.2 8.4 49.5 41-1.2-64.3-.2-13.2 13-2.7 62.9-13.2-51-39.2-10.5-8.1 6-11.8 28.9-57.4-62.4 15.4zM520 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 424 56zm15.6 154.5L387.1 368H408h16 32 16 16 16 32 16 20.9L520.4 210.5l-2.5-7.6 15.2-5.1 2.5 7.6 56 168 3.5 10.5H584 552V504v8h-8H496h-8v-8V384H472V504v8h-8H416h-8v-8V384H376 364.9l3.5-10.5 56-168 2.5-7.6 15.2 5.1-2.5 7.6zM424 496h32V384H424V496zm80-112V496h32V384H504zM415.9 128h5H539.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L534.1 144H425.9L343.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fast',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M176 16v96h96V16H176zM160 0h16 96 16V16v96 6.8l23.1 76c8-1.8 16.3-2.8 24.9-2.8c36.4 0 68.8 17.4 89.2 44.3L512 179.7V176 80 64h16 96 16V80v96 16H624 528h-5.6L434 249.7c8.9 16.1 14 34.6 14 54.3c0 14.5-2.7 28.3-7.7 41l81.6 39H528h96 16v16 96 16H624 528 512V496 400v-3l-78.7-37.6C414.1 393.2 377.7 416 336 416c-59.2 0-107.6-45.9-111.7-104H128v40 16H112 16 0V352 256 240H16h96 16v16 40h96.3c3.1-44.2 31.9-81.3 71.5-96.6L274.1 128H272 176 160V112 16 0zM112 256H16v96h96V256zM624 80H528v96h96V80zM528 400v96h96V400H528zm-192 0a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fast',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      'M329.3 304H310.7L289.4 48h61.2L329.3 304zM296 320h48L366.7 48 368 32H351.9 288.1 272l1.3 16L296 320zm-40 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM386.1 199.6l-1.3 16.1c46.4 11.3 88.1 34.6 121.7 66.3l11-11.6c-36.2-34.1-81.3-59-131.3-70.7zM255.2 215.8l-1.3-16.1c-50.1 11.8-95.1 36.6-131.3 70.7l11 11.6c33.6-31.7 75.3-54.9 121.7-66.3zm371.1-40.4l11.3-11.3C574.3 100.4 491.8 55.6 399.5 39l-1.3 16c88.4 16.2 167.3 59.2 228.1 120.3zM241.8 55.1l-1.3-16C148.2 55.6 65.7 100.4 2.3 164.1l11.3 11.3C74.5 114.2 153.4 71.2 241.8 55.1zM272 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fast',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      'M200.6 197.4l4.7-5.2L244.5 148c12.6-14.1 19.5-32.4 19.5-51.3c0-27.1-14.4-50.9-37.8-66.5c-13-8.7-36-15-62.6-14.3C116.5 17.3 80 45.1 54.6 85.8C29.1 126.6 16 178.9 16 224c0 32.6 7.1 69.6 23.8 97.8C56 349.2 80.8 368 118.3 368c50.6 0 95-43.9 90.3-90.9l-7.3-72.7-.7-7zm17.9 18.1l6 60C230.3 333.6 176.7 384 118.3 384C29.8 384 0 293 0 224C0 128.4 55 3 163.2 0c28.9-.8 55.4 5.9 71.9 16.9C262.2 35 280 63.5 280 96.7c0 22.8-8.4 44.8-23.5 61.9L220.6 199 283 224.6l5 2V232 504v8H272v-8V237.4l-53.5-21.9zm220.9-18.1l-.7 7-7.3 72.7c-4.7 47 39.6 90.9 90.3 90.9c37.6 0 62.4-18.8 78.6-46.2C616.9 293.6 624 256.6 624 224c0-45.1-13.1-97.4-38.6-138.2C560 45.1 523.5 17.3 476.4 16c-26.6-.7-49.6 5.6-62.6 14.3C390.4 45.8 376 69.6 376 96.7c0 18.9 6.9 37.1 19.5 51.3l39.2 44.1 4.7 5.2zm-18.2 20.9L368 237.6V504v8H352v-8V232v-5.6l5.3-1.9 64.1-23.3-37.8-42.5C368.4 141.6 360 119.6 360 96.7c0-33.3 17.8-61.7 44.9-79.8C421.5 5.9 448-.8 476.8 0C585 3 640 128.4 640 224c0 69-29.8 160-118.3 160c-58.4 0-112-50.4-106.2-108.5l5.7-57.3z'
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fast',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      'M320 496c78.5 0 148.2-37.7 192-96h19.7C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256c0-23.8 3.2-46.8 9.3-68.7L8.5 18.9 3.1 4.8 17.8 8.2 175.6 44.6C216.7 16.5 266.4 0 320 0C433.4 0 529.7 73.8 563.3 176H546.3C513.4 82.8 424.5 16 320 16c-44.8 0-86.7 12.3-122.6 33.6l0 0c-6.3 3.8-12.5 7.8-18.4 12.2l0 0c-41.8 30.4-73.5 74.1-88.7 124.8l0 0c-2.7 9-4.9 18.2-6.5 27.5l0 0C81.2 227.7 80 241.7 80 256c0 132.5 107.5 240 240 240zM81.3 163.4C97.5 121.5 124.5 85 158.8 57.2l-30.2-7c-24.4 22.9-44.7 50.3-59.7 80.9l12.4 32.3zM110 45.9L76.8 38.2C66.5 51 57.1 64.4 48.6 78.6l12.5 32.6c13.3-24 29.8-46 48.8-65.2zM28.9 27.2L41.4 59.8C47.1 51 53.1 42.5 59.5 34.3L28.9 27.2zM198.6 219.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9zm160 0l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9zm-16 60L344 272c1.4-7.9 1.4-7.9 1.4-7.9l0 0 0 0 0 0 .2 0 .6 .1c.5 .1 1.2 .2 2.2 .4c1.8 .4 4.4 1 7.6 1.8c6.2 1.6 14.6 4 23 7.4c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-.8 .6-1.6 1.1-2.5 1.6H624V224H528v64h48 8v16h-8H520h-8v-8V216v-8h8H632h8v8V344v8h-8H400.1c.9 .5 1.7 1.1 2.5 1.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-8.5 3.2-16.9 5.3-23.2 6.6c-3.1 .7-5.8 1.1-7.6 1.4c-.9 .2-1.7 .3-2.2 .3l-.6 .1-.2 0 0 0 0 0 0 0s0 0-1-7.9l-1-7.9 0 0 .1 0 .5-.1c.4-.1 1.1-.2 1.9-.3c1.6-.3 4-.7 6.9-1.3c5.8-1.2 13.3-3.1 20.8-5.9c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.9-.5-5.3-.8-7-1c-.8-.1-1.5-.2-1.9-.2l-.5-.1-.1 0 0 0 0 0 0 0 0 0 0-15.9 0 0 0 0 0 0 0 0 .1 0 .5-.1c.4-.1 1.1-.1 1.9-.2c1.7-.2 4.1-.6 7-1c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-2.9-.7-5.3-1.3-6.9-1.6c-.8-.2-1.5-.3-1.9-.4l-.5-.1-.1 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fast',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      'M298.7 330.7l131.4-65.7L448 256l-17.9-8.9L298.7 181.3 232.9 49.9 224 32l-8.9 17.9L149.3 181.3 17.9 247.1 0 256l17.9 8.9 131.4 65.7 65.7 131.4L224 480l8.9-17.9 65.7-131.4zM224 444.2L163.6 323.5l-2.4-4.8-4.8-2.4L35.8 256l120.7-60.4 4.8-2.4 2.4-4.8L224 67.8l60.4 120.7 2.4 4.8 4.8 2.4L412.2 256 291.5 316.4l-4.8 2.4-2.4 4.8L224 444.2z'
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fast',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zM368 64H352 320 304V80 96v64 16 16h16 32 16V176 160 96 80 64zM320 96V80h32V96v64 16H320V160 96zm-64 48v16 64 16H224V224 160 144h32zm-96 96v16 64 16H128V320 256 240h32zM448 80V96 320v16H416V320 96 80h32zM272 160V144 128H256 224 208v16 16 64 16 16h16 32 16V240 224 160zm-96 96V240 224H160 128 112v16 16 64 16 16h16 32 16V336 320 256zM464 96V80 64H448 416 400V80 96 320v16 16h16 32 16V336 320 96z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fast',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M40 40V56h8H72V208H32 24v16h8 96 8V208h-8H88V48 40H80 48 40zM200 88v16h8H496h8V88h-8H208h-8zm0 160v16h8H496h8V248h-8H208h-8zm0 160v16h8H496h8V408h-8H208h-8zM80 288c-30.9 0-56 25.1-56 56H40c0-22.1 17.9-40 40-40h2.1c20.9 0 37.9 17 37.9 37.9c0 9.6-3.6 18.8-10.2 25.9L18.2 466 16 468.3v3.2 .6 8h8H136h8V464h-8H41.9l79.6-85.3c9.3-10 14.5-23.1 14.5-36.8c0-29.8-24.1-53.9-53.9-53.9H80z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fast',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M16 208H304V183.1L160 53.5 16 183.1V208zM0 176L160 32 320 176v32 16H304 16 0V208 176zM16 304v24.9L160 458.5 304 328.9V304H16zM0 336V304 288H16 304h16v16 32L160 480 0 336z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fast',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      'M312 32h-8V48h8 64c98.9 0 179.6 78.1 183.8 176H444.6l-53.7-92-6.5-11.2-7.1 10.9-52.7 80.8-53.9-80.9-6.3-9.5-6.8 9.2L189.6 224H48 32v16 99.2l54.9 25.1L2.1 480H21.9l79.8-108.9 73.8 33.8L120.2 480H140l50.4-68.4L200 416h89.6l-40 64h18.9l40-64H480c6.2 0 12.3-.6 18.2-1.7L531.1 480h17.9l-35.1-70.1C550.2 396.2 576 361.1 576 320V240 224h-.2C571.6 117.3 483.8 32 376 32H312zM111.4 357.9L197.7 240H435.4l1.7 2.9 5-2.9H560v80c0 44.2-35.8 80-80 80H203.5l-92.1-42.1zM177.9 240L96.5 351.1 48 328.9V240H177.9zm31.6-16l54.2-74 49.4 74H209.5zm126.7 0l47.5-72.8L426.1 224H336.1zM496 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fast',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      'M208 282.1V288v72.7l52.2 45.7c2.3 10.2 5.4 20 9.4 29.4L192 368V288L0 64V16 0H16 496h16V16 64L399.8 194.9c-9.4 1.7-18.6 4.2-27.4 7.4L496 58.1V16H16V58.1L204.1 277.6l3.9 4.5zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L443.3 368l50.3 50.3 5.7 5.7L488 435.3l-5.7-5.7L432 379.3l-50.3 50.3-5.7 5.7L364.7 424l5.7-5.7L420.7 368l-50.3-50.3-5.7-5.7L376 300.7l5.7 5.7L432 356.7l50.3-50.3 5.7-5.7L499.3 312l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fast',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      'M14.7 496l11.8-28.2C60.1 382.6 64 281.9 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.5-.1 3.8-.1c35.1 0 63.4 25.9 81.9 59.9C596.8 94.5 608 141.2 608 192s-11.2 97.5-30.1 132.1c-18.6 34-46.8 59.9-81.9 59.9c-28.5 0-52.6-17.1-70.5-41.8c.9-8.7 1.7-17.4 2.4-26.1C445.3 348.1 469.4 368 496 368c53 0 96-78.8 96-176s-43-176-96-176c-5.4 0-10.7 .8-15.9 2.4C434.7 32.3 400 104.7 400 192c0 97.5-4.4 208.3-42.4 300.3L349.3 512H25.3 8l6.7-16zM160 16c-17.2 0-37 14.3-53.6 47.4C90.4 95.5 80 140.9 80 192c0 89.8-3.8 193.4-38.7 281.7l-.1 .3 0 0L32 496H338.7l4.1-9.9 0 0C379.4 397.5 384 289.9 384 192.5l0-.5c0-50.8 11.2-97.5 30.1-132.1c9.6-17.6 21.9-33.1 36.3-43.9H160zM516.6 255c-4.9 4.8-11.9 9-20.6 9s-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1zM496 248c13.3 0 24-25.1 24-56s-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56zM301.7 173.7l-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L168 188.7l5.7 5.7L216 236.7l74.3-74.3 5.7-5.7L307.3 168l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fast',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128h-8v16h8 80V368H168h-8v16h8 80 16 80 8V368h-8H264V144h80 8V128h-8H256 168z'
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fast',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      'M272.1 45.9L224 18.4 175.9 45.9l-7 4-7.4-3.3L112 24.6V112H336V24.6l-49.5 22-7.4 3.3-7-4zM112 144c0 61.9 50.1 112 112 112s112-50.1 112-112V128H112v16zM352 0V17.5 144c0 70.7-57.3 128-128 128s-128-57.3-128-128V17.5 0l16 7.1L168 32 224 0l56 32L336 7.1 352 0zM21.7 496H426.3L372.2 320H75.8L21.7 496zM64 304H384l59.1 192 4.9 16H431.3 16.7 0l4.9-16L64 304zM623.1 512H481.5l-2.9-9.4-2-6.6H617.8L564.5 336H427.3l-4.9-16H576l58.7 176 5.3 16H623.1zM432 256c-27.7 0-53-10.1-72.6-26.7c2.9-4.6 5.6-9.4 8-14.3c17.1 15.5 39.7 25 64.6 25c53 0 96-43 96-96s-43-96-96-96c-17.5 0-33.9 4.7-48 12.8V53.7 42.8C398.6 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z'
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fast',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm381.7 5.7l5.7-5.7-5.7-5.7-104-104-5.7-5.7L260.7 152l5.7 5.7L356.7 248 136 248l-8 0 0 16 8 0 220.7 0-90.3 90.3-5.7 5.7L272 371.3l5.7-5.7 104-104z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fast',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      'M80 256V240H64c-26.5 0-48-21.5-48-48c0-54.2 40.2-90.1 94.3-113.3C163.9 55.7 225.7 48 256 48s92.1 7.7 145.7 30.7C455.8 101.9 496 137.8 496 192c0 26.5-21.5 48-48 48H432v16V464H80V256zM448 480V464 272 256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v16V464v16H80 432h16zM261.7 194.3l-5.7-5.7-5.7 5.7-88 88-5.7 5.7 5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7-5.7-5.7-88-88zM256 364.7L179.3 288 256 211.3 332.7 288 256 364.7z'
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fast',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      'M543.6 41.2c-9.9-2.9-20.1-5.2-30.5-6.7C502.3 32.8 491.2 32 480 32c-118.5 0-215.4 91.9-223.5 208.3c5.4 .4 10.7 1.3 15.9 2.5C279.2 134.1 369.5 48 480 48c1.9 0 3.8 0 5.6 .1c-61.1 36.2-102 102.9-102 179.1c0 113 90 205.1 202.1 207.9C554.8 453.5 518.6 464 480 464c-48.3 0-92.7-16.4-128-44v19.9c36.3 25.3 80.4 40.2 128 40.2c51.3 0 98.6-17.3 136.4-46.3c8.3-6.4 16.1-13.3 23.4-20.7c-9.6 2.5-19.5 4.3-29.7 5.3c-6.2 .6-12.6 .9-19 .9c-105.8 0-191.5-86-191.5-192c0-78.9 47.5-146.7 115.4-176.3c9.2-4 18.7-7.3 28.5-9.8zM64 288c-35.3 0-64 28.7-64 64v48 16H16 64 248h56 16V400 344c0-39.8-32.2-72-72-72c-6.4 0-12.7 .8-18.6 2.4c-3.4 .9-6.6 2-9.8 3.4c-1.3-3.6-2.8-7.2-4.5-10.5C201.8 241.6 174.9 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0zm240 56v56H248 64 16V352c0-26.5 21.5-48 48-48c.4 0 .8 0 1.2 0l13.4 .3 2.7-13.1C87.2 262 113.1 240 144 240c28 0 51.8 18 60.5 43l5.6 16.3 15.8-6.8c6.8-2.9 14.2-4.5 22.1-4.5c30.9 0 56 25.1 56 56z'
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fast',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M16 40V32H0v8V288v8H8 484.7L354.3 426.3l-5.7 5.7L360 443.3l5.7-5.7 144-144 5.7-5.7-5.7-5.7-144-144-5.7-5.7L348.7 144l5.7 5.7L484.7 280H16V40z'
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fast',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      'M475.9 .6l4 4 10.3 10.3c18.3 18.3 18.3 47.9 0 66.2c-13.7 13.7-35.6 14.4-50.1 2.1l-58.4 58.4 0 0L270.9 252.4c47.5 47.3 83 11.8 83 11.8l0 0 12.4 12.4 11.3 11.3-11.3 11.3L349 316.7c-9.4 9.4-21.2 15.3-33 21.2c-11.8 5.9-23.7 11.8-33.2 21.3c-24.9 24.9-40 66.1-47.6 91.2C224.9 484.4 196.9 511 160 512c-20.5 .5-41.2-7-56.8-22.7L22.7 408c-30.7-30.3-30.3-79.3 0-109.6c10.7-10.8 24.5-18 39-22.4c39.5-11.8 86.8-30.9 106.7-69.8c1.7-3.3 3.3-6.6 4.9-10c5.8-12.2 11.8-24.6 21.2-34l29.3-29.3 11.3-11.3 11.3 11.3 12.4 12.4 0 0c-.4 .4-47.3 47.7 0 95l.7 .7L368 132.7V56 50.9l4.6-2.2L470.9 3l5.1-2.4zM384 116.7l50.3-50.3 5.7-5.7 5.7 5.7 3.4 3.4c8.2 8.2 21.6 8.2 29.8 0c12-12 12-31.5 0-43.5l-6.4-6.4L384 61.1v55.6zM237.6 146.6l-2.4-2.4-29.3 29.3c-4.4 4.4-8.1 10.1-11.8 17.1c-1.9 3.5-3.6 7.1-5.5 11l-.7 1.5 0 0c-1.6 3.4-3.3 6.9-5.1 10.4c-11.8 23.2-31.4 39.6-52.3 51.7s-43.9 20.2-64.1 26.2c-12.6 3.8-23.8 9.9-32.3 18.4c-24.1 24.1-24.3 63-.1 86.9l.1 .1 0 0L114.5 478l0 0c12.4 12.4 28.8 18.4 45.1 18c28.6-.7 51.5-21.4 60.2-50.3c7.6-25.2 23.6-69.9 51.6-97.9c11.4-11.4 25.3-18.3 36.6-23.9l.8-.4c12.2-6.1 21.6-10.9 28.9-18.2l17.5-17.5-3-3c-4.9 2.7-11.2 5.3-18.8 6.8c-20.7 4.1-46.8-1.1-73.8-28.1l-11.9-11.9c-13.9-13.9-21.5-28.5-24.4-43.1c-2.9-14.5-.9-27.7 2.7-38.6c3.2-9.5 7.7-17.5 11.6-23.4zM157.7 306.3l48 48 5.7 5.7L200 371.3l-5.7-5.7-48-48-5.7-5.7L152 300.7l5.7 5.7zm-48 48l48 48 5.7 5.7L152 419.3l-5.7-5.7-48-48L92.7 360 104 348.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fast',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM320 280a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-72c22.6 0 42.8 10.4 56 26.7V168v-8h16v8V280v64 8H432v-8V325.3c-13.2 16.3-33.4 26.7-56 26.7c-39.8 0-72-32.2-72-72s32.2-72 72-72zM183.1 160h5.2 7.3 5.2l2.1 4.8L284.2 352H266.8l-20.8-48H138.1l-20.8 48H99.8L181 164.8l2.1-4.8zM145 288h94L192 179.7 145 288z'
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fast',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      'M96 32h8H504h8v8V472v8h-8H112h-8H56 8 0v-8V136v-8H8 64v16H16V464H56 96V40 32zm16 16V464H496V48H112zM352 96h8 80 8v16h-8H360h-8V96zm0 64h8 80 8v16h-8H360h-8V160zm0 64h8 80 8v16h-8H360h-8V224zM160 288h8H440h8v16h-8H168h-8V288zm0 64h8H440h8v16h-8H168h-8V352zm16-240V224H304V112H176zM160 96h16H304h16v16V224v16H304 176 160V224 112 96z'
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fast',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      'M160 0V8 176H272c17.8-46.8 63-80 116-80c68.5 0 124 55.5 124 124V320c0 106-86 192-192 192c-71 0-134.9-48.8-173.4-86c-10.2-9.8-23-16.8-35.4-18.1c-6.8-.7-22.3-.7-36.6-.5c-7 .1-13.6 .2-18.5 .3l-.1 0V504v8H48 8 0v-8V360v-8H8 176c48.6 0 88-39.4 88-88V220c0-9.6 1.1-19 3.2-28H152h-8v-8V8 0h16zM388 112c-59.6 0-108 48.4-108 108v44c0 9.1-1.2 17.9-3.3 26.2c24.6-8.8 44.7-10.3 62.2-7.5c20.4 3.3 36.6 12.5 51.2 20.8l.9 .5c15.1 8.6 28.6 16 45 17.9c15.3 1.8 34.2-1.2 60-14.7V220c0-59.6-48.4-108-108-108zM495.9 325.1c-24.4 11.6-44.2 14.7-61.8 12.7c-20.1-2.3-36.1-11.4-51-19.9l-.1-.1c-15.1-8.6-29.1-16.5-46.7-19.4c-17.1-2.8-38.2-.8-67.3 12C252 344.6 216.7 368 176 368H16V496H40V400v-7.8l7.8-.2 .2 8-.2-8 0 0 0 0 0 0 .1 0 .4 0 1.6 0c1.4 0 3.4-.1 5.8-.2c4.9-.1 11.5-.3 18.7-.3c14-.2 30.5-.2 38.4 .6c16.9 1.7 32.9 10.9 44.9 22.5c38.1 36.8 98 81.5 162.3 81.5c95.5 0 173.2-76 175.9-170.9z'
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fast',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      'M232 8V0H216V8 108.7L165.7 58.3 160 52.7 148.7 64l5.7 5.7L216 131.3V242.1l-96-55.4L97.4 102.5l-2.1-7.7L79.9 98.9l2.1 7.7 18.4 68.8L20.2 129.1l-6.9-4-8 13.9 6.9 4 80.3 46.3L23.7 207.7l-7.7 2.1 4.1 15.5 7.7-2.1L112 200.6 208 256l-96 55.4L27.8 288.8l-7.7-2.1-4.1 15.5 7.7 2.1 68.8 18.4L12.2 369.1l-6.9 4 8 13.9 6.9-4 80.3-46.3L82 405.4l-2.1 7.7 15.5 4.1 2.1-7.7L120 325.3l96-55.4V380.7l-61.7 61.7-5.7 5.7L160 459.3l5.7-5.7L216 403.3V504v8h16v-8V403.3l50.3 50.3 5.7 5.7L299.3 448l-5.7-5.7L232 380.7V269.9l96 55.4 22.6 84.2 2.1 7.7 15.5-4.1-2.1-7.7-18.4-68.8 80.3 46.3 6.9 4 8-13.9-6.9-4-80.3-46.3 68.8-18.4 7.7-2.1-4.1-15.5-7.7 2.1L336 311.4 240 256l96-55.4 84.2 22.6 7.7 2.1 4.1-15.5-7.7-2.1-68.8-18.4 80.3-46.3 6.9-4-8-13.9-6.9 4-80.3 46.3L366 106.6l2.1-7.7-15.5-4.1-2.1 7.7L328 186.7l-96 55.4V131.3l61.7-61.7 5.7-5.7L288 52.7l-5.7 5.7L232 108.7V8z'
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fast',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      'M357.7 165.7L416 224 248.6 498 240 512l-11.6-11.6L11.6 283.6 0 272l14-8.6L288 96l58.3 58.3 152-152 11.3 11.3-152 152zM25.7 275.1l68 68 52.7-52.7 5.7-5.7L163.3 296l-5.7 5.7L105 354.3l132 132L339.4 318.7 193.3 172.6 25.7 275.1zM348 304.6l47.8-78.2L285.6 116.2 207.4 164 348 304.6z'
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fast',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M0 32H8 184c75.1 0 136 60.9 136 136s-60.9 136-136 136H16V472v8H0v-8V304 288 40 32zM16 288H184c66.3 0 120-53.7 120-120s-53.7-120-120-120H16V288z'
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fast',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H311.2c6.1 5.8 12.7 11.1 19.6 16H40 32v-8zM312 239.3V160v-8h16v8 66c-5.6 4.1-10.9 8.5-16 13.3zm104-46.5c-5.4 .5-10.7 1.2-16 2.2V112h16v80.7zM136 160V416v8H120v-8V160v-8h16v8zm96 0V416v8H216v-8V160v-8h16v8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm8 64v8 64h48 8v16h-8H432h-8v-8V296v-8h16z'
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fast',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      'M363.1 0H376h96 12.9l-5.8 11.6-16 32-3.6 7.2-14.3-7.2 3.6-7.2L459.1 16H388.9l10.2 20.4 3.6 7.2-14.3 7.2-3.6-7.2-16-32L363.1 0zM16 392v8l0 59.1 20.4-10.2 7.2-3.6 7.2 14.3-7.2 3.6-32 16L0 484.9V472v-8V400v-8V376 363.1l11.6 5.8 32 16 7.2 3.6-7.2 14.3-7.2-3.6L16 388.9l0 3.1zM424 80c-39.8 0-72 32.2-72 72c0 48.6-22.8 99-61.9 138.1S200.6 352 152 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c92.8 0 178.4-42.5 239.9-104.1S496 244.8 496 152c0-39.8-32.2-72-72-72zm0-16c48.6 0 88 39.4 88 88c0 97.7-44.7 187.2-108.8 251.2S249.7 512 152 512c-48.6 0-88-39.4-88-88s39.4-88 88-88c43.7 0 90.2-20.6 126.8-57.2S336 195.7 336 152c0-48.6 39.4-88 88-88zM400 168c0 128.1-103.9 232-232 232h-8V384h8c119.3 0 216-96.7 216-216v-8h16v8z'
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fast',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      'M86.8 352.3c-13.5-49.9-13.3-134.2 61.9-209.3C191.3 100.3 260.8 70 331.9 49.6c60.6-17.4 120.6-27.2 162.3-31.8c-4.6 41.7-14.4 101.7-31.8 162.3c-4.3 14.8-8.9 29.5-14.1 43.9H299.3l51.2-51.2 5.7-5.7-11.3-11.3-5.7 5.7L110 390.7c-11.1-12.1-19.5-24.6-23.2-38.4zm23.2 61c13.2 12.3 28.1 22.7 45.6 27.4c54.1 14.6 144.7 14 224.8-66.1c85.7-85.7 120.5-267.5 130.1-358.4C511.1 10.4 511.6 5 512 0c-5 .4-10.4 .9-16.2 1.5c-91 9.6-272.7 44.4-358.4 130.1C57.3 211.7 56.7 302.3 71.3 356.4C76 373.8 86.4 388.8 98.7 402L5.9 494.8 .2 500.5l11.3 11.3 5.7-5.7L110 413.3zM121.3 402l66-66H392.2c-7.3 10-15 19.1-23.2 27.3c-75.2 75.2-159.4 75.4-209.3 61.9c-13.8-3.7-26.3-12.1-38.4-23.2zm281.8-82H203.3l80-80H442.4c-11.1 28.9-24.2 56.2-39.3 80z'
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fast',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      'M323.7 100.9l-3-5.6L288 34 255.3 95.3l-3 5.6-6 2c-37.2 12.8-66.7 42.3-79.5 79.5l-2 6-5.6 3L98 224l61.3 32.7 5.6 3 2 6c12.8 37.2 42.3 66.7 79.5 79.5l6 2 3 5.6L288 414l32.7-61.3 3-5.6 6-2c37.2-12.8 66.7-42.3 79.5-79.5l2-6 5.6-3L478 224l-61.3-32.7-5.6-3-2-6c-12.8-37.2-42.3-66.7-79.5-79.5l-6-2zM495 214.9l17 9.1-17 9.1-70.8 37.8c-14.4 41.9-47.5 75-89.4 89.4L297.1 431 288 448l-9.1-17-37.8-70.8c-41.9-14.4-75-47.5-89.4-89.4L81 233.1 64 224l17-9.1 70.8-37.8c14.4-41.9 47.5-75 89.4-89.4L278.9 17 288 0l9.1 17 37.7 70.8c41.9 14.4 75 47.5 89.4 89.4L495 214.9zM240 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM59.3 500.7L48 512 36.7 500.7 11.3 475.3 0 464l11.3-11.3L141.9 322.1c3 4.5 6.2 8.8 9.6 13L22.6 464 48 489.4 176.9 360.5c4.2 3.4 8.5 6.6 13 9.6L59.3 500.7z'
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fast',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      'M104.9 261.6l7.1-4.8v-8.5V16H240V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM256 0H240 112 96V16 248.3C57.4 274.1 32 318.1 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V264v-8H168v8 40.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64zM450.3 477.7l5.7 5.7 5.7-5.7 80-80-11.3-11.3L464 452.7V40 32l-16 0v8V452.7l-66.3-66.3-11.3 11.3 80 80z'
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fast',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      'M512 16V0H496 144 128V12.7l16 12.6V16H496V303.2l16 12.6V16zM144 484.1V208.8l-16-12.6V493.5 512l16-9.3L320 400 496 502.7l16 9.3V499.3L483.7 477 328.1 386.2l-8.1-4.7-8.1 4.7L144 484.1zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fast',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M186.6 32l-2 5L3.2 480H20.5L66.3 368H317.7l45.9 112h17.3L199.4 37l-2-5H186.6zM311.1 352H72.9L192 61.1 311.1 352z'
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fast',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      'M53.2 464L172.1 48H312v56 8h16v-8V48H467.9l32.9 115.3c5.2-1.3 10.4-2.2 15.9-2.7L480 32H160L36.6 464 32 480H48.6 384l0-16H328V408v-8H312v8 56H53.2zM328 200v-8H312v8V312v8h16v-8V200zm200 8c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fast',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      'M16 80V432H624V80H16zM0 64H16 624h16V80 432v16H624 16 0V432 80 64zM128 168V344v8H112v-8V168v-8h16v8z'
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fast',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      'M240 8V0H224V8 32c0 26.5 21.5 48 48 48h16 8 8 6.1l-49.7 24.8-4.4 2.2V112v24 8h8 48 6.5l-11.3 32H112h0H88c-48.6 0-88 39.4-88 88v48 8H16v-8V264c0-39.8 32.2-72 72-72h24 0H312.9h5.7l1.9-5.3 15-42.7h.6 8V128h-2.9H336h-6.2H312 272V116.9L345.9 80h58.8L496 171.3V208H400h-6.1l-1.6 5.9L370 295.7c-1.3 4.8-2 9.8-2 14.7V496H296V352v-8h-8H218.8L181 313.8l-16.3-13.1 3.4 20.6 7.1 42.9-43.7 29.1-5 3.3 1.8 5.7L157.2 496H85.9L56.4 400.1l15.2-45.6 .4-1.2V352 320v-4.3l-3.6-2.4L43.8 296.9C39 293.7 35 289.5 32 284.7v23.4c1 .7 1.9 1.4 3 2.1l21 14v26.4L40.4 397.5l-.8 2.4 .8 2.5 32 104 1.7 5.6H80h88 10.8l-3.2-10.4-30.2-98.3 43-28.7 4.3-2.9-.9-5.1-4.6-27.4L211 358.2l2.2 1.8H216h64V504v8h8 88 8v-8V310.4c0-3.6 .5-7.1 1.4-10.5L406.1 224H504h8v-8V168v-3.3l-2.3-2.3L427.2 79.9C452.2 78.2 472 57.4 472 32V8 0H456V8 32c0 17.7-14.3 32-32 32h-8-4.7H408h0H344h-1.9-2.3c7.6-8.5 12.2-19.7 12.2-32V8 0H336V8 32c0 17.7-14.3 32-32 32h-8-8H272c-17.7 0-32-14.3-32-32V8zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fast',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      'M258.7 204.1L301 223.7l41.6 41.6 18.6 18.6-14.6 21.8-64 96-8.9 13.3-.3 .5 159.1 77 60.9-20.1 7.6-2.5 5 15.2-7.6 2.5-64 21.1-3.1 1-2.9-1.4L4.5 303.2l7-14.4 203.8 98.6 5.2-7.8 8.9-13.3 49.4-74.2-76.5-76.5c-13.1-13.1-19.1-29.9-18.7-46.4l16.4 7.6c1.3 9.9 5.8 19.6 13.7 27.5l76.5 76.5 9.3 9.3L292.1 301l-49.4 74.2-8.9 13.3 26.6 17.8 8.9-13.3 64-96 7.3-10.9-9.3-9.3-63.8-63.8-8.8-8.8zm-40.5-71.8l86.3 40.2 34.9-12.7 12.6-4.6 6.7 11.5 19.4 33.3 2.2 3.7 3.7 2.1L417.4 225l.9 .4c.6 .3 1.2 .7 1.7 1.1l20 11.4 13.9 7.9L469.8 218l-13.9-7.9-48.6-27.7-3.7-2.1-2.2-3.7L349.8 87.9l-7.2-12.4-13.1 5.8L228.1 126.5c-3.6 1.6-6.9 3.6-9.9 5.8zm-15.8-7.4c5.3-5.3 11.8-9.8 19.2-13.1L323 66.8l26.2-11.6 14.4 24.8 51.7 88.6 48.6 27.7 13.9 7.9 13.9 7.9L483.7 226l-15.9 27.8-7.9 13.9L446 259.7l-13.9-7.9-22-12.6-270-125.6-13 25.9-3.6 7.2-14.3-7.2 3.6-7.2 12.8-25.5-25-11.6-7.3-3.4 6.7-14.5 7.3 3.4 25.4 11.8 12.1-24.1 3.6-7.2 14.3 7.2-3.6 7.2L147.3 99.3l55.1 25.6zm155.7 72.4l-13.2-22.5L325.1 182l33 15.3zM428.7 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-48-32a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fast',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M384 32h-8H8 0V48H8 358.7L1.9 466.8 0 469.1V480H8 376h8V464h-8H25.3L382.1 45.2l1.9-2.2V32z'
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fast',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      'M352 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM71.3 364.1c-10.1-3.3-19-8.3-26.6-14.7c-33.9-28.4-38.3-78.9-9.9-112.8s78.8-38.3 112.7-9.9l0 0L383.5 426.7l-17.3 32.4-295-95 0 0zm-36.9-2.5c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1 29.6-55.7-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6zM112 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 256a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fast',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM163 392.8l-5.6 5.1-10.8-11.8 5.6-5.1c54.5-49.5 125.5-77 199.1-77H360v16h-8.7c-69.7 0-136.8 26-188.3 72.8zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fast',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      'M208 11.2l6.9-4.1L210.5-.3l-7.1 5L144 46.2 84.6 4.6l-7.1-5L73.1 7.1 80 11.2 73.1 7.1l0 0 0 0 0 0 0 .1-.1 .3-.5 .9c-.5 .8-1.1 2-1.9 3.4c-1.5 2.8-3.6 6.8-5.7 11.1c-2.1 4.3-4.2 9.2-5.8 14C57.4 41.5 56 46.6 56 51.2C56 68 65.1 80 74 89.2L4.9 179.1 .7 184.6l4.8 5 76.8 80 5.2 5.5 5.7-4.9 47.2-40.4L176 329.4V504v8h8 96 8v-8V400H464V504v8h8 96 8v-8V328 170.8l45.6 96.7 3.4 7.2 14.5-6.8-3.4-7.2-52.8-112-2.2-4.6-5.1 0h-8H269.5c-6.5 0-12.7-2.6-17.2-7.2L210.1 93.5C220.4 83.9 232 70.2 232 51.2c0-4.6-1.4-9.7-2.9-14.3c-1.6-4.7-3.8-9.6-5.8-14c-2.1-4.4-4.2-8.3-5.7-11.1c-.8-1.4-1.4-2.6-1.9-3.4l-.5-.9-.1-.3 0-.1 0 0 0 0 0 0L208 11.2zM456 160v0l104 0V320H189.6L151.5 213.3l-3.9-11-8.8 7.6L88.5 253 21.7 183.4l69.2-90 4.3-5.6-5-5C79.8 72.7 72 63.8 72 51.2c0-1.9 .6-4.9 2.1-9.1c1.4-4 3.2-8.3 5.2-12.3c1.2-2.5 2.4-4.9 3.5-7l56.7 39.7 4.6 3.2 4.6-3.2 56.7-39.7c1.1 2.1 2.3 4.4 3.5 7c1.9 4 3.8 8.3 5.2 12.3c1.4 4.1 2.1 7.2 2.1 9.1c0 14.8-10.9 25.5-22.7 35.9l-6.4 5.6 5.9 6 48.1 49.2c7.5 7.7 17.8 12.1 28.6 12.1H456zM560 336V496H480V392v-8h-8H280h-8v8V496H192V336H560zM264 208v-8H248v8 24H224h-8v16h8 24v24 8h16v-8V248h24 8V232h-8H264V208zm112-8H360v8 24H336h-8v16h8 24v24 8h16v-8V248h24 8V232h-8H376V208v-8zm112 8v-8H472v8 24H448h-8v16h8 24v24 8h16v-8V248h24 8V232h-8H488V208z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fast',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM576 256c0-88.4-71.6-160-160-160H360h-8v16h8 56c79.5 0 144 64.5 144 144c0 29.2-8.7 56.4-23.6 79.1L549 345c17.1-25.5 27-56.1 27-89zm-112 8h8V248h-8H426.1l20.3 16H464zM193.7 248H176h-8v16h8 37.9l-20.3-16zm-90-71.1L91 167C74 192.4 64 223 64 256c0 88.4 71.6 160 160 160h56 8V400h-8H224c-79.5 0-144-64.5-144-144c0-29.2 8.7-56.4 23.6-79.1z'
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fast',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      'M476.9 369.3C445.2 294.9 402.7 226.7 344 168S217.1 66.8 142.7 35.1l1.3-.5C238.1-3.5 349.5 19.2 421.3 91.3c71.6 71.9 94 182.9 56.1 276.7l-.5 1.3zm8.7 21.2l6.7-16.6c40.4-99.7 16.6-217.6-59.6-294C356.3 3.4 238-20.7 138 19.8l-16.6 6.7L99.6 35.3c7.3 2.7 14.6 5.5 21.9 8.4c78.8 31.6 150.4 74.8 211.2 135.6s104 132.4 135.6 211.2c2.9 7.2 5.7 14.5 8.4 21.9l8.8-21.8zM283.8 177.4L0 472l40 40L334.6 228.2c-3.5-4-7-7.9-10.7-11.9L40.2 489.6 22.4 471.8 295.7 188.2c-4-3.7-7.9-7.2-11.9-10.7zM429.7 18.3L424 12.7 412.7 24l5.7 5.7 64 64 5.7 5.7L499.3 88l-5.7-5.7-64-64z'
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fast',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      'M96 32V48v96 16c26.5 0 48 21.5 48 48s-21.5 48-48 48v16 96 16h16H624h16V368 272 256c-26.5 0-48-21.5-48-48s21.5-48 48-48V144 48 32H624 112 96zm64 176c0-29.8-20.4-54.9-48-62V48H624v98c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62v98H112V270c27.6-7.1 48-32.2 48-62zM16 96V88H0v8V472v8H8 552h8V464h-8H16V96z'
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fast',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      'M56.5 274.7l-4.7 9.3L28.9 329.9l76-15.2 5.1-1 4.7 2.2C142.3 328.7 174.1 336 208 336c108.6 0 192-74 192-160s-83.4-160-192-160S16 90 16 176c0 33.4 12.3 64.7 33.9 90.7l6.7 8zM19.9 348L0 352l9.1-18.1 28.5-57C13.9 248.3 0 213.5 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.2 0-70.3-7.8-99.9-21.6L19.9 348zm211.6 35c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c33.9 0 65.7-7.3 93.2-20.1l4.7-2.2 5.1 1 76 15.2-22.9-45.8-4.7-9.3 6.7-8c21.5-26 33.9-57.2 33.9-90.7c0-81.7-75.3-152.6-176-159.5l0-.5c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9l28.5 57L640 512l-19.9-4-88.2-17.6C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM215.1 90.7v14.8c1.7 .2 3.3 .4 5 .6c4.3 .7 17.5 3.2 22.1 4.4l-3.6 13.8c-4-1-16.6-3.5-20.7-4.1c-12.7-2-23.9-.5-32 3.1c-8.1 3.6-12.5 9-13.6 15.1c-.8 4.8-.2 8.2 1 10.8c1.3 2.7 3.5 5.1 7 7.4c7.2 4.8 17.6 7.9 29.6 11.5l.2 .1c11.4 3.4 24.4 7.3 33.8 14.1c4.9 3.5 9.1 8 11.7 13.8c2.6 5.9 3.3 12.6 1.9 20.1c-2.2 12.8-10.7 21.6-22.1 26.4c-6.1 2.6-13 4-20.5 4.4v14.3 7.1H200.9v-7.1l0-14.7c-1.7-.2-3.3-.4-5-.6l0 0c-7.7-1.2-20.3-5.5-28.8-8.3l0 0c-1.7-.6-3.2-1.1-4.5-1.5l-6.8-2.2 4.4-13.5 6.8 2.2c1.6 .5 3.3 1.1 5.1 1.7l0 0 0 0 0 0 0 0c8.6 2.9 19.5 6.6 25.9 7.6c4.4 .7 8.5 1 12.4 1h.2c7.6 0 14.1-1.2 19.4-3.4c7.7-3.3 12.3-8.6 13.6-15.8c.9-5.3 .3-9.1-.9-12c-1.3-2.9-3.6-5.6-6.9-8c-7.1-5.1-17.5-8.4-29.6-12l-1.5-.4c-11-3.3-23.3-6.9-32.2-12.9c-4.9-3.3-9.2-7.5-11.9-13.1c-2.7-5.7-3.5-12.2-2.2-19.4c2.1-11.9 10.7-20.7 21.8-25.6c6.1-2.7 13.2-4.4 20.7-5V90.7 83.6h14.2v7.1z'
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fast',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192.5 144c-32.5 2-61.6 16.5-82.7 38.7l-5.5 5.8-11.6-11 5.5-5.8c23.7-25.1 56.6-41.4 93.3-43.7l8-.5 1 16-8 .5zm119-.5l1-16 8 .5c36.7 2.3 69.6 18.6 93.3 43.7l5.5 5.8-11.6 11-5.5-5.8C381.1 160.5 352 146 319.5 144l-8-.5zM304 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fast',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      'M272 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM347.6 77.3l3.6 7.2 39.1 78.2L576 240v96l-90.4 60.3L563.9 496h8.8l45.7-45.7 5.7-5.7L635.3 456l-5.7 5.7-48 48-2.3 2.3H576 560.1h-.2H424h-8V496h8H543.5l-75.4-96h-129c-3.3-5.7-7.2-11.1-11.6-16H471.9h.2 3.1L560 327.4V250.7L388.6 179.2 300.1 282.4c-3 3.5-7.5 5.6-12.1 5.6H89.9L57.8 352.2c-6.7 .4-13.3 1.5-19.5 3.3L80 272H288l54.9-64H288h-4l-2.4-3.2L236 144H164.9l-45.8 91.6-3.6 7.2-14.3-7.2 3.6-7.2 48-96 2.2-4.4H160h80 4l2.4 3.2L292 192h64.6l19.3-22.5-39-78-3.6-7.2 14.3-7.2zM304 448c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48s21.5 48 48 48H256c26.5 0 48-21.5 48-48zM64 384H256c35.3 0 64 28.7 64 64s-28.7 64-64 64H64c-35.3 0-64-28.7-64-64s28.7-64 64-64z'
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fast',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      'M328 8V0H312V8 48H264h-8V64h8 48v59.6L163.7 217.2l-3.7 2.4V224 496H16V364.3l112-74.7V270.4l-4.4 3-120 80L0 355.7V360 504v8H8 176h8v0h72 16 96 16 88 8v0H632h8v-8V360v-4.3l-3.6-2.4-120-80-4.4-3v19.2l112 74.7V496H480V224v-4.4l-3.7-2.4L328 123.6V64h48 8V48h-8H328V8zM464 496h-8v0H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64V496H176V228.4l144-90.9 144 90.9V496zM368 384V496H272V384c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fast',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      'M352 48l144 0 0 117.5c5.1-1.8 10.5-3.2 16-4.1L512 48l0-16-16 0L16 32 0 32 0 48 0 464l0 16 16 0 368 0 0-16-32 0 0-128 32 0 0-16-32 0 0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L352 176l0-128zm-16 0l0 128-160 0 0-128 160 0zM160 48l0 416L16 464 16 48l144 0zm16 416l0-128 160 0 0 128-160 0zM336 320l-160 0 0-128 160 0 0 128zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-32 0-16 0 0 16 0 160 0 16 16 0 192 0 16 0 0-16 0-160 0-16-16 0-32 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80l32 0 16 0 96 0 16 0 32 0 0 160-192 0 0-160z'
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fast',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 253.4l2.3-16H16V192H384h48 16V176 80 64H432 336V8 0H320V8 64H128V8zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zm-8 304H96v16h8H248h8V384h-8H104zm-8-96v16h8H344h8V288h-8H104 96zm402.9-64.1L302.2 420.6l-11.6 74.7L288 511.9l16.6-2.6 74.7-11.6L564.7 312.3 576 300.9l-11.3-11.3-54.5-54.5-11.3-11.3zM317.2 428.2L455 290.4l54.5 54.5L371.7 482.6l-64.5 10 10-64.5zM553.4 300.9l-32.5 32.5L466.4 279l32.5-32.5 54.5 54.5z'
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fast',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      'M496 144c0-70.7-57.3-128-128-128c-53.7 0-99.7 33.1-118.7 80H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-.5 0 1.7-16c70.2-.6 126.8-57.7 126.8-128zM54.4 496H297.6l23.3-224H31.1L54.4 496zM322.6 256l11.7-112H17.8L29.4 256H322.6zM312 512H40L1.7 144 0 128H16.1 335.9 352l-1.7 16L312 512z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fast',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 32h8H376h8V48h-8H285.4L115.9 464H248h8v16h-8H8 0V464H8 98.6L268.1 48H136h-8V32z'
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fast',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      'M232 0V8 64c43.7 .4 84.1 14.6 116.7 38.3l-9.4 12.9C309.4 93.5 272.3 80.4 232 80V432c40.3-.4 77.4-13.5 107.3-35.3l9.4 12.9c-32.6 23.7-73 37.9-116.7 38.3v0 8 48 8H216v-8V456v-8-.5C113.4 440.6 32 357.7 32 256S113.4 71.4 216 64.5V8 0h16zM48 256c0 92.4 73.8 168.6 168 175.5V80.5C121.8 87.4 48 163.6 48 256z'
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fast',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      'M560 48H80V192H64V48 32H80 560h16V48 192H560V48zM16 464h96V240H16V464zM0 224H16h96 16v16 48H512V240 224h16 96 16v16V464v16H624 528 512V464 432H128v32 16H112 16 0V464 240 224zM128 416H512V304H128V416zm400 48h96V240H528V464z'
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fast',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      'M255.8 272.8h.4L496 25.5V16H16v9.5L255.8 272.8zM248 287.8l-3.1-3.2L0 32V16 0H16 496h16V16 32L267.1 284.5l-3.1 3.2V496H376h8v16h-8H256 136h-8V496h8H248V287.8z'
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fast',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM72 128H312h8v16h-8H72 64V128h8zm0 96H312h8v16h-8H72 64V224h8zm0 96H216h8v16h-8H72 64V320h8z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fast',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16z'
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fast',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM357.7 181.7l5.7-5.7L352 164.7l-5.7 5.7L224 292.7l-58.3-58.3-5.7-5.7L148.7 240l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fast',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      'M256 480V457.4 96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L240 464l16 16zm-16-38.6L51.1 252.5C28.6 230 16 199.5 16 167.8C16 101.6 69.6 48 135.8 48c31.8 0 62.2 12.6 84.7 35.1L240 102.6V441.4z'
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fast',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      'M0 64V80 432v16H16 624h16V432 336 320H624c-26.5 0-48-21.5-48-48s21.5-48 48-48h16V208 80 64H624 16 0zM624 432H16V80H624V208c-35.3 0-64 28.7-64 64s28.7 64 64 64v96zM480 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fast',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M16 496H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM16 0H224L384 160V496v16H368 16 0V496 16 0H16zM192 416H176 80 64V400 344L96 224h64l32 120v56 16zM108.3 240L80 346.1V400h96V346.1L147.7 240H108.3zM112 344h32 8v16h-8H112h-8V344h8zM104 32h48 8V48h-8H104 96V32h8zm0 32h48 8V80h-8H104 96V64h8zm0 32h48 8v16h-8H104 96V96h8zm0 32h48 8v16h-8H104 96V128h8zm0 32h48 8v16h-8H104 96V160h8zm0 32h48 8v16h-8H104 96V192h8z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fast',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H504h8v-8V218.5l50.8 43.5 10.4-12.1L512 197.5V40 32h-8H392h-8v8V87.7L293.2 9.9zM400 101.5V48h96V183.7l-96-82.3zm96 103.4V496H300.3l-56.9-85.3L348 350.9l9.9-5.6-8.6-7.4-112-96-6.1-5.2-10.4 12.1 6.1 5.2 103.4 88.6L228 401.1l-7.4 4.3 4.8 7.1L281.1 496H80V204.8L288 26.5 496 204.8z'
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fast',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm75.3 104l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L368 348.7l5.7 5.7L416 396.7l74.3-74.3 5.7-5.7L507.3 328z'
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fast',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      'M0 32H8 32 48 464h16 24 8V48h-8H480V464h24 8v16h-8H480 464 432h-8H368 352V464 352c0-53-43-96-96-96s-96 43-96 96V464v16H144 88 80 48 32 8 0V464H8 32V48H8 0V32zM48 48V464H80h8 56V352c0-61.9 50.1-112 112-112s112 50.1 112 112V464h56 8 32V48H48zm56 96H408h8v16h-8H104 96V144h8z'
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fast',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V256v-4.3l3.6-2.4 96-64 6.7-4.4 8.9 13.3-6.7 4.4L264 260.3V408v8H248v-8z'
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fast',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      'M353.6 32H370L345.1 144H445.9l-3.2 16H341.5L298.9 352H320l0 16H295.3L270.4 480H254l24.9-112H103.3L78.4 480H62L86.9 368H2.1l3.2-16H90.5l42.7-192H43.7l3.2-16h89.8L161.6 32H178L153.1 144H328.7L353.6 32zM149.5 160L106.9 352H282.5l42.7-192H149.5zM464 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H560 368 352V496 336 320h16 32V256zm-32 80V496H560V336H528 512 416 400 368z'
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fast',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM240 144v32H208V144h32zM112 240h32v32H112V240zm128 0v32H208V240h32zm64 0h32v32H304V240zm-64 96v32H208V336h32z'
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fast',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      'M248 0V8l0 156.7L173.7 90.3 168 84.7 156.7 96l5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7L344 84.7l-5.7 5.7L264 164.7 264 8V0H248zM416 156.7l-5.7 5.7-88 88-5.7 5.7 5.7 5.7 88 88 5.7 5.7L427.3 344l-5.7-5.7L347.3 264 504 264h8V248h-8l-156.7 0 74.3-74.3 5.7-5.7L416 156.7zM256 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM101.7 162.3L96 156.7 84.7 168l5.7 5.7L164.7 248 8 248H0v16H8l156.7 0L90.3 338.3 84.7 344 96 355.3l5.7-5.7 88-88 5.7-5.7-5.7-5.7-88-88zm60.7 248l-5.7 5.7L168 427.3l5.7-5.7L248 347.3 248 504v8h16v-8V347.3l74.3 74.3 5.7 5.7L355.3 416l-5.7-5.7-88-88-5.7-5.7-5.7 5.7-88 88z'
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fast',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      'M80 64a48 48 0 1 1 96 0A48 48 0 1 1 80 64zm112 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM40.7 336l6.7-160H208.7l6.7 160H192 144 112 64 40.7zM136 352V504v8h8 48 8v-8V352h16 16l-.7-16L224 160H32L24.7 336 24 352H40 56V504v8h8 48 8v-8V352h16zm48 0V496H152V352h32zM72 352h32V496H72V352zM320 0H304V8 504v8h16v-8V8 0zM512 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-51.9 48H563.9l54.9 192H576 528 496 448 405.2l54.9-192zM504 384h16V504v8h8 48 8v-8V384h39.4H640l-4.6-16L576 160H448L388.6 368 384 384h16.6H440V504v8h8 48 8v-8V384zm64 112H536V384h32V496zM488 384V496H456V384h32z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fast',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M288 238.5L39.4 128 288 17.5 536.6 128 288 238.5zM556.3 119.2L288 0 19.7 119.2 0 128l19.7 8.8L288 256 556.3 136.8 576 128l-19.7-8.8zm-432 99l-19.7-8.8L19.7 247.2 0 256l19.7 8.8L288 384 556.3 264.8 576 256l-19.7-8.8-84.9-37.7-19.7 8.8L536.6 256 288 366.5 39.4 256l84.9-37.7zM104.6 337.5L19.7 375.2 0 384l19.7 8.8L288 512 556.3 392.8 576 384l-19.7-8.8-84.9-37.7-19.7 8.8L536.6 384 288 494.5 39.4 384l84.9-37.7-19.7-8.8z'
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fast',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      'M16 167.6l240 165L328.1 283c-2.4 7.6-4.3 15.3-5.6 23.3L256 352 16 187V432H348.5c3.6 5.6 7.6 10.9 11.8 16H16 0V432 176 80 64H16 496h16V80v80.7c-5.3-.5-10.6-.7-16-.7V80H16v87.6zM496 464a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm75.3 104l-5.7 5.7-80 80-5.7 5.7-5.7-5.7-48-48-5.7-5.7L432 316.7l5.7 5.7L480 364.7l74.3-74.3 5.7-5.7L571.3 296z'
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fast',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      'M304 72c-92.8 0-168 75.2-168 168c0 57.4-46.6 104-104 104H24V328h8c48.6 0 88-39.4 88-88c0-101.6 82.4-184 184-184c62.2 0 117.3 30.9 150.5 78.2l-10 11.8c-13.5-6.4-28.6-10-44.6-10c-57.4 0-104 46.6-104 104c0 48.6 39.4 88 88 88c22.5 0 44.5-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 313.8 553.5 328 576 328v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8C438.6 326.2 412.7 344 384 344c-57.4 0-104-46.6-104-104c0-66.3 53.7-120 120-120c8.2 0 16.2 .8 24 2.4C393.5 91.3 351 72 304 72zM96 394l.6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l0 0 0 0 .6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9 0 0 0 0 0 0c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 449.8 553.5 464 576 464v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 462.2 28.7 480 0 480V464c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9z'
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fast',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      'M310.2 116.8l-3.6-5.8L256 30.2l-50.5 80.9-3.6 5.8-6.7 1.4C89.8 140.3 16 216.9 16 304c0 103.1 104.2 192 240 192s240-88.9 240-192c0-87.1-73.8-163.7-179.2-185.8l-6.7-1.4zM246.6 15.1L256 0l9.4 15.1 54.7 87.5C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4l54.7-87.5z'
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fast',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      'M128 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm80-256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 240a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm96-80a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fast',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      'M383.6 83.1C348.3 118.4 288 93.4 288 43.5V16 0H272 240 224V16 43.5c0 49.9-60.3 74.9-95.6 39.6L108.9 63.7 97.6 52.4 86.3 63.7 75 75 63.7 86.3 52.4 97.6l11.3 11.3 19.5 19.5C118.4 163.7 93.4 224 43.5 224H16 0v16 32 16H16 43.5c49.9 0 74.9 60.3 39.6 95.6L63.7 403.1 52.4 414.4l11.3 11.3L75 437l11.3 11.3 11.3 11.3 11.3-11.3 19.5-19.5 0 0c35.3-35.2 95.6-10.3 95.6 39.6V496v16h16 32 16V496 468.5c0-49.9 60.3-74.9 95.6-39.6l19.5 19.5 11.3 11.3 11.3-11.3 22.6-22.6 11.3-11.3-11.3-11.3-19.5-19.5c-35.3-35.3-10.3-95.6 39.6-95.6H496h16V272 240 224H496 468.5c-49.9 0-74.9-60.3-39.6-95.6l19.5-19.5 11.3-11.3L448.3 86.3 425.7 63.7 414.4 52.4 403.1 63.7 383.6 83.1zM414.4 75L437 97.6l-19.5 19.5C372.2 162.4 404.3 240 468.5 240H496v32H468.5c-64.1 0-96.3 77.6-50.9 122.9L437 414.4 414.4 437l-19.5-19.5C349.6 372.2 272 404.3 272 468.5V496H240V468.5c0-64.1-77.5-96.3-122.9-50.9l0 0 0 0 0 0L97.6 437 86.3 425.7 75 414.4l19.5-19.5C139.8 349.6 107.7 272 43.5 272H16V240H43.5c64.2 0 96.2-77.6 50.9-122.9l0 0L75 97.6 86.3 86.3 97.6 75l19.5 19.5C162.4 139.8 240 107.7 240 43.5V16h32V43.5c0 64.2 77.6 96.2 122.9 50.9l0 0L414.4 75zM224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fast',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400H432V16H56C33.9 16 16 33.9 16 56V416.8zm200.2-91.2c-17.4-18.2-38.3-51.8-40-109.6H120.3c3.6 54.5 43.6 99.1 95.9 109.6zm4.5-19.3c7 9 13.8 14.9 18.8 18.5l.6 .4 .6-.4c5-3.6 11.8-9.6 18.8-18.5c13-16.8 27-45 28.5-90.4H192.1c1.5 45.4 15.5 73.6 28.5 90.4zM192.1 200h95.7c-1.5-45.4-15.5-73.6-28.5-90.4c-7-9-13.8-14.9-18.8-18.5l-.6-.4-.6 .4c-5 3.6-11.8 9.6-18.8 18.5c-13 16.8-27 45-28.5 90.4zm71.7 125.6c52.3-10.5 92.3-55.1 95.9-109.6H303.9c-1.8 57.8-22.6 91.5-40 109.6zm40-125.6h55.9c-3.6-54.5-43.6-99.1-95.9-109.6c17.4 18.2 38.3 51.8 40 109.6zm-183.6 0h55.9c1.8-57.8 22.6-91.5 40-109.6c-52.3 10.5-92.3 55.1-95.9 109.6zM240 72a136 136 0 1 1 0 272 136 136 0 1 1 0-272z'
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fast',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      'M128 32h8H288h4.4l2.4 3.7 96 152 2.7 4.3H480h16v16V368h32V200v-3.1l2.1-2.3 88-96 5.4-5.9 11.8 10.8-5.4 5.9L544 203.1V368v4.9l85.9 93.7 5.4 5.9-11.8 10.8-5.4-5.9L532.5 384H496 480 464c0 53-43 96-96 96s-96-43-96-96H224c0 53-43 96-96 96s-96-43-96-96H16 0V368 208 192H16 128v-8V40 32zM462.7 368H480V208H16V368H33.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80h50.7c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80zM144 192H374.5L283.6 48H144V184v8zm64 192A80 80 0 1 0 48 384a80 80 0 1 0 160 0zm160 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fast',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      'M248 20.3V491.1C155.1 450.3 99.8 379.5 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L248 20.3zm16 470.8V20.3L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6c-31.3 72-86.6 142.8-179.5 183.5zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fast',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM212.4 361.3l43.6 29 43.6-29 4.4-3 4.4 3 44.1 29.4 27.8-13.9 7.2-3.6 7.2 14.3-7.2 3.6-32 16-4.2 2.1-3.9-2.6-43.6-29-43.6 29-4.4 3-4.4-3-43.6-29-43.6 29-3.9 2.6-4.2-2.1-32-16-7.2-3.6 7.2-14.3 7.2 3.6 27.8 13.9 44.1-29.4 4.4-3 4.4 3zm-80-156.1l7.2 3.6 80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L198.1 256l-65.7-32.8-7.2-3.6 7.2-14.3zm240 3.6l7.2-3.6 7.2 14.3-7.2 3.6L313.9 256l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L278.1 256l14.3-7.2 80-40z'
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fast',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      'M496 16V272H144V16H256V124v20l16-12 48-36 48 36 16 12V124 16H496zM272 16h96v96L329.6 83.2 320 76l-9.6 7.2L272 112V16zM496 0H384 368 272 256 144 128V16 272v16h16H496h16V272 16 0H496zM0 352v16H8 80V496H8 0v16H8 80h8 8H312h8 8H544h8 8 72 8V496h-8H560V368h72 8V352h-8H560h-8-8H328h-8-8H96 88 80 8 0zM96 496V368H312V496H96zm232 0V368H544V496H328z'
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fast',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      'M411.1 184.6L32 28V45.4L387 192 32 338.7V356L411.1 199.4l4.9-2V186.7l-4.9-2zM440 464H8 0v16H8 440h8V464h-8z'
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fast',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm229.7 98.3l104 104 5.7 5.7L328 251.3l-5.7-5.7L232 155.3V376v8H216v-8V155.3l-90.3 90.3-5.7 5.7L108.7 240l5.7-5.7 104-104 5.7-5.7 5.7 5.7z'
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fast',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      'M217.8 0H224h56 8V16h-8H230.2l-28 112H376h8v16h-8H8 0V128H8 185.8L216.2 6.1 217.8 0zM64 512L36 176H52.1L78.7 496H272v8.2c0 2.7 .3 5.3 .8 7.8H64zM304 303.8s32-104 160-104s160 104 160 104v32h16v16 64 16H624v72c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-72H288v-16-64-16h16v-32zm304 2.7c0-.1-.1-.2-.1-.3c-.1-.3-.2-.6-.4-1c-1-2.4-2.5-6-4.7-10.4c-4.5-8.8-11.7-20.5-22.5-32.2C558.9 239.6 523 215.8 464 215.8s-94.9 23.7-116.2 46.9c-10.8 11.7-18 23.4-22.5 32.2c-2.2 4.4-3.8 7.9-4.7 10.4c-.2 .5-.4 .9-.5 1.3v29.3H608V306.5zM304 415.8h8H616h8v-64H608 320 304v64zm16 16v64H608v-64H320zm74-168a10 10 0 1 1 -20 0 10 10 0 1 1 20 0zm70-6a10 10 0 1 1 0-20 10 10 0 1 1 0 20zm90 6a10 10 0 1 1 -20 0 10 10 0 1 1 20 0z'
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fast',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      'M432 248V16H16V248H432zM0 496V264v-8-8V16 0H16 432h16V16 248v8 8V496v16H432 16 0V496zM16 264V496H432V264H16zM136 96H312h8v8 32 8H304v-8V112H144v24 8H128v-8V104 96h8zm0 256H312h8v8 32 8H304v-8V368H144v24 8H128v-8V360v-8h8z'
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fast',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      'M16 48V176H496V48H16zm0 144V464H496V192H16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM120 272H392h8v16h-8H120h-8V272h8zm0 96H392h8v16h-8H120h-8V368h8zM349 89.8l35 28 35-28 6.2-5 10 12.5-6.2 5-40 32-5 4-5-4-40-32-6.2-5 10-12.5 6.2 5z'
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fast',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      'M72 0H64V8 64H16 0V80 432v16H16 64l0 56v8h8l240 0h8v-8V448h48 16V432 80 64H368 320V8 0h-8H72zM304 432L80 432H64l-48 0V80H64 80 304h16 48V432H320 304zM80 448H304v48L80 496l0-48zM304 64H80V16H304V64zM80 144H304v64H80V144zM64 128v16 64 16H80 304h16V208 144 128H304 80 64zm8 120v8 48 8h8 48 8v-8V256v-8h-8H80 72zm16 16h32v32H88V264zm80-16h-8v8 48 8h8 48 8v-8V256v-8h-8H168zm8 48V264h32v32H176zm72-48v8 48 8h8 48 8v-8V256v-8h-8H256h-8zm16 16h32v32H264V264zM80 328H72v8 48 8h8 48 8v-8V336v-8h-8H80zm8 48V344h32v32H88zm72-48v8 48 8h8 48 8v-8V336v-8h-8H168h-8zm16 16h32v32H176V344zm80-16h-8v8 48 8h8 48 8v-8V336v-8h-8H256zm8 48V344h32v32H264z'
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fast',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      'M72 0H64V8 64H16 0V80 432v16H16 64l0 56v8h8l240 0h8v-8V448h48 16V432 80 64H368 320V8 0h-8H72zM320 432H304L80 432H64l-48 0V80H64 80 304h16 48V432H320zm-16 16v48L80 496l0-48H304zm0-384H80V16H304V64zM80 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm80-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fast',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      'M48 256C48 141.3 143.1 48 260.8 48c54.6 0 104.3 20.1 141.9 53l10.5-12c-40.5-35.4-93.9-57-152.5-57C134.6 32 32 132.1 32 256s102.6 224 228.8 224c58.5 0 112-21.5 152.5-57l-10.5-12c-37.6 33-87.4 53-141.9 53c-12.6 0-24.8-1.1-36.8-3.1V328c0-30.9 25.1-56 56-56c17.6 0 34.2 8.3 44.8 22.4l4.8 6.4 12.8-9.6-4.8-6.4C324 266.7 302.7 256 280 256c-22.6 0-42.8 10.4-56 26.7V256H208v72V457.6C115.9 434.6 48 352.9 48 256z'
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fast',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      'M16 8V0H0V8 176v8 8V432v8 8 56 8H16v-8V448H624v56 8h16v-8V448v-8-8V192v-8-8V8 0H624V8 176H16V8zm0 184H624V432H16V192z'
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fast',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M322.9 8.5L320 7.4l-2.9 1.1-312 120-5.1 2V136 504v8H16v-8V141.5L320 24.6 624 141.5V504v8h16v-8V136v-5.5l-5.1-2-312-120zM104 192H96v8V504v8h16v-8V288H528V504v8h16v-8V200v-8h-8H104zm424 80H112V208H528v64zM199.4 320l-5.2 16H168h-8v8V504v8h16v-8V464H464v40 8h16v-8V344v-8h-8H445.8l-5.2-16H423.8l5.2 16H211l5.2-16H199.4zM176 352H464v96H176V352zm48 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm208-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fast',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      'M283.3 108.7L272 120l11.3 11.3L296 144H400h16V128 24L403.3 11.3 392 0 380.7 11.3 342.6 49.4C306.3 18.6 259.3 0 208 0C93.1 0 0 93.1 0 208H16C16 102 102 16 208 16c46.9 0 89.9 16.8 123.2 44.8l-47.9 47.9zM392 22.6l8 8V128H302.6l-8-8L392 22.6zM132.7 307.3L144 296l-11.3-11.3L120 272H16 0v16V392l12.7 12.7L24 416l11.3-11.3 38.1-38.1C109.7 397.4 156.7 416 208 416c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208H400c0 106-86 192-192 192c-46.9 0-89.9-16.8-123.2-44.8l47.9-47.9zM24 393.4l-8-8L16 288h97.4l8 8L24 393.4z'
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fast',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      'M136 0h-8V8 72H112C50.1 72 0 122.1 0 184v8H16v-8c0-53 43-96 96-96h16v50.8c-37.8 18-64 56.5-64 101.2V496v16H80 272h16V496 240c0-44.7-26.2-83.2-64-101.2V88h64v40l208 29.7 16 2.3V143.8 16.2 0L496 2.3 288 32V72H224V8 0h-8H136zM304 80V45.9L496 18.4V141.6L304 114.1V80zm-91.7 71.1c.4 .2 .8 .4 1.2 .5C247.9 166.2 272 200.3 272 240V400H80V240c0-39.7 24.1-73.8 58.5-88.4c.4-.1 .8-.3 1.2-.5c11.2-4.6 23.5-7.1 36.3-7.1s25.1 2.5 36.3 7.1zM208 132.6c-10.1-3-20.9-4.6-32-4.6s-21.9 1.6-32 4.6V16h64V132.6zM80 496V416H272v80H80z'
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fast',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      'M229.7 189.7l-5.7 5.7-5.7-5.7-88-88L124.7 96 136 84.7l5.7 5.7L216 164.7V8 0h16V8 164.7l74.3-74.3 5.7-5.7L323.3 96l-5.7 5.7-88 88zM48 240v32H16V240H48zm64 0h32v32H112V240zm96 32V240h32v32H208zm96-32h32v32H304V240zm128 0v32H400V240h32zM224 316.7l5.7 5.7 88 88 5.7 5.7L312 427.3l-5.7-5.7L232 347.3V504v8H216v-8V347.3l-74.3 74.3-5.7 5.7L124.7 416l5.7-5.7 88-88 5.7-5.7z'
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fast',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-82.5V334.4c3.9-.7 8.7-1.5 14.2-2.3c14-2 32.4-4.1 49.8-4.1c18.7 0 36 6.6 48.3 12.9c2.8 1.4 5.4 2.9 7.7 4.2V173c-.2-.1-.3-.2-.5-.2c-3.2-1.4-7.8-3.3-13.4-5.2c-11.3-3.8-26.4-7.6-42.1-7.6c-15.8 0-32.9 3.8-46.4 7.7c-6.7 1.9-12.3 3.9-16.3 5.3l-1.2 .5zm136-.4V345.1c2.3-1.4 4.9-2.8 7.7-4.2C284 334.6 301.3 328 320 328c17.4 0 35.9 2.1 49.8 4.1c5.5 .8 10.3 1.6 14.2 2.3V173.5l-1.2-.5c-4-1.5-9.6-3.4-16.3-5.3c-13.5-3.9-30.6-7.7-46.4-7.7c-15.7 0-30.8 3.7-42.1 7.6c-5.6 1.9-10.2 3.8-13.4 5.2c-.2 .1-.3 .2-.5 .2zm-8-13.9c.6-.3 1.3-.6 2-.9c3.5-1.6 8.6-3.7 14.8-5.8c12.3-4.2 29.2-8.4 47.2-8.4c18 0 36.8 4.2 50.9 8.3c7.1 2.1 13.1 4.1 17.3 5.7c2.1 .8 3.8 1.4 5 1.9l1.4 .5 .4 .1 .1 0 0 0 0 0 0 0s0 0-3.1 7.4l3.1-7.4 4.9 2.1V168 344v9.8l-9.6-2 0 0 0 0 0 0-.1 0-.3-.1-1.2-.2c-1.1-.2-2.7-.5-4.7-.9c-4-.7-9.8-1.7-16.6-2.7c-13.6-2-31.2-3.9-47.5-3.9c-15.1 0-29.8 5.4-41 11.1c-5.6 2.8-10.1 5.7-13.3 7.8c-1.6 1.1-2.8 1.9-3.6 2.5c-.4 .3-.7 .5-.9 .7l-.2 .2 0 0 0 0 0 0 0 0 0 0-5 3.9-5-3.9 0 0 0 0 0 0 0 0 0 0-.2-.2c-.2-.1-.5-.4-.9-.7c-.8-.6-2-1.5-3.6-2.5c-3.2-2.1-7.7-4.9-13.3-7.8c-11.2-5.7-25.9-11.1-41-11.1c-16.3 0-33.9 1.9-47.5 3.9c-6.8 1-12.5 2-16.6 2.7c-2 .4-3.6 .7-4.7 .9l-1.2 .2-.3 .1-.1 0 0 0 0 0 0 0-9.6 2V344 168v-5.3l4.9-2.1L120 168l-3.1-7.4 0 0 0 0 0 0 .1 0 .4-.1 1.4-.5c1.2-.5 2.9-1.1 5-1.9c4.2-1.5 10.3-3.6 17.3-5.7c14.1-4.1 32.9-8.3 50.9-8.3c18.1 0 35 4.3 47.2 8.4c6.2 2.1 11.2 4.2 14.8 5.8c.7 .3 1.4 .6 2 .9z'
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fast',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      'M34.3 224c8-55.2 36.4-107.5 83.8-144.5c97.5-76.2 238.3-58.9 314.4 38.6l.1 .1 0 0L464 160V72 64h16v8V184v8h-8H360h-8V176h8 96l-36.1-48.1C349.1 37.4 218.4 21.4 127.9 92.1C84.6 126 58.3 173.6 50.5 224H34.3zm5.9 96h112 8v16h-8H54.9L91 384.1c70.7 90.5 201.4 106.5 291.9 35.8c43.4-33.9 69.6-81.5 77.5-131.9h16.2c-8 55.2-36.4 107.5-83.8 144.5c-97.5 76.2-238.3 58.9-314.4-38.6l-.1-.1 0 0-30.1-40V440v8h-16v-8V328v-8h8z'
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fast',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      'M0 32H448V48H0V32zM16 144H48v32H16V144zm416 0v32H400V144h32zm-224 0h32v32H208V144zM48 336v32H16V336H48zm352 0h32v32H400V336zm-160 0v32H208V336h32zM16 240H48v32H16V240zm416 0v32H400V240h32zm-224 0h32v32H208V240zM48 432v32H16V432H48zm352 0h32v32H400V432zm-160 0v32H208V432h32zM112 240h32v32H112V240zm32 192v32H112V432h32zm160 0h32v32H304V432zm32-192v32H304V240h32z'
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fast',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      'M152 80v37L98 178.7 96 181v3 96 8h8H216h8v-8V184v-3l-2-2.3L168 117V80H336h32V272v16V432H16V80H152zM384 432V288h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H384 368 336 16 0V80 432v16H16 368h16V432zm48-160H384V80h48c53 0 96 43 96 96s-43 96-96 96zM112 187l48-54.9L208 187v85H112V187z'
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fast',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      'M155 8.6L144 4.2V16 272h16V27.8l64 25.6V272h16V48 42.6l-5-2-80-32zM305.6 200.2L335.8 57.7l2.5-11.9-11.9 2.4L272 59V75.4l45.7-9.1L282.1 233.7l19.7-28.1 3.8-5.4zm44.9-17.4c5.6-2.6 11.6-5.1 17.8-7.4l15.6-77.9 1.6-7.8-15.7-3.1-1.6 7.8-17.7 88.4zM256 304H112L64 224H16.4 0l3.6 16L64 512H256V496H76.8L19.9 240h35l43.3 72.2 4.7 7.8H112 256V304zM35.4 192L15.8 94.4l-1.6-7.8L-1.4 89.7 .2 97.6 19 192H35.4zm67 42.4L72.8 52.5 112 32.9V15.1L60.4 40.8l-5.3 2.6 .9 5.8 25.1 155 1 1.4 20.1 28.7zM464 199.8c-128 0-160 104-160 104v32H288v16 64 16h16v72c0 4.4 3.6 8 8 8H616c4.4 0 8-3.6 8-8v-72h16v-16-64-16H624v-32s-32-104-160-104zm144 136H320V306.5c.1-.4 .3-.8 .5-1.3c1-2.4 2.5-6 4.7-10.4c4.5-8.8 11.7-20.5 22.5-32.2c21.3-23.1 57.2-46.9 116.2-46.9s94.9 23.7 116.2 46.9c10.8 11.7 18 23.4 22.5 32.2c2.2 4.4 3.8 7.9 4.7 10.4c.2 .5 .4 .9 .5 1.3v29.3zm-304 16h16H608h16v64h-8H312h-8v-64zm16 144v-64H608v64H320zm64-242a10 10 0 1 0 0 20 10 10 0 1 0 0-20zm70-6a10 10 0 1 0 20 0 10 10 0 1 0 -20 0zm90 6a10 10 0 1 0 0 20 10 10 0 1 0 0-20z'
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fast',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      'M192 0H176V64.7C77.4 72.8 0 155.3 0 256S77.4 439.2 176 447.3V512h16V448c106 0 192-86 192-192v-8h-8H192V80c48 0 91.4 19.2 123.2 50.3l11.2-11.4C291.8 84.9 244.3 64 192 64V0zM176 80.7V431.3C86.3 423.2 16 347.8 16 256S86.3 88.8 176 80.7zM192 432V264H367.8c-4.2 93.5-81.3 168-175.8 168z'
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fast',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      'M224 0C166.6 0 120 46.6 120 104c0 20.6 6 39.8 16.4 56H88 24 16v8V296v8h8H88h32v9.5L34 410.7 32 413v3 88 8h8 92.8 3.6l2.4-2.7L214.4 424h19.2l75.6 85.3 2.4 2.7h3.6H408h8v-8V416v-3l-2-2.3-86-97.2V304h32 64 8v-8V168v-8h-8H360 311.6C322 143.8 328 124.6 328 104C328 46.6 281.4 0 224 0zM136 104c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.5-8.5 43.1-22.4 58.7L277.7 176h17.9H360h56V288H360 320h-8v8 20.5 3l2 2.3L400 419v77H318.8l-75.6-85.3-2.4-2.7h-3.6H210.8h-3.6l-2.4 2.7L129.2 496H48V419l86-97.2 2-2.3v-3V296v-8h-8H88 32V176H88h64.4 17.9l-11.9-13.3C144.5 147.1 136 126.5 136 104zm56 8a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fast',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM168 168v6.5l16 0 0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2-3.6 2.4v4.3V288v8h16v-8V262.9L315.3 229c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H224c-30.9 0-56 25.1-56 56zm72 184h32V320H240v32z'
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fast',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      'M328 136c0-66.3 53.7-120 120-120h8 16 43.7l33.8 50.8 10 104.5-67.9 34-28.4-56.8-2.2-4.4H456 440h-8v8 87.5 .2l0 .3c-.2 25.4-11.6 47.6-29.2 62.5l-2.8 2.4v3.7V496H328V325.7v-6.4l-6.3-1.4-120-26.3-9.7-2.1v9.9V304v40 8.2l-3.2 7.5-17.4 40.5-1.1 2.6 .8 2.7L196.2 496h-83L89.5 410.7l-3.8-13.5 5.5-12.9 20.1-46.9 .6-1.5v-1.6V314.4v-1.7l-.7-1.6L77.9 237.7c-3.9-8.6-5.9-18-5.9-27.4c0-28.2 17.6-52.2 42.3-61.8c-1.9-4.9-3.6-9.9-5.2-15.1c-14.3 5.4-26.7 14.8-36 26.7H72 64c-35.3 0-64 28.7-64 64v88 8H16v-8V224c0-26.3 21.2-47.7 47.5-48c-4.8 10.4-7.5 22.1-7.5 34.3c0 11.7 2.5 23.4 7.4 34.1L96 316.1v16.4L76.5 377.9l-6.6 15.5L68.8 396l.8 2.7L74 415l25.3 91.2L101 512h6.1 99.6 10.5l-2.8-10.1L187.2 404l16.2-37.9 3.9-9.1 .6-1.5v-1.6V344 309.3l104 22.8V504v8h8 88 8v-8V312.1c17.3-15.8 29.1-37.9 31.5-63l.5 .1V240v-.5V160h3.1l29.8 59.6 3.6 7.2 7.2-3.6 80-40 4.9-2.5-.5-5.5-8.6-89.8 67.8-30.1 4.8-2.1V48 40 32h-8H545.6L534.9 16H552h8V0h-8H524.3 520 472 456h-8C375.9 0 316.9 56.1 312.3 127L139.8 33 128 26.5V40c0 34.4 4.9 63.5 13 88c1.8 5.6 3.8 10.9 6 16c14.3 34.2 35 58.4 56 75.2c18.8 15.1 37.6 24.3 51.7 29.6c7.1 2.7 13 4.4 17.2 5.5c2.1 .5 3.8 .9 4.9 1.2c.6 .1 1 .2 1.4 .3l.4 .1 .1 0 0 0 0 0s0 0 1.3-7.9l-1.3 7.9 7.9 1.3 2.6-15.8-7.9-1.3 0 0 0 0 0 0 0 0-.2 0c-.2 0-.6-.1-1-.2c-.9-.2-2.4-.5-4.2-1c-3.7-1-9-2.5-15.5-5c-12.9-4.9-30.1-13.3-47.3-27.1c-32.4-26.1-65.4-72.1-68.7-153.1L308.2 143l1.8 1h2 8 8v-8zM556.3 48h56L565.8 68.7l-.5-5.4-.2-2L564 59.6 556.3 48zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fast',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      'M157.4 25l5.9 5.4L152.4 42.2l-5.9-5.4C132.7 23.9 114.1 16 93.7 16C50.8 16 16 50.8 16 93.7c0 15.4 4.4 29.7 12.1 41.7l4.3 6.7-13.5 8.6L14.6 144C5.4 129.5 0 112.2 0 93.7C0 42 42 0 93.7 0c24.6 0 47 9.5 63.7 25zm-54.1 427L53.7 501.7 48 507.3 36.7 496l5.7-5.7 49.7-49.7C54.8 400.6 32 347 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 59-22.8 112.6-60.1 152.6l49.7 49.7 5.7 5.7L464 507.3l-5.7-5.7-49.7-49.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1zM464 288A208 208 0 1 0 48 288a208 208 0 1 0 416 0zM354.6 25C371.3 9.5 393.7 0 418.3 0C470 0 512 42 512 93.7c0 18.5-5.4 35.8-14.6 50.3l-4.3 6.7-13.5-8.6 4.3-6.7c7.7-12 12.1-26.3 12.1-41.7C496 50.8 461.2 16 418.3 16c-20.4 0-39 7.9-52.8 20.7l-5.9 5.4L348.7 30.4l5.9-5.4zM264 184v8 88h88 8v16h-8H264v88 8H248v-8V296H160h-8V280h8 88V192v-8h16z'
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fast',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      'M256 80V432H16V80H256zm16 0H624V432H272V80zM16 64H0V80 432v16H16 624h16V432 80 64H624 16zm192 80V368H80V144H208zM80 128H64v16V368v16H80 208h16V368 144 128H208 80z'
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fast',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      'M16 128H432V496H16V128zm0-16V16H432v96H16zm432 8v-8V16 0H432 16 0V16v96 8 8V496v16H16 432h16V496 128v-8zM104 208H96v16h8H344h8V208h-8H104zm0 96H96v16h8H344h8V304h-8H104zm0 96H96v16h8H248h8V400h-8H104z'
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fast',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      'M498 173.5l-29.5-20.1-2-1.4H464 432c-.7 0-1.5 0-2.2 0l0-.1-1.4-5.7c-13.1-52-51.9-93.7-102.8-110.5l-3.4-1.1L319 36.5l-27.6 16L286 55.5l1.6 6 15.6 56.5c4.9 17.9 13.4 34.3 24.7 48.5l-80-36.3c-14.7-6.7-30.7-10.1-46.8-10.1h-9c-30.4 0-57.8 13-76.8 33.8C103.7 138.1 85 128 64 128c-35.3 0-64 28.7-64 64s28.7 64 64 64c9.7 0 19-2.2 27.2-6.1c4.6 18 13.9 34.6 27.3 47.9L182 361.3l-68.2 45.4L87.2 424.5l-6.7 4.4 4.4 6.7 27.3 40.9 2.4 3.6h4.3 26.8 2.4l2-1.3 8.1-5.4L239.7 419l34.7 34.7 2.3 2.3H280 456h8v-8V384v-8h-8H353.1l40-48H568h8v-8V231.1v-4.2l-3.5-2.4-59.8-40.9c8.6-51.3-8.9-104.1-47.4-140.2l-8.9-8.3-2.6-2.4-3.6 .3-28.5 2.6-5.5 .5-1.5 5.3-3.3 11.8c4.6 4.3 9 8.7 13.2 13.4c.6-3 1.4-5.9 2.2-8.9l1.9-6.7 19.5-1.7 6.3 5.9c32.7 30.7 48.5 74.7 43.6 118.4zM64 144c17.4 0 32.6 9.2 41 23.1c-10.8 16.4-17 36-17 57.1c0 3.1 .1 6.1 .4 9.2C81.3 237.6 72.9 240 64 240c-26.5 0-48-21.5-48-48s21.5-48 48-48zM228.1 407.4L149.3 460l-6 4H123.2l-20.4-30.7 20-13.3 70.8-47.2 34.6 34.6zM304.7 63.2l19.1-11c44.1 15.8 77.5 52.5 89 98.1l1.4 5.7c.4 1.5 .6 3.1 .5 4.6l-.3 9.5 9.4-1.4c2.6-.4 5.3-.6 8.1-.6h29.5L560 235.3V312H389.3h-3.7l-2.4 2.9L336 371.5V352c0-42-25.2-79.9-64-96l-36.9-15.4-7.4-3.1-6.2 14.8 7.4 3.1 36.9 15.4C298.6 284.4 320 316.5 320 352v32 6.7V392v0h8 8 16v0h96v48H283.3L129.8 286.5c-16.5-16.5-25.8-39-25.8-62.3c0-48.7 39.5-88.2 88.2-88.2h9c13.9 0 27.6 3 40.2 8.7L371 203.6l7.1 3.2 3.4-7.1c.2-.4 .4-.8 .6-1.2l3.9-7.7-7.9-3.3c-.4-.2-.7-.3-1.1-.5c-28.6-15.5-49.6-42-58.3-73.4l-14-50.5zM496 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fast',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zm351 369.8l-50.7 50.7-43-43-5.7-5.7-5.7 5.7-37 37-44.1-44.1 0 0-37-37-2.3-2.3h-3.3H48 40l0 16h8 87.2l50.1 50.1 5.7 5.7 0 0 28.7 28.7 5.7 5.7 5.7-5.7 37-37 43 43 5.7 5.7 5.7-5.7L376 388.7v-6.9l-8.8-6.9zm-29-308.6l-70.6 66.9 12.7 10L346.9 80h79.5l73.9 62.1 2.2 1.9h2.9H600h8V128h-8H508.4L434.5 65.9 432.2 64h-2.9H343.8h-3.2l-2.3 2.2zm24.5 142l12.5-12.5 5.7-5.7-11.3-11.3-5.7 5.7-13.9 13.9 12.6 10zM193.6 74.7l12.8 10.1 5.7-4.8h65L294 64H209.3c-1.9 0-3.7 .7-5.1 1.9l-10.5 8.8zM74.8 144L54.6 128H40 32v16h8H74.8zM600 352h8V336h-8H524.6l20.3 16H600z'
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fast',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M448 304a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0 16c-77.6 0-142.3-55.2-156.9-128.5C186.4 219.1 112 314.1 112 424v72H328h8v0h32V482.7c0-19.1-15.5-34.7-34.7-34.7H288h-8v-8l0-40c0-26.5-21.5-48-48-48H200h-8V336h8 32c35.3 0 64 28.7 64 64v30.3l125.5-85 12.5-8.5V352 496h46V316.8c-10.3 2.1-21 3.2-32 3.2zM608 160c0 71.6-47.1 132.3-112 152.7V504v8h-8H426h-8v-8V367.1L322.1 432h11.2c28 0 50.7 22.7 50.7 50.7V504v8h-8H184v0H104 96v-8V424 168c0-30.9-25.1-56-56-56H32V96h8c39.8 0 72 32.2 72 72V334.7c28.8-77.4 94-138 176.8-159.2c-.5-5.1-.8-10.3-.8-15.6C288 71.6 359.6 0 448 0s160 71.6 160 160zM373 65.8L410.8 96h74.4L523 65.8l13-10.4V72v96c0 48.6-39.4 88-88 88s-88-39.4-88-88V72 55.4l13 10.4zM376 168c0 39.8 32.2 72 72 72s72-32.2 72-72V88.6l-27 21.6-2.2 1.8H488 408h-2.8l-2.2-1.8L376 88.6V168zm24-8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM232 16V56h40 8V72h-8H232v40 8H216v-8V72H176h-8V56h8 40V16 8h16v8z'
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fast',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      'M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm46.1-18.7C296.3 81.4 277.9 96 256 96s-40.3-14.6-46.1-34.7C136.5 78.7 78.7 136.5 61.3 209.9C81.4 215.7 96 234.1 96 256s-14.6 40.3-34.7 46.1c17.3 73.4 75.1 131.2 148.5 148.5c5.8-20 24.2-34.7 46.1-34.7s40.3 14.6 46.1 34.7c73.4-17.3 131.2-75.1 148.5-148.5c-20-5.8-34.7-24.2-34.7-46.1s14.6-40.3 34.7-46.1C433.3 136.5 375.5 78.7 302.1 61.3zM466.7 208.1c25.3 1.4 45.3 22.3 45.3 47.9s-20.1 46.5-45.3 47.9c-18.3 80.8-81.9 144.4-162.7 162.7C302.5 491.9 281.6 512 256 512s-46.5-20.1-47.9-45.3C127.3 448.4 63.6 384.7 45.3 303.9C20.1 302.5 0 281.6 0 256s20.1-46.5 45.3-47.9C63.6 127.3 127.3 63.6 208.1 45.3C209.5 20.1 230.4 0 256 0s46.5 20.1 47.9 45.3c80.8 18.3 144.4 81.9 162.7 162.7zM256 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm384 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fast',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      'M16 231.6l240 165 240-165V200L256 20 16 200v31.6zM496 251L256 416 16 251V496H496V251zM0 192L256 0 512 192v48V496v16H496 16 0V496 240 192z'
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fast',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      'M16 64v64H40 56 80V64H16zm24 80H16 0V128 64 48H16 80 96V64v64 16H80 56V256h72V224 208h16 64 16v16 64 16H208 144 128V288 272H56V416h72V384 368h16 64 16v16 64 16H208 144 128V448 432H48 40v-8V264 144zM144 416v16 16h64V384H144v32zm0-128h64V224H144v32 16 16zM168 88h8H496h8v16h-8H176h-8V88zM296 248h8H496h8v16h-8H304h-8V248zm0 160h8H496h8v16h-8H304h-8V408z'
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fast',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      'M192 368c-51.8 0-98.4-22.4-130.6-58.1C84.8 326.4 113.3 336 144 336h16c70.7 0 128-57.3 128-128V192c0-53-43-96-96-96s-96 43-96 96c0 30.9 25.1 56 56 56s56-25.1 56-56v-8-8H192v8 8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-44.2 35.8-80 80-80s80 35.8 80 80v16c0 61.9-50.1 112-112 112H144C73.3 320 16 262.7 16 192C16 94.8 94.8 16 192 16s176 78.8 176 176s-78.8 176-176 176zM0 192C0 298 86 384 192 384c50.1 0 95.8-19.2 130-50.7l.4 .4L493.5 504.9l5.7 5.7 11.3-11.3-5.7-5.7L333.7 322.3l-.4-.4c31.5-34.2 50.7-79.8 50.7-130C384 86 298 0 192 0S0 86 0 192z'
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fast',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      'M456 104V96H440v8V504v8h16v-8V104zM328 192H312v8V504v8h16v-8V200v-8zM200 296v-8H184v8V504v8h16v-8V296zM72 392v-8H56v8V504v8H72v-8V392z'
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fast',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      'M528.1 512l-20.3-16H88l66.7-160H305.1l-20.3-16H144L70.7 496 64 512H81.3 528.1zM464 144C464 64.5 399.5 0 320 0c-51.5 0-96.8 27.1-122.2 67.8l12.6 10C232.9 40.7 273.5 16 320 16c70.7 0 128 57.3 128 128c0 35.7-14.6 68-38.2 91.2l12.6 10c25.7-26 41.5-61.7 41.5-101.2zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fast',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      'M32 32h8H536h8v8V432v8H528v-8V48H48V432v8H32v-8V40 32zM0 464H8 256V392v-8h8H408h8v8 72H568h8v16h-8H416h-8H264h-8H8 0V464zm400 0V400H272v64H400z'
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fast',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      'M256 496c51.3 0 98.9-16.1 137.9-43.5c2 5.1 4.2 10 6.8 14.8C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C369.8 0 466.3 74.3 499.6 177l-11.5 17.6C461 91.8 367.3 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zM144 144v64h32V144H144zm-16-16h16 32 16v16 64 16H176 144 128V208 144 128zm112 16v64h32V144H240zm0-16h32 16v16 64 16H272 240 224V208 144 128h16zm96 16v64h32V144H336zm-16-16h16 32 16v16 64 16H368 336 320V208 144 128zM447.9 344.3c-10.4 15.9-15.9 34.5-15.9 53.5V400c0 53 43 96 96 96s96-43 96-96v-2.1c0-19-5.5-37.6-15.9-53.5L528 221.3l-80.1 123zm-13.4-8.7l84-128.9L528 192l9.5 14.7 84 128.9c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z'
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fast',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      'M115 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 99 64a64 64 0 1 0 128 0zm-.8 188.6l-3.4-7.2-14.5 6.8 3.4 7.2L270.3 384H235 187 139 91 55.6l58.6-124.6 3.4-7.2-14.5-6.8-3.4 7.2-64 136L30.3 400H43 83V504v8h8 48 8v-8V400h32V504v8h8 48 8v-8V400h40 12.6l-5.4-11.4-64-136zM99 400h32v96H99V400zm128 0v96H195V400h32zM107.3 160l-2.3 3.9-84.9 144L16 314.8 29.8 323l4.1-6.9L116.4 176h93l82.6 140.1 4.1 6.9 13.8-8.1-4.1-6.9-84.9-144-2.3-3.9H214 111.9h-4.6zM435 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 419 64a64 64 0 1 0 128 0zM423.9 160h-4.8l-2.3 4.2-76.9 144-3.8 7.1 14.1 7.5 3.8-7.1L428.7 176H537.2l74.7 139.8 3.8 7.1 14.1-7.5-3.8-7.1-76.9-144-2.3-4.2H542 423.9zM419 280H403v8V504c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V384h32V504c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V288v-8H547v8V496H515V376c0-4.4-3.6-8-8-8H459c-4.4 0-8 3.6-8 8V496H419V288v-8z'
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fast',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      'M213.6 27.4L224 36.2l10.4-8.8c8.4-7.1 19.2-11.4 31.1-11.4c20.9 0 38.7 13.3 45.3 32l5.1 14.3L330.3 58c4.3-1.3 8.9-2 13.7-2c26.5 0 48 21.5 48 48c0 4.8-.7 9.4-2 13.7l-4.3 14.6 14.3 5.1c18.7 6.6 32 24.4 32 45.3c0 11.9-4.3 22.7-11.4 31.1L411.8 224l8.8 10.4c7.1 8.4 11.4 19.2 11.4 31.1c0 20.9-13.3 38.7-32 45.3l-14.3 5.1 4.3 14.6c1.3 4.3 2 8.9 2 13.7c0 23.8-17.3 43.5-40 47.3v16.2c31.6-3.9 56-30.9 56-63.5c0-6.3-.9-12.5-2.6-18.2c24.8-8.8 42.6-32.5 42.6-60.3c0-15.8-5.7-30.2-15.2-41.4c9.5-11.2 15.2-25.6 15.2-41.4c0-27.9-17.8-51.6-42.6-60.3c1.7-5.8 2.6-11.9 2.6-18.2c0-35.3-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C317 17.8 293.3 0 265.4 0C249.6 0 235.2 5.7 224 15.2C212.8 5.7 198.4 0 182.6 0C154.7 0 131 17.8 122.2 42.6C116.5 40.9 110.3 40 104 40c-35.3 0-64 28.7-64 64c0 6.3 .9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3C40.9 331.5 40 337.7 40 344c0 32.6 24.4 59.6 56 63.5V391.3c-22.7-3.8-40-23.6-40-47.3c0-4.8 .7-9.4 2-13.7l4.3-14.6L48 310.7c-18.7-6.6-32-24.4-32-45.3c0-11.9 4.3-22.7 11.4-31.1L36.2 224l-8.8-10.4C20.3 205.3 16 194.4 16 182.6c0-20.9 13.3-38.7 32-45.3l14.3-5.1L58 117.7c-1.3-4.3-2-8.9-2-13.7c0-26.5 21.5-48 48-48c4.8 0 9.4 .7 13.7 2l14.6 4.3L137.3 48c6.6-18.7 24.4-32 45.3-32c11.9 0 22.7 4.3 31.1 11.4zM224 471.5l-3.9 1-76.1 19v-87l76.1 19 3.9 1 3.9-1 76.1-19v87l-76.1-19-3.9-1zM144 508l80-20 80 20 16 4V495.5v-95V384l-16 4-80 20-80-20-16-4v16.5 95V512l16-4zm91-376.3L224 120l-11 11.7-18.9 20.2-27.7-.9-16-.5 .5 16 .9 27.7L131.7 213 120 224l11.7 11 20.2 18.9-.9 27.7-.5 16 16-.5 27.7-.9L213 316.3 224 328l11-11.7 18.9-20.2 27.7 .9 16 .5-.5-16-.9-27.7L316.3 235 328 224l-11.7-11-20.2-18.9 .9-27.7 .5-16-16 .5-27.7 .9L235 131.7zm19.4 36.2L281 167l-.9 26.6-.2 7.3 5.3 5L304.6 224l-19.4 18.2-5.3 5 .2 7.3L281 281l-26.6-.9-7.3-.2-5 5.3L224 304.6l-18.2-19.4-5-5.3-7.3 .2L167 281l.9-26.6 .2-7.3-5.3-5L143.4 224l19.4-18.2 5.3-5-.2-7.3L167 167l26.6 .9 7.3 .2 5-5.3L224 143.4l18.2 19.4 5 5.3 7.3-.2z'
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fast',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zm226.3-26.3l-5.7-5.7L232 292.7l5.7 5.7L312 372.7V176v-8h16v8V372.7l74.3-74.3 5.7-5.7L419.3 304l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88z'
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fast',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      'M288 5.5l5.2 4.5L482 171.7c-4.9 2.7-9.5 5.8-13.8 9.2L288 26.5 80 204.8V496H208V312v-8h8H360h8v8V496h16l0 16H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zM224 496H352V320H224V496zM528 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H624 432 416V496 336 320h16 32V256zm-32 80V496H624V336H592 576 480 464 432z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fast',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M503.2 260.3l-5.5 5.5-104 104-5.7 5.7-11.3-11.3 5.7-5.7 90.3-90.3-441.4 0 90.3 90.3 5.7 5.7-11.3 11.3-5.7-5.7-104-104L.8 260.1l5.7-5.7 104-104 5.7-5.7 11.3 11.3-5.7 5.7L31.4 252.1l442.3 0-91.5-98.6-5.4-5.9 11.7-10.9 5.4 5.9 104 112 5.2 5.6z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fast',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      'M208 48l0 200v16l0 200L80 464 80 48l128 0zm16 200l0-200V32l-16 0L80 32 64 32V48l0 200H0l0 16H64l0 200v16H80l128 0h16l0-16 0-200 64 0V400v16h16H432h16V400 264h64V248H448l0-136V96H432L304 96H288v16l0 136-64 0zm80 0l0-136 128 0 0 136v16V400H304V264 248z'
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fast',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zM192 256V144h64V256v16h16 64v1.4l-112 112-112-112V272h64 16V256zm20.7 140.7L224 408l11.3-11.3L352 280v-8V256H336 288 272V240 144 128H256 192 176v16 96 16H160 112 96v16 8L212.7 396.7z'
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fast',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM120 224h-8v8V360v80 8h16v-8V368h72c39.8 0 72-32.2 72-72s-32.2-72-72-72H120zm80 128H128V240h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z'
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fast',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zm90.7 240H298L248 411.4 199.7 245.8 198 240H186l-1.7 5.8L136 411.4 86 240H69.3l59 202.2L130 448h12l1.7-5.8L192 276.6l48.3 165.7L242 448h12l1.7-5.8 59-202.2z'
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fast',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      'M208 304l16 0 208 0 0-96-208 0-16 0 0-16 0-112-9.4 0L22.6 256l176 176 9.4 0 0-112 0-16zM192 448L11.3 267.3 0 256l11.3-11.3L192 64l16 0 16 0 0 16 0 96 0 16 16 0 192 0 16 0 0 16 0 96 0 16-16 0-192 0-16 0 0 16 0 96 0 16-16 0-16 0z'
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fast',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      'M530.2 103.4C554.8 62 586.7 32 632 32h8V48h-8c-36.8 0-64.5 24-88.1 63.6c-16 26.9-29.6 60.1-42.4 95.6c-2.7-7.8-5.5-15.6-8.4-23.4c11.1-29.4 23.2-57 37.1-80.4zM421.8 408.6C397.2 450 365.3 480 320 480s-77.2-30-101.8-71.4c-24.5-41.2-43.2-95.9-61.5-149.4l-.2-.6c-18.6-54.2-36.8-107.4-60.4-147C72.5 72 44.8 48 8 48H0V32H8c45.3 0 77.2 30 101.8 71.4c24.5 41.2 43.2 95.9 61.5 149.4l.2 .6c18.6 54.2 36.8 107.4 60.4 147C255.5 440 283.2 464 320 464s64.5-24 88.1-63.6c16-26.9 29.6-60.1 42.4-95.6c2.7 7.8 5.5 15.6 8.4 23.4c-11.1 29.4-23.2 57-37.1 80.4zm-189.9-297c-16 26.9-29.6 60.1-42.4 95.6c-2.7-7.8-5.5-15.6-8.4-23.4c11.1-29.4 23.2-57 37.1-80.4C242.8 62 274.7 32 320 32s77.2 30 101.8 71.4c24.5 41.2 43.2 95.9 61.5 149.4l0 0 0 0 .2 .6c18.6 54.2 36.8 107.4 60.4 147C567.5 440 595.2 464 632 464h8v16h-8c-45.3 0-77.2-30-101.8-71.4c-24.5-41.2-43.2-95.9-61.5-149.4l-.2-.6c-18.6-54.2-36.8-107.4-60.4-147C384.5 72 356.8 48 320 48s-64.5 24-88.1 63.6zm-122.1 297C85.2 450 53.3 480 8 480H0V464H8c36.8 0 64.5-24 88.1-63.6c16-26.9 29.6-60.1 42.4-95.6c2.7 7.8 5.5 15.6 8.4 23.4c-11.1 29.4-23.2 57-37.1 80.4z'
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fast',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm37-384L192.8 215.6c-8.6 7.6-15.7 16.5-21.1 26.3c-7.5 13.7-11.7 29.3-11.7 46v0c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-4.3 0-8.6 .3-12.8 .8L317.3 128H293zM256.1 368A80 80 0 1 1 256 208a80 80 0 1 1 .1 160z'
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fast',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      'M136 8V0H120V8 32H88 80V48h8 32V96H56 40v16 16l36.9 96H64 56v16h8H78.7l-23 144H71.9l23-144h66.2l23 144h16.2l-23-144H192h8V224h-8H179.1L216 128V112 96H200 136V48h32 8V32h-8H136V8zM120 112h16 64v13l-38.1 99H94.1L56 125V112h64zM48 416H44.3l-2.4 2.9-40 48L0 469.1V472v32 8H8 248h8v-8V472v-2.9l-1.9-2.2-40-48-2.4-2.9H208 48zM16 474.9L51.7 432H204.3L240 474.9V496H16V474.9z'
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fast',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      'M400 192V464h16V192C416 86 330 0 224 0S32 86 32 192V464H48V192C48 94.8 126.8 16 224 16s176 78.8 176 176zM8 496H0v16H8 440h8V496h-8H8z'
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fast',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm137.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm134.2 19.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fast',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      'M424 8V0H408V8 120v8h16v-8V8zM261.7 42.3L256 36.7 244.7 48l5.7 5.7 80 80 5.7 5.7L347.3 128l-5.7-5.7-80-80zm320 11.3l5.7-5.7L576 36.7l-5.7 5.7-80 80-5.7 5.7L496 139.3l5.7-5.7 80-80zM272 320a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm304 0c0-43.6-17.4-83.1-45.7-112H624V432H576 560 530.3c28.3-28.9 45.7-68.4 45.7-112zm0 128h48 16V432 208 192H624 512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H16 0v16V432v16H16 64v56 8H80v-8V448H320c26.7 20.1 60 32 96 32s69.3-11.9 96-32l0 0h48v56 8h16v-8V448zM80 432H64 16V208H301.7C273.4 236.9 256 276.4 256 320s17.4 83.1 45.7 112H80zm32-112a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 288a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fast',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      'M16 32h8H224 424h8v8 64 8H416v-8V48H232l0 416h80 8v16h-8H224 136h-8V464h8 80l0-416H32v56 8H16v-8V40 32z'
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fast',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm60.7-179.3L328 344l-11.3 11.3L304 368H160 144V352 208l12.7-12.7L168 184l11.3 11.3 25.4 25.4L216 232l11.3-11.3 73.4-73.4L312 136l11.3 11.3 41.4 41.4L376 200l-11.3 11.3-73.4 73.4L280 296l11.3 11.3 25.4 25.4zm-48-48L353.4 200 312 158.6l-84.7 84.7L216 254.6l-11.3-11.3L168 206.6l-8 8V352H297.4l8-8-36.7-36.7L257.4 296l11.3-11.3z'
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fast',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      'M64 0h8H312h8V8 112h-1c39.9 35.2 65 86.7 65 144c0 56.9-24.7 108-64 143.1V504v8h-8L72 512H64v-8l0-104.9C24.7 364 0 312.9 0 256c0-57.3 25.1-108.8 65-144H64V8 0zM80 412l0 84 224 0V412c-31.5 22.7-70.2 36-112 36s-80.5-13.4-112-36zM304 16H80v84c31.5-22.7 70.2-36 112-36s80.5 13.4 112 36V16zm64 240A176 176 0 1 0 16 256a176 176 0 1 0 352 0zM200 160v92l60.8 45.6 6.4 4.8-9.6 12.8-6.4-4.8-64-48L184 260v-4V160v-8h16v8z'
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fast',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM348.8 187L390 48H557.8l-16 64h16.5l17.5-70.1 2.5-9.9H568 384.2h-.4H168h-6.2l-1.5 6.1 0 .1L174 49l.2-1h199l-38 128.3L348.8 187zM304.7 335.7L291.2 325 250 464H168h-8v16h8 87.8 .4H344h8V464h-8H266.7l38-128.3z'
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fast',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      'M16 32v8V464H504h8v16h-8H8 0v-8V40 32H16zM352 64h8H472h8v8V184v8H464v-8V91.3L293.7 261.7l-5.7 5.7-5.7-5.7L208 187.3l-98.3 98.3-5.7 5.7L92.7 280l5.7-5.7 104-104 5.7-5.7 5.7 5.7L288 244.7 452.7 80H360h-8V64zm8 320h-8V368h8 92.7l-90.3-90.3-5.7-5.7L368 260.7l5.7 5.7L464 356.7V264v-8h16v8V376v8h-8H360z'
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fast',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      'M400 144V128c0-44.2-35.8-80-80-80c-16.1 0-31.1 4.8-43.7 12.9l-12.9 8.4-8.9-12.6C237.1 32.1 208.4 16 176 16c-53 0-96 43-96 96v21.5 11.3l-10.7 3.8C38.2 159.5 16 189.2 16 224v80H96h68.1l-20.7 16H96 16 0V304 224c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96c53 0 96 43 96 96v80 16H496 416 400 329l4-16h83 80V224c0-44.2-35.8-80-80-80H400zM198.3 486.9L220 400l4-16H207.5 160 144V368v-8L299.6 239.8 320 224l-6.3 25.1L292 336l-4 16h16.5H352h16v16 8L212.4 496.2 192 512l6.3-25.1zM224 368h20.5l-5 19.9-20.8 83.3L352 368.1V368H288 267.5l5-19.9 20.8-83.3L160 367.9v.1h64z'
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fast',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM357.7 141.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L160 188.7l5.7 5.7L224 252.7 346.3 130.3l5.7-5.7L363.3 136l-5.7 5.7z'
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fast',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      'M96 0h8 40c83.9 0 152 68.1 152 152v16 96 8H280v-8V176H248C164.1 176 96 107.9 96 24V8 0zM280 160v-8c0-75.1-60.9-136-136-136H112v8c0 75.1 60.9 136 136 136h32zM148.8 320h2.8H376h8v8 56 8h-8H256v24H394.8l120.9-83.1 6.6-4.5 4.5 6.6 36.3 52.7 4.5 6.6-6.6 4.5L398.5 510.6l-2 1.4h-2.5H8 0V496H8 391.5L545.4 390.2l-27.2-39.6-116.3 80-2 1.4h-2.5H248h-8v-8V384v-8h8H368V336H154.4L76.6 398.2 74.4 400H71.6 8 0V384H8 68.8l77.8-62.2 2.2-1.8zM480 24c0 83.9-68.1 152-152 152v-8-8c75.1 0 136-60.9 136-136V16H432c-50 0-93.7 27-117.3 67.2c-2.4-5.9-5.1-11.6-8-17.2C334.1 26.1 380 0 432 0h40 8V8 24z'
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fast',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      'M448 512C200.6 512 0 311.4 0 64L0 32 144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448zM16 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L372 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C222.2 348.3 163.7 289.8 126 218.5l-6.2-11.7 10.3-8.3L203.4 140 135.8 18.2 16 44.8 16 64zM413.7 10.3l88 88 5.7 5.7-5.7 5.7-88 88-5.7 5.7L396.7 192l5.7-5.7L476.7 112H296h-8V96h8H476.7L402.3 21.7 396.7 16 408 4.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fast',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM231.6 140.8c5.6 .2 11.3 .7 17 1.6c7.5 1.1 30.5 5.3 38.4 7.3l7.8 1.9-3.9 15.5-7.8-1.9c-7.2-1.8-29.6-5.9-36.9-7c-23.1-3.4-43.8-.9-59 5.6c-15.3 6.5-24.3 16.6-26.4 28.3c-2.7 14.8 3.4 26.4 15.8 34.4c14 8.9 30.6 13.5 46.6 18c2.4 .7 4.9 1.4 7.3 2c20.3 5.8 42.4 12.1 58.2 23c18.1 12.4 26.2 31.7 22.3 53.3c-3.7 20.1-17.5 33.9-36.3 41.4c-12.4 5-27.2 7.4-43.2 7.3v44.7h-16V370.6c-2.7-.3-5.4-.6-8.1-1l0 0c-13.2-2-34.8-9-49.7-13.8l0 0c-5.2-1.7-10.5-3.3-15.7-5l4.8-15.3c5.5 1.7 11 3.5 16.5 5.2l0 0c15.1 4.8 34.9 11.2 46.6 13c23.3 3.4 43.8 1.7 58.9-4.4c14.9-6 24-16 26.5-29.5c2.8-15.5-2.6-28.4-15.6-37.2c-13.2-9.1-32.5-14.8-53.5-20.8c-2-.6-4.1-1.2-6.2-1.7c-17.9-5-36.3-10.2-52-20.2c-17.9-11.4-26.8-29.6-23-50.8c3.4-18.6 17.4-32.2 35.9-40.1c10.1-4.3 21.9-7.1 34.6-8V96h16v44.8z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fast',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M133.7 469.7l-5.7 5.7-5.7-5.7-104-104L12.7 360 24 348.7l5.7 5.7L120 444.7V40 32h16v8V444.7l90.3-90.3 5.7-5.7L243.3 360l-5.7 5.7-104 104zM296 464h-8V448h8 80 8v16h-8H296zm0-144h-8V304h8H440h8v16h-8H296zm0-128h-8V176h8H504h8v16h-8H296zm0-128h-8V48h8H568h8V64h-8H296z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fast',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      'M331.4 123.5l-31-93.1c-3.7 1.9-7.4 3.9-11 6.2L222.5 78.4l50.9 81.4 58-36.3zM315.1 24l30.4 91.2c4.9-2.1 10.1-3.2 15.5-3.2c7.9 0 15.2 2.3 21.4 6.4l68.3-68.3C426.8 28.9 395.4 16 361 16c-15.7 0-31.2 2.7-45.9 8zm35.5 106.4l0 0c-.6 .3-1.2 .7-1.8 1l-12.1 7.6s0 0 0 0l-54.8 34.2-13.6 8.5-8.5-13.6L208.9 86.8l-8.5-13.6L214 64.8 280.9 23c24-15 51.7-23 80-23c83.4 0 151 67.6 151 151v5.6c0 14.9-2.1 29.6-6.2 43.5c-.3 1-.6 2.1-.9 3.1c-1.3 4.1-2.7 8.1-4.3 12l0 0c-12.2 30.2-33.7 56.4-62.2 74.2l-25.7 16s0 0 0 0L397.6 315l0 0-94 58.7s0 0 0 0L290.4 382l0 0-90.6 56.6s0 0 0 0l-12.6 7.9 0 0L95.9 503.5 82.4 512l-8.5-13.6L23 417l-8.5-13.6L28.1 395l342.5-214c5.9-3.7 10.2-9.4 12.2-16c.5-1.5 .8-3.1 1-4.7c.2-1.2 .2-2.4 .2-3.7V151c0-12.7-10.3-23-23-23c-3.6 0-7.2 .8-10.4 2.5zm43 49.2c-3.6 5.9-8.5 11.1-14.6 14.9l-72 45 90.6 56.6 32.3-20.2c25.3-15.8 44.5-38.9 55.5-65.7l-91.8-30.6zm97 15.5c3.5-12.4 5.4-25.3 5.4-38.5V151c0-34.4-12.9-65.8-34.1-89.7l-68.3 68.3c4 6.1 6.4 13.5 6.4 21.4v5.6c0 2.7-.2 5.4-.7 8l91.4 30.5zM382.5 305.5L292 248.9l-92.1 57.6 90.6 56.6 92.1-57.6zm-107.2 67l-90.6-56.6L96.7 371l90.6 56.6 88.1-55.1zM172.1 437L81.6 380.4l-45 28.1L87.4 490 172.1 437z'
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fast',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM187 384H162.7l74.1-64.8c-4.2 .6-8.5 .8-12.8 .8c-53 0-96-43-96-96s43-96 96-96s96 43 96 96v0c0 16.7-4.3 32.4-11.7 46c-5.4 9.8-12.5 18.8-21.1 26.3L187 384zm37-80a80 80 0 1 0 -.1-160 80 80 0 1 0 .1 160z'
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fast',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      'M194.3 86.8C205.9 63.7 229.3 48 256 48s50.1 15.7 61.7 38.8l3.9 7.8 7.4-4.6C339.4 83.7 351.5 80 364.5 80c33.4 0 61.6 24.5 68.1 57.6l1.3 6.6 6.8-.2c.4 0 .9 0 1.3 0c29.6 0 54 24.8 54 56c0 7.5-1.4 14.6-4 21.1l-2.9 7.4 14.9 5.8 2.9-7.4c3.3-8.3 5.1-17.4 5.1-26.9c0-37.9-28.6-69.3-65.2-71.8C436.8 91.3 403.9 64 364.5 64c-13.1 0-25.5 3-36.6 8.4C312.8 48.2 286.3 32 256 32s-56.8 16.2-71.9 40.4C173 67 160.6 64 147.5 64c-39.4 0-72.3 27.3-82.3 64.2C28.6 130.7 0 162.1 0 200c0 9.5 1.8 18.6 5.1 26.9L8 234.4l14.9-5.8L20 221.1c-2.5-6.5-4-13.6-4-21.1c0-31.2 24.4-56 54-56c.4 0 .9 0 1.3 0l6.8 .2 1.3-6.6c6.5-33 34.7-57.6 68.1-57.6c13 0 25.1 3.7 35.5 10.1l7.4 4.6 3.9-7.8zM112 431.8V421.7l-9.1-4.3C51.5 393 16 340.6 16 280v-8H496v8c0 60.6-35.5 113-86.9 137.4l-9.1 4.3v10.1V464H112V431.8zM512 256H496 16 0v16 8c0 67 39.2 124.9 96 151.8V464v16h16H400h16V464 431.8c56.8-27 96-84.8 96-151.8v-8V256z'
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fast',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      'M160 96c0 35.3-28.7 64-64 64c-10.7 0-20.9-2.6-29.7-7.3c-7.2 13.1-13 27-17.3 41.6l-15.3-4.6C38.4 173.5 45 158 53.1 143.5C40.1 131.8 32 114.8 32 96c0-35.3 28.7-64 64-64c18.8 0 35.8 8.1 47.5 21.1c14.5-8.1 30-14.6 46.2-19.5l4.6 15.3c-14.6 4.3-28.5 10.2-41.6 17.3c4.7 8.9 7.3 19 7.3 29.7zm303.1 98.3c-4.3-14.6-10.2-28.5-17.3-41.6c-8.9 4.7-19 7.3-29.7 7.3c-35.3 0-64-28.7-64-64c0-10.7 2.6-20.9 7.3-29.7c-13.1-7.2-27-13-41.6-17.3l4.6-15.3C338.5 38.4 354 45 368.5 53.1C380.2 40.1 397.2 32 416 32c35.3 0 64 28.7 64 64c0 18.8-8.1 35.8-21.1 47.5c8.1 14.5 14.6 30 19.5 46.2l-15.3 4.6zM152.7 445.7c13.1 7.1 27 13 41.6 17.3l-4.6 15.3c-16.2-4.8-31.7-11.4-46.2-19.5C131.8 471.9 114.8 480 96 480c-35.3 0-64-28.7-64-64c0-18.8 8.1-35.8 21.1-47.5c-8.1-14.5-14.6-30-19.5-46.2l15.3-4.6c4.3 14.6 10.2 28.5 17.3 41.6c8.9-4.7 19-7.3 29.7-7.3c35.3 0 64 28.7 64 64c0 10.7-2.6 20.9-7.3 29.7zm293.1-86.4c7.1-13.1 13-27 17.3-41.6l15.3 4.6c-4.8 16.2-11.4 31.7-19.5 46.2C471.9 380.2 480 397.2 480 416c0 35.3-28.7 64-64 64c-18.8 0-35.8-8.1-47.5-21.1c-14.5 8.1-30 14.6-46.2 19.5l-4.6-15.3c14.6-4.3 28.5-10.2 41.6-17.3c-4.7-8.9-7.3-19-7.3-29.7c0-35.3 28.7-64 64-64c10.7 0 20.9 2.6 29.7 7.3zm-293-206.5h8 56l8 0v8 56l0 8h-16l0-8V181.7C184.3 197.3 168 224.8 168 256c0 48.6 39.4 88 88 88h8v16h-8c-57.4 0-104-46.6-104-104c0-36.5 18.8-68.7 47.3-87.2H160.8h-8l0-16zM359.2 360h-8-56-8v-8V296l0-8 16 0v8 35.1C327.7 315.4 344 288 344 256.8c0-48.6-39.4-88-88-88h-8v-16h8c57.4 0 104 46.6 104 104c0 36.5-18.8 68.7-47.3 87.2h38.5 8v16zM464 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM464 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fast',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM208 512c-22.1 0-40-17.9-40-40V456v-8h16v8 16c0 13.3 10.7 24 24 24s24-10.7 24-24V376v-8h16v8 96c0 22.1-17.9 40-40 40zM456 368h16c17.7 0 32 14.3 32 32v16H488V400c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V464h-8-8V448h8 16 8v8 24c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm-160 0h8 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H312v40 8H296v-8V456 376v-8zm16 80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H312v64z'
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fast',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      'M388.8 336l4 2.7 31.5 21c31.2 20.8 66.7 33.9 103.6 38.5V113.8c-36.9 4.6-72.4 17.7-103.6 38.5l-31.5 21-4 2.7H384 16V336H384h4.8zm168.7 64H624V112H557.5c-4.5 0-9 .1-13.5 .4V399.6c4.5 .3 9 .4 13.5 .4zM16 352H0V336 176 160H16 384l31.5-21c42.1-28 91.5-43 142-43H624h16v16V400v16H624 557.5c-50.5 0-100-15-142-43L384 352H16zM240 240v32h64V240H240zm-16-16h16 64 16v16 32 16H304 240 224V272 240 224z'
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fast',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-381.7-5.7l-5.7 5.7 5.7 5.7 104 104 5.7 5.7L251.3 360l-5.7-5.7L155.3 264 376 264l8 0 0-16-8 0-220.7 0 90.3-90.3 5.7-5.7L240 140.7l-5.7 5.7-104 104z'
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fast',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      'M624 16H272V128H256V16 0h16H624h16V16 496v16H624 384V496H624V16zM549.7 322.3l5.7 5.7L544 339.3l-5.7-5.7L488 283.3V440v8H472v-8V283.3l-50.3 50.3-5.7 5.7L404.7 328l5.7-5.7 64-64 5.7-5.7 5.7 5.7 64 64zM16 176v96H32 48 336h16 16V176H16zM32 288H16 0V272 176 160H16 368h16v16 96 16H368 352V496v16H336 48 32V496 288zm304 0H272v40 8h-8H120h-8v-8V288H48V496H336V288zm-208 0v32H256V288H128z'
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fast',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      'M160 320l0-16 16 0 160 0 16 0 0 16 0 48 0 16 16 0 16 0L500.7 267.3 512 256l-11.3-11.3L384 128l-16 0-16 0 0 16 0 48 0 16-16 0-160 0-16 0 0-16 0-48 0-16-16 0-16 0L11.3 244.7 0 256l11.3 11.3L128 384l16 0 16 0 0-16 0-48zm-16 48l-9.4 0L22.6 256l112-112 9.4 0 0 64 0 16 16 0 192 0 16 0 0-16 0-64 9.4 0 112 112-112 112-9.4 0 0-64 0-16-16 0-192 0-16 0 0 16 0 64z'
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fast',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V253.6l-62.7 94-4.4 6.7 13.3 8.9 4.4-6.7 64-96 1.3-2V256 104 96H248v8z'
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fast',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      'M496 16V32c0 102.9-74.7 188.4-172.9 205.1c1 5.2 1.9 10.5 2.6 15.8C431.4 234.9 512 142.9 512 32V16 0H496 448C367 0 296 43 256.6 107.5c3.8 4.1 7.5 8.3 11.1 12.6C303.7 57.9 371 16 448 16h48zM64 80c114.9 0 208 93.1 208 208v16H224C109.1 304 16 210.9 16 96V80H64zM224 320h48V504v8h16v-8V320v-8-8V288C288 164.3 187.7 64 64 64H16 0V80 96C0 219.7 100.3 320 224 320z'
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fast',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      'M136 8V0h16V8 164.7l50.3-50.3 5.7-5.7L219.3 120l-5.7 5.7-64 64-5.7 5.7-5.7-5.7-64-64L68.7 120 80 108.7l5.7 5.7L136 164.7V8zM420.7 120L432 108.7l5.7 5.7L488 164.7V8 0h16V8 164.7l50.3-50.3 5.7-5.7L571.3 120l-5.7 5.7-64 64-5.7 5.7-5.7-5.7-64-64-5.7-5.7zM496 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm83 232.5l-11-19.8-16-28.8v32.9V496v16H536 456 440V496 472.8 439.8l-16 28.8-11 19.8-3.9 7-7.8 14-14-7.8-14-7.8-14-7.8 7.8-14 3.9-7 56-100.8 6.9-12.3H448h96 14.1l6.9 12.3 56 100.8 3.9 7 7.8 14-14 7.8-14 7.8-14 7.8-7.8-14-3.9-7zm-43-48.6V400h12.2L566 432l27 48.6 3.9 7 14-7.8-3.9-7L551 372.1l-2.3-4.1H544 448h-4.7l-2.3 4.1L385 472.9l-3.9 7 14 7.8 3.9-7L426 432l17.8-32H456v39.8V496h80V439.8zM168 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM216 468.6l-16-28.8v32.9V496v16H184 104 88V496 472.8 439.8L72 468.6 61 488.5l-3.9 7-7.8 14-14-7.8-14-7.8-14-7.8 7.8-14 3.9-7L75 364.3 81.9 352H96h96 14.1l6.9 12.3 56 100.8 3.9 7 7.8 14-14 7.8-14 7.8-14 7.8-7.8-14-3.9-7-11-19.8zM184 496V439.8 400h12.2L214 432l27 48.6 3.9 7 14-7.8-3.9-7L199 372.1l-2.3-4.1H192 96 91.3L89 372.1 33 472.9l-3.9 7 14 7.8 3.9-7L74 432l17.8-32H104v39.8V496h80zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm69 108.3L426.6 320H415l-3.4 6.1-36.7-66-2.3-4.1H368 272h-4.7l-2.3 4.1-36.7 66L225 320H213.4L251 252.3l6.9-12.3H272h96 14.1l6.9 12.3zm1 67.7l12.5 22.5-9.2 16.5-1.4-2.4-16-28.8v32.9V384v6.3l0 0V400h-5.4H360h0V384h0V327.8 288h12.2L390 320zM280 384h0v16H269.4 264V384h0V360.8 327.8l-16 28.8-1.4 2.4-9.2-16.5L250 320l17.8-32H280v39.8V384z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fast',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M256 0c26.5 0 52 4 76 11.5L319.1 24.4C299 18.9 277.8 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240s240-107.5 240-240c0-21.8-2.9-43-8.4-63.1L500.5 180c7.4 24 11.5 49.5 11.5 76c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zm0 88c8.5 0 16.9 .6 25.1 1.9l2.8 16.7c-9-1.7-18.4-2.6-27.9-2.6c-83.9 0-152 68.1-152 152s68.1 152 152 152s152-68.1 152-152c0-9.5-.9-18.8-2.6-27.9l16.7 2.8c1.2 8.2 1.9 16.6 1.9 25.1c0 92.8-75.2 168-168 168s-168-75.2-168-168s75.2-168 168-168zm14.1 97.4L255.4 200c-30.5 .3-55.1 25-55.4 55.4l-.6 .6 .6 .6c.3 30.5 25 55.1 55.4 55.4l.6 .6 .6-.6c30.5-.3 55.1-25 55.4-55.4l14.6-14.6c.9 4.5 1.4 9.2 1.4 14.1c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72c4.8 0 9.5 .5 14.1 1.4zM406.6 94.1L381.1 30.2 328.6 82.7l12.8 76.6 65.3-65.3zm-54 76.6l76.6 12.8 52.5-52.5-63.8-25.5-65.3 65.3zm-13.9 13.9l-77.1 77.1-5.7 5.7L244.7 256l5.7-5.7 77.1-77.1L312.1 81.3l-.7-4.1 2.9-2.9 64-64 8.6-8.6L391.4 13l30.7 76.8L499 120.6l11.3 4.5-8.6 8.6-64 64-2.9 2.9-4.1-.7-91.9-15.3z'
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fast',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      'M368 16V48H208V16H368zM192 16V48H105.3 88l6.7 16 26.7 64H72c-4.4 0-8 3.6-8 8V304c0 1.3 .3 2.6 1 3.8l56 104 3.8 7 14.1-7.6-3.8-7L81.1 304H494.9L441 404.2l-3.8 7 14.1 7.6 3.8-7 56-104c.6-1.2 1-2.5 1-3.8V136c0-4.4-3.6-8-8-8H454.7l26.7-64L488 48H470.7 384V16 0H368 208 192V16zM496 288H80V144h48H448h48V288zM368 64h16 80l-26.7 64H138.7L112 64h80 16H368zM112 184v72 8h16v-8V192H448v64 8h16v-8V184c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fast',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      'M10 496L0 512H18.9 621.1 640l-10-16L329.4 15.1 320 0l-9.4 15.1L10 496zm601.1 0H28.9L320 30.2 611.1 496zM352 432h18.9H493.1 512l-10-16-60.6-96.9L432 304l-9.4 15.1-30.1 48.2-58.6-29.6-38.6-84.9-1.2-2.6-2.5-1.3-48-24-6.5-3.2-3.9 6.1-32 50.9-4.7 7.4 7.8 4 179.6 90.8L362 416l-10 16zm131.1-16H380.9L432 334.2 483.1 416zM272 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8.9 134.1l-91.6-46.4 23.5-37.3 39 19.5 29.2 64.2zm-99.5-1.2l-3 8.4L172.6 432h17l30.9-84.9L280 376.2V424v8h16v-8V371.2v-5l-4.5-2.2-72-35.2-8-3.9z'
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fast',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-96H368h16v16V336v16H368 144 128V336 176 160h16zm224 39.5V176H144v23.5l3.9 2.2L256 262.8l108.1-61.1 3.9-2.2zm0 18.4L259.9 279l-3.9 2.2-3.9-2.2L144 217.9V336H368V217.9z'
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fast',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      'M16 322l.5-2H123.1l29.8 59.6 2.2 4.4H160 352h4.9l2.2-4.4L388.9 320H495.5l.5 2V464H16V322zM84.5 48h343l64 256H384h-4.9l-2.2 4.4L347.1 368H164.9l-29.8-59.6-2.2-4.4H128 20.5l64-256zM0 320V464v16H16 496h16V464 320L440 32H72L0 320zM152 112h-8v16h8H368h8V112h-8H152zm-24 64h-8v16h8H384h8V176h-8H128zm-16 64h-8v16h8H392h8V240h-8H112z'
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fast',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      'M480 32h-1.5l-1.4 .5L415.4 56.3c-12.9 5-23.8 13.3-31.9 23.7c-.8 0-1.5 0-2.3 0H240C157 80 88.8 143.1 80.8 224H45.2C29.1 224 16 210.9 16 194.8v-1.5c0-11.7 7.5-22 18.5-25.7l24-8 7.6-2.5-5.1-15.2-7.6 2.5-24 8C11.9 158.3 0 174.7 0 193.3v1.5c0 25 20.2 45.2 45.2 45.2H80v16c0 52.1 27.7 97.8 69.2 123l34.2 95.6 1.9 5.3h5.6H264h8v-8V416h48 64v56 8h8 73.1 5.6l1.9-5.3 22.2-62.1c34.2-8.1 64-29.8 81.9-60.6H632h8v-8V216v-8h-8H586.5c-13.2-5.9-24.7-15.2-33.1-27.1c28.1-12.4 46.6-40.3 46.6-71.5V96 88h-8H512V40 32h-8H480zm31.3 72H584v5.4c0 25.7-15.7 48.5-39.4 57.9c-11-16.4-24.2-30.9-39.2-43.1c2.9-6.3 4.9-13.1 5.9-20.2zM421.2 71.2L481.5 48H496V94c0 10.2-2.8 19.9-7.7 28.3l-3.6 6.1 5.7 4.3c18.1 13.7 33.7 30.9 45.7 51c10.7 17.8 26.7 31.6 45.7 39.7l1.5 .6h1.6H624V336H572.1h-4.8l-2.3 4.2c-16.1 30.1-44.8 51.1-77.8 57.6l-4.5 .9-1.5 4.3-21.8 61H400V408v-8h-8H320 264h-8v8 56H196.5l-33.2-93-1-2.8-2.5-1.5C121.6 344.6 96 303.3 96 256V240c0-79.5 64.5-144 144-144H381.2c2 0 4 0 6 .1l4.4 .1 2.5-3.6c6.5-9.5 15.8-17.1 27.1-21.4zM464 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fast',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      'M143 0h-1.5H136 104 56 48V8 197.8L1.1 275.9 0 277.8V280 504v8H8 160V496H16V467.5L125.4 365.9l5.9-5.4-10.9-11.7-5.9 5.4L16 445.7V282.2l46.9-78.1 1.1-1.9V200 16h40 26.4l64.1 172.7 8.7-22.6L154.9 35.8c.7 .7 1.5 1.4 2.3 2.1C171.4 50.9 193.5 64 224 64s52.6-13.1 66.9-26.1l.9-.8L192.6 285l-.6 1.4V288 504v8h8H440h8v-8V280v-2.2l-1.1-1.9L400 197.8V8 0h-8H344 312h-5.4H305h-4.9l-2.2 4.3 0 0 0 0 0 0 0 0 0 0 0 0-.2 .3c-.2 .3-.4 .7-.8 1.3c-.7 1.2-1.8 2.9-3.3 4.9c-3 4.1-7.5 9.7-13.6 15.2C267.9 37.1 249.5 48 224 48s-43.9-10.9-56.1-21.9c-6.1-5.5-10.6-11.1-13.6-15.2c-1.5-2.1-2.6-3.8-3.3-4.9c-.3-.6-.6-1-.8-1.3l-.2-.3 0 0 0 0 0 0 0 0L147.9 0H143zm65 289.5L317.4 16H344h40V200v2.2l1.1 1.9L432 282.2V445.7l-98.6-91.5-5.9-5.4-10.9 11.7 5.9 5.4L432 467.5V496H208V289.5z'
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fast',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      'M311.2 4.7l6 5.3 128 112 6.9 6-6.9 6-128 112-6 5.3-10.5-12 6-5.3 112-98H16V280v8H0v-8V128v-8H8 418.7l-112-98-6-5.3 10.5-12zm-96 256l6 5.3 128 112 6.9 6-6.9 6-128 112-6 5.3-10.5-12 6-5.3 112-98H16V504v8H0v-8V384v-8H8 322.7l-112-98-6-5.3 10.5-12z'
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fast',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      'M512 512L512 0 496 0l0 512 16 0zM400 208L16 208 16 80l384 0 0 128zM416 80l0-16-16 0L16 64 0 64 0 80 0 208l0 16 16 0 384 0 16 0 0-16 0-128zM400 432l-256 0 0-128 256 0 0 128zm16-128l0-16-16 0-256 0-16 0 0 16 0 128 0 16 16 0 256 0 16 0 0-16 0-128z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fast',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M424 0h-8V16h8 91.9L320.3 189 197.7 66.3l-5-5-5.6 4.4-184 144 9.9 12.6L191.4 82.7l123 123 5.3 5.3 5.6-5L528 26.7V120v8h16v-8V8 0h-8H424zM208 240V464H176V240h32zm-32-16H160v16V464v16h16 32 16V464 240 224H208 176zM80 336V464H48V336H80zM48 320H32v16V464v16H48 80 96V464 336 320H80 48zm256 48a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-200 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm128 0c0-17-5.9-32.6-15.7-44.9l21.4-21.4-11.3-11.3-21.4 21.4C464.6 301.9 449 296 432 296s-32.6 5.9-44.9 15.7l-21.4-21.4-11.3 11.3 21.4 21.4C365.9 335.4 360 351 360 368s5.9 32.6 15.7 44.9l-21.4 21.4 11.3 11.3 21.4-21.4C399.4 434.1 415 440 432 440s32.6-5.9 44.9-15.7l21.4 21.4 11.3-11.3-21.4-21.4C498.1 400.6 504 385 504 368z'
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fast',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      'M224 0h8 48 8V16h-8H232h-8V0zM472 128v8 32h32 8v16h-8H472v32 8H456v-8V184H424h-8V168h8 32V136v-8h16zM56 352v8 32H88h8v16H88 56v32 8H40v-8V408H8 0V392H8 40V360v-8H56zm40 96h8H408h8v8 48 8H400v-8V464H112v40 8H96v-8V456v-8zm72-64H344h8v16h-8H168h-8V384h8zm-8-64h8H344h8v16h-8H168h-8V320zm-56-64H408h8v16h-8H104 96V256h8zm24-64h8H376h8v16h-8H136h-8V192zm72-64H312h8v16h-8H200h-8V128h8zm24-64h64 8V80h-8H224h-8V64h8z'
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fast',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      'M496 304V256C496 123.5 388.5 16 256 16S16 123.5 16 256c0 130.4 103.9 236.4 233.5 239.9L297.4 448l-.8-.8c-15.7-15.7-24.6-37.1-24.6-59.3c0-46.3 37.6-83.9 83.9-83.9H496zM308.7 436.7L320 448l-11.3 11.3L256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v48 16H496 355.9c-37.5 0-67.9 30.4-67.9 67.9c0 18 7.2 35.3 19.9 48l.8 .8zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm56-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm168-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM416 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fast',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zm226.3-61.7l88-88 5.7-5.7 5.7 5.7 88 88 5.7 5.7L408 291.3l-5.7-5.7L328 211.3V408v8H312v-8V211.3l-74.3 74.3-5.7 5.7L220.7 280l5.7-5.7z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fast',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      'M102.8 56A38.8 38.8 0 1 0 25.2 56a38.8 38.8 0 1 0 77.5 0zM64 112s0 0 0 0s0 0 0 0l-16 0 0 320 432 0 0-12.6L417.4 278.5l-2.9-6.5 2.9-6.5L480 124.6l0-12.6L64 112zM32 102C17.5 91.8 8 75 8 56C8 25.1 33.1 0 64 0s56 25.1 56 56c0 15.7-6.4 29.8-16.8 40L480 96l16 0 0 16 0 16L432 272l64 144 0 16 0 16-16 0L48 448l0 64-16 0 0-64 0-16 0-320 0-10z'
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fast',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      'M576 128v-3.5l-2.6-2.4-96-88-5.9-5.4L460.7 40.5l5.9 5.4 29.4 27V168c0 30.9 25.1 56 56 56h8V363.9l16 12.6V128zM384 388.1l-16-12.6V416H112V173.3L96 160.7V496l-32 0v16H96h16H368h16 32V496l-32 0V388.1zM384 225V16 0H368 112 99l20.3 16H368V212.4L384 225zM368 432v64H112V432H368zM560 208h-8c-22.1 0-40-17.9-40-40V87.5l48 44V208zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fast',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      'M336 2.7l11.3 11.3 11.3 11.3 128 128 11.3 11.3L509.3 176l-11.3 11.3-22.6 22.6L464 221.3l-11.3-11.3-11.3-11.3-128-128L302.1 59.3 290.7 48l11.3-11.3 22.6-22.6L336 2.7zM324.7 59.3l128 128L464 198.6 486.6 176l-11.3-11.3-128-128L336 25.4 313.4 48l11.3 11.3zM202.4 170.2l82.6-82.6 11.3 11.3L219.3 176 336 292.7l77.1-77.1 11.3 11.3L293.7 357.7l-1.7 1.7-2.4 .5L131.9 391.4 29.7 493.7 24 499.3l0 0-6.8 6.8-5.7 5.7L.2 500.5l5.7-5.7L120.6 380.1l.1-.1 31.5-157.6 .5-2.4 1.7-1.7 47.9-47.9 .1-.1 .1-.1zm5.6 17.1l-40.6 40.6L138.2 373.8l145.9-29.2L324.7 304 208 187.3z'
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fast',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      'M16 48H432V164.6c5.2-1.5 10.5-2.7 16-3.5V48 32H432 16 0V48 464v16H16 320l0-16H16V48zm215.2 84.6l-2.2-4.6H218.9l-2.2 4.6L97.8 384h17.7l30.3-64H302.2L320 357.5l0-37.4L231.2 132.6zM294.7 304H153.3L224 154.7 294.7 304zM464 208c26.5 0 48 21.5 48 48v64H416V256c0-26.5 21.5-48 48-48zm-64 48v64H368 352v16V496v16h16H560h16V496 336 320H560 528V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H368V336z'
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fast',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      'M336 144v-8-8c0-5.4-.4-10.8-1.1-16H280h-4l-2.4-3.2L255.4 84.5l-33.2 40.6-2.4 2.9H216l-104 0v8 8c0 61.9 50.1 112 112 112s112-50.1 112-112zm8.6 43.1C326.9 236.6 279.6 272 224 272s-102.9-35.4-120.6-84.9L48 235.6V256h72 8v16h-8H40 32v-8V232v-3.6l2.7-2.4L96 172.4V144v-8-8C96 57.3 153.3 0 224 0s128 57.3 128 128v8 8 28.4L413.3 226l2.7 2.4V232v32 8h-8H328h-8V256h8 72V235.6l-55.4-48.5zM284 96h47.4c-6.8-22.8-20.6-42.5-39-56.7L265.8 71.8 284 96zm-5-65.6C262.7 21.2 244 16 224 16c-56.4 0-103.1 41.7-110.9 96h99.1L279 30.4zm-67.1 380L134.4 320H75.8L21.7 496H426.3L372.2 320H313.6l-77.5 90.4L224 424.6l-12.1-14.2zM384 304l59.1 192 4.9 16H431.3 16.7 0l4.9-16L64 304h77.7l71.8 83.7L224 400l10.5-12.3L306.3 304H384z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fast',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 320h16H368h16V304 280L256 160 128 280v24 16zm240-33.1V304H144V286.9l112-105 112 105z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faUfoBeam = {
    prefix: 'fast',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      'M138.8 165.6c-1.3-1.3-2.1-3-2.2-4.9c-1.4-15.9-.3-31.1 2.9-45.5c-36 9.1-65.8 21.3-87.2 35.4C27.8 166.8 16 184.2 16 201.1c0 12.4 6.3 25 19.5 37.3c13.2 12.4 32.7 23.8 57.5 33.7C142.5 291.7 211.4 304 288 304s145.5-12.3 195-31.9c24.8-9.8 44.3-21.3 57.5-33.7c13.2-12.3 19.5-25 19.5-37.3c0-16.9-11.8-34.3-36.3-50.4c-21.4-14.1-51.3-26.3-87.2-35.4c3.2 14.3 4.3 29.6 2.9 45.5c-.2 1.8-1 3.6-2.2 4.9l-5.7-5.6c5.7 5.6 5.7 5.6 5.7 5.6l0 0 0 0-.1 .1-.1 .1-.5 .5c-.4 .4-1 .9-1.7 1.5c-1.5 1.3-3.6 3-6.4 5c-5.7 4-14.3 9.3-26.3 14.5C378.2 197.8 341.2 208 288 208s-90.2-10.2-114-20.7c-11.9-5.2-20.5-10.5-26.3-14.5c-2.9-2-5-3.7-6.4-5c-.7-.6-1.3-1.1-1.7-1.5l-.5-.5-.1-.1-.1-.1 0 0 0 0s0 0 5.7-5.6l-5.7 5.6zM431.3 97.5c41.1 9.5 76 23.2 101.3 39.8c26.2 17.2 43.5 38.9 43.5 63.8c0 18.3-9.4 34.8-24.5 49c-15.2 14.2-36.6 26.6-62.5 36.9C437.1 307.5 366.1 320 288 320s-149.1-12.5-200.9-33.1c-25.9-10.3-47.4-22.7-62.5-36.9C9.4 235.9 0 219.3 0 201.1c0-24.9 17.3-46.5 43.5-63.8c25.2-16.6 60.2-30.2 101.2-39.8C166 39.5 223.6 0 288 0s122 39.5 143.3 97.5zM288 16c-76.4 0-140.9 61.3-135.7 140.2c1.1 .9 2.6 2.1 4.6 3.5c4.9 3.5 12.6 8.2 23.4 13C202.1 182.2 236.9 192 288 192s85.9-9.8 107.6-19.3c10.9-4.8 18.6-9.5 23.4-13c2-1.4 3.5-2.6 4.6-3.5C428.9 77.3 364.4 16 288 16zM72 192l24-24 24 24L96 216 72 192zm216 40l24 24-24 24-24-24 24-24zm168-40l24-24 24 24-24 24-24-24zM103 355.9l-80 144-3.9 7-14-7.8 3.9-7 80-144 3.9-7 14 7.8-3.9 7zm384-7.8l80 144 3.9 7-14 7.8-3.9-7-80-144-3.9-7 14-7.8 3.9 7z'
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fast',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      'M176 0C96.5 0 32 64.5 32 144V280v8h8H176 299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496 600h8v-8V180v-4-1.7l0 0C607.1 113.2 557.3 64 496 64c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM48 144C48 73.3 105.3 16 176 16c33 0 63.1 12.5 85.8 33l5.6 5.1 5.4-5.4C293.1 28.5 321.1 16 352 16c45.2 0 84.1 26.8 101.8 65.3l3.1 6.7 6.9-2.5C473.9 82 484.7 80 496 80c53 0 96 43 96 96c0 1.2 0 2.5-.1 3.7l-.2 5.9 .3 .1V272H496 465.6h-3.1l-2.3 2.1c-20 18.5-46.7 29.9-76.1 29.9s-56.2-11.3-76.1-29.9l-2.3-2.1h-3.1H176 48V144zM72 384H64v16h8H216h8V384h-8H72zm192 0h-8v16h8H632h8V384h-8H264zM8 496H0v16H8 376h8V496h-8H8zm416 0h-8v16h8H568h8V496h-8H424z'
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fast',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      'M16 16V80H496V16H16zM0 0H16 496h16V16 80 96H496 152v80 16 80 16V416c0 .2 0 .4 0 .7c22.7 3.8 40 23.5 40 47.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3c0-.2 0-.4 0-.7V288 272 192 176 96H16 0V80 16 0zM104 176v16H17.1 0l6-16 18-48H41.1l-18 48H104zm80 16V176H488.9l-18-48H488l18 48 6 16H494.9 184zm304.9 80l-18-48H488l18 48 6 16H494.9 184V272H488.9zM104 272v16H17.1 0l6-16 18-48H41.1l-18 48H104zm40 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fast',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      'M624 48V368H112V48H624zM112 32H96V48 368v16h16H624h16V368 48 32H624 112zM64 128H16 0v16V464v16H16 528h16V464 416H528v48H16V144H64V128zm224 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm136-48V144h-8-8c-30.9 0-56-25.1-56-56V80 72H512v8 8c0 39.8 32.2 72 72 72h8 8zm-456 0h8c39.8 0 72-32.2 72-72V80 72H208v8 8c0 30.9-25.1 56-56 56h-8-8v16h8zm456 96h-8-8c-39.8 0-72 32.2-72 72v8 8h16v-8-8c0-30.9 25.1-56 56-56h8 8V256zm-456 0h-8v16h8 8c30.9 0 56 25.1 56 56v8 8h16v-8-8c0-39.8-32.2-72-72-72h-8z'
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fast',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368c39 0 75.9 7.4 108.6 20.7C352.5 340 308.4 304 256 304s-96.5 36-108.6 84.7C180.1 375.4 217 368 256 368zm0 16c-40.7 0-78.8 8.5-111.7 23.4c-5.6 2.5-11 5.3-16.3 8.1c0-6.4 .5-12.7 1.4-18.8C138.7 335.2 191.8 288 256 288s117.3 47.2 126.6 108.8c.9 6.1 1.4 12.4 1.4 18.8c-5.3-2.9-10.7-5.6-16.3-8.1C334.8 392.5 296.7 384 256 384zM132.4 157.3l7.2 3.6 80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L198.1 208l-65.7-32.8-7.2-3.6 7.2-14.3zm240 3.6l7.2-3.6 7.2 14.3-7.2 3.6L313.9 208l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L278.1 208l14.3-7.2 80-40z'
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fast',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      'M240 5.5l5.2 4.5 224 192 6.1 5.2-10.4 12.1-6.1-5.2L416 177.4V224H400V163.7L240 26.5 80 163.7V400H272v16H72 64v-8V177.4L21.2 214.1l-6.1 5.2L4.7 207.1l6.1-5.2 224-192L240 5.5zM304 184v40H288V192H192v96h80v16H184h-8v-8V184v-8h8H296h8v8zm272 88H320V448H576V272zm-272 0V256h16H576h16v16V448h32 16v16 16l-32 32H288l-32-32V464 448h16 32V272zM576 464H320 304 272v9.4L294.6 496H601.4L624 473.4V464H592 576z'
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fast',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      'M312.8 118.8l-48-100.3L256 0l-8.9 18.5-41 85.8-6.9 14.5-13.8-8.2L28.9 17.3 0 0 17.3 28.9l93.3 156.5 8.2 13.8-14.5 6.9-85.8 41L0 256l18.5 8.9 100.3 48-37 104.8L75 437l19.4-6.8 104.8-37 48 100.3L256 512l8.9-18.5 48-100.3 104.8 37L437 437l-6.8-19.4-37-104.8 100.3-48L512 256l-18.5-8.9-100.3-48 37-104.8L437 75l-19.4 6.8-104.8 37zm98-17.6l-32.7 92.6-4.8 13.6 13 6.2L474.9 256l-88.6 42.4-13 6.2 4.8 13.6 32.7 92.6-92.6-32.7-13.6-4.8-6.2 13L256 474.9l-42.4-88.6-6.2-13-13.6 4.8-92.6 32.7 32.7-92.6 4.8-13.6-13-6.2L37.1 256l88.6-42.4 15.8-7.6-9-15.1L46.2 46.2 191 132.6l15.1 9 7.6-15.8L256 37.1l42.4 88.6 6.2 13 13.6-4.8 92.6-32.7z'
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fast',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      'M152 0h8H280h8V8 88v8H272V88 16H168V504v8h-8H40 32v-8V424v-8H48v8 72H152V8 0z'
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fast',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      'M11.3 267.3L0 256l11.3-11.3L244.7 11.3 256 0l11.3 11.3L500.7 244.7 512 256l-11.3 11.3L267.3 500.7 256 512l-11.3-11.3L11.3 267.3zM22.6 256L256 489.4 489.4 256 256 22.6 22.6 256zm287-109.7l72 72 5.7 5.7-5.7 5.7-72 72-5.7 5.7L292.7 296l5.7-5.7L356.7 232H200v96 8H184v-8V224v-8h8H356.7l-58.3-58.3-5.7-5.7L304 140.7l5.7 5.7z'
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fast',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      'M8 64H0V80H8 36L166.1 256 36 432H8 0v16H8 40h4l2.4-3.2L176 269.5 305.6 444.8 308 448h4 32 8V432h-8H316L185.9 256 316 80h28 8V64h-8H312h-4l-2.4 3.2L176 242.5 46.4 67.2 44 64H40 8zM424 352h-8v16h8 24V496H416v16h40 8 32 8V496h-8H464V360v-8h-8H424z'
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fast',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      'M432 224c0 55.9-22 106.6-57.9 144h21.5c32.7-38.9 52.4-89.2 52.4-144C448 100.3 347.7 0 224 0S0 100.3 0 224c0 54.8 19.7 105.1 52.4 144H73.9C38 330.6 16 279.9 16 224C16 109.1 109.1 16 224 16s208 93.1 208 208zM256 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-26.3 82.3l-5.7-5.7-5.7 5.7-72 72-5.7 5.7L152 251.3l5.7-5.7L216 187.3v41.4l-77.7 77.7-5.7 5.7L144 323.3l5.7-5.7L216 251.3V368h16V251.3l66.3 66.3 5.7 5.7L315.3 312l-5.7-5.7L232 228.7V187.3l58.3 58.3 5.7 5.7L307.3 240l-5.7-5.7-72-72zM18.4 512H429.6 448l-9.1-16L384 400H64L9.1 496 0 512H18.4zm356.3-96l45.7 80H27.6l45.7-80H374.7zM336 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fast',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      'M105.9 .4L256.7 50.7C262.9 21.7 288.6 0 319.3 0c35.3 0 64 28.7 64 64c0 9.6-2.1 18.7-5.9 26.9l160.5 53.5 7.6 2.5-5.1 15.2-7.6-2.5L368.6 104.9c-10.1 12.2-24.7 20.6-41.3 22.6V504v8h-8-216-8V496h8 208V127.5c-30.6-3.8-54.4-29.2-55.9-60.4L100.8 15.6 105.9 .4zM319.3 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM136.7 80.9L255.9 270.6l.2 40L182.6 384H73.5L.1 310.6v-40L117.9 80.9l9.4-15.1 9.5 15.1zM18.1 272H237.9L127.3 96 18.1 272zm-2 16v16l64 64H176l64-64-.1-16H16.1zm495-96l9.5 15.1L639.7 396.8l.2 40-73.4 73.4H457.4L384 436.8v-40L501.7 207.1l9.4-15.1zm.1 30.2L402 398.2H621.7l-110.5-176zM400 430.2l64 64h95.9l64-64-.1-16H400v16z'
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faAddressCard = {
    prefix: 'fast',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM360 176H504h8v16h-8H360h-8V176h8zm0 64H504h8v16h-8H360h-8V240h8zm0 64H504h8v16h-8H360h-8V304h8zM102.2 368H85.3L112 288H272l26.7 80H281.8l-21.3-64H123.5l-21.3 64zM240 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fast',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM232 192v8 80h80 8v16h-8H232v80 8H216v-8V296H136h-8V280h8 80V200v-8h16z'
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fast',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v8V280v96 8h16v-8V288h91.9l69.3 96H357l-70.3-97.3c37.2-6.9 65.3-39.5 65.3-78.7c0-44.2-35.8-80-80-80H168h-8zm16 144V144h96c35.3 0 64 28.7 64 64s-28.7 64-64 64H176z'
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fast',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-16 0c0-22.2 11.3-41.7 28.4-53.2L136.8 131.6l-3.6-7.2 14.3-7.2 3.6 7.2 83.6 167.2c6.6-2.3 13.8-3.6 21.2-3.6c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM384 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fast',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      'M456 8v8V56h40 8V72h-8H456v40 8H440v-8V72H400h-8V56h8 40V16 8h16zM282.6 126.7l-9.6-3.4C252.8 116 230.9 112 208 112C102 112 16 198 16 304s86 192 192 192s192-86 192-192c0-22.9-4-44.8-11.3-65.1l-3.4-9.6 7.2-7.2 2.9-2.9L406.6 208l-11.3-11.3-80-80L304 105.4l-11.3 11.3-2.9 2.9-7.2 7.2zm10.1-32.7L304 82.7l11.3 11.3 11.3 11.3L361 139.7l33.4-33.4 5.7-5.7L411.3 112l-5.7 5.7L372.3 151l34.3 34.3 11.3 11.3L429.3 208l-11.3 11.3-11.3 11.3-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9 11.3-11.3zM88 296v8H72v-8c0-70.7 57.3-128 128-128h8v16h-8c-61.9 0-112 50.1-112 112z'
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fast',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      'M88.9 261.6l7.1-4.8v-8.5V16H224V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128S32 438.7 32 368c0-44.4 22.6-83.5 56.9-106.5zM240 0H224 96 80V16 248.3C41.4 274.1 16 318.1 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM112 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fast',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      'M449.7 406.3c21.2 21.2 55.5 21.2 76.7 0s21.2-55.5 0-76.7l-4-4c-19-19-49.7-19-68.7 0l-11.3-11.3c25.2-25.2 66.1-25.2 91.3 0l4 4c27.4 27.4 27.4 71.9 0 99.3s-71.9 27.4-99.3 0l-316-316L120 99.3V96c0-39.7 31.9-72 71.7-72c17.1 0 32.9 6 45.2 16c14.3-10.1 31.8-16 50.6-16c48.5 0 87.9 39.4 87.9 88c0 5.7-.6 11.4-1.6 16.8c29.3 14.3 49.5 44.4 49.5 79.2c0 19.8-6.5 38.1-17.6 52.8l-4.8 6.4-12.8-9.6 4.8-6.4c9-12 14.4-27 14.4-43.2c0-30.5-19-56.6-45.7-67.1l-6.7-2.6 1.9-7c1.7-6.1 2.6-12.6 2.6-19.3c0-39.8-32.2-72-71.9-72c-17.4 0-33.4 6.2-45.9 16.6l-5.6 4.6-5.2-5.1C220.8 46.1 207 40 191.7 40c-29.7 0-53.9 23.3-55.6 52.8L449.7 406.3zM463.1 64a15.9 15.9 0 1 0 -31.9 0 15.9 15.9 0 1 0 31.9 0zm-47.9 0a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM495 160a15.9 15.9 0 1 0 -31.9 0 15.9 15.9 0 1 0 31.9 0zm-47.9 0a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1 -63.9 0zM0 44.7L13.7 58.3l440 440L467.3 512H448 8 0v-8V64 44.7zM16 83.3V496H428.7L16 83.3z'
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fast',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      'M576 256c0-19.8-16.2-35.8-33.3-46.3C525.2 199 503.4 192 486.8 192H368l-1.3 0-35.3-64H344h8v-8V72 64h-8H296L263 4.1 260.7 0H256 168 157.5l2.8 10.1L210.5 192H192l-68 0L78.4 131.2 76 128H72l-56 0H5.6l2.7 10.1L31.2 224C13.9 224.4 0 238.6 0 256s13.9 31.6 31.2 32L8.3 373.9 5.6 384H16 72h4l2.4-3.2L124 320h68l18.5 0L160.3 501.9 157.5 512H168l88 0h4.7l2.3-4.1L296 448h48 8v-8V392v-8h-8H331.3l35.3-64 1.3 0 118.8 0c16.6 0 38.3-6.7 55.8-17.3C559.8 292.3 576 276.2 576 256zM322.5 400H336v32H304.9l17.7-32zM336 112H322.5L304.9 80H336v32zM35.5 272H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h3.5l4.3 16-4.3 16zm451.4-64c13 0 31.8 5.7 47.5 15.3c16.1 9.9 25.7 21.8 25.7 32.7c0 11.3-9.6 23.2-25.6 33c-15.6 9.5-34.5 15-47.5 15L368 304l-6.1 0h-4.7l-125.7 0H221 192 120h-4l-2.4 3.2L68 368H26.4L55.7 258.1l.5-2.1-.5-2.1L26.4 144 68 144l45.6 60.8L116 208h4l72 0h29 10.5l125.7 0h4.7l6.1 0H486.8zM251.3 16l97.1 176H227.1L178.5 16l72.8 0zm97.1 304L251.3 496l-72.8 0 48.6-176H348.4z'
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fast',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V270.9l-83.6 55.7-6.7 4.4-8.9-13.3 6.7-4.4 96-64 12.4-8.3V256 408v8H248v-8z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fast',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M16 80V432h96V80H16zM0 64H16h96 16V80 432v16H112 16 0V432 80 64zM208 80V432h96V80H208zM192 64h16 96 16V80 432v16H304 208 192V432 80 64z'
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fast',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      'M209.8 467.4c13-15.4 29.2-35.1 46.2-57.3l0 26.1c-22.2 28.1-41.8 50.8-53.3 63.9c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-5.3 .9-10.6 2.1-15.6 3.8C353.1 80.7 280.1 16 192 16C94.8 16 16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm144 16c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H496 304 288V496 336 320h16 32V256zm-32 80V496H496V336H464 448 352 336 304z'
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fast',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      'M344.1 3.8l-5.5 5.8-5.5-5.8 5.5-5.3 5.5 5.2zM502.4 173.3c5.8 5.5 5.8 5.5 5.8 5.6l0 0 0 0 0 0-.1 .1-.4 .4c-.3 .3-.8 .8-1.5 1.4c-1.3 1.2-3.1 3-5.4 5c-4.6 4.1-11 9.7-18.7 15.2c-10.1 7.3-23 15.3-36.6 19.6c-3.7-4.7-7.7-9.1-11.9-13.5c13-2.4 27.1-10.3 39.2-19.1c7-5.1 13.1-10.3 17.3-14.1l.9-.8-1-.9c-4.3-4-10.6-9.2-18.1-14.5c-15.3-10.7-34.9-20.6-54.5-20.6c-16.7 0-26.6 2.1-32.1 3.9c-2.7 .9-4.4 1.8-5.2 2.2c-.3 .2-.6 .4-.6 .4c-2 1.9-4.8 2.5-7.4 1.8l-5.8-5.8c-.6-2.5 0-5.3 1.8-7.4c.1-.1 .2-.3 .4-.6c.5-.8 1.3-2.4 2.2-5.2c1.8-5.5 3.9-15.4 3.9-32.1c0-19.5-9.9-39.1-20.6-54.5c-5.3-7.5-10.5-13.8-14.5-18.1l-.9-1-.8 .9c-3.9 4.2-9 10.3-14.1 17.3c-8.8 12.1-16.7 26.2-19.1 39.2c-4.3-4.3-8.8-8.3-13.5-11.9c4.3-13.6 12.3-26.5 19.6-36.6c5.5-7.6 11.1-14.1 15.2-18.7c2.1-2.3 3.8-4.1 5-5.4c.6-.6 1.1-1.1 1.4-1.5L333 4l.1-.1 0 0 0 0 0 0s0 0 5.6 5.8c5.5-5.8 5.5-5.8 5.5-5.8l0 0 0 0 0 0 .1 .1 .4 .4c.4 .3 .9 .8 1.5 1.5c1.3 1.3 3.1 3.1 5.2 5.5c4.3 4.7 10 11.5 15.8 19.7c11.3 16.2 23.4 39.1 23.4 63.6c0 7.1-.4 13.3-.9 18.5C425.5 84.7 458.5 57.3 472.3 9l2.2-7.7 15.4 4.4-2.2 7.7c-14.6 51-48.9 81.1-83 108.3c3.8-.3 8-.4 12.6-.4c24.5 0 47.4 12.1 63.6 23.4c8.2 5.7 15 11.5 19.7 15.8c2.4 2.2 4.2 4 5.5 5.2c.6 .6 1.1 1.1 1.5 1.5l.4 .4 .1 .1 0 0 0 0 0 0s0 0-5.8 5.5zm0 0l5.8 5.5 5.3-5.5-5.2-5.5-5.8 5.5zM369.8 188.8l32.7 32.7 8 8c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l8 8 32.7 32.7 46.6 46.6zM311 152.7l-39.9-39.9C249.4 91 220.8 80.1 192.2 80C108.5 80 16 165 16 336c0 62.7 11.9 101.3 35.3 124.7S113.3 496 176 496c171 0 256-92.3 256-176c0-28.7-10.9-57.3-32.8-79.2l-39.9-39.9c-8.7-6.5-17.2-14.1-25.7-22.6s-16.1-16.9-22.6-25.7zm-129.4-3l-32 32-5.7 5.7L132.7 176l5.7-5.7 32-32 5.7-5.7L187.3 144l-5.7 5.7zm64 64l-32 32-5.7 5.7L196.7 240l5.7-5.7 32-32 5.7-5.7L251.3 208l-5.7 5.7zm-96 32l-32 32-5.7 5.7L100.7 272l5.7-5.7 32-32 5.7-5.7L155.3 240l-5.7 5.7zm160 32l-32 32-5.7 5.7L260.7 304l5.7-5.7 32-32 5.7-5.7L315.3 272l-5.7 5.7zm-96 32l-32 32-5.7 5.7L164.7 336l5.7-5.7 32-32 5.7-5.7L219.3 304l-5.7 5.7zm-96 32l-32 32L80 379.3 68.7 368l5.7-5.7 32-32 5.7-5.7L123.3 336l-5.7 5.7zm256 0l-32 32-5.7 5.7L324.7 368l5.7-5.7 32-32 5.7-5.7L379.3 336l-5.7 5.7zm-96 32l-32 32-5.7 5.7L228.7 400l5.7-5.7 32-32 5.7-5.7L283.3 368l-5.7 5.7zm-96 32l-32 32-5.7 5.7L132.7 432l5.7-5.7 32-32 5.7-5.7L187.3 400l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fast',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      'M8 252.7l-5.7 5.7L8 264 144 400l5.7 5.7L161 394.3l-5.7-5.7L33 266.3l308.7 0 8 0 0-16-8 0L33 250.3 155.3 128l5.7-5.7L149.7 111l-5.7 5.7L8 252.7zM429.7 442.3l0 8 16 0 0-8 0-368 0-8-16 0 0 8 0 368z'
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fast',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      'M189.8 213.3C215.1 119.4 268 64.6 284.9 49c.5-.5 1.4-1 3.1-1s2.6 .5 3.1 1c16.9 15.6 69.8 70.4 95.1 164.3c4.6-3.1 9.3-6.1 14.1-9c-26.9-94.9-80.5-150.6-98.4-167.1c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.9 16.5-71.5 72.2-98.4 167.1c4.8 2.9 9.5 5.9 14.1 9zM.4 208C6.3 314 69.8 404.7 160 449.7c39.2 19.6 83.2 30.3 127 30.3H289c43.9 0 87.8-10.7 127-30.3C506.2 404.7 569.7 314 575.6 208c.3-5.3 .4-10.6 .4-16l-16 0c-52.7 .2-101.9 14.9-144 40.2c-63.1 38.1-110 100.3-128 173.9c-18-73.6-64.9-135.8-128-173.9C117.9 206.9 68.7 192.2 16 192L0 192c0 5.4 .1 10.7 .4 16zM160 431.7C78.8 388.1 22.1 304.8 16.5 208c53 .3 102.3 16.1 143.5 43.1c69.9 45.8 116.8 123.7 119.8 212.7c-43.2-1.4-83.9-12.9-119.8-32.2zM559.5 208c-8.2 139.7-122.6 251.2-263.4 255.8c3-89 50-166.9 119.8-212.7c41.3-27 90.6-42.9 143.5-43.1z'
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fast',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      'M16 104c0-30.9 25.1-56 56-56s56 25.1 56 56V400c0 44.2 35.8 80 80 80H496c44.2 0 80-35.8 80-80V344v-8h-8-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.6-.6-.6-.6-.6-.6-.6-.6H542h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H535h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H527h-.6-.6-.6-.6H524h-.6-.6-.6-.6H521h-.6-.6-.6-.6H518h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H511h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H503h-.6-.6-.6-.6-.6-.6H499h-.6-.6-.6-.6-.6-.6-.6-.6H494h-.6-.6-.6-.6-.5-.5-.5-.5-.5-.5H488h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H482h-.5H481h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H473h-.5H472h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H458h-.5H457h-.5H456h-.5H455h-.5H454h-.5H453h-.5H452h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H430h-.5H429h-.5H428h-.5H427h-.5H426h-.5H425h-.5H424h-.5H423h-.5H422h-.5H421h-.5H420h-.5H419h-.5H418h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H396h-.5H395h-.5H394h-.5H393h-.5H392h-.5H391h-.5H390h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H376h-.5H375h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H367h-.5H366h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H360h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H354h-.6-.6-.6-.6-.6-.6-.6-.6H349h-.6-.6-.6-.6-.6-.6H345h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H337h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H330h-.6-.6-.6-.6H327h-.6-.6-.6-.6H324h-.6-.6-.6-.6H321h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H313h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H306h-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H280h-8v8 56c0 35.3-28.7 64-64 64s-64-28.7-64-64V104c0-22.6-10.4-42.8-26.7-56H408c30.9 0 56 25.1 56 56V304h16V104c0-39.8-32.2-72-72-72H72C32.2 32 0 64.2 0 104v96 8H8 96V192H16V104zM496 464H256c19.4-14.6 32-37.8 32-64V352h.2 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .2v48c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fast',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm136 96H312h8v16h-8H144v96H280h8v16h-8H144V376v8H128v-8V248 136v-8h8z'
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fast',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      'M581.1 31.2l2.3 5.9 48 120 3.4 8.4-8.7 2.3-210.7 56-5.5 1.5-3.2-4.7L320 91.7 233.3 220.5l-3.2 4.7-5.5-1.5-210.7-56-8.7-2.3L8.6 157l48-120 2.3-5.9 6.2 .9L320 69.2 574.8 32.1l6.2-.9zM570.9 48.8L333.7 83.4l83 123.4 196.4-52.2L570.9 48.8zM26.8 154.6l196.4 52.2L306.3 83.4 69.1 48.8 26.8 154.6zM560 216.1l16-4.6V416L320 480 64 416V211.6l16 4.6V403.5l232 58V200v-8h16v8V461.5l232-58V216.1z'
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fast',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      'M424.7 4.7l-224 496 14.6 6.6 224-496L424.7 4.7zM1.7 96L152.8 411.5 155 416H165l2.2-4.5L318.3 96H300.6L160 389.5 19.4 96H1.7zM475 96l-2.2 4.5L321.7 416h17.7l38.3-80H582.2l38.3 80h17.7L487.2 100.5 485 96H475zm99.6 224H385.4L480 122.5 574.6 320z'
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fast',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      'M44.1 33.1L37.3 29 29 42.7l6.9 4.1 80 48 6.9 4.1L131 85.3l-6.9-4.1-80-48zm560 13.7l6.9-4.1L602.7 29l-6.9 4.1-80 48L509 85.3 517.3 99l6.9-4.1 80-48zM8 192H0v16H8 88h8V192H88 8zm544 0h-8v16h8 80 8V192h-8H552zm-88 0V320h16V192c0-88.4-71.6-160-160-160s-160 71.6-160 160V320h16V192c0-79.5 64.5-144 144-144s144 64.5 144 144zM112 464V368H528v96H112zM96 352v16 96 16h16H528h16V464 368 352H528 112 96zM320 112V96c-53 0-96 43-96 96h16c0-44.2 35.8-80 80-80z'
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fast',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      'M432 48V464H16V48H432zm16-16H432 16 0V48 464v16H16 432h16V464 48 32zM312 160H168h-8v16h8H292.7L130.3 338.3l-5.7 5.7L136 355.3l5.7-5.7L304 187.3V312v8h16v-8V168v-8h-8z'
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fast',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      'M451.9 2.2l4.9 4.9 48 48 4.9 4.9-4.2 5.6-51.2 67.2-1.8 2.4-3 .6-77.6 15.5-77.3 77.3c24 26.5 39.3 61.2 41.2 99.3H344h8v16h-8-8.2c-1.9 38.2-17.1 72.8-41.2 99.3l5.8 5.8 5.7 5.7-11.3 11.3-5.7-5.7-5.8-5.8c-26.5 24-61.2 39.3-99.3 41.2V504v8H168v-8-8.2c-38.2-1.9-72.8-17.1-99.3-41.2l-5.8 5.8-5.7 5.7L45.9 454.8l5.7-5.7 5.8-5.8c-24-26.5-39.3-61.2-41.2-99.3H8 0V328H8h8.2c1.9-38.2 17.1-72.8 41.2-99.3l-5.8-5.8-5.7-5.7 11.3-11.3 5.7 5.7 5.8 5.8c26.5-24 61.2-39.3 99.3-41.2V168v-8h16v8 8.2c38.2 1.9 72.8 17.1 99.3 41.2l77.3-77.3 15.5-77.6 .6-3 2.4-1.8L446.4 6.4l5.6-4.2zM74.2 234.1A144 144 0 1 0 277.8 437.9 144 144 0 1 0 74.2 234.1zm304-100.3l65.3-13.1 45.1-59.2L450.5 23.4 391.3 68.5l-13.1 65.3zM117.7 330.3l64 64 5.7 5.7L176 411.3l-5.7-5.7-64-64-5.7-5.7L112 324.7l5.7 5.7z'
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fast',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      'M496 496H144V352H128V496v16h16H496h16V496 160L352 0H144 128V16 256h16V16H336V168v8h8H496V496zm-6.6-336H352V22.6L489.4 160zM269.7 186.3l-5.7-5.7L252.7 192l5.7 5.7L356.7 296H8 0v16H8 356.7l-98.3 98.3-5.7 5.7L264 427.3l5.7-5.7 112-112 5.7-5.7-5.7-5.7-112-112z'
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fast',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM300.5 144.3l-131 131-6.9 44.3L160 336.1l16.6-2.6 44.3-6.9L340.8 206.8l11.3-11.3-11.3-11.3L300.7 144l-.2 .2zm.2 22.4l28.8 28.8-21.4 21.4L279.3 188l21.4-21.4zM184.5 282.9L268 199.3l28.8 28.8-83.5 83.5L179.2 317l5.3-34.1z'
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fast',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm5.7-130.3l-5.7 5.7-5.7-5.7-104-104-5.7-5.7L152 260.7l5.7 5.7L248 356.7V136v-8h16v8V356.7l90.3-90.3 5.7-5.7L371.3 272l-5.7 5.7-104 104z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fast',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      'M192 96H16V232H146c18.5-42.4 60.8-72 110-72s91.5 29.6 110 72H496V48H261.3L201.6 92.8c-2.8 2.1-6.1 3.2-9.6 3.2zM16 248V464H496V248H371.7c2.8 10.2 4.3 20.9 4.3 32c0 66.3-53.7 120-120 120s-120-53.7-120-120c0-11.1 1.5-21.8 4.3-32H16zM192 80l64-48H496h16V48 464v16H496 16 0V464 96 80H16 192zM360 280a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM64 32h96V48H64V32z'
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fast',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      'M208 282.1V288v72.7l52.2 45.7c2.3 10.2 5.4 20 9.4 29.4L192 368V288L0 64V16 0H16 496h16V16 64L399.8 194.9c-9.4 1.7-18.6 4.2-27.4 7.4L496 58.1V16H16V58.1L204.1 277.6l3.9 4.5zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7 8H424v-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9l-7.7-2.3 4.5-15.3 7.7 2.3c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280v-8h16v8 16.4c10.2 .8 20.4 2.8 29.8 5l7.8 1.8-3.7 15.6-7.8-1.8c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fast',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      'M224 0V16h8 64V208H232h-8v16h8 72 72 8V208h-8H312V8 0h-8H232h-8zM0 288v16H8 72V496H8 0v16H8 80h72 8V496h-8H88V296v-8H80 8 0zM24 0H16V8 216v8h8H168h8v-8V8 0h-8H24zm8 208V16H160V208H32zm176 80v8V504v8h8H360h8v-8V296v-8h-8H216h-8zm16 16H352V496H224V304zm304-96c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fast',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M309.7 21.7l-72 72L232 99.3 220.7 88l5.7-5.7 72-72L304 4.7 315.3 16l-5.7 5.7zm192 0l-168 168-5.7 5.7L316.7 184l5.7-5.7 168-168L496 4.7 507.3 16l-5.7 5.7zm0 192l-72 72-5.7 5.7L412.7 280l5.7-5.7 72-72 5.7-5.7L507.3 208l-5.7 5.7zM202.4 162.1l50.9 103.1L367 281.7l19.9 2.9-14.4 14.1-82.3 80.2 19.4 113.3L313 512l-17.8-9.4L193.5 449.1 91.7 502.6 73.9 512l3.4-19.9L96.7 378.9 14.4 298.6 0 284.6l19.9-2.9 113.7-16.5 50.9-103.1 8.9-18.1 8.9 18.1zM251 281l-8.3-1.2-3.7-7.5-45.4-92.1L148 272.2l-3.7 7.5L136 281 34.4 295.7l73.5 71.7 6 5.9-1.4 8.3L95.1 482.8 186 435l7.4-3.9 7.4 3.9 90.9 47.8L274.4 381.6l-1.4-8.3 6-5.9 73.5-71.7L251 281z'
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fast',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      'M289.5 237.6l71.7-66.9L373.7 159l11.7-10.9L374 136.8l-12.1-12.1-19.3-19.3L333.3 96H320 160 144 128v16 32 16h16 16 49.8 25l-19.2 16-1.2 1c-28.9 24.1-30.9 67.8-4.3 94.4L288 349.3V432v16 16h16 32 16V448 432 336 322.7l-9.4-9.4-53.5-53.5-11.3-11.3 11.7-10.9zM336 329.4V336v96 16H304V432 349.3v-6.6l-4.7-4.7-77.9-77.9c-20-20-18.5-52.7 3.2-70.8l20.4-17L279 144H234.8 160 144V112h16H320h6.6l4.7 4.7L350.6 136l11.7 11.7L350.2 159l-83.4 77.8-12.1 11.3 11.7 11.7 64.9 64.9 4.7 4.7zM400 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM148.4 468.3l6.5-4.6-9.3-13-6.5 4.6L105 479.7 13.7 388.3 2.3 399.6l96.2 96.2 4.8 4.8 5.5-3.9 39.6-28.3zm259.5 37l8-48-15.8-2.6L393.2 496H264h-8v16h8H400h6.8l1.1-6.7zM81.4 353.4L70.1 364.7 58.7 376l11.3 11.3 22.6 22.6L104 421.3l11.3-11.3 11.3-11.3 82.7-82.7-11.3-11.3-82.7 82.7L104 398.6 81.4 376l11.3-11.3 83.8-83.8c-3.2-4.6-6-9.4-8.2-14.4L81.4 353.4z'
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fast',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      'M136 0h-8V8 96H16 0v16V464v16H16 496h16V464 112 96H496 384V8 0h-8H136zM368 96H144V16H368V96zM136 112H376h32V464H104V112h32zm-48 0V464H16V112H88zM424 464V112h72V464H424z'
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fast',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      'M448 480s13.1-4.9 30.8-15.7C516.7 441.2 576 391.1 576 304c0-97.2-78.8-176-176-176H336 320V112 48 32H304 288L107.8 197.1 96 208l11.8 10.9L288 384h16 16V368 304 288h16 32c61.9 0 112 50.1 112 112c0 21.2-6.2 39.2-13.2 52.8C458 470 448 480 448 480zm53.5-52c-3.7 3.2-7.4 6.2-11 9c3.3-11 5.6-23.4 5.6-37c0-70.7-57.3-128-128-128H320 304v16 80h-9.8L119.7 208 294.2 48H304v80 16h16 80c88.4 0 160 71.6 160 160c0 58-28.8 97.9-58.5 124zM197.4 59.9l5.9-5.4L192.5 42.7l-5.9 5.4-168 154L12.2 208l6.4 5.9 168 154 5.9 5.4 10.8-11.8-5.9-5.4L35.8 208 197.4 59.9z'
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fast',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      'M432 224c0 55.9-22 106.6-57.9 144h21.5c32.7-38.9 52.4-89.2 52.4-144C448 100.3 347.7 0 224 0S0 100.3 0 224c0 54.8 19.7 105.1 52.4 144H73.9C38 330.6 16 279.9 16 224C16 109.1 109.1 16 224 16s208 93.1 208 208zM19 512H429h19l-10.3-16L376 400H72L10.3 496 0 512H19zm348.2-96l51.4 80H29.3l51.4-80H367.3zM296 152H280v8 56H224h-8v16h8 56v56 8h16v-8V232h56 8V216h-8H296V160v-8zM152 104H136v8 24H112h-8v16h8 24v24 8h16v-8V152h24 8V136h-8H152V112v-8z'
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fast',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      'M256 57.2L200.5 10.9 187.4 0l-5.9 16L156.6 83.9 85.3 71.5 68.6 68.6l2.9 16.7 12.4 71.3L16 181.5 0 187.4l10.9 13L57.2 256 10.9 311.5 0 324.6l16 5.9 67.9 24.9L71.5 426.7l-2.9 16.7 16.7-2.9 71.3-12.4L181.5 496l5.9 16 13-10.9L256 454.8l55.5 46.3 13 10.9 5.9-16 24.9-67.9 71.3 12.4 16.7 2.9-2.9-16.7-12.4-71.3L496 330.5l16-5.9-10.9-13L454.8 256l46.3-55.5 10.9-13-16-5.9-67.9-24.9 12.4-71.3 2.9-16.7-16.7 2.9L355.4 83.9 330.5 15.9 324.6 0l-13 10.9L256 57.2zm61.4-30.4l23 62.5 4.6 12.5 13.2-2.3 65.6-11.4-11.4 65.6L410.1 167l12.5 4.6 62.5 23-42.7 51.2L433.9 256l8.6 10.2 42.7 51.2-62.5 23L410.1 345l2.3 13.2 11.4 65.6-65.6-11.4L345 410.1l-4.6 12.5-23 62.5-51.2-42.7L256 433.9l-10.2 8.6-51.2 42.7-23-62.5L167 410.1l-13.2 2.3L88.2 423.8l11.4-65.6 2.3-13.2-12.5-4.6-62.5-23 42.7-51.2L78.1 256l-8.6-10.2L26.8 194.6l62.5-23 12.5-4.6-2.3-13.2L88.2 88.2l65.6 11.4 13.2 2.3 4.6-12.5 23-62.5 51.2 42.7L256 78.1l10.2-8.6 51.2-42.7z'
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fast',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      'M251.3 128.5l-5.9 5.4-96 88-5.4 5-5.4-5-96-88-5.9-5.4 10.8-11.8 5.9 5.4L136 197.8 136 8V0h16V8l0 189.8 82.6-75.7 5.9-5.4 10.8 11.8zM0 496H8 632h8v16h-8H8 0V496zm178.4-32H162.3L192 256 384 128 576 256l29.7 208H589.6L561.2 265.3 392 152.6V285.8L500.5 464H481.8L392 316.5V464H376V152.6L206.8 265.3 178.4 464z'
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fast',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      'M186.3 506.3L192 512l5.7-5.7 152-152 5.7-5.7L344 337.4l-5.7 5.7L200 481.4 200 8l0-8L184 0l0 8 0 473.4L45.7 343 40 337.4 28.7 348.7l5.7 5.7 152 152z'
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fast',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      'M160 352l-16 0-64 0-16 0 0-16 0-16L212.7 171.3 224 160l11.3 11.3L384 320l0 16 0 16-16 0-64 0-16 0 0 16 0 128 0 16-16 0-96 0-16 0 0-16 0-128 0-16zm0-16l16 0 0 16 0 144 96 0 0-144 0-16 16 0 80 0 0-9.4-144-144L80 326.6l0 9.4 80 0zM16 184l0 8L0 192l0-8L0 8C0 3.6 3.6 0 8 0L440 0c4.4 0 8 3.6 8 8l0 176 0 8-16 0 0-8 0-168L16 16l0 168z'
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fast',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM168.5 304H184h80 15.5l-9 12.6-37.2 52.1 23.2 46.3L304 320h80l58.7 176 5.3 16H431.1 225.9h-3.8H16.9 0l5.3-16L64 320h80l47.5 95.1 23.2-46.3-37.2-52.1-9-12.6zm80 16H199.5l23.2 32.5 1.2-2.4 1.2 2.4L248.5 320zM209.7 487.2L134.1 336H75.5L22.2 496H214.1l-4.4-8.8zm-9.2-54.2l14.6 29.2L224 480l8.9-17.9 14.6-29.2L224 385.9l-23.5 47.1zM233.9 496H425.8L372.5 336H313.9L238.3 487.2l-4.4 8.8z'
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fast',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM239.4 396.7l-42.7-42.7L184.8 342l-7.5 15.1-20.6 41.2-7.2 14.3-7.2 14.3L128 419.8 99.4 405.5l-14.3-7.2L92.2 384l7.2-14.3 48-96 51.2-8.3L224 290.7l16 16 0-22.6 0-44.1 0-13.3 9.4-9.4 16-16 9.4-9.4H288h32 16 16v16 16V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3zm-97.1-5.5l28.1-56.3 9.9-19.9 15.7 15.7 54.7 54.7c9.4 9.4 22.1 14.6 35.3 14.6c27.6 0 49.9-22.4 49.9-49.9V224 208H320 288h-6.6l-4.7 4.7-16 16-4.7 4.7 0 6.6 0 66.7 0 38.6-27.3-27.3-35.6-35.6L158 288.2l-44.3 88.7-7.2 14.3 28.6 14.3 7.2-14.3zM240 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM208 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fast',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      'M318.2 284.3l0 0C293 259.1 310 216 345.6 216H368h16V200 184 168H368 345.6c-35.6 0-52.6-43.1-27.4-68.3l15.2-15.2 11.3-11.3L333.4 61.9l-5.6-5.6-5.7-5.7L310.8 39.3 299.5 50.6 284.3 65.8C259.1 91 216 74 216 38.4V16 0H200 184 168V16 38.4C168 74 124.9 91 99.7 65.8L84.5 50.6 73.2 39.3 61.9 50.6 50.6 61.9 39.3 73.2 50.6 84.5 65.8 99.7C96 128 74 168 38.4 168H16 0v16 16 16H16 38.4C74 216 91 259.1 65.8 284.3L50.6 299.5 39.3 310.8l11.3 11.3 11.3 11.3 11.3 11.3 11.3-11.3 15.2-15.2C124.9 293 168 310 168 345.6V368v16h16 16 16V368 345.6c0-35.6 43.1-52.6 68.3-27.4l15.2 15.2 11.3 11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3-11.3-15.2-15.2zm3.9 26.5l-11.3 11.3-15.2-15.2 0 0c-34.7-34.7-95.6-12-95.6 38.7V368H184V345.6c0-50.7-60.9-73.4-95.6-38.7L73.2 322.1 61.9 310.8l15.2-15.2c34.7-34.7 12-95.6-38.7-95.6H16V184H38.4c23.9 0 44.1-13.5 52.9-32.9c9.1-20 5.3-44.3-14.4-62.9l-15-15L73.2 61.9 88.4 77.1l0 0c34.7 34.7 95.6 12 95.6-38.7V16h16V38.4c0 50.7 60.9 73.4 95.6 38.7l15.2-15.2 5.7 5.7 5.6 5.6L306.9 88.4c-34.7 34.7-12 95.6 38.7 95.6H368v16H345.6c-50.7 0-73.4 60.8-38.7 95.6l0 0 0 0 0 0 15.2 15.2zM480 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-80-40a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM368 368c47.2 0 70.9-57.1 37.5-90.5c33.4 33.4 90.5 9.7 90.5-37.5c0 21.8 12.1 38.5 28.5 47c19.1 9.9 44 8.5 62-9.5C553.1 310.9 576.8 368 624 368c-47.2 0-70.9 57.1-37.5 90.5C553.1 425.1 496 448.8 496 496c0-47.2-57.1-70.9-90.5-37.5c33.4-33.4 9.7-90.5-37.5-90.5zM480 224v16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-22.6 22.6 11.3 11.3C417.5 312.1 401 352 368 352H352v32h16c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 22.6 22.6 11.3-11.3C440.1 446.5 480 463 480 496v16h32V496c0-33 39.9-49.5 63.2-26.2l11.3 11.3 22.6-22.6-11.3-11.3C574.5 423.9 591 384 624 384h16V352H624c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-22.6-22.6-11.3 11.3C551.9 289.5 512 273 512 240V224H480z'
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fast',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM280 144H264v8V296v8h16v-8V152v-8zM256 336v32h32V336H256z'
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fast',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      'M80 142c0-51.9 42.1-94 94-94c11 0 21.8 1.9 32.1 5.7l71.1 25.9 7.5 2.7 5.5-15-7.5-2.7L211.6 38.6C199.6 34.2 186.8 32 174 32C113.3 32 64 81.3 64 142V256H0v16H64v54.2L.8 460.6 0 462.2V464v8 8H8 312h8V464h-8H16.8L79.2 331.4l.8-1.6V328 272H256V256H80V142z'
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fast',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      'M48 128c0 32.8 14.1 62.3 36.6 82.8c-5.4 2-10.7 4.4-15.8 6.9C46 194.7 32 163 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c47.2 0 88.4 25.6 110.6 63.6c-4.5 2.9-8.9 6-13.1 9.3C398.3 70.9 361.8 48 320 48c-21.5 0-41.5 6-58.6 16.5l-6.3 3.9-4.3-6C230.4 34.3 197.3 16 160 16C98.1 16 48 66.1 48 128zm464-16c-44 0-82.1 25.4-100.4 62.3l-4.9 9.9-7.9-7.8C378.6 156.4 350.7 144 320 144c-47.7 0-88.5 29.8-104.6 71.9c-4.8-2.3-9.7-4.3-14.8-6.1c18.5-47.9 65-81.8 119.4-81.8c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 45.1-23.3 84.7-58.5 107.5c-2.7-4.6-5.7-9.1-8.9-13.3C603.5 298.2 624 263.5 624 224c0-61.9-50.1-112-112-112zM144 240C73.3 240 16 297.3 16 368V496H144 464h96V400c0-53-43-96-96-96c-11.3 0-22.1 2-32.2 5.5l-6.9 2.5-3.1-6.7C404.1 266.8 365.2 240 320 240c-30.9 0-58.9 12.5-79.2 32.8l-5.4 5.4-5.6-5.1c-22.7-20.5-52.8-33-85.8-33zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112V504v8h-8H464 144 8 0v-8V368z'
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fast',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      'M576 32H560 512 496V48 72 367.3c0 35.7-28.9 64.7-64.7 64.7c-31.2 0-58-22.3-63.6-53.1l-.4-2.1-4.3-23.6-2.9-15.7-15.7 2.9-47.2 8.6-15.7 2.9 2.9 15.7 4.3 23.6 .4 2.1C301.5 462 361.4 512 431.3 512C511.2 512 576 447.2 576 367.3V72 48 32zM512 72V48h48V72v72H512V72zm0 88h48v32H512V160zm0 207.3V208h48V367.3C560 438.4 502.4 496 431.3 496c-62.2 0-115.5-44.5-126.6-105.6l-.4-2.1-4.3-23.6 47.2-8.6 4.3 23.6 .4 2.1c7 38.4 40.4 66.2 79.4 66.2c44.5 0 80.7-36.1 80.7-80.7zM256 288H432h16V272 80 64H432 16 0V80 272v16H16 192l18.3-64h27.4L256 288zm-61.1-68.4l-15 52.4H16V80H432V272H268.1l-15-52.4L249.8 208H237.7 210.3 198.2l-3.3 11.6z'
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fast',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM467.3 464h-280L310.8 340.5l-12.6-10L288 340.7l-86.5-86.5-10.6-8.4-4.5 4.5L80 356.7V158.3L64 145.6V464v16H80 487.5l-20.3-16zM560 32H152.5l20.3 16H560V292.7L453.7 186.3l-5.7-5.7-5.7 5.7L400.7 228l12.6 10L448 203.3l112 112v38.4l16 12.6V48 32H560zM80 379.3l112-112L276.7 352l-112 112H80V379.3z'
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fast',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      'M208 88a36 36 0 1 0 0-72 36 36 0 1 0 0 72zm0-88a52 52 0 1 1 0 104A52 52 0 1 1 208 0zm19.4 270.3l-3.2-6.4-10.5-21-6.6 22.5-11.7 39.9 52.3 57 5.2 5.7 2 7.5 24 88 4.2 15.4 4.2 15.4-15.4 4.2L241 507.1l-15.4 4.2-4.2-15.4-4.2-15.4-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l11.7-43.7 5.3-19.9-18.8 8.3-17.9 7.9L78.4 250.1l-5.1 15.2-5.1 15.2-15.2-5.1L22.7 265.3 7.5 260.2l5.1-15.2 5.1-15.2 16-48 4.5-13.4L51 162.8l72-32 9.3-4.1 10 2 80 16 15.3 3.1 7 14 35.2 70.5L304 244.2l14.3 7.2-7.2 14.3-14.3 28.6-7.2 14.3-14.3-7.2-33.7-16.8-9.5-4.8-4.8-9.5zm8.4 102.9l-52.3-57-6.1-6.7 2.5-8.7 18.4-62.4 11.5-39L228 235.8l13.7 27.4 2.4 4.8 4.8 2.4 33.7 16.8 14.3-28.6-24.1-12.1-4.8-2.4-2.4-4.8-35.2-70.5-3.5-7-7.7-1.5-80-16-5-1-4.6 2.1-72 32-6.4 2.9-2.2 6.7-16 48-5.1 15.2 30.4 10.1 5.1-15.2 11.5-34.6 2.2-6.7 6.4-2.9 36.7-16.3L150.6 171 142 203.3l-17 63.6c-4.2 15.8-.1 32.7 11 44.8L207 389.1l2.6 2.9 1 3.7 22 80.5 4.2 15.4 30.9-8.4-4.2-15.4-24-88-1-3.7-2.6-2.9zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l4.8 5.2L83.6 404l-1.2 3L80 409.3 36.7 452.7 25.4 464 48 486.6l11.3-11.3 48-48 2.3-2.3 1.2-3 18.6-46.4 12 13.1-15.7 39.3-2.4 6.1-4.6 4.6-48 48L59.3 497.9 48 509.3 36.7 497.9 14.1 475.3 2.7 464l11.3-11.3 11.3-11.3L68.7 398zM400 8V88v8H384V88 8 0h16V8zM533.1 169.9l96 80 7.4 6.1-7.4 6.1-96 80-6.1 5.1L516.7 335l6.1-5.1 79-65.9H392h-8V248h8H601.9l-79-65.9-6.1-5.1L527 164.7l6.1 5.1zM400 128v8 48 8H384v-8V136v-8h16zm0 200v48 8H384v-8V328v-8h16v8zm0 88v8 80 8H384v-8V424v-8h16z'
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fast',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      'M80 16V96H368V16H80zM64 0H80 368h16V16 96v16H368 80 64V96 16 0zm48 264.6l-7.1 4.8L64.6 296.2C34.2 316.4 16 350.5 16 386.9v2.2C16 448.2 63.8 496 122.8 496c21.1 0 41.7-6.2 59.3-17.9L336 375.4V144h16V384L190.9 491.4c-20.2 13.4-43.9 20.6-68.1 20.6C55 512 0 457 0 389.2v-2.2c0-41.8 20.9-80.9 55.7-104.1L96 256V144h16V256v8.6z'
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fast',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      'M144 64c0 16.8 8.6 31.6 21.7 40.2l4.4 2.9-.9 5.2c-.8 4.5-1.2 9.3-1.2 14.4C168 188 220.4 240 288 240s120-52 120-113.3c0-5.2-.4-10-1.2-14.4l-.9-5.2 4.4-2.9C423.4 95.6 432 80.8 432 64c0-26.5-21.5-48-48-48c-20.3 0-37.8 12.7-44.7 30.6l-2.4 6.1-6.5-1.2C316.3 49 301.7 48 288 48s-28.3 1-42.4 3.5l-6.5 1.2-2.4-6.1C229.8 28.7 212.3 16 192 16c-26.5 0-48 21.5-48 48zM192 0c24.8 0 46.3 14.1 56.9 34.8c13.2-2 26.5-2.8 39.1-2.8s25.8 .8 39.1 2.8C337.7 14.1 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.5-9.7 38.8-24.7 50.5c.5 3.9 .7 7.9 .7 12.1C424 197.4 363.8 256 288 256s-136-58.6-136-129.3c0-4.2 .2-8.2 .7-12.1c-15-11.7-24.7-30-24.7-50.5c0-35.3 28.7-64 64-64zm72 168c0 3.5 1.9 7.4 6.2 10.6s10.6 5.4 17.8 5.4s13.5-2.2 17.8-5.4s6.2-7 6.2-10.6s-1.9-7.4-6.2-10.6s-10.6-5.4-17.8-5.4s-13.5 2.2-17.8 5.4s-6.2 7-6.2 10.6zm24-32c10.4 0 20.1 3.2 27.4 8.6s12.6 13.7 12.6 23.4s-5.3 17.9-12.6 23.4s-17 8.6-27.4 8.6s-20.1-3.2-27.4-8.6s-12.6-13.7-12.6-23.4s5.3-17.9 12.6-23.4s17-8.6 27.4-8.6zm183.3 25.3l6.2 5 75 60 6.2 5-5 6.2-30 37.5-10.8 13.5c-27.4 34.2-60.6 60.3-96.9 78.3V400h49l5.3-41 .9-7h7 86.6 8.8l-.9 8.8-14.4 144-.7 7.2h-7.2H472l-361.4 0 0 0H104 25.6 18.4l-.7-7.2L3.2 360.8 2.4 352h8.8H97.8h7l.9 7 5.3 41h49V366.8c-36.3-18-69.5-44.1-96.9-78.3L52.3 275l-30-37.5-5-6.2 6.2-5 75-60 6.2-5 5 6.2 30 37.5 10.8 13.5c70.5 88.1 204.4 88.1 274.9 0L436.3 205l30-37.5 5-6.2zM39.8 233.7l25 31.2 10.8 13.5c26.9 33.7 59.9 59 95.8 76l4.6 2.2v5.1V400h24v-4-3.3l2.3-2.3 36-36 2.3-2.3H244h88 3.3l2.3 2.3 36 36 2.3 2.3V396v4h24V361.8v-5.1l4.6-2.2c35.9-17 68.9-42.3 95.8-76L511.2 265l25-31.2-62.5-50-25 31.2-10.8 13.5c-76.9 96.1-223 96.1-299.9 0L127.2 215l-25-31.2-62.5 50zM376 416l0 16 0 64 96 0h71.2L556 368H485.3l-5.3 41-.9 7h-7H416v0H376zm-16 16l0-24v-8l0-.7L328.7 368H247.3L216 399.3v.7 8 24 64l144 0 0-64zm-160 0V416H160v0H104 97l-.9-7-5.3-41H20L32.8 496H97.4l0 0H104l96 0V432zm40-332a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm84 12a12 12 0 1 1 24 0 12 12 0 1 1 -24 0z'
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fast',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      'M210.9 47.4C217.7 29.1 235.3 16 256 16s38.3 13.1 45.1 31.4l4.8 13.2 8.9-10.9C323.6 38.9 337 32 352 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H302.5h-4.4l-2.4 3.7L267.6 176H244.4l-28.2-44.3-2.4-3.7h-4.4H160c-26.5 0-48-21.5-48-48s21.5-48 48-48c15 0 28.4 6.9 37.2 17.7l8.9 10.9 4.8-13.2zM256 0c-23.3 0-43.6 12.4-54.8 31C190 21.6 175.7 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64h45.1l28.2 44.3 2.4 3.7H240h32 4.4l2.4-3.7L306.9 144H352c35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.7 0-30 5.6-41.2 15C299.6 12.4 279.3 0 256 0zM16 446.1l94.2-106L128 352l112-32 80 64 83.6-41.8L496 446.1V496H16V446.1zM418.5 334.8l-11-12.4L320 224H192l-84.5 95.1 0 0L96.7 331.2l0 0L0 440v56 16H16 496h16V496 440L418.5 334.8zM199.2 240H312.8l79.8 89.8L322 365.1l-72-57.6-6.4-5.2-7.9 2.3-104.9 30-9.8-6.5 78.3-88z'
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fast',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      'M144 32v70c15.3-3.9 31.4-6 48-6c10.9 0 21.6 .9 32 2.7V32h16v70c82.8 21.3 144 96.5 144 186H368c0-80.6-54.1-148.5-128-169.4L240 288H224l0-173.1c-10.4-1.9-21.1-2.9-32-2.9c-16.6 0-32.7 2.3-48 6.6L144 288H128l0-164C62.4 149.6 16 213.4 16 288c0 97.2 78.8 176 176 176H384v16H192 0V464H115.1C47.4 434.4 0 366.7 0 288c0-83.6 53.4-154.7 128-181.1V32h16z'
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fast',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      'M400 80V48L224 0 48 48V80L80 99.2V144c16 10.7 67.2 32 144 32s128-21.3 144-32V99.2L400 80zM352 99.2v35.6c-16.2 8.2-50.5 20.5-99.4 24.2c21.5-20.4 27.4-48.8 27.4-67.7V85.8l-5-2L227 64.6l-3-1.2-3 1.2L173 83.8l-5 2v5.4c0 19 5.9 47.4 27.4 67.7c-48.9-3.6-83.2-16-99.4-24.2V99.2 90.1l-7.8-4.7L64 70.9V60.2L224 16.6 384 60.2V70.9L359.8 85.5 352 90.1v9.1zM96.3 183.3c-.2 2.9-.3 5.8-.3 8.7c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7c-4.8 2.3-10.1 4.5-15.7 6.7c0 .7 0 1.3 0 2c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-.7 0-1.3 0-2c-5.7-2.2-10.9-4.4-15.7-6.7zm87.9-86.8L224 80.6l39.8 15.9c-1.3 20.9-10.8 49-39.8 62.7c-29-13.7-38.5-41.8-39.8-62.7zm29 331.2l2.9 2.6V496H21.5L59.9 368h88.5l64.7 59.8zM232 496V430.4l2.9-2.6L299.6 368h88.5l38.4 128H232zm61.3-144L224 416l-69.3-64H48L4.8 496 0 512H16.7 224 431.3 448l-4.8-16L400 352H293.3zM360 424v-8H344v8 16H328h-8v16h8 16v16 8h16v-8V456h16 8V440h-8H360V424z'
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fast',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.7-341.7l-5.7-5.7-5.7 5.7-120 120-5.7 5.7L136 307.3l5.7-5.7L256 187.3 370.3 301.7l5.7 5.7L387.3 296l-5.7-5.7-120-120z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fast',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      'M132.7 196.7L59.3 123.3 48 112l11.3-11.3L80 80H352h16V96 368l-20.7 20.7L336 400l-11.3-11.3-73.4-73.4L240 304l-11.3 11.3L107.3 436.7 96 448 84.7 436.7 11.3 363.3 0 352l11.3-11.3L132.7 219.3 144 208l-11.3-11.3zM22.6 352L96 425.4 228.7 292.7 240 281.4l11.3 11.3L336 377.4l16-16V96H86.6l-16 16 84.7 84.7L166.6 208l-11.3 11.3L22.6 352z'
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM176 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176c23.6 0 45.2-8.5 61.9-22.6l44.4 44.4 5.7 5.7 11.3-11.3-5.7-5.7-44.4-44.4C263.4 365.3 272 343.7 272 320c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z'
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fast',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      'M319.7 12.9L317.1 0H304 208 194.9l-2.6 12.9-9.7 48.5c-4.2 1.6-8.3 3.3-12.4 5.1L129.1 39l-10.9-7.3L108.9 41 41 108.9l-9.3 9.3L39 129.1l27.4 41.1c-1.8 4.1-3.6 8.2-5.1 12.4l-48.5 9.7L0 194.9V208v96 13.1l12.9 2.6 48.5 9.7c1.6 4.2 3.3 8.3 5.1 12.4L39 382.9l-7.3 10.9 9.3 9.3L108.9 471l9.3 9.3 10.9-7.3 41.1-27.4c4.1 1.8 8.2 3.6 12.4 5.1l9.7 48.5 2.6 12.9H208h96 13.1l2.6-12.9 9.7-48.5c4.2-1.6 8.3-3.3 12.4-5.1L382.9 473l10.9 7.3 9.3-9.3L471 403.1l9.3-9.3L473 382.9l-27.4-41.1c1.8-4.1 3.6-8.2 5.1-12.4l48.5-9.7 12.9-2.6V304 208 194.9l-12.9-2.6-48.5-9.7c-1.6-4.2-3.3-8.3-5.1-12.4L473 129.1l7.3-10.9-9.3-9.3L403.1 41l-9.3-9.3L382.9 39 341.8 66.5c-4.1-1.8-8.2-3.6-12.4-5.1l-9.7-48.5zm-150.7 72c8.8-4.5 18-8.3 27.6-11.4L208 16h96l11.5 57.4c9.5 3.1 18.8 6.9 27.6 11.4l48.7-32.5 67.9 67.9-32.5 48.7c4.5 8.8 8.3 18 11.4 27.6L496 208v96l-57.4 11.5c-3.1 9.5-6.9 18.8-11.4 27.6l32.5 48.7-67.9 67.9-48.7-32.5c-8.8 4.5-18 8.3-27.6 11.4L304 496H208l-11.5-57.4c-9.5-3.1-18.8-6.9-27.6-11.4l-48.7 32.5L52.4 391.8l32.5-48.7c-4.5-8.8-8.3-18-11.4-27.6L16 304V208l57.4-11.5c3.1-9.5 6.9-18.8 11.4-27.6L52.4 120.2l67.9-67.9 48.7 32.5zM176 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fast',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM131.9 181.4l-6.5 14.6 7.3 3.2 72 32 1.6 .7H208l0 94.8-23.7 78.9-2.3 7.7 15.3 4.6 2.3-7.7L222 336H290l22.3 74.3 2.3 7.7 15.3-4.6-2.3-7.7L304 326.8l0-94.8h1.7l1.6-.7 72-32 7.3-3.2-6.5-14.6-7.3 3.2L302.3 216H288 224 209.7l-70.4-31.3-7.3-3.2zM224 232h64v88H224V232z'
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fast',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      'M438.4 412l-1.1-2L357.6 272 316 344 229.1 494.5c8.8 1 17.8 1.5 26.9 1.5c73 0 138.4-32.6 182.4-84zm10.7-13.5C478.6 358.7 496 309.4 496 256c0-28.1-4.8-55-13.7-80H480 320.7l41.6 72 86.9 150.5zM302.2 176H217.8h-8l-42.2 73.1-4 6.9 42.2 73.1 4 6.9 0 0h0 84.4 8l0 0 42.2-73.1 4-6.9 0 0-42.2-73.1-4-6.9zM191.3 336l-41.6-72L62.9 113.5C33.4 153.3 16 202.6 16 256c0 28.1 4.8 55 13.7 80H32 191.3zM73.6 100l1.1 2 79.7 138L196 168 282.9 17.5C274 16.5 265.1 16 256 16c-73 0-138.4 32.6-182.4 84zM213.3 490L293 352H209.8 36c31.4 71.9 97 125.4 176.2 140l1.2-2zM476 160c-31.4-71.9-97-125.4-176.2-140l-1.2 2L219 160h83.1H476zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fast',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      'M493.9 224H510C495.6 108.2 403.8 16.4 288 2V18.1C395 32.4 479.6 117.1 493.9 224zM510 288H493.9C479.6 395 395 479.6 288 493.9V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V493.9C117 479.6 32.4 395 18.1 288H2zm0-64H18.1C32.4 117 117.1 32.4 224 18.1V2C108.2 16.4 16.4 108.2 2 224zm166-80v-8H152v8V368v8h16v-8V264H344V368v8h16v-8V144v-8H344v8V248H168V144z'
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fast',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      'M349 208h19 16V192 168L235 11.6 224 0 213 11.6 64 168v24 16H80 99h21l-13.5 16L32 312v24 16H48 75.5 96L83.2 368 0 472v24 16H16 432h16V496 472L364.8 368 352 352h20.5H400h16V336 312l-74.5-88L328 208h21zm51 109.9V336H352 318.7l20.8 26L432 477.6V496H16V477.6L108.5 362l20.8-26H96 48V317.9l84.2-99.5L154.5 192H120 80V174.4L224 23.2 368 174.4V192H328 293.5l22.3 26.3L400 317.9z'
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fast',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      'M512 416H239.6l20.7-16H512V320 304 208 192 112H369l4-16H512h16v16 80h32 16v16 96 16H560 528v80 16H512zM16 112V400H175l-4 16H16 0V400 112 96H16 304.4l-20.7 16H16zm544 96H528v96h32V208zM214.3 374.9L236 288l4-16H223.5 176 160V256v-8L315.6 127.8 336 112l-6.3 25.1L308 224l-4 16h16.5H368h16v16 8L228.4 384.2 208 400l6.3-25.1zM240 256h20.5l-5 19.9-20.8 83.3L368 256.1V256H304 283.5l5-19.9 20.8-83.3L176 255.9v.1h64z'
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fast',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zM136 352H280h8V336h-8H155.3L317.7 173.7l5.7-5.7L312 156.7l-5.7 5.7L144 324.7V200v-8H128v8V344v8h8z'
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fast',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 416c66.8 0 123-47.7 137.3-112H118.7C133 368.3 189.2 416 256 416zM100 288h16.1H395.9 412c-.5 5.4-1.3 10.8-2.4 16C395.1 377 331.8 432 256 432s-139.1-55-153.6-128c-1-5.2-1.8-10.6-2.4-16zm50.9-108.3c-7.4 11.4-12.7 26.3-15.2 39.8L120 216.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L216 219.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8L280 216.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L376 219.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fast',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      'M384 0h8H504h8V8 32v8H496V32 16H400V32v8H384V32 8 0zM575.1 192h-16c0-1.3 .2-2.7 .5-3.9V104.3L507.8 80H387.4L340 102.2l-18.2-9.1L383.9 64H511.3l64.3 30.1V176v15.9 .1h-.5zM352 192H336V153.9L252.2 112H131.8L48 153.9V192H32V144l96-48H256l63.6 31.8v0l16 8v0L352 144l0 48zm256 32h32v16H606.2L576 512H64L33.8 240H0V224H32 48h.1H591.9h.1 16zM49.9 240L78.3 496H561.7l28.4-256H49.9zM136 0H248h8V8 48h8 8V64h-8H248h-8V56 16H144V56v8h-8H120h-8V48h8 8V8 0h8z'
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fast',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      'M3.4 495L0 512l17-3.4L160 480 485.5 154.5c17-17 26.5-40 26.5-64C512 40.5 471.5 0 421.5 0c-24 0-47 9.5-64 26.5L301.7 82.3l-48-48L248 28.7l-5.7 5.7-96 96-5.7 5.7L152 147.3l5.7-5.7L248 51.3l42.3 42.3L32 352 3.4 495zm17-3.4L46.7 359.9 181.7 225 287 330.3 152.1 465.3 20.4 491.6zM193 213.7L368.8 37.8c14-14 32.9-21.8 52.7-21.8C462.6 16 496 49.4 496 90.5c0 19.8-7.8 38.7-21.8 52.7L298.3 319 193 213.7z'
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fast',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      'M448 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272c23.8 0 46.3-5.8 66-16H624h16V368 144 128H624 514c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H219.4L0 192V320l219.4 64H382c19.8 10.2 42.2 16 66 16zm176-32H538.5c32.6-26.4 53.5-66.8 53.5-112s-20.9-85.6-53.5-112H624V368zM221.7 144H357.5C324.9 170.4 304 210.8 304 256s20.9 85.6 53.5 112H221.7L16 308V204l205.7-60zm191.9 66.3l-5.7-5.7L396.7 216l5.7 5.7L436.7 256l-34.3 34.3-5.7 5.7L408 307.3l5.7-5.7L448 267.3l34.3 34.3 5.7 5.7L499.3 296l-5.7-5.7L459.3 256l34.3-34.3 5.7-5.7L488 204.7l-5.7 5.7L448 244.7l-34.3-34.3z'
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fast',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM128 64h8H248h8V80h-8H136h-8V64zM240 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-4.5 112l-21.3 64H85.3L112 320H272l26.7 80H281.8l-21.3-64H123.5z'
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fast',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      'M32 176a160 160 0 1 1 320 0A160 160 0 1 1 32 176zM200 351.8c93.5-4.2 168-81.3 168-175.8C368 78.8 289.2 0 192 0S16 78.8 16 176c0 94.5 74.5 171.6 168 175.8V504v8h16v-8V351.8z'
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fast',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      'M260.2 4.4L256 1.8l-4.2 2.6-248 152L0 158.7v4.5V504v8H16v-8V167.7L256 20.6 496 167.7V504v8h16v-8V163.2v-4.5l-3.8-2.3-248-152zM232 168a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM216 296v-8H200v8V504v8h8 40 8 0 8 40 8v-8V296v-8H296v8V496H264V384v-8h0H248h0v8V496H216V296zm-11.1-72H200l-2.2 4.4-60.9 120-3.6 7.1 14.3 7.2 3.6-7.1L209.8 240h92.3l58.7 115.6 3.6 7.1 14.3-7.2-3.6-7.1-60.9-120L312 224h-4.9H204.9z'
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fast',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      'M343.9 194.6l63.2 278.2L416 512l7.4-39.6L509 16l3-16H495.7 16.6 0L4.4 16 88 322.8 96 352l8.7-29 29.8-99.2L144 192l7 32.5 32.9 153.3L192 416l8.2-38.2L233 224.5l7-32.5 9.5 31.8L279 322l9 30 7.6-30.4 31.8-127.3L336 160l7.9 34.6zm-57.3 97.1L255.3 187.4l-17.9-59.7-13.1 60.9L192 339.6l-32.4-151-13.1-60.9-17.9 59.7L96.7 293.9 20.9 16H492.7L414.5 433.2 351.6 156.5 336.7 91.1l-16.3 65.1L286.6 291.6z'
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fast',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      'M153.3 96H358.7h10.5l4.2 9.6c9.9 22.6 32.5 38.4 58.7 38.4c23.7 0 44.4-12.9 55.4-32H432 416V96 64 48h16 55.4C476.4 28.9 455.7 16 432 16c-26.2 0-48.8 15.8-58.7 38.4L369.1 64H358.7 153.3 142.9l-4.2-9.6C128.8 31.8 106.2 16 80 16C56.3 16 35.6 28.9 24.6 48H80 96V64 96v16H80 24.6c11.1 19.1 31.8 32 55.4 32c26.2 0 48.8-15.8 58.7-38.4l4.2-9.6h10.5zM1.6 96H18 64 80V80 64H64 18 1.6c1.1-5.6 2.8-10.9 5.1-16C19 19.7 47.2 0 80 0s61 19.7 73.3 48H358.7C371 19.7 399.2 0 432 0s61 19.7 73.3 48c2.2 5.1 3.9 10.4 5.1 16H494 448 432V80 96h16 46 16.4c-1.1 5.6-2.8 10.9-5.1 16c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48H153.3C141 140.3 112.8 160 80 160s-61-19.7-73.3-48c-2.2-5.1-3.9-10.4-5.1-16zM146 176h6H360h6l1.7 5.8L398 288h34 16v16V432v16 48 16H432 384 368V496 448H144v48 16H128 80 64V496 448 432 304 288H80h34l30.3-106.2L146 176zM80 304V432h48 16H368h16 48V304H80zM384 496h48V448H384v48zM128 448H80v48h48V448zM354 192H158l-27.4 96H381.4L354 192zM128 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fast',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      'M333.9 13.1L343.1 0l12.6 9.9L407.9 51l12.6 9.9-10.6 12L24.6 510.4 0 491 333.9 13.1zM21.8 487.8l.8 .7L397.3 63 346.5 23 21.8 487.8zM564.5 72L576 61l10.4 12.2 43.1 50.3L640 135.6l-12.7 9.8L149.4 512 129 488.2 564.5 72zM151 489.3l.7 .8L616.9 133.2l-42-49L151 489.3z'
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fast',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 330.8c-6.9-4.9-13.5-10.2-19.6-16H16V192H352h80 16V176 80 64H432 336V8 0H320V8 64H128V8zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM432 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-136V360h-8H360h-8v16h8H504h8z'
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fast',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      'M176 72c0 35.3 28.7 64 64 64V112c0-35.3-28.7-64-64-64V72zM160 32h16c44.2 0 80 35.8 80 80v24 16H240c-44.2 0-80-35.8-80-80V48 32zm16 216v24c35.3 0 64-28.7 64-64V184c-35.3 0-64 28.7-64 64zm-16 40V272 248c0-44.2 35.8-80 80-80h16v16 24c0 44.2-35.8 80-80 80H160zM288 48V72c0 35.3 28.7 64 64 64V112c0-35.3-28.7-64-64-64zm0-16c44.2 0 80 35.8 80 80v24 16H352c-44.2 0-80-35.8-80-80V48 32h16zm0 216v24c35.3 0 64-28.7 64-64V184c-35.3 0-64 28.7-64 64zm-16 40V272 248c0-44.2 35.8-80 80-80h16v16 24c0 44.2-35.8 80-80 80H272zM400 48V72c0 35.3 28.7 64 64 64V112c0-35.3-28.7-64-64-64zm0-16c44.2 0 80 35.8 80 80v24 16H464c-44.2 0-80-35.8-80-80V48 32h16zm0 216v24c35.3 0 64-28.7 64-64V184c-35.3 0-64 28.7-64 64zm-16 40V272 248c0-44.2 35.8-80 80-80h16v16 24c0 44.2-35.8 80-80 80H384zM0 152H8 152h8v16h-8H8 0V152zM40 80h80 8V96h-8H40 32V80h8zM32 224h8 80 8v16h-8H40 32V224zm80 220v20H400V444 431.6l12-3.1c43.3-11.1 76.4-47.5 82.9-92.5H416 96 17.1c6.4 45 39.6 81.3 82.9 92.5l12 3.1V444zm-16 0C45.8 431 7.5 388.5 1 336c-.7-5.2-1-10.6-1-16H16 96 416h80 16c0 5.4-.3 10.8-1 16c-6.5 52.5-44.8 95-95 108v20 16H400 112 96V464 444z'
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fast',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      'M320 80A64 64 0 1 0 192 80a64 64 0 1 0 128 0zm-22.7 68.5C285.3 155.8 271.1 160 256 160s-29.3-4.2-41.3-11.5l-88.9 160c37.4 22.6 81.2 35.5 128 35.5c91.8 0 171.9-49.9 214.8-124l13.8 8c-45.6 78.9-130.9 132-228.7 132c-49.6 0-96.1-13.7-135.8-37.5L15 507.9 1 500.1 104.5 313.8C72.1 291.5 44.8 262.2 25.1 228l13.8-8c18.3 31.7 43.5 58.9 73.4 79.8L201 140.1l.7-1.3C185.9 124.2 176 103.2 176 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 23.2-9.9 44.2-25.7 58.8l.7 1.3 71.8 129.2c-4.3 3.2-8.7 6.2-13.2 9.1L297.3 148.5zM497 507.9L408.4 348.4c4.6-2.8 9-5.7 13.4-8.8L511 500.1l-14 7.8z'
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fast',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      'M229.7 162.3l-5.7-5.7-5.7 5.7-136 136L76.7 304 88 315.3l5.7-5.7L216 187.3 216 504l0 8 16 0 0-8 0-316.7L354.3 309.7l5.7 5.7L371.3 304l-5.7-5.7-136-136zM16 184L16 16l416 0 0 168 0 8 16 0 0-8L448 8l0-8-8 0L8 0 0 0 0 8 0 184l0 8 16 0 0-8z'
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fast',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      'M256 120c-80 0-128 24-128 24L96 224H0V128s96-96 256-96s256 96 256 96v96H416l-32-80s-48-24-128-24zM115.4 132.4c13.6-6.8 27.7-11.8 42.4-15.8C181 110.2 214.4 104 256 104s75 6.2 98.2 12.6c14.6 4 28.8 9.1 42.4 15.8L426.8 208H496V135c-8.7-7.7-29.1-24.3-59.7-41C394.1 71 332.7 48 256 48S117.9 71 75.7 94c-30.6 16.7-51 33.3-59.7 41v73H85.2l30.2-75.6zM256 240a72 72 0 1 0 0 144 72 72 0 1 0 0-144zm56 72a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM32 480V384L160 160H352L480 384v96H32zm432-16V388.2L342.7 176H169.3L48 388.2V464H464z'
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fast',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      'M168 23.6v79.7c12.4-4.8 25.9-7.4 40-7.4s27.6 2.6 40 7.4V16H224c-19.4 0-38.2 2.7-56 7.6zm-16 5.2C72.6 58.1 16 134.4 16 224c0 55.7 22.7 108.1 61.7 147.9l2.3 2.3v3.3V504v8H64v-8V380.7C23.7 338.4 0 283.1 0 224C0 100.3 100.3 0 224 0h24C351.6 0 434.3 83.3 439.8 184.7l69.5 61.8 2.7 2.4v3.6V328v8h-8H448V440v8h-8H320v56 8H304v-8V440v-8h8H432V328v-8h8 56V256l-69.3-61.6-2.6-2.3-.1-3.4c-3.3-89.4-71.9-163.9-160-172V111c33.5 19.4 56 55.6 56 97c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-41.5 22.5-77.7 56-97V28.8zM304 208a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fast',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96h16H336h16v16V336v16H336 176 160V336 176 160zm16 16V336H336V176H176z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fast',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      'M275.8 96l-3.7-2.1L234.4 72.4l-19.2 76.9-4.7 19-17.7-8.4-92.4-44C45.8 183.7 16 268.2 16 355.5v18.6l72.8-36.4 13.3-6.6 7.6 12.7 37.5 62.4 49.5-49.5 12.9-12.9 11.1 14.4L288 445.8l67.3-87.5 11.1-14.4 12.9 12.9 49.5 49.5 37.5-62.4 7.6-12.7 13.3 6.6L560 374.1V355.5c0-87.3-29.8-171.8-84.4-239.7l-92.4 44-17.7 8.4-4.7-19L341.6 72.4 303.9 93.9 300.2 96H296 280h-4.2zm61.8-39.8L352 48l4 16.1 16.3 65.4 4 15.8 14.7-7L480 96c61.9 72.3 96 164.3 96 259.5v26.6V400l-16-8-80-40-39.5 65.9L432 432l-11.7-11.7-40.9-40.9L368 368l-9.8 12.8-60.1 78.1L288 472l-10.1-13.1-60.1-78.1L208 368l-11.4 11.4-40.9 40.9L144 432l-8.5-14.1L96 352 16 392 0 400V382.1 355.5C0 260.3 34.1 168.3 96 96l88.9 42.3 14.7 7 4-15.8L220 64.1 224 48l14.4 8.2L280 80h16l41.6-23.8z'
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fast',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      'M0 0H8 632h8V8 152v8H624v-8V16H16V152v8H0v-8V8 0zM512 80v8l0 416v8h-8l-368 0h-8v-8l0-416V80h16v8l0 408 352 0 0-408V80h16zM320 200c-50 0-88 33.5-88 72s38 72 88 72s88-33.5 88-72s-38-72-88-72zm104 72c0 49.9-48 88-104 88s-104-38.1-104-88s48-88 104-88s104 38.1 104 88z'
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fast',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      'M272 16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272A144 144 0 1 0 272 0a144 144 0 1 0 0 288zM243.8 93.9c8.3-4.2 19.3-6 28.1-5.8c11.2 .2 22.8 2.3 34.3 5l7.8 1.8 3.7-15.6-7.8-1.8c-9.4-2.2-19.6-4.2-29.8-5V56 48H264v8V72.3c-8.9 .7-18.9 2.9-27.4 7.3C225.1 85.4 215 96 216.1 112.5c.9 13.4 10.1 21.5 20.2 26.7c9.4 4.8 21.4 8 32.3 11l1.8 .5c12 3.2 22.7 6.2 30.5 10.6c7.5 4.2 10.9 8.8 11.1 14.9c.3 8.7-4.2 14.3-11.7 18.3c-7.9 4.1-18.7 5.7-28 5.5c-13.1-.4-25.6-4.2-39.2-8.3l0 0 0 0c-2.2-.7-4.4-1.3-6.7-2l-7.7-2.3-4.5 15.3 7.7 2.3c2.1 .6 4.2 1.3 6.3 1.9l0 0c11.2 3.4 23.3 7.1 35.9 8.5v18.1 8h16v-8V215.8c9.2-.6 19.1-2.7 27.6-7.1c11.5-5.9 20.9-16.6 20.4-33c-.4-13.9-9-22.7-19.2-28.4c-9.9-5.5-22.6-9-34.1-12.1l-1-.3c-11.7-3.1-22.1-6-30-10c-7.9-4.1-11.2-8.3-11.5-13.5c-.5-8 3.7-13.5 11.7-17.6zM151.6 320h-2.8l-2.2 1.8L68.8 384H8 0v16H8 71.6h2.8l2.2-1.8L154.4 336H368v40H248h-8v8 40 8h8H397.3h2.5l2-1.4 116.3-80 27.2 39.6L391.5 496H8 0v16H8 393.9h2.5l2-1.4L561 398.8l6.6-4.5-4.5-6.6L526.8 335l-4.5-6.6-6.6 4.5L394.8 416H256V392H376h8v-8V328v-8h-8H151.6z'
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fast',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      'M8 32H128V48H16V160H0V40 32H8zM0 192H16V320H0V192zM0 352H16V464H128v16H8 0v-8V352zM448 192.7c-5.3-.5-10.6-.7-16-.7V48H320V32H440h8v8V192.7zM288 469.2V480H160V464H284.5c1.1 1.8 2.3 3.5 3.5 5.2zM160 48V32H288V48H160zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H440v64 8H424v-8V376H360h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fast',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7l5.7-5.7L352 180.7l-5.7 5.7L224 308.7l-58.3-58.3-5.7-5.7L148.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fast',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      'M304 16V256H288V16H232V256H216V16H160V256H144V16H80V256H64V16 0H80 368h16V16 256H368V16H304zM16 368H432V355.8L406.1 304H41.9L16 355.8V368zM0 368V352l32-64H416l32 64v16 16H432 400V504v8H384v-8V384H64V504v8H48v-8V384H16 0V368z'
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fast',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      'M35.7 208c-2.4 13-3.7 26.3-3.7 40v16c0 13.7 1.3 27 3.7 40H0v16H39.3C64 412.1 148.1 480 248 480h65 8V464h-8H248c-91 0-167.8-60.8-192.1-144H288V304H52c-2.6-12.9-4-26.3-4-40V248c0-13.7 1.4-27.1 4-40H288V192H55.9C80.2 108.8 157 48 248 48h65 8V32h-8H248C148.1 32 64 99.9 39.3 192H0v16H35.7z'
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fast',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      'M128 64h8H376h8v8 56h56 8v8 56h56 8v8V440v8h-8H400 304 208 112 8 0v-8V200v-8H8 64V136v-8h8 56V72 64zm16 16v56 8h-8H80v56 8H72 16V432h88V328v-8h16v8V432h80V328v-8h16v8V432h80V328v-8h16v8V432h80V328v-8h16v8V432h88V208H440h-8v-8V144H376h-8v-8V80H144z'
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fast',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      'M608 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM560 368c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-35.3 28.7-64 64-64s64 28.7 64 64V368zM496 64c-44.2 0-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80V144c0-44.2-35.8-80-80-80zM347.8 80l0 0 0 0 0 0 8-.6-1.1-16-8 .6 .6 8c-.6-8-.6-8-.6-8l0 0 0 0-.1 0-.3 0c-.3 0-.6 .1-1.1 .1c-.9 .1-2.3 .3-4 .5c-3.4 .5-8.1 1.3-13.8 2.7c-11.3 2.8-26.5 7.8-41.8 16.8C254.6 102.4 224 136.8 224 200v88 8 72c0 44.2 35.8 80 80 80s80-35.8 80-80V288c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32V200c0-56.8 27-86.4 53.7-102.1c13.5-8 27.2-12.5 37.4-15c5.1-1.2 9.4-2 12.3-2.4c1.5-.2 2.6-.3 3.3-.4l.8-.1 .2 0 0 0zM304 224c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64s-64-28.7-64-64V296v-8c0-35.3 28.7-64 64-64zM8 64H0V80H8 149L34.2 202.5 32 204.8V208v8 8h8H72c57.4 0 104 46.6 104 104v8c0 53-43 96-96 96c-25.9 0-42-9.2-51.6-17.9c-4.9-4.4-8.2-8.9-10.2-12.1c-1-1.6-1.7-3-2.2-3.8c-.2-.4-.4-.8-.5-1l-.1-.2 0 0 0 0 0 0 0 0s0 0-7.4 3s-7.4 3-7.4 3l0 0 0 0 0 .1 .1 .2 .2 .5c.2 .4 .4 .9 .8 1.6c.7 1.3 1.6 3.1 3 5.2c2.7 4.2 6.9 9.8 13 15.4C30 437.2 49.9 448 80 448c61.9 0 112-50.1 112-112v-8c0-66.3-53.7-120-120-120H51L165.8 85.5l2.2-2.3V80 72 64h-8H8z'
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fast',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      'M576 267.3L372.7 64C349.9 89.5 336 123.1 336 160c0 79.5 64.5 144 144 144c36.9 0 70.5-13.9 96-36.7zM587.3 256c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144c-36.9 0-70.5 13.9-96 36.7L587.3 256zM320 160a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM303.8 360H16.2C20.4 435.8 83.2 496 160 496s139.6-60.2 143.8-136zm0-16c-4.2-75.8-66.9-136-143.8-136S20.4 268.2 16.2 344H303.8zM160 192a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fast',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      'M224 347.7l9.8 7.6L368.7 460.3l27-18L224 70.2 52.3 442.3l27 18L214.2 355.4l9.8-7.6zM80 480L32 448 215.2 51.1 224 32l8.8 19.1L416 448l-48 32L224 368 80 480z'
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fast',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      'M290.3 210.3l-5.7 5.7L296 227.3l5.7-5.7L496 27.3V168v8h16v-8V8 0h-8H344h-8V16h8H484.7L290.3 210.3zm-68.7 91.3l5.7-5.7L216 284.7l-5.7 5.7L16 484.7V344v-8H0v8V504v8H8 168h8V496h-8H27.3L221.7 301.7z'
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fast',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 374.2L176 384V365.2 146.8 128l16 9.8L368.7 246.6 384 256l-15.3 9.4L192 374.2zM353.5 256L192 156.6V355.4L353.5 256z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fast',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      'M164.7 219.3c-10-10-25-19-42.9-26.9c-17.7-7.8-37.4-14.1-55.9-18.9c-18.2-4.8-35-8.2-47.4-10.4c1.7 10.7 4.5 24.9 8.9 40.6c9.7 34.9 26.7 75.8 55.9 105l13.8 13.8L80.9 333.3 26.4 369.6c6.3 5 14.5 10.9 24 16.7C75.1 401.6 108.1 416 144 416h16v16c0 11.8 1.2 21 2.5 27.7c4.9-1.7 10.9-3.9 17.5-6.6c19.4-7.8 44.3-19.3 67.1-34.5l.9-.6V328v-8h16v8 90.1l.9 .6c22.7 15.2 47.6 26.7 67.1 34.5c6.6 2.7 12.6 4.9 17.5 6.6c1.3-6.7 2.5-15.9 2.5-27.7V416h16c35.9 0 68.9-14.4 93.6-29.6c9.5-5.9 17.7-11.8 24-16.7l-54.5-36.3-16.2-10.8 13.8-13.8c29.2-29.2 46.2-70.1 55.9-105c4.4-15.7 7.2-29.9 8.9-40.6c-12.4 2.2-29.2 5.6-47.4 10.4c-18.5 4.9-38.1 11.1-55.9 18.9c-17.9 7.9-32.9 16.9-42.9 26.9L320 246.6V208c0-60.6-18.9-109.9-38-144.2c-9.5-17.1-19-30.3-26-39.3c-7.1 8.9-16.5 22.2-26 39.3c-19 34.3-38 83.6-38 144.2v38.6l-27.3-27.3zM248 437.1c-46 28.6-96 42.9-96 42.9s-8-16-8-48c-59 0-109.2-34.8-131.6-53C4.4 372.4 0 368 0 368l13.7-9.1L58.4 329 72 320c-3.8-3.8-7.5-7.8-10.9-12C20.6 259.2 6.5 191.3 1.9 160.4C.4 150.2 0 144 0 144s6.2 .8 16.3 2.5c31.6 5.3 101.9 19.8 144 48.6c5.9 4 11.2 8.3 15.7 12.9c0-7 .2-13.9 .7-20.7c6-87.9 48.5-150.3 68.7-175.2C251.8 4.2 256 0 256 0s4.2 4.2 10.6 12.1c20.2 25 62.8 87.3 68.7 175.2c.5 6.7 .7 13.6 .7 20.7c4.6-4.6 9.9-8.9 15.7-12.9c42-28.8 112.3-43.3 144-48.6c10.1-1.7 16.3-2.5 16.3-2.5s-.4 6.2-1.9 16.4c-4.5 30.9-18.6 98.8-59.2 147.6c-3.4 4.1-7.1 8.1-10.9 12l13.6 9 44.8 29.9L512 368s-4.4 4.4-12.4 11C477.2 397.2 427 432 368 432c0 32-8 48-8 48s-50-14.3-96-42.9V504v8H248v-8V437.1z'
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fast',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      'M352 0h8H632h8V16h-8H368V391.8l50.1-13.7C428.3 326.7 473.6 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-1.6 0-3.2 .1-4.7L18.1 503.7l-7.7 2.1L6.2 490.4l7.7-2.1L352 396.2V8 0zM624 400a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM318.4 194.5l1.6 6v19.4c-2.6 .1-5.3 .4-8 1.2c-18.2 4.9-29 23.6-24.2 41.8l2.3 8.5 4.1 15.5-15.5 4.1L112.9 335.4l-15.5 4.1L93.3 324l-2.8-10.6c-4.6-17.1-22.1-27.2-39.2-22.6S24.2 313 28.7 330l21.8 81.2 47.9-12.8 15.5-4.1 .1 .2 179.7-48.1 15.5-4.1 0 .1 10.9-2.9v16.6l-6.8 1.8-15.5 4.1 0-.1-15.5 4.1-164.2 44L102.6 414l-.1-.2L87.1 418l-32.5 8.7-15.5 4.1L35 415.4 13.3 334.2c-5.4-20 2.8-40.5 18.8-51.8l-2.8-10.5C16.7 225 44.6 176.7 91.5 164.1l119.1-31.9c46.9-12.6 95.2 15.3 107.8 62.2zM214.8 147.7L95.7 179.6c-38.4 10.3-61.2 49.8-50.9 88.2l2.1 7.7 .4-.1c25.6-6.9 51.9 8.3 58.8 33.9l2.8 10.6 15.5-4.1 134.9-36.2 15.5-4.1-2.3-8.5c-6.9-25.8 7.6-52.3 32.7-60.6l-2.1-7.8c-10.3-38.4-49.8-61.2-88.2-50.9z'
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fast',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M269.7 261.7l5.7-5.7-5.7-5.7-176-176L88 68.7 76.7 80l5.7 5.7L252.7 256 82.3 426.3 76.7 432 88 443.3l5.7-5.7 176-176zm192 0l5.7-5.7-5.7-5.7-176-176L280 68.7 268.7 80l5.7 5.7L444.7 256 274.3 426.3l-5.7 5.7L280 443.3l5.7-5.7 176-176z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fast',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      'M128 0h8H320h4.8l2.2 4.3 96 184 3.7 7.1-14.2 7.4-3.7-7.1L315.2 16H144v88 8H128v-8V8 0zM537.9 234.8l88-104 12.2 10.3L552 242.9V397.1l86.1 101.8-12.2 10.3-88-104-1.9-2.2V400 320H446.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V152v-8h8 64 3.6l2.4 2.6L211.6 224H424h8v8 72H536V240v-2.9l1.9-2.2zM80 160V292.6c10.1-3 20.9-4.6 32-4.6H368c17.2 0 33.5 3.9 48 10.8V240H208h-3.6l-2.4-2.6L132.4 160H80zM368 304H112c-53 0-96 43-96 96s43 96 96 96H368c53 0 96-43 96-96s-43-96-96-96zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fast',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM274.7 312H104 96v16h8H295l-20.3-16zm252.7 16H536h8V312h-8H507.1l20.3 16zM536 200h8V184h-8H345l20.3 16H536zm-403.1 0l-20.3-16H104 96v16h8 28.9zM536 56H182.9l20.3 16H536h8V56h-8zM457.1 456l-20.3-16H104 96v16h8H457.1z'
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fast',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm25.8 174.5l-11.3 11.3 5.7 5.7L244.7 256l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L256 267.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L267.3 256l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L256 244.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fast',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      'M74.1 400l37.1-296.6L192 22.6l80.8 80.8L309.9 400H326L288 96 203.3 11.3 192 0 180.7 11.3 96 96 58 400H74.1zM144 272h96v32H144V272zm0-16H128v16 32 16h16 96 16V304 272 256H240 144zM16 496V448H368v48H16zM0 432v16 48 16H16 368h16V496 448 432H368 16 0z'
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fast',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      'M368 16V176H272V104 96H256v8 72H16V16H368zM256 192V376v8h16v-8V192h96V496H16V192H256zM0 16V184 496v16H16 368h16V496 184 16 0H368 16 0V16z'
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fast',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      'M21.7 10.3L16 4.7 4.7 16l5.7 5.7 112 112 0 0-63 63L48 208l11.3 11.3L64 224H208h16V208 64l-4.7-4.7L208 48 196.7 59.3l-63 63 0 0-112-112zm480 11.3l5.7-5.7L496 4.7l-5.7 5.7-112 112 0 0-63-63L304 48 292.7 59.3 288 64V208v16h16H448l4.7-4.7L464 208l-11.3-11.3-63-63 0 0 112-112zm-368 368l63 63L208 464l11.3-11.3L224 448V304 288H208 64l-4.7 4.7L48 304l11.3 11.3 63 63-112 112L4.7 496 16 507.3l5.7-5.7 112-112zm244.7 0l112 112 5.7 5.7L507.3 496l-5.7-5.7-112-112 63-63L464 304l-11.3-11.3L448 288H304 288v16V448l4.7 4.7L304 464l11.3-11.3 63-63zM208 70.6V208H70.6L208 70.6zm0 370.7L70.6 304H208V441.4zM441.4 304L304 441.4V304H441.4zM304 70.6L441.4 208H304V70.6z'
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fast',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      'M448 0V43c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6v43h16V245c0-25.5-10.1-49.9-28.1-67.9l-21-21C480.9 126.1 464 85.4 464 43V0H448zM640 288V245c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43V0H528V43c0 25.5 10.1 49.9 28.1 67.9l21 21c30 30 46.9 70.7 46.9 113.1v43h16zM0 352v16V496v16H16 224h16H496h16V496 368 352H496 240 224 16 0zM496 496H240V368H496V496zm-272 0H16V368H224V496zM640 360v-8H624v8V504v8h16v-8V360zm-80-8H544v8V504v8h16v-8V360v-8zm40 8v-8H584v8V504v8h16v-8V360z'
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fast',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      'M8 0H0V16H8 114.1L231.5 388.9C208.3 398.5 192 421.3 192 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.4-.9-12.6-2.7-18.5l253.1-77.9 7.6-2.4L573.3 334l-7.6 2.4L310.7 414.8C299.5 396.3 279.2 384 256 384c-3.1 0-6.1 .2-9 .6L127.6 5.6c-1-3.3-4.1-5.6-7.6-5.6H8zM256 400a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM356.7 164.1l2.3 7.7 15.3-4.7-2.3-7.7-16.4-53.5 84.2-25.7 56.1 183.6L312.3 319.9 256.1 136.3l84.2-25.7 16.4 53.5zM236.2 125.6l4.7 15.3L297 324.6l4.7 15.3 15.3-4.7L500.6 279l15.3-4.7-4.7-15.3L455 75.5l-4.7-15.3-15.3 4.7L251.5 121l-15.3 4.7z'
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fast',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      'M267 468.3L256 480l-11-11.7L0 208 112 32H400L512 208 267 468.3zM490 208H256 22L256 456.7 490 208zm-7.2-16L393.1 51 273.3 192H482.9zM374.7 48H137.3L256 187.6 374.7 48zM118.9 51L29.1 192H238.7L118.9 51z'
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fast',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      'M209.3 64c-1.9 0-3.7 .7-5.1 1.9L144 116.4v20.9L212.2 80h65L294 64H209.3zM112 352h23.2l50.1 50.1 5.7 5.7 0 0 28.7 28.7 5.7 5.7 5.7-5.7 37-37 43 43 5.7 5.7 5.7-5.7 56.9-56.9 26 26 5.7 5.7 5.7-5.7L476.1 352H480h48v32 16h16 80 16V384 144 128H624 544 528v16V336H487.8l-3.5-3.5L361.4 209.6l13.9-13.9 5.7-5.7-11.3-11.3-5.7 5.7L259.6 288.7 194.9 224 346.9 80h79.5L496 138.5V117.6L434.5 65.9 432.2 64h-2.9H343.8h-3.2l-2.3 2.2L177.9 218.1l-6 5.7 5.8 5.8 76.2 76.2 5.7 5.7 5.7-5.7 84.8-84.8L467.3 338.1l-56.5 56.5-26-26-5.7-5.7-5.7 5.7-56.9 56.9-43-43-5.7-5.7-5.7 5.7-37 37-44.1-44.1 0 0-37-37-2.3-2.3h-3.3H112V144 128H96 16 0v16V384v16H16 96h16V384 352zM96 144V384H16V144H96zm528 0V384H544V144h80z'
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fast',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      'M48 224c0-21.5 3.3-42.2 9.3-61.7L256 287.4v.6V496v16h16H480l59.6-208.6c1.4-5.1 2.5-10.2 3.3-15.4c.7-5.3 1.1-10.6 1.1-16V252.4v-3.6l-2.7-2.4-69.5-61.8C466.3 83.3 383.6 0 280 0H256C132.3 0 32 100.3 32 224c0 59.1 23.7 114.5 64 156.7V504v8h16v-8V377.5v-3.3l-2.3-2.3C70.7 332.1 48 279.7 48 224zm213.6 48L62.8 146.8C93.4 70.2 168.4 16 256 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L528 256v16H272 261.6zM272 496V288H526.7c-.6 3.7-1.4 7.4-2.5 11l-15.1 53H368h-8v16h8H504.5l-13.7 48H368h-8v16h8H486.2l-18.3 64H272zm96-272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fast',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      'M448 80l-24.1 72.3c39.8 83.7 9.9 181.4-56.1 247.4s-163.7 96-247.4 56.1L48 480 0 432l24.1-72.3C-15.7 276 14.2 178.2 80.2 112.2s163.7-96 247.4-56.1L400 32l48 48zM115.3 440.7l6.1-2 5.8 2.8c75.9 36.2 166.6 9.7 229.2-53s89.1-153.3 53-229.2l-2.8-5.8 2-6.1 21-63-34-34-63 21-6.1 2-5.8-2.8c-75.9-36.1-166.6-9.7-229.2 53s-89.1 153.3-53 229.2l2.8 5.8-2 6.1-21 63 34 34 63-21zM219.1 119.4l-16.9 7.1c-48.7 20.3-87.4 59-107.7 107.7l-7.1 16.9-3.1 7.4-14.8-6.2 3.1-7.4L79.7 228c21.9-52.6 63.7-94.4 116.3-116.3l16.9-7.1 7.4-3.1 6.2 14.8-7.4 3.1z'
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fast',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      'M48 110.2L84.8 272l22.5 0L144 110.2 144 48 48 48l0 62.2zM144 32l16 0 0 16 0 64L120 288l-48 0L32 112l0-64 0-16 16 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fast',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm218.9 96h10.1l2.2 4.6L350.2 384H332.5l-30.3-64H145.8l-30.3 64H97.8l119-251.4 2.2-4.6zm75.7 176L224 154.7 153.3 304H294.7z'
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fast',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M16 48l480 0 0 112L16 160 16 48zm0 416l0-288 232 0 0 288L16 464zm248 0l0-288 232 0 0 288-232 0zM0 464l0 16 16 0 480 0 16 0 0-16 0-416 0-16-16 0L16 32 0 32 0 48 0 464z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fast',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M419.9 384.1c-70.7 90.5-201.4 106.6-292 35.8C105 402 86.9 380.2 73.7 356.3l-14 7.7c14.2 25.8 33.7 49.3 58.4 68.6c97.5 76.2 238.3 58.9 314.4-38.6s58.9-238.3-38.6-314.4C304.1 9.3 177.5 18.5 98.6 96.6l11.3 11.3c73.3-72.5 190.8-81 274.2-15.8c90.5 70.7 106.6 201.4 35.8 292zM37 35L25.7 46.3 8 64V192v16H24 152l17.7-17.7L181 179l-11.3-11.3L48.3 46.3 37 35zm0 22.6L158.3 179l-13 13H24V70.6l13-13z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faMartiniGlass = {
    prefix: 'fast',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      'M130.9 144H381.1L256.2 272.8h-.4L130.9 144zm-15.5-16L16 25.5V16H496v9.5L396.6 128H115.4zM244.9 284.5l3.1 3.2V496H136h-8v16h8H256 376h8V496h-8H264V287.8l3.1-3.2L512 32V16 0H496 16 0V16 32L244.9 284.5z'
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fast',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      'M192 32h-8H40 32V48h8H176V464H40 32v16h8H184h8v-8V40 32z'
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fast',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      'M296 352v-8V35.3l82.3 82.3 5.7 5.7L395.3 112l-5.7-5.7-96-96L288 4.7l-5.7 5.7-96 96-5.7 5.7L192 123.3l5.7-5.7L280 35.3V344v8h16zM16 192H0v16V415c5.2 0 10.5-.7 16-1.9V208H192V192H16zM576 415V208 192H560 384v16H560V413.1c5.5 1.2 10.8 1.9 16 1.9zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fast',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      'M136 0h-8V8 128v8h16v-8V16H283.1L392.9 227.7l3.7 7.1 14.2-7.4-3.7-7.1-112-216L292.9 0H288 136zM96 336a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176c53 0 96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V272 256H400 264L144 160H16 0v16V400v16c0 53 43 96 96 96zm0-192c-33.4 0-62.8 17-80 42.9V176H138.4L254 268.5l4.4 3.5H264 400v60.8c-14.1-8.2-30.5-12.8-48-12.8c-47.6 0-87.1 34.6-94.7 80H190.7c-7.6-45.4-47.1-80-94.7-80zm256 16a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM496 8V0H480V8 440v8h8H632h8V432h-8H496V8z'
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fast',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM64 160v8V344v8H80v-8V187.3l72.7 160 2.1 4.7H160h8 8v-8V168v-8H160v8V324.7l-72.7-160L85.2 160H80 72 64zm168 0v8 64V344v8h16v-8V240h64 8V224h-8H248V176h64 8V160h-8H240h-8zm152 8v-8H368v8V344v8h16v-8V168z'
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fast',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      'M16 200C16 98.8 102.6 16 210.3 16c22.4 0 44 3.6 64 10.2l5-15.2c-21.6-7.1-44.9-11-69-11C94.6 0 0 89.2 0 200C0 309.8 74 400 190.9 400c.4 0 .8 0 1.1-.1v.1c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V384c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l0 0 0 0 0 0 0 0-.6-.9-.6 .9 0 0c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 369.8 406.5 384 384 384s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 369.8 214.5 384 192 384v.1c-.4-.1-.8-.1-1.1-.1C84.2 384 16 302.3 16 200zm320 73V136L448 52l111.5 84 .3 149.1c5.5 1.2 10.8 1.9 16 1.9l-.3-159L448 32 320 128V262.9c5.6 3.9 10.7 7.2 16 10.1zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l0 0 0 0-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9 0 0 0 0c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9zM190 112c16.7 0 32.6 3.5 46.7 9.8l6.5-14.6C227.1 100 209 96 190 96C120.8 96 64 149.3 64 216s56.8 120 126 120V320c-61.2 0-110-47-110-104s48.9-104 110-104z'
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fast',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V176H496V112H272zM16 192V464H496V192H16z'
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fast',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm345.4-48L256 118.6 166.6 208H144L244.7 107.3 256 96l11.3 11.3L368 208H345.4zM160 304v8.6l96 82.3 96-82.3V304H160zm-16 16V304 288h16H352h16v16 16L256 416 144 320z'
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fast',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      'M336 104v72h72L490.9 65.5 446.5 21.1 336 104zm-4.7 88l-71 71L249 251.7l71-71V176 96L448 0l64 64L416 192H336h-4.7zm-224 308.7L96 512 84.7 500.7 11.3 427.3 0 416l11.3-11.3L172.7 243.3 184 232l11.3 11.3 73.4 73.4L280 328l-11.3 11.3L107.3 500.7zM257.4 328L184 254.6 22.6 416 96 489.4 257.4 328z'
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fast',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.3 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM185.8 174.5l-11.3 11.3 5.7 5.7L244.7 256l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L256 267.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L267.3 256l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L256 244.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fast',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M16 279.1L160 149.5 304 279.1V304H16V279.1zM160 128L0 272v32 16H16 304h16V304 272L160 128z'
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fast',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      'M128 288l-16 0-64 0-16 0 0 16 0 16L180.7 468.7 192 480l11.3-11.3L352 320l0-16 0-16-16 0-64 0-16 0 0-16 0-128 0-16-16 0-96 0-16 0 0 16 0 128 0 16zm0 16l16 0 0-16 0-144 96 0 0 144 0 16 16 0 80 0 0 9.4-144 144L48 313.4l0-9.4 80 0zM8 32L0 32 0 48l8 0 368 0 8 0 0-16-8 0L8 32z'
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fast',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm208 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM144 256a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm176 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fast',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      'M288 32V50.7L93 224h99c70.7 0 128 57.3 128 128s-57.3 128-128 128H95.9c-41.6 0-78.4-26.8-91.3-66.3l-1-3.2-2.5-7.6 15.2-4.9 2.5 7.6 1 3.2c10.7 33 41.4 55.3 76.1 55.3H192c61.9 0 112-50.1 112-112s-50.1-112-112-112H72 64V228.4l2.7-2.4L267 48H8 0V32H8 288z'
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fast',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      'M16 496H176v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM240 368h64 8v8 8 2.1l-1.1 1.8L249.2 496H304h8v16h-8H240h-8v-8-8-2.1l1.1-1.8 61.7-108H240h-8V368h8zm136 8V504v8H360v-8V376v-8h16v8zm48-8h8 24c26.5 0 48 21.5 48 48s-21.5 48-48 48H440v40 8H424v-8V456 376v-8zm16 80h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H440v64z'
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fast',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      'M120 80c-30.9 0-56 25.1-56 56v88 8 8 24c0 28.2-20.9 51.6-48 55.4c-2.6 .4-5.3 .6-8 .6H0V304 280c0-28.2 20.9-51.6 48-55.4V136c0-39.8 32.2-72 72-72h48 16H472h4l2.4 3.2L560 177.4V176h8 48 8v8 24 55.8l14.4 19.5 1.6 2.1V288 440v8h-8H560h-4l-2.4-3.2L488 357.3c-5.2-6.9-8-15.3-8-24V284.3l-32-21.3V440v8h-8H344h-8v-8V362l-6.7 1.5c-8.4 1.9-16.8 3.3-25.3 4.3v.2 16 8H288v-8V369.3c-10.7 .6-21.3 .6-32 0V384v8H240v-8V368v-.2c-8.5-1-16.9-2.5-25.3-4.3L208 362v78 8h-8H104 96v-8V136c0-22.6 10.4-42.8 26.7-56H120zm88 265.6l10.2 2.3c35.4 7.9 72.2 7.9 107.6 0l10.2-2.3V328c0-35.3-28.7-64-64-64s-64 28.7-64 64v17.6zm-48-265c.1 23.2 9.3 45.5 25.8 61.9l3.1 3.1c19.5 19.5 46 30.5 73.5 30.5h3.2c27.6 0 54-11 73.5-30.5l3.1-3.1C358.7 126 368 103.6 368 80.2V80H184 168c-2.7 0-5.4 .2-8 .6zm-15.9 4.8c-19 9-32.1 28.3-32.1 50.7V432h80V328c0-44.2 35.8-80 80-80s80 35.8 80 80V432h80V248 233.1l12.4 8.3 48 32 3.6 2.4V280v53.3c0 5.2 1.7 10.2 4.8 14.4L564 432h60V290.6l-14.4-19.5L608 269v-2.6V208 192H576v9.6 24.2l-14.4-19.5L468 80H384v.2c0 27.6-11 54-30.5 73.5l-3.1 3.1c-22.5 22.5-53 35.1-84.9 35.1h-3.2c-31.8 0-62.3-12.6-84.9-35.1l-3.1-3.1c-18.3-18.3-29.1-42.7-30.3-68.4zM16 280v23.2c18.3-3.7 32-19.8 32-39.2V240.8c-18.3 3.7-32 19.8-32 39.2zm536 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fast',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      'M112 16H272V256c0 44.2-35.8 80-80 80s-80-35.8-80-80V16zM96 0V16 256c0 53 43 96 96 96s96-43 96-96V16 0H272 112 96zM48 200v-8H32v8 56c0 85.7 67.4 155.6 152 159.8V496H104 96v16h8 88 88 8V496h-8H200V415.8c84.6-4.2 152-74.1 152-159.8V200v-8H336v8 56c0 79.5-64.5 144-144 144s-144-64.5-144-144V200z'
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fast',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      'M248 256V496H48V256H248zm16 240V256H464V496H264zm216 0V16 0H464 48 32V16 496H8 0v16H8 32 48 464h16 24 8V496h-8H480zM464 240H264V16H464V240zM48 16H248V240H48V16z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fast',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M16 48V356.7L122.3 250.3l5.7-5.7 5.7 5.7L224 340.7 378.3 186.3l5.7-5.7 5.7 5.7L496 292.7V48H16zm0 331.3V464h84.7l112-112L128 267.3 16 379.3zm368-176L123.3 464H496V315.3l-112-112zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zM168 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z'
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fast',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      'M0 480H16 260.6l2.5-16H16V48H64V184c0 4.4 3.6 8 8 8H312c4.4 0 8-3.6 8-8V48h9.4L432 150.6v94.9l16-16V144L336 32H16 0V48 464v16zM304 48V176H80V48H304zM224 400a72 72 0 1 1 0-144 72 72 0 1 1 0 144zm-88-72a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM498.9 224L302.2 420.7l-11.6 74.7L288 512l16.6-2.6 74.7-11.6L564.7 312.4 576 301.1l-11.3-11.3-54.5-54.5L498.9 224zM317.2 428.3L455 290.5l54.5 54.5L371.7 482.8l-64.5 10 10-64.5zM553.4 301.1l-32.5 32.5-54.5-54.5 32.5-32.5 54.5 54.5z'
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fast',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      'M89.4 0H96 352h6.6l1.2 6.5L389.1 160H372.8L345.4 16H102.6L75.2 160H58.9L88.1 6.5 89.4 0zM0 192H24 40.1 407.9 424h24v16H422L384 512H64L26 208H0V192zm42.1 16l36 288H369.9l36-288H42.1z'
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fast',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      'M312 104c0-30.9 25.1-56 56-56s56 25.1 56 56c0 1.5-.1 3-.2 4.5l-.6 7.4 7.3 1.2c38 6.1 71.5 16.6 95.6 25.7c12 4.5 21.6 8.6 28.2 11.6c2.3 1 4.2 1.9 5.7 2.7v62.3L388.2 313l-8.3 4.5 5.9 7.4 120 152 2.4 3H512h56 8V464h-8H515.9L404.2 322.5 571.8 231l4.2-2.3V224 152v-4.9l-4.3-2.2L568 152c3.7-7.1 3.7-7.1 3.7-7.1l0 0 0 0 0 0-.2-.1-.6-.3c-.5-.2-1.2-.6-2.1-1c-1.8-.9-4.5-2.2-7.9-3.7c-6.9-3.1-16.8-7.4-29.2-12c-23.3-8.8-55.3-18.9-91.7-25.3c-.9-39-32.8-70.4-72-70.4c-37.5 0-68.3 28.7-71.7 65.3l-57.9 11C100.1 134.4 0 255.3 0 396v76 8H8 376h8v-8V408v-8h-8H320.6l3.4-4.3C337 379.6 344 359.6 344 338.9v-3.7c0-48.2-39-87.2-87.2-87.2c-23.1 0-45.3 9.2-61.7 25.5l-40.8 40.8-5.7 5.7L160 331.3l5.7-5.7 40.8-40.8c13.4-13.4 31.5-20.9 50.3-20.9c39.3 0 71.2 31.9 71.2 71.2v3.7c0 17-5.8 33.5-16.4 46.8L297.8 403l-10.4 13H304h64v48H16V396c0-133 94.6-247.2 225.3-272l64.1-12.1 6.5-1.2V104zm56 24a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fast',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM136 152H376h8v16h-8H136h-8V152h8zm0 96H280h8v16h-8H136h-8V248h8z'
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fast',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM328 160v8V328v8H312v-8V168v-8h16zM304 368h32v32H304V368z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fast',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M416 48h2.6l2.5-.8 74.9-25v95L428.9 144H416l-152 0H248L96 144H83.1L16 117.2v-95l74.9 25 2.5 .8H96 416zM248 160v80L96 240V160H248zM80 256V504v8H96v-8V256l160 0 160 0V504v8h16v-8V256h72 8V240h-8H432V160l80-32V16.9 0L496 5.3 416 32H96L16 5.3 0 0V16.9 128l80 32v80H8 0v16H8 80zm336-16l-152 0V160H416v80z'
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fast',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      'M16 16H496V496H16V304c30.9 0 56 25.1 56 56v32c0 30.9 25.1 56 56 56s56-25.1 56-56V352h40 16V336 240 224H224 128 112v16 96 16h16 40v40c0 22.1-17.9 40-40 40s-40-17.9-40-40V360c0-39.8-32.2-72-72-72V16zM0 296V496v16H16 496h16V496 16 0H496 16 0V16 296zM96 80H88V96h8H224h8V80h-8H96zm192 0h-8V96h8H416h8V80h-8H288zM96 144H88v16h8H224h8V144h-8H96zm192 0h-8v16h8H416h8V144h-8H288zM224 336H176 128V240h96v96zm80-96h96V432H304V240zm-16-16v16V432v16h16 96 16V432 240 224H400 304 288z'
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fast',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM112 272H304h8v16h-8H112h-8V272h8zm256 0h96 8v16h-8H368h-8V272h8zM112 368h96 8v16h-8H112h-8V368h8zm160 0H464h8v16h-8H272h-8V368h8z'
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fast',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      'M288 4.7l-5.7 5.7-88 88-5.7 5.7L200 115.3l5.7-5.7L280 35.3V216v8h16v-8V35.3l74.3 74.3 5.7 5.7L387.3 104l-5.7-5.7-88-88L288 4.7zm0 276.4l-91.7-49.4L182 224l-4.7 15.6-29.9 99.7L47.6 369.3 32 374l7.7 14.4L80.5 464H98.7L55.4 383.6l96.6-29 8.3-2.5 2.5-8.3 29-96.6 88.8 47.8 7.6 4.1 7.6-4.1 88.8-47.8 29 96.6 2.5 8.3 8.3 2.5 96.6 29L477.3 464h18.2l40.8-75.7L544 374l-15.6-4.7-99.7-29.9-29.9-99.7L394 224l-14.4 7.7L288 281.1zM398.9 464c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96h16.2c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80h16.2zM8 496H0v16H8 568h8V496h-8H8z'
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fast',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      'M58.7 438.2C28.2 398.8 16 335.7 16 240V16H224 432V240c0 95.7-12.2 158.8-42.7 198.2C359.8 476.4 310 496 224 496s-135.8-19.6-165.3-57.8zM0 240C0 432 48 512 224 512s224-80 224-272V16 0H432 224 16 0V16 240zm176-16c0 26.5-21.5 48-48 48s-48-21.5-48-48V192h96v32zm-48 64c35.3 0 64-28.7 64-64V192 176H176 80 64v16 32c0 35.3 28.7 64 64 64zm240-64c0 26.5-21.5 48-48 48s-48-21.5-48-48V192h96v32zm-48 64c35.3 0 64-28.7 64-64V192 176H368 272 256v16 32c0 35.3 28.7 64 64 64zM160 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM304 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fast',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      'M344 16c-51.2 0-96.7 32.8-112.9 81.4l-13.3 39.9-.9 2.8-1.9 2.3-47.9 58.5c-15 18.3-23.1 41.2-23.1 64.8C144 322.2 189.8 368 246.3 368c23.6 0 46.5-8.2 64.8-23.1L369.6 297l2.3-1.9 2.8-.9 39.9-13.3C463.2 264.7 496 219.2 496 168v0l0-.2 0-.1c0-34.8-21.6-72.7-50.3-101.4C417 37.6 379.2 16 344.4 16l-.3 0-.1 0zm0-16l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-39.9 13.3-58.5 47.9c-21.1 17.3-47.6 26.7-74.9 26.7c-29.8 0-57-11-77.8-29.2l-151 151-5.7 5.7L.5 500.2l5.7-5.7 151-151c-18.2-20.8-29.2-48-29.2-77.8c0-27.3 9.5-53.8 26.7-74.9l47.9-58.5 13.3-39.9C234.3 37.2 285.9 0 344 0z'
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fast',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      'M57.8 384L136 64H440l34.8 142.5 0 0 4.3 17.6 0 0 39.1 160H501.8L461.6 219.6l-77.3-19.3-93.8 31.3-2.5 .8-2.5-.8-93.8-31.3-77.3 19.3L74.2 384H57.8zm61-181.9l71.4-17.8 2.3-.6 2.2 .7L288 215.6l93.5-31.2 2.2-.7 2.3 .6 71.3 17.8L427.4 80H148.6L118.7 202.1zM0 432H8 568h8v16h-8H8 0V432z'
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fast',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      'M296 0V8 92.7l86 86 2.9 .6 99.8 19.2C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-19.2-99.8-.6-2.9L296 115.3V266.7l2 2.7 66.8 89.1C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L278 269.3l2-2.7V115.3L205.3 190l-.6 2.9-6.7 35c-4.9-1.8-10.2-3-15.6-3.6l4.9-25.7-2-2-91 17.5C48.9 222.9 16 262.7 16 309c0 32.6 26.4 59 59 59c25.4 0 48.8-9.9 66.2-26.3c4.7 3.1 9.9 5.5 15.4 7.3c-20.7 21.7-49.8 35-81.6 35c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l99.8-19.2 2.9-.6 86-86V8 0h16zm94.7 196.7l-2 2 17.5 91c8.7 45.5 48.5 78.3 94.8 78.3c32.6 0 59-26.4 59-59c0-46.3-32.9-86.1-78.3-94.8l-91-17.5zM224 368c-10.4 13.8-16 30.7-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80c0-17.3-5.6-34.2-16-48l-64-85.3L224 368zM360 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80zM176 264a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z'
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fast',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      'M335.3 64.7C313.3 26.1 271.7 0 224 0s-89.3 26.1-111.3 64.7c5-.5 10.1-.7 15.3-.7c1.4 0 2.7 0 4 0c20.2-29 53.9-48 92-48s71.7 19 92 48c1.3 0 2.7 0 4 0c5.2 0 10.3 .2 15.3 .7zM200 118.2c-20.5-14-45.3-22.2-72-22.2C57.3 96 0 153.3 0 224H16c0-61.9 50.1-112 112-112c22.9 0 44.2 6.9 62 18.7c3.1-4.4 6.5-8.5 10-12.6zM448 224c0-70.7-57.3-128-128-128s-128 57.3-128 128h16c0-61.9 50.1-112 112-112s112 50.1 112 112h16zM9.6 256H.8l.9 8.8 1.4 14.3C10.8 356.8 76.2 416 154.3 416H158l-60 66.6L96 484.9V488v16 8h8H344h8v-8V488v-3.1l-2.1-2.3L290 416h3.7c78.1 0 143.5-59.2 151.2-136.9l1.4-14.3 .9-8.8h-8.8H9.6zM19 277.5l-.6-5.5H429.6l-.6 5.5c-7 69.5-65.5 122.5-135.3 122.5H272 254l12 13.4L336 491.1V496H112v-4.9l69.9-77.7L194 400H176 154.3C84.4 400 25.9 347.1 19 277.5z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fast',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM232 160v8 80h80 8v16h-8H232v80 8H216v-8V264H136h-8V248h8 80V168v-8h16z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fast',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM129.8 144l119 251.4 2.2 4.6h10.1l2.2-4.6L382.2 144H364.5L256 373.3 147.5 144H129.8z'
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fast',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM80 256H72v8V408v8h8 96 8v-8V264v-8h-8H80zm8 144V272h80V400H88zM240 256h-8v16h8 24V400H240h-8v16h8 32 32 8V400h-8H280V264v-8h-8H240z'
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      'M432 48H16V464H378.2c21.1 10.2 44.8 16 69.8 16H432 16 0V464 48 32H16 432h16V48 160c-5.4 0-10.7 .3-16 .8V48zm-64 72v61.4c-5.6 3.2-10.9 6.7-16 10.6V128H232v88.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V120v-8h8H360h8v8zM309.4 400H88 80v-8V120v-8h8 64 8v16h-8H96V384H301.3c2.4 5.5 5.1 10.8 8.1 16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM448 432.2a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0 16c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 32.5-12.1 62.1-32 84.7l93.7 93.7c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-93.7-93.7c-22.6 19.9-52.2 32-84.7 32z'
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fast',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      'M496 16H144V96H128V16 0h16H496h16V16 368v16H496 416V368h80V16zM368 144H16V256H368V144zM16 496H368V272H16V496zm0-368H368h16v16V496v16H368 16 0V496 144 128H16z'
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fast',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      'M272 352H256V336 26.2 0l16 20.7L515.6 336 528 352H507.8 272zm223.4-16L272 46.9V336H495.4zM20 384H556h20l-12 16L480 512H96L12 400 0 384H20zm12 16l72 96H472l72-96H32zm192-48H208 66.8 48l9.8-16L208 90.2 224 64V94.7 336v16zM208 120.9L76.5 336H208V120.9z'
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fast',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      'M16 144H560V464H16V144zm0-16V48H560v80H16zm560 8v-8V48 32H560 16 0V48v80 8 8V464v16H16 560h16V464 144v-8zM80 304a80 80 0 1 1 160 0A80 80 0 1 1 80 304zm176 0A96 96 0 1 0 64 304a96 96 0 1 0 192 0zm-96 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm208-80H496V384H336V224zm-16-16v16V384v16h16H496h16V384 224 208H496 336 320z'
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fast',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      'M440 0c-48.6 0-88 39.4-88 88v59.9L3.3 401.5l6.6 14.2L137 384h149l52.7 128h17.3L303.2 384H336c15.1 0 29.8-1.7 43.9-5l54.8 133h17.3L395.4 374.6c77-25 132.6-97.3 132.6-182.6V148l112-28V84L592 48H518.4C503.8 19.5 474.2 0 440 0zM624 107.5l-96 24V88c0-8.3-1.2-16.4-3.3-24h62L624 92v15.5zM201 368l21.3-5.3C307.9 341.3 368 264.3 368 176v-8V88c0-39.8 32.2-72 72-72s72 32.2 72 72V192c0 97.2-78.8 176-176 176H201zM352 168v8c0 81-55.1 151.5-133.6 171.2L46 390.3 352 167.7v.3zM456 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fast',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      'M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM16 176C16 105.3 73.3 48 144 48s128 57.3 128 128V336c0 70.7-57.3 128-128 128S16 406.7 16 336V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM368 176c0-70.7 57.3-128 128-128s128 57.3 128 128V336c0 70.7-57.3 128-128 128s-128-57.3-128-128V176z'
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fast',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zM240 144h32v32H240V144zm-16-16v16 32 16h16 32 16V176 144 128H272 240 224zM152 248h-8v16h8H360h8V248h-8H152zm120 88v32H240V336h32zm-32-16H224v16 32 16h16 32 16V368 336 320H272 240z'
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fast',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      'M224 240a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM75.8 320L21.7 496H384l0 16H16.7 0l4.9-16L64 304H384l0 54.4L372.2 320H75.8zM480 256v64h32 64 16 32 16v16V496v16H624 432 416V496 336 320h16 32V256c0-35.3 28.7-64 64-64s64 28.7 64 64v16H576V256c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-16 80H432V496H624V336H592 576 480 464z'
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fast',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      'M16 48H432v84.1l16-10V48 32H432 16 0V48 464v16H16 337c-4.6-5.1-8.9-10.4-12.9-16H16V48zm80 56V96H80v8V280v8H96v-8V104zm64 0V96H144v8V280v8h16v-8V104zM500.7 212.8L448 160.2c-42.7 26.7-128 102.4-128 192c0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160l-20.7 20.7L512 224.2l-11.3-11.3zM576 422.6c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 18.2 5.8 35.1 15.7 49.2C361.3 445.9 336 402 336 352.2c0-39.7 19-77.6 44.5-109.6c21.3-26.7 46.2-48.2 65.4-61.8l54.7 54.7L512 246.8l11.3-11.3L544.8 214C609.1 272.5 624 332 624 352.2c0 49.8-25.3 93.7-63.7 119.6c9.9-14.1 15.7-31 15.7-49.2zm-96 73.6c-45.2 0-80-34-80-73.6c0-28.5 20-58.2 43.5-82.5c11.4-11.8 22.8-21.5 31.4-28.3c1.8-1.5 3.5-2.8 5.1-3.9c1.5 1.2 3.2 2.5 5.1 3.9c8.6 6.8 20 16.5 31.4 28.3C540 364.4 560 394 560 422.6c0 39.6-34.8 73.6-80 73.6z'
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fast',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c47.7 0 92.2-13.9 129.6-38c3 4.5 6.4 8.6 10.3 12.4C355.7 496.7 307.6 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 2 0 3.9-.1 5.9c-5.1-1.1-10.5-1.7-16-1.8c0-1.4 0-2.7 0-4.1C496 123.5 388.5 16 256 16zm0 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm54.6-91.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7zM159.6 272c14.6 0 30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7c10.9 19.3 26.4 27.9 41 27.9zm335.2 24c23.3 0 42.3 18.3 43.8 41.3C556 345.5 568 363.4 568 384s-12 38.5-29.4 46.7c-1.6 23-20.5 41.3-43.8 41.3c-13.4 0-25.4-6.1-33.4-15.6c-3.1 .7-6.2 1-9.5 1c-24.4 0-44-19.9-44-44.4c0-1.4 .1-2.8 .2-4.2l-50.7-17.3L335.2 384l22.2-7.6L408 359.2c1.5-23 20.5-41.3 43.8-41.3c1.7 0 3.3 .1 4.9 .3c7.6-13.2 21.7-22.1 38-22.1zm-26 34l-2.6 6.7-7-1.9c-2.3-.6-4.8-1-7.3-1c-15.4 0-27.9 12.6-27.9 28.4c0 .7 0 1.4 .1 2.1l.4 6.2-5.8 2L384.8 384l35 11.9 7.1 2.4-1.9 7.2c-.6 2.4-1 4.9-1 7.5c0 15.8 12.6 28.4 28 28.4c3.4 0 6.7-.6 9.8-1.8l6.1-2.3 3.5 5.5c5 7.9 13.7 13.1 23.6 13.1c15.4 0 27.9-12.6 27.9-28.4c0-.6 0-1.2-.1-1.8l-.4-6.1 5.8-2c13.9-4.7 23.9-18 23.9-33.8s-10.1-29-23.9-33.8l-5.8-2 .4-6.1c0-.6 .1-1.2 .1-1.8c0-15.8-12.6-28.4-27.9-28.4c-11.8 0-21.9 7.4-26 18z'
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fast',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      'M304 16V352c0 79.5-64.5 144-144 144S16 431.5 16 352V16H304zM16 0H0V16 352c0 88.4 71.6 160 160 160s160-71.6 160-160V16 0H304 16zM160 432a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm40-80a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm-96 0a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56-96a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm0-96a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0 312a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fast',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      'M9.9 0l6.3 5L633.7 494.5l6.3 5L630.1 512l-6.3-5L6.3 17.5 0 12.5 9.9 0zM576 256C546 181.3 446.4 32 288 32c-38.8 0-74.1 9-105.7 23.6l14.2 11.2C224.3 55 254.8 48 288 48c73.8 0 134.5 34.7 181 79.5c44.1 42.5 74.4 93.1 89.6 128.5c-8.2 19.1-20.8 42.7-37.6 67l12.6 9.9c19.6-28.2 33.8-55.6 42.4-76.9zM0 256v0l0 0 0 0zM294.6 144.2c47.7 2.8 87.4 35.4 100.7 79.5l-28.4-22.4c-10.8-15.6-26.1-27.8-44-34.8l-28.3-22.3zM101 169.8l320 256 6.2 5-10 12.5-6.2-5L91 182.2l-6.2-5 10-12.5 6.2 5zm-22.2 67l6.2 5 250 200 6.2 5-10 12.5-6.2-5L75 254.2l-6.2-5 10-12.5zM101 342.6l124 99.2 6.2 5-10 12.5-6.2-5L91 355l-6.2-5 10-12.5 6.2 5z'
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fast',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      'M16 480V448H48v32H16zm128 0H112V448h32v32zm96 0H208V448h32v32zm96 0H304V448h32v32zm64 0V448h32v32H400zM160 240H144 80 64V224 208L212.7 59.3 224 48l11.3 11.3L384 208v16 16H368 304 288v16V384v16H272 176 160V384 256 240zm0-16h16v16V384h96V240 224h16 80v-9.4L224 70.6 80 214.6V224h80z'
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fast',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      'M16 16V432H432V16H16zM0 0H16 432h16V16 432v16H432 363.3l58.3 58.3 5.7 5.7H404.7l-64-64H107.3l-64 64H20.7l5.7-5.7L84.7 448H16 0V432 16 0zM224 272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM368 80H80V208H368V80zM80 64H368h16V80 208v16H368 80 64V208 80 64H80z'
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fast',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      'M36.9 184.6L416 28V45.4L61 192 416 338.7V356L36.9 199.4l-4.9-2V186.7l4.9-2zM8 464H440h8v16h-8H8 0V464H8z'
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fast',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      'M392 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM0 96H8l64 0h8v8l0 32v25.7L160.4 22.4l4-6.9 6.9 4 48.3 27.9 12.4-21 4.1-6.9 6.9 4.1L298.1 56l6.9 4.1L301 67 289 87.3l.2 .1 48.5 28 6.9 4-4 6.9-.2 .4-16.3 6.8-8.1 3.4 6.8-11.8-41.6-24-38.5 66.8c-10.6 4.9-20.6 10.6-29.9 17.1L283.1 65.7 241.8 41.3l-8.2 14 .2 .1-4 6.9-64 110.9-4 6.9-13.9-8 4-6.9 60-103.9-41.6-24L78.9 195.5 64 221.4V191.5L64 136V112l-48 0 0 24 0 90.5C16 283 45.9 335.3 94.6 364l1.4 .8c-5.1 2.9-9.8 6.3-14.3 10.1C31 342.8 0 286.8 0 226.5L0 136l0-32V96zM325 512c-34.1 0-65.7-10.3-92-28c2.1-5.2 3.7-10.5 4.9-16.1C262.4 485.6 292.5 496 325 496H472h24V448H376h-8V432h8l120 0h8 24V384H376h-8V368h8H528l8 0h24V320H544l-8 0H376h-8V304h8H528V256H504 320.5 312l-3-11.9 8.3-3.5 44-18.5 22.1-9.3-18.6-44.2-22.1 9.3-75.5 31.8C211.9 232.9 176 287 176 347c0 3.6 .1 7.1 .4 10.6c-5.2-1.9-10.7-3.3-16.3-4.2c-.1-2.1-.1-4.2-.1-6.3c0-66.4 39.8-126.3 101-152.1l75.5-31.8L366 150.7l7.4-3.1 3.1 7.4 24.8 59 3.1 7.4-7.4 3.1-29.5 12.4-7.4 3.1H504h32 8v8 56h24 8v8 64 8h-8l-24 0v56 8h-8H512v56 8h-8H472 325zM128.9 328.2l-.5-.2 .6-1-.1 1.2zM192 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a64 64 0 1 1 128 0A64 64 0 1 1 80 448zM528 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fast',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm96 88l16 0 192 0h16v32H320l-192 0H112V128zm208 48h16l16 0V160 128 112H336 320l-192 0-16 0H96v16 32 16h16 16l192 0zM112 224h16H256h16v32H256 128 112V224zm0 96h16H384h16v32H384 128 112V320zm16-112H112 96v16 32 16h16 16H256h16 16V256 224 208H272 256 128zm0 96H112 96v16 32 16h16 16H384h16 16V352 320 304H400 384 128z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fast',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      'M296.6 62.4l9.7 20.9L322.5 67c11.6-11.7 27.7-19 45.5-19c30.9 0 56.8 22 62.7 51.2l2.6 12.8h13.1H448c26.5 0 48 21.5 48 48v48H80V160c0-26.5 21.5-48 48-48h16V96c0-44.2 35.8-80 80-80c32.2 0 59.9 19 72.6 46.4zM512 224V208 160c0-35.3-28.7-64-64-64h-1.6C439 59.5 406.7 32 368 32c-16.3 0-31.5 4.9-44.1 13.3c-4.6 3-8.9 6.5-12.7 10.4c-2.3-5-5.1-9.8-8.2-14.3C285.6 16.4 256.7 0 224 0c-53 0-96 43-96 96c-35.3 0-64 28.7-64 64v48 16H80 496h16zM32 400H48l88-128H120L32 400zM256 272H240L152 400h16l88-128zm16 128h16l88-128H360L272 400zM496 272H480L392 400h16l88-128zM96.6 427L96 426l-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fast',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM96 320V304 280L224 160 352 280v24 16H336 112 96zm240-33.1l-112-105-112 105V304H336V286.9z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fast',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      'M136 32v8V308.9l112-37.3V40 32h16v8V266.2l112-37.3V40 32h16v8V223.6l112-37.3V40 32h16v8V180.9l85.5-28.5 7.6-2.5 5.1 15.2-7.6 2.5L520 197.8V472v8H504v-8V203.1L392 240.4V472v8H376v-8V245.8L264 283.1V472v8H248v-8V288.4L136 325.8V472v8H120v-8V331.1L34.5 359.6l-7.6 2.5-5.1-15.2 7.6-2.5L120 314.2V40 32h16z'
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fast',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      'M51.2 64A19.2 19.2 0 1 1 12.8 64a19.2 19.2 0 1 1 38.4 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM51.2 160a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM147.2 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM96 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM128 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 44.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM224 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM339.2 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM288 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 44.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM416 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.2 96a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zM416 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 108.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM384 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fast',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      'M120 0h-8V8 116.7L50.3 178.3 48 180.7V184v64 8 8h.3c3.6 54.5 43.5 99 95.7 109.6V504v8h16v-8V366.9v-6.9l-6.9-1C102.7 351.7 64 308.4 64 256v-8V187.3l48-48V216v8h16v-8V16h80V48v8h8 56V80v8h8 56v24 8h8 56v40 8 80 8c0 44.4-24.1 83.2-60 104l-4 2.3v4.6V504v8h16v-8V371.4c38.4-24 64-66.7 64-115.4v-8V168v-8V112v-8h-8H352V80 72h-8H288V48 40h-8H224V8 0h-8H120z'
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fast',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      'M48 256a160 160 0 1 1 320 0A160 160 0 1 1 48 256zm335.8-8C379.6 154.5 302.5 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c94.5 0 171.6-74.5 175.8-168H448v56 8h16v-8V264H572.7l-74.3 74.3-5.7 5.7L504 355.3l5.7-5.7 88-88 5.7-5.7-5.7-5.7-88-88-5.7-5.7L492.7 168l5.7 5.7L572.7 248H464V192v-8H448v8 56H383.8z'
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fast',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      'M152 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM132.9 128h-4.8l-2.3 4.3-92.9 176 14.1 7.5L137.7 144H251.1 400v32H256h-8v8 56h0v8V496H216V344v-8h-8H176h-8v8V496H136V248v-8H120v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V256h0V192H408h8v-8V136v-8h-8H336V16H624V304H336V224H320v80 16h16H624h16V304 16 0H624 336 320V16 128H251.1 132.9z'
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fast',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      'M640 72V64H624v8V440v8h16v-8V72zM320 216h16V200 112h9.4l144 144-144 144H336V312 296H320L16 296l0-80 304 0zm180.7 28.7L352 96H336 320v16 72 16H304L16 200H0v16 80 16H16l288 0h16v16 72 16h16 16L500.7 267.3 512 256l-11.3-11.3z'
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fast',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      'M112 4.7l5.7 5.7 88 88 5.7 5.7L200 115.3l-5.7-5.7L120 35.3 120 464H312V40 32h8l208 0h8v8l0 436.7 74.3-74.3 5.7-5.7L627.3 408l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L440 396.7l5.7 5.7L520 476.7V48L328 48V472v8h-8H112h-8v-8l0-436.7L29.7 109.7 24 115.3 12.7 104l5.7-5.7 88-88L112 4.7z'
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fast',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      'M51.2 44.8V83.2H12.8V44.8H51.2zM12.8 32H0V44.8 83.2 96H12.8 51.2 64V83.2 44.8 32H51.2 12.8zM51.2 140.8v38.4H12.8V140.8H51.2zM12.8 128H0v12.8 38.4V192H12.8 51.2 64V179.2 140.8 128H51.2 12.8zm0 108.8H51.2v38.4H12.8V236.8zM0 224v12.8 38.4V288H12.8 51.2 64V275.2 236.8 224H51.2 12.8 0zM51.2 332.8v38.4H12.8V332.8H51.2zM12.8 320H0v12.8 38.4V384H12.8 51.2 64V371.2 332.8 320H51.2 12.8zm0 108.8H51.2v38.4H12.8V428.8zM0 416v12.8 38.4V480H12.8 51.2 64V467.2 428.8 416H51.2 12.8 0zM147.2 44.8V83.2H108.8V44.8h38.4zM108.8 32H96V44.8 83.2 96h12.8 38.4H160V83.2 44.8 32H147.2 108.8zm0 108.8h38.4v38.4H108.8V140.8zM96 128v12.8 38.4V192h12.8 38.4H160V179.2 140.8 128H147.2 108.8 96zm51.2 108.8v38.4H108.8V236.8h38.4zM108.8 224H96v12.8 38.4V288h12.8 38.4H160V275.2 236.8 224H147.2 108.8zm0 108.8h38.4v38.4H108.8V332.8zM96 320v12.8 38.4V384h12.8 38.4H160V371.2 332.8 320H147.2 108.8 96zm51.2 108.8v38.4H108.8V428.8h38.4zM108.8 416H96v12.8 38.4V480h12.8 38.4H160V467.2 428.8 416H147.2 108.8zm96-371.2h38.4V83.2H204.8V44.8zM192 32V44.8 83.2 96h12.8 38.4H256V83.2 44.8 32H243.2 204.8 192zm51.2 108.8v38.4H204.8V140.8h38.4zM204.8 128H192v12.8 38.4V192h12.8 38.4H256V179.2 140.8 128H243.2 204.8zm0 108.8h38.4v38.4H204.8V236.8zM192 224v12.8 38.4V288h12.8 38.4H256V275.2 236.8 224H243.2 204.8 192zm51.2 108.8v38.4H204.8V332.8h38.4zM204.8 320H192v12.8 38.4V384h12.8 38.4H256V371.2 332.8 320H243.2 204.8zm0 108.8h38.4v38.4H204.8V428.8zM192 416v12.8 38.4V480h12.8 38.4H256V467.2 428.8 416H243.2 204.8 192zM339.2 44.8V83.2H300.8V44.8h38.4zM300.8 32H288V44.8 83.2 96h12.8 38.4H352V83.2 44.8 32H339.2 300.8zm0 108.8h38.4v38.4H300.8V140.8zM288 128v12.8 38.4V192h12.8 38.4H352V179.2 140.8 128H339.2 300.8 288zm51.2 108.8v38.4H300.8V236.8h38.4zM300.8 224H288v12.8 38.4V288h12.8 38.4H352V275.2 236.8 224H339.2 300.8zm0 108.8h38.4v38.4H300.8V332.8zM288 320v12.8 38.4V384h12.8 38.4H352V371.2 332.8 320H339.2 300.8 288zm51.2 108.8v38.4H300.8V428.8h38.4zM300.8 416H288v12.8 38.4V480h12.8 38.4H352V467.2 428.8 416H339.2 300.8zm96-371.2h38.4V83.2H396.8V44.8zM384 32V44.8 83.2 96h12.8 38.4H448V83.2 44.8 32H435.2 396.8 384zm51.2 108.8v38.4H396.8V140.8h38.4zM396.8 128H384v12.8 38.4V192h12.8 38.4H448V179.2 140.8 128H435.2 396.8zm0 108.8h38.4v38.4H396.8V236.8zM384 224v12.8 38.4V288h12.8 38.4H448V275.2 236.8 224H435.2 396.8 384zm51.2 108.8v38.4H396.8V332.8h38.4zM396.8 320H384v12.8 38.4V384h12.8 38.4H448V371.2 332.8 320H435.2 396.8zm0 108.8h38.4v38.4H396.8V428.8zM384 416v12.8 38.4V480h12.8 38.4H448V467.2 428.8 416H435.2 396.8 384z'
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fast',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M8 480l-8 0 0-16 8 0 368 0 8 0 0 16-8 0L8 480zm189.7-98.3l-5.7 5.7-5.7-5.7-136-136L44.7 240 56 228.7l5.7 5.7L184 356.7 184 40l0-8 16 0 0 8 0 316.7L322.3 234.3l5.7-5.7L339.3 240l-5.7 5.7-136 136z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fast',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      'M336 16V88v16 72h9.4l80-80-80-80H336zM320 88V16 0h16 16l84.7 84.7L448 96l-11.3 11.3L352 192H336 320V176 104H16V264v8H0v-8V96 88H8 320zM176 496V424 408 336h-9.4l-80 80 80 80H176zm16-72v72 16H176 160L75.3 427.3 64 416l11.3-11.3L160 320h16 16v16 72H496V248v-8h16v8V416v8h-8H192zm48-232h32 8v8V312v8H264v-8V208H240h-8V192h8z'
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fast',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      'M16 16H368V247.2c5-5.3 10.4-10.3 16-15V16 0H368 16 0V16 496v16H16 144h16 64 16H368h16v-8.2c-5.6-4.7-11-9.7-16-15V496H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fast',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      'M33.3 208C32 218 32 224 32 224H48 464h16s0-6-1.3-16C472.9 161.9 440.2 32 256 32S39.1 161.9 33.3 208zm429.4 0H49.4c.4-3.3 1-6.9 1.8-10.9c3.3-16.8 9.8-39 22.6-61C98.9 93 149.6 48 256 48s157.1 45 182.2 88.1c12.9 22 19.4 44.2 22.6 61c.8 4 1.4 7.7 1.8 10.9zM48 400H464v64H48V400zm0-16H32v16 64 16H48 464h16V464 400 384H464 48zm96-240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm240-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-8 160H392l-72 48-72-48zm-28.8 0l92 61.3 4 2.7 4.8 3.2 4.8-3.2 4-2.7 92-61.3H448h32v64H382.5l-24 16H480h16V336 272 256H480 448 416 224 192 32 16v16 64 16H32 281.5l-24-16H32V272H192h27.2z'
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fast',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM64 88h64 64 64 64 64 8v8 64 64 64 64 64 8h-8H320 256 192 128 64 56v-8V352 288 224 160 96 88h8zm8 64h48V104H72v48zm64 0h48V104H136v48zm64 0h48V104H200v48zm64 0h48V104H264v48zm64 0h48V104H328v48zm0 16v48h48V168H328zm0 64v48h48V232H328zm0 64v48h48V296H328zm0 64v48h48V360H328zm-16 0H264v48h48V360zm-64 0H200v48h48V360zm-64 0H136v48h48V360zm-64 0H72v48h48V360zm0-16V296H72v48h48zm0-64V232H72v48h48zm0-64V168H72v48h48zm16 0h48V168H136v48zm64 0h48V168H200v48zm64 0h48V168H264v48zm0 16v48h48V232H264zm0 64v48h48V296H264zm-16 0H200v48h48V296zm-64 0H136v48h48V296zm0-16V232H136v48h48zm16 0h48V232H200v48z'
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fast',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      'M16 16H240V64h16V16 0H240 16 0V16 240v16H16 128V240H16V16zM384 496v16h16H624h16V496 272 256H624 512v16H624V496H400V448H384v48zm80-384V400H176V112H464zM176 96H160v16V400v16h16H464h16V400 112 96H464 176zm64 80H400V336H240V176zm-16-16v16V336v16h16H400h16V336 176 160H400 240 224z'
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fast',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      'M251.3 196.7l73.4-73.4L336 112l-11.3-11.3L304 80H32 16V96 368l20.7 20.7L48 400l11.3-11.3 73.4-73.4L144 304l11.3 11.3L276.7 436.7 288 448l11.3-11.3 73.4-73.4L384 352l-11.3-11.3L251.3 219.3 240 208l11.3-11.3zM361.4 352L288 425.4 155.3 292.7 144 281.4l-11.3 11.3L48 377.4l-16-16V96H297.4l16 16-84.7 84.7L217.4 208l11.3 11.3L361.4 352z'
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fast',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM112 256h80V216 176H112v80zm0 16H96V256 176 160h16 80 16v16 40 40 16 16c0 30.9-25.1 56-56 56h-8-8V328h8 8c22.1 0 40-17.9 40-40V272H112zm224-16V216 176H256v80h80zm16-80v40 40 16 16c0 30.9-25.1 56-56 56h-8-8V328h8 8c22.1 0 40-17.9 40-40V272H256 240V256 176 160h16 80 16v16z'
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fast',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      'M0 464l64-80V288C64 128 160 0 288 0H457.4 480L464 16 418.7 61.3 407.2 72.8c4.5 3 8.8 6.2 13 9.6C475.4 126.1 512 196.6 512 288v96l64 80v32 16H560 16 0V496 464zM288 16C172.5 16 80 132.7 80 288v96 5.6L76.5 394 16 469.6V496H160V320c0-70.7 57.3-128 128-128s128 57.3 128 128V496H560V469.6L499.5 394l-3.5-4.4V384 288c0-93.5-40.1-162.6-97.8-202l-16-10.9 13.7-13.7L441.4 16H288zM176 496H400V320c0-61.9-50.1-112-112-112s-112 50.1-112 112V496z'
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fast',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      'M66.4 33.2l7 1.2 80 13.8 7.9 1.4-2.7 15.8-7.9-1.4-73-12.6L16.4 256H240h16v16 16h64V272 256h16H559.6L498.4 51.3l-73 12.6-7.9 1.4-2.7-15.8 7.9-1.4 80-13.8 7-1.2 2 6.8 64 213.8 .3 1.1V256v16 24 8V464v16H560 336 320V464 304H256V464v16H240 16 0V464 304v-8V272 256v-1.2l.3-1.1 64-213.8 2-6.8zM560 304v-8V272H336v24V464H560V304zM16 296v8V464H240V296 272H16v24z'
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fast',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      'M492.7 11.3L504 0l11.3 11.3 49.4 49.4L576 72 564.7 83.3l-295 295L268 380l.3 .3c2.4 8.8 3.7 18.1 3.7 27.7c0 54.7-42.3 99.6-96 103.7v.3h-8-8H64 32 16 0V496 464 448H16 32 48 64V432 408c0-57.4 46.6-104 104-104c9.6 0 18.9 1.3 27.7 3.7l.3 .3 1.7-1.7 295-295zM258.3 367L339 286.3 289.7 237 209 317.7 258.3 367zM192 323.3c-7.6-2.2-15.7-3.3-24-3.3c-48.6 0-88 39.4-88 88v40 16H64 32 16v32H32 64 168h3.4l3.4-.3c45.4-3.5 81.2-41.4 81.2-87.7c0-8.3-1.2-16.4-3.3-24L192 323.3zM553.4 72L504 22.6l-203 203L350.3 275l203-203z'
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fast',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      'M216 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM150.6 120h-6.7l-1.2 6.6c-6.8 37.3-39.5 65.5-78.7 65.5c-15 0-28.9-4.1-40.9-11.2l-3.9-2.3-4 2.2L7.4 185 .5 188.7l3.6 6.9L102 384h18l-96-184.6c12.2 5.6 25.7 8.7 39.9 8.7c44.8 0 82.4-30.6 93-72.1h6.7c17.3 33.3 52.1 56 92.3 56s74.9-22.7 92.3-56H355c10.6 41.5 48.2 72.1 93 72.1c14.2 0 27.8-3.1 39.9-8.7L391.9 384h18l97.9-188.3 3.6-6.9-6.9-3.8-7.8-4.3-4-2.2-3.9 2.3c-12 7.1-25.9 11.2-40.9 11.2c-39.2 0-71.9-28.3-78.7-65.5l-1.2-6.6h-6.7H343.3h-5.1l-2.1 4.7C322.1 155 291.5 176 256 176s-66.1-21-80-51.3l-2.1-4.7h-5.1H150.6zM80 475.5L119.1 432H392.9L432 475.5V496H80V475.5zm-16-6.1V496v16H80 432h16V496 469.3L400 416H112L64 469.3z'
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fast',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      'M136 48V272h80V192 176h16H344h16v16 80h80V48H136zM360 352v16H344 232 216V352 288H136V464H440V288H360v64zM120 48.3C61.9 52.4 16 100.8 16 160V272H120V48.3zM16 288V464H120V288H16zM456 464H560V288H456V464zM560 272V160c0-59.2-45.9-107.6-104-111.7V272H560zM0 160C0 89.3 57.3 32 128 32H448c70.7 0 128 57.3 128 128V464v16H560 16 0V464 160zm344 32H232V352H344V192zm-48 48v64 8H280v-8V240v-8h16v8z'
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fast',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm40-280H328h8v8V256v8H320v-8V147.3L181.7 285.7l-5.7 5.7L164.7 280l5.7-5.7L308.7 136H200h-8V120h8z'
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fast',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      'M512 160L352 0H144 128V12.7l16 12.6V16H336V168v8h8H496V303.2l16 12.6V160zM144 496V208.8l-16-12.6V496v16h16H496h16V499.3l-16-12.6V496H144zM489.4 160H352V22.6L489.4 160zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fast',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-432a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 368a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm8-280v-8H248v8V344v8h16v-8V168z'
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fast',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      'M256 496c35.6 0 69.4-7.7 99.8-21.6c3.3 4.4 6.9 8.6 10.6 12.7C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-2.9 0-5.7 .1-8.6 .2C459.5 90.6 366.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240zm0-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V80 72h16v8V288.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64zM144 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm24.8 56.8l-5 24.8L508.2 344H560h20l-14.5 13.8-84 80-18.3 17.5 5-24.8 7.7-38.4H424 404l14.5-13.8 84-80 18.3-17.5zM444 376h41.6 9.8l-1.9 9.6-4.6 23.2L540 360H498.4h-9.8l1.9-9.6 4.6-23.2L444 376z'
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fast',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      'M472 0V8 40h32 8V56h-8H472V88v8H456V88 56H424h-8V40h8 32V8 0h16zM56 128v8 32H88h8v16H88 56v32 8H40v-8V184H8 0V168H8 40V136v-8H56zM96 448h8H408h8v8 48 8H400v-8V464H112v40 8H96v-8V456v-8zm72-64H344h8v16h-8H168h-8V384h8zm-8-64h8H344h8v16h-8H168h-8V320zm-56-64H408h8v16h-8H104 96V256h8zm24-64h8H376h8v16h-8H136h-8V192zm72-64H312h8v16h-8H200h-8V128h8zM224 0h8 48 8V16h-8H232h-8V0zm0 64h64 8V80h-8H224h-8V64h8z'
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fast',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      'M170.6 340l-4.5-4H160 48V176H160h6.1l4.5-4L310.1 48H336V464H310.1L170.6 340zM32 352H48 160L304 480h32 16V464 48 32H336 304L160 160H48 32v16V336v16zm409.6-19.2C464.9 315.3 480 287.4 480 256s-15.1-59.3-38.4-76.8L432 192c19.4 14.6 32 37.8 32 64s-12.6 49.4-32 64l9.6 12.8zm57.6 76.8c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-9.6 12.8C532.4 147.3 560 198.4 560 256s-27.6 108.7-70.4 140.8l9.6 12.8z'
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fast',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM320 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fast',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      'M373.1 16c-20.3 0-39.2 10.5-50 27.7L270.4 128H296h80c30.9 0 56-25.1 56-56s-25.1-56-56-56h-2.9zM241.6 128L188.9 43.7C178.1 26.5 159.2 16 138.9 16H136c-30.9 0-56 25.1-56 56s25.1 56 56 56h80 25.6zm14.4-7.1l53.6-85.7C323.3 13.3 347.3 0 373.1 0H376c39.8 0 72 32.2 72 72c0 22.6-10.4 42.8-26.7 56H496h16v16 96 16H496 480V496v16H464 48 32V496 256H16 0V240 144 128H16 90.7C74.4 114.8 64 94.6 64 72C64 32.2 96.2 0 136 0h2.9c25.8 0 49.8 13.3 63.5 35.2L256 120.9zM136 144H16v96H32 48 248V144H216 136zm128 0v96H464h16 16V144H376 296 264zM248 256H48V496H248V256zm16 240H464V256H264V496z'
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fast',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      'M368 16H16V496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 368h16V16 198.6c-5.4 1.5-10.8 3.3-16 5.4V16zM64 128h8H312h8v16h-8H72 64V128zm8 96H280h8v16h-8H72 64V224h8zm0 96H216h8v16h-8H72 64V320h8zm488 48a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156-76v24H420V292h24zM408 456V440h8 8V360h-8-8V344h8 16 8v8 88h8 8v16h-8-8H424h-8-8z'
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fast',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      'M352 200V104 40 32h8 96 8v8 64 8h-8l-88 0v88 8H352v-8zM448 96V48l-80 0V96l80 0zM560 208c0-47.4-25.7-88.7-64-110.9V79c47.4 23.6 80 72.5 80 129V432v16H560 288 272 16 0V432 208C0 128.5 64.5 64 144 64H320V80H210c46.3 23.9 78 72.3 78 128V432H560V208zM272 432V208c0-70.7-57.3-128-128-128S16 137.3 16 208V432H272zM64 192h8H216h8v16h-8H72 64V192z'
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fast',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      'M129.2 33.5C166.6 12.2 209.9 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-27.9 4.4-54.7 12.7-79.8c4.5 3.1 9.3 5.7 14.3 7.9C19.8 206.8 16 231 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240S388.5 16 256 16c-42.4 0-82.3 11-116.8 30.3c-1.2-1.8-2.6-3.6-3.9-5.3l-6-7.5zM208 272h8v16h-8H112h-8V272h8 96zm200 0v16h-8H304h-8V272h8 96 8zM184.6 419.3l-11.9-10.7 5.4-5.9C193.1 386 219.1 368 256 368s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7-5.4-5.9C309.3 399.1 287.3 384 256 384s-53.3 15.1-66.1 29.4l-5.4 5.9zM28.6 75.9c-7.2 9.9-9.8 22.5-7.2 34.5C25.7 130 43.1 144 63.2 144h1.6c20.1 0 37.5-14 41.8-33.6c2.7-12 .1-24.6-7.2-34.5L64 27.2 28.6 75.9zM15.6 66.5L54.1 13.6 64 0l9.9 13.6 38.5 52.9c9.9 13.7 13.5 30.9 9.9 47.4c-6 26.9-29.9 46.1-57.5 46.1H63.2c-27.6 0-51.5-19.2-57.5-46.1c-3.7-16.5-.1-33.7 9.9-47.4z'
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fast',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      'M176 80v48H80V80h96zm16 48V80 64H176 80 64V80v48H16 0v16V432v16H16 496h16V432 144 128H496 448V80 64H432 336 320V80v48H192zm144 0V80h96v48H336zm-16 16h16 96 16 48V432H16V144H64 80h96 16H320zm56 72H360v8 40H320h-8v16h8 40v40 8h16v-8V280h40 8V264h-8H376V224v-8zM96 264H88v16h8 96 8V264h-8H96z'
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fast',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      'M336 345.2v24.2V496h80l0-246.7-4-2.4L317.8 192h-3.2H288V363.2c8.9-2.2 17.5-5 25.7-8.6l22.3-9.5zm-64 21.1V192H184h-8H152 104.5c-24.2 0-44.6-18-47.6-42l-1-7.9-2-15.9-31.8 4 2 15.9 1 7.9c3.5 28.1 21.3 51.3 45.6 62.6l9.2 4.3v10.2V496h80V369.4 345.2l22.3 9.5c20.2 8.6 42.4 13.3 65.7 13.3c8.2 0 16.2-.6 24-1.7zM425.5 189.4l2.2-13.4h13.6H464h40c30.9 0 56-25.1 56-56V80H496h-6.6l-4.7-4.7L457.4 48H400h-8l-4.8-6.4L368 16H357.6L330.4 178.6l-.3 2 88.3 51.5 7.1-42.8zM6.3 132.1l-2-15.9 15.9-2 31.8-4 15.9-2 2 15.9 2 15.9 1 7.9c2 16 15.6 28 31.8 28H152h24 8 96.2L67.2 14.4 76.8 1.6 306.7 176h8L344 0h32l24 32h64l32 32h64 16V80v40c0 39.8-32.2 72-72 72H464 441.3L432 248l0 248v16H416 336 320V496 386.6 369.4c-5.2 2.2-10.6 4.2-16 5.9c-17.7 5.6-36.5 8.7-56 8.7s-38.3-3-56-8.7c-5.4-1.7-10.8-3.7-16-5.9v17.3V496v16H160 80 64V496 231.1c-29.1-13.6-50.5-41.4-54.8-75.1l-1-7.9-2-15.9zM444 80a12 12 0 1 1 0 24 12 12 0 1 1 0-24z'
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fast',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      'M80 8V0H64V8c0 27.3 5.1 45.2 13.6 57.9C86 78.4 97.1 85 106.7 90.6l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49v8h16v-8c0-27.3-5.1-45.2-13.6-57.9c-8.4-12.5-19.5-19.1-29.1-24.7l-.4-.3C105.4 71.2 97.1 66.2 90.9 57C84.7 47.8 80 33.5 80 8zM209.6 8V0h-16V8c0 27.3 5.1 45.2 13.6 57.9c8.4 12.5 19.5 19.1 29.1 24.7l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49v8h16v-8c0-27.3-5.1-45.2-13.6-57.9C266 89.6 254.9 83 245.3 77.4l-.4-.3C235 71.2 226.7 66.2 220.5 57c-6.2-9.2-10.9-23.5-10.9-49zM344 208h24V496H16V208H344zm40 176V208h24c48.6 0 88 39.4 88 88s-39.4 88-88 88H384zm0 112V400h24c57.4 0 104-46.6 104-104s-46.6-104-104-104H384 368 344 16 0v16V496v16H16 368h16V496z'
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fast',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      'M165.7 469.7l-5.7 5.7-5.7-5.7-104-104L44.7 360 56 348.7l5.7 5.7L152 444.7V40 32h16v8V444.7l90.3-90.3 5.7-5.7L275.3 360l-5.7 5.7-104 104zM496 48H336V208H496V48zM336 32H496h16V48 208v16H496 336 320V208 48 32h16zM296 480l10-16L406.6 303.1 416 288l9.4 15.1L526 464l10 16H517.1 314.9 296zm211.1-16L416 318.2 324.9 464H507.1z'
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fast',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      'M16 48l0 416 416 0 0-416L16 48zM0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32zM112 368l32 0 0-16 0-96 0-16-32 0 0 16 0 96 0 16zm48-144l0 16 0 16 0 96 0 16 0 16-16 0-32 0-16 0 0-16 0-16 0-96 0-16 0-16 16 0 32 0 16 0zm48 144l32 0 0-16 0-192 0-16-32 0 0 16 0 192 0 16zm96 0l32 0 0-16 0-32 0-16-32 0 0 16 0 32 0 16zM192 352l0-192 0-16 0-16 16 0 32 0 16 0 0 16 0 16 0 192 0 16 0 16-16 0-32 0-16 0 0-16 0-16zm96 0l0-32 0-16 0-16 16 0 32 0 16 0 0 16 0 16 0 32 0 16 0 16-16 0-32 0-16 0 0-16 0-16z'
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fast',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      'M296 0V8 308.7l42.9-42.9 5.7-5.7 11.3 11.3-5.7 5.7L307.3 320H368h8v16h-8H307.3l42.9 42.9 5.7 5.7-11.3 11.3-5.7-5.7L296 347.3v84.4c58.1-4.1 104-52.6 104-111.7c0-37.3-18.2-70.4-46.3-90.7l-10.5-7.6 11.4-6C400.6 191.6 432 143.5 432 88c0-26.8-7.3-51.8-20-73.2l10.9-11C504.8 50.6 560 138.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 138.8 71.2 50.6 153.1 3.7l10.9 11C151.3 36.2 144 61.2 144 88c0 55.5 31.4 103.6 77.4 127.7l11.4 6-10.5 7.6C194.2 249.6 176 282.7 176 320c0 59.2 45.9 107.6 104 111.7V347.3l-42.9 42.9-5.7 5.7-11.3-11.3 5.7-5.7L268.7 336H208h-8V320h8 60.7l-42.9-42.9-5.7-5.7 11.3-11.3 5.7 5.7L280 308.7V8 0h16zm0 448h-7.8l-.2 0-.2 0H280v-.2C213 443.6 160 388 160 320c0-38.3 16.8-72.7 43.5-96.1C158.2 195.6 128 145.3 128 88c0-19.5 3.5-38.1 9.8-55.4C101 59.4 71.6 95.7 53.2 137.9l.5 .5 80 80 5.7 5.7-5.7 5.7 0 0-5.7 5.7-5.7-5.7L46.8 154.1c-6.8 19-11.4 39.1-13.5 59.9l4.4 4.4 64 64 5.7 5.7-5.7 5.7L96 299.3l-5.7-5.7L32 235.4c0 1.5 0 3.1 0 4.6c0 141.4 114.6 256 256 256s256-114.6 256-256c0-1.6 0-3.1 0-4.6l-58.3 58.3-5.7 5.7L468.7 288l5.7-5.7 64-64 4.4-4.4c-2.1-20.8-6.7-40.9-13.5-59.9l-75.6 75.6-5.7 5.7L436.7 224l5.7-5.7 80-80 .5-.5C504.4 95.7 475 59.4 438.2 32.6C444.5 49.9 448 68.5 448 88c0 57.3-30.2 107.6-75.5 135.9C399.2 247.3 416 281.7 416 320c0 68-53 123.6-120 127.8v.2z'
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fast',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      'M0 144H8 128h3.5l2.4 2.6L323.5 352H432V192v-8h16v8V360v8h-8H320h-3.5l-2.4-2.6L124.5 160H16V320v8H0v-8V152v-8z'
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fast',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M375 173.5c10.9-21.4 17-39.9 17-53.5c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 13.6 6.1 32.1 17 53.5c10.7 21 25.2 43.1 39.9 63.3c14.7 20.2 29.4 38.3 40.5 51.4c2.4 2.8 4.6 5.3 6.5 7.6c2-2.3 4.2-4.8 6.5-7.6c11.1-13.1 25.8-31.2 40.5-51.4c14.7-20.3 29.2-42.3 39.9-63.3zM298.7 308c-6.6 7.6-10.7 12-10.7 12s-4.1-4.4-10.7-12C247.9 274.2 168 177.1 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 57.1-79.9 154.2-109.3 188zM560 150.5L414.8 201c1-1.9 2-3.8 3-5.7c2.4-4.8 4.8-9.7 7.1-14.7l135.2-47 16-5.6v16.9V448L392 512 184 448 16 506.4 0 512V495.1 192l138.7-48.2c1.1 5.2 2.5 10.3 4.2 15.5L16 203.4V489.5l160-55.7V288h16V433.7l192 59.1V288h16V492.3l160-55.7V150.5zM320 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fast',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      'M0 456l0 8 16 0 0-8L16 48l408 0 8 0 0-16-8 0L8 32 0 32l0 8L0 456zm112-24l0 32 32 0 0-32-32 0zm192 0l0 32 32 0 0-32-32 0zm-96 32l32 0 0-32-32 0 0 32zm192-32l0 32 32 0 0-32-32 0zm0-160l32 0 0-32-32 0 0 32zm0 64l0 32 32 0 0-32-32 0zm0-160l32 0 0-32-32 0 0 32z'
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fast',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      'M146.7 352L56.6 480H76.1l90.1-128H424h8V336h-8H177.5L290.1 176H424h8V160h-8H301.3L391.4 32H371.8L281.8 160H24 16v16h8H270.5L157.9 336H24 16v16h8H146.7z'
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fast',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      'M560 80H16V432H328.9l-2.3 16H16 0V432 80 64H16 560h16V80v92.4L564.4 184l0 0-4.4 4.4V80zM384 304v16H96V304H384zM96 208H480v16H96V208zm466.9 15.9l11.3 11.3 54.5 54.5L640 300.9l-11.3 11.3L443.3 497.6l-74.7 11.6L352 511.9l2.6-16.6 11.6-74.7L562.9 223.9zM381.2 428.2l-10 64.5 64.5-10L573.5 344.8 519 290.4 381.2 428.2zM617.4 300.9l-54.5-54.5L530.4 279l54.5 54.5 32.5-32.5z'
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fast',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      'M200 32H184V96.2C81.7 100.4 0 184.6 0 288V472v8H16v-8V288c0-94.5 74.5-171.6 168-175.8V480h16V112.2c93.5 4.2 168 81.3 168 175.8V472v8h16v-8V288c0-103.4-81.7-187.6-184-191.8V32z'
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fast',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm128 96h16v8V279.8L302.4 128h23.1L214.1 234.8l.4 .6L321.2 384H301.5L202.4 245.9l-58.4 56V376v8H128v-8V298.5 136v-8z'
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fast',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      'M256 496a240 240 0 1 1 0-480 240 240 0 1 1 0 480zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM195.3 332.7L184 344l11.3 11.3L208 368H352h16V352 208l-12.7-12.7L344 184l-11.3 11.3-25.4 25.4L296 232l-11.3-11.3-73.4-73.4L200 136l-11.3 11.3-41.4 41.4L136 200l11.3 11.3 73.4 73.4L232 296l-11.3 11.3-25.4 25.4zm48-48L158.6 200 200 158.6l84.7 84.7L296 254.6l11.3-11.3L344 206.6l8 8V352H214.6l-8-8 36.7-36.7L254.6 296l-11.3-11.3z'
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fast',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      'M408 80l8 0V64h-8H304 200h-8V80h8l96 0v48H160 80 64v16V248H16V168v-8H0v8V344v8H16v-8V264H64V368v16H80h99.2L256 448H496h16V432 192l-96-64H336 312V80l96 0zM80 264V248 144h80l144 0 32 0h75.2L496 200.6V432H261.8l-72.3-60.3L185 368h-5.8H80V264zm480-56h64V432H560V208zm-16-16v16V432v16h16 64 16V432 208 192H624 560 544zM288 352v16h16 16V352 336H304 288v16zm24-168v-8H296v8V304v8h16v-8V184z'
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fast',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      'M56 8V0H40V8 40H8 0V56H8 40V88v8H56V88 56H88h8V40H88 56V8zM472 328v-8H456v8 32H424h-8v16h8 32v32 8h16v-8V376h32 8V360h-8H472V328zM104 448H96v8 48 8h16v-8V464H400v40 8h16v-8V456v-8h-8H104zM288 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM168 384h-8v16h8H344h8V384h-8H168zm-8-64v16h8H344h8V320h-8H168h-8zm-56-64H96v16h8H408h8V256h-8H104zm24-64v16h8H376h8V192h-8H136h-8zm72-64h-8v16h8H312h8V128h-8H200z'
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fast',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      'M16 16V496H144V384 368h16 64 16v16V496H368V16H16zM160 496h64V384H160V496zm-16 16H16 0V496 16 0H16 368h16V16 496v16H368 240 224 160 144zM80 232h64 8v8 64 8h-8H80 72v-8V240v-8h8zm8 64h48V248H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V240v-8zm16 16v48h48V248H248zM48 56h8 8 4.9l2.2 4.4L112 142.1V64 56h16v8 96 8h-8-8-4.9l-2.2-4.4L64 81.9V160v8H48v-8V64 56zm120 0h48 8V72h-8H176v80h32V120v-8h16v8 40 8h-8H168h-8v-8V64 56h8zM272 96v32c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24-40c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40s-40-17.9-40-40V96c0-22.1 17.9-40 40-40z'
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fast',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200h-8v16h8 80V496H88V291.3l58.3 58.3 11.3-11.3-72-72L80 260.7l-5.6 5.6 0 0-72 72 11.3 11.3L72 291.3V504v8h8H288h96l0-16H296V224h80 8V208h-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fast',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 32H8 40 72 224c61.9 0 112 50.1 112 112c0 43.1-24.4 80.5-60.1 99.3C328.7 255.8 368 303.3 368 360c0 66.3-53.7 120-120 120H72 40 8 0V464H8 32V248 48H8 0V32zM48 464H72 248c57.4 0 104-46.6 104-104s-46.6-104-104-104H224 48V464zm0-224H224c53 0 96-43 96-96s-43-96-96-96H72 48V240z'
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fast',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM131.5 120.2l56.6 56.6 56.6-56.6L210.7 86.3l-5.7-5.7 11.3-11.3 5.7 5.7L256 108.9 289.9 75l5.7-5.7 11.3 11.3-5.7 5.7-33.9 33.9 56.6 56.6 56.6-56.6 5.7-5.7 11.3 11.3-5.7 5.7-56.6 56.6 56.6 56.6 33.9-33.9 5.7-5.7 11.3 11.3-5.7 5.7L403.1 256 437 289.9l5.7 5.7-11.3 11.3-5.7-5.7-33.9-33.9-56.6 56.6 56.6 56.6 5.7 5.7-11.3 11.3-5.7-5.7-56.6-56.6-56.6 56.6 33.9 33.9 5.7 5.7-11.3 11.3-5.7-5.7L256 403.1 222.1 437l-5.7 5.7-11.3-11.3 5.7-5.7 33.9-33.9-56.6-56.6-56.6 56.6-5.7 5.7-11.3-11.3 5.7-5.7 56.6-56.6-56.6-56.6L86.3 301.3l-5.7 5.7L69.3 295.6l5.7-5.7L108.9 256 75 222.1l-5.7-5.7 11.3-11.3 5.7 5.7 33.9 33.9 56.6-56.6-56.6-56.6-5.7-5.7 11.3-11.3 5.7 5.7zm0 135.8l56.6 56.6L244.7 256l-56.6-56.6L131.5 256zm67.9 67.9L256 380.5l56.6-56.6L256 267.3l-56.6 56.6zm181-67.9l-56.6-56.6L267.3 256l56.6 56.6L380.5 256zM256 244.7l56.6-56.6L256 131.5l-56.6 56.6L256 244.7z'
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fast',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      'M144 120c0-39.8 32.2-72 72-72s72 32.2 72 72v15.9c0 26.8-2.1 53.6-6.4 80L117.7 264.3 112 266v6V472v8h8 72 4.8l2.3-4.3 39.7-74.9c21.8-41.2 37.9-85 48-130.5l4.8-21.8c1.5-6.7 2.8-13.4 4.1-20.1L454 181.6 385.2 291.8 377.6 304H392 568c4.4 0 8-3.6 8-8s-3.6-8-8-8H406.4l72.3-115.8L490 154.4l-20.2 6L298.6 210.9c3.6-24.8 5.4-49.9 5.4-75V120c0-48.6-39.4-88-88-88s-88 39.4-88 88v40c0 4.4 3.6 8 8 8s8-3.6 8-8V120zM128 278l150.4-44.4c-.8 3.8-1.6 7.7-2.4 11.5l-4.8 21.8c-9.8 44.1-25.5 86.6-46.6 126.5L187.2 464H128V278zM8 368H0v16H8 56h8V368H56 8zm320 0h-8v16h8H632h8V368h-8H328z'
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fast',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      'M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-8 15.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 23.8-17.3 43.5-40 47.3l0 43.7L380.4 80.8l5.2-2.6 4.1 4.1 120 120 2.3 2.3 0 3.3 0 8 0 8-8 0-138.1 0c-31.5 0-62.3-8.8-89-25.5l-12.8-8 0 172.8 58.8-32.1c18-9.8 29.2-28.7 29.2-49.2l0-18 0-8 16 0 0 8 0 18c0 26.3-14.4 50.6-37.5 63.2l-57.8 31.5 25.8 14.1C321.6 403.4 336 427.6 336 454l0 18 0 8-16 0 0-8 0-18c0-20.5-11.2-39.4-29.2-49.2L264 390.2l0 57.8 0 64-16 0 0-64 0-57.8-26.8 14.6c-18 9.8-29.2 28.7-29.2 49.2l0 18 0 8-16 0 0-8 0-18c0-26.3 14.4-50.6 37.5-63.2l25.8-14.1-57.8-31.5C158.4 332.6 144 308.4 144 282l0-18 0-8 16 0 0 8 0 18c0 20.5 11.2 39.3 29.2 49.2L248 363.3l0-172.8-12.8 8c-26.7 16.7-57.6 25.5-89 25.5L8 224l-8 0 0-8 0-8 0-3.3 2.3-2.3 120-120 4.1-4.1 5.2 2.6L248 139.1l0-43.7zm0 61.6L129.6 97.7 19.3 208l126.8 0c28.5 0 56.4-8 80.6-23.1L248 171.6l0-14.6zm16 14.6l21.3 13.3C309.5 200 337.4 208 365.9 208l126.8 0L382.4 97.7 264 156.9l0 14.6z'
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fast',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM112 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fast',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      'M432 224h72 8V208h-8H440V8 0h-8H360h-8V16h8 64V208H375.4l20.3 16H432zM304 8V0h-8H152h-8V8 25.3L160 38V16H288V139l16 12.6V8zm32 496v8h8H488h8v-8V486.7L480 474v22H352V373l-16-12.6V504zM136 288h-8v16h8 64V496H136h-8v16h8 72 72 8V496h-8H216V296v-8h-8H136zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fast',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM21.7 496H322.1l-2.5 16H16.7 0l4.9-16L64 304H384l12.6 40.9-12.8 12.8L372.2 320H75.8L21.7 496zM562.9 223.9l11.3 11.3 54.5 54.5L640 300.9l-11.3 11.3L443.3 497.6l-74.7 11.6L352 511.9l2.6-16.6 11.6-74.7L562.9 223.9zM381.2 428.2l-10 64.5 64.5-10L573.5 344.8 519 290.4 381.2 428.2zM617.4 300.9l-54.5-54.5L530.4 279l54.5 54.5 32.5-32.5z'
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fast',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      'M368 16v96H16V16H368zM16 0H0V16v96 16H16 368h16V112 16 0H368 16zM32 416v80 16H48 330.8c-6.9-4.9-13.5-10.2-19.6-16H48V416H152h8V400h-8H48V320H152h8V304h-8H48V224H152h8V208h-8H48V160H32v48 16 80 16 80 16zM352 160H336v60.5c5.2-3.4 10.5-6.5 16-9.3V160zm80 80a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM376 300.7L364.7 312l5.7 5.7 112 112 5.7 5.7L499.3 424l-5.7-5.7-112-112-5.7-5.7z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fast',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M0 32H8 136h8V48h-8H80V240c0 79.5 64.5 144 144 144s144-64.5 144-144V48H312h-8V32h8H440h8V48h-8H384V240c0 88.4-71.6 160-160 160s-160-71.6-160-160V48H8 0V32zM0 464H8 440h8v16h-8H8 0V464z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fast',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      'M496 144v48c5.4 0 10.7 .2 16 .7V144 128H496L16 128H0v16V496v16H16l378.8 0c-6.9-4.9-13.4-10.2-19.6-16L16 496l0-352 480 0zM464 64L48 64V80l416 0V64zM416 0H96V16l320 0V0zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 296v-8H488v8 64H424h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H504V296z'
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fast',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      'M264 8V0H248V8 32.1C115.7 36.2 8.6 140.7 .5 272c-.3 5.3-.5 10.6-.5 16H16 496h16c0-5.4-.2-10.7-.5-16C503.4 140.7 396.3 36.2 264 32.1V8zm-8 40c127.2 0 231.2 98.9 239.5 224H16.5C24.8 146.9 128.8 48 256 48zm8 414.2V320H248V462.2c0 18.7-15.2 33.8-33.8 33.8c-14.6 0-27.5-9.3-32.1-23.1l-6.5-19.4-2.5-7.6-15.2 5.1 2.5 7.6 6.5 19.4c6.8 20.4 25.8 34.1 47.3 34.1c27.5 0 49.8-22.3 49.8-49.8z'
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fast',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M32 0h8 64 3.3l2.3 2.3 45.4 45.4C167.4 37.9 183 32 200 32c23.1 0 43.7 10.9 56.9 27.8l1.5-1.5 5.7-5.7L275.3 64l-5.7 5.7-104 104-5.7 5.7L148.7 168l5.7-5.7 1.5-1.5C138.9 147.7 128 127.1 128 104c0-17 5.9-32.6 15.7-44.9L100.7 16H48V272H464h16 24 8v16h-8H480 464 48 32 8 0V272H8 32V8 0zm0 320H48v48c0 53 43 96 96 96H368c53 0 96-43 96-96V320h16v48c0 38.1-19 71.7-48 91.9V504v8H416v-8V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V504v8H80v-8V459.9C51 439.7 32 406.1 32 368V320zM200 48c-30.9 0-56 25.1-56 56c0 18.7 9.2 35.3 23.3 45.4l78.2-78.2C235.3 57.2 218.7 48 200 48z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fast',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      'M96 320H80 16 0V304 16 0H16 400h16V16 304v16H400 224L112 376l-16 8V366.1 336 320zm0-16h16v16 38.1l104.8-52.4 3.4-1.7H224 400V16H16V304H96zM256 432V352h16v80H416h3.8l3.4 1.7L528 486.1V448 432h16 80V144H448V128H624h16v16V432v16H624 560 544v16 30.1V512l-16-8L416 448H272 256V432z'
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fast',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      'M320 48C200.3 48 91.9 96.7 13.7 175.4L2.3 164.1C83.5 82.5 195.8 32 320 32s236.5 50.5 317.7 132.1l-11.3 11.3C548.1 96.7 439.7 48 320 48zm0 160c-72.2 0-137.8 28.1-186.5 74l-11-11.6C174.1 221.8 243.6 192 320 192s145.9 29.8 197.5 78.4l-11 11.6c-48.7-45.9-114.3-74-186.5-74zm48 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fast',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM200 440V251.3l74.3 74.3 5.7 5.7L291.3 320l-5.7-5.7-88-88-5.7-5.7-5.7 5.7-88 88L92.7 320 104 331.3l5.7-5.7L184 251.3V440v8h16v-8z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fast',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H368v0H352v0H224V320h32 70.6c1.5-5.4 3.3-10.8 5.4-16H216h-8v8V496H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 10 .3L293.2 9.9zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fast',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M257.3 80h13.1H304v64H192 80V80h33.6 13.1l2.6-12.8C135.2 38 161.1 16 192 16s56.8 22 62.7 51.2L257.3 80zM113.6 64H80 64V80 96H8 0v8V504v8H8 376h8v-8V104 96h-8H320V80 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64zM16 112H64v32 16H80 192 304h16V144 112h48V496H16V112zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fast',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zM264 160H248v8 80H168h-8v16h8 80v80 8h16v-8V264h80 8V248h-8H264V168v-8z'
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fast',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      'M325.9 86.1l88.3-2.7 24.7 84.9L512 218l-22.2 61.8c-3.7-5.1-7.6-10.2-11.6-15l14.6-40.5-62.8-42.7-4.8-3.2-1.6-5.5-21.2-73-76 2.3-5.7 .2-4.5-3.5L256 52.2 195.9 98.8l-4.5 3.5-5.7-.2-76-2.3-21.2 73-1.6 5.5-4.8 3.2L19.2 224.2l14.6 40.5c-4 4.9-7.9 9.9-11.6 15L0 218l73.1-49.7L97.8 83.4l88.3 2.7L256 32l69.9 54.1zM16 448v16H496V448c0-132.5-107.5-240-240-240S16 315.5 16 448zM0 464V448C0 306.6 114.6 192 256 192s256 114.6 256 256v16 16H496 16 0V464zM176 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fast',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      'M72.4 174.8L164.4 0 333.1 61.4 291.3 254.5c-14.5 67-82.7 106.8-147.5 88l-46 126.3L175.2 497l-5.5 15L0 450.2l5.5-15 77.3 28.1 46-126.3C67.1 309.8 40.5 235.5 72.4 174.8zm14.2 7.5C57.9 236.7 83.8 303.9 141.7 325s120.9-13.8 134-73.9l13.4-61.9-173-63-29.5 56zm205.9-8.8L314.5 71.7 172.1 19.8 123.6 112l168.9 61.5zm56.2 81l-12.3-57 8.2-37.8 3 13.7L516.4 112 467.9 19.8l-101 36.8 3.4-15.7-3.6-1.3L475.6 0l92 174.8c31.9 60.6 5.3 135-56.4 162.2l46 126.3 77.3-28.1 5.5 15L470.3 512l-5.5-15 77.3-28.1-46-126.3c-64.8 18.8-132.9-21-147.5-88zm204.7-72.2l-29.5-56-173 63 13.4 61.9c13 60.1 76.1 94.9 134 73.9s83.8-88.3 55.1-142.7z'
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fast',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      'M165.7 10.3L160 4.7l-5.7 5.7-64 64L84.7 80 96 91.3l5.7-5.7L152 35.3V128H96 88v16h8 56v48.2C67.4 196.4 0 266.3 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.7-67.4-155.6-152-159.8V144h56 8V128h-8H168V35.3l50.3 50.3 5.7 5.7L235.3 80l-5.7-5.7-64-64zM160 496a144 144 0 1 1 0-288 144 144 0 1 1 0 288z'
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fast',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zm40-88H632V200H424v16z'
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fast',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      'M584 8V0H568V8 360.1l16 12.6V8zM456 455.1l-16-12.6V504v8h16v-8V455.1zM328 354l-16-12.6V504v8h16v-8V354zM440 104V259l16 12.6V104 96H440v8zM200 288H184v8V504v8h16v-8V296v-8zM72 384H56v8V504v8H72v-8V392v-8zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fast',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      'M53.2 464L172.1 48H312v56 8h16v-8V48H467.9l41.3 144.5c5.8 .4 11.6 1.2 17.3 2.1L480 32H160L36.6 464 32 480H48.6 360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2.1-6.7-3.8-13.6-5.1-20.6H312v8 56H53.2zM328 312V200v-8H312v8V312v8h14.6c.4-1.5 .9-3.1 1.4-4.6V312zm40 56a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fast',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      'M528.1 512l-20.3-16H112V384 256 223.2l.2 0c4 .5 8.1 .8 12.1 .8c11.2 0 21.8-2.1 31.5-5.8l-15.2-12c-5.2 1.2-10.7 1.9-16.3 1.9c-3.3 0-6.7-.2-10-.7c-30.7-4.1-50.8-32.1-50.4-61.8L49 133.8c-5.7 35.5 13 72.4 47 85.3V256 384 504v8h8H528.1zM528 256v72.5l16 12.6V256 219.1c43.9-16.7 62.2-73.3 35.6-115.3L512 0H128l-5.5 8.4 12.6 10 1.5-2.3H503.3l62.8 96.4c24.1 38.2 1.7 89.3-40.7 94.9c-3.3 .4-6.6 .7-10 .7c-21.3 0-40.2-9.3-53.3-23.7l-11.9-13.1-11.8 13.1c-13 14.4-31.9 23.7-53.3 23.7c-3.6 0-7.2-.3-10.7-.8L395 223.5c16.4-1.8 31.3-8.2 43.5-17.6c4.3-3.3 8.2-6.9 11.8-10.9c3.6 3.9 7.5 7.6 11.8 10.8c14.7 11.3 33.2 18.1 53.4 18.1c4.1 0 8.1-.3 12.1-.8l.5-.1V256zM365.9 384l-20.3-16H176V256v-8H160v8V376v8h8H365.9zM464 256v22l16 12.6V256v-8H464v8zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fast',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      'M16 64v8V240H304V72 64h16v8V248 440v8H304v-8V256H16V440v8H0v-8V248 72 64H16zm624 0v8V440v8H624v-8V288h0H392h-9.7l1.8-9.5L425.4 64h16.3l-40 208H624h0V72 64h16z'
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fast',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      'M424 64h-1.9l-1.7 .8L358.1 96H124C56.9 96 2.2 149.4 .1 216H0v4 4 96 8H16v-8V281 224c0-.3 0-.6 0-.9c0-1 0-2.1 0-3.1c0-47.1 30.1-87.1 72.1-101.9C91.3 194.8 154.5 256 232 256h16 2.1l1.8-1.1L418.1 160h64c-1.4 2.4-2.1 5.1-2.1 8c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.9-.8-5.6-2.1-8H624v36.7L596.7 224c-82.3 1.1-165.4 43.2-212.6 79.3l-3.8 2.9 .8 4.7 25.5 153H326.8L305.2 334.7l-1.1-6.7h-6.8H192h-5.3l-2.1 4.8-24 56-1.1 2.7 .8 2.8L181.2 464H102L80.3 391.9l16.8-59 2.1-7.5-7.5-2.3c-25.1-7.8-46.3-24.6-59.9-46.5v26.5c13 14.4 29.3 25.7 47.7 32.7L64.3 389.8l-.6 2.3 .7 2.2 24 80L90 480h6 96 10.8l-3.1-10.3-23.2-77.2L197.3 344h93.3l21.6 129.3 1.1 6.7H320h96 9.4l-1.6-9.3L397.6 313.1C433 287 486.8 258.6 544 246.3V248v32 8h16v-8V248v-4.7c13.3-2.1 26.7-3.3 40-3.3h3.3l2.3-2.3 32-32 2.3-2.3V200 144v-4.8l-4.3-2.3-136-72L498 64h-2H424zm-60.4 47.2L425.9 80H494l120.9 64H416h-2.1l-1.8 1.1L245.9 240H232c-70.1 0-127-56.3-128-126.2c6.5-1.2 13.2-1.8 20-1.8H360h1.9l1.7-.8z'
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fast',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240V456.1L320 456V432 416H304 240c-26.5 0-48 21.5-48 48s21.5 48 48 48h64 16V496 472l184 .1 8 0v-8V256C512 114.6 397.4 0 256 0S0 114.6 0 256v56 8H16v-8V256zM304 464l0 8h0v24H240c-17.7 0-32-14.3-32-32s14.3-32 32-32h64v32zM80 208h80V368H80V208zM64 192v16V368v16H80h80 16V368 208 192H160 80 64zm368 16V368H352V208h80zm16-16H432 352 336v16V368v16h16 80 16V368 208 192z'
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fast',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      'M137.1 427.3l-16.9 75 15.6 3.5L152 434c18.9 7.6 39.2 12.4 60.5 13.6l-12.3 54.6 15.6 3.5 13.1-57.8c60.8-1.5 114.6-31.3 148.7-76.7l-12.8-9.6c-30.5 40.6-78.2 67.6-132.3 70.2l74.7-330.9c22.6 12.2 42.3 29.1 57.6 49.5l12.8-9.6c-17.6-23.4-40.4-42.7-66.7-56l16.9-75L312.2 6.2 296 78c-18.9-7.6-39.2-12.4-60.5-13.6L247.8 9.8 232.2 6.2 219.1 64.1C115.3 66.6 32 151.6 32 256c0 74.8 42.7 139.6 105.1 171.3zm18.4-9.1l76.3-338c21.4 .9 41.8 5.7 60.5 13.6l-76.3 338c-21.4-.9-41.8-5.7-60.5-13.6zm59.9-338L140.8 411.1C85.5 381.4 48 323.1 48 256c0-94.4 74.2-171.4 167.5-175.8z'
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fast',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      'M112 128c0-61.9 50.1-112 112-112c51.5 0 94.9 34.8 108 82.1l15.4-4.3C332.5 39.8 282.9 0 224 0C153.3 0 96 57.3 96 128v64H16 0v16V496v16H16 432h16V496 208 192H432 112V128zM96 208h16H432V496H16V208H96z'
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fast',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      'M392 288H560V102.6L505.4 48H446.6L392 102.6V288zM338.7 141.7l16 25.8L376 155.4V114.8l-37.3 26.9zM356 185.2l-6.7 3.8-4.1-6.6-24-38.7-3.9-6.3 6.1-4.4 55.9-40.3L440 32h72l60.8 60.8 55.9 40.3 6.1 4.4-3.9 6.3-24 38.7-4.1 6.6-6.7-3.8-20-11.4V288v16H560 392 376V288 173.8l-20 11.4zm241.3-17.7l16-25.8L576 114.8v40.5l21.3 12.2zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM304.2 69.9C315.1 61.2 329 56 344 56V72c-11.3 0-21.7 3.9-29.8 10.4l-12 9.5L292.1 80.4C283.3 70.3 270.4 64 256 64s-27.3 6.3-36.1 16.4L209.8 91.9l-12-9.5C189.7 75.9 179.3 72 168 72c-22.5 0-41.5 15.6-46.6 36.5l-3.5 14.2-14.5-2.2c-2.4-.4-4.9-.6-7.4-.6c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6l3 12.1-11 5.9C26.3 205.7 16 221.7 16 240s10.3 34.3 25.4 42.4l11 5.9-3 12.1C48.5 304.1 48 308 48 312c0 26.5 21.5 48 48 48c2.5 0 5-.2 7.4-.6l14.5-2.2 3.5 14.2c5.1 21 24.1 36.6 46.6 36.6c11.3 0 21.7-3.9 29.8-10.4l12-9.5 10.1 11.5c8.8 10.1 21.7 16.4 36.1 16.4s27.3-6.3 36.1-16.4l10.1-11.5 12 9.5c8.2 6.5 18.5 10.4 29.8 10.4c22.5 0 41.5-15.6 46.6-36.6l3.5-14.2 14.5 2.2c2.4 .4 4.9 .6 7.4 .6c17.8 0 33.3-9.7 41.6-24h17.8c-8.7 21.6-28.9 37.3-52.9 39.7L391.8 505.8l-1.5 6.2H384 312h-8v-8V448v-8h16v8 48h57.7l27.7-117.9C397.6 404.6 373.1 424 344 424c-15 0-28.9-5.2-39.8-13.9c-11.7 13.4-29 21.9-48.2 21.9s-36.5-8.5-48.2-21.9C196.9 418.8 183 424 168 424c-29.1 0-53.6-19.4-61.4-45.9L134.3 496H192V448v-8h16v8 56 8h-8H128h-6.3l-1.5-6.2L89.6 375.7C57.3 372.5 32 345.2 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9z'
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fast',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      'M496 208c0 159.1-128.9 288-288 288c-69.7 0-133.6-24.7-183.4-66L63.7 391c40.8 35.5 94 57 152.3 57c128.1 0 232-103.9 232-232c0-58.3-21.5-111.6-57-152.3L430 24.6c41.2 49.8 66 113.7 66 183.4zM184 429.6c-41.3-6.1-78.8-24-109-50l99.1-99.1c3.2 1.5 6.5 2.8 9.9 3.8V429.6zm16 1.8V287.6c2.6 .3 5.3 .4 8 .4c19.2 0 36.8-6.8 50.6-18.1L363 374.3C324.4 410.1 272.8 432 216 432c-5.4 0-10.7-.2-16-.6zm69.9-172.8C281.2 244.8 288 227.2 288 208c0-2.7-.1-5.4-.4-8H431.4c.4 5.3 .6 10.6 .6 16c0 56.8-21.9 108.4-57.7 147L269.9 258.6zM284.3 184c-1.1-3.4-2.4-6.7-3.8-9.9L379.6 75c26.1 30.2 43.9 67.7 50 109H284.3zm-16.1 2.4c2.4 6.8 3.7 14 3.7 21.6c0 35.3-28.7 64-64 64c-7.6 0-14.9-1.3-21.6-3.7l81.9-81.9zM1.2 430.8c3.9 3.6 7.9 7.2 12 10.6C66 485.5 133.9 512 208 512c167.9 0 304-136.1 304-304c0-74.1-26.5-142-70.6-194.8c-3.4-4.1-7-8.1-10.6-12L419.5 12.5l-407 407L1.2 430.8z'
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fast',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      'M459.4 .4L445.2 7.8l3.7 7.1 2.1 3.9c15.9 30.5 15.4 66.2 .2 95.6C423.9 92.9 389.5 80 352 80c-42.1 0-80.5 16.3-109.1 42.9c-4.7 4.4-9.2 9.1-13.3 14l18.7 3.1L320 152l16 104H440l33.6 61.1 8.7 15.8c3.5-5 6.8-10.1 9.8-15.5c12.7-22.9 20-49.3 20-77.4c0-45-18.6-85.6-48.4-114.7c19.3-34.6 20.6-77.4 1.6-113.8l-2.1-3.9L459.4 .4zM334.1 138.1l-11.4-1.9-59.1-9.8C288 107.3 318.6 96 352 96c79.5 0 144 64.5 144 144c0 21.6-4.8 42.1-13.3 60.5L454 248.3l-4.6-8.3H440 349.7l-13.9-90.4-1.8-11.4zm-83.7 34.7L172.3 304.4c-18 30.4-47.8 51.9-82.3 59.6L0 384V496v16H16h87.2c139.5 0 266.2-66.5 346.2-172.6L440.9 324C364.2 429.5 240 496 103.2 496H16V396.8l77.4-17.2c38.8-8.6 72.3-32.9 92.6-67.1l81.3-136.9-16.9-2.8z'
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fast',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 104V256v8H248v-8V104 96h16v8z'
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fast',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      'M272 16H112V256c0 44.2 35.8 80 80 80s80-35.8 80-80H200h-8V240h8 72V192H200h-8V176h8 72V128H200h-8V112h8 72V16zm16 96v16 48 16 48 16c0 53-43 96-96 96s-96-43-96-96V16 0h16H272h16V16v96zM48 192v8 56c0 79.5 64.5 144 144 144s144-64.5 144-144V200v-8h16v8 56c0 85.7-67.4 155.6-152 159.8V496h80 8v16h-8H192 104 96V496h8 80V415.8C99.4 411.6 32 341.7 32 256V200v-8H48z'
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fast',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      'M112 400v96H48V400h64zM48 384H32v16 96 16H48h64 16V496 400 384H112 48z'
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fast',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      'M80 8V0H64V8 64H8 0v8V504v8H8 224V496H16V80H64 80h80 16 48V64H176V8 0H160V8 64H80V8zM496 160H480V144 16 0H464 272 256V16 160 496v16h16H480 624h16V496 176 160H624 496zM464 16V160v16h16H624V496H480 272V160 16H464zM328 408h8 64 8v-8V336v-8h-8H336h-8v8 64 8zm16-16V344h48v48H344zM336 72h-8v8 64 8h8 64 8v-8V80 72h-8H336zm8 64V88h48v48H344zM328 280h8 64 8v-8V208v-8h-8H336h-8v8 64 8zm16-16V216h48v48H344zM496 440h64 8v-8V368v-8h-8H496h-8v8 64 8h8zm56-64v48H504V376h48zm-64-64h8 64 8v-8V240v-8h-8H496h-8v8 64 8zm16-16V248h48v48H504zM80 344h64 8v-8V272v-8h-8H80 72v8 64 8h8zm8-64h48v48H88V280zM72 216h8 64 8v-8V144v-8h-8H80 72v8 64 8zm16-16V152h48v48H88z'
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fast',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M112 16v96H16V16h96zM16 0H0V16v96 16H16 56v64c0 39.8 32.2 72 72 72h88V384H176 160v16 96 16h16 96 16V496 400 384H272 232V264h88c39.8 0 72-32.2 72-72V128h40 16V112 16 0H432 336 320V16v96 16h16 40v64c0 30.9-25.1 56-56 56H128c-30.9 0-56-25.1-56-56V128h40 16V112 16 0H112 16zM272 400v96H176V400h96zM336 16h96v96H336V16z'
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fast',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm152-72v64h64 8v16h-8H440v64 8H424v-8V376H360h-8V360h8 64V296v-8h16v8z'
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fast',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm357.7-90.3l-192 192-5.7 5.7L148.7 352l5.7-5.7 192-192 5.7-5.7L363.3 160l-5.7 5.7zM251.3 112l-5.7 5.7-128 128-5.7 5.7L100.7 240l5.7-5.7 128-128 5.7-5.7L251.3 112zM405.7 277.7l-128 128-5.7 5.7L260.7 400l5.7-5.7 128-128 5.7-5.7L411.3 272l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fast',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      'M144 0H128V8 25.4c0 31.8 16.7 61.2 43.9 77.5c22.4 13.4 36.1 37.7 36.1 63.8V184v8h16v-8V166.6c0-29.1-14-56.2-37.2-73.1l.2-.3-6.9-4.1C157.7 75.7 144 51.5 144 25.4V8 0zm0 462.9l-8.9-4.4c-65-32.2-111-97.3-115.5-174.3L17 240H495l-2.6 44.2c-4.5 77-50.5 142.2-115.5 174.3l-8.9 4.4v9.9V496H144V472.9v-9.9zM.9 240l2.7 45.2C8.5 368.1 58 438.2 128 472.9V496v16h16H368h16V496 472.9c70-34.6 119.5-104.8 124.4-187.7l2.7-45.2 .9-16H496 16 0l.9 16zM272 8V0H256V8 25.4c0 31.8 16.7 61.2 43.9 77.5c22.4 13.4 36.1 37.7 36.1 63.8V184v8h16v-8V166.6c0-29.1-14-56.2-37.2-73.1l.2-.3-6.9-4.1C285.7 75.7 272 51.5 272 25.4V8z'
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fast',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      'M391.5 416.9L234.2 102.3c-26 14.6-48 35.5-63.7 60.8L304.6 431.3c5.1 .4 10.2 .7 15.4 .7c25.5 0 49.6-5.4 71.5-15.1zm14.3-7.2c26-14.6 48-35.5 63.7-60.8L335.4 80.7c-5.1-.4-10.2-.7-15.4-.7c-25.5 0-49.6 5.4-71.5 15.1L405.8 409.7zM507.3 298.6l92.6 46.3 12-16.3-25.8-25.8L567 283.7l25.9-7.6L624 267V245l-31.1-9.1L567 228.3l19.1-19.1 25.8-25.8-12-16.3-92.6 46.3c3.1 13.7 4.7 27.9 4.7 42.6s-1.6 28.9-4.7 42.6zM503 314.3c-15 47-47.6 86.2-90 109.7l0 0c-4.7 2.6-9.4 5-14.3 7.2l0 0C374.6 442 348 448 320 448c-2.4 0-4.8 0-7.1-.1l0 0c-6.3-.2-12.5-.8-18.7-1.6l0 0c-74.2-10-135-62.4-157.2-132L35.2 365.2 7 327l22.7-22.7 12.9-12.9-17.5-5.1L0 279V233l25.1-7.3 17.5-5.1L29.7 207.7 7 185l28.2-38.2L137 197.7c15-47 47.6-86.2 90-109.7l0 0c4.7-2.6 9.4-5 14.3-7.2l0 0C265.3 70 292 64 320 64c2.4 0 4.8 0 7.1 .1l0 0c6.3 .2 12.5 .8 18.7 1.6l0 0c74.2 10 135 62.4 157.2 132l101.8-50.9L633 185l-22.7 22.7-12.9 12.9 17.5 5.1L640 233v46l-25.1 7.3-17.5 5.1 12.9 12.9L633 327l-28.2 38.2L503 314.3zM40.1 167.1l-12 16.3 25.8 25.8L73 228.3l-25.9 7.6L16 245v22l31.1 9.1L73 283.7 53.9 302.8 28.1 328.6l12 16.3 92.6-46.3c-3.1-13.7-4.7-27.9-4.7-42.6s1.6-28.9 4.7-42.6L40.1 167.1zM285.3 428.6L161.1 180.2c-11 23-17.1 48.7-17.1 75.8c0 85.3 60.7 156.5 141.3 172.6zM354.6 83.4L478.9 331.8c11-23 17.1-48.7 17.1-75.8c0-85.3-60.7-156.5-141.4-172.6z'
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fast',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      'M40 0H32V8 40v8H48V40 16H464V40v8h16V40 8 0h-8H40zM16 80v8 32 8H32v-8V96H480v24 8h16v-8V88 80h-8H24 16zM54.3 496L17.9 176H494.1l-1.8 16c1.2 0 2.5 0 3.7 0c4.1 0 8.2 .1 12.3 .4l1.9-16.4 1.8-16H495.9 16.1 0l1.8 16L40 512H394.8c-6.9-4.9-13.5-10.2-19.6-16H54.3zM256 208c-97.2 0-176 59.1-176 132s78.8 132 176 132c31.6 0 61.2-6.2 86.9-17.2c-2.6-4.6-5.1-9.4-7.3-14.3C312.3 450.3 285.2 456 256 456c-45.5 0-86-13.8-114.9-35.5S96 370.3 96 340s16.3-58.9 45.1-80.5S210.5 224 256 224c41.2 0 78.3 11.3 106.3 29.5c3.5-4.1 7.2-8.1 11.1-11.8C342.3 220.7 301.1 208 256 208zm25.8 160.6C289 363.8 296 355.4 296 344s-7-19.8-14.2-24.6c-7.3-4.9-16.5-7.4-25.8-7.4s-18.5 2.5-25.8 7.4C223 324.2 216 332.6 216 344s7 19.8 14.2 24.6c7.3 4.9 16.5 7.4 25.8 7.4s18.5-2.5 25.8-7.4zM256 360c-13.3 0-24-7.2-24-16s10.7-16 24-16s24 7.2 24 16s-10.7 16-24 16zM572.5 470.7C551.1 486.6 524.7 496 496 496s-55.1-9.4-76.5-25.3L451.7 432h88.5l32.2 38.7zm12.2-10.3l-34.5-41.4-2.4-2.9H544 448h-3.7l-2.4 2.9-34.5 41.4C383.1 437 368 404.3 368 368c0-70.7 57.3-128 128-128s128 57.3 128 128c0 36.3-15.1 69-39.3 92.3zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fast',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      'M272 96L208 32H16 0V48 464v16H16h1.9H384h64L568 240l8-16H558.1 128L16 448V48H201.4l59.3 59.3 4.7 4.7H272 464v80h16V112 96H464 272zM25.9 464l112-224H550.1l-112 224H384 25.9z'
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fast',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 416c66.8 0 123-47.7 137.3-112H118.7C133 368.3 189.2 416 256 416zM100 288h16.1H395.9 412c-.5 5.4-1.3 10.8-2.4 16C395.1 377 331.8 432 256 432s-139.1-55-153.6-128c-1-5.2-1.8-10.6-2.4-16zm60.4-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fast',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      'M496 238.9l0 1.1H272V16l1.1 0C396.2 16 496 115.8 496 238.9zM273.1 0c-5.7 0-11.4 .2-17.1 .6V240v16h16H511.4c.4-5.6 .6-11.3 .6-17.1C512 107 405 0 273.1 0zM208 288v16h16H461.7C446.2 412.5 352.8 496 240 496C116.3 496 16 395.7 16 272C16 159.2 99.5 65.8 208 50.3V288zm271.5 0h-16H240 224V272 48.6v-16c-5.4 .4-10.7 .9-16 1.6C90.6 49.8 0 150.3 0 272C0 404.5 107.5 512 240 512c121.7 0 222.2-90.6 237.9-208c.7-5.3 1.2-10.6 1.6-16z'
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fast',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      'M115.6 0h-4.7l-2.3 4.1L94.9 29 6.9 189 1 199.8l-1 1.8v2.1V216 408v8H8h96 8v-8V230.4l48-87.3V504v8h8H472h8v-8V143.1l48 87.3V408v8h8 96 8v-8V216 203.7v-2.1l-1-1.8L633.1 189l-88-160L531.4 4.1 529.1 0h-4.7H496 472 448 400 240 192 168 144 115.6zM109 36.7L120.3 16H144h24 24 33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H448h24 24 23.7L531 36.7l88 160 5 9V216 400H544V228.3v-2.1l-1-1.8L479 108.1 464 112V496H176V112l-15-3.9L97 224.5l-1 1.8v2.1V400H16V216 205.7l5-9 88-160zM398.4 16C391 52.5 358.7 80 320 80s-71-27.5-78.4-64H398.4z'
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fast',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      'M405.3 352L192 480H48 32V464 384H8 0v-8V136v-8H8 32V48 32H48 192L405.3 160H456c66.8 0 134.7 38.3 174.4 91.2L634 256l-3.6 4.8C590.7 313.7 522.8 352 456 352H405.3zm-31.1 0H185.4L136 370v94h51.6L374.2 352zM98.7 383.5l-1.3 .5H96 48v80h72V375.8l-21.3 7.7zM374.2 160L187.6 48H136v94l49.4 18H374.2zM48 48v80H96h1.4l1.3 .5 21.3 7.7V48H48zM16 248H184h8v16h-8H16V368H94.6l86.7-31.5 1.3-.5H184 456c59.2 0 120.4-33.1 157.9-80c-37.5-46.9-98.7-80-157.9-80H184h-1.4l-1.3-.5L94.6 144H16V248zm480-32v80H480V216h16z'
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fast',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M182.7 11.7l37.4 57.8L287.5 55l12.1-2.6L297 64.5l-15.6 72.7-15.6-3.4 13-60.6-60.6 13-5.4 1.2-3-4.6L176 30.7 142.3 82.8l-3 4.6-5.4-1.2-60.6-13 13 60.6 1.2 5.4-4.6 3L30.7 176l52.1 33.7 4.6 3-1.2 5.4-13 60.6 60.6-13 3.4 15.6L64.5 297l-12.1 2.6L55 287.5l14.4-67.3L11.7 182.7 1.3 176l10.4-6.7 57.8-37.4L55 64.5 52.5 52.5 64.5 55l67.3 14.4 37.4-57.8L176 1.3l6.7 10.4zM400 101.5l5.2 4.5 224 192 6.1 5.2-10.4 12.1-6.1-5.2L576 273.4V504v8h-8H232h-8v-8V273.4l-42.8 36.7-6.1 5.2-10.4-12.1 6.1-5.2 224-192 5.2-4.5zm0 21.1L240 259.7V496H560V259.7L400 122.5zM344 272H456h8v8V392v8h-8H344h-8v-8V280v-8h8zm8 112h96V288H352v96zM174.1 126.5a47.7 47.7 0 1 0 0 95.3 47.7 47.7 0 1 0 0-95.3zm63.6 47.7a63.6 63.6 0 1 1 -127.3 0 63.6 63.6 0 1 1 127.3 0z'
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fast',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      'M464 0h8 5.5l1.9 5.2L501.5 64H632h8V80h-8H496h-5.5l-1.9-5.2-20.6-55L407.4 171l-2 5H400h-8-5.3l-2.1-4.9L346.7 80H200h-8V64h8H352h5.3l2.1 4.9 36.5 87.7L456.6 5l2-5H464zM280 160h65.3l6.7 16H288V352H624V264c0-48.6-39.4-88-88-88H439.9l6.4-16H536c57.4 0 104 46.6 104 104v96 80 64 8H624v-8V448H16v56 8H0v-8V440 360 72 64H16v8V352H272V168v-8h8zM624 432V368H280 16v64H624zM208 240A64 64 0 1 0 80 240a64 64 0 1 0 128 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z'
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fast',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      'M252.2 99.4c-11.4-14.2-32.8-35.9-52-54.6c-9.3-9-17.9-17.2-24.3-23.2c-4.3 4-9.8 9.2-16.1 15.5c-16.2 16-37.8 38.7-59.3 65.4c-21.6 26.7-42.8 57.2-58.7 88.7C25.9 223 16 254.8 16 284.5C16 403.5 107.5 496 224 496c115.2 0 208-92.5 208-211.5c0-52.7-31.2-108.6-64.8-153c-16.5-21.8-33.1-40.1-45.5-53c-4-4.2-7.6-7.7-10.6-10.7c-2.5 2.1-5.4 4.5-8.3 7c-10.7 9.1-21.2 18.8-25.5 24.4l-12.4 16.2-12.8-16zM0 284.5C0 152 176 0 176 0s49.6 45.5 78.1 77.1c4 4.4 7.6 8.6 10.6 12.3c2.6-3.3 6.5-7.5 11-11.8C290.6 63.3 312 46.6 312 46.6s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM303.4 408.3C279.8 424 254.3 432 225.7 432c-35 0-67.4-11.3-91.3-33.1C110.3 377 96 345.3 96 306.8c0-20.5 6.5-39.1 18-58.6c11.2-19.2 27.8-40.5 48.8-66.2l12.5-15.4L187.7 182c2.9 3.6 24.7 31.3 45.7 58L262 276.4l.8 1 37.9-44 13-15.1 12 15.9c5.1 6.8 8.4 13.5 11.2 18.9l.1 .1c28.6 52.6 16.3 120.4-33.1 154.9l-.3 .2 0 0zM262.3 302.6l-10.1-12.8c-16.7-21.2-49.9-63.4-66.8-84.9c-5.4-6.8-9.1-11.5-10.2-12.9c-3.6 4.4-7 8.7-10.3 12.8c-35.3 44.1-52.9 71.3-52.9 102C112 375.4 162.6 416 225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4l-1.2-2.3c-2.4-4.8-5-9.6-8.7-14.5L302 256.3l-29.2 33.9-10.6 12.4z'
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fast',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      'M352 0V8 72h64 8V88h-8H352v64 8H336v-8V88H272h-8V72h8 64V8 0h16zM464 152v8 48h48 8v16h-8H464v48 8H448v-8V224H400h-8V208h8 48V160v-8h16zM202.4 162.1l50.9 103.1L367 281.7l19.9 2.9-14.4 14.1-82.3 80.2 19.4 113.3L313 512l-17.8-9.4L193.5 449.1 91.7 502.6 73.9 512l3.4-19.9L96.7 378.9 14.4 298.6 0 284.6l19.9-2.9 113.7-16.5 50.9-103.1 8.9-18.1 8.9 18.1zM251 281l-8.3-1.2-3.7-7.5-45.4-92.1L148 272.2l-3.7 7.5L136 281 34.4 295.7l73.5 71.7 6 5.9-1.4 8.3L95.1 482.8 186 435l7.4-3.9 7.4 3.9 90.9 47.8L274.4 381.6l-1.4-8.3 6-5.9 73.5-71.7L251 281z'
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fast',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-384H160h-8v16h8H335.4L153.8 371l-1.8 2.2V384h8H352h8V368h-8H176.6L358.2 141l1.8-2.2V128h-8z'
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fast',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      'M160 160l-16 0-64 0-16 0 0 16 0 16L212.7 340.7 224 352l11.3-11.3L384 192l0-16 0-16-16 0-64 0-16 0 0-16 0-128 0-16L272 0 176 0 160 0l0 16 0 128 0 16zm0 16l16 0 0-16 0-144 96 0 0 144 0 16 16 0 80 0 0 9.4-144 144L80 185.4l0-9.4 80 0zM16 328l0-8L0 320l0 8L0 504c0 4.4 3.6 8 8 8l432 0c4.4 0 8-3.6 8-8l0-176 0-8-16 0 0 8 0 168L16 496l0-168z'
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fast',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      'M560 256c0-68.2-25.1-130.6-66.6-178.3l12.1-10.5C549.4 117.7 576 183.8 576 256s-26.6 138.3-70.5 188.8l-12.1-10.5C534.9 386.6 560 324.2 560 256zM16 256c0 68.2 25.1 130.6 66.6 178.3L70.5 444.8C26.6 394.3 0 328.2 0 256S26.6 117.7 70.5 67.2L82.6 77.7C41.1 125.4 16 187.8 16 256zm80 0c0-48.2 17.7-92.2 47-125.9l12.1 10.5C128.3 171.5 112 211.8 112 256s16.3 84.5 43.1 115.4L143 381.9C113.7 348.2 96 304.2 96 256zm384 0c0 48.2-17.7 92.2-47 125.9l-12.1-10.5C447.7 340.5 464 300.2 464 256s-16.3-84.5-43.1-115.4L433 130.1c29.3 33.7 47 77.7 47 125.9zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fast',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M48 32v8V464H312h8v16h-8H40 32v-8V40 32H48z'
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fast',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      'M172 52a36 36 0 1 1 72 0 36 36 0 1 1 -72 0zm88 0A52 52 0 1 0 156 52a52 52 0 1 0 104 0zM224.2 263.9l3.2 6.4 4.8 9.5 9.5 4.8 33.7 16.8 14.3 7.2 7.2-14.3 14.3-28.6 7.2-14.3L304 244.2l-24.1-12.1-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-5.1 15.2L7.5 260.2l15.2 5.1 30.4 10.1 15.2 5.1 5.1-15.2 5.1-15.2 11.5-34.6 17.9-7.9 18.8-8.3-5.3 19.9-11.7 43.7c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 4.2 15.4 4.2 15.4 15.4-4.2 30.9-8.4 15.4-4.2L283.1 479l-4.2-15.4-24-88-2-7.5-5.2-5.7-52.3-57 11.7-39.9 6.6-22.5 10.5 21zM238.4 376l1 3.7 24 88 4.2 15.4-30.9 8.4-4.2-15.4-22-80.5-1-3.7-2.6-2.9-70.9-77.4c-11.1-12.1-15.2-29-11-44.8l17-63.6 8.6-32.3-30.6 13.6L83.4 200.9l-6.4 2.9-2.2 6.7L63.2 245.1l-5.1 15.2L27.8 250.1l5.1-15.2 16-48 2.2-6.7 6.4-2.9 72-32 4.6-2.1 5 1 80 16 7.7 1.5 3.5 7 35.2 70.5 2.4 4.8 4.8 2.4 24.1 12.1-14.3 28.6-33.7-16.8-4.8-2.4-2.4-4.8L228 235.8l-18.2-36.4-11.5 39L180 300.8l-2.5 8.7 6.1 6.7 52.3 57 2.6 2.9zM93.7 335.6L68.7 398 25.4 441.4 14.1 452.7 2.7 464l11.3 11.3 22.6 22.6L48 509.3l11.3-11.3 11.3-11.3 48-48 4.6-4.6 2.4-6.1 15.7-39.3-12-13.1-18.6 46.4-1.2 3-2.3 2.3-48 48L48 486.6 25.4 464l11.3-11.3L80 409.3l2.3-2.3 1.2-3 21.8-54.6-4.8-5.2c-2.5-2.7-4.8-5.6-7-8.6z'
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fast',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      'M368 496L16 496 16 16l352 0 0 480zM384 16V0L368 0 16 0 0 0 0 16 0 496l0 16H16l352 0h16V496l0-480z'
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fast',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M16 112V400H560V112H16zM0 96H16 560h16v16V400v16H560 16 0V400 112 96zm336 80V336H496V176H336zm-16-16h16H496h16v16V336v16H496 336 320V336 176 160z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fast',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.7-381.7l-5.7-5.7-5.7 5.7-104 104-5.7 5.7L152 251.3l5.7-5.7L248 155.3V376v8h16v-8V155.3l90.3 90.3 5.7 5.7L371.3 240l-5.7-5.7-104-104z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fast',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      'M16 40V32H0v8V200 328v80 64 8H16v-8V416H624v56 8h16v-8V408 328 200v-8h-8H16V40zM624 320H16V208H624V320zM16 336H624v64H16V336z'
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fast',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      'M560 224H464V328v8h-8H432v96H560V224zM416 432V336H392h-8v-8V224H328V328v8h-8H296v96H416zm-136 0V336H256h-8v-8V224H192V328v8h-8H160v96H280zm-136 0V336H120h-8v-8V224H16V432H144zm0-112h16 16V224H128v96h16zm136 0h16 16V224H264v96h16zm136 0h16 16V224H400v96h16zM560 208V80H16V208H120h64 72 64 72 64H560zm16 0v8 8V432v16H560 16 0V432 224v-8-8V80 64H16 560h16V80 208z'
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fast',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      'M368 99.2V144c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2L48 80V48L224 0 400 48V80L368 99.2zm-16 35.6V99.2 90.1l7.8-4.7L384 70.9V60.2L224 16.6 64 60.2V70.9L88.2 85.5 96 90.1v9.1 35.6c19.2 9.7 63.8 25.2 128 25.2s108.8-15.5 128-25.2zM214 466.7L224 480l10-13.3 6.2-8.2L224 431.6l-16.2 26.9 6.2 8.2zM128 352l69.5 92.6 17-28.3-37-51.7-9-12.6H184h80 15.5l-9 12.6-37 51.7 17 28.3L320 352h80l43.2 144 4.8 16H431.3 16.7 0l4.8-16L48 352h80zm96.6 49.4L248.5 368H199.5l23.9 33.4 .6-1 .6 1zM328 368L236.8 489.6 232 496H426.5L388.1 368H328zM216 496l-4.8-6.4L120 368H59.9L21.5 496H216zM96.3 183.3c4.8 2.3 10.1 4.5 15.7 6.7c0 .7 0 1.3 0 2c0 61.9 50.1 112 112 112s112-50.1 112-112c0-.7 0-1.3 0-2c5.7-2.2 10.9-4.4 15.7-6.7c.2 2.9 .3 5.8 .3 8.7c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.9 .1-5.8 .3-8.7zM320 432h8 48 8v16h-8H328h-8V432zM163.6 64.8L224 95.1l60.4-30.2 7.2-3.6 7.2 14.3-7.2 3.6-64 32-3.6 1.8-3.6-1.8-64-32-7.2-3.6 7.2-14.3 7.2 3.6z'
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fast',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      'M192 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM137.3 209.8C68.5 220.7 16 280.2 16 352c0 79.5 64.5 144 144 144c66.4 0 122.4-45 139-106.2l15.4 4.2C296 462 233.8 512 160 512C71.6 512 0 440.4 0 352c0-79.8 58.4-145.9 134.8-158l2.5 15.8zM336 240H289 272.6l3.2 16 6.4 32H384h22.2l7.8 20.8 37.1 99 10.7-3.6 15.2-5.1 15.2-5.1 5.1 15.2 10.2 30.3 5.1 15.2-15.2 5.1-15.2 5.1-40 13.5-29.3 9.9-10.9-29L361.8 352H256.6c-.4 0-.8 0-1.3 0H224 197.8l-5.1-25.7-32-160L156.2 144 153 128h16.3H192h32 26.2l5.1 25.7 4.5 22.3H336h16 16v16 32 16H352 336zm48 64H282.2 269.1l-2.6-12.9-9.6-48L253.1 224h19.5H336h16V192H336 259.8 246.7l-2.6-12.9-4.5-22.3L237.1 144H224 192 172.5l3.8 19.1 32 160 2.6 12.9H224h31.3 .3l0 0c.1 0 .1 0 .2 0c.1 0 .3 0 .4 0l.3 0v0H361.8h11.1l3.9 10.4L417 453.6l5.4 14.5 14.7-5 40-13.5 15.2-5.1L482 414.2l-15.2 5.1-10.7 3.6-14.7 5-5.4-14.5-37.1-99L395.1 304H384z'
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fast',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      'M296 8V0H280V8 45.3l-1.3 2.2L9.6 496 0 512H18.7 557.3 576l-9.6-16L417.2 247.4 405.6 259 547.7 496H28.3L288 63.1l92.1 153.5-52.9 52.9C316.4 261 302.8 256 288 256c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-14.8-5-28.4-13.4-39.2l50-50 11.7-11.7L541.7 77.7l5.7-5.7L536 60.7l-5.7 5.7L391.8 204.9 297.3 47.5 296 45.3V8zm40 312a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fast',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM264 144H248v8 80H168h-8v16h8 80v80 8h16v-8V248h80 8V232h-8H264V152v-8z'
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fast',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zM229.7 341.7l120-120 5.7-5.7L344 204.7l-5.7 5.7L224 324.7 109.7 210.3l-5.7-5.7L92.7 216l5.7 5.7 120 120 5.7 5.7 5.7-5.7z'
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fast',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      'M16 48V272H176V48H16zM0 32H16 176h16V48 272v16H176 16 0V272 48 32zM272 240V464H432V240H272zm-16-16h16H432h16v16V464v16H432 272 256V464 240 224zM176 336H16V464H176V336zM16 320H176h16v16V464v16H176 16 0V464 336 320H16zM272 48V176H432V48H272zM256 32h16H432h16V48 176v16H432 272 256V176 48 32z'
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fast',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      'M512 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM347.3 16l-5.7 5.7-320 320L16 347.3 4.7 336l5.7-5.7 320-320L336 4.7 347.3 16zM208 304c-14.7 0-28.6-3.3-41-9.2c-14.5 20.7-23 46-23 73.2c0 17.1 3.4 33.4 9.4 48.3L232 368l40 40-48.3 78.6c14.9 6.1 31.2 9.4 48.3 9.4c27.2 0 52.4-8.5 73.2-23c-5.9-12.4-9.2-26.4-9.2-41c0-53 43-96 96-96c6.9 0 13.7 .7 20.2 2.1C459.7 323.1 464 306 464 288c0-28-10.3-53.7-27.3-73.3l-71 71-5.7 5.7L348.7 280l5.7-5.7 71-71c-19.7-17-45.3-27.3-73.3-27.3c-18 0-35.1 4.3-50.1 11.8c1.4 6.5 2.1 13.3 2.1 20.2c0 53-43 96-96 96zM448 203.3c19.9 22.6 32 52.2 32 84.7c0 25.4-7.4 49.1-20.2 69c-8.7-3.2-18.1-5-27.8-5c-44.2 0-80 35.8-80 80c0 16.7 5.1 32.3 13.9 45.1c-25.2 21.7-58 34.9-93.9 34.9c-20.2 0-39.4-4.2-56.8-11.6L208 512l-11.6-11.6-56.7-56.7L128 432l11.6-7.2C132.2 407.4 128 388.2 128 368c0-35.9 13.1-68.7 34.9-93.9c12.8 8.8 28.4 13.9 45.1 13.9c44.2 0 80-35.8 80-80c0-9.8-1.8-19.2-5-27.8c19.9-12.8 43.6-20.2 69-20.2c32.5 0 62.1 12.1 84.7 32L618.3 10.3 624 4.7 635.3 16l-5.7 5.7L448 203.3zm-243 283l46.8-76-22.1-22.1-76 46.8L205 486.4z'
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fast',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      'M263 41L0 304v96L112 512h96L471 249c24.2-11.6 41-36.3 41-65c0-11.5-2.7-22.4-7.5-32c4.8-9.6 7.5-20.5 7.5-32c0-32.5-21.5-60-51.1-68.9C452 21.5 424.5 0 392 0c-11.5 0-22.4 2.7-32 7.5C350.4 2.7 339.5 0 328 0c-28.7 0-53.4 16.8-65 41zm14.5 6.7C286.6 28.9 305.8 16 328 16c10.2 0 19.8 2.7 28 7.5l4 2.3 4-2.3c8.2-4.8 17.8-7.5 28-7.5c26.6 0 48.9 18.5 54.6 43.4l1.1 4.9 4.9 1.1c24.9 5.7 43.4 28 43.4 54.6c0 10.2-2.7 19.8-7.5 28l-2.3 4 2.3 4c4.8 8.2 7.5 17.8 7.5 28c0 22.2-12.9 41.4-31.7 50.5C432.3 212.7 393.6 200 352 200c-15.5 0-30.6 1.8-45.1 5.1c3.3-14.5 5.1-29.6 5.1-45.1c0-41.6-12.7-80.3-34.5-112.3zM16 393.4V335.5C44.5 351.1 77.2 360 112 360c88.5 0 163.5-57.5 189.9-137.1c15.9-4.5 32.7-6.9 50.1-6.9c36.8 0 71.1 10.8 99.9 29.5L201.4 496H118.6L16 393.4zm0-82.7L266.5 60.1C285.2 88.9 296 123.2 296 160c0 18.8-2.8 37-8.1 54.1C264.8 289.3 194.8 344 112 344c-35.2 0-68.1-9.9-96-27v-6.4z'
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fast',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM152 248H360V232H152v16z'
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fast',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      'M232 0h-8V16h8 64V208H232h-8v16h8 72 72 5.4c.8-.7 1.7-1.3 2.6-2V208h-8H312V8 0h-8H232zM216 288h-8v8V504v8h8H360h8v-8-3.8c-5.7-5.5-11-11.4-16-17.6V496H224V304h99.4c2-5.5 4.3-10.8 6.8-16H216zM8 288H0v16H8 72V496H8 0v16H8 80h72 8V496h-8H88V296v-8H80 8zM16 0V8 216v8h8H168h8v-8V8 0h-8H24 16zM32 16H160V208H32V16zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fast',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      'M432 48H16V464H324.1c4 5.6 8.3 10.9 12.9 16H16 0V464 48 32H16 432h16V48v74.1l-16 10V48zm-48 64v56.8c-5.3 4.8-10.7 9.9-16 15.3V112H80v80H360.5c-4.8 5.1-9.4 10.5-14 16H80 64V192 112 96H80 368h16v16zM120 256v24H96V256h24zm40 0h24v24H160V256zm88 0v24H224V256h24zm252.7-43.2L512 224.2l11.3-11.3L544 192.2c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192l52.7 52.7zM576 422.6c0 18.2-5.8 35.1-15.7 49.2C598.7 445.9 624 402 624 352.2c0-20.2-14.9-79.7-79.2-138.1l-21.4 21.4L512 246.8l-11.3-11.3L446 180.7c-19.3 13.6-44.2 35.1-65.4 61.8C355 274.5 336 312.4 336 352.2c0 49.8 25.3 93.7 63.7 119.6c-9.9-14.1-15.7-31-15.7-49.2c0-70.4 96-134.4 96-134.4s96 64 96 134.4zm-96 73.6c45.2 0 80-34 80-73.6c0-28.5-20-58.2-43.5-82.5c-11.4-11.8-22.8-21.5-31.4-28.3c-1.8-1.5-3.5-2.8-5.1-3.9c-1.5 1.2-3.2 2.5-5.1 3.9c-8.6 6.8-20 16.5-31.4 28.3C420 364.4 400 394 400 422.6c0 39.6 34.8 73.6 80 73.6z'
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fast',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      'M544 272V224l-112.7-3.9-16.5-.6 4.7-15.8 52.9-178L480 0 458.5 16.1 291.2 141.6l13 10.3 146.6-110L399.4 215l-2.9 9.7 13.6 10.7 4.1 .1L528 239.5V264l-41.9 31.4 13 10.3L544 272zM172.1 230.9L160 240v48l88.2 3L227 274.3l-51-1.8V248l9.1-6.8-13-10.3zm109.7 86.6L231.7 486.3 224 512l21.5-16.1L379.9 395l-13-10.3L253.1 470.2l42.2-141.9-13.5-10.7zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fast',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      'M386.3 85.7L380.7 80 392 68.7l5.7 5.7 176 176 5.7 5.7-5.7 5.7-176 176-5.7 5.7L380.7 432l5.7-5.7L556.7 256 386.3 85.7zm-196.6-.1L27.1 256 189.8 426.5l5.5 5.8-11.6 11-5.5-5.8-168-176L4.9 256l5.3-5.5 168-176 5.5-5.8 11.6 11-5.5 5.8z'
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fast',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM118.7 304H393.3C379 368.3 322.8 416 256 416s-123-47.7-137.3-112zm-16.3 0c14.5 73 77.8 128 153.6 128s139.1-55 153.6-128c1-5.2 1.8-10.6 2.4-16H395.9 116.1 100c.5 5.4 1.3 10.8 2.4 16zM379.6 141.3l-7.2 3.6-80 40L278.1 192l14.3 7.2 80 40 7.2 3.6 3.6-7.1 0 0 3.6-7.2-7.2-3.6L313.9 192l65.7-32.8 7.2-3.6-3.6-7.1 0 0 0 0-3.6-7.1zm-240 3.6l-7.2-3.6-7.2 14.3 7.2 3.6L198.1 192l-65.7 32.8-7.2 3.6 7.2 14.3 7.2-3.6 80-40 14.3-7.2-14.3-7.2-80-40z'
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fast',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      'M304 16H80V272H304V16zM80 0H304h16V16 272v16H304 80 64V272 16 0H80zM560 112H400V272H560V112zM400 96H560h16v16V272v16H560 400 384V272 112 96h16zM0 352H8 80h8 8H312h8 8H544h8 8 72 8v16h-8H560V496h72 8v16h-8H560h-8-8H328h-8-8H96 88 80 8 0V496H8 80V368H8 0V352zM96 496H312V368H96V496zm232 0H544V368H328V496z'
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fast',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      'M0 80H448V96H0V80zM0 240H320v16H0V240zM192 400v16H0V400H192z'
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fast',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      'M64 0h8H234.6C334.8 0 416 81.2 416 181.4c0 10.2-.9 20.4-2.6 30.4L383.9 385.3l-15.8-2.7 29.5-173.6c1.6-9.2 2.3-18.4 2.3-27.7C400 90 326 16 234.6 16H80V35.1l27.6 13.8 9.9 5-7.8 7.8L80 91.3l-.4 152.1 51.5 36.8 112-86.6 6.3-4.9 9.8 12.7-6.3 4.9L80 339.9l0 2.6L80 368v16H64V368l0-25.4 0-5.1 0-1.1 0-.3 0-.1 0 0v0 0 0l0-3.9 3.1-2.4 50.7-39.2L66.9 254.1l-3.4-2.4 0-4.1L64 88l0-3.3 2.3-2.3L90.5 58.2l-22.1-11L64 44.9V40 8 0zm64 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM32 496H416V470.6L377.4 432H70.6L32 470.6V496zm-16 0V464l48-48H384l48 48v32 16H416 32 16V496z'
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fast',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      'M104 0C46.6 0 0 46.6 0 104V504v8H8 128v-8-8H16V192H152.3l7-16H16V104c0-48.6 39.4-88 88-88c47.7 0 86.6 38 88 85.4l2.1-4.7 13.3-5.2C201.1 40 157.2 0 104 0zM370.9 64.5L368 63.4l-2.9 1.1-144 56-3.1 1.2-1.3 3-56 128-.7 1.5V256 504v8h8H568h8v-8V256v-1.7l-.7-1.5-56-128-1.3-3-3.1-1.2-144-56zM176 257.7l54-123.4L368 80.6l138 53.7 54 123.4V496H448V392v-8h-8H296h-8v8V496H176V257.7zM432 496H304V400H432v96zM320 192H304v16 96 16h16 96 16V304 208 192H416 320zm96 16v96H320V208h96z'
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fast',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM104 144H224 344h8v16h-8H232V392v8H216v-8V160H104 96V144h8z'
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fast',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      'M141 1.8l115 92 115-92 10 12.5L278.8 96H496h16v16V496v16H496 16 0V496 112 96H16 233.2L131 14.2 141 1.8zM256 112H16V496H496V112H256zm112 64H80V432H368V176zM80 160H368h16v16V432v16H368 80 64V432 176 160H80zm360 48a8 8 0 1 0 -16 0 8 8 0 1 0 16 0zm-32 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a8 8 0 1 0 0-16 8 8 0 1 0 0 16zm0-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fast',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      'M43.3 40.7L36 37.4 29.4 52l7.3 3.3L548.7 288H16 0v16V464v16H16 560h16V464 416v-8V304 288c0-3.1-1.8-6-4.7-7.3l-528-240zM560 304V408v8 48H16V304H560zM208 384a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 400a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fast',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      'M160 0h8H312h8V8v8 3.9l-3.1 2.4L181 128H312h8v16h-8H168h-8v-8-8-3.9l3.1-2.4L299 16H168h-8V0zM0 256H8 216h8v8 8 3.1l-2.1 2.3L18.9 496H216h8v16h-8H8 0v-8-8-3.1l2.1-2.3L205.1 272H8 0V256zm296-32H440h8v8 8 3.3l-2.3 2.3L307.3 384H440h8v16h-8H296h-8v-8-8-3.3l2.3-2.3L428.7 240H296h-8V224h8z'
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fast',
    iconName: 'block-question',
    icon: [
      448,
      512,
      [],
      'e3dd',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM80 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm272 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm272 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM136 192c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L232 286.9V312v8H216v-8V282.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H192c-22.1 0-40 17.9-40 40l0 6.5-16 0V192zm72 152h32v32H208V344z'
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fast',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      'M64 448V428 84 64L80 76 306.7 246 320 256l-13.3 10L80 436 64 448zM293.3 256L80 96V416L293.3 256zM432 72V440v8H416v-8V72 64h16v8zm144 0V440v8H560v-8V72 64h16v8z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fast',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M472 24V72h48 8V88h-8H472v48 8H456v-8V88H408h-8V72h8 48V24 16h16v8zM39.4 256L288 366.5 536.6 256 288 145.5 39.4 256zM288 128L556.3 247.2 576 256l-19.7 8.8L288 384 19.7 264.8 0 256l19.7-8.8L288 128zM104.6 337.5l19.7 8.8L39.4 384 288 494.5 536.6 384l-84.9-37.7 19.7-8.8 84.9 37.7L576 384l-19.7 8.8L288 512 19.7 392.8 0 384l19.7-8.8 84.9-37.7z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fast',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M410.9 32l-2.1 4.6L321.9 224h17.6l22.3-48H470.2l22.3 48h17.6L423.3 36.6 421.1 32H410.9zm51.9 128H369.2L416 59l46.8 101zM165.7 42.3L160 36.7l-5.7 5.7-112 112L36.7 160 48 171.3l5.7-5.7L152 67.3V472v8h16v-8V67.3l98.3 98.3 5.7 5.7L283.3 160l-5.7-5.7-112-112zM344 288h-8v16h8H477.2L338.1 458.6l-2.1 2.3V464v8 8h8H488h8V464h-8H354.8L493.9 309.4l2.1-2.3V304v-8-8h-8H344z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fast',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zM623.1 512H640l-5.3-16L576 320H422.4l4.9 16H564.5l53.3 160H476.6l2 6.6 2.9 9.4H623.1zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c2.5 4.8 4.8 9.8 6.9 14.9C388.9 55.7 409.6 48 432 48c53 0 96 43 96 96s-43 96-96 96c-27.7 0-52.7-11.8-70.2-30.6c-2.8 4.7-5.8 9.3-9.1 13.7C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fast',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      'M128 416v80H16V416H128zm0-304V400H16V112H128zm0-96V96H16V16H128zM144 0H128 16 0V16 96v8 8V400v8 8 80 16H16 128h16H256h16V496 416v-8-8V170.9l59.7 222.6 2.1 7.7 2.1 7.7 23.5 87.5 4.1 15.5 15.5-4.1 116.7-31.3 15.5-4.1L506.9 457l-23.5-87.5-2.1-7.7-2.1-7.7L416.2 118.5l-2.1-7.7L412 103 388.6 15.5 384.4 0 369 4.1l-97 26V16 0H256 144zM272 46.7L373.1 19.6l23.5 87.5L279.9 138.4 272 109.1V104 96 46.7zM256 496H144V416H256v80zm0-400H144V16H256V96zm0 304H144V112H256V400zm118.7 92.4l-23.5-87.5L468 373.6l23.5 87.5L374.7 492.4zm-27.6-103L284 153.9l116.7-31.3 63.1 235.5L347.1 389.4z'
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fast',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      'M297.1 17.1L374.6 164l163.6 28.3 19.1 3.3-13.5 13.9L428 328.5l23.7 164.8 2.7 18.7-17.3-7.7L288.1 438.2 139 504.3 121.7 512l2.7-18.7 23.7-164.8L32.4 209.5 18.9 195.6 38 192.3 201.6 164 279 17.1l9-17.1 9 17.1zm74.7 162.6l-7.8-1.3-3.7-7L288.1 34.3 215.7 171.4l-3.7 7-7.8 1.3L51.5 206.2 159.6 317.4 165 323l-1.1 7.8L141.7 485.6l139.9-62.1 6.5-2.9 6.5 2.9 139.9 62.1L412.2 330.8l-1.1-7.8 5.5-5.6L524.6 206.2 371.8 179.7zM296 152v8V296v8H280v-8V160v-8h16zM272 336h32v32H272V336z'
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fast',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      'M256 16c132.5 0 240 107.5 240 240l0 8 16 0 0-8C512 114.6 397.4 0 256 0S0 114.6 0 256l0 8 16 0 0-8C16 123.5 123.5 16 256 16zM390.1 314.8l-128-152-6.1-7.3-6.1 7.3-128 152-5.2 6.1L129 331.3l5.2-6.1L248 189.9 248 504l0 8 16 0 0-8 0-314.1L377.9 325.2l5.2 6.1L395.3 321l-5.2-6.1z'
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fast',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      'M416 176c0-36-11.9-69.3-32-96c-4.2-5.5-8.7-10.8-13.5-15.8l-.2-.2c-29-29.6-69.5-48-114.3-48s-85.2 18.4-114.3 48c-4.6 4.6-8.8 9.6-12.8 14.7L128 80c-20.1 26.7-32 60-32 96c0 88.4 71.6 160 160 160s160-71.6 160-160zM403.5 80c18 27.6 28.5 60.6 28.5 96c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-35.4 10.5-68.4 28.5-96H16V496H496V80H403.5zM120.2 64C152.5 24.9 201.3 0 256 0s103.5 24.9 135.8 64H496h16V80 496v16H496 16 0V496 80 64H16 120.2zM304 224c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.4 0 8.7 .6 12.8 1.7l36-77.1 3.4-7.2 14.5 6.8-3.4 7.2-36 77.1c12.5 8.7 20.7 23.1 20.7 39.5zm-48 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fast',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      'M96 0H88V8 232v8 7.4L18.8 305.9 16 308.3V312v53.7c0 48.8 26.2 93.9 68.5 118.1l18 10.3C123.1 505.8 146.3 512 170 512H312c57.4 0 104-46.6 104-104V392 304 256v-8h-8H352V224v-8h-8H280V192v-8h-8H192V8 0h-8H96zM88 268.3V344v8h16v-8V254.8v-3.7V240v-8V16h72V192v8h8 80v24 8h8 64v24 8h8 56v40 88 16c0 48.6-39.4 88-88 88H170c-20.9 0-41.4-5.4-59.5-15.8l-18-10.3C55.1 448.5 32 408.8 32 365.7v-50l56-47.4z'
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fast',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      'M112 80c0-44.2 35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c44.2 0 80 35.8 80 80c0 26.2-12.6 49.4-32 64c19.4 14.6 32 37.8 32 64c0 44.2-35.8 80-80 80c-21.8 0-41.6-8.7-56-22.9V422.6C291.8 362 353 320 424 320h72 16v16c0 97.2-78.8 176-176 176H264 248 176C78.8 512 0 433.2 0 336V320H16 88c71 0 132.2 42 160 102.6V265.1c-14.4 14.1-34.2 22.9-56 22.9c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64c-19.4-14.6-32-37.8-32-64zm80-64c-35.3 0-64 28.7-64 64c0 24.8 14.1 46.2 34.7 56.9l13.7 7.1-13.7 7.1C142.1 161.8 128 183.2 128 208c0 35.3 28.7 64 64 64c24.8 0 46.2-14.1 56.9-34.7l7.1-13.7 7.1 13.7C273.8 257.9 295.2 272 320 272c35.3 0 64-28.7 64-64c0-24.8-14.1-46.2-34.7-56.9L335.6 144l13.7-7.1C369.9 126.2 384 104.8 384 80c0-35.3-28.7-64-64-64c-24.8 0-46.2 14.1-56.9 34.7L256 64.4l-7.1-13.7C238.2 30.1 216.8 16 192 16zm56 480c0-88.4-71.6-160-160-160H16c0 88.4 71.6 160 160 160h72zm88 0c88.4 0 160-71.6 160-160H424c-88.4 0-160 71.6-160 160h72zM261.7 98.3l40 40 5.7 5.7-5.7 5.7-40 40-5.7 5.7-5.7-5.7-40-40-5.7-5.7 5.7-5.7 40-40 5.7-5.7 5.7 5.7zM256 172.7L284.7 144 256 115.3 227.3 144 256 172.7z'
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fast',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM376 288h-8H176h-8V272h8H368h8v16zM272 416H80 72V400h8H272h8v16h-8zM120 264H72v48h48V264zM72 248h48 16v16 48 16H120 72 56V312 264 248H72zM328 392v48h48V392H328zm-16-16h16 48 16v16 48 16H376 328 312V440 392 376z'
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fast',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      'M352 48l144 0 0 117.5c5.1-1.8 10.5-3.2 16-4.1L512 48l0-16-16 0L16 32 0 32 0 48 0 464l0 16 16 0 368 0 0-16-32 0 0-128 32 0 0-16-32 0 0-128 104.4 0c5.4-6.1 11.7-11.5 18.5-16L352 176l0-128zm-16 0l0 128-160 0 0-128 160 0zM160 48l0 128L16 176 16 48l144 0zM16 192l144 0 0 128L16 320l0-128zm0 144l144 0 0 128L16 464l0-128zM176 464l0-128 160 0 0 128-160 0zm0-144l0-128 160 0 0 128-160 0zM528 208c26.5 0 48 21.5 48 48l0 64-96 0 0-64c0-26.5 21.5-48 48-48zm-64 48l0 64-32 0-16 0 0 16 0 160 0 16 16 0 192 0 16 0 0-16 0-160 0-16-16 0-32 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80l32 0 16 0 96 0 16 0 32 0 0 160-192 0 0-160z'
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fast',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      'M16 16H208V168v8h8H368V496H16V16zm208 6.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM104 224H96v8 80 80 8h16v-8V320h52.7l64 64-42.3 42.3-5.7 5.7L192 443.3l5.7-5.7L240 395.3l42.3 42.3 5.7 5.7L299.3 432l-5.7-5.7L251.3 384l42.3-42.3 5.7-5.7L288 324.7l-5.7 5.7L240 372.7l-53.8-53.8C207.8 314.2 224 295 224 272c0-26.5-21.5-48-48-48H104zm72 80H112V240h64c17.7 0 32 14.3 32 32s-14.3 32-32 32z'
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fast',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      'M8 32H0V48H8 632h8V32h-8H8zM8 80H0V96H8 632h8V80h-8H8zM8 416H0v16H8 632h8V416h-8H8zm0 48H0v16H8 632h8V464h-8H8zM21.7 170.3L16 164.7 4.7 176l5.7 5.7L84.7 256 10.3 330.3 4.7 336 16 347.3l5.7-5.7L96 267.3l74.3 74.3 5.7 5.7L187.3 336l-5.7-5.7L107.3 256l74.3-74.3 5.7-5.7L176 164.7l-5.7 5.7L96 244.7 21.7 170.3zm224 0l-5.7-5.7L228.7 176l5.7 5.7L308.7 256l-74.3 74.3-5.7 5.7L240 347.3l5.7-5.7L320 267.3l74.3 74.3 5.7 5.7L411.3 336l-5.7-5.7L331.3 256l74.3-74.3 5.7-5.7L400 164.7l-5.7 5.7L320 244.7l-74.3-74.3zm224 0l-5.7-5.7L452.7 176l5.7 5.7L532.7 256l-74.3 74.3-5.7 5.7L464 347.3l5.7-5.7L544 267.3l74.3 74.3 5.7 5.7L635.3 336l-5.7-5.7L555.3 256l74.3-74.3 5.7-5.7L624 164.7l-5.7 5.7L544 244.7l-74.3-74.3z'
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fast',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      'M200 72a56 56 0 1 1 112 0A56 56 0 1 1 200 72zm101.3 56C317.6 114.8 328 94.6 328 72c0-39.8-32.2-72-72-72s-72 32.2-72 72c0 22.6 10.4 42.8 26.7 56H88L3.7 496 0 512H16.4 495.6 512l-3.7-16L424 128H301.3zM256 144H411.3l80.7 352H20.1l80.7-352H256z'
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fast',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M264 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm29.9 39.6l75.8 151.6 8.9 17.7L394 268.5l122.2-97.7c1.1 .6 2.3 1.2 3.5 1.8L466.6 464H109.4l-53-291.5c1.2-.5 2.3-1.1 3.5-1.8L182 268.5l15.5 12.4 8.9-17.7 75.8-151.6c1.9 .3 3.9 .4 5.9 .4s4-.1 5.9-.4zM504 160L396.8 245.8 384 256l-7.3-14.6L309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L199.3 241.4 192 256l-12.8-10.2L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40l.7 0L96 480H480l55.3-304c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24zM40 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm472 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fast',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      'M0 72V64H16v8V440v8H0v-8V72zM320 216H304V200 112h-9.4l-144 144 144 144H304V312 296h16l304 0V216l-304 0zM139.3 244.7L288 96h16 16v16 72 16h16l288 0h16v16 80 16H624l-288 0H320v16 72 16H304 288L139.3 267.3 128 256l11.3-11.3z'
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fast',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      'M168 8V0H152V8 64H80 64V80v72H8 0v16H8 64v80H8 0v16H8 64v80H8 0v16H8 64v72 16H80h72v56 8h16v-8V448h80v56 8h16v-8V448h80v56 8h16v-8V448h72 16V432 360h56 8V344h-8H448V264h56 8V248h-8H448V168h56 8V152h-8H448V80 64H432 360V8 0H344V8 64H264V8 0H248V8 64H168V8zm80 72h16 80 16 72v72 16 80 16 80 16 72H360 344 264 248 168 152 80V360 344 264 248 168 152 80h72 16 80zm120 64V368H144V144H368zM144 128H128v16V368v16h16H368h16V368 144 128H368 144z'
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fast',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      'M416 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM104.9 261.6l7.1-4.8v-8.5V16H240V248.3v8.5l7.1 4.8c34.3 23 56.9 62.1 56.9 106.5c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-44.4 22.6-83.5 56.9-106.5zM256 0H240 112 96V16 248.3C57.4 274.1 32 318.1 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-49.9-25.4-93.9-64-119.8V16 0zM128 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-32.6-24.4-59.6-56-63.5V72 64H168v8V304.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fast',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM153.8 206.5l5.7 5.7L224 276.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L235.3 288l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L224 299.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L212.7 288l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fast',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zM256 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM187.5 336l-21.3 64H345.8l-21.3-64H187.5zM336 320l26.7 80 5.3 16H351.1 160.9 144l5.3-16L176 320H336z'
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fast',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      'M213.9 231.2l-59.3-88.9L145.1 128H128 80 64 48v16 16V274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 8 48 4 24 .5 2.7h48.7 16.2l-2.2-13.3-.5-2.7-3.5-21.3-8-48-8-48-1.7-10.1-7.3-7.3L144 306.7V270.5 241.7l16 24 5.4 8.1 4.7 7.1 7.6 3.8 65.7 32.8 14.3 7.2L260 320H378.3l2.3 4.6 14.3-7.2 65.7-32.8 7.6-3.8 4.7-7.1 5.4-8.1 16-24v28.8 36.2l-54.6 54.6-7.3 7.3-1.7 10.1-8 48-8 48L411.2 496l-.5 2.7L408.5 512h16.2 48.7l.5-2.7 4-24 8-48 6.3-37.9 56.7-56.7L571.6 320c12-12 18.7-28.3 18.7-45.3V160 144 128h-16-16-48H493.2l-9.5 14.3-59.3 88.9-8.4 4.2V136v-8h-8H232h-8v8V236.2l-10.1-5zm26.1 13V144H400v99.4l-33.7 16.8L352 267.4l7.2 14.3L370.3 304H268l11.2-22.3 7.2-14.3L272 260.2l-32-16zm24.8 30.3l-14.3 28.6-65.7-32.8-3.8-1.9-2.4-3.5-21.4-32.1-29.3-44v52.8 65.1 6.6l4.7 4.7 54.6 54.6 3.6 3.6 .8 5.1 8 48 8 48 3.1 18.6H178.5l-2.2-13.4-8-48-6.3-37.9-.8-5.1-3.6-3.6-56.7-56.7L78.1 308.7c-9-9-14.1-21.2-14.1-33.9V160 144H80h48 8.6l4.7 7.1 59.3 88.9 2.4 3.5 3.8 1.9 58.1 29zM128 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM373.5 274.5l58.1-29 3.8-1.9 2.4-3.5L497 151.1l4.7-7.1h8.6 48 16v16V274.7c0 12.7-5.1 24.9-14.1 33.9l-22.6 22.6-56.8 56.7-3.6 3.6-.8 5.1-6.3 37.9-8 48L459.9 496H427.4l3.1-18.6 8-48 8-48 .8-5.1 3.6-3.6 54.6-54.6 4.7-4.7v-6.6V241.7 188.8l-29.3 44-21.4 32.1-2.4 3.5-3.8 1.9-65.7 32.8-14.3-28.6zM510.3 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-48 32a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM9.5 486.3L6.4 496 1.3 512H18.1 68.5l2-6.3 33-103.7L90.8 389.3 56.8 496H23.2l1.5-4.9L65.3 363.8 52.5 351 9.5 486.3zM588.3 351l-12.7 12.7 40.5 127.4 1.5 4.9H584l-34-106.7L537.3 402l33 103.7 2 6.3h50.4 16.8l-5.1-16-3.1-9.7L588.3 351z'
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fast',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256v-4.3l-3.6-2.4-96-64-6.7-4.4-8.9 13.3 6.7 4.4L248 260.3V408v8h16v-8z'
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fast',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      'M564.7 8.9c-11.7 1.3-22.9 4.2-33.4 8.4C482.5 36.7 448 84.3 448 140c0 72.9 59.1 132 132 132c8.7 0 17.2-.8 25.5-2.5c11.4-2.2 22.4-6 32.5-10.9c-7.5 9.5-16 18.2-25.4 25.8C585.2 306.7 550.1 320 512 320c-4 0-7.9-.1-11.8-.4c-11.2-9.8-24.2-17.7-38.4-23.1l-.3-1.5c15.7 5.9 32.7 9.1 50.4 9.1c23.8 0 46.3-5.8 66.1-16C497.2 287 432 221.1 432 140c0-51.5 26.3-96.8 66.2-123.3C425.1 23.6 368 85.1 368 160c0 12.9 1.7 25.5 4.9 37.4c-5.6-1.7-11.5-3-17.4-3.9c-2.3-10.8-3.5-22-3.5-33.5C352 71.6 423.6 0 512 0c5.8 0 11.6 .3 17.3 .9c12.3 1.3 24.1 4 35.4 8zM261 259.9C278.6 238 305.6 224 335.9 224c53 0 96 43 96 96l0 1.3c45.4 7.6 80 47.1 80 94.6v80 16h-16-80H144l-64 0H64l0-16 0-64c0-37.1 25.3-68.4 59.7-77.4c2-.5 4.1-1 6.2-1.4c-.5-2.1-.8-4.1-1.1-6.2c-.5-3.6-.8-7.3-.8-11c0-44.2 35.8-80 80-80c13.2 0 25.7 3.2 36.7 8.9c3.2 1.6 6.2 3.5 9.1 5.5c2.2-3.6 4.6-7.1 7.3-10.4zM80 495.9l64 0H415.9h80v-80c0-39.6-28.8-72.5-66.6-78.9l-13.4-2.3 .1-13.6 0-1.3c0-44.1-35.8-79.9-80-79.9c-29 0-54.5 15.5-68.5 38.7l-8.8 14.6-14-9.8c-10.4-7.3-23-11.5-36.6-11.5c-35.3 0-64 28.6-64 64c0 4.8 .5 9.4 1.5 13.8L149 366 132.7 369c-29.9 5.3-52.7 31.5-52.7 63v64zM233.4 144.1H222.9l-4.2-9.6c-9.9-22.6-32.5-38.4-58.7-38.4c-30.9 0-56.8 22-62.7 51.2l-2.6 12.8H81.7 72.1c-30.9 0-56 25.1-56 56v56h56H88l0 0h28c-3.5 5-6.6 10.4-9.3 16H72.1l0 0h-56H.1v-16-56c0-39.8 32.2-72 72-72h9.6c7.4-36.5 39.7-64 78.4-64c32.8 0 61 19.7 73.3 48H256c35.3 0 64 28.6 64 64v.9c-5.4 .7-10.8 1.7-16 3.1v-3.9c0-26.5-21.5-48-48-48H233.4z'
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fast',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c35.3 0 64 28.7 64 64c0 22.3-11.4 41.9-28.7 53.4C325.5 256.1 344 281.9 344 312c0 39.8-32.2 72-72 72H240c-39.8 0-72-32.2-72-72c0-30.1 18.5-55.9 44.7-66.6C195.4 233.9 184 214.3 184 192c0-35.3 28.7-64 64-64h16zM248 240c0 0 0 0 0 0h16c0 0 0 0 0 0c26.5 0 48-21.5 48-48c0-26.5-21.5-48-48-48H248c-26.5 0-48 21.5-48 48c0 26.5 21.5 48 48 48zm16 16H248h-8c-30.9 0-56 25.1-56 56s25.1 56 56 56h32c30.9 0 56-25.1 56-56s-25.1-56-56-56h-8z'
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fast',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l3.5 3.5h4.6 79.5l37.9-91.1 7.1-17 7.6 16.8 65.1 144.6 56.5-112.9 7.2-14.3 7.2 14.3L356.9 256h95.9 4.6l3.5-3.5C483.4 230 496 199.5 496 167.8C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM460.8 272h-8H441.4 352h-4.9l-2.2-4.4L320 217.9 263.2 331.6l-7.5 15.1-6.9-15.4L184.3 188.1l-32.9 79-2.1 4.9H144 70.6 59.2h-8H48l-8.2-8.2C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L464 272h-3.2zM80 304h22.6L256 457.4 409.4 304H432L267.3 468.7 256 480l-11.3-11.3L80 304z'
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fast',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      'M264 8V292.7L370.3 186.3l5.7-5.7L387.3 192l-5.7 5.7-120 120-5.7 5.7-5.7-5.7-120-120-5.7-5.7L136 180.7l5.7 5.7L248 292.7V8 0h16V8zM152 320l32 64H328l32-64H496h16v16V496v16H496 16 0V496 336 320H16 152zm190.3 71.2c-2.7 5.4-8.2 8.8-14.3 8.8H184c-6.1 0-11.6-3.4-14.3-8.8L142.1 336H16V496H496V336H369.9l-27.6 55.2z'
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faPassport = {
    prefix: 'fast',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      'M432 16V496H16V16H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM96 384v16h8H344h8V384h-8H104 96zm.2-200c-.2 2.6-.2 5.3-.2 8s.1 5.4 .2 8C100.4 267 156 320 224 320s123.6-53 127.8-120c.2-2.6 .2-5.3 .2-8s-.1-5.4-.2-8C347.6 117 292 64 224 64s-123.6 53-127.8 120zm16 16h55.8c1.4 41.3 13.1 70.2 25.1 89.3c3.1 4.9 6.1 9 9.1 12.6c-48.9-9.6-86.4-51.1-90-101.9zm223.4 0c-3.6 50.8-41.1 92.3-90 101.9c2.9-3.6 6-7.8 9.1-12.6c12-19 23.8-48 25.1-89.3h55.8zm0-16H279.9c-1.4-41.3-13.1-70.2-25.1-89.3c-3.1-4.9-6.1-9-9.1-12.6c48.9 9.6 86.4 51.1 90 101.9zm-223.4 0c3.6-50.8 41.1-92.3 90-101.9c-2.9 3.6-6 7.8-9.1 12.6c-12 19-23.8 48-25.1 89.3H112.3zm94.5-80.7c5.6-8.9 11.2-15.2 15.3-19.2c.7-.7 1.3-1.3 1.9-1.8c.6 .5 1.2 1.1 1.9 1.8c4.1 4 9.7 10.3 15.3 19.2c10.5 16.6 21.3 42.7 22.6 80.7H184.1c1.3-38.1 12.1-64.1 22.6-80.7zM263.9 200c-1.3 38.1-12.1 64.1-22.6 80.7c-5.6 8.9-11.2 15.2-15.3 19.2c-.7 .7-1.3 1.3-1.9 1.8c-.6-.5-1.2-1.1-1.9-1.8c-4.1-4-9.7-10.3-15.3-19.2c-10.5-16.6-21.3-42.7-22.6-80.7h79.7z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fast',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M32 176a160 160 0 1 1 320 0A160 160 0 1 1 32 176zM200 351.8c93.5-4.2 168-81.3 168-175.8C368 78.8 289.2 0 192 0S16 78.8 16 176c0 94.5 74.5 171.6 168 175.8V416H104 96v16h8 80v72 8h16v-8V432h80 8V416h-8H200V351.8z'
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fast',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM192 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm128 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM167.2 276.7l-11.9 10.7 5.3 6C184 319.5 218.1 336 256 336s72-16.5 95.4-42.7l5.3-6-11.9-10.7-5.3 6C319 305.6 289.2 320 256 320s-63-14.4-83.5-37.3l-5.3-6z'
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fast',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16l0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32l16 0 416 0 16 0zM224 224l-112 0 0 64 112 0 16 0 0 16 0 64 1.4 0 112-112-112-112-1.4 0 0 64 0 16-16 0zm140.7 20.7L376 256l-11.3 11.3L248 384l-8 0-16 0 0-16 0-48 0-16-16 0-96 0-16 0 0-16 0-64 0-16 16 0 96 0 16 0 0-16 0-48 0-16 16 0 8 0L364.7 244.7z'
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fast',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      'M368 80v88V344v88H16V80H368zm16 352V352 334.1 177.9 160 80 64H368 16 0V80 432v16H16 368h16V432zm176-9.9l-144-72V368l144 72 16 8V430.1 81.9 64l-16 8L416 144v17.9l144-72V422.1zM200 168v-8H184v8 80H104 96v16h8 80v80 8h16v-8V264h80 8V248h-8H200V168z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fast',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M160 320l0 16 0 64 0 16 16 0 16 0L340.7 267.3 352 256l-11.3-11.3L192 96l-16 0-16 0 0 16 0 64 0 16-16 0L16 192 0 192l0 16 0 96 0 16 16 0 128 0 16 0zm16 0l0-16-16 0L16 304l0-96 144 0 16 0 0-16 0-80 9.4 0 144 144-144 144-9.4 0 0-80zM328 464l-8 0 0 16 8 0 176 0c4.4 0 8-3.6 8-8l0-432c0-4.4-3.6-8-8-8L328 32l-8 0 0 16 8 0 168 0 0 416-168 0z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fast',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      'M200 0H184V8 32v.2C122.4 36 72.5 83.5 65 144H40 32v16h8H64 80 304h16 24 8V144h-8H319C311.5 83.5 261.6 36 200 32.2V32 8 0zm-8 48c56.4 0 103.1 41.7 110.9 96H81.1C88.9 89.7 135.6 48 192 48zm80 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM40 496H32v16h8H72 312h32 8V496h-8H320V392h56 8v-8V256v-8h-8H320V192H304v64V384 496H80V384 256 192H64v56H8 0v8V384v8H8 64V496H40zM64 376H16V264H64V376zm256 0V264h48V376H320z'
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fast',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      'M16 496l96 0 0 16-96 0L0 512l0-16L0 16 0 0 16 0 224 0 384 160l0 144-16 0 0-128-152 0-8 0 0-8 0-152L16 16l0 480zM361.4 160L224 22.6 224 160l137.4 0zM176 368l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-24 0 0 40 0 8-16 0 0-8 0-48 0-80 0-8 8 0zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32l-24 0 0 64 24 0zm96-80l4 0 5.3 0 2.1 4.9 44.6 105L360 376l0-8 16 0 0 8 0 128 0 8-8 0-5.6 0-5.3 0-2.1-4.9L312 405.9l0 98.1 0 8-16 0 0-8 0-128 0-8 8 0zm120 32c0-17.7 14.3-32 32-32l16 0c17.7 0 32 14.3 32 32l0 16-16 0 0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16-8 0-8 0 0-16 8 0 16 0 8 0 0 8 0 24c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-80z'
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fast',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      'M80 352c61.9 0 112-50.1 112-112V224 208 136 48 32H176 16 0V48 208v16H16 176v16c0 53-43 96-96 96H72 64v16h8 8zm96-144H16V48H176v88 72z'
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fast',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      'M288 80A64 64 0 1 1 160 80a64 64 0 1 1 128 0zM224 0a80 80 0 1 0 0 160A80 80 0 1 0 224 0zM124 192h-4l-2.4 3.2L1.6 349.9 0 352l0 2.7 0 54.1 0 4.9 4.4 2.2 184 92 7.2 3.6 3.6-7.2 37.6-75.1 3.6-7.2-7.2-3.6-89.1-44.5v-70H176V344v3.3l2.3 2.3 48 48 1.1 1.1 1.4 .6 49.6 21.3-8.1 10.1-5 6.2 6.2 5 65.6 52.5 6.2 5 5-6.2L446.2 371l1.8-2.2 0-2.8 0-44.5 0-2.9-1.9-2.2L344.9 194.9l-2.4-2.9h-3.7H124zM353.6 326.8l-64.7 80.9-52.3-22.4L192 340.7V295.9v-8h-8H136.1h-8v8 82.9 4.9l4.4 2.2 86.3 43.2L188.4 490 16 403.8l0-46.4L128 208H335l97 116.4 0 38.8L341 477l-53.1-42.5 78.2-97.7 5-6.2-12.5-10-5 6.2zM272 376a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fast',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm16 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-16 0c0-35.3 28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6 6.6-4.6 9.2 13.1-6.6 4.6-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64s-64-28.7-64-64zM384 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z'
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fast',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      'M368 16V496H240V384 368H224 160 144v16V496H16V16H368zM224 496H160V384h64V496zM16 512H144h16 64 16H368h16V496 16 0H368 16 0V16 496v16H16zM72 232v8 64 8h8 64 8v-8V240v-8h-8H80 72zm16 16h48v48H88V248zm152-16h-8v8 64 8h8 64 8v-8V240v-8h-8H240zm8 64V248h48v48H248zM72 104v8 64 8h8 64 8v-8V112v-8h-8H80 72zm16 16h48v48H88V120zm152-16h-8v8 64 8h8 64 8v-8V112v-8h-8H240zm8 64V120h48v48H248zm376 72c0 35.3-28.7 64-64 64H536V288c0-35.3 28.7-64 64-64h24v16zm-72 80c-10.1 7.6-18.4 17.6-24 29.1c-5.6-11.5-13.9-21.5-24-29.1l16 0h16 16zM448 304H432 416v16 16c0 26.2 12.6 49.4 32 64H432 416v16 16c0 44.2 35.8 80 80 80l24 0h16 24c44.2 0 80-35.8 80-80V416 400H624 608c19.4-14.6 32-37.8 32-64V320 304H624 608c19.4-14.6 32-37.8 32-64V224 208H624 600c-31.7 0-59 18.4-72 45.1c-13-26.7-40.3-45.1-72-45.1H432 416v16 16c0 26.2 12.6 49.4 32 64zm72-16v16l-24 0c-35.3 0-64-28.7-64-64V224h24c35.3 0 64 28.7 64 64zm104 48c0 35.3-28.7 64-64 64H536V384c0-35.3 28.7-64 64-64h24v16zm-72 80c-10.1 7.6-18.4 17.6-24 29.1c-5.6-11.5-13.9-21.5-24-29.1l16 0h16 16zm-32-32v16l-24 0c-35.3 0-64-28.7-64-64V320h24c35.3 0 64 28.7 64 64zm104 32v16c0 35.3-28.7 64-64 64H536V480c0-35.3 28.7-64 64-64h24zM520 496l-24 0c-35.3 0-64-28.7-64-64V416h24c35.3 0 64 28.7 64 64v16zM536 32l-16 0v8V184v8h16v-8V40 32zm72 40V64H592v8 80 8h16v-8V72zM464 64H448v8 80 8h16v-8V72 64z'
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fast',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128h-8v8V256 376v8h8H344h8V368h-8H176V264H304h8V248h-8H176V144H344h8V128h-8H168z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fast',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      'M272 240H375.2c-5.3 5-10.3 10.4-15 16H272 256V240 .6c5.6-.4 11.3-.6 17.1-.6c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-1.7 0-3.3 0-4.9 .1C469.5 91.4 380.1 16 273.1 16L272 16V240zm-32 48h99.2c-2.7 5.2-5.1 10.5-7.2 16H224 208V288 50.3C99.5 65.8 16 159.2 16 272c0 123.7 100.3 224 224 224c40.1 0 77.8-10.6 110.4-29.1c3 4.5 6.3 8.8 9.7 12.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.5 0 272C0 150.3 90.6 49.8 208 34.1c5.3-.7 10.6-1.2 16-1.6v16V272v16h16zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 200a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm56.3-11.1l21.4 21.4-11.3 11.3-21.4-21.4C528.6 434.1 513 440 496 440s-32.6-5.9-44.9-15.7l-21.4 21.4-11.3-11.3 21.4-21.4C429.9 400.6 424 385 424 368s5.9-32.6 15.7-44.9l-21.4-21.4 11.3-11.3 21.4 21.4C463.4 301.9 479 296 496 296s32.6 5.9 44.9 15.7l21.4-21.4 11.3 11.3-21.4 21.4C562.1 335.4 568 351 568 368s-5.9 32.6-15.7 44.9z'
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fast',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      'M408 72h-8V88h8H520h8V72h-8H408zM288 366.5L39.4 256 288 145.5 536.6 256 288 366.5zM556.3 247.2L288 128 19.7 247.2 0 256l19.7 8.8L288 384 556.3 264.8 576 256l-19.7-8.8zm-432 99l-19.7-8.8L19.7 375.2 0 384l19.7 8.8L288 512 556.3 392.8 576 384l-19.7-8.8-84.9-37.7-19.7 8.8L536.6 384 288 494.5 39.4 384l84.9-37.7z'
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fast',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      'M352 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2C42.5 241.3 32 209.9 32 176C32 87.6 103.6 16 192 16s160 71.6 160 160zM128 432H256v64H128V432zm-16 0v64 16h16H256h16V496 432 416H256 128 112v16zM200 96H184v8V264v8h16v-8V104 96zM176 336h32V304H176v32z'
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fast',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM264 296v8H248v-8V123.3l-74.3 74.3-5.7 5.7L156.7 192l5.7-5.7 88-88 5.7-5.7 5.7 5.7 88 88 5.7 5.7L344 203.3l-5.7-5.7L264 123.3V296z'
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fast',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      'M110 248L24.3 48h36l400 200H110zm350.2 16L60.2 464h-36L110 264H460.2zM0 32L6.9 48 96 256 6.9 464 0 480H17.4 64L494.1 264.9 512 256l-17.9-8.9L64 32H17.4 0z'
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fast',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      'M217 160l6.1 24.2L225 192h95 16 16v16 32 16H336 320 257.5 241l4 16 4 16H352h22.1l7.8 20.7 34.7 91.7 19.2-6 15.3-4.8 15.3-4.8 4.8 15.3 9.6 30.5 4.8 15.3-15.3 4.8-15.3 4.8-48 15.1-28.8 9-10.7-28.3L329.9 352H224h-7c-29.4 0-55-20-62.1-48.5L129 199.8 123 176l-4-16h16.5H160h32 25zm103 48H225 212.5l-3-12.1-1.9-7.8-3-12.1H192 160 139.5l5 19.9 25.9 103.8C175.8 321 195 336 217 336h7H329.9h11.1l3.9 10.3 37.5 99.3 5.3 14.1 14.4-4.5 48-15.1 15.3-4.8-9.6-30.5-15.3 4.8-19.2 6L407 420.2l-5.3-14.1L367 314.3 363.1 304H352 249 236.5l-3-12.1-8-32-5-19.9H241h79 16V208H320zM192 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM32.2 137.6l15.7-3.2L102.5 400H296h8v16h-8H96 89.5l-1.3-6.4-56-272z'
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fast',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      'M8 0H0V16H8 32V144v4l3.3 2.4L178.5 256 35.3 361.6 32 364v4V496H8 0v16H8 330.8c-6.9-4.9-13.5-10.2-19.6-16H48V372L192 265.9l71.1 52.4c1.6-5.4 3.4-10.7 5.5-15.8L205.5 256 348.7 150.4 352 148v-4V16h24 8V0h-8H8zM336 16V140L192 246.1 48 140V16H336zm96 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-224H424v8 72 8h8 56 8V360h-8H440V296v-8z'
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fast',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      'M83.2 241.4l3.4 11.4H98.5h31.3l26.8 68L99.1 363.4l-4.7-4.2c-104.4-92.6-104.4-241.9 0-334.5l4.7-4.2 57.5 42.6-26.8 68H98.5 86.7l-3.4 11.4c-9.8 32.3-9.8 66.5 0 98.9zm92.8 85l-35.3-89.6H98.5c-8.9-29.3-8.9-60.3 0-89.6h42.1L176 57.6 98.2 0 83.7 12.8c-111.6 99-111.6 259.4 0 358.4L98.2 384 176 326.4zM471.5 352H237.4l-28-336H555.5l-20 80H360h-8v16h8H531.5l-20 80H360h-8v16h8H507.5l-36 144zm16.5 0L572 16l4-16H559.5 208.1 192l1.3 16 28 336H208 192v16V496v16h16H528h16V496 368 352H528 488zM208 368H528V496H208V368zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fast',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      'M333.4 104H259.3L229.7 74.3 224 68.7l-5.7 5.7L188.7 104H114.6c11-50.3 55.8-88 109.4-88s98.4 37.7 109.4 88zm2.3 16c.2 2.6 .3 5.3 .3 8v16c0 61.9-50.1 112-112 112s-112-50.1-112-112V128c0-2.7 .1-5.4 .3-8H192h3.3l2.3-2.3L224 91.3l26.3 26.3 2.3 2.3H256h79.7zM224 272c48.2 0 90.2-26.6 112-66v2 16h16 48 16V208 80 64H400 352 336v2C314.2 26.6 272.2 0 224 0s-90.2 26.6-112 66V64H96 48 32V80 208v16H48 96h16V208v-2c21.8 39.4 63.8 66 112 66zm128-64V144 128 80h48V208H352zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zM48 80H96v48 16 64H48V80z'
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fast',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      'M0 0H8 376h8V16h-8H352V144v4l-3.3 2.4L205.5 256 348.7 361.6 352 364v4V496h24 8v16h-8H8 0V496H8 32V368v-4l3.3-2.4L178.5 256 35.3 150.4 32 148v-4V16H8 0V0zM48 16V64H336V16H48zm0 64v60L192 246.1 336 140V80H48zm0 292V496H336V372L192 265.9 48 372z'
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fast',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      'M176 64A48 48 0 1 0 80 64a48 48 0 1 0 96 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM40.7 336H64h48 32 16v16h-8V496h24v16H144h-8v-8V352H120V504v8h-8H64 56v-8V352H40 24l.7-16L32 160H171.3c-1.5 5.2-2.5 10.5-3 16H47.3L40.7 336zM376 512h-8H336V496h24V384h-8V368h16 32 48 42.8L435.9 176H343.6c-.5-5.5-1.5-10.8-3-16H448l59.4 208 4.6 16H495.4 456V504v8h-8H400h-8v-8V384H376V504v8zM72 352V496h32V352H72zM432 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zM440 384H408V496h32V384zM256 224a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM208 416H192 176V400 272 256h16H320h16v16V400v16H320 304v88 8H288v-8V416H224v88 8H208v-8V416zM320 272H192V400h16 16 64 16 16V272z'
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fast',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      'M80 224H426.8c2.7-5.6 5.8-11 9.3-16H16V180.1L105.5 16h429L624 180.1V208h-4.1c3.5 5 6.6 10.4 9.3 16H640V208 176L544 0H96L0 176v32 16H16 64V504c0 4.4 3.6 8 8 8H376c4.4 0 8-3.6 8-8V256H368V496H80V224zm48 136c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V256H304V360c0 4.4-3.6 8-8 8H152c-4.4 0-8-3.6-8-8V256H128V360zM528 208c26.5 0 48 21.5 48 48v64H480V256c0-26.5 21.5-48 48-48zm-64 48v64H432 416v16V496v16h16H624h16V496 336 320H624 592V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 80h32 16 96 16 32V496H432V336z'
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fast',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      'M32 480v-8V208c0-88.4 71.6-160 160-160s160 71.6 160 160V472v8h16v-8V208c0-97.2-78.8-176-176-176S16 110.8 16 208V472v8H32z'
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fast',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM503.8 264H552v32 8h16v-8V216v-8H552v8 32H503.8c-1.9-44.8-19.8-85.4-48.2-116.3l34.1-34.1 0 0 22.6 22.6 5.7 5.7 11.3-11.3-5.7-5.7L467.1 52.4l-5.7-5.7L450.1 58l5.7 5.7 22.6 22.6 0 0-34.1 34.1C413.4 92 372.8 74.1 328 72.2V24l32 0h8V8h-8H280h-8V24h8 32V72.2c-29 1.2-56.3 9.2-80.3 22.4l13.8 10.9C267.9 94.3 293.2 88 320 88c92.8 0 168 75.2 168 168c0 12.9-1.5 25.5-4.2 37.6l13.8 10.9c3.5-13 5.7-26.5 6.3-40.4zM142.4 207.6c-3.5 13-5.7 26.5-6.3 40.4H88l0-32v-8H72v8 80 8H88v-8V264h48.2c1.9 44.8 19.8 85.4 48.2 116.3l-34.1 34.1 0 0-22.6-22.6-5.7-5.7-11.3 11.3 5.7 5.7 56.6 56.6 5.7 5.7L189.9 454l-5.7-5.7-22.6-22.6 0 0 34.1-34.1c30.9 28.4 71.5 46.3 116.3 48.2V488H280h-8v16h8 80 8V488h-8H328V439.8c29-1.2 56.3-9.2 80.3-22.4l-13.8-10.9C372.1 417.7 346.8 424 320 424c-92.8 0-168-75.2-168-168c0-12.9 1.5-25.5 4.2-37.6l-13.8-10.9z'
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fast',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      'M16 48V208H496V48H16zM0 32H16 496h16V48 208v16H496 16 0V208 48 32zM16 304V464H496V304H16zM0 288H16 496h16v16V464v16H496 16 0V464 304 288zm336 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-272a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fast',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      'M224 0c-30.9 0-56 25.1-56 56c0 16.3 7 31 18.1 41.2l-27 46.3-49.5 .2c-4-13.1-12.8-24.8-25.6-32.2C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c13.3 7.7 28.4 9.3 42.2 5.7L94.1 256 70.2 297.8c-13.8-3.6-28.9-2-42.2 5.7C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c12.8-7.4 21.6-19.1 25.6-32.2l49.5 .2 27 46.3C175 425 168 439.7 168 456c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.3-7-31-18.1-41.2l27-46.3 49.5-.2c4 13.1 12.8 24.8 25.6 32.2c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-13.3-7.7-28.5-9.3-42.2-5.7L353.9 256l23.9-41.8c13.8 3.6 28.9 2 42.2-5.7c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-12.8 7.4-21.6 19.1-25.6 32.2l-49.5-.2-27-46.3C273 87 280 72.3 280 56c0-30.9-25.1-56-56-56zM184 56c0-22.1 17.9-40 40-40s40 17.9 40 40c0 13.5-6.7 25.5-17 32.8L241 93l3.7 6.3 32.8 56.2 2.3 4 4.6 0 60.4 .2 6.8 0 1.2-6.6c2-11.3 8.7-21.6 19.4-27.8c19.1-11 43.6-4.5 54.6 14.6s4.5 43.6-14.6 54.6c-11.1 6.4-23.9 6.9-34.9 2.5l-6.5-2.6-3.5 6L337.7 252l-2.3 4 2.3 4 29.4 51.5 3.5 6 6.5-2.6c11-4.4 23.9-3.9 34.9 2.5c19.1 11 25.7 35.5 14.6 54.6s-35.5 25.7-54.6 14.6c-10.7-6.2-17.4-16.5-19.4-27.8l-1.2-6.6-6.8 0-60.4 .2-4.6 0-2.3 4-32.8 56.2L241 419l6 4.2c10.3 7.3 17 19.2 17 32.8c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.5 6.7-25.5 17-32.8l6-4.2-3.7-6.3-32.8-56.2-2.3-4-4.6 0-60.4-.2-6.8 0-1.2 6.6c-2 11.3-8.7 21.6-19.4 27.8c-19.1 11-43.6 4.5-54.6-14.6s-4.5-43.6 14.6-54.6c11.1-6.4 23.9-6.9 34.9-2.5l6.5 2.6 3.5-6L110.3 260l2.3-4-2.3-4L80.9 200.6l-3.5-6-6.5 2.6c-11 4.4-23.9 3.9-34.9-2.5c-19.1-11-25.7-35.5-14.6-54.6s35.5-25.7 54.6-14.6c10.7 6.2 17.4 16.5 19.4 27.8l1.2 6.6 6.8 0 60.4-.2 4.6 0 2.3-4 32.8-56.2 3.7-6.3-6-4.2c-10.3-7.2-17-19.2-17-32.8zm45.7 130.3l-5.7-5.7-5.7 5.7-64 64-5.7 5.7 5.7 5.7 64 64 5.7 5.7 5.7-5.7 64-64 5.7-5.7-5.7-5.7-64-64zM224 308.7L171.3 256 224 203.3 276.7 256 224 308.7z'
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fast',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      'M112 96A48 48 0 1 1 16 96a48 48 0 1 1 96 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zm48 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM272 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-64 48a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM272 416a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zM432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-64 48a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fast',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      'M16 432l128 0 0-56 0-16 0-56L16 304l0 128zm144-56l0 56 0 16-16 0L16 448 0 448l0-16L0 304l0-16 16 0 128 0 16 0 0 16 0 56 344 0 8 0 0 16-8 0-344 0zM8 152l-8 0 0-16 8 0 344 0 0-56 0-16 16 0 128 0 16 0 0 16 0 128 0 16-16 0-128 0-16 0 0-16 0-56L8 152zm360 56l128 0 0-128L368 80l0 56 0 16 0 56z'
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fast',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      'M300.7 199.9l.5 4.6 16.9 158L229.4 230.6l-2.6-3.8-4.2-1.9L77.4 160.5l158.5-10.8 4.6-.3 3.7-2.7L372.6 53 302.7 195.7l-2 4.1zm99.7-167L415.4 2 387.7 22.2 234.8 133.7 46 146.6l-34.2 2.3 31.4 13.9 173 76.7 7.9 11.7L240 275l32 47.6 16 23.8 33.7 50.1L340.8 425l-3.6-34.1L317.1 202.8 400.3 32.8zM240 332.4l-16-23.8V496H136h-8v16h8 96 48 96 8V496h-8H288V403.8L272 380V496H240V332.4zM256 216a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fast',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      'M624 224h16V208 176L544 0H111.9l20.3 16H534.5L624 180.1V208H375.4l20.3 16H560V353.7l16 12.6V224h48zM0 176v32 16H16 64V504v8h8H376h8v-8V398.3l-16-12.6V496H80V224h83.3L143 208H16V180.1l27.6-50.6L30.8 119.5 0 176zM304 368H144V256H128V376v8h8H312h8v-8V347.7l-16-12.6V368zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fast',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm261 96h24.3l-74.1 64.8c4.2-.6 8.5-.8 12.8-.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96v0c0-16.7 4.3-32.4 11.7-46c5.4-9.8 12.5-18.8 21.1-26.3L261 128zm-37 80a80 80 0 1 0 .1 160A80 80 0 1 0 224 208z'
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fast',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      'M256 0H240V8 202.6l16-4.3V8 0zm0 314.2V432v5.7L101.2 496.5l5.7 15 400-152 5.2-2V352 296v-8H496v8 50.5L320 413.4V256l-40.2-30.9-65.9 17.6-32.7-71.9-7.1-15.5-6.6-14.6-14.3 7.1-15.3 7.6-26.1 12.9L83.8 182l13.1 28.3 36.4 78.9c9.8 21.2 33.4 32.3 55.9 26.3L240 301.9l16-4.3v16.6zm48 105.2l-32 12.2v-134V276.8l-20.1 5.4L185.1 300c-15 4-30.8-3.4-37.3-17.5l-36.4-78.9-6.5-14.1 14-6.9 26.1-12.9 14.8-7.3 6.8 15.1 32.7 71.9 5.6 12.3 13.1-3.5 58.3-15.6L304 263.9V419.4zM112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32A48 48 0 1 0 64 80a48 48 0 1 0 96 0zM96.6 395.2l3 7.1 7.2-2.8 104-40 7.5-2.9-5.7-14.9-7.5 2.9-96.8 37.2-93-216.9L.6 171.2l96 224z'
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fast',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      'M432 48H16V464H320l0 16H16 0V464 48 32H16 432h16V48 161.3c-5.5 .9-10.9 2.3-16 4.1V48zM368 256v32H352V128H232v88.8c18.3 3.7 32 19.8 32 39.2c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-19.4 13.7-35.5 32-39.2V120v-8h8H360h8v8V256zM320 400H88 80v-8V120v-8h8 64 8v16h-8H96V384H320l0 16zM224 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm240-24c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H560 368 352V496 336 320h16 32V256zm-32 80V496H560V336H528 512 416 400 368z'
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fast',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      'M127.6 207.2C192 176 559 51.3 559 51.3l81 161.9s-51.5 35.2-117.2 79.5c-2.8-4.6-5.8-8.9-9.1-13.1c24.8-16.7 47.6-32.1 66.4-44.9c15.5-10.5 28.2-19.2 37.1-25.2l2.3-1.6L551 70.9l-2.7 .9c-10.2 3.5-24.7 8.5-42.4 14.5c-35.4 12.2-83.3 28.7-133.1 46.2c-100.2 35.2-206.8 73.8-238.1 88.9C71.5 253.2 45.9 330.1 77.5 393.3s108.4 88.8 171.6 57.3c5.9-3 14.1-7.8 24.2-13.9c2.6 4.7 5.4 9.2 8.4 13.6c-10.5 6.4-19.2 11.3-25.4 14.5c-56.1 28.1-121.8 16-164.5-25.2c0 0 .1 .1 .1 .1L57.2 457l-14.3 7.2-7.2-14.3L7.2 392.6 0 378.3l14.3-7.2 34.8-17.4c-7.3-58.9 22.5-118.5 78.5-146.6zM52 369.7c0 .2 .1 .3 .1 .5L21.5 385.5l28.6 57.2 30.6-15.3s0 0 0 0c-6.7-8.2-12.6-17.2-17.5-27c-5-10-8.7-20.3-11.2-30.7zM496 368a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-208 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm136 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z'
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fast',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      'M432 400H144V16H336v88 8h8 88V400zm8-304L344 0H144 128V16 400v16h16H432h16V400 104l-8-8zm-22.6 0H352V30.6L417.4 96zM96 96H16 0v16V496v16H16 304h16V496 448H304v48H16V112H96V96zm165.3 65.3h-8v8 52h-52-8v8 53.3 8h8 52v52 8h8 53.3 8v-8-52h52 8v-8V229.3v-8h-8-52v-52-8h-8H261.3zm8 68v-52h37.3v52 8h8l52 0v37.3h-52-8v8 52H269.3v-52-8h-8-52V237.3h52 8v-8z'
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fast',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      'M448 16c-66.3 0-120 53.7-120 120v8h-8-8-2l-1.8-1L144.3 53.6c3.3 81 36.4 127.1 68.7 153.1c17.2 13.9 34.4 22.2 47.3 27.1c6.4 2.4 11.8 4 15.5 5c1.8 .5 3.3 .8 4.2 1c.5 .1 .8 .2 1 .2l.2 0 0 0 0 0 0 0 0 0 7.9 1.3-2.6 15.8-7.9-1.3L280 248c-1.3 7.9-1.3 7.9-1.3 7.9l0 0 0 0-.1 0-.4-.1c-.3-.1-.8-.2-1.4-.3c-1.2-.2-2.8-.6-4.9-1.2c-4.2-1.1-10.1-2.8-17.2-5.5c-14.1-5.4-32.9-14.5-51.7-29.6c-21-16.9-41.7-41-56-75.2c-2.1-5.1-4.1-10.4-6-16c-8.1-24.5-13-53.6-13-88V26.5L139.8 33 312.3 127C316.9 56.1 375.9 0 448 0h8 16 48 4.3H552h8V16h-8H534.9l29 43.6 1.1 1.7 .2 2 10.7 112 .5 5.5-4.9 2.5-80 40-7.2 3.6-3.6-7.2L451.1 160H448v79.5 .5 9.1l-.5-.1c-2.4 25.2-14.2 47.2-31.5 63V504v8h-8H320h-8v-8V332.1L208 309.3V344v9.9 1.6l-.6 1.5-3.9 9.1L187.2 404l27.2 97.9 2.8 10.1H206.7 107.1 101l-1.6-5.9L74 415l-4.5-16.3-.8-2.7 1.1-2.6 6.6-15.5L96 332.5V316.1L63.4 244.4c-4.9-10.7-7.4-22.3-7.4-34.1c0-12.2 2.7-23.9 7.5-34.3C37.2 176.3 16 197.7 16 224v88 8H0v-8V224c0-35.3 28.7-64 64-64h8 1.2c9.2-11.9 21.6-21.2 36-26.7c1.6 5.2 3.3 10.3 5.2 15.1C89.6 158.1 72 182.1 72 210.3c0 9.5 2 18.8 5.9 27.4l33.3 73.3 .7 1.6v1.7 19.8 1.6l-.6 1.5L91.2 384.2l-5.5 12.9 3.8 13.5L113.2 496h83l-25.1-90.5-.8-2.7 1.1-2.6 17.4-40.5 3.2-7.5V344 304v-4.7-9.9l9.7 2.1 120 26.3 6.3 1.4v6.4V496h72V308.5v-3.7l2.8-2.4c17.6-14.9 29-37.1 29.2-62.5l0-.3v-.2V152v-8h8 16 4.9l2.2 4.4 28.4 56.8 67.9-34-10-104.5L515.7 16H472 456h-8zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fast',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M349.7 250.3l5.7 5.7-5.7 5.7-136 136-5.7 5.7L196.7 392l5.7-5.7L324.7 264 8 264l-8 0 0-16 8 0 316.7 0L202.3 125.7l-5.7-5.7L208 108.7l5.7 5.7 136 136zM328 464l168 0 0-416L328 48l-8 0 0-16 8 0 176 0 8 0 0 8 0 432 0 8-8 0-176 0-8 0 0-16 8 0z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fast',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      'M16 192H184V16H16V192zM184 0h8 8H368h16V16 192v8 8V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V208v-8-8V16 0H16 184zM16 208V352c0 79.5 64.5 144 144 144h64c79.5 0 144-64.5 144-144V208H192 16zm352-16V16H200V192H368z'
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fast',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM231.2 236.5L224 221.9l-7.2 14.5-31.1 62.9-69.4 10.1-16 2.3 11.6 11.3 50.2 49-11.9 69.2-2.7 16 14.3-7.5L224 417l62.1 32.7 14.3 7.5-2.7-16-11.9-69.2 50.2-49 11.6-11.3-16-2.3-69.4-10.1-31.1-62.9zm-32.9 73.8L224 258.1l25.7 52.2 1.9 3.8 4.2 .6 57.6 8.4-41.7 40.6-3 2.9 .7 4.1 9.8 57.3-51.5-27.1-3.7-2-3.7 2L168.8 428l9.8-57.3 .7-4.1-3-2.9L134.7 323l57.6-8.4 4.2-.6 1.9-3.8z'
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fast',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      'M276.3 240.2l15.1 30.1 8.8 17.7H320h64 16 16V272 240 224H400 384 339.8l-39.2-78.3-5.4-10.9-11.3-4.5-80-32L198.2 96H192 128 114.7l-9.4 9.4-48 48L46.1 164.7 34.7 176l11.3 11.3 22.6 22.6L80 221.3l11.3-11.3 11.3-11.3L141.3 160h10.8 16.9l-5.3 16-26 78c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8L218.1 496l-4.6 16h16.6 49.9l6.6-23.2 32-112 6.6-23.2L305 340.9l-68.3-42.7L258.8 241l7.8-20.1 9.7 19.3zm30.4 120.6l-3.3 11.6-32 112L268.1 496H234.8l5.8-20.4L266 386.8l3.3-11.6-10.2-6.4-86.2-53.9c-18.8-11.8-27.1-34.8-20.1-55.9l31.3-94 7-21.1H168.9 141.3h-6.6l-4.7 4.7L91.3 187.3 80 198.6 57.4 176l11.3-11.3 48-48 4.7-4.7H128h64 3.1l2.9 1.1 80 32 5.6 2.3 2.7 5.4 39.2 78.3 4.4 8.8h9.9H384h16v32H384 320h-9.9l-4.4-8.8L281 213.7l-16.1-32.3-13.1 33.6-30 77.3-4.8 12.3 11.2 7 68.3 42.7 10.2 6.4zM272 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm48 32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM111.3 314.8L97.6 352H16 0v16 32 16H16 142.4l19-51.7-13.9-8.7 0 0L131.2 400H16V368H97.6h11.2l3.8-10.5 9.2-25.2c-4.2-5.5-7.7-11.4-10.6-17.6zM473.5 449.6C487.1 411.9 496 350.1 496 256s-8.9-155.9-22.5-193.6C459.8 24.3 443.8 16 432 16s-27.8 8.3-41.5 46.4c-10.2 28.4-17.8 70.4-20.9 129.6h-16C360.9 51.3 393.2 0 432 0c44.2 0 80 66.6 80 256s-35.8 256-80 256c-38.8 0-71.1-51.3-78.4-192h16c3.1 59.2 10.7 101.2 20.9 129.6C404.2 487.7 420.2 496 432 496s27.8-8.3 41.5-46.4z'
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fast',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      'M9.9 0l6.3 5L633.7 494.5l6.3 5L630.1 512l-6.3-5L6.3 17.5 0 12.5 9.9 0z'
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fast',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      'M576 176c0 97.2-128.9 176-288 176c-30.4 0-59.6-2.9-87.1-8.2C220.4 361.9 232 387.6 232 415c0 53.6-43.4 97-97 97H40 32V496h8 95c44.7 0 81-36.3 81-81c0-30.7-17.3-58.7-44.8-72.4l-30.7-15.4C56.4 296.5 0 240.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 336c150.2 0 272-71.6 272-160S438.2 16 288 16S16 87.6 16 176s121.8 160 272 160z'
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fast',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      'M496 256C496 123.5 388.5 16 256 16V232c0 4.4-3.6 8-8 8H16.5c-.3 5.3-.5 10.6-.5 16c0 132.5 107.5 240 240 240s240-107.5 240-240zM240 16.5C125.6 24.1 33.1 111.8 18.1 224H240V16.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fast',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM121.8 110.5l5.7 5.7L192 180.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L203.3 192l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L192 203.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L180.7 192l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fast',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      'M106.7 0h10.7l2 4.9L223.8 256H206.5l-33.3-80H50.8L17.5 256H.2L104.6 4.9l2-4.9zm59.9 160L112 28.8 57.4 160H166.6zM264 0h88c35.3 0 64 28.7 64 64c0 20.1-9.3 38.1-23.8 49.8c32 7.3 55.8 36 55.8 70.2c0 39.8-32.2 72-72 72H264h-8v-8V120 8 0h8zM400 64c0-26.5-21.5-48-48-48H272v96h80c26.5 0 48-21.5 48-48zM272 240H376c30.9 0 56-25.1 56-56s-25.1-56-56-56H352 272V240zm299.3 52.8l-5.7 5.7-208 208-5.5 5.5-5.7-5.3-120-112-5.8-5.5 10.9-11.7 5.8 5.5L351.8 489.7 554.3 287.1l5.7-5.7 11.3 11.3z'
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fast',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      'M17.6 147.4L119.8 16H264.2L366.4 147.4 267.9 496H116.1L17.6 147.4zM104 512H280L384 144 272 0H112L0 144 104 512zm96-408V96H184v8 72H104 96v16h8 80V344v8h16v-8V192h80 8V176h-8H200V104z'
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fast',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      'M8 32H0v8V472c0 4.4 3.6 8 8 8s8-3.6 8-8V48H624V472v8h16v-8V40 32h-8H8zM160 96H144v64H64v16h80v96H64v16h80v96H64v16h80v80h16V400h96v80h16V400h96v80h16V400h96v80h16V400h80V384H496V288h80V272H496V176h80V160H496V96H480v64H384V96H368v64H272V96H256v64H160V96zm0 80h96v96H160V176zm112 0h96v96H272V176zm112 0h96v96H384V176zM160 384V288h96v96H160zm112 0V288h96v96H272zm112 0V288h96v96H384z'
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fast',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      'M0 32H8 40 472h32 8V48h-8H480V464h24 8v16h-8H472 40 8 0V464H8 32V48H8 0V32zM48 48V464H464V48H48zM264 96v8 40h80 8v16h-8H264v48H376h8v16h-8H264v80 1.5l72-25.1 1.3-.4h1.4H392h8v8 65.6 2.8l-1.7 2.2-42.7 54.4-2.4 3.1h-3.9H162.7h-3.9l-2.4-3.1-42.7-54.4-1.7-2.2v-2.8V288v-8h8 53.3 1.4l1.3 .4 72 25.1V304 224H144h-8V208h8H248V160H176h-8V144h8 72V104 96h16zM128 350.8L166.6 400H345.4L384 350.8V296H340l-81.4 28.4-2.6 .9-2.6-.9L172 296H128v54.8zm64 1.2a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fast',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      'M229.7 501.7l-5.7 5.7-5.7-5.7-136-136L76.7 360 88 348.7l5.7 5.7L216 476.7 216 168l0-8 16 0 0 8 0 308.7L354.3 354.3l5.7-5.7L371.3 360l-5.7 5.7-136 136zM16 184l0 8L0 192l0-8L0 8 0 0 8 0 440 0l8 0 0 8 0 176 0 8-16 0 0-8 0-168L16 16l0 168z'
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fast',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      'M224 464C109.1 464 16 370.9 16 256S109.1 48 224 48c27.6 0 53.9 5.4 78 15.1c-65.9 39-110 110.8-110 192.9s44.2 153.9 110 192.9c-24.1 9.8-50.4 15.1-78 15.1zM431.8 248H208.2c1-25.4 6.5-49.7 15.8-72H416.1c9.3 22.3 14.8 46.6 15.8 72zM416 336.1V336H224v.1c-9.3-22.3-14.9-46.7-15.8-72.1H431.8c-1 25.5-6.5 49.8-15.8 72.1zM408.6 352c-19.7 37.8-50.7 68.8-88.6 88.6c-37.8-19.7-68.8-50.7-88.6-88.6H408.6zM231.4 160c19.7-37.8 50.7-68.8 88.6-88.6c37.8 19.7 68.8 50.7 88.6 88.6H231.4zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 48c114.9 0 208 93.1 208 208s-93.1 208-208 208c-27.6 0-53.9-5.4-78-15.1c65.9-39 110-110.8 110-192.9s-44.2-153.9-110-192.9C362.1 53.4 388.4 48 416 48z'
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fast',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      'M320 496H16V16H208V168v8h8H320h48 16V160L224 0H16 0V16 496v16H16 320l0-16zM224 22.6L361.4 160H224V22.6zM464 208c26.5 0 48 21.5 48 48v64H416V256c0-26.5 21.5-48 48-48zm-64 48v64H368 352v16V496v16h16H560h16V496 336 320H560 528V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zM368 496V336h32 16 96 16 32V496H368z'
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fast',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      'M279.7 344.6C332.5 314.2 368 257.2 368 192c0-97.2-78.8-176-176-176S16 94.8 16 192V368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.8-.1-5.7-.3-8.5l-.6-9.9 8.6-5zM384 192c0 71.2-38.7 133.3-96.3 166.5c.2 3.1 .3 6.3 .3 9.5c0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0S384 86 384 192zM80 192v35.7l44.4 29.6c2.2 1.5 3.6 4 3.6 6.7v40c0 2.4-1.1 4.6-2.9 6.1l-48 40L71 355.3 60.7 343l6.1-5.1L112 300.3v-32L67.6 238.7c-2.2-1.5-3.6-4-3.6-6.7V192c0-70.7 57.3-128 128-128s128 57.3 128 128v8 8H304v-8-8c0-61.9-50.1-112-112-112S80 130.1 80 192z'
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fast',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      'M258.8 2.8C239 2.8 223 19 212.5 36.1C201.7 53.6 194.8 75.4 194.8 92l0 78.8 0 9.3L6.9 283.8l-4.1 2.3v4.7 88 10.5l10.1-2.8 181.9-50.2 0 10.5 0 44L134 436.4l-3.2 2.4v4l0 56v10.4l10.1-2.7 117.9-31.5L368 504.2V487.6L260.9 459.1l-2.1-.6-2.1 .6L146.8 488.4l0-41.6 60.8-45.6 3.2-2.4v-4l0-48 0-21V315.3 184.9l0-14.1 0-78.8c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 78.8 0 14.1v4.7l0 125.7v10.5 21l0 48v4l3.2 2.4 26 19.5c-2.5-7.9-4.4-16-5.8-24.3l-7.5-5.6 0-44V336.3l7.7 2.1c.9-5.3 2-10.5 3.4-15.7l-11.1-3.1V198.4l66.1 36.5c4.4-3.8 9-7.4 13.7-10.7l-79.8-44 0-9.3 0-78.8c0-16.6-6.7-38.3-17.3-55.8C295 19 279 2.8 258.8 2.8zM18.8 295.5l176-97.1V319.7l-176 48.6 0-72.8zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fast',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      'M16 48V464H496V48H16zM0 32H16 496h16V48 464v16H496 16 0V464 48 32zm112 80v32H80V112h32zm64 0h32v32H176V112zm128 0v32H272V112h32z'
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fast',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304 96c0-26.5-21.5-48-48-48s-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V352zm-112 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM160.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200.5 127.5l-8 .5c-32.5 2-61.6 16.5-82.7 38.7l-5.5 5.8-11.6-11 5.5-5.8c23.7-25.1 56.6-41.4 93.3-43.7l8-.5 1 16zm119 .5l-8-.5 1-16 8 .5c36.7 2.3 69.6 18.6 93.3 43.7l5.5 5.8-11.6 11-5.5-5.8C381.1 144.5 352 130 319.5 128z'
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fast',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      'M498.7 0h-4l-2.4 3.1L256 312.4V232v-8h-8H8 0v8V360c0 83.9 68.1 152 152 152h9.8c51.5 0 99.5-26.1 127.5-69.3L535 64h97 8V56 8 0h-8H498.7zM367.1 193.3L502.6 16H624V48H530.7h-4.3L524 51.6 410.8 226.1l-43.7-32.8zM357.4 206l44.7 33.5L275.9 434c-25.1 38.7-68 62-114.1 62H152C76.9 496 16 435.1 16 360V240H240v96 23.6l14.4-18.8L357.4 206z'
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fast',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM64 64V80h8 96 8V64h-8H72 64zm0 64v16h8 96 8V128h-8H72 64zM200 242.7H184v8 13.7c-8.3 .6-16 2.3-22.7 5c-12.1 4.9-22.1 13.6-24.5 26.2c-1.5 7.6-.6 14.4 2.6 20.4c3.1 5.8 8 10.1 13.4 13.3c10 6 23.5 9.6 35.7 12.9l1.7 .4c13.4 3.6 25.1 6.9 33 12c3.8 2.4 6.2 5 7.5 7.7c1.3 2.6 1.9 6 .9 11c-1.3 6.6-6 11.8-14.8 15.2c-9 3.4-21.4 4.5-35.9 2.5c-7.2-1-19.4-4.7-28.9-7.6l0 0c-2.1-.6-4-1.2-5.7-1.7l-7.7-2.3-4.5 15.3 7.7 2.3c1.4 .4 3.1 .9 5 1.5l0 0 0 0 0 0 0 0 0 0c9.4 2.9 23.3 7.1 31.9 8.3l0 0c1.8 .2 3.6 .5 5.3 .6v13.9 8h16v-8V407.9c8.2-.4 15.8-1.9 22.4-4.4c12.4-4.7 22.2-13.6 24.8-27.1c1.5-7.8 .8-14.9-2.3-21.1c-3-6.1-7.8-10.6-13.2-14.1c-10.4-6.7-24.8-10.6-37.5-14l-.3-.1c-13.4-3.6-25-6.7-33-11.5c-3.9-2.3-6.2-4.7-7.5-7.1c-1.2-2.3-1.9-5.3-1-9.8c1-5.4 5.6-10.8 14.8-14.5c9.1-3.7 21.7-5.1 35.9-3.2c4.6 .6 18.6 3.1 23 4.1l3.7-15.6c-5.1-1.2-19.7-3.7-24.5-4.4c-1.8-.2-3.6-.5-5.3-.6V250.7v-8z'
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fast',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      'M441.4 16c-16.1 0-31.4 7.1-41.7 19.4L200 272H347.5L482.2 112.4c8.9-10.6 13.8-24 13.8-37.8v-4C496 40.5 471.5 16 441.4 16zM354.9 288h-7.4H200 186.5 165.6l13.5-16 8.7-10.3L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L359.7 282.3l-4.8 5.7zM176.1 320h22.3L29.5 493.5c30.7-3.6 86.9-13.7 140.6-36.3c63.5-26.7 121-69.6 132-137.1h16.2c-11.2 77.3-76.3 124.2-142 151.9C103.7 502.4 26.8 511 9 511H-10L3.2 497.5 176.1 320zM232 496h80 8v16h-8H232h-8V496h8zm128 0h80 8v16h-8H360h-8V496h8zm128 0h80 8v16h-8H488h-8V496h8z'
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fast',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      'M195.1 238.8l-19.8 11.7L96 144.8V96 32 16 0H80 48 32V16 32 96v59.1 .7V192v32 11.8l7.7 9L145.3 368H128h-8v16h8 31 1 16 96 16 64 16 96 16 1 31 8V368h-8H494.7L600.3 244.8l7.7-9V224 192 155.8v-.7V96 32 16 0H592 560 544V16 32 96v48.8L464.7 250.5l-19.8-11.7-13.9-8.2 9.7-12.9 40.9-54.5-50.4-39.5-72 88-7.2 8.8V232v88 32 16H288V352 320 232 220.6l-7.2-8.8-72-88-50.4 39.5 40.9 54.5 9.7 12.9-13.9 8.2zM176 368h-9.6l-4.8-5.6L51.9 234.4 48 229.9V224 192 155.8v-.7V96 32 16H80V32 96v48.8 5.3l3.2 4.3 79.3 105.7 8.6 11.5 12.3-7.3 33.7-19.9 15.4-9.1L221.7 221l-41.1-54.9L206.3 146l62.1 75.9 3.6 4.4V232v88 32 16H176zm288 0H368V352 320 232v-5.7l3.6-4.4L433.7 146l25.7 20.1L418.3 221l-10.7 14.3 15.4 9.1 33.7 19.9 12.3 7.3 8.6-11.5 79.3-105.7 3.2-4.3v-5.3V96 32 16h32V32 96v59.1 .7V192v32 5.9l-3.9 4.5-109.7 128-4.8 5.6H464zM176 464H160v32 16h16 96 16V496 464H272v32H176V464zm288 0v32H368V464H352v32 16h16 96 16V496 464H464zM128 416h-8v16h8H512h8V416h-8H128z'
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fast',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256v8h8H376h8V248h-8H264V104 96H248v8z'
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fast',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      'M383.2 4.4l56 112c1.5 2.9 1 6.4-1.1 8.8L340.8 236.4l133-35 22.6-67.9 15.2 5.1-24 72c-.9 2.6-2.9 4.5-5.6 5.2L344.2 252 482 288.3c2.6 .7 4.7 2.6 5.6 5.2l24 72-15.2 5.1-22.6-67.9L358.2 272.2l80.2 107c1.6 2.1 2 4.8 1.2 7.3l-40 120-15.2-5.1 38.7-116-57.7-77c1.7 7.5 2.6 15.3 2.6 23.4v8.3C368 400 317.5 448 256 448s-112-48-112-107.8v-8.3c0-8 .9-15.8 2.6-23.3l-57.7 77 38.7 116-15.2 5.1-40-120c-.8-2.5-.4-5.2 1.2-7.3l80.2-107L38.2 302.6 15.6 370.5 .4 365.5l24-72c.9-2.6 2.9-4.5 5.6-5.2L167.8 252 30 215.7c-2.6-.7-4.7-2.6-5.6-5.2l-24-72 15.2-5.1 22.6 67.9 133 35L74 125.3c-2.1-2.4-2.6-5.9-1.1-8.8l56-112 14.3 7.2L89.6 118.8 184 226.7V144c0-27.4 15.3-51.2 37.9-63.4l7-3.8 3.8 7L256 127.1l23.3-43.3 3.8-7 7 3.8c22.5 12.2 37.9 36 37.9 63.4v82.7l94.4-107.9L368.8 11.6l14.3-7.2zM200 144V253.1v4l-3.2 2.4c-22.5 16.9-36.8 43-36.8 72.3v8.3c0 50.4 42.7 91.8 96 91.8s96-41.4 96-91.8v-8.3c0-29.3-14.3-55.4-36.8-72.3l-3.2-2.4v-4V144c0-18.4-8.9-34.8-22.7-45L263 147.8l-7 13.1-7-13.1L222.7 99c-13.8 10.2-22.7 26.6-22.7 45z'
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fast',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      'M184 32h8v8V188.7l61.7 61.7 2.3 2.3v6.6l-2.3 2.3L192 323.3V472v8h-8H56 48V464h8H176V320v-3.3l2.3-2.3L236.7 256l-58.3-58.3-2.3-2.3V192 48H56 48V32h8H184z'
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fast',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      'M496 496H144V352H128V496v16h16H496h16V496 352H496V496zm0-320v64h16V160L352 0H144 128V16 240h16V16H336V168v8h8H496zm-6.6-16H352V22.6L489.4 160zM40 288H32v16h8H184h8V288h-8H40zm224 0h-8v16h8H376h8V288h-8H264zm192 0h-8v16h8H600h8V288h-8H456z'
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fast',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      'M261.7 10.3L256 4.7l-5.7 5.7-112 112-5.7 5.7L144 139.3l5.7-5.7L248 35.3V328v8h16v-8V35.3l98.3 98.3 5.7 5.7L379.3 128l-5.7-5.7-112-112zM8 32H0v8V504v8H8 504h8v-8V40 32h-8H408h-8V48h8 88V496H16V48h88 8V32h-8H8z'
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fast',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      'M384 0V8 32v8h16V32 16h96V32v8h16V32 8 0h-8H392h-8zM575.1 192h.5v-.1V176 94.1L511.3 64H383.9L321.8 93.1l18.2 9.1L387.4 80H507.8l51.8 24.3v83.8c-.3 1.3-.5 2.6-.5 3.9h16zM352 192l0-48-16.4-8.2v0l-16-8v0L256 96H128L32 144v48H48V153.9L131.8 112H252.2L336 153.9V192h16zm288 32H608 592h-.1H48.1 48 32 0v16H33.8L64 512H576l30.2-272H640V224zM78.3 496L49.9 240H590.1L561.7 496H78.3zM299.6 288l-2.4 3.7-28.4 44.2 13.6 8.5L308.4 304h23.2l26.7 42 13.6-8.5-29.2-45.8-2.4-3.7H336 304h-4.4zm75.9 85l23.7 37.3V432H337.7v16h69.5 8v-8V408v-2.3l-1.3-2-24.9-39.2L375.5 373zM240 432V410.3l25.1-39.1-13.6-8.5-26.3 40.9-1.3 2V408v32 8h8 73.7V432H240zM136 0h-8V8 48h-8-8V64h8 16 8V56 16h96V56v8h8 16 8V48h-8-8V8 0h-8H136z'
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fast',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      'M40 32L24 32l0 448H40L40 32zm128 0l-16 0 0 448h16l0-448z'
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fast',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      'M288 16V496H32V16H288zM32 0H16V16 496v16H32 288h16V496 16 0H288 32zM240 144v96H80V144H240zM80 128H64v16 96 16H80 240h16V240 144 128H240 80zm24-64H96V80h8H216h8V64h-8H104zM72 320H88v16H72V320zm0-16H56v16 16 16H72 88h16V336 320 304H88 72zm0 112V400H88v16H72zM56 384v16 16 16H72 88h16V416 400 384H88 72 56zm112-64v16H152V320h16zm-16-16H136v16 16 16h16 16 16V336 320 304H168 152zm0 96h16v16H152V400zm-16-16v16 16 16h16 16 16V416 400 384H168 152 136zm96-64h16v16H232V320zm0-16H216v16 16 16h16 16 16V336 320 304H248 232zm0 112V400h16v16H232zm-16-32v16 16 16h16 16 16V416 400 384H248 232 216z'
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fast',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      'M291.4 270.3l-15.1-30.1-9.7-19.3L258.8 241l-22.2 57.1L305 340.9l20.4 12.8-6.6 23.2-32 112L280.1 512H230.2 213.6l4.6-16 7.1-24.8 25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l26-78 5.3-16H152.1 141.3l-38.6 38.6L91.3 209.9 80 221.3 68.7 209.9 46.1 187.3 34.7 176l11.3-11.3 11.3-11.3 48-48 9.4-9.4H128h64 6.2l5.7 2.3 80 32 11.3 4.5 5.4 10.9L339.8 224H384h16 16v16 32 16H400 384 320 300.2l-8.8-17.7zm5.1 84.1l-68.3-42.7-11.2-7 4.8-12.3 30-77.3 13.1-33.6L281 213.7l24.7 49.4 4.4 8.8H320h64 16V240H384 339.8h-9.9l-4.4-8.8-39.2-78.3-2.7-5.4-5.6-2.3-80-32-2.9-1.1H192 128h-6.6l-4.7 4.7-48 48L57.4 176 80 198.6l11.3-11.3 38.6-38.6 4.7-4.7h6.6 27.7 22.2l-7 21.1-31.3 94c-7 21 1.3 44.1 20.1 55.9l86.2 53.9 10.2 6.4L266 386.8l-25.4 88.8L234.8 496h33.3l3.3-11.6 32-112 3.3-11.6-10.2-6.4zM304 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM97.6 352l13.7-37.2c2.9 6.2 6.4 12.1 10.6 17.6l-9.2 25.2L108.8 368H97.6 16v32H131.2l16.3-44.4 0 0 13.9 8.7-19 51.7H16 0V400 368 352H16 97.6z'
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fast',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      'M410.3 458.3l-5.7 5.7L416 475.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80-5.7-5.7L404.7 304l5.7 5.7L476.7 376H324L134.4 123.2 132 120h-4H8 0v16H8 124L313.6 388.8 316 392h4H476.7l-66.3 66.3zM134.4 388.8L204 296l-10-13.3L124 376H8 0v16H8 128h4l2.4-3.2zM254 229.3L324 136H476.7l-66.3 66.3-5.7 5.7L416 219.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80L416 36.7 404.7 48l5.7 5.7L476.7 120H320h-4l-2.4 3.2L244 216l10 13.3z'
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fast',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      'M306.9 139.9c-.9-12.6-4-25.3-9.4-37.5L258.2 14.3 251.9 0 237.5 6.4 149.4 45.6c-13.9 6.2-25.9 14.8-35.7 25.2c-9.8 10.3-17.8 22.7-23.3 36.9l-.2 .4c-5.4 14.1-7.7 28.6-7.3 42.9c.2 7.8 1.2 15.7 3.1 23.5c4.2 18.4 6.4 37.9-.4 55.5s-21.4 30.6-36.8 41.5c-6.6 4.5-12.7 9.7-18 15.3c-9.9 10.4-17.9 22.8-23.4 37C2 338-.3 352.6 0 366.9c.4 14.3 3.5 28.8 9.7 42.7l39.2 88.1L55.3 512l14.3-6.4L96 493.9V476.7L63.3 491.3 24 403.2c-5.3-12-8-24.4-8.3-36.7l0 0c-.3-12.3 1.7-24.8 6.4-37.1c4.7-12.2 11.6-23 20.1-31.9l0 0c4.6-4.9 9.8-9.3 15.5-13.2l0 0 .2-.1c16-11.3 33.9-26.5 42.4-48.7s5.4-45.5 1-64.6l0 0-.1-.2c-1.6-6.7-2.5-13.5-2.7-20.2l0 0c-.3-12.2 1.7-24.7 6.3-36.9l0 0 .1-.4c4.7-12.2 11.6-22.8 20-31.7l0 0c8.5-8.9 18.8-16.4 30.7-21.7l88.1-39.2 39.2 88.1c8.8 19.8 10.4 41 5.9 60.6c1.6-1.2 3.1-2.5 4.4-3.9c5.5-5.5 9.7-13.5 13.4-25.6zM548.6 284.8c17.3-7.2 33.5-17.7 47.6-31.7c27-26.8 43.8-64 43.8-105.1V16 0H624 492c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32c-14.3 14.2-25 30.7-32.3 48.2c-4.6 11.2-7.6 22.9-10.4 34.6c-5.6 22.4-11.1 44.6-28.6 62.1c-17.6 17.6-42.2 25.4-66.7 30.3c-29.5 5.4-56.1 19-78.1 41c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364V496v16h16H276c40.5 0 77.1-16.2 103.8-42.5c22.4-22 36.4-49 41.8-78.9c4.8-24.5 12.6-49.1 30.3-66.7c17.6-17.6 39.7-23.1 62.1-28.6c11.7-2.9 23.4-5.8 34.6-10.4zM624 16V148c0 36.6-14.9 69.8-39 93.7l0 0c-12.6 12.5-27.1 21.9-42.5 28.3l0 0c-10.1 4.2-19.9 6.6-30.9 9.3c-5.6 1.4-11.6 2.9-18 4.7c-17.7 5-36.8 12.3-53.1 28.6c-21.1 21.1-29.7 49.7-34.6 74.9l0 0 0 .2c-4.8 26.7-17.3 50.6-37.3 70.3C344.8 481.5 312.1 496 276 496H144V364c0-17.9 3.6-35 10-50.5l0 0c6.4-15.5 16-30.1 28.6-42.8c19.6-19.6 43.3-31.8 69.6-36.5l0 0 .2 0c25.2-5 53.8-13.5 74.9-34.6c16.2-16.2 23.5-35.3 28.6-53.1c1.8-6.4 3.3-12.3 4.7-18l0 0 0 0c2.7-11 5.1-20.8 9.3-30.9l0 0c6.5-15.6 16.1-30.3 28.8-43C411.4 41.9 426 32.4 441.5 26l0 0C457 19.6 474.1 16 492 16H624zM544 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM320 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM560 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fast',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M256 16a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm48 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM189.6 128h3.8H318.6h3.8l2.4 3L424 254.7l5 6.2-6.2 5-37.5 30-6.2 5-5-6.2-46-57.5V288H312V214.5 191.7l14.2 17.8 55.3 69 25-20L314.8 144H197.2L105.5 258.5l25 20 55.3-69L200 191.7v22.8V288H184V237.3l-46 57.5-5 6.2-6.2-5L89.3 266 83 261l5-6.2L187.2 131l2.4-3zM472 128v8 32h32 8v16h-8H472v32 8H456v-8V184H424h-8V168h8 32V136v-8h16zM56 320v8 32H88h8v16H88 56v32 8H40v-8V376H8 0V360H8 40V328v-8H56zM96 448h8H408h8v8 48 8H400v-8V464H112v40 8H96v-8V456v-8zm64-64h8H344h8v16h-8H168h-8V384zm8-64H344h8v16h-8H168h-8V320h8z'
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fast',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      'M40 96H32v8V344v8H48v-8V123.3L330.3 405.7l5.7 5.7L347.3 400l-5.7-5.7L59.3 112H280h8V96h-8H40z'
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fast',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      'M432 48V464H16V48H432zm16-16H432 16 0V48 464v16H16 432h16V464 48 32zM378.9 230.6c-85.6-83.5-224.3-83.5-309.8 0L58.4 241l-4.7 4.6 3.6 5.5 37.3 57.2 3.2 4.9 5.6-1.6 74.7-20.8 6.6-1.8-.8-6.8L179.1 240c29.4-7.7 60.4-7.7 89.7 0l-4.8 42.3-.8 6.8 6.6 1.8 74.7 20.8 5.6 1.6 3.2-4.9 37.3-57.2 3.6-5.5-4.7-4.6-10.7-10.4zM80.3 242.1c79.4-77.4 208.1-77.4 287.5 0l0 0 6 5.8-30.5 46.8-62.4-17.4 4.8-42.3 .8-6.6-6.4-1.9c-36.4-11-75.4-11-111.8 0l-6.4 1.9 .8 6.6 4.8 42.3-62.4 17.4L74.3 247.9l6-5.8z'
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fast',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM422.9 429c-26.5 24.7-58.4 46.3-96.6 62.8l-6.4 2.7-6.4-2.7C219.8 451.2 164 379.9 132.5 307.5c-20.4-46.9-30.6-94.4-34.6-135.1L80.8 158.9c2.9 45.3 13.4 100.6 37 155c32.7 75.3 91 150 189.4 192.6L320 512l12.7-5.5c40.9-17.7 74.8-40.9 102.9-67.5l-12.7-10zM308.4 4.5L180.5 54.1l14.6 11.5L314.2 19.4l5.8-2.2 5.8 2.2L533.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6c-.5 1.2-1 2.3-1.5 3.5l12.9 10.2c1.1-2.4 2.2-4.9 3.3-7.3c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L539.1 85 331.6 4.5 320 0 308.4 4.5z'
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fast',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152v-8H144v8V288c0 61.9 50.1 112 112 112s112-50.1 112-112V152v-8H352v8V288c0 53-43 96-96 96s-96-43-96-96V152z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fast',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.8 0 35.7 8.1 47.4 21l108-75.6 6.6-4.6 9.2 13.1-6.6 4.6-108 75.6c4.7 8.9 7.4 19.1 7.4 29.9c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fast',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      'M-9.9 0H0 128h3.3l2.3 2.3 248 248 5.7 5.7H504h8v16h-8H257L16 334.2v76.2L257.4 496H504h8v16h-8H256h-1.4l-1.3-.5-248-88L0 421.7V416 328v-6.2l6-1.5 48.9-12.6L-7.8 9.6-9.9 0zM124.7 16H9.9L70.4 303.6 254 256.3l1-.3h1H364.7L124.7 16zM200 368H376h8v16h-8H200h-8V368h8z'
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fast',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      'M160 224h18.4H397.6 416l-9.1-16L297.2 16.1 288 0l-9.2 16.1L169.1 208 160 224zM288 32.2L388.4 208H187.6L288 32.2zM128 272a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM496 288V480H304V288H496zM304 272H288v16V480v16h16H496h16V480 288 272H496 304z'
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fast',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      'M48 16V416H304V16H48zm0 416v64H304V432H48zM32 496V16 0H48 304h16V16 272h8c39.8 0 72 32.2 72 72v44c0 24.3 19.7 44 44 44s44-19.7 44-44V255.6c-40.4-4-72-38.1-72-79.6V136v-8h8 24V72 64h16v8 56h64V72 64h16v8 56h24 8v8 40c0 41.5-31.6 75.6-72 79.6V388c0 33.1-26.9 60-60 60s-60-26.9-60-60V344c0-30.9-25.1-56-56-56h-8V496l32 0v16H320 304 48 32 0V496l32 0zM544 144H528 464 448 432v32c0 35.3 28.7 64 64 64s64-28.7 64-64V144H544zM203.2 110.4l-4.8 6.4L136 200h96 16l-9.6 12.8-72 96-4.8 6.4-12.8-9.6 4.8-6.4L216 216H120 104l9.6-12.8 72-96 4.8-6.4 12.8 9.6z'
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fast',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      'M193.4 56L56 193.4l-8-8V48H185.4l8 8zM192 32H48 32V48 192l12.7 12.7L56 216l11.3-11.3 63-63L244.7 256 130.3 370.3l-63-63L56 296 44.7 307.3 32 320V464v16H48 192l12.7-12.7L216 456l-11.3-11.3-63-63L256 267.3 370.3 381.7l-63 63L296 456l11.3 11.3L320 480H464h16V464 320l-12.7-12.7L456 296l-11.3 11.3-63 63L267.3 256 381.7 141.7l63 63L456 216l11.3-11.3L480 192V48 32H464 320L307.3 44.7 296 56l11.3 11.3 63 63L256 244.7 141.7 130.3l63-63L216 56 204.7 44.7 192 32zm-6.6 432H48V326.6l8-8L193.4 456l-8 8zm141.3 0l-8-8L456 318.6l8 8V464H326.6zm0-416H464V185.4l-8 8L318.6 56l8-8z'
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fast',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      'M192 0c96.7 0 175.1 77.9 176 174.4H352C351.1 86.8 279.8 16 192 16C103.6 16 32 87.6 32 176c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0zm80 452.3V496v16H256 128 112V496 432 416h16H251l21 36.3zM184 80c-48.6 0-88 39.4-88 88H80c0-57.4 46.6-104 104-104V80zM128 432v64H256V432H128zM460.1 248.8c7.9 3.4 15.4 7.7 22.3 12.8l35-20.2 0 0 37 64 8 13.9-13.9 8-21.3 12.3c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l21.3 12.3 13.9 8-8 13.9-37 64-35.1-20.2c-6.9 5.1-14.3 9.4-22.3 12.8V481v16h-16H388 372V481 454.8c-8-3.4-15.6-7.7-22.5-12.9l-34.9 20.1-37-64-8-13.9 13.9-8 21.1-12.2c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4l-21.1-12.2-13.9-8 8-13.9 28.9-50.1 8-13.9 13.9 8 21.1 12.2c6.9-5.1 14.5-9.4 22.5-12.9V222.4v-16h16 56.1 16v16 26.4zm51.5 14.4l-21.2 12.2-9.1 5.2-8.4-6.2c-5.9-4.3-12.3-8-19.1-11l-9.7-4.2V248.8 222.4H388v26.2 10.6l-9.7 4.1c-6.9 2.9-13.3 6.6-19.3 11l-8.4 6.2-9.1-5.2-21.1-12.2-28.9 50.1 21.1 12.2 9 5.2-1.1 10.4c-.4 3.5-.6 7-.6 10.6s.2 7.2 .6 10.6l1.1 10.4-9.1 5.2-21.1 12.1 29 50.1 21.1-12.1 9.1-5.2L359 429c5.9 4.4 12.4 8.1 19.3 11l9.7 4.1v10.6V481h56.1V454.6 444.1l9.7-4.2c6.8-2.9 13.2-6.6 19.1-11l8.4-6.2 9.1 5.2 21.2 12.2 29-50.1-21.3-12.3-9-5.2 1.1-10.4c.4-3.5 .6-7 .6-10.5s-.2-7.1-.6-10.5l-1.1-10.4 9-5.2 21.3-12.3-29-50.1zM416 383.7a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fast',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      'M336 496V448 432 368 352 96c0-44.2-35.8-80-80-80s-80 35.8-80 80V224v16 64 16V496H336zm16-128v64H464h32V400 272 240H432v32 80 16H416 352zm0 80v48 16H336 176 160V496 320H48 16 0V304 272 144 112 96H16 80 96v16 32 64 16h16 48V96c0-53 43-96 96-96s96 43 96 96V352h48 16V336 272 240 224h16 64 16v16 32V400v32 16H496 464 352zM160 240H96 80V224 144 112H16v32V272v32H48 160V240zm64-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fast',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      'M368 144V496h64V144H368zm-16-16h16 64 16v16V496v16H432 368 352V496 144 128zM272 272H208V496h64V272zm-64-16h64 16v16V496v16H272 208 192V496 272 256h16zM112 400H48v96h64V400zM48 384h64 16v16 96 16H112 48 32V496 400 384H48z'
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fast',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V270.9l83.6 55.7 6.7 4.4 8.9-13.3-6.7-4.4-96-64L248 241.1V256 408v8h16v-8z'
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fast',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      'M152.9 320H304h16l0-16-.1-26L32 32 0 46.9V432l18.1 19.8 10.9 12 10.3-12.5L139.4 329.1l69.3 146.3 14.5-6.8L152.9 320zm-18.3-10.1L28.3 439.3 16 425.8V57.1l13.4-6.3L303.9 285.4 304 304H146.9h-7.6l-4.8 5.9z'
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fast',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V282.4l-49.3 74-4.4 6.7-13.3-8.9 4.4-6.7 64-96 14.7-22V256 408v8H248v-8z'
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fast',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      'M176 336a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM352 176c0 94.5-74.5 171.6-168 175.8V416h80 8v16h-8H184v72 8H168v-8V432H88 80V416h8 80V351.8C74.5 347.6 0 270.5 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM286.2 352.5c29 29.4 69.3 47.5 113.8 47.5c88.4 0 160-71.6 160-160s-71.6-160-160-160c-12.8 0-25.3 1.5-37.2 4.4c-2.4-5-5.1-9.8-7.9-14.5C369.3 66 384.4 64 400 64c45.7 0 87.4 17.4 118.7 46l94-94H488h-8V0h8H632h8V8 152v8H624v-8V27.3l-94 94c28.6 31.3 46 72.9 46 118.7c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4c4.9-2.5 9.7-5.3 14.3-8.2z'
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fast',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      'M74.4 48H216V176H17.5L74.4 48zM232 176V48H373.6l56.9 128H232zm200 16V464H16V192H432zM384 32H64L0 176V464v16H16 432h16V464 176L384 32z'
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fast',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      'M368 118.6V496H16V16H265.4L368 118.6zm16-6.6L272 0H16 0V16 496v16H16 368h16V496 112zM96 240v16l84.7 84.7L192 352l11.3-11.3L288 256V240 224H272 112 96v16zm16 9.4V240H272v9.4l-80 80-80-80z'
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fast',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      'M128 0h8H248h8V8 128H376h8v8V248v8h-8H256V504v8h-8H136h-8v-8V256H8 0v-8V136v-8H8 128V8 0zm16 16V136v8h-8H16v96H136h8v8V496h96V248v-8h8H368V144H248h-8v-8V16H144z'
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fast',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      'M345.4 16l80 80-80 80H336V104 88 16h9.4zM320 16V88H8 0v8V264v8H16v-8V104H320v72 16h16 16l84.7-84.7L448 96 436.7 84.7 352 0H336 320V16zM166.6 496l-80-80 80-80H176v72 16 72h-9.4zm25.4 0V424H504h8v-8V248v-8H496v8V408H192V336 320H176 160L75.3 404.7 64 416l11.3 11.3L160 512h16 16V496z'
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fast',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm266.3 26.3L180.7 384c-50.7-56.5-48.8-143.5 5.5-197.8c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6C335.5 444.2 248.5 446 192 395.3L293.7 293.7l5.7-5.7L288 276.7l-5.7 5.7zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fast',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M374.6 164L297.1 17.1 288.1 0l-9 17.1L201.5 164 38 192.3l-19.1 3.3 13.5 13.9 115.7 119L124.5 492.8 121.7 512l17.4-8.6 149-73.2 149 73.2 17.4 8.6-2.8-19.2L428 328.5l115.7-119 13.5-13.9-19.1-3.3L374.6 164zm150.1 42.2L416.6 317.4l-5.5 5.6 1.1 7.8 22.1 153.5L295.1 415.8l-7.1-3.5-7.1 3.5L141.9 484.3l22.1-153.5L165 323l-5.5-5.6L51.5 206.2l152.8-26.4 7.8-1.3 3.7-7L288.1 34.3l72.4 137.1 3.7 7 7.8 1.3 152.8 26.4z'
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fast',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      'M11.3 267.3L0 256l11.3-11.3L244.7 11.3 256 0l11.3 11.3L500.7 244.7 512 256l-11.3 11.3L267.3 500.7 256 512l-11.3-11.3L11.3 267.3zM22.6 256L256 489.4 489.4 256 256 22.6 22.6 256zM264 128v8V296v8H248v-8V136v-8h16zM240 368V336h32v32H240z'
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fast',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      'M528 16V496h64V16H528zM512 0h16 64 16V16 496v16H592 528 512V496 16 0zM432 144H368V496h64V144zm-64-16h64 16v16V496v16H432 368 352V496 144 128h16zM208 272V496h64V272H208zm-16-16h16 64 16v16V496v16H272 208 192V496 272 256zM48 400v96h64V400H48zM32 384H48h64 16v16 96 16H112 48 32V496 400 384z'
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fast',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      'M96 0V8 120v8h16v-8V16h96V120v8h16v-8V8 0h-8H104 96zM224 176c44.2 0 80 35.8 80 80V496H16V256c0-44.2 35.8-80 80-80H224zM96 160c-53 0-96 43-96 96V496v16H16 304h16V496 256c0-53-43-96-96-96H96zM232 336A72 72 0 1 1 88 336a72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zM344 0H328V8 40H296h-8V56h8 32V88v8h16V88 56h32 8V40h-8H344V8 0zM472 0H456V8 40H424h-8V56h8 32V88v8h16V88 56h32 8V40h-8H472V8 0zm0 200v-8H456v8 32H424h-8v16h8 32v32 8h16v-8V248h32 8V232h-8H472V200zM408 96H392v8 32H360h-8v16h8 32v32 8h16v-8V152h32 8V136h-8H408V104 96z'
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fast',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM168 176h-8v16h8 80V328v8h16v-8V192h80 8V176h-8H256 168z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fast',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M164.3 7.7L256 57.1 347.7 7.7 362 0l4.7 15.6 29.9 99.7 0 0-12.9 12.9 0 0-2.5-8.3-29-96.6L263.6 71.2 256 75.3l-7.6-4.1L159.7 23.4l-29 96.6-2.5 8.3-8.3 2.5-96.6 29 47.8 88.8 4.1 7.6-4.1 7.6L23.4 352.3l96.6 29 8.3 2.5 0 0-12.9 12.8 0 0L15.6 366.7 0 362l7.7-14.4L57.1 256 7.7 164.3 0 150l15.6-4.7 99.7-29.9 29.9-99.7L150 0l14.4 7.7zM256 144c30.9 0 58.9 12.5 79.2 32.8l-11.3 11.3C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96c0 26.5 10.7 50.5 28.1 67.9l-11.3 11.3C156.5 314.9 144 286.9 144 256c0-61.9 50.1-112 112-112zm208 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 464a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm160 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fast',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      'M416 32l21.3 64H560h16v16V464v16H560 80 64V464 112 96H80 202.7L224 32H416zm21.3 80H425.8l-3.6-10.9L404.5 48H235.5l-17.7 53.1L214.2 112H202.7 80V464H560V112H437.3zM224 312h64 8v16h-8H243.3L271 355.7c13 13 30.6 20.3 49 20.3c30.6 0 57.6-15.6 73.3-39.3l13.3 8.9C388 373.5 356.2 392 320 392c-22.6 0-44.3-9-60.3-25L232 339.3V384v8H216v-8V320v-8h8zm200-48h-8H352h-8V248h8 44.7L369 220.3c-13-13-30.6-20.3-49-20.3c-30.6 0-57.6 15.6-73.3 39.3l-13.3-8.9C252 202.5 283.8 184 320 184c22.6 0 44.3 9 60.3 25L408 236.7V192v-8h16v8 64 8z'
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fast',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      'M235.1 16H192 168 144 120.3L109 36.7l-88 160-5 9V216 400H96V228.3v-2.1l1-1.8 64-116.4 15 3.9V304H160V143.1l-48 87.3V408v8h-8H8 0v-8V216 203.7v-2.1l1-1.8L6.9 189l88-160L108.6 4.1 110.9 0h4.7H144h24 24 47.8 .2 .2H399.8h.3H448h24 24 28.4 4.7l2.3 4.1L545.1 29l88 160 5.9 10.8 1 1.8v2.1V216 408v8h-8H536h-8v-8V230.4l-48-87.3V304H464V112l15-3.9 64 116.4 1 1.8v2.1V400h80V216 205.7l-5-9-88-160L519.7 16H496 472 448 404.9L327.2 171.5 264.1 304H246.4l64.7-135.9L235.1 16zM160 504V384h16V496H464V384h16V504v8h-8H168h-8v-8zM387.1 16H252.9L320 150.1 387.1 16zM160 336H320 480h8v16h-8H334.9l55.7 83.6 4.4 6.7-13.3 8.9-4.4-6.7-57.3-86-57.3 86-4.4 6.7-13.3-8.9 4.4-6.7L305.1 352H160h-8V336h8z'
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fast',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368c39 0 75.9 7.4 108.6 20.7C352.5 340 308.4 304 256 304s-96.5 36-108.6 84.7C180.1 375.4 217 368 256 368zm0 16c-40.7 0-78.8 8.5-111.7 23.4c-5.6 2.5-11 5.3-16.3 8.1c0-6.4 .5-12.7 1.4-18.8C138.7 335.2 191.8 288 256 288s117.3 47.2 126.6 108.8c.9 6.1 1.4 12.4 1.4 18.8c-5.3-2.9-10.7-5.6-16.3-8.1C334.8 392.5 296.7 384 256 384zM211.3 176l-5.7 5.7-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L211.3 176zm95 5.7l-5.7-5.7L312 164.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fast',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      'M474 173.3C510.8 223 500.4 293.1 450.7 330c-15.6 11.6-33.2 18.5-51.1 21c-21.2 3-44.4 12.1-64.7 24.6c-20.2 12.4-39.1 29.2-50.2 48.5C244.9 492.9 156.9 516.5 88 476.7S-4.5 348.9 35.3 280C61.7 234.3 76 168.6 80.4 118.2c2.3-26 13.6-51.4 34-70.9C159 4.4 229.9 5.8 272.7 50.4c16.5 17.2 40.1 34.5 64.7 48.9s51.3 26.4 74.4 32.3c24.1 6.2 46.2 20.3 62.1 41.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 240c0-26.5 21.5-48 48-48h8V176h-8c-35.3 0-64 28.7-64 64v8h16v-8z'
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fast',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm8.9-205.3l-8.9-5.9-8.9 5.9L176 354.1V144H336V354.1l-71.1-47.4zM160 384l16-10.7L256 320l80 53.3L352 384V364.8 144 128H336 176 160v16V364.8 384z'
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fast',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      'M216 0h16V32.2c84.6 4.2 152 74.1 152 159.8v93.2L446.2 363l1.8 2.2V368v40 8h-8H8 0v-8V368v-2.8L1.8 363 64 285.2V192c0-85.7 67.4-155.6 152-159.8V0zm8 48C144.5 48 80 112.5 80 192v96 2.8L78.2 293 16 370.8V400H432V370.8L369.8 293l-1.8-2.2V288 192c0-79.5-64.5-144-144-144zM190.1 481.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9h16c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3h16c0 12.7 5.1 24.9 14.1 33.9zM240 304v32H208V304h32zm-8-168V264v8H216v-8V136v-8h16v8z'
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fast',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      'M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7L431.3 420zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fast',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      'M399.6 35.4C410 23.1 425.3 16 441.4 16C471.5 16 496 40.5 496 70.6v4c0 13.8-4.9 27.2-13.8 37.8L347.5 272H200L399.6 35.4zM347.5 288h7.4l4.8-5.7L494.4 122.7C505.8 109.2 512 92.2 512 74.6v-4C512 31.6 480.4 0 441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7 179.1 272l-13.5 16h20.9H200 347.5zM3.2 497.5L-10 511H9c17.9 0 94.7-8.6 167.3-39.1c65.8-27.7 130.8-74.6 142-151.9H302.1C291 387.5 233.6 430.4 170 457.1c-53.7 22.6-109.9 32.8-140.6 36.3L198.5 320H176.1L3.2 497.5z'
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fast',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      'M160 16a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96A56 56 0 1 0 160 0a56 56 0 1 0 0 112zM95.9 128l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H214.1l65.6 135.9c3.1-5.4 6.5-10.6 10.2-15.6L226.3 132.5l-2.2-4.5h-5H100.9h-5zM104 248v-8H88v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H216v8V496H184V344v-8h-8H144h-8v8V496H104V248zm328-8a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-136V360h-8H360h-8v16h8H504h8z'
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fast',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      'M495.5 272H248h-8v-8V16.5C114.9 24.8 16 128.8 16 256c0 132.5 107.5 240 240 240c127.2 0 231.2-98.9 239.5-224zm.5-16C496 123.5 388.5 16 256 16V256H496zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fast',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      'M464 0H448V8 32h0V48 176v16h0V512h16V192H624h16V176 48 32H624 464V8 0zm0 176V48H624V176H464zm-48-38L276.8 33.6 272 30l-4.8 3.6-256 192-6.4 4.8 9.6 12.8 6.4-4.8L64 206V504v8h8H416V496H352V328v-8h-8H200h-8v8V496H80V194L272 50 416 158V138zM336 336V496l-128 0V336H336z'
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fast',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm219.3 67.3L224 96l-11.3 11.3L96 224V368v16h16H464h16V368 240l-85.6-99.8L384 128l-11.3 11.3-41.3 41.3L320 192l-11.3-11.3-73.4-73.4zm96 96l51.8-51.8L464 245.9V368H112V230.6l112-112 84.7 84.7L320 214.6l11.3-11.3z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fast',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      'M284 436.2l2.2-.6c87.2-22.2 180.2-45.9 273.8-8.7V70.3c-86.9-40.1-174.2-18.4-268 5.5l-2.2 .6C202.6 98.5 109.6 122.3 16 85V441.7c86.9 40.1 174.2 18.4 268-5.5zM0 60.3c5.3 2.7 10.7 5.2 16 7.5c90.7 38.7 181.3 15.6 272-7.5c96-24.5 192-48.9 288 0V433.9v17.8c-5.3-2.7-10.7-5.2-16-7.5c-90.7-38.7-181.3-15.6-272 7.5c-96 24.5-192 48.9-288 0V78.1 60.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104zm256 0c0 4.4-3.6 8-8 8h-8c-39.8 0-72-32.2-72-72V80c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8zM40 216c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40zm504 88c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zM40 352h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8s3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fast',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      'M4.4 494.4L0 512l17.6-4.4L407.8 410l16.1-4L512 384C512 171.9 340.1 0 128 0L106 88.1l-4 16.1L4.4 494.4zM495.8 371.6l-72 18c-5.4-164-137.4-296-301.4-301.4l18-72c193.4 6.4 348.9 162 355.4 355.4zm-87.9 22L22 490l96.5-385.9c158.3 3.4 286.1 131.1 289.5 289.5zM176 280a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-24-40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm160 96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM144 408a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-24-40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fast',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      'M400 16V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H16V16H400zM16 416H64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632h8V400h-8H608V216v-3.3l-2.3-2.3-112-112L491.3 96H488 416V16 0H400 16 0V16 400v16H16zM416 112h68.7l104 104H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM254.2 81.9l6.1-24.3L241.2 73.9 106.8 189.1 90.4 203.2H112h66.6l-16.7 66.9-6.1 24.3 19.1-16.3L309.2 162.9l16.4-14.1H304 237.4l16.7-66.9zM188.8 187.2H133.6l98.9-84.8-13.1 52.5-2.5 9.9h10.2 55.2l-98.9 84.8 13.1-52.5 2.5-9.9H188.8z'
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fast',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      'M80 32L80 0H96l0 32H480l0-32h16l0 32h64 16V48 400v16H560 496l0 96H480l0-96H96l0 96H80l0-96H16 0V400 48 32H16 80zM560 48H16V400H560V48z'
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fast',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      'M272 432H16V208C16 137.3 73.3 80 144 80s128 57.3 128 128V432zm16-224c0-55.7-31.7-104.1-78-128H432c70.7 0 128 57.3 128 128V432H288V208zM272 448h16H560h16V432 208c0-79.5-64.5-144-144-144H144C64.5 64 0 128.5 0 208V432v16H16 272zM72 192H64v16h8H216h8V192h-8H72zm304 0h-8v16h8 56v80 8h8 64 8v-8V200v-8h-8H440 376zm72 88V208h48v72H448z'
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fast',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      'M16 40V32H0v8V472v8H8 504h8V464h-8H16V40zm336 88h-8v16h8H452.7L288 308.7l-90.3-90.3-5.7-5.7-5.7 5.7-96 96L84.7 320 96 331.3l5.7-5.7L192 235.3l90.3 90.3 5.7 5.7 5.7-5.7L464 155.3V256v8h16v-8V136v-8h-8H352z'
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fast',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      'M16 16H368V256c0-19.6 5.9-37.9 16-53.1V16 0H368 16 0V16 496v16H16 144h16 64 16 80l0-16H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zm216 88c26.5 0 48 21.5 48 48v64H416V256c0-26.5 21.5-48 48-48zm-64 48v64H368 352v16V496v16h16H560h16V496 336 320H560 528V256c0-35.3-28.7-64-64-64s-64 28.7-64 64zM368 496V336h32 16 96 16 32V496H368z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fast',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      'M496 144v48c5.4 0 10.7 .2 16 .7V144 128H496L16 128H0v16V496v16H16l378.8 0c-6.9-4.9-13.4-10.2-19.6-16L16 496l0-352 480 0zM464 64L48 64V80l416 0V64zM416 0H96V16l320 0V0zM572.5 470.7C551.1 486.6 524.7 496 496 496s-55.1-9.4-76.5-25.3L451.7 432h88.5l32.2 38.7zm12.2-10.3l-34.5-41.4-2.4-2.9H544 448h-3.7l-2.4 2.9-34.5 41.4C383.1 437 368 404.3 368 368c0-70.7 57.3-128 128-128s128 57.3 128 128c0 36.3-15.1 69-39.3 92.3zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fast',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      'M320 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 320 0a64 64 0 1 0 0 128zm-51.9 48H371.9l54.9 192H384 336 304 256 213.2l54.9-192zM312 384h16V504v8h8 48 8v-8V384h39.4H448l-4.6-16L384 160H256L196.6 368 192 384h16.6H248V504v8h8 48 8v-8V384zm64 112H344V384h32V496zM296 384V496H264V384h32zM34.9 32H8 0v8 72c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448v24 8h8 40c37.9 0 73.4-10.1 104-27.8V433.4C186 452.8 150.3 464 112 464H80V448c0-42.2 13.6-81.2 36.7-112.9l4.5-6.2 4.5-6.2-6-4.8-6-4.8C54.1 266.2 16 193.6 16 112V48H34.9c77.1 0 146.7 32.4 195.7 84.4l5.1-17.7C184.1 63.6 113.2 32 34.9 32zM528 464c-38.3 0-74-11.2-104-30.6v18.7c30.6 17.7 66.1 27.8 104 27.8h40 8v-8V448c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112V40 32h-8H605.1c-78.3 0-149.3 31.6-200.8 82.7l5.1 17.7C458.5 80.4 528 48 605.1 48H624v64c0 81.6-38.1 154.2-97.6 201.2l-6 4.8-6 4.8 4.5 6.2 4.5 6.2C546.4 366.8 560 405.8 560 448v16H528z'
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fast',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      'M16 16V496H432V16H16zM0 0H16 432h16V16 496v16H432 16 0V496 16 0zM208 432a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fast',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M371.1 108.9c-81.2-81.2-212.9-81.2-294.2 0s-81.2 212.9 0 294.2s212.9 81.2 294.2 0l11.3 11.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8s229.3-87.5 316.8 0l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fast',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M240 240v16V464h20.9l144-388.9L16 219.1V240H224h16zM0 208L412.2 55.3 432 48l-7.3 19.8L272 480H240 224V464 272 256H208 16 0V240 208z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fast',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM264 112v8 80h80 8v16h-8H264v80 8H248v-8V216H168h-8V200h8 80V120v-8h16z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fast',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-197.3l25.6 34.1c4.2 5.5 6.4 12.3 6.4 19.2c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-6.9 2.2-13.7 6.4-19.2L336 314.7zm-10-13.3l-28.4 37.9c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L346 301.3 336 288l-10 13.3zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM150.6 323.4l-4.6-6.6L132.9 326l4.6 6.6c22.4 32 61.9 67.4 118.6 67.4h8V384h-8c-49.4 0-84.6-30.8-105.4-60.6z'
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fast',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      'M320 16V0h16H472h16H624h16V16 496v16H624 336 320V496 16zm16 0V496H472V416v-8h16v8 80H624V16H488V96v8H472V96 16H336zM488 192v8V312v8H472v-8V200v-8h16zM8 96H288v16H232v80h56v16H8 0V192H8 88V112H8 0V96H8zM272 304h16v16H272c-39.8 0-72 32.2-72 72V504v8h-8H96 88v-8V392c0-39.8-32.2-72-72-72H8 0V304H8h8c48.6 0 88 39.4 88 88V496h80V392c0-48.6 39.4-88 88-88zM216 112H104v80H216V112z'
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fast',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 432h16V496 192 176 80 64H432 336V8 0H320V8 64H128V8zM16 192H432V496H16V192zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM272.1 228.7l-5.7 5.7L128.6 372.2l-1.6 1.6-.5 2.2-14.2 62.1-2.9 12.4 12.4-2.9 62.1-14.2 2.2-.5 1.6-1.6L325.7 293.5l5.7-5.7-5.7-5.7-47.9-47.9-5.7-5.7zM141.5 381.9l90.5-90.5 36.5 36.5-90.5 90.5-47.4 10.9 10.9-47.4zm167.2-94.1l-28.8 28.8-36.5-36.5 28.8-28.8 36.5 36.5z'
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fast',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zM88 208a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-30.2l6.6 9.7 120 176 1.4 2V392v16 8h-8H96 88v-8V392v-2.7l1.6-2.1 72-96 6.1-8.1 6.5 7.8 33.2 39.9 82-119.3 6.6-9.6zm-.1 28.3L214.6 348.5l-6 8.7-6.8-8.1-33.5-40.2L104 394.7V400H408v-5.5L296 230.2z'
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fast',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      'M120 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM168 384V504v8l0 0h8 48 8v-8V416l0-168v-8H216v8V496H184l0-80 0-32V368H168V144h-8v0h54.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H160v0H100.9h-5l-2.2 4.5L8.8 308.5l-3.5 7.2 14.4 7 3.5-7.2L105.9 144H152V368h8v16h8zm-8-16v16h-8V504v8h-8H96 88v-8V384H56 44.9l3.5-10.5 56-168 2.5-7.6 15.2 5.1-2.5 7.6L67.1 368H88h16 32 16 8zM104 496h32V384H104V496z'
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fast',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM168 224c-4.4 0-8 3.6-8 8v24V416v24c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416 256 232c0-4.4-3.6-8-8-8H168zm8 32V240h32v16V416v16H176V416 256zm88 32c-4.4 0-8 3.6-8 8v24 96 24c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416 320 296c0-4.4-3.6-8-8-8H264zm8 32V304h32v16 96 16H272V416 320zM72 352c-4.4 0-8 3.6-8 8v24 32 24c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416 384 360c0-4.4-3.6-8-8-8H72zm8 32V368h32v16 32 16H80V416 384z'
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fast',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      'M176 288V496h80V384c0-35.3 28.7-64 64-64s64 28.7 64 64V496h80V288 135.7L320 20.5 176 135.7V288zm-16-17.5V128L320 0 480 128V270.5l61.1-66.7L552 192l10.9 11.8L640 288V496v16H624 480 464 384 368 272 256 176 160 16 0V496 288l77.1-84.2L88 192l10.9 11.8L160 270.5zm0 23.7L88 215.7 16 294.2V496H160V294.2zm320 0V496H624V294.2l-72-78.5-72 78.5zM272 496h96V384c0-26.5-21.5-48-48-48s-48 21.5-48 48V496zM229 139.6h11 47.7l26.7-46.8 5.6-9.7 5.6 9.7 26.7 46.8H400h11l-5.5 9.6L381.7 191l23.9 41.8 5.5 9.6H400 352.3l-26.7 46.8-5.6 9.7-5.6-9.7-26.7-46.8H240 229l5.5-9.6L258.3 191l-23.9-41.8-5.5-9.6zm36.7 64.3L251 229.6h29.4l-14.7-25.7zm29.4 25.7h49.7L366.9 191l-22.1-38.6H295.1L273.1 191l22.1 38.6zm7.3 12.8L320 273.1l17.5-30.7H302.5zm57.1-12.8H389l-14.7-25.7-14.7 25.7zm14.7-51.5L389 152.4H359.6l14.7 25.7zm-36.7-38.5L320 108.9l-17.5 30.7h35.1zm-57.1 12.8H251l14.7 25.7 14.7-25.7z'
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fast',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      'M234.5 495C145.4 487.1 70.3 430.5 36 352H142.2c22.4 72.6 66.1 119.8 92.3 143zm-29.7-55.7c-17.1-22.6-34.1-51.6-45.8-87.4H353.1c-11.7 35.7-28.7 64.8-45.8 87.4c-15.2 20.1-30.4 35.1-41.7 44.9c-3.6 3.1-6.8 5.8-9.5 7.9c-2.7-2.1-5.9-4.7-9.5-7.9c-11.3-9.9-26.5-24.8-41.7-44.9zM144 256c0-29.4 3.9-56.1 10.2-80H357.8c6.3 23.9 10.2 50.6 10.2 80s-3.9 56.1-10.2 80H154.2c-6.4-23.9-10.2-50.6-10.2-80zm-6.3-80c-6.1 24.1-9.7 50.8-9.7 80s3.6 55.9 9.7 80H29.7C20.8 311 16 284.1 16 256s4.8-55 13.7-80h108zm21.3-16c11.7-35.7 28.7-64.8 45.8-87.4c15.2-20.1 30.4-35.1 41.7-44.9c3.6-3.1 6.8-5.8 9.5-7.9c2.7 2.1 5.9 4.7 9.5 7.9c11.3 9.9 26.5 24.8 41.7 44.9c17.1 22.6 34.1 51.6 45.8 87.4H158.9zm215.4 16h108c8.8 25 13.7 51.9 13.7 80s-4.8 55-13.7 80h-108c6.1-24.1 9.7-50.8 9.7-80s-3.6-55.9-9.7-80zM476 160H369.8C347.5 87.4 303.8 40.2 277.5 17C366.6 24.9 441.7 81.5 476 160zm-333.9 0H36C70.3 81.5 145.4 24.9 234.5 17c-26.3 23.2-69.9 70.5-92.3 143zM277.5 495c26.3-23.2 69.9-70.5 92.3-143H476c-34.3 78.5-109.4 135.1-198.5 143zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fast',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      'M80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zm37.4 273.7l-5.4-8.1-16-24v28.8 36.2l54.6 54.6 7.3 7.3 1.7 10.1 8 48 4 24 4 24 0 0 3.5 21.3 .5 2.7 2.2 13.3H165.6 116.9l-.5-2.7-4-24 0 0-4-24-4-24-6.3-37.9L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7V160 144 128H16 32 80 97.1l9.5 14.3L161.1 224h53.6l-14.5-62.2-1.8-7.8 15.6-3.6 1.8 7.8 53.3 228.6c6-1.8 12.3-2.8 18.9-2.8c31.3 0 57.4 22.5 62.9 52.2l151.2-36 3.7 15.6-154 36.7c-2.3 33.3-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-23 12.1-43.1 30.3-54.4L229.7 288H224 144 126.9l-9.5-14.3zM161.1 240h-8.6l-4.8-7.1L93.3 151.1 88.6 144H80 32 16v16V274.7c0 12.7 5.1 24.9 14.1 33.9l22.6 22.6 56.8 56.7 3.6 3.6 .8 5.1 6.3 37.9 4 24 4 24 0 0 0 0 0 0 2.2 13.4h32.4l-3.1-18.6 0 0 0 0 0 0-4-24-4-24-8-48-.8-5.1-3.6-3.6L84.7 318.1 80 313.4v-6.6V241.7 188.8l29.3 44 21.4 32.1 4.7 7.1H144h80 1.9l-7.5-32H161.1zM0 480L0 346.5l16 16L16 480l0 16 32 0 0-16 0-85.5 16 16v37.4L64 480l0 16 0 16-16 0-32 0L0 512l0-16 0-16zm336-32a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM480 345.6l-15.5 3.9L341.9 380.1 326.4 384l-3.9-15.5L291.9 245.9 288 230.4l15.5-3.9 122.6-30.6 15.5-3.9 3.9 15.5 30.6 122.6 3.9 15.5zm-142 19L460.6 334 430 211.4 307.4 242 338 364.6z'
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fast',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      'M401.5 412.1C377.1 424.8 349.4 432 320 432c-97.2 0-176-78.8-176-176c0-14.8 1.8-29.3 5.3-43l-13.7-10.8c-4.3 14.6-6.8 30-7.5 45.8H72 64v16h8 56.2c4.1 99.7 84.2 179.8 183.8 183.8V504v8h16v-8V447.8c31.6-1.3 61.2-10.2 87.1-25l-13.6-10.8zM312 64.2c-31.6 1.3-61.2 10.2-87.1 25l13.6 10.8C262.9 87.2 290.6 80 320 80c97.2 0 176 78.8 176 176c0 14.8-1.8 29.3-5.3 43l13.7 10.8c4.3-14.6 6.8-30 7.5-45.8H568h8V248h-8H511.8C507.8 148.3 427.7 68.2 328 64.2V8 0H312V8 64.2zM320 352c1.8 0 3.5 0 5.2-.1l-22.4-17.7c-24.2-5.3-44.3-21.5-54.8-43.3l-22.5-17.7C233.6 318 272.8 352 320 352zm-5.2-191.9l22.4 17.7c24.2 5.3 44.3 21.5 54.8 43.3l22.5 17.7C406.4 194 367.2 160 320 160c-1.8 0-3.5 0-5.2 .1zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fast',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      'M368 16c58.3 0 106.9 35.2 138 74c31.9 39.9 54 93.7 54 150c0 76.7-50.6 141.4-106.9 183.3C395 466.6 317.8 496 240 496H16V360c0-33.1 15.1-58.4 36.5-75.6c18.2-14.6 38.5-24.9 60.5-36c2.7-1.4 5.5-2.8 8.2-4.2c24.6-12.6 50.8-26.8 73.5-49.5c16.1-16.1 23-32.8 32.9-56.6l.6-1.6c3.2-7.7 6.8-16.3 11.1-26.3c7.6-17.3 19.3-41.7 40.3-61.2C303.3 27.1 333.3 16 368 16zM16 512H240c81.7 0 162.1-30.8 222.6-75.8C520.9 392.8 576 323.9 576 240c0-60.4-23.6-117.6-57.5-160C485.7 39 433 0 368 0c-38.3 0-72.3 12.4-99.2 37.4c-23.5 21.9-36.3 48.9-44.1 66.5c-4.4 10.1-8 18.9-11.2 26.6c-10.4 25.1-16.2 39.1-30 52.9c-23.1 23.1-50.4 36.9-77.7 50.7c-21.8 11-43.6 22.1-63.3 37.8C17.8 291.7 0 321.4 0 360V496v16H16zM384 248a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM121.7 316l0 0-1.3 .6 0 0c-15 6.4-27.2 11.7-35.6 18.8c-3.4 2.9-7 6.8-9.5 12.4C72.9 353.1 72 359 72 365.2V424v16H88 238c65 0 131.5-25.2 181.8-62.9c50.3-37.8 84.2-88 84.2-137.9c0-41.8-16.6-83.6-41.5-115C437.6 92.8 404.4 72 371.3 72c-20.7 0-35.2 6.3-46.2 16.6C314 99 306.3 113.6 299 130.4c-2.5 5.7-5 11.9-7.5 18.2l0 .1c-12 29.8-25.8 63.7-53 91.2C193 285.6 151.7 303.2 121.7 316zM88 365.2c0-9.5 2.7-13.8 7.2-17.7c6.1-5.2 15.6-9.5 31.4-16.2l1.3-.6c30.5-13 74.1-31.5 121.9-79.6c29.8-30.1 44.6-66.9 56.5-96.5c2.6-6.3 5-12.4 7.4-17.9c7.1-16.5 13.8-28.4 22.4-36.4C343.9 93 354.3 88 371.3 88c26.5 0 55.5 17 78.7 46.2c22.9 28.9 38 67.3 38 105c0 42.9-29.5 88.9-77.8 125.1C362.3 400.2 299.1 424 238 424H104 88V408 365.2z'
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fast',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      'M446.8 0H444l-2.2 1.8L362.1 66c-39.9 32.2-87.7 52.6-138.1 59.5v16.1c54-6.9 105.4-28.7 148.1-63.1L448 17.3V462.7l-75.9-61.1C329.4 367.1 278 345.3 224 338.4v16.1c50.4 6.8 98.2 27.3 138.1 59.5l79.7 64.2L444 480h2.8H456h8v-8V313.3c28.3-12.3 48-40.5 48-73.3s-19.7-61-48-73.3V8 0h-8-9.2zM192 416V352.1v-16V143.9v-16c-1.9 0-3.7 .1-5.6 .1h-2.3l-.1 0-.1 0H160L8 128H0v8V344v8H8 64V504v8h8H184h8v-8V416zM160 144h16V336H160 16V144l144 0zM464 295.4V184.6c19.1 11.1 32 31.7 32 55.4s-12.9 44.4-32 55.4zM176 352V496H80V352h80 16z'
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fast',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      'M17.5 176H216V48H74.4L17.5 176zm413 0L373.6 48H232V176H430.5zM16 192V464H432V192H16zM64 32H384l64 144V464v16H432 16 0V464 176L64 32zM325.7 261.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L128 308.7l5.7 5.7L192 372.7 314.3 250.3l5.7-5.7L331.3 256l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fast',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      'M294.2 296H278l24.8 161.5c-.4 .3-.9 .7-1.4 1c-5.5 3.9-14.1 9.4-26.1 15C251.3 484.5 213.6 496 160 496s-91.3-11.5-115.3-22.5c-12-5.5-20.6-11-26.1-15c-.5-.4-1-.7-1.4-1L42 296H25.8L0 464s48 48 160 48s160-48 160-48L294.2 296zM320 48s-48-48-160-48S0 48 0 48L25.8 216H42L17.2 54.5c.4-.3 .9-.7 1.4-1c5.5-3.9 14.1-9.4 26.1-15C68.7 27.5 106.4 16 160 16s91.3 11.5 115.3 22.5c12 5.5 20.6 11 26.1 15c.5 .4 1 .7 1.4 1L278 216h16.2L320 48zM8 248v16h8H143.6l-46 59.1-4.9 6.3 12.6 9.8 4.9-6.3L160 269l49.7 63.9 4.9 6.3 12.6-9.8-4.9-6.3-46-59.1H304h8V248h-8H160 16 8zM168 64H152v8V216h8 8V72 64zm-8 258.7l-8 10.7V440v8h16v-8V333.3l-8-10.7zM88 79.3l-.7-8L71.3 72.8l.7 8L84.3 216h16.1L88 79.3zm6.9 277.9l-15-11.3L72 431.3l-.7 8 15.9 1.4 .7-8 6.9-75.6zm145.4-11.3l-15 11.3 6.9 75.6 .7 8 15.9-1.4-.7-8-7.8-85.4zM219.6 216h16.1L248 80.7l.7-8-15.9-1.4-.7 8L219.6 216z'
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fast',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      'M422.8 336h17.7L385.9 220c-1.2-2.6-1.9-5.5-1.9-8.4c0-10.8 8.8-19.6 19.6-19.6h1.2c2.1 0 4.2 .3 6.3 1l56.3 17.8-2.1-15.6-.3-1.9-49.1-15.5c-3.6-1.1-7.3-1.7-11.1-1.7h-1.2c-19.7 0-35.6 15.9-35.6 35.6c0 5.2 1.2 10.4 3.4 15.2L422.8 336zm-.6-234.1l50.3 59.4 19.2-2.1L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L70.4 336H87.6l76.9-192.3C187.7 85.9 243.7 48 305.9 48c44.8 0 87.3 19.7 116.3 53.9zM496 384v80H16V384H496zM16 368H0v16 80 16H16 496h16V464 384 368H496 16zM562.7 170.6l-12.5-10-9.7 12.7L530 187.1 512.8 189l-15.9 1.8 2.2 15.9 2.3 17.1-10.8 13.5-10 12.5 12.7 9.7L507.1 270l1.9 17.2 1.8 15.9 15.9-2.2 17.1-2.3 13.5 10.8 12.5 10 9.7-12.7L590 292.9l17.2-1.9 15.9-1.8-2.2-15.9-2.3-17.1 10.8-13.5 10-12.5-12.7-9.7L612.9 210 611 192.8l-1.8-15.9-15.9 2.2-17.1 2.3-13.5-10.8zm15.7 26.7l16.8-2.3 1.9 16.8 .8 6.8 5.5 4.1L616.7 233l-10.6 13.2-4.3 5.4 .9 6.8 2.3 16.8L588.2 277l-6.8 .8-4.2 5.5L567 296.7l-13.2-10.6-5.4-4.3-6.8 .9L524.9 285 523 268.2l-.8-6.8-5.4-4.1L503.3 247l10.6-13.2 4.3-5.4-.9-6.8L515 204.9l16.8-1.9 6.8-.8 4.2-5.5L553 183.3l13.2 10.6 5.4 4.3 6.8-.9z'
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fast',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      'M162.3 250.3l-5.7 5.7 5.7 5.7 136 136 5.7 5.7L315.3 392l-5.7-5.7L187.3 264 504 264l8 0 0-16-8 0-316.7 0L309.7 125.7l5.7-5.7L304 108.7l-5.7 5.7-136 136zM184 464L16 464 16 48l168 0 8 0 0-16-8 0L8 32 0 32l0 8L0 472l0 8 8 0 176 0 8 0 0-16-8 0z'
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fast',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      'M287.2 328.4l-9.3-3-6.9 6.9-33.3 33.3-2.3 2.3H232 192 176v16 40 8h-8H128 112v16 40 8h-8H24 16v-8V408v-3.3l2.3-2.3L179.7 241l6.9-6.9-3-9.3c-4.9-15.4-7.6-31.8-7.6-48.8c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-17.1 0-33.5-2.7-48.8-7.6zM232 384h9.9l7-7 33.3-33.3c16.9 5.4 35 8.3 53.7 8.3c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391l-7 7V408v80 8 16H16h8 80 8 16V496v-8V464 448h16 24 8 16V432v-8V400 384h16 24zM368 184a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-24-40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fast',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      'M308.5 0h6.7 9.6 6.4l1.4 6.2L420.8 393l51.7-147.6 1.9-5.4H480 632h8v16h-8H485.7L431.6 410.6l-1.9 5.4H424h-8-6.4l-1.4-6.2L320.3 24.4 231.9 505.4l-1.2 6.6H224h-8-6.4l-1.4-6.3L153.6 256H8 0V240H8 160h6.4l1.4 6.3 51.9 237L307.3 6.6 308.5 0z'
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fast',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      'M231.4 416H320L544 80 464 0 128 224v88.6L75.3 365.3 64 376.6l11.3 11.3 80.8 80.8L167.4 480l11.3-11.3L231.4 416zm-64 41.4L86.6 376.6l52.7-52.7 4.7-4.7v-6.6V232.6l46.4-30.9 152 152L311.4 400h-80-6.6l-4.7 4.7-52.7 52.7zm36.5-264.8l258-172L523.4 82l-172 258L203.9 192.6zM2.3 474.3L0 476.7V480v24 8H8 96h3.3l2.3-2.3 30.7-30.7-11.3-11.3L92.7 496H16V483.3l60.4-60.4L65.1 411.6 2.3 474.3z'
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fast',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M16 464l416 0 0-416L16 48l0 416zM0 480l0-16L0 48 0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480zm288-96l-16 0-24 0L128 256 248 128l24 0 16 0 0 16 0 224 0 16zM254.9 144l-105 112 105 112 17.1 0 0-224-17.1 0z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fast',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      'M368 16V496H16V16H368zM16 0H0V16 496v16H16 368h16V496 16 0H368 16zM272 400H112V264H272V400zM112 112H272V248H112V112zm0-16H96v16V400v16h16H272h16V400 112 96H272 112zm96-40a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 400a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fast',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      'M16 16H368V395.6L384 359V16 0H368 16 0V16 496v16H16 144h16 64 16 77.1l7-16H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zM408 384l-4.2 9.6-42 96L359 496l-7 16h17.5 7H615.5h7H640l-7-16-2.8-6.4-42-96L584 384H573.5 418.5 408zM615.5 496H598.1 393.9 376.5l7-16 35-80H573.5l35 80 7 16zM432 272a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fast',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      'M8 32H0v8V376v8H8 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h56 8v-8V200v-3.2l-2.2-2.3-152-160L483.4 32H480 376 168 8zM480 288c-47.6 0-87.1 34.6-94.7 80H254.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H16V208H168 376 624V368H574.7c-7.6-45.4-47.1-80-94.7-80zM16 192V48H160V192H16zm160 0V48H368V192H176zm208 0V48h92.6L613.4 192H384zm16 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM160 304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fast',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      'M0 160H16.5h543H576l-4-16L544 32H32L4 144 0 160zm20.5-16l24-96H147.8l-24 96H20.5zM411.8 48l24 96H140.2l24-96L280 48v96h16V48l115.8 0zm40.5 96l-24-96H531.5l24 96H452.2zM0 248v16H8 41.1l23 161.1 1 6.9H72 96v40 8h16v-8V432H464v40 8h16v-8V432h24 6.9l1-6.9 23-161.1H568h8V248h-8H537.2l6.7-46.9 1.3-9.1H529.1l-1 6.9L497.1 416 480 416H464 112 96l-17.1 0-31-217.1-1-6.9H30.8l1.3 9.1L38.8 248H8 0z'
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fast',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      'M256 496c132.5 0 240-107.5 240-240l0-8 16 0 0 8c0 141.4-114.6 256-256 256S0 397.4 0 256l0-8 16 0 0 8c0 132.5 107.5 240 240 240zM390.1 197.2l-128 152-6.1 7.3-6.1-7.3-128-152-5.2-6.1L129 180.7l5.2 6.1L248 322.1 248 8l0-8 16 0 0 8 0 314.1L377.9 186.8l5.2-6.1L395.3 191l-5.2 6.1z'
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fast',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      'M368 320V192c0-79.5-64.5-144-144-144S80 112.5 80 192V320H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160V320H368zM16 368v96H432V368H16zm0-16H432h16v16 96 16H432 16 0V464 368 352H16zM144 192H128c0-53 43-96 96-96v16c-44.2 0-80 35.8-80 80z'
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fast',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      'M16 192c0 49.7 11.4 94.3 29.4 126.2C63.6 350.3 87.4 368 112 368H354.8c-13.6-10.2-25.5-24.7-35.3-42C299.9 291.3 288 243.9 288 192s11.9-99.3 31.5-134c9.8-17.3 21.7-31.8 35.3-42H112C87.4 16 63.6 33.7 45.4 65.8C27.4 97.7 16 142.3 16 192zM333.4 65.8C315.4 97.7 304 142.3 304 192s11.4 94.3 29.4 126.2c18.2 32.1 42 49.8 66.6 49.8s48.4-17.7 66.6-49.8c18-31.9 29.4-76.5 29.4-126.2s-11.4-94.3-29.4-126.2C448.4 33.7 424.6 16 400 16s-48.4 17.7-66.6 49.8zM496 496V291.5c-4.4 12.5-9.6 24.1-15.5 34.6c-19.5 34.5-47.6 58-80.5 58H112c-32.9 0-61-23.5-80.5-58C11.9 291.3 0 243.9 0 192S11.9 92.7 31.5 58C51 23.5 79.1 0 112 0H400c32.9 0 61 23.5 80.5 58C500.1 92.7 512 140.1 512 192V504v8h-8H168h-8v-8V416h16v80H496zM400 264c-8.7 0-15.7-4.2-20.6-9c-4.8-4.8-8.4-10.8-11.1-17.1c-5.4-12.6-8.3-28.8-8.3-45.9s2.9-33.3 8.3-45.9c2.7-6.3 6.3-12.3 11.1-17.1c4.9-4.8 11.9-9 20.6-9s15.7 4.2 20.6 9c4.8 4.8 8.4 10.8 11.1 17.1c5.4 12.6 8.3 28.8 8.3 45.9s-2.9 33.3-8.3 45.9c-2.7 6.3-6.3 12.3-11.1 17.1c-4.9 4.8-11.9 9-20.6 9zm24-72c0-30.9-10.7-56-24-56s-24 25.1-24 56s10.7 56 24 56s24-25.1 24-56zM64 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fast',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      'M160 112H16 0v16V496v16H16 256h16 96 16 10.8c-6.9-4.9-13.4-10.2-19.6-16H368 304 272V384c0-26.5 21.5-48 48-48c1 0 1.9 0 2.9 .1c1-5.3 2.2-10.6 3.6-15.8c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64V496H16V128H160h5l4.1-2.9L320 19.5 470.8 125.1 475 128h5H624V247.2c5.8 6.1 11.1 12.7 16 19.6V128 112H624 480L320 0 160 112zM72 192H64v8 80 8h8 64 8v-8V200v-8h-8H72zm8 80V208h48v64H80zM320 112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm8-112v-8H312v8 32 8h8 24 8V168h-8H328V144zM64 320v8 80 8h8 64 8v-8V328v-8h-8H72 64zm16 16h48v64H80V336zm416-96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fast',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      'M145.7 363.2L57.1 496H28.8L63 304h82.6v59.2zM49.7 288L12.5 496 9.7 512H25.9 65.7l96-144V304 288h-16-96z'
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fast',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm96 72V280v8H80v-8V104 96H96v8zm64 0V280v8H144v-8V104 96h16v8z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fast',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M336 128a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM21.7 496H426.3L372.2 320H75.8L21.7 496zM64 304H384l59.1 192 4.9 16H431.3 16.7 0l4.9-16L64 304z'
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fast',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      'M393.9 79.5c47.4 37 75.8 89.3 83.8 144.5H461.5c-7.8-50.4-34.1-98-77.5-131.9c-81.9-64-196.6-57-270.1 11.9l47.7 47.7L173 163l-11.3 11.3L144 192H32 16V176 64L33.7 46.3 45 35 56.3 46.3l46.4 46.4c79.1-74.5 203-82.2 291.3-13.2zM45 57.7l-13 13V176H137.4l13-13L45 57.7zM467 477l-11.3-11.3-45.8-45.8c-79.2 74-202.6 81.5-290.7 12.7c-47.4-37-75.8-89.3-83.8-144.5H51.6c7.8 50.4 34.1 98 77.5 131.9c81.6 63.8 196 57 269.5-11.4l-48.2-48.2L339 349l11.3-11.3L368 320H480h16v16V448l-17.7 17.7L467 477zm0-22.6l13-13V336H374.6l-13 13L467 454.3z'
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fast',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2l3.1 5.8 6.3-1.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1l-1.9 6.3 5.8 3.1C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2l-5.8 3.1 1.9 6.3c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1l-6.3-1.9-3.1 5.8C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2l-3.1-5.8-6.3 1.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1l1.9-6.3-5.8-3.1C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2l5.8-3.1-1.9-6.3c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1l6.3 1.9 3.1-5.8zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-62-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM176 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm21.7-170.3l5.7-5.7L336 164.7l-5.7 5.7-160 160-5.7 5.7L176 347.3l5.7-5.7 160-160z'
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fast',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      'M40 32H600h8V48h-8H520v96h80 8v16h-8H40 32V144h8 80V48H40 32V32h8zM504 48H392v96H504V48zM376 48H264v96H376V48zM248 48H136v96H248V48zM40 256H64c48.6 0 88 39.4 88 88V464h80V344c0-48.6 39.4-88 88-88c12.3 0 24 2.5 34.7 7.1c-3.2 4.4-6.3 8.9-9.1 13.6c-7.9-3-16.5-4.7-25.5-4.7c-39.8 0-72 32.2-72 72V472v8h-8H144h-8v-8V344c0-39.8-32.2-72-72-72H40 32V256h8zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156 76H484V420h24v24zm-4-164v8 96 8H488v-8V288v-8h16z'
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fast',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      'M0 512l3.4-17L32 352 282.3 101.7 240 59.3 109.7 189.7l-5.7 5.7L92.7 184l5.7-5.7 136-136 5.7-5.7 5.7 5.7 48 48 79-79L384 0l11.3 11.3L500.7 116.7 512 128l-11.3 11.3-79 79 0 0-11.3 11.3 0 0L160 480 17 508.6 0 512zM410.3 207l79-79L384 22.6l-79 79L410.3 207zM293.7 113L46.7 359.9 20.4 491.6l131.7-26.3L399 218.3 293.7 113z'
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fast',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      'M16 72V64H0v8V248 440v8H16v-8V256H304V440v8h16v-8V248 72 64H304v8V240H16V72zm584-8H392h-8V80h8H580.7L418.3 242.3l-2.3 2.3V256h8 96c48.6 0 88 39.4 88 88s-39.4 88-88 88H447.4c-23.5 0-43.5-17-47.3-40.1l-.2-1.2-1.3-7.9-15.8 2.6 1.3 7.9 .2 1.2c5.1 30.9 31.8 53.5 63.1 53.5H520c57.4 0 104-46.6 104-104s-46.6-104-104-104H443.3L605.7 77.7l2.3-2.3V64h-8z'
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fast',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      'M208.5 79.4V63 32 24h16v8V59.7 76.1v62 16V224v0h32v0h240 16l-.9 16-2.7 45.2c-4.9 82.9-54.4 153.1-124.4 187.7V496v16h-16-224-16V496 472.9C58.5 438.2 9 368.1 4.1 285.2L1.4 240 .5 224h16 144V158.2L9 168l-8 .5-1-16 8-.5 152.5-9.8V89.3L12 119.8l-7.8 1.6L1 105.8l7.8-1.6L160.5 72.9V48 40h16v8V69.6 86v55.2 16V224v0h32v0V155.1v-16V79.4zm0 160.6h-32v0h-16v0H17.5l2.6 44.2c4.5 77 50.5 142.1 115.5 174.3l8.9 4.4v9.9V496h224V472.9v-9.9l8.9-4.4c65-32.2 111-97.4 115.5-174.3l2.6-44.2h-271v0h-16v0zm48-104L504 120l8-.5 1 16-8 .5L256.5 152V136zm0-82.8L502.9 2.4l7.8-1.6 3.2 15.7-7.8 1.6L256.5 69.5V53.1z'
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fast',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      'M425.7 86.3l-33.9 33.9-11.3 11.3L267.3 244.7 256 256l11.3 11.3L380.5 380.5l11.3 11.3 33.9 33.9L437 437c-3.8 3.8-7.7 7.4-11.7 11c-45.1 39.8-104.4 64-169.4 64C114.6 512 0 397.4 0 256S114.6 0 256 0c64.9 0 124.2 24.2 169.4 64c4 3.5 7.9 7.2 11.7 11L425.7 86.3zM414 75.4C371.8 38.4 316.5 16 256 16C123.5 16 16 123.5 16 256s107.5 240 240 240c60.5 0 115.8-22.4 158-59.4l-34-34C346.5 430.9 303.3 448 256 448C150 448 64 362 64 256S150 64 256 64c47.3 0 90.5 17.1 124 45.4l34-34zM256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c42.8 0 82.1-15.3 112.6-40.7L244.7 267.3 233.4 256l11.3-11.3L368.6 120.7C338.1 95.3 298.8 80 256 80zM560 256c0-60.5-22.4-115.8-59.4-158l-34 34c28.3 33.5 45.4 76.7 45.4 124s-17.1 90.5-45.4 124l34 34c37-42.2 59.4-97.5 59.4-158zM455.3 143.4L342.6 256 455.3 368.6C480.7 338.1 496 298.8 496 256s-15.3-82.1-40.7-112.6zM501 437l-11.3-11.3-33.9-33.9-11.3-11.3L331.3 267.3 320 256l11.3-11.3L489.7 86.3 501 75c3.8 3.8 7.4 7.7 11 11.7c39.8 45.1 64 104.4 64 169.4s-24.2 124.2-64 169.4c-3.5 4-7.2 7.9-11 11.7zM144 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM208 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fast',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M8 32H0v8V256 472v8H8 312h8V464h-8H16V256H248h8V240h-8H16V48H312c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z'
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fast',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      'M8 32H0V48H8 147l27.7 57.5L11.8 480H29.2L183.8 124.5l169 351L355 480h5 80 8V464h-8H365L159.2 36.5 157 32h-5H8z'
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fast',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      'M123.3 500.7L112 512l-11.3-11.3L43.3 443.3 32 432l11.3-11.3L452.7 11.3 464 0l11.3 11.3 57.4 57.4L544 80 532.7 91.3 123.3 500.7zM521.4 80L464 22.6l-135 135L386.3 215l135-135zM54.6 432L112 489.4l263-263L317.7 169 54.6 432zM104 64v56h56 8v16h-8H104v56 8H88v-8V136H32 24V120h8H88V64 56h16v8zM488 312v8 56h56 8v16h-8H488v56 8H472v-8V392H416h-8V376h8 56V320v-8h16zM232 32V56h24 8V72h-8H232V96v8H216V96 72H192h-8V56h8 24V32 24h16v8z'
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fast',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64c0-32.6-24.4-59.6-56-63.5V80 72H248v8V288.5c-31.6 3.9-56 30.9-56 63.5c0 35.3 28.7 64 64 64zM144 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm304 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM384 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fast',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      'M331.5 .2l5.7 5.7 20.5 20.5 128 128 20.5 20.5 5.7 5.7-11.3 11.3-5.7-5.7L480 171.3l-98.3 98.3L168.2 483.1C149.7 501.6 124.6 512 98.5 512C44.1 512 0 467.9 0 413.5c0-26.1 10.4-51.2 28.9-69.7l85.5-85.5L340.7 32 325.9 17.2l-5.7-5.7L331.5 .2zM352 43.3L139.3 256H372.7l96-96L352 43.3zM356.7 272H123.3L40.2 355.1C24.7 370.6 16 391.6 16 413.5C16 459.1 52.9 496 98.5 496c21.9 0 42.9-8.7 58.3-24.2L356.7 272z'
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fast',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM166.3 374.9L188 288l4-16H175.5 128 112V256v-8L267.6 127.8 288 112l-6.3 25.1L260 224l-4 16h16.5H320h16v16 8L180.4 384.2 160 400l6.3-25.1zM192 256h20.5l-5 19.9-20.8 83.3L320 256.1V256H256 235.5l5-19.9 20.8-83.3L128 255.9v.1h64z'
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fast',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      'M512 248l-63.7 19.1L432 272l10.2 13.6L480 336l-48 48-78.2-6.5L336 376l6.6 16.6L352 416l-64 64-96-48H96 91.3L17.2 506.1l-5.7 5.7L.2 500.5l5.7-5.7L80 420.7V416l0-96L32 224l64-64 23.4 9.4L136 176l-1.5-17.8L128 80l48-48 50.4 37.8L240 80l4.9-16.3L264 0h72l32 48 64-16 48 48-16 64 48 32v72zM96 404.7L306.3 194.3l5.7-5.7L323.3 200l-5.7 5.7L107.3 416H192h3.8l3.4 1.7 85.7 42.8 48.4-48.4-12.1-30.2-9.6-24 25.8 2.2 88.6 7.4 32.9-32.9-39.7-52.9-13.8-18.3 22-6.6L496 236.1V184.6l-40.9-27.2-9.4-6.3 2.7-10.9 13.8-55.2L427.1 49.7 371.9 63.5l-10.9 2.7-6.3-9.4L327.4 16H275.9L255.3 84.6l-6.6 22L230.4 92.8 177.5 53.1 144.6 86.1l7.4 88.6 2.2 25.8-24-9.6L99.9 178.8 51.5 227.2l42.8 85.7 1.7 3.4V320l0 84.7z'
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fast',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      'M376 0h-8V16h8H484.7L392 108.7 349.7 66.3 344 60.7 332.7 72l5.7 5.7L380.7 120l-50.3 50.3-3.7 3.7c-31.3-28.6-72.9-46-118.7-46c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-45.7-17.4-87.4-46-118.7l3.7-3.7L392 131.3l42.3 42.3 5.7 5.7L451.3 168l-5.7-5.7L403.3 120 496 27.3V136v8h16v-8V8 0h-8H376zM48 304a160 160 0 1 1 320 0A160 160 0 1 1 48 304z'
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fast',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM184 128H288c48.6 0 88 39.4 88 88s-39.4 88-88 88H192v72 8H176v-8V304 288 136v-8h8zM288 288c39.8 0 72-32.2 72-72s-32.2-72-72-72H192V288h96z'
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fast',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      'M452.7 14.1L430.1 36.7 418.7 48l11.3 11.3 11.3 11.3 128 128 11.3 11.3L592 221.3l11.3-11.3 22.6-22.6L637.3 176l-11.3-11.3-11.3-11.3-128-128L475.3 14.1 464 2.7 452.7 14.1zM441.4 48L464 25.4l11.3 11.3 128 128L614.6 176 592 198.6l-11.3-11.3-128-128L441.4 48zM413.1 87.6l-82.6 82.6-.1 .1-.1 .1-47.9 47.9-1.7 1.7-.5 2.4L248.6 380.1l-.1 .1L133.9 494.8l-5.7 5.7 11.3 11.3 5.7-5.7 6.8-6.8 0 0 5.7-5.7L259.9 391.4l157.6-31.5 2.4-.5 1.7-1.7L552.4 226.9l-11.3-11.3L464 292.7 347.3 176l77.1-77.1L413.1 87.6zM295.4 227.9L336 187.3 452.7 304l-40.6 40.6L266.2 373.8l29.2-145.9zM187.3 14.1L176 2.7 164.7 14.1 153.4 25.4l-128 128L14.1 164.7 2.7 176l11.3 11.3 22.6 22.6L48 221.3l11.3-11.3 11.3-11.3 128-128 11.3-11.3L221.3 48 209.9 36.7 187.3 14.1zM198.6 48L187.3 59.3l-128 128L48 198.6 25.4 176l11.3-11.3 128-128L176 25.4 198.6 48zm98.7 110.1L226.9 87.6 215.6 98.9l70.5 70.5 11.3-11.3zM223.9 340.6l-125-125L87.6 226.9 218.3 357.7l1.7 1.7 .1 0 3.8-18.8zm163.3 58l95.1 95.1 5.7 5.7 0 0 6.8 6.8 5.7 5.7 11.3-11.3-5.7-5.7-100.1-100-18.9 3.8z'
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fast',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      'M272 48V464H176V48h96zM176 32H160V48 464v16h16 96 16V464 48 32H272 176zM112 240V464H16V240h96zM16 224H0v16V464v16H16h96 16V464 240 224H112 16zM336 112h96V464H336V112zM320 96v16V464v16h16 96 16V464 112 96H432 336 320z'
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fast',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      'M76.5 80h359l15.6 62.4c8.6 34.3 12.9 69.5 12.9 104.8v17.7c0 35.3-4.3 70.5-12.9 104.8L435.5 432H76.5L60.9 369.6C52.3 335.4 48 300.2 48 264.8V247.2c0-35.3 4.3-70.5 12.9-104.8L76.5 80zM437.2 64H74.8L55.6 16H456.4L437.2 64zM74.8 448H437.2l19.2 48H55.6l19.2-48zM32 0l6.4 16L61.5 73.8 45.4 138.5C36.5 174 32 210.5 32 247.2v17.7c0 36.6 4.5 73.1 13.4 108.7l16.2 64.6L38.4 496 32 512H49.2 462.8 480l-6.4-16-23.1-57.8 16.2-64.6c8.9-35.5 13.4-72 13.4-108.7V247.2c0-36.6-4.5-73.1-13.4-108.7L450.5 73.8 473.6 16 480 0H462.8 49.2 32zm96 160v8 8c0 68 53 123.6 120 127.8V368v8h16v-8V303.8C331 299.6 384 244 384 176v-8-8h-8H344.7c-38.8 0-71.2 21-88.7 50.9C238.5 181 206.1 160 167.3 160H136h-8zM264 287.7V230.9c12.5-31.5 43-54.9 80.7-54.9H368c0 59.2-45.9 107.6-104 111.7zm-16-56.9v56.9c-58.1-4.1-104-52.6-104-111.7h23.3c37.7 0 68.2 23.4 80.7 54.9z'
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fast',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM327.3 111.9l11.3 11.3 50.2 50.2 11.3 11.3L388.8 196 214.3 370.6l-69.7 10.9L128 384l2.6-16.6 10.9-69.7L327.3 111.9zM156.4 305.4l-9.3 59.5 59.5-9.3L336.4 225.8l-50.2-50.2L156.4 305.4zM377.5 184.7l-50.2-50.2-29.8 29.8 50.2 50.2 29.8-29.8z'
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fast',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      'M136 48.1l80 138.6c-23.9 13.8-40 39.7-40 69.3H160L16 256H0c0-5.4 .2-10.7 .5-16C5.6 157.6 49.6 85.8 114.4 42.7c4.4-3 9-5.8 13.6-8.4l8 13.9zM194.8 182L122.4 56.6C62.4 96.9 21.6 163.6 16.5 240l144.8 0c3.9-23.2 16.1-43.6 33.5-58zM216 325.3l.1 .1c11.7 6.8 25.4 10.6 39.9 10.6s28.1-3.9 39.9-10.6l.1-.1 8 13.9 80 138.6-.4 .2c-4.5 2.6-9 5-13.7 7.3C335.6 502.4 296.9 512 256 512s-79.6-9.6-113.9-26.7c-4.6-2.3-9.2-4.8-13.7-7.3l-.4-.2 80-138.6 8-13.9zM256 496c38 0 74-8.8 105.9-24.6L289.5 346c-10.4 3.9-21.7 6-33.5 6s-23-2.1-33.5-6L150.1 471.4C182 487.2 218 496 256 496zM397.6 42.7C462.4 85.8 506.4 157.6 511.5 240c.3 5.3 .5 10.6 .5 16H496l-144 0H336c0-29.6-16.1-55.5-40-69.3L376 48.1l8-13.9c4.6 2.7 9.2 5.5 13.6 8.4zm-8 13.9L317.2 182c17.4 14.4 29.6 34.8 33.5 58l144.8 0c-5-76.4-45.8-143.1-105.9-183.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fast',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM434.8 438.4v50L324.9 459.1l-2.1-.5-2.1 .5L210.8 488.4V446.8l60.8-45.6 3.2-2.4v-4-69V315.3l-10.1 2.8L82.8 368.3V295.5L183.5 240l-13.6-10.8L70.9 283.8l-4.1 2.3v4.7 88 10.5l10.1-2.8 181.9-50.2v54.5L198 436.4l-3.2 2.4v4 56 10.4l10.1-2.7 117.9-31.5 117.9 31.5 10.1 2.7V498.8 451l-16-12.6zM258.8 92v24l16 12.6V92c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5v92.9 4.7l4.1 2.3L562.8 295.5v60.4l16 12.6V290.8v-4.7l-4.1-2.3L386.8 180.1V92c0-16.6-6.7-38.3-17.3-55.8C359 19 343 2.8 322.8 2.8C303 2.8 287 19 276.5 36.1C265.7 53.6 258.8 75.4 258.8 92z'
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fast',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      'M48 80V432H400V288 272 80H368 48zM416 288V432v16H400 48 32V432 80 64H48 368h32 16 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H416zm0-16h48c53 0 96-43 96-96s-43-96-96-96H416V272z'
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fast',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      'M168 0V8 64h80V8 0h16V8 64h80V8 0h16V8 64h72 16V80v72h56 8v16h-8H448v80h56 8v16h-8H448v80h56 8v16h-8H448v72 16H432 360v56 8H344v-8V448H264v56 8H248v-8V448H168v56 8H152v-8V448H80 64V432 360H8 0V344H8 64V264H8 0V248H8 64V168H8 0V152H8 64V80 64H80h72V8 0h16zm0 80H152 80v72 16 80 16 80 16 72h72 16 80 16 80 16 72V360 344 264 248 168 152 80H360 344 264 248 168zm160 96h16v8V328v8H328v-8V184v-8zM131.7 336l69-155.2 2.1-4.8h10.4l2.1 4.8 69 155.2H266.8l-14.2-32H248 168h-4.6l-14.2 32H131.7zm113.8-48L208 203.7 170.5 288h74.9z'
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fast',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      'M432 496H80V336H64V496v16H80 432h16V496 160L288 0H80 64V16 256H80V16H272V168v8h8H432V496zm-6.6-336H288V22.6L425.4 160zM263.2 228.4l-7.6-15.2-6.9 15.5L190.9 358.7l-40.1-66.8-2.3-3.9H144 8 0v16H8 139.5l45.7 76.1 7.9 13.2 6.3-14.1 57.1-128.5 24.4 48.8 2.2 4.4H288h64 8V288h-8H292.9l-29.8-59.6z'
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fast',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      'M16 48V464H560V48H16zM0 32H16 560h16V48 464v16H560 16 0V464 48 32zM96 352h96v16H96V352zm128 0H384v16H224V352z'
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fast',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      'M288 16C166 16 65.2 107.1 50 225l-15.9-2C50.3 97.2 157.8 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-70.4 0-134.1-28.4-180.4-74.3l11.3-11.4C162.3 469.4 222 496 288 496c132.5 0 240-107.5 240-240S420.5 16 288 16zM203.3 168l-5.7 5.7-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L203.3 168zm175 5.7l-5.7-5.7L384 156.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.2-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zm5.3 98.3a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200 400c0-44.2 35.8-80 80-80h16c44.2 0 80 35.8 80 80v8 8h-8H208h-8v-8-8zm80-64c-35.3 0-64 28.7-64 64H360c0-35.3-28.7-64-64-64H280zM28.1 326.5c-7.4 9.2-10.9 21-9.7 32.8c2.3 23.1 21.8 40.7 45 40.7h1.2c23.2 0 42.7-17.6 45-40.7c1.2-11.8-2.3-23.5-9.7-32.8L64 281.6 28.1 326.5zm-12.5-10l38.2-47.7L64 256l10.2 12.8 38.2 47.7c10 12.5 14.7 28.4 13.1 44.4C122.4 392.2 96 416 64.6 416H63.4C32 416 5.6 392.2 2.5 360.9C.9 344.9 5.6 329 15.6 316.5z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fast',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M272 96L224 32H16 0V48 464v16H16 496h16V464 112 96H496 272zm224 16V464H16V48H216l43.2 57.6L264 112h8H496z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fast',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      'M512 0L0 0 0 16l512 0V0zM208 112l0 384L80 496l0-384 128 0zM80 96H64l0 16 0 384 0 16H80 208h16V496l0-384V96l-16 0L80 96zm352 16l0 256H304l0-256 128 0zM304 96H288v16l0 256v16h16H432h16V368l0-256V96H432L304 96z'
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fast',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      'M16 496l96 0 0 16-96 0L0 512l0-16L0 16 0 0 16 0 224 0 384 160l0 144-16 0 0-128-152 0-8 0 0-8 0-152L16 16l0 480zM361.4 160L224 22.6 224 160l137.4 0zM200 368l16 0c17.7 0 32 14.3 32 32l0 8 0 8-16 0 0-8 0-8c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-8 0-8 16 0 0 8 0 8c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-80c0-17.7 14.3-32 32-32zm128 0l16 0c17.7 0 32 14.3 32 32l0 40 0 64 0 8-16 0 0-8 0-56-48 0 0 56 0 8-16 0 0-8 0-64 0-40c0-17.7 14.3-32 32-32zm32 64l0-32c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 32 48 0zm64-64l8 0 32 0c22.1 0 40 17.9 40 40l0 64c0 22.1-17.9 40-40 40l-32 0-8 0 0-8 0-128 0-8zm16 128l24 0c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24l-24 0 0 112z'
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fast',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      'M160 0h-4.4l-2.4 3.8L115.6 64H0V80H448V64H332.4L294.8 3.8 292.4 0H288 160zM313.6 64H134.4l30-48H283.6l30 48zM24 112l.1 .8 40 392 .7 7.2H72 376h7.2l.7-7.2 40-392 .1-.8H408L368.8 496H79.2L40 112H24zm208 80H216v8 80H136h-8v16h8 80v80 8h16v-8V296h80 8V280h-8H232V200v-8z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fast',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zM192 96v8 29.6c-11 4.4-20.9 10.2-30.3 17.5l-25.6-14.8-6.9-4-4 6.9-24 41.6-4 6.9 6.9 4 25.6 14.8c-.9 5.6-1.6 11.5-1.6 17.5s.7 11.9 1.6 17.5l-25.6 14.8-6.9 4 4 6.9 24 41.6 4 6.9 6.9-4 25.6-14.8c9.3 7.3 19.2 13.1 30.3 17.5V344v8h8 48 8v-8V314.4c11-4.4 20.9-10.2 30.3-17.5l25.6 14.8 6.9 4 4-6.9 24-41.6 4-6.9-6.9-4-25.6-14.8c.9-5.6 1.6-11.5 1.6-17.5s-.7-11.9-1.6-17.5l25.6-14.8 6.9-4-4-6.9-24-41.6-4-6.9-6.9 4-25.6 14.8c-9.3-7.3-19.2-13.1-30.3-17.5V104 96h-8H200h-8zm16 16h32v27.1 5.7l5.3 1.9c13.1 4.6 24.3 11.1 34.9 20.2l4.3 3.7 4.9-2.8L313 154.1l16 27.7-23.5 13.6-4.9 2.8 1 5.6c1.3 7.1 2.4 13.7 2.4 20.2s-1 13.1-2.4 20.2l-1 5.6 4.9 2.8L329 266.1l-16 27.7-23.5-13.6-4.9-2.8-4.3 3.7c-10.6 9.1-21.8 15.6-34.9 20.2l-5.3 1.9v5.7V336H208V308.9v-5.7l-5.3-1.9c-13.2-4.6-24.3-11.1-34.9-20.2l-4.3-3.7-4.9 2.8L135 293.9l-16-27.7 23.5-13.6 4.9-2.8-1-5.6c-1.3-7.1-2.4-13.7-2.4-20.2s1-13.1 2.4-20.2l1-5.6-4.9-2.8L119 181.9l16-27.7 23.5 13.6 4.9 2.8 4.3-3.7c10.6-9.1 21.8-15.6 34.9-20.2l5.3-1.9v-5.7V112zm16 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fast',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      'M229.7 10.3L224 4.7l-5.7 5.7-136 136L76.7 152 88 163.3l5.7-5.7L216 35.3 216 344l0 8 16 0 0-8 0-308.7L354.3 157.7l5.7 5.7L371.3 152l-5.7-5.7-136-136zM16 328l0-8L0 320l0 8L0 504l0 8 8 0 432 0 8 0 0-8 0-176 0-8-16 0 0 8 0 168L16 496l0-168z'
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fast',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      'M56 512H48v-8V256H8 0v-8V152C0 68.1 68.1 0 152 0h80c83.9 0 152 68.1 152 152v8 8 64 72 8h-8H304v8 8h-8H224v24 8h-8H144V504v8h-8H56zm88-168h64l0-16v-8V256H144v88zm64-104l0 0 0-64H104 96V160h8H208h8 8 64 8 8 64v-8c0-75.1-60.9-136-136-136H152C76.9 16 16 76.9 16 152v88H48v0H64v0h64v0h16v0h64zm16 0l0 8v8l0 56h64v-8V176H224l0 64zm-96 16H64V496h64V360v-8V256zm240-24V176H304V296h64V232z'
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fast',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      'M232 0h60.2H296h8 64 8 3.8H440h3.3l2.3 2.3 32 32 3.8 3.8-2.1 5L457.4 94.3l36.7 44.6 1.8 2.2V144v40 5.6l-5.3 1.9-87.1 31.7-47.2 31.5-2 1.3H352 336 320h-2.4l-2-1.3-47.2-31.5-87.1-31.7-5.3-1.9V184 144v-2.9l1.8-2.2 36.7-44.6L192.6 43.2l-2.1-5 3.8-3.8 32-32L228.7 0H232zM367.8 227.9l27.8-18.5 .8-.5 .9-.3 4.5-1.6-51.5-41.2c-6.3-5.1-11.2-11.5-14.2-18.7c-3.1 7.2-7.9 13.6-14.2 18.7l-51.5 41.2 4.5 1.6 .9 .3 .8 .5 27.8 18.5c-.2-1.3-.2-2.6-.2-3.9c0-17.7 14.3-32 32-32s32 14.3 32 32c0 1.3-.1 2.6-.2 3.9zM336 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM299.8 16l-80.8 98.2L266.9 86c25.7-15.1 58-3.5 69.1 22.6c11.2-26.1 43.4-37.7 69.1-22.6l47.9 28.2L372.2 16H368 304h-4.2zM446 80.4l16.5-38.6L436.7 16H393l53 64.4zM235.3 16L209.5 41.8 226 80.4 279 16H235.3zm184 184.4l60.6-22V148.6L397 99.8c-19.3-11.3-44-.3-48.3 21.6c-2.4 11.9 2.1 24.2 11.6 31.7l59.1 47.3zM311.8 153.1c9.5-7.6 13.9-19.8 11.6-31.7c-4.4-21.9-29.1-33-48.3-21.6l-83 48.8v29.8l60.6 22 59.1-47.3zm138.4 77.4C469 249.7 480 275.8 480 303.4V328v4.2l-3.5 2.4-66.7 45.3-5.5 3.7-4.7-4.7-37.3-37.3-5.7-5.7 5.7-5.7 48-48 5.7-5.7L427.3 288l-5.7 5.7L379.3 336l26.9 26.9L464 323.8V303.4c0-26.3-11.8-51-31.6-67.6l17.8-5.3zm-242.6-4.3l7.3 2.2C149.9 254.3 104 317.8 104 392v8 8H88v-8-8c0-19.5 2.9-38.3 8.3-56H16v72c0 48.6 39.4 88 88 88H336V472c0-22.1-17.9-40-40-40H248h-8V416h8 48c30.9 0 56 25.1 56 56v24H464V472c0-22.1-17.9-40-40-40H408h-8V416h8 16c30.9 0 56 25.1 56 56v24 8 8h-8H104C46.6 512 0 465.4 0 408V40 32H8 120h8v8V274.7c17.5-22.6 39.9-41.2 65.7-54.2c4.4 2.4 9 4.3 13.9 5.8zM102 320c2.9-7.2 6.3-14.3 10-21V240H16v80h86zm10-176H16v80h96V144zm0-16V48H16v80h96zM287.5 380.6l-82.7-37.3-7.3-3.3 6.6-14.6 7.3 3.3 77 34.7 20.3-25.9-57.5-43.1-6.4-4.8 9.6-12.8 6.4 4.8 64 48 6.5 4.9-5.1 6.4L297 378.2l-3.9 4.9-5.7-2.6zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fast',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      'M472 448h-3.8l-2.4-2.9L164.2 80H8 0V64H8 168h3.8l2.4 2.9L475.8 432H632h8v16h-8H472zM424 80h-8V64h8H632h8V80h-8H424z'
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fast',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      'M0 352c5.1-2.3 10.1-4.6 15-6.9c144.5-67 169.2-109.5 195.8-155.2C239.1 141.4 269.6 89.2 448 0L565.8 147.2 576 160c-5 2.5-9.8 4.9-14.6 7.4C395.9 252.1 366.4 302.8 338.8 350c-27.5 47.2-53 91-210.8 162L10.3 364.9 0 352zm75.8 69.1c118-60.7 168.5-128 214.4-189.4l3.4-4.6c24-32 47.5-62.7 79.3-89.3c29.4-24.6 65.6-45.7 115.7-61.6L443.6 20.1C363.3 61 315.8 93.5 285.2 120.9c-31.6 28.3-45.7 51.7-59.4 75.1l-1.3 2.2c-13.7 23.4-27.8 47.8-58.5 74.8c-28.7 25.3-71.3 52.5-140.8 85l50.5 63.1zM86 433.9l46.7 58.4C205 459 246.5 432.3 272.9 409c26.7-23.6 38.7-44.1 52.2-67.3l1-1.8c14.3-24.5 30.3-51.2 65.6-82.9c32.6-29.2 81.2-62.2 159.4-102.5L499.3 89.7C448 105.2 411.9 126 383.1 150.1c-30.2 25.3-52.7 54.6-76.7 86.7l-3.4 4.6c-46 61.4-97.8 130.5-217 192.5z'
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fast',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      'M160 0h96 4.4l2.4 3.8L300.4 64H416V80H0V64H115.6L153.2 3.8 155.6 0H160zM281.6 64l-30-48H164.4l-30 48H281.6zM448 128H640v16H448V128zm0 128H608v16H448V256zm96 128v16H448V384h96zM64 504.7L31.3 112H47.4l32 384H336.6l32-384h16.1L352 504.7l-.6 7.3H344 72 64.6l-.6-7.3z'
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fast',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM72 240H312h8v16h-8H72 64V240h8zm304 0h64 8v16h-8H376h-8V240h8zM72 304h96 8v16h-8H72 64V304h8zm160 0H440h8v16h-8H232h-8V304h8z'
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fast',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      'M328.2 64h38.7c93.2 0 172.9 66.9 189.1 158.6l16.8 95.5L576 336l-17.3-5.7L281.9 238.3 17.3 330 0 336l3.2-18L20 222.6C36.2 130.9 115.9 64 209.1 64H327.8c.1 0 .3 0 .4 0zM271.1 195.8l-3.8 7.1-14.1-7.5 3.8-7.1L314.7 80H209.1c-1.6 0-3.1 0-4.7 .1L110.8 228.3l-4.3 6.8L93 226.5l4.3-6.8 87.2-138C109.9 92.2 49.2 149.5 35.8 225.4L20.5 312l256.2-88.8 5.1-1.8 5.2 1.7 268.6 89.2-15.3-86.9c-7.6-43.3-30.7-80.6-63-106.5L414.9 228l-4 6.9L397.1 227l4-6.9 63.2-110.6C436.2 90.7 402.6 80 366.9 80H332.8L271.1 195.8zM128 448c-50.8 0-92.3-39.4-95.8-89.3L48 353.2c.7 43.6 36.2 78.8 80 78.8c16 0 30.8-4.7 43.3-12.7l8.7-5.6 8.7 5.6C201.2 427.3 216 432 232 432c17.4 0 33.5-5.6 46.7-15l9.3-6.7 9.3 6.7c13.1 9.4 29.2 15 46.7 15c16 0 30.8-4.7 43.3-12.7l8.7-5.6 8.7 5.6C417.2 427.3 432 432 448 432c43.6 0 79-34.9 80-78.2l15.8 5.2c-3.6 49.7-45.1 89-95.7 89c-19.2 0-37-5.6-52-15.3c-15 9.7-32.8 15.3-52 15.3c-20.9 0-40.2-6.7-56-18c-15.8 11.3-35.1 18-56 18c-19.2 0-37-5.6-52-15.3c-15 9.7-32.8 15.3-52 15.3z'
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fast',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-408a152 152 0 1 1 0 304 152 152 0 1 1 0-304zm0 320a168 168 0 1 0 0-336 168 168 0 1 0 0 336zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm128 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z'
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fast',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 440l0 8 16 0 0-8L16 72l0-8L0 64l0 8L0 440zM98.3 250.3L92.7 256l5.7 5.7 136 136 5.7 5.7L251.3 392l-5.7-5.7L123.3 264 440 264l8 0 0-16-8 0-316.7 0L245.7 125.7l5.7-5.7L240 108.7l-5.7 5.7-136 136z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fast',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM128 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM89.3 268.4l13.3-8.9C112.3 274 144.2 304 192 304s79.7-30 89.3-44.4l13.3 8.9C282.9 286 246.6 320 192 320s-90.9-34-102.7-51.6z'
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fast',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      'M16 240V368H218.2l30.2-90.5 1.8-5.5H256 464V240C464 116.3 363.7 16 240 16S16 116.3 16 240zm464 0v32h24 8v16h-8H480 464 368V496H472h8v16h-8H360h-3.2l-2.3-2.2L220.8 384H8 0v-8V240C0 107.5 107.5 0 240 0S480 107.5 480 240zM261.8 288l-28.6 85.7L352 485.5V288H261.8zM144 104v72c0 17.7 14.3 32 32 32s32-14.3 32-32V104 96h16v8 72c0 26.5-21.5 48-48 48s-48-21.5-48-48V104 96h16v8zm120-8h8 4.6l2.3 4L336 199.9V104 96h16v8V216v8h-8-8-4.6l-2.3-4L272 120.1V216v8H256v-8V104 96h8z'
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fast',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      'M568.9 301.7c-.9 5.3-1.9 10.6-3.1 15.9l-15.2-5.5-108-39.3 0 0-15-5.5L229.9 195.4l-15-5.5 0 0L103.6 149.4l-15.2-5.5c2.5-4.8 5.1-9.6 7.8-14.2C157.2 27.2 283.5-21.4 399.8 18.9c.9 .3 1.7 .6 2.6 .9l5.9 2.1c2.5 .9 5 1.9 7.4 3c110 46.3 172 161.9 153.2 276.8zM394.7 34c-30-9.9-63.2-1.7-85 21.4c-30.9 32.6-54.7 71.3-70.1 113.5l-4.1 11.4 197.7 71.9 4.2-11.4c15.4-42.2 21.9-87.1 19.3-132c-1.8-30.2-20.1-56.7-47.2-69.3c-3.6-1.5-7.3-3-11-4.3c-1.2-.4-2.4-.9-3.6-1.3zM331.8 21.3c-88.1-5.8-173.6 37.9-220.2 114l108.8 39.6 4.1-11.4c16.1-44.3 41.1-84.8 73.5-119c9.7-10.2 21.2-18 33.7-23.2zM448.1 257.8l105.5 38.4c13-86.5-22.7-173-91-225.6c5.7 11.5 9.1 24.1 9.9 37.4c2.8 47-4.1 94.1-20.2 138.4l-4.1 11.4zM8 496H222.1l1.8-4.9 84.8-233 15 5.5L239.1 496H568h8v16h-8H8 0V496H8z'
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fast',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      'M184.5 57.1l-1 6.9-7 0-.5 0c-26.5 0-48 21.5-48 48c0 7.7 1.8 14.9 5 21.3l4.8 9.7L127 144.7C100.4 149 80 172.1 80 200c0 12.3 4 23.6 10.7 32.9l5.9 8.2-9.3 3.9C64.2 254.6 48 277.4 48 304c0 28.8 19 53.2 45.3 61.2l7.7 2.4-2.4 7.7C96.9 380.5 96 386.2 96 392c0 30.9 25.1 56 56 56c5.1 0 10-.7 14.7-1.9l8.6-2.3 1.4 8.7c4 24.7 25.5 43.5 51.3 43.5h52V448v-4V64 16H232c-24.2 0-44.2 17.9-47.5 41.1zM280 512H228c-30.9 0-57-20.6-65.2-48.8c-3.5 .5-7.1 .8-10.8 .8c-39.8 0-72-32.2-72-72c0-4.8 .5-9.5 1.4-14.1C52.4 365.9 32 337.3 32 304c0-29.9 16.4-56 40.7-69.7C67.1 224.1 64 212.4 64 200c0-32.4 21.4-59.8 50.9-68.9c-1.9-6-2.9-12.5-2.9-19.1c0-33.3 25.4-60.7 57.9-63.7C177 20.5 202.1 0 232 0h48 8 8 48c29.9 0 55 20.5 62.1 48.3C438.6 51.3 464 78.7 464 112c0 6.7-1 13.1-2.9 19.1c29.5 9 50.9 36.4 50.9 68.9c0 2.6-.1 5.2-.4 7.8H495.5c.3-2.5 .5-5.1 .5-7.8c0-27.9-20.4-51-47-55.3L438.2 143l4.8-9.7c3.2-6.4 5-13.6 5-21.3c0-26.5-21.5-48-48-48l-.5 0-7 0-1-6.9C388.2 33.9 368.2 16 344 16H296V64 444v4 48h36.6c4.7 6 9.6 11.3 14.4 16H296h-8-8zM479.4 241l.6-.8v1.1l-.6-.2zM400 464v29.4V512s-6.8-3.4-16-10.2c-19-14.1-48-42.7-48-85.8c0-61.9 50.1-112 112-112h48 16V288 256 240h16L628.7 340.7 640 352l-11.3 11.3L528 464H512V448 416 400H496 464c-35.3 0-64 28.7-64 64zm128-64v41.4L617.4 352 528 262.6V304v16H512 448c-53 0-96 43-96 96c0 26.3 13.1 46.4 27.3 60.7c1.6 1.6 3.1 3 4.7 4.4V464c0-44.2 35.8-80 80-80h48 16v16z'
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fast',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      'M16 320a144 144 0 1 1 288 0A144 144 0 1 1 16 320zm84.6-148.6L234.8 32H212.6L46.6 204.4C16.7 235.4 0 276.9 0 320c0 88.4 71.6 160 160 160s160-71.6 160-160s-71.6-160-160-160c-21 0-41.1 4-59.4 11.4z'
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fast',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM96 288v16H480V288H96zm0 64v16h96V352H96zm288 0H224v16H384V352zm16-240h96v80H400V112zM384 96v16 80 16h16 96 16V192 112 96H496 400 384z'
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fast',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      'M512 112v80 16 96 16 80H16V112H512zm16 288V320h32 16V304 208 192H560 528V112 96H512 16 0v16V400v16H16 512h16V400zm0-96V208h32v96H528zM80 176h64V336H80V176zM64 160v16V336v16H80h64 16V336 176 160H144 80 64z'
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fast',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      'M8 56H0V72H8 440h8V56h-8H8zM0 184v16H8 440h8V184h-8H8 0zM8 312H0v16H8 440h8V312h-8H8zM8 440H0v16H8 440h8V440h-8H8z'
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fast',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      'M432 224A208 208 0 1 0 16 224a208 208 0 1 0 416 0zm16 0c0 121-96 219.6-216 223.9V496H376h8v16h-8H224 72 64V496h8H216V447.9C96 443.6 0 345 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM186.3 66.7l40.5 100.1c20.6-21 50.5-32.2 81.9-27.8c52.5 7.4 89.1 55.9 81.7 108.4l-2.2 15.8-1.1 7.9-7.9-1.1L272.2 255c7.9 28.3 2.7 59.9-16.8 84.8c-32.6 41.8-93 49.2-134.8 16.5L108 346.5l-6.3-4.9 4.9-6.3 66.5-85.1c-28.5-7.4-53.2-27.6-65-57c-19.9-49.2 3.9-105.1 53-125l14.8-6 7.4-3 3 7.4zM167.1 83.1c-41 16.6-60.8 63.2-44.2 104.1c11.4 28.3 37.2 46.5 65.5 49.6l14.3 1.6-8.8 11.3-69.7 89.2 6.3 4.9c34.8 27.2 85.1 21 112.3-13.8c18.8-24 21.7-55.4 10.2-81.5l-5.8-13.1 14.2 2 112.1 15.8 1.1-7.9c6.1-43.8-24.3-84.2-68.1-90.4c-30.2-4.2-58.8 8.9-75.7 31.9l-8.5 11.6L216.9 185 174.5 80.1l-7.4 3zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fast',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M192 381.5l8.1 4.7 167.9 98V16H16V484.1l167.9-98 8.1-4.7zM16 502.7L0 512V493.5 16 0H16 368h16V16 493.5 512l-16-9.3L192 400 16 502.7z'
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fast',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      'M48 80v96h96V80H48zM32 64H48h96 16V80v96 16H144 48 32V176 80 64zM63 496l81-132.5V304H61.4L27.1 496H63zm-52.2 0L48 288h96 16v16 64L72 512H24.3 8l2.9-16z'
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fast',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm232 96v8V296v8H216v-8V136v-8h16zM208 336h32v32H208V336z'
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fast',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240V504v8h16v-8V256C512 114.6 397.4 0 256 0S0 114.6 0 256V504v8H16v-8V256zM128 144H384V432H128V144zm-16-16v16V432v16h16 44.7l-58.3 58.3-5.7 5.7 0 0h22.6l64-64H316.7l64 64h22.6l-5.7-5.7L339.3 448H384h16V432 144 128H384 128 112zm64 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM336 208v96H176V208H336zM176 192H160v16 96 16h16H336h16V304 208 192H336 176z'
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fast',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM192 256V368h64V256 240h16 64v-1.4l-112-112-112 112V240h64 16v16zm20.7-140.7L224 104l11.3 11.3L352 232v8 16H336 288 272v16 96 16H256 192 176V368 272 256H160 112 96V240v-8L212.7 115.3z'
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fast',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM317.7 99.3l2.8 7.5 1.2 3.1c7.3 19.5 19.2 36.6 34.2 50.2c-1.3-.1-2.6-.1-3.9-.1c-44.2 0-80 35.8-80 80s35.8 80 80 80c18 0 34.6-6 48-16v16 8h16v-8V288c10-13.4 16-30 16-48c0-18.9-6.5-36.2-17.5-49.9l7.7 1.7 7.8 1.7 3.5-15.6-7.8-1.7-8.5-1.9c-37-8.2-67.3-34.6-80.6-70l-1.2-3.1-2.8-7.5-15 5.6zm-126.2 7.5l2.8-7.5-15-5.6-2.8 7.5-1.2 3.1c-13.3 35.5-43.6 61.8-80.6 70l-8.5 1.9-7.8 1.7 3.5 15.6 7.8-1.7 7.7-1.7C86.5 203.8 80 221.1 80 240c0 18 6 34.6 16 48v32 8h16v-8V304c13.4 10 30 16 48 16c21.8 0 41.6-8.7 56-22.9V304v8h16v-8V274.9c5.1-10.6 8-22.4 8-34.9c0-44.2-35.8-80-80-80c-1.3 0-2.6 0-3.9 .1c15-13.5 26.9-30.6 34.2-50.2l1.2-3.1zM160 176a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm128 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM160 272c-17.7 0-32-14.3-32-32c0-1.4 .1-2.8 .3-4.1c4.6 2.6 10 4.1 15.7 4.1c16.3 0 29.7-12.1 31.7-27.9C185.4 217.6 192 228 192 240c0 17.7-14.3 32-32 32zm-44.6-49.7c-2.2 5.5-3.4 11.4-3.4 17.7c0 26.5 21.5 48 48 48s48-21.5 48-48c0-22.1-15-40.8-35.4-46.3c-4-1.1-8.3-1.7-12.6-1.7c-3.5 0-6.9 .4-10.2 1.1c5.9 2.3 10.1 8.1 10.2 14.8l0 .1c0 8.8-7.2 16-16 16c-3.6 0-6.9-1.2-9.6-3.2c-3.9-2.9-6.4-7.6-6.4-12.8c0-1.5 .2-2.9 .6-4.3c-1.5 1.3-3 2.8-4.4 4.3c-3.7 4.2-6.8 9-8.9 14.3zM384 240c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.8 .3-4.1c4.6 2.6 10 4.1 15.7 4.1c16.3 0 29.7-12.1 31.7-27.9C377.4 217.6 384 228 384 240zm-80 0c0 26.5 21.5 48 48 48s48-21.5 48-48c0-22.1-15-40.8-35.4-46.3c-4-1.1-8.3-1.7-12.6-1.7c-3.5 0-6.9 .4-10.2 1.1c6 2.3 10.2 8.1 10.2 14.9c0 8.8-7.2 16-16 16c-3.6 0-6.9-1.2-9.6-3.2c-3.9-2.9-6.4-7.6-6.4-12.8c0-1.5 .2-2.9 .6-4.3c-1.5 1.3-3 2.8-4.4 4.3c-3.7 4.2-6.8 9-8.9 14.3c-2.2 5.5-3.4 11.4-3.4 17.7zM256 430c43.4 0 73.5-27.1 90.6-51.4l-13.1-9.2C318 391.5 292.1 414 256 414s-62-22.5-77.4-44.6l-13.1 9.2c17 24.3 47.1 51.4 90.6 51.4z'
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fast',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      'M264 0H249.1l8.3 12.4 10.8 16.3c2.5 3.7 3.8 8.1 3.8 12.6C272 53.8 261.8 64 249.3 64H176c-35.3 0-64 28.7-64 64c0 8.5 1.7 16.6 4.7 24h-7.9C66.4 152 32 186.4 32 228.8V296v8h8H472h8v-8V228.8c0-42.4-34.4-76.8-76.8-76.8H392h-.3c5.3-10.2 8.3-21.7 8.3-34C400 52.8 347.2 0 282 0H264zM373 152H296h-8v16h8 63.9 17H384h8 11.2c33.6 0 60.8 27.2 60.8 60.8V288H48V228.8c0-33.6 27.2-60.8 60.8-60.8H120h8 2 15.3H168h8V152h-8H134.4c-4.1-7.1-6.4-15.2-6.4-24c0-26.5 21.5-48 48-48h73.3C270.7 80 288 62.7 288 41.3c0-7.6-2.3-15.1-6.5-21.5L278.9 16H282c56.3 0 102 45.7 102 102c0 12.7-4.1 24.4-11 34zM64 336v-8H48v8 16c0 53 43 96 96 96h43.1l-26.2 52.4L155.1 512H168 344h12.9l-5.8-11.6L324.9 448H368c53 0 96-43 96-96V336v-8H448v8 16c0 44.2-35.8 80-80 80H312 299.1l5.8 11.6L331.1 496H180.9l26.2-52.4 5.8-11.6H200 144c-44.2 0-80-35.8-80-80V336z'
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fast',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      'M605.2 65.9C570.9 14.4 501.3 .5 449.9 34.8L361.2 93.9l60.4 60.4 5.7 5.7L416 171.3l-5.7-5.7L347.6 103 246 170.7l63.6 63.6 5.7 5.7L304 251.3l-5.7-5.7-65.9-65.9L130.8 247.5l66.8 66.8 5.7 5.7L192 331.3l-5.7-5.7-69.1-69.1L65.9 290.8C14.4 325.1 .5 394.7 34.8 446.1s103.8 65.4 155.3 31.1l384-256c51.5-34.3 65.4-103.8 31.1-155.3zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z'
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fast',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      'M0 0H8 152h8V16h-8H16V152v8H0v-8V8 0zM144 128V384H128V128h16zm48 0V384H176V128h16zm48 0h16V384H240V128zm96 0V384H320V128h16zm32 0h16V384H368V128zm80 0V384H432V128h16zM568 0h8V8 152v8H560v-8V16H424h-8V0h8H568zM0 512v-8V360v-8H16v8V496H152h8v16h-8H8 0zm568 0H424h-8V496h8H560V360v-8h16v8V504v8h-8z'
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fast',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      'M320 32h16H528h16V48 240v16H528 336 320V240 48 32zM528 240V48H336V240H528zM160 36.7l5.7 5.7 104 104 5.7 5.7L264 163.3l-5.7-5.7L168 67.3V472v8H152v-8V67.3L61.7 157.7 56 163.3 44.7 152l5.7-5.7 104-104 5.7-5.7zM336 320H464h16v16V464v16H464 336 320V464 336 320h16zm128 16H336V464H464V336z'
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fast',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      'M16 80V432H560V80H16zM0 64H16 560h16V80 432v16H560 16 0V432 80 64zM536 184h-8c-39.8 0-72-32.2-72-72v-8V96h16v8 8c0 30.9 25.1 56 56 56h8 8v16h-8zM32 184V168h8 8c30.9 0 56-25.1 56-56v-8V96h16v8 8c0 39.8-32.2 72-72 72H40 32zM536 328h8v16h-8-8c-30.9 0-56 25.1-56 56v8 8H456v-8-8c0-39.8 32.2-72 72-72h8zM32 328h8 8c39.8 0 72 32.2 72 72v8 8H104v-8-8c0-30.9-25.1-56-56-56H40 32V328zm336-72a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fast',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M56 0H48V8 256H8 0v8 96c0 83.9 68.1 152 152 152h80c83.9 0 152-68.1 152-152v-8-8V280 208v-8h-8H304v-8-8h-8H224V160v-8h-8H144V8 0h-8H56zm88 168h64l0 16v8 64H144V168zm64 104l0 0 0 64H104 96v16h8H208h8 8 64 8 8 64v8c0 75.1-60.9 136-136 136H152C76.9 496 16 435.1 16 360V272H48v0H64v0h64v0h16v0h64zm16 0l0-8v-8l0-56h64v8V336H224l0-64zm-96-16H64V16h64V152v8 96zm240 24v56H304V216h64v64z'
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fast',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM304 136V296c0 48.6-39.4 88-88 88s-88-39.4-88-88V280v-8h16v8 16c0 39.8 32.2 72 72 72s72-32.2 72-72V136v-8h16v8z'
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fast',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      'M144 96v32H304V96c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-16 32V96c0-53 43-96 96-96h8V.3c49.3 4.1 88 45.3 88 95.7v32H432h16v16V496v16H432 16 0V496 144 128H16 128zm0 16H16V496H432V144H320 304 144 128zm8 168h8 72V240v-8h16v8 72h72 8v16h-8H232v72l0 8H216l0-8V328H144h-8V312z'
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fast',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      'M8 32H128V48H16V160H0V40 32H8zM0 192H16V320H0V192zm432 0h16V320H432V192zm16-32H432V48H320V32H440h8v8V160zm0 192V472v8h-8H320V464H432V352h16zM16 352V464H128v16H8 0v-8V352H16zM288 480H160V464H288v16zM160 48V32H288V48H160z'
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fast',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm30.9 180.2c-27.2-12.7-60-20.2-95.3-20.2c-35.3 0-68 7.5-95.2 20.2l-12.9 6 1.6-14.1C154.7 331.9 201.4 296 256 296s101.3 36 106.6 84.1l1.6 14.1-12.9-6zM256 312c-42.2 0-76.6 24-87.5 55.5c26.2-9.9 55.9-15.5 87.5-15.5c31.5 0 61.3 5.6 87.5 15.5C332.6 336 298.3 312 256 312z'
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fast',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM96 240h32v8 16 8h-8H104 96V240zm8 48v96H96 80v16 32 16H96h32 16V432v-8h96v8 16h16 32 16V432 400 384H288h-8V288h8 16V272 240 224H288 256 240v16 8H144v-8V224H128 96 80v16 32 16H96h8zm160 0v96h-8H240v16 8H144v-8V384H128h-8V288h8 16V272v-8h96v8 16h16 8zm-8 144v-8V408v-8h8 16 8v32H256zm-128-8v8H96V400h8 16 8v8 16zM288 272h-8H264h-8v-8V248v-8h32v32z'
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fast',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      'M136 32v8V472v8H120v-8V40 32h16z'
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fast',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      'M167.6 0h11.2c41.8 0 79.3 11.2 107.3 32.3C312.9 52.7 330.7 82 335 118.2c28.8 12.1 49 40.6 49 73.8v13.5c37.3 13.2 64 48.7 64 90.5v96 8h-8H357.3l10.7-8.3V384h64V296c0-36.6-24.6-67.5-58.2-77l-5.8-1.6v-6.1V192c0-28-18-51.8-43.1-60.5l-4.9-1.7-.4-5.2c-2.8-34-18.6-60.9-43.1-79.5c-22.2-16.8-51.9-26.9-86.1-28.8C194.5 28.3 200 46 200 63.4c0 34.5-24.7 54.1-41.9 63.6l-1.8 1h-2.1H144c-35.3 0-64 28.7-64 64v19.3 6.1L74.2 219C40.6 228.5 16 259.4 16 296v88H80v16H8 0v-8V296c0-41.8 26.7-77.4 64-90.5V192c0-44.2 35.8-80 80-80h8.2c15.1-8.7 31.8-23.9 31.8-48.6c0-17.5-6.7-36.1-11-47.8l0-.1 0 0 0 0c-.7-1.8-1.3-3.5-1.8-5L167.6 0zm-1.3 486.9L188 400l4-16H175.5 128 112V368v-8L267.6 239.8 288 224l-6.3 25.1L260 336l-4 16h16.5H320h16v16 8L180.4 496.2 160 512l6.3-25.1zM192 368h20.5l-5 19.9-20.8 83.3L320 368.1V368H256 235.5l5-19.9 20.8-83.3L128 367.9v.1h64z'
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fast',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      'M112 48c-53 0-96 43-96 96V256H208V144c0-53-43-96-96-96zM16 368c0 53 43 96 96 96s96-43 96-96V272H16v96zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zm257 91.4l62.8 91.6L474.1 209.8l-60-87.5c-30.5-44.4-90.2-55.1-133.5-24.1c-43.5 31.1-54.2 92.5-23.6 137.2zM385.4 422.7c30.5 44.4 90.2 55.1 133.5 24.1c43.5-31.1 54.2-92.5 23.6-137.2L483.1 223 328.8 340.1l56.6 82.5z'
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fast',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      'M16 208v24 8 23.4l53.9 26.3 1.2 .6 .9 .9 41.8 40.7 70.1 6.8 .7 .1 .7 .2L256 359.7 326.7 339l.7-.2 .7-.1 70.1-6.8 41.8-40.7 .9-.9 1.2-.6L496 263.4V240v-8V208c0-36.7-23.8-72.3-67.5-99.6C395.7 87.9 352.8 73 304.3 67l-2.7 2.7-40 40-5.7 5.7L244.7 104l5.7-5.7L283.7 65c-9.1-.6-18.3-1-27.7-1c-68.2 0-129.1 17.3-172.5 44.4C39.8 135.7 16 171.3 16 208zM0 232V208C0 119.6 114.6 48 256 48s256 71.6 256 160v24 8 28.4 5V304c0 88.4-114.6 160-256 160S0 392.4 0 304V273.4v-5V240v-8zm16 49.2V304c0 36.7 23.8 72.3 67.5 99.6C126.9 430.7 187.8 448 256 448s129.1-17.3 172.5-44.4C472.2 376.3 496 340.7 496 304V281.2l-45.7 22.3-42.8 41.8-2 2-2.8 .3-72.2 7-72.2 21.1-2.2 .7-2.2-.7-72.2-21.1-72.2-7-2.8-.3-2-2L61.7 303.5 16 281.2zM165.7 133.7l-32 32-5.7 5.7L116.7 160l5.7-5.7 32-32 5.7-5.7L171.3 128l-5.7 5.7zm224 4.7l32 32 5.7 5.7L416 187.3l-5.7-5.7-32-32-5.7-5.7L384 132.7l5.7 5.7zM64 200H96h8v16H96 64 56V200h8zm325.7 34.3l32 32 5.7 5.7L416 283.3l-5.7-5.7-32-32-5.7-5.7L384 228.7l5.7 5.7zm-240 16l32 32 5.7 5.7L176 299.3l-5.7-5.7-32-32-5.7-5.7L144 244.7l5.7 5.7zm176 27.3l-32 32-5.7 5.7L276.7 304l5.7-5.7 32-32 5.7-5.7L331.3 272l-5.7 5.7zM209 170.7c-11.9 6.6-17 14.5-17 21.3s5.1 14.7 17 21.3c11.6 6.5 28.2 10.7 47 10.7s35.4-4.2 47-10.7c11.9-6.6 17-14.5 17-21.3s-5.1-14.7-17-21.3c-11.6-6.5-28.2-10.7-47-10.7s-35.4 4.2-47 10.7zm-7.8-14c14.4-8 33.8-12.7 54.8-12.7s40.4 4.7 54.8 12.7c14.2 7.9 25.2 20 25.2 35.3s-11 27.4-25.2 35.3C296.4 235.3 277 240 256 240s-40.4-4.7-54.8-12.7C187 219.4 176 207.3 176 192s11-27.4 25.2-35.3z'
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fast',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      'M320 32H304V80H192V96H304V226c-21.8-39.4-63.8-66-112-66c-70.7 0-128 57.3-128 128s57.3 128 128 128c48.2 0 90.2-26.6 112-66v66h16V288 96h32V80H320V32zM80 288a112 112 0 1 1 224 0A112 112 0 1 1 80 288zM384 480V464H0v16H384z'
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fast',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      'M96 256.8l-7.1 4.8C54.6 284.6 32 323.7 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-44.4-22.6-83.5-56.9-106.5l-7.1-4.8v-8.5V16H96V248.3v8.5zM224 0h16V16 248.3c38.6 25.8 64 69.8 64 119.8c0 79.5-64.5 144-144 144S16 447.6 16 368c0-49.9 25.4-93.9 64-119.8V16 0H96 224zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-32.6 24.4-59.6 56-63.5V200v-8h16v8V304.5c31.6 3.9 56 30.9 56 63.5c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fast',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM200 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136.4 3.2l-6.5 7.6L199.5 252.2l-25.9-25.9-6-6-5.6 6.3-72 80L88 308.9V312v16 8h8H416h8v-8V312v-2.7l-1.6-2.1-120-160-6-8zm-.8 25.6L408 314.7V320H104v-4.9l64.3-71.5 26 26 6.1 6.1 5.6-6.6 89.5-104.4z'
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fast',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      'M280 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zm236.9 88h3 24H568h64 8v8V280v8h-8H568 475.1L239.4 494.2 221.3 510l-2.3 2h-3H192 72 8 0v-8V376v-8H8 72h92.9L400.6 161.8 418.7 146l2.3-2zm6 16l-15.8 13.9L173.2 382l-2.3 2h-3H72 16V496H72 192h21l15.8-13.9L466.8 274l2.3-2h3 96 56V160H568 448 427zM320 184.5l-16 14V160H176V310.5l-16 14V160 144h16H304h16v16 24.5z'
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fast',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      'M87.1 104.2C92 99.7 96 92.2 96 80c0-4.4-1.8-10.8-5.8-18.8c-3.9-7.8-9.3-16-15-23.6c-3.9-5.2-7.8-9.9-11.2-13.9c-3.4 4-7.3 8.7-11.2 13.9c-5.7 7.6-11.1 15.7-15 23.6C33.8 69.2 32 75.6 32 80c0 17.7 14.3 32 32 32c10.1 0 18-3 23.1-7.8zm-34-92.4C59.4 4.6 64 0 64 0s4.6 4.6 10.9 11.8C89 28 112 57.9 112 80c0 32-21.5 48-48 48s-48-21.5-48-48c0-22.1 23-52 37.1-68.2zM256 80c0-4.4-1.8-10.8-5.8-18.8c-3.9-7.8-9.3-16-15-23.6c-3.9-5.2-7.8-9.9-11.2-13.9c-3.4 4-7.3 8.7-11.2 13.9c-5.7 7.6-11.1 15.7-15 23.6c-4 8.1-5.8 14.5-5.8 18.8c0 17.7 14.3 32 32 32c10.1 0 18-3 23.1-7.8c4.9-4.5 8.9-12 8.9-24.2zm-80 0c0-22.1 23-52 37.1-68.2C219.4 4.6 224 0 224 0s4.6 4.6 10.9 11.8C249 28 272 57.9 272 80c0 32-21.5 48-48 48s-48-21.5-48-48zm-62 96h6H328h6l1.7 5.8L366 288h34 16v16V432v16 48 16H400 352 336V496 448H112v48 16H96 48 32V496 448 432 304 288H48 82l30.3-106.2L114 176zM400 432V304H48V432H96h16H336h16 48zm-48 64h48V448H352v48zM96 448H48v48H96V448zM322 192H126L98.6 288H349.4L322 192zM96 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm224-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 80c0-4.4-1.8-10.8-5.8-18.8c-3.9-7.8-9.3-16-15-23.6c-3.9-5.2-7.8-9.9-11.2-13.9c-3.4 4-7.3 8.7-11.2 13.9c-5.7 7.6-11.1 15.7-15 23.6c-4 8.1-5.8 14.5-5.8 18.8c0 17.7 14.3 32 32 32c10.1 0 18-3 23.1-7.8c4.9-4.5 8.9-12 8.9-24.2zm-80 0c0-22.1 23-52 37.1-68.2C379.4 4.6 384 0 384 0s4.6 4.6 10.9 11.8C409 28 432 57.9 432 80c0 32-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fast',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      'M112 416H96V400 48 32h16H464h16V48 320l-96 96H112zm265.4-16L464 313.4V48H112V400H377.4zM248 112h8 64 8v8 64h64 8v8 64 8h-8H328v64 8h-8H256h-8v-8V264H184h-8v-8V192v-8h8 64V120v-8zm16 16v64 8h-8H192v48h64 8v8 64h48V256v-8h8 64V200H320h-8v-8V128H264zM16 128H64v16H16V496H368V448h16v48 16H368 16 0V496 144 128H16z'
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fast',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      'M432 416H80l0 80 304 0h48V416zm-48 96L80 512H64V496 416H16 0V400 112 96H16 64V16 0H80 432h16V16 96h48 16v16V400v16H496 448v80H584V223.3c-22.7-3.8-40-23.6-40-47.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V504v8h-8H448 432 384h0zM624 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 16L80 16V96H432V16zm64 96H16V400H496V112zM88 176h8 72 11.7l-4.2 10.9L117.5 336H100.3l56-144H96 88V176zM228.3 336l56-144H224h-8V176h8 72 11.7l-4.2 10.9L245.5 336H228.3zm128 0l56-144H352h-8V176h8 72 11.7l-4.2 10.9L373.5 336H356.3z'
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fast',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      'M46.6 16L30.4 194.1C23.5 270.3 83.5 336 160 336s136.5-65.7 129.6-141.9L273.4 16H168.6l30.8 77 2.7 6.8-6.6 3.3-54.1 27 56.2 56.2 5.7 5.7L192 203.3l-5.7-5.7-64-64-7.8-7.8 9.9-5 57.4-28.7L152.6 19l-1.2-3H46.6zM305.5 192.7c7.5 82.9-55.5 154.7-137.5 159.1V496h80 8v16h-8H160 72 64V496h8 80V351.8C69.9 347.4 7 275.5 14.5 192.7L32 0H288l17.5 192.7z'
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fast',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 48C109.1 48 16 141.1 16 256s93.1 208 208 208c112.2 0 203.6-88.8 207.8-200H232h-8V248h8H440h8v8c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57l6 5.3-10.7 11.9-6-5.3C325.9 68 277.3 48 224 48z'
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fast',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      'M105.9 104.6C82.4 123 63.2 146.7 50.3 174C30.5 168.1 16 149.8 16 128c0-26.5 21.5-48 48-48c18 0 33.7 9.9 41.9 24.6zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L536 448l93.1-100.2L640 336l-12.6-10L493.9 220.5 448 248l-32-24 14.6-53.6-78.1-61.8C315.9 79.7 270.6 64 224 64c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM375.7 346.3l-8.1 11.4C335.7 402.7 283.3 432 224 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c43 0 84.8 14.5 118.6 41.2l69.8 55.2-11.8 43.4-2.9 10.5 8.7 6.5 32 24 8.6 6.5 9.2-5.5 36.4-21.8 123.9 97.9-83.9 90.4L388.1 352.8l-12.4-6.5zM176 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fast',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M32 256c0-88.4 71.6-160 160-160h56 8v16h-8H192c-79.5 0-144 64.5-144 144s64.5 144 144 144h56 8v16h-8H192c-88.4 0-160-71.6-160-160zm512 0c0 88.4-71.6 160-160 160H328h-8V400h8 56c79.5 0 144-64.5 144-144s-64.5-144-144-144H328h-8V96h8 56c88.4 0 160 71.6 160 160zm-400-8H432h8v16h-8H144h-8V248h8z'
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fast',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM279 148.1l-6.5 17L214 318.7l-39.4-59.1-2.4-3.6H168 80V112H496V400H80V272h83.7l45.6 68.4 8.6 12.9 5.5-14.5 57.5-151 39.9 79.7 2.2 4.4H328h80 8V256h-8H332.9l-45.8-91.6L279 148.1zM64 96v16V400v16H80 496h16V400 112 96H496 80 64z'
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fast',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M16 256c0 114.9 93.1 208 208 208c47.9 0 91.9-16.2 127.1-43.3L219.4 256h20.5L363.4 410.4C405.5 372.3 432 317.3 432 256c0-114.9-93.1-208-208-208S16 141.1 16 256zM361.1 433.2C323.2 462.5 275.6 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 66.3-28.8 125.9-74.6 166.9L444.6 512H424.2l-63.1-78.8z'
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fast',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      'M328 136v8h-8H248 191.8 138.3C101.7 144 72 173.7 72 210.3c0 9.5 2 18.8 5.9 27.4l33.3 73.3 .7 1.6v1.7 19.8 1.6l-.6 1.5L91.2 384.2l-5.5 12.9 3.8 13.5L113.2 496h83l-25.1-90.5-.8-2.7 1.1-2.6 17.4-40.5 3.2-7.5V344 304v-4.7-9.9l9.7 2.1 120 26.3 6.3 1.4v6.4V496h72V308.5v-3.7l2.8-2.4c17.6-14.9 29-37.1 29.2-62.5l0-.3v-.2V152v-8h8 16 4.9l2.2 4.4 28.4 56.8 67.9-34-10-104.5L515.7 16H472 456h-8c-66.3 0-120 53.7-120 120zM534.9 16l29 43.6 1.1 1.7 .2 2 10.7 112 .5 5.5-4.9 2.5-80 40-7.2 3.6-3.6-7.2L451.1 160H448v79.5 .5 9.1l-.5-.1c-2.4 25.2-14.2 47.2-31.5 63V504v8h-8H320h-8v-8V332.1L208 309.3V344v9.9 1.6l-.6 1.5-3.9 9.1L187.2 404l27.2 97.9 2.8 10.1H206.7 107.1 101l-1.6-5.9L74 415l-4.5-16.3-.8-2.7 1.1-2.6 6.6-15.5L96 332.5V316.1L63.4 244.4c-4.9-10.7-7.4-22.3-7.4-34.1c0-12.2 2.7-23.9 7.5-34.3C37.2 176.3 16 197.7 16 224v88 8H0v-8V224c0-35.3 28.7-64 64-64h8 1.2c15.1-19.5 38.6-32 65.1-32h53.5H248h64.2C316.4 56.6 375.6 0 448 0h8 16 48 4.3H552h8V16h-8H534.9zM480 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fast',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm280 32l0-143.8c75.8 4.2 136 66.9 136 143.8c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-76.8 60.2-139.6 136-143.8L280 288v8h16v-8zm-8-160a160 160 0 1 0 0 320 160 160 0 1 0 0-320z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fast',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M275.3 256l-5.7 5.7-176 176L88 443.3 76.7 432l5.7-5.7L252.7 256 82.3 85.7 76.7 80 88 68.7l5.7 5.7 176 176 5.7 5.7z'
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fast',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      'M312 0h16V32.2c84.6 4.2 152 74.1 152 159.8v93.2L542.2 363l1.8 2.2V368v40 8h-8H104 96v-8V368v-2.8l1.8-2.2L160 285.2V192c0-85.7 67.4-155.6 152-159.8V0zm8 48c-79.5 0-144 64.5-144 144v96 2.8l-1.8 2.2L112 370.8V400H528V370.8L465.8 293l-1.8-2.2V288 192c0-79.5-64.5-144-144-144zM286.1 481.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9h16c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3h16c0 12.7 5.1 24.9 14.1 33.9zM0 176H8h96 8v16h-8H8 0V176zm536 0h96 8v16h-8H536h-8V176h8zM610.7 43.6l-7.2 3.6-80 40-7.2 3.6-7.2-14.3 7.2-3.6 80-40 7.2-3.6 7.2 14.3zM36.4 47.2l-7.2-3.6 7.2-14.3 7.2 3.6 80 40 7.2 3.6-7.2 14.3-7.2-3.6-80-40z'
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fast',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      'M368 272V376l96 72V272v-6.2l4.2-4.6L624 89.8V48H208V89.8L363.8 261.2l4.2 4.6V272zm-16 0L192 96V48 32h16H624h16V48 96L480 272V460v20l-16-12L352 384V272zm-32 28.8L288 336V492v20l-16-12L160 416V336L0 160V112 96H16 160v12.4l3.3 3.6H16v41.8L171.8 325.2l4.2 4.6V336v72l96 72V336v-6.2l4.2-4.6 40.5-44.5 3.3 3.7v16.4z'
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fast',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      'M176 128l0 0 11.3-11.3 73.4-73.4L272 32l11.3 11.3 73.4 73.4L368 128l0 0H345.4l0 0L272 54.6 198.6 128l0 0H176zM48 128H32V48 32H48 226.7l-16 16H48v80zm128 48v72 8H160v-8V176H112V280v8H96v-8V176H16V464H368V176H344 176zm0-16H344h24 16 24c57.4 0 104 46.6 104 104s-46.6 104-104 104H384v96 16H368 16 0V464 176 160H16 96h16 48 16zm208 16V352h24c48.6 0 88-39.4 88-88s-39.4-88-88-88H384z'
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fast',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      'M328 136c0-66.3 53.7-120 120-120h8 16 43.7l33.8 50.8 10 104.5-67.9 34-28.4-56.8-2.2-4.4H456 440h-8v8 87.5 .2l0 .3c-.2 25.4-11.6 47.6-29.2 62.5l-2.8 2.4v3.7V496H328V325.7v-6.4l-6.3-1.4L248 301.7v-54c44.9-4 80-41.7 80-87.6V144v-8zm-88 96c-39.8 0-72-32.2-72-72V144h23.8H248h64v16c0 39.8-32.2 72-72 72zm-8 15.6v50.5l-30.3-6.6-9.7-2.1v9.9V304v40 8.2l-3.2 7.5-17.4 40.5-1.1 2.6 .8 2.7L196.2 496h-83L89.5 410.7l-3.8-13.5 5.5-12.9 20.1-46.9 .6-1.5v-1.6V314.4v-1.7l-.7-1.6L77.9 237.7c-3.9-8.6-5.9-18-5.9-27.4c0-36.6 29.7-66.3 66.3-66.3H152v16c0 45.9 35.1 83.6 80 87.6zM191.8 128H160 138.3c-26.5 0-50.1 12.5-65.1 32H72 64c-35.3 0-64 28.7-64 64v88 8H16v-8V224c0-26.3 21.2-47.7 47.5-48c-4.8 10.4-7.5 22.1-7.5 34.3c0 11.7 2.5 23.4 7.4 34.1L96 316.1v16.4L76.5 377.9l-6.6 15.5L68.8 396l.8 2.7L74 415l25.3 91.2L101 512h6.1 99.6 10.5l-2.8-10.1L187.2 404l16.2-37.9 3.9-9.1 .6-1.5v-1.6V344 309.3l104 22.8V504v8h8 88 8v-8V312.1c17.3-15.8 29.1-37.9 31.5-63l.5 .1V240v-.5V160h3.1l29.8 59.6 3.6 7.2 7.2-3.6 80-40 4.9-2.5-.5-5.5-10.7-112-.2-2L564 59.6 534.9 16H552h8V0h-8H524.3 520 472 456h-8C375.6 0 316.4 56.6 312.2 128H248 191.8zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fast',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      'M448 0V43c0 44.6 17.7 87.3 49.2 118.8l21 21C534.7 199.3 544 221.7 544 245v43H528V245c0-19.1-7.6-37.4-21.1-50.9l-21-21C451.4 138.6 432 91.8 432 43V0h16zM624 288V245c0-44.6-17.7-87.3-49.2-118.8l-21-21C537.3 88.7 528 66.3 528 43V0h16V43c0 19.1 7.6 37.4 21.1 50.9l21 21C620.6 149.4 640 196.2 640 245v43H624zM14.8 441.4C5.1 435.6 0 432 0 432s5.1-3.6 14.8-9.4C50.7 401.5 149.5 352 288 352H624h16v16V496v16H624 288c-138.5 0-237.3-49.5-273.2-70.6zM30.7 432c12.6 7 30.6 16.1 53.3 25.1C132.5 476.6 202.4 496 288 496h54L249.6 372.8l-2.5-3.3c-67.1 4.9-122.6 21.1-163.2 37.4C61.3 415.9 43.3 425 30.7 432zm235.6-63.6l92.1 122.8L362 496H502L409.6 372.8 406 368H288c-7.3 0-14.6 .1-21.7 .4zM426 368l92.4 123.2L522 496H624V368H426z'
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fast',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      'M55.8 108.7c30.8-37.5 67.7-63.4 92.6-75.9l7.2 14.3c-23.1 11.5-58.2 36.1-87.4 71.7C39 154.5 16 200.7 16 256s23 101.5 52.2 137.1c29.2 35.7 64.3 60.2 87.4 71.7l-7.2 14.3c-24.9-12.5-61.8-38.3-92.6-75.9C25 365.7 0 315.9 0 256s25-109.7 55.8-147.3z'
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fast',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      'M560 336H464V192h64.1c20.4 38.1 31.9 81.7 31.9 128v16zm-112 0H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H128V192H320h16H448V336zm-65.3 16H448h16 96V464H384V368c0-5.5-.5-10.8-1.3-16zM128 352h65.3c-.9 5.2-1.3 10.5-1.3 16v96H16V352h96 16zm-16-16H16V320c0-46.3 11.6-89.9 32-128.1v.1h64V336zM518.8 176H336V52.2C413 65.9 478.8 112.1 518.8 176zM288 48c10.8 0 21.5 .6 32 1.9V176H57.2C105.3 99.1 190.7 48 288 48zM16 480H192 384 560h16V464 320C576 160.9 447.1 32 288 32S0 160.9 0 320V464v16H16zM288 288c44.2 0 80 35.8 80 80v96H208V368c0-44.2 35.8-80 80-80z'
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fast',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      'M16 112H160L320 0 480 112H624h16v16V496v16H624 384 368 272 256 16 0V496 128 112H16zM368 496V384c0-26.5-21.5-48-48-48s-48 21.5-48 48V496h96zm16 0H624V128H480h-5l-4.1-2.9L320 19.5 169.2 125.1 165 128h-5H16V496H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64V496zM64 192h8 64 8v8 80 8h-8H72 64v-8V200v-8zm16 16v64h48V208H80zm424-16h64 8v8 80 8h-8H504h-8v-8V200v-8h8zm8 16v64h48V208H512zM320 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm8 48v24h16 8v16h-8H320h-8v-8V144v-8h16v8zM64 320h8 64 8v8 80 8h-8H72 64v-8V328v-8zm16 16v64h48V336H80zm424-16h64 8v8 80 8h-8H504h-8v-8V328v-8h8zm8 80h48V336H512v64z'
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fast',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      'M136 0h-8V8 96H16 0v16V464v16H16 496h16V464 112 96H496 384V8 0h-8H136zM368 96H144V16H368V96zM136 112H376 496V464H16V112H136z'
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fast',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      'M16 32v8V464H504h8v16h-8H8 0v-8V40 32H16zm320 80H312 296 272V240h24 16 24V112zm0-16h16v16V240v16H336 312v56 8H296v-8V256H272 256V240 112 96h16 24V40 32h16v8V96h24zM440 208H424 400v96h24 16 24V208H440zm0-16h24 16v16 96 16H464 440v56 8H424v-8V320H400 384V304 208 192h16 24V136v-8h16v8 56zM168 144H144V304h24 16 24V144H184 168zm0-16V72 64h16v8 56h24 16v16V304v16H208 184v56 8H168v-8V320H144 128V304 144 128h16 24z'
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fast',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      'M16 40V32H0v8V80 96 288v16V472v8H16v-8V304H624V472v8h16v-8V304 288 96 80 40 32H624v8V80H16V40zm0 56H119.1L24.8 284.4 23.1 288H16V96zm608 0V288H520.9L615.2 99.6l1.8-3.6H624zM456.9 96H599.1L504.8 284.4l-1.8 3.6H360.9L455.2 99.6l1.8-3.6zM279.1 96L184.8 284.4l-1.8 3.6H40.9L135.2 99.6l1.8-3.6H279.1zm17.9 0H439.1L344.8 284.4l-1.8 3.6H200.9L295.2 99.6l1.8-3.6z'
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fast',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      'M252.3 160L469.5 0l40.6 47.2L397.3 160H374.6L488.3 46.4 467 21.7 279.3 160h-27zM480 256c0 77.1-37.9 139-108.4 170.1c-5 2.2-10.1 4.2-15.5 6.1c3.4 4.3 6.6 8.8 9.5 13.6c9.1 15 15.2 32 17.4 50.2c.7 5.2 1 10.6 1 16H368 144 128c0-5.4 .3-10.8 1-16c2.3-18.2 8.4-35.2 17.4-50.2c2.9-4.7 6-9.3 9.5-13.6c-5.3-1.9-10.5-3.9-15.5-6.1C69.9 395 32 333.1 32 256V224 208H16 8 0V192H8h8H32 48 464h16 16 8 8v16h-8-8H480v16 32zM343.6 442.2l-14-17.5 21.1-7.5C424.6 390.9 464 332 464 256V208H48v48c0 76 39.4 134.9 113.2 161.2l21.1 7.5-14 17.5c-12.1 15.2-20.4 33.6-23.3 53.8H366.9c-2.9-20.2-11.1-38.6-23.3-53.8z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fast',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM357.7 197.7l5.7-5.7L352 180.7l-5.7 5.7L224 308.7l-58.3-58.3-5.7-5.7L148.7 256l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fast',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      'M80 167C80 83 145.1 16 224 16s144 67 144 151c0 52.9-35.9 103.1-75.2 141.8c-19.3 19-38.7 34.4-53.3 45.1c-6.2 4.6-11.5 8.2-15.5 10.9c-4-2.7-9.3-6.4-15.5-10.9c-14.6-10.7-33.9-26.2-53.3-45.1C115.9 270.1 80 219.9 80 167zM224 0C135.6 0 64 74.8 64 167c0 119.3 160 217 160 217s160-97.7 160-217C384 74.8 312.4 0 224 0zM388.1 368l38.4 128H21.5L59.9 368h89c-5.8-5-11.9-10.3-18-16H48L4.8 496 0 512H16.7 431.3 448l-4.8-16L400 352H317.1c-6.1 5.7-12.1 11-18 16h89zM208 240c0-35.3-28.7-64-64-64H120h-8v8 8c0 35.3 28.7 64 64 64h24 8v-8-8zm-64-48c26.5 0 48 21.5 48 48H176c-26.5 0-48-21.5-48-48h16zm160-16c-35.3 0-64 28.7-64 64v8 8h8 24c35.3 0 64-28.7 64-64v-8-8h-8H304zm-48 64c0-26.5 21.5-48 48-48h16c0 26.5-21.5 48-48 48H256z'
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fast',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      'M256 0C198.6 0 152 46.6 152 104c0 18.1 4.6 35.2 12.8 50c-10.8 12.6-19 27.4-23.8 43.7L80 169v-1V104 96H64v8 57.5L11.4 136.8 4.6 151.2l132.8 62.5c-.9 6-1.4 12.1-1.4 18.3c0 18.9 4.4 36.9 12.2 52.8C120.9 312.3 104 350.2 104 392c0 39.1 14.8 74.9 39.1 101.8c11.8 13 28.8 18.2 45 18.2H323.9c16.2 0 33.3-5.2 45-18.2C393.2 466.9 408 431.1 408 392c0-41.8-16.9-79.7-44.2-107.2c7.8-15.9 12.2-33.9 12.2-52.8c0-6.2-.5-12.3-1.4-18.3l132.8-62.5-6.8-14.5L448 161.5V104 96H432v8 64 1l-61 28.7c-4.8-16.3-13.1-31.1-23.8-43.7c8.2-14.8 12.8-31.9 12.8-50C360 46.6 313.4 0 256 0zM168 104c0-48.6 39.4-88 88-88s88 39.4 88 88c0 17.2-4.9 33.2-13.4 46.8l-3.3 5.3 4.3 4.5C349.2 179.2 360 204.3 360 232c0 18.4-4.7 35.6-13.1 50.5l-3.1 5.5 4.6 4.3C375.3 317.1 392 352.6 392 392c0 35-13.2 67-35 91.1c-7.9 8.7-20 12.9-33.1 12.9H188.1c-13.1 0-25.3-4.2-33.1-12.9c-21.8-24.1-35-56-35-91.1c0-39.4 16.7-74.9 43.5-99.7l4.6-4.3-3.1-5.5c-8.3-15-13.1-32.2-13.1-50.5c0-27.7 10.8-52.8 28.5-71.5l4.3-4.5-3.3-5.3C172.9 137.2 168 121.2 168 104zM272 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-61.3 88.9l13.3 20 13.3-20 12.9-19.4c3.8-5.7 5.8-12.3 5.8-19.1V144c0-17.7-14.3-32-32-32s-32 14.3-32 32v2.4c0 6.8 2 13.4 5.8 19.1l12.9 19.4zm3.7-23.3l-3.3-4.9c-2-3-3.1-6.6-3.1-10.2V144c0-8.8 7.2-16 16-16s16 7.2 16 16v2.4c0 3.6-1.1 7.2-3.1 10.2l-3.3 4.9L256 176l-9.6-14.4z'
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fast',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      'M365.7 61.7l48-48L402.3 2.3l-48 48L348.7 56 360 67.3l5.7-5.7zm96 96l48-48L498.3 98.3l-48 48-5.7 5.7L456 163.3l5.7-5.7zm40-136l5.7-5.7L496 4.7l-5.7 5.7L336.9 163.8c5.7-38.7-6.4-79.4-36.1-109.1L289.5 43.3 278.2 32 266.8 43.3 255.5 54.6c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1l-11.3-11.3-11.3-11.3L165 145.1l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1L85.8 247 74.5 235.6 63.2 247 51.9 258.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L5.5 495.1l-5.7 5.7 11.3 11.3 5.7-5.7 73.7-73.7 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3 11.3-11.3L266.8 428l-11.3-11.3C224.7 385.8 182 374 142.1 381.2l50.3-50.3 29.2 29.2c26.8 26.8 65.5 34.4 99 22.9c-.4-5-.6-10-.6-15l0-1.8c-29 12-63.6 6.2-87.1-17.4l-29.2-29.2 15.8-15.8c35-16.3 76.8-13.5 109.5 8.4c1.7-5.2 3.7-10.3 5.9-15.2c-27.5-17.3-60.1-23.1-91-17.5l50.3-50.3 29.2 29.2c7 7 14.7 12.6 23 17c2.8-4.6 5.9-9 9.1-13.3c-7.5-3.8-14.5-8.8-20.8-15l-29.2-29.2L321.3 202c33.1-15.4 72.1-13.8 103.9 4.8c6-2.7 12.2-5 18.6-6.9c-28.8-21-64.4-28.4-98.1-22.3L501.7 21.7zM289.5 65.9c32.5 32.5 40.9 80 25 120.2l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zM187.6 167.8c32.5 32.5 40.9 80 25 120.2l-20.3 20.3L165 280.9c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zM85.8 269.6c32.5 32.5 40.9 80 25 120.2L90.6 410.1 63.2 382.7C32 351.5 32 300.8 63.2 269.6l11.3-11.3 11.3 11.3zm16.1 151.8l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM508 444V420H484v24h24zm-4-164H488v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fast',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      'M112 32v8V64H536h8v8 48h24 8v8 64 8h-8H544v48 8h-8H248l-16 64h56V296v-8h16v8 32 32 8H288v-8V336H228L192 480H48.5 32l4-16L88.1 255.7C38.8 251.7 0 210.4 0 160c0-53 43-96 96-96V40 32h16zM16 160c0 44.2 35.8 80 80 80H528V192v-8h8 24V136H536h-8v-8V80H96c-44.2 0-80 35.8-80 80zm215.5 96h-127l-52 208h127l52-208zM80 144v32H464V144H80zM64 128H80 464h16v16 32 16H464 80 64V176 144 128z'
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fast',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      'M112 352v64 16H96 64 48V416 352H16V496H496V352H464v64 16H448 416 400V416 352H384v64 16H368 336 320V416 352H272v64 16H256 224 208V416 352H192v64 16H176 144 128V416 352H112zm336 0H416v64h32V352zm16-16h32V297.9L376.8 238.3c-5.4-2.7-8.8-8.3-8.8-14.3V192c0-97.2-78.8-176-176-176S16 94.8 16 192V336H48 64 96h16 16 16 32 16 16 16 32 16 48 16 32 16 16 16 32 16zM336 416h32V352H336v64zm-80-64H224v64h32V352zM144 416h32V352H144v64zM96 352H64v64H96V352zm416-64v48 8 8V496v16H496 16 0V496 352v-8-8V192C0 86 86 0 192 0S384 86 384 192v32l128 64z'
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fast',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      'M214.1 6.3L208.9 .2 196.7 10.7l5.2 6.1 0 0 0 0 0 0 .1 .1 .4 .4c.3 .4 .8 1 1.4 1.8c1.2 1.6 3 3.9 5.2 6.9c4.3 6 10.2 14.8 16 25.4c9.6 17.5 18.9 39.9 22 63.9c-21.3-17-50.1-23.9-78.3-16.1c-10.6 2.9-20.2 7.7-28.6 13.8C120 98.4 94 92.2 68 98.3C20.7 109.3-8.7 156.7 2.3 204l56 240c11 47.3 58.4 76.7 105.7 65.7c13.7-3.2 25.9-9.4 36-17.8c9.5 7.8 20.7 13.8 33.3 17.1c28.5 7.6 57.5 .3 78.7-17.1c10.1 8.4 22.3 14.6 36 17.8c47.3 11 94.6-18.4 105.7-65.7l56-240c11-47.3-18.4-94.7-65.7-105.7c-26-6.1-52 .1-72 14.7c-8.6-6.3-18.5-11.1-29.3-14c-28.9-7.7-58.2-.1-79.5 17.8c-2.9-28.2-13.7-53.8-24.2-73.1c-6.2-11.3-12.4-20.6-17-27.1c-2.3-3.2-4.3-5.8-5.7-7.5c-.7-.9-1.2-1.5-1.6-2l-.4-.5-.1-.1 0 0 0 0 0 0s0 0-6.1 5.2l6.1-5.2zm49.3 133.2h.6v-.8c17.3-21.4 46.2-31.8 74.5-24.3c10.8 2.9 20.3 8 28.3 14.8l5.2 4.4 5.2-4.4c16.8-14.4 40-20.8 63.2-15.4c38.7 9 62.8 47.8 53.8 86.5l-56 240c-9 38.7-47.8 62.8-86.5 53.8c-13.3-3.1-24.9-9.7-34-18.7l-5.6-5.5-5.6 5.5c-17.6 17.2-43.5 24.9-69 18.1c-12.5-3.3-23.3-9.7-31.8-18.1l-5.6-5.5-5.6 5.5c-9.1 8.9-20.7 15.6-34 18.7c-38.7 9-77.4-15-86.5-53.8l-56-240c-9-38.7 15-77.4 53.8-86.5c20.1-4.7 40.1-.5 56 10C108 145 99.1 175.3 106.6 205.3l37.6 150.4 1.9 7.8 15.5-3.9-1.9-7.8L122.2 201.5c-7.5-29.9 4.9-60.1 28.9-76.7l0 0c6.5-4.5 13.8-7.9 21.8-10.2c28.5-7.9 57.7 2.5 75.1 24.1v.8h.6c.3 .4 .6 .8 1 1.2l6.4 8.5 6.4-8.5c.3-.4 .6-.8 1-1.2z'
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fast',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      'M400 16V400H236.7c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64H16V16H400zM16 416H64.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H400h.4c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8H632h8V400h-8H608V216v-3.3l-2.3-2.3-112-112L491.3 96H488 416V16 0H400 16 0V16 400v16H16zM416 112h68.7l104 104H416V112zm0 261.4V232H592V400H572.7c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4zM152 352a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm264 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM176 72h-8v8 64H104 96v8 64 8h8 64v64 8h8 64 8v-8V224h64 8v-8V152v-8h-8H248V80 72h-8H176zm8 80V88h48v64 8h8 64v48H240h-8v8 64H184V216v-8h-8H112V160h64 8v-8z'
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fast',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      'M432 192h16 96 16v16V496v16H544 432 336h-8H296h-8H248h-8H144 32 16V496 112 96H32h96 16V80 16 0h16H416h16V16 176v16zM256 496h32 8 24V400H256v96zm80 0h96H544V208H432 416V192 16H160V96v16H144 32V496H144h96V392v-8h8 80 8v8V496zm152-72h-8H416h-8v-8V352v-8h8 64 8v8 64 8zM160 328H96 88v-8V256v-8h8 64 8v8 64 8h-8zm-8-64H104v48h48V264zm16 160h-8H96 88v-8V352v-8h8 64 8v8 64 8zm-16-16V360H104v48h48zm168-80H256h-8v-8V256v-8h8 64 8v8 64 8h-8zm-8-64H264v48h48V264zM328 56v8 64 8h-8H256h-8v-8V64 56h8 64 8zM312 72H264v48h48V72zM480 328H416h-8v-8V256v-8h8 64 8v8 64 8h-8zm-8-64H424v48h48V264zM168 232h-8H96 88v-8V160v-8h8 64 8v8 64 8zm-16-16V168H104v48h48zm168 16H256h-8v-8V160v-8h8 64 8v8 64 8h-8zm-8-64H264v48h48V168zM472 408V360H424v48h48z'
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fast',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      'M0 480l9.1-16L246.8 48.1 256 32l9.2 16.1L502.9 464l9.1 16H493.6 18.4 0zM256 64.2L27.6 464H484.4L256 64.2z'
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fast',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      'M80 496H16V16H208V168v8h8H368V304h16V160L224 0H16 0V16 496v16H16 80V496zM361.4 160H224V22.6L361.4 160zM248 376v-8l-8 0-5.6 0-4.6 0-2.3 3.9-35.6 60.5-37-60.6-2.3-3.8-4.5 0-4 0-8 0v8V504v8h16v-8V397.9l33.2 54.3 7 11.4 6.8-11.5L232 395.8V504v8h16v-8V376zm192 0v-8H424v8 35c0 20.1 3.6 40.1 10.7 59l13.8 36.8 1.9 5.2H456h16 5.5l1.9-5.2L493.3 470c7.1-18.9 10.7-38.8 10.7-59V376v-8H488v8 35c0 18.2-3.3 36.3-9.7 53.4L466.5 496h-4.9l-11.9-31.6c-6.4-17.1-9.7-35.1-9.7-53.4V376zM296 400v80c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V400c0-17.7-14.3-32-32-32H328c-17.7 0-32 14.3-32 32zm32-16h16c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H328c-8.8 0-16-7.2-16-16V400c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fast',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      'M224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v47.2l16 12.6V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224c-31.6 0-61.6 6.5-88.9 18.3l14.4 11.4C172.7 20.8 197.8 16 224 16zM27.3 116.7C9.9 148.5 0 185.1 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224c0-35.1 8.7-68.2 24.1-97.2L27.3 116.7zM546.6 343.2l25 19.8c2.7-2.9 4.3-6.7 4.3-11c0-8.8-7.2-16-16-16c-5.6 0-10.5 2.9-13.4 7.2zm63 49.7l24.6 19.4c3.5-2.9 5.8-7.4 5.8-12.3c0-8.8-7.2-16-16-16c-6.3 0-11.7 3.6-14.4 8.9zM432 436.2l-27.6-21.8L336 408.6V383.4l26.8-1.9-18.6-14.7L327.4 368l-7.4 .5V376v40 7.4l7.3 .6 88.7 7.4V464H312h-8v8 32 8h16v-8V480H424h8v-8V436.2zM640 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fast',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      'M510.5 12.8l-5.7 5.7L448 75.3c44.4 50.3 42.6 127.1-5.5 175.2l-58.8 58.8c.2 3.5 .3 7.1 .3 10.7c0 106-86 192-192 192S0 426 0 320S86 128 192 128c3.6 0 7.2 .1 10.7 .3l58.8-58.8C309.6 21.4 386.4 19.6 436.7 64L493.5 7.1l5.7-5.7 11.3 11.3zM402.3 98.3l23-23c-44-38.2-110.7-36.4-152.5 5.5L214 139.6l-5.1 5.1-7.1-.4c-3.2-.2-6.5-.3-9.8-.3C94.8 144 16 222.8 16 320s78.8 176 176 176s176-78.8 176-176c0-3.3-.1-6.6-.3-9.8l-.4-7.1 5.1-5.1 58.8-58.8c41.8-41.8 43.7-108.5 5.5-152.5l-23 23-5.7 5.7L396.7 104l5.7-5.7zM304 328c0 57.4-46.6 104-104 104h-8V416h8c48.6 0 88-39.4 88-88v-8h16v8z'
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fast',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      'M151.5 0H143l.5 8.5L146.1 48H64C28.7 48 0 76.7 0 112v40 8H8 63.5c26.3 0 51.2-11.8 67.9-32h19.8l2.1 32c-49.7 .9-89.8 41.5-89.8 91.5V256c0 53 43 96 96 96h6.2l0 .5 2 31.5H103.5h-8v8 48 8h8 68.4l3.6 56.4 .5 7.5h7.5 16H207l.5-7.5 9.8-151.9 0-.5h54.2c8.8 0 16 7.2 16 16s-7.2 16-16 16H247.3l-1 16h25.2c17.7 0 32-14.3 32-32s-14.3-32-32-32h-112c-44.2 0-80-35.8-80-80v-4.5c0-41.5 33.4-75.1 74.8-75.5l2.1 32.1c-25.1 1.6-44.9 22.4-44.9 47.9c0 26.5 21.5 48 48 48h112c35.3 0 64 28.7 64 64s-28.7 64-64 64H244.2l-1 16h28.3c44.2 0 80-35.8 80-80s-35.8-80-80-80h-112c-17.7 0-32-14.3-32-32c0-17 13.2-30.9 29.9-31.9l2.1 31.9h16l0-.5L167.3 128h48.5l-8.2 127.5 0 .5h16l7.2-112 1-16h55.7c8.8 0 16 7.2 16 16s-7.2 16-16 16H261.8l-1 16h26.8c17.7 0 32-14.3 32-32s-14.3-32-32-32H217l-.2 0 0 0H166.2l0 0-.2 0H127.5h-4l-2.4 3.2C107.5 133.3 86.2 144 63.5 144H16V112c0-26.5 21.5-48 48-48h90.6 73.8 59.1c44.2 0 80 35.8 80 80s-35.8 80-80 80H257.6l-1 16h30.9c53 0 96-43 96-96s-43-96-96-96H236.9l2.5-39.5L240 0h-8.5-80zm49.8 352L192 495.9h-1L181.7 352h19.6zm-30.5 80H111.5V400h57.3l2.1 32zM220.9 48H162.1L160 16H223l-2.1 32zM47.5 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z'
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fast',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      'M439.2 116.4l-56-112-14.3 7.2 53.6 107.2L328 226.7V144c0-27.4-15.3-51.2-37.9-63.4l-7-3.8-3.8 7L256 127.1 232.7 83.8l-3.8-7-7 3.8C199.3 92.7 184 116.6 184 144v82.7L89.6 118.8 143.2 11.6 128.8 4.4l-56 112c-1.5 2.9-1 6.4 1.1 8.8l97.2 111.1-133-35L15.6 133.5 .4 138.5l24 72c.9 2.6 2.9 4.5 5.6 5.2L167.8 252 30 288.3c-2.6 .7-4.7 2.6-5.6 5.2l-24 72 15.2 5.1 22.6-67.9 115.6-30.4-80.2 107c-1.6 2.1-2 4.8-1.2 7.3l40 120 15.2-5.1-38.7-116 57.7-77c-1.7 7.5-2.6 15.3-2.6 23.3v8.3C144 400 194.5 448 256 448s112-48 112-107.8v-8.3c0-8-.9-15.8-2.6-23.4l57.7 77-38.7 116 15.2 5.1 40-120c.8-2.5 .4-5.2-1.2-7.3l-80.2-107 115.6 30.4 22.6 67.9 15.2-5.1-24-72c-.9-2.6-2.9-4.5-5.6-5.2L344.2 252 482 215.7c2.6-.7 4.7-2.6 5.6-5.2l24-72-15.2-5.1-22.6 67.9-133 35L438 125.3c2.1-2.4 2.6-5.9 1.1-8.8zM222.7 99L249 147.8l7 13.1 7-13.1L289.3 99c13.8 10.2 22.7 26.6 22.7 45V253.1v4l3.2 2.4c22.5 16.9 36.8 43 36.8 72.3v8.3c0 50.4-42.7 91.8-96 91.8s-96-41.4-96-91.8v-8.3c0-29.3 14.3-55.4 36.8-72.3l3.2-2.4v-4V144c0-18.4 8.9-34.8 22.7-45zM216 280h-8v8 16 2.7l1.6 2.1L230 336l-20.4 27.2-1.6 2.1V368v16 8h8 80 8v-8V368v-2.7l-1.6-2.1L282 336l20.4-27.2 1.6-2.1V304 288v-8h-8H216zm8 21.3V296h64v5.3l-22.4 29.9L262 336l3.6 4.8L288 370.7V376H224v-5.3l22.4-29.9L250 336l-3.6-4.8L224 301.3z'
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fast',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 120h-8v8V384v8h8 96c75.1 0 136-60.9 136-136s-60.9-136-136-136H160zm96 256H168V136h88c66.3 0 120 53.7 120 120s-53.7 120-120 120z'
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fast',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      'M224 0H208 176 160V16 32 56.9L48 32H16 0V48 272v16H16 48l144-32 144 32h32 16V272 48 32H368 336L224 56.9V32 16 0zM208 60.4L192 64l-16-3.6V32 16h32V32 60.4zm16 235.4l-16-3.6V480v16H176V480 292.3l-16 3.6V480v16 16h16 32 16V496 480 295.9zm-35.5-55.5L46.2 272H16V48H46.2L188.5 79.6c2.3 .5 4.7 .5 6.9 0L337.8 48H368V272H337.8L195.5 240.4c-2.3-.5-4.7-.5-6.9 0z'
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fast',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      'M296 32h-8V48h8 51.1l57.4 112H205.6L166.7 99.7 164.4 96H160 104 96v16h8 51.6l36.4 56.5-26.9 61c-11.8-3.6-24.3-5.5-37.2-5.5C57.3 224 0 281.3 0 352s57.3 128 128 128c68 0 123.6-53 127.8-120H320h4.8l2.2-4.3 89.7-171.9L446.6 242C409.1 264.3 384 305.2 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-18.2 0-35.5 3.8-51.2 10.6L359.1 36.3 356.9 32H352 296zM453.9 256.2l51 99.4 3.7 7.1 14.2-7.3-3.6-7.1-51-99.4c13.5-5.7 28.3-8.9 43.9-8.9c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-40.6 21.6-76.1 53.9-95.8zm-295.2-12l-46 104.5L120 360H239.7c-4.1 58.1-52.6 104-111.7 104C66.1 464 16 413.9 16 352s50.1-112 112-112c10.7 0 20.9 1.5 30.7 4.3zM132.3 344l70.2-159.4L305.3 344H132.3zM216 176H402.8L319.3 336.1 216 176z'
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fast',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      'M32 48h8c30.9 0 56 25.1 56 56v88H32v16H96V408c0 39.8 32.2 72 72 72h16c110.5 0 200-89.5 200-200V264c0-39.8-32.2-72-72-72H264h-8v16h8 48c30.9 0 56 25.1 56 56v16c0 101.6-82.4 184-184 184H168c-30.9 0-56-25.1-56-56V208h80V192H112V104c0-39.8-32.2-72-72-72H32V48z'
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fast',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      'M224 0V8 64H384V8 0h16V8 64h96 16V80v96 16V400v16H496 112 96V400 192 176 80 64h16 96V8 0h16zM208 120V80H112v96H496V80H400v40 8H384v-8V80H224v40 8H208v-8zm288 72H112V400H496V192zM16 160H48v16H16V496H400V464h16v32 16H400 16 0V496 176 160H16z'
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fast',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm88 160h8v8V312v8H336v-8V187.3L173.7 349.7l-5.7 5.7L156.7 344l5.7-5.7L324.7 176H200h-8V160h8H344z'
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fast',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      'M529.6 183.1l7.3 10.1c9.5 13.1 15.1 29.3 15.1 46.8c0 41.8-32.1 76.2-73 79.7l-5.8 .5-4.1 4.1L409.4 384H320h-6.6l-4.7 4.7L265.4 432H155.1L269.7 317.7l0 0L331.3 256H440h8V240h-8H347.3l98.3-98.3 5.7-5.7L440 124.7l-5.7 5.7-112 112L272 292.7V200v-8H256v8V308.7L144 420.5V310.6l43.3-43.3 4.7-4.7V256 166.6L251.7 107l4.1-4.1 .5-5.8c3.5-40.9 37.9-73 79.7-73c17.5 0 33.6 5.6 46.8 15.1l10.1 7.3 9.5-8C419.1 24.4 440.5 16 464 16c53 0 96 43 96 96c0 23.5-8.4 44.9-22.4 61.6l-8 9.5zM139.1 448H144 272l48-48h96l64.4-64.4c49.1-4.2 87.6-45.4 87.6-95.6c0-21-6.7-40.3-18.1-56.1C566.2 164.4 576 139.4 576 112C576 50.1 525.9 0 464 0c-27.4 0-52.4 9.8-71.9 26.1C376.3 14.7 357 8 336 8c-50.2 0-91.4 38.5-95.6 87.6L176 160v96l-48 48V432v4.5L69.5 494.8l-5.7 5.7 11.3 11.3 5.7-5.7L139.1 448zM226.4 37.9c-2.9-4.1-6.2-8-9.9-11.7C181.6-8.7 125-8.7 90.1 26.2c-15.4 15.4-24 35.1-25.8 55.3C49 83.9 34.2 91.1 22.4 102.9c-27.8 27.8-29.8 71.6-5.9 101.7c.5 .6 .9 1.1 1.4 1.7v90 6.6l4.7 4.7L72.1 357l0 43v13.4l14.6-14.6c.5-.5 1-1 1.4-1.5l0-40.3v-6.6l-4.7-4.7L33.9 296.3v-90-5.8L30.2 196c-20-23.8-18.8-59.4 3.6-81.8c9.4-9.4 21-15 33.1-17l12.3-2 1.1-12.4c1.5-16.6 8.5-32.7 21.2-45.4c28.6-28.6 75.1-28.6 103.7 0c5.2 5.2 9.4 10.9 12.7 17.1c2.4-5.8 5.3-11.3 8.5-16.7z'
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fast',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      'M128.4 .5l5.1 4.8 32.9 31c16 15.1 16.8 40.2 1.9 56.3l-61.4 66.1c-8.8 9.5-8.5 24.2 .6 33.3L153 237.7c4.2-39.6 22.6-88.4 67.7-131.7C233 94.1 247.4 82.7 264 72l-7-61.5L255.8 .6l9.9 1L406.4 15.8c28.7-6.3 60.3-11.2 95.3-14.2l9.5-.8-.8 9.5c-3 35-7.8 66.6-14.2 95.3l14.2 141.6 1 10-10-1.3L440 248.1c-10.7 16.6-22.1 30.9-34 43.3c-43.3 45-92.1 63.4-131.7 67.7l45.5 45.5c9.1 9.1 23.8 9.4 33.3 .6l66.1-61.4c16.1-15 41.2-14.1 56.3 1.9l31 32.9 4.8 5.1-4.5 5.4-8 9.7c-27 32.8-76.4 35.1-106.5 5.1l-7-7-21.5 20c-15.8 14.6-40.3 14.2-55.5-1l-53.3-53.3-51.1 38.3L247 443.7c15.6 15.6 15.6 40.9 0 56.6l-9.4 9.4-11.3-11.3 9.4-9.4c9.4-9.4 9.4-24.6 0-33.9l-44.5-44.5-43.2 32.4c-7.6 5.7-11.9 14.6-11.8 24.1c.3 16.1 13.4 29 29.5 29h19.1 8v16h-8H165.8c-24.8 0-45.1-19.9-45.5-44.8c-.2-14.6 6.5-28.4 18.2-37.1l41.3-31-67-67L81.4 374.1C73 385.4 59.7 392 45.6 392C20.9 392 .9 372 .9 347.3V328v-8h16v8 19.3c0 15.9 12.9 28.7 28.7 28.7c9 0 17.6-4.3 23-11.5l32.8-43.8L57 276.3c-9.4-9.4-24.6-9.4-33.9 0l-9.4 9.4L2.3 274.3l9.4-9.4c15.6-15.6 40.9-15.6 56.6 0l42.9 42.9 38.3-51.1L96.1 203.5c-15.2-15.2-15.7-39.7-1-55.5l20-21.5-7-7C78.1 89.4 80.5 40 113.2 13l9.7-8 5.4-4.5zm-5.8 318.7l70.2 70.2 58.4-43.8 2.1-1.6H256c38 0 91.4-14.8 138.4-63.7c45.9-47.8 86.2-128.8 99.1-261.8c-133.1 12.9-214 53.2-261.8 99.1C182.8 164.5 168 218 168 256v2.7l-1.6 2.1-43.8 58.4zm326.5-86.2l44.4 5.7-8.9-89c-9.9 32.1-22 59.7-35.5 83.3zM362.2 27.4L274 18.6l5 44.3c23.6-13.5 51.1-25.5 83.2-35.4zM126 114.7l30.5-32.9c9-9.7 8.5-24.7-1.1-33.8L127.6 21.9l-4.2 3.5c-25.5 21-27.3 59.4-4 82.8l6.6 6.5zM397.3 386l6.6 6.6c23.4 23.4 61.8 21.5 82.8-4l3.5-4.2L464 356.6c-9-9.6-24.1-10.1-33.8-1.1L397.3 386zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fast',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M440 40v8 56h56 8v16h-8H440v56 8H424v-8V120H368h-8V104h8 56V48 40h16zm0 288v8 56h56 8v16h-8H440v56 8H424v-8V408H368h-8V392h8 56V336v-8h16zm-73.9-63.1L256 320 200.9 430.1 192 448l-8.9-17.9L128 320 17.9 264.9 0 256l17.9-8.9L128 192 183.1 81.9 192 64l8.9 17.9L256 192l110.1 55.1L384 256l-17.9 8.9zM241.7 312.8l2.4-4.8 4.8-2.4L348.2 256l-99.4-49.7-4.8-2.4-2.4-4.8L192 99.8l-49.7 99.4-2.4 4.8-4.8 2.4L35.8 256l99.4 49.7 4.8 2.4 2.4 4.8L192 412.2l49.7-99.4z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fast',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M364.4 32h17.3L199.4 475l-2 5H186.6l-2-5L2.3 32H19.6L192 451 364.4 32z'
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fast',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      'M512 512L0 512l0-16 512 0v16zM208 400l0-384L80 16l0 384H208zM80 416H64l0-16L64 16 64 0H80 208h16V16l0 384v16l-16 0H80zm352-16l0-256H304l0 256H432zM304 416H288V400l0-256V128h16H432h16v16l0 256v16H432 304z'
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fast',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      'M86.9 108.4C135.2 62.3 211 16 320 16s184.8 46.3 233.1 92.4c29 27.8 54.1 60.3 70.9 96.2V362.3L500.1 416.2l-2.5 18.5L640 372.8V201.1c-17.8-39.2-44.8-74.5-75.9-104.2C513.6 48.5 434 0 320 0S126.4 48.5 75.9 96.9c-31 29.7-58 64.9-75.9 104.2V372.8l142.4 61.9-2.5-18.5L16 362.3V204.6c16.8-35.8 41.9-68.4 70.9-96.2zM168 144h-8v8 72h16V160H464v64h16V152v-8h-8H168zM496 256H480 464 176 160 144 128h-8v16h8 25l31.1 233.1 .9 6.9h10.8l2.4-3 51.4-64.2 64.7 64.9 2.3 2.4h6.6l2.3-2.4 64.7-64.9L441.8 509l2.4 3H455l.9-6.9L487 272h25 8V256h-8H496zm-25.1 16l-10.6 79.7L400.1 272h70.8zm-103.5 0L320 331.2 272.6 272h94.7zm-127.4 0l-60.2 79.7L169.1 272h70.8zM197.5 484.4L183.3 378.2l55 55.2-40.8 51zM320 492.7l-60.3-60.5L320 356.8l60.3 75.4L320 492.7zm-71.7-71.9l-57.3-57.5L256.2 277l53.6 67-61.4 76.8zm143.3 0L330.2 344l53.6-67L449 363.3l-57.3 57.5zm10.1 12.6l55-55.2L442.5 484.4l-40.8-51z'
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fast',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      'M130 48c17.7 0 35 5.8 49.2 16.4l40 30 21.3 16 6.4 4.8 9.6-12.8-6.4-4.8-13.4-10 22.2-19C274.4 55.3 294.2 48 314.6 48c47.2 0 85.4 38.3 85.4 85.4v3.6c0 13.8-3.2 27.5-9.4 39.8l-29.8 59.5-.5 1.1-.2 1.2L321.3 464H301.9L253 309.6c-1.1-3.3-4.1-5.6-7.6-5.6H200c-3.5 0-6.6 2.3-7.7 5.7L146 464H126.7L87.9 238.6l-.2-1.2-.5-1.1L57.4 176.9c-6.2-12.4-9.4-26-9.4-39.8V130c0-45.3 36.7-82 82-82zm93.7 29.7L188.8 51.6C171.8 38.9 151.2 32 130 32c-54.1 0-98 43.9-98 98v7.1c0 16.3 3.8 32.4 11.1 47l29.2 58.4 39.8 230.8c.7 3.8 4 6.6 7.9 6.6h32c3.5 0 6.6-2.3 7.7-5.7L206 320h33.5l48.9 154.4c1.1 3.3 4.1 5.6 7.6 5.6h32c3.9 0 7.2-2.8 7.9-6.6l39.8-230.8 29.2-58.4c7.3-14.6 11.1-30.7 11.1-47v-3.6C416 77.4 370.6 32 314.6 32c-24.2 0-47.6 8.7-66 24.4L223.7 77.7z'
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fast',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM160.5 150.3c-5.1 10.3-8.5 25-8.5 41.7s3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C186.1 139.6 180.2 136 176 136s-10.1 3.6-15.5 14.3zm-14.3-7.2c6.2-12.4 16.3-23.2 29.8-23.2s23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C199.6 253.3 189.5 264 176 264s-23.6-10.7-29.8-23.2C139.8 227.9 136 210.6 136 192s3.8-35.9 10.2-48.8zM312 192c0 16.7 3.4 31.4 8.5 41.7c5.4 10.7 11.3 14.3 15.5 14.3s10.1-3.6 15.5-14.3c5.1-10.3 8.5-25 8.5-41.7s-3.4-31.4-8.5-41.7C346.1 139.6 340.2 136 336 136s-10.1 3.6-15.5 14.3c-5.1 10.3-8.5 25-8.5 41.7zm24-72c13.5 0 23.6 10.7 29.8 23.2c6.5 12.9 10.2 30.2 10.2 48.8s-3.8 35.9-10.2 48.8C359.6 253.3 349.5 264 336 264s-23.6-10.7-29.8-23.2C299.8 227.9 296 210.6 296 192s3.8-35.9 10.2-48.8c6.2-12.4 16.3-23.2 29.8-23.2z'
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fast',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      'M112 48c53 0 96 43 96 96V256H16V144c0-53 43-96 96-96zM16 368V272H208v96c0 53-43 96-96 96s-96-43-96-96zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 464c-79.5 0-144-64.5-144-144c0-36.9 13.9-70.5 36.7-96L512 427.3c-25.5 22.8-59.1 36.7-96 36.7zM320 212.7c25.5-22.8 59.1-36.7 96-36.7c79.5 0 144 64.5 144 144c0 36.9-13.9 70.5-36.7 96L320 212.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fast',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      'M456 224h8V208h-8H315.3L501.7 21.7l5.7-5.7L496 4.7l-5.7 5.7L304 196.7V56 48H288v8V216v8h8H456zM56 288H48v16h8H196.7L10.3 490.3 4.7 496 16 507.3l5.7-5.7L208 315.3V456v8h16v-8V296v-8h-8H56z'
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fast',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      'M84.2 73.5C109.1 56.9 138.4 48 168.3 48H235c46.9 0 85 38.1 85 85c0 22.4-8.8 43.4-23.8 59H16 0v16H16 275c-1.2 .7-2.5 1.3-3.8 1.9L106 287.6c-.3 .1-.5 .2-.8 .4H16 0v16H16 81.4C60.5 322.9 48 350 48 379c0 55.8 45.2 101 101 101h66.7c33.1 0 65.5-9.8 93-28.2l7.8-5.2 6.7-4.4-8.9-13.3-6.7 4.4-7.8 5.2c-24.9 16.6-54.2 25.5-84.1 25.5H149c-46.9 0-85-38.1-85-85c0-31.5 17.4-60.3 45-75H368h16V288H368 142.8L278 224.4c9.1-4.3 17.4-9.8 24.6-16.4H368h16V192H368 317c12.1-16.9 19-37.4 19-59c0-55.8-45.2-101-101-101H168.3c-33.1 0-65.5 9.8-93 28.2l-7.8 5.2-6.7 4.4 8.9 13.3 6.7-4.4 7.8-5.2z'
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fast',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M8 32H0V48H8 152V464H8 0v16H8 312h8V464h-8H168V48H312h8V32h-8H160 8z'
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fast',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      'M184 0V8 22C128.4 39.1 88 90.8 88 152v8l-16 0H64v16h8H376h8V160h-8l-16 0v-8c0-61.2-40.4-112.9-96-130V8 0h-8H192h-8zm0 38.8V88v8h16V88 16h48V88v8h16V88 38.8c46.6 16.5 80 60.9 80 113.2v8H104v-8c0-52.2 33.4-96.7 80-113.2zM224 320c65.3 0 119.1-48.9 127-112H334.9c-7.8 54.3-54.4 96-110.9 96s-103.1-41.7-110.9-96H97c7.9 63.1 61.7 112 127 112zM59.9 368H388.1l38.4 128H21.5L59.9 368zM443.2 496L400 352H48L4.8 496 0 512H16.7 431.3 448l-4.8-16z'
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fast',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm272 40H431.8c-4.2 75.8-66.9 136-143.8 136c-79.5 0-144-64.5-144-144s64.5-144 144-144c76.8 0 139.6 60.2 143.8 136H288h-8v16h8zm160-8a160 160 0 1 0 -320 0 160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fast',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      'M54.8 496H329.2L366.7 16H17.3L54.8 496zM344 512H40L1.3 16 0 0H16 368h16l-1.3 16L344 512z'
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fast',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      'M152 104V96H136v8 24H16 8v16h8H136V296v8h8 53.6l0 0-35.7 42.9-1.9 2.2V352v56 8h16v-8V354.9l35-42 56.6 37.7 2 1.3H272h96 2.4l2-1.3L429 312.9l35 42V408v8h16v-8V352v-2.9l-1.9-2.2L442.4 304l0 0H496h8v-8V144H624h8V128h-8H504V104 96H488v8 24H368h-8v16h8H488v99.8l-80-35c-25.3-11.1-52.6-16.8-80.2-16.8H312.2c-27.6 0-54.9 5.7-80.2 16.8l-80 35V144H272h8V128h-8H152V104zm0 157.2l86.4-37.8c23.3-10.2 48.4-15.4 73.8-15.4h15.7c25.4 0 50.5 5.3 73.8 15.4L488 261.2V288H440h-2.4l-2 1.3-70 46.7H274.4l-70-46.7-2-1.3H200 152V261.2z'
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fast',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      'M424 32h8H568h8V48h-8H440V184v8h-8H296V328v8h-8H152V472v8h-8H8 0V464H8 136V328v-8h8H280V184v-8h8H424V40 32z'
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fast',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      'M528.1 512l-20.3-16H240V416H224v88 8h8H528.1zM560 291.5v62.3l16 12.6V192c0-51.9-11.9-99.3-31.5-134C525 23.5 496.9 0 464 0H176c-16.1 0-31.1 5.6-44.5 15.5l13.1 10.4c10-6.5 20.6-9.8 31.3-9.8H418.8c-13.6 10.2-25.5 24.7-35.3 42c-19.3 34.2-31.1 80.6-31.5 131.6l16.2 12.8c-.1-3.4-.2-6.8-.2-10.3c0-49.7 11.4-94.3 29.4-126.2C415.6 33.7 439.4 16 464 16s48.4 17.7 66.6 49.8C548.6 97.7 560 142.3 560 192s-11.4 94.3-29.4 126.2c-1.6 2.9-3.3 5.7-5.1 8.3l12.6 9.9c2.2-3.3 4.3-6.8 6.4-10.4c5.9-10.4 11.1-22 15.5-34.6zM64 192c0 51.9 11.9 99.3 31.5 134c19.5 34.5 47.6 58 80.5 58H365.9l-20.3-16H176c-24.6 0-48.4-17.7-66.6-49.8C91.4 286.3 80 241.7 80 192c0-11.1 .6-21.9 1.7-32.4L66.9 147.9C65 162.1 64 176.9 64 192zm420.6 63c4.8-4.8 8.4-10.8 11.1-17.1c5.4-12.6 8.3-28.8 8.3-45.9s-2.9-33.3-8.3-45.9c-2.7-6.3-6.3-12.3-11.1-17.1c-4.9-4.8-11.9-9-20.6-9s-15.7 4.2-20.6 9c-4.8 4.8-8.4 10.8-11.1 17.1c-5.4 12.6-8.3 28.8-8.3 45.9s2.9 33.3 8.3 45.9c2.7 6.3 6.3 12.3 11.1 17.1c4.9 4.8 11.9 9 20.6 9s15.7-4.2 20.6-9zM464 248c-13.3 0-24-25.1-24-56s10.7-56 24-56s24 25.1 24 56s-10.7 56-24 56zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fast',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      'M48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm8 15.3V384.7C76.1 388 92 403.9 95.3 424H352.7c3.4-20.1 19.2-36 39.3-39.3V127.3c-20.1-3.4-36-19.2-39.3-39.3H95.3C92 108.1 76.1 124 56 127.3zM95.3 440c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3V127.3C17.3 123.5 0 103.8 0 80C0 53.5 21.5 32 48 32c23.8 0 43.5 17.3 47.3 40H352.7c3.8-22.7 23.6-40 47.3-40c26.5 0 48 21.5 48 48c0 23.8-17.3 43.5-40 47.3V384.7c22.7 3.8 40 23.6 40 47.3c0 26.5-21.5 48-48 48c-23.8 0-43.5-17.3-47.3-40H95.3zM80 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fast',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM200 240H184v8 72H112h-8v16h8 72v72 8h16v-8V336h72 8V320h-8H200V248v-8z'
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fast',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      'M309.3 155.6l-5.3 4.8v7.2V256v16h16 96c44.2 0 80 35.8 80 80v48H16V352c0-44.2 35.8-80 80-80h96 16V256 167.6v-7.2l-5.3-4.8C186.3 141 176 119.7 176 96c0-44.2 35.8-80 80-80s80 35.8 80 80c0 23.7-10.3 45-26.7 59.6zM512 416V400 352c0-53-43-96-96-96H336 320V240 167.6c19.6-17.6 32-43.1 32-71.6c0-53-43-96-96-96s-96 43-96 96c0 28.4 12.4 54 32 71.6V240v16H176 96c-53 0-96 43-96 96v48 16H16 496h16zM48 456v-8H32v8 48 8h8H472h8v-8V456v-8H464v8 40H48V456z'
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fast',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      'M381.5 496l2.5 16H367.8 16.2 0l2.5-16L62.7 110.7C72.7 47 127.5 0 192 0s119.3 47 129.3 110.7L381.5 496zM315.3 176H68.7l-50 320H365.3l-50-320zm-2.5-16l-7.3-46.9C296.7 57.2 248.6 16 192 16S87.3 57.2 78.5 113.1L71.2 160H312.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM123.4 224h16.1L111 448H94.9l28.4-224zm137.3 0l28.4 224H273L244.5 224h16.1z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fast',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      'M424 0h-8V16h8 91.9L320.3 189 197.7 66.3l-5-5-5.6 4.4-184 144 9.9 12.6L191.4 82.7l123 123 5.3 5.3 5.6-5L528 26.7V120v8h16v-8V8 0h-8H424zM208 240V464H176V240h32zm-32-16H160v16V464v16h16 32 16V464 240 224H208 176zM80 336V464H48V336H80zM48 320H32v16V464v16H48 80 96V464 336 320H80 48zm256 48a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM392.1 335.5c-.5-8 3.7-13.5 11.7-17.6c8.3-4.2 19.3-6 28.1-5.8c11.2 .2 22.8 2.3 34.3 5l7.8 1.8 3.7-15.6-7.8-1.8c-9.4-2.2-19.6-4.2-29.8-5V280v-8H424v8 16.3c-8.9 .7-18.9 2.9-27.4 7.3c-11.5 5.9-21.6 16.4-20.4 32.9c.9 13.4 10.1 21.5 20.2 26.7c9.4 4.8 21.4 8 32.3 11l1.8 .5c12 3.2 22.7 6.2 30.5 10.6c7.5 4.2 10.9 8.8 11.1 14.9c.3 8.7-4.2 14.3-11.7 18.3c-7.9 4.1-18.7 5.7-28 5.5c-13.1-.4-25.6-4.2-39.2-8.3l0 0 0 0c-2.2-.7-4.4-1.3-6.7-2l-7.7-2.3-4.5 15.3 7.7 2.3c2.1 .6 4.2 1.3 6.3 1.9l0 0c11.2 3.4 23.3 7.1 35.9 8.5v18.1 8h16v-8V439.8c9.2-.6 19.1-2.7 27.6-7.1c11.5-5.9 20.9-16.6 20.4-33c-.4-13.9-9-22.7-19.2-28.4c-9.9-5.5-22.6-9-34.1-12.1l-1-.3c-11.7-3.1-22.1-6-30-10c-7.9-4.1-11.2-8.3-11.5-13.5z'
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fast',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      'M128 76.8C110.7 31.9 67.1 0 16 0H8 0V16H8h8c57.4 0 104 46.6 104 104V248H64 56v16h8 56V392c0 57.4-46.6 104-104 104H8 0v16H8h8c51.1 0 94.7-31.9 112-76.8c17.3 44.9 60.9 76.8 112 76.8h8 8V496h-8-8c-57.4 0-104-46.6-104-104V264h56 8V248h-8H136V120c0-57.4 46.6-104 104-104h8 8V0h-8-8c-51.1 0-94.7 31.9-112 76.8z'
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fast',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM136 160H280h8v16h-8H155.3L317.7 338.3l5.7 5.7L312 355.3l-5.7-5.7L144 187.3V312v8H128v-8V168v-8h8z'
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fast',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      'M49.7 32H56 280h8V48h-8H62.3L21.3 224H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H100.7C60.5 480 24 456.9 6.7 420.6l-4.4-9.2 14.5-6.9 4.4 9.2C35.8 444.4 66.7 464 100.7 464H192c61.9 0 112-50.1 112-112s-50.1-112-112-112H11.2 1.1l2.3-9.8 44.8-192L49.7 32z'
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fast',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      'M328 0H312V8 184v8h16v-8V8 0zM38.5 124.8l-9.7 12.7 6.4 4.9 136 104 6.4 4.9 9.7-12.7-6.4-4.9-136-104-6.4-4.9zm572.7 12.7l-9.7-12.7-6.4 4.9-136 104-6.4 4.9 9.7 12.7 6.4-4.9 136-104 6.4-4.9zM192 352v16H176 128L71.1 496 64 512H81.5h477H576l-7.1-16L512 368H464 448h0V352 304 288H432 208 192v16 48zm240 16H208V304H432v64zM208 384H432h16 0 53.6l49.8 112H88.6l49.8-112H192h0 16z'
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fast',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      'M264 32h-8V48h8H400v59.7L333.6 152H299.3c-59.1 0-114.5 26.1-152.2 70.2L94.9 144H120h8V128h-8H40 32v16h8H75.7l61 91.5c-2.7 3.8-5.3 7.7-7.8 11.7l-5.8 9.4c-3.7-.4-7.4-.6-11.2-.6C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-52.1-35.6-96-83.9-108.4l2.5-4c33.5-54.4 92.8-87.6 156.7-87.6h30.5l15.5 62C293.5 246.4 256 294.8 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-7.9 0-15.7 .7-23.2 2.1l-15.6-62.6 67.3-44.9 3.6-2.4V112 40 32h-8H264zm85.1 213.5l27.1 108.4 1.9 7.8 15.5-3.9-1.9-7.8L364.7 241.7c6.3-1.1 12.7-1.7 19.3-1.7c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-49.7 32.4-91.8 77.1-106.5zM112 272a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fast',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      'M256 16C123.5 16 16 123.5 16 256c0 100.3 61.5 186.2 148.8 222.1c2.4 7.3 5.7 14.3 9.7 20.7C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8c4-6.4 7.3-13.4 9.7-20.7C434.5 442.2 496 356.3 496 256C496 123.5 388.5 16 256 16zm56 192c30.9 0 56-25.1 56-56c0-27.9-20.4-51-47.1-55.3C330.1 104 336 115.3 336 128c0 22.1-17.9 40-40 40c-18.3 0-33.7-12.3-38.5-29c-1 4.2-1.5 8.5-1.5 13c0 30.9 25.1 56 56 56zm0-128a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM184 368h8 48 3.3l2.3 2.3L256 380.7l10.3-10.3 2.3-2.3H272h48 8v8 64c0 39.8-32.2 72-72 72s-72-32.2-72-72V376v-8zm64 27.3L236.7 384H200v56c0 30.9 25.1 56 56 56s56-25.1 56-56V384H275.3L264 395.3V424v8H248v-8V395.3zM176 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 224a64 64 0 1 1 128 0A64 64 0 1 1 64 224zm232-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm259.3 21.2l3.8 7C401.9 256.4 408 279.5 408 304c0 43.8-19.6 83.1-50.5 109.5l-6.1 5.2-10.4-12.2 6.1-5.2C374.6 377.8 392 343 392 304c0-18.9-4.1-36.9-11.5-53.1L155 371.2c3.2 5.2 6.8 10.1 10.6 14.8l5.1 6.1-12.3 10.2-5.1-6.1c-6.3-7.5-11.8-15.7-16.5-24.4l-3.8-7.1 7.1-3.8 240.1-128 7.1-3.8z'
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fast',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm96 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM64 112c167.9 0 304 136.1 304 304h16C384 239.3 240.7 96 64 96v16zM288 416c0-123.7-100.3-224-224-224v16c114.9 0 208 93.1 208 208h16z'
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fast',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      'M16 345.4V166.6L166.6 16H345.4L496 166.6V345.4L345.4 496H166.6L16 345.4zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm-8 264H360V248H152v16z'
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fast',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM144 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm112-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fast',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      'M53.2 464L172.1 48H312v56 8h16v-8V48H467.9l41.3 144.5c5.8 .4 11.6 1.2 17.3 2.1L480 32H160L36.6 464 32 480H48.6 360.2c-4.2-5.1-8.1-10.4-11.8-16H328V420.6c-2.1-6.7-3.8-13.6-5.1-20.6H312v8 56H53.2zM328 312V200v-8H312v8V312v8h14.6c.4-1.5 .9-3.1 1.4-4.6V312zm168-72a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fast',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM181.7 370.3c14.3 14.3 39 29.7 74.3 29.7s60.1-15.4 74.3-29.7l5.7-5.7L347.3 376l-5.7 5.7C325 398.3 296.4 416 256 416s-69-17.7-85.7-34.3l-5.7-5.7L176 364.7l5.7 5.7zm170-98.3c14.6 0 30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7c10.9 19.3 26.4 27.9 41 27.9zm-233-27.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9l3.9-7 13.9 7.8-3.9 7c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1l-3.9-7 13.9-7.8 3.9 7zm83.5-143l-7.6 2.5-6.3 2.1c-25.3 8.4-47.1 25.1-61.9 47.3l-7.6 11.5-4.4 6.7-13.3-8.9 4.4-6.7 7.6-11.5c16.8-25.2 41.5-44 70.2-53.6l6.3-2.1 7.6-2.5 5.1 15.2zm115.4 2.5l-7.6-2.5 5.1-15.2 7.6 2.5 6.3 2.1c28.7 9.6 53.4 28.4 70.2 53.6l7.6 11.5 4.4 6.7-13.3 8.9-4.4-6.7L385.7 153c-14.8-22.2-36.6-38.8-61.9-47.3l-6.3-2.1z'
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fast',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      'M164.3 7.7L256 57.1 347.7 7.7 362 0l4.7 15.6L381.5 65c-5 2.1-9.8 4.5-14.6 7L352.3 23.4 263.6 71.2 256 75.3l-7.6-4.1L159.7 23.4l-29 96.6-2.5 8.3-8.3 2.5-96.6 29 47.8 88.8 4.1 7.6-4.1 7.6L23.4 352.3l96.6 29 8.3 2.5 2.5 8.3 29 96.6 88.8-47.8 7.6-4.1 7.6 4.1 88.8 47.8L366.9 440c4.8 2.5 9.6 4.9 14.6 7l-14.8 49.3L362 512l-14.4-7.7L256 454.9l-91.7 49.4L150 512l-4.7-15.6-29.9-99.7L15.6 366.7 0 362l7.7-14.4L57.1 256 7.7 164.3 0 150l15.6-4.7 99.7-29.9 29.9-99.7L150 0l14.4 7.7zM256 144c10.4 0 20.6 1.4 30.1 4.1c-2.9 4.7-5.5 9.5-8 14.5c-7.1-1.7-14.5-2.6-22.1-2.6c-53 0-96 43-96 96s43 96 96 96c7.6 0 15-.9 22.1-2.6c2.5 4.9 5.2 9.8 8 14.5c-9.6 2.7-19.7 4.1-30.1 4.1c-61.9 0-112-50.1-112-112s50.1-112 112-112zM624 256a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm-336 0a176 176 0 1 1 352 0 176 176 0 1 1 -352 0z'
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fast',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      'M157.4 25l5.9 5.4L152.4 42.2l-5.9-5.4C132.7 23.9 114.1 16 93.7 16C50.8 16 16 50.8 16 93.7c0 15.4 4.4 29.7 12.1 41.7l4.3 6.7-13.5 8.6L14.6 144C5.4 129.5 0 112.2 0 93.7C0 42 42 0 93.7 0c24.6 0 47 9.5 63.7 25zm-54.1 427L53.7 501.7 48 507.3 36.7 496l5.7-5.7 49.7-49.7C54.8 400.6 32 347 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 59-22.8 112.6-60.1 152.6l49.7 49.7 5.7 5.7L464 507.3l-5.7-5.7-49.7-49.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1zM464 288A208 208 0 1 0 48 288a208 208 0 1 0 416 0zM354.6 25C371.3 9.5 393.7 0 418.3 0C470 0 512 42 512 93.7c0 18.5-5.4 35.8-14.6 50.3l-4.3 6.7-13.5-8.6 4.3-6.7c7.7-12 12.1-26.3 12.1-41.7C496 50.8 461.2 16 418.3 16c-20.4 0-39 7.9-52.8 20.7l-5.9 5.4L348.7 30.4l5.9-5.4zM264 168V300.2l77 61.6 6.2 5-10 12.5-6.2-5-80-64-3-2.4V304 168v-8h16v8z'
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fast',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      'M429.7 93.7L424 99.3 412.7 88l5.7-5.7 80-80 11.3 11.3-80 80zm-240 240l-176 176L2.3 498.3l176-176 5.7-5.7L195.3 328l-5.7 5.7zM240 80C151.6 80 80 150.9 80 238.2v8H64v-8C64 141.9 142.9 64 240 64s176 77.9 176 174.2c0 55.6-26.3 105-67.2 136.9V392c0 66.3-53.7 120-120 120H206.4h-8V496h8 22.4c57.4 0 104-46.6 104-104V371.1c0-2.5 1.2-4.9 3.2-6.4c38.9-28.9 64-74.8 64-126.5C400 150.9 328.4 80 240 80zm0 64c-53 0-96 43-96 96v8H128v-8c0-61.9 50.1-112 112-112s112 50.1 112 112v8H336v-8c0-53-43-96-96-96z'
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fast',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      'M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm496 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM248 408V256v-8h8H376h8v16h-8H264V408v8H248v-8z'
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fast',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm134.2 19.9l-3.9 7-13.9-7.8 3.9-7c13.1-23.4 33.6-36.1 55-36.1s41.8 12.7 55 36.1l3.9 7-13.9 7.8-3.9-7c-10.9-19.3-26.4-27.9-41-27.9s-30.2 8.6-41 27.9z'
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fast',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      'M480 176l22.1 33.1L512 224l8.9-15.5L576 112 448 0 208 128 96 384h17.5l107-244.5L445.8 19.3l109.8 96.1L511 193.6l-17.6-26.5-4.7-7.1H480 432h-9.9l-4.4 8.8-16 32-3.1 6.2 2.4 6.5L463 384h17L416 208l16-32h48zM240 336h96v48h16V336 320H336 240 224v16 48h16V336zm320 96v6.1L444.2 496H131.8L16 438.1V432H560zm0-16H16 0v16 16l128 64H448l128-64V432 416H560z'
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fast',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      'M411.2 173.2l49.9 79.1c-43 33.2-117 25.1-171.7-29.6c-52.4-52.4-62.1-122.5-33.6-166.1L304 133l1.5 2.3 2.6 .9 103.1 36.9zM446.6 65.4c56.5 56.5 63.3 133.5 26.3 175.7l-49.7-78.8-1.5-2.3-2.6-.9L316.1 122.1 266.4 43.3l.5-.5C308.1 1.7 388.3 7 446.6 65.4zm33.8 191.1C530.1 206.8 520.1 116.1 458 54S305.2-18.1 255.6 31.6S215.9 171.9 278 234s152.7 72.2 202.4 22.5zm-336.8 160l-19.9 79.4C66.8 493.1 16 433 16 352c0-77.1 46-135.2 99.5-143.1L96.2 286.1l-.6 2.4 .9 2.3 47.1 125.7zM240 352c0 77.1-46 135.2-99.5 143.1l19.3-77.1 .6-2.4-.9-2.3L112.4 287.5l19.9-79.4C189.2 210.9 240 270.9 240 352zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z'
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fast',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      'M160 432V416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432zm0-32h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm62.8-244.2L256 208.9l33.2-53.1 2.4-3.8 4.4 0 8 0 8 0v8 96 8H296v-8V175.1l-33.2 53.1L256 239.1l-6.8-10.9L216 175.1V256v8H200v-8V160v-8l8 0 8 0 4.4 0 2.4 3.8zM372.8 152H392h8v16h-8H372.8c-7.1 0-12.8 5.8-12.8 12.8c0 4.3 2.1 8.3 5.7 10.7l29.4 19.6c8 5.3 12.8 14.4 12.8 24c0 15.9-12.9 28.8-28.8 28.8H352h-8V248h8 27.2c7.1 0 12.8-5.8 12.8-12.8c0-4.3-2.1-8.3-5.7-10.7l-29.4-19.6c-8-5.3-12.8-14.4-12.8-24c0-15.9 12.9-28.8 28.8-28.8zM104 180.8c0-15.9 12.9-28.8 28.8-28.8H152h8v16h-8H132.8c-7.1 0-12.8 5.8-12.8 12.8c0 4.3 2.1 8.3 5.7 10.7l29.4 19.6c8 5.3 12.8 14.4 12.8 24c0 15.9-12.9 28.8-28.8 28.8H112h-8V248h8 27.2c7.1 0 12.8-5.8 12.8-12.8c0-4.3-2.1-8.3-5.7-10.7l-29.4-19.6c-8-5.3-12.8-14.4-12.8-24z'
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fast',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      'M88 0h8H224h8V8 56v8h-8-4.8c22.1 23.5 44.7 52.7 62.9 83.4c21.8 36.9 37.9 77 37.9 112.5c0 33.1-12.4 81.3-56 111.8V384H248V367.5v-4.3l3.6-2.4c40.5-26.4 52.4-70.2 52.4-100.9c0-24.6-8.9-52.9-23.1-81.4L173.7 285.7l-5.7 5.7L156.7 280l5.7-5.7L273 163.7c-1.5-2.7-3.1-5.4-4.7-8.1c-21.2-35.8-48.7-69.5-73.8-93.9L180.4 48h19.7H216V16H104V48h15.9 19.7L125.4 61.7c-25.1 24.3-52.6 58.1-73.8 93.9C30.3 191.6 16 228.7 16 259.9c0 30.6 11.9 74.5 52.4 100.9l3.6 2.4v4.3V384H56V371.7C12.4 341.2 0 293 0 259.9c0-35.5 16-75.6 37.9-112.5c18.2-30.7 40.9-60 62.9-83.4H96 88V56 8 0zM16 496H304V475.5L264.9 432H55.1L16 475.5V496zM0 496V469.3L48 416H272l48 53.3V496v16H304 16 0V496z'
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fast',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      'M267.3 11.3L331 75l90 0 16 0 0 16 0 90 63.7 63.7L512 256l-11.3 11.3L437 331l0 90 0 16-16 0-90 0-63.7 63.7L256 512l-11.3-11.3L181 437l-90 0-16 0 0-16 0-90L11.3 267.3 0 256l11.3-11.3L75 181l0-90 0-16 16 0 90 0 63.7-63.7L256 0l11.3 11.3zM331 91l-6.6 0-4.7-4.7L256 22.6 192.3 86.3 187.6 91 181 91 91 91l0 90 0 6.6-4.7 4.7L22.6 256l63.7 63.7 4.7 4.7 0 6.6 0 90 90 0 6.6 0 4.7 4.7L256 489.4l63.7-63.7 4.7-4.7 6.6 0 90 0 0-90 0-6.6 4.7-4.7L489.4 256l-63.7-63.7-4.7-4.7 0-6.6 0-90-90 0zm-67 37l0 8 0 160 0 8-16 0 0-8 0-160 0-8 16 0zM240 336l32 0 0 32-32 0 0-32z'
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fast',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      'M16 48H432V182.5l16-24.6V48 32H432 16 0V48 464v16H16 344.2c-3.4-5.1-6.5-10.5-9.3-16H16V48zM384 256V104 96h-8H296 224 152 72 64v8V256 408v8h8 80 72 72 24.9c-.6-5.3-.9-10.6-.9-16H304V264h64v16.8l16-24.6V256zM80 248V112h64V248H80zm80 0V112h56V248H160zm72 0V112h56V248H232zm72 0V112h64V248H304zm-16 16V400H232V264h56zm-72 0V400H160V264h56zm-72 0V400H80V264h64zm239.9 80.3l80.1-123 80.1 123c10.4 15.9 15.9 34.5 15.9 53.5V400c0 53-43 96-96 96s-96-43-96-96v-2.1c0-19 5.5-37.6 15.9-53.5zm-13.4-8.7c-12.1 18.5-18.5 40.2-18.5 62.3V400c0 61.9 50.1 112 112 112s112-50.1 112-112v-2.1c0-22.1-6.4-43.7-18.5-62.3l-84-128.9L464 192l-9.5 14.7-84 128.9z'
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fast',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      'M368 80v88V344v88H16V80H368zm16 352V352 334.1 177.9 160 80 64H368 16 0V80 432v16H16 368h16V432zm176-9.9l-144-72V368l144 72 16 8V430.1 81.9 64l-16 8L416 144v17.9l144-72V422.1zM152 160h-8v16h8H260.7L98.3 338.3 92.7 344 104 355.3l5.7-5.7L272 187.3V296v8h16v-8V168v-8h-8H152z'
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fast',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      'M252.3 23l9.4-9.4L250.3 2.3 241 11.7C226.9 25.8 218.2 44.3 216.4 64H96C43 64 0 107 0 160v32 16H16 432h16V192 160c0-53-43-96-96-96H232.5c1.8-15.4 8.7-29.9 19.8-41zM352 80c44.2 0 80 35.8 80 80v32H16V160c0-44.2 35.8-80 80-80H352zM48.4 240C52.6 320.1 89.3 435.1 224 480c134.7-44.9 171.4-159.9 175.6-240h-16c-4.1 75.4-38.2 180.1-159.6 223.1C102.6 420.1 68.5 315.4 64.4 240h-16z'
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fast',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      'M128 336V176H624V336H128zm-16 0H16V176h96V336zm8-176h-8H16 0v16V336v16H16h96 8 8H624h16V336 176 160H624 128h-8zm184 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fast',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      'M59.1 5.1L48 .5v12V84.1C19 104.3 0 137.9 0 176c0 61.9 50.1 112 112 112L39.2 433.7 32 448l14.3 7.2 99.4 49.7L160 512l7.2-14.3L272 288h64v16 8h16v-8V288 272 184h48v88 8h16v-8V184h48v16 5.3l4.9 2.1 96 40L576 252V240 112 100l-11.1 4.6-96 40-4.9 2.1V152v16H416V80 72H400v8 88H352V80 64 48 40H336v8V64H201.6L59.1 5.1zM254.1 288L152.8 490.5 53.5 440.8 129.9 288H254.1zM480 194.7V184 168 157.3L560 124V228l-80-33.3zM199.8 80h.4H336v96 96H112c-53 0-96-43-96-96s43-96 96-96h87.8zM159.7 64H112c-17.2 0-33.5 3.9-48 10.8V24.4L159.7 64zM128 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fast',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      'M328 8V0H312V8 64H208h-4.9l-2.2 4.4L208 72c-7.2-3.6-7.2-3.6-7.2-3.6l0 0 0 0-.1 .1-.2 .5-.9 1.8c-.8 1.6-1.9 3.9-3.3 6.9c-2.9 6-7 14.7-11.9 25.5c-9.8 21.6-22.9 51.8-35.9 85.9C122.5 257.2 96 342.4 96 408v64 8h8 64 1.6l1.5-.6L312 420v84 8h16v-8V420l140.9 59.3 1.5 .6H472h64 8v-8V408c0-65.6-26.5-150.8-52.5-218.9c-13.1-34.2-26.1-64.3-35.9-85.9c-4.9-10.8-9-19.5-11.9-25.5c-1.4-3-2.6-5.3-3.3-6.9l-.9-1.8-.2-.5-.1-.1 0 0 0 0s0 0-7.2 3.6l7.2-3.6L436.9 64H432 328V8zM312 80v89.9L157 212.2c2.1-5.9 4.3-11.6 6.5-17.3c12.9-33.8 25.9-63.7 35.6-85.1c4.8-10.7 8.9-19.3 11.7-25.2c.9-1.8 1.6-3.4 2.2-4.6h99zM150.4 230.5L312 186.5v95.6L119.3 341.4c7-36.2 18.5-74.6 31.1-110.8zM116.2 359.1L312 298.8V402.7L166.4 464H112V408c0-15.3 1.5-31.7 4.2-48.9zM328 402.7V298.8l195.8 60.2c2.7 17.2 4.2 33.7 4.2 48.9v56H473.6L328 402.7zm192.7-61.3L328 282.1V186.5l161.6 44.1c12.6 36.2 24 74.6 31.1 110.8zM483 212.2L328 169.9V80h99c.6 1.3 1.4 2.8 2.2 4.6c2.8 5.9 6.9 14.5 11.7 25.2c9.7 21.4 22.6 51.2 35.6 85.1c2.2 5.7 4.3 11.4 6.5 17.3zM8 64H0v8V208v24 8V504v8H16v-8V240v-8V213.1L59.6 193C96.4 176 120 139.1 120 98.6V72 64h-8H8zm8 16h88V98.6c0 34.3-20 65.5-51.1 79.9L16 195.5V80zM632 64H528h-8v8V98.6c0 40.6 23.6 77.4 60.4 94.4L624 213.1V232v8V504v8h16v-8V240v-8V208 72 64h-8zm-8 16V195.5l-36.9-17C556 164.1 536 132.9 536 98.6V80h88z'
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fast',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      'M145.1 80h9.2l4.6-8c19.4-33.5 55.6-56 97-56s77.6 22.5 97 56l4.6 8h9.2H368c70.7 0 128 57.3 128 128s-57.3 128-128 128H334.4h-6.5l-4.7 4.6c-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4l-4.7-4.6h-6.5H144C73.3 336 16 278.7 16 208S73.3 80 144 80h1.1zM256 0c-47.4 0-88.7 25.7-110.9 64H144C64.5 64 0 128.5 0 208s64.5 144 144 144h33.6c20.2 19.8 47.9 32 78.4 32s58.2-12.2 78.4-32H368c79.5 0 144-64.5 144-144s-64.5-144-144-144h-1.1C344.7 25.7 303.4 0 256 0zM168 456H120V408h48v48zm-48-64H104v16 48 16h16 48 16V456 408 392H168 120zM48 464v32H16V464H48zM16 448H0v16 32 16H16 48 64V496 464 448H48 16z'
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fast',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      'M16 48H48V80H16V48zm128 0V80H112V48h32zm96 0V80H208V48h32zm96 0V80H304V48h32zm64 0h32V80H400V48zM160 320H144 80 64V304 288L212.7 139.3 224 128l11.3 11.3L384 288v16 16H368 304 288v16V464v16H272 176 160V464 336 320zm0-16h16v16V464h96V320 304h16 80v-9.4l-144-144L80 294.6V304h80z'
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fast',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 100.3-61.5 186.2-148.8 222.1c-2.4 7.3-5.7 14.3-9.7 20.7C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 368.9 73.1 464.7 174.5 498.8c-4-6.4-7.3-13.4-9.7-20.7C77.5 442.2 16 356.3 16 256zm395.1 66c2.2-6.2 4-12.6 5.4-19.2c-5.9 2.4-12 4.6-18.2 6.7c-42.1 14.2-90.5 22.3-142 22.3s-99.9-8.1-142-22.3c-6.2-2.1-12.3-4.3-18.2-6.7c1.4 6.5 3.3 12.9 5.4 19.2c11.2 31.8 31.8 59.2 58.5 78.7V380.2c-16.4-14.1-29.7-31.7-38.7-51.7c40.9 12.4 86.7 19.3 135 19.3s94.1-6.9 135-19.3c-9.1 20.2-22.6 38-39.2 52.2v20.3c27-19.5 47.8-47 59.1-79.1zM176.4 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 368h-8v8 64c0 39.8 32.2 72 72 72s72-32.2 72-72V376v-8h-8H272h-3.3l-2.3 2.3L256 380.7l-10.3-10.3-2.3-2.3H240 192zm44.7 16L248 395.3V424v8h16v-8V395.3L275.3 384H312v56c0 30.9-25.1 56-56 56s-56-25.1-56-56V384h36.7zM352.4 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fast',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      'M144 368l0 96-96 0 0-96 96 0zM48 352l-16 0 0 16 0 96 0 16 16 0 96 0 16 0 0-16 0-96 0-16-16 0-96 0z'
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fast',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      'M40 32H600h8V48h-8H520v96h80 8v16h-8H40 32V144h8 80V48H40 32V32h8zM504 48H392v96H504V48zM376 48H264v96H376V48zM248 48H136v96H248V48zM40 256H64c48.6 0 88 39.4 88 88V464h80V344c0-48.6 39.4-88 88-88c12.3 0 24 2.5 34.7 7.1c-3.2 4.4-6.3 8.9-9.1 13.6c-7.9-3-16.5-4.7-25.5-4.7c-39.8 0-72 32.2-72 72V472v8h-8H144h-8v-8V344c0-39.8-32.2-72-72-72H40 32V256h8zM624 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm205.7-50.3L507.3 368l50.3 50.3 5.7 5.7L552 435.3l-5.7-5.7L496 379.3l-50.3 50.3-5.7 5.7L428.7 424l5.7-5.7L484.7 368l-50.3-50.3-5.7-5.7L440 300.7l5.7 5.7L496 356.7l50.3-50.3 5.7-5.7L563.3 312l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fast',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240 24c1.4-7.9 1.4-7.9 1.4-7.9l0 0 0 0 0 0 .2 0 .6 .1c.5 .1 1.2 .2 2.2 .4c1.8 .4 4.4 1 7.6 1.8c6.2 1.6 14.6 4 23 7.4c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-8.5 3.2-16.9 5.3-23.2 6.6c-3.1 .7-5.8 1.1-7.6 1.4c-.9 .2-1.7 .3-2.2 .3l-.6 .1-.2 0-.1 0 0 0 0 0s0 0-1-7.9l-1-7.9 0 0 .1 0 .5-.1c.4-.1 1.1-.2 1.9-.3c1.6-.3 4-.7 6.9-1.3c5.8-1.2 13.3-3.1 20.8-5.9c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.9-.5-5.3-.8-7-1c-.8-.1-1.5-.2-1.9-.2l-.5-.1-.1 0 0 0 0 0 0 0 0 0V344.1l0 0 0 0 0 0 0 0 .1 0 .5-.1c.4-.1 1.1-.1 1.9-.2c1.7-.2 4.1-.6 7-1c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-2.9-.7-5.3-1.3-6.9-1.6c-.8-.2-1.5-.3-1.9-.4l-.5-.1-.1 0 0 0 0 0L240 280zm-79.6-72a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fast',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      'M264 16H464V272H264V16zM480 288V272 16 0H464 48 32V16 272v16H48 464h16zM48 272V16H248V272H48zM8 496H0v16H8 40 472h32 8V496h-8H480V320H464V496H48V320H32V496H8z'
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fast',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      'M176 14V3.8L166 6.3 6.2 46.2 .1 47.7V54v73.8V134v10.2 63.5V214v0 10.2V294v10.2l9.9-2.5 143.8-36 0 0 150-37.5v63.5L198 318.3l-6.1 1.5V326v42H80 64v16 64 16H80h32v40 8h8 80 8v-8V464h32 16V448 384 368H240 207.9V332.3l105.9-26.5 6.1-1.5V298 224.3l0 0V218 144.3 138 127.8 58 47.8L310 50.3 176 83.8V14zM303.9 148.3v63.5L150 250.2 16.1 283.7V220.2l287.8-71.9zm0-16.5L16.1 203.7V140.2l153.8-38.4 6.1-1.5 127.9-32v63.5zM160 87.8l-143.9 36V60.2L160 24.3V87.8zM240 384v64H200 120 80V384H240zM192 496H128V464h64v32zM112 368h16V305.2l-16 4V368z'
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fast',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM264 136v-8H248v8V308.7l-74.3-74.3-5.7-5.7L156.7 240l5.7 5.7 88 88 5.7 5.7 5.7-5.7 88-88 5.7-5.7L344 228.7l-5.7 5.7L264 308.7V136z'
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fast',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      'M432 224A208 208 0 1 0 16 224a208 208 0 1 0 416 0zm16 0c0 76.4-38.3 143.9-96.7 184.3L419.6 496 432 512H411.7 36.3 16l12.4-16 68.2-87.7C38.3 367.9 0 300.4 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 448c-41.6 0-80.5-11.3-113.8-31L48.7 496H399.3l-61.5-79c-33.4 19.7-72.3 31-113.8 31zM352 224A128 128 0 1 0 96 224a128 128 0 1 0 256 0zM80 224a144 144 0 1 1 288 0A144 144 0 1 1 80 224zm88 0H152c0-39.8 32.2-72 72-72v16c-30.9 0-56 25.1-56 56z'
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fast',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM96 136v-8h12.1l2.4 3.4L224 290.2 337.5 131.4l2.4-3.4H352v8V376v8H336v-8V161L230.5 308.6l-6.5 9.1-6.5-9.1L112 161V376v8H96v-8V136z'
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fast',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      'M320 16C187.5 16 80 123.5 80 256H64C64 114.6 178.6 0 320 0S576 114.6 576 256H560C560 123.5 452.5 16 320 16zM258.1 487.9c19.8 5.3 40.5 8.1 61.9 8.1s42.2-2.8 61.9-8.1l4.1 15.5C365 509 342.8 512 320 512s-45-3-66.1-8.6l4.1-15.5zM221.1 157.1c-14.7 6.5-29.2 19-39.7 36.1s-14.6 35.2-13.2 50.2c1.4 15 8.1 26.5 18.9 32.3c10.9 5.9 25 5.7 39.8-.8c14.7-6.5 29.2-19 39.7-36.1s14.6-35.2 13.2-50.2c-1.4-15-8.1-26.5-18.9-32.3c-10.9-5.9-25-5.7-39.8 .8zm-6.5-14.6c17.9-7.9 37.5-9.1 53.9-.2c16.5 9 25.4 26 27.1 44.9c1.7 18.9-3.5 40.3-15.5 60s-28.9 34.5-46.9 42.4c-17.9 7.9-37.5 9.1-53.9 .2c-16.5-9-25.4-26-27.1-44.9c-1.7-18.9 3.5-40.3 15.5-60s28.9-34.5 46.9-42.4zm243.9 50.8c-10.5-17.2-25-29.7-39.7-36.1c-14.7-6.5-28.9-6.7-39.8-.8c-10.8 5.9-17.5 17.3-18.9 32.3c-1.4 15 2.7 33 13.2 50.2s25 29.7 39.7 36.1c14.7 6.5 28.9 6.7 39.8 .8c10.8-5.9 17.5-17.3 18.9-32.3c1.4-15-2.7-33-13.2-50.2zm-87.1-51c16.4-9 36-7.7 53.9 .2c17.9 7.9 34.8 22.7 46.9 42.4s17.2 41.1 15.5 60c-1.7 18.9-10.6 35.9-27.1 44.9c-16.4 9-36 7.7-53.9-.2c-17.9-7.9-34.8-22.7-46.9-42.4s-17.2-41.1-15.5-60c1.7-18.9 10.6-35.9 27.1-44.9zM368 400V368c0-26.5-21.5-48-48-48s-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48zm-48-96c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-35.3 28.7-64 64-64zM108.5 316c54.3 45.3 82.4 128 90.7 196H183.1c-8.1-63.5-33.7-137.3-79.7-179.3l-53.8 47C73.3 417.8 89 464.9 90.2 512l64.2 0H74.2c-1.3-46.2-17.5-92.6-41.8-129.3l-3.9-5.8 5.3-4.6 64.3-56.2 5.1-4.5 5.2 4.4zm499.1 66.7c-24.3 36.7-40.4 83.2-41.8 129.3H485.6l64.2 0c1.3-47.1 16.9-94.2 40.6-132.3l-53.8-47c-46 42-71.6 115.8-79.7 179.3H440.8c8.3-68 36.4-150.8 90.7-196l5.2-4.4 5.1 4.5 64.3 56.2 5.3 4.6-3.9 5.8z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fast',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M496 48V208H336V48H496zM336 32H320V48 208v16h16H496h16V208 48 32H496 336zM296 480h18.9H517.1 536l-10-16L425.4 303.1 416 288l-9.4 15.1L306 464l-10 16zm211.1-16H324.9L416 318.2 507.1 464zM165.7 42.3L160 36.7l-5.7 5.7-104 104L44.7 152 56 163.3l5.7-5.7L152 67.3V472v8h16v-8V67.3l90.3 90.3 5.7 5.7L275.3 152l-5.7-5.7-104-104z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fast',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      'M486.8 98.2l28.2-38.8L437.4 2.9 409.2 41.8 145.3 404.7c-5 6.9-13.1 11.1-21.7 11.1c-14.9 0-27.1-12.2-27-27.2c0-3.7 .8-7.3 2.3-10.7l17-38.5 19.4-43.9L47.5 256.7 28.1 300.6l-17 38.5C4.3 354.4 .7 371 .6 387.8C.1 456.2 55.4 512 123.9 511.8c39.2-.1 76-18.9 99.1-50.6L486.8 98.2zm-12.9-9.4l-54.3 74.6-53.3-35.5 55.8-76.7 18.8-25.9 51.8 37.6L473.9 88.8zm-63.7 87.6L210 451.7c-20.1 27.6-52.1 43.9-86.2 44C64.3 496 16.1 447.4 16.6 388c.1-14.6 3.2-29 9.1-42.4l17-38.5 12.9-29.3 58.5 25.9-12.9 29.3-17 38.5c-2.4 5.4-3.6 11.2-3.7 17c-.2 23.9 19.2 43.4 43 43.3c13.7 0 26.5-6.6 34.6-17.7L356.9 140.9l53.3 35.5zM432 368a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fast',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM227 144.4c-14.4-.2-28.3 4.6-39.6 13.6L157 182.2l-6.2 5-10-12.5 6.2-5 30.4-24.3c14.1-11.3 31.7-17.3 49.8-17.1l2.3 0C270.8 129 304 162.7 304 204c0 20.1-8 39.3-22.1 53.5L171.3 368H312h8v16h-8H152h-8V372.7l2.3-2.3L270.5 246.1C281.7 235 288 219.8 288 204c0-32.6-26.2-59.1-58.8-59.6l-2.3 0z'
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fast',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      'M508.8 32H512h80 3.3l2.3 2.3 40 40 2.3 2.3V80v24 8h-8H539.8L283.8 421.8C253.4 458.7 208.1 480 160.3 480C71.8 480 0 408.2 0 319.7v-7.9c0-11.1 1.1-22.1 3.3-33L30.2 144H8 0V128H8 40 248h32 8v16h-8H253.5L193.6 301.2l21.7 16.2L342.4 193.7l-20.1-20.1-5.7-5.7L328 156.7l5.7 5.7 20.2 20.2 37.2-36.2-20.8-20.8-5.7-5.7L376 108.7l5.7 5.7 20.9 20.9 37.2-36.2L418.3 77.7 412.7 72 424 60.7l5.7 5.7 21.6 21.6 55.2-53.7 2.3-2.3zM19 282c-2 9.8-3 19.8-3 29.8v7.9C16 399.4 80.6 464 160.3 464c43 0 83.8-19.2 111.2-52.4L529.8 98.9l2.4-2.9H536h88V83.3L588.7 48H515.2L221.6 333.6l-4.9 4.8-5.5-4.1-32-23.8-4.8-3.6 2.2-5.7L236.4 144H46.6L19 282zm93-58a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fast',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      'M144 0H304V16H232V96.2c55.4 2.1 105.3 25.9 141.4 63.1l36.9-36.9 5.7-5.7L427.3 128l-5.7 5.7-37.6 37.6C414 207.2 432 253.5 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-112.2 88.8-203.6 200-207.8V16H144V0zm80 496a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm8-312V320v8H216v-8V184v-8h16v8z'
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fast',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      'M496 16V80H152 136 16V16H496zM152 96H496h16V80 16 0H496 16 0V16 80 96H16 136V256.7c-22.7 3.8-40 23.6-40 47.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.8-17.3-43.5-40-47.3V96zm32 128H494.9 512l-6-16-30-80H458.9l30 80H184v16zm-80-16H23.1l30-80H36L6 208 0 224H17.1 104V208zM64 304H23.1l18-48H24L6 304 0 320H17.1 65.6c-1-5.2-1.6-10.5-1.6-16zm158.4 16H494.9 512l-6-16-18-48H470.9l18 48H224c0 5.5-.6 10.8-1.6 16zM24 352L6 400 0 416H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24zm0 96L6 496 0 512H17.1 494.9 512l-6-16-18-48H470.9l18 48H23.1l18-48H24zM176 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fast',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 0H8 152h8V8 144H352V8 0h8H504h8V8 152v8h-8H368V352H504h8v8V504v8h-8H360h-8v-8V368H160V504v8h-8H8 0v-8V360v-8H8 144V160H8 0v-8V8 0zM144 144V16H16V144H144zm16 208H352V160H160V352zm-16 16H16V496H144V368zm224 0V496H496V368H368zm0-224H496V16H368V144z'
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fast',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      'M304 160c0-79.5-64.5-144-144-144S16 80.5 16 160V368H152V168v-8h16v8V368H304V160zM152 384H16 0V368 160C0 71.6 71.6 0 160 0s160 71.6 160 160V368v16H304 168V504v8H152v-8V384z'
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fast',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      'M56 0C25.1 0 0 25.1 0 56V456c0 30.9 25.1 56 56 56H192V496H56c-22.1 0-40-17.9-40-40s17.9-40 40-40H192V400H56c-15.7 0-29.8 6.4-40 16.8V56c0-22.1 17.9-40 40-40H432V400H288v16H400v80H288v16H440h8V496h-8H416V416h24 8v-8V8 0h-8H56zm74.3 234.3l-5.7 5.7L136 251.3l5.7-5.7L232 155.3 232 504v8h16v-8l0-348.7 90.3 90.3 5.7 5.7L355.3 240l-5.7-5.7-104-104-5.7-5.7-5.7 5.7-104 104z'
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fast',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 96v8V256c0 35.3 28.7 64 64 64s64-28.7 64-64V104 96h-8H200h-8zm16 16h96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM144 232v-8H128v8 24c0 68 53 123.6 120 127.8V408v8h16v-8V383.8C331 379.6 384 324 384 256V232v-8H368v8 24c0 61.9-50.1 112-112 112s-112-50.1-112-112V232z'
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fast',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      'M148 6.9l6.6 1.2L290.3 33.6 426 8.1l6.6-1.2 2.4 6.3 51 135.9 84.8 101.8L575 256l-4.3 5.1L485.9 362.9l-51 135.9-2.4 6.3-6.6-1.2L290.3 478.4 154.6 503.9l-6.6 1.2-2.4-6.3-51-135.9L9.9 261.1 5.6 256l4.3-5.1L94.7 149.1l51-135.9L148 6.9zM154.2 36l-45 120-.5 1.3-.9 1L33.1 248h91.1l47.3-54.1L199.4 115 154.2 36zm13.2-9.2l44.4 77.7 78 22.6L366.2 105l44.4-77.7L291.8 49.6l-1.5 .3-1.5-.3L167.4 26.8zm258.1 6.7l-45.7 80 28.3 80.3L455.4 248h92.1l-74.8-89.7-.9-1-.5-1.3L425.5 33.6zM547.5 264H455l-47 53.7-27.8 81.8 45.1 79L471.4 356l.5-1.3 .9-1L547.5 264zM410.6 484.7l-42.3-74.1-.1 0-78.5-26L212 407l-44.7 78.1 121.4-22.8 1.5-.3 1.5 .3 118.9 22.3zM154.2 476l45.2-79.2-27.9-79.2-47-53.7H33.1l74.8 89.7 .9 1 .5 1.3 45 120zm-8.4-212l38.8 44.3 1 1.2 .5 1.5 23.8 67.6L275.4 264H145.8zm77.7 123.1l64.1-18.6 2.4-.7 2.4 .8 64.1 21.2L289.1 272.1l-65.7 115zm146.3-6.2L393.4 311l.5-1.5 1-1.2L433.8 264H302.9l66.8 116.9zM434.1 248L395 203.3l-1-1.2-.5-1.5L369.2 132 302.9 248H434.1zM354.8 124.9L292 143.1l-2.2 .6-2.2-.6-64.4-18.6 65.9 115.4 65.7-115zm-145 8.4l-23.7 67.3-.5 1.5-1 1.2L145.5 248H275.4L209.8 133.4z'
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fast',
    iconName: 'hand-spock',
    icon: [
      543,
      512,
      [128406],
      'f259',
      
      'M248.6 11.5l-2.1-7.2-7.2 2.1L166.9 27.3l-7.2 2.1 2.1 7.2 8.8 30.5L101.7 88.5l-7.2 2.2 2.2 7.2 11.1 36L163.4 313l-37.7-34.2L97.8 253.5l-5.6-5.1-5.1 5.6L36.6 309.8l-5.1 5.6 5.6 5.1L65 345.8l86.7 78.6c41.6 37.7 95.6 58.6 151.7 58.6h14.1 0l.3 0h0l.3 0h0 1.5 7.5v-.3c59.2-4 109.7-45.5 124.5-103.7L511 146.7l1.9-7.3-7.3-1.9-70.1-17.9 8-34L452.1 49l1.7-7.3-7.3-1.7L373.2 22.7 365.9 21l-1.7 7.3-8.6 36.6-41 174.4L259 47.7 248.6 11.5zM113.4 100.6l57.5-17.8 8.9 28.8 46 148.5 1.6 5.3H233h.7 10l-2.8-9.6L186.7 68.6l-8.4-28.9 57.9-16.7 8.4 28.9 60.2 208.1 1.6 5.4H312h5.9 6l1.4-5.8 45-191.2 6.9-29.3 58.6 13.8-6.9 29.3L387.9 256.1l-2.2 9.3h9.5 1.9H403l1.4-5.7 31.8-124.3 58.4 14.9L437.1 375.2c-13.8 54-62 91.9-117.6 92.6l-.8 0h-.6 0l-.3 0h0l-.3 0h0H303.4c-52.4 0-102.8-19.5-141.6-54.7L75.1 334.6 52.8 314.4l40.5-44.6L115.5 290l50.1 45.4L182.2 323 122.3 129.4l-8.9-28.8z'
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fast',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM211.1 128l-2.2 4.4L195.1 160H136h-8v8V344v8h8H376h8v-8V168v-8h-8H316.9l-13.8-27.6-2.2-4.4H296 216h-4.9zm9.9 16h70.1l13.8 27.6 2.2 4.4H312h56V336H144V176h56 4.9l2.2-4.4L220.9 144zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fast',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 413.4C309.3 399.1 287.3 384 256 384s-53.3 15.1-66.1 29.4l-5.4 5.9-11.9-10.7 5.4-5.9C193.1 386 219.1 368 256 368s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7-5.4-5.9zM211.3 104l-5.7 5.7-7.4 7.4c-22.4 22.4-51.2 37.2-82.5 42.5l-2.5 .4-7.9 1.3-2.6-15.8 7.9-1.3 2.5-.4c28-4.7 53.8-17.9 73.8-38l7.4-7.4 5.7-5.7L211.3 104zm95 5.7l-5.7-5.7L312 92.7l5.7 5.7 7.4 7.4c20 20 45.8 33.3 73.8 38l2.5 .4 7.9 1.3-2.6 15.8-7.9-1.3-2.5-.4c-31.3-5.2-60.1-20.1-82.5-42.5l-7.4-7.4zM132.4 221.3l7.2 3.6 80 40 14.3 7.2-14.3 7.2-80 40-7.2 3.6-7.2-14.3 7.2-3.6L198.1 272l-65.7-32.8-7.2-3.6 7.2-14.3zm240 3.6l7.2-3.6 7.2 14.3-7.2 3.6L313.9 272l65.7 32.8 7.2 3.6-7.2 14.3-7.2-3.6-80-40L278.1 272l14.3-7.2 80-40z'
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fast',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      'M256 496a240 240 0 1 0 0-480 240 240 0 1 0 0 480zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 16c-35.3 0-64-28.7-64-64c0-22.2 11.3-41.7 28.4-53.2L136.8 131.6l-3.6-7.2 14.3-7.2 3.6 7.2 83.6 167.2c6.6-2.3 13.8-3.6 21.2-3.6c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fast',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      'M352 16c-10.5 0-20.8 .7-31 2L319 2.1C329.8 .7 340.8 0 352 0C493.4 0 608 114.6 608 256s-114.6 256-256 256c-116.9 0-215.6-78.4-246.2-185.5l15.4-4.4C149.9 422.5 242.4 496 352 496c132.6 0 240-107.5 240-240S484.6 16 352 16zm0 381c-55.2 0-94.4-21.6-117.3-42L245.3 343c20.4 18.2 55.9 38 106.7 38s86.3-19.8 106.7-38L469.3 355c-22.9 20.5-62.1 42-117.3 42zM272.4 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM248.5 7.5L283 61.4l4.3 6.7-6.7 4.3L253.7 89.7l-24 15.4 30.4 50.8 4.1 6.9-6.9 4.1-27.5 16.4-105.3 63c-17.1 10.2-37.8 12.8-56.9 7.1c-58.2-17.4-69.1-95.1-18-127.9L210.5 22.3 237.4 5.1l6.7-4.3 4.3 6.7zM197 128.3l-53.9 32.3L134.6 147 245 76.2l20.2-13L239.3 22.8l-20.2 13L58.3 138.9C18.7 164.3 27.2 224.5 72.3 238c14.8 4.4 30.8 2.4 44.1-5.5l105.3-63 20.6-12.3L217.6 116 197 128.3z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fast',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 108.7l5.7 5.7 208 208 5.7 5.7L464 339.3l-5.7-5.7L256 131.3 53.7 333.7 48 339.3 36.7 328l5.7-5.7 208-208 5.7-5.7z'
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fast',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm136 96h88 88 8v16h-8H232V368h80 8v16h-8H232 216 136h-8V368h8 80V144H136h-8V128h8z'
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fast',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 330.8c-6.9-4.9-13.5-10.2-19.6-16H16V192H352h80 16V176 80 64H432 336V8 0H320V8 64H128V8zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM304 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM444 444V420H420v24h24zm-4-164H424v8 96 8h16v-8V288v-8z'
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fast',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      'M112 8V0H96V8 112h16V8zM288 8V0H272V8 112h16V8zM8 144H0v16H8 40v80c0 81.3 63.8 147.6 144 151.8V504v8h16v-8V391.8c80.2-4.2 144-70.5 144-151.8V160h32 8V144h-8H344 328 56 40 8zM192 376c-75.1 0-136-60.9-136-136V160H328v80c0 75.1-60.9 136-136 136z'
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fast',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H368v0H352v0H224V320h32 70.6c1.5-5.4 3.3-10.8 5.4-16H216h-8v8V496H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 10 .3L293.2 9.9zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fast',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      'M432 178.3V164.4l-13.7-2-54.4-7.8c-34.3-4.9-59.8-34.3-59.8-69C304 47.2 335.2 16 373.7 16H496V128v48 16V360c0 75.1-60.9 136-136 136s-136-60.9-136-136V312c0-39.8-32.2-72-72-72s-72 32.2-72 72V464v32H16V464 312c0-75.1 60.9-136 136-136s136 60.9 136 136v48c0 39.8 32.2 72 72 72s72-32.2 72-72V178.3zM373.7 0C326.4 0 288 38.4 288 85.7c0 42.6 31.4 78.8 73.6 84.8l54.4 7.8V360c0 30.9-25.1 56-56 56s-56-25.1-56-56V312c0-83.9-68.1-152-152-152S0 228.1 0 312V464v32 16H16 80 96V496 464 312c0-30.9 25.1-56 56-56s56 25.1 56 56v48c0 83.9 68.1 152 152 152s152-68.1 152-152V192 176 128 16 0H496 373.7zM400 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fast',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 73.5-33.1 139.3-85.2 183.4l10.3 12.2C476.7 404.7 512 334.4 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 93 49.7 174.5 123.9 219.3l8.3-13.7C62.5 419.6 16 343.2 16 256zm160.4-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM224 247c-26.5-5.6-46-17.7-58.7-29L154.7 230c15 13.4 38.2 27.4 69.3 33.3V320H176h-8v8V504v8h8H320h3l2.3-2 64-56 6.4-5.6-6-6-32-32-4.8-4.8-5.5 3.9-51.5 36.8L232 403.7V384h32v16 8h8 48 8v-8V328v-8h-8H288V263.3c31.2-5.9 54.3-19.9 69.3-33.3L346.7 218c-12.6 11.3-32.2 23.3-58.7 29V216v-8h-8H232h-8v8 31zm48 73H240V224h32v96zm-88 16H312v56H280V376v-8h-8H224h-8v8 32 4.3l3.6 2.4 72 48 4.6 3.1 4.5-3.2 50.5-36.1 21.2 21.2L317 496H184V336z'
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fast',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      'M160 170.6V159.9 16H288V159.9v10.7l9.8 4.1C367.3 203.7 416 272.2 416 352c0 5.4-.2 10.7-.6 15.9c-62.6-1.3-98.7-16.1-130.3-31.1c-3.1-1.5-6.2-3-9.3-4.5C245.9 317.9 217.1 304 171.8 304c-49.2 0-87.3 12.4-113.2 24.8c-11.1 5.3-19.9 10.6-26.4 15c3.2-76.3 51-141.1 118-169.1l9.8-4.1zM413.4 383.9c-7.4 44.4-30 83.6-62.4 112.1H97c-37.2-32.8-61.6-79.8-64.7-132.5c1.4-1.1 3.4-2.7 5.9-4.4c6.1-4.3 15.2-10 27.3-15.8C89.6 331.6 125.4 320 171.8 320c41.5 0 67.2 12.4 97 26.8c3.1 1.5 6.1 3 9.3 4.5c32.6 15.5 70.6 31.1 135.2 32.6zM304 159.9V16h24 8V0h-8H304 288 160 144 120h-8V16h8 24V159.9C68.8 191.3 16 265.5 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-86.5-52.8-160.7-128-192.1z'
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fast',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      'M8 64H0V80H8 128V357.2L65.8 435l12.5 10 64-80 1.8-2.2V360 80H304V440v8h8 80 4.9l2.2-4.4 16-32 3.6-7.2-14.3-7.2-3.6 7.2L387.1 432H320V80H440h8V64h-8H144 128 8z'
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fast',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      'M332.7 44.7l24-24L368 9.4l11.3 11.3 24 24L414.6 56 403.3 67.3l-24 24L368 102.6 356.7 91.3l-24-24L321.4 56l11.3-11.3zM368 80l11.3-11.3 1.4-1.4L392 56 380.7 44.7l-1.4-1.4L368 32 356.7 43.3l-1.4 1.4L344 56l11.3 11.3 1.4 1.4L368 80zM142.4 112c-26.2 0-49.4 12.6-64 32l-4.8 6.4-12.8-9.6 4.8-6.4C83.1 111.1 111 96 142.4 96c53 0 96 43 96 96c0 33.4-17 62.8-42.9 80H309.2L387 209.8l2.2-1.8H392c66.3 0 120 53.7 120 120v64.9c0 48.1-39 87.1-87.1 87.1c-33 0-63.2-18.6-77.9-48.2l-10.1-20.3-3.6-7.2 14.3-7.2 3.6 7.2 10.1 20.3c12 24.1 36.7 39.3 63.6 39.3c39.3 0 71.1-31.8 71.1-71.1V328c0-56.5-45.1-102.5-101.2-104L317 286.2l-2.2 1.8H312 211.9c35.9 20.7 60.1 59.5 60.1 104c0 66.3-53.7 120-120 120H136C60.9 512 0 451.1 0 376v-8H16v8c0 66.3 53.7 120 120 120h16c57.4 0 104-46.6 104-104s-46.6-104-104-104h-8-1.6H136h-1.6H128V272h6.4H136h6.4c44.2 0 80-35.8 80-80s-35.8-80-80-80zm151.2 10.3l.1 .1c.1 .1 .3 .3 .6 .6c.6 .5 1.6 1.3 3 2.3c2.8 2 7.1 4.7 13.1 7.5c12 5.5 30.9 11.3 57.6 11.3s45.6-5.7 57.6-11.3c6-2.8 10.3-5.5 13.1-7.5c1.4-1 2.4-1.8 3-2.3c.3-.3 .5-.4 .6-.6l.1-.1 0 0 0 0 5.6-5.6L459.3 128l-5.7 5.6L448 128c5.6 5.7 5.6 5.7 5.6 5.7l0 0 0 0 0 0-.1 .1-.3 .3c-.3 .2-.6 .6-1.1 1c-.9 .8-2.3 1.9-4 3.1c-3.5 2.5-8.7 5.8-15.7 9c-14 6.5-35.2 12.7-64.3 12.7s-50.3-6.3-64.3-12.7c-7-3.2-12.2-6.5-15.7-9c-1.8-1.3-3.1-2.3-4-3.1c-.5-.4-.8-.7-1.1-1l-.3-.3-.1-.1 0 0 0 0 0 0s0 0 5.6-5.7l-5.6 5.7-5.7-5.6L288 116.7l5.6 5.6z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fast',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      'M341.7 365.7l5.7-5.7L336 348.7l-5.7 5.7L200 484.7 200 16l176 0 8 0 0-16-8 0L192 0l-8 0 0 8 0 476.7L53.7 354.3 48 348.7 36.7 360l5.7 5.7 144 144 5.7 5.7 5.7-5.7 144-144z'
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fast',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      'M224 32l48 64h8H424h16 56 16v16V464v16H496 16 0V464 48 32H16 224zm216 80V344v16.6l-13-10.4-75-60-75 60-13 10.4V344 112l-4.8-6.4L216 48H16V464H496V112H440zm-16 0H280V327.4l67-53.6 5-4 5 4 67 53.6V112z'
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fast',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      'M336 256l-16 0L96 256l-16 0 0 16 0 192-64 0 0-272 304 0 16 0 0-16 0-96 9.4 0 144 144-144 144-9.4 0 0-96 0-16zm16 128L500.7 235.3 512 224l-11.3-11.3L352 64l-16 0-16 0 0 16 0 80 0 16-16 0L16 176 0 176l0 16L0 464l0 16 16 0 64 0 16 0 0-16 0-176 0-16 16 0 192 0 16 0 0 16 0 80 0 16 16 0 16 0z'
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fast',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      'M144 16V160H128V16 0h16H448l64 64v96H496V70.6L441.4 16H144zM333.7 208H80V400h48V336 320h16H288c0 5.4 .3 10.7 .8 16H144V496H496V472.7c.7-.2 1.4-.5 2.2-.7L512 485.8V496v16H496 144 128V496 416H80 64V400 208 192H80 352c-6.5 4.9-12.6 10.2-18.2 16zM448 432.2a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0 16c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 32.5-12.1 62.1-32 84.7l89.7 89.5 5.7 5.7L628 511.3l-5.7-5.7-89.7-89.5c-22.6 19.9-52.2 32-84.7 32z'
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fast',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      'M286.8 0H270.6l1.6 9.3 22.5 134.9L312 158v-.7c0-4-.3-7.9-1-11.8L287.9 6.7v0L286.8 0zM160.5 221.8c-14.2-4.1-26.1-13.7-33.3-26.3l-22.6-17.8c4.7 35.2 34.9 62.3 71.3 62.3h7.5l-23-18.2zM173.9 49l15.4 12.2 .6-12.7 1-20 1-20 .4-8.4h-16L176 7.6l-1 20-1 20-.1 1.4zm54.2 42.8l16.7 13.2L240 7.6 239.6 0h-16l.4 8.4 4.2 83.4zm-101-79.7l14.3 11.3 2.3-14.1 0 0L145.4 0H129.2l-1.1 6.7 0 0-.9 5.4zM200 504v8h16v-8V265.6L200 253V504zM528 16V0H512h-8C488 0 384 32 384 176v38.8l16 12.6V176c0-67.7 24.2-107.4 48.9-130.3c12.5-11.6 25.5-19.2 36-23.8c5.3-2.3 9.9-3.8 13.4-4.8c3.7-1 5.6-1.1 5.7-1.1l0 0h8V315.8l16 12.6V16zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fast',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      'M392 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM314.8 121.9c2.9-2.5 7.3-2.6 10.3-.1L410.9 192H488h8v16h-8H408h-2.9l-2.2-1.8-82.8-67.8-74.4 63.8c-12.2 10.4-10.9 29.7 2.6 38.4l100 64.7 3.7 2.4V312 416v8H336v-8V316.4L239.6 254c-22.4-14.5-24.6-46.6-4.3-64l79.5-68.1zM482 256h60 8v8 13.6c3.6 1.3 7 2.7 10.4 4.3l9.6-9.6 5.7-5.7 5.7 5.7 42.4 42.4 5.7 5.7-5.7 5.7-9.6 9.6c1.6 3.4 3 6.8 4.3 10.4H632h8v8 60 8h-8H618.4c-1.3 3.6-2.7 7-4.3 10.4l9.6 9.6 5.7 5.7-5.7 5.7-42.4 42.4-5.7 5.7-5.7-5.7-9.6-9.6c-3.4 1.6-6.8 3-10.4 4.3V504v8h-8H482h-8v-8V490.4c-3.6-1.3-7-2.7-10.4-4.3l-9.6 9.6-5.7 5.7-5.7-5.7-42.4-42.4-5.7-5.7 5.7-5.7 9.6-9.6c-1.6-3.4-3-6.8-4.3-10.4H392h-8v-8V354v-8h8 13.6c1.3-3.6 2.7-7 4.3-10.4l-9.6-9.6-5.7-5.7 5.7-5.7 42.4-42.4 5.7-5.7 5.7 5.7 9.6 9.6c3.4-1.6 6.8-3 10.4-4.3V264v-8h8zm8 27.3v6l-5.7 1.7c-6.4 1.9-12.6 4.5-18.4 7.6l-5.2 2.8-4.2-4.2-8-8-31.1 31.1 8 8 4.2 4.2-2.8 5.2c-3.1 5.8-5.7 12-7.6 18.4l-1.7 5.7h-6H400v44h11.3 6l1.7 5.7c1.9 6.4 4.5 12.6 7.6 18.4l2.8 5.2-4.2 4.2-8 8 31.1 31.1 8-8 4.2-4.2 5.2 2.8c5.8 3.1 12 5.7 18.4 7.6l5.7 1.7v6V496h44V484.7v-6l5.7-1.7c6.4-1.9 12.6-4.5 18.4-7.6l5.2-2.8 4.2 4.2 8 8 31.1-31.1-8-8-4.2-4.2 2.8-5.2c3.1-5.8 5.7-12 7.6-18.4l1.7-5.7h6H624V362H612.7h-6l-1.7-5.7c-1.9-6.4-4.5-12.6-7.6-18.4l-2.8-5.2 4.2-4.2 8-8-31.1-31.1-8 8-4.2 4.2-5.2-2.8c-5.8-3.1-12-5.7-18.4-7.6l-5.7-1.7v-6V272H490v11.3zM472 384a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM90 256h8 60 8v8 13.6c3.6 1.3 7 2.7 10.4 4.3l9.6-9.6 5.7-5.7 5.7 5.7 42.4 42.4 5.7 5.7-5.7 5.7-9.6 9.6c1.6 3.4 3 6.8 4.3 10.4H248h8v8 60 8h-8H234.4c-1.3 3.6-2.7 7-4.3 10.4l9.6 9.6 5.7 5.7-5.7 5.7-42.4 42.4-5.7 5.7-5.7-5.7-9.6-9.6c-3.4 1.6-6.8 3-10.4 4.3V504v8h-8H98 90v-8V490.4c-3.6-1.3-7-2.7-10.4-4.3L70 495.7l-5.7 5.7-5.7-5.7L16.3 453.3l-5.7-5.7 5.7-5.7 9.6-9.6c-1.6-3.4-3-6.8-4.3-10.4H8 0v-8V354v-8H8 21.6c1.3-3.6 2.7-7 4.3-10.4L16.3 326l-5.7-5.7 5.7-5.7 42.4-42.4 5.7-5.7 5.7 5.7 9.6 9.6c3.4-1.6 6.8-3 10.4-4.3V264v-8zm16 16v11.3 6l-5.7 1.7c-6.4 1.9-12.6 4.5-18.4 7.6l-5.2 2.8-4.2-4.2-8-8L33.2 320.4l8 8 4.2 4.2-2.8 5.2c-3.1 5.8-5.7 12-7.6 18.4L33.3 362h-6H16v44H27.3h6l1.7 5.7c1.9 6.4 4.5 12.6 7.6 18.4l2.8 5.2-4.2 4.2-8 8 31.1 31.1 8-8 4.2-4.2 5.2 2.8c5.8 3.1 12 5.7 18.4 7.6l5.7 1.7v6V496h44V484.7v-6l5.7-1.7c6.4-1.9 12.6-4.5 18.4-7.6l5.2-2.8 4.2 4.2 8 8 31.1-31.1-8-8-4.2-4.2 2.8-5.2c3.1-5.8 5.7-12 7.6-18.4l1.7-5.7h6H240V362H228.7h-6l-1.7-5.7c-1.9-6.4-4.5-12.6-7.6-18.4l-2.8-5.2 4.2-4.2 8-8-31.1-31.1-8 8-4.2 4.2-5.2-2.8c-5.8-3.1-12-5.7-18.4-7.6l-5.7-1.7v-6V272H106zm22 72a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40A56 56 0 1 1 72 384a56 56 0 1 1 112 0zM250 80H201.3l-51.4 42 34.4 46.9 81.9-67L250 80zm38 24.7l-94.3 77.1L181.3 192l-9.5-12.9L128 119.3 195.6 64h62.6L288 104.7z'
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fast',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      'M224 0h-8V8 32H144h-8v8V316.1l-31.7-31.7L76.1 256.2l-5.7-5.7-5.7 5.7L8.2 312.7l-5.7 5.7 5.7 5.7 28.3 28.3 89.4 89.4c45 45 106.1 70.3 169.7 70.3H304c92.8 0 168-75.2 168-168V104 96h-8H392V40 32h-8H312V8 0h-8H224zm88 48h64l0 48v8V248v8h16v-8V112h64V344c0 83.9-68.1 152-152 152h-8.5c-59.4 0-116.4-23.6-158.4-65.6L47.8 341 25.1 318.4l45.3-45.3L93 295.8l45.3 45.3 13.7-5.7V48h64V248v8h16v-8V48 40 32 16h64l0 16 0 8V248v8h16v-8l0-64 0-136z'
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fast',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M16 224C16 109.1 109.1 16 224 16h24c95.7 0 172.5 77.9 176 172.7l.1 3.4 2.6 2.3L496 256v64H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V252.4v-3.6l-2.7-2.4-69.5-61.8C434.3 83.3 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 59.1 23.7 114.5 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3C38.7 332.1 16 279.7 16 224zM194 113.8c6-10.7 17.2-17.8 30-17.8s24.1 7.1 30 17.8l3.9 6.9 7-3.8c4.3-2.4 9.2-3.7 14.4-3.7c10.6 0 19.9 5.5 25.4 14l2.8 4.3 5.1-.8c1.6-.2 3.3-.4 5-.4c19 0 34.5 15.6 34.5 35.1v35.1H263.5h-8v8 52.3H232h-8v16h8 31.5 8v-8V216.6H360h8v-8V165.5c0-28.1-22.5-51.1-50.5-51.1c-.8 0-1.6 0-2.3 .1c-8.5-10.5-21.4-17.3-35.9-17.3c-5.4 0-10.5 .9-15.3 2.6c-9.2-12-23.7-19.8-40-19.8s-30.7 7.8-40 19.8c-4.8-1.7-9.9-2.6-15.3-2.6c-21.6 0-39.5 14.9-44.7 34.9c-24.9 3.2-44 24.8-44 50.7c0 19 10.3 35.6 25.5 44.4c.7 27.5 22.9 49.8 50.5 49.8h9V312v8h16v-8V268.9v-8h-8H156c-19 0-34.5-15.6-34.5-35.1c0-1 0-1.9 .1-2.9l.5-5.7-5.2-2.3C104.6 209.6 96 197.2 96 182.8c0-19.5 15.5-35.1 34.5-35.1l.2 0 7.2 0 .8-7.2c1.7-15.5 14.6-27.3 30.1-27.3c5.2 0 10.1 1.3 14.4 3.7l7 3.8 3.9-6.9z'
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fast',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      'M223 469.6l-10.5-10.5-11.3 9.7c-44 38.1-110.6 36.2-152.4-5.6c-43.7-43.7-43.7-114.7 0-158.4l89.4-89.4 11.3-11.3-11.3-11.3-.8-.8L160 169.4l.8 .8 11.3 11.3 11.3-11.3L304.8 48.8c43.7-43.7 114.7-43.7 158.4 0c41.8 41.8 43.7 108.4 5.6 152.4l-9.7 11.3L469.6 223l1 1L448 246.6l-.8-.8-11.3-11.3-11.3 11.3L245.8 424.6l-11.3 11.3 11.3 11.3 .8 .8L224 470.6l-1-1zM148.7 158.1l-22.6 22.6L114.7 192l.8 .8 10.5 10.5 .8 .8-11.3 11.3L37.5 293.5c-50 50-50 131 0 181c47.8 47.8 123.9 49.9 174.2 6.4l1 1L224 493.3l11.3-11.3 22.6-22.6L269.3 448l-.8-.8-10.5-10.5-.8-.8 11.3-11.3L424.6 268.5l11.3-11.3 .8 .8 10.5 10.5 .8 .8 11.3-11.3 22.6-22.6L493.3 224l-11.3-11.3-1-1c43.5-50.3 41.4-126.4-6.4-174.2c-50-50-131-50-181 0L183.4 147.5l-11.3 11.3-.8-.8-10.5-10.5-.8-.8-11.3 11.3zM176 336V304H144v32h32zm160-96v32h32V240H336zm32-128H336v32h32V112z'
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fast',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      'M200 8V0H184V8 32H72 64v8V64H40 32v8V496H8 0v16H8 376h8V496h-8H352V72 64h-8H320V40 32h-8H200V8zM336 496H48V80H70.5 72h8H304h8 2.8H336V496zM184 48h16H304V64H80V48H184zM96 272h64v64H96V272zM80 256v16 64 16H96h64 16V336 272 256H160 96 80zM288 144v24H264V144h24zm-64 0h24v24H224V144zm0 40h24v24H224V184zm64 24H264V184h24v24zm-64-80H208v16 64 16h16 64 16V208 144 128H288 224zm-88 16h24v24H136V144zm-16 24H96V144h24v24zm0 16v24H96V184h24zm16 0h24v24H136V184zM80 128v16 64 16H96h64 16V208 144 128H160 96 80z'
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fast',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      'M224 16V327.1l-16 23.1V176H48V352c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7V432v10.5c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V16H0V0H40 216h40V16H224zM48 160H208V16H48V160zm304 64v2.5l-1.4 2.1L287.3 320H544.7l-63.3-91.4-1.4-2.1V224 16H352V224zM276.2 336L208 434.5V496H624V434.5L555.8 336H276.2zM496 16V221.5L638.6 427.4l1.4 2.1V432v72 8h-8H200h-8v-8V432v-2.5l1.4-2.1L336 221.5V16H312h-8V0h8 24 16H480h16 24 8V16h-8H496z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fast',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM608 256c-10.2 25.3-28.3 59.2-54.1 92.9L541.4 339c22.7-29.8 39.3-59.7 49.3-83c-15.2-35.4-45.5-86-89.6-128.5C454.5 82.7 393.8 48 320 48c-41.3 0-78.5 10.9-111.4 28.3L194.9 65.5C231.3 45.1 273 32 320 32c158.4 0 258 149.3 288 224zM86.1 163.1L98.6 173c-22.7 29.8-39.3 59.7-49.3 83c15.2 35.4 45.5 86 89.6 128.5C185.5 429.3 246.2 464 320 464c41.3 0 78.5-10.9 111.4-28.3l13.7 10.8C408.7 466.9 367 480 320 480C161.6 480 62 330.7 32 256c10.2-25.3 28.3-59.2 54.1-92.9zM320 368c7.8 0 15.4-.8 22.7-2.3l-17.5-13.8c-1.7 .1-3.5 .1-5.2 .1c-47.2 0-86.4-34-94.5-78.9L208 259.4C209.8 319.7 259.3 368 320 368zm0-224c-7.8 0-15.4 .8-22.7 2.3l17.5 13.8c1.7-.1 3.5-.1 5.2-.1c47.2 0 86.4 34 94.5 78.9L432 252.6C430.2 192.3 380.7 144 320 144z'
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fast',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM295.1 420.4c-7.6-8.4-20.6-17.4-39.1-17.4s-31.5 8.9-39.1 17.4l-5.4 5.9-11.9-10.7 5.4-5.9c9.8-10.9 26.8-22.6 50.9-22.6s41.1 11.7 50.9 22.6l5.4 5.9-11.9 10.7-5.4-5.9zm22.6-321l15-5.6 2.8 7.5 1.2 3.1c13.3 35.5 43.6 61.8 80.6 70l8.5 1.9 7.8 1.7-3.5 15.6-7.8-1.7-7.7-1.7c10.9 13.7 17.5 31 17.5 49.9c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c1.3 0 2.6 0 3.9 .1c-15-13.5-26.9-30.6-34.2-50.2l-1.2-3.1-2.8-7.5zm-126.2 7.5l-1.2 3.1c-7.3 19.5-19.2 36.6-34.2 50.2c1.3-.1 2.6-.1 3.9-.1c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-18.9 6.5-36.2 17.5-49.9l-7.7 1.7-7.8 1.7-3.5-15.6 7.8-1.7 8.5-1.9c37-8.2 67.3-34.6 80.6-70l1.2-3.1 2.8-7.5 15 5.6-2.8 7.5zM160 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 272c17.7 0 32-14.3 32-32c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32zm-44.6-49.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-.1c0-6.7-4.3-12.5-10.2-14.8c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C193 199.2 208 217.9 208 240c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7zM384 240c0-12-6.6-22.4-16.3-27.9c-2 15.7-15.5 27.9-31.7 27.9c-5.7 0-11.1-1.5-15.7-4.1c-.2 1.4-.3 2.7-.3 4.1c0 17.7 14.3 32 32 32s32-14.3 32-32zm-80 0c0-6.2 1.2-12.2 3.4-17.7c2.1-5.3 5.1-10.1 8.9-14.3c1.4-1.5 2.8-3 4.4-4.3c-.4 1.4-.6 2.8-.6 4.3c0 5.2 2.5 9.9 6.4 12.8c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16c0-6.8-4.2-12.6-10.2-14.9c3.3-.7 6.7-1.1 10.2-1.1c4.4 0 8.6 .6 12.6 1.7C385 199.2 400 217.9 400 240c0 26.5-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fast',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M80 80a64 64 0 1 1 128 0A64 64 0 1 1 80 80zm144 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM187.9 368H452.1l38.4 128h-341l38.4-128zM464 352H176L132.8 496 128 512h16.7H495.3 512l-4.8-16L464 352zM196 192H48L6 304H23.1l36-96H193c.7-5.4 1.7-10.8 3-16zM444 192c1.3 5.2 2.4 10.6 3 16H580.9l36 96H634L592 192H444zm4-112a64 64 0 1 1 128 0A64 64 0 1 1 448 80zm144 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fast',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128h-8v8V248 376v8h16v-8V256H312h8V240h-8H176V144H344h8V128h-8H168z'
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fast',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      'M240 208l-16 0L16 208l0 96 208 0 16 0 0 16 0 112 9.4 0 176-176L249.4 80 240 80l0 112 0 16zM256 64L436.7 244.7 448 256l-11.3 11.3L256 448l-16 0-16 0 0-16 0-96 0-16-16 0L16 320 0 320l0-16 0-96 0-16 16 0 192 0 16 0 0-16 0-96 0-16 16 0 16 0z'
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fast',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      'M216 56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM196.9 128h-5l-2.2 4.5-84.9 176-3.5 7.2 14.4 7 3.5-7.2L201.9 144H310.1l82.7 171.5 3.5 7.2 14.4-7-3.5-7.2-84.9-176-2.2-4.5h-5H196.9zM200 240H184v8V504v8h8 48 8v-8V352h16V504v8h8 48 8v-8V248v-8H312v8V496H280V344v-8h-8H240h-8v8V496H200V248v-8zM106.3 117.7l11.3-11.3L13.7 2.3 2.3 13.7l104 104zm299.3 0l104-104L498.3 2.3l-104 104 11.3 11.3zM2.3 498.3l11.3 11.3 104-104-11.3-11.3-104 104zm403.3-104l-11.3 11.3 104 104 11.3-11.3-104-104z'
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fast',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      'M496 16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272A144 144 0 1 0 496 0a144 144 0 1 0 0 288zm8-224H488v8 72 8h8 56 8V136h-8H504V72 64zm8 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6l-.8 0c.5 5.3 .8 10.6 .8 16c0 58-28.8 97.9-58.5 124c-3.7 3.2-7.4 6.2-11 9c3.3-11 5.6-23.4 5.6-37c0-70.7-57.3-128-128-128H224 208v16 80h-9.8L23.7 240 198.2 80H208v80 16h16 98.9c-1-5.3-1.7-10.6-2.2-16H240 224V144 80 64H208 192L11.8 229.1 0 240l11.8 10.9L192 416h16 16V400 336 320h16 64c61.9 0 112 50.1 112 112c0 21.2-6.2 39.2-13.2 52.8C394 502 384 512 384 512s13.1-4.9 30.8-15.7C452.7 473.2 512 423.1 512 336z'
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fast',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      'M0 136C0 60.9 60.9 0 136 0h16.3c60.3 0 113.3 39.7 130.4 97.5l33.3 112.8 21.3-30.8 4.7-6.8 6.6 4.9 92.8 68.8 6.2 4.6-4.4 6.4L367.6 368H348.2l77.6-113.4-80-59.3-26.1 37.8-9.5 13.7-4.7-16L267.4 102c-15.1-51-61.9-86-115.1-86H136C69.7 16 16 69.7 16 136v8.2c0 9.8 1.2 19.6 3.6 29.1L68.2 368H51.8L4.1 177.2C1.4 166.4 0 155.4 0 144.2V136zM48 416v80H368V416H48zM32 400H48 368h16v16 80 16H368 48 32V496 416 400z'
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fast',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      'M160 475.3l5.7-5.7 112-112 5.7-5.7L272 340.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L53.7 346.3 48 340.7 36.7 352l5.7 5.7 112 112 5.7 5.7zM336 32V48h8H477.2L338.1 202.6l-2.1 2.3V208v8 8h8H488h8V208h-8H354.8L493.9 53.4l2.1-2.3V48 40 32h-8H344h-8zm72.7 260.6L321.9 480h17.6l22.3-48H470.2l22.3 48h17.6L423.3 292.6l-2.1-4.6H410.9l-2.1 4.6zM416 315l46.8 101H369.2L416 315z'
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fast',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M144 96v32H304V96c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-16 48H16V496H432V144H320v88 8H304v-8V144H144v88 8H128v-8V144zm0-16V96c0-53 43-96 96-96s96 43 96 96v32H432h16v16V496v16H432 16 0V496 144 128H16 128z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fast',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      'M216 0h8 80 8V8 32h72 8v8V96h72 8v8V344c0 92.8-75.2 168-168 168h-8.5c-63.7 0-124.7-25.3-169.7-70.3L36.5 352.3 8.2 324.1l-5.7-5.7 5.7-5.7 56.6-56.6 5.7-5.7 5.7 5.7 28.3 28.3L136 316.1V40 32h8 72V8 0zm96 184l0 64v8H296v-8V40l0-8 0-16H232V32v8 8V248v8H216v-8V48H152V335.4l-13.7 5.7L93 295.8 70.4 273.1 25.1 318.4 47.8 341l89.4 89.4c42 42 99 65.6 158.4 65.6H304c83.9 0 152-68.1 152-152V112H392V248v8H376v-8V104 96l0-48H312l0 136zM189.7 337.1c0-28.6 23.2-51.8 51.8-51.8H245c14 0 27.5 5.3 37.8 14.9l5.2 4.8 5.2-4.8c10.3-9.6 23.8-14.9 37.8-14.9h3.5c28.6 0 51.8 23.2 51.8 51.8c0 14.3-5.9 28-16.4 37.8l-70.9 66.4L288 451.5l-10.9-10.2-70.9-66.4c-10.5-9.8-16.4-23.5-16.4-37.8zm87.4-20.4l-5.2-4.8c-7.3-6.8-16.9-10.6-26.9-10.6h-3.5c-19.8 0-35.8 16-35.8 35.8c0 9.9 4.1 19.4 11.3 26.1L288 429.6l70.9-66.4c7.2-6.8 11.3-16.2 11.3-26.1c0-19.8-16-35.8-35.8-35.8H331c-10 0-19.6 3.8-26.9 10.6l-5.2 4.8L288 327l-10.9-10.2z'
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fast',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      'M448 128h8H560h4l2.4 3.2 72 96 1.6 2.1V232 400v8h-8H607.6c-4 40.4-38.1 72-79.6 72s-75.6-31.6-79.6-72H448v-8H304c0 44.2-35.8 80-80 80c-31.7 0-59-18.4-72-45.1C139 461.6 111.7 480 80 480c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.7 0 59 18.4 72 45.1c13-26.7 40.3-45.1 72-45.1c38.7 0 71 27.5 78.4 64H448V352 136v-8zM624 392V240H464V352c14.6-19.4 37.8-32 64-32c41.5 0 75.6 31.6 79.6 72H624zm-8-168l-60-80H464v80H616zM528 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM80 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fast',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM232 240v8V360v8H216v-8V248v-8h16zm8 160v32H208V400h32z'
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fast',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      'M264 72c0-30.9 25.1-56 56-56s56 25.1 56 56v48 8h16v-8V72c0-39.8-32.2-72-72-72s-72 32.2-72 72V288H144V232v-8h-8H40 32v16h8 88v48H8 0v8 48 8H8 504h8v-8V296v-8h-8H384V240h88 8V224h-8H376h-8v8 56H264V72zM16 304H128h16H248h16H368h16H496v32H16V304zm16 80v24c0 57.4 46.6 104 104 104H376c57.4 0 104-46.6 104-104V384H464v24c0 48.6-39.4 88-88 88H136c-48.6 0-88-39.4-88-88V384H32z'
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fast',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      'M288 227.3l5.7-5.7 88-88 5.7-5.7L376 116.7l-5.7 5.7L296 196.7V8 0H280V8 196.7l-74.3-74.3-5.7-5.7L188.7 128l5.7 5.7 88 88 5.7 5.7zm0 53.8l-91.7-49.4L182 224l-4.7 15.6-29.9 99.7L47.6 369.3 32 374l7.7 14.4L80.5 464H98.7L55.4 383.6l96.6-29 8.3-2.5 2.5-8.3 29-96.6 88.8 47.8 7.6 4.1 7.6-4.1 88.8-47.8 29 96.6 2.5 8.3 8.3 2.5 96.6 29L477.3 464h18.2l40.8-75.7L544 374l-15.6-4.7-99.7-29.9-29.9-99.7L394 224l-14.4 7.7L288 281.1zM398.9 464c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96h16.2c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80h16.2zM8 496H0v16H8 568h8V496h-8H8z'
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fast',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      'M168 0h-8V8 32H136h-8v8V312v8h8H280h8v-8V144c97.2 0 176 78.8 176 176s-78.8 176-176 176H208 8 0v16H8 208h80H504h8V496h-8H364.9C432.6 466.4 480 398.7 480 320c0-106-86-192-192-192V40 32h-8H256V8 0h-8H168zM272 128v16V304H144V48h24 8V40 16h64V40v8h8 24v80zM160 352v16h8 80 8V352h-8H168h-8zM96 416v16h8H312h8V416h-8H104 96z'
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fast',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      'M8 0H0V16H8 32V144v4l3.3 2.4L178.5 256 35.3 361.6 32 364v4V496H8 0v16H8 376h8V496h-8H352V368v-4l-3.3-2.4L205.5 256 348.7 150.4 352 148v-4V16h24 8V0h-8H8zM336 16V128H48V16H336zm-5.5 128L192 246.1 53.5 144h277zM192 265.9L336 372v44H48V372L192 265.9zM48 496V432H336v64H48z'
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fast',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 96v8 24h96V104 96h16v8 24h48 16v16 64 16V368v16H368 144 128V368 224 208 144 128h16 48V104 96h16zm-16 72V144H144v64H368V144H320v24 8H304v-8V144H208v24 8H192v-8zm176 56H144V368H368V224z'
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fast',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM117.6 144l66.7 250.1 1.6 5.9H198l1.7-5.7L256 204.2l56.3 190.1L314 400h12.1l1.6-5.9L394.4 144H377.9L319.6 362.5 263.7 173.7 259.6 160h-7.2l-4.1 13.7L192.4 362.5 134.1 144H117.6z'
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fast',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      'M256 118.6l-11.3-11.3L220.5 83.1C198 60.6 167.5 48 135.8 48C69.6 48 16 101.6 16 167.8c0 31.8 12.6 62.2 35.1 84.7l24.2 24.2L256 457.4l16-16c2.3 5.1 4.9 10.1 7.7 14.9l-12.4 12.4L256 480l-11.3-11.3L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l12.9 12.9L256 96l11.3-11.3 12.9-12.9c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-4.8-2.2-9.8-4.3-14.9-6.1c3.3-11 5-22.6 5-34.3C496 101.6 442.4 48 376.2 48c-31.8 0-62.2 12.6-84.7 35.1l-24.2 24.2L256 118.6zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 152h-8H360h-8V360h8H504h8v16z'
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fast',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      'M15.8 249.8L8 248c-7.8-1.8-7.8-1.8-7.8-1.8l0 0 0 0 0-.1 .1-.5c.1-.4 .2-1 .4-1.8c.4-1.6 1-3.9 1.8-6.8c1.6-5.8 4-14.1 7.2-23.9c6.5-19.8 16.4-46.2 30.1-72.7C53.6 113.9 71.4 87 93.7 66.6C116.1 46.1 143.5 32 176 32c48.2 0 79.4 30 101.6 71.7c21.9 41.3 36.1 96.1 50 149.6l.2 .7c14.1 54.3 27.9 107.3 48.8 146.8C397.4 440 424.2 464 464 464c27.5 0 51.1-11.9 71.5-30.4c20.4-18.6 37.1-43.7 50.4-69.3c13.2-25.5 22.8-51.1 29.1-70.3c3.1-9.6 5.4-17.6 7-23.2c.8-2.8 1.3-5 1.7-6.4l.4-1.7 .1-.4 0-.1 0 0 0 0L632 264c7.8 1.8 7.8 1.8 7.8 1.8l0 0 0 0 0 .1-.1 .5c-.1 .4-.2 1-.4 1.8c-.4 1.6-1 3.9-1.8 6.8c-1.6 5.8-4 14.1-7.2 23.9c-6.5 19.8-16.4 46.2-30.1 72.7c-13.7 26.4-31.5 53.3-53.8 73.7C523.9 465.8 496.5 480 464 480c-48.2 0-79.4-30-101.6-71.8c-21.9-41.3-36.1-96.1-50-149.6l-.2-.7c-14.1-54.3-27.9-107.3-48.8-146.8C242.6 72 215.8 48 176 48c-27.5 0-51.1 11.9-71.5 30.4C84.1 97 67.4 122.1 54.1 147.7C40.9 173.2 31.3 198.7 25 218c-3.1 9.6-5.4 17.6-7 23.2c-.8 2.8-1.3 5-1.7 6.4l-.4 1.7-.1 .4 0 .1 0 0 0 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fast',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      'M560 16H16V400H231.8h.3 90.8c1 5.4 2.2 10.8 3.7 16H238.8l-13.3 80H288h62.6 16.2 8.4c6.1 5.8 12.7 11.1 19.6 16H360 216 136h-8V496h8 73.2l13.3-80H16 0V400 16 0H16 560h16V16 211.2c-5.2-2.7-10.5-5.1-16-7.2V16zM512 192.7c-5.3-.5-10.6-.7-16-.7V80H80V336H322.9c-1 5.3-1.7 10.6-2.2 16H80 64V336 80 64H80 496h16V80 192.7zm-64 5.9c-5.4 1.5-10.8 3.3-16 5.4V155.3L325.7 261.7l-5.7 5.7-5.7-5.7L240 187.3 133.7 293.7l-5.7 5.7L116.7 288l5.7-5.7 112-112 5.7-5.7 5.7 5.7L320 244.7 420.7 144H352h-8V128h8 88 8v8 62.6zM496 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-28.2 93.9c-8 4.1-12.3 9.7-11.7 17.6c.4 5.2 3.6 9.5 11.5 13.5c7.9 4 18.3 6.8 30 10l1 .3c11.5 3.1 24.3 6.6 34.1 12.1c10.2 5.7 18.8 14.5 19.2 28.4c.5 16.4-8.9 27-20.4 33c-8.5 4.4-18.5 6.5-27.6 7.1v17.7 8H488v-8V439.4c-12.6-1.4-24.7-5.1-35.9-8.5l0 0c-2.1-.7-4.3-1.3-6.3-1.9l-7.7-2.3 4.5-15.3 7.7 2.3c2.3 .7 4.5 1.3 6.7 2l0 0 0 0c13.6 4.1 26.1 7.9 39.2 8.3c9.4 .3 20.1-1.4 28-5.5c7.6-3.9 12-9.6 11.7-18.3c-.2-6.2-3.6-10.7-11.1-14.9c-7.8-4.4-18.5-7.4-30.5-10.6l-1.8-.5c-11-2.9-22.9-6.1-32.3-11c-10.1-5.2-19.3-13.3-20.2-26.7c-1.1-16.5 8.9-27.1 20.4-32.9c8.5-4.3 18.5-6.5 27.4-7.3V280v-8h16v8 16.4c10.2 .8 20.4 2.8 29.8 5l7.8 1.8-3.7 15.6-7.8-1.8c-11.4-2.7-23.1-4.8-34.3-5c-8.8-.1-19.8 1.6-28.1 5.8z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fast',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      'M448 112c0 44.2-35.8 80-80 80c-25.9 0-48.9-12.3-63.5-31.3L157.1 234.4c1.9 6.9 2.9 14.1 2.9 21.6s-1 14.7-2.9 21.6l147.5 73.7c14.6-19 37.6-31.3 63.5-31.3c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-12.6 2.9-24.5 8.1-35L151.2 292.5C137.9 318.3 111 336 80 336c-44.2 0-80-35.8-80-80s35.8-80 80-80c31 0 57.9 17.7 71.2 43.5L296.1 147c-5.2-10.6-8.1-22.5-8.1-35c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM432 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM368 464a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fast',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      'M473.6 6.2l-5.7 5.6c5.7-5.6 5.7-5.6 5.7-5.6l0 0 0 0 0 0 .1 .1 .4 .4c.3 .3 .8 .8 1.3 1.4c1.1 1.2 2.6 3 4.4 5.4c3.6 4.7 8.4 11.4 13.1 20.1c9.5 17.4 19.1 42.5 19.1 73.4c0 44.5-15.4 81.7-42.6 119.5c-27 37.5-66.1 76-113.9 123.1c0 0 0 0 0 0L303 402.3l-5.7 5.7-5.7-5.7-92-92L17.1 506.3l-5.5 5.8L-.1 501.2l5.5-5.9 188.3-202 0 0L462 6.4l5.7-6.1 5.8 6zm-6 17.6L210.6 298.7l86.7 86.7 46.9-46.9 0 0c48.1-47.4 86.1-84.9 112.2-121.1c25.9-35.9 39.6-69.9 39.6-110.2c0-27.5-8.5-50.1-17.1-65.8c-4.1-7.5-8.2-13.5-11.4-17.6z'
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fast',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M480 176c0 33.9-10.5 65.3-28.5 91.2c-4.5 6.5-9.5 13.3-14.5 20.2c-12.5 17.2-25.9 35.5-36.3 54.4c-7.4 13.5-11.6 27.8-14 42.2H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h16.2c-2.4-14.4-6.6-28.7-14-42.2c-10.4-19-23.7-37.3-36.3-54.4l0 0 0 0c-5-6.9-10-13.7-14.5-20.2c-18-25.9-28.5-57.3-28.5-91.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm-256-8c0-48.6 39.4-88 88-88V64c-57.4 0-104 46.6-104 104h16zm32 328V432H384v64H256zm-16-80v16 64 16h16H384h16V496 432 416H384 256 240zM49.1 4.1L42.3 0 34 13.7l6.9 4.1 75 45 6.9 4.1L131 53.3l-6.9-4.1-75-45zm550 13.7l6.9-4.1L597.7 0l-6.9 4.1-75 45L509 53.3 517.3 67l6.9-4.1 75-45zM8 160H0v16H8 88h8V160H88 8zm544 0h-8v16h8 80 8V160h-8H552zM124.1 270.9l6.9-4.1L122.7 253l-6.9 4.1-75 45L34 306.3 42.3 320l6.9-4.1 75-45zm400-13.7l-6.9-4.1L509 266.7l6.9 4.1 75 45 6.9 4.1 8.2-13.7-6.9-4.1-75-45z'
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fast',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      'M173.7 96H16 0v16V496v16H16 496h16V496 112 96H496 338.3L266.5 12.3 256 0 245.5 12.3 173.7 96zM256 24.6l70.1 81.8 4.8 5.6h7.4H496V496H16V112H173.7h7.4l4.8-5.6L256 24.6z'
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fast',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      'M122.6 32H128 384h3.8l2.4 3L515.8 192H624h16v16V384v16H624 574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H16 0V384 208 192H16 58.6l62-155 2-5zM384 384c0-53 43-96 96-96s96 43 96 96h48V208H256 240 16V384H64c0-53 43-96 96-96s96 43 96 96H384zM75.8 192H240V176 80 48H133.4L75.8 192zM256 192H495.4L380.2 48H256V80v96 16zM160 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm400-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fast',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      'M16 464l416 0 0-416L16 48l0 416zM0 48L0 32l16 0 416 0 16 0 0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48zM64 176l0-16 8 0 56 0 0-40 0-16 16 0 32 0 16 0 0 16 0 96 0 16-16 0-32 0-16 0 0-16 0-40-56 0-8 0zm80 0l0 40 32 0 0-96-32 0 0 40 0 16zm80 0l0-16 8 0 144 0 8 0 0 16-8 0-144 0-8 0zM72 352l-8 0 0-16 8 0 152 0 0-40 0-16 16 0 32 0 16 0 0 16 0 96 0 16-16 0-32 0-16 0 0-16 0-40L72 352zm168-16l0 16 0 40 32 0 0-96-32 0 0 40zm88 16l-8 0 0-16 8 0 48 0 8 0 0 16-8 0-48 0z'
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fast',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M442.3 143l47-47L416 22.6l-47 47L442.3 143zM431 154.3L357.7 81 174.4 264.2 150 362l97.8-24.5L431 154.3zM352 64l5.7-5.7 47-47L416 0l11.3 11.3 73.4 73.4L512 96l-11.3 11.3-47 47L448 160l-5.7 5.7L256 352 145.6 379.6 128 384l4.4-17.6L160 256 346.3 69.7 352 64zM0 72c0-4.4 3.6-8 8-8H216h8V80h-8H16V496H432V296v-8h16v8V504c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V72z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fast',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      'M342.1 107.2L405 16 416 0H396.6 115.4 96l11 16 62.9 91.2 9.1 13.2c-4.1 2.6-8.6 5.6-13.3 8.8C105.1 170.8 0 262.9 0 416v80 16H16 496h16V496 416c0-153.1-105.1-245.2-165.7-286.8c-4.7-3.3-9.2-6.2-13.3-8.8l9.1-13.2zM496 496H16V416c0-156.4 115.8-246.4 171.6-282.1l9.2-5.9H315.2l9.2 5.9C380.2 169.6 496 259.6 496 416v80zM319.8 111.3l-.5 .7H192.7l-.5-.7L126.5 16H385.5l-65.7 95.3zM264 224v-8H248v8 16.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-5.7 2.5-13 3.8-21.3 3.8h-.5c-4.3 0-8.8-.4-13.6-1.1c-7.1-1.2-19.2-5.3-28.8-8.5l0 0c-2.1-.7-4-1.4-5.7-1.9l-7.6-2.5-5.1 15.2 7.6 2.5c1.4 .5 3.1 1 5 1.7l0 0 0 0 0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7l0 16.6v8h16v-8V399.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6l4.1-15.5c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V224z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fast',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M495.9 248H392h-8v16h8H495.9C491.7 390.2 390.2 491.7 264 495.9V392v-8H248v8V495.9C121.8 491.7 20.3 390.2 16.1 264H120h8V248h-8H16.1C20.3 121.8 121.8 20.3 248 16.1V120v8h16v-8V16.1C390.2 20.3 491.7 121.8 495.9 248zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fast',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      'M32 32h8H600h8V48h-8H520v96h80 8v16h-8H528 40 32V144h8 80V48H40 32V32zM384 288l0 23c-12-23.2-36.1-39-64-39c-39.8 0-72 32.2-72 72V472v8h-8H144h-8v-8V344c0-39.8-32.2-72-72-72H40 32V256h8H64c48.6 0 88 39.4 88 88V464h80V344c0-48.6 39.4-88 88-88c25.2 0 48 10.6 64 27.6V288zm8-240v96H504V48H392zm-16 96V48H264v96H376zM136 48v96H248V48H136zM528 208c-26.5 0-48 21.5-48 48v64h96V256c0-26.5-21.5-48-48-48zm-64 48c0-35.3 28.7-64 64-64s64 28.7 64 64v64h32 16v16V496v16H624 432 416V496 336 320h16 32V256zm-32 80V496H624V336H592 576 480 464 432z'
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fast',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-8 280v8H248v-8V203.3l-74.3 74.3-5.7 5.7L156.7 272l5.7-5.7 88-88 5.7-5.7 5.7 5.7 88 88 5.7 5.7L344 283.3l-5.7-5.7L264 203.3V392z'
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fast',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      'M304 112V400H16V112H304zM16 96H0v16V400v16H16 304h16V400 112 96H304 16z'
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fast',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      'M144 0h8H296h8V8 80h16c70.7 0 128 57.3 128 128V496v16H432 368 352 96 80 16 0V496 208C0 137.3 57.3 80 128 80h16V8 0zM96 496H352V392H96V496zm272 0h64V208c0-61.9-50.1-112-112-112H128C66.1 96 16 146.1 16 208V496H80V384 296v-8h8H360h8v8 88V496zM288 16H160V80H288V16zM136 192H312h8v16h-8H136h-8V192h8zM352 376V304H96v72H352z'
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fast',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      'M280 32h-8V48h8H420.7L10.3 458.3 4.7 464 16 475.3l5.7-5.7L432 59.3V200v8h16v-8V40 32h-8H280zM21.7 42.3L16 36.7 4.7 48l5.7 5.7L190.1 233.4l11.3-11.3L21.7 42.3zM420.7 464H280h-8v16h8H440h8v-8V312v-8H432v8V452.7L257.9 278.6l-11.3 11.3L420.7 464z'
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fast',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      'M229.7 7.1L224 1.5l-5.7 5.7-152 152L64 161.5v3.3V184v8h8 52.7L34.3 282.3 32 284.7V288v24 8h8H92.7L2.3 410.3 0 412.7V416v24 8H8 152h8 56v56 8h16v-8V448h56 8H440h8v-8V416v-3.3l-2.3-2.3L355.3 320H408h8v-8V288v-3.3l-2.3-2.3L323.3 192H376h8v-8V164.8v-3.3l-2.3-2.3-152-152zM232 432V200v-8H216v8V432H160h-8H16V419.3L117.7 317.7 131.3 304H112 48V291.3L149.7 189.7 163.3 176H144 80v-7.9l144-144 144 144V176H304 284.7l13.7 13.7L400 291.3V304H336 316.7l13.7 13.7L432 419.3V432H296h-8H232z'
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fast',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      'M56.5 274.7l-4.7 9.3L28.9 329.9l76-15.2 5.1-1 4.7 2.2C142.3 328.7 174.1 336 208 336c108.6 0 192-74 192-160s-83.4-160-192-160S16 90 16 176c0 33.4 12.3 64.7 33.9 90.7l6.7 8zM19.9 348L0 352l9.1-18.1 28.5-57C13.9 248.3 0 213.5 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.2 0-70.3-7.8-99.9-21.6L19.9 348zm211.6 35c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c33.9 0 65.7-7.3 93.2-20.1l4.7-2.2 5.1 1 76 15.2-22.9-45.8-4.7-9.3 6.7-8c21.5-26 33.9-57.2 33.9-90.7c0-81.7-75.3-152.6-176-159.5l0-.5c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9l28.5 57L640 512l-19.9-4-88.2-17.6C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM185.3 83h39.8c26.2 0 47.5 21.3 47.5 47.5c0 16-8 30.9-21.4 39.7L216 193.4V210v8H200v-8V189.1v-4.3l3.6-2.4 38.9-25.6c8.8-5.8 14.2-15.7 14.2-26.3c0-17.4-14.1-31.5-31.5-31.5H185.3c-14.4 0-26 11.6-26 26l0 4.6-16 0 0-4.6c0-23.2 18.8-42 42-42zm34 149.7v22.7H196.7V232.7h22.7zm304 68.7l-5.7 5.7-85.3 85.3-5.7 5.7-5.7-5.7-42.7-42.7-5.7-5.7L384 332.7l5.7 5.7 37 37 79.7-79.7L512 290l11.3 11.3z'
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fast',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      'M292.6 9.5L288 6.2l-4.6 3.2-216 152-6.5 4.6 9.2 13.1 6.5-4.6L112 149.6V251.5l2.6 1.9 1.1 .8 0 0 0 0c4.4 3.2 8.5 6.1 12.2 8.7V138.4L288 25.8 448 138.4V262.9c3.8-2.6 7.8-5.5 12.3-8.7l3.7-2.7V149.6l35.4 24.9 6.5 4.6 9.2-13.1-6.5-4.6-216-152zM96 314l-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 369.8 22.5 384 0 384v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V384c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l0 0-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 369.8 406.5 384 384 384s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9 0 0c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 369.8 214.5 384 192 384s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9L96 314zM96.6 427L96 426c-.2 .3-.4 .6-.6 .9c-4.3 6.1-8.5 12.2-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C44.6 481.8 22.5 496 0 496v16c28.7 0 54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1V496c-22.5 0-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9l-.6-.9-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C428.5 481.8 406.5 496 384 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9c-.2-.3-.4-.6-.6-.9l-.6 .9c-4.3 6.1-8.5 12.1-13.3 17.9c-4.8 5.8-11.8 13.5-20.2 21.2C236.5 481.8 214.5 496 192 496s-44.6-14.2-61.8-29.9c-8.5-7.7-15.4-15.4-20.2-21.2c-4.8-5.8-9-11.8-13.3-17.9z'
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fast',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      'M392 120c0 13.6-6.1 32.1-17 53.5c-10.7 21-25.2 43.1-39.9 63.3c-14.7 20.2-29.4 38.3-40.5 51.4c-2.4 2.8-4.6 5.3-6.5 7.6c-2-2.3-4.2-4.8-6.5-7.6c-11.1-13.1-25.8-31.2-40.5-51.4c-14.7-20.3-29.2-42.3-39.9-63.3c-10.9-21.4-17-39.9-17-53.5c0-57.4 46.6-104 104-104s104 46.6 104 104zm16 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 57.1 79.9 154.2 109.3 188c6.6 7.6 10.7 12 10.7 12s4.1-4.4 10.7-12C328.1 274.2 408 177.1 408 120zm6.8 81L560 150.5V436.6L400 492.3V288H384V492.8L192 433.7V288H176V433.8L16 489.5V203.4l126.9-44.1c-1.7-5.1-3.1-10.3-4.2-15.5L0 192V495.1 512l16-5.6L184 448l208 64 184-64V144.9 128l-16 5.6-135.2 47c-2.2 5-4.6 10-7.1 14.7c-1 1.9-2 3.8-3 5.7z'
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fast',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      'M8 32H0v8V304v8 8V472v8H8 440h8V464h-8H16V320H432v64H88 80v16h8H440h8v-8V320v-8-8V40 32h-8H8zM432 304H16V48H432V304z'
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fast',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      'M230.4 491.3c1.4 1.3 2.8 2.5 4.1 3.7c-1.7-.2-3.4-.3-5-.5L225 510.1c10.2 1.2 20.5 1.9 31 1.9c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.5 .6 20.8 1.9 31l15.6-4.5C16.5 273.8 16 265 16 256c0-28.1 4.8-55 13.7-80h108c-5.7 22.7-9.3 47.7-9.7 75l16.1-4.6c.7-25.6 4.4-49.1 10.1-70.4H357.8c6.3 23.9 10.2 50.6 10.2 80s-3.9 56.1-10.2 80h-83l-4.6 16h82.9c-11.7 35.7-28.7 64.8-45.8 87.4c-15.2 20.1-30.4 35.1-41.7 44.9c-3.6 3.1-6.8 5.8-9.5 7.9c-2.7-2.1-5.9-4.7-9.5-7.9c-3.4-3-7.2-6.4-11.2-10.3l-4.9 17-.1 .3zM353.1 160H158.9c11.7-35.7 28.7-64.8 45.8-87.4c15.2-20.1 30.4-35.1 41.7-44.9c3.6-3.1 6.8-5.8 9.5-7.9c2.7 2.1 5.9 4.7 9.5 7.9c11.3 9.9 26.5 24.8 41.7 44.9c17.1 22.6 34.1 51.6 45.8 87.4zM384 256c0-29.2-3.6-55.9-9.7-80h108c8.8 25 13.7 51.9 13.7 80s-4.8 55-13.7 80h-108c6.1-24.1 9.7-50.8 9.7-80zm-14.2-96C347.5 87.4 303.8 40.2 277.5 17C366.6 24.9 441.7 81.5 476 160H369.8zM36 160C70.3 81.5 145.4 24.9 234.5 17c-26.3 23.2-69.9 70.5-92.3 143H36zM369.8 352H476c-34.3 78.5-109.4 135.1-198.5 143c26.3-23.2 69.9-70.5 92.3-143zM263.7 258.2l4-13.8-13.8 4-224 64L4.4 319.6l25.2 8.1 108.7 34.8L2.3 498.3l11.3 11.3L149.6 373.7l34.8 108.7 8.1 25.2 7.3-25.4 64-224zM59.6 320.4l184.8-52.8L191.6 452.4l-30.7-96-1.3-3.9-3.9-1.3-96-30.7z'
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fast',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      'M256 0V8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C336 115.4 352 148.7 352 184v8H336v-8c0-30.6-13.9-59-36.7-75.6L283.2 96.5C256 76.6 240 43.3 240 8V0h16zM128 160l128 96h16H496h16v16V496v16H496 16 0V496 336 256 176 160H16 128zM272 272H256h-5.3H16v64V496H496V272H272zm-42.7-16L122.7 176H16v80H229.3zM384 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C464 115.4 480 148.7 480 184v8H464v-8c0-30.6-13.9-59-36.7-75.6L411.2 96.5C384 76.6 368 43.3 368 8V0h16V8zM120 320v8V440v8H104v-8V328v-8h16zm96 0v8V440v8H200v-8V328v-8h16zm96 0v8V440v8H296v-8V328v-8h16zm96 0v8V440v8H392v-8V328v-8h16zM112 64A48 48 0 1 0 16 64a48 48 0 1 0 96 0zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z'
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fast',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M138.9 3.2C130.3 1.1 121.3 0 112 0C50.1 0 0 50.1 0 112s50.1 112 112 112c35 0 66.2-16 86.7-41.1c5-6.1 9.3-12.7 13-19.8c-6.8 2.5-14 4.1-21.6 4.7c-2 .2-4.1 .2-6.2 .2c-44.2 0-80-35.8-80-80c0-28.4 14.8-53.3 37.1-67.5c6.2-3.9 12.9-7 20-9.2c-7-3.4-14.5-6.2-22.2-8.1zM112 16c2.7 0 5.4 .1 8.1 .3C100.4 33.9 88 59.5 88 88c0 50.3 38.7 91.5 87.9 95.7c-17 15.1-39.4 24.3-63.9 24.3c-53 0-96-43-96-96s43-96 96-96zm293.2 89.9l-5.2-4.5-5.2 4.5-224 192-6.1 5.2 10.4 12.1 6.1-5.2L224 273.4V504v8h8H568h8v-8V273.4l42.8 36.7 6.1 5.2 10.4-12.1-6.1-5.2-224-192zM560 259.7V496H240V259.7L400 122.5 560 259.7zM336 272v8V392v8h8H456h8v-8V280v-8h-8H344h-8zm16 16h96v96H352V288zM264 0H248V8 56H200h-8V72h8 48v48 8h16v-8V72h48 8V56h-8H264V8 0zM104 320H88v8 48H40 32v16h8H88v48 8h16v-8V392h48 8V376h-8H104V328v-8z'
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fast',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      'M16 48V464H624V48H16zM0 32H16 624h16V48 464v16H624 16 0V464 48 32zM88 160h56c30.9 0 56 25.1 56 56s-25.1 56-56 56H96v72 8H80v-8V264 168v-8h8zm56 96c22.1 0 40-17.9 40-40s-17.9-40-40-40H96v80h48zm264-24c0-39.8 32.2-72 72-72s72 32.2 72 72v48c0 39.8-32.2 72-72 72s-72-32.2-72-72V232zm72-56c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56s56-25.1 56-56V232c0-30.9-25.1-56-56-56zM240 160h8 56c30.9 0 56 25.1 56 56c0 23.9-15 44.4-36.2 52.4L372.6 352H354.1l-46.7-80.1c-1.1 .1-2.2 .1-3.3 .1H256v72 8H240v-8V264 168v-8zm16 96h48c22.1 0 40-17.9 40-40s-17.9-40-40-40H256v80z'
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fast',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      'M0 0H8 216h8V8 168v8h-8H104 96V160h8H208V16H16V376c0 66.3 53.7 120 120 120h40V398.5c0-81.1 51.7-152.8 128-178.7V167.4c-27.1-3.9-48-27.2-48-55.4c0-30.9 25.1-56 56-56h7c19.4-33.5 55.6-56 97-56s77.7 22.5 97 56h7c30.9 0 56 25.1 56 56c0 28.2-20.9 51.6-48 55.4V240v16H512 320 304V240v-3.2c-67 25.1-112 89.4-112 161.7V496H496V464H440h-7.4l-.6-7.3-.7-8c-3.8-45.6-41.9-80.7-87.7-80.7H328h-8V352h8 15.7c37.1 0 69.9 19.5 88.3 49.1V296v-8h11.5l2.4 2.5 128 136 2.2 2.3V432v72 8H560v-8V435.2l-112-119V448h56 8v8 48 8h-8H136C60.9 512 0 451.1 0 376V8 0zM416 16c-53 0-96 43-96 96v40 16 72H512V168 152 112c0-53-43-96-96-96zM304 151.2V112c0-14.1 2.6-27.6 7.4-40c-21.8 .3-39.4 18.1-39.4 40c0 19.4 13.7 35.5 32 39.2zM560 112c0-21.9-17.6-39.6-39.4-40c4.7 12.4 7.4 25.9 7.4 40v39.2c18.3-3.7 32-19.8 32-39.2zm-192 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-96 16c0 17.4 11.1 32.2 26.7 37.7l5.3 1.9v5.7V200h64V157.3v-5.7l5.3-1.9c15.5-5.5 26.7-20.3 26.7-37.7c0-22.1-17.9-40-40-40H392c-22.1 0-40 17.9-40 40zm40-56h48c30.9 0 56 25.1 56 56c0 22.3-13.1 41.6-32 50.6V208v8h-8H376h-8v-8V162.6c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56z'
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fast',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      'M512 315.8l16 12.6V16h64V379l16 12.6V16 0H592 528 512V16 315.8zm-64-50.5V144 128H432 368 352v16 45.5l16 12.6V144h64V252.7l16 12.6zM352 373V496v16h16 64 16V496 448.8l-16-12.6V496H368V385.6L352 373zM203.8 256H192v16V496v16h16 64 16V496 322.5l-16-12.6V496H208V272h16.1l-20.3-16zM112 400v96H48V400h64zM48 384H32v16 96 16H48h64 16V496 400 384H112 48zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fast',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      'M304 16H48V416H304V16zM48 496H304V432H48v64zm304 16H320 304 48 32 0V496H32V16 0H48 304h16V16 272h8c39.8 0 72 32.2 72 72v40c0 26.5 21.5 48 48 48s48-21.5 48-48V224h-8c-30.9 0-56-25.1-56-56V72.9l-29.4-27-5.9-5.4 10.8-11.8 5.9 5.4 96 88 2.6 2.4V128 384c0 35.3-28.7 64-64 64s-64-28.7-64-64V344c0-30.9-25.1-56-56-56h-8V496h32v16zM496 131.5l-48-44V168c0 22.1 17.9 40 40 40h8V131.5zM112 80V208H240V80H112zM96 64h16H240h16V80 208v16H240 112 96V208 80 64z'
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fast',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      'M197.7 474.3L192 480l-5.7-5.7-136-136-5.7-5.7L56 321.4l5.7 5.7L184 449.4l0-308.7 0-8 16 0 0 8 0 308.7L322.3 327l5.7-5.7 11.3 11.3-5.7 5.7-136 136zM8 52.7l-8 0 0-16 8 0 368 0 8 0 0 16-8 0L8 52.7z'
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fast',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h80 16v16V496v16H432 16 0V496 208 192H16 96zm0 16H16V496H432V208H352 336 112 96z'
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fast',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      'M187.2 308.6l49.4-105.8L510 20.6 555.4 66 373.2 339.4 267.4 388.8l-80.2-80.2zm68.4 91c.3 2.8 .4 5.6 .4 8.4c0 46.3-35.8 84.3-81.2 87.7l-3.4 .3H168 32 16V464H32 64 80V448 408c0-48.6 39.4-88 88-88c2.8 0 5.6 .1 8.4 .4l79.2 79.2zm16.3 4.7L384 352 576 64 512 0 224 192 171.7 304.1c-1.2 0-2.5-.1-3.7-.1c-57.4 0-104 46.6-104 104v24 16H48 32 16 0v16 32 16H16 32 160h8 8v-.3c53.7-4.1 96-49 96-103.7c0-1.2 0-2.5-.1-3.7z'
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fast',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      'M184 72V64H168v8 52.7L133.7 90.3 128 84.7 116.7 96l5.7 5.7L168 147.3v94.8L85.9 194.7 69.2 132.4l-2.1-7.7-15.5 4.1 2.1 7.7 12.6 46.9L20.7 157.1l-6.9-4-8 13.9 6.9 4 45.6 26.3L11.4 209.8l-7.7 2.1 4.1 15.5 7.7-2.1 62.4-16.7L160 256 77.9 303.4 15.5 286.7l-7.7-2.1L3.6 300.1l7.7 2.1 46.9 12.6L12.7 341.1l-6.9 4 8 13.9 6.9-4 45.6-26.3L53.7 375.5l-2.1 7.7 15.5 4.1 2.1-7.7 16.7-62.4L168 269.9v94.8l-45.7 45.7-5.7 5.7L128 427.3l5.7-5.7L168 387.3V440v8h16v-8V387.3l34.3 34.3 5.7 5.7L235.3 416l-5.7-5.7L184 364.7V269.9l82.1 47.4 16.7 62.4 2.1 7.7 15.5-4.1-2.1-7.7-12.6-46.9 45.6 26.3 6.9 4 8-13.9-6.9-4-45.6-26.3 46.9-12.6 7.7-2.1-4.1-15.5-7.7 2.1-62.4 16.7L192 256l82.1-47.4 62.4 16.7 7.7 2.1 4.1-15.5-7.7-2.1-46.9-12.6 45.6-26.3 6.9-4-8-13.9-6.9 4-45.6 26.3 12.6-46.9 2.1-7.7-15.5-4.1-2.1 7.7-16.7 62.4L184 242.1V147.3l45.7-45.7 5.7-5.7L224 84.7l-5.7 5.7L184 124.7V72zm296-8V80h8 72c35.3 0 64 28.7 64 64s-28.7 64-64 64H392h-8v16h8H560c44.2 0 80-35.8 80-80s-35.8-80-80-80H488h-8zm0 384h8 72c44.2 0 80-35.8 80-80s-35.8-80-80-80H392h-8v16h8H560c35.3 0 64 28.7 64 64s-28.7 64-64 64H488h-8v16z'
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fast',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      'M307.6 490.4l31.8-106.1-31.6-43.5-2.5-3.4H206.7l-2.5 3.4-31.6 43.5 31.8 106.1c16.6 3.6 33.9 5.6 51.6 5.6s35-1.9 51.6-5.6zm18.1-4.7c52.1-15.8 96.7-48.8 127.2-92.5L354 391l-28.4 94.8zM463 377.5c17.2-29.3 28.4-62.6 31.9-98.1l-91.1-63L352.6 233l-4 1.3L318.2 328l2.5 3.4 31.6 43.5L463 377.5zM496 260.7c0-1.6 0-3.1 0-4.7c0-54.4-18.1-104.6-48.6-144.8l-32.7 93.3L496 260.7zm-60.5-164C412.6 70.9 384.2 50 352.1 36L264 103.2l0 53.8v4.2l79.7 57.9 4-1.3 51.2-16.6L435.5 96.7zM334.7 29.2C310 20.6 283.6 16 256 16s-54 4.6-78.7 13.2l78.7 60 78.7-60zM159.9 36C127.8 50 99.4 70.9 76.5 96.7l36.7 104.5 51.2 16.6 4 1.3L248 161.2V157 103.2L159.9 36zM64.6 111.2C34.1 151.4 16 201.6 16 256c0 1.6 0 3.1 0 4.7l81.3-56.2L64.6 111.2zM17.1 279.4c3.4 35.5 14.6 68.8 31.8 98.1l110.7-2.6 31.6-43.5 2.5-3.4-30.4-93.7-4-1.3-51.2-16.6-91.1 63zm42 113.9c30.5 43.6 75.1 76.7 127.2 92.5L157.9 391l-98.8 2.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.5 65.4l95.1 0L332.9 231 256 175.1 179.1 231l29.4 90.4z'
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fast',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      'M304 16V48H288 160 144V16H304zM128 64h16V96L32 240V496v16H48 400h16V496 240l-14.4-18.5c26.8-7.7 46.4-32.3 46.4-61.5c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8L304 96V64h16V48 16 0H304 144 128V16 48 64zm32 0H288V96v5.5l3.4 4.3L400 245.5V496H48V245.5L156.6 105.8l3.4-4.3V96 64zm179.6 77.8c7.2-17.5 24.4-29.8 44.4-29.8c26.5 0 48 21.5 48 48c0 24.2-17.9 44.3-41.3 47.5l-51.2-65.8zM112 304H336v96H112V304zM96 288v16 96 16h16H336h16V400 304 288H336 112 96z'
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fast',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-8 80v8 80h80 8v16h-8H264v80 8H248v-8V296H168h-8V280h8 80V200v-8h16z'
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fast',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      'M48 427.3V496h92.1L281.7 315.1l6.3-8 6.3 8L435.9 496H528V427.3L288 143.4 48 427.3zM160.4 496H288 415.6L288 333 160.4 496zM33.9 419.2L277.5 131 177.9 13.2 190.1 2.8 288 118.6 385.9 2.8l12.2 10.3L298.5 131 542.1 419.2l1.9 2.2v2.9V504v8h-8H288 40 32v-8V424.4v-2.9l1.9-2.2z'
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fast',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      'M16 256a240 240 0 1 1 480 0A240 240 0 1 1 16 256zm496 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM264 408V256v-8h-8H136h-8v16h8H248V408v8h16v-8z'
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fast',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      'M72 0H64V8 64H16 0V80 432v16H16 64l0 56v8h8l240 0h8v-8V448h48 16V432 80 64H368 320V8 0h-8H72zM320 432H304L80 432H64l-48 0V80H64 80 304h16 48V432H320zM80 496l0-48H304v48L80 496zM304 64H80V16H304V64zM184.3 177.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4C106.5 160 80 186.5 80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm-3.4 18.9L192 206.8l11.1-10.7 7.7-7.4c8.5-8.2 19.8-12.7 31.6-12.7h2.4c23.9 0 43.2 19.3 43.2 43.2c0 11.7-4.8 23-13.2 31.1L192 329.9l-82.8-79.6c-8.5-8.1-13.2-19.4-13.2-31.1c0-23.9 19.3-43.2 43.2-43.2h2.4c11.8 0 23.1 4.6 31.6 12.7l7.7 7.4z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fast',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5V504v8h8H394.8c-6.9-4.9-13.5-10.2-19.6-16H80V204.8L288 26.5l193.7 166c4.7-.4 9.5-.6 14.3-.6c3.3 0 6.7 .1 9.9 .3L293.2 9.9zm74 238.1H328V184v-8h-8H256h-8v8 64H184h-8v8 64 8h8 64v64 8h8 64 2.9c-1.4-7.8-2.4-15.8-2.7-24H312v8H264V320v-8h-8H192V264h64 8v-8V192h48v64 8h8 34c4.1-5.6 8.5-10.9 13.3-16zm.7 120a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fast',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      'M8 48L0 48 0 32l8 0 368 0 8 0 0 16-8 0L8 48zM128 320l-16 0-64 0-16 0 0-16 0-16L180.7 139.3 192 128l11.3 11.3L352 288l0 16 0 16-16 0-64 0-16 0 0 16 0 128 0 16-16 0-96 0-16 0 0-16 0-128 0-16zm0-16l16 0 0 16 0 144 96 0 0-144 0-16 16 0 80 0 0-9.4-144-144L48 294.6l0 9.4 80 0z'
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fast',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      'M192 480C96.4 480 16 386.9 16 288c0-53.4 15.4-118.6 45.8-169.8C92.1 66.9 135.7 32 192 32s99.9 34.9 130.2 86.2C352.6 169.4 368 234.6 368 288c0 98.9-80.4 192-176 192zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm80-8c0-25.4 5.2-56.3 15.5-85.4c10.4-29.2 25.8-56.2 45.9-74.5l-10.8-11.8c-22.6 20.6-39.2 50.2-50.1 80.9C69.5 220 64 252.6 64 280v8H80v-8z'
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fast',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm200 96a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144zM148.7 192l-42.3-42.3 11.3-11.3L160 180.7l42.3-42.3 11.3 11.3L171.3 192l42.3 42.3-11.3 11.3L160 203.3l-42.3 42.3-11.3-11.3L148.7 192zm192 0l-42.3-42.3 11.3-11.3L352 180.7l42.3-42.3 11.3 11.3L363.3 192l42.3 42.3-11.3 11.3L352 203.3l-42.3 42.3-11.3-11.3L340.7 192z'
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fast',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      'M254.7 67.2C248.8 38 222.9 16 192 16s-56.8 22-62.7 51.2L126.7 80H113.6 80v64H192 304V80H270.4 257.3l-2.6-12.8zM80 64h33.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H304h16V80 96h56 8v8V504v8h-8H8 0v-8V104 96H8 64V80 64H80zM64 112H16V496H368V112H320v32 16H304 192 80 64V144 112zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 208h64 8v8 64h64 8v8 64 8h-8H232v64 8h-8H160h-8v-8V360H88 80v-8V288v-8h8 64V216v-8h8zm8 80v8h-8H96v48h64 8v8 64h48V352v-8h8 64V296H224h-8v-8V224H168v64z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fast',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fast',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      'M216 472l0 8 16 0 0-8 0-432 0-8-16 0 0 8 0 432zM48 464l0-32-32 0 0 32 32 0zm384 0l0-32-32 0 0 32 32 0zM48 368l0-32-32 0 0 32 32 0zm384 0l0-32-32 0 0 32 32 0zM400 176l32 0 0-32-32 0 0 32zM48 176l0-32-32 0 0 32 32 0zm352 96l32 0 0-32-32 0 0 32zM48 272l0-32-32 0 0 32 32 0zM400 80l32 0 0-32-32 0 0 32zM16 80l32 0 0-32L16 48l0 32zM304 272l32 0 0-32-32 0 0 32zM336 80l0-32-32 0 0 32 32 0zM304 464l32 0 0-32-32 0 0 32zM144 80l0-32-32 0 0 32 32 0zM112 464l32 0 0-32-32 0 0 32zm32-192l0-32-32 0 0 32 32 0z'
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fast',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      'M16 80V432H624V80H16zM0 64H16 624h16V80 432v16H624 16 0V432 80 64zM200 192v56h56 8v16h-8H200v56 8H184v-8V264H128h-8V248h8 56V192v-8h16v8zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fast',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      'M0 0H8 64h6.2l1.6 6 69.4 266h341L557.6 32h16.8L495.6 282.4l-1.8 5.6H488 145.3l20.9 80H496h8v16h-8H160h-6.2l-1.6-6L57.8 16H8 0V0zM208 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM328 64v72h72 8v16h-8H328v72 8H312v-8V152H240h-8V136h8 72V64 56h16v8z'
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fast',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      'M432 48V464H16V48H432zm16-16H432 16 0V48 464v16H16 432h16V464 48 32zM273 124.1l-40 72-3.3 5.9 5.3 4.2 36.6 29.3c-16.3 28.3-39.8 51.8-68.1 68.1L174.3 267l-4.2-5.3-5.9 3.3-72 40-5.2 2.9 1.3 5.8 16 72 1.4 6.3H112h16c128.1 0 232-103.9 232-232v0l0-16 0-6.4-6.3-1.4-72-16-5.8-1.3-2.9 5.2zM344 160c0 119.3-96.7 216-216 216h-9.6l-13.3-59.9L166 282.3l29.3 36.6 4.1 5.2 5.8-3.1c35.6-18.8 64.9-48.1 83.7-83.7l3.1-5.8-5.2-4.1L250.3 198l33.8-60.9L344 150.4l0 9.6 8 0-8 0z'
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fast',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      'M59.5 120H16.5C21.8 79.1 66.8 16 168 16c77.7 0 122.4 37.2 141.2 73.1l3.8 7.2 7.1-3.9C342.6 80.2 371.7 72 408 72c101.2 0 146.2 63.1 151.5 104H492.5l-21.7-36.1L464 128.5l-6.9 11.4L435.5 176H328 265.1h-3.4l-2.4 2.4L102.1 338.9C77.9 307 64.6 235.4 127.6 171.1c16.7-17 33.8-28.5 50.5-35.8L174.9 120H116.5L94.9 83.9 88 72.5 81.1 83.9 59.5 120zM168 0C52.1 0 0 78.1 0 128v8H8 64h4.5l2.3-3.9L88 103.5l17.1 28.6 2.3 3.9H112h32.4c-9.5 6.6-19 14.5-28.2 23.9C42.6 235.1 62.7 322.3 96 356.3l5.7 5.8 5.7-5.8L240.2 220.9c2.8 13 4.9 28.5 5.8 46.7c2.6 54.6-5.9 132.3-37.6 234L205.1 512H216 352h7.1l.9-7c8.1-65.1 2-138-12.1-204.7c-8.3-39-19.3-76.1-32-108.3H328 440h4.5l2.3-3.9L464 159.5l17.1 28.6 2.3 3.9H488h80 8v-8c0-49.9-52.1-128-168-128c-35.3 0-64.7 7.2-88.5 18.7C296 36 246.8 0 168 0zM298.5 192c13.3 32.5 25 70.9 33.6 111.7c13.4 63 19.3 131.2 12.7 192.3H226.8c29.6-98.1 37.8-174.2 35.2-229.2c-1.1-23.6-4.3-43.4-8.6-59.4L268.5 192h30.1z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fast',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M32 64v64H96V64H32zM16 48H32 96h16V64v64 16H96 32 16V128 64 48zM176 88H496h8v16h-8H176h-8V88h8zm0 160H496h8v16h-8H176h-8V248h8zm0 160H496h8v16h-8H176h-8V408h8zM96 224H32v64H96V224zM32 208H96h16v16 64 16H96 32 16V288 224 208H32zm0 176v64H96V384H32zM16 368H32 96h16v16 64 16H96 32 16V448 384 368z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fast',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      'M112 120v80H16V120h96zm0-16H16V48h96v56zm0-72H16 0V48v56 8 8 80 8 8 80 8 8 80 8 8 56 16H16h96 8 8H384h8 8 96 16V464 408v-8-8V312v-8-8V216v-8-8V120v-8-8V48 32H496 400h-8-8H128h-8-8zm16 16H384v64 96 96 96 64H128V400 304 208 112 48zm272 0h96v56H400V48zm96 72v80H400V120h96zm0 96v80H400V216h96zm0 96v80H400V312h96zm0 96v56H400V408h96zM112 464H16V408h96v56zM16 392V312h96v80H16zm0-96V216h96v80H16z'
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fast',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      'M440 48V96h24 16v16 32 16H464 440v40H560V48H440zM400 160H384V144 112 96h16 24V48H280V96h24 16v16 32 16H304 280v40H424V160H400zM264 96V48H152V96h24 16v16 32 16H176 152v40H264V160H240 224V144 112 96h16 24zM112 160H96V144 112 96h16 24V48H16V200H136V160H112zM144 32H272 432 560h16V48 208 464v16H560 432 272 144 16 0V464 208 48 32H16 144zM16 216V464H136V416H112 96V400 368 352h16 24V320H112 96V304 272 256h16 24V216H16zM152 464H264V416H240 224V400 368 352h16 24V320H240 224V304 272 256h16 24V216H152v40h24 16v16 32 16H176 152v32h24 16v16 32 16H176 152v48zm128-48v48H424V416H400 384V400 368 352h16 24V216H280v40h24 16v16 32 16H304 280v32h24 16v16 32 16H304 280zm160-64h24 16v16 32 16H464 440v48H560V216H440V352zM112 112v32h64V112H112zm0 192h64V272H112v32zm0 64v32h64V368H112zM240 144h64V112H240v32zm0 128v32h64V272H240zm0 128h64V368H240v32zM400 112v32h64V112H400zm0 288h64V368H400v32z'
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fast',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      'M328.3 330.7L496.9 4.3l14.2 7.3-256.3 496-2.2 4.3h-4.9H8 0v-8V338.7v-8H8 328.3zm-8.3 16H112V496H242.9L320 346.7zm-304 0V496H96V346.7H16zm615.1-16h8v8V504v8h-8H391.4h-4.9l-2.2-4.3L342.1 426l9-17.4L396.2 496H527.1V346.7H383l8.3-16H631.1zm-340.9-40h-18L128 11.7l14.2-7.3L290.2 290.7zm252.9 56V496h80V346.7h-80z'
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fast',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 64h16c44.2 0 80 35.8 80 80v8 8h-8H176h-8v-8-8c0-44.2 35.8-80 80-80zm-64 80H328c0-35.3-28.7-64-64-64H248c-35.3 0-64 28.7-64 64zM160.4 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM200.5 111.5l-8 .5c-32.5 2-61.6 16.5-82.7 38.7l-5.5 5.8-11.6-11 5.5-5.8c23.7-25.1 56.6-41.4 93.3-43.7l8-.5 1 16zm119 .5l-8-.5 1-16 8 .5c36.7 2.3 69.6 18.6 93.3 43.7l5.5 5.8-11.6 11-5.5-5.8C381.1 128.5 352 114 319.5 112z'
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fast',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      'M67.9 428.2l8.1 9.3 45.4 51.9L181.4 436l10.6-9.4 10.6 9.4 59.9 53.3L308 437.5l8.1-9.3 11.1 5.5L368 454.1V192c0-97.2-78.8-176-176-176S16 94.8 16 192V454.1l40.8-20.4 11.1-5.5zM16 472L0 480V462.1 192C0 86 86 0 192 0S384 86 384 192V462.1 480l-16-8-48-24-45.5 52L264 512l-12-10.6L192 448l-60 53.4L120 512l-10.5-12L64 448 16 472zM128 168a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm64 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z'
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fast',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      'M0 32H8 72h64 8V48h-8H80V240H368V48H312h-8V32h8 64 64 8V48h-8H384V248 464h56 8v16h-8H376 312h-8V464h8 56V256H80V464h56 8v16h-8H72 8 0V464H8 64V248 48H8 0V32z'
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fast',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      'M256 16C123.5 16 16 123.5 16 256V504v8H0v-8V256C0 114.6 114.6 0 256 0S512 114.6 512 256V504v8H496v-8V256C496 123.5 388.5 16 256 16zM108.7 512l0 0 5.7-5.7L172.7 448H128 112V432 144 128h16H384h16v16V432v16H384 339.3l58.3 58.3 5.7 5.7H380.7l-64-64H195.3l-64 64H108.7zM128 432H384V144H128V432zm48-240H336h16v16 96 16H336 176 160V304 208 192h16zm96 184a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64-168H176v96H336V208zM224 376a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fast',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM487.5 480l-20.3-16H112V183.5L96 170.9V464v16h16H487.5zM152.5 32l20.3 16H528V328.5l16 12.6V48 32H528 152.5zM240 284.6V288v16 72 8h16v-8V352 304v-6.8l-16-12.6zm192-31.9c5.1-11.2 8-23.6 8-36.7c0-48.6-39.4-88-88-88H274.1l20.3 16 57.7 0c39.8 0 72 32.2 72 72c0 9.3-1.8 18.2-5 26.4l13 10.3z'
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fast',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      'M56 32H48v8V176H0v16H48V312 472v8H64v-8V320H192c74.1 0 135.2-56 143.1-128H384V176H336c0-79.5-64.5-144-144-144H56zM320 176H64V48H192c70.7 0 128 57.3 128 128zM64 192H319c-7.9 63.1-61.7 112-127 112H64V192z'
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fast',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      'M496 80v96H16V80H496zM16 64H0V80v96 16H16 496h16V176 80 64H496 16zM0 320v8V440v8H8 504h8v-8V328v-8h-8H392h-2.4l-2 1.3-67.6 45-67.6-45-2-1.3H248 8 0zm16 16H245.6l70 46.7 4.4 3 4.4-3 70-46.7H496v96H16V336zM130.8 224.5l-3-1.1-3 1.3-112 48-7.4 3.2 6.3 14.7 7.4-3.2 109-46.7 125 46.9 2.8 1.1 2.8-1.1 125-46.9 109 46.7 7.4 3.2 6.3-14.7-7.4-3.2-112-48-3-1.3-3 1.1L256 271.5 130.8 224.5z'
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fast',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      'M80 386.9l232 46.4V50.3L80 18.4V386.9zm248 46.4l232-46.4V18.4L328 50.3v383zM320 35.2l240-33L576 0V16.2 400L320 451.2 64 400V16.2 0L80 2.2l240 33zM16 31l16 2.2V49.4L16 47.2V431.7l304 60.8 304-60.8V47.2l-16 2.2V33.2L624 31l16-2.2V45 444.8l-320 64L0 444.8V45 28.8L16 31z'
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fast',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      'M80 16V192H432V70.6L377.4 16H80zM448 192h48 16v16V368v16H496 16 0V368 208 192H16 64V16 0H80 384l64 64V192zM16 208V368H496V208H16zM56 416H72v88 8H56v-8V416zm96 0h16v88 8H152v-8V416zm96 0h16v88 8H248v-8V416zm96 0h16v88 8H344v-8V416zm96 0h16v88 8H440v-8V416zm8-128H416V256h32v32z'
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fast',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM325.7 197.7l-128 128-5.7 5.7-5.7-5.7-64-64-5.7-5.7L128 244.7l5.7 5.7L192 308.7 314.3 186.3l5.7-5.7L331.3 192l-5.7 5.7z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fast',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      'M432 496H16V224C16 109.1 109.1 16 224 16s208 93.1 208 208V496zM224 0C100.3 0 0 100.3 0 224V496v16H16 432h16V496 224C448 100.3 347.7 0 224 0zM56 144v8 56c0 48.6 39.4 88 88 88h27.1l-8 16H152c-39.8 0-72 32.2-72 72s32.2 72 72 72h72 72c39.8 0 72-32.2 72-72s-32.2-72-72-72H284.9l-8-16h30.2c50.6 0 90.8-42.6 87.8-93.2l-3-51.3-.4-7.5H384 290.3c-24.1 0-46.6 12-59.9 32.1l-6.3 9.5-6.3-9.5c-13.4-20-35.8-32.1-59.9-32.1H64 56zm16 16h85.7c18.7 0 36.2 9.4 46.6 24.9l13 19.5 6.7 10 6.7-10 13-19.5C254 169.4 271.5 160 290.3 160h86.2l2.6 43.8c2.4 41.4-30.4 76.2-71.9 76.2H264 251.1l5.8 11.6 16 32 2.2 4.4H280h16c30.9 0 56 25.1 56 56s-25.1 56-56 56H224 152c-30.9 0-56-25.1-56-56s25.1-56 56-56h16 4.9l2.2-4.4 16-32 5.8-11.6H184 144c-39.8 0-72-32.2-72-72V160zm120 80H152c-22.1 0-40-17.9-40-40h40c22.1 0 40 17.9 40 40zm0 16c8.8 0 16-7.2 16-16c0-30.9-25.1-56-56-56H112c-8.8 0-16 7.2-16 16c0 30.9 25.1 56 56 56h40zm104-16H256c0-22.1 17.9-40 40-40h40c0 22.1-17.9 40-40 40zm0 16c30.9 0 56-25.1 56-56c0-8.8-7.2-16-16-16H296c-30.9 0-56 25.1-56 56c0 8.8 7.2 16 16 16h40zM136 384c0-8.8 7.2-16 16-16H296c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16zm-16 0c0 17.7 14.3 32 32 32H296c17.7 0 32-14.3 32-32s-14.3-32-32-32H152c-17.7 0-32 14.3-32 32z'
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fast',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M71.9 376.4l3.6-9.6-7.3-7.3C35.2 326.3 16 284.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L42.3 455.4l29.6-79zM16 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L23.1 461.2 16 480zM136 184h-8v16h8H376h8V184h-8H136zm0 96h-8v16h8H280h8V280h-8H136z'
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fast',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      'M624 112c0-53-43-96-96-96c-52.7 0-95.5 42.5-96 95.1v.9l0 0c0 53 43 96 96 96s96-43 96-96zM417.1 96C424.9 41.7 471.6 0 528 0c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112l-144 0v72 8H256v-8V112l-80 0 0 72 0 8-16 0 0-8 0-80 0-8 8 0 249.1 0zM16 400c0 53 43 96 96 96c52.7 0 95.5-42.5 96-95.1V400l0 0c0-53-43-96-96-96s-96 43-96 96zm206.9 16c-7.8 54.3-54.4 96-110.9 96C50.1 512 0 461.9 0 400s50.1-112 112-112s112 50.1 112 112l144 0V328v-8h16v8 72l80 0 0-72 0-8 16 0 0 8 0 80 0 8h-8l-249.1 0z'
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fast',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M200 32v8V241.2L371.6 129.3l8.7 13.4L206.6 256 380.4 369.3l-8.7 13.4L200 270.8V472v8H184v-8V270.8L12.4 382.7 3.6 369.3 177.4 256 3.6 142.7l8.7-13.4L184 241.2V40 32h16z'
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fast',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      'M280 40a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM384.5 181l6.1 5.2 12.2 10.3 10.3-12.2 10.3-12.2 10.3-12.2-12.2-10.3-6.1-5.2L365 101.7 358.3 96h-8.8H320 290.5h-8.8l-6.7 5.7-50.5 42.7-6.1 5.2-12.2 10.3 10.3 12.2 10.3 12.2 10.3 12.2 12.2-10.3 6.1-5.2 1.8-1.5 8.4-7.1 3.4-2.9 4.3-3.7 1.1 4.4-2.2 17.5L264.2 253l-1 7.9-2 15.9 15.9 2 15.9 2 15.9 2 2-15.9 1-7.9 .1-1 4.1-33 .1-1h7.6l.1 1 4.1 33 .1 1 1 7.9 2 15.9 15.9-2 15.9-2 15.9-2-2-15.9-1-7.9-8.2-65.3-2.2-17.5 1.1-4.4 4.4 3.7 3.4 2.9 8.4 7.1 1.8 1.5zm-24.6 74l1 7.9-15.9 2-1-7.9-4.4-35-1.8-14H323.8h-7.6H302.1l-1.8 14-4.4 35-1 7.9-15.9-2 1-7.9 10.4-82.9 .4-3-.7-2.9-1.1-4.4L282.7 137l-19.6 16.6-18 15.2-6.1 5.2-10.3-12.2 6.1-5.2 50.5-42.7 2.2-1.9h2.9 59.1 2.9l2.2 1.9 50.5 42.7 6.1 5.2-10.3 12.2-6.1-5.2-18-15.2L357.3 137 351 161.9l-1.1 4.4-.7 2.9 .4 3L359.9 255zM296 40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 72c0-4.4-3.6-8-8-8H8c-4.4 0-8 3.6-8 8V384c0 2.1 .8 4.2 2.3 5.7l120 120 11.3-11.3L16 380.7V80H80V288c0 2.1 .8 4.2 2.3 5.7l10.8 10.8 5.2 5.2 80 80 8 8 5.7 5.7L203.3 392l-5.7-5.7-8-8-74.8-74.8 37.6-43.8L288 395.3V504v8h16v-8V392v-3.3l-2.3-2.3-144-144-6.1-6.1-5.6 6.6-42.4 49.4L96 284.7V72zm456-8c-4.4 0-8 3.6-8 8V284.7l-7.5 7.5-42.4-49.4-5.6-6.6-6.1 6.1-144 144-2.3 2.3V392 504v8h16v-8V395.3L487.5 259.8l37.6 43.8-74.8 74.8-8 8-5.7 5.7L448 403.3l5.7-5.7 8-8 80-80 5.2-5.2 10.8-10.8c1.5-1.5 2.3-3.5 2.3-5.7V80h64V380.7L506.3 498.3l11.3 11.3 120-120c1.5-1.5 2.3-3.5 2.3-5.7V72c0-4.4-3.6-8-8-8H552z'
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fast',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      'M48 128c0 54.1 28.9 98.3 59.5 129.9c15.2 15.7 30.4 27.8 41.9 36c4.1 3 7.7 5.4 10.7 7.3c2.9-1.9 6.5-4.3 10.7-7.3c11.4-8.2 26.7-20.4 41.9-36C243.1 226.3 272 182.1 272 128c0-61.9-50.1-112-112-112S48 66.1 48 128zm88.1 176C99 276.5 32 214.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 86.8-67 148.5-104.1 176H312h8v16h-8H168V504v8H152v-8V320H8 0V304H8 136.1z'
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fast',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      'M365.7 61.7l48-48L402.3 2.3l-48 48L348.7 56 360 67.3l5.7-5.7zm96 96l48-48L498.3 98.3l-48 48-5.7 5.7L456 163.3l5.7-5.7zm40-136l5.7-5.7L496 4.7l-5.7 5.7L336.9 163.8c5.7-38.7-6.4-79.4-36.1-109.1L289.5 43.3 278.2 32 266.8 43.3 255.5 54.6c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1l-11.3-11.3-11.3-11.3L165 145.1l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4-47.8 47.8c5.7-38.7-6.4-79.4-36.1-109.1L85.8 247 74.5 235.6 63.2 247 51.9 258.3c-37.5 37.5-37.5 98.3 0 135.8l27.4 27.4L5.5 495.1l-5.7 5.7 11.3 11.3 5.7-5.7 73.7-73.7 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3 11.3-11.3L266.8 428l-11.3-11.3C224.7 385.8 182 374 142.1 381.2l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3L380 337.5l-11.3-11.3-11.3-11.3c-30.9-30.9-73.5-42.7-113.5-35.4l50.3-50.3 29.2 29.2c37.5 37.5 98.3 37.5 135.8 0L470.5 247l11.3-11.3-11.3-11.3L459.2 213c-30.9-30.9-73.5-42.7-113.5-35.4L501.7 21.7zM289.5 65.9c32.5 32.5 40.9 80 25 120.2l-20.3 20.3-27.4-27.4c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zM187.6 167.8c32.5 32.5 40.9 80 25 120.2l-20.3 20.3L165 280.9c-31.2-31.2-31.2-81.9 0-113.1l11.3-11.3 11.3 11.3zM85.8 269.6c32.5 32.5 40.9 80 25 120.2L90.6 410.1 63.2 382.7C32 351.5 32 300.8 63.2 269.6l11.3-11.3 11.3 11.3zm219.7-51.8L321.3 202c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L447.9 247c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM203.7 319.6l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3L346 348.8c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2zM101.9 421.4l15.8-15.8c41.5-19.3 92.3-11.9 126.5 22.3l11.3 11.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0l-29.2-29.2z'
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fast',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M160 32v8V184v8h-8H8 0V176H8 144V40 32h16zm144 0v8V176H440h8v16h-8H296h-8v-8V40 32h16zM0 320H8 152h8v8V472v8H144v-8V336H8 0V320zm288 0h8H440h8v16h-8H304V472v8H288v-8V328v-8z'
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fast',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 128v8V376v8h16v-8V157.4L354 381.2l2.4 2.8H368v-8V136v-8H352v8V354.6L158 130.8l-2.4-2.8H144z'
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fast',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm208 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 304a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM208 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fast',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      'M106.6 119.8l-79 13.2 46.1 65.9 6.4 9.2-6.4 9.2L27.7 283.1l79 13.2 11.3 1.9 1.9 11.3 13.2 79L160 369.4v19.5l-24.1 16.9L121.3 416l-2.9-17.5L104 312 17.5 297.6 0 294.7l10.2-14.5L60.7 208 10.2 135.9 0 121.3l17.5-2.9L104 104l14.4-86.5L121.3 0l14.5 10.2L208 60.7l72.1-50.5L294.7 0l2.9 17.5L307.8 79c-5.1 2.7-10 5.8-14.7 9.2L283.1 27.7 217.2 73.8 208 80.2l-9.2-6.4L132.9 27.7l-13.2 79-1.9 11.3-11.3 1.9zM208 112c18.4 0 35.6 5.2 50.2 14.1c-2.7 4.6-5.2 9.3-7.4 14.3C238.4 132.5 223.7 128 208 128c-44.2 0-80 35.8-80 80c0 26.6 13 50.1 32.9 64.7c-.6 5-.9 10.1-.9 15.3v3.2c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96zm86.5 303.9h.2l0 .1-.1-.1zM368 96c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.8 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4l0 64 0 16h-16l-64 0H288 208 192v-16-80c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zM623.9 303.9c0-31.5-22.7-57.6-52.6-63L554.8 238l3.6-16.3c1-4.4 1.5-9 1.5-13.8c0-35.3-28.6-64-64-64c-13.6 0-26.2 4.3-36.6 11.5l-14 9.8-8.8-14.6C422.4 127.5 397 112 368 112c-44.2 0-79.9 35.8-80 79.9l0 1.3 .1 13.6-13.4 2.3c-37.8 6.3-66.6 39.3-66.6 78.9v80h80H559.9l64 0v-64zM288 416l-64 96H200l64-96h24zm72 0h24l-64 96H296l64-96zm120 0l-64 96H392l64-96h24zm72 0h24l-64 96H488l64-96z'
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fast',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      'M282.1 378.1L8 104 1.2 16.1 0 0 16.1 1.2 104 8 256.1 160.1l11.3 11.3 73.4 73.4 11.3 11.3 26 26-11.3 11.3L96.9 23.5 17.4 17.4l6.1 79.5L293.4 366.7l-11.3 11.3zM440 276.7l5.7 5.7 32 32 3.9 3.9-2.2 5-29.8 67 56.9 56.9 5.7 5.7-5.7 5.7-48 48-5.7 5.7-5.7-5.7-56.9-56.9-67 29.8-5 2.2-3.9-3.9-32-32-5.7-5.7 5.7-5.7 152-152 5.7-5.7zm22.5 45.1L440 299.3 299.3 440l22.5 22.5 67-29.8 5-2.2 3.9 3.9 55.1 55.1 36.7-36.7-55.1-55.1-3.9-3.9 2.2-5 29.8-67zM105.8 310.3l31.7-31.7L148.7 290l-31.7 31.7L190.5 395l31.7-31.7 11.3 11.3-31.7 31.7 28 28 5.7 5.7-5.7 5.7-32 32-3.9 3.9-5-2.2-67-29.8L65 506.5l-5.7 5.7-5.7-5.7-48-48L0 452.8l5.7-5.7 56.9-56.9-29.8-67-2.2-5 3.9-3.9 32-32 5.7-5.7 5.7 5.7 28 28zM504.1 104L374.7 233.4l-11.3-11.3L488.6 96.9l6.1-79.5-79.5 6.1L290 148.7l-11.3-11.3L408.1 8 496 1.2 512.1 0l-1.2 16.1L504.1 104zM49.7 321.8l29.8 67 2.2 5-3.9 3.9L22.6 452.8l36.7 36.7 55.1-55.1 3.9-3.9 5 2.2 67 29.8L212.8 440 72.1 299.3 49.7 321.8z'
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fast',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM409.4 418.3C382 427.1 351.8 432 320 432c-30 0-58.6-4.4-85-12.4l-4.6-1.4-4.6 1.4L106.3 455.4l29.6-79 3.6-9.6-7.3-7.3C99.2 326.3 80 284.7 80 240c0-24.1 5.7-47.4 16.1-69L83.2 160.8C70.8 185.2 64 212 64 240c0 49.6 21.3 95.1 56.9 130.8L87.1 461.2 80 480l19.3-5.8 131.1-39.3c27.9 8.5 58.1 13.1 89.6 13.1c37.1 0 72.4-6.4 104.2-18l-14.9-11.7zM320 32c-47.7 0-92.4 10.6-130.7 29.1l14 11C237.6 56.8 277.2 48 320 48c135.8 0 240 88.9 240 192c0 32.5-10.4 63.6-28.8 91l12.7 10c20.5-29.9 32.1-64.3 32.1-101C576 125.1 461.4 32 320 32z'
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fast',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      'M17.5 176L74.4 48H188.6L161.7 176H144 17.5zM144 192h16v96 16h16 96 16V288 192h16H432V464H16V192H144zm32 0h96v96H176V192zm110.3-16L259.4 48H373.6l56.9 128H304 286.3zM270 176H178L205 48h3 8 16 8 3L270 176zM256 32H192 64L0 176V464v16H16 432h16V464 176L384 32H256z'
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fast',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      'M112 48V408H464V48H112zm368 0V408h32 8v16h-8H480 464 112 96 64 56V408h8H96V48 32h16H464h16V48zM16 352H64v16H16v96H560V368H512V352h48 16v16 96 16H560 16 0V464 368 352H16zM217.8 142.5l5.7 5.7L288 212.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L299.3 224l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L288 235.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L276.7 224l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fast',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      'M138.6 340l-4.5-4H128 16V176H128h6.1l4.5-4L278.1 48H304V464H278.1L138.6 340zM0 352H16 128L272 480h32 16V464 48 32H304 272L128 160H16 0v16V336v16zm409.6-19.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8L400 192c19.4 14.6 32 37.8 32 64s-12.6 49.4-32 64l9.6 12.8z'
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fast',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      'M339.2 161.4l5.7-5.7 11.3 11.3-5.7 5.7L299.3 224h181c10.2-19.6 15.7-41.5 15.7-64c0-36.7-14.6-72-40.6-97.9l-5.5-5.5C424 30.6 388.7 16 352 16s-72 14.6-97.9 40.6L80 230.6l0 190.1L339.2 161.4zM283.3 240l-80 80H393.4l62.1-62.1c5.6-5.6 10.6-11.6 15.1-17.9H283.3zM400 336L288 448H75.3L17.2 506.1l-5.7 5.7L.2 500.5l5.7-5.7L64 436.7V224L242.7 45.3C271.7 16.3 311 0 352 0s80.3 16.3 109.3 45.3l5.5 5.5C495.7 79.7 512 119 512 160s-16.3 80.3-45.3 109.3L400 336zm-22.6 0H187.3l-96 96H281.4l96-96z'
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fast',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM260.7 176l5.7 5.7L340.7 256l-74.3 74.3-5.7 5.7L272 347.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80-5.7-5.7L260.7 176zm-79 5.7l5.7-5.7L176 164.7l-5.7 5.7-80 80L84.7 256l5.7 5.7 80 80 5.7 5.7L187.3 336l-5.7-5.7L107.3 256l74.3-74.3z'
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fast',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      'M16 16V400H231.8h.3H343.9h.3H560V16H16zM222.6 416H16 0V400 16 0H16 560h16V16 400v16H560 353.4l13.3 80H440h8v16h-8H360 216 136h-8V496h8 73.2l13.3-80zm16.2 0l-13.3 80H350.6l-13.3-80H238.8zM496 80H80V336H496V80zM80 64H496h16V80 336v16H496 80 64V336 80 64H80zm272 64h88 8v8 88 8H432v-8V155.3L325.7 261.7l-5.7 5.7-5.7-5.7L240 187.3 133.7 293.7l-5.7 5.7L116.7 288l5.7-5.7 112-112 5.7-5.7 5.7 5.7L320 244.7 420.7 144H352h-8V128h8z'
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fast',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      'M16 48H48V80H16V48zM0 32V48 80 96H16 48 64V80 48 32H48 16 0zm264 8V32H248v8V284.3L34.8 465.9l-6.1 5.2 10.4 12.2 6.1-5.2L256 298.5 466.8 478.1l6.1 5.2 10.4-12.2-6.1-5.2L264 284.3V40zM48 240v32H16V240H48zM16 224H0v16 32 16H16 48 64V272 240 224H48 16zm96-80h32v32H112V144zM96 128v16 32 16h16 32 16V176 144 128H144 112 96zM400 48V80H368V48h32zM368 32H352V48 80 96h16 32 16V80 48 32H400 368zm96 112h32v32H464V144zm-16-16v16 32 16h16 32 16V176 144 128H496 464 448zM400 240v32H368V240h32zm-32-16H352v16 32 16h16 32 16V272 240 224H400 368zM240 432h32v32H240V432zm-16-16v16 32 16h16 32 16V464 432 416H272 240 224z'
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fast',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      'M320 80c8.8 0 16-7.2 16-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C309.8 40.1 304 52.8 304 64c0 8.8 7.2 16 16 16zM309.6 12.2C315.3 4.7 320 0 320 0s4.7 4.7 10.4 12.2C339.8 24.4 352 44.2 352 64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-19.8 12.2-39.6 21.6-51.8zM224 112c8.8 0 16-7.2 16-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C213.8 72.1 208 84.8 208 96c0 8.8 7.2 16 16 16zM213.6 44.2C219.3 36.7 224 32 224 32s4.7 4.7 10.4 12.2C243.8 56.4 256 76.2 256 96c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32S0 113.7 0 96C0 76.2 12.2 56.4 21.6 44.2C27.3 36.7 32 32 32 32s4.7 4.7 10.4 12.2C51.8 56.4 64 76.2 64 96c0-19.8 12.2-39.6 21.6-51.8C91.3 36.7 96 32 96 32s4.7 4.7 10.4 12.2C115.8 56.4 128 76.2 128 96c0-19.8 12.2-39.6 21.6-51.8C155.3 36.7 160 32 160 32s4.7 4.7 10.4 12.2C179.8 56.4 192 76.2 192 96c0-19.8 12.2-39.6 21.6-51.8zM176 96c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C149.8 72.1 144 84.8 144 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM96 112c8.8 0 16-7.2 16-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C85.8 72.1 80 84.8 80 96c0 8.8 7.2 16 16 16zM48 96c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C21.8 72.1 16 84.8 16 96c0 8.8 7.2 16 16 16s16-7.2 16-16zm368 16c8.8 0 16-7.2 16-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C405.8 72.1 400 84.8 400 96c0 8.8 7.2 16 16 16zM405.6 44.2C411.3 36.7 416 32 416 32s4.7 4.7 10.4 12.2C435.8 56.4 448 76.2 448 96c0-19.8 12.2-39.6 21.6-51.8C475.3 36.7 480 32 480 32s4.7 4.7 10.4 12.2C499.8 56.4 512 76.2 512 96c0-19.8 12.2-39.6 21.6-51.8C539.3 36.7 544 32 544 32s4.7 4.7 10.4 12.2C563.8 56.4 576 76.2 576 96c0-19.8 12.2-39.6 21.6-51.8C603.3 36.7 608 32 608 32s4.7 4.7 10.4 12.2C627.8 56.4 640 76.2 640 96c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-19.8 12.2-39.6 21.6-51.8zM496 96c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C469.8 72.1 464 84.8 464 96c0 8.8 7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C533.8 72.1 528 84.8 528 96c0 8.8 7.2 16 16 16zm80-16c0-11.2-5.8-23.9-13.3-35.1c-.9-1.3-1.8-2.6-2.7-3.9c-.9 1.2-1.8 2.5-2.7 3.9C597.8 72.1 592 84.8 592 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM328 128v8l0 232h80V168v-8h16v8V368h48V168v-8h16v8V368h48V168v-8h16v8V367.4c27.1-3.9 48-27.2 48-55.4l0-144v-8h16v8l0 144c0 39.8-32.2 72-72 72H328V496H504h8v16h-8H320 136h-8V496h8H312V384H96c-39.8 0-72-32.2-72-72l0-144 0-8H40v8l0 144c0 28.2 20.9 51.6 48 55.4V168v-8h16v8V368h48V168v-8h16v8V368h48V168v-8h16v8V368h80l0-232v-8h16z'
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fast',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      'M195.6 8.8L256 39.1 316.4 8.8l7.2-3.6 3.6 7.2 49.1 98.1c36.1-11.1 68.2-27 94.5-46.5L488 81.3C460.8 163.5 367.2 224 256 224S51.2 163.5 24 81.3L41.3 64c27 20.1 60.3 36.4 97.8 47.5l45.6-98.9 3.5-7.5 7.4 3.7zM360.5 115L316.4 26.7 259.6 55.2 256 56.9l-3.6-1.8L195.8 26.8l-41.1 89C186.2 123.7 220.4 128 256 128c36.9 0 72.1-4.6 104.5-13zM468.9 84.8C413.7 121.7 338.4 144 256 144s-157.7-22.3-212.9-59.2l-.6 .6C70.9 155 154.2 208 256 208s185.1-53 213.5-122.6l-.6-.6zM424 211c4.6-2.8 9.1-5.6 13.5-8.6C454.4 232.4 464 267.1 464 304c0 114.9-93.1 208-208 208S48 418.9 48 304c0-36.9 9.6-71.6 26.5-101.7c4.4 3 8.9 5.9 13.5 8.6c-15.3 27.6-24 59.3-24 93c0 106 86 192 192 192s192-86 192-192c0-33.8-8.7-65.5-24-93zM176 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256.2 379.8c-41.3 0-80.6-6.5-115.9-18.3c20.6 52 65.6 86.5 115.9 86.5s95.3-34.6 115.9-86.5c-35.3 11.8-74.6 18.3-115.9 18.3zm0-16c44.2 0 85.8-7.8 122.1-21.5c6.2-2.3 12.2-4.8 18.1-7.5c-1.3 6.7-2.9 13.2-4.9 19.5C371.8 418.2 318.7 464 256.2 464s-115.6-45.8-135.3-109.7c-2-6.3-3.6-12.8-4.9-19.5c5.9 2.7 11.9 5.2 18.1 7.5c36.4 13.7 78 21.5 122.1 21.5z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fast',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M16 8V0H0V8 64 383.5 400 504v8H16v-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V33.9 16l-16 8L393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 68.5L136.8 46.3c34.4-8.6 70.7-4.6 102.4 11.2c50.8 25.4 110.6 25.4 161.5 0L432 41.9v315l-45.1 16.9c-42.1 15.8-88.8 13.3-129-6.8c-41.3-20.7-88.7-25.9-133.5-14.7L16 379.5V76.5z'
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fast',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      'M8 32L0 32 0 48l8 0 368 0 8 0 0-16-8 0L8 32zm189.7 98.3l-5.7-5.7-5.7 5.7-136 136L44.7 272 56 283.3l5.7-5.7L184 155.3 184 472l0 8 16 0 0-8 0-316.7L322.3 277.7l5.7 5.7L339.3 272l-5.7-5.7-136-136z'
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fast',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      'M16 140.3C16 71.6 71.6 16 140.3 16s124.3 55.6 124.3 124.3v33.1 8h16v-8V140.3C280.5 62.8 217.7 0 140.3 0S0 62.8 0 140.3s62.8 140.3 140.3 140.3h11.8l13.1 23.7c-20.4 22.1-32.9 51.6-32.9 84V504v8h8H361.2 472h8V496h-8H413.1c24.2-16.6 40.1-44.4 40.1-76c0-26.9-11.6-51.2-30-68h.8V248h32 3.3l2.3-2.3 48-48 2.3-2.3V192 153.4v-3.9l-3.1-2.4-64-49.4L442.7 96H440 416V72 64h-8-8c-13.1 0-24.7 6.3-32 16c-7.3-9.7-18.9-16-32-16h-8-8v8V88v8 8 44.2c0 35.7-6.4 59.1-18.1 80.1c-10.6 18.9-25.5 36.1-45.3 58.9l0 0c-2.8 3.2-5.7 6.5-8.7 10l-11.2 13C218 331.8 208 363.9 208 392v8h16v-8c0-24.9 9-53.1 24.7-71.3l11.2-13c3-3.4 5.8-6.7 8.7-10c19.6-22.6 35.8-41.2 47.2-61.6c13.3-23.9 20.2-50 20.2-87.9V104 96 88 80c13.3 0 24 10.7 24 24h16c0-13.3 10.7-24 24-24v24 8h8 29.3L496 157.3v31.4L452.7 232H416h-8v8V340.8c-13.7-8.1-29.7-12.8-46.8-12.8c-9.6 0-18.9 1.5-27.6 4.2l-7.6 2.4 4.8 15.3 7.6-2.4c7.2-2.3 14.8-3.5 22.8-3.5c42 0 76 34 76 76s-34 76-76 76H148.3V388.3c0-30.1 12.4-57.4 32.3-77l4.3-4.3-2.9-5.3-18.2-33.1-2.3-4.1h-4.7H140.3C71.6 264.5 16 208.9 16 140.3zM432 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fast',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      'M340.7 52.8L352 64.2l11.3-11.3L384 32.2c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192l52.7 52.7zM416 262.6c0 18.2-5.8 35.1-15.7 49.2C438.7 285.9 464 242 464 192.2c0-20.2-14.9-79.7-79.2-138.1L363.3 75.5 352 86.8 340.7 75.5 286 20.7c-19.3 13.6-44.2 35.1-65.4 61.8C195 114.5 176 152.4 176 192.2c0 49.8 25.3 93.7 63.7 119.6c-9.9-14.1-15.7-31-15.7-49.2c0-70.4 96-134.4 96-134.4s96 64 96 134.4zm-96 73.6c45.2 0 80-34 80-73.6c0-28.5-20-58.2-43.5-82.5c-11.4-11.8-22.8-21.5-31.4-28.3c-1.8-1.5-3.5-2.8-5.1-3.9c-1.5 1.2-3.2 2.5-5.1 3.9c-8.6 6.8-20 16.5-31.4 28.3C260 204.4 240 234 240 262.6c0 39.6 34.8 73.6 80 73.6zM32 256h8H88h8v16H88 48V384H592V272H552h-8V256h8 48 8v8V384h16 16v16 96 16H624 16 0V496 400 384H16 32V264v-8zM16 400v96H624V400H608 592 48 32 16zm304 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fast',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      'M432 112V275.2 336H579.1l-140-224H432zm0 240H416 304 288 176 160 48 32V336 112 96H48 64l96 153.6V112 96h16 16l96 153.6V112 96h16 16l96 153.6V112 96h16 16L598 336l10 16H589.1 432zM176 275.2V336H288V279.8L183.1 112H176V275.2zm-16 4.6L55.1 112H48V336H160V279.8zM304 336H416V279.8L311.1 112H304V275.2 336zM0 432H8 632h8v16h-8H8 0V432z'
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fast',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      'M16 256C16 123.5 123.5 16 256 16c35.4 0 69.1 7.7 99.3 21.4l6.6-14.6C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9l-14.6 6.6C488.3 186.9 496 220.6 496 256c0 132.5-107.5 240-240 240S16 388.5 16 256zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm47.6-112c-14.6 0-30.2-8.6-41-27.9l-3.9-7-13.9 7.8 3.9 7c13.1 23.4 33.6 36.1 55 36.1s41.8-12.7 55-36.1l3.9-7-13.9-7.8-3.9 7c-10.9 19.3-26.4 27.9-41 27.9zm-233-27.9l-3.9-7-13.9 7.8 3.9 7c13.1 23.4 33.6 36.1 55 36.1s41.8-12.7 55-36.1l3.9-7-13.9-7.8-3.9 7c-10.9 19.3-26.4 27.9-41 27.9s-30.2-8.6-41-27.9zM288 96v16h8 67.2L291 169.8l-3 2.4V176v8 8h8 80 8V176h-8H308.8L381 118.2l3-2.4V112v-8V96h-8H296h-8zM424 0h-8V16h8 67.2L419 73.8l-3 2.4V80v8 8h8 80 8V80h-8H436.8L509 22.2l3-2.4V16 8 0h-8H424z'
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fast',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      'M0 64V80v66.7c18.6 6.6 32 24.4 32 45.3s-13.4 38.7-32 45.3V432v16H16 96h16H224h16 96 16H464h16 80 16V432 237.3c-18.6-6.6-32-24.4-32-45.3s13.4-38.7 32-45.3V80 64H560 16 0zM112 400v-8H96v8 32H16V336H560v96H480V400v-8H464v8 32H352V400v-8H336v8 32H240V400v-8H224v8 32H112V400zM48 192c0-23.7-12.9-44.4-32-55.4V80H560v56.6c-19.1 11.1-32 31.7-32 55.4s12.9 44.4 32 55.4V320H16V247.4c19.1-11.1 32-31.7 32-55.4zm144-64H176 144 128v16 16 64 16 16h16 32 16V240 224 160 144 128zm-48 32V144h32v16 64 16H144V224 160zm176-32H304 272 256v16 16 64 16 16h16 32 16V240 224 160 144 128zm-48 32V144h32v16 64 16H272V224 160zm176-32H432 400 384v16 16 64 16 16h16 32 16V240 224 160 144 128zm-48 32V144h32v16 64 16H400V224 160z'
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fast',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      'M448 208A192 192 0 1 0 64 208a192 192 0 1 0 384 0zM48 208a208 208 0 1 1 416 0A208 208 0 1 1 48 208zM8 368H77.1c5 5.6 10.2 10.9 15.7 16H16V496H496V384H419.2c5.5-5.1 10.7-10.4 15.7-16H504h8v8V504v8h-8H8 0v-8V376v-8H8zM264.9 93.3v8 19.3c2.3 .2 4.5 .5 6.8 .9c5.3 .8 21.5 4 27.2 5.5l-4.1 15.5c-4.9-1.3-20.5-4.3-25.6-5.1c-1.5-.2-2.9-.4-4.4-.6v.2h-16v-.5c-7.4 .6-14 2.3-19.5 4.8c-10.1 4.6-15.9 11.5-17.3 19.5c-1.1 6.2-.3 10.7 1.3 14.1c1.7 3.5 4.6 6.7 8.9 9.6c8.9 6.1 21.9 10 36.7 14.4l.4 .1c14.2 4.3 30.1 9.1 41.6 17.5c5.9 4.3 11 9.8 14.1 16.9c3.1 7.2 3.9 15.4 2.3 24.6c-2.7 15.6-12.9 26.5-26.7 32.4c-7.6 3.3-16.4 5.1-25.8 5.5v18.8 8h-16v-8l0-19.2c-2.3-.2-4.5-.5-6.8-.9l0 0c-9.5-1.5-25-6.8-35.4-10.4l0 0 0 0 0 0c-2.1-.7-4-1.3-5.5-1.9l-7.6-2.5 5.1-15.2 7.6 2.5c1.9 .6 4 1.4 6.3 2.1l0 0 0 0 0 0 0 0c10.6 3.6 24.1 8.2 32.1 9.5c1.5 .2 2.9 .4 4.3 .6v-.2h16v.8c7.5-.4 14.1-1.9 19.5-4.2c9.7-4.2 15.6-11 17.3-20.4c1.2-6.7 .4-11.7-1.2-15.5c-1.7-3.9-4.6-7.2-8.8-10.3c-8.9-6.4-21.9-10.6-36.8-15.1l-1.8-.5c-13.6-4.1-28.7-8.6-39.6-16.1c-5.9-4-11.1-9.2-14.4-16c-3.3-6.9-4.2-14.8-2.6-23.7c2.5-14.5 12.9-25.2 26.4-31.4c7.7-3.5 16.5-5.6 26.1-6.3V101.3v-8h16zM64 440H448h8v16h-8H64 56V440h8z'
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fast',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      'M256 16C123.5 16 16 123.5 16 256c0 12.4 .9 24.5 2.7 36.4C92.4 320.6 172.4 336 256 336s163.6-15.4 237.3-43.6c1.4-9.3 2.3-18.7 2.6-28.4H416h-8V248h8 88 8v8c0 14.8-1.3 29.2-3.7 43.3l-.7 4-3.6 1.8-1.4 .7-.3 .2-.4 .1C425.7 335.8 342.7 352 256 352c-82.1 0-160.8-14.6-233.7-41.2C47.1 416.9 142.3 496 256 496c82 0 154.5-41.2 197.8-104H400h-8V376h8 68.5l6.8 12.1C430.5 462.3 349 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c78.4 0 148.7 35.3 195.6 90.8L445.5 104H360h-8V88h8 67.4C383.8 43.6 323.1 16 256 16zm88 128h8 96 8v16h-8H352h-8V144zm0 48h8 96 8v16h-8H352h-8V192zM192 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fast',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      'M48 112V400H16V112H48zM16 96H0v16V400v16H16 48 64V400 384H576v16 16h16 32 16V400 112 96H624 592 576v16 16H64V112 96H48 16zm560 48V368H64V144H576zm16-32h32V400H592V112z'
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fast',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      'M352 48V176H224V48H352zM224 32H208V48 176v16h16 56v56H80 72v8 64H16 0v16V464v16H16 144h16V464 336 320H144 88V264H280v56H224 208v16V464v16h16H352h16V464 336 320H352 296V264H488v56H432 416v16V464v16h16H560h16V464 336 320H560 504V256v-8h-8H296V192h56 16V176 48 32H352 224zM16 464V336H144V464H16zM224 336H352V464H224V336zM432 464V336H560V464H432z'
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fast',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      'M16 288C16 155.5 123.5 48 256 48s240 107.5 240 240v88 8h16v-8V288C512 146.6 397.4 32 256 32S0 146.6 0 288v88 8H16v-8V288zm144-16V464H64V272h96zM64 256H48v16V464v16H64h96 16V464 272 256H160 64zm288 16h96V464H352V272zm96-16H352 336v16V464v16h16 96 16V464 272 256H448z'
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fast',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      'M400 128v16h16c44.2 0 80 35.8 80 80v80H416 96 16V224c0-34.8 22.2-64.5 53.3-75.5L80 144.8V133.5 112c0-53 43-96 96-96c32.4 0 61.1 16.1 78.5 40.8l8.9 12.6 12.9-8.4C288.9 52.8 303.9 48 320 48c44.2 0 80 35.8 80 80zM0 320H16 96 416h80 16V304 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v80 16zM0 512H16L88 352H72L0 512zM192 352L120 512h16l72-160H192zm128 0H304L232 512h16l72-160zm104 0L352 512h16l72-160H424z'
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fast',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      'M96 256.8l-7.1 4.8C54.6 284.6 32 323.7 32 368c0 70.7 57.3 128 128 128s128-57.3 128-128c0-44.4-22.6-83.5-56.9-106.5l-7.1-4.8v-8.5V16H96V248.3v8.5zM224 0h16V16 248.3c38.6 25.8 64 69.8 64 119.8c0 79.5-64.5 144-144 144S16 447.6 16 368c0-49.9 25.4-93.9 64-119.8V16 0H96 224zM160 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM328 32H504h8V48h-8H328h-8V32h8zm0 128H504h8v16h-8H328h-8V160h8zm32 128H504h8v16h-8H360h-8V288h8z'
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fast',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      'M224 16c-61.9 0-112 50.1-112 112v64H432h16v16V496v16H432 16 0V496 208 192H16 96V128C96 57.3 153.3 0 224 0c58.9 0 108.5 39.8 123.4 93.9L332 98.1C318.9 50.8 275.5 16 224 16zM16 208V496H432V208H112 96 16zM272 336H176v32h96V336zm16-16v16 32 16H272 176 160V368 336 320h16 96 16z'
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fast',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      'M16 48V464H288V48H16zm480 0H304V464H496V48zm0-16h16V48 464v16H496 16 0V464 48 32H16 496zM352 96h96v16H352V96zm96 64v16H352V160h96zm-96 64h96v16H352V224z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fast',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm5.7-170.3l-5.7 5.7-5.7-5.7-120-120-5.7-5.7L136 204.7l5.7 5.7L256 324.7 370.3 210.3l5.7-5.7L387.3 216l-5.7 5.7-120 120z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fast',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM374.6 387.4l-13.1 9.2C340.6 366.8 305.4 336 256 336s-84.6 30.8-105.4 60.6l-13.1-9.2c22.4-32 61.9-67.4 118.6-67.4s96.1 35.4 118.6 67.4zM160.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fast',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M501.7 261.7l5.7-5.7-5.7-5.7-136-136-5.7-5.7L348.7 120l5.7 5.7L476.7 248 168 248l-8 0 0 16 8 0 308.7 0L354.3 386.3l-5.7 5.7L360 403.3l5.7-5.7 136-136zM184 48l8 0 0-16-8 0L8 32 0 32l0 8L0 472l0 8 8 0 176 0 8 0 0-16-8 0L16 464 16 48l168 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fast',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      'M160 112H16 0v16V496v16H16 256h16 96 16 10.8c-6.9-4.9-13.4-10.2-19.6-16H368 304 272V384c0-26.5 21.5-48 48-48c1 0 1.9 0 2.9 .1c1-5.3 2.2-10.6 3.6-15.8c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64V496H16V128H160h5l4.1-2.9L320 19.5 470.8 125.1 475 128h5H624V247.2c5.8 6.1 11.1 12.7 16 19.6V128 112H624 480L320 0 160 112zM72 192H64v8 80 8h8 64 8v-8V200v-8h-8H72zm8 80V208h48v64H80zM320 112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm8-112v-8H312v8 32 8h8 24 8V168h-8H328V144zM64 320v8 80 8h8 64 8v-8V328v-8h-8H72 64zm16 16h48v64H80V336zm288 32a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-82.3-50.3l5.7-5.7L552 300.7l-5.7 5.7L496 356.7l-50.3-50.3-5.7-5.7L428.7 312l5.7 5.7L484.7 368l-50.3 50.3-5.7 5.7L440 435.3l5.7-5.7L496 379.3l50.3 50.3 5.7 5.7L563.3 424l-5.7-5.7L507.3 368l50.3-50.3z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fast',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm8-384H248v8V296v8h16v-8V136v-8zM240 368h32V336H240v32z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fast',
    iconName: 'block',
    icon: [
      448,
      512,
      [],
      'e46a',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm80 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 400a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fast',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      'M147.6 0l-2.4 3.8L107.6 64H0V80H416V64H308.4L270.8 3.8 268.4 0H264 152h-4.4zm112 16l30 48H126.4l30-48H259.6zM48 120v-8H32v8V504v8h8H376h8v-8V120v-8H368v8V496H48V120zm120 32H152v8V416v8h16v-8V160v-8zm96 0H248v8V416v8h16v-8V160v-8zm376-24H448v16H640V128zM608 256H448v16H608V256zM448 384v16h96V384H448z'
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fast',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      'M310.2 395.2l-3.6 5.8L256 481.8l-50.5-80.9-3.6-5.8-6.7-1.4C89.8 371.7 16 295.1 16 208C16 104.9 120.2 16 256 16s240 88.9 240 192c0 87.1-73.8 163.7-179.2 185.8l-6.7 1.4zM246.6 496.9L256 512l9.4-15.1 54.7-87.5C430.5 386.3 512 304.9 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4l54.7 87.5z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fast',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M151.1 400L21.5 256 151.1 112l24.9 0 0 288-24.9 0zM0 256L144 416l32 0 16 0 0-16 0-288 0-16-16 0-32 0L0 256z'
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fast',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      'M323.5 267.2c18-25.9 28.5-57.3 28.5-91.2c0-88.4-71.6-160-160-160S32 87.6 32 176c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H258.7c2.4-14.4 6.6-28.7 14-42.2c10.4-19 23.7-37.3 36.3-54.4c5-6.9 10-13.7 14.5-20.2zM184 80c-48.6 0-88 39.4-88 88H80c0-57.4 46.6-104 104-104V80zM128 432v64H256V432H128zm-16 0V416h16H256h16v16 64 16H256 128 112V496 432z'
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fast',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      'M158.1 142.9L209.6 224H240h16 16v16 32 16H256 240 192 174.4L168 277.9l-3-4.8-13-20.5v28.7 1.2V480v16 16H136 104 88V496 480 368 352H72v16l0 112 0 16 0 16H56 24 8V496 480 336 320H8V304 288 160 144 128H24 40 80h51.1 17.6l9.4 14.9zM240 240H209.6h-8.8l-4.7-7.4-51.5-81.1-4.7-7.4h-8.8H40 24v16V288v16h0v16V480v16H56V480 352 336H72 88h16v16V480v16h32V480 252.7 197.6l29.5 46.5 13 20.5 4.7 7.4H192h48 16V240H240zM120 56A40 40 0 1 0 40 56a40 40 0 1 0 80 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zM306.9 39.8L329 128h47 16v0h7.9l.1 0 .1 0H408l0 0h16 47l22.1-88.2L497 24.2l15.5 3.9 31 7.8L559 39.8l-3.9 15.5L527 167.8 521 192H496h-8H472v16V480v16 16H456 424 408V496 480 368 352H392v16l0 112 0 16 0 16H376 344 328V496 480 208 192H312h-8H279L273 167.8 244.8 55.3 241 39.8l15.5-3.9 31-7.8L303 24.2l3.9 15.5zM329 144H316.5l-3-12.1L291.4 43.6l-31 7.8 28.1 112.5 3 12.1H304h24 16v16V480v16h32V480 352 336h16 16 16v16V480v16h32V480 192 176h16 24 12.5l3-12.1L539.6 51.4l-31-7.8-22.1 88.2-3 12.1H471 424v0H408 392 376v0H329zM440 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40.2 56C369 111.9 344 86.9 344 56c0-30.9 25.1-56 56-56s56 25.1 56 56c0 30.9-24.9 55.9-55.8 56l-.1 0-.1 0-.1 0-.1 0z'
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fast',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM92.7 160.5l5.9 5.4L196.2 256 98.6 346.1l-5.9 5.4 10.9 11.8 5.9-5.4 104-96 6.4-5.9-6.4-5.9-104-96-5.9-5.4L92.7 160.5zM200 368h-8v16h8H376h8V368h-8H200z'
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fast',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M560 48V464H470L439.7 357.8 438 352h-6H144h-6l-1.7 5.8L106 464H16V48H560zM453.4 464H122.6L150 368H426l27.4 96zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm42.3 96c13.3-11.7 21.7-28.9 21.7-48s-8.4-36.3-21.7-48H373.7c-13.3 11.7-21.7 28.9-21.7 48s8.4 36.3 21.7 48H202.3zM160 288H416c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zM416 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fast',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      'M250.2 19.4l5.8-2.2 5.8 2.2L469.3 99.9l9.6 3.7 .6 10.3c2.8 47.8-4.7 121.5-36 193.6C412 379.9 356.2 451.2 262.4 491.8l-6.4 2.7-6.4-2.7C155.8 451.2 100 379.9 68.5 307.5c-31.3-72.1-38.8-145.8-36-193.6l.6-10.3 9.6-3.7L250.2 19.4zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM264 104V96H248v8 80H104 96v16h8H248V408v8h16v-8V200H408h8V184h-8H264V104z'
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fast',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      'M296 148c0-64.1-51.9-116-116-116H140C75.9 32 24 83.9 24 148c0 45.2 25.9 84.4 63.6 103.5C37.3 264.2 0 309.7 0 364c0 64.1 51.9 116 116 116h88c64.1 0 116-51.9 116-116c0-54.3-37.3-99.8-87.6-112.5C270.1 232.4 296 193.2 296 148zM180.1 264H204c55.2 0 100 44.8 100 100s-44.8 100-100 100H116C60.8 464 16 419.2 16 364s44.8-100 100-100h23.9c0 0 0 0 .1 0h40c0 0 0 0 .1 0zm0-16c0 0 0 0-.1 0H140c0 0 0 0-.1 0C84.7 248 40 203.2 40 148C40 92.8 84.8 48 140 48l40 0c55.2 0 100 44.8 100 100c0 55.2-44.7 100-99.9 100z'
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fast',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      'M16 368l608 0V144l-104 0v80 8H504v-8V144H424v48 32 8H408v-8V192 144l-80 0v80 8H312v-8V144H232v80 8H216v-8V144H136v80 8H120v-8V144L16 144l0 224zM520 128H624h16v16V368v16H624L16 384H0V368 144 128H16 216h16 80 16 80 16 80 16z'
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fast',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      'M270.6 24.6C318.6 9.8 358.2 14.2 381 37s27.2 62.3 12.4 110.4c-14.7 47.7-47.8 101.5-96.1 149.8s-102.2 81.4-149.8 96.1C99.3 408.2 59.8 403.8 37 381S9.8 318.6 24.6 270.6c14.7-47.7 47.8-101.5 96.1-149.8s102.2-81.4 149.8-96.1zm121.7 1C363.2-3.4 316.1-6.2 265.9 9.3C215.2 24.9 159.2 59.7 109.4 109.4S24.9 215.2 9.3 265.9C-6.2 316.1-3.4 363.2 25.7 392.3l43.8 43.8C118.1 484.7 184 512 252.8 512c17.4 0 34.5-1.7 50.9-5l.3 .3 .5-.5c101.7-20.6 181.8-100.7 202.4-202.4l.5-.5-.3-.3c3.3-16.5 5-33.5 5-50.9c0-68.8-27.3-134.7-75.9-183.3L392.3 25.7zM253.7 434.3l-5.7-5.7L236.7 440l5.7 5.7 47.5 47.5c-12.1 1.9-24.5 2.8-37.1 2.8c-64.5 0-126.4-25.6-172-71.2l-9-9c23.9 4.6 51.6 1.7 80.3-7.2c50.6-15.6 106.6-50.3 156.4-100.1s84.5-105.8 100.1-156.4c8.9-28.7 11.7-56.4 7.2-80.3l9 9c45.6 45.6 71.2 107.5 71.2 172c0 12.6-1 25-2.8 37.1l-47.5-47.5-5.7-5.7L428.7 248l5.7 5.7 55.2 55.2c-9.9 42-30.7 79.7-59.2 110.2l-.7-.7-64-64-5.7-5.7L348.7 360l5.7 5.7 64 64 .7 .7c-30.4 28.5-68.2 49.3-110.2 59.2l-55.2-55.2zM329.5 80.6c3.9 3.9 6.7 10.4 6.7 21.3c-.1 10.9-3.2 24.9-9.9 41.1c-13.3 32.4-39.6 71-75.9 107.3s-74.9 62.6-107.3 76c-16.2 6.7-30.2 9.8-41.1 9.9c-10.8 .1-17.4-2.8-21.3-6.7s-6.7-10.4-6.7-21.3c.1-10.9 3.2-24.9 9.9-41.1c13.3-32.4 39.6-71 76-107.3s74.9-62.6 107.3-76c16.2-6.7 30.2-9.8 41.1-9.9c10.8-.1 17.4 2.8 21.3 6.7zm11.3-11.3c-31.2-31.2-117.4 4.2-192.3 79.2s-110.4 161.1-79.2 192.3s117.4-4.2 192.3-79.2s110.4-161.1 79.2-192.3z'
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fast',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      'M16 120v80h96V120H16zm0-16h96V48H16v56zm0-72h96 8 8H384h8 8 96 16V48v56 8 8 80 8 8 80 8 8 80 8 8 56 16H496 400h-8-8H128h-8-8H16 0V464 408v-8-8V312v-8-8V216v-8-8V120v-8-8V48 32H16zm112 80v96 40H384V208 112 48H128v64zM112 256V216H16v80h96V256zm16 8v40 96 64H384V400 304 264H128zm272-8v40h96V216H400v40zm0-152h96V48H400v56zm0 16v80h96V120H400zm0 192v80h96V312H400zm0 96v56h96V408H400zm-288 0H16v56h96V408zm0-16V312H16v80h96z'
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fast',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      'M320 0C214 0 128 86 128 192c0 68 35.3 127.7 88.6 161.8l5.4 3.5 4.6-4.6 37.9-37.9 4.4-4.4-3.2-5.3C254.5 286 248 263.8 248 240c0-70.7 57.3-128 128-128c55.5 0 102.7 35.3 120.5 84.6L512 194c0-.7 0-1.3 0-2C512 86 426 0 320 0zM144 192c0-97.2 78.8-176 176-176c84.4 0 154.9 59.4 172 138.7C465.8 119.1 423.6 96 376 96c-79.5 0-144 64.5-144 144c0 24.5 6.1 47.6 16.9 67.8l-29 29C174 305 144 252 144 192zM117.7 298.3l-5.7-5.7L100.7 304l5.7 5.7L116.7 320 5.5 431.1l-5.7 5.7 5.7 5.7 64 64 5.7 5.7 5.7-5.7L192 395.3l10.3 10.3 5.7 5.7L219.3 400l-5.7-5.7-16-16-64-64-16-16zM22.5 436.8L128 331.3 180.7 384 75.2 489.5 22.5 436.8z'
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fast',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240s240-107.5 240-240h16c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c67.8 0 129.5 26.4 175.3 69.4l43.1-43.1 5.7-5.7L491.3 32l-5.7 5.7-224 224-5.7 5.7L244.7 256l5.7-5.7 33.5-33.5c-7.8-5.6-17.4-8.9-27.8-8.9c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48h16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.8 0 28.4 5 39.2 13.4L352 148.7c-25.5-22.8-59.1-36.7-96-36.7c-57.9 0-107.8 34.1-130.7 83.4l-14.5-6.7C136.3 133.9 191.7 96 256 96c41.3 0 79 15.7 107.3 41.3L420 80.7C377 40.6 319.4 16 256 16zM96 216a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm96 160a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM400 256h16c0 64.3-37.9 119.7-92.6 145.2l-6.7-14.5C365.9 363.8 400 313.9 400 256zM195.4 386.7l-6.7 14.5c-34.2-15.9-61.9-43.6-77.8-77.8l14.5-6.7c14.3 30.8 39.2 55.7 70 70z'
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fast',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      'M592 16H176V336h20.7l5.7-5.7 240-240 5.7-5.7 5.7 5.7 72.1 72.1-17 5.7L448 107.3 219.3 336H400v16H176 160V336 16 0h16H592h16V16 135l-16 5.3V16zM264 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80zM128 96v16 80 80 72 40 48H296.5c-2.7 5-4.9 10.3-6.3 16H128h-8-8H16 0V432 352v-8-8V280v-8-8V200v-8-8V112 96H16h96 8 8zM16 352v80h96V352H16zm0-16h96V280H16v56zm0-72h96V200H16v64zm0-80h96V112H16v72zm624-27.2v11.1 72 152c0 .9-.1 1.7-.4 2.5c.3 1.8 .4 3.6 .4 5.5c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V251L448 309.7V463.9l0 .1c0 26.5-28.7 47.9-64 47.9c-35.3 0-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.2V303.9v-72-5.8l5.5-1.8 192-64 10.5-3.5zm-220.3 286c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1s-3.8-14.7-12.3-21.1zm28.3-150l176-58.7V179L448 237.7v55.1zM624 399.9c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1z'
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fast',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      'M136 48c-8.2 0-16.2 .8-24 2.4V472v8H96v-8V54.8C49.4 71.3 16 115.8 16 168V472v8H0v-8V168C0 92.9 60.9 32 136 32h6.5c43.1 0 83.7 20.4 109.3 55.1l140.6 190c27.4 37 70.8 58.9 116.9 58.9H512c61.9 0 112-50.1 112-112c0-50.7-33.7-93.6-80-107.4V280v8H528v-8V113.1c-5.2-.7-10.6-1.1-16-1.1H494.2c-15.8 0-31.5 2.9-46.2 8.5V248v8H432v-8V127.9c-1.6 .8-3.1 1.7-4.6 2.6l-47.3 28.4-6.9 4.1L365 149.3l6.9-4.1 47.3-28.4c22.7-13.6 48.6-20.8 75-20.8H512c70.7 0 128 57.3 128 128V472v8H624v-8V286c-19.4 34.9-54.6 59.8-96 65V472v8H512v-8V352h-2.7c-33.8 0-66.4-10.6-93.3-29.7V472v8H400v-8V309.4c-7.4-6.9-14.3-14.4-20.4-22.7L304 184.5V472v8H288v-8V162.9L238.9 96.6C230.3 85 219.8 75.2 208 67.5V472v8H192v-8V58.7c-15.4-7-32.2-10.7-49.5-10.7H136z'
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fast',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      'M453.9 0c-15.1 0-29 5.8-39.3 15.3C406.4 10.9 397 8.4 387 8.4c-20.2 0-38 10.3-48.4 25.9c-3.3-.6-6.6-.9-10.1-.9c-20.2 0-38 10.3-48.4 25.9c-3.3-.6-6.6-.9-10.1-.9c-20.8 0-39 10.9-49.3 27.3c3.6 4.9 7 9.8 10.3 14.9c6.3-15.3 21.4-26.1 39-26.1c4.1 0 8 .6 11.8 1.7l6.3 1.8 3-5.8c7-13.5 21.2-22.7 37.4-22.7c4.1 0 8 .6 11.8 1.7l6.3 1.8 3-5.8c7-13.5 21.2-22.7 37.4-22.7c9 0 17.4 2.8 24.2 7.6l5.9 4.2 4.7-5.5c7.7-9 19.2-14.7 32-14.7C477.1 16 496 34.9 496 58.1c0 12.8-5.7 24.2-14.7 32l-5.5 4.7 4.2 5.9c4.8 6.8 7.6 15.2 7.6 24.2c0 16.3-9.2 30.4-22.7 37.4l-5.8 3 1.8 6.3c1.1 3.7 1.7 7.7 1.7 11.8c0 16.3-9.2 30.4-22.7 37.4l-5.8 3 1.8 6.3c1.1 3.7 1.7 7.7 1.7 11.8c0 13.4-6.2 25.3-16 33c4.1 3.4 8.2 7 12.1 10.8c12.2-10.7 19.9-26.3 19.9-43.8c0-3.4-.3-6.8-.9-10.1c15.6-10.4 25.9-28.2 25.9-48.4c0-3.4-.3-6.8-.9-10.1c15.6-10.4 25.9-28.2 25.9-48.4c0-10-2.5-19.3-6.9-27.6C506.2 87.1 512 73.3 512 58.1C512 26 486 0 453.9 0zm-299 66.3l-9.2-9.2-4.1 12.3-22.9 68.7c-1 3-2.6 5.8-4.7 8.2L2 274.4l-2 2.3v3V396v3.1l2.1 2.3 99.7 108 2.4 2.6h3.5H232.3h3.3l2.3-2.3L349.3 398.4c2.5-2.5 5.5-4.4 8.8-5.6L442.7 362l11.8-4.3-8.9-8.9-30.2-30.2c-35.4-35.4-83.3-55.2-133.3-55.2c-14.2 0-28.2 1.6-41.8 4.7v-7c0-70-27.8-137.2-77.3-186.7l-8.1-8.1zm69.4 205h3.5c-29.6 8.9-56.7 25-79 47.2L44.1 423.3 16 392.9V282.7L126.1 156.9c3.5-4 6.2-8.7 7.8-13.7l18.8-56.4c45.8 46.4 71.6 109 71.6 174.3v10.3zM111.2 496L49.8 429.5l5.4 5.4 105-105c32.4-32.4 76.2-50.5 122-50.5s89.6 18.2 122 50.5l21.3 21.3-72.9 26.5c-5.5 2-10.5 5.2-14.6 9.3L229 496H111.2z'
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fast',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240 24c1.4-7.9 1.4-7.9 1.4-7.9l0 0 0 0 0 0 .2 0 .6 .1c.5 .1 1.2 .2 2.2 .4c1.8 .4 4.4 1 7.6 1.8c6.2 1.6 14.6 4 23 7.4c8.4 3.4 17.2 7.9 24.2 13.7c6.9 5.9 12.8 14 12.8 24.4c0 10.2-6.4 17.5-13.4 22.4c-5.9 4.1-13.2 7.3-20.3 9.6c7.1 2.4 14.4 5.5 20.3 9.6c7 4.9 13.4 12.2 13.4 22.4c0 11-5.6 19.5-12.7 25.8c-7 6.2-16 10.6-24.5 13.7c-8.5 3.2-16.9 5.3-23.2 6.6c-3.1 .7-5.8 1.1-7.6 1.4c-.9 .2-1.7 .3-2.2 .3l-.6 .1-.2 0-.1 0 0 0 0 0s0 0-1-7.9l-1-7.9 0 0 .1 0 .5-.1c.4-.1 1.1-.2 1.9-.3c1.6-.3 4-.7 6.9-1.3c5.8-1.2 13.3-3.1 20.8-5.9c7.6-2.8 14.6-6.4 19.5-10.8c4.9-4.3 7.3-8.7 7.3-13.7c0-2.6-1.6-5.7-6.6-9.2c-5-3.5-12-6.4-19.7-8.7c-7.6-2.3-15.2-3.8-21-4.8c-2.9-.5-5.3-.8-7-1c-.8-.1-1.5-.2-1.9-.2l-.5-.1-.1 0 0 0 0 0 0 0 0 0V344.1l0 0 0 0 0 0 0 0 .1 0 .5-.1c.4-.1 1.1-.1 1.9-.2c1.7-.2 4.1-.6 7-1c5.8-1 13.4-2.5 21-4.8c7.7-2.3 14.7-5.2 19.7-8.7c5-3.5 6.6-6.6 6.6-9.2c0-3.8-2.1-7.9-7.2-12.2c-5.1-4.3-12.2-8-19.8-11.1c-7.6-3-15.2-5.3-21-6.7c-2.9-.7-5.3-1.3-6.9-1.6c-.8-.2-1.5-.3-1.9-.4l-.5-.1-.1 0 0 0 0 0L240 280zm-89.1-94.3c-7.4 11.4-12.7 26.3-15.2 39.8L120 222.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L216 225.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8L280 222.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L376 225.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fast',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      'M432 48V464H16V48H432zm16-16H432 16 0V48 464v16H16 432h16V464 48 32zM163.3 179.3l25.4 25.4L200 216l-11.3 11.3-73.4 73.4L104 312l11.3 11.3 41.4 41.4L168 376l11.3-11.3 73.4-73.4L264 280l11.3 11.3 25.4 25.4L312 328l11.3-11.3L336 304V160 144H320 176l-12.7 12.7L152 168l11.3 11.3zm48 48L222.6 216l-11.3-11.3L174.6 168l8-8H320V297.4l-8 8-36.7-36.7L264 257.4l-11.3 11.3L168 353.4 126.6 312l84.7-84.7z'
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fast',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      'M368 320c0-22.5-10.5-52.9-28.2-87.4c-17.5-34-41-70-64.8-103c-23.7-33-47.5-62.7-65.3-84.3c-6.9-8.3-12.9-15.4-17.7-21c-4.8 5.6-10.8 12.6-17.7 21c-17.8 21.5-41.6 51.3-65.3 84.3c-23.8 33-47.3 69-64.8 103C26.5 267.1 16 297.5 16 320c0 97.2 78.8 176 176 176s176-78.8 176-176zM0 320C0 229.1 141.1 58.9 181.4 12.1C188.1 4.4 192 0 192 0s3.9 4.4 10.6 12.1C242.9 58.9 384 229.1 384 320c0 106-86 192-192 192S0 426 0 320zm269.7-66.3l-144 144-5.7 5.7L108.7 392l5.7-5.7 144-144 5.7-5.7L275.3 248l-5.7 5.7zM112 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fast',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 99.6-60.7 185-147.1 221.4l6.2 14.8C447.3 453.4 512 362.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 86 42.4 162 107.3 208.4l9.3-13C55.7 407.9 16 336.6 16 256zm119.7-46.5c2.5-13.5 7.8-28.4 15.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9zm175.2-39.8c7.6-11.6 16.1-17.7 24.9-17.7s17.3 6.1 24.9 17.7c7.4 11.4 12.7 26.3 15.2 39.8l15.7-2.9c-2.8-15-8.7-32-17.6-45.6c-8.7-13.3-21.5-25-38.3-25s-29.6 11.7-38.3 25c-8.8 13.5-14.8 30.6-17.6 45.6l15.7 2.9c2.5-13.5 7.8-28.4 15.2-39.8zM256 345.4l44.7-44.7L312 289.4l4.7-4.7 6.6-6.6 4.7-4.7 11.3 11.3L350.6 296l-4.7 4.7-6.6 6.6-4.7 4.7-11.3 11.3L278.6 368l-11.3 11.3 9.4 9.4L288 377.4l44.7-44.7L344 321.4l1.9 1.9 9.4 9.4L366.6 344l-11.3 11.3-9.4 9.4L334.6 376l-11.3 11.3L310.6 400l-11.3 11.3 9.4 9.4L320 409.4l12.7-12.7L344 385.4l1.9 1.9 9.4 9.4L366.6 408l-11.3 11.3-48.8 48.8C288.7 486 264.4 496 239.2 496c-52.6 0-95.2-42.6-95.2-95.2V388 368 338.4v-4-16h16 8 16v12.3 3.7 4 15l15-15 1-1 68.7-68.7L280 257.4l11.3 11.3 9.4 9.4 1.9 1.9-11.3 11.3L246.6 336l-11.3 11.3 9.4 9.4L256 345.4zm35.3-99.3L280 234.7l-11.3 11.3-11.3 11.3L200 314.7V302.4H184 144 128v16 20V368v20 12.8C128 462.2 177.8 512 239.2 512c29.5 0 57.8-11.7 78.6-32.6l48.8-48.8 11.3-11.3L389.3 408l-11.3-11.3L357.3 376l9.4-9.4 11.3-11.3L389.3 344l-11.3-11.3L357.3 312l4.7-4.7L373.3 296l-11.3-11.3-22.6-22.6L328 250.7l-11.3 11.3-4.7 4.7-20.7-20.7z'
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fast',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      'M248 110.6V144v3.3l2.3 2.3 41.1 41.1-87.9 58.6-7.3 4.8 5.5 6.8 64 80 5 6.2 12.5-10-5-6.2-58.5-73.2 88.7-59.2 8.1-5.4-6.9-6.9L264 140.7v-30l3.3-3.3 24.2-24.2C314 60.6 344.5 48 376.2 48C442.4 48 496 101.6 496 167.8c0 31.8-12.6 62.2-35.1 84.7l-24.2 24.2L256 457.4 75.3 276.7 51.1 252.5C28.6 230 16 199.5 16 167.8C16 101.6 69.6 48 135.8 48c31.8 0 62.2 12.6 84.7 35.1l24.2 24.2 3.3 3.3zM256 480l11.3-11.3L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L267.3 84.7 256 96 244.7 84.7 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 244.7 468.7 256 480z'
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fast',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      'M0 0H8 376h8V16h-8H352V144v4l-3.3 2.4L205.5 256l130.3 96h.2v.2l12.7 9.4L352 364v4V496h24 8v16h-8H8 0V496H8 32V368v-4l3.3-2.4L48 352.2V352h.2l130.3-96L35.3 150.4 32 148v-4V16H8 0V0zM53.5 368L48 372V496H336V372l-5.5-4H53.5zm255.3-16L192 265.9 75.2 352H308.8zM48 16V140L192 246.1 336 140V16H48z'
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fast',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      'M128 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM512 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 96a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM72 264v-8H56v8 89.7L18.6 287.6 61.2 192H200.6l7.1-16H56 50.8l-2.1 4.7L2.3 284.7 .6 288.4l2 3.5L56 386.1V456v8h8H192h8v-8V366.3l-16-28.2V448H72V264zm384 74.1l-16 28.2V456v8h8H576h8v-8V386.1l53.4-94.2 2-3.5-1.6-3.7-46.4-104-2.1-4.7H584 432.2l7.1 16H578.8l42.6 95.6L584 353.7V264v-8H568v8V448H456V338.1zM272 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM264 272H248v8 73.7l-37.4-66.1L253.2 192H386.8l42.6 95.6L392 353.7V280v-8H376v8V464H264V280v-8zM248 386.1V472v8h8H384h8v-8V386.1l53.4-94.2 2-3.5-1.6-3.7-46.4-104-2.1-4.7H392 248h-5.2l-2.1 4.7-46.4 104-1.6 3.7 2 3.5L248 386.1z'
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fast',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      'M624 80V432H176V80H624zM176 64H160V80 432v16h16H624h16V432 80 64H624 176zm96 272v32H240V336h32zm-32-16H224v16 32 16h16 32 16V368 336 320H272 240zm96 16H464v32H336V336zm-16-16v16 32 16h16H464h16V368 336 320H464 336 320zm-48-80v32H240V240h32zm-32-16H224v16 32 16h16 32 16V272 240 224H272 240zm96 16h32v32H336V240zm-16-16v16 32 16h16 32 16V272 240 224H368 336 320zm144 16v32H432V240h32zm-32-16H416v16 32 16h16 32 16V272 240 224H464 432zm96 16h32v32H528V240zm-16-16v16 32 16h16 32 16V272 240 224H560 528 512zm48 112v32H528V336h32zm-32-16H512v16 32 16h16 32 16V368 336 320H560 528zM240 144h32v32H240V144zm-16-16v16 32 16h16 32 16V176 144 128H272 240 224zm144 16v32H336V144h32zm-32-16H320v16 32 16h16 32 16V176 144 128H368 336zm96 16h32v32H432V144zm-16-16v16 32 16h16 32 16V176 144 128H464 432 416zm144 16v32H528V144h32zm-32-16H512v16 32 16h16 32 16V176 144 128H560 528zM105.2 173.7l5.7-5.7L99.5 156.7l-5.7 5.7-88 88L.2 256l5.7 5.7 88 88 5.7 5.7L110.8 344l-5.7-5.7L22.8 256l82.3-82.3z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fast',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 80H448V96H0V80zM0 240H448v16H0V240zM448 400v16H0V400H448z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fast',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      'M368 16v96H16V16H368zM16 0H0V16v96 16H16 368h16V112 16 0H368 16zM32 416v80 16H48 336h16V496 160H336V496H48V416H152h8V400h-8H48V320H152h8V304h-8H48V224H152h8V208h-8H48V160H32v48 16 80 16 80 16z'
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fast',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      'M0 416c0 53 43 96 96 96s96-43 96-96L192 8V0h-8H8 0V8 416zm96 80c-44.2 0-80-35.8-80-80L16 16l160 0 0 400c0 44.2-35.8 80-80 80zm408 16h8v-8V328v-8h-8H357.9l-16 16H496V496H195.9c-4.6 5.8-9.7 11.1-15.3 16H504zM223.8 423.3L453 194.1l5.7-5.7-5.7-5.7L328.5 58.3l-5.7-5.7-5.7 5.7L224 151.5v22.6l98.8-98.8L436 188.5l-212 212V416c0 2.4-.1 4.9-.2 7.3zM64 48H48V64v64 16H64h64 16V128 64 48H128 64zm0 16H80h32 16V80v32 16H112 80 64V112 80 64zM48 176v16 64 16H64h64 16V256 192 176H128 64 48zm32 16h32 16v16 32 16H112 80 64V240 208 192H80zm32 224a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fast',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      'M208 16V496H560V16H208zM192 0h16H560h16V16 496v16H560 208 192V496 16 0zM96 48h16V464H96V48zM0 96H16V416H0V96z'
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fast',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      'M432 48H16V96c0 114.9 93.1 208 208 208c2.2 0 4.4 0 6.5-.1c-1.4 5.3-2.6 10.6-3.6 16.1c-1 0-1.9 0-2.9 0c-24.1 0-47.4-3.8-69.2-10.9l-24.1 53.1c8.5 5.5 15.7 13 20.7 21.8h75.2c.9 5.4 2.1 10.7 3.4 16H158c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c7.1 0 13.9 1.2 20.3 3.3l23.5-51.7C57.8 270.3 0 189.9 0 96V48 32H16 432h16V48 96c0 24.8-4 48.7-11.5 71.1l-12.8-12.8c5.4-18.5 8.3-38.1 8.3-58.3V48zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM436.7 212.8L448 224.2l11.3-11.3L480 192.2c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192l52.7 52.7zM512 422.6c0 18.2-5.8 35.1-15.7 49.2C534.7 445.9 560 402 560 352.2c0-20.2-14.9-79.7-79.2-138.1l-21.4 21.4L448 246.8l-11.3-11.3L382 180.7c-19.3 13.6-44.2 35.1-65.4 61.8C291 274.5 272 312.4 272 352.2c0 49.8 25.3 93.7 63.7 119.6c-9.9-14.1-15.7-31-15.7-49.2c0-70.4 96-134.4 96-134.4s96 64 96 134.4zm-96 73.6c45.2 0 80-34 80-73.6c0-28.5-20-58.2-43.5-82.5c-11.4-11.8-22.8-21.5-31.4-28.3c-1.8-1.5-3.5-2.8-5.1-3.9c-1.5 1.2-3.2 2.5-5.1 3.9c-8.6 6.8-20 16.5-31.4 28.3C356 364.4 336 394 336 422.6c0 39.6 34.8 73.6 80 73.6z'
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fast',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      'M320 112a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm16 0c0 59.2-45.9 107.6-104 111.7V352H432h16v16V496v16H432 16 0V496 368 352H16 216V223.7c-58.1-4.1-104-52.6-104-111.7C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 304h8 48 8v16h-8H72 64V304zM432 496V368H16V496H432zM192 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fast',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      'M80 48H560V352h16V48 32H560 80 64V48 352H80V48zM16 425.4V400H624v25.4L585.4 464H54.6L16 425.4zM624 384H16 0v16 32l48 48H592l48-48V400 384H624zM269.7 157.7l5.7-5.7L264 140.7l-5.7 5.7-64 64-5.7 5.7 5.7 5.7 64 64 5.7 5.7L275.3 280l-5.7-5.7L211.3 216l58.3-58.3zm112-11.3l-5.7-5.7L364.7 152l5.7 5.7L428.7 216l-58.3 58.3-5.7 5.7L376 291.3l5.7-5.7 64-64 5.7-5.7-5.7-5.7-64-64z'
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fast',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      'M16 16V400H67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V16H16zM64.4 416H16 0V400 16 0H16 400h16V16 96h72 3.3l2.3 2.3 112 112 2.3 2.3V216 400h24 8v16h-8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H400 239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8zM416 216H588.7l-104-104H416V216zm0 16V373.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416zM224 424A72 72 0 1 0 80 424a72 72 0 1 0 144 0zm264 72a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM320 128v8V240v16 56 8H304v-8V256H256 240V240 144c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6V80v48zM304 240V136v-8V82c-27.6 7.1-48 32.2-48 62v96h48zM152 200v0 96 8H136v-8V200v-.5c-31-4.1-54.3-31.8-52-63.9l4-56.1 .6-8 16 1.1-.6 8-4 56.1c-1.8 25.6 18.4 47.3 44 47.3s45.9-21.7 44-47.3l-4-56.1-.6-8 16-1.1 .6 8 4 56.1c2.3 32.1-21 59.8-52 63.9v.5zm0-120v64 8H136v-8V80 72h16v8z'
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fast',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm117.9-80H454c23.2 0 42 18.8 42 42v8h-.8c-2.6 13.2-11.4 24.6-24 30.3L440 382.4V392v8H424v-8V377.2v-5.2l4.7-2.1 36-16.2C474 349.5 480 340.3 480 330c0-14.4-11.6-26-26-26H405.9c-12.1 0-21.9 9.8-21.9 21.9V328v8H368v-8-2.1c0-20.9 17-37.9 37.9-37.9zM444 420v24H420V420h24z'
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fast',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      'M248 110.6V449.4L75.3 276.7 51.1 252.5C28.6 230 16 199.5 16 167.8C16 101.6 69.6 48 135.8 48c31.8 0 62.2 12.6 84.7 35.1l24.2 24.2 3.3 3.3zm16 338.7V110.6l3.3-3.3 24.2-24.2C314 60.6 344.5 48 376.2 48C442.4 48 496 101.6 496 167.8c0 31.8-12.6 62.2-35.1 84.7l-24.2 24.2L264 449.4zM256 480l11.3-11.3L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L267.3 84.7 256 96 244.7 84.7 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 244.7 468.7 256 480z'
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fast',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M16 464V48H432V464H16zM0 480H16 432h16V464 48 32H432 16 0V48 464v16zM96 192v16 24L224 352 352 232V208 192H336 112 96zm240 33.1l-112 105-112-105V208H336v17.1z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fast',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm51.4-204.6L153.3 358.7l51.4-154.1 154.1-51.4L307.4 307.4zm57.7-173L192 192 134.3 365 128 384l19-6.3L320 320l57.7-173 6.3-19-19 6.3zM240 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fast',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      'M224 176H16v8c0 110.5 89.5 200 200 200s200-89.5 200-200V104c0-7.4-.9-14.6-2.6-21.5l-.5-.3 .3-.4C403.3 44 368.9 16 328 16c-48.6 0-88 39.4-88 88v56 16H224zM431.6 94.7c.3 3.1 .4 6.2 .4 9.3v57.1L481.6 128l-50-33.3zm.4 85.6V184c0 95.2-61.5 176-147 204.7L357.3 512H338.8L269.2 393.4c-17 4.3-34.8 6.6-53.2 6.6c-6 0-11.9-.2-17.8-.7L261.7 512H243.3L178.4 396.7C77 379 0 290.5 0 184v-8V160H16 208h16V144 104C224 46.6 270.6 0 328 0c46.4 0 85.8 30.4 99.1 72.5l1.3 .9 72 48 10 6.7-10 6.7L432 180.3zM320 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fast',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      'M136 0h-8V16h8H352V144H132.5L86.9 67.9 84.5 64H80 16 5.8l2.5 9.9 32 128 .9 3.8 3.6 1.6 142.4 63.3L298 397.3l2.4 2.7H304h.6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 8v-8V280c0-75.1-60.9-136-136-136H368V16H568h8V0h-8H136zM26.2 80H75.5l45.7 76.1 2.3 3.9H128 352V384h-.2-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H346h-.5H345h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H338h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H331h-.5-.5-.5-.6-.5-.6-.6-.6H326h-.6-.6-.6-.6-.6-.6-.6-.6H321h-.6-.6-.6-.6-.6-.6-.6-.6H316h-.6-.6-.6-.6-.6-.6H312h-.6-.6-.6-.6-.6-.6H308h-.4L198 258.7l-1.2-1.3-1.6-.7L54.8 194.3 26.2 80zM368.4 384H368V160h72c66.3 0 120 53.7 120 120V384h0-.6-.6-.6-.6-.6-.6H556h-.6-.6-.6-.6-.6-.6-.6-.6H551h-.6-.6-.6-.6-.6-.6-.6-.6H546h-.6-.6-.6-.6-.5-.6-.5-.5H541h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H534h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H527h-.5H526h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H517h-.5H516h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H501h-.5H500h-.5H499h-.5H498h-.5H497h-.5H496h-.5H495h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H479h-.5H478h-.5H477h-.5H476h-.5H475h-.5H474h-.5H473h-.5H472h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H453h-.5H452h-.5H451h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H437h-.5H436h-.5H435h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H421h-.5H420h-.5H419h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400h-.5H399h-.5H398h-.5H397h-.5H396h-.5H395h-.5H394h-.5H393h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H377h-.5H376h-.5H375h-.5H374h-.5H373h-.5H372h-.5H371h-.5-.5-.5-.5-.5zM640 456v-8H624v8 40H232h-8v16h8H632h8v-8V456z'
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fast',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM120 264V248H328v16H120z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fast',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      'M288 5.5l5.2 4.5 141 120.8-3.1 2c-3.4 2.1-7 4.5-10.8 7.2L288 26.5 80 204.8V496H208V312v-8h8 78.5c-1.4 5.2-2.6 10.6-3.6 16H224V496H352v-1c6.9 6.2 14.3 11.9 22.1 17H72 64v-8V218.5L13.2 262.1 2.8 249.9l280-240L288 5.5zM500.7 212.8L512 224.2l11.3-11.3L544 192.2c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-89.6 85.3-165.3 128-192l52.7 52.7zM576 422.6c0 18.2-5.8 35.1-15.7 49.2C598.7 445.9 624 402 624 352.2c0-20.2-14.9-79.7-79.2-138.1l-21.4 21.4L512 246.8l-11.3-11.3L446 180.7c-19.3 13.6-44.2 35.1-65.4 61.8C355 274.5 336 312.4 336 352.2c0 49.8 25.3 93.7 63.7 119.6c-9.9-14.1-15.7-31-15.7-49.2c0-70.4 96-134.4 96-134.4s96 64 96 134.4zm-96 73.6c45.2 0 80-34 80-73.6c0-28.5-20-58.2-43.5-82.5c-11.4-11.8-22.8-21.5-31.4-28.3c-1.8-1.5-3.5-2.8-5.1-3.9c-1.5 1.2-3.2 2.5-5.1 3.9c-8.6 6.8-20 16.5-31.4 28.3C420 364.4 400 394 400 422.6c0 39.6 34.8 73.6 80 73.6z'
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fast',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      'M419.9 103.4l65.7-65.7L474.3 26.3 408.6 92.1C368.6 54.8 315 32 256 32C132.3 32 32 132.3 32 256c0 59 22.8 112.6 60.1 152.6L26.3 474.3l11.3 11.3 65.7-65.7C143.4 457.2 197 480 256 480c123.7 0 224-100.3 224-224c0-59-22.8-112.6-60.1-152.6zm-22.6 0L103.4 397.3C69 360.2 48 310.6 48 256C48 141.1 141.1 48 256 48c54.6 0 104.2 21 141.3 55.4zM114.7 408.6L408.6 114.7C443 151.8 464 201.4 464 256c0 114.9-93.1 208-208 208c-54.6 0-104.2-21-141.3-55.4z'
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fast',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      'M328 48c22.1 0 43.5 3.5 63.5 9.9c19.8 6.4 38.4 15.6 55.1 27.3c-14.2-15.8-30.3-29.9-48-41.8C357.8 16 308.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c52.8 0 101.8-16 142.6-43.4c17.7-11.9 33.8-25.9 48-41.8c-16.8 11.7-35.3 20.9-55.1 27.3c-20 6.4-41.3 9.9-63.5 9.9c-114.9 0-208-93.1-208-208s93.1-208 208-208zm0-16C204.3 32 104 132.3 104 256s100.3 224 224 224c5.3 0 10.6-.2 15.8-.5C316.6 490.1 287 496 256 496C123.5 496 16 388.5 16 256S123.5 16 256 16c31 0 60.6 5.9 87.8 16.5c-5.2-.4-10.5-.5-15.8-.5zm64.9 106.1L384 120l-8.9 18.1-33.4 67.7L267 216.6 247 219.5l14.4 14.1 54 52.7-12.8 74.4-3.4 19.9 17.8-9.4L384 336l66.8 35.1 17.8 9.4-3.4-19.9-12.8-74.4 54-52.7L521 219.5 501 216.6l-74.7-10.9-33.4-67.7zM424 221.6l62.6 9.1-45.3 44.1-6 5.9 1.4 8.3 10.7 62.3-55.9-29.4-7.4-3.9-7.4 3.9-55.9 29.4L331.3 289l1.4-8.3-6-5.9-45.3-44.1 62.5-9.1 8.3-1.2 3.7-7.5 28-56.7 28 56.7 3.7 7.5 8.3 1.2z'
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fast',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      'M414.8 464.3C397.1 475.1 384 480 384 480s10-10 18.8-27.2c7-13.6 13.2-31.6 13.2-52.8c0-61.9-50.1-112-112-112H240 224v16 64 16H208 192L11.8 218.9 0 208l11.8-10.9L192 32h16 16V48v64 16h16 96c97.2 0 176 78.8 176 176c0 87.1-59.3 137.2-97.2 160.3zM426.4 437c3.6-2.8 7.3-5.8 11-9c29.7-26 58.5-66 58.5-124c0-88.4-71.6-160-160-160H224 208V128 48h-9.8L23.7 208 198.2 368H208V288 272h16 80c70.7 0 128 57.3 128 128c0 13.6-2.2 26-5.6 37z'
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fast',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      'M271.1 31.1c-15 15-19.1 40-11.1 70.3c7.9 30.1 27.5 63.7 57.2 93.4s63.4 49.3 93.4 57.2c30.3 8 55.3 3.8 70.3-11.1c9.5-9.5 14.6-23 15.1-39.3c-.2-10.6-1.8-21.3-4.5-31.3c-4.1-15.7-11-31.7-20.3-47.2c-9.5-15.7-21.7-31.3-36.4-46c-14.7-14.7-30.4-26.9-46.1-36.5c-15.5-9.2-31.4-16.1-47.1-20.2c-10.2-2.7-20.9-4.3-31.7-4.5c-16.1 .5-29.5 5.7-38.9 15.1zM406.5 267.5c-33.3-8.8-69.3-30-100.7-61.4s-52.6-67.4-61.4-100.7c-6.1-23-6.3-45.5 1.1-64L195.5 91.6c-33 33-51.5 77.8-51.5 124.5v97.4L198.6 368H296c46.7 0 91.4-18.5 124.4-51.5l50.2-50.2c-18.5 7.4-41 7.2-64.1 1.2zM446.3 65.7c15.2 15.2 28.2 31.9 38.6 49.3c10.5 17.3 18.1 34.8 22.5 51.6c3.2 12.1 4.7 24 4.5 35.2c.3 25.7-6.8 52.7-28.1 74l-52.1 52.1c-36 36-84.8 56.2-135.7 56.2H195.3l-20.4 20.4C185.5 415.9 192 431.2 192 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1L128 316.7V216c0-50.9 20.2-99.8 56.2-135.8l52-52C257.4 7.1 284.2-.2 309.8 .1c11.4-.3 23.5 1.2 35.7 4.4c16.8 4.4 34.3 12 51.5 22.5c17.4 10.4 34.1 23.5 49.3 38.7zM136 328v0l1.7 1.7-24.6 24.6-6.3 6.3-5.6-6.9C92.4 342.9 79 336 64 336c-26.5 0-48 21.5-48 48s21.5 48 48 48c2.5 0 5-.2 7.4-.6l10.8-1.7-1.7 10.8c-.4 2.4-.6 4.9-.6 7.4c0 26.5 21.5 48 48 48s48-21.5 48-48c0-15-6.9-28.4-17.7-37.2l-6.9-5.6 6.3-6.3 24.6-24.6L184 376h0l-48-48zM354 114c-1.6 1.6-2.9 5.3-1.2 11.8c1.7 6.3 5.9 13.8 12.7 20.6s14.3 11.1 20.6 12.7c6.5 1.7 10.2 .4 11.8-1.2s2.9-5.3 1.2-11.8c-1.7-6.3-5.9-13.8-12.7-20.6s-14.3-11.1-20.6-12.7c-6.5-1.7-10.2-.4-11.8 1.2zm43.8 .2c8.5 8.5 14.4 18.4 16.9 27.9c2.4 9.3 1.9 19.9-5.4 27.2s-17.9 7.8-27.2 5.4c-9.5-2.5-19.4-8.4-27.9-16.9s-14.4-18.4-16.9-27.9c-2.4-9.3-1.9-19.9 5.4-27.2s17.9-7.8 27.2-5.4c9.5 2.5 19.4 8.4 27.9 16.9z'
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fast',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      'M175.4 48c-23.8 0-43.1 19.3-43.1 43.1c0 8.8 2.1 17.5 6.1 25.4l44.7 87.9 11.2 21.9-21.9-11.2L84.5 170.4c-7.9-4-16.5-6.1-25.4-6.1c-23.8 0-43.1 19.3-43.1 43.1v12l30.9 30.9 5.7 5.7-5.7 5.7L16 292.5v12c0 23.8 19.3 43.1 43.1 43.1c8.8 0 17.5-2.1 25.4-6.1l87.9-44.7 21.9-11.2-11.2 21.9-44.7 87.9c-4 7.9-6.1 16.6-6.1 25.4c0 23.8 19.3 43.1 43.1 43.1h12l30.9-30.9 5.7-5.7 5.7 5.7L260.5 464h12c23.8 0 43.1-19.3 43.1-43.1c0-8.8-2.1-17.5-6.1-25.4l-44.7-87.9-11.2-21.9 21.9 11.2 87.9 44.7c7.9 4 16.6 6.1 25.4 6.1c23.8 0 43.1-19.3 43.1-43.1v-12l-30.9-30.9-5.7-5.7 5.7-5.7L432 219.5V207.3c0-23.7-19.3-43-43-43c-8.9 0-17.6 2.1-25.5 6.2l-86.6 44.6-21.7 11.2 10.9-21.8 43.8-88c3.9-7.8 5.9-16.3 5.9-25c0-24-19.4-43.4-43.4-43.4H260.5L229.7 78.9 224 84.5l-5.7-5.7L187.5 48h-12zM331.7 91.4c0 11.2-2.6 22.2-7.5 32.1l-32.9 66.2 64.9-33.4c10.2-5.2 21.4-8 32.9-8c32.6 0 59 26.4 59 59v15.5 3.3l-2.3 2.3L418.1 256l27.6 27.6 2.3 2.3v3.3 15.3c0 32.7-26.5 59.1-59.1 59.1c-11.3 0-22.5-2.7-32.6-7.8l-66-33.6 33.6 66c5.1 10.1 7.8 21.3 7.8 32.6c0 32.7-26.5 59.1-59.1 59.1H257.2h-3.3l-2.3-2.3L224 450.1l-27.6 27.6-2.3 2.3h-3.3H175.4c-32.7 0-59.1-26.5-59.1-59.1c0-11.3 2.7-22.5 7.8-32.6l33.6-66-66 33.6c-10.1 5.1-21.3 7.8-32.6 7.8C26.5 363.7 0 337.2 0 304.6V289.2v-3.3l2.3-2.3L29.9 256 2.3 228.4 0 226.1v-3.3V207.4c0-32.7 26.5-59.1 59.1-59.1c11.3 0 22.5 2.7 32.6 7.8l66 33.6-33.6-66c-5.1-10.1-7.8-21.3-7.8-32.6c0-32.7 26.5-59.1 59.1-59.1h15.3 3.3l2.3 2.3L224 61.9l27.6-27.6 2.3-2.3h3.3 15.1c32.8 0 59.4 26.6 59.4 59.4z'
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fast',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      'M416 224c0-53-43-96-96-96c-13 0-25.4 2.6-36.7 7.3L298.2 147c6.9-2 14.3-3 21.8-3c44.2 0 80 35.8 80 80c0 1.1 0 2.3-.1 3.4l14.9 11.8c.8-4.9 1.2-10 1.2-15.1zM224 80c0-44.2-35.8-80-80-80c-9.3 0-18.1 1.6-26.4 4.5l15.7 12.4c3.5-.6 7-.9 10.7-.9c33.9 0 61.7 26.4 63.9 59.7l15.7 12.4c.3-2.7 .4-5.4 .4-8.2zM48 192L6 304H23.1l36-96H143l-20.3-16H48zM176 352L132.8 496 128 512h16.7H495.3 512l-4.8-16-.2-.6-21.9-17.3 5.4 17.9h-341l38.4-128H345.7l-20.3-16H176zM444 192c1.3 5.2 2.4 10.6 3 16H580.9l36 96H634L592 192H444zm4-112a64 64 0 1 1 128 0A64 64 0 1 1 448 80zm144 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fast',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      'M185.2 316.4L129.5 488.1 121.7 512l21.2-13.5L312.1 391.1V39.2 0l-16 35.7L224.5 195.6H46.1 18.9l22 16L185.2 316.4zM68.1 211.6H224.5h10.4l4.2-9.5L296.1 74.9V382.3L150.7 474.7l49.8-153.3 3.6-11.1-9.4-6.8L68.1 211.6z'
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fast',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      'M122 364.6l-6.7 6.7L38.6 448 80 489.4l76.7-76.7 6.7-6.7 9.1 2.7L282.4 441c2.5 6.6 5.5 13.1 8.9 19.3L168 424 91.3 500.7 80 512 68.7 500.7 27.3 459.3 16 448l11.3-11.3L104 360 64 224 276.7 11.3 288 0l11.3 11.3L516.7 228.7 528 240l-9.5 9.5c-4.6-3-9.4-5.7-14.4-8.2l1.2-1.2L288 22.6 82 228.6l37.3 126.9 2.7 9.1zm158.4-32c-2 5.8-3.6 11.7-4.9 17.7L138.6 213.9l-5.7-5.6 11.3-11.3 5.7 5.6L280.4 332.6zM431.9 496.1a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fast',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      'M480 400c-43.8 58.3-113.5 96-192 96s-148.2-37.7-192-96h48l32 48H400l32-48h48zm11-16H488 432V292.8l95.6-51c.3 4.7 .4 9.4 .4 14.2c0 47.1-13.5 91-36.9 128zM526 224.6l-94 50.1V272 256H416 160 144v16 2.7L50 224.6C65.4 106.9 166.1 16 288 16s222.6 90.9 238 208.6zm15-8C522 93.9 416 0 288 0S54 93.9 35 216.5l-6.3-3.4-7.5 14.1 7.1 3.8 4.7 2.5c-.6 7.4-1 14.9-1 22.4c0 141.4 114.6 256 256 256s256-114.6 256-256c0-7.6-.3-15-1-22.4l4.7-2.5 7.1-3.8-7.5-14.1-6.3 3.4zM48.4 241.8l95.6 51V384H88 84.9C61.5 347 48 303.1 48 256c0-4.8 .1-9.5 .4-14.2zM416 272V395.2L391.4 432H184.6L160 395.2V272H416zM184 312v16h8H384h8V312h-8H192h-8zm0 64v16h8H384h8V376h-8H192h-8zm56-208h8V152h-8c-53.3 0-89.5 22.1-101.7 34.3l-5.7 5.7L144 203.3l5.7-5.7c9.1-9.1 41.2-29.7 90.3-29.7zm186.3 29.7l5.7 5.7L443.3 192l-5.7-5.7C425.5 174.1 389.3 152 336 152h-8v16h8c49.1 0 81.2 20.5 90.3 29.7z'
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fast',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      'M16 80V432H624V80H16zM0 64H16 624h16V80 432v16H624 16 0V432 80 64zm80 80v96H336V144H80zM64 128H80 336h16v16 96 16H336 80 64V240 144 128zm0 240h8H344h8v16h-8H72 64V368zm320 0h8H568h8v16h-8H392h-8V368zM96 288v32H64V288H96zm32 0h32v32H128V288zm96 0v32H192V288h32zm32 0h32v32H256V288zm96 32H320V288h32v32z'
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fast',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm29.7-293.7l-5.7-5.7L220.7 128l5.7 5.7L292.7 200H104 96v16h8H292.7l-66.3 66.3-5.7 5.7L232 299.3l5.7-5.7 80-80 5.7-5.7-5.7-5.7-80-80z'
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fast',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      'M16 48H432v74.5l16-29.3V48 32H432 16 0V48 464v16H16 237l8.7-16H16V48zm80 56V96H80v8V280v8H96v-8V104zm64 0V96H144v8V280v8h16v-8V104zm96 408h18.2H621.8 640l-8.7-16L457.1 176.7 448 160l-9.1 16.7L264.7 496 256 512zm357-16H283L448 193.4 613 496zM456 296v-8H440v8 96 8h16v-8V296zM436 424v24h24V424H436z'
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fast',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      'M208 80A64 64 0 1 0 80 80a64 64 0 1 0 128 0zM64 80a80 80 0 1 1 160 0A80 80 0 1 1 64 80zM320 304a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-176a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM187.9 368L149.5 496H448v16H144.7 128l4.8-16L176 352H384v16H187.9zM196 192c-1.3 5.2-2.4 10.6-3 16H59.1l-36 96H6L48 192H196zM444 192H592l42 112H616.9l-36-96H447c-.7-5.4-1.7-10.8-3-16zM576 80A64 64 0 1 0 448 80a64 64 0 1 0 128 0zM432 80a80 80 0 1 1 160 0A80 80 0 1 1 432 80zm64 208h64 8v8 64h64 8v8 64 8h-8H568v64 8h-8H496h-8v-8V440H424h-8v-8V368v-8h8 64V296v-8h8zm8 80v8h-8H432v48h64 8v8 64h48V432v-8h8 64V376H560h-8v-8V304H504v64z'
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fast',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      'M160 432V416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432zm0-32h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM88 128a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168.4-28.8l6 8 120 160 1.6 2.1V296v16 8h-8H96 88v-8V296v-3.1l2.1-2.3 72-80 5.6-6.3 6 6 25.9 25.9 90.4-105.4 6.5-7.6zm-.8 25.6L206.1 253.2l-5.6 6.6-6.1-6.1-26-26L104 299.1V304H408v-5.3L295.6 148.8z'
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fast',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      'M124 0C90.9 0 64 26.9 64 60c0 23 13 43 32 53.1V152v8 16c0 70.7 57.3 128 128 128s128-57.3 128-128V160v-8V113.1C371 103 384 83 384 60c0-33.1-26.9-60-60-60c-21.4 0-40.2 11.2-50.8 28.1C262.6 11.2 243.8 0 222.4 0C202 0 184 10.1 173.2 25.7C162.4 10.1 144.4 0 124 0zM112 176V160H336v16c0 61.9-50.1 112-112 112s-112-50.1-112-112zM80 60c0-24.3 19.7-44 44-44c19.3 0 35.7 12.4 41.6 29.7h15.1C186.7 28.4 203.1 16 222.4 16c21 0 38.7 14.8 43 34.6H281C285.3 30.8 303 16 324 16c24.3 0 44 19.7 44 44c0 18.3-11.2 34-27.1 40.6l-4.9 2.1V108v36H112V108v-5.3l-4.9-2.1C91.2 94 80 78.3 80 60zM352 368h16 20.1l38.4 128H144V410.2l174.4-69.8L352 327.4V352v16zm-39.5-42.4L224 360 96 310.2 80 304v17.2V336v16H64 48L4.8 496 0 512H16.7 431.3 448l-4.8-16L400 352H384 368V336 321.2 304l-16 6.2-26.9 10.5 0-.1-12.5 5zm-109 43.6L133 397.4l-5 2v5.4V496H21.5L59.9 368H80 96V352 327.4l107.5 41.8zM240 444a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm76-12a12 12 0 1 0 -24 0 12 12 0 1 0 24 0z'
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fast',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M16 48l480 0 0 112L16 160 16 48zM248 176l0 128L16 304l0-128 232 0zm16 0l232 0 0 128-232 0 0-128zM248 320l0 144L16 464l0-144 232 0zm16 144l0-144 232 0 0 144-232 0zM0 464l0 16 16 0 480 0 16 0 0-16 0-416 0-16-16 0L16 32 0 32 0 48 0 464z'
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fast',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 248H8 312h8v16h-8H8 0V248z'
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fast',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      'M189.1 112H192h80 2.9l2.2 1.9L320 149.6l42.9-35.7 2.2-1.9H368h80 2.9l2.2 1.9 91.8 76.5L628.2 145l11.8-6.5 0 13.5 0 51.7c0 104-84.3 188.3-188.3 188.3c-45.6 0-89.7-16.6-124-46.6l-7.8-6.8-7.8 6.8c-34.3 30-78.4 46.6-124 46.6C84.3 392 0 307.7 0 203.7L0 152l0-13.5L11.8 145l83.2 45.4 91.8-76.5 2.2-1.9zm5.8 16l-93.8 78.1-4.2 3.5L92.2 207 16 165.5l0 38.3C16 298.9 93.1 376 188.3 376c41.7 0 82-15.1 113.4-42.6l13-11.4 5.3-4.6 5.3 4.6 13 11.4C369.7 360.9 410 376 451.7 376C546.9 376 624 298.9 624 203.7l0-38.3L547.8 207l-4.8 2.6-4.2-3.5L445.1 128H370.9l-45.8 38.1-5.1 4.3-5.1-4.3L269.1 128H194.9z'
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fast',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      'M58.4 132.1c-17.6 13.2-33.9 29.4-41.7 47.3c.2 .3 .3 .7 .5 1.1c1.3 2.6 3.5 6.5 6.7 11.2c6.5 9.4 17.3 22.2 34.5 35.1c34.3 25.7 94.5 52.1 197.6 52.1s163.3-26.5 197.6-52.1c17.2-12.9 28-25.6 34.5-35.1c3.2-4.7 5.4-8.6 6.7-11.2c.2-.4 .4-.8 .5-1.1c-7.9-17.8-24.1-34.1-41.7-47.3C419.3 106.5 359.1 80 256 80S92.7 106.5 58.4 132.1zM16 207.9v123c7.6 18.5 24.3 35.3 42.4 48.9c34.3 25.7 94.5 52.1 197.6 52.1s163.3-26.5 197.6-52.1c18.2-13.6 34.8-30.3 42.4-48.9v-123c-7.4 9.5-18 20.6-32.8 31.7c-37.5 28.1-101.2 55.3-207.2 55.3s-169.7-27.3-207.2-55.3C34 228.5 23.4 217.4 16 207.9zm447.2-88.6c19.8 14.8 40.2 34.9 48.8 58.7V333.9c-8.7 24-29 43.9-48.8 58.7c-37.5 28.1-101.2 55.3-207.2 55.3s-169.7-27.3-207.2-55.3C29.1 377.8 8.7 357.8 0 333.9V178.1c8.7-23.8 29.1-43.9 48.8-58.7C86.3 91.3 150.1 64 256 64s169.7 27.3 207.2 55.3z'
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fast',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      'M0 0H8 248h8V8 504v8H240v-8V464H16v40 8H0v-8V8 0zM240 112H16V448H240V112zm0-16V16H16V96H240zM176 216h8 32 8v16h-8H192v80h24 8v16h-8H184h-8v-8V224v-8zM320 0h8H568h8V8 504v8H560v-8V464H336v40 8H320v-8V8 0zM560 112H336V448H560V112zm0-16V16H336V96H560zM496 216h8 32 8v16h-8H512v80h24 8v16h-8H504h-8v-8V224v-8z'
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fast',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      'M199.8 63.9L169.4 15.1 160 0l-9.4 15.1L120.2 63.9l-56-13-17.4-4 4 17.4 13 56L15.1 150.6 0 160l15.1 9.4 48.8 30.4-13 56-4 17.4 17.4-4 56-13 30.4 48.8L160 320l9.4-15.1 30.4-48.8 56 13 17.4 4-4-17.4-13-56 48.8-30.4L320 160l-15.1-9.4-48.8-30.4 13-56 4-17.4-17.4 4-56 13zm51.9 4.4l-11.2 48.3-2.6 11.2 9.7 6.1L289.7 160l-42.1 26.2-9.7 6.1 2.6 11.2 11.2 48.3-48.3-11.2-11.2-2.6-6.1 9.7L160 289.7l-26.2-42.1-6.1-9.7-11.2 2.6L68.3 251.7l11.2-48.3 2.6-11.2-9.7-6.1L30.3 160l42.1-26.2 9.7-6.1-2.6-11.2L68.3 68.3l48.3 11.2 11.2 2.6 6.1-9.7L160 30.3l26.2 42.1 6.1 9.7 11.2-2.6 48.3-11.2zm-43.1 92.9a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM496 160c0-22.1 17.9-40 40-40s40 17.9 40 40v56.5c-12.6 1.5-23.8 6.6-32.3 15.1c-10.2 10.3-15.7 25-15.7 42.5c0 12.1 6.4 26.9 15.3 41.1c9.1 14.5 21.5 29.7 35.2 42.6L584 363l5.5-5.2c13.7-13 26.2-28.2 35.2-42.7c8.9-14.2 15.3-29.1 15.3-41c0-17.5-5.5-32.1-15.7-42.5c-8.5-8.6-19.6-13.6-32.3-15.1V160c0-30.9-25.1-56-56-56s-56 25.1-56 56v56.2c-12.5-14.8-31.1-24.2-52-24.2c-37.6 0-68 30.4-68 68v20.5c-12.6 1.5-23.8 6.6-32.3 15.1c-10.2 10.3-15.7 25-15.7 42.5c0 12.1 6.4 26.9 15.3 41.1c9.1 14.5 21.5 29.7 35.2 42.6L368 427l5.5-5.2c13.7-13 26.2-28.2 35.2-42.7c8.9-14.2 15.3-29.1 15.3-41c0-17.5-5.5-32.1-15.7-42.5c-8.5-8.6-19.6-13.6-32.3-15.1V260c0-28.7 23.3-52 52-52s52 23.3 52 52v20V496H8 0v16H8 488 632h8V496h-8H496V280 260 160zm88 72c12.3 0 22.2 4 28.9 10.8S624 260 624 274c0 7.3-4.3 18.9-12.9 32.6C604 318 594.6 330 584 340.8c-10.6-10.8-20.1-22.7-27.1-34.1C548.3 293.1 544 281.5 544 274c0-14.1 4.4-24.4 11.1-31.2S571.7 232 584 232zM395.1 370.6C388 382 378.6 394 368 404.8c-10.6-10.8-20.1-22.7-27.1-34.1c-8.5-13.6-12.8-25.3-12.8-32.7c0-14.1 4.4-24.4 11.1-31.2S355.7 296 368 296s22.2 4 28.9 10.8s11.1 17.2 11.1 31.2c0 7.3-4.3 18.9-12.9 32.6z'
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fast',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      'M384 59.5L496 22.2V148.5L384 185.8V128 59.5zM368 48v80 63.1V208 390.8c-19.6-23.2-55.3-38.8-96-38.8c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V202.7L512 160V16.9 0L496 5.3 368 48zm0 384c0 15.6-8.8 31.2-26.1 43.5C324.6 487.9 300 496 272 496s-52.6-8.1-69.9-20.5c-17.3-12.3-26.1-28-26.1-43.5s8.8-31.2 26.1-43.5C219.4 376.1 244 368 272 368s52.6 8.1 69.9 20.5c17.3 12.3 26.1 28 26.1 43.5zM8 64H0V80H8 280h8V64h-8H8zM8 192H0v16H8 280h8V192h-8H8zM8 320H0v16H8 152h8V320h-8H8z'
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fast',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      'M16 112a96 96 0 1 1 192 0A96 96 0 1 1 16 112zm208 0C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c32.4 0 61.6-13.8 82.1-35.8L249.4 235l24.8 21-80.1 67.8c-20.5-22-49.6-35.8-82.1-35.8C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-23.7-7.4-45.7-19.9-63.8L509.2 78.1 498.8 65.9 286.5 245.5l-24.8-21-57.7-48.8C216.6 157.7 224 135.7 224 112zM112 304a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm199.3-16.6L498.8 446.1l10.3-12.2L323.7 277l-12.4 10.5z'
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fast',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16l0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32l16 0 416 0 16 0zM160 128l16 0 24 0L320 256 200 384l-24 0-16 0 0-16 0-224 0-16zm33.1 240l105-112-105-112L176 144l0 224 17.1 0z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fast',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      'M400 464V192c0-97.2-78.8-176-176-176S48 94.8 48 192V464H32V192C32 86 118 0 224 0S416 86 416 192V464H400zM0 496H8 440h8v16h-8H8 0V496zM232 136v72h80 8v16h-8H232V376v8H216v-8V224H136h-8V208h8 80V136v-8h16v8z'
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fast',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      'M217.4 90.1L184.8 19.2 176 0l-8.8 19.2L134.6 90.1 58.9 71.3 38.4 66.3l9.5 18.8L83 154.8 21.1 202.3 4.4 215.2 25 219.5l76.4 16-1.4 78-.4 21.1 16.2-13.4L176 271.4l56.7 46.9c-5.9-10.4-10.8-21.4-14.7-32.9l-31.8-26.3L176 250.6l-10.2 8.4-49.5 41 1.2-64.3 .2-13.2-13-2.7L41.8 206.6l51-39.2 10.5-8.1-6-11.8L68.4 90.2l62.4 15.4 12.9 3.2 5.5-12L176 38.3l26.9 58.4 5.5 12 12.9-3.2L256 97c7.1-8 14.8-15.5 23.2-22.2L217.4 90.1zM520 0h-8V16h8 92.7l-97.2 97.2C486.3 82.9 445.4 64 400 64c-88.4 0-160 71.6-160 160c0 85.7 67.4 155.6 152 159.8v.2 48H344h-8v16h8 48v56 8h16v-8V448h48 8V432h-8H408V384v-.2c84.6-4.2 152-74.1 152-159.8c0-37.2-12.7-71.5-34-98.7l98-98V120v8h16v-8V8 0h-8H520zM256 224a144 144 0 1 1 288 0 144 144 0 1 1 -288 0z'
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fast',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      'M567.3 189.5C573 210.7 576 233 576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-23 3-45.3 8.7-66.5C50.3 158 8 90.4 1 19.7C.3 13.1 0 6.6 0 0C0 0 5.4 4.1 16.3 9.9C40.2 22.9 90.6 44.5 167.4 50.5C210 18.8 262.8 0 320 0s110 18.8 152.6 50.5c76.8-5.9 127.1-27.6 151.1-40.5C634.6 4.1 640 0 640 0c0 6.6-.3 13.1-1 19.7c-7 70.7-49.3 138.4-71.7 169.9zm-77-124.7c31.7 28.3 56.4 64.4 70.9 105.3c6.5-9.7 14-21.5 21.4-34.9c16.9-30.5 33.2-68 39-106.3c-7.8 3.8-17.1 7.9-28.1 12c-25.7 9.6-60.1 19.1-103.3 23.9zm-340.6 0C106.5 60.1 72.1 50.6 46.4 41c-11-4.1-20.3-8.3-28.1-12c5.9 38.3 22.1 75.8 39 106.3c7.5 13.4 14.9 25.3 21.4 34.9c14.5-40.9 39.2-77 70.9-105.3zM560 256A240 240 0 1 0 80 256a240 240 0 1 0 480 0zM386.1 413.4C373.3 399.1 351.3 384 320 384s-53.3 15.1-66.1 29.4l-5.4 5.9-11.9-10.7 5.4-5.9C257.1 386 283.1 368 320 368s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7-5.4-5.9zM224.4 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.9 197.9l7.6 2.5 96 32 7.6 2.5-5.1 15.2-7.6-2.5-96-32-7.6-2.5 5.1-15.2zm271.2 15.2l-7.6 2.5-96 32-7.6 2.5-5.1-15.2 7.6-2.5 96-32 7.6-2.5 5.1 15.2z'
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fast',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      'M248 0h16V64H432l80 96-80 96H264V512H248V256H48 32V240 80 64H48 248V0zM491.2 160L424.5 80H48V240H424.5l66.7-80z'
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fast',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      'M128 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM47.3 176L40.7 336H64h48 31.4l16 16H152V496h32V376.6l16 16V504v8h-8H144h-8v-8V352H120V504v8h-8H64 56v-8V352H40 24l.7-16L32 160H224l1.3 30.2-13.5 13.5-1.8 1.8L208.7 176H47.3zM440 504V392.6l16-16V496h32V352h-7.4l16-16H528h48 23.3l-6.7-160H431.3l-1.2 29.5-1.8-1.8-13.5-13.5L416 160H608l7.3 176 .7 16H600 584V504v8h-8H528h-8v-8V352H504V504v8h-8H448h-8v-8zM104 352H72V496h32V352zM512 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zm56 496V352H536V496h32zM245.7 237.7L187.3 296H452.7l-58.3-58.3-5.7-5.7L400 220.7l5.7 5.7 72 72 5.7 5.7-5.7 5.7-72 72-5.7 5.7L388.7 376l5.7-5.7L452.7 312H187.3l58.3 58.3 5.7 5.7L240 387.3l-5.7-5.7-72-72-5.7-5.7 5.7-5.7 72-72 5.7-5.7L251.3 232l-5.7 5.7z'
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fast',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      'M40 0H32V8 40v8H48V40 16H464V40v8h16V40 8 0h-8H40zM16 80v8 32 8H32v-8V96H480v24 8h16v-8V88 80h-8H24 16zM54.3 496L17.9 176H494.1l-1.8 16c1.2 0 2.5 0 3.7 0c4.1 0 8.2 .1 12.3 .4l1.9-16.4 1.8-16H495.9 16.1 0l1.8 16L40 512H394.8c-6.9-4.9-13.4-10.2-19.6-16H54.3zM256 208c-97.2 0-176 59.1-176 132s78.8 132 176 132c31.6 0 61.2-6.2 86.9-17.2c-2.6-4.6-5.1-9.4-7.3-14.3C312.3 450.3 285.2 456 256 456c-45.5 0-86-13.8-114.9-35.5S96 370.3 96 340s16.3-58.9 45.1-80.5S210.5 224 256 224c41.2 0 78.3 11.3 106.3 29.5c3.5-4.1 7.2-8.1 11.1-11.8C342.3 220.7 301.1 208 256 208zm25.8 160.6C289 363.8 296 355.4 296 344s-7-19.8-14.2-24.6c-7.3-4.9-16.5-7.4-25.8-7.4s-18.5 2.5-25.8 7.4C223 324.2 216 332.6 216 344s7 19.8 14.2 24.6c7.3 4.9 16.5 7.4 25.8 7.4s18.5-2.5 25.8-7.4zM256 360c-13.3 0-24-7.2-24-16s10.7-16 24-16s24 7.2 24 16s-10.7 16-24 16zm112 8a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM504 296v-8H488v8 64H424h-8v16h8 64v64 8h16v-8V376h64 8V360h-8H504V296z'
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fast',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      'M352 32h-5.8l-1.8 5.5L206.5 451.1 95.2 228.4 92.9 224H88 8 0v16H8 83.1L200.8 475.6l2.2 4.4h10.7l1.8-5.5L357.8 48H568h8V32h-8H352z'
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fast',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      'M24 96H16v8V232v2.9l1.9 2.2 38 45.6L49.5 384h16L72 280.5l.2-3.2-2-2.4L32 229.1V112H72v40 8h8 48 8v-8V112h47.5v40 8h8H240h8v-8V112h40V229.1l-38.1 45.8-2 2.4 .2 3.2L254.5 384h16l-6.3-101.3 38-45.6 1.9-2.2V232 104 96h-8H240h-8v8 40H199.5V104 96h-8H128h-8v8 40H88V104 96H80 24zM44.3 416l-2.4 2.9-40 48L0 469.1V472v32 8H8 312h8v-8V472v-2.9l-1.9-2.2-40-48-2.4-2.9H272 48 44.3zm7.5 16H268.3L304 474.9V496H16V474.9L51.7 432zM160 224c-17.7 0-32 14.3-32 32v40 8h8 48 8v-8V256c0-17.7-14.3-32-32-32zm-16 32c0-8.8 7.2-16 16-16s16 7.2 16 16v32H144V256z'
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fast',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M400 16v96h96V16H400zM384 0h16 96 16V16v96 16H496 400 384V112 16 0zM287 12.7l6.1 5.1 48 40 7.4 6.1-7.4 6.1-48 40-6.1 5.1L276.7 103l6.1-5.1 31-25.9H16V248H504h8v8V448v8h-8H416v40 16H400 304 288V496 400 384h16 96 16v16 40h80V264H8 0v-8V64 56H8 313.9l-31-25.9L276.7 25 287 12.7zM128 400v40h89.9l-31-25.9-6.1-5.1L191 396.7l6.1 5.1 48 40 7.4 6.1-7.4 6.1-48 40-6.1 5.1L180.7 487l6.1-5.1 31-25.9H128v40 16H112 16 0V496 400 384H16h96 16v16zm-16 0H16v96h96V400zm192 0v96h96V400H304z'
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fast',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      'M80 496H16V16H208V168v8h8H368V304h16V160L224 0H16 0V16 496v16H16 80V496zM361.4 160H224V22.6L361.4 160zM248 376v-8l-8 0-5.6 0-4.6 0-2.3 3.9-35.6 60.5-37-60.6-2.3-3.8-4.5 0-4 0-8 0v8V504v8h16v-8V397.9l33.2 54.3 7 11.4 6.8-11.5L232 395.8V504v8h16v-8V376zm56-8h-8v8 80 48 8h16v-8V464h24c26.5 0 48-21.5 48-48s-21.5-48-48-48H304zm32 80H312V384h24c17.7 0 32 14.3 32 32s-14.3 32-32 32zm96-80h-8v16h8 32c13.3 0 24 10.7 24 24s-10.7 24-24 24H440h-8v16h8 24c13.3 0 24 10.7 24 24s-10.7 24-24 24H432h-8v16h8 32c22.1 0 40-17.9 40-40c0-13.1-6.3-24.7-16-32c9.7-7.3 16-18.9 16-32c0-22.1-17.9-40-40-40H432z'
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fast',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      'M139.3 11.3L128 0 116.7 11.3 11.3 116.7 0 128l11.3 11.3 98.1 98.1 11.3-11.3L22.6 128 128 22.6l47 47-44.7 44.7-5.7 5.7L136 131.3l5.7-5.7L186.3 81l39.7 39.7 11.3-11.3L139.3 11.3zM372.7 500.7L384 512l11.3-11.3L500.7 395.3 512 384l-11.3-11.3-98.1-98.1-11.3 11.3L431 325.7l-44.7 44.7-5.7 5.7L392 387.3l5.7-5.7L442.3 337l47 47L384 489.4l-98.1-98.1-11.3 11.3 98.1 98.1zM4.4 494.4L0 512l17.6-4.4L160 472 500.7 131.3 512 120l-11.3-11.3L403.3 11.3 392 0 380.7 11.3 40 352 4.4 494.4zM22 490L54.4 360.2 313.7 101 411 198.3 151.8 457.6 22 490zM489.4 120l-67 67L325 89.7l67-67L489.4 120z'
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fast',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      'M200 64h-8V80h8 48v64.1C128 148.4 32 247 32 368v32H48V368c0-114.9 93.1-208 208-208s208 93.1 208 208v32h16V368c0-121-96-219.6-216-223.9V80h48 8V64h-8H256 200zM8 432H0v16H8 504h8V432h-8H8z'
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fast',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM300.5 112.3l.2-.2 40.1 40.1 11.3 11.3-11.3 11.3L220.9 294.7l-44.3 6.9L160 304.1l2.6-16.6 6.9-44.3 131-131zm.2 22.4L279.3 156l28.8 28.8 21.4-21.4-28.8-28.8zM184.5 250.9L179.2 285l34.1-5.3 83.5-83.5L268 167.3l-83.5 83.5z'
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fast',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 16c-32.6 0-60.9 18.3-75.2 45.2l-3.1 5.8-6.3-1.9c-29.1-8.9-62.1-1.9-85.1 21.1s-30.1 56-21.1 85.1l1.9 6.3-5.8 3.1C34.3 195.1 16 223.4 16 256s18.3 60.9 45.2 75.2l5.8 3.1-1.9 6.3c-8.9 29.1-1.9 62.1 21.1 85.1s56 30.1 85.1 21.1l6.3-1.9 3.1 5.8C195.1 477.7 223.4 496 256 496s60.9-18.3 75.2-45.2l3.1-5.8 6.3 1.9c29.1 8.9 62.1 1.9 85.1-21.1s30.1-56 21.1-85.1l-1.9-6.3 5.8-3.1C477.7 316.9 496 288.6 496 256s-18.3-60.9-45.2-75.2l-5.8-3.1 1.9-6.3c8.9-29.1 1.9-62.1-21.1-85.1s-56-30.1-85.1-21.1l-6.3 1.9-3.1-5.8C316.9 34.3 288.6 16 256 16zM169.9 48.2C187.7 19.3 219.6 0 256 0s68.3 19.3 86.1 48.2c33-7.9 69.2 1.1 94.9 26.8s34.7 62 26.8 94.9C492.7 187.7 512 219.6 512 256s-19.3 68.3-48.2 86.1c7.9 33-1.1 69.2-26.8 94.9s-61.9 34.7-94.9 26.8C324.3 492.7 292.4 512 256 512s-68.3-19.3-86.1-48.2c-33 7.9-69.2-1.1-94.9-26.8s-34.7-61.9-26.8-94.9C19.3 324.3 0 292.4 0 256s19.3-68.3 48.2-86.1c-7.9-33 1.1-69.2 26.8-94.9s61.9-34.7 94.9-26.8z'
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fast',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      'M66.4 33.2l7 1.2 80 13.8 7.9 1.4-2.7 15.8-7.9-1.4-73-12.6L16.4 256H240h16v16 16h64V272 256h16H559.6L498.4 51.3l-73 12.6-7.9 1.4-2.7-15.8 7.9-1.4 80-13.8 7-1.2 2 6.8 64 213.8 .3 1.1V256v16 24 8V464v16H560 336 320V464 304H256V464v16H240 16 0V464 304v-8V272 256v-1.2l.3-1.1 64-213.8 2-6.8zM560 304v-8V272H336v24 83.1l100.4-50.2 7.2-3.6 7.2 14.3-7.2 3.6L336 396.9v59.2l148.2-79.2 7.1-3.8 7.5 14.1-7.1 3.8L355.3 464H560V304zM16 296v8 79.1l108.4-54.2 7.2-3.6 7.2 14.3-7.2 3.6-112 56L16 400.9v59.5l156.2-83.5 7.1-3.8 7.5 14.1-7.1 3.8L43.3 464H240V296 272H16v24z'
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fast',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      'M460.2 414.1l-8.1 13.2 12.9 8.6 31 20.7V496H380 132 16V456.6l31-20.7 12.9-8.6-8.1-13.2C29.1 377.5 16 334.3 16 288C16 155.5 123.5 48 256 48s240 107.5 240 240c0 46.3-13.1 89.5-35.8 126.1zM512 496V448l-38.2-25.4C498 383.5 512 337.4 512 288C512 146.6 397.4 32 256 32S0 146.6 0 288c0 49.4 14 95.5 38.2 134.6L0 448v48 16H16 132 380 496h16V496zM400 288c0 12.8-1.7 25.2-4.8 37l-76.4-24.9c.8-3.9 1.1-8 1.1-12.1c0-18.4-7.7-34.9-20.1-46.6l47.2-65C379.4 202.8 400 243 400 288zm-86.1 27.3l76.4 24.9c-20 51.4-68.6 88.5-126.3 91.6l0-80.3c22.1-2.7 40.8-16.8 50-36.2zm-66 36.2l0 80.3c-57.6-3.2-106.3-40.2-126.2-91.6l76.4-24.9c9.2 19.4 27.7 33.4 49.8 36.2zM112 288c0-45 20.6-85.2 52.9-111.6l38 52.3 9.2 12.7C199.7 253.1 192 269.6 192 288c0 4.1 .4 8.2 1.1 12.1L116.8 325c-3.1-11.8-4.8-24.2-4.8-37zm144-64c-11.2 0-21.8 2.9-31 8l-9.2-12.6-38-52.3c22.5-14.6 49.3-23 78.1-23s55.6 8.5 78.1 23L287 232c-9.2-5.1-19.7-8-31-8zm160 64A160 160 0 1 0 96 288a160 160 0 1 0 320 0zm-208 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fast',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      'M217.3 0h13.3 5.2L238 4.8l18.7 42.5L299.2 66l4.8 2.1v5.2V86.7v5.2L299.2 94l-42.5 18.7L238 155.2l-2.1 4.8h-5.2H217.3h-5.2l-2.1-4.8-18.7-42.5L148.8 94 144 91.9V86.7 73.3 68.1l4.8-2.1 42.5-18.7L210 4.8 212.1 0h5.2zM204.7 56.6l-1.3 2.8-2.8 1.3L160 78.5v2.9l40.6 17.9 2.8 1.3 1.3 2.8L222.5 144h2.9l17.9-40.6 1.3-2.8 2.8-1.3L288 81.5V78.5L247.4 60.7l-2.8-1.3-1.3-2.8L225.5 16h-2.9L204.7 56.6zM24 312L156.2 132.2 167 137l2.1 4.7L40 317.2V336H80h29.9L93.3 360.9 16 476.8V496H432V476.8l-77.3-116L338.1 336H368h40V317.2L278.9 141.7 281 137l10.8-4.8L424 312v24 16H408 387.2 368l10.7 16L448 472v24 16H432 16 0V496 472L69.3 368 80 352H60.8 40 24V336 312zm136-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fast',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      'M264 32h-8V48h8 83.1l20.2 39.4-111.6 79-30.3-18.9c-20.3-12.7-43.9-19.5-67.8-19.5H40c-4.4 0-8 3.6-8 8v48 8h8 71.8c94.2 0 171.7 74.2 175.8 168.4l.3 8 .3 7.7H296h48 8v-8V352c0-59.2 32.2-110.9 79.9-138.6L446.6 242C409.1 264.3 384 305.2 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-18.2 0-35.5 3.8-51.2 10.6L406.1 128H504h8v-8V40 32h-8H448h-2.5l-2.1 1.5L380.5 78 359.1 36.3 356.9 32H352 264zm-3.4 150.5l114-80.8 50 97.4C371.7 229.5 336 286.6 336 352v8H303.7l0-.3C299.2 257 214.6 176 111.8 176H48V144H157.6c21 0 41.6 5.9 59.4 17l34.8 21.8 4.5 2.8 4.3-3.1zM496 112H397.9L387.9 92.4 450.5 48H496v64zM453.9 256.2l51 99.4 3.7 7.1 14.2-7.3-3.6-7.1-51-99.4c13.5-5.7 28.3-8.9 43.9-8.9c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-40.6 21.6-76.1 53.9-95.8zM239.7 344H191.5c-3.9-31.6-30.9-56-63.5-56c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56h48.2c-4.1 58.1-52.6 104-111.7 104C66.1 464 16 413.9 16 352s50.1-112 112-112c59.2 0 107.6 45.9 111.7 104zm-64.4 0H128h-8v16h8 47.3c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48s21.5-48 48-48c23.8 0 43.5 17.3 47.3 40zM128 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fast',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      'M288 32v8V64H496h16V80 208v16H496 288v24 8H272v-8V224H16 0V208 80 64H16 272V40 32h16zM160 80V208H272V80H160zm128 0V208H496V80H288zM144 80H16V208H144V80zM384 256v8 24H496h16v16V432v16H496 384v24 8H368v-8V448H16 0V432 304 288H16 368V264v-8h16zM224 304V432H368V304H224zm160 0V432H496V304H384zm-176 0H16V432H208V304z'
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fast',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      'M204.6 307.4l-7.6-2.5L50.6 256l146.5-48.8 7.6-2.5 2.5-7.6L256 50.6l48.8 146.5 2.5 7.6 7.6 2.5L461.4 256 314.9 304.8l-7.6 2.5-2.5 7.6L256 461.4 207.2 314.9l-2.5-7.6zM25.3 264.4L192 320l55.6 166.7L256 512l8.4-25.3L320 320l166.7-55.6L512 256l-25.3-8.4L320 192 264.4 25.3 256 0l-8.4 25.3L192 192 25.3 247.6 0 256l25.3 8.4zM360 348.7L348.7 360l5.7 5.7 80 80 5.7 5.7L451.3 440l-5.7-5.7-80-80-5.7-5.7zm-5.7-202.3l-5.7 5.7L360 163.3l5.7-5.7 80-80 5.7-5.7L440 60.7l-5.7 5.7-80 80zM72 60.7L60.7 72l5.7 5.7 80 80 5.7 5.7L163.3 152l-5.7-5.7-80-80L72 60.7zM66.3 434.3L60.7 440 72 451.3l5.7-5.7 80-80 5.7-5.7L152 348.7l-5.7 5.7-80 80z'
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fast',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.8 335.2c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0l5.7 5.7 11.3-11.3-5.7-5.7c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0l5.7-5.7-11.3-11.3-5.7 5.7c-43.7 43.7-114.7 43.7-158.4 0z'
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fast',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M80.4 0H208c40 0 52 24 64 48s24 48 64 48h95.1H448l-5.3 16-64 192H408h8v16h-8H104 96V304h8 27.6L67.6 16 64 0H80.4zM361.8 304l64-192H336c-23.7 0-40.7-7.3-53.5-19.4c-11.6-11-18.7-25.1-24.3-36.5l-.5-1c-6.3-12.5-11.1-21.8-18.2-28.5C233.3 20.7 224.3 16 208 16H83.9l64 288H361.8zM496 240H433.7l5.3-16H496h16v16V496v16H496 16 0V496 240 224H16 81l3.6 16H16V384H496V240zm0 160H16v96H496V400z'
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fast',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      'M387.6 401.1l-14.3-11.3C356.8 396.4 338.8 400 320 400c-79.5 0-144-64.5-144-144V234l-16-12.6V256c0 85.7 67.4 155.6 152 159.8V496H232h-8v16h8 88 88 8V496h-8H328V415.8c21.2-1 41.3-6.2 59.6-14.7zM240 101.1V16H400V227.4l16 12.6V16 0H400 240 224V16 88.5l16 12.6zM476.8 288c2.1-10.4 3.2-21.1 3.2-32V200v-8H464v8 56c0 7.1-.5 14-1.5 20.8L476.8 288zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fast',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      'M112 48V96h80V48H112zM96 96V48 32h16 80 16V48 96h16v16 16h64V112 96h16V48 32h16 80 16V48 96h32l16 128 48 80V464v16H496 304 288V464 288H224V464v16H208 16 0V464 304l48-80L64 96H96zm0 16H78.1L63.9 226l-.4 3.4-1.7 2.9L16 308.4V464H208V280 136 112H192 112 96zM400 96V48H320V96h80zm-80 16H304v24V280 464H496V308.4l-45.7-76.2-1.7-2.9-.4-3.4L433.9 112H416 400 320zM224 272h64V144H224V272z'
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fast',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      'M360 0h-8V8 396.2L13.9 488.3l-7.7 2.1 4.2 15.4 7.7-2.1 398-108.4c-.1 1.6-.1 3.1-.1 4.7c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-54.4 0-99.7 38.7-109.9 90.1L368 391.8V16H632h8V0h-8H360zM528 304a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fast',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM367.3 201.6L560 139V323.8c-17.2-21.6-46.6-35.8-80-35.8c-1.1 0-2.1 0-3.2 0l22.5 17.8c29.2 5.7 50.6 24.2 57.9 45.7L576 366.4V128 16 5.2L565.7 8.3l-320 96-1.2 .3 15.3 12.1L560 26.8v95.4L352.2 189.7l15.1 11.9zM240 284.6V387.8c-17.2-21.6-46.6-35.8-80-35.8c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80v0V297.2l-16-12.6zM240 432v0c0 32.7-33 64-80 64s-80-31.3-80-64s33-64 80-64s80 31.3 80 64z'
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fast',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      'M144 209.8l-8 4.6-35.1 20.3c-29.7 17.1-50.7 53.5-64.4 88.5c-6.7 17.1-11.3 33.1-14.3 44.8c-.5 1.8-.9 3.6-1.3 5.2c1.6 .5 3.3 1 5.1 1.5c11.6 3.3 27.8 7.3 45.9 10c37.2 5.7 79.2 5.7 108.9-11.5L216 353l8-4.6 8 4.6 35.1 20.3c29.7 17.1 71.6 17.1 108.9 11.5c18.2-2.8 34.3-6.7 45.9-10c1.8-.5 3.5-1 5.1-1.5c-.4-1.6-.8-3.3-1.3-5.2c-3-11.7-7.6-27.7-14.3-44.8c-13.7-35.1-34.7-71.4-64.4-88.5L312 214.4l-8-4.6v-9.2V160c0-34.3-21-70.6-44.5-100c-11.5-14.4-23-26.4-31.7-34.8c-1.4-1.3-2.6-2.6-3.8-3.7c-1.2 1.1-2.5 2.4-3.8 3.7C211.5 33.6 200 45.6 188.5 60C165 89.4 144 125.7 144 160v40.6 9.2zm-16-9.2V160C128 80 224 0 224 0s96 80 96 160v40.6l35.1 20.3c69.3 40 90.6 163.1 90.6 163.1s-117.3 43.1-186.6 3.1L224 366.9l-35.1 20.3C119.6 427.1 2.3 384 2.3 384s21.3-123.1 90.6-163.1L128 200.6zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm48 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM101.1 122.3c-1.4 5.2-2.5 10.5-3.3 15.8c-26-9.3-46.5-11.5-61.3-11c-10 .3-17.6 1.9-22.9 3.4c1.3 5.4 3.8 12.8 8.5 21.6c7 13.1 19.1 29.7 40.1 47.6c-4.1 3.5-8 7.2-11.8 11C-5.5 162.6-4 120.5-4 120.5s35.7-22.3 105.1 1.9zm72.3 299.5c5.2-1.3 10.3-2.9 15.4-4.8c5 26.1 13.1 44.3 20.8 56.6c5.3 8.5 10.4 14.3 14.4 18.1c4-3.8 9.2-9.7 14.4-18.1c7.7-12.3 15.8-30.5 20.8-56.6c5.1 1.9 10.2 3.4 15.4 4.8C260.5 492.6 224 512 224 512s-36.5-19.4-50.6-90.2zM398.6 211.7c-3.7-3.9-7.6-7.6-11.7-11.1c21.6-18.2 34-35.1 41.1-48.4c4.7-8.8 7.2-16.2 8.5-21.6c-5.3-1.5-13-3.1-22.9-3.4c-15.2-.5-36.3 1.8-63.2 11.6c-.8-5.3-1.9-10.6-3.3-15.8c70.6-25.2 106.9-2.5 106.9-2.5s1.5 42.7-55.4 91.2z'
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fast',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      'M560 16V96H200V48 16H560zM112 16h72V48 96H112V16zm0 384V112h80H560V400H112zM112 0H96V16 400v16h16H560h16V400 16 0H560 112zM16 104V96H0v8V504v8H8 472h8V496h-8H16V104z'
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fast',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      'M0 0H16V89.8L128 119v16.5L6 103.7l-6-1.6V96 0zM256 119L368 89.8V0h16V96v6.2l-6 1.6L256 135.6V119zM160 40c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8V240h88 8v16h-8H216 168 72 64V240h8 88V40zm16 200h32V48H176V240zm-32 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0A16 16 0 1 1 0 464z'
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fast',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      'M304.1 11.2l-5.7 5.7L291.3 24 488 220.7l7.1-7.1 5.7-5.7 11.3 11.3-5.7 5.7-12.8 12.8-112 112 0 0-12.8 12.8-5.7 5.7-11.3-11.3 5.7-5.7 7.1-7.1L168 147.3l-7.1 7.1-5.7 5.7-11.3-11.3 5.7-5.7 12.8-12.8 112-112L287.1 5.5l5.7-5.7 11.3 11.3zM179.3 136L376 332.7 476.7 232 280 35.3 179.3 136zm-72 364.7L96 512 84.7 500.7 11.3 427.3 0 416l11.3-11.3L132.7 283.3 144 272l11.3 11.3 31 31 51.7-51.7 11.3 11.3-51.7 51.7 31 31L240 368l-11.3 11.3L107.3 500.7zM217.4 368L144 294.6 22.6 416 96 489.4 217.4 368z'
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fast',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      'M267.3 180.7L256 192l-11.3-11.3L96 32l0-16L96 0l16 0L400 0l16 0 0 16 0 16L267.3 180.7zM400 25.4l0-9.4L112 16l0 9.4 144 144 144-144zM192 256l-11.3 11.3L32 416l-16 0L0 416l0-16L0 112 0 96l16 0 16 0L180.7 244.7 192 256zM16 112l0 288 9.4 0 144-144L25.4 112 16 112zM320 256l11.3-11.3L480 96l16 0 16 0 0 16 0 288 0 16-16 0-16 0L331.3 267.3 320 256zM496 112l-9.4 0-144 144 144 144 9.4 0 0-288zM256 320l11.3 11.3L416 480l0 16 0 16-16 0-288 0-16 0 0-16 0-16L244.7 331.3 256 320zM400 496l0-9.4-144-144-144 144 0 9.4 288 0z'
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fast',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      'M155.6 0H160 288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0zm128 16H164.4l-30 48H313.6l-30-48zM24 112.8L24 112H40L79.2 496h232c6.1 5.8 12.7 11.1 19.6 16H72 64.8l-.7-7.2-40-392zm391.8 79.9c-5.5 .5-11 1.3-16.3 2.3l8.5-83H424l-.1 .8-8.2 79.9zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm8 64v8 64h48 8v16h-8H432h-8v-8V296v-8h16z'
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fast',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 320.7c-.5-5.3-.7-10.6-.7-16H166.2l-20.9-80H339.2c2.8-5.5 5.9-10.8 9.3-16H141.1L82.7 48H554.2L509.1 192.5c5.5 .4 10.8 1.1 16.2 1.9L571 48l5-16H559.2 78.5L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM368 368a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm272 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-219.3-8L432 371.3l5.7-5.7L488 315.3V440v8h16v-8V315.3l50.3 50.3 5.7 5.7L571.3 360l-5.7-5.7-64-64-5.7-5.7-5.7 5.7-64 64-5.7 5.7z'
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fast',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      'M565.4 90.1l6.4 5.9-6.4 5.9-96 88-10.8-11.8L539.4 104 36.6 104l80.8 74.1-10.8 11.8-96-88L4.2 96l6.4-5.9 96-88 10.8 11.8L36.6 88l502.9 0L458.6 13.9 469.4 2.1l96 88zM80.2 512H64l2.3-16L96 288 288 160 480 288l29.7 208 2.3 16H495.8 80.2zm305.6-16L296 348.5V496h89.8zM280 184.6L110.8 297.3 82.4 496H280V184.6zM465.2 297.3L296 184.6V317.8L404.5 496h89.1L465.2 297.3z'
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fast',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      'M80 32C35.8 32 0 67.8 0 112V400c0 44.2 35.8 80 80 80s80-35.8 80-80H144c0 35.3-28.7 64-64 64s-64-28.7-64-64V112c0-35.3 28.7-64 64-64s64 28.7 64 64h16c0-44.2-35.8-80-80-80zm144 8V32H208v8V240v16V472v8h16v-8V256H384V472v8h16v-8V256 240 40 32H384v8V240H224V40zm232-8h-8v8V472v8h16v-8V256H600h8V240h-8H464V48H632h8V32h-8H456z'
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fast',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M560 48V432H16V48H560zM16 32H0V48 432v16H16 64v32H80V448H496v32h16V448h48 16V432 48 32H560 16zM496 96V384h16V96H496zM96 128H416V352H96V128zM80 112v16V352v16H96 416h16V352 128 112H416 96 80z'
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fast',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      'M8 0H0V8 504v8H8 253.1l7-16H16V384H152h8V368h-8H16V288H152h8V272h-8H16V16H304V395.6L320 359V8 0h-8H8zM136 56h-8v8V96H96 88v8 48 8h8 32v32 8h8 48 8v-8V160h32 8v-8V104 96h-8H192V64 56h-8H136zm8 48V72h32v32 8h8 32v32H184h-8v8 32H144V152v-8h-8H104V112h32 8v-8zM344 384l-4.2 9.6-42 96L295 496l-7 16h17.5 7H551.5h7H576l-7-16-2.8-6.4-42-96L520 384H509.5 354.5 344zM551.5 496H534.1 329.9 312.5l7-16 35-80H509.5l35 80 7 16zM368 272a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fast',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368H320h8v16h-8H192h-8V368h8zm-32-80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm256 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM160.4 208a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm192 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z'
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fast',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm296 96h8v11.6l-2.7 2.4L189.4 239.9l58.1-.3c40-.2 72.5 32.2 72.5 72.2c0 39.9-32.3 72.2-72.2 72.2H176.7c-18.2 0-34.8-10.3-42.9-26.5l-4.9-9.9-3.6-7.2 14.3-7.2 3.6 7.2 4.9 9.9c5.4 10.8 16.5 17.7 28.6 17.7h71.1c31 0 56.2-25.2 56.2-56.2c0-31.1-25.3-56.3-56.4-56.2L168 256l-8 0V244.4l2.7-2.4 112-98H136h-8V128h8H296z'
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fast',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      'M212.5 240L30.5 128l182-112H240V240H212.5zM208 256h32 16V240 136h88v24 16h16H496h16V160 96 80H496 360 344V96v24H256V16 0H240 208L15.3 118.6 0 128l15.3 9.4L208 256zM360 96H496v64H360V128 96zM288 352v16H272 240 224 16 0v16V496v16H16 496h16V496 440 368 256 240H496 304 288v16 96zM16 384H224V496H16V384zM496 496H240V384h48 16H496v56 56zM304 256H496V368H304V256z'
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fast',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      'M528 240.4l12 3.1c48.3 12.4 84 56.3 84 108.5V464H512 144 16V336c0-55.7 35.6-103.1 85.3-120.7l10.7-3.8V200.2 192c0-79.5 64.5-144 144-144c53.3 0 99.9 29 124.8 72.2l8.5 14.8 14.2-9.5c12.7-8.5 28-13.5 44.4-13.5c44.2 0 80 35.8 80 80v36 12.4zM96 200.2C40.1 220 0 273.3 0 336V464v16H16 144 512 624h16V464 352c0-59.6-40.8-109.8-96-124V192c0-53-43-96-96-96c-15.2 0-29.5 3.5-42.3 9.8c-3.8 1.9-7.5 4-11 6.4c-2.7-4.6-5.6-9.1-8.7-13.4C357 58.3 309.6 32 256 32C167.6 32 96 103.6 96 192v8.2z'
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fast',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zm8-264c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 230.9V256v8H248v-8V226.5v-4.3l3.6-2.4 54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5-16 0V136zm72 152h32v32H240V288z'
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fast',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      'M212.5 148.3c4.7-13.9 5-31.9-1.2-50.3s-17.2-32.8-29.4-41.2s-24.5-10.5-34.9-7.1c-10.3 3.4-18.9 12.3-23.6 26.2c-4.7 13.9-5 31.9 1.2 50.3s17.2 32.8 29.4 41.2s24.5 10.5 34.9 7.1c10.3-3.4 18.9-12.3 23.6-26.2zm-18.6 41.4c-32.3 10.6-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8zm-98.3 56c1.4-11.4-1.3-25.5-9.1-39s-18.8-22.8-29.6-27.4s-20.2-4-27.2-.1c-6.9 4-12.1 11.8-13.4 23.2c-1.4 11.4 1.3 25.5 9.1 39s18.8 22.8 29.6 27.4s20.2 4 27.2 .1c6.9-4 12.1-11.8 13.4-23.2zm-5.5 37.1c-24.5 14-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3s14.3 70.1-10.2 84.1zM256 415.5l3.9 1 171.5 42.9c-4.5-73.1-32.9-126.5-67-162.3c-37.8-39.7-81.9-57-108.4-57s-70.6 17.3-108.4 57c-34.1 35.8-62.4 89.2-67 162.3l171.5-42.9 3.9-1zM80 476l-16 4c0-5.6 .1-11.2 .4-16.6C72.1 299 194 224 256 224s183.9 75 191.6 239.4c.3 5.4 .4 11 .4 16.6l-16-4L256 432 80 476zM425.5 206.6c-7.9 13.5-10.5 27.6-9.1 39c1.4 11.4 6.5 19.3 13.4 23.2c6.9 4 16.4 4.5 27.2-.1s21.7-13.9 29.6-27.4s10.5-27.6 9.1-39c-1.4-11.4-6.5-19.3-13.4-23.2c-6.9-4-16.4-4.5-27.2 .1s-21.7 13.9-29.6 27.4zm-13.8-8c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.1zM292.7 97.9c-6.2 18.5-5.9 36.4-1.2 50.3c4.7 13.9 13.3 22.8 23.6 26.2c10.3 3.4 22.7 1.3 34.9-7.1s23.2-22.7 29.4-41.2s5.9-36.4 1.2-50.3c-4.7-13.9-13.3-22.8-23.6-26.2c-10.3-3.4-22.7-1.3-34.9 7.1s-23.2 22.7-29.4 41.2zm-15.2-5.1c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8z'
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fast',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      'M432 16V352H16V16H432zm0 352V496H16V368H432zM16 0H0V16 496v16H16 432h16V496 16 0H432 16zM224 448a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fast',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M194.1 24.1C91.5 51.4 16 144.9 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-111.1-75.5-204.6-178.1-231.9l4.1-15.5C431.4 37.7 512 137.4 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 137.4 80.6 37.7 189.9 8.6l4.1 15.5z'
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fast',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      'M320 48C152.1 48 16 184.1 16 352V472v8H0v-8V352C0 175.3 143.3 32 320 32s320 143.3 320 320V472v8H624v-8V352C624 184.1 487.9 48 320 48zm0 192c-61.9 0-112 50.1-112 112V472v8H192v-8V352c0-70.7 57.3-128 128-128s128 57.3 128 128V472v8H432v-8V352c0-61.9-50.1-112-112-112zM104 360V472v8H88v-8V360c0-128.1 103.9-232 232-232s232 103.9 232 232V472v8H536v-8V360c0-119.3-96.7-216-216-216s-216 96.7-216 216z'
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fast',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      'M496 256c0-22.2-3-43.6-8.6-64H368v20.7l29.7 29.7 2.3 2.3V248v64 8h-8H368v40 3.3l-2.3 2.3-48 48-2.3 2.3H312 264h-8v-8V320H168h-8v-8V224v-3.3l2.3-2.3 40-40 2.3-2.3H208h84.7l48-48H267.3l-29.7 29.7-2.3 2.3H232 200h-8v-8V87.3L146.9 42.2C69.2 81.9 16 162.7 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240zm-13.7-80C449.4 82.8 360.5 16 256 16c-33.2 0-64.9 6.8-93.7 19l43.4 43.4 2.3 2.3V84v60h20.7l29.7-29.7 2.3-2.3H264h96 19.3l-13.7 13.7-64 64-2.3 2.3H296 211.3L176 227.3V304h88 8v8 88h36.7L352 356.7V312v-8h8 24V251.3l-29.7-29.7-2.3-2.3V216 184v-8h8H482.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fast',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      'M200 0h-8V8 36C100.7 54.5 32 135.2 32 232v30.9L1.9 373.9l-2.1 7.7 15.4 4.2 2.1-7.7 30.4-112 .3-1V264 232c0-87.9 61.6-161.4 144-179.6v51.3c0 63 48.5 115.4 111.4 120.3l1.2-16c-54.5-4.2-96.6-49.7-96.6-104.3V49.5s0 0 0 0V33.4s0 0 0 0V16h87.7c54.7 0 100.1 42.1 104.3 96.6l16-1.2c-1.8-23.8-10.5-45.5-24-63.4c75.1 0 136 60.9 136 136V328v8h16v-8V184c0-83.9-68.1-152-152-152H377.5C356 12.1 327.1 0 295.7 0H200zM416 304v-8H400v8V496H304V397.5c1.6-1 3.1-2 4.6-3l6.6-4.6L306 376.8l-6.6 4.6c-3.4 2.4-7 4.6-10.7 6.6H288v.4c-14.4 7.5-30.7 11.7-48 11.7s-33.6-4.2-48-11.7v-.4h-.7c-3.7-2-7.3-4.2-10.7-6.6l-6.6-4.6-9.2 13.1 6.6 4.6c1.5 1 3 2.1 4.6 3V496H80V336v-8H64v8V504v8h8H184h8v-8V406c14.7 6.4 30.9 10 48 10s33.3-3.6 48-10v98 8h8H408h8v-8V341.3c16.8 18.6 38.9 32.3 64 38.7v22.7c0 42.7 34.6 77.3 77.3 77.3c34.9 0 65.5-23.4 74.6-57.1l2.8-10.3 4.2-15.4L623.4 393l-30.9-8.4-15.4-4.2-4.2 15.4-2.8 10.3c-1.6 5.8-6.8 9.8-12.8 9.8c-7.4 0-13.3-6-13.3-13.3V380c23.3-5.9 44.1-18.2 60.4-34.8l5.6-5.7-11.4-11.2L593 334c-20.6 21-49.2 34-81 34c-40.4 0-75.9-21.2-96-53.1V304zm80 98.7V383c5.2 .6 10.6 1 16 1s10.8-.3 16-1v19.7c0 16.2 13.1 29.3 29.3 29.3c13.2 0 24.8-8.9 28.3-21.7l2.8-10.3 30.9 8.3-2.8 10.3C609.3 445.4 585 464 557.3 464c-33.9 0-61.3-27.4-61.3-61.3zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fast',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm128 96h8H236c37.6 0 68 30.4 68 68c0 22.1-10.6 41.8-26.9 54.2c29.3 7.6 50.9 34.2 50.9 65.8c0 37.6-30.4 68-68 68H136h-8v-8V264v-8-8V136v-8zm160 68c0-28.7-23.3-52-52-52H144V248h92c28.7 0 52-23.3 52-52zM144 368H260c28.7 0 52-23.3 52-52s-23.3-52-52-52H236 144V368z'
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fast',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      'M128 16v96H32V16h96zM32 0H16V16v96 16H32 72V384H32 16v16 96 16H32h96 16V496 400 384H128 88V128h40 16V112 16 0H128 32zm0 400h96v96H32V400zm288 0h96v96H320V400zm-16-16v16 96 16h16 96 16V496 400 384H416 320 304zm88-168v48H344V216h48zm-48-16H328v16 48 16h16 48 16V264 216 200H392 344zm0-144h48v48H344V56zM328 40V56v48 16h16 48 16V104 56 40H392 344 328z'
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fast',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M555.1 32H572L423.6 474.5l-1.8 5.5H410l-1.7-5.7L288 68.2 167.7 474.3 166 480H154.3l-1.8-5.5L4 32H20.9L159.5 445.4 280.3 37.7 282 32H294l1.7 5.7L416.5 445.4 555.1 32z'
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fast',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      'M405.1 16c-20.3 0-39.2 10.5-50 27.7L302.4 128H328h80c30.9 0 56-25.1 56-56s-25.1-56-56-56h-2.9zM273.6 128L220.9 43.7C210.1 26.5 191.2 16 170.9 16H168c-30.9 0-56 25.1-56 56s25.1 56 56 56h80 25.6zm14.4-7.1l53.6-85.7C355.3 13.3 379.3 0 405.1 0H408c39.8 0 72 32.2 72 72c0 22.6-10.4 42.8-26.7 56H560h16v16V496v16H560 16 0V496 144 128H16 122.7C106.4 114.8 96 94.6 96 72c0-39.8 32.2-72 72-72h2.9c25.8 0 49.8 13.3 63.5 35.2L288 120.9zM168 144H16V288H560V144H408 328 305.1l69.1 82.9 5.1 6.1L367 243.3l-5.1-6.1L288 148.5l-73.9 88.6-5.1 6.1L196.7 233l5.1-6.1L270.9 144H248 168zM16 304v96H560V304H16zM560 496V416H16v80H560z'
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fast',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      'M224 0h8H384h3.8l2.4 3L491.8 128H600h8v8V251.8c2 1.9 3.9 3.9 5.8 5.9l5.5 5.8-11.6 11-5.5-5.8C571.5 236.2 528.1 216 480 216c-59 0-110.8 30.4-140.8 76.4l-2.4 3.6h-4.3H307.5h-4.3l-2.4-3.6C270.8 246.4 219 216 160 216c-48.1 0-91.5 20.2-122.2 52.7l-5.5 5.8-11.6-11 5.5-5.8c1.9-2 3.8-4 5.8-5.9V136v-8h8H224V8 0zM48 238c31-23.8 69.9-38 112-38c63 0 118.7 31.7 151.8 80h16.4c33.1-48.3 88.8-80 151.8-80c42.1 0 81 14.2 112 38V144H488.1h-.1H232 48v94zM380.2 16H240V128H471.2l-91-112zM122 248h8 60 8v8 13.6c3.6 1.3 7 2.7 10.4 4.3l9.6-9.6 5.7-5.7 5.7 5.7 42.4 42.4 5.7 5.7-5.7 5.7-9.6 9.6c1.6 3.4 3 6.8 4.3 10.4H280h8v8 60 8h-8H266.4c-1.3 3.6-2.7 7-4.3 10.4l9.6 9.6 5.7 5.7-5.7 5.7-42.4 42.4-5.7 5.7-5.7-5.7-9.6-9.6c-3.4 1.6-6.8 3-10.4 4.3V496v8h-8H130h-8v-8V482.4c-3.6-1.3-7-2.7-10.4-4.3l-9.6 9.6-5.7 5.7-5.7-5.7L48.3 445.3l-5.7-5.7 5.7-5.7 9.6-9.6c-1.6-3.4-3-6.8-4.3-10.4H40 32v-8V346v-8h8H53.6c1.3-3.6 2.7-7 4.3-10.4L48.3 318l-5.7-5.7 5.7-5.7 42.4-42.4 5.7-5.7 5.7 5.7 9.6 9.6c3.4-1.6 6.8-3 10.4-4.3V256v-8zm16 16v11.3 6l-5.7 1.7c-6.4 1.9-12.6 4.5-18.4 7.6l-5.2 2.8-4.2-4.2-8-8L65.2 312.4l8 8 4.2 4.2-2.8 5.2c-3.1 5.8-5.7 12-7.6 18.4L65.3 354h-6H48v44H59.3h6l1.7 5.7c1.9 6.4 4.5 12.6 7.6 18.4l2.8 5.2-4.2 4.2-8 8 31.1 31.1 8-8 4.2-4.2 5.2 2.8c5.8 3.1 12 5.7 18.4 7.6l5.7 1.7v6V488h44V476.7v-6l5.7-1.7c6.4-1.9 12.6-4.5 18.4-7.6l5.2-2.8 4.2 4.2 8 8 31.1-31.1-8-8-4.2-4.2 2.8-5.2c3.1-5.8 5.7-12 7.6-18.4l1.7-5.7h6H272V354H260.7h-6l-1.7-5.7c-1.9-6.4-4.5-12.6-7.6-18.4l-2.8-5.2 4.2-4.2 8-8-31.1-31.1-8 8-4.2 4.2-5.2-2.8c-5.8-3.1-12-5.7-18.4-7.6l-5.7-1.7v-6V264H138zm22 72a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm56 40a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM450 248h60 8v8 13.6c3.6 1.3 7 2.7 10.4 4.3l9.6-9.6 5.7-5.7 5.7 5.7 42.4 42.4 5.7 5.7-5.7 5.7-9.6 9.6c1.6 3.4 3 6.8 4.3 10.4H600h8v8 60 8h-8H586.5c-1.3 3.6-2.7 7-4.3 10.4l9.6 9.6 5.7 5.7-5.7 5.7-42.4 42.4-5.7 5.7-5.7-5.7-9.6-9.6c-3.4 1.6-6.8 3-10.4 4.3V496v8h-8H450h-8v-8V482.4c-3.6-1.3-7-2.7-10.4-4.3l-9.6 9.6-5.7 5.7-5.7-5.7-42.4-42.4-5.7-5.7 5.7-5.7 9.6-9.6c-1.6-3.4-3-6.8-4.3-10.4H360h-8v-8V346v-8h8 13.6c1.3-3.6 2.7-7 4.3-10.4l-9.6-9.6-5.7-5.7 5.7-5.7 42.4-42.4 5.7-5.7 5.7 5.7 9.6 9.6c3.4-1.6 6.8-3 10.4-4.3V256v-8h8zm8 27.3v6l-5.7 1.7c-6.4 1.9-12.6 4.5-18.4 7.6l-5.2 2.8-4.2-4.2-8-8-31.1 31.1 8 8 4.2 4.2-2.8 5.2c-3.1 5.8-5.7 12-7.6 18.4l-1.7 5.7h-6H368v44h11.3 6l1.7 5.7c1.9 6.4 4.5 12.6 7.6 18.4l2.8 5.2-4.2 4.2-8 8 31.1 31.1 8-8 4.2-4.2 5.2 2.8c5.8 3.1 12 5.7 18.4 7.6l5.7 1.7v6V488h44V476.7v-6l5.7-1.7c6.4-1.9 12.6-4.5 18.4-7.6l5.2-2.8 4.2 4.2 8 8 31.1-31.1-8-8-4.2-4.2 2.8-5.2c3.1-5.8 5.7-12 7.6-18.4l1.7-5.7h6H592V354H580.7h-6l-1.7-5.7c-1.9-6.4-4.5-12.6-7.6-18.4l-2.8-5.2 4.2-4.2 8-8-31.1-31.1-8 8-4.2 4.2-5.2-2.8c-5.8-3.1-12-5.7-18.4-7.6l-5.7-1.7v-6V264H458v11.3zM440 376a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fast',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      'M224 192a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm0 16c-43.3 0-80.4-26.4-96-64h-83l10.2 20.4 3 6-5.3 4L29.3 192l23.5 17.6 5.3 4-3 6L44.9 240H136h9.8l-1.9 9.6-28.8 144 49.4-24.7 3.8-1.9 3.7 2.1 52 29.7 52-29.7 3.7-2.1 3.8 1.9 49.4 24.7-28.8-144-1.9-9.6H312h91.1l-10.2-20.4-3-6 5.3-4L418.7 192l-23.5-17.6-5.3-4 3-6L403.1 144H320c-15.7 37.6-52.8 64-96 64zM328 104c0 8.3-1 16.3-2.8 24H416h12.9l-5.8 11.6-13 26 26.7 20 8.5 6.4-8.5 6.4-26.7 20 13 26 5.8 11.6H416 321.8l30.1 150.4 3.2 16-14.6-7.3-60.2-30.1L228 414.9l-4 2.3-4-2.3-52.3-29.9-60.2 30.1-14.6 7.3 3.2-16L126.2 256H32 19.1l5.8-11.6 13-26-26.7-20L2.7 192l8.5-6.4 26.7-20-13-26L19.1 128H32h90.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM176 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM216 504V436.9l8 4.6 8-4.6V504v8H216v-8z'
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fast',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      'M157.4 25l5.9 5.4L152.4 42.2l-5.9-5.4C132.7 23.9 114.1 16 93.7 16C50.8 16 16 50.8 16 93.7c0 15.4 4.4 29.7 12.1 41.7l4.3 6.7-13.5 8.6L14.6 144C5.4 129.5 0 112.2 0 93.7C0 42 42 0 93.7 0c24.6 0 47 9.5 63.7 25zm-54.1 427L53.7 501.7 48 507.3 36.7 496l5.7-5.7 49.7-49.7C54.8 400.6 32 347 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 59-22.8 112.6-60.1 152.6l49.7 49.7 5.7 5.7L464 507.3l-5.7-5.7-49.7-49.7C368.6 489.2 315 512 256 512s-112.6-22.8-152.6-60.1zM464 288A208 208 0 1 0 48 288a208 208 0 1 0 416 0zM354.6 25C371.3 9.5 393.7 0 418.3 0C470 0 512 42 512 93.7c0 18.5-5.4 35.8-14.6 50.3l-4.3 6.7-13.5-8.6 4.3-6.7c7.7-12 12.1-26.3 12.1-41.7C496 50.8 461.2 16 418.3 16c-20.4 0-39 7.9-52.8 20.7l-5.9 5.4L348.7 30.4l5.9-5.4zM192 192H320h15.7l-9.2 12.7L207.7 368H320h8v16h-8H192 176.3l9.2-12.7L304.3 208H192h-8V192h8z'
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fast',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      'M96 0V8 120v8h16v-8V16h96V120v8h16v-8V8 0h-8H104 96zM224 176c44.2 0 80 35.8 80 80V496H16V256c0-44.2 35.8-80 80-80H224zM96 160c-53 0-96 43-96 96V496v16H16 304h16V496 256c0-53-43-96-96-96H96zM232 336A72 72 0 1 1 88 336a72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176zM320 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM512 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM496 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fast',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      'M352 88c0-39.8 32.2-72 72-72s72 32.2 72 72c0 16.2-5.4 31.2-14.4 43.2l-4.8 6.4 12.8 9.6 4.8-6.4c11-14.7 17.6-33 17.6-52.8c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 21.4 7.7 41.1 20.4 56.3l-42 42L264 136l-20.7-20.7L232 104l-11.3 11.3-73.4 73.4L136 200l11.3 11.3L168 232 280 344l20.7 20.7L312 376l11.3-11.3 73.4-73.4L408 280l-11.3-11.3L376 248l-50.3-50.3 47.4-47.4 5.7-5.7-5.7-5.7c-13-13-21.1-31-21.1-50.9zM101.7 421.7L152 472l20.7 20.7L184 504l11.3-11.3 81.4-81.4L288 400l-11.3-11.3L256 368 144 256l-20.7-20.7L112 224l-11.3 11.3L19.3 316.7 8 328l11.3 11.3L40 360l50.3 50.3-88 88L-3.3 504 8 515.3l5.7-5.7 88-88zm77.7-201L158.6 200 232 126.6l20.7 20.7 112 112L385.4 280 312 353.4l-20.7-20.7-112-112zm-128 128L30.6 328 112 246.6l20.7 20.7 112 112L265.4 400 184 481.4l-20.7-20.7-112-112z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fast',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240c0 100.3-61.5 186.2-148.8 222.1c-2.4 7.3-5.7 14.3-9.7 20.7C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 368.9 73.1 464.7 174.5 498.8c-4-6.4-7.3-13.4-9.7-20.7C77.5 442.2 16 356.3 16 256zm395.1 66c2.2-6.2 4-12.6 5.4-19.2c-5.9 2.4-12 4.6-18.2 6.7c-42.1 14.2-90.5 22.3-142 22.3s-99.9-8.1-142-22.3c-6.2-2.1-12.3-4.3-18.2-6.7c1.4 6.5 3.3 12.9 5.4 19.2c11.2 31.8 31.8 59.2 58.5 78.7V380.2c-16.4-14.1-29.7-31.7-38.7-51.7c40.9 12.4 86.7 19.3 135 19.3s94.1-6.9 135-19.3c-9.1 20.2-22.6 38-39.2 52.2v20.3c27-19.5 47.8-47 59.1-79.1zM192 368h-8v8 64c0 39.8 32.2 72 72 72s72-32.2 72-72V376v-8h-8H272h-3.3l-2.3 2.3L256 380.7l-10.3-10.3-2.3-2.3H240 192zm44.7 16L248 395.3V424v8h16v-8V395.3L275.3 384H312v56c0 30.9-25.1 56-56 56s-56-25.1-56-56V384h36.7zM132.4 157.3l-7.2 14.3 7.2 3.6L198.1 208l-65.7 32.8-7.2 3.6 7.2 14.3 7.2-3.6 80-40 14.3-7.2-14.3-7.2-80-40-7.2-3.6zm240 3.6l-80 40L278.1 208l14.3 7.2 80 40 7.2 3.6 7.2-14.3-7.2-3.6L313.9 208l65.7-32.8 7.2-3.6-7.2-14.3-7.2 3.6z'
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fast',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      'M160 475.3l5.7-5.7 112-112 5.7-5.7L272 340.7l-5.7 5.7L168 444.7V40 32H152v8V444.7L53.7 346.3 48 340.7 36.7 352l5.7 5.7 112 112 5.7 5.7zM368 288v16h8 48V464H376h-8v16h8 56 56 8V464h-8H440V296v-8h-8H376h-8zm59.8-103.9A68 68 0 1 1 428 48a68 68 0 1 1 -.2 136.1zM428 200c9.2 0 18-1.5 26.3-4.2L405.7 256h20.6l62-76.7c7.9-9.8 14-20.9 18-32.6c3.7-9.5 5.8-19.8 5.8-30.6c0-.6 0-1.3 0-1.9c0-.7 0-1.4 0-2.1h-.1C509.8 67.5 473 32 428 32c-46.4 0-84 37.6-84 84s37.6 84 84 84z'
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fast',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zm0 496A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM128 192h16H368h16v16 24L256 352 128 232V208 192zm240 33.1V208H144v17.1l112 105 112-105z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fast',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      'M128 0V8 64H320V8 0h16V8 64h96 16V80v96 16V496v16H432 16 0V496 192 176 80 64H16h96V8 0h16zM432 192H16V496H432V192zM112 120V80H16v96H432V80H336v40 8H320v-8V80H128v40 8H112v-8zM255.8 250.2l6.6 9.1 128 176 9.2 12.7H384 64 48.5l9-12.6 80-112 5.5-7.7 6.7 6.7 33.2 33.2 66.5-96.1 6.4-9.3zm.3 27.6l-65.6 94.7-5.5 7.9-6.8-6.8L145 340.3 79.5 432H368.3L256.2 277.8zM96 272a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fast',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 136V376v8h16v-8V161L249.5 308.6l6.5 9.1 6.5-9.1L368 161V376v8h16v-8V136v-8H371.9l-2.4 3.4L256 290.2 142.5 131.4l-2.4-3.4H128v8z'
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fast',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm266.3 37.7L384 395.3c-56.5 50.7-143.5 48.8-197.8-5.5c-56.2-56.2-56.2-147.4 0-203.6s147.4-56.2 203.6 0c54.3 54.3 56.2 141.3 5.5 197.8L293.7 282.3l-5.7-5.7L276.7 288l5.7 5.7zM401.1 401.1A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1z'
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fast',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      'M185 384.1c-5.1-.5-10.4-1.5-15.7-2.9L185.4 268l-45-13.7L112 245.6V216 72 48 32h16 48 16V48 72 186.4l145.3 44.2 157.5-37.5 23.3-5.6 15.6-3.7 3.7 15.6 11.1 46.7 3.7 15.6-15.6 3.7-23.3 5.6-134.4 32-14.4 79.2c-5.1-1.2-10.3-2.8-15.4-4.9l14-77.2 1.9-10.3 10.2-2.4 134.4-32 23.3-5.6-11.1-46.7-23.3 5.6L341 246.1l-4.2 1-4.1-1.3L187.3 201.7 176 198.2V186.4 72 48H128V72 216v17.8l17 5.2 45 13.7 13.1 4-1.9 13.6L185 384.1zM320 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-64-48a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM96.6 395c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C147.4 449.8 169.5 464 192 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C339.4 449.8 361.5 464 384 464s44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9l.6-.9 .6 .9c4.3 6.1 8.5 12.2 13.3 17.9c4.8 5.8 11.8 13.5 20.2 21.2C531.4 449.8 553.5 464 576 464v16c-28.7 0-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.3 15.6-23.4 24.8c-18 16.3-43.9 34.1-72.6 34.1s-54.6-17.8-72.6-34.1c-10.2-9.2-18.2-18.4-23.4-24.8c-5.2 6.4-13.2 15.6-23.4 24.8C54.6 462.2 28.7 480 0 480V464c22.5 0 44.6-14.2 61.8-29.9c8.5-7.7 15.4-15.4 20.2-21.2c4.8-5.8 9-11.8 13.3-17.9c.2-.3 .4-.6 .6-.9c.2 .3 .4 .6 .6 .9z'
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fast',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      'M365.3 11.2L370 4.7l-4.6-3.4-4.7 3.3 4.6 6.6zM500.8 148c6.5 4.7 6.5 4.7 6.5 4.7l0 0 0 0 0 0-.1 .1-.3 .4c-.2 .3-.6 .7-1 1.3c-.9 1.1-2.1 2.6-3.8 4.4c-3.2 3.6-8 8.4-13.9 13.3C476.4 181.8 458.9 192 438 192c-19.5 0-33.6-3.8-45.9-10.9c-11.8-6.9-21.6-16.7-32.6-27.6l0 0-.5-.5-.5-.5c-11-10.9-20.8-20.8-27.6-32.6C323.8 107.6 320 93.5 320 74c0-21 10.7-38.5 20.5-50.3c5-6 10-10.7 13.7-13.9c1.9-1.6 3.4-2.9 4.6-3.7c.6-.4 1-.8 1.3-1l.4-.3 .1-.1 0 0 0 0 0 0s0 0 4.6 6.6C370 4.7 370 4.7 370 4.7l0 0 0 0 0 0 .1 .1 .4 .3c.3 .2 .8 .6 1.3 1c1.1 .9 2.6 2.2 4.5 3.9c3.6 3.4 8.5 8.4 13.3 14.9c9.7 12.9 19.6 32.1 19.6 56.4c0 9.7-.8 17.3-1.9 23.2c5.9-1.1 13.5-1.9 23.2-1.9c24.3 0 43.6 10.3 56.5 20.3c6.5 5 11.5 10 14.9 13.8c1.7 1.9 3 3.5 3.9 4.6c.5 .6 .8 1 1 1.4l.3 .4 .1 .1 0 0 0 0 0 0s0 0-6.6 4.6zm0 0l6.5 4.7 3.4-4.6-3.3-4.7-6.6 4.6zM388.3 112.4l0 0 0 0 0 0-.1 .1-.1 .1-.1 .1s.1-.1 .3-.4c.4-.6 1-1.9 1.8-4.1c1.5-4.5 3.3-12.8 3.3-26.8c0-19.7-8.1-35.6-16.4-46.8c-4.2-5.6-8.3-9.8-11.4-12.7l-.3-.3-.5 .4c-3.3 2.8-7.6 6.9-11.9 12.1C344 44.5 336 58.4 336 74c0 17.2 3.3 28.4 8.8 37.9c5.7 9.8 14.1 18.3 25.6 29.8s19.9 19.8 29.8 25.6c9.5 5.5 20.7 8.8 37.9 8.8c15.7 0 29.7-7.8 40.1-16.2c5.2-4.2 9.3-8.4 12.1-11.5l.3-.3-.4-.5c-2.9-3.2-7.2-7.5-12.7-11.9c-11.2-8.7-27-17-46.7-17c-14 0-22.3 1.8-26.8 3.3c-2.2 .7-3.5 1.4-4.1 1.8c-.3 .2-.4 .3-.4 .3l.1-.1 .1-.1 .1-.1 0 0 0 0 0 0s0 0-5.6-5.7s-5.7-5.7-5.7-5.6zM288 152a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM152 176a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM128 312a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM96 456a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm144-32a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm56-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM264 288a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm136-24a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM248 96a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM56 176a56 56 0 1 1 112 0A56 56 0 1 1 56 176zm32 80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM56 400a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm144-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm80 32a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM224 232a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm80 32a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fast',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M496 48H16v80H32 48 464h16 16V48zm-16 96H464 48 32 16 0V128 48 32H16 496h16V48v80 16H496 480zM160 224h8H344h8v16h-8H168h-8V224zm304-48h16V464v16H464 48 32V464 176H48V464H464V176z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fast',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      'M567.3 189.5C573 210.7 576 233 576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-23 3-45.3 8.7-66.5C50.3 158 8 90.4 1 19.7C.3 13.1 0 6.6 0 0C0 0 5.4 4.1 16.3 9.9C40.2 22.9 90.6 44.5 167.4 50.5C210 18.8 262.8 0 320 0s110 18.8 152.6 50.5c76.8-5.9 127.1-27.6 151.1-40.5C634.6 4.1 640 0 640 0c0 6.6-.3 13.1-1 19.7c-7 70.7-49.3 138.4-71.7 169.9zm-77-124.7c31.7 28.3 56.4 64.4 70.9 105.3c6.5-9.7 14-21.5 21.4-34.9c16.9-30.5 33.2-68 39-106.3c-7.8 3.8-17.1 7.9-28.1 12c-25.7 9.6-60.1 19.1-103.3 23.9zm-340.6 0C106.5 60.1 72.1 50.6 46.4 41c-11-4.1-20.3-8.3-28.1-12c5.9 38.3 22.1 75.8 39 106.3c7.5 13.4 14.9 25.3 21.4 34.9c14.5-40.9 39.2-77 70.9-105.3zM560 256A240 240 0 1 0 80 256a240 240 0 1 0 480 0zM201.4 364.6l13.1-9.2C235.4 385.2 270.6 416 320 416s84.6-30.8 105.4-60.6l13.1 9.2C416.1 396.6 376.7 432 320 432s-96.1-35.4-118.6-67.4zM224.4 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.9 197.9l7.6 2.5 96 32 7.6 2.5-5.1 15.2-7.6-2.5-96-32-7.6-2.5 5.1-15.2zm271.2 15.2l-7.6 2.5-96 32-7.6 2.5-5.1-15.2 7.6-2.5 96-32 7.6-2.5 5.1 15.2z'
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fast',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      'M560 112V400H16V112H560zm16-16H560 16 0v16V400v16H16 560h16V400 112 96zM240 176V336H80V176H240zm16-16H240 80 64v16V336v16H80 240h16V336 176 160z'
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fast',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      'M272 16h32V48H272V16zM256 0V16 48 64h16 32 16V48 16 0H304 272 256zM80 80h32v32H80V80zM64 64V80v32 16H80h32 16V112 80 64H112 80 64zM464 80h32v32H464V80zM448 64V80v32 16h16 32 16V112 80 64H496 464 448zM560 272v32H528V272h32zm-32-16H512v16 32 16h16 32 16V304 272 256H560 528zM464 464h32v32H464V464zm-16-16v16 32 16h16 32 16V496 464 448H496 464 448zM112 464v32H80V464h32zM80 448H64v16 32 16H80h32 16V496 464 448H112 80zM48 272v32H16V272H48zM16 256H0v16 32 16H16 48 64V304 272 256H48 16zm264 32V431.8c-75.8-4.2-136-66.9-136-143.8c0-79.5 64.5-144 144-144s144 64.5 144 144c0 76.8-60.2 139.6-136 143.8V288v-8H280v8zm8 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fast',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 224H80V192c0-30.9 25.1-56 56-56c.9 0 1.8 0 2.8 .1c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c12.8 0 23.8-7.5 28.9-18.3c2 5.7 3.1 11.9 3.1 18.3v32zM136 120c-39.8 0-72 32.2-72 72v32 16H80 192h16V224 192c0-39.8-32.2-72-72-72zm40 40a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm200 8a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-21.2-39.9c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c15.1 0 27.8-10.5 31.1-24.5c5.6 9.5 8.9 20.7 8.9 32.5v32H288V192c0-35.3 28.7-64 64-64c.9 0 1.8 0 2.8 .1zM272 192v32 16h16H416h16V224 192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm89.9 187.8C334.2 411.9 293.3 432 248 432c-2.1 0-4.3 0-6.4-.1c7.5-36.4 39.7-63.9 78.4-63.9c15.4 0 29.7 4.3 41.9 11.8zm12.8-10.7C359.2 358.3 340.4 352 320 352c-47 0-86.1 33.8-94.4 78.4C153.8 420.3 96.6 362.1 89.5 288h317c-2.9 30.5-14.3 58.3-31.7 81.1zM248 448c90.6 0 166.3-69.1 174.5-159.3l.1-.7 1.5-16H407.9 88.1 72l1.5 16 .1 .7C81.7 378.9 157.4 448 248 448'
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fast',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM97.8 144h17.7L224 373.3 332.5 144h17.7l-119 251.4-2.2 4.6H218.9l-2.2-4.6L97.8 144z'
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fast',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      'M230.6 336H336c88.4 0 160-71.6 160-160s-71.6-160-160-160s-160 71.6-160 160V281.4L230.6 336zm-3.3 16l-52.4 52.4C185.5 415.8 192 431.2 192 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1L160 284.7V176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176H227.3zM168 296v0l1.7 1.7-56.6 56.6-6.3 6.3-5.6-6.9C92.4 342.9 79 336 64 336c-26.5 0-48 21.5-48 48s21.5 48 48 48c2.5 0 5-.2 7.4-.6l10.8-1.7-1.7 10.8c-.4 2.4-.6 4.9-.6 7.4c0 26.5 21.5 48 48 48s48-21.5 48-48c0-15-6.9-28.4-17.7-37.2l-6.9-5.6 6.3-6.3 56.6-56.6L216 344h0l-48-48zm112-64l0 0h0v0z'
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fast',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      'M389.7 290.3L343.3 244 573.7 13.7 562.3 2.3 332 232.7l-46.3-46.3-2.3-2.3H280 264h-7.1l-.9 7L250 239.5 217.3 237c-41.4-3.2-82.2 11.9-111.6 41.3C81.6 302.4 67 334.3 64.4 368c-.3 3.6-.4 7.3-.4 11l0 5H80l7.4 0 24.6 0L93.3 400 0 480v16 16l16 0 181 0c37.8 0 74-15 100.7-41.7c29.4-29.4 44.5-70.2 41.3-111.6L336.5 326l48.5-6.1 7-.9V312 296v-3.3l-2.3-2.3zm-62.6 20.7l-62.1-62.1 6.1-48.9h5.6L376 299.3v5.6l-48.9 6.1zM112 368H80.5c2.6-29.5 15.4-57.3 36.5-78.4c26.1-26.1 62.3-39.5 99-36.6l32.8 2.5 71.6 71.6 2.5 32.8c2.8 36.8-10.6 73-36.6 99c-23.7 23.7-55.8 37-89.4 37L16 496l0-8.6 106.4-91.2L155.3 368 112 368zm288 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fast',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M144 240v16V464h96V256 240h16H368v-9.4L192 54.6 16 230.6V240H128h16zM0 224L180.7 43.3 192 32l11.3 11.3L384 224v16 16H368 272 256v16V464v16H240 144 128V464 272 256H112 16 0V240 224z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fast',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      'M32 102L72 56.3 112 102V464H32V288 102zM61.4 44.1L16 96V288 464v16H32h80 16V464 368h72v96 16h16 80 16V464 368h72v96 16h16 80 16V464 96L450.6 44.1 440 32 429.4 44.1 384 96v64H312V96L266.6 44.1 256 32 245.4 44.1 200 96v64H128V96L82.6 44.1 72 32 61.4 44.1zM384 352H312V176h72V288v64zm-184 0H128V176h72V288v64zm16-250l40-45.7L296 102V464H216V288 102zM400 288V102l40-45.7L480 102V464H400V288z'
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fast',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      'M496 16V80H152 136 16V16H496zM16 96H136v80 16 64.7c-22.7 3.8-40 23.6-40 47.3c0 12.3 4.6 23.5 12.2 32c.6 .7 1.2 1.3 1.8 1.9c8.7 8.7 20.7 14.1 33.9 14.1c14.2 0 27-6.2 35.8-16c7.6-8.5 12.2-19.7 12.2-32c0-23.8-17.3-43.5-40-47.3V192 176 96H496h16V80 16 0H496 16 0V16 80 96H16zM144 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM8 176H0v16H8h96V176H8zM8 336H0v16H8 80c-3.7-4.9-6.8-10.3-9.3-16H8zm496 16h8V336h-8H217.3c-2.5 5.7-5.6 11.1-9.3 16H504zm0-160h8V176h-8H184v16H504zM0 496v16H8 504h8V496h-8H8 0z'
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fast',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M176 128c0-61.9 50.1-112 112-112s112 50.1 112 112v8h16v-8C416 57.3 358.7 0 288 0S160 57.3 160 128c0 42.9 21.1 80.9 53.5 104.1l-58.6 93.8c-8.2-3.8-17.3-5.9-26.9-5.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-20-9.2-37.9-23.6-49.6L231.2 234l4.2-6.8-6.8-4.2C197 203.2 176 168 176 128zm0 256.1a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 176a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM224 128c0 35.3 28.7 64 64 64c9.6 0 18.7-2.1 26.9-5.9l62.7 100.4 4.2 6.8 6.8-4.3c17.2-10.8 37.5-17 59.4-17c61.9 0 112 50.1 112 112s-50.1 112-112 112c-21.8 0-42.2-6.2-59.4-17l-6.8-4.2-8.5 13.6 6.8 4.2C399.8 504.9 423.1 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-22 0-42.8 5.6-60.9 15.4l-58.6-93.8C342.8 165.9 352 148 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64zM68.3 289.2L75 285l-8.5-13.5-6.8 4.3C23.9 298.4 0 338.4 0 384c0 70.7 57.3 128 128 128c68 0 123.6-53 127.8-120H384.5c3.9 31.6 30.9 56 63.5 56c35.3 0 64-28.7 64-64s-28.7-64-64-64c-32.6 0-59.6 24.4-63.5 56H248h-8v8c0 61.9-50.1 112-112 112S16 445.9 16 384c0-39.9 20.8-74.9 52.3-94.8zM496 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fast',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      'M16 16V496H96V16H16zM0 0H16 96h16V16 32H528V16 0h16 80 16V16 496v16H624 544 528V496 480H112v16 16H96 16 0V496 16 0zM112 464H528V48H112V464zm82.1-136l7-12 35-60-35-60-7-12H208h70.1l35-60 6.9-11.8 6.9 11.8 35 60H432h13.9l-7 12-35 60 35 60 7 12H432 361.9l-35 60L320 399.9 313.1 388l-35-60H208 194.1zM320 368.1L343.4 328H296.6L320 368.1zM287.3 312h65.5l32.7-56-32.7-56H287.3l-32.7 56 32.7 56zm130.8 0l-23.4-40.1L371.3 312h46.8zm0-112H371.3l23.4 40.1L418.1 200zM320 143.9L296.6 184h46.8L320 143.9zm-74.7 96.2L268.7 200H221.9l23.4 40.1zM268.7 312l-23.4-40.1L221.9 312h46.8zM624 16H544V496h80V16z'
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fast',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      'M132.7 315.3L59.3 388.7 48 400l11.3 11.3L80 432H352h16V416 144l-20.7-20.7L336 112l-11.3 11.3-73.4 73.4L240 208l-11.3-11.3L107.3 75.3 96 64 84.7 75.3 11.3 148.7 0 160l11.3 11.3L132.7 292.7 144 304l-11.3 11.3zM22.6 160L96 86.6 228.7 219.3 240 230.6l11.3-11.3L336 134.6l16 16V416H86.6l-16-16 84.7-84.7L166.6 304l-11.3-11.3L22.6 160z'
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fast',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      'M232 56a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 136 56zm-3.1 72H251.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L246.1 144H137.9L55.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5h5zM136 240v8V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V496H632h8v16h-8H8 0V496H8 120V248v-8h16zm48 256h16V352H184V496zM597.9 138.6l5.4 5.9-11.8 10.9-5.4-5.9L504 60.5 504 408v8H488v-8l0-347.5-82.1 89-5.4 5.9-11.8-10.9 5.4-5.9 96-104 5.9-6.4 5.9 6.4 96 104z'
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fast',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      'M97.3 168L32 367.9 81.2 512H193.4L240 368 177.3 168l22-86c1.4-5.3 2-10.8 2-16.2V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.7c0 5.5 .7 10.9 2 16.2l22 86zm86.5-90l-20.9 82H111.8L90.9 78c-1-4-1.5-8.1-1.5-12.3V64c0-26.5 21.5-48 48-48s48 21.5 48 48v1.7c0 4.1-.5 8.3-1.5 12.3zM163 176l60.2 191.9L181.8 496H92.6L48.9 367.8 111.5 176H163zm173-8L272 368l47.9 144H432.1L480 368 416 168l22-86c1.4-5.3 2-10.8 2-16.2V64c0-35.3-28.7-64-64-64s-64 28.7-64 64v1.7c0 5.5 .7 10.9 2 16.2l22 86zm86.5-90l-20.9 82H350.5L329.5 78c-1-4-1.5-8.1-1.5-12.3V64c0-26.5 21.5-48 48-48s48 21.5 48 48v1.7c0 4.1-.5 8.3-1.5 12.3zm40.7 289.9L420.6 496H331.4L288.8 367.9 350.2 176h51.5l61.4 191.9z'
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fast',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      'M564.7 131.3L576 120l-11.3-11.3L467.3 11.3 456 0 444.7 11.3 304.2 151.8l12.6 10L377.7 101 475 198.3l-49.4 49.4 12.6 10L564.7 131.3zM126.6 352l87.7-87.7-12.6-10L104 352 68.4 494.4 64 512l17.6-4.4L224 472 335.8 360.2l-12.6-10L224 449.4V408v-8h-8H176V360v-8h-8H126.6zm82.1 107.3L86 490l30.7-122.7c1 .5 2.1 .7 3.3 .7h40v40 8h8 40v40c0 1.2 .3 2.3 .7 3.3zM553.4 120l-67 67L389 89.7l67-67L553.4 120zM13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7z'
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fast',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240c70.7 0 128-57.3 128-128S294.7 0 224 0C164.2 0 113.9 41.1 99.9 96.6L45.7 42.3 40 36.7 28.7 48l5.7 5.7L92.7 112 34.3 170.3 28.7 176 40 187.3l5.7-5.7L96 131.3C97.8 200.5 154.4 256 224 256zM144 80V96v32 16h16H288h16V128 96 80H288 160 144zM132 320L262.1 496H21.7L75.8 320H132zm3.9-16H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304H308l-74 98.7L224 416l-10-13.3-71.6-95.4c0 0 0 0 0-.1L140 304h-3.9c-.1 0-.1 0-.2 0zm97.4 126.2l3.5-4.6L316 320h56.2l54.2 176H281.9l-3.5-4.8-45.1-61zM160 96H288v32H160V96z'
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fast',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      'M320 32V42.3l-1.2 1.9L51.6 480H32.8L297.7 48H8 0V32H8 312h8z'
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fast',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      'M192 48c150.2 0 272 121.8 272 272h16C480 160.9 351.1 32 192 32V48zM384 320c0-106-86-192-192-192v16c97.2 0 176 78.8 176 176h16zM16 104V96H0v8V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8-8v16h8 8c70.7 0 128 57.3 128 128s-57.3 128-128 128S16 438.7 16 368V104z'
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fast',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM219 384l100.2-87.6c8.6-7.6 15.7-16.5 21.1-26.3c7.5-13.7 11.7-29.3 11.7-46v0c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c4.3 0 8.6-.3 12.8-.8L194.7 384H219zm36.9-240a80 80 0 1 1 .1 160 80 80 0 1 1 -.1-160z'
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fast',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      'M16 16V496H208V344v-8h8H368V16H16zM224 489.4L361.4 352H224V489.4zm0 22.6H16 0V496 16 0H16 368h16V16 352L224 512zM173.7 77.7l-96 96L72 179.3 60.7 168l5.7-5.7 96-96 5.7-5.7L179.3 72l-5.7 5.7zm96 32l-160 160-5.7 5.7L92.7 264l5.7-5.7 160-160 5.7-5.7L275.3 104l-5.7 5.7z'
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fast',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-64h8 72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H104 96V192zm64 32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm136-32h72c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16H296h-8V192h8zm72 16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM322.1 397.4C309.3 383.1 287.3 368 256 368s-53.3 15.1-66.1 29.4l-5.4 5.9-11.9-10.7 5.4-5.9C193.1 370 219.1 352 256 352s62.9 18 77.9 34.6l5.4 5.9-11.9 10.7-5.4-5.9z'
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fast',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM264 104V276.7l74.3-74.3 5.7-5.7L355.3 208l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L168 196.7l5.7 5.7L248 276.7V104 96h16v8z'
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fast',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      'M128 3.4l11.4 5.3 240 112 15.5 7.2-15.5 7.2L144 245.1v69.4c33.8-6.7 71.8-10.5 112-10.5c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v16.9c-5.2 1.8-10.2 3.7-15 5.6c-22 9-38.8 19.2-49.8 29.8C20.2 389.6 16 399.4 16 408s4.2 18.4 15.2 28.9c11 10.6 27.8 20.8 49.8 29.8C125 484.6 186.8 496 256 496s131-11.4 175-29.3c22-9 38.8-19.2 49.8-29.8c11-10.5 15.2-20.3 15.2-28.9s-4.2-18.4-15.2-28.9c-11-10.6-27.8-20.8-49.8-29.8C387 331.4 325.2 320 256 320c-40.6 0-78.6 3.9-112 10.8v50.7c17.2-12.9 46.6-21.5 80-21.5c53 0 96 21.5 96 48s-43 48-96 48c-47.6 0-87.1-17.3-94.7-40H128v-8V334.4 317.9 240 16 3.4zM144 408c0 3.9 3.6 11.8 19.3 19.6C178 435 199.4 440 224 440s46-5 60.7-12.4c15.7-7.8 19.3-15.7 19.3-19.6s-3.6-11.8-19.3-19.6C270 381 248.6 376 224 376s-46 5-60.7 12.4C147.6 396.2 144 404.1 144 408zm0-180.6L357.1 128 144 28.6V227.4z'
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fast',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      'M0 56C0 25.1 25.1 0 56 0H440h8V8 408v8h-8H416v80h24 8v16h-8H56c-30.9 0-56-25.1-56-56V56zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40H400V416H56zm-40 .8C26.2 406.4 40.3 400 56 400h56V16H56C33.9 16 16 33.9 16 56V416.8zM128 16V400H432V16H128z'
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fast',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      'M0 32H8 32 48 208h16 24 8V48h-8H224V208.5l-16 16V208H48V384c0 44.2 35.8 80 80 80c18.2 0 35-6.1 48.4-16.3l.2 .5 11 11c-16.4 13-37.1 20.8-59.7 20.8c-53 0-96-43-96-96V48H8 0V32zM48 48V192H208V48H48zM465.1 272.8c-20.4 20.4-6 55.2 22.8 55.2H512v48l-24 0c-28.8 0-43.2 34.8-22.9 55.2l17 17-33.9 33.9-17-17c-20.3-20.3-55-6-55.2 22.7V512H328V488.2l0-.2c0-28.8-34.8-43.2-55.2-22.9l-17 17-33.9-33.9 17-17c20.4-20.4 5.9-55.2-22.9-55.2l-24 0V328h24.1c28.8 0 43.2-34.8 22.8-55.2l-17-17 33.9-33.9 17 17c20.4 20.4 55.2 5.8 55.2-23V192h48v24.2c.1 28.7 34.9 43 55.2 22.7l17-17 33.9 33.9-17 17zM487.9 344c-43-.1-64.6-52.1-34.1-82.5l5.7-5.7-11.3-11.3-5.7 5.7c-30.4 30.4-82.3 9-82.5-33.9l0-.1 0-8.2H344v7.9c0 42.9-51.9 64.9-82.5 34.3l-5.7-5.7-11.3 11.3 5.7 5.7c30.4 30.4 8.9 82.4-34.1 82.5H208v16l8 0c43.1 0 64.6 52.1 34.2 82.5l-5.7 5.7 11.3 11.3 5.7-5.7c30.4-30.4 82.5-8.9 82.5 34.1l0 8h16v-8.3c0-6.6 1.3-12.8 3.6-18.3c5.3-13 16-22.4 28.4-26.9c16.4-5.9 35.9-3.3 50.5 11.3l5.7 5.7 11.3-11.3-5.7-5.7c-13.5-13.5-16.8-31.2-12.5-46.7c4.6-16.8 18-31.1 36.8-34.8c3.2-.6 6.5-1 9.9-1l8 0V344h-8.1zM320 336a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fast',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      'M528 228V192c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5L389.4 135l-8.5-14.8C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144v8.2 11.3l-10.7 3.8C51.6 232.9 16 280.3 16 336V464H144 512 624V352c0-52.2-35.7-96-84-108.5l-12-3.1V228zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96v36c55.2 14.2 96 64.3 96 124V464v16H624 512 144 16 0V464 336zM249.8 206.5l5.7 5.7L320 276.7l64.6-64.6 5.7-5.7 11.3 11.3-5.7 5.7L331.3 288l64.6 64.6 5.7 5.7-11.3 11.3-5.7-5.7L320 299.3l-64.6 64.6-5.7 5.7-11.3-11.3 5.7-5.7L308.7 288l-64.6-64.6-5.7-5.7 11.3-11.3z'
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fast',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zM629.7 149.7l5.7-5.7L624 132.7l-5.7 5.7L496 260.7l-58.3-58.3-5.7-5.7L420.7 208l5.7 5.7 64 64 5.7 5.7 5.7-5.7 128-128z'
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fast',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      'M261.7 333.7l112-112 5.7-5.7L368 204.7l-5.7 5.7L264 308.7V8 0H248V8 308.7l-98.3-98.3-5.7-5.7L132.7 216l5.7 5.7 112 112 5.7 5.7 5.7-5.7zM8 32H0v8V504v8H8 504h8v-8V40 32h-8H408h-8V48h8 88V496H16V48h88 8V32h-8H8z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fast',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      'M432 48V320H304 288v16V464H16V48H432zm-6.6 288L304 457.4V336H425.4zM16 480H288h16L448 336V320 48 32H432 16 0V48 464v16H16zM72 96H64v8 48 8h8 48 8v-8V104 96h-8H72zm8 48V112h32v32H80zM64 224v8 48 8h8 48 8v-8V232v-8h-8H72 64zm16 16h32v32H80V240zM72 352H64v8 48 8h8 48 8v-8V360v-8h-8H72zm8 48V368h32v32H80z'
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fast',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      'M352 0h8H632h8V16h-8H368V391.8l50.1-13.7C428.3 326.7 473.6 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-1.6 0-3.2 .1-4.7L18.1 503.7l-7.7 2.1L6.2 490.4l7.7-2.1L352 396.2V8 0zM624 400a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM219.9 138.4l-54.1 14.5 20.7 77.3 2.1 7.7-7.7 2.1L119 256.6l-7.7 2.1-2.1-7.7L88.5 173.6 34.4 188.1 84.1 373.6l185.5-49.7L219.9 138.4zM104 169.5L122.6 239 169 226.6l-18.6-69.5L104 169.5zm-73.7 3.2L215.7 123l15.5-4.1 4.1 15.5L285 319.7l4.1 15.5-15.5 4.1L88.3 389l-15.5 4.1-4.1-15.5L19 192.3l-4.1-15.5 15.5-4.1z'
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fast',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      'M383.9 328.7c65-20.3 112.1-81 112.1-152.7c0-88.4-71.6-160-160-160c-71.7 0-132.4 47.1-152.7 112.1c-2.4-.1-4.8-.1-7.3-.1c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-2.4 0-4.9-.1-7.3zM336 336A160 160 0 1 0 16 336a160 160 0 1 0 320 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm168-96v40h40 8v16h-8H168v40 8H152v-8V296H112h-8V280h8 40V240v-8h16v8zM360 80v40h40 8v16h-8H360v40 8H344v-8V136H304h-8V120h8 40V80 72h16v8z'
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fast',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      'M570.3 143L497 69.7l47-47L617.4 96l-47 47zM480 64l-5.7 5.7L320 224 292.4 334.4 288 352l17.6-4.4L416 320 570.3 165.7 576 160l5.7-5.7 47-47L640 96 628.7 84.7 555.3 11.3 544 0 532.7 11.3l-47 47L480 64zm5.7 17L559 154.3 407.8 305.6 310 330l24.5-97.8L485.7 81zM8 128H0v8V504v8H8 568h8v-8V264v-8H560v8V496H16V144H312h8V128h-8H8zM144 304H112v32h32V304zm64 0v32h32V304H208z'
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fast',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M257.3 80h13.1H304v64H192 80V80h33.6 13.1l2.6-12.8C135.2 38 161.1 16 192 16s56.8 22 62.7 51.2L257.3 80zM113.6 64H80 64V80 96H8 0v8V504v8H8 376h8v-8V104 96h-8H320V80 64H304 270.4C263 27.5 230.7 0 192 0s-71 27.5-78.4 64zM16 112H64v32 16H80 192 304h16V144 112h48V496H16V112zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM160 216v16h8H312h8V216h-8H168h-8zm0 96v16h8H312h8V312h-8H168h-8zm0 96v16h8H312h8V408h-8H168h-8zM96 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fast',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      'M296 20.1l40 15V111c5.5 1.6 10.8 3.5 16 5.7V24L288 0 232.8 113.3c6.7-2.3 13.6-4.2 20.6-5.7L296 20.1zM188.3 136.8c5-3.7 10.1-7.1 15.5-10.2C186.6 117.2 167.8 112 148 112c-41.8 0-79 23.3-105.5 59.5S0 257.5 0 312s16.1 104.2 42.5 140.5S106.2 512 148 512c25.5 0 49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6s49.3-8.7 70-23.6c20.7 15 44.5 23.6 70 23.6c41.8 0 79-23.3 105.5-59.5S576 366.5 576 312s-16.1-104.2-42.5-140.5S469.8 112 428 112c-19.8 0-38.6 5.2-55.8 14.6c5.4 3.1 10.5 6.5 15.5 10.2c12.8-5.7 26.3-8.8 40.3-8.8c35.5 0 68.3 19.7 92.5 52.9S560 260.5 560 312s-15.2 97.8-39.5 131c-24.2 33.2-57.1 53-92.5 53c-23.5 0-45.7-8.6-65-24l-5-3.9-5 3.9c-19.4 15.4-41.6 24-65 24s-45.7-8.6-65-24l-5-3.9-5 3.9c-19.4 15.4-41.6 24-65 24c-35.5 0-68.3-19.7-92.5-53C31.2 409.8 16 363.5 16 312s15.2-97.8 39.5-131.1S112.5 128 148 128c14 0 27.5 3.1 40.3 8.8zM288 152c41.2 0 77.6 20.8 99.2 52.5l4.5 6.6 13.2-9-4.5-6.6C376 159.6 334.7 136 288 136s-88 23.6-112.4 59.5l-4.5 6.6 13.2 9 4.5-6.6c21.6-31.7 58-52.5 99.2-52.5z'
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fast',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      'M128 16v96H32V16h96zM32 0H16V16v96 16H32 72V384H32 16v16 96 16H32h96 16V496 400 384H128 88V128h40 16V112 16 0H128 32zM306.6 10.1l-88 80L212.1 96l6.5 5.9 88 80 10.8-11.8L244.7 104H336c48.6 0 88 39.4 88 88V384H384 368v16 96 16h16 96 16V496 400 384H480 440V192c0-57.4-46.6-104-104-104H244.7l72.7-66.1L306.6 10.1zM32 400h96v96H32V400zm352 0h96v96H384V400z'
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fast',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      'M16 0H248V16H16V400H231.8h.3H343.9h.3H560V16H328V0H560h16V16 400v16H560 353.4l13.3 80H440h8v16h-8H360 216 136h-8V496h8 73.2l13.3-80H16 0V400 16 0H16zM80 64H248V80H80V272H496V80H328V64H496h16V80 272v16H496 80 64V272 80 64H80zM225.4 496H350.6l-13.3-80H238.8l-13.3 80zM296 8V212.7l74.3-74.3 5.7-5.7L387.3 144l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L200 132.7l5.7 5.7L280 212.7V8 0h16V8z'
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fast',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M128.6 41.6L127.3 48h-6.5H80V64 96H240V64 48H199.2h-6.5l-1.3-6.4C188.4 27 175.5 16 160 16s-28.4 11-31.4 25.6zM64 48V40 32h8 42.7C121.3 13.4 139.1 0 160 0s38.7 13.4 45.3 32H248h8v8 8h48 16V64 96H304V64H256v40 8h-8H72 64v-8V64H16V432H192v16H16 0V432 64 48H16 64zM496 496V230.6L409.4 144H240V496H496zm16-272V496v16H496 240 224V496 144 128h16H416l96 96z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fast',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M51.9 284.1l4.7-9.3-6.7-8C28.3 240.7 16 209.4 16 176C16 90 99.4 16 208 16s192 74 192 160s-83.4 160-192 160c-33.9 0-65.7-7.3-93.2-20.1l-4.7-2.2-5.1 1-76 15.2 22.9-45.8zM0 352l19.9-4 88.2-17.6C137.7 344.2 171.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 37.5 13.9 72.3 37.6 100.9l-28.5 57L0 352zM432 512c36.2 0 70.3-7.8 99.9-21.6L620.1 508l19.9 4-9.1-18.1-28.5-57C626.1 408.3 640 373.5 640 336c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5l0 .5c100.7 6.8 176 77.8 176 159.5c0 33.4-12.3 64.7-33.9 90.7l-6.7 8 4.7 9.3 22.9 45.8-76-15.2-5.1-1-4.7 2.2C497.7 488.7 465.9 496 432 496c-89 0-161-49.7-184.2-114.9c-5.4 .8-10.8 1.4-16.3 1.9C255.8 457.4 336.4 512 432 512z'
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fast',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M104.9 112L234.5 256 104.9 400 80 400l0-288 24.9 0zM256 256L112 96 80 96 64 96l0 16 0 288 0 16 16 0 32 0L256 256z'
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fast',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      'M14.4 265.6L0 256l14.4-9.6L272 74.7 288 64V83.2 198.4L496 73.6 512 64V82.7 429.3 448l-16-9.6L288 313.6V428.8 448l-16-10.7L14.4 265.6zM288 294.9L496 419.7V92.3L288 217.1v77.9zM272 418.1V93.9L28.8 256 272 418.1z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fast',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M0 512l4.4-17.6L40 352 380.7 11.3 392 0l11.3 11.3 97.4 97.4L512 120l-11.3 11.3L160 472 17.6 507.6 0 512zM160 408v41.4l251-251L313.7 101 62.6 352H104h8v8 40h40 8v8zm-16 48V416H104 96v-8V368H56c-1.2 0-2.3-.3-3.3-.7L22 490l122.7-30.7c-.5-1-.7-2.1-.7-3.3zM422.3 187l67-67L392 22.6l-67 67L422.3 187zM317.7 173.1l-144 144-5.7 5.7-11.3-11.3 5.7-5.7 144-144 5.7-5.7 11.3 11.3-5.7 5.7z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fast',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      'M192 64l96 48 96-48L576 224s-80 224-240 224H240C80 448 0 224 0 224L192 64zm103.2 62.3c-4.5 2.3-9.8 2.3-14.3 0L194.2 83 19.1 228.9c2.4 5.8 5.8 13.8 10.3 23.2c9.7 20.4 24.3 47.6 43.6 74.6C112.1 381.5 168 432 240 432h96c72 0 127.9-50.5 167-105.3c19.3-27 33.8-54.2 43.6-74.6c4.5-9.4 7.9-17.4 10.3-23.2L381.8 83l-86.6 43.3zm-181 109c8.1 7.6 20.1 17.8 35.9 28c31.6 20.4 78.1 40.7 138 40.7s106.3-20.3 138-40.7c15.8-10.2 27.9-20.4 35.9-28c1-.9 1.9-1.8 2.7-2.6L357 208.3c-1.2 .4-2.9 .9-4.9 1.5c-4.4 1.3-10.5 3.1-17.5 4.9c-13.8 3.5-31.8 7.2-46.5 7.2s-32.7-3.7-46.5-7.2c-7-1.8-13.1-3.6-17.5-4.9c-2.1-.6-3.7-1.2-4.9-1.5L111.4 232.7c.8 .8 1.7 1.7 2.7 2.6zM222 192.4l0 0 .1 0 .3 .1 1.3 .4c1.1 .4 2.8 .9 4.9 1.5c4.2 1.3 10.1 3 16.8 4.7c13.6 3.5 30 6.8 42.6 6.8s28.9-3.3 42.6-6.8c6.7-1.7 12.6-3.4 16.8-4.7c2.1-.6 3.8-1.2 4.9-1.5l1.3-.4 .3-.1 .1 0 0 0 0 0 0 0 4.3-.2 123.4 28 4.4 12.9L480 228c6.2 5.1 6.2 5.1 6.2 5.1l0 0 0 0-.1 .1-.2 .2-.7 .8c-.6 .7-1.4 1.6-2.6 2.9c-2.2 2.4-5.5 5.8-9.9 9.9c-8.6 8.2-21.5 19-38.2 29.8C401.1 298.3 351.6 320 288 320s-113.1-21.7-146.6-43.3c-16.8-10.8-29.6-21.6-38.2-29.8c-4.3-4.1-7.6-7.5-9.9-9.9c-1.1-1.2-2-2.2-2.6-2.9l-.7-.8-.2-.2-.1-.1 0 0 0 0s0 0 6.2-5.1l-6.2 5.1 4.4-12.9 123.4-28 4.3 .2 0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fast',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      'M352 16V80H256V40 16h96zM256 96h96 16V80 16 0H352 256 240V16 56 80 96v48H40 32v16h8H472h8V144h-8H256V96zM80 200v-8H64v8V376v8h8H184h16H312h16H440h8v-8V200v-8H432v8V368H328V200v-8H312v8V368H200V200v-8H184v8V368H80V200zM40 432H32v16h8H472h8V432h-8H40zM8 496H0v16H8 504h8V496h-8H8z'
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fast',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      'M352 48c0-26.5 21.5-48 48-48s48 21.5 48 48V64h64l0-16c0-26.5 21.5-48 48-48s48 21.5 48 48v8 8H592V56 48c0-17.7-14.3-32-32-32s-32 14.3-32 32V80l44.8 44.8 55.9 40.3 6.1 4.4-3.9 6.3-24 38.7-4.1 6.6-6.7-3.8-20-11.4V320v16H560 392 376V320 205.8l-20 11.4-6.7 3.8-4.1-6.6-24-38.7-3.9-6.3 6.1-4.4 55.9-40.3L432 72V48c0-17.7-14.3-32-32-32s-32 14.3-32 32v8 8H352V56 48zm40 86.6V320H560V134.6L505.4 80H448h-1.4L392 134.6zM304.2 69.9c6.9-5.5 15-9.6 23.8-11.9V74.7c-5.1 1.8-9.7 4.4-13.8 7.7l-12 9.5L292.1 80.4C283.3 70.3 270.4 64 256 64s-27.3 6.3-36.1 16.4L209.8 91.9l-12-9.5C189.7 75.9 179.3 72 168 72c-22.5 0-41.5 15.6-46.6 36.5l-3.5 14.2-14.5-2.2c-2.4-.4-4.9-.6-7.4-.6c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6l3 12.1-11 5.9C26.3 205.7 16 221.7 16 240s10.3 34.3 25.4 42.4l11 5.9-3 12.1C48.5 304.1 48 308 48 312c0 26.5 21.5 48 48 48c2.5 0 5-.2 7.4-.6l14.5-2.2 3.5 14.2c5.1 21 24.1 36.6 46.6 36.6c11.3 0 21.7-3.9 29.8-10.4l12-9.5 10.1 11.5c8.8 10.1 21.7 16.4 36.1 16.4s27.3-6.3 36.1-16.4l10.1-11.5 12 9.5c8.2 6.5 18.5 10.4 29.8 10.4c22.5 0 41.5-15.6 46.6-36.6l.8-3.4H447c-7.4 4.1-15.7 6.8-24.6 7.7L391.8 505.8l-1.5 6.2H384 312h-8v-8V448v-8h16v8 48h57.7l27.7-117.9C397.6 404.6 373.1 424 344 424c-15 0-28.9-5.2-39.8-13.9c-11.7 13.4-29 21.9-48.2 21.9s-36.5-8.5-48.2-21.9C196.9 418.8 183 424 168 424c-29.1 0-53.6-19.4-61.4-45.9L134.3 496H192V448v-8h16v8 56 8h-8H128h-6.3l-1.5-6.2L89.6 375.7C57.3 372.5 32 345.2 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zm34.5 103.8l16 25.8L376 187.4V146.8l-37.3 26.9zm258.5 25.8l16-25.8L576 146.8v40.5l21.3 12.2zM448 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fast',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      'M112 0h8H272h4.2l2.4 3.5 104 152 1.4 2V160v16 24V304v16H368 16 0V304 176 160H16h96V8 0zM267.8 16H128V160H366.3L267.8 16zM16 176V304H368V200 176H120 16zM80 368c-35.3 0-64 28.7-64 64s28.7 64 64 64H336c35.3 0 64-28.7 64-64s-28.7-64-64-64H80zM0 432c0-44.2 35.8-80 80-80H336c44.2 0 80 35.8 80 80s-35.8 80-80 80H80c-44.2 0-80-35.8-80-80zm96 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM576 161.5L416 300.2V279L578.8 138 592 126.5V144 322.1v3.2l-2.2 2.3L456 467.2V496h96c39.8 0 72-32.2 72-72V384 320 272 16H586.9L416 158.4V137.6L578.9 1.9 581.1 0H584h48 8V8 272v48 64 40c0 48.6-39.4 88-88 88H448h-8v-8V464v-3.2l2.2-2.3L576 318.9V161.5z'
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fast',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      'M504.9 18.5L488 35.3V40 215.5 232l-16-4-48-12-16-48-48-16-16-48L296 88 284 40l-4-16h16.5H472h4.7L493.5 7.1l5.7-5.7 11.3 11.3-5.7 5.7zM420.6 155.3l2.5 7.6 13.2 39.7 35.6 8.9V40H300.5l8.9 35.6 39.7 13.2 7.6 2.5 2.5 7.6 13.5 40.4 40.4 13.5 7.6 2.5zM169.9 139.3l0 0 0 0C83.4 181.3-1.6 222.5 0 336c1.4 95.3 79.8 175.9 176.4 176c128.1 .1 224.3-134.9 273.6-256.5l-15.7-3.9c-17.2 42-40.2 85.7-68.2 124.3c-50.8 70-115.5 120.2-189.8 120.2C88.9 495.9 17.3 422.6 16 335.8c-.6-43.5 12.5-74.5 33.2-99.1c21.2-25.1 51.2-44.1 85.7-62.2c12.9-6.7 26.8-13.5 41-20.4l0 0 0 0 0 0c22.4-10.9 45.4-22.1 66.4-34.1c8.5-4.9 16.8-10 24.9-15.4L265 95.8 263 88.1c-28.3 19.7-60.8 35.5-93.1 51.2z'
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fast',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zM96 256v64h64V256H96zM80 240H96h64 16v16 64 16H160 96 80V320 256 240zm144 16v64h64V256H224zm-16-16h16 64 16v16 64 16H288 224 208V320 256 240zm208 16H352v64h64V256zm-64-16h64 16v16 64 16H416 352 336V320 256 240h16z'
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fast',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 352a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0c0-35.3-28.7-64-64-64c-18.8 0-35.7 8.1-47.4 21l-108-75.6L94 228.9 84.9 242l6.6 4.6 108 75.6c-4.7 8.9-7.4 19.1-7.4 29.9c0 35.3 28.7 64 64 64s64-28.7 64-64zM160 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM384 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fast',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      'M496 304L16 304l0 160 480 0V304zm16-16v16V464v16H496 16 0V464 304 288H16 248V163.3l-50.3 50.3-5.7 5.7L180.7 208l5.7-5.7 64-64 5.7-5.7 5.7 5.7 64 64 5.7 5.7L320 219.3l-5.7-5.7L264 163.3V288H496h16zm0-248V216v8h-8H400h-8V208h8 96V48L16 48l0 160h96 8v16h-8H8 0v-8V40 32H8l496 0h8v8z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fast',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M295.8 32h22.4l-184 187 .2 .3L318.8 480H299.2L122.9 230.6 16 339.3V472v8H0v-8V336 40 32H16v8V316.5L295.8 32z'
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fast',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      'M16 496H368V118.6L265.4 16H16V496zM272 0L384 112V496v16H368 16 0V496 16 0H16 272z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fast',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M113.9 125.9c5.6-30.4 26.3-52.3 57.8-65c31.8-12.9 74.4-16.3 121.9-9.3C308.2 53.8 353.2 62 368 65.8l7.8 2 3.9-15.5-7.8-2c-15.5-3.9-61.1-12.3-76-14.5c-49.3-7.3-95-4-130.3 10.3c-35.5 14.4-60.8 40.2-67.6 77.2l0 0-.1 .4c-2.8 22.3 .6 41.1 9.1 57c8.4 15.8 21.5 28.1 37.1 38.1c25.8 16.5 59.7 27.4 93.8 37.2H8 0v16H8 504h8V256h-8H295.4c-11-3.4-22.2-6.6-33.3-9.7l-2.2-.6c-40.4-11.5-79.3-22.5-107.2-40.4c-14-9-24.8-19.4-31.6-32.1c-6.7-12.5-9.7-27.9-7.3-47.2zM394 336.5c5.8 13 7.8 29 4.1 49.3c-5.6 30.5-26.2 52.4-57.9 65.3c-31.8 12.9-74.4 16.3-121.9 9.3c-24.2-3.7-64.7-16.8-94.7-26.5l0 0 0 0c-6.3-2-12.2-3.9-17.3-5.5L98.8 426 94 441.2l7.6 2.4c4.8 1.5 10.4 3.3 16.6 5.3l0 0c29.9 9.7 72.2 23.3 97.8 27.3l0 0c49.3 7.3 95 4 130.3-10.3c35.5-14.4 60.8-40.2 67.6-77.2c4.2-22.9 2.1-42.2-5.3-58.7c-1.6-3.5-3.3-6.8-5.3-10H383.5c4.3 5.1 7.8 10.6 10.5 16.5z'
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fast',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      'M192 1.1l5.8 6.2 128 136 2.2 2.3v3.2V168v8h-8H268.5l89 82.1 2.6 2.4V264v24 8h-8H299.3l82.3 82.3 2.3 2.3V384v24 8h-8H200v88 8H184v-8V416H8 0v-8V384v-3.3l2.3-2.3L84.7 296H32 24v-8V264v-3.5l2.6-2.4 89-82.1H64 56v-8V148.8v-3.2l2.2-2.3 128-136L192 1.1zM368 400V387.3l-93.7-93.7L260.7 280H280h64V267.5L242.6 173.9l-15-13.9H248h64v-8L192 24.5 72 152v8h64 20.5l-15 13.9L40 267.5V280h64 19.3l-13.7 13.7L16 387.3V400H184V200v-8h16v8V400H368zM448 1.1l5.8 6.2 128 136 2.2 2.3v3.2V168v8h-8H524.5l89 82.1 2.6 2.4V264v24 8h-8H555.3l82.3 82.3 2.3 2.3V384v24 8h-8H456v88 8H440v-8l0-88V400l0-200v-8h16v8V400H624V387.3l-93.7-93.7L516.7 280H536h64V267.5L498.6 173.9l-15-13.9H504h64v-8L448 24.5l-90.2 95.8-5.5 5.8-11.7-11 5.5-5.8 96-102L448 1.1z'
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fast',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      'M144 0h8 80 8V8 32v8l0 120h64 16v16 16h64V72 64h8 80 8v8V344c0 92.8-75.2 168-168 168h-8.5c-63.7 0-124.7-25.3-169.7-70.3L44.5 352.3 16.2 324.1l-5.7-5.7 5.7-5.7 56.6-56.6 5.7-5.7 5.7 5.7 28.3 28.3L144 316.1V8 0zM400 192v13.4V208 336v16H384 320 304 240 224V336l0-80v-8V205.4 40 32 16H160V335.4l-13.7 5.7L101 295.8 78.4 273.1 33.1 318.4 55.8 341l89.4 89.4c42 42 99 65.6 158.4 65.6H312c83.9 0 152-68.1 152-152V80H400V192zm-16 16H320V336h64l0-80 0-48zm-80-16V176H240V336h64V208 192z'
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fast',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      'M329.6 246.8l164.6-20.6-.1-.6c-.6-5.1-1.5-10.2-2.4-15.2C470.4 99.7 373 16 256 16C123.5 16 16 123.5 16 256c0 61.5 23.1 117.5 61.1 160H112l99.5 42.6c8.3 3.5 17.2 5.4 26.1 5.4c36.7 0 66.4-29.7 66.4-66.4v-1.3c0-8.1-1.5-16.2-4.3-23.8L286 336h46l12.1 57.5 16 95.8 1.1 6.7H368 504h8v-8V392 328v-8h-8H345l-15.4-73.2zm-15.9 2l15 71.2H280l-18.2-48.6L256 256l16.3-2 41.4-5.2zM84.4 400C51.7 361.1 32 310.8 32 256C32 132.3 132.3 32 256 32c108.8 0 199.5 77.6 219.8 180.4L254 240.1l-20.1 2.5 7.1 19 43.7 116.5c2.2 5.8 3.3 12 3.3 18.2v1.3c0 27.8-22.6 50.4-50.4 50.4c-6.8 0-13.6-1.4-19.8-4.1l-99.5-42.6-3-1.3H112 84.4zM176 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320 16H358.5l-10.1-48H496v48zM374.8 480l-13.3-80H496v80H374.8z'
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fast',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      'M112 48v96H16V48h96zM16 32H0V48v96 16H16h96 16V144 48 32H112 16zm96 176v96H16V208h96zM16 192H0v16 96 16H16h96 16V304 208 192H112 16zm0 176h96v96H16V368zM0 352v16 96 16H16h96 16V464 368 352H112 16 0zM272 48v96H176V48h96zM176 32H160V48v96 16h16 96 16V144 48 32H272 176zm0 176h96v96H176V208zm-16-16v16 96 16h16 96 16V304 208 192H272 176 160zM272 368v96H176V368h96zm-96-16H160v16 96 16h16 96 16V464 368 352H272 176zM336 48h96v96H336V48zM320 32V48v96 16h16 96 16V144 48 32H432 336 320zM432 208v96H336V208h96zm-96-16H320v16 96 16h16 96 16V304 208 192H432 336zm0 176h96v96H336V368zm-16-16v16 96 16h16 96 16V464 368 352H432 336 320z'
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fast',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      'M224 432C109.1 432 16 338.9 16 224S109.1 16 224 16s208 93.1 208 208c0 31-6.8 60.3-18.9 86.7c-2.1 4.6-4.4 9.1-6.8 13.6c-10.4 18.8-23.6 35.8-39 50.5l0 0c-3.9 3.7-7.9 7.2-12.1 10.6l0 0C319.4 414.6 273.7 432 224 432zm0 16c54.4 0 104.3-19.4 143.1-51.7l116.2 105L495.2 512l10.3-12.2 60-71.2 10.4-12.3-13.5-8.8L427 318.8c13.5-28.8 21-60.9 21-94.8C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm269.7 41L379.1 385.6c16-15.3 29.7-33 40.6-52.5l132.4 86.6L493.7 489zM323.9 138.5c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8zm-4 15.5c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8c15.2 15.8 44.5 32.9 65.8 38.4zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM484.8 440a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fast',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      'M48 16V496H432V16H48zM32 0H48 432h16V16 496v16H432 48 32V496 16 0zM504 80v64 8H488v-8V80 72h16v8zm0 120v8 64 8H488v-8V208v-8h16zm0 136v64 8H488v-8V336v-8h16v8zM150.2 368H133.3L160 288H320l26.7 80H329.8l-21.3-64H171.5l-21.3 64zM288 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fast',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      'M0 0H8 64h6.2l1.6 6 69.4 266h341L557.6 32h16.8L495.6 282.4l-1.8 5.6H488 145.3l20.9 80H496h8v16h-8H160h-6.2l-1.6-6L57.8 16H8 0V0zM208 464a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM240 128H400h8v16h-8H240h-8V128h8z'
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fast',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      'M496 80V432H16V80H496zM16 64H0V80 432v16H16 496h16V432 80 64H496 16zM64 320v16h8 80 8V320h-8H72 64zm128 0v16h8 80 8V320h-8H200h-8zM80 144H432v96H80V144zM64 128v16 96 16H80 432h16V240 144 128H432 80 64z'
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fast',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      'M0 64H8 96h64 4.2l2.4 3.4L292.2 248H476.7l-66.3-66.3-5.7-5.7L416 164.7l5.7 5.7 80 80 5.7 5.7-5.7 5.7-80 80-5.7 5.7L404.7 336l5.7-5.7L476.7 264H292.2L166.6 444.6l-2.4 3.4H160 96 8 0V432H8 96h59.8L278.3 256 155.8 80H96 8 0V64z'
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fast',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-376V248H176V136v-8H160v8V248v16l0 112v8h16v-8l0-112H336V376v8h16v-8V256 136v-8H336v8z'
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fast',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      'M18.4 256L137.3 48H374.7L493.6 256 374.7 464H137.3L18.4 256zM128 32L0 256 128 480H384L512 256 384 32H128zm57.8 142.5l-11.3 11.3 5.7 5.7L244.7 256l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L256 267.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L267.3 256l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L256 244.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fast',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      'M8 0H0V16H8 57.8l94.4 362 1.6 6H160 496h8V368h-8H166.2l-20.9-80H488h5.9l1.8-5.6L574.3 32H557.6L482.1 272h-341L71.7 6 70.2 0H64 8zM176 432a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256-48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM263.4 76.1L252.1 87.4l5.7 5.7L308.7 144l-50.9 50.9-5.7 5.7 11.3 11.3 5.7-5.7L320 155.3l50.9 50.9 5.7 5.7 11.3-11.3-5.7-5.7L331.3 144l50.9-50.9 5.7-5.7L376.6 76.1l-5.7 5.7L320 132.7 269.1 81.8l-5.7-5.7z'
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fast',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      'M365.6 45.6L352 32l18.9-3.8L495 3.4 512 0l-3.4 17L483.8 141.1 480 160l-13.6-13.6-44.7-44.7-243 243L200 416l-83.2 83.1L104 512l-5.2-17.4L80 432 17.4 413.2 0 408l12.8-12.9L96 312l71.3 21.4 243-243L365.6 45.6zM160.8 348.2l-60.3-18.1L30.3 400.4l54.3 16.3 8.3 2.5 2.5 8.3 16.3 54.3 70.3-70.3-18.1-60.3-3-3zM470.2 127.5L491.6 20.4 384.5 41.8l85.7 85.7zM192 64c56.3 0 108.3 18.1 150.5 48.9l-11.5 11.5C291.8 96.4 243.8 80 192 80C136.8 80 85.9 98.7 45.3 130l140 140-11.3 11.3L10.3 117.7 4.7 112 16 100.7l5.7 5.7 12.3 12.3C77.5 84.4 132.3 64 192 64zM387.6 180.9l11.5-11.5C429.9 211.7 448 263.7 448 320c0 59.7-20.4 114.5-54.6 158.1l12.3 12.3 5.7 5.7L400 507.3l-5.7-5.7L230.6 337.9l11.3-11.3 140 140c31.4-40.6 50-91.4 50-146.7c0-51.8-16.4-99.8-44.4-139.1z'
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fast',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      'M16 496H311.2c6.1 5.8 12.7 11.1 19.6 16H16 0V496 16 0H16 224L384 160v38.6c-5.4 1.5-10.8 3.3-16 5.4V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM560 368a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-272 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm156 76H420V420h24v24zm-4-164v8 96 8H424v-8V288v-8h16z'
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fast',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      'M464 16V80h16V16 0H464 80 64V16 192H80V16H464zM208 128H624V400H416v16H624h16V400 128 112H624 208 192v16 64h16V128zM16 496V310.8L187.4 432l4.6 3.3 4.6-3.3L368 310.8V496H16zm4.6-201.5L16 291.2V240H368v51.2l-4.6 3.3L192 415.7 20.6 294.5zM0 224v16V496v16H16 368h16V496 240 224H368 16 0zm512-48h-8v8 64 8h8 64 8v-8V184v-8h-8H512zm8 64V192h48v48H520z'
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fast',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      'M256 16V64H64V16H256zM48 16V64H16 0V80 496v16H16 304h16V496 80 64H304 272V16 0H256 64 48V16zM256 80h16 32V496H16V80H48 64 256zM128 208c-35.3 0-64-28.7-64-64H88c35.3 0 64 28.7 64 64H128zM88 128l-24 0H48v16c0 44.2 35.8 80 80 80h24 16 24c44.2 0 80-35.8 80-80V128H256l-24 0c-31.7 0-59 18.4-72 45.1C147 146.4 119.7 128 88 128zm104 80H168c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64zM128 312c-35.3 0-64-28.7-64-64H88c35.3 0 64 28.7 64 64H128zM88 232H64 48v16c0 44.2 35.8 80 80 80h24 16 24c44.2 0 80-35.8 80-80V232H256 232c-31.7 0-59 18.4-72 45.1C147 250.4 119.7 232 88 232zm104 80H168c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64zM128 416c-35.3 0-64-28.7-64-64H88c35.3 0 64 28.7 64 64H128zM88 336H64 48v16c0 44.2 35.8 80 80 80h24v24 8h16v-8V432h24c44.2 0 80-35.8 80-80V336H256 232c-31.7 0-59 18.4-72 45.1C147 354.4 119.7 336 88 336zm104 80H168c0-35.3 28.7-64 64-64h24c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fast',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      'M240 160.2c0-33.8 20.5-69.7 54.2-97.9C327.8 34.3 372.3 16 416 16c44.2 0 80 35.8 80 80c0 43.7-18.3 88.2-46.3 121.8c-28.2 33.8-64.1 54.2-97.9 54.2h-33l-23.4-23.4-32-32L240 193.1v-33zm44.1 99.7L312.2 288h39.6C432 288 512 192 512 96c0-53-43-96-96-96C320 0 224 80 224 160.2v39.6l28.1 28.1 10.3 10.3L6.2 494.5 .5 500.2l11.3 11.3 5.7-5.7L273.8 249.5l10.3 10.3z'
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fast',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      'M16 272V464H496V272H416c0 26.5-21.5 48-48 48s-48-21.5-48-48H16zm480-16c0-113.1-90.2-205.1-202.6-207.9l-64 49.8c20 5.8 34.6 24.2 34.6 46.1c0 26.5-21.5 48-48 48c-26 0-47.1-20.6-48-46.4L26.1 256H322.7c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32H496zM368 240a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM186.7 131c-1.8 4-2.7 8.4-2.7 13c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32c-1.8 0-3.6 .2-5.4 .4L186.7 131zm16.9-33.4L288 32c123.7 0 224 100.3 224 224V464v16H496 16 0V464 256L174.1 120.6l29.6-23zM176 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fast',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      'M336 16H624V496H416v16H624h16V496 16 0H624 336 320V16 161l16 13.3V16zm80 272h40 8v-8V216v-8h-8H392h-8v6.3l16 13.3V224h48v48H416v16zm0 112h40 8v-8V328v-8h-8H416v16h32v48H416v16zm88-192h-8v8 64 8h8 64 8v-8V216v-8h-8H504zm8 64V224h48v48H512zm-16 48v8 64 8h8 64 8v-8V328v-8h-8H504h-8zm64 16v48H512V336h48zM392 96h-8v8 64 8h8 64 8v-8V104 96h-8H392zm8 64V112h48v48H400zm96-64v8 64 8h8 64 8v-8V104 96h-8H504h-8zm16 16h48v48H512V112zM16 263.5L192 116.8 368 263.5V496H16V263.5zM0 256V496v16H16 368h16V496 256L192 96 0 256zm152 24h80v80H152V280zm0-16H136v16 80 16h16 80 16V360 280 264H232 152z'
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fast',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      'M272 96c-90.6 0-165.2 68.5-174.9 156.5C38.9 287.5 0 351.2 0 424v48 8H16v-8V424c0-63 31.7-118.6 80-151.8C96.1 369.3 174.9 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-41.9-7.3-81.7-20.4-117.6c-2.7-7.3-5.6-14.5-8.7-21.5c-2.2 7.2-5.2 14-8.8 20.5C455.1 72.5 418.3 96 376 96H288 272v0zm16 16h88c43.5 0 81.8-21.7 105-54.7c9.7 30.8 15 64.2 15 99.3C496 311.3 393.5 431.4 272.9 432l-.9 0h0c-88.4 0-160-71.6-160-160s71.6-160 160-160h16v0zM189.7 241.1c0 14.3 5.9 28 16.4 37.8l70.9 66.4L288 355.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8H331c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8zm87.4-20.4L288 231l10.9-10.2 5.2-4.8c7.3-6.8 16.9-10.6 26.9-10.6h3.5c19.8 0 35.8 16 35.8 35.8c0 9.9-4.1 19.4-11.3 26.1L288 333.6l-70.9-66.4c-7.2-6.8-11.3-16.2-11.3-26.1c0-19.8 16-35.8 35.8-35.8H245c10 0 19.6 3.8 26.9 10.6l5.2 4.8z'
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fast',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      'M476.6 224c-8-55.2-36.4-107.5-83.8-144.5C295.3 3.3 154.5 20.6 78.4 118.1l-.1 .1 0 0L46.9 160V72 64h-16v8V184v8h8 112 8V176h-8-96L91 127.9C161.7 37.4 292.4 21.4 382.9 92.1c43.4 33.9 69.6 81.5 77.5 131.9h16.2zm-5.9 96h-112-8v16h8H456l-36.1 48.1c-70.7 90.5-201.4 106.5-291.9 35.8C84.6 386 58.3 338.4 50.5 288H34.3c8 55.2 36.4 107.5 83.8 144.5c97.5 76.2 238.3 58.9 314.4-38.6l.1-.1 0 0 30.1-40V440v8h16v-8V328v-8h-8z'
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fast',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      'M160 507.3l5.7-5.7 96-96 5.7-5.7L256 388.7l-5.7 5.7L168 476.7V264H568h8V248h-8H424V35.3l82.3 82.3 5.7 5.7L523.3 112l-5.7-5.7-96-96L416 4.7l-5.7 5.7-96 96-5.7 5.7L320 123.3l5.7-5.7L408 35.3V248H8 0v16H8 152V476.7L69.7 394.3 64 388.7 52.7 400l5.7 5.7 96 96 5.7 5.7zM152 40V192h16V40 32H152v8zM408 320V472v8h16v-8V320H408z'
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fast',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      'M192 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32.5 103.1C243.4 108 256 87.5 256 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c6.2 0 12.2-.9 17.8-2.5l12.9 25.9c-25.5 14.1-44.8 32.8-60.7 51.4c-7.7 9-14.6 17.9-20.9 26.1l0 0 0 0-.5 .6c-6.5 8.5-12.5 16.1-18.3 22.6C110.6 265.4 100.8 272 90.1 272c-15.5 0-23.5-11.5-34.3-28.3l-.7-1.1C45.4 227.5 32.9 208 8 208H0v16H8c15.5 0 23.5 11.5 34.3 28.3l.7 1.1c9.6 15 22.1 34.5 47.1 34.5c18 0 31.9-11.4 44.2-25.2l.3-.3c1.6 2.8 3.5 6.1 5.7 9.7c6.6 10.7 16.1 24.4 28.7 38.5c-3.6 9.6-6.5 19.4-9.3 28.6l0 0 0 0 0 0 0 0 0 0-1.3 4.3c-3.4 11.1-6.6 21.2-10.6 29.9c-4 8.6-8.5 15.1-14 19.5c-5.3 4.3-12.1 6.9-21.7 6.9c-13.3 0-26.8-6.4-43.5-14.3l-2.1-1C49.5 376.8 30 368 8 368H0v16H8c18 0 34.5 7.2 51.6 15.2l3.3 1.6C78.3 408.1 95 416 112 416c12.9 0 23.3-3.7 31.7-10.4c8.2-6.6 14-15.6 18.5-25.3c4.5-9.7 8-20.8 11.4-31.9L175 344l0 0c2-6.8 4.1-13.5 6.4-20.2c21.5 21.2 50 41.8 85.8 52.5c-5.6 17.9-17.3 47.4-33.3 72.9c-8.4 13.4-17.8 25.3-27.8 33.7s-20.1 13-30.1 13h-8v16h8c15.1 0 28.7-6.9 40.4-16.8s22.1-23.3 31-37.4c17.1-27.3 29.5-58.7 35.3-77.5c11.7 2.4 24.2 3.8 37.3 3.8s25.6-1.3 37.3-3.8c5.8 18.8 18.1 50.2 35.3 77.5c8.9 14.1 19.3 27.5 31 37.4s25.3 16.8 40.4 16.8h8V496h-8c-10 0-20.1-4.6-30.1-13s-19.4-20.4-27.8-33.7c-16-25.5-27.7-55-33.3-72.9c35.8-10.7 64.3-31.3 85.8-52.5c2.3 6.7 4.3 13.4 6.4 20.2l0 0 1.3 4.4c3.4 11.1 6.9 22.2 11.4 31.9c4.5 9.8 10.3 18.8 18.5 25.3c8.4 6.7 18.8 10.4 31.7 10.4c17 0 33.7-7.9 49.1-15.2l3.3-1.6C597.5 391.2 614 384 632 384h8V368h-8c-22 0-41.5 8.8-58.4 16.8l-2.1 1C554.8 393.6 541.3 400 528 400c-9.6 0-16.4-2.7-21.7-6.9c-5.5-4.4-10-10.9-14-19.5c-4-8.6-7.2-18.7-10.6-29.9l-1.3-4.3 0 0c-2.8-9.2-5.8-19-9.3-28.6c12.5-14.2 22-27.9 28.7-38.5c2.2-3.6 4.2-6.9 5.7-9.7l.3 .3C518 276.6 531.9 288 549.9 288c24.9 0 37.4-19.5 47.1-34.5l.7-1.1C608.5 235.5 616.5 224 632 224h8V208h-8c-24.9 0-37.4 19.5-47 34.5l-.7 1.1c-10.8 16.8-18.8 28.3-34.3 28.3c-10.7 0-20.5-6.6-32.3-19.8c-5.8-6.5-11.7-14.1-18.3-22.6l-.5-.6 0 0 0 0 0 0c-6.4-8.2-13.3-17.2-20.9-26.1c-15.9-18.6-35.2-37.4-60.7-51.4l12.9-25.9c5.7 1.6 11.6 2.5 17.8 2.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 23.5 12.6 44 31.5 55.1l-12.6 25.1c-22.7-10-49.8-16.3-82.9-16.3s-60.3 6.3-82.9 16.3l-12.6-25.1zM448 16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM145.8 249.8l-.3-.5c2.6-3.2 5.1-6.6 7.7-9.9l.4-.5 0 0 0 0c6.4-8.3 13.1-17 20.5-25.6c29.9-34.9 71-69.2 145.8-69.2s115.9 34.3 145.8 69.2c7.4 8.6 14.1 17.3 20.5 25.6l.4 .5c2.6 3.4 5.2 6.7 7.7 9.9l-.3 .5c-1.8 3.4-4.5 8.2-8.1 14c-7.2 11.7-18.2 27.2-32.9 42.7C423.8 337.6 379.8 368 320 368s-103.8-30.4-133.2-61.5c-14.7-15.5-25.6-31.1-32.9-42.7c-3.6-5.8-6.3-10.7-8.1-14zM208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fast',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      'M400 96h8 80 3.3l2.3 2.3 112 112 2.3 2.3V216 400h24 8v16h-8H575.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H239.6c.2 2.6 .4 5.3 .4 8c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8H8 0V400H8 67.3c10.4-36.9 44.4-64 84.7-64s74.2 27.1 84.7 64H400V104 96zm16 277.4c15.9-22.6 42.2-37.4 72-37.4c40.3 0 74.2 27.1 84.7 64H592V232H416V373.4zM416 216H588.7l-104-104H416V216zM152 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm408-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z'
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fast',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      'M224 128h8 32H368 472h32 8v16h-8H480v48h86.1l62.3-31.2 11.6-5.8V168 376v12.9l-11.6-5.8L566.1 352H96 94.6l-1.3-.5-88-32L0 317.6V312 232v-5.6l5.3-1.9 88-32 1.3-.5H96 256V144H232h-8V128zm240 16H376v48h88V144zm-104 0H272v48h88V144zM97.4 208L16 237.6v68.8L97.4 336H568h1.9l1.7 .8L624 363.1V180.9l-52.4 26.2-1.7 .8H568 480 464 376 360 272 256 97.4zM272 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fast',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      'M118.7 224c-41.3 19-74.1 53.5-90.7 96H356c-16.6-42.6-49.3-77.1-90.7-96l-9.3-4.3V209.4 16H128V209.4v10.3l-9.3 4.3zM272 16V209.4c25.4 11.6 47.8 28.6 65.7 49.6l.6-.6L396.7 200l-26.3-26.3-5.7-5.7L376 156.7l5.7 5.7 32 32 32 32 5.7 5.7L440 243.3l-5.7-5.7L408 211.3l-58.3 58.3-2 2C370.5 303.2 384 342 384 384c0 49.2-18.5 94-48.9 128H48.9C18.5 478 0 433.2 0 384c0-77.5 45.9-144.3 112-174.6V16H88 80V0h8 24 16H256h16 24 8V16h-8H272zm88 320H24c-.5 0-.9 0-1.3-.1C18.3 351.2 16 367.3 16 384c0 42.6 15.1 81.6 40.2 112H327.8c25.1-30.4 40.2-69.4 40.2-112c0-16.7-2.3-32.8-6.7-48.1c-.4 .1-.9 .1-1.3 .1z'
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fast',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      'M16 128C16 66.1 66.1 16 128 16c47.6 0 88.4 29.7 104.5 71.7l7.5 19.4 7.5-19.4C263.6 45.7 304.4 16 352 16c61.9 0 112 50.1 112 112s-50.1 112-112 112H128C66.1 240 16 189.9 16 128zM128 0C57.3 0 0 57.3 0 128s57.3 128 128 128H352c70.7 0 128-57.3 128-128S422.7 0 352 0c-48.2 0-90.2 26.6-112 66C218.2 26.6 176.2 0 128 0zM448 467.7l112 38.8 16 5.5V495.1 272.9 256l-16 5.5L448 300.3v16.9l112-38.8V489.5L448 450.8v16.9zM48 352H64v16V496v16H80 400h16V496 304 288H400 160 128 64 32 16 0v16 32 16H16 32 48zM16 336V304H32 64h64 32H400V496H80V352 336H64 32 16zM128 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm176-64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fast',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M0 480H8 376h8v-8V384v-8H368v8 80H25.8L206 261.3l4.7-5.3-4.7-5.3L25.8 48H368v80 8h16v-8V40 32h-8H8 0V43l2 2.3L189.3 256 2 466.7 0 469v11z'
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fast',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256.3 91.8c-48.2 0-94.1-6.9-135-19.3c23.3 51.6 75 87.5 135 87.5s111.7-35.8 135-87.5c-40.9 12.4-86.7 19.3-135 19.3zm0-16c51.5 0 99.9-8.1 142-22.3c6.2-2.1 12.3-4.3 18.2-6.7c-1.4 6.5-3.3 12.9-5.4 19.2c-22.5 64.1-83.3 110-154.8 110s-132.3-45.9-154.8-110c-2.2-6.2-4-12.6-5.4-19.2c5.9 2.4 12 4.6 18.2 6.7c42.1 14.2 90.5 22.3 142 22.3zM160 101.4l7.2 15.1 21.2 44.4 48.7 6.4 16.6 2.2-12.2 11.5-35.7 33.8 9 48.3 3.1 16.5-14.7-8L160 248.3l-43.2 23.5-14.7 8 3.1-16.5 9-48.3L78.4 181.1 66.2 169.5l16.6-2.2 48.7-6.4 21.2-44.4 7.2-15.1zm0 37.2l-15.8 33.2-1.9 3.9-4.3 .6L101.6 181l26.6 25.3 3.1 3-.8 4.3-6.7 36.1 32.3-17.5 3.8-2.1 3.8 2.1 32.3 17.5-6.7-36.1-.8-4.3 3.1-3L218.4 181 182 176.2l-4.3-.6-1.9-3.9L160 138.6zm199.2-22l21.2 44.4 48.7 6.4 16.6 2.2-12.2 11.5-35.7 33.8 9 48.3 3.1 16.5-14.7-8L352 248.3l-43.2 23.5-14.7 8 3.1-16.5 9-48.3-35.7-33.8-12.2-11.5 16.6-2.2 48.7-6.4 21.2-44.4 7.2-15.1 7.2 15.1zm-23 55.2l-1.9 3.9-4.3 .6L293.6 181l26.6 25.3 3.1 3-.8 4.3-6.7 36.1 32.3-17.5 3.8-2.1 3.8 2.1 32.3 17.5-6.7-36.1-.8-4.3 3.1-3L410.4 181 374 176.2l-4.3-.6-1.9-3.9L352 138.6l-15.8 33.2z'
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fast',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm136 96H240c48.6 0 88 39.4 88 88s-39.4 88-88 88H144v72 8H128v-8V296 136v-8h8zM240 288c39.8 0 72-32.2 72-72s-32.2-72-72-72H144V288h96z'
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fast',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      'M176 496H496V176H384V160H496h16v16V496v16H496 176 160V496 384h16V496zM336 352H16 0V336 16 0H16 336h16V16 336v16H336zm-48-64H272 80 64V272 80 64H80 272h16V80 272v16zM16 336H336V16H16V336zm256-64V80H80V272H272z'
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fast',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fast',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      'M145.7 36.1C135 53.6 128 75.4 128 92v95.3L3.4 276.3 0 278.7v4.1 88 11.1l10.5-3.5L128 339.2l0 52.3L82.3 437.1 80 439.5v3.3 56 10.8l10.4-3.2L192 475.2l64 19.7V478.1l-61.6-19-2.4-.7-2.4 .7L96 488V446.1l45.7-45.7 2.3-2.3v-3.3V336l0-7.9V317l0-121.5V192v-.6V92c0-13 5.7-31.9 15.3-47.5c9.9-16.1 21.8-25.7 32.7-25.7c11.3 0 23.2 9.6 33 25.6c9.5 15.6 15 34.5 15 47.5l0 94.8v4.5l3.9 2.3 12.1 7.3 0-18.7L256 96l0-4c0-16.6-6.7-38.3-17.3-55.8C228.3 19 212.2 2.8 192 2.8c-19.8 0-35.8 16.2-46.3 33.3zM128 322.4L16 359.7V286.9l112-80V322.4zM304 144H624V448H608V328v-8h-8H576.7l-1.4-4.6-19.2-64L552.7 240H540.8 387.2 375.3l-3.4 11.4-19.2 64-1.4 4.6H328h-8v8V448H304V144zM600 464h8 16 16V448 144 128H624 304 288v16V448v16h16 16 8 8v40 8h16v-8V464H576v40 8h16v-8V464h8zm-8-16H576 352 336V336h10.5H368 560h21.5H592V448zM555.2 304l4.8 16H543.3 384.7 368l4.8-16 14.4-48H540.8l14.4 48zM388 384a12 12 0 1 1 0 24 12 12 0 1 1 0-24zm0 40a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm140-28a12 12 0 1 1 24 0 12 12 0 1 1 -24 0zm40 0a28 28 0 1 0 -56 0 28 28 0 1 0 56 0z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fast',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM243.5 193.9L256 209.5l12.5-15.6 9.3-11.6c11.3-14.1 28.5-22.4 46.6-22.4c32.9 0 59.6 26.7 59.6 59.6v3.6c0 16.8-6.7 32.8-18.5 44.7l-24.8 24.8L256 377.3l-84.7-84.7-24.8-24.8c-11.9-11.9-18.5-27.9-18.5-44.7v-3.6c0-32.9 26.7-59.6 59.6-59.6c18.1 0 35.3 8.2 46.6 22.4l9.3 11.6zm12.5 206l11.3-11.3L352 303.9l24.8-24.8c14.9-14.9 23.2-35 23.2-56v-3.6c0-41.8-33.9-75.6-75.6-75.6c-22.5 0-43.7 10-58.1 27.2c-.3 .4-.6 .8-1 1.2L256 183.9l-9.3-11.6c-.3-.4-.6-.8-1-1.2c-14.4-17.2-35.6-27.2-58.1-27.2c-41.8 0-75.6 33.9-75.6 75.6v3.6c0 21 8.3 41.1 23.2 56L160 303.9l84.7 84.7L256 399.9z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fast',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M50.3 250.3L44.7 256l5.7 5.7 208 208 5.7 5.7L275.3 464l-5.7-5.7L67.3 256 269.7 53.7l5.7-5.7L264 36.7l-5.7 5.7-208 208zm192 0l-5.7 5.7 5.7 5.7 208 208 5.7 5.7L467.3 464l-5.7-5.7L259.3 256 461.7 53.7l5.7-5.7L456 36.7l-5.7 5.7-208 208z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fast',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      'M32 32v8V304c0 88.4 71.6 160 160 160s160-71.6 160-160V40 32h16v8V304c0 97.2-78.8 176-176 176S16 401.2 16 304V40 32H32z'
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fast',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      'M251.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7C256 81.8 241.8 96 224.4 96h-.8C206.2 96 192 81.8 192 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6L224 0l9.2 16.1 18.6 32.6zm-41.8 7.9c-1.3 2.4-2.1 5-2.1 7.7C208 73 215 80 223.6 80h.8C233 80 240 73 240 64.4c0-2.7-.7-5.4-2.1-7.7L224 32.2 210.1 56.7l-13.9-7.9 13.9 7.9zm233.8-7.9c2.7 4.8 4.2 10.2 4.2 15.7C448 81.8 433.8 96 416.4 96h-.8C398.2 96 384 81.8 384 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6L416 0l9.2 16.1 18.6 32.6zM416 32.2L402.1 56.7c-1.4 2.4-2.1 5-2.1 7.7C400 73 407 80 415.6 80h.8C425 80 432 73 432 64.4c0-2.7-.7-5.4-2.1-7.7L416 32.2zm-384 0L18.1 56.7c-1.3 2.4-2.1 5-2.1 7.7C16 73 23 80 31.6 80h.8C41 80 48 73 48 64.4c0-2.7-.7-5.4-2.1-7.7L32 32.2zM22.8 16.1L32 0l9.2 16.1L59.8 48.7C62.6 53.5 64 58.9 64 64.4C64 81.8 49.8 96 32.4 96h-.8C14.2 96 0 81.8 0 64.4c0-5.5 1.4-10.9 4.2-15.7L22.8 16.1zM128 32.2L114.1 56.7c-1.3 2.4-2.1 5-2.1 7.7C112 73 119 80 127.6 80h.8C137 80 144 73 144 64.4c0-2.7-.7-5.4-2.1-7.7L128 32.2zm-9.2-16.1L128 0l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7C160 81.8 145.8 96 128.4 96h-.8C110.2 96 96 81.8 96 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zm192 0L320 0l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7C352 81.8 337.8 96 320.4 96h-.8C302.2 96 288 81.8 288 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zM320 32.2L306.1 56.7c-1.3 2.4-2.1 5-2.1 7.7C304 73 311 80 319.6 80h.8C329 80 336 73 336 64.4c0-2.7-.7-5.4-2.1-7.7L320 32.2zm192 0L498.1 56.7c-1.4 2.4-2.1 5-2.1 7.7C496 73 503 80 511.6 80h.8C521 80 528 73 528 64.4c0-2.7-.7-5.4-2.1-7.7L512 32.2zm-9.2-16.1L512 0l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7C544 81.8 529.8 96 512.4 96h-.8C494.2 96 480 81.8 480 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zM608 32.2L594.1 56.7c-1.3 2.4-2.1 5-2.1 7.7C592 73 599 80 607.6 80h.8C617 80 624 73 624 64.4c0-2.7-.7-5.4-2.1-7.7L608 32.2zm-9.2-16.1L608 0l9.2 16.1 18.6 32.6c2.7 4.8 4.2 10.2 4.2 15.7C640 81.8 625.8 96 608.4 96h-.8C590.2 96 576 81.8 576 64.4c0-5.5 1.4-10.9 4.2-15.7l18.6-32.6zM40 128v8l0 176c0 30.9 25.1 56 56 56h24V136v-8h16v8V368h80V136v-8h16v8V368h80l0-232v-8h16v8l0 232h80V136v-8h16v8V368h80V136v-8h16v8V368h24c30.9 0 56-25.1 56-56l0-176v-8h16v8l0 176c0 39.8-32.2 72-72 72H328V496H504h8v16h-8H320 136h-8V496h8H312V384H96c-39.8 0-72-32.2-72-72l0-176 0-8H40z'
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fast',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      'M16 496h96v16H16 0V496 16 0H16 224L384 160V304H368V176H216h-8v-8V16H16V496zM361.4 160L224 22.6V160H361.4zM200 368h16c17.7 0 32 14.3 32 32v8 8H232v-8-8c0-8.8-7.2-16-16-16H200c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8-8h16v8 8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm133.1 0H368h8v16h-8H333.1c-11.7 0-21.1 9.4-21.1 21.1c0 8.3 4.9 15.9 12.5 19.3L362 441c13.4 6 22 19.2 22 33.9c0 20.5-16.6 37.1-37.1 37.1H304h-8V496h8 42.9c11.7 0 21.1-9.4 21.1-21.1c0-8.3-4.9-15.9-12.5-19.3L318 439c-13.4-6-22-19.2-22-33.9c0-20.5 16.6-37.1 37.1-37.1zM440 368v8 62.6L461.5 496h4.9L488 438.6V376v-8h16v8 64 1.4l-.5 1.4-24 64-1.9 5.2H472 456h-5.5l-1.9-5.2-24-64-.5-1.4V440 376v-8h16z'
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fast',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      'M560 48H80V352H64V48 32H80 560h16V48 352H560V48zM54.6 464H585.4L624 425.4V400H16v25.4L54.6 464zM640 384v16 32l-48 48H48L0 432V400 384H16 624h16z'
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fast',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      'M160 96a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-96a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM95.9 128h5H219.1h5l2.2 4.5 84.9 176 3.5 7.2-14.4 7-3.5-7.2L214.1 144H105.9L23.2 315.5l-3.5 7.2-14.4-7 3.5-7.2 84.9-176 2.2-4.5zM104 248V496h32V344v-8h8 32 8v8V496h32V248v-8h16v8V504v8h-8H176h-8v-8V352H152V504v8h-8H96 88v-8V248v-8h16v8z'
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fast',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      'M0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2zM191.4 21.8C116.8 87.1 59.9 170.2 26 263.5c-6.6 18.1-10 37.4-10 56.7C16 416.5 95.6 496 192 496s176-79.5 176-175.8c0-19.3-3.4-38.6-10-56.7C324.1 170.2 267.2 87.1 192.6 21.8l-.6-.5-.6 .5zM202.5 164l18 15.7c32.1 28 57.6 62.7 74.9 101.7l.9 2.1c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l.9-2.1c17.3-38.9 42.9-73.6 74.9-101.7l18-15.7 10.5-9.2 10.5 9.2zM174 191.7c-30.3 26.5-54.5 59.3-70.8 96.1l-.9 2.1c-4.1 9.3-6.2 19.4-6.2 29.5c0 53 43 96.5 96 96.5s96-43.5 96-96.5c0-10.1-2.1-20.3-6.2-29.5l-.9-2.1c-16.4-36.8-40.5-69.6-70.8-96.1L192 176l-18 15.7z'
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fast',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      'M80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zm37.4 273.7l-5.4-8.1-16-24v28.8 36.2l54.6 54.6 7.3 7.3 1.7 10.1 8 48 4 24 4 24 0 0 3.5 21.3 .5 2.7 2.2 13.3H165.6 116.9l-.5-2.7-4-24 0 0-4-24-4-24-6.3-37.9L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7V160 144 128H16 32 80 97.1l9.5 14.3L161.1 224H224h16 16v16 32h32 80V112H208v80H192V112 96h16H368h16v16V272v16H368 256 240 224 208 192 144 126.9l-9.5-14.3zM192 272h16 16 16V240H224 161.1h-8.6l-4.8-7.1L93.3 151.1 88.6 144H80 32 16v16V274.7c0 12.7 5.1 24.9 14.1 33.9l22.6 22.6 56.8 56.7 3.6 3.6 .8 5.1 6.3 37.9 4 24 4 24 0 0 0 0 0 0 2.2 13.4h32.4l-3.1-18.6 0 0 0 0 0 0-4-24-4-24-8-48-.8-5.1-3.6-3.6L84.7 318.1 80 313.4v-6.6V241.7 188.8l29.3 44 21.4 32.1 4.7 7.1H144h48zM0 480L0 346.5l16 16L16 480l0 16 32 0 0-16 0-85.5 16 16v37.4L64 480l0 16 0 16-16 0-32 0L0 512l0-16 0-16z'
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fast',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      'M197.7 5.7L192 0l-5.7 5.7-152 152-5.7 5.7L40 174.6l5.7-5.7L184 30.6V504v8h16v-8V30.6L338.3 169l5.7 5.7 11.3-11.3-5.7-5.7-152-152z'
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fast',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      'M128 8V0H112V8 64H16 0V80v96 16V496v16H16 330.8c-6.9-4.9-13.5-10.2-19.6-16H16V192H352h80 16V176 80 64H432 336V8 0H320V8 64H128V8zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM508.5 470.7C487.1 486.6 460.7 496 432 496s-55.1-9.4-76.5-25.3L387.7 432h88.5l32.2 38.7zm12.2-10.3l-34.5-41.4-2.4-2.9H480 384h-3.7l-2.4 2.9-34.5 41.4C319.1 437 304 404.3 304 368c0-70.7 57.3-128 128-128s128 57.3 128 128c0 36.3-15.1 69-39.3 92.3zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fast',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M472 0V8 40h32 8V56h-8H472V88v8H456V88 56H424h-8V40h8 32V8 0h16zM56 64v8 32H88h8v16H88 56v32 8H40v-8V120H8 0V104H8 40V72 64H56zM96 448h8H408h8v8 48 8H400v-8V464H112v40 8H96v-8V456v-8zM256 16a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm48 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM189.6 128h3.8H318.6h3.8l2.4 3L424 254.7l5 6.2-6.2 5-37.5 30-6.2 5-5-6.2-46-57.5V416H312V214.5 191.7l14.2 17.8 55.3 69 25-20L314.8 144H197.2L105.5 258.5l25 20 55.3-69L200 191.7v22.8V416H184V237.3l-46 57.5-5 6.2-6.2-5L89.3 266 83 261l5-6.2L187.2 131l2.4-3zM280 312V416H264V320H248v96H232V312v-8h8 32 8v8z'
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fast',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      'M496 464L16 464l0-160 480 0 0 160zm16 16l0-16 0-160 0-16-16 0L16 288 0 288l0 16L0 464l0 16 16 0 480 0 16 0zM272 208L16 208 16 48l176 0 80 0 0 160zm16 0l0-160 120 0 0 156.7-50.3-50.3-5.7-5.7L340.7 160l5.7 5.7 64 64 5.7 5.7 5.7-5.7 64-64 5.7-5.7L480 148.7l-5.7 5.7L424 204.7 424 40l0-8-8 0L288 32l-16 0-80 0L16 32 0 32 0 48 0 208l0 16 16 0 256 0 16 0 0-16zM72 376l0 16 8 0 352 0 8 0 0-16-8 0L80 376l-8 0zm8-256c-4.4 0-8 3.6-8 8s3.6 8 8 8l128 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L80 120z'
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fast',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      'M496 376H16V496H496V376zm0-16V240H16V360H496zm16 0v8 8V496v16H496 16 0V496 376v-8-8V240 224H16 496h16v16V360zM64 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBeerMugEmpty = {
    prefix: 'fast',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      'M368 48V96v16V464H48V48H368zm16 307.8V112H496V306.8l-112 49zM384 464V373.2l123.2-53.9 4.8-2.1V312 104 96h-8H384V48 32H368 48 32V48 464v16H48 368h16V464zM144 136v-8H128v8V376v8h16v-8V136zm72 0v-8H200v8V376v8h16v-8V136zm72 0v-8H272v8V376v8h16v-8V136z'
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fast',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      'M320 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm69 108.3L426.6 208H415l-3.4 6.1-36.7-66-2.3-4.1H368 272h-4.7l-2.3 4.1-36.7 66L225 208H213.4L251 140.3l6.9-12.3H272h96 14.1l6.9 12.3zm1 67.7l12.5 22.5-9.2 16.5-1.4-2.4-16-28.8v32.9V272h0v16h-5.4H360h0 0V272h0V215.8 176h12.2L390 208zM280 272v16h0H269.4 264v-9.7l0 0V272 248.8 215.8l-16 28.8-1.4 2.4-9.2-16.5L250 208l17.8-32H280v39.8V272h0zm216-64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm83 232.5l-11-19.8-16-28.8v32.9V384v16H536 456 440V384 360.8 327.8l-16 28.8-11 19.8-3.9 7-7.8 14-14-7.8-14-7.8-14-7.8 7.8-14 3.9-7 56-100.8 6.9-12.3H448h96 14.1l6.9 12.3 56 100.8 3.9 7 7.8 14-14 7.8-14 7.8-14 7.8-7.8-14-3.9-7zm-43-48.6V288h12.2L566 320l27 48.6 3.9 7 14-7.8-3.9-7L551 260.1l-2.3-4.1H544 448h-4.7l-2.3 4.1L385 360.9l-3.9 7 14 7.8 3.9-7L426 320l17.8-32H456v39.8V384h80V327.8zM8 464H632h8v16h-8H8 0V464H8zM168 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM216 356.6l-16-28.8v32.9V384v16H184 104 88V384 360.8 327.8L72 356.6 61 376.5l-3.9 7-7.8 14-14-7.8-14-7.8-14-7.8 7.8-14 3.9-7L75 252.3 81.9 240H96h96 14.1l6.9 12.3 56 100.8 3.9 7 7.8 14-14 7.8-14 7.8-14 7.8-7.8-14-3.9-7-11-19.8zM184 384V327.8 288h12.2L214 320l27 48.6 3.9 7 14-7.8-3.9-7L199 260.1l-2.3-4.1H192 96 91.3L89 260.1 33 360.9l-3.9 7 14 7.8 3.9-7L74 320l17.8-32H104v39.8V384h80z'
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fast',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      'M451.5 267.2c18-25.9 28.5-57.3 28.5-91.2c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 33.9 10.5 65.3 28.5 91.2c4.5 6.5 9.5 13.3 14.5 20.2l0 0 0 0c12.5 17.2 25.9 35.5 36.3 54.4c7.4 13.5 11.6 27.8 14 42.2H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H386.7c2.4-14.4 6.6-28.7 14-42.2c10.4-19 23.7-37.3 36.3-54.4c5-6.9 10-13.7 14.5-20.2zM256 496H384V432H256v64zm-16-80h16H384h16v16 64 16H384 256 240V496 432 416zm88-312V264v8H312v-8V104 96h16v8zM304 304h32v32H304V304zM49.1 4.1l75 45 6.9 4.1L122.7 67l-6.9-4.1-75-45L34 13.7 42.3 0l6.9 4.1zm550 13.7l-75 45L517.3 67 509 53.3l6.9-4.1 75-45L597.7 0 606 13.7l-6.9 4.1zM8 160H88h8v16H88 8 0V160H8zm544 0h80 8v16h-8H552h-8V160h8zM124.1 270.9l-75 45L42.3 320 34 306.3l6.9-4.1 75-45 6.9-4.1 8.2 13.7-6.9 4.1zm400-13.7l75 45 6.9 4.1L597.7 320l-6.9-4.1-75-45-6.9-4.1 8.2-13.7 6.9 4.1z'
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fast',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM200 96v8 80h80 8v16h-8H200v80 8H184v-8V200H104 96V184h8 80V104 96h16z'
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fast',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      'M432 48L16 48l0 416 416 0 0-416zm16-16l0 16 0 416 0 16-16 0L16 480 0 480l0-16L0 48 0 32l16 0 416 0 16 0zM349.7 261.7l-104 104-5.7 5.7L228.7 360l5.7-5.7L324.7 264 104 264l-8 0 0-16 8 0 220.7 0-90.3-90.3-5.7-5.7L240 140.7l5.7 5.7 104 104 5.7 5.7-5.7 5.7z'
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fast',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      'M324.4 2.9L320 0l-4.4 3-312 208 8.9 13.3L320 19.2l307.6 205 8.9-13.3-312-208zM496 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm83 152.5l3.9 7 7.8 14 14-7.8 14-7.8 14-7.8-7.8-14-3.9-7L565 364.3 558.1 352H544 448 433.9L427 364.3 371 465.1l-3.9 7-7.8 14 14 7.8 14 7.8 14 7.8 7.8-14 3.9-7 11-19.8 16-28.8v32.9V496v16h16 80 16V496 472.8 439.8l16 28.8 11 19.8zm-43-48.6V496H456V439.8 400H443.8L426 432l-27 48.6-3.9 7-14-7.8 3.9-7 56-100.8 2.3-4.1H448h96 4.7l2.3 4.1 56 100.8 3.9 7-14 7.8-3.9-7L566 432l-17.8-32H536v39.8zM120 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm32 172.6l11 19.8 3.9 7 7.8 14 14-7.8 14-7.8 14-7.8-7.8-14-3.9-7L213 364.3 206.1 352H192 96 81.9L75 364.3 19 465.1l-3.9 7-7.8 14 14 7.8 14 7.8 14 7.8 7.8-14 3.9-7 11-19.8 16-28.8v32.9V496v16h16 80 16V496 472.8 439.8l16 28.8zM184 496H104V439.8 400H91.8L74 432 47 480.7l-3.9 7-14-7.8 3.9-7L89 372.1l2.3-4.1H96h96 4.7l2.3 4.1 56 100.8 3.9 7-14 7.8-3.9-7L214 432l-17.8-32H184v39.8V496zM320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm69 28.3L382.1 240H368 272 257.9L251 252.3 213.4 320H225l3.4 6.1 36.7-66 2.3-4.1H272h96 4.7l2.3 4.1 36.7 66L415 320h11.5L389 252.3zm1 67.7l-17.8-32H360v39.8V384l0 0 0 0v16h0 10.6l5.4 0v-9.7l0 0V384 360.8 327.8l16 28.8 1.4 2.4 9.2-16.5L390 320zM280 384V327.8 288H267.8L250 320l-12.5 22.5 9.2 16.5 1.4-2.4 16-28.8v32.9V384l0 0v16l5.4 0H280l0 0V384l0 0z'
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fast',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      'M8 0H0V8 504v8H8 632h8v-8V8 0h-8H8zm8 496V16H624V496H16zM272 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM235.5 304H404.5l21.3 64H214.2l21.3-64zM416 288H224l-26.7 80L192 384h16.9H431.1 448l-5.3-16L416 288zM144 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM116.9 328l15.3-56h63.4l5.3-16H120l-19.6 72L96 344h16.6 59l5.3-16h-60zm406.1 0h-60l5.3 16h59H544l-4.4-16L520 256H439.1l5.3 16h63.4l15.3 56z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fast',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M229.7 269.7l-5.7 5.7-5.7-5.7-176-176L36.7 88 48 76.7l5.7 5.7L224 252.7 394.3 82.3l5.7-5.7L411.3 88l-5.7 5.7-176 176zm0 192l-5.7 5.7-5.7-5.7-176-176L36.7 280 48 268.7l5.7 5.7L224 444.7 394.3 274.3l5.7-5.7L411.3 280l-5.7 5.7-176 176z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fast',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      'M112 0V8 388.7L388.7 112 160 112V96l244.7 0 85.7-85.7L496 4.7 507.3 16l-5.7 5.7L416 107.3 416 400h88 8v16h-8H416v88 8H400v-8l0-380.7L123.3 400H352v16H104 96v-8V112H8 0V96H8 96V8 0h16z'
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fast',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      'M496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm12-92H484v24h24V420zm-4-132v-8H488v8 96 8h16v-8V288zM16 112H160L320 0 480 112H624h16v16V266.8c-4.9-6.9-10.2-13.5-16-19.6V128H480h-5l-4.1-2.9L320 19.5 169.2 125.1 165 128h-5H16V496H256V384c0-35.3 28.7-64 64-64c2.2 0 4.4 .1 6.5 .3c-1.4 5.2-2.7 10.4-3.6 15.8c-1-.1-1.9-.1-2.9-.1c-26.5 0-48 21.5-48 48V496h32 64 7.2c6.1 5.8 12.7 11.1 19.6 16H384 368 272 256 16 0V496 128 112H16zm48 80h8 64 8v8 80 8h-8H72 64v-8V200v-8zm16 16v64h48V208H80zm304-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-144 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm88-40v8 24h16 8v16h-8H320h-8v-8V144v-8h16zM72 320h64 8v8 80 8h-8H72 64v-8V328v-8h8zm8 80h48V336H80v64z'
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fast',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zM211.9 410.4L224 424.6l12.1-14.2L313.6 320h58.5l54.2 176H21.7L75.8 320h58.5l77.5 90.4zM384 304H306.3l-71.8 83.7L224 400l-10.5-12.3L141.7 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304z'
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fast',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      'M280 35.3c-23.8 3.8-45.6 9.5-65.5 16.9C152 75.3 108.6 114.9 79.7 162c-22.5 36.7-36.1 77.8-43.2 119.2l1.2 1.2 192 192 2.4 2.4c23.8-3.8 45.6-9.5 65.5-16.9C360 436.7 403.4 397.1 432.3 350c22.5-36.7 36.1-77.8 43.2-119.2l-1.2-1.2-192-192L280 35.3zm20-2.7L478.4 211.1c7.1-57.3 2.7-113.9-6.6-159l-2.2-10.7-10.8-1.8c-60.4-10.1-113-11.9-158.9-7zM212 479.4L33.6 300.9c-7.1 57.3-2.7 113.9 6.6 159l2.2 10.7 10.8 1.8c60.3 10.1 113 11.9 158.9 7zM483.1 27.4l4.4 21.5c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3l-21.6-3.6-4.4-21.5C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5C274.4 12.8 357.6 6.5 461.5 23.8l21.6 3.6zM280 156.7l5.7 5.7 64 64 5.7 5.7L344 243.3l-5.7-5.7-64-64-5.7-5.7L280 156.7zm-56 56l5.7 5.7 64 64 5.7 5.7L288 299.3l-5.7-5.7-64-64-5.7-5.7L224 212.7zm-56 56l5.7 5.7 64 64 5.7 5.7L232 355.3l-5.7-5.7-64-64-5.7-5.7L168 268.7z'
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fast',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      'M261.7 50.3L256 44.7l-5.7 5.7-208 208L36.7 264 48 275.3l5.7-5.7L256 67.3 458.3 269.7l5.7 5.7L475.3 264l-5.7-5.7-208-208zm0 192l-5.7-5.7-5.7 5.7-208 208L36.7 456 48 467.3l5.7-5.7L256 259.3 458.3 461.7l5.7 5.7L475.3 456l-5.7-5.7-208-208z'
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fast',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      'M16 8V0H0V8 64 383.5 400 504v8H16v-8V396l112.3-28.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V33.9 16l-16 8L393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L16 60V8zm0 68.5l112-28v93.2L16 166.1V76.5zm0 106l112-24.3v87.6L16 270.1V182.4zm128-27.8l17.8-3.9c19.7-4.3 40.1-3.5 59.4 2.1l65.7 19.3c5.7 1.7 11.4 3 17.2 4.1V264c-4.3-.9-8.5-1.9-12.7-3.1l-65.7-19.3c-21.9-6.4-45-7.3-67.3-2.4L144 242.2V154.6zm176 23.8c16.5 1.4 33.1 .4 49.4-3.1L432 161.9v87.6l-66 14.1c-15.2 3.3-30.7 4.1-46 2.7V178.4zM304 280.3V382c-15.9-2.6-31.4-7.6-46.1-14.9c-35.3-17.7-75.1-24-113.9-18.5V258.6l17.8-3.9c19.7-4.3 40.1-3.5 59.4 2.1l65.7 19.3c5.7 1.7 11.4 3 17.2 4.1zm16 103.5V282.4c16.5 1.4 33.1 .4 49.4-3.1L432 265.9v91l-45.1 16.9c-21.6 8.1-44.4 11.4-66.9 10zm0-221.4V76.6c27.7 0 55.3-6.4 80.7-19.1L432 41.9V145.5l-66 14.1c-15.2 3.3-30.7 4.1-46 2.7zM304 75.9V160c-4.3-.9-8.5-1.9-12.7-3.1l-65.7-19.3c-21.9-6.4-45-7.3-67.3-2.4L144 138.2V44.7c32.2-6.4 65.8-1.9 95.3 12.8c20.5 10.3 42.5 16.4 64.7 18.3zM16 286.4l112-24.3v89.4c-1.2 .3-2.4 .6-3.6 .9L16 379.5V286.4z'
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fast',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      'M272 16V80H240V16h32zm-48 0V80H80V40 32H64v8V80H16V40 32H0v8V80v8 8 32 16H16h85.5L224 228.2V272H80V232v-8H64v8 40H16V232v-8H0v8 40 8 8 32 16H16h85.5L224 420.2V504v8h16v-8V336h32V504v8h16v-8V420.2L410.5 336H496h16V320 288v-8-8V232v-8H496v8 40H448V232v-8H432v8 40H288V228.2L410.5 144H496h16V128 96 88 80 40 32H496v8V80H448V40 32H432v8V80H288V16 0H272 240 224V16zM382.2 144L288 208.8V144h94.2zm0 192L288 400.8V336h94.2zM224 400.8L129.8 336H224v64.8zm0-192L129.8 144H224v64.8zM240 320H224 16V288H224h16 32 16H496v32H288 272 240zm32-176V272H240V144h32zm16-16H272 240 224 16V96H224h16 32 16H496v32H288z'
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fast',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      'M368 16H16V496H144V384 368h16 64 16v16V496h48v16H240 224 160 144 16 0V496 16 0H16 368h16V16 64H368V16zm-80 88v16H256h-8v48h8 32v16H240h-8v-8V112v-8h8 48zm0 128v16H256h-8v48h8 32v16H240h-8v-8V240v-8h8 48zM224 496V384H160V496h64zM72 232h8 64 8v8 64 8h-8H80 72v-8V240v-8zm16 16v48h48V248H88zM72 104h8 64 8v8 64 8h-8H80 72v-8V112v-8zm16 16v48h48V120H88zm248-8V496H624V112H336zM320 96h16H624h16v16V496v16H624 336 320V496 112 96zm64 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM384 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-200H576h8v16h-8H456h-8V200h8zm0 96H576h8v16h-8H456h-8V296h8zm0 96H576h8v16h-8H456h-8V392h8z'
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fast',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zm109.6 96h20.6L224 243.3 317.8 128h20.6L234.3 256 338.4 384H317.8L224 268.7 130.2 384H109.6L213.7 256 109.6 128z'
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fast',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      'M416 224c0-106-86-192-192-192S32 118 32 224H48c0-97.2 78.8-176 176-176s176 78.8 176 176h16zM9.6 256H.8l.9 8.8 1.4 14.3C10.8 356.8 76.2 416 154.3 416H158l-60 66.6L96 484.9V488v16 8h8H344h8v-8V488v-3.1l-2.1-2.3L290 416h3.7c78.1 0 143.5-59.2 151.2-136.9l1.4-14.3 .9-8.8h-8.8H9.6zM19 277.5l-.6-5.5H429.6l-.6 5.5c-7 69.5-65.5 122.5-135.3 122.5H272 254l12 13.4L336 491.1V496H112v-4.9l69.9-77.7L194 400H176 154.3C84.4 400 25.9 347.1 19 277.5z'
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fast',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      'M160 416H144 16 0V400 16 0H16 496h16V16 400v16H496 304L176 501.3 160 512V492.8 432 416zm0-16h16v16 66.1l119.1-79.4 4-2.7H304 496V16H16V400H160zM264 80v8V248v8H248v-8V88 80h16zM240 288h32v32H240V288z'
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fast',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M16.5 400h479C487.2 274.9 383.2 176 256 176S24.8 274.9 16.5 400zM248 160.1V0h16V160.1C396.3 164.2 503.4 268.7 511.5 400c.3 5.3 .5 10.6 .5 16H496 16 0c0-5.4 .2-10.7 .5-16C8.6 268.7 115.7 164.2 248 160.1zM256 512c-35.3 0-64-28.7-64-64h16c0 26.5 21.5 48 48 48s48-21.5 48-48h16c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fast',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm137.4 76.6l13.1-9.2C171.4 353.2 206.6 384 256 384s84.6-30.8 105.4-60.6l13.1 9.2C352.1 364.6 312.7 400 256 400s-96.1-35.4-118.6-67.4zm13.5-146.9c-7.4 11.4-12.7 26.3-15.2 39.8L120 222.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L216 225.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7zm144.8 39.8L280 222.5c2.8-15 8.7-32 17.6-45.6c8.7-13.3 21.5-25 38.3-25s29.6 11.7 38.3 25c8.8 13.5 14.8 30.6 17.6 45.6L376 225.5c-2.5-13.5-7.8-28.4-15.2-39.8c-7.6-11.6-16.1-17.7-24.9-17.7s-17.3 6.1-24.9 17.7c-7.4 11.4-12.7 26.3-15.2 39.8z'
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fast',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      'M272 72V64h16v8V248v16V440v8H272v-8V275.5L48 436.5 32 448V428.3 83.7 64L48 75.5l224 161V72zm-.3 184L48 95.2V416.8L271.7 256z'
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fast',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      'M208 416h16v16 60.8V512l16-10.7L368 416H528h16V400 200h32v8 16h16 32 16V208 176 160H624 592 576v16 8H544V16 0H528 112 96V16 184H64v-8V160H48 16 0v16 32 16H16 48 64V208v-8H96V400v16h16 96zm-96-16V16H528V400H368h-4.8l-4 2.7L240 482.1V416 400H224 112zM160 96H480V288H160V96zM144 80V96 288v16h16H480h16V288 96 80H480 160 144zm80 136a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm256 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm208 24v32H592V176h32zM16 176H48v32H16V176z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fast',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      'M208 16a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 400c54.6 0 104.2-21 141.3-55.4L499.9 511.3l11.3-11.3L360.6 349.3C395 312.2 416 262.6 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm52.8-195.6c-7 16.1-16.5 32.2-26.1 46.8c-9.7 14.5-19.3 27.1-26.6 36l-.1 .1-.1-.1c-7.3-9-17-21.6-26.6-36c-9.7-14.5-19.1-30.7-26.1-46.8C148.1 204.1 144 188.9 144 176c0-35.3 28.7-64 64-64s64 28.7 64 64c0 12.9-4.1 28.1-11.2 44.4zm-42.3 95.3C240.2 289.3 288 225.5 288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 49.5 47.8 113.3 69.5 139.7C203.9 323.5 208 328 208 328s4.1-4.5 10.5-12.3zM224 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fast',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      'M512 120l0-8-8 0-248 0 0-40 0-8-8 0-96 0C68.1 64 0 132.1 0 216l0 80c0 83.9 68.1 152 152 152l8 0 8 0 64 0 72 0 8 0 0-8 0-72 8 0 8 0 0-8 0-72 24 0 8 0 0-8 0-72 144 0 8 0 0-8 0-80zM344 208l0 64-16 0-8 0-64 0 0-64 88 0zM240 272l0 0-64 0 0-104 0-8-16 0 0 8 0 104 0 8 0 8 0 64 0 8 0 8 0 64-8 0C76.9 432 16 371.1 16 296l0-80C16 140.9 76.9 80 152 80l88 0 0 32 0 0 0 16 0 0 0 64 0 0 0 16 0 0 0 64zm0 16l8 0 8 0 56 0 0 64-8 0-128 0 0-64 64 0zm16-96l0-64 240 0 0 64-136 0-8 0-96 0zM232 432l-56 0 0-64 120 0 0 64-64 0z'
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fast',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      'M16 72V64H0v8V248 440v8H16v-8V256H304V440v8h16v-8V248 72 64H304v8V240H16V72zm464 9.4V432H424h-8v16h8 64 64 8V432h-8H496V72 64h-8-8-2.3l-1.9 1.2L416 102.6v18.9l64-40z'
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fast',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      'M560 48V464H16V48H560zM16 32H0V48 464v16H16 560h16V464 48 32H560 16zM312 160v8V344v8h8 64c53 0 96-43 96-96s-43-96-96-96H320h-8zm16 16h56c44.2 0 80 35.8 80 80s-35.8 80-80 80H328V176zm-176.2 3.1c13.2-4.3 31.2-4.5 52.5-1.6c6.5 .9 26.5 4.2 33 5.7l7.8 1.8 3.6-15.6-7.8-1.8c-7.1-1.6-27.6-5-34.4-5.9c-22.1-3-43-3.1-59.6 2.2c-17.2 5.6-29.9 17.3-33.9 36.9l0 0-.1 .4c-1.5 10.5-.1 19.6 4 27.4c4.1 7.7 10.5 13.4 17.8 17.7c14 8.3 33.1 12.8 50.6 16.9l.8 .2c18.5 4.3 35.3 8.3 46.9 15.2c5.6 3.4 9.5 7.1 11.9 11.5c2.3 4.3 3.4 9.8 2.3 17.5c-1 6.8-3.5 11.8-7.1 15.6c-3.6 3.8-8.7 6.8-15.3 8.9c-13.4 4.3-31.9 4.4-53.2 1.5c-10.5-1.5-28.2-6.6-41.7-10.6l0 0c-2.9-.8-5.5-1.6-7.9-2.3l-7.7-2.2L110.1 334l7.7 2.2c2.1 .6 4.6 1.3 7.2 2.1c13.4 3.9 32.7 9.6 44.5 11.2l0 0c22 3 43.4 3.2 60.2-2.1c8.5-2.7 16.2-6.9 22.1-13.2c6-6.4 9.8-14.5 11.2-24.2c1.5-10.5 .1-19.6-4-27.4c-4.1-7.7-10.5-13.4-17.8-17.7c-14-8.3-33.1-12.8-50.6-16.9l-.8-.2c-18.5-4.3-35.3-8.3-46.9-15.2c-5.6-3.4-9.6-7.1-11.9-11.5c-2.3-4.2-3.4-9.7-2.3-17.3c2.7-13 10.6-20.6 23.1-24.7z'
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fast',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      'M369.6 0l-7.1 32H96 89.4l-1.2 6.5-88 464L-1.7 512H8 472h32 8V496h-8H480V360v-5.4l-5-2L321.3 291.1 386 0H369.6zM201.8 48H358.9l-32 144H256h-8v16h8 67.4l-17.8 80H224h-8v16h8 86.5L464 365.4V496H17.7l41-216h90.2 6.6l1.3-6.4L201.8 48zm-16.3 0L142.2 264H61.7l41-216h82.8z'
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fast',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      'M16 256C16 123.5 123.5 16 256 16c77.9 0 147.2 37.1 191 94.7l4.8 6.4 12.7-9.7-4.8-6.4C413 39.6 339.1 0 256 0C114.6 0 0 114.6 0 256v56 8H16v-8V256zm484.8-75l-2.3-7.6L483.2 178l2.3 7.6c6.8 22.2 10.5 45.9 10.5 70.4v56 8h16v-8V256c0-26.1-3.9-51.3-11.2-75zM256 80c-30.5 0-59.3 7.8-84.3 21.5l9.4 13.1C203.4 102.7 228.9 96 256 96c88.4 0 160 71.6 160 160v24.9c0 34.6-2.7 69-8 103.1h16.2c5.2-34 7.8-68.5 7.8-103.1V256c0-97.2-78.8-176-176-176zM133.1 130C100.3 162 80 206.6 80 256v24.9c0 35-5.5 69.8-16.2 103.1H80.6C90.8 350.6 96 315.9 96 280.9V256c0-44 17.8-83.9 46.5-112.8L133.1 130zM256 160c-53 0-96 43-96 96v24.9c0 46-7.6 91.6-22.5 135.1h16.9c14.3-43.5 21.7-89.1 21.7-135.1V256c0-44.2 35.8-80 80-80s80 35.8 80 80v24.9c0 45.6-5.3 90.9-15.6 135.1h16.4c10.1-44.2 15.2-89.5 15.2-135.1V256c0-53-43-96-96-96zm8 96H248v24.9c0 61.9-11.4 123.2-33.6 180.9l-5.9 15.3-1.1 2.9h17.1l4.8-12.4C252.3 408 264 344.8 264 280.9V256z'
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fast',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      'M136 0H248h8V8 56h80 3.3l2.3 2.3 56 56 5.7 5.7L392 131.3l-5.7-5.7L332.7 72H256v56H240V16H144V128H128V8 0h8zM48 512H32l1.1-16L56 160H328l22.9 336 1.1 16H336 48zm286.8-16L313.1 176H70.9L49.1 496H334.9zM168 256h48 8v8 40h40 8v8 48 8h-8H224v40 8h-8H168h-8v-8V368H120h-8v-8V312v-8h8 40V264v-8h8zm8 56v8h-8H128v32h40 8v8 40h32V360v-8h8 40V320H216h-8v-8V272H176v40z'
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fast',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      'M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 24.1 10.6 55.3 28.2 90c17.5 34.2 40.9 70 64.7 102.6c23.7 32.6 47.4 61.8 65.3 82.8c7 8.2 13 15.2 17.8 20.6c4.8-5.4 10.8-12.4 17.8-20.6c17.8-21 41.6-50.2 65.3-82.8c23.7-32.6 47.2-68.4 64.7-102.6c17.7-34.7 28.2-65.9 28.2-90zm16 0c0 95.9-140.8 262.2-181.3 308c-6.8 7.7-10.7 12-10.7 12s-4-4.3-10.7-12C140.8 454.2 0 287.9 0 192C0 86 86 0 192 0S384 86 384 192zM88 200V184H296v16H88z'
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fast',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      'M104 0V8 96h40 16v16 96 16H144 104V504v8H88v-8V224H48 32V208 112 96H48 88V8 0h16zM88 208h16 40V112H104 88 48v96H88zM264 0V8 288h40 16v16 96 16H304 264v88 8H248v-8V416H208 192V400 304 288h16 40V8 0h16zm0 400h40V304H264 248 208v96h40 16zM424 8V128h40 16v16 96 16H464 424V504v8H408v-8V256H368 352V240 144 128h16 40V8 0h16V8zM408 240h16 40V144H424 408 368v96h40z'
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fast',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      'M40 32H32V48h8 80v96H40 32v16h8H600h8V144h-8H520V48h80 8V32h-8H40zM504 48v96H392V48H504zM376 48v96H264V48H376zM248 48v96H136V48H248zM40 256H32v16h8H64c39.8 0 72 32.2 72 72V472v8h8 96 8v-8V344c0-39.8 32.2-72 72-72c9 0 17.6 1.6 25.5 4.7c2.8-4.7 5.9-9.2 9.1-13.6C344 258.5 332.3 256 320 256c-48.6 0-88 39.4-88 88V464H152V344c0-48.6-39.4-88-88-88H40zm456-16a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fast',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      'M264 0V8 248H504h8v16h-8H264V504v8H248v-8V264H8 0V248H8 248V8 0h16zM408 48v8 48h48 8 8 8v16h-8-8-8H408v48 8 8 8H392v-8-8-8V120H344h-8-8-8V104h8 8 8 48V56 48 40 32h16v8 8zM56.4 333.1l5.7 5.7L112 388.7l49.9-49.9 5.7-5.7 11.3 11.3-5.7 5.7L123.3 400l49.9 49.9 5.7 5.7-11.3 11.3-5.7-5.7L112 411.3 62.1 461.3l-5.7 5.7L45.1 455.6l5.7-5.7L100.7 400 50.7 350.1l-5.7-5.7 11.3-11.3zM40 104H184h8v16h-8H40 32V104h8zM328 360H472h8v16h-8H328h-8V360h8zm0 64H472h8v16h-8H328h-8V424h8z'
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fast',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      'M16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5zM608 391.6V48 32H592 152.5l20.3 16H592V379l16 12.6zM370.9 204.4C385.5 187 407.5 176 432 176c27.3 0 51.4 13.7 65.9 34.6l13.2-9.1C493.8 176.5 464.8 160 432 160c-29.6 0-56.1 13.4-73.7 34.5l12.6 9.9zM48 133L32 120.4V464v16H48 487.5l-20.3-16H48V133zM278.3 314.8C264 328 244.9 336 224 336c-44.2 0-80-35.8-80-80c0-14.2 3.7-27.6 10.2-39.1l-12.7-10C132.9 221.2 128 238 128 256c0 53 43 96 96 96c26 0 49.7-10.4 67-27.2l-12.7-10z'
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fast',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      'M387.6 401.1l-14.3-11.3C356.8 396.4 338.8 400 320 400c-79.5 0-144-64.5-144-144V234l-16-12.6V256c0 85.7 67.4 155.6 152 159.8V496H232h-8v16h8 88 88 8V496h-8H328V415.8c21.2-1 41.3-6.2 59.6-14.7zM240 101.1V16H400v96H328h-8v16h8 72v48H334.9l20.3 16H400v35.4l16 12.6V240 192 176 128 112 16 0H400 240 224V16 88.5l16 12.6zM476.8 288c2.1-10.4 3.2-21.1 3.2-32V200v-8H464v8 56c0 7.1-.5 14-1.5 20.8L476.8 288zM16.2 5L9.9 0 0 12.5l6.3 5L623.8 507l6.3 5 9.9-12.5-6.3-5L16.2 5z'
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fast',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      'M73.3 0c19.5 0 38.5 7.7 52.3 21.5L114.2 32.9C103.5 22.1 88.6 16 73.3 16C41.8 16 16 41.5 16 72.6c0 15.6 6.5 30.6 17.9 41.3L128 202.1l94.1-88.2C233.5 103.1 240 88.2 240 72.6c0-31-25.8-56.6-57.3-56.6c-15.3 0-30.2 6.1-41 16.9l-2.5 2.5L128 46.6 116.7 35.3l-2.5-2.5 11.3-11.3L128 24l2.5-2.5C144.3 7.7 163.2 0 182.7 0C222.8 0 256 32.5 256 72.6c0 20.1-8.3 39.2-22.9 52.9L128 224 22.9 125.5C8.3 111.8 0 92.6 0 72.6C0 32.5 33.2 0 73.3 0zM512 6.2V16 176v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3V25.8L352 54.6V208v0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3V48 41.4l6.4-1.3 160-32L512 6.2zM483.7 154.9c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zm-160 32c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1v0c0-7.1-3.8-14.7-12.3-21.1zM472 256h8 11.4l-3.8 10.7L451.4 368H504h8v8 16 3.9l-3.1 2.4-144 112-2.2 1.7H360h-8H340.6l3.8-10.7L380.6 400H328h-8v-8V376.9 373l3.1-2.4 144-112.9 2.2-1.7H472zM336 380.8V384h56 11.4l-3.8 10.7-33.8 94.7L496 388.1V384H440 428.6l3.8-10.7 33.8-94.7L336 380.8zM200 272l16 32h56 16v16V496v16H272 16 0V496 320 304H16 72l16-32H200zm16 48h-9.9l-4.4-8.8L190.1 288H97.9L86.3 311.2 81.9 320H72 16V496H272V320H216zm-32 88a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fast',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      'M240 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM16 192H225.3c.9 5.5 2.3 10.9 4.1 16H16V496H496V208H410.5c1.8-5.1 3.2-10.5 4.1-16H496h16v16V496v16H496 16 0V496 208 192H16zm64 80H96 320h96 16v16V416v16H416 96 80V416 288 272zM96 416H416V288H96V416zM384 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fast',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      'M338 424.7c-25.7-4.7-53.5-13.5-82-25.9c-28.6 12.5-56.3 21.3-82 25.9c.8 1.8 1.6 3.6 2.5 5.4C197.3 474 225 496 256 496s58.7-22 79.5-65.8c.8-1.8 1.7-3.6 2.5-5.4zM256 512c-42.8 0-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8zM236.3 389.7c-13.9-6.8-27.9-14.4-42-22.8c-15.7-9.4-30.6-19.3-44.5-29.5c4 26.6 10.1 51 18 72.3c21.3-3.6 44.4-10.3 68.5-19.9zm107.9 19.9c7.8-21.2 13.9-45.6 18-72.3c-13.9 10.3-28.8 20.2-44.5 29.5c-14 8.4-28.1 16-42 22.8c24.1 9.6 47.2 16.3 68.5 19.9zm-34.7-56.4c20.1-12 38.7-24.8 55.6-38.1c2-18.8 3-38.6 3-59s-1-40.2-3-59c-16.9-13.3-35.5-26.1-55.6-38.1c-18-10.8-35.9-20.2-53.4-28.2c-17.5 8-35.4 17.4-53.4 28.2c-20.1 12-38.7 24.8-55.6 38.1c-2 18.8-3 38.6-3 59s1 40.2 3 59c16.9 13.3 35.5 26.1 55.6 38.1c18 10.8 35.9 20.2 53.4 28.2c17.5-8 35.4-17.4 53.4-28.2zm51 58.6c.9 .1 1.8 .2 2.7 .2c46.3 3.9 77.6-9 92.5-35.8c15.1-27.1 9.9-62.3-16.6-102.3c-1.1-1.6-2.1-3.2-3.3-4.8c-15.3 18.5-34 36.8-55.6 54.2c-3.8 32.5-10.5 62.4-19.7 88.3zm21.9-111.1C399.2 286 413.8 271 425.8 256c-12-15-26.7-30-43.5-44.7c1.1 14.5 1.7 29.4 1.7 44.7s-.6 30.2-1.7 44.7zM439 238c26.6-40 31.7-75.2 16.6-102.3C440.7 109 409.3 96.2 363.1 100c-.9 .1-1.8 .2-2.7 .2c9.2 26 15.9 55.9 19.7 88.3c21.6 17.5 40.3 35.7 55.6 54.2c1.1-1.6 2.2-3.2 3.3-4.8zM335.5 81.8C314.7 38 287 16 256 16s-58.7 22-79.5 65.8c-.8 1.8-1.7 3.6-2.5 5.4c25.7 4.7 53.5 13.5 82 25.9c28.6-12.5 56.3-21.3 82-25.9c-.8-1.8-1.6-3.6-2.5-5.4zm8.6 20.6c-21.3 3.6-44.4 10.3-68.5 19.9c13.9 6.8 27.9 14.4 42 22.8c15.7 9.4 30.6 19.3 44.5 29.5c-4-26.6-10.1-51-18-72.3zm-176.4 0c-7.8 21.2-13.9 45.6-18 72.3c13.9-10.3 28.8-20.1 44.5-29.5c14-8.4 28.1-16 42-22.8c-24.1-9.6-47.2-16.3-68.5-19.9zm-16.2-2.2c-.9-.1-1.8-.2-2.7-.2c-46.3-3.9-77.6 9-92.5 35.7C41.3 162.8 46.5 198.1 73 238c1.1 1.6 2.1 3.2 3.3 4.8c15.3-18.5 34-36.8 55.6-54.2c3.8-32.5 10.5-62.4 19.7-88.3zM131.8 323.4c-21.6-17.5-40.3-35.7-55.6-54.2c-1.1 1.6-2.2 3.2-3.3 4.8c-26.6 40-31.7 75.2-16.6 102.3c14.9 26.8 46.3 39.6 92.5 35.8c.9-.1 1.8-.2 2.7-.2c-9.2-26-15.9-55.9-19.7-88.3zm-2.2-112.1C112.8 226 98.2 241 86.2 256c12 15 26.7 30 43.5 44.7c-1.1-14.5-1.7-29.4-1.7-44.7s.6-30.2 1.7-44.7zm83 33.4l32-32L256 201.4l11.3 11.3 32 32L310.6 256l-11.3 11.3-32 32L256 310.6l-11.3-11.3-32-32L201.4 256l11.3-11.3zM256 288l11.3-11.3 9.4-9.4L288 256l-11.3-11.3-9.4-9.4L256 224l-11.3 11.3-9.4 9.4L224 256l11.3 11.3 9.4 9.4L256 288z'
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fast',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      'M432 48V464H16V48H432zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zm64 80v8V392v8h8H360h8v-8V120v-8h-8H224h-8v8 96.8c-18.3 3.7-32 19.8-32 39.2c0 22.1 17.9 40 40 40s40-17.9 40-40c0-19.4-13.7-35.5-32-39.2V128H352V384H96V128h56 8V112h-8H88 80zM224 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fast',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      'M256 496C123.5 496 16 388.5 16 256c0-28.1 4.8-55 13.7-80H48V296v8h8H232h8v-8V176h32V296v8h8H456h8v-8V176h18.3c8.8 25 13.7 51.9 13.7 80c0 132.5-107.5 240-240 240zM224 176V288H64V176 160H224v16zm16-16v-8-8h-8H56 48v8 8H36C73 75.2 157.6 16 256 16s183 59.2 220 144H464v-8-8h-8H280h-8v8 8H240zm48 0H448v16V288H288V176 160zM256 0C148.6 0 56.6 66.2 18.6 160H8 0v16H8h4.7C4.5 201.2 0 228.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-27.9-4.5-54.8-12.7-80H504h8V160h-8H493.4C455.4 66.2 363.4 0 256 0zm0 416c56.7 0 96.1-35.4 118.6-67.4l-13.1-9.2C340.6 369.2 305.4 400 256 400s-84.6-30.8-105.4-60.6l-13.1 9.2c22.4 32 61.9 67.4 118.6 67.4zM192.4 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm144 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fast',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      'M320 192l0-16 0-64 0-16 16 0 16 0L500.7 244.7 512 256l-11.3 11.3L352 416l-16 0-16 0 0-16 0-64 0-16-16 0-128 0-16 0 0-16 0-96 0-16 16 0 128 0 16 0zm16 0l0 16-16 0-144 0 0 96 144 0 16 0 0 16 0 80 9.4 0 144-144-144-144-9.4 0 0 80zM184 48L16 48l0 416 168 0 8 0 0 16-8 0L8 480l-8 0 0-8L0 40l0-8 8 0 176 0 8 0 0 16-8 0z'
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fast',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      'M224 288V216H448v72 80H224V288zm0-88V128 48H448v80 72H224zm240 80V216h96v64H464zm0-80V136h96v64H464zm112 8v-8V136v-8-8V48 32H560 464h-8-8H224h-8-8H112 96V48v72 8 8 64 8 8 64 8 8 72 16h16 96 8 8H448h8 8 96 16V368 296v-8-8V216v-8zM560 48v72H464V48h96zM112 48h96v72H112V48zm0 88h96v64H112V136zm96 80v64H112V216h96zM112 368V296h96v72H112zm448 0H464V296h96v72zM16 128H0v16V464v16H16 464h16V464 416H464v48H16V144H64V128H16z'
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fast',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      'M320 0L304 4 64 64V496H8 0v16H8 64 80 96 304h16V496 16.5 0zM96 496H80V76.5l224-56V496H96zM496 80V504v8h8 64 8V496h-8H512V72 64h-8H352V80H496zM232 216c-9.7 0-17.9 5.3-23.4 12.6s-8.6 17-8.6 27.4s3.2 20.1 8.6 27.4s13.7 12.6 23.4 12.6s17.9-5.3 23.4-12.6s8.6-17 8.6-27.4s-3.2-20.1-8.6-27.4s-13.7-12.6-23.4-12.6zm-16 40c0-7.2 2.2-13.5 5.4-17.8s7-6.2 10.6-6.2s7.4 1.9 10.6 6.2s5.4 10.6 5.4 17.8s-2.2 13.5-5.4 17.8s-7 6.2-10.6 6.2s-7.4-1.9-10.6-6.2s-5.4-10.6-5.4-17.8z'
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fast',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      'M412.8-.1l5.7 5.7 88 88 5.7 5.7-5.7 5.7-34.6 34.6c-13.2 13.2-31 20.6-49.7 20.6c-16.5 0-31.7-5.7-43.7-15.2L221.7 301.7l71 71L304 384l-11.3 11.3L176 512H16 0V496 336L116.7 219.3 128 208l11.3 11.3 71 71L367.2 133.5c-9.5-12-15.2-27.2-15.2-43.7c0-18.6 7.4-36.5 20.6-49.7L407.1 5.5l5.7-5.7zm0 22.6L383.9 51.4C373.7 61.6 368 75.4 368 89.8c0 29.9 24.3 54.2 54.2 54.2c14.4 0 28.2-5.7 38.3-15.9l28.9-28.9L412.8 22.5zM16 342.6V496H169.4l112-112L128 230.6 16 342.6z'
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fast',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240V465l-8.6-20.2-14.7 6.3 24 56L512 504V256C512 114.6 397.4 0 256 0S0 114.6 0 256V440l15.4 3.2 24-56-14.7-6.3L16 401V256zM128 361.4V304h48v80H150.6L128 361.4zM192 384V304h56v80H192zm112 0H288 264V304h56v80H304zm0 16h64V504v8h16v-8V384l16-16V304 288H384 128 112v16 64l32 32H288v40 8h16v-8V400zm57.4-16H336V304h48v57.4L361.4 384zm-185-160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm176-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-19 275.2C309.1 491.5 283.1 496 256 496c-73.5 0-139.3-33.1-183.4-85.2L60.4 421.2C107.3 476.7 177.6 512 256 512c28.9 0 56.7-4.8 82.6-13.6l-5.2-15.1zM461.6 379.9c-14.3 23.6-32.5 44.6-53.7 61.9L418 454.2c22.6-18.5 42.1-40.9 57.3-66.1l-13.7-8.3zM78.3 263.8l-15-34.9-14.7 6.3 24 56 9 21.1 6-22.1 24-88-15.4-4.2-18 65.9zM367.7 69.9l-15.4 4.2 24 88 6 22.1 9-21.1 24-56-14.7-6.3-15 34.9-18-65.9z'
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fast',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 264H360V248H152v16z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fast',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      'M224 32l48 64H496h16v16V464v16H496 16 0V464 48 32H16 224zm48 80h-8l-4.8-6.4L216 48H16V464H496V112H272zm-8 72V372.7l74.3-74.3 5.7-5.7L355.3 304l-5.7 5.7-88 88-5.7 5.7-5.7-5.7-88-88-5.7-5.7L168 292.7l5.7 5.7L248 372.7V184v-8h16v8z'
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fast',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M16 328.9L160 458.5 304 328.9V304H16v24.9zM160 480L0 336V304 288H16 304h16v16 32L160 480z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fast',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      'M64 32V192H80V32H64zm0 288V480H80V320H64zm64 0H112V480h16V320zM112 192h16V32H112V192zm64 288h16V320H176V480zm0-288h16V32H176V192zm72 288h16V320H248V480zm0-288h16V32H248V192zm72 288h16V320H320V480zm0-288h16V32H320V192zm48 288h16V320H368V480zm0-288h16V32H368V192zm80 288h16V320H448V480zm0-288h16V32H448V192zm64 288h16V320H512V480zm0-288h16V32H512V192zm48 288h16V320H560V480zm0-288h16V32H560V192zM0 248v16l640 0V248L0 248z'
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fast',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      'M48 16H336V284c5.2-4 10.5-7.9 16-11.5V16 0H336 48 32V16 496v16H48 224c0-5.4 .1-10.7 .4-16H48V16zm96 416h-8v16h8 87.1c1.2-5.4 2.6-10.7 4.1-16H144zM512 272V256c-141.4 0-256 114.6-256 256h16c0-132.5 107.5-240 240-240zM496 480a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-48 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-80 32c0-79.5 64.5-144 144-144V352c-88.4 0-160 71.6-160 160h16z'
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fast',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      'M8 48l560 0 8 0 0-16-8 0L8 32 0 32 0 48l8 0zm8 203.3l5.7-5.7L120 147.3 120 472l0 8 16 0 0-8 0-324.7 98.3 98.3 5.7 5.7L251.3 240l-5.7-5.7-112-112-5.7-5.7-5.7 5.7-112 112L4.7 240 16 251.3zm320 0l5.7-5.7L440 147.3 440 472l0 8 16 0 0-8 0-324.7 98.3 98.3 5.7 5.7L571.3 240l-5.7-5.7-112-112-5.7-5.7-5.7 5.7-112 112-5.7 5.7L336 251.3z'
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fast',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      'M277.3 89L400.8 .8l11.5 11.5L286.6 102c-2.5 1.8-4.9 3.8-7 6l-7.6 7.6c-21.9 21.9-21.9 57.3 0 79.2L317.3 240c21.9 21.9 57.3 21.9 79.2 0l7.6-7.6c2.2-2.2 4.2-4.5 6-7L499.7 99.7l11.5 11.5L423 234.7c-2.3 3.2-4.9 6.3-7.7 9.1l-7.6 7.6c-28.1 28.1-73.7 28.1-101.8 0l-17-17L17.5 505.8l-5.7 5.7L.5 500.2l5.7-5.7L277.7 223l-17-17c-28.1-28.1-28.1-73.7 0-101.8l7.6-7.6c2.8-2.8 5.8-5.4 9.1-7.7zm28.9 60.2L433.8 33.8l11.3 11.3L317 161.1l-6.2 5.6-11.3-11.3 6.8-6.2zm39 52.1L466.9 66.9l11.3 11.3L356.6 212.6l-11.3-11.3z'
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fast',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      'M168 236.7l-5.8 5.5c-1.3-1.3-2-3-2.2-4.8c-1.3-14.7-.6-28.8 1.8-42.3c-21.7 5.7-41.6 12.4-59.2 20.1c-27.6 12-49.5 26.2-64.3 41.5C23.5 271.9 16 287.9 16 304s7.5 32.1 22.3 47.4c14.8 15.3 36.7 29.4 64.3 41.5C157.8 416.9 234.7 432 320 432s162.2-15.1 217.4-39.2c27.6-12 49.5-26.2 64.3-41.5C616.5 336.1 624 320.1 624 304s-7.5-32.1-22.3-47.4c-14.8-15.3-36.7-29.4-64.3-41.5c-17.7-7.7-37.6-14.5-59.2-20.1c2.4 13.5 3 27.7 1.8 42.3c-.2 1.8-.9 3.5-2.2 4.8l-5.8-5.5c5.8 5.5 5.8 5.5 5.8 5.5l0 0 0 0-.1 .1-.2 .2-.5 .5c-.4 .4-1 .9-1.8 1.6c-1.5 1.3-3.8 3.2-6.8 5.4c-6 4.4-15.1 10.1-27.8 15.7C415.5 276.9 376.3 288 320 288s-95.5-11.1-120.7-22.4c-12.6-5.7-21.7-11.3-27.8-15.7c-3-2.2-5.3-4-6.8-5.4c-.8-.7-1.4-1.2-1.8-1.6l-.5-.5-.2-.2-.1-.1 0 0 0 0s0 0 5.8-5.5zm306.1-59.2c25.6 6.2 49 14 69.7 23c28.8 12.6 52.7 27.7 69.4 45C630 262.8 640 282.6 640 304s-10 41.2-26.8 58.5c-16.7 17.3-40.6 32.4-69.4 45C486.1 432.6 407 448 320 448s-166.1-15.4-223.8-40.5c-28.8-12.6-52.7-27.7-69.4-45C10 345.2 0 325.4 0 304s10-41.2 26.8-58.5c16.7-17.3 40.6-32.4 69.4-45c20.7-9 44.2-16.8 69.7-23C185.9 110.4 248.8 64 320 64s134.1 46.4 154.1 113.5zm-9.8 55.4C470 146.7 401.1 80 320 80s-150 66.7-144.3 152.9c1.2 1 2.9 2.4 5.2 4c5.2 3.8 13.4 8.9 24.9 14.1c23.1 10.4 60 21 114.2 21s91.1-10.6 114.2-21c11.6-5.2 19.7-10.3 24.9-14.1c2.3-1.6 4-3 5.2-4zM320 316.7l5.7 5.7 32 32 5.7 5.7-5.7 5.7-32 32-5.7 5.7-5.7-5.7-32-32-5.7-5.7 5.7-5.7 32-32 5.7-5.7zM299.3 360L320 380.7 340.7 360 320 339.3 299.3 360zM133.7 274.3l32 32 5.7 5.7-5.7 5.7-32 32-5.7 5.7-5.7-5.7-32-32L84.7 312l5.7-5.7 32-32 5.7-5.7 5.7 5.7zM128 332.7L148.7 312 128 291.3 107.3 312 128 332.7zm384-64l5.7 5.7 32 32 5.7 5.7-5.7 5.7-32 32-5.7 5.7-5.7-5.7-32-32-5.7-5.7 5.7-5.7 32-32 5.7-5.7zM491.3 312L512 332.7 532.7 312 512 291.3 491.3 312z'
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fast',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      'M8 32H0v8 64 8H16v-8V48H184l0 416H104 96v16h8 88 88 8V464h-8H200l0-416H368v56 8h16v-8V40 32h-8H192 8zM328 224h-8v8 64 8h16v-8V240H472l0 224H392h-8v16h8 88 88 8V464h-8H488l0-224H624v56 8h16v-8V232v-8h-8H480 328z'
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fast',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      'M228.3 7.7L320 57.1 411.7 7.7 426 0l4.7 15.6 29.9 99.7 99.7 29.9L576 150l-7.7 14.4L518.9 256l17.2 32H517.9l-13.2-24.4-4.1-7.6 4.1-7.6 47.8-88.8-96.6-29-8.3-2.5-2.5-8.3-29-96.6L327.6 71.2 320 75.3l-7.6-4.1L223.7 23.4l-29 96.6-2.5 8.3-8.3 2.5-96.6 29 47.8 88.8 4.1 7.6-4.1 7.6L122.1 288H103.9l17.2-32L71.7 164.3 64 150l15.6-4.7 99.7-29.9 29.9-99.7L214 0l14.4 7.7zM432 256c0 11.1-1.6 21.9-4.6 32H410.5c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H212.6c-3-10.1-4.6-20.9-4.6-32c0-61.9 50.1-112 112-112s112 50.1 112 112zM72 320H440h8v16h-8H72 64V320h8zm416 0H632h8v16h-8H488h-8V320h8zM8 408H568h8v16h-8H8 0V408H8zm64 88H216h8v16h-8H72 64V496h8zm192 0H632h8v16h-8H264h-8V496h8z'
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fast',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      'M464.7 374.6l-85.4 32.3-1.9 .7-2-.3L177.3 381.7l-9.5 97.6C195.1 490.1 224.9 496 256 496c89.4 0 167.4-48.9 208.7-121.4zm10.7-21.1C488.6 323.7 496 290.7 496 256c0-6.2-.2-12.4-.7-18.5l-92 41.8-2 .9-2.2-.2L259.7 264.5 184.6 366.5l190.8 24.7 99.9-37.8zm18-132.7C476.4 104.9 376.6 16 256 16c-.5 0-1.1 0-1.6 0l70.6 57.8 1.5 1.3 .8 1.8 76.8 184.4 89.2-40.5zM230.7 17.3C190.1 21.6 152.4 36 120.3 58l82.2 58.8 1.8 1.3 .9 2 56.3 128.5 125.9 14-74-177.6L230.7 17.3zM106.8 68C51.5 112 16 179.8 16 256c0 44.3 12 85.8 32.9 121.4l14.7-90.1 .3-2 1.2-1.6L186.5 125 106.8 68zM61.9 397.2c23.3 32 54.4 58 90.4 75.3l9.8-100.6 .2-2.2 1.3-1.8 83.1-113L196 138.9 79.1 291.8 61.9 397.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fast',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      'M16 16H368V247.2c5-5.3 10.4-10.3 16-15V16 0H368 16 0V16 496v16H16 144h16 64 16H368h16v-8.2c-5.6-4.7-11-9.7-16-15V496H240V384 368H224 160 144v16V496H16V16zM160 496V384h64V496H160zM80 232H72v8 64 8h8 64 8v-8V240v-8h-8H80zm8 64V248h48v48H88zm144-64v8 64 8h8 64 8v-8V240v-8h-8H240h-8zm16 16h48v48H248V248zM80 104H72v8 64 8h8 64 8v-8V112v-8h-8H80zm8 64V120h48v48H88zm144-64v8 64 8h8 64 8v-8V112v-8h-8H240h-8zm16 16h48v48H248V120zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-219.3L492.7 304l5.7 5.7L548.7 360H424h-8v16h8H548.7l-50.3 50.3-5.7 5.7L504 443.3l5.7-5.7 64-64 5.7-5.7-5.7-5.7-64-64-5.7-5.7z'
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fast',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      'M496 144L16 144l0 352 480 0 0-352zm16-16l0 16 0 352 0 16-16 0L16 512 0 512l0-16L0 144l0-16 16 0 480 0 16 0zM464 64l0 16L48 80l0-16 416 0zM416 0l0 16L96 16 96 0 416 0z'
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fast',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      'M136 40V32H120v8V472v8h16v-8V40zm128 0V32H248v8V472v8h16v-8V40zm128-8H376v8V472v8h16v-8V40 32zm128 8V32H504v8V472v8h16v-8V40z'
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fast',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      'M352 80A64 64 0 1 1 224 80a64 64 0 1 1 128 0zM288 0c-44.2 0-80 35.8-80 80c0 41.5 31.6 75.6 72 79.6c0 .1 0 .3 0 .4v48H200h-8v16h8 80V496H88V291.3l58.3 58.3 11.3-11.3-72-72L80 260.7l-5.6 5.6 0 0-72 72 11.3 11.3L72 291.3V504v8h8H288 394.8c-6.9-4.9-13.4-10.2-19.6-16H296V224h80 8V208h-8H296V160c0-.1 0-.3 0-.4c40.4-4 72-38.1 72-79.6c0-44.2-35.8-80-80-80zM496 240a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 272a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm75.3-184L560 316.7l-5.7 5.7L480 396.7l-42.3-42.3-5.7-5.7L420.7 360l5.7 5.7 48 48 5.7 5.7 5.7-5.7 80-80 5.7-5.7z'
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fast',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      'M16 16V496H368V16H16zM0 0H16 368h16V16 496v16H368 16 0V496 16 0zM80 80v96H304V80H80zM64 64H80 304h16V80v96 16H304 80 64V176 80 64zM192 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fast',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M128 8V0H112V8 64H16 0V80v96 16 96 16 96 16 80 16H16 432h16V496 416 400 304 288 192 176 80 64H432 336V8 0H320V8 64H128V8zM432 288H304V192H432v96zM288 192v96H160V192H288zm-144 0v96H16V192H144zM16 304H144v96H16V304zm0 112H144v80H16V416zm144 80V416H288v80H160zm144 0V416H432v80H304zm128-96H304V304H432v96zM112 80v40 8h16v-8V80H320v40 8h16v-8V80h96v96H16V80h96zM288 400H160V304H288v96z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fast',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      'M133.5 282c48.7-45.9 114.3-74 186.5-74s137.8 28.1 186.5 74l11-11.6C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4l11 11.6zM272 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fast',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      'M416 0V8 35.6c0 41 9.5 81.4 27.9 118.1l5 9.9c.1 .2 .2 .3 .2 .5c18.3 31.4 37.6 75.1 36.9 124.7c-.6 48.6-20.4 103.7-81.1 159.3H107.1C46.4 392.4 26.6 337.2 26 288.7c-.6-49.5 18.6-93.2 36.9-124.7c.1-.1 .2-.3 .2-.5l5-9.9C86.5 117 96 76.6 96 35.6V8 0H80V8 35.6c0 38.5-9 76.5-26.2 110.9L49 156.2C30 188.8 9.3 235.3 10 288.9c.7 53.3 22.6 112.5 86 170.6V512h16V464h88v48h16V464h80v48h16V464h88v48h16V459.5c63.4-58.2 85.3-117.3 86-170.6c.7-53.6-20-100.2-39-132.7l-4.9-9.7C441 112 432 74.1 432 35.6V8 0H416zM264 96H248v8V264v8h16v-8V104 96zM240 304v32h32V304H240z'
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fast',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      'M16 48V464H432V48H16zM0 32H16 432h16V48 464v16H432 16 0V464 48 32zM144 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fast',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      'M16 16V496H144V384 368h16 64 16v16V496H368V16H16zM160 496h64V384H160V496zm-16 16H16 0V496 16 0H16 368h16V16 496v16H368 240 224 160 144zM80 232h64 8v8 64 8h-8H80 72v-8V240v-8h8zm8 64h48V248H88v48zm144-64h8 64 8v8 64 8h-8H240h-8v-8V240v-8zm16 16v48h48V248H248zM104 64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64 56h16v8 64c0 22.1-17.9 40-40 40s-40-17.9-40-40V64 56h16v8zm120-8h8 4.9l2.2 4.4L280 142.1V64 56h16v8 96 8h-8-8-4.9l-2.2-4.4L232 81.9V160v8H216v-8V64 56h8z'
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fast',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      'M16 181.1v8.5c.4 .6 .9 1.3 1.6 2.1c2 2.7 5.1 6.5 9.5 11.2c8.7 9.3 22.1 21.9 41.1 34.5c.3 .2 .6 .4 1 .6C110.2 213.8 171 192 256 192c85 0 145.8 21.9 186.9 46c.3-.2 .7-.4 1-.7c19-12.6 32.5-25.2 41.1-34.5c4.3-4.7 7.4-8.5 9.5-11.2c.6-.8 1.1-1.5 1.6-2.1v-8.5C473.4 150.4 397.4 80 256 80S38.6 150.4 16 181.1zm411.2 66.4C388.6 226.5 332.9 208 256 208c-76.9 0-132.6 18.5-171.2 39.5C123 268.9 178.7 288 256 288c77.3 0 133-19.1 171.2-40.5zM16 330.9C38.6 361.6 114.6 432 256 432s217.4-70.4 240-101.1V214.5c-9.4 10.1-23.6 23.2-43.3 36.2C412.2 277.5 348.6 304 256 304s-156.2-26.5-196.7-53.3C39.6 237.6 25.4 224.5 16 214.5V330.9zM512 176V336c-21.3 32-102.4 112-256 112S21.3 368 0 336V176C21.3 144 102.4 64 256 64s234.7 80 256 112z'
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fast',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      'M144 40c0-4.4 3.6-8 8-8H320c4.4 0 8 3.6 8 8V464H480V256c0-4.4 3.6-8 8-8H632h8v16h-8H496V472c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8V48H160V256c0 4.4-3.6 8-8 8H8 0V248H8 144V40z'
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fast',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      'M16 496V16H208V168v8h8H368V496H16zM224 22.6L361.4 160H224V22.6zM224 0H16 0V16 496v16H16 368h16V496 160L224 0zM104 256H96v16h8H280h8V256h-8H104zm0 64H96v16h8H280h8V320h-8H104zm0 64H96v16h8H280h8V384h-8H104z'
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fast',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      'M55.6 355.4l71.1 10.2L144 368l-4.6-16.8L103.7 220.3 96 192l21.9 19.5 108.3 96.3L240 320l3.8-18.1L280 128h16l35.3 162.2L336 312l12.3-18.5L513.2 46.2 544 0 527.8 53.1l-90.7 298L432 368l17.5-2.5 70.9-10.1L544 352l-15.3 18.3-78 93.7H429.8l75.2-90.3-70.8 10.1-24.9 3.6 7.3-24.1L497.1 99.2 349.3 320.9l-20.9 31.4-8-36.9L288.2 167.3l-32.5 156L250 350.3 229.4 332 125.6 239.7l33.8 124.1 6.4 23.5-24.1-3.4L70.9 373.7 146.2 464H125.3l-78-93.7L32 352l23.6 3.4zM296 8V88v8H280V88 8 0h16V8zM8 496H192.3c4.1-49.3 45.3-88 95.7-88s91.6 38.7 95.7 88H568h8v16h-8H376.1c0 0-.1 0-.1 0s-.1 0-.1 0H200.1c0 0-.1 0-.1 0s-.1 0-.1 0H8 0V496H8zm200.4 0H367.6c-4-40.4-38.1-72-79.6-72s-75.6 31.6-79.6 72z'
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fast',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M452.7 196.7l-21.4-21.4L420 164l11.3-11.3 69.4-69.4L512 72 500.7 60.7 451.3 11.3 440 0 428.7 11.3 359.3 80.7 348 92 336.7 80.7 315.3 59.3 304 48 292.7 59.3 272 80V224v16h16H432l20.7-20.7L464 208l-11.3-11.3zm-44-44L397.4 164l11.3 11.3L441.4 208l-16 16H288V86.6l16-16 32.7 32.7L348 114.6l11.3-11.3L440 22.6 489.4 72l-80.7 80.7zM59.3 315.3l21.4 21.4L92 348 80.7 359.3 11.3 428.7 0 440l11.3 11.3 49.4 49.4L72 512l11.3-11.3 69.4-69.4L164 420l11.3 11.3 21.4 21.4L208 464l11.3-11.3L240 432V288 272H224 80L59.3 292.7 48 304l11.3 11.3zm44 44L114.6 348l-11.3-11.3L70.6 304l16-16H224V425.4l-16 16-32.7-32.7L164 397.4l-11.3 11.3L72 489.4 22.6 440l80.7-80.7z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fast',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      'M432 48V464H384L336 320H112L64 464H16V48H432zM367.1 464H80.9l42.7-128H324.5l42.7 128zM16 32H0V48 464v16H16 432h16V464 48 32H432 16zM304 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fast',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      'M168.1 70.2C209.5 36.3 262.3 16 320 16c74.9 0 141.8 34.3 185.8 88.1l12.4-10.1C471.3 36.6 399.9 0 320 0C258.5 0 202.1 21.7 157.9 57.8l10.1 12.4zM320 496c-95.6 0-178.2-55.9-216.8-136.9L88.8 366C129.9 452.3 218 512 320 512c79.9 0 151.3-36.6 198.2-93.9l-12.4-10.1C461.8 461.7 394.9 496 320 496zm-56-96c0-7.3 4.8-15.1 15-21.5c10.1-6.3 24.6-10.5 41-10.5s30.9 4.2 41 10.5c10.2 6.4 15 14.2 15 21.5s-4.8 15.1-15 21.5c-10.1 6.3-24.6 10.5-41 10.5s-30.9-4.2-41-10.5c-10.2-6.4-15-14.2-15-21.5zm56-48c-18.9 0-36.5 4.8-49.5 12.9C257.6 373 248 385.2 248 400s9.6 27 22.5 35.1c13 8.2 30.6 12.9 49.5 12.9s36.5-4.8 49.5-12.9C382.4 427 392 414.8 392 400s-9.6-27-22.5-35.1c-13-8.2-30.6-12.9-49.5-12.9zm36-176.5l-8-13.8c-21.5 12.4-36 35.7-36 62.4c0 9.5 1.8 18.6 5.2 26.9l14.8-6c-2.6-6.5-4-13.5-4-21c0-20.7 11.2-38.8 28-48.5zM400 224c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 6.6 4 12.3 9.7 14.7H368v16 32 16h16v24 16h16 24v24.9 16h16 80.8c29.5 0 57.8-11.7 78.6-32.6c43.1-43.1 43.4-112.8 .9-156.3l0 0-.1-.1-.8-.8 0 0-45.1-45.1L543 137.4l-11.3 11.3L503.4 177l-8 8-53.1-36.4-12.9-8.9-9.1 12.8-18.6 26-9.3 13 13 9.3 53.1 38-68.2 0c5.7-2.4 9.7-8.1 9.7-14.7zm188.1-18.9l.8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H456 440v-16-8.9-7.1h16 8 16v-8.9H464 440l-16 0h-8H400v-16-8-8h16 48 16v-8H464 400 384v-8-8-16h16l66.6 0h8.9 5.5 1.8 8.7V242.5l-5.4-3.8-11.7-8.4L427.7 197l-13-9.3 9.3-13 9.3-13 96.2 66 16 11V219.3v-.2l-19.5-19.5-11.3-11.3L526.1 177l5.7-5.7L543 160l11.3 11.3 33.8 33.8zM256 174.7v-16H240 137.5l15.1-15.1 11.3-11.3L152.6 121 124.3 92.7 113 81.4 101.7 92.7 40.6 153.8l0 0-.8 .8 0 0-.1 .1C-2.9 198.2-2.5 267.9 40.6 311c20.9 20.9 49.1 32.6 78.6 32.6H192h16v-16V302.7h32.3 16.2l-.2-16.2-.2-23.8H272v-16-32-16H256v-24zM112.5 161L98.8 174.7h19.3 3.3H224h16v16 8 8H224 176 160v8h16 64 0 16v8 8 16h-.1H240h0l-64 0H160v8h16 64l.1 8 .1 8 .2 16h-16H208 192 176 160v8.9h16 0 16v7.1 8.9 16H176 119.2c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8 49.8-49.8L113 104l11.3 11.3 5.7 5.7 11.3 11.3-11.3 11.3-15.1 15.1-2.3 2.3z'
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fast',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      'M40 256c0-62.7 17.5-119 45.4-159.5C113.4 56 151.2 32 192 32s78.6 24 106.6 64.5C326.5 137 344 193.3 344 256s-17.5 119-45.4 159.5C270.6 456 232.8 480 192 480s-78.6-24-106.6-64.5C57.5 375 40 318.7 40 256zM192 16c-47.6 0-89.8 28-119.7 71.4C42.3 130.9 24 190.5 24 256s18.3 125.1 48.3 168.6C102.2 468 144.4 496 192 496s89.8-28 119.7-71.4C341.7 381.1 360 321.5 360 256s-18.3-125.1-48.3-168.6C281.8 44 239.6 16 192 16zM96 248H88v16h8H288h8V248h-8H96z'
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fast',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      'M484.2 34.6l-8.6 13.5-8.6 13.5L419 137.2l-8.6 13.5-8.6 13.5-13.5-8.6-7.3-4.7L353.6 192H334.4l33.1-49.7-6.2-3.9-13.5-8.6 8.6-13.5 8.6-13.5 48.1-75.5 8.6-13.5L430.2 .3l13.5 8.6 27 17.2 13.5 8.6zM261.6 152.5L248.4 192H231.6l14.6-43.7-6-1.6-15.4-4.2 4.2-15.4 4.2-15.4 21.6-79.3L259 16.8l4.2-15.4 15.4 4.2L309.5 14l15.4 4.2-4.2 15.4-4.2 15.4-21.6 79.3-4.2 15.4-4.2 15.4L271 155.1l-9.4-2.6zm-17.2-21.3l30.9 8.4 4.2-15.4 21.6-79.3 4.2-15.4-30.9-8.4-4.2 15.4-21.6 79.3-4.2 15.4zM462.2 39.6l-27-17.2-8.6 13.5-48.1 75.5-8.6 13.5 27 17.2 8.6-13.5 48.1-75.5 8.6-13.5zM16 240v80c0 79.5 64.5 144 144 144H288c79.5 0 144-64.5 144-144V240h-8H168v56 16H152 136 120V296 272H104v56 16H88 72 56V328 240H16zm0-16H56 72h80 16H424h8 16 56 8v16h-8H448v80c0 52.3-25.1 98.8-64 128v56 8H368v-8V458.6c-23.5 13.6-50.9 21.4-80 21.4H160c-29.1 0-56.5-7.8-80-21.4V504v8H64v-8V448C25.1 418.8 0 372.3 0 320V240 224H16zm56 32v56 16H88V312 272 256h16 16 16v16 8 16h16V280 256 240H136 88 72v16z'
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fast',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      'M139.9 0H144h96 4.1l2.4 3.4 40 56 3.2 4.5-3.1 4.6-44.2 66.3C324 156.9 384 231.4 384 320c0 106-86 192-192 192S0 426 0 320c0-88.6 60-163.1 141.5-185.3L97.3 68.4l-3.1-4.6 3.2-4.5 40-56L139.9 0zM265.1 72H118.9l39.3 59c11-1.9 22.2-3 33.7-3s22.8 1 33.7 3l39.3-59zm-.6-16L235.9 16H148.1L119.5 56H264.5zM192 496a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fast',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      'M256 0C176.5 0 112 64.5 112 144v32H40 32v8V422.1L.8 484.4 0 486.1V488v16 8H8 120h8v-8V389l50 56.3 2.4 2.7H184 328h3.6l2.4-2.7L384 389V504v8h8H504h8v-8V488v-1.9l-.8-1.7L480 422.1V184v-8h-8H400V144C400 64.5 335.5 0 256 0zM400 192h64V424v1.9l.8 1.7L496 489.9V496H400V371v-3V192zm-16-16H128V144c0-70.7 57.3-128 128-128s128 57.3 128 128v32zM128 192H384V365l-59.6 67H187.6L128 365V192zm-16 0V368v3V496H16v-6.1l31.2-62.3 .8-1.7V424 192h64zm88-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm64 0a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm40 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 240v16h8H312h8V240h-8H200h-8zm0 64v16h8H312h8V304h-8H200h-8z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fast',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      'M96 64H64V96H96V64zM64 48H96h16V64 96v16H96 64 48V96 64 48H64zM32 176h8H96h8v8V464h80 8v16h-8H8 0V464H8 88V192H40 32V176z'
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fast',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      'M240 16c-41.6 0-77.6 24.5-94.2 59.9l-2.4 5.1-5.6-.5c-3.2-.3-6.5-.4-9.9-.4C66.1 80 16 130.1 16 192c0 23.8 7.4 45.9 20.1 64h-19C6.2 237.2 0 215.3 0 192C0 121.3 57.3 64 128 64c1.9 0 3.9 0 5.8 .1C153.9 26 193.9 0 240 0c46.7 0 87.2 26.7 107 65.7c6.8-1.1 13.8-1.7 21-1.7c41.2 0 77.9 19.5 101.3 49.7c-11.9-6.5-24.8-11.4-38.4-14.4C413 87.1 391.3 80 368 80c-8.2 0-16.2 .9-23.8 2.5l-6.4 1.4-2.6-6C319 41.4 282.5 16 240 16zM400 144c-53 0-96 43-96 96c0 5.5 .5 10.8 1.3 16H289.1c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 5.4-.4 10.8-1.1 16H494.7c.9-5.2 1.3-10.5 1.3-16c0-53-43-96-96-96zM112 463.8V496H400V463.8 453.7l9.1-4.3C460.5 425 496 372.6 496 312v-8H16v8c0 60.6 35.5 113 86.9 137.4l9.1 4.3v10.1zM512 288v16 8c0 67-39.2 124.9-96 151.8V496v16H400 112 96V496 463.8C39.2 436.9 0 379 0 312v-8V288H16 496h16zM248 104V248v8H232v-8V104 96h16v8zM93.7 146.3l96 96 5.7 5.7L184 259.3l-5.7-5.7-96-96L76.7 152 88 140.7l5.7 5.7z'
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fast',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M144 416h16v16 60.8V512l16-10.7L304 416H496h16V400 16 0H496 16 0V16 400v16H16 144zM16 400V16H496V400H304h-4.8l-4 2.7L176 482.1V416 400H160 16z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fast',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      'M116.1 496H267.9l98.5-348.6L264.2 16H119.8L17.6 147.4 116.1 496zM280 512H104L0 144 112 0H272L384 144 280 512z'
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fast',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      'M130.1 16.3l-7.6 2.5L64 37.8V192c0 70.7 57.3 128 128 128s128-57.3 128-128V37.8l-58.5-19-7.6-2.5 4.9-15.2 7.6 2.5 64 20.8 5.5 1.8V32 192c0 76.8-60.2 139.6-136 143.8c0 .1 0 .1 0 .2v24c0 75.1 60.9 136 136 136s136-60.9 136-136V255.5c-31.6-3.9-56-30.9-56-63.5c0-35.3 28.7-64 64-64s64 28.7 64 64c0 32.6-24.4 59.6-56 63.5V360c0 83.9-68.1 152-152 152s-152-68.1-152-152V336c0-.1 0-.1 0-.2C108.2 331.6 48 268.8 48 192V32 26.2l5.5-1.8 64-20.8 7.6-2.5 4.9 15.2zM480 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fast',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112c35.3 0 64-28.7 64-64s-28.7-64-64-64c-18.8 0-35.7 8.1-47.4 21l-108-75.6L94 228.9 84.9 242l6.6 4.6 108 75.6c-4.7 8.9-7.4 19.1-7.4 29.9c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fast',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      'M256 16C123.5 16 16 123.5 16 256c0 80.6 39.7 151.9 100.7 195.4l-9.3 13C42.4 418 0 342 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 106.3-64.7 197.4-156.9 236.1l-6.2-14.8C435.3 441 496 355.6 496 256C496 123.5 388.5 16 256 16zM244.7 356.7l-9.4-9.4L246.6 336l44.7-44.7L302.6 280l-1.9-1.9-9.4-9.4L280 257.4l-11.3 11.3L200 337.4l-1 1-15 15v-15-4-3.7V318.4H168h-8H144v16 4V368v20 12.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l48.8-48.8L366.6 408l-11.3-11.3-9.4-9.4-1.9-1.9-11.3 11.3L320 409.4l-11.3 11.3-9.4-9.4L310.6 400l12.7-12.7L334.6 376l11.3-11.3 9.4-9.4L366.6 344l-11.3-11.3-9.4-9.4-1.9-1.9-11.3 11.3L288 377.4l-11.3 11.3-9.4-9.4L278.6 368l44.7-44.7L334.6 312l4.7-4.7 6.6-6.6 4.7-4.7-11.3-11.3L328 273.4l-4.7 4.7-6.6 6.6-4.7 4.7-11.3 11.3L256 345.4l-11.3 11.3zM312 266.7l4.7-4.7L328 250.7l11.3 11.3 22.6 22.6L373.3 296l-11.3 11.3-4.7 4.7 20.7 20.7L389.3 344l-11.3 11.3-11.3 11.3-9.4 9.4 20.7 20.7L389.3 408l-11.3 11.3-11.3 11.3-48.8 48.8C297 500.3 268.7 512 239.2 512C177.8 512 128 462.2 128 400.8V388 368 338.4v-20-16h16 40 16v12.3l57.4-57.4 11.3-11.3L280 234.7l11.3 11.3L312 266.7zm-137.1-4.9l-14.7-6.2C175.9 218.3 212.9 192 256 192c30.8 0 58.5 13.4 77.5 34.7l-11.9 10.7c-16.1-18-39.5-29.3-65.6-29.3c-36.5 0-67.8 22.2-81.1 53.9zm36.4-148.6l-6.2 5-80 64-6.2 5-10-12.5 6.2-5 80-64 6.2-5 10 12.5zm95.8 5l-6.2-5 10-12.5 6.2 5 80 64 6.2 5-10 12.5-6.2-5-80-64z'
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fast',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 240A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM75.8 320H372.2l54.2 176H21.7L75.8 320zM384 304H64L4.9 496 0 512H16.7 431.3 448l-4.9-16L384 304zm73.8-177.5l-11.3 11.3 5.7 5.7L516.7 208l-64.6 64.6-5.7 5.7 11.3 11.3 5.7-5.7L528 219.3l64.6 64.6 5.7 5.7 11.3-11.3-5.7-5.7L539.3 208l64.6-64.6 5.7-5.7-11.3-11.3-5.7 5.7L528 196.7l-64.6-64.6-5.7-5.7z'
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fast',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      'M485.7 37.5L480 31.9l-5.7 5.7-80 80-5.7 5.7L400 134.5l5.7-5.7L472 62.5l0 387-66.3-66.3-5.7-5.7-11.3 11.3 5.7 5.7 80 80 5.7 5.7 5.7-5.7 80-80 5.7-5.7L560 377.5l-5.7 5.7L488 449.5l0-387 66.3 66.3 5.7 5.7 11.3-11.3-5.7-5.7-80-80zM8 32H0v8 64 8H16v-8V48H152l0 416H72 64v16h8 88 88 8V464h-8H168l0-416H304v56 8h16v-8V40 32h-8H8z'
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fast',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      'M77.7 371.9C38.7 332.1 16 279.7 16 224H0c0 59.1 23.7 114.4 64 156.7V504v8H80v-8V377.5v-3.3l-2.3-2.3zM40.1 96H8 0v8 80 8H8 222.2c15.7 24.1 42.9 40 73.8 40H408h96 8v-8V64 56h-8H408 382.4C347.9 21.5 300.6 0 248 0H224C147.9 0 80.6 38 40.1 96zM60 96c38.1-48.7 97.4-80 164-80h24c42.1 0 80.5 15.1 110.6 40H296c-30.9 0-58.1 15.9-73.8 40H60zM496 320H440h-8v8V432H312h-8v8 64 8h16v-8V448H440h8v-8V336h56 8v-8V256H496v64zM296 72H400V216H296c-39.8 0-72-32.2-72-72s32.2-72 72-72zM416 216V72h80V216H416zM208 144c0 11.3 2.1 22.1 6 32H16V112H214c-3.9 9.9-6 20.7-6 32z'
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fast',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 136v-8H160v8V376v8h8H344h8V368h-8H176V136z'
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fast',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      'M160 0H288h4.4l2.4 3.8L332.4 64H448V80H0V64H115.6L153.2 3.8 155.6 0H160zM313.6 64l-30-48H164.4l-30 48H313.6zM32 504V112H48V496H400V112h16V504v8h-8H40 32v-8zM136 160V416v8H120v-8V160v-8h16v8zm96 0V416v8H216v-8V160v-8h16v8zm96 0V416v8H312v-8V160v-8h16v8z'
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fast',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      'M448 512C200.6 512 0 311.4 0 64L0 32 144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448zM16 64l0 0c0 238.6 193.4 432 432 432h19.2l26.6-119.8L372 308.6l-58.6 73.2-8.3 10.3-11.7-6.2C222.2 348.3 163.7 289.8 126 218.5l-6.2-11.7 10.3-8.3L203.4 140 135.8 18.2 16 44.8 16 64zM290.3 210.3L484.7 16H360h-8V0h8H504h8V8 152v8H496v-8V27.3L301.7 221.7l-5.7 5.7L284.7 216l5.7-5.7z'
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fast',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      'M304 48V240H16V48H304zM16 32H0V48 240v16H16 304h16V240 48 32H304 16zM560 48V368H400V48H560zM400 32H384V48 368v16h16H560h16V368 48 32H560 400zM80 320H320V464H80V320zM64 304v16V464v16H80 320h16V464 320 304H320 80 64z'
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fast',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M16 256C16 123.5 123.5 16 256 16s240 107.5 240 240l0 20 0 68H428c-37.6 0-68-30.4-68-68V256 168v-8H344v8 32.5c-18.4-29.2-50.9-48.5-88-48.5c-57.4 0-104 46.6-104 104s46.6 104 104 104c40.4 0 75.3-23 92.6-56.6C359.9 336.4 391.2 360 428 360h76 8v-8l0-76 0-20C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512h8V496h-8C123.5 496 16 388.5 16 256zm152 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z'
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fast',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      'M472 40V32H456v8V72H424h-8V88h8 32v32 8h16v-8V88h32 8V72h-8H472V40zM56 264v-8H40v8 32H8 0v16H8 40v32 8H56v-8V312H88h8V296H88 56V264zm48 184H96v8 48 8h16v-8V464H400v40 8h16v-8V456v-8h-8H104z'
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fast',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      'M432 400c106 0 192-86 192-192s-86-192-192-192c-56.1 0-106.6 24.1-141.7 62.5c-5.4-2-11-3.8-16.6-5.4C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c2.7-5.1 5.2-10.4 7.6-15.7c1.3 0 2.6 0 4 0zM338 78.6l51.5-1.4L432 48l42.5 29.1L526 78.6l17.3 48.6 40.8 31.4L569.6 208l14.6 49.4-40.8 31.4L526 337.4l-51.5 1.4-33.5 23c1.8-7.3 3.3-14.8 4.4-22.4l20.1-13.8 3.9-2.7 4.7-.1 40.6-1.1 13.6-38.2 1.6-4.4 3.7-2.9 32.2-24.8-11.5-38.9-1.3-4.5 1.3-4.5 11.5-38.9-32.2-24.8-3.7-2.9-1.6-4.4L514.6 94.2l-40.6-1.1-4.7-.1-3.9-2.7L432 67.4 398.5 90.3 394.6 93l-4.7 .1-40.6 1.1-4.5 12.6c-4.5-3.1-9.1-6.1-13.8-8.9L338 78.6zM496 208c0 30.6-21.5 56.3-50.3 62.5c-.7-5.3-1.7-10.6-2.7-15.8c21.2-5 37.1-24 37.1-46.7c0-26.5-21.5-48-48-48c-9.7 0-18.8 2.9-26.3 7.9c-3-4.4-6.2-8.7-9.5-12.9c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zm-96 96A192 192 0 1 0 16 304a192 192 0 1 0 384 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm144-96l-16-16 16-16 16 16-16 16zm160 32l16-16 16 16-16 16-16-16zM96 400l16-16 16 16-16 16L96 400zm128 32l16-16 16 16-16 16-16-16zm80-16l-16-16 16-16 16 16-16 16zM64 272l16-16 16 16L80 288 64 272zm80 32a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fast',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      'M101.4 42.1L96 37.2l-5.4 4.8-80 72-5.9 5.4 10.7 11.9 5.9-5.4L88 66V446l-66.6-60-5.9-5.4L4.7 392.6l5.9 5.4 80 72 5.4 4.8 5.4-4.8 80-72 5.9-5.4-10.7-11.9-5.9 5.4L104 446V66l66.6 60 5.9 5.4 10.7-11.9-5.9-5.4-80-72zM264 88h-8v16h8H568h8V88h-8H264zm-8 160h-8v16h8H568h8V248h-8H256zm0 160v16h8H568h8V408h-8H264h-8z'
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fast',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      'M13.2 4.8L1.7 4.3l3.5 11L77 240H72 64v8 40 8H80v-8V256H560v32 8h16v-8V248v-8h-8-5L634.8 15.2l3.5-11-11.5 .5L391.9 16H248.2L13.2 4.8zM256 32H384V240H256V32zm-16-.4V240H93.8L23.9 21.3 240 31.6zM353.1 416c7.8 54.3 54.4 96 110.9 96c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112H288c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c56.4 0 103.1-41.7 110.9-96h66.3zM368 400h0c0-53 43-96 96-96s96 43 96 96s-43 96-96 96c-52.9 0-95.8-42.8-96-95.6V400zm-96 0l0 .1c0 53-43 95.9-96 95.9c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-88-72v-8H168v8 64H104 96v16h8 64v64 8h16v-8V408h64 8V392h-8H184V328zm288-8H456v8 64H392h-8v16h8 64v64 8h16v-8V408h64 8V392h-8H472V328v-8zM616.1 21.3L546.2 240H400V31.6L616.1 21.3z'
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fast',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm341.7 5.7l5.7-5.7-5.7-5.7-120-120-5.7-5.7L204.7 136l5.7 5.7L324.7 256 210.3 370.3l-5.7 5.7L216 387.3l5.7-5.7 120-120z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fast',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      'M13.7 2.3C10.5-.8 5.5-.8 2.3 2.3s-3.1 8.2 0 11.3L164.7 176H72 64v16h8H184h8v-8V72 64H176v8 92.7L13.7 2.3zm612.7 0L464 164.7V72 64H448v8V184v8h8H568h8V176h-8H475.3L637.7 13.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0zM320 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128 96h16v-8V347.3L626.3 509.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L475.3 336H568h8V320h-8H456h-8v8V440v8zm-256 0v-8V328v-8h-8H72 64v16h8 92.7L2.3 498.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L176 347.3V440v8h16z'
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fast',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      'M0 272l11.3 11.3L32 304v0h0L228.7 500.7 240 512l11.3-11.3L500.7 251.3 512 240l-11.3-11.3L283.3 11.3 272 0 260.7 11.3l-103 103-104-104L48 4.7 36.7 16l5.7 5.7 104 104-135 135L0 272zM240 489.4L54.6 304H425.4L240 489.4zM38.6 288l-16-16 135-135 84.7 84.7 5.7 5.7L259.3 216l-5.7-5.7L169 125.7l103-103L489.4 240l-48 48H38.6zM470.2 425.4L512 352.2l41.8 73.1c4.1 7.1 6.2 15.2 6.2 23.4c0 26.1-21.1 47.2-47.2 47.2h-1.6c-26.1 0-47.2-21.1-47.2-47.2c0-8.2 2.1-16.3 6.2-23.4zm-13.9-7.9c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4l-46.5-81.3L512 320l-9.2 16.1-46.5 81.3z'
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
